import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Decimal: { input: any; output: any; }
  Int64: { input: any; output: any; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
  openfed__Scope: { input: any; output: any; }
};

export type AcceptAndStartTaskInput = {
  putawayTaskID: Scalars['UUID']['input'];
};

export type AccountJournal = {
  __typename?: 'AccountJournal';
  accountJournalID: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AccountJournalPaged = {
  __typename?: 'AccountJournalPaged';
  items?: Maybe<Array<AccountJournal>>;
  pagination: PaginationResult;
};

export type AccountJournalQopFilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AccountJournalQopInput = {
  filters?: InputMaybe<AccountJournalQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type AdminResetPasswordInput = {
  username: Scalars['String']['input'];
};

export type AdminResetPasswordResponse = {
  __typename?: 'AdminResetPasswordResponse';
  newPassword: Scalars['String']['output'];
};

export type AiAppClient = {
  __typename?: 'AiAppClient';
  apiKey: Scalars['String']['output'];
  appId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  domains: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rateLimitPerMin: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type AiChatCreateSessionInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AiChatMessage = {
  __typename?: 'AiChatMessage';
  content: Scalars['String']['output'];
  createdTimeUtc: Scalars['String']['output'];
  messageID: Scalars['String']['output'];
  senderRole: Scalars['String']['output'];
  sessionID: Scalars['String']['output'];
};

export type AiChatMessagePaged = {
  __typename?: 'AiChatMessagePaged';
  items: Array<AiChatMessage>;
  pageInfo: AiChatPageInfo;
};

export type AiChatMessageQopInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sessionID: Scalars['String']['input'];
  sortDir?: InputMaybe<Scalars['String']['input']>;
};

export type AiChatPageInfo = {
  __typename?: 'AiChatPageInfo';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type AiChatRenameSessionInput = {
  sessionID: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AiChatSendMessageInput = {
  message: Scalars['String']['input'];
  sessionID?: InputMaybe<Scalars['String']['input']>;
};

export type AiChatSendMessageResponse = {
  __typename?: 'AiChatSendMessageResponse';
  messageID: Scalars['String']['output'];
  response: Scalars['String']['output'];
  sessionID: Scalars['String']['output'];
};

export type AiChatSession = {
  __typename?: 'AiChatSession';
  branchCode?: Maybe<Scalars['String']['output']>;
  branchID?: Maybe<Scalars['String']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  createdTimeUtc: Scalars['String']['output'];
  lastMessageAt: Scalars['String']['output'];
  sessionID: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AiChatSessionPaged = {
  __typename?: 'AiChatSessionPaged';
  items: Array<AiChatSession>;
  pageInfo: AiChatPageInfo;
};

export type AiChatSessionQopInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
};

export type AiDlpGuardConfig = {
  __typename?: 'AiDlpGuardConfig';
  maskEmails: Scalars['Boolean']['output'];
  maskPhones: Scalars['Boolean']['output'];
  maskSecrets: Scalars['Boolean']['output'];
};

export type AiGuardrailsConfig = {
  __typename?: 'AiGuardrailsConfig';
  defaultApp: Scalars['String']['output'];
  dlp: AiDlpGuardConfig;
  prompt: AiPromptGuardConfig;
  sql: AiSqlGuardConfig;
};

export type AiPromptGuardConfig = {
  __typename?: 'AiPromptGuardConfig';
  jailbreakPatterns: Array<Scalars['String']['output']>;
};

export type AiScopeConfig = {
  __typename?: 'AiScopeConfig';
  tables: Array<AiScopeTable>;
  tools: Array<AiScopeTool>;
};

export type AiScopeTable = {
  __typename?: 'AiScopeTable';
  description: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AiScopeTool = {
  __typename?: 'AiScopeTool';
  description: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requiredScope: Scalars['String']['output'];
};

export type AiSqlGuardConfig = {
  __typename?: 'AiSqlGuardConfig';
  blockedTables: Array<Scalars['String']['output']>;
  forbiddenStmts: Array<Scalars['String']['output']>;
  readOnly: Scalars['Boolean']['output'];
};

export type AiUpdateDlpGuardInput = {
  maskEmails?: InputMaybe<Scalars['Boolean']['input']>;
  maskPhones?: InputMaybe<Scalars['Boolean']['input']>;
  maskSecrets?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiUpdateGuardrailsInput = {
  defaultApp?: InputMaybe<Scalars['String']['input']>;
  dlp?: InputMaybe<AiUpdateDlpGuardInput>;
  prompt?: InputMaybe<AiUpdatePromptGuardInput>;
  sql?: InputMaybe<AiUpdateSqlGuardInput>;
};

export type AiUpdatePromptGuardInput = {
  jailbreakPatterns?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AiUpdateScopeTableInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type AiUpdateScopeToolInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type AiUpdateSqlGuardInput = {
  blockedTables?: InputMaybe<Array<Scalars['String']['input']>>;
  forbiddenStmts?: InputMaybe<Array<Scalars['String']['input']>>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiUpsertAppClientInput = {
  appId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  domains: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  rateLimitPerMin?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type App = {
  __typename?: 'App';
  appID: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
};

export type AppCreateInput = {
  appID: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type AppPaged = {
  __typename?: 'AppPaged';
  items?: Maybe<Array<App>>;
  pagination: PaginationResult;
};

export type AppQopFilterInput = {
  appName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type AppQopInput = {
  filters?: InputMaybe<AppQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type AppRole = {
  __typename?: 'AppRole';
  appID: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  roleID: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
};

export type AppRolePermission = {
  __typename?: 'AppRolePermission';
  appID: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  roles?: Maybe<Array<RoleProfile>>;
};

export type AppUpdateInput = {
  appID: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type AssignTaskInput = {
  assignedToUserID: Scalars['UUID']['input'];
  putawayTaskID: Scalars['UUID']['input'];
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  accessToken: Scalars['String']['output'];
  appRolePermissions?: Maybe<Array<AppRolePermission>>;
  appRoles?: Maybe<Array<AppRole>>;
  branches?: Maybe<Array<BranchProfile>>;
  defaultBranchCode?: Maybe<Scalars['String']['output']>;
  defaultBranchID?: Maybe<Scalars['UUID']['output']>;
  defaultBranchName?: Maybe<Scalars['String']['output']>;
  defaultRoleAppID?: Maybe<Scalars['String']['output']>;
  defaultRoleAppName?: Maybe<Scalars['String']['output']>;
  defaultRoleID?: Maybe<Scalars['UUID']['output']>;
  defaultRoleName?: Maybe<Scalars['String']['output']>;
  defaultWarehouseID?: Maybe<Scalars['UUID']['output']>;
  defaultWarehouseName?: Maybe<Scalars['String']['output']>;
  isAllBranches?: Maybe<Scalars['Boolean']['output']>;
  refreshToken: Scalars['String']['output'];
  user: UserProfile;
};

export type BackgroundJob = {
  __typename?: 'BackgroundJob';
  backgroundJobID: Scalars['UUID']['output'];
  branchID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  finishedDatetime?: Maybe<Scalars['Time']['output']>;
  finishedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  jobCategory: Scalars['String']['output'];
  jobData: Scalars['String']['output'];
  jobDescription: Scalars['String']['output'];
  jobKey: Scalars['String']['output'];
  jobMessage: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  retryCount: Scalars['Int']['output'];
  startedDatetime?: Maybe<Scalars['Time']['output']>;
  startedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type BackgroundJobCreateInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  finishedDatetime?: InputMaybe<Scalars['Time']['input']>;
  finishedDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  jobCategory: Scalars['String']['input'];
  jobData?: InputMaybe<Scalars['String']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  jobKey: Scalars['String']['input'];
  jobMessage?: InputMaybe<Scalars['String']['input']>;
  jobType: Scalars['String']['input'];
  processedCount?: InputMaybe<Scalars['Int']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  startedDatetime?: InputMaybe<Scalars['Time']['input']>;
  startedDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  status: Scalars['String']['input'];
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type BackgroundJobPaged = {
  __typename?: 'BackgroundJobPaged';
  items?: Maybe<Array<BackgroundJob>>;
  pagination: PaginationResult;
};

export type BackgroundJobQopFilterInput = {
  backgroundJobIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  finishedDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  finishedDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  jobCategory?: InputMaybe<Scalars['String']['input']>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  startedDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  startedDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type BackgroundJobQopInput = {
  filters?: InputMaybe<BackgroundJobQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BackgroundJobUpdateInput = {
  backgroundJobID: Scalars['UUID']['input'];
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  finishedDatetime?: InputMaybe<Scalars['Time']['input']>;
  finishedDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  jobCategory: Scalars['String']['input'];
  jobData?: InputMaybe<Scalars['String']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  jobKey: Scalars['String']['input'];
  jobMessage?: InputMaybe<Scalars['String']['input']>;
  jobType: Scalars['String']['input'];
  processedCount?: InputMaybe<Scalars['Int']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  startedDatetime?: InputMaybe<Scalars['Time']['input']>;
  startedDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  status: Scalars['String']['input'];
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type Bank = {
  __typename?: 'Bank';
  bankID: Scalars['UUID']['output'];
  bankName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  bank: Bank;
  bankAccountID: Scalars['UUID']['output'];
  bankAccountNumber: Scalars['String']['output'];
  bankID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  journalAccountCode: Scalars['String']['output'];
  journalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  journalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type BankAccountCreateInput = {
  bankAccountNumber: Scalars['String']['input'];
  bankID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
};

export type BankAccountPaged = {
  __typename?: 'BankAccountPaged';
  items?: Maybe<Array<BankAccount>>;
  pagination: PaginationResult;
};

export type BankAccountQopFilterInput = {
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BankAccountQopInput = {
  filters?: InputMaybe<BankAccountQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankAccountUpdateInput = {
  bankAccountID: Scalars['UUID']['input'];
  bankAccountNumber: Scalars['String']['input'];
  bankID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
};

export type BankCreateInput = {
  bankName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BankDataRow = {
  __typename?: 'BankDataRow';
  amount: Scalars['Float']['output'];
  approvalCode: Scalars['String']['output'];
  bankAccountID: Scalars['UUID']['output'];
  bankDataRowID: Scalars['UUID']['output'];
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankName: Scalars['String']['output'];
  bankReconciliationID?: Maybe<Scalars['UUID']['output']>;
  bankReconciliationItemID?: Maybe<Scalars['UUID']['output']>;
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName: Scalars['String']['output'];
  cardNumber: Scalars['String']['output'];
  externalTransactionID: Scalars['String']['output'];
  isMatched: Scalars['Boolean']['output'];
  matchedAt?: Maybe<Scalars['Time']['output']>;
  mdrAmount: Scalars['Float']['output'];
  merchantID: Scalars['String']['output'];
  merchantName: Scalars['String']['output'];
  netAmount: Scalars['Float']['output'];
  referenceNumber: Scalars['String']['output'];
  settlementDate?: Maybe<Scalars['Time']['output']>;
  terminalID: Scalars['String']['output'];
  transactionDate: Scalars['Time']['output'];
  transactionTime: Scalars['String']['output'];
  uploadBatchID?: Maybe<Scalars['UUID']['output']>;
  uploadFilename: Scalars['String']['output'];
};

export type BankDataRowPaged = {
  __typename?: 'BankDataRowPaged';
  items: Array<BankDataRow>;
  pagination: PaginationResult;
};

export type BankDataRowQopFilterInput = {
  approvalCode?: InputMaybe<Scalars['String']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankReconciliationID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  isMatched?: InputMaybe<Scalars['Boolean']['input']>;
  merchantID?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  transactionDateFrom?: InputMaybe<Scalars['Time']['input']>;
  transactionDateTo?: InputMaybe<Scalars['Time']['input']>;
  uploadBatchID?: InputMaybe<Scalars['UUID']['input']>;
};

export type BankDataRowQopInput = {
  filters?: InputMaybe<BankDataRowQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankPaged = {
  __typename?: 'BankPaged';
  items?: Maybe<Array<Bank>>;
  pagination: PaginationResult;
};

export type BankQopFilterInput = {
  bankName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BankQopInput = {
  filters?: InputMaybe<BankQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankReconciliation = {
  __typename?: 'BankReconciliation';
  bankID: Scalars['UUID']['output'];
  bankName: Scalars['String']['output'];
  bankReconciliationID: Scalars['UUID']['output'];
  bankReconciliationNumber: Scalars['String']['output'];
  branches: Array<BankReconciliationBranch>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  doneByUserID?: Maybe<Scalars['UUID']['output']>;
  doneByUserName?: Maybe<Scalars['String']['output']>;
  doneDatetime?: Maybe<Scalars['Time']['output']>;
  doneDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  reconDate: Scalars['Time']['output'];
  reconDatetime: Scalars['Time']['output'];
  reconDatetimeUtc: Scalars['Time']['output'];
  settlementDateFrom?: Maybe<Scalars['Time']['output']>;
  settlementDateTo?: Maybe<Scalars['Time']['output']>;
  statementFileID?: Maybe<Scalars['UUID']['output']>;
  statementFileName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalItems: Scalars['Int']['output'];
  totalMatched: Scalars['Int']['output'];
  totalPartialMatched: Scalars['Int']['output'];
  totalUnmatched: Scalars['Int']['output'];
};

export type BankReconciliationBranch = {
  __typename?: 'BankReconciliationBranch';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
};

export type BankReconciliationCancelInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['UUID']['input'];
};

export type BankReconciliationColumnMapInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationCreateInput = {
  bankID: Scalars['UUID']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  branchIDs: Array<Scalars['UUID']['input']>;
  reconDate?: InputMaybe<Scalars['Time']['input']>;
  transactionDateFrom: Scalars['Time']['input'];
  transactionDateTo: Scalars['Time']['input'];
};

export type BankReconciliationExport = {
  __typename?: 'BankReconciliationExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type BankReconciliationExportInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  statuses: Array<Scalars['String']['input']>;
};

export type BankReconciliationFile = {
  __typename?: 'BankReconciliationFile';
  bankID: Scalars['UUID']['output'];
  bankReconciliationFileID: Scalars['UUID']['output'];
  bankReconciliationID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  midFailureCount: Scalars['Int']['output'];
  rowCount: Scalars['Int']['output'];
  settlementDateFrom?: Maybe<Scalars['Time']['output']>;
  settlementDateTo?: Maybe<Scalars['Time']['output']>;
  statementFileID: Scalars['UUID']['output'];
  statementFileName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type BankReconciliationFileMappingInput = {
  columns: Array<BankReconciliationColumnMapInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type BankReconciliationFinalizeInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type BankReconciliationImportDuplicateMerchantId = {
  __typename?: 'BankReconciliationImportDuplicateMerchantID';
  branches: Array<BankReconciliationImportMerchantBranch>;
  merchantID: Scalars['String']['output'];
};

export type BankReconciliationImportMerchantBranch = {
  __typename?: 'BankReconciliationImportMerchantBranch';
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
};

export type BankReconciliationImportRowReport = {
  __typename?: 'BankReconciliationImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  validTotalAmount: Scalars['Float']['output'];
  violationGroups: Array<BankReconciliationImportRowViolationGroup>;
  violationSample: Array<BankReconciliationImportRowViolation>;
};

export type BankReconciliationImportRowViolation = {
  __typename?: 'BankReconciliationImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BankReconciliationImportRowViolationGroup = {
  __typename?: 'BankReconciliationImportRowViolationGroup';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  sampleRowNumbers: Array<Scalars['Int']['output']>;
  sampleValue: Scalars['String']['output'];
  standardKey: Scalars['String']['output'];
};

export type BankReconciliationImportValidateInput = {
  bankID: Scalars['UUID']['input'];
  fileID: Scalars['UUID']['input'];
  fileMapping: BankReconciliationFileMappingInput;
  reconDate: Scalars['Time']['input'];
};

export type BankReconciliationImportValidateResult = {
  __typename?: 'BankReconciliationImportValidateResult';
  alreadyReconciledAmount: Scalars['Float']['output'];
  alreadyReconciledCount: Scalars['Int']['output'];
  duplicateMerchantIDs: Array<BankReconciliationImportDuplicateMerchantId>;
  missingMerchantIDs: Array<Scalars['String']['output']>;
  rowReport: BankReconciliationImportRowReport;
};

export type BankReconciliationItem = {
  __typename?: 'BankReconciliationItem';
  amount: Scalars['Float']['output'];
  approvalCode: Scalars['String']['output'];
  bankAccountID: Scalars['UUID']['output'];
  bankBranchID?: Maybe<Scalars['UUID']['output']>;
  bankBranchName: Scalars['String']['output'];
  bankExist: Scalars['Boolean']['output'];
  bankReconciliationID: Scalars['UUID']['output'];
  bankReconciliationItemID: Scalars['UUID']['output'];
  cardNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalTransactionID: Scalars['String']['output'];
  isReconciliation: Scalars['Boolean']['output'];
  issuer: Scalars['String']['output'];
  matchedAt?: Maybe<Scalars['Time']['output']>;
  matchedAtUtc?: Maybe<Scalars['Time']['output']>;
  matchedSalesInvoicePaymentID?: Maybe<Scalars['UUID']['output']>;
  mdrAmount: Scalars['Float']['output'];
  merchantID: Scalars['String']['output'];
  merchantName: Scalars['String']['output'];
  netAmount: Scalars['Float']['output'];
  note: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentApprovalCode: Scalars['String']['output'];
  paymentBankReferenceNumber: Scalars['String']['output'];
  paymentBranchID?: Maybe<Scalars['UUID']['output']>;
  paymentBranchName: Scalars['String']['output'];
  paymentCardNumber: Scalars['String']['output'];
  paymentCashierUserName: Scalars['String']['output'];
  paymentDate?: Maybe<Scalars['Time']['output']>;
  paymentDatetime?: Maybe<Scalars['Time']['output']>;
  paymentMethodID?: Maybe<Scalars['UUID']['output']>;
  paymentMethodName: Scalars['String']['output'];
  rawDescription: Scalars['String']['output'];
  reconciliationStatus: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  resolution: Scalars['String']['output'];
  resolutionReason: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Time']['output']>;
  resolvedAtUtc?: Maybe<Scalars['Time']['output']>;
  resolvedByUserID?: Maybe<Scalars['UUID']['output']>;
  resolvedByUserName?: Maybe<Scalars['String']['output']>;
  salesInvoiceID?: Maybe<Scalars['UUID']['output']>;
  salesInvoiceNumber: Scalars['String']['output'];
  salesInvoicePaymentID?: Maybe<Scalars['UUID']['output']>;
  salesPaymentExist: Scalars['Boolean']['output'];
  settlementDate?: Maybe<Scalars['Time']['output']>;
  terminalID: Scalars['String']['output'];
  transactionDate?: Maybe<Scalars['Time']['output']>;
  transactionTime: Scalars['String']['output'];
};

export type BankReconciliationItemManualMatchInput = {
  bankReconciliationItemID: Scalars['UUID']['input'];
  matchedSalesInvoicePaymentID?: InputMaybe<Scalars['UUID']['input']>;
  reconciliationStatus: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationItemMergeInput = {
  reconciliationStatus: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
  sourceItemID: Scalars['UUID']['input'];
  targetItemID: Scalars['UUID']['input'];
};

export type BankReconciliationItemPaged = {
  __typename?: 'BankReconciliationItemPaged';
  items: Array<BankReconciliationItem>;
  pagination: PaginationResult;
};

export type BankReconciliationItemQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  approvalCode?: InputMaybe<Scalars['String']['input']>;
  bankBranchID?: InputMaybe<Scalars['UUID']['input']>;
  bankReconciliationID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  merchantID?: InputMaybe<Scalars['String']['input']>;
  paymentBranchID?: InputMaybe<Scalars['UUID']['input']>;
  paymentDateFrom?: InputMaybe<Scalars['String']['input']>;
  paymentDateTo?: InputMaybe<Scalars['String']['input']>;
  reconciliationStatus?: InputMaybe<Scalars['String']['input']>;
  reconciliationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationItemQopInput = {
  filters?: InputMaybe<BankReconciliationItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankReconciliationItemResolveInput = {
  bankReconciliationItemID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  resolution: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationItemsBulkResolveByFilterInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  filters?: InputMaybe<BankReconciliationItemQopFilterInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  resolution: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationItemsBulkResolveInput = {
  bankReconciliationItemIDs: Array<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  resolution: Scalars['String']['input'];
  resolutionReason?: InputMaybe<Scalars['String']['input']>;
};

export type BankReconciliationPaged = {
  __typename?: 'BankReconciliationPaged';
  items: Array<BankReconciliation>;
  pagination: PaginationResult;
};

export type BankReconciliationProcessInput = {
  bankReconciliationID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type BankReconciliationQopFilterInput = {
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankReconciliationNumber?: InputMaybe<Scalars['String']['input']>;
  reconDateEnd?: InputMaybe<Scalars['Time']['input']>;
  reconDateStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BankReconciliationQopInput = {
  filters?: InputMaybe<BankReconciliationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BankReconciliationRemoveFileInput = {
  bankReconciliationFileID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type BankReconciliationUploadFileInput = {
  bankID: Scalars['UUID']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  fileMapping: BankReconciliationFileMappingInput;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  reconDate?: InputMaybe<Scalars['Time']['input']>;
  statementFileID: Scalars['UUID']['input'];
};

export type BankReconciliationUploadPoolFileInput = {
  bankID: Scalars['UUID']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  fileMapping: BankReconciliationFileMappingInput;
  statementFileID: Scalars['UUID']['input'];
};

export type BankUpdateInput = {
  bankID: Scalars['UUID']['input'];
  bankName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BarcodeConflictOwner = {
  __typename?: 'BarcodeConflictOwner';
  barcode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isConsignment: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
};

export type BaseModelAddress = {
  __typename?: 'BaseModelAddress';
  cityID?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryID?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  provinceID?: Maybe<Scalars['String']['output']>;
  provinceName?: Maybe<Scalars['String']['output']>;
  subdistrictID?: Maybe<Scalars['String']['output']>;
  subdistrictName?: Maybe<Scalars['String']['output']>;
};

export type BatchExecutionInput = {
  executions: Array<RecordExecutionInput>;
  putawayTaskID: Scalars['UUID']['input'];
};

export type BatchExecutionResult = {
  __typename?: 'BatchExecutionResult';
  errors: Array<Scalars['String']['output']>;
  failureCount: Scalars['Int']['output'];
  results: Array<ExecutionResult>;
  successCount: Scalars['Int']['output'];
};

export type BiKnowledge = {
  __typename?: 'BiKnowledge';
  biKnowledgeID: Scalars['UUID']['output'];
  category: Scalars['String']['output'];
  contentMD: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  sourceFile: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BiKnowledgeCreateInput = {
  category: Scalars['String']['input'];
  contentMD: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
  sourceFile: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BiKnowledgePaged = {
  __typename?: 'BiKnowledgePaged';
  items?: Maybe<Array<BiKnowledge>>;
  pagination: PaginationResult;
};

export type BiKnowledgeQopFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BiKnowledgeQopInput = {
  filters?: InputMaybe<BiKnowledgeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BiKnowledgeUpdateInput = {
  biKnowledgeID: Scalars['UUID']['input'];
  category: Scalars['String']['input'];
  contentMD: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
  sourceFile: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BiLeader = {
  __typename?: 'BiLeader';
  count: Scalars['Int']['output'];
  successRate: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type BiMonitorSummary = {
  __typename?: 'BiMonitorSummary';
  activeUsers7d: Scalars['Int']['output'];
  leaders: Array<BiLeader>;
  questionsToday: Scalars['Int']['output'];
  successRate7d: Scalars['Int']['output'];
  topTables: Array<BiTableUsage>;
  usage14d: Array<BiUsageDay>;
};

export type BiRole = {
  __typename?: 'BiRole';
  allowedCategories: Scalars['String']['output'];
  blockedTables: Scalars['String']['output'];
  canSeeAllBranches: Scalars['Boolean']['output'];
  consignmentOnly: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  role: Scalars['String']['output'];
};

export type BiRoleCreateInput = {
  allowedCategories: Scalars['String']['input'];
  blockedTables: Scalars['String']['input'];
  canSeeAllBranches: Scalars['Boolean']['input'];
  consignmentOnly: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type BiRolePaged = {
  __typename?: 'BiRolePaged';
  items?: Maybe<Array<BiRole>>;
  pagination: PaginationResult;
};

export type BiRoleQopFilterInput = {
  role?: InputMaybe<Scalars['String']['input']>;
};

export type BiRoleQopInput = {
  filters?: InputMaybe<BiRoleQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BiRoleUpdateInput = {
  allowedCategories: Scalars['String']['input'];
  blockedTables: Scalars['String']['input'];
  canSeeAllBranches: Scalars['Boolean']['input'];
  consignmentOnly: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type BiScopeTable = {
  __typename?: 'BiScopeTable';
  category: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  tableName: Scalars['String']['output'];
};

export type BiScopeTableBulkUpdateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  tableNames: Array<Scalars['String']['input']>;
};

export type BiScopeTableBulkUpdateResult = {
  __typename?: 'BiScopeTableBulkUpdateResult';
  updatedCount: Scalars['Int']['output'];
};

export type BiScopeTableCreateInput = {
  category: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  tableName: Scalars['String']['input'];
};

export type BiScopeTablePaged = {
  __typename?: 'BiScopeTablePaged';
  items?: Maybe<Array<BiScopeTable>>;
  pagination: PaginationResult;
};

export type BiScopeTableQopFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
};

export type BiScopeTableQopInput = {
  filters?: InputMaybe<BiScopeTableQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BiScopeTableUpdateInput = {
  category: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  tableName: Scalars['String']['input'];
};

export type BiTableUsage = {
  __typename?: 'BiTableUsage';
  count: Scalars['Int']['output'];
  tableName: Scalars['String']['output'];
};

export type BiUsageDay = {
  __typename?: 'BiUsageDay';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type BiUser = {
  __typename?: 'BiUser';
  allowedBranchNames: Scalars['String']['output'];
  allowedBranches: Scalars['String']['output'];
  biUserID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  requestEmail: Scalars['String']['output'];
  role: Scalars['String']['output'];
  telegramUserID: Scalars['Int']['output'];
  vendorID: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

export type BiUserCreateInput = {
  allowedBranchNames?: InputMaybe<Scalars['String']['input']>;
  allowedBranches: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
  telegramUserID: Scalars['Int']['input'];
  vendorID: Scalars['String']['input'];
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type BiUserPaged = {
  __typename?: 'BiUserPaged';
  items?: Maybe<Array<BiUser>>;
  pagination: PaginationResult;
};

export type BiUserQopFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type BiUserQopInput = {
  filters?: InputMaybe<BiUserQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BiUserUpdateInput = {
  allowedBranchNames?: InputMaybe<Scalars['String']['input']>;
  allowedBranches: Scalars['String']['input'];
  biUserID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
  telegramUserID: Scalars['Int']['input'];
  vendorID: Scalars['String']['input'];
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type BillOfMaterial = {
  __typename?: 'BillOfMaterial';
  billOfMaterialID: Scalars['UUID']['output'];
  components: Array<BillOfMaterialComponent>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uom?: Maybe<Uom>;
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
};

export type BillOfMaterialComponent = {
  __typename?: 'BillOfMaterialComponent';
  billOfMaterialComponentID: Scalars['UUID']['output'];
  billOfMaterialID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uom?: Maybe<Uom>;
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
};

export type BillOfMaterialComponentCreateInput = {
  billOfMaterialComponentID?: InputMaybe<Scalars['UUID']['input']>;
  isActive: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type BillOfMaterialComponentPaged = {
  __typename?: 'BillOfMaterialComponentPaged';
  items?: Maybe<Array<BillOfMaterialComponent>>;
  pagination: PaginationResult;
};

export type BillOfMaterialComponentQopFilterInput = {
  billOfMaterialID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  qty?: InputMaybe<Scalars['Float']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BillOfMaterialComponentQopInput = {
  filters?: InputMaybe<BillOfMaterialComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BillOfMaterialComponentUpdateInput = {
  billOfMaterialComponentID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type BillOfMaterialCreateInput = {
  components?: InputMaybe<Array<BillOfMaterialComponentCreateInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type BillOfMaterialPaged = {
  __typename?: 'BillOfMaterialPaged';
  items?: Maybe<Array<BillOfMaterial>>;
  pagination: PaginationResult;
};

export type BillOfMaterialQopFilterInput = {
  billOfMaterialName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BillOfMaterialQopInput = {
  filters?: InputMaybe<BillOfMaterialQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BillOfMaterialUpdateInput = {
  billOfMaterialID: Scalars['UUID']['input'];
  components?: InputMaybe<Array<BillOfMaterialComponentCreateInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type Branch = {
  __typename?: 'Branch';
  addressLabel?: Maybe<Scalars['String']['output']>;
  branchCategory?: Maybe<BranchCategory>;
  branchCategoryID: Scalars['UUID']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  branchPosBookmarks: Array<BranchPosBookmark>;
  branchSalesPaymentMethods: Array<BranchSalesPaymentMethod>;
  branchStoreSupervisors: Array<BranchStoreSupervisor>;
  branchType: Scalars['String']['output'];
  canSell?: Maybe<Scalars['Boolean']['output']>;
  cashJournalAccountCode?: Maybe<Scalars['String']['output']>;
  cashJournalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  cashJournalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  edcTerminals: Array<EdcTerminal>;
  entityAuditMetadata: EntityAuditMetadata;
  erpRefCode?: Maybe<Scalars['String']['output']>;
  erpRefID?: Maybe<Scalars['String']['output']>;
  erpRefName?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isMain?: Maybe<Scalars['Boolean']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  mainSupplyWarehouse?: Maybe<Warehouse>;
  mainSupplyWarehouseID?: Maybe<Scalars['UUID']['output']>;
  pettyCashJournalAccountCode?: Maybe<Scalars['String']['output']>;
  pettyCashJournalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  pettyCashJournalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  picName?: Maybe<Scalars['String']['output']>;
  picPhoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  pricelist?: Maybe<Pricelist>;
  pricelistID?: Maybe<Scalars['UUID']['output']>;
  productAvailabilityTemplate?: Maybe<ProductAvailabilityTemplate>;
  productAvailabilityTemplateID?: Maybe<Scalars['UUID']['output']>;
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  subdistrict?: Maybe<Subdistrict>;
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  warehouseDeliveryLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseID?: Maybe<Scalars['UUID']['output']>;
  warehouseInboundLocationID?: Maybe<Scalars['UUID']['output']>;
  warehousePackingLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseTransitID?: Maybe<Scalars['UUID']['output']>;
  warehouseTransitLocationID?: Maybe<Scalars['UUID']['output']>;
};

export type BranchBankAccount = {
  __typename?: 'BranchBankAccount';
  bankAccount?: Maybe<BankAccount>;
  bankAccountID: Scalars['UUID']['output'];
  branch: Branch;
  branchBankAccountID: Scalars['UUID']['output'];
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  merchantID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchBankAccountCreateInput = {
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  merchantID: Scalars['String']['input'];
};

export type BranchBankAccountPaged = {
  __typename?: 'BranchBankAccountPaged';
  items: Array<BranchBankAccount>;
  pagination: PaginationResult;
};

export type BranchBankAccountQopFilterInput = {
  bankAccountID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  merchantID?: InputMaybe<Scalars['String']['input']>;
};

export type BranchBankAccountQopInput = {
  filters?: InputMaybe<BranchBankAccountQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchBankAccountUpdateInput = {
  bankAccountID: Scalars['UUID']['input'];
  branchBankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  merchantID: Scalars['String']['input'];
};

export type BranchCategory = {
  __typename?: 'BranchCategory';
  branchCategoryID: Scalars['UUID']['output'];
  branchCategoryName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchCategoryCreateInput = {
  branchCategoryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BranchCategoryPaged = {
  __typename?: 'BranchCategoryPaged';
  items?: Maybe<Array<BranchCategory>>;
  pagination: PaginationResult;
};

export type BranchCategoryQopFilterInput = {
  branchCategoryName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchCategoryQopInput = {
  filters?: InputMaybe<BranchCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchCategoryUpdateInput = {
  branchCategoryID: Scalars['UUID']['input'];
  branchCategoryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BranchCreateInput = {
  addressLabel?: InputMaybe<Scalars['String']['input']>;
  branchCategoryID: Scalars['UUID']['input'];
  branchCode: Scalars['String']['input'];
  branchName: Scalars['String']['input'];
  branchPosBookmarks?: InputMaybe<Array<BranchPosBookmarkInput>>;
  branchSalesPaymentMethods?: InputMaybe<Array<BranchSalesPaymentMethodInput>>;
  branchStoreSupervisors?: InputMaybe<Array<BranchStoreSupervisorInput>>;
  branchType: Scalars['String']['input'];
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  cashJournalAccountCode?: InputMaybe<Scalars['String']['input']>;
  cashJournalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  cashJournalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  erpRefCode?: InputMaybe<Scalars['String']['input']>;
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mainSupplyWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashJournalAccountCode?: InputMaybe<Scalars['String']['input']>;
  pettyCashJournalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  pettyCashJournalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  picName?: InputMaybe<Scalars['String']['input']>;
  picPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One entry of the branch picker: a name to show, an id to
 * store, and the warehouse the device will book stock against.
 *
 * Every field here is lightweight and safe for dropdowns / POS first-run.
 * Contact details, journal account codes, addresses and coordinates stay on `Branch`, behind
 * `branches`/`branch`, which remain authenticated.
 */
export type BranchLite = {
  __typename?: 'BranchLite';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  /**
   * Warehouse the device books stock against. Null for a branch with no warehouse
   *   configured. POS needs it at setup time: the authenticated backfill that would
   *   otherwise fill it in only runs on the next sync, which is after login.
   */
  warehouseID?: Maybe<Scalars['UUID']['output']>;
};

export type BranchPaged = {
  __typename?: 'BranchPaged';
  items?: Maybe<Array<Branch>>;
  pagination: PaginationResult;
};

export type BranchPosBookmark = {
  __typename?: 'BranchPosBookmark';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  branchPosBookmarkID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  posBookmark?: Maybe<PosBookmark>;
  posBookmarkID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchPosBookmarkCreateInput = {
  branchID: Scalars['UUID']['input'];
  posBookmarkID: Scalars['UUID']['input'];
};

export type BranchPosBookmarkInput = {
  branchPosBookmarkID?: InputMaybe<Scalars['UUID']['input']>;
  posBookmarkID: Scalars['UUID']['input'];
};

export type BranchPosBookmarkPaged = {
  __typename?: 'BranchPosBookmarkPaged';
  items?: Maybe<Array<BranchPosBookmark>>;
  pagination: PaginationResult;
};

export type BranchPosBookmarkQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  posBookmarkID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchPosBookmarkQopInput = {
  filters?: InputMaybe<BranchPosBookmarkQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchPosBookmarkUpdateInput = {
  branchID: Scalars['UUID']['input'];
  branchPosBookmarkID: Scalars['UUID']['input'];
  posBookmarkID: Scalars['UUID']['input'];
};

export type BranchProductSalesChannelItem = {
  __typename?: 'BranchProductSalesChannelItem';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchProductSalesChannelItemID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  note: Scalars['String']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  salesChannelCategoryGroupID?: Maybe<Scalars['UUID']['output']>;
  salesChannelID: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchProductSalesChannelItemDisableInput = {
  branchID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type BranchProductSalesChannelItemPaged = {
  __typename?: 'BranchProductSalesChannelItemPaged';
  items?: Maybe<Array<BranchProductSalesChannelItem>>;
  pagination: PaginationResult;
};

export type BranchProductSalesChannelItemQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchProductSalesChannelItemQopInput = {
  filters?: InputMaybe<BranchProductSalesChannelItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchProductSalesChannelItemRestoreInput = {
  branchID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type BranchProfile = {
  __typename?: 'BranchProfile';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  warehouse?: Maybe<BranchWarehouseProfile>;
  warehouseInboundLocation?: Maybe<BranchWarehouseLocationProfile>;
  warehouseTransitLocation?: Maybe<BranchWarehouseLocationProfile>;
};

export type BranchQopFilterInput = {
  branchCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  branchType?: InputMaybe<Scalars['String']['input']>;
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  mainSupplyWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchQopInput = {
  filters?: InputMaybe<BranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchQrisMerchant = {
  __typename?: 'BranchQrisMerchant';
  bank: Bank;
  bankID: Scalars['UUID']['output'];
  bankName: Scalars['String']['output'];
  branch: Branch;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  branchQrisMerchantID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  merchantName: Scalars['String']['output'];
  nmid: Scalars['String']['output'];
  providerCode: Scalars['String']['output'];
  terminalID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchQrisMerchantCreateInput = {
  bankID: Scalars['UUID']['input'];
  bankName: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  merchantName: Scalars['String']['input'];
  nmid: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  terminalID: Scalars['String']['input'];
};

export type BranchQrisMerchantPaged = {
  __typename?: 'BranchQrisMerchantPaged';
  items: Array<BranchQrisMerchant>;
  pagination: PaginationResult;
};

export type BranchQrisMerchantQopFilterInput = {
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  nmid?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  terminalID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchQrisMerchantQopInput = {
  filters?: InputMaybe<BranchQrisMerchantQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchQrisMerchantUpdateInput = {
  bankID: Scalars['UUID']['input'];
  bankName: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  branchQrisMerchantID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  merchantName: Scalars['String']['input'];
  nmid: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  terminalID: Scalars['String']['input'];
};

export type BranchSalesChannelCategoryGroup = {
  __typename?: 'BranchSalesChannelCategoryGroup';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  branchSalesChannelCategoryGroupID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryGroupName: Scalars['String']['output'];
  salesChannelID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchSalesChannelCategoryGroupCreateInput = {
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID: Scalars['String']['input'];
};

export type BranchSalesChannelCategoryGroupPaged = {
  __typename?: 'BranchSalesChannelCategoryGroupPaged';
  items?: Maybe<Array<BranchSalesChannelCategoryGroup>>;
  pagination: PaginationResult;
};

export type BranchSalesChannelCategoryGroupQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchSalesChannelCategoryGroupQopInput = {
  filters?: InputMaybe<BranchSalesChannelCategoryGroupQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchSalesChannelCategoryGroupUpdateInput = {
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  branchSalesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID: Scalars['String']['input'];
};

export type BranchSalesChannelMerchantMap = {
  __typename?: 'BranchSalesChannelMerchantMap';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  branchSalesChannelMerchantMapID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalMerchantID: Scalars['String']['output'];
  externalStoreID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isPaused: Scalars['Boolean']['output'];
  operatingHours?: Maybe<OperatingHours>;
  packagingChargeAmount: Scalars['Float']['output'];
  packagingProduct?: Maybe<Product>;
  packagingProductID?: Maybe<Scalars['UUID']['output']>;
  packagingQty: Scalars['Float']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchSalesChannelMerchantMapCreateInput = {
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  externalMerchantID: Scalars['String']['input'];
  externalStoreID: Scalars['String']['input'];
  isActive?: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName?: InputMaybe<Scalars['String']['input']>;
};

export type BranchSalesChannelMerchantMapPaged = {
  __typename?: 'BranchSalesChannelMerchantMapPaged';
  items?: Maybe<Array<BranchSalesChannelMerchantMap>>;
  pagination: PaginationResult;
};

export type BranchSalesChannelMerchantMapQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  externalStoreID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPaused?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchSalesChannelMerchantMapQopInput = {
  filters?: InputMaybe<BranchSalesChannelMerchantMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchSalesChannelMerchantMapUpdateInput = {
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
  externalMerchantID: Scalars['String']['input'];
  externalStoreID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName?: InputMaybe<Scalars['String']['input']>;
};

export type BranchSalesChannelOperatingHoursUpdateInput = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
  operatingHours: OperatingHoursInput;
};

export type BranchSalesChannelPackagingUpdateInput = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
  packagingChargeAmount?: Scalars['Float']['input'];
  packagingProductID?: InputMaybe<Scalars['UUID']['input']>;
  packagingQty?: Scalars['Float']['input'];
};

export type BranchSalesChannelPauseUpdateInput = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
  duration?: InputMaybe<PauseDuration>;
  isPaused: Scalars['Boolean']['input'];
};

export type BranchSalesPaymentMethod = {
  __typename?: 'BranchSalesPaymentMethod';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  branchSalesPaymentMethodID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  paymentMethod?: Maybe<SalesPaymentMethod>;
  paymentMethodID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type BranchSalesPaymentMethodCreateInput = {
  branchID: Scalars['UUID']['input'];
  paymentMethodID: Scalars['UUID']['input'];
};

export type BranchSalesPaymentMethodInput = {
  branchSalesPaymentMethodID?: InputMaybe<Scalars['UUID']['input']>;
  paymentMethodID: Scalars['UUID']['input'];
};

export type BranchSalesPaymentMethodPaged = {
  __typename?: 'BranchSalesPaymentMethodPaged';
  items?: Maybe<Array<BranchSalesPaymentMethod>>;
  pagination: PaginationResult;
};

export type BranchSalesPaymentMethodQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  paymentMethodID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type BranchSalesPaymentMethodQopInput = {
  filters?: InputMaybe<BranchSalesPaymentMethodQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchSalesPaymentMethodUpdateInput = {
  branchID: Scalars['UUID']['input'];
  branchSalesPaymentMethodID: Scalars['UUID']['input'];
  paymentMethodID: Scalars['UUID']['input'];
};

export type BranchStoreSupervisor = {
  __typename?: 'BranchStoreSupervisor';
  branchID: Scalars['UUID']['output'];
  branchStoreSupervisorID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
  user?: Maybe<User>;
  userID: Scalars['UUID']['output'];
};

export type BranchStoreSupervisorCreateInput = {
  branchID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  userIDs: Array<Scalars['UUID']['input']>;
};

export type BranchStoreSupervisorCreated = {
  __typename?: 'BranchStoreSupervisorCreated';
  branchID: Scalars['UUID']['output'];
  branchStoreSupervisorID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
  userID: Scalars['UUID']['output'];
};

export type BranchStoreSupervisorInput = {
  branchStoreSupervisorID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  userID: Scalars['UUID']['input'];
};

export type BranchStoreSupervisorPaged = {
  __typename?: 'BranchStoreSupervisorPaged';
  items?: Maybe<Array<BranchStoreSupervisor>>;
  pagination: PaginationResult;
};

export type BranchStoreSupervisorQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  userID?: InputMaybe<Scalars['UUID']['input']>;
};

export type BranchStoreSupervisorQopInput = {
  filters?: InputMaybe<BranchStoreSupervisorQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type BranchStoreSupervisorUpdateInput = {
  branchStoreSupervisorID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type BranchUpdateInput = {
  addressLabel?: InputMaybe<Scalars['String']['input']>;
  branchCategoryID: Scalars['UUID']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  branchPosBookmarks?: InputMaybe<Array<BranchPosBookmarkInput>>;
  branchSalesPaymentMethods?: InputMaybe<Array<BranchSalesPaymentMethodInput>>;
  branchStoreSupervisors?: InputMaybe<Array<BranchStoreSupervisorInput>>;
  branchType: Scalars['String']['input'];
  canSell?: InputMaybe<Scalars['Boolean']['input']>;
  cashJournalAccountCode?: InputMaybe<Scalars['String']['input']>;
  cashJournalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  cashJournalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  erpRefCode?: InputMaybe<Scalars['String']['input']>;
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mainSupplyWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashJournalAccountCode?: InputMaybe<Scalars['String']['input']>;
  pettyCashJournalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  pettyCashJournalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  picName?: InputMaybe<Scalars['String']['input']>;
  picPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
};

export type BranchWarehouseLocationProfile = {
  __typename?: 'BranchWarehouseLocationProfile';
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type BranchWarehouseProfile = {
  __typename?: 'BranchWarehouseProfile';
  warehouseCode: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseName: Scalars['String']['output'];
  warehouseType: Scalars['String']['output'];
};

export type BulkConsignmentEmailResult = {
  __typename?: 'BulkConsignmentEmailResult';
  error: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  vendorConsignmentInvoiceID: Scalars['UUID']['output'];
};

export type BulkConsignmentGenerateResult = {
  __typename?: 'BulkConsignmentGenerateResult';
  error: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  vendorConsignmentInvoiceID: Scalars['UUID']['output'];
};

export type BulkConsignmentPayResult = {
  __typename?: 'BulkConsignmentPayResult';
  error: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  vendorConsignmentInvoiceID: Scalars['UUID']['output'];
};

export type BulkContainerGenerationInput = {
  packingTaskID: Scalars['UUID']['input'];
  packingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
};

export type CancelTaskInput = {
  putawayTaskID: Scalars['UUID']['input'];
};

export type ChangePasswordInput = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type ChannelTaxonomyNode = {
  __typename?: 'ChannelTaxonomyNode';
  externalCategoryID: Scalars['String']['output'];
  externalCategoryName: Scalars['String']['output'];
  externalParentCategoryID: Scalars['String']['output'];
  externalParentCategoryName: Scalars['String']['output'];
};

export type CheckOtpRequest = {
  tokenCode: Scalars['String']['input'];
  tokenType: TokenType;
  userName: Scalars['String']['input'];
};

export type CheckOtpResponse = {
  __typename?: 'CheckOTPResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CheckReadyGenerateDeliveryOrderBulk = {
  __typename?: 'CheckReadyGenerateDeliveryOrderBulk';
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  isReadyGenerateDeliveryOrder: Scalars['Boolean']['output'];
  reasonNotReadyGenerateDeliveryOrder: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalContainerReady: Scalars['Float']['output'];
};

export type City = {
  __typename?: 'City';
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  subdistricts?: Maybe<Array<Subdistrict>>;
  uniqueKey: Scalars['String']['output'];
};

export type CityCreateInput = {
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
};

export type CityPaged = {
  __typename?: 'CityPaged';
  items: Array<City>;
  pagination: PaginationResult;
};

export type CityQop = {
  filters?: InputMaybe<CityQopFilter>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type CityQopFilter = {
  cityID?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
};

export type CityUpdateInput = {
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
};

export type ConsignmentPayoutBankInput = {
  payoutBankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  payoutBankID?: InputMaybe<Scalars['UUID']['input']>;
  payoutBankName?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type ConsignmentSettlementBranchChange = {
  __typename?: 'ConsignmentSettlementBranchChange';
  branchID: Scalars['String']['output'];
  branchName: Scalars['String']['output'];
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
};

export type ConsignmentSettlementBranchInput = {
  branchID: Scalars['UUID']['input'];
  branchName?: InputMaybe<Scalars['String']['input']>;
  commissionAmount: Scalars['Float']['input'];
  payout: Scalars['Float']['input'];
  subtotal: Scalars['Float']['input'];
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type ConsignmentSettlementBranchRow = {
  __typename?: 'ConsignmentSettlementBranchRow';
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  commissionAmount: Scalars['Float']['output'];
  payout: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
};

export type ConsignmentSettlementExportResult = {
  __typename?: 'ConsignmentSettlementExportResult';
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type ConsignmentSettlementFieldChange = {
  __typename?: 'ConsignmentSettlementFieldChange';
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
};

export type ConsignmentSettlementHistory = {
  __typename?: 'ConsignmentSettlementHistory';
  branchChanges: Array<ConsignmentSettlementBranchChange>;
  editedAt: Scalars['Time']['output'];
  editedByUserID?: Maybe<Scalars['UUID']['output']>;
  editedByUserName: Scalars['String']['output'];
  fieldChanges: Array<ConsignmentSettlementFieldChange>;
  reason: Scalars['String']['output'];
  vendorConsignmentInvoiceHistoryID: Scalars['UUID']['output'];
};

export type ConsignmentSettlementListExportFilterInput = {
  periodEndDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentSettlementPeriod = {
  __typename?: 'ConsignmentSettlementPeriod';
  emailableCount: Scalars['Int']['output'];
  periodEndDate: Scalars['Time']['output'];
  periodStartDate: Scalars['Time']['output'];
  sentCount: Scalars['Int']['output'];
  totalCommission: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  totalPayout: Scalars['Float']['output'];
};

export type ConsignmentSettlementPivotRow = {
  __typename?: 'ConsignmentSettlementPivotRow';
  barcode: Scalars['String']['output'];
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  commissionAmount: Scalars['Float']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type ConsignmentStockIn = {
  __typename?: 'ConsignmentStockIn';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  consignmentStockInDatetime: Scalars['Time']['output'];
  consignmentStockInID: Scalars['UUID']['output'];
  consignmentStockInNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalReferenceNumber?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<ConsignmentStockInFile>>;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  receivedByName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItemWeightReceived: Scalars['Float']['output'];
  vendor: Vendor;
  vendorID: Scalars['UUID']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type ConsignmentStockInCreateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockInDatetime: Scalars['Time']['input'];
  consignmentStockInNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<ConsignmentStockInFileInput>>;
  items: Array<ConsignmentStockInItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockInFile = {
  __typename?: 'ConsignmentStockInFile';
  consignmentStockInFileID: Scalars['UUID']['output'];
  consignmentStockInFileType: Scalars['String']['output'];
  consignmentStockInID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ConsignmentStockInFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type ConsignmentStockInItem = {
  __typename?: 'ConsignmentStockInItem';
  baseUomQty: Scalars['Float']['output'];
  consignmentStockInID: Scalars['UUID']['output'];
  consignmentStockInItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ConsignmentStockInItemCreateInput = {
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockInItemPaged = {
  __typename?: 'ConsignmentStockInItemPaged';
  items: Array<ConsignmentStockInItem>;
  pagination: PaginationResult;
};

export type ConsignmentStockInItemQopFilterInput = {
  consignmentStockInID?: InputMaybe<Scalars['String']['input']>;
  consignmentStockInItemID?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInItemQopInput = {
  filters?: InputMaybe<ConsignmentStockInItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInItemUpdateInput = {
  consignmentStockInItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockInPaged = {
  __typename?: 'ConsignmentStockInPaged';
  items: Array<ConsignmentStockIn>;
  pagination: PaginationResult;
};

export type ConsignmentStockInQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentStockInDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockInDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockInNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInQopInput = {
  filters?: InputMaybe<ConsignmentStockInQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequest = {
  __typename?: 'ConsignmentStockInRequest';
  approvedByUserID?: Maybe<Scalars['UUID']['output']>;
  approvedByUserName?: Maybe<Scalars['String']['output']>;
  approvedDatetime?: Maybe<Scalars['Time']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  consignmentStockInID?: Maybe<Scalars['UUID']['output']>;
  consignmentStockInNumber: Scalars['String']['output'];
  consignmentStockInRequestID: Scalars['UUID']['output'];
  consignmentStockInRequestNumber: Scalars['String']['output'];
  consignmentStockOutID?: Maybe<Scalars['UUID']['output']>;
  consignmentStockOutNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  estimatedDeliveryDate: Scalars['Time']['output'];
  gmt: Scalars['Int']['output'];
  noteAdditional: Scalars['String']['output'];
  rejectedByUserID?: Maybe<Scalars['UUID']['output']>;
  rejectedByUserName?: Maybe<Scalars['String']['output']>;
  rejectedDatetime?: Maybe<Scalars['Time']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestDatetime: Scalars['Time']['output'];
  requestDatetimeUtc: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  submittedByUserID?: Maybe<Scalars['UUID']['output']>;
  submittedByUserName?: Maybe<Scalars['String']['output']>;
  submittedDatetime?: Maybe<Scalars['Time']['output']>;
  totalItemQtyApproved: Scalars['Float']['output'];
  totalItemQtyRequested: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
};

export type ConsignmentStockInRequestApproveInput = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<ConsignmentStockInRequestFileInput>>;
  items: Array<ConsignmentStockInRequestApproveItemInput>;
  receivedByName: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestApproveItemInput = {
  consignmentStockInRequestItemID: Scalars['UUID']['input'];
  expiredDate?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  qtyReceived: Scalars['Float']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentStockInRequestCancelInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  consignmentStockInRequestID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestCreateInput = {
  branchID: Scalars['UUID']['input'];
  estimatedDeliveryDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<ConsignmentStockInRequestFileInput>>;
  items: Array<ConsignmentStockInRequestItemInput>;
  noteAdditional?: InputMaybe<Scalars['String']['input']>;
  submit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsignmentStockInRequestFile = {
  __typename?: 'ConsignmentStockInRequestFile';
  consignmentStockInRequestFileID: Scalars['UUID']['output'];
  consignmentStockInRequestFileRole: Scalars['String']['output'];
  consignmentStockInRequestID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ConsignmentStockInRequestFileInput = {
  fileID: Scalars['UUID']['input'];
  fileRole: Scalars['String']['input'];
};

export type ConsignmentStockInRequestFilePaged = {
  __typename?: 'ConsignmentStockInRequestFilePaged';
  items: Array<ConsignmentStockInRequestFile>;
  pagination: PaginationResult;
};

export type ConsignmentStockInRequestFileQopFilterInput = {
  consignmentStockInRequestFileRole?: InputMaybe<Scalars['String']['input']>;
  consignmentStockInRequestID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInRequestFileQopInput = {
  filters?: InputMaybe<ConsignmentStockInRequestFileQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequestItem = {
  __typename?: 'ConsignmentStockInRequestItem';
  baseUomQtyApproved: Scalars['Float']['output'];
  baseUomQtyRequested: Scalars['Float']['output'];
  consignmentStockInRequestID: Scalars['UUID']['output'];
  consignmentStockInRequestItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiredDate?: Maybe<Scalars['Time']['output']>;
  expiredDateConfirmed?: Maybe<Scalars['Time']['output']>;
  noteReason: Scalars['String']['output'];
  noteRequester: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyApproved: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  qtyRequested: Scalars['Float']['output'];
  receivingReason: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ConsignmentStockInRequestItemInput = {
  expiredDate?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestItemPaged = {
  __typename?: 'ConsignmentStockInRequestItemPaged';
  items: Array<ConsignmentStockInRequestItem>;
  pagination: PaginationResult;
};

export type ConsignmentStockInRequestItemQopFilterInput = {
  consignmentStockInRequestID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInRequestItemQopInput = {
  filters?: InputMaybe<ConsignmentStockInRequestItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequestLabel = {
  __typename?: 'ConsignmentStockInRequestLabel';
  barcode: Scalars['String']['output'];
  copies: Scalars['Int']['output'];
  expiredDate?: Maybe<Scalars['Time']['output']>;
  printable: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
};

export type ConsignmentStockInRequestPaged = {
  __typename?: 'ConsignmentStockInRequestPaged';
  items: Array<ConsignmentStockInRequest>;
  pagination: PaginationResult;
};

export type ConsignmentStockInRequestQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  consignmentStockInRequestNumber?: InputMaybe<Scalars['String']['input']>;
  requestDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  requestDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockInRequestQopInput = {
  filters?: InputMaybe<ConsignmentStockInRequestQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockInRequestRejectInput = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
  rejectionReason: Scalars['String']['input'];
};

export type ConsignmentStockInRequestSubmitInput = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
};

export type ConsignmentStockInRequestSummary = {
  __typename?: 'ConsignmentStockInRequestSummary';
  approved: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  totalRequest: Scalars['Int']['output'];
};

export type ConsignmentStockInRequestUpdateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockInRequestID: Scalars['UUID']['input'];
  estimatedDeliveryDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<ConsignmentStockInRequestFileInput>>;
  items: Array<ConsignmentStockInRequestItemInput>;
  noteAdditional?: InputMaybe<Scalars['String']['input']>;
};

export type ConsignmentStockInUpdateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockInDatetime: Scalars['Time']['input'];
  consignmentStockInID: Scalars['UUID']['input'];
  consignmentStockInNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<ConsignmentStockInFileInput>>;
  items: Array<ConsignmentStockInItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockOut = {
  __typename?: 'ConsignmentStockOut';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  consignmentStockOutDatetime: Scalars['Time']['output'];
  consignmentStockOutID: Scalars['UUID']['output'];
  consignmentStockOutNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalReferenceNumber?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<ConsignmentStockOutFile>>;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  receivedByVendorName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItemWeight: Scalars['Float']['output'];
  vendor: Vendor;
  vendorID: Scalars['UUID']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type ConsignmentStockOutCreateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockOutDatetime: Scalars['Time']['input'];
  consignmentStockOutNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<ConsignmentStockOutFileInput>>;
  items: Array<ConsignmentStockOutItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByVendorName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentStockOutFile = {
  __typename?: 'ConsignmentStockOutFile';
  consignmentStockOutFileID: Scalars['UUID']['output'];
  consignmentStockOutFileType: Scalars['String']['output'];
  consignmentStockOutID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ConsignmentStockOutFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type ConsignmentStockOutItem = {
  __typename?: 'ConsignmentStockOutItem';
  baseUomQty: Scalars['Float']['output'];
  consignmentStockOutID: Scalars['UUID']['output'];
  consignmentStockOutItemID: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ConsignmentStockOutItemCreateInput = {
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockOutItemPaged = {
  __typename?: 'ConsignmentStockOutItemPaged';
  items: Array<ConsignmentStockOutItem>;
  pagination: PaginationResult;
};

export type ConsignmentStockOutItemQopFilterInput = {
  consignmentStockOutID?: InputMaybe<Scalars['String']['input']>;
  consignmentStockOutItemID?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockOutItemQopInput = {
  filters?: InputMaybe<ConsignmentStockOutItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockOutItemUpdateInput = {
  consignmentStockOutItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ConsignmentStockOutPaged = {
  __typename?: 'ConsignmentStockOutPaged';
  items: Array<ConsignmentStockOut>;
  pagination: PaginationResult;
};

export type ConsignmentStockOutQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentStockOutDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockOutDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  consignmentStockOutNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConsignmentStockOutQopInput = {
  filters?: InputMaybe<ConsignmentStockOutQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ConsignmentStockOutUpdateInput = {
  branchID: Scalars['UUID']['input'];
  consignmentStockOutDatetime: Scalars['Time']['input'];
  consignmentStockOutID: Scalars['UUID']['input'];
  consignmentStockOutNumber?: InputMaybe<Scalars['String']['input']>;
  externalReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<ConsignmentStockOutFileInput>>;
  items: Array<ConsignmentStockOutItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  receivedByVendorName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type ConsignmentTagItem = {
  __typename?: 'ConsignmentTagItem';
  barcode: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  found: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
  stickerCode: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
};

export type ConsignmentTagPricesInput = {
  branchID: Scalars['UUID']['input'];
  skus: Array<Scalars['String']['input']>;
};

export type ConversationTurn = {
  __typename?: 'ConversationTurn';
  answer: Scalars['String']['output'];
  conversationTurnID: Scalars['UUID']['output'];
  createdAt: Scalars['Time']['output'];
  generatedSQL: Scalars['String']['output'];
  intent: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  telegramUserID: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type ConversationTurnPaged = {
  __typename?: 'ConversationTurnPaged';
  items?: Maybe<Array<ConversationTurn>>;
  pagination: PaginationResult;
};

export type ConversationTurnQopFilterInput = {
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  telegramUserID?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationTurnQopInput = {
  filters?: InputMaybe<ConversationTurnQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type CostAdjustmentImportInput = {
  branchID: Scalars['UUID']['input'];
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryAdjustmentOpeningBalanceImportFileMappingInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  warehouseID: Scalars['UUID']['input'];
};

export type CostAdjustmentImportValidateCodesInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryAdjustmentOpeningBalanceImportFileMappingInput;
  warehouseID: Scalars['UUID']['input'];
};

export type CostAdjustmentImportValidateCodesResult = {
  __typename?: 'CostAdjustmentImportValidateCodesResult';
  invalidRows: Scalars['Int']['output'];
  missingProductCodes: Array<Scalars['String']['output']>;
  totalRows: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type CountryCreateInput = {
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type CountryPaged = {
  __typename?: 'CountryPaged';
  items: Array<Country>;
  pagination: PaginationResult;
};

export type CountryQop = {
  filters?: InputMaybe<CountryQopFilter>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type CountryQopFilter = {
  countryID?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryUpdateInput = {
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type CreateErpProductInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  canBePurchased?: InputMaybe<Scalars['Boolean']['input']>;
  canBeSold?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mainImageFileLargePathURL?: InputMaybe<Scalars['String']['input']>;
  mainImageFileMediumPathURL?: InputMaybe<Scalars['String']['input']>;
  mainImageFileSmallPathURL?: InputMaybe<Scalars['String']['input']>;
  productCategoryID?: InputMaybe<Scalars['Int']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
  productType?: InputMaybe<Scalars['String']['input']>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['Int']['input']>;
  purchaseUomID?: InputMaybe<Scalars['Int']['input']>;
  salesTaxID?: InputMaybe<Scalars['Int']['input']>;
  salesUomID?: InputMaybe<Scalars['Int']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate?: InputMaybe<Scalars['Boolean']['input']>;
  trackStock?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateManualConsignmentProformaInput = {
  cutoffDate: Scalars['Time']['input'];
  periodEndDate: Scalars['Time']['input'];
  periodStartDate: Scalars['Time']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  addresses: Array<CustomerAddress>;
  customerCode: Scalars['String']['output'];
  customerID: Scalars['UUID']['output'];
  customerName: Scalars['String']['output'];
  customerPointTransactions: CustomerPointTransactionPaged;
  email?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gender?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isMember: Scalars['Boolean']['output'];
  joinDate: Scalars['Time']['output'];
  memberPoints: Scalars['Int']['output'];
  memberType?: Maybe<MemberType>;
  memberTypeID?: Maybe<Scalars['UUID']['output']>;
  phoneNumber: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};


export type CustomerCustomerPointTransactionsArgs = {
  qop?: InputMaybe<CustomerPointTransactionQopInput>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  addressLabel: Scalars['String']['output'];
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  customerAddressID: Scalars['UUID']['output'];
  customerID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fullAddress: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  postalCode: Scalars['String']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  subdistrict?: Maybe<Subdistrict>;
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type CustomerAddressCreateInput = {
  addressLabel: Scalars['String']['input'];
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  customerID: Scalars['UUID']['input'];
  fullAddress: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type CustomerAddressDeleteInput = {
  customerAddressID: Scalars['UUID']['input'];
};

export type CustomerAddressInput = {
  addressLabel: Scalars['String']['input'];
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  customerAddressID?: InputMaybe<Scalars['UUID']['input']>;
  fullAddress: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type CustomerAddressPaged = {
  __typename?: 'CustomerAddressPaged';
  items?: Maybe<Array<CustomerAddress>>;
  pagination: PaginationResult;
};

export type CustomerAddressQopFilterInput = {
  addressLabel?: InputMaybe<Scalars['String']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type CustomerAddressQopInput = {
  filters?: InputMaybe<CustomerAddressQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type CustomerAddressUpdateInput = {
  addressLabel: Scalars['String']['input'];
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  customerAddressID: Scalars['UUID']['input'];
  customerID: Scalars['UUID']['input'];
  fullAddress: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type CustomerCreateFromPosInput = {
  customerName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CustomerCreateInput = {
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type CustomerImportInput = {
  customerCode: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  joinDate?: InputMaybe<Scalars['Time']['input']>;
  memberPoints: Scalars['Int']['input'];
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type CustomerPaged = {
  __typename?: 'CustomerPaged';
  items?: Maybe<Array<Customer>>;
  pagination: PaginationResult;
};

export type CustomerPointTransaction = {
  __typename?: 'CustomerPointTransaction';
  branchID: Scalars['UUID']['output'];
  customerCode: Scalars['String']['output'];
  customerID: Scalars['UUID']['output'];
  customerName: Scalars['String']['output'];
  customerPointTransactionID: Scalars['UUID']['output'];
  customerPointTransactionNumber: Scalars['String']['output'];
  earnedPoint: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  memberTypeID: Scalars['UUID']['output'];
  memberTypeName: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  pointAfter: Scalars['Int']['output'];
  pointBefore: Scalars['Int']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  transactionDatetime: Scalars['String']['output'];
  transactionDatetimeUtc: Scalars['Time']['output'];
};

export type CustomerPointTransactionPaged = {
  __typename?: 'CustomerPointTransactionPaged';
  items: Array<CustomerPointTransaction>;
  pagination: PaginationResult;
};

export type CustomerPointTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  customerPointTransactionNumber?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  transactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
};

export type CustomerPointTransactionQopInput = {
  filters?: InputMaybe<CustomerPointTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type CustomerQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isMember?: InputMaybe<Scalars['Boolean']['input']>;
  joinDateFrom?: InputMaybe<Scalars['Time']['input']>;
  joinDateTo?: InputMaybe<Scalars['Time']['input']>;
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type CustomerQopInput = {
  filters?: InputMaybe<CustomerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type CustomerSetDefaultInput = {
  customerID: Scalars['UUID']['input'];
};

export type CustomerUpdateInput = {
  addresses?: InputMaybe<Array<CustomerAddressInput>>;
  customerCode: Scalars['String']['input'];
  customerID: Scalars['UUID']['input'];
  customerName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type CustomerVoucherTransaction = {
  __typename?: 'CustomerVoucherTransaction';
  branchID: Scalars['UUID']['output'];
  customerCode: Scalars['String']['output'];
  customerID: Scalars['UUID']['output'];
  customerName: Scalars['String']['output'];
  customerVoucherTransactionID: Scalars['UUID']['output'];
  customerVoucherTransactionNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  journalAccountCode: Scalars['String']['output'];
  memberTypeID: Scalars['UUID']['output'];
  memberTypeName: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionDatetime: Scalars['Time']['output'];
  transactionDatetimeUtc: Scalars['Time']['output'];
  voucherCode: Scalars['String']['output'];
  voucherID: Scalars['UUID']['output'];
  voucherItemCode: Scalars['String']['output'];
  voucherItemID: Scalars['UUID']['output'];
  voucherName: Scalars['String']['output'];
  voucherType: Scalars['String']['output'];
  voucherValue: Scalars['Float']['output'];
};

export type CustomerVoucherTransactionBackfillInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  salesInvoiceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CustomerVoucherTransactionBackfillItem = {
  __typename?: 'CustomerVoucherTransactionBackfillItem';
  customerVoucherTransactionID: Scalars['UUID']['output'];
  customerVoucherTransactionNumber: Scalars['String']['output'];
  error: Scalars['String']['output'];
  journalAccountCode: Scalars['String']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  skipReason: Scalars['String']['output'];
  updated: Scalars['Boolean']['output'];
  voucherItemID: Scalars['UUID']['output'];
  voucherType: Scalars['String']['output'];
};

export type CustomerVoucherTransactionBackfillResult = {
  __typename?: 'CustomerVoucherTransactionBackfillResult';
  dryRun: Scalars['Boolean']['output'];
  failed: Scalars['Int']['output'];
  results: Array<CustomerVoucherTransactionBackfillItem>;
  skipped: Scalars['Int']['output'];
  totalScanned: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type CustomerVoucherTransactionPaged = {
  __typename?: 'CustomerVoucherTransactionPaged';
  items: Array<CustomerVoucherTransaction>;
  pagination: PaginationResult;
};

export type CustomerVoucherTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  customerVoucherTransactionNumber?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  transactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
};

export type CustomerVoucherTransactionQopInput = {
  filters?: InputMaybe<CustomerVoucherTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUTC?: Maybe<Scalars['Time']['output']>;
  deliveredDatetime?: Maybe<Scalars['Time']['output']>;
  deliveredDatetimeUTC?: Maybe<Scalars['Time']['output']>;
  deliveryAddress: Scalars['String']['output'];
  deliveryBy: Scalars['String']['output'];
  deliveryOrderDatetime: Scalars['Time']['output'];
  deliveryOrderDatetimeUTC: Scalars['Time']['output'];
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderNumber: Scalars['String']['output'];
  driverName: Scalars['String']['output'];
  driverPhoneNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  landedCost: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  shippedByUserID?: Maybe<Scalars['UUID']['output']>;
  shippedByUserName?: Maybe<Scalars['String']['output']>;
  shippedDatetime?: Maybe<Scalars['Time']['output']>;
  shippedDatetimeUTC?: Maybe<Scalars['Time']['output']>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalContainers: Scalars['Int']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItems: Scalars['Int']['output'];
  transferRequest?: Maybe<TransferRequest>;
  vehiclePlateNumber: Scalars['String']['output'];
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
  vendorRefNumber?: Maybe<Scalars['String']['output']>;
};

export type DeliveryOrderBatch = {
  __typename?: 'DeliveryOrderBatch';
  branchID: Scalars['UUID']['output'];
  containers?: Maybe<Array<DeliveryOrderBatchContainer>>;
  deliveredBy: Scalars['String']['output'];
  deliveryOrderBatchDatetime: Scalars['Time']['output'];
  deliveryOrderBatchDatetimeUtc: Scalars['Time']['output'];
  deliveryOrderBatchID: Scalars['UUID']['output'];
  deliveryOrderBatchNumber: Scalars['String']['output'];
  deliveryOrderDate?: Maybe<Scalars['Time']['output']>;
  driverName: Scalars['String']['output'];
  driverPhoneNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  generatedDatetime?: Maybe<Scalars['Time']['output']>;
  generatedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  gmt: Scalars['Int']['output'];
  isShipAfterGenerate: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  shippedDatetime?: Maybe<Scalars['Time']['output']>;
  sourceDocuments?: Maybe<Array<DeliveryOrderBatchSourceDocument>>;
  status: Scalars['String']['output'];
  toBranchID: Scalars['UUID']['output'];
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalFailedSourceDocuments: Scalars['Int']['output'];
  totalGeneratedDeliveryOrders: Scalars['Int']['output'];
  totalScannedContainers: Scalars['Int']['output'];
  totalShippedDeliveryOrders: Scalars['Int']['output'];
  vehiclePlateNumber: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorName: Scalars['String']['output'];
  vendorRefNumber: Scalars['String']['output'];
};

export type DeliveryOrderBatchContainer = {
  __typename?: 'DeliveryOrderBatchContainer';
  containerNumber: Scalars['String']['output'];
  deliveryOrderBatchContainerID: Scalars['UUID']['output'];
  deliveryOrderBatchID: Scalars['UUID']['output'];
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  itemCount: Scalars['Int']['output'];
  outboundContainerID: Scalars['UUID']['output'];
  scannedAt: Scalars['Time']['output'];
  scannedAtUtc: Scalars['Time']['output'];
  scannedByUserID: Scalars['UUID']['output'];
  scannedByUserName: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
};

export type DeliveryOrderBatchCreateInput = {
  destinationWarehouseID: Scalars['UUID']['input'];
  originWarehouseID: Scalars['UUID']['input'];
};

export type DeliveryOrderBatchDestinationSummary = {
  __typename?: 'DeliveryOrderBatchDestinationSummary';
  containersLeft: Scalars['Int']['output'];
  itemsLeft: Scalars['Int']['output'];
  toEligible: Scalars['Int']['output'];
  transferOrders?: Maybe<Array<DeliveryOrderBatchEligibleTransferOrder>>;
};

export type DeliveryOrderBatchEligibleTransferOrder = {
  __typename?: 'DeliveryOrderBatchEligibleTransferOrder';
  containerCount: Scalars['Int']['output'];
  itemCount: Scalars['Int']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderNumber: Scalars['String']['output'];
};

export type DeliveryOrderBatchGenerateInput = {
  allowPartial?: InputMaybe<Scalars['Boolean']['input']>;
  deliveredBy?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderBatchID: Scalars['UUID']['input'];
  deliveryOrderDate?: InputMaybe<Scalars['Time']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  shippedDatetime?: InputMaybe<Scalars['Time']['input']>;
  vehiclePlateNumber?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderBatchPaged = {
  __typename?: 'DeliveryOrderBatchPaged';
  items?: Maybe<Array<DeliveryOrderBatch>>;
  pagination: PaginationResult;
};

export type DeliveryOrderBatchQopFilterInput = {
  deliveryOrderBatchDatetimeFrom?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderBatchDatetimeTo?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderBatchNumber?: InputMaybe<Scalars['String']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeliveryOrderBatchQopInput = {
  filters?: InputMaybe<DeliveryOrderBatchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderBatchScanInput = {
  allowPendingDeliveryOrder?: InputMaybe<Scalars['Boolean']['input']>;
  containerNumber: Scalars['String']['input'];
  deliveryOrderBatchID: Scalars['UUID']['input'];
};

export type DeliveryOrderBatchScanResult = {
  __typename?: 'DeliveryOrderBatchScanResult';
  code: Scalars['String']['output'];
  container?: Maybe<DeliveryOrderBatchContainer>;
  message: Scalars['String']['output'];
  pendingDeliveryOrderNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Generate (and optional ship) outcome of one source document within a batch.
 *
 * status: pending -> generated -> shipped, or failed (see errorMessage).
 * A row can stay 'generated' with a non-empty errorMessage when the delivery order was created but shipping it failed.
 */
export type DeliveryOrderBatchSourceDocument = {
  __typename?: 'DeliveryOrderBatchSourceDocument';
  deliveryOrderBatchID: Scalars['UUID']['output'];
  deliveryOrderBatchSourceDocumentID: Scalars['UUID']['output'];
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  deliveryOrderNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalContainers: Scalars['Int']['output'];
};

export type DeliveryOrderCancelInput = {
  cancellationReason: Scalars['String']['input'];
  deliveryOrderID: Scalars['UUID']['input'];
};

export type DeliveryOrderContainerInput = {
  outboundContainerID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type DeliveryOrderContainerRemoveInput = {
  outboundContainerID: Scalars['UUID']['input'];
};

export type DeliveryOrderCreateInput = {
  allowPartial?: InputMaybe<Scalars['Boolean']['input']>;
  containers: Array<DeliveryOrderContainerInput>;
  deliveryBy: Scalars['String']['input'];
  deliveryOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
  vehiclePlateNumber?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderGenerateBulkInput = {
  transferOrderIDs: Array<Scalars['UUID']['input']>;
};

export type DeliveryOrderItem = {
  __typename?: 'DeliveryOrderItem';
  baseUomQty: Scalars['Float']['output'];
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderItemID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type DeliveryOrderItemPaged = {
  __typename?: 'DeliveryOrderItemPaged';
  items?: Maybe<Array<DeliveryOrderItem>>;
  pagination: PaginationResult;
};

export type DeliveryOrderItemQopFilterInput = {
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  deliveryOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeliveryOrderItemQopInput = {
  filters?: InputMaybe<DeliveryOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderItemSummary = {
  __typename?: 'DeliveryOrderItemSummary';
  baseUomQty: Scalars['Float']['output'];
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderItemSummaryID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  totalWeight: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type DeliveryOrderItemSummaryPaged = {
  __typename?: 'DeliveryOrderItemSummaryPaged';
  items: Array<DeliveryOrderItemSummary>;
  pagination: PaginationResult;
};

export type DeliveryOrderItemSummaryQopFilterInput = {
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderItemSummaryQopInput = {
  filters?: InputMaybe<DeliveryOrderItemSummaryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderPaged = {
  __typename?: 'DeliveryOrderPaged';
  items?: Maybe<Array<DeliveryOrder>>;
  pagination: PaginationResult;
};

export type DeliveryOrderQopFilterInput = {
  deliveryBy?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderDatetimeFrom?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderDatetimeTo?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderNumber?: InputMaybe<Scalars['String']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeliveryOrderQopInput = {
  filters?: InputMaybe<DeliveryOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderReceivingItemSummary = {
  __typename?: 'DeliveryOrderReceivingItemSummary';
  baseUomQty: Scalars['Float']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type DeliveryOrderReceivingItemSummaryPaged = {
  __typename?: 'DeliveryOrderReceivingItemSummaryPaged';
  items?: Maybe<Array<DeliveryOrderReceivingItemSummary>>;
  pagination: PaginationResult;
};

export type DeliveryOrderReceivingItemSummaryQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderReceivingItemSummaryQopInput = {
  filters?: InputMaybe<DeliveryOrderReceivingItemSummaryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type DeliveryOrderShippedInput = {
  deliveryBy: Scalars['String']['input'];
  deliveryOrderID: Scalars['UUID']['input'];
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  shippedDatetime: Scalars['Time']['input'];
  vehiclePlateNumber?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOrderUpdateInput = {
  containers?: InputMaybe<Array<DeliveryOrderContainerInput>>;
  deliveryBy?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderID: Scalars['UUID']['input'];
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  vehiclePlateNumber?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeltaItem = {
  __typename?: 'DeltaItem';
  createdAt: Scalars['String']['output'];
  op: ProductImageEmbeddingChangeOp;
  productAiImageId: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  seq: Scalars['Int']['output'];
  sourceDeletedAt?: Maybe<Scalars['String']['output']>;
  sourceUpdatedAt: Scalars['String']['output'];
  vector?: Maybe<Array<Scalars['Float']['output']>>;
};

export type DeltaPage = {
  __typename?: 'DeltaPage';
  afterSeq: Scalars['Int']['output'];
  items: Array<DeltaItem>;
  limit: Scalars['Int']['output'];
  nextAfterSeq?: Maybe<Scalars['Int']['output']>;
};

export type EdcTerminal = {
  __typename?: 'EdcTerminal';
  bankAccount?: Maybe<BankAccount>;
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  edcTerminalID: Scalars['UUID']['output'];
  edcTerminalName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  serialNumber: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type EdcTerminalCreateInput = {
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  edcTerminalName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  serialNumber: Scalars['String']['input'];
};

export type EdcTerminalPaged = {
  __typename?: 'EdcTerminalPaged';
  items: Array<EdcTerminal>;
  pagination: PaginationResult;
};

export type EdcTerminalQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  edcTerminalName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type EdcTerminalQopInput = {
  filters?: InputMaybe<EdcTerminalQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type EdcTerminalUpdateInput = {
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  edcTerminalID: Scalars['UUID']['input'];
  edcTerminalName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  serialNumber: Scalars['String']['input'];
};

export type EditConsignmentSettlementInput = {
  branches?: InputMaybe<Array<ConsignmentSettlementBranchInput>>;
  chargeAmount?: InputMaybe<Scalars['Float']['input']>;
  commissionAmount?: InputMaybe<Scalars['Float']['input']>;
  periodEndDate?: InputMaybe<Scalars['Time']['input']>;
  periodStartDate?: InputMaybe<Scalars['Time']['input']>;
  reason: Scalars['String']['input'];
  transferFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
  vendorPayoutTotal?: InputMaybe<Scalars['Float']['input']>;
};

export type Employee = {
  __typename?: 'Employee';
  employeeCode: Scalars['String']['output'];
  employeeID: Scalars['UUID']['output'];
  employeeName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  erpReferenceID: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type EmployeeCreateInput = {
  employeeCode: Scalars['String']['input'];
  employeeName: Scalars['String']['input'];
  erpReferenceID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type EmployeePaged = {
  __typename?: 'EmployeePaged';
  items?: Maybe<Array<Employee>>;
  pagination: PaginationResult;
};

export type EmployeeQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  employeeCode?: InputMaybe<Scalars['String']['input']>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  erpReferenceID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type EmployeeQopInput = {
  filters?: InputMaybe<EmployeeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type EmployeeUpdateInput = {
  employeeCode: Scalars['String']['input'];
  employeeID: Scalars['UUID']['input'];
  employeeName: Scalars['String']['input'];
  erpReferenceID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type EntityAuditMetadata = {
  __typename?: 'EntityAuditMetadata';
  createdAt: Scalars['Time']['output'];
  createdByUserID?: Maybe<Scalars['UUID']['output']>;
  createdByUserName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  deletedByUserID?: Maybe<Scalars['UUID']['output']>;
  deletedByUserName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  updatedByUserID?: Maybe<Scalars['UUID']['output']>;
  updatedByUserName?: Maybe<Scalars['String']['output']>;
  version: Scalars['UUID']['output'];
};

export type ErpBranch = {
  __typename?: 'ErpBranch';
  balance: Scalars['Float']['output'];
  branchID: Scalars['Int']['output'];
  credit: Scalars['Float']['output'];
  debit: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  planID: Scalars['Int']['output'];
  planName: Scalars['String']['output'];
  ref: Scalars['String']['output'];
};

export type ErpBranchPaged = {
  __typename?: 'ErpBranchPaged';
  items?: Maybe<Array<ErpBranch>>;
  pagination: PaginationResult;
};

export type ErpBranchQopFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  planID?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type ErpBranchQopInput = {
  filters?: InputMaybe<ErpBranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpEmployee = {
  __typename?: 'ErpEmployee';
  coachName: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  department: Scalars['String']['output'];
  employeeID: Scalars['Int64']['output'];
  employeeName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  homeAddress: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  jobPosition: Scalars['String']['output'];
  nationality: Scalars['String']['output'];
  nomorIdentity: Scalars['String']['output'];
  workAddress: Scalars['String']['output'];
  workEmail: Scalars['String']['output'];
  workLocation: Scalars['String']['output'];
  workPhoneNumber: Scalars['String']['output'];
};

export type ErpEmployeePaged = {
  __typename?: 'ErpEmployeePaged';
  items?: Maybe<Array<ErpEmployee>>;
  pagination: PaginationResult;
};

export type ErpEmployeeQopFilterInput = {
  employeeName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  nomorIdentity?: InputMaybe<Scalars['String']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
};

export type ErpEmployeeQopInput = {
  filters?: InputMaybe<ErpEmployeeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpProduct = {
  __typename?: 'ErpProduct';
  barcode: Scalars['String']['output'];
  canBePurchased: Scalars['Boolean']['output'];
  canBeSold: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  mainImageFileLargePathURL: Scalars['String']['output'];
  mainImageFileMediumPathURL: Scalars['String']['output'];
  mainImageFileSmallPathURL: Scalars['String']['output'];
  productCategoryID: Scalars['Int']['output'];
  productCategoryName: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  purchaseCost: Scalars['Float']['output'];
  purchaseTaxID: Scalars['Int']['output'];
  purchaseUomID: Scalars['Int']['output'];
  purchaseUomName: Scalars['String']['output'];
  salesTaxID: Scalars['Int']['output'];
  salesUomID: Scalars['Int']['output'];
  salesUomName: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
  trackExpiredDate: Scalars['Boolean']['output'];
  trackStock: Scalars['Boolean']['output'];
  weight: Scalars['Float']['output'];
};

export type ErpProductCategory = {
  __typename?: 'ErpProductCategory';
  parentID: Scalars['Int']['output'];
  parentName: Scalars['String']['output'];
  productCategoryID: Scalars['Int']['output'];
  productCategoryName: Scalars['String']['output'];
};

export type ErpProductCategoryPaged = {
  __typename?: 'ErpProductCategoryPaged';
  items?: Maybe<Array<ErpProductCategory>>;
  pagination: PaginationResult;
};

export type ErpProductCategoryQopFilterInput = {
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
};

export type ErpProductCategoryQopInput = {
  filters?: InputMaybe<ErpProductCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpProductPaged = {
  __typename?: 'ErpProductPaged';
  items?: Maybe<Array<ErpProduct>>;
  pagination: PaginationResult;
};

export type ErpProductQopFilterInput = {
  productCategoryID?: InputMaybe<Scalars['Int']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type ErpProductQopInput = {
  filters?: InputMaybe<ErpProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpPurchaseOrderReceive = {
  __typename?: 'ErpPurchaseOrderReceive';
  erpID: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingNumber: Scalars['String']['output'];
  reasonFailed: Scalars['String']['output'];
  syncStatus: Scalars['String']['output'];
};

export type ErpPurchaseOrderReceivePaged = {
  __typename?: 'ErpPurchaseOrderReceivePaged';
  items?: Maybe<Array<ErpPurchaseOrderReceive>>;
  pagination: PaginationResult;
};

export type ErpPurchaseOrderReceiveQopFilterInput = {
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<Scalars['String']['input']>;
};

export type ErpPurchaseOrderReceiveQopInput = {
  filters?: InputMaybe<ErpPurchaseOrderReceiveQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpSyncFullRun = {
  __typename?: 'ErpSyncFullRun';
  completedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  dispatchedCount: Scalars['Int']['output'];
  entityType: Scalars['String']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  lastBatchIndex: Scalars['Int']['output'];
  startedAt: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type ErpSyncFullRunPaged = {
  __typename?: 'ErpSyncFullRunPaged';
  items?: Maybe<Array<ErpSyncFullRun>>;
  pagination: PaginationResult;
};

export type ErpSyncFullRunQopFilterInput = {
  entityType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ErpSyncFullRunQopInput = {
  filters?: InputMaybe<ErpSyncFullRunQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpTax = {
  __typename?: 'ErpTax';
  isActive: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  taxID: Scalars['Int']['output'];
  taxName: Scalars['String']['output'];
  taxType: Scalars['String']['output'];
};

export type ErpTaxPaged = {
  __typename?: 'ErpTaxPaged';
  items?: Maybe<Array<ErpTax>>;
  pagination: PaginationResult;
};

export type ErpTaxQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxName?: InputMaybe<Scalars['String']['input']>;
  taxType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ErpTaxQopInput = {
  filters?: InputMaybe<ErpTaxQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type ErpUom = {
  __typename?: 'ErpUom';
  categoryID: Scalars['Int']['output'];
  categoryName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uomID: Scalars['Int']['output'];
};

export type ErpUomCategory = {
  __typename?: 'ErpUomCategory';
  name: Scalars['String']['output'];
  uomCategoryID: Scalars['Int']['output'];
};

export type ErpUomCategoryPaged = {
  __typename?: 'ErpUomCategoryPaged';
  items?: Maybe<Array<ErpUomCategory>>;
  pagination: PaginationResult;
};

export type ErpUomCategoryQopFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ErpUomCategoryQopInput = {
  filters?: InputMaybe<ErpUomCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpUomPaged = {
  __typename?: 'ErpUomPaged';
  items?: Maybe<Array<ErpUom>>;
  pagination: PaginationResult;
};

export type ErpUomQopFilterInput = {
  categoryID?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ErpUomQopInput = {
  filters?: InputMaybe<ErpUomQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpVendor = {
  __typename?: 'ErpVendor';
  active: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  companyType: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  creditLimit: Scalars['Float']['output'];
  currencyName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  isCompany: Scalars['Boolean']['output'];
  isPkp: Scalars['Boolean']['output'];
  mobile: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  stateName: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2: Scalars['String']['output'];
  vat: Scalars['String']['output'];
  vendorID: Scalars['Int']['output'];
  website: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type ErpVendorPaged = {
  __typename?: 'ErpVendorPaged';
  items?: Maybe<Array<ErpVendor>>;
  pagination: PaginationResult;
};

export type ErpVendorQopFilterInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ErpVendorQopInput = {
  filters?: InputMaybe<ErpVendorQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ErpWarehouse = {
  __typename?: 'ErpWarehouse';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  companyID: Scalars['Int']['output'];
  companyName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  warehouseID: Scalars['Int']['output'];
};

export type ErpWarehousePaged = {
  __typename?: 'ErpWarehousePaged';
  items?: Maybe<Array<ErpWarehouse>>;
  pagination: PaginationResult;
};

export type ErpWarehouseQopFilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  companyID?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ErpWarehouseQopInput = {
  filters?: InputMaybe<ErpWarehouseQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ExecutionResult = {
  __typename?: 'ExecutionResult';
  executionID: Scalars['UUID']['output'];
  progressPercent: Scalars['Float']['output'];
  qtyExecuted: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  taskItemID: Scalars['UUID']['output'];
  totalQtyExecuted: Scalars['Float']['output'];
};

export type ExpenseItem = {
  __typename?: 'ExpenseItem';
  entityAuditMetadata: EntityAuditMetadata;
  expenseItemID: Scalars['UUID']['output'];
  expenseItemName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  journalAccountCode: Scalars['String']['output'];
  journalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  journalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type ExpenseItemCreateInput = {
  expenseItemName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
};

export type ExpenseItemPaged = {
  __typename?: 'ExpenseItemPaged';
  items?: Maybe<Array<ExpenseItem>>;
  pagination: PaginationResult;
};

export type ExpenseItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  expenseItemName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ExpenseItemQopInput = {
  filters?: InputMaybe<ExpenseItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ExpenseItemUpdateInput = {
  expenseItemID: Scalars['UUID']['input'];
  expenseItemName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
};

export type File = {
  __typename?: 'File';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  fileSizeMB: Scalars['Float']['output'];
  imageProxyURL?: Maybe<Scalars['String']['output']>;
  imageProxyURLLarge?: Maybe<Scalars['String']['output']>;
  imageProxyURLMedium?: Maybe<Scalars['String']['output']>;
  imageProxyURLSmall?: Maybe<Scalars['String']['output']>;
  imageProxyURLThumbnail?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  originalFileName: Scalars['String']['output'];
  publicURL?: Maybe<Scalars['String']['output']>;
  storageBucket: Scalars['String']['output'];
  storagePath: Scalars['String']['output'];
};

export type FileCreateFromStorageObjectInput = {
  fileSizeMB?: InputMaybe<Scalars['Float']['input']>;
  mimeType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  storageBucket: Scalars['String']['input'];
  storagePath: Scalars['String']['input'];
};

export type FilePaged = {
  __typename?: 'FilePaged';
  items?: Maybe<Array<File>>;
  pagination: PaginationResult;
};

export type FileQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type FileQopInput = {
  filters?: InputMaybe<FileQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type FinishTaskInput = {
  putawayTaskID: Scalars['UUID']['input'];
};

export type GenerateConsignmentInvoiceInput = {
  payoutBankAccountNumber: Scalars['String']['input'];
  payoutBankID?: InputMaybe<Scalars['UUID']['input']>;
  payoutBankName?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type GenerateLinkResetPasswordInput = {
  userName?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type GenerateLinkResetPasswordResponse = {
  __typename?: 'GenerateLinkResetPasswordResponse';
  nextRetryDelay: Scalars['Int']['output'];
  nextSessionDelay: Scalars['Int']['output'];
  remainingAttempts: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type GenerateMultipleTasksInput = {
  putawayTaskDatetime: Scalars['Time']['input'];
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
  tasks: Array<TaskAllocationInput>;
};

export type GenerateOtpCodeInput = {
  channel: OtpChannel;
  type: OtpType;
  userName: Scalars['String']['input'];
};

export type GenerateSingleTaskInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
};

export type GenerateTransferRequestFromReplenishmentInput = {
  items: Array<GenerateTransferRequestFromReplenishmentItemInput>;
  noteForApprover: Scalars['String']['input'];
  replenishmentID: Scalars['UUID']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
};

export type GenerateTransferRequestFromReplenishmentItemInput = {
  qtyRequested: Scalars['Float']['input'];
  replenishmentItemID: Scalars['UUID']['input'];
};

export type InboundReceiving = {
  __typename?: 'InboundReceiving';
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  inboundReceivingDatetime: Scalars['Time']['output'];
  inboundReceivingDatetimeUtc: Scalars['Time']['output'];
  inboundReceivingID: Scalars['UUID']['output'];
  inboundReceivingNumber: Scalars['String']['output'];
  isPutawayCompleted: Scalars['Boolean']['output'];
  items: Array<InboundReceivingItem>;
  noteInternal: Scalars['String']['output'];
  originWarehouse?: Maybe<Warehouse>;
  originWarehouseID?: Maybe<Scalars['UUID']['output']>;
  originWarehouseLocation?: Maybe<WarehouseLocation>;
  originWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  simpleTransferOrder?: Maybe<SimpleTransferOrder>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItems: Scalars['Float']['output'];
  transferOrder?: Maybe<TransferOrder>;
  vendor?: Maybe<Vendor>;
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorRefNo?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InboundReceivingItem = {
  __typename?: 'InboundReceivingItem';
  baseUomQtyPutawayAssigned: Scalars['Float']['output'];
  baseUomQtyPutawayExecuted: Scalars['Float']['output'];
  baseUomQtyReceived: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inboundReceivingID: Scalars['UUID']['output'];
  inboundReceivingItemID: Scalars['UUID']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyPutawayAssigned: Scalars['Float']['output'];
  qtyPutawayExecuted: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type InboundReceivingPaged = {
  __typename?: 'InboundReceivingPaged';
  items: Array<InboundReceiving>;
  pagination: PaginationResult;
};

export type InboundReceivingQopFilterInput = {
  inboundReceivingDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  inboundReceivingDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  inboundReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  originWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InboundReceivingQopInput = {
  filters?: InputMaybe<InboundReceivingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type IngestionRunInfo = {
  __typename?: 'IngestionRunInfo';
  candidateCount: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  failureCount: Scalars['Float']['output'];
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startedAt: Scalars['String']['output'];
  status: IngestionRunStatus;
  successCount: Scalars['Float']['output'];
  watermarkFrom?: Maybe<Scalars['String']['output']>;
  watermarkTo?: Maybe<Scalars['String']['output']>;
};

export enum IngestionRunStatus {
  Failed = 'FAILED',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type InternalTransfer = {
  __typename?: 'InternalTransfer';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  confirmByUserID?: Maybe<Scalars['UUID']['output']>;
  confirmByUserName?: Maybe<Scalars['String']['output']>;
  confirmDatetime?: Maybe<Scalars['Time']['output']>;
  confirmDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  internalTransferDatetime: Scalars['Time']['output'];
  internalTransferDatetimeUtc: Scalars['Time']['output'];
  internalTransferID: Scalars['UUID']['output'];
  internalTransferNumber: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalItemQtyRequested: Scalars['Float']['output'];
  totalItemQtyTransferred: Scalars['Float']['output'];
  totalItemWeight: Scalars['Float']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InternalTransferCancelInput = {
  cancellationReason: Scalars['String']['input'];
  internalTransferID: Scalars['UUID']['input'];
};

export type InternalTransferConfirmInput = {
  internalTransferID: Scalars['UUID']['input'];
};

export type InternalTransferCreateInput = {
  description: Scalars['String']['input'];
  internalTransferDatetime: Scalars['Time']['input'];
  internalTransferNumber?: InputMaybe<Scalars['String']['input']>;
  items: Array<InternalTransferItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InternalTransferExecution = {
  __typename?: 'InternalTransferExecution';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  executedAtUtc: Scalars['Time']['output'];
  executedByUserID: Scalars['UUID']['output'];
  executedByUserName: Scalars['String']['output'];
  fromWarehouseLocationCode: Scalars['String']['output'];
  fromWarehouseLocationID: Scalars['UUID']['output'];
  internalTransferExecutionID: Scalars['UUID']['output'];
  internalTransferID: Scalars['UUID']['output'];
  internalTransferItemID: Scalars['UUID']['output'];
  noteInternal: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  toWarehouseLocationCode: Scalars['String']['output'];
  toWarehouseLocationID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
};

export type InternalTransferExecutionPaged = {
  __typename?: 'InternalTransferExecutionPaged';
  items: Array<InternalTransferExecution>;
  pagination: PaginationResult;
};

export type InternalTransferExecutionQopFilterInput = {
  executedAtEnd?: InputMaybe<Scalars['Time']['input']>;
  executedAtStart?: InputMaybe<Scalars['Time']['input']>;
  fromWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferExecutionID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  toWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InternalTransferExecutionQopInput = {
  filters?: InputMaybe<InternalTransferExecutionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InternalTransferItem = {
  __typename?: 'InternalTransferItem';
  baseUomQtyOutstanding: Scalars['Float']['output'];
  baseUomQtyRequested: Scalars['Float']['output'];
  baseUomQtyTransferred: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseLocationCode: Scalars['String']['output'];
  fromWarehouseLocationID: Scalars['UUID']['output'];
  fromWarehouseLocationName: Scalars['String']['output'];
  internalTransferID: Scalars['UUID']['output'];
  internalTransferItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  qtyRequested: Scalars['Float']['output'];
  qtyTransferred: Scalars['Float']['output'];
  toWarehouseLocationCode: Scalars['String']['output'];
  toWarehouseLocationID: Scalars['UUID']['output'];
  toWarehouseLocationName: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type InternalTransferItemCreateInput = {
  fromWarehouseLocationID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  toWarehouseLocationID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type InternalTransferItemPaged = {
  __typename?: 'InternalTransferItemPaged';
  items: Array<InternalTransferItem>;
  pagination: PaginationResult;
};

export type InternalTransferItemQopFilterInput = {
  fromWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferID?: InputMaybe<Scalars['UUID']['input']>;
  internalTransferItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  toWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InternalTransferItemQopInput = {
  filters?: InputMaybe<InternalTransferItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InternalTransferItemUpdateInput = {
  fromWarehouseLocationID: Scalars['UUID']['input'];
  internalTransferItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  toWarehouseLocationID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type InternalTransferPaged = {
  __typename?: 'InternalTransferPaged';
  items: Array<InternalTransfer>;
  pagination: PaginationResult;
};

export type InternalTransferQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  internalTransferDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  internalTransferDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  internalTransferNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InternalTransferQopInput = {
  filters?: InputMaybe<InternalTransferQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InternalTransferUpdateInput = {
  description: Scalars['String']['input'];
  internalTransferDatetime: Scalars['Time']['input'];
  internalTransferID: Scalars['UUID']['input'];
  internalTransferNumber: Scalars['String']['input'];
  items: Array<InternalTransferItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustment = {
  __typename?: 'InventoryAdjustment';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  confirmByUserID?: Maybe<Scalars['UUID']['output']>;
  confirmByUserName?: Maybe<Scalars['String']['output']>;
  confirmDatetime?: Maybe<Scalars['Time']['output']>;
  confirmDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<InventoryAdjustmentFile>>;
  inventoryAdjustmentDate: Scalars['Time']['output'];
  inventoryAdjustmentID: Scalars['UUID']['output'];
  inventoryAdjustmentNumber: Scalars['String']['output'];
  inventoryAdjustmentType: Scalars['String']['output'];
  isSystemGenerated: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sourceDocumentID?: Maybe<Scalars['UUID']['output']>;
  sourceDocumentNumber?: Maybe<Scalars['String']['output']>;
  sourceDocumentType?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  usedCost: Scalars['Boolean']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryAdjustmentCancelInput = {
  inventoryAdjustmentID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentConfirmInput = {
  inventoryAdjustmentID: Scalars['UUID']['input'];
  /** System Correction only: mirror to Odoo (true when the error already reached Odoo). Ignored for other types. */
  syncToErp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InventoryAdjustmentCreateInput = {
  branchID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<InventoryAdjustmentFileInput>>;
  inventoryAdjustmentDate: Scalars['Time']['input'];
  inventoryAdjustmentNumber?: InputMaybe<Scalars['String']['input']>;
  inventoryAdjustmentType: Scalars['String']['input'];
  items: Array<InventoryAdjustmentItemCreateInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  usedCost: Scalars['Boolean']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentCreateOpeningBalanceInput = {
  branchID: Scalars['UUID']['input'];
  inventoryAdjustmentDate: Scalars['Time']['input'];
  items: Array<InventoryAdjustmentItemCreateOpeningBalanceInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentCreateSystemInput = {
  branchID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<InventoryAdjustmentFileInput>>;
  inventoryAdjustmentDate: Scalars['Time']['input'];
  inventoryAdjustmentType: Scalars['String']['input'];
  items: Array<InventoryAdjustmentItemCreateInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  usedCost: Scalars['Boolean']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentFile = {
  __typename?: 'InventoryAdjustmentFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  inventoryAdjustmentFileID: Scalars['UUID']['output'];
  inventoryAdjustmentFileType: Scalars['String']['output'];
  inventoryAdjustmentID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type InventoryAdjustmentFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type InventoryAdjustmentItem = {
  __typename?: 'InventoryAdjustmentItem';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryAdjustmentID: Scalars['UUID']['output'];
  inventoryAdjustmentItemID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  reasonID: Scalars['UUID']['output'];
  reasonName: Scalars['String']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
  unitCost: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryAdjustmentItemCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentItemCreateOpeningBalanceInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentItemPaged = {
  __typename?: 'InventoryAdjustmentItemPaged';
  items: Array<InventoryAdjustmentItem>;
  pagination: PaginationResult;
};

export type InventoryAdjustmentItemQopFilterInput = {
  inventoryAdjustmentID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryAdjustmentItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  reasonID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryAdjustmentItemQopInput = {
  filters?: InputMaybe<InventoryAdjustmentItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryAdjustmentItemUpdateInput = {
  inventoryAdjustmentItemID?: InputMaybe<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentOpeningBalanceImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryAdjustmentOpeningBalanceImportFileMappingInput = {
  columns: Array<InventoryAdjustmentOpeningBalanceImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type InventoryAdjustmentOpeningBalanceImportInput = {
  branchID: Scalars['UUID']['input'];
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryAdjustmentOpeningBalanceImportFileMappingInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentOpeningBalanceImportMissingProductUom = {
  __typename?: 'InventoryAdjustmentOpeningBalanceImportMissingProductUom';
  productCode: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  uomName: Scalars['String']['output'];
};

export type InventoryAdjustmentOpeningBalanceImportRowReport = {
  __typename?: 'InventoryAdjustmentOpeningBalanceImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<InventoryAdjustmentOpeningBalanceImportRowViolation>;
};

export type InventoryAdjustmentOpeningBalanceImportRowViolation = {
  __typename?: 'InventoryAdjustmentOpeningBalanceImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InventoryAdjustmentOpeningBalanceImportValidateCodesInput = {
  branchID: Scalars['UUID']['input'];
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  fileMapping?: InputMaybe<InventoryAdjustmentOpeningBalanceImportFileMappingInput>;
  locationNames?: InputMaybe<Array<Scalars['String']['input']>>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryAdjustmentOpeningBalanceImportValidateCodesResult = {
  __typename?: 'InventoryAdjustmentOpeningBalanceImportValidateCodesResult';
  missingLocationNames: Array<Scalars['String']['output']>;
  missingProductCodes: Array<Scalars['String']['output']>;
  missingProductUoms: Array<InventoryAdjustmentOpeningBalanceImportMissingProductUom>;
  rowReport?: Maybe<InventoryAdjustmentOpeningBalanceImportRowReport>;
};

export type InventoryAdjustmentPaged = {
  __typename?: 'InventoryAdjustmentPaged';
  items?: Maybe<Array<InventoryAdjustment>>;
  pagination: PaginationResult;
};

export type InventoryAdjustmentQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryAdjustmentDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryAdjustmentDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  inventoryAdjustmentDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  inventoryAdjustmentNumber?: InputMaybe<Scalars['String']['input']>;
  inventoryAdjustmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryAdjustmentQopInput = {
  filters?: InputMaybe<InventoryAdjustmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryAdjustmentType = {
  __typename?: 'InventoryAdjustmentType';
  code: Scalars['String']['output'];
  inventoryAdjustmentTypeID: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Selectable in the Standard form dropdown */
  isStandard: Scalars['Boolean']['output'];
  /** A confirmed document mirrors stock to Odoo */
  isSyncToErp: Scalars['Boolean']['output'];
  /** Only system flows / IT tooling create it; operator forms reject it */
  isSystemGenerated: Scalars['Boolean']['output'];
  /** Created through the Waste form (type fixed) */
  isWaste: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type InventoryAdjustmentUpdateInput = {
  branchID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<InventoryAdjustmentFileInput>>;
  inventoryAdjustmentDate: Scalars['Time']['input'];
  inventoryAdjustmentID: Scalars['UUID']['input'];
  inventoryAdjustmentNumber?: InputMaybe<Scalars['String']['input']>;
  inventoryAdjustmentType: Scalars['String']['input'];
  items: Array<InventoryAdjustmentItemUpdateInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  usedCost: Scalars['Boolean']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type InventoryCountItemTemplate = {
  __typename?: 'InventoryCountItemTemplate';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountItemTemplateID: Scalars['UUID']['output'];
  inventoryCountItemTemplateItemPaged: InventoryCountItemTemplateItemPaged;
  inventoryCountItemTemplateName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
};


export type InventoryCountItemTemplateInventoryCountItemTemplateItemPagedArgs = {
  qop?: InputMaybe<InventoryCountItemTemplateItemQopInput>;
};

export type InventoryCountItemTemplateCreateInput = {
  inventoryCountItemTemplateName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryCountItemTemplateItem = {
  __typename?: 'InventoryCountItemTemplateItem';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountItemTemplateID: Scalars['UUID']['output'];
  inventoryCountItemTemplateItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type InventoryCountItemTemplateItemCreateInput = {
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type InventoryCountItemTemplateItemImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountItemTemplateItemImportFileMappingInput = {
  columns: Array<InventoryCountItemTemplateItemImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type InventoryCountItemTemplateItemImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryCountItemTemplateItemImportFileMappingInput;
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
};

export type InventoryCountItemTemplateItemImportResult = {
  __typename?: 'InventoryCountItemTemplateItemImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type InventoryCountItemTemplateItemImportRowReport = {
  __typename?: 'InventoryCountItemTemplateItemImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<InventoryCountItemTemplateItemImportRowViolation>;
};

export type InventoryCountItemTemplateItemImportRowViolation = {
  __typename?: 'InventoryCountItemTemplateItemImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InventoryCountItemTemplateItemImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: InventoryCountItemTemplateItemImportFileMappingInput;
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
};

export type InventoryCountItemTemplateItemImportValidateResult = {
  __typename?: 'InventoryCountItemTemplateItemImportValidateResult';
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: InventoryCountItemTemplateItemImportRowReport;
};

export type InventoryCountItemTemplateItemPaged = {
  __typename?: 'InventoryCountItemTemplateItemPaged';
  items?: Maybe<Array<InventoryCountItemTemplateItem>>;
  pagination: PaginationResult;
};

export type InventoryCountItemTemplateItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountItemTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type InventoryCountItemTemplateItemQopInput = {
  filters?: InputMaybe<InventoryCountItemTemplateItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountItemTemplatePaged = {
  __typename?: 'InventoryCountItemTemplatePaged';
  items?: Maybe<Array<InventoryCountItemTemplate>>;
  pagination: PaginationResult;
};

export type InventoryCountItemTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountItemTemplateName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type InventoryCountItemTemplateQopInput = {
  filters?: InputMaybe<InventoryCountItemTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountItemTemplateUpdateInput = {
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
  inventoryCountItemTemplateName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryCountTask = {
  __typename?: 'InventoryCountTask';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  cancelledAtUtc?: Maybe<Scalars['Time']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  inventoryCountTaskDatetime: Scalars['Time']['output'];
  inventoryCountTaskDatetimeUtc: Scalars['Time']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTaskNumber: Scalars['String']['output'];
  inventoryCountTransaction: InventoryCountTransaction;
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionLocations?: Maybe<Array<InventoryCountTransactionLocation>>;
  inventoryCountTransactionNumber: Scalars['String']['output'];
  isRecount: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  taskDoneAt?: Maybe<Scalars['Time']['output']>;
  taskDoneAtUtc?: Maybe<Scalars['Time']['output']>;
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  taskStartAtUtc?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyCounted: Scalars['Float']['output'];
  totalQtyDiff: Scalars['Float']['output'];
  totalQtySystem: Scalars['Float']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryCountTaskAssignedFinishInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskAssignee = {
  __typename?: 'InventoryCountTaskAssignee';
  assignedToUserID: Scalars['UUID']['output'];
  assignedToUserName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  finishedAt?: Maybe<Scalars['Time']['output']>;
  finishedAtUtc?: Maybe<Scalars['Time']['output']>;
  inventoryCountTask: InventoryCountTask;
  inventoryCountTaskAssigneeID: Scalars['UUID']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  sequenceNo: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['Time']['output']>;
  startedAtUtc?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
};

export type InventoryCountTaskAssigneeAddInput = {
  assignedToUserID: Scalars['UUID']['input'];
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskAssigneeDeleteInput = {
  inventoryCountTaskAssigneeID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskAssigneePaged = {
  __typename?: 'InventoryCountTaskAssigneePaged';
  items: Array<InventoryCountTaskAssignee>;
  pagination: PaginationResult;
};

export type InventoryCountTaskAssigneeQopFilterInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskAssigneeID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountTaskAssigneeQopInput = {
  filters?: InputMaybe<InventoryCountTaskAssigneeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskCancelInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskExecuteImportInput = {
  assigneeUserID: Scalars['UUID']['input'];
  fileID: Scalars['UUID']['input'];
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskExecuteImportResult = {
  __typename?: 'InventoryCountTaskExecuteImportResult';
  backgroundJobID: Scalars['UUID']['output'];
};

export type InventoryCountTaskExecutionDetailDeleteInput = {
  inventoryCountTaskExecutionItemDetailID: Scalars['UUID']['input'];
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskExecutionItem = {
  __typename?: 'InventoryCountTaskExecutionItem';
  barcode: Scalars['String']['output'];
  baseUomQtyCounted: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  baseUomUnitCostCounted: Scalars['Float']['output'];
  baseUomUnitCostDiff: Scalars['Float']['output'];
  baseUomUnitCostSystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTaskExecutionItemID: Scalars['UUID']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  isRecountRequired: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  resultItemDetails?: Maybe<Array<InventoryCountTransactionResultItemDetail>>;
  totalExecutionCount: Scalars['Int']['output'];
  unitCostSystem: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  virtualWarehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTaskExecutionItemDetail = {
  __typename?: 'InventoryCountTaskExecutionItemDetail';
  barcode: Scalars['String']['output'];
  baseUomQty: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  executedAtUtc: Scalars['Time']['output'];
  executedByUserID: Scalars['UUID']['output'];
  executedByUserName: Scalars['String']['output'];
  inputMethod: Scalars['String']['output'];
  inventoryCountTaskExecutionItemDetailID: Scalars['UUID']['output'];
  inventoryCountTaskExecutionItemID: Scalars['UUID']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionLocationDetailID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  sequenceNo: Scalars['Int']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  virtualWarehouseLocationName: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTaskExecutionItemDetailPaged = {
  __typename?: 'InventoryCountTaskExecutionItemDetailPaged';
  items: Array<InventoryCountTaskExecutionItemDetail>;
  pagination: PaginationResult;
};

export type InventoryCountTaskExecutionItemDetailQopFilterInput = {
  executedAtEnd?: InputMaybe<Scalars['Time']['input']>;
  executedAtStart?: InputMaybe<Scalars['Time']['input']>;
  executedByUserID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskExecutionItemDetailID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskExecutionItemID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationDetailID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTaskExecutionItemDetailQopInput = {
  filters?: InputMaybe<InventoryCountTaskExecutionItemDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskExecutionItemPaged = {
  __typename?: 'InventoryCountTaskExecutionItemPaged';
  items: Array<InventoryCountTaskExecutionItem>;
  pagination: PaginationResult;
};

export type InventoryCountTaskExecutionItemQopFilterInput = {
  inventoryCountTaskExecutionItemID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  isRecountRequired?: InputMaybe<Scalars['Boolean']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  qtyDiffEqual?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMax?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMin?: InputMaybe<Scalars['Float']['input']>;
  warehouseLocationIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryCountTaskExecutionItemQopInput = {
  filters?: InputMaybe<InventoryCountTaskExecutionItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskExecutionItemSummary = {
  __typename?: 'InventoryCountTaskExecutionItemSummary';
  barcode: Scalars['String']['output'];
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedByUserID: Scalars['UUID']['output'];
  executedByUserName: Scalars['String']['output'];
  inventoryCountTaskExecutionItemSummaryID: Scalars['UUID']['output'];
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  sequenceNo: Scalars['Int']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTaskExecutionItemSummaryPaged = {
  __typename?: 'InventoryCountTaskExecutionItemSummaryPaged';
  items: Array<InventoryCountTaskExecutionItemSummary>;
  pagination: PaginationResult;
};

export type InventoryCountTaskExecutionItemSummaryQopFilterInput = {
  executedByUserID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTaskExecutionItemSummaryQopInput = {
  filters?: InputMaybe<InventoryCountTaskExecutionItemSummaryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskExportInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
};

export type InventoryCountTaskFinishInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskItemExecuteInput = {
  inputMethod: Scalars['String']['input'];
  inventoryCountTaskID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventoryCountTaskItemResetExecutedInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskPaged = {
  __typename?: 'InventoryCountTaskPaged';
  items: Array<InventoryCountTask>;
  pagination: PaginationResult;
};

export type InventoryCountTaskQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTaskDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTaskQopInput = {
  filters?: InputMaybe<InventoryCountTaskQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskRecountCreateInput = {
  assignedToUserIDs: Array<Scalars['UUID']['input']>;
  inventoryCountTaskDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionID: Scalars['UUID']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  parentInventoryCountTaskID: Scalars['UUID']['input'];
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskRecountItem = {
  __typename?: 'InventoryCountTaskRecountItem';
  barcode: Scalars['String']['output'];
  baseUomQtyCounted: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  baseUomUnitCostCounted: Scalars['Float']['output'];
  baseUomUnitCostDiff: Scalars['Float']['output'];
  baseUomUnitCostSystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTaskID: Scalars['UUID']['output'];
  inventoryCountTaskRecountItemID: Scalars['UUID']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  parentInventoryCountTaskID: Scalars['UUID']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type InventoryCountTaskRecountItemInput = {
  inventoryCountTransactionResultItemID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountTaskRecountItemPaged = {
  __typename?: 'InventoryCountTaskRecountItemPaged';
  items: Array<InventoryCountTaskRecountItem>;
  pagination: PaginationResult;
};

export type InventoryCountTaskRecountItemQopFilterInput = {
  difference?: InputMaybe<Scalars['Float']['input']>;
  inventoryCountTaskID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTaskRecountItemID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionResultItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  qtyDiffMax?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMin?: InputMaybe<Scalars['Float']['input']>;
  totalCostMax?: InputMaybe<Scalars['Float']['input']>;
  totalCostMin?: InputMaybe<Scalars['Float']['input']>;
  unitCostDifference?: InputMaybe<Scalars['Float']['input']>;
};

export type InventoryCountTaskRecountItemQopInput = {
  filters?: InputMaybe<InventoryCountTaskRecountItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTaskStartInput = {
  inventoryCountTaskID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTaskUpdateInput = {
  assignedToUserIDs: Array<Scalars['UUID']['input']>;
  inventoryCountTaskDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTaskID: Scalars['UUID']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  version: Scalars['UUID']['input'];
};

export type InventoryCountTransaction = {
  __typename?: 'InventoryCountTransaction';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  inventoryCountTransactionDatetime: Scalars['Time']['output'];
  inventoryCountTransactionDatetimeUtc: Scalars['Time']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionNumber: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
  totalCountTasks: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryCountTransactionCancelInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  inventoryCountTransactionID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type InventoryCountTransactionCreateInput = {
  assignedToUserIDs: Array<Scalars['UUID']['input']>;
  excludeProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  inventoryCountTransactionDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  locationScopeType: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  partialProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  taskType: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryCountTransactionExport = {
  __typename?: 'InventoryCountTransactionExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type InventoryCountTransactionExportInput = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
};

export type InventoryCountTransactionFinishInput = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
  reasonID?: InputMaybe<Scalars['UUID']['input']>;
  version: Scalars['UUID']['input'];
};

export type InventoryCountTransactionItem = {
  __typename?: 'InventoryCountTransactionItem';
  barcode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionItemID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type InventoryCountTransactionItemPaged = {
  __typename?: 'InventoryCountTransactionItemPaged';
  items: Array<InventoryCountTransactionItem>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionItemQopFilterInput = {
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountTransactionItemQopInput = {
  filters?: InputMaybe<InventoryCountTransactionItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionLocation = {
  __typename?: 'InventoryCountTransactionLocation';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionLocationID: Scalars['UUID']['output'];
  sequenceNo: Scalars['Int']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTransactionLocationDetail = {
  __typename?: 'InventoryCountTransactionLocationDetail';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionLocationDetailID: Scalars['UUID']['output'];
  inventoryCountTransactionLocationID: Scalars['UUID']['output'];
  sequenceNo: Scalars['Int']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTransactionLocationDetailPaged = {
  __typename?: 'InventoryCountTransactionLocationDetailPaged';
  items: Array<InventoryCountTransactionLocationDetail>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionLocationDetailQopFilterInput = {
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationDetailID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationName?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountTransactionLocationDetailQopInput = {
  filters?: InputMaybe<InventoryCountTransactionLocationDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionLocationPaged = {
  __typename?: 'InventoryCountTransactionLocationPaged';
  items: Array<InventoryCountTransactionLocation>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionLocationQopFilterInput = {
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTransactionLocationQopInput = {
  filters?: InputMaybe<InventoryCountTransactionLocationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionPaged = {
  __typename?: 'InventoryCountTransactionPaged';
  items: Array<InventoryCountTransaction>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTransactionQopInput = {
  filters?: InputMaybe<InventoryCountTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionResultItem = {
  __typename?: 'InventoryCountTransactionResultItem';
  barcode: Scalars['String']['output'];
  baseUomQtyCounted: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  baseUomUnitCostCounted: Scalars['Float']['output'];
  baseUomUnitCostDiff: Scalars['Float']['output'];
  baseUomUnitCostSystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionResultItemID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  sequence: Scalars['Int']['output'];
  totalCost: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  virtualWarehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTransactionResultItemDetail = {
  __typename?: 'InventoryCountTransactionResultItemDetail';
  barcode: Scalars['String']['output'];
  baseUomQtyCounted: Scalars['Float']['output'];
  baseUomQtyDiff: Scalars['Float']['output'];
  baseUomQtySystem: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryCountTransactionLocationDetailID: Scalars['UUID']['output'];
  inventoryCountTransactionResultItemDetailID: Scalars['UUID']['output'];
  inventoryCountTransactionResultItemID: Scalars['UUID']['output'];
  note: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  virtualWarehouseLocationName: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type InventoryCountTransactionResultItemDetailPaged = {
  __typename?: 'InventoryCountTransactionResultItemDetailPaged';
  items: Array<InventoryCountTransactionResultItemDetail>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionResultItemDetailQopFilterInput = {
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionLocationDetailID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionResultItemDetailID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionResultItemID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryCountTransactionResultItemDetailQopInput = {
  filters?: InputMaybe<InventoryCountTransactionResultItemDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionResultItemPaged = {
  __typename?: 'InventoryCountTransactionResultItemPaged';
  items: Array<InventoryCountTransactionResultItem>;
  pagination: PaginationResult;
};

export type InventoryCountTransactionResultItemQopFilterInput = {
  difference?: InputMaybe<Scalars['Float']['input']>;
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryCountTransactionResultItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  qtyDiffEqual?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMax?: InputMaybe<Scalars['Float']['input']>;
  qtyDiffMin?: InputMaybe<Scalars['Float']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  totalCostMax?: InputMaybe<Scalars['Float']['input']>;
  totalCostMin?: InputMaybe<Scalars['Float']['input']>;
  unitCostDifference?: InputMaybe<Scalars['Float']['input']>;
};

export type InventoryCountTransactionResultItemQopInput = {
  filters?: InputMaybe<InventoryCountTransactionResultItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryCountTransactionUpdateInput = {
  assignedToUserIDs: Array<Scalars['UUID']['input']>;
  excludeProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  inventoryCountTransactionDatetime?: InputMaybe<Scalars['Time']['input']>;
  inventoryCountTransactionID: Scalars['UUID']['input'];
  inventoryCountTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  locationScopeType: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  partialProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  taskType: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryDailyMovement = {
  __typename?: 'InventoryDailyMovement';
  branchID: Scalars['UUID']['output'];
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  dcUsageQty: Scalars['Decimal']['output'];
  endingQty: Scalars['Decimal']['output'];
  endingQtyOnHand: Scalars['Decimal']['output'];
  endingQtyRejected: Scalars['Decimal']['output'];
  endingTotalCost: Scalars['Decimal']['output'];
  endingUnitCost: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  hasStartingStockOrStockIn: Scalars['Boolean']['output'];
  inventoryDailyMovementDate: Scalars['Time']['output'];
  inventoryDailyMovementID: Scalars['UUID']['output'];
  isConsignment: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qtyIn: Scalars['Decimal']['output'];
  qtyOut: Scalars['Decimal']['output'];
  qtyRejected: Scalars['Decimal']['output'];
  startingQty: Scalars['Decimal']['output'];
  startingQtyOnHand: Scalars['Decimal']['output'];
  startingQtyRejected: Scalars['Decimal']['output'];
  startingTotalCost: Scalars['Decimal']['output'];
  startingUnitCost: Scalars['Decimal']['output'];
  storeUsageQty: Scalars['Decimal']['output'];
  totalCostIn: Scalars['Decimal']['output'];
  totalCostOut: Scalars['Decimal']['output'];
  uniqueKey: Scalars['String']['output'];
  unitCostIn: Scalars['Decimal']['output'];
  unitCostOut: Scalars['Decimal']['output'];
  vendor?: Maybe<Vendor>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryDailyMovementPaged = {
  __typename?: 'InventoryDailyMovementPaged';
  items?: Maybe<Array<InventoryDailyMovement>>;
  pagination: PaginationResult;
};

export type InventoryDailyMovementQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  hasStartingStockOrStockIn?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryDailyMovementDate?: InputMaybe<Scalars['Time']['input']>;
  inventoryDailyMovementDateGte?: InputMaybe<Scalars['Time']['input']>;
  inventoryDailyMovementDateLte?: InputMaybe<Scalars['Time']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryDailyMovementQopInput = {
  filters?: InputMaybe<InventoryDailyMovementQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryLocation = {
  __typename?: 'InventoryLocation';
  entityAuditMetadata: EntityAuditMetadata;
  inventoryLocationID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation?: Maybe<WarehouseLocation>;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryLocationPaged = {
  __typename?: 'InventoryLocationPaged';
  items?: Maybe<Array<InventoryLocation>>;
  pagination: PaginationResult;
};

export type InventoryLocationQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type InventoryLocationQopInput = {
  filters?: InputMaybe<InventoryLocationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryMovementSummary = {
  __typename?: 'InventoryMovementSummary';
  endingDate: Scalars['Time']['output'];
  endingQty: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qtyIn: Scalars['Decimal']['output'];
  qtyOut: Scalars['Decimal']['output'];
  startingDate: Scalars['Time']['output'];
  startingQty: Scalars['Decimal']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryMovementSummaryFilterInput = {
  dateEnd: Scalars['Time']['input'];
  dateStart: Scalars['Time']['input'];
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryMovementSummaryPaged = {
  __typename?: 'InventoryMovementSummaryPaged';
  items?: Maybe<Array<InventoryMovementSummary>>;
  pagination: PaginationResult;
};

export type InventoryMovementSummaryQopInput = {
  filters: InventoryMovementSummaryFilterInput;
  pagination?: InputMaybe<Pagination>;
};

export type InventoryPosition = {
  __typename?: 'InventoryPosition';
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  inventoryPositionID: Scalars['UUID']['output'];
  lotNumber: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  searchKey: Scalars['String']['output'];
  sortIndex: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryPositionPaged = {
  __typename?: 'InventoryPositionPaged';
  items?: Maybe<Array<InventoryPosition>>;
  pagination: PaginationResult;
};

export type InventoryPositionQopFilterInput = {
  expiryDateFrom?: InputMaybe<Scalars['Time']['input']>;
  expiryDateTo?: InputMaybe<Scalars['Time']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryPositionQopInput = {
  filters?: InputMaybe<InventoryPositionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryPositionSnapshot = {
  __typename?: 'InventoryPositionSnapshot';
  balanceLastUnitCost: Scalars['Decimal']['output'];
  balanceQty: Scalars['Decimal']['output'];
  balanceSortIndex: Scalars['Int']['output'];
  balanceTotalCost: Scalars['Decimal']['output'];
  balanceUnitCost: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  inventoryPositionID: Scalars['UUID']['output'];
  lotNumber: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  sortIndex: Scalars['Int']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryPositionSnapshotQopInput = {
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type InventorySummary = {
  __typename?: 'InventorySummary';
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  inventorySummaryID: Scalars['UUID']['output'];
  isConsignment: Scalars['Boolean']['output'];
  lastAvgCost: Scalars['Decimal']['output'];
  lastUnitCost: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  qtyAvailable: Scalars['Decimal']['output'];
  qtyCommitted: Scalars['Decimal']['output'];
  qtyOnHand: Scalars['Decimal']['output'];
  qtyRejected: Scalars['Decimal']['output'];
  totalCost: Scalars['Decimal']['output'];
  unitCost: Scalars['Decimal']['output'];
  vendor?: Maybe<Vendor>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventorySummaryPaged = {
  __typename?: 'InventorySummaryPaged';
  items?: Maybe<Array<InventorySummary>>;
  pagination: PaginationResult;
};

export type InventorySummaryQopFilterInput = {
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  qtyGt?: InputMaybe<Scalars['Float']['input']>;
  qtyLt?: InputMaybe<Scalars['Float']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventorySummaryQopInput = {
  filters?: InputMaybe<InventorySummaryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryTransaction = {
  __typename?: 'InventoryTransaction';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  counterpartWarehouse?: Maybe<Warehouse>;
  counterpartWarehouseID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  inventoryTransactionID: Scalars['UUID']['output'];
  inventoryTransactionKey: Scalars['String']['output'];
  inventoryTransactionNumber: Scalars['String']['output'];
  inventoryTransactionTransactionDate: Scalars['Time']['output'];
  inventoryTransactionTransactionDateUtc: Scalars['Time']['output'];
  itemCount: Scalars['Int']['output'];
  itemTotalCost: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type InventoryTransactionItemQopFilterInput = {
  costCalcType?: InputMaybe<Scalars['String']['input']>;
  inventoryTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryTransactionItemQopInput = {
  filters?: InputMaybe<InventoryTransactionItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryTransactionLine = {
  __typename?: 'InventoryTransactionLine';
  actualTotalCost: Scalars['Decimal']['output'];
  actualUnitCost: Scalars['Decimal']['output'];
  counterpartWarehouse?: Maybe<Warehouse>;
  counterpartWarehouseID?: Maybe<Scalars['UUID']['output']>;
  counterpartWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  direction: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryTransactionID: Scalars['UUID']['output'];
  inventoryTransactionLineID: Scalars['UUID']['output'];
  inventoryTransactionLineType: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  postedTotalCost: Scalars['Decimal']['output'];
  postedUnitCost: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  sourceDocumentDetailID2: Scalars['UUID']['output'];
  varianceCost: Scalars['Decimal']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryTransactionLineItem = {
  __typename?: 'InventoryTransactionLineItem';
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  direction: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  inventoryTransactionID: Scalars['UUID']['output'];
  inventoryTransactionLineID: Scalars['UUID']['output'];
  inventoryTransactionLineItemID: Scalars['UUID']['output'];
  isConsignment: Scalars['Boolean']['output'];
  isDCUsage: Scalars['Boolean']['output'];
  isStoreUsage: Scalars['Boolean']['output'];
  qty: Scalars['Decimal']['output'];
  totalCost: Scalars['Decimal']['output'];
  unitCost: Scalars['Decimal']['output'];
  varianceCost: Scalars['Decimal']['output'];
};

export type InventoryTransactionLineItemPaged = {
  __typename?: 'InventoryTransactionLineItemPaged';
  items?: Maybe<Array<InventoryTransactionLineItem>>;
  pagination: PaginationResult;
};

export type InventoryTransactionLinePaged = {
  __typename?: 'InventoryTransactionLinePaged';
  items?: Maybe<Array<InventoryTransactionLine>>;
  pagination: PaginationResult;
};

export type InventoryTransactionLineQopFilterInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  inventoryTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryTransactionLineType?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryTransactionLineQopInput = {
  filters?: InputMaybe<InventoryTransactionLineQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryTransactionLineUnit = {
  __typename?: 'InventoryTransactionLineUnit';
  actualTotalCost: Scalars['Decimal']['output'];
  actualUnitCost: Scalars['Decimal']['output'];
  balanceUpdate: Scalars['Boolean']['output'];
  direction: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate?: Maybe<Scalars['Time']['output']>;
  inventoryTransaction: InventoryTransaction;
  inventoryTransactionID: Scalars['UUID']['output'];
  inventoryTransactionLineID: Scalars['UUID']['output'];
  inventoryTransactionLineItemID: Scalars['UUID']['output'];
  inventoryTransactionLineUnitID: Scalars['UUID']['output'];
  lotNumber: Scalars['String']['output'];
  postedTotalCost: Scalars['Decimal']['output'];
  postedUnitCost: Scalars['Decimal']['output'];
  prevLocationQtyBalance: Scalars['Decimal']['output'];
  prevQtyBalance: Scalars['Decimal']['output'];
  prevWarehouseQtyBalance: Scalars['Decimal']['output'];
  prevWarehouseTotalCostBalance: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  sortIndex: Scalars['Int']['output'];
  varianceCost: Scalars['Decimal']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type InventoryTransactionLineUnitPaged = {
  __typename?: 'InventoryTransactionLineUnitPaged';
  items?: Maybe<Array<InventoryTransactionLineUnit>>;
  pagination: PaginationResult;
};

export type InventoryTransactionLineUnitQopFilterInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  expiryDateFrom?: InputMaybe<Scalars['Time']['input']>;
  expiryDateTo?: InputMaybe<Scalars['Time']['input']>;
  inventoryTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryTransactionLineID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryTransactionLineItemID?: InputMaybe<Scalars['UUID']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryTransactionLineUnitQopInput = {
  filters?: InputMaybe<InventoryTransactionLineUnitQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type InventoryTransactionPaged = {
  __typename?: 'InventoryTransactionPaged';
  items?: Maybe<Array<InventoryTransaction>>;
  pagination: PaginationResult;
};

export type InventoryTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  inventoryTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  transactionDateFrom?: InputMaybe<Scalars['Time']['input']>;
  transactionDateTo?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type InventoryTransactionQopInput = {
  filters?: InputMaybe<InventoryTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type LocationValidationResult = {
  __typename?: 'LocationValidationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  warehouseLocationCode?: Maybe<Scalars['String']['output']>;
  warehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
};

export type LoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MarkConsignmentInvoicesPaidBulkInput = {
  paidReference?: InputMaybe<Scalars['String']['input']>;
  settlementBankAccountID: Scalars['UUID']['input'];
  vendorConsignmentInvoiceIDs: Array<Scalars['UUID']['input']>;
};

export type MarketplaceBackgroundJob = {
  __typename?: 'MarketplaceBackgroundJob';
  createdAtUtc: Scalars['Time']['output'];
  finishedAtUtc?: Maybe<Scalars['Time']['output']>;
  jobCategory: Scalars['String']['output'];
  jobMessage: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  marketplaceBackgroundJobID: Scalars['UUID']['output'];
  processedCount: Scalars['Int']['output'];
  retryCount: Scalars['Int']['output'];
  startedAtUtc?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
  updatedAtUtc: Scalars['Time']['output'];
};

export type MarketplaceBackgroundJobPaged = {
  __typename?: 'MarketplaceBackgroundJobPaged';
  items?: Maybe<Array<MarketplaceBackgroundJob>>;
  pagination: PaginationResult;
};

export type MarketplaceBackgroundJobQopFilterInput = {
  jobCategory?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceBackgroundJobQopInput = {
  filters?: InputMaybe<MarketplaceBackgroundJobQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceCampaign = {
  __typename?: 'MarketplaceCampaign';
  branchCode: Scalars['String']['output'];
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName: Scalars['String']['output'];
  createdAtUtc: Scalars['Time']['output'];
  customTag: Scalars['String']['output'];
  discountCap?: Maybe<Scalars['Float']['output']>;
  discountType: Scalars['String']['output'];
  discountValue?: Maybe<Scalars['Float']['output']>;
  eaterType: Scalars['String']['output'];
  endAtUtc: Scalars['Time']['output'];
  errorMessage: Scalars['String']['output'];
  externalCampaignID: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  marketplaceCampaignID: Scalars['UUID']['output'];
  minBasketAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  objectIDs: Array<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  quotaPerUser?: Maybe<Scalars['Int']['output']>;
  quotaTotal?: Maybe<Scalars['Int']['output']>;
  salesChannelID: Scalars['String']['output'];
  scopeType: Scalars['String']['output'];
  startAtUtc: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  updatedAtUtc: Scalars['Time']['output'];
};

export type MarketplaceCampaignCreateInput = {
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountType: Scalars['String']['input'];
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAtUtc: Scalars['Time']['input'];
  externalMerchantID: Scalars['String']['input'];
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  objectIDs: Array<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  quotaPerUser?: InputMaybe<Scalars['Int']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int']['input']>;
  salesChannelID: Scalars['String']['input'];
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startAtUtc: Scalars['Time']['input'];
};

export type MarketplaceCampaignExtendInput = {
  endAtUtc: Scalars['Time']['input'];
  marketplaceCampaignID: Scalars['UUID']['input'];
  startAtUtc?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceCampaignImportProductsInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: MarketplaceItemMapImportFileMappingInput;
  marketplaceCampaignID: Scalars['UUID']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceCampaignImportResult = {
  __typename?: 'MarketplaceCampaignImportResult';
  importedCount: Scalars['Int']['output'];
  missingBarcodes: Array<Scalars['String']['output']>;
  totalRows: Scalars['Int']['output'];
};

export type MarketplaceCampaignPaged = {
  __typename?: 'MarketplaceCampaignPaged';
  items?: Maybe<Array<MarketplaceCampaign>>;
  pagination: PaginationResult;
};

export type MarketplaceCampaignProduct = {
  __typename?: 'MarketplaceCampaignProduct';
  barcode?: Maybe<Scalars['String']['output']>;
  externalItemID?: Maybe<Scalars['String']['output']>;
  marketplaceCampaignProductID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode?: Maybe<Scalars['String']['output']>;
  productID?: Maybe<Scalars['UUID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceCampaignProductPaged = {
  __typename?: 'MarketplaceCampaignProductPaged';
  items?: Maybe<Array<MarketplaceCampaignProduct>>;
  pagination: PaginationResult;
};

export type MarketplaceCampaignProductQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  marketplaceCampaignID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceCampaignProductQopInput = {
  filters?: InputMaybe<MarketplaceCampaignProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceCampaignPublishFromPromoInput = {
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAtUtc: Scalars['Time']['input'];
  externalMerchantID: Scalars['String']['input'];
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  promoComponentID: Scalars['UUID']['input'];
  promoID: Scalars['UUID']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  quotaPerUser?: InputMaybe<Scalars['Int']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int']['input']>;
  salesChannelID: Scalars['String']['input'];
  startAtUtc: Scalars['Time']['input'];
};

export type MarketplaceCampaignQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAtUtc?: InputMaybe<Scalars['Time']['input']>;
  endAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  endAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  externalCampaignID?: InputMaybe<Scalars['String']['input']>;
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  marketplaceCampaignIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startAtUtc?: InputMaybe<Scalars['Time']['input']>;
  startAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  startAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceCampaignQopInput = {
  filters?: InputMaybe<MarketplaceCampaignQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceCampaignSyncInput = {
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceCampaignSyncResult = {
  __typename?: 'MarketplaceCampaignSyncResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MarketplaceCampaignUpdateInput = {
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountType: Scalars['String']['input'];
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAtUtc: Scalars['Time']['input'];
  marketplaceCampaignID: Scalars['UUID']['input'];
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  objectIDs: Array<Scalars['String']['input']>;
  quotaPerUser?: InputMaybe<Scalars['Int']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startAtUtc: Scalars['Time']['input'];
};

export type MarketplaceChannelApiLog = {
  __typename?: 'MarketplaceChannelAPILog';
  createdAt: Scalars['Time']['output'];
  direction: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  errorMessage: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  httpMethod: Scalars['String']['output'];
  marketplaceChannelAPILogID: Scalars['UUID']['output'];
  operation: Scalars['String']['output'];
  requestBody: Scalars['String']['output'];
  responseBody: Scalars['String']['output'];
  responseStatus: Scalars['Int']['output'];
  salesChannelID: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MarketplaceChannelApiLogPaged = {
  __typename?: 'MarketplaceChannelAPILogPaged';
  items?: Maybe<Array<MarketplaceChannelApiLog>>;
  pagination: PaginationResult;
};

export type MarketplaceChannelApiLogQopFilterInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  httpMethod?: InputMaybe<Scalars['String']['input']>;
  marketplaceChannelAPILogIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operation?: InputMaybe<Scalars['String']['input']>;
  responseStatus?: InputMaybe<Scalars['Int']['input']>;
  responseStatusEnd?: InputMaybe<Scalars['Int']['input']>;
  responseStatusStart?: InputMaybe<Scalars['Int']['input']>;
  responseStatuses?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesChannelIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MarketplaceChannelApiLogQopInput = {
  filters?: InputMaybe<MarketplaceChannelApiLogQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceChannelSyncHealth = {
  __typename?: 'MarketplaceChannelSyncHealth';
  grabPulledAtUtc?: Maybe<Scalars['Time']['output']>;
  menuPushError: Scalars['String']['output'];
  menuPushStatus: Scalars['Int']['output'];
  menuPushedAtUtc?: Maybe<Scalars['Time']['output']>;
  priceSyncedAtUtc?: Maybe<Scalars['Time']['output']>;
  recentFailureCount: Scalars['Int']['output'];
  salesChannelID: Scalars['String']['output'];
};

export type MarketplaceCronRunResult = {
  __typename?: 'MarketplaceCronRunResult';
  jobKey: Scalars['String']['output'];
  message: Scalars['String']['output'];
  ranAt: Scalars['Time']['output'];
  status: Scalars['String']['output'];
};

export type MarketplaceCronSetting = {
  __typename?: 'MarketplaceCronSetting';
  description: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  jobKey: Scalars['String']['output'];
  jobName: Scalars['String']['output'];
  lastRunAt?: Maybe<Scalars['Time']['output']>;
  lastRunMessage: Scalars['String']['output'];
  lastRunStatus?: Maybe<Scalars['String']['output']>;
  spec: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type MarketplaceCronSettingPaged = {
  __typename?: 'MarketplaceCronSettingPaged';
  items?: Maybe<Array<MarketplaceCronSetting>>;
  pagination: PaginationResult;
};

export type MarketplaceCronSettingQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceCronSettingQopInput = {
  filters?: InputMaybe<MarketplaceCronSettingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceCronSettingUpdateInput = {
  isEnabled: Scalars['Boolean']['input'];
  jobKey: Scalars['String']['input'];
};

export type MarketplaceInboundOrder = {
  __typename?: 'MarketplaceInboundOrder';
  acceptedAtUtc?: Maybe<Scalars['Time']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['String']['output'];
  branchName: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  eventKey: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  externalOrderID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  lastProcessAttemptAtUtc?: Maybe<Scalars['Time']['output']>;
  marketplaceInboundOrderID: Scalars['UUID']['output'];
  payload: Scalars['String']['output'];
  posInvoiceNumber: Scalars['String']['output'];
  processedAtUtc?: Maybe<Scalars['Time']['output']>;
  readyMarkedAtUtc?: Maybe<Scalars['Time']['output']>;
  receivedAtUtc: Scalars['Time']['output'];
  retryCount: Scalars['Int']['output'];
  salesChannelID: Scalars['String']['output'];
  settledAtUtc?: Maybe<Scalars['Time']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MarketplaceInboundOrderPaged = {
  __typename?: 'MarketplaceInboundOrderPaged';
  items?: Maybe<Array<MarketplaceInboundOrder>>;
  pagination: PaginationResult;
};

export type MarketplaceInboundOrderQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  externalOrderID?: InputMaybe<Scalars['String']['input']>;
  marketplaceInboundOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  receivedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  settledAtUtc?: InputMaybe<Scalars['Time']['input']>;
  settledAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  settledAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceInboundOrderQopInput = {
  filters?: InputMaybe<MarketplaceInboundOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceItemMapImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceItemMapImportFileMappingInput = {
  columns: Array<MarketplaceItemMapImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  rowFilters?: InputMaybe<Array<MarketplaceItemMapImportRowFilterInput>>;
};

export type MarketplaceItemMapImportRowFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
};

export type MarketplaceMenuSyncInput = {
  externalMerchantID?: InputMaybe<Scalars['String']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID: Scalars['String']['input'];
};

export type MarketplaceMenuSyncResult = {
  __typename?: 'MarketplaceMenuSyncResult';
  categoryCount?: Maybe<Scalars['Int']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  menuGroupName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  syncedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type MarketplaceMenuSyncStatus = {
  __typename?: 'MarketplaceMenuSyncStatus';
  code: Scalars['String']['output'];
  createdAtUtc: Scalars['Time']['output'];
  errors: Array<Scalars['String']['output']>;
  externalMerchantID: Scalars['String']['output'];
  failedSectionCount: Scalars['Int']['output'];
  salesChannelID: Scalars['String']['output'];
  updatedAtUtc: Scalars['Time']['output'];
};

export type MarketplaceOrder = {
  __typename?: 'MarketplaceOrder';
  acceptedAtUtc?: Maybe<Scalars['Time']['output']>;
  branchCode: Scalars['String']['output'];
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  customerPaymentAmount: Scalars['Float']['output'];
  deliveryFeeAmount: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  externalMerchantID: Scalars['String']['output'];
  externalOrderID: Scalars['String']['output'];
  externalOrderStatus: Scalars['String']['output'];
  externalStoreID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isEdited: Scalars['Boolean']['output'];
  items: Array<MarketplaceOrderItem>;
  marketplaceOrderID: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  noteInternal: Scalars['String']['output'];
  orderDatetimeUtc: Scalars['Time']['output'];
  paymentReconciledAtUtc?: Maybe<Scalars['Time']['output']>;
  paymentType: Scalars['String']['output'];
  posInvoiceNumber: Scalars['String']['output'];
  pricingIssues: Array<MarketplaceOrderPricingIssue>;
  pricingStatus: Scalars['String']['output'];
  promos: Array<MarketplaceOrderPromo>;
  readyMarkedAtUtc?: Maybe<Scalars['Time']['output']>;
  receiptMetadata?: Maybe<MarketplaceOrderReceiptMetadata>;
  receivedAtUtc: Scalars['Time']['output'];
  salesChannelAdditionalCharge: Scalars['Float']['output'];
  salesChannelID: Scalars['String']['output'];
  settledAtUtc?: Maybe<Scalars['Time']['output']>;
  shortOrderNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotalAmount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAtUtc: Scalars['Time']['output'];
  version: Scalars['UUID']['output'];
};

export type MarketplaceOrderCancelInput = {
  cancelCode: Scalars['Int']['input'];
  marketplaceOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type MarketplaceOrderCancelReason = {
  __typename?: 'MarketplaceOrderCancelReason';
  code: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export type MarketplaceOrderCancelableResult = {
  __typename?: 'MarketplaceOrderCancelableResult';
  cancelReasons: Array<MarketplaceOrderCancelReason>;
  cancelable: Scalars['Boolean']['output'];
  limitTimes?: Maybe<Scalars['Int']['output']>;
  limitType?: Maybe<Scalars['String']['output']>;
  nonCancellationReason?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceOrderDriverMetadata = {
  __typename?: 'MarketplaceOrderDriverMetadata';
  etaSeconds?: Maybe<Scalars['Int']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceOrderEditInput = {
  items: Array<MarketplaceOrderEditItemInput>;
  marketplaceOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type MarketplaceOrderEditItemInput = {
  isExternalItemID?: InputMaybe<Scalars['Boolean']['input']>;
  itemID: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceOrderExportFile = {
  __typename?: 'MarketplaceOrderExportFile';
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type MarketplaceOrderItem = {
  __typename?: 'MarketplaceOrderItem';
  addonComponents: Array<MarketplaceOrderItemAddon>;
  barcode: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  externalItemID: Scalars['String']['output'];
  externalItemName: Scalars['String']['output'];
  freeQty: Scalars['Float']['output'];
  item?: Maybe<MarketplaceOrderItemListing>;
  lineIndex: Scalars['Int']['output'];
  marketplaceOrderID: Scalars['UUID']['output'];
  marketplaceOrderItemID: Scalars['UUID']['output'];
  netAmount: Scalars['Float']['output'];
  note: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  promoNames: Array<Scalars['String']['output']>;
  qty: Scalars['Float']['output'];
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type MarketplaceOrderItemAddon = {
  __typename?: 'MarketplaceOrderItemAddon';
  productCode: Scalars['String']['output'];
  productID: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type MarketplaceOrderItemListing = {
  __typename?: 'MarketplaceOrderItemListing';
  externalCategoryName: Scalars['String']['output'];
  externalItemID: Scalars['String']['output'];
  externalItemName: Scalars['String']['output'];
  externalVariantName: Scalars['String']['output'];
  imageURL?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  salesChannelCategoryName: Scalars['String']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
};

export type MarketplaceOrderItemPaged = {
  __typename?: 'MarketplaceOrderItemPaged';
  items?: Maybe<Array<MarketplaceOrderItem>>;
  pagination: PaginationResult;
};

export type MarketplaceOrderItemQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalItemID?: InputMaybe<Scalars['String']['input']>;
  externalItemName?: InputMaybe<Scalars['String']['input']>;
  lineIndex?: InputMaybe<Scalars['Int']['input']>;
  marketplaceOrderID?: InputMaybe<Scalars['UUID']['input']>;
  marketplaceOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketplaceOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  marketplaceOrderItemIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['String']['input']>;
  productIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceOrderItemQopInput = {
  filters?: InputMaybe<MarketplaceOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceOrderMarkReadyInput = {
  marketplaceOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type MarketplaceOrderPaged = {
  __typename?: 'MarketplaceOrderPaged';
  items?: Maybe<Array<MarketplaceOrder>>;
  pagination: PaginationResult;
};

export type MarketplaceOrderPricingIssue = {
  __typename?: 'MarketplaceOrderPricingIssue';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type MarketplaceOrderPromo = {
  __typename?: 'MarketplaceOrderPromo';
  code: Scalars['String']['output'];
  freeItemProductCode: Scalars['String']['output'];
  freeItemQty: Scalars['Float']['output'];
  fullAmount: Scalars['Float']['output'];
  kind: Scalars['String']['output'];
  level: Scalars['String']['output'];
  merchantAmount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type MarketplaceOrderPromoMetadata = {
  __typename?: 'MarketplaceOrderPromoMetadata';
  amount: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MarketplaceOrderQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  externalOrderID?: InputMaybe<Scalars['String']['input']>;
  externalOrderStatus?: InputMaybe<Scalars['String']['input']>;
  isEdited?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  orderDatetimeUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  orderDatetimeUtcStart?: InputMaybe<Scalars['Time']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  posInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  receivedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  settledAtUtc?: InputMaybe<Scalars['Time']['input']>;
  settledAtUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  settledAtUtcStart?: InputMaybe<Scalars['Time']['input']>;
  shortOrderNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MarketplaceOrderQopInput = {
  filters?: InputMaybe<MarketplaceOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MarketplaceOrderReceiptMetadata = {
  __typename?: 'MarketplaceOrderReceiptMetadata';
  cutleryRequired?: Maybe<Scalars['Boolean']['output']>;
  driver?: Maybe<MarketplaceOrderDriverMetadata>;
  estimatedPickupTime?: Maybe<Scalars['Time']['output']>;
  orderNotes?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  promoName?: Maybe<Scalars['String']['output']>;
  promos?: Maybe<Array<MarketplaceOrderPromoMetadata>>;
  virtualContact?: Maybe<MarketplaceOrderVirtualContact>;
};

export type MarketplaceOrderReconcilePaymentInput = {
  marketplaceOrderID: Scalars['UUID']['input'];
};

export type MarketplaceOrderSyncPosInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  externalOrderID?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<MarketplaceOrderEditItemInput>>;
  marketplaceOrderID?: InputMaybe<Scalars['UUID']['input']>;
  orderState?: InputMaybe<Scalars['String']['input']>;
  posInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  posOrderID?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceOrderSyncPosResult = {
  __typename?: 'MarketplaceOrderSyncPOSResult';
  externalOrderID: Scalars['String']['output'];
  paybillQRCode?: Maybe<Scalars['String']['output']>;
  posInvoiceNumber?: Maybe<Scalars['String']['output']>;
  posOrderID?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MarketplaceOrderVirtualContact = {
  __typename?: 'MarketplaceOrderVirtualContact';
  phone?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
};

export type MarketplacePromoForPublish = {
  __typename?: 'MarketplacePromoForPublish';
  components: Array<MarketplacePromoForPublishComponent>;
  name: Scalars['String']['output'];
  promoID: Scalars['String']['output'];
};

export type MarketplacePromoForPublishComponent = {
  __typename?: 'MarketplacePromoForPublishComponent';
  discountType: Scalars['String']['output'];
  discountValue: Scalars['Float']['output'];
  productCount: Scalars['Int']['output'];
  promoComponentID: Scalars['String']['output'];
  promoTypeName: Scalars['String']['output'];
  promoTypeUniqueKey: Scalars['String']['output'];
  publishable: Scalars['Boolean']['output'];
  scopeType: Scalars['String']['output'];
};

export type MarketplaceProviderCampaign = {
  __typename?: 'MarketplaceProviderCampaign';
  createdBy: Scalars['String']['output'];
  customTag: Scalars['String']['output'];
  discountCap?: Maybe<Scalars['Float']['output']>;
  discountType: Scalars['String']['output'];
  discountValue?: Maybe<Scalars['Float']['output']>;
  eaterType: Scalars['String']['output'];
  endAtUtc: Scalars['Time']['output'];
  id: Scalars['String']['output'];
  minBasketAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  objectIDs: Array<Scalars['String']['output']>;
  scopeType: Scalars['String']['output'];
  startAtUtc: Scalars['Time']['output'];
  state: Scalars['String']['output'];
};

export type MarketplaceProvisionablePromo = {
  __typename?: 'MarketplaceProvisionablePromo';
  endDate: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  promoID: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type MarketplaceStorePauseInput = {
  duration?: InputMaybe<Scalars['String']['input']>;
  externalMerchantID: Scalars['String']['input'];
  isPause: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type MarketplaceStoreStatus = {
  __typename?: 'MarketplaceStoreStatus';
  closeReason: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  isInSpecialOpeningHourRange: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  salesChannelID: Scalars['String']['output'];
};

export type MasterdataBackgroundJob = {
  __typename?: 'MasterdataBackgroundJob';
  backgroundJobID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  finishedDatetime?: Maybe<Scalars['Time']['output']>;
  finishedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  jobCategory: Scalars['String']['output'];
  jobDescription: Scalars['String']['output'];
  jobKey: Scalars['String']['output'];
  jobMessage: Scalars['String']['output'];
  jobType: Scalars['String']['output'];
  processedCount: Scalars['Int']['output'];
  retryCount: Scalars['Int']['output'];
  startedDatetime?: Maybe<Scalars['Time']['output']>;
  startedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum MasterdataSyncEntityType {
  Branch = 'BRANCH',
  Product = 'PRODUCT',
  ProductCategory = 'PRODUCT_CATEGORY',
  ReasonInventoryAdjustment = 'REASON_INVENTORY_ADJUSTMENT',
  Tax = 'TAX',
  Uom = 'UOM',
  UomCategory = 'UOM_CATEGORY',
  Vendor = 'VENDOR',
  Warehouse = 'WAREHOUSE'
}

export type MemberType = {
  __typename?: 'MemberType';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  memberTypeID: Scalars['UUID']['output'];
  memberTypeName: Scalars['String']['output'];
  spendPerPoint: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type MemberTypeCreateInput = {
  isActive: Scalars['Boolean']['input'];
  memberTypeName: Scalars['String']['input'];
  spendPerPoint: Scalars['Int']['input'];
};

export type MemberTypePaged = {
  __typename?: 'MemberTypePaged';
  items?: Maybe<Array<MemberType>>;
  pagination: PaginationResult;
};

export type MemberTypeQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  memberTypeName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type MemberTypeQopInput = {
  filters?: InputMaybe<MemberTypeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type MemberTypeUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  memberTypeID: Scalars['UUID']['input'];
  memberTypeName: Scalars['String']['input'];
  spendPerPoint: Scalars['Int']['input'];
};

export type MobilePickingTask = {
  __typename?: 'MobilePickingTask';
  branchID: Scalars['UUID']['output'];
  items: Array<MobilePickingTaskItem>;
  pickingTaskDatetime: Scalars['Time']['output'];
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskNumber: Scalars['String']['output'];
  progressPercent: Scalars['Float']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyAssigned: Scalars['Float']['output'];
  totalQtyExecuted: Scalars['Float']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type MobilePickingTaskItem = {
  __typename?: 'MobilePickingTaskItem';
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskItemID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyAssigned: Scalars['Float']['output'];
  qtyExecuted: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  unfulfilledReason?: Maybe<Scalars['String']['output']>;
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type MobilePutawayTask = {
  __typename?: 'MobilePutawayTask';
  branchID: Scalars['UUID']['output'];
  fromWarehouseLocationCode: Scalars['String']['output'];
  fromWarehouseLocationID: Scalars['UUID']['output'];
  fromWarehouseLocationName: Scalars['String']['output'];
  items: Array<MobilePutawayTaskItem>;
  progressPercent: Scalars['Float']['output'];
  putawayTaskDatetime: Scalars['Time']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskNumber: Scalars['String']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyAssigned: Scalars['Float']['output'];
  totalQtyExecuted: Scalars['Float']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type MobilePutawayTaskItem = {
  __typename?: 'MobilePutawayTaskItem';
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskItemID: Scalars['UUID']['output'];
  qtyAssigned: Scalars['Float']['output'];
  qtyExecuted: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  suggestionWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  suggestionWarehouseLocationName?: Maybe<Scalars['String']['output']>;
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type MoveConsignmentItemsInput = {
  salesConsignmentInvoiceIDs: Array<Scalars['UUID']['input']>;
  targetVendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  SalesChannelCreate: SalesChannel;
  SalesChannelDelete: Scalars['Boolean']['output'];
  SalesChannelUpdate: SalesChannel;
  adminResetPassword: AdminResetPasswordResponse;
  aiChatCreateSession: AiChatSession;
  aiChatDeleteSession: Scalars['Boolean']['output'];
  aiChatRenameSession: AiChatSession;
  aiChatSendMessage: AiChatSendMessageResponse;
  aiDeleteAppClient: Scalars['Boolean']['output'];
  aiRegenerateAppClientKey: Scalars['String']['output'];
  aiUpdateGuardrailsConfig: AiGuardrailsConfig;
  aiUpdateScopeTable: AiScopeTable;
  aiUpdateScopeTool: AiScopeTool;
  aiUpsertAppClient: AiAppClient;
  appCreate: App;
  appDelete: Scalars['Boolean']['output'];
  appUpdate: App;
  authLogin: AuthResponse;
  authLoginVendor: AuthResponse;
  authRefreshToken: AuthResponse;
  authSetDefaultBranch: AuthResponse;
  backgroundJobCreate: BackgroundJob;
  backgroundJobDelete: Scalars['Boolean']['output'];
  backgroundJobUpdate: BackgroundJob;
  bankAccountCreate: BankAccount;
  bankAccountDelete: Scalars['Boolean']['output'];
  bankAccountUpdate: BankAccount;
  bankCreate: Bank;
  bankDelete: Scalars['Boolean']['output'];
  bankReconciliationCancel: BankReconciliation;
  bankReconciliationCreate: BankReconciliation;
  bankReconciliationExport: BankReconciliationExport;
  bankReconciliationFinalize: BankReconciliation;
  bankReconciliationImportValidate: BankReconciliationImportValidateResult;
  bankReconciliationItemManualMatch: BankReconciliation;
  bankReconciliationItemMerge: BankReconciliation;
  bankReconciliationItemResolve: BankReconciliation;
  bankReconciliationItemsBulkResolve: BankReconciliation;
  bankReconciliationItemsBulkResolveByFilter: BankReconciliation;
  bankReconciliationProcess: BankReconciliation;
  bankReconciliationRemoveFile?: Maybe<BankReconciliation>;
  bankReconciliationRetryPoolFile: BankReconciliationFile;
  bankReconciliationUploadFile: BankReconciliation;
  bankReconciliationUploadPoolFile: BankReconciliationFile;
  bankUpdate: Bank;
  biKnowledgeCreate: BiKnowledge;
  biKnowledgeDelete: Scalars['Boolean']['output'];
  biKnowledgeUpdate: BiKnowledge;
  biRoleCreate: BiRole;
  biRoleDelete: Scalars['Boolean']['output'];
  biRoleUpdate: BiRole;
  biScopeTableBulkUpdate: BiScopeTableBulkUpdateResult;
  biScopeTableCreate: BiScopeTable;
  biScopeTableDelete: Scalars['Boolean']['output'];
  biScopeTableUpdate: BiScopeTable;
  biUserCreate: BiUser;
  biUserDelete: Scalars['Boolean']['output'];
  biUserUpdate: BiUser;
  billOfMaterialComponentCreate: BillOfMaterialComponent;
  billOfMaterialComponentDelete: Scalars['Boolean']['output'];
  billOfMaterialComponentUpdate: BillOfMaterialComponent;
  billOfMaterialCreate: BillOfMaterial;
  billOfMaterialDelete: Scalars['Boolean']['output'];
  billOfMaterialUpdate: BillOfMaterial;
  branchBankAccountCreate: BranchBankAccount;
  branchBankAccountDelete: Scalars['Boolean']['output'];
  branchBankAccountUpdate: BranchBankAccount;
  branchCategoryCreate: BranchCategory;
  branchCategoryDelete: Scalars['Boolean']['output'];
  branchCategoryUpdate: BranchCategory;
  branchCreate: Branch;
  branchDelete: Scalars['Boolean']['output'];
  branchPosBookmarkCreate: BranchPosBookmark;
  branchPosBookmarkDelete: Scalars['Boolean']['output'];
  branchPosBookmarkUpdate: BranchPosBookmark;
  branchProductSalesChannelItemDisable: BranchProductSalesChannelItem;
  branchProductSalesChannelItemRestore: Scalars['Boolean']['output'];
  branchQrisMerchantCreate: BranchQrisMerchant;
  branchQrisMerchantDelete: Scalars['Boolean']['output'];
  branchQrisMerchantUpdate: BranchQrisMerchant;
  branchSalesChannelCategoryGroupCreate: BranchSalesChannelCategoryGroup;
  branchSalesChannelCategoryGroupDelete: Scalars['Boolean']['output'];
  branchSalesChannelCategoryGroupUpdate: BranchSalesChannelCategoryGroup;
  branchSalesChannelMerchantMapCreate: BranchSalesChannelMerchantMap;
  branchSalesChannelMerchantMapDelete: Scalars['Boolean']['output'];
  branchSalesChannelMerchantMapUpdate: BranchSalesChannelMerchantMap;
  branchSalesChannelOperatingHoursUpdate: BranchSalesChannelMerchantMap;
  branchSalesChannelPackagingUpdate: BranchSalesChannelMerchantMap;
  branchSalesChannelPauseUpdate: BranchSalesChannelMerchantMap;
  branchSalesPaymentMethodCreate: BranchSalesPaymentMethod;
  branchSalesPaymentMethodDelete: Scalars['Boolean']['output'];
  branchSalesPaymentMethodUpdate: BranchSalesPaymentMethod;
  branchStoreSupervisorCreate: Array<BranchStoreSupervisorCreated>;
  branchStoreSupervisorDelete: Scalars['Boolean']['output'];
  branchStoreSupervisorSync: Array<BranchStoreSupervisor>;
  branchStoreSupervisorUpdate: BranchStoreSupervisor;
  branchUpdate: Branch;
  cancelConsignmentInvoice: VendorConsignmentInvoice;
  changePassword: Scalars['Boolean']['output'];
  cityCreate: City;
  cityDelete: Scalars['Boolean']['output'];
  cityUpdate: City;
  consignmentStockInCancel: Scalars['Boolean']['output'];
  consignmentStockInConfirm: ConsignmentStockIn;
  consignmentStockInCreate: ConsignmentStockIn;
  consignmentStockInRequestApprove: ConsignmentStockInRequest;
  consignmentStockInRequestCancel: Scalars['Boolean']['output'];
  consignmentStockInRequestCreate: ConsignmentStockInRequest;
  consignmentStockInRequestReject: ConsignmentStockInRequest;
  consignmentStockInRequestSubmit: ConsignmentStockInRequest;
  consignmentStockInRequestUpdate: ConsignmentStockInRequest;
  consignmentStockInUpdate: ConsignmentStockIn;
  consignmentStockOutCancel: Scalars['Boolean']['output'];
  consignmentStockOutConfirm: ConsignmentStockOut;
  consignmentStockOutCreate: ConsignmentStockOut;
  consignmentStockOutUpdate: ConsignmentStockOut;
  costAdjustmentImport: Scalars['UUID']['output'];
  costAdjustmentImportValidateCodes: CostAdjustmentImportValidateCodesResult;
  countryCreate: Country;
  countryDelete: Scalars['Boolean']['output'];
  countryUpdate: Country;
  createErpProduct: Scalars['Int']['output'];
  createManualConsignmentProforma: VendorConsignmentInvoice;
  customerAddressCreate: CustomerAddress;
  customerAddressDelete: Scalars['Boolean']['output'];
  customerAddressUpdate: CustomerAddress;
  customerCreate: Customer;
  customerCreateFromPOS: Customer;
  customerDelete: Scalars['Boolean']['output'];
  customerImport: Array<Customer>;
  customerSetDefault: Customer;
  customerUpdate: Customer;
  customerVoucherTransactionBackfill: CustomerVoucherTransactionBackfillResult;
  deliveryOrderBatchAddLeftoverContainers: DeliveryOrderBatch;
  deliveryOrderBatchCancel: Scalars['Boolean']['output'];
  deliveryOrderBatchCreate: DeliveryOrderBatch;
  deliveryOrderBatchDetachSourceDocument: Scalars['Int']['output'];
  deliveryOrderBatchGenerate: DeliveryOrderBatch;
  deliveryOrderBatchGenerateAndShip: DeliveryOrderBatch;
  deliveryOrderBatchRegenerateFailed: DeliveryOrderBatch;
  deliveryOrderBatchRemoveContainer: Scalars['Boolean']['output'];
  deliveryOrderBatchScan: DeliveryOrderBatchScanResult;
  deliveryOrderCancel: DeliveryOrder;
  deliveryOrderCheckGenerateBulk?: Maybe<Array<CheckReadyGenerateDeliveryOrderBulk>>;
  deliveryOrderContainerRemove: Scalars['Boolean']['output'];
  deliveryOrderCreate: DeliveryOrder;
  deliveryOrderGenerateBulk: Scalars['Boolean']['output'];
  deliveryOrderShipped: DeliveryOrder;
  deliveryOrderUpdate: DeliveryOrder;
  edcTerminalCreate: EdcTerminal;
  edcTerminalDelete: Scalars['Boolean']['output'];
  edcTerminalUpdate: EdcTerminal;
  editConsignmentSettlement: VendorConsignmentInvoice;
  employeeCreate: Employee;
  employeeDelete: Scalars['Boolean']['output'];
  employeeUpdate: Employee;
  erpSyncAllBranches: SyncAllResult;
  erpSyncAllProductCategories: SyncAllResult;
  erpSyncAllProducts: SyncAllResult;
  erpSyncAllReasonInventoryAdjustments: SyncAllResult;
  erpSyncAllTaxes: SyncAllResult;
  erpSyncAllUomCategories: SyncAllResult;
  erpSyncAllUoms: SyncAllResult;
  erpSyncAllVendors: SyncAllResult;
  erpSyncAllWarehouses: SyncAllResult;
  erpSyncMasterdataByIds: SyncAllResult;
  erpSyncTransactionByIds: SyncAllResult;
  expenseItemCreate: ExpenseItem;
  expenseItemDelete: Scalars['Boolean']['output'];
  expenseItemUpdate: ExpenseItem;
  fileCreateFromStorageObject: File;
  generateConsignmentInvoice: VendorConsignmentInvoice;
  generateConsignmentInvoicesBulk: Array<BulkConsignmentGenerateResult>;
  generateLinkResetPassword: GenerateLinkResetPasswordResponse;
  generateOtpCode: GenerateLinkResetPasswordResponse;
  generateTransferRequestFromReplenishment: TransferRequest;
  internalTransferCancel: InternalTransfer;
  internalTransferConfirm: InternalTransfer;
  internalTransferCreate: InternalTransfer;
  internalTransferUpdate: InternalTransfer;
  inventoryAdjustmentCancel: InventoryAdjustment;
  inventoryAdjustmentConfirm: InventoryAdjustment;
  inventoryAdjustmentCreate: InventoryAdjustment;
  inventoryAdjustmentCreateOpeningBalance: InventoryAdjustment;
  inventoryAdjustmentCreateSystem: InventoryAdjustment;
  inventoryAdjustmentDelete: Scalars['Boolean']['output'];
  inventoryAdjustmentOpeningBalanceImport: Scalars['UUID']['output'];
  inventoryAdjustmentOpeningBalanceImportValidateCodes: InventoryAdjustmentOpeningBalanceImportValidateCodesResult;
  inventoryAdjustmentRetryFromBackgroundJob: Scalars['Boolean']['output'];
  inventoryAdjustmentUpdate: InventoryAdjustment;
  inventoryCountItemTemplateCreate: InventoryCountItemTemplate;
  inventoryCountItemTemplateDelete: Scalars['Boolean']['output'];
  inventoryCountItemTemplateItemCreate: InventoryCountItemTemplateItem;
  inventoryCountItemTemplateItemDelete: Scalars['Boolean']['output'];
  inventoryCountItemTemplateItemImport: InventoryCountItemTemplateItemImportResult;
  inventoryCountItemTemplateItemImportValidate: InventoryCountItemTemplateItemImportValidateResult;
  inventoryCountItemTemplateUpdate: InventoryCountItemTemplate;
  inventoryCountTaskAssignedFinish: Scalars['Boolean']['output'];
  inventoryCountTaskAssigneeAdd: Scalars['Boolean']['output'];
  inventoryCountTaskAssigneeDelete: Scalars['Boolean']['output'];
  inventoryCountTaskCancel: Scalars['Boolean']['output'];
  inventoryCountTaskExecuteImport: InventoryCountTaskExecuteImportResult;
  inventoryCountTaskExecutionDetailDelete?: Maybe<InventoryCountTaskExecutionItem>;
  inventoryCountTaskExportImportTemplate: InventoryCountTransactionExport;
  inventoryCountTaskExportRecountItems: InventoryCountTransactionExport;
  inventoryCountTaskFinish: Scalars['Boolean']['output'];
  inventoryCountTaskItemExecute: InventoryCountTask;
  inventoryCountTaskItemResetExecuted: Scalars['Boolean']['output'];
  inventoryCountTaskRecountCreate: InventoryCountTask;
  inventoryCountTaskStart: InventoryCountTask;
  inventoryCountTaskUpdate: InventoryCountTask;
  inventoryCountTransactionCancel: InventoryCountTransaction;
  inventoryCountTransactionCreate: InventoryCountTransaction;
  inventoryCountTransactionExportResults: InventoryCountTransactionExport;
  inventoryCountTransactionExportResultsByLocation: InventoryCountTransactionExport;
  inventoryCountTransactionFinish: InventoryCountTransaction;
  inventoryCountTransactionUpdate: InventoryCountTransaction;
  lockConsignmentDraftToProforma: VendorConsignmentInvoice;
  markConsignmentInvoicePaid: VendorConsignmentInvoice;
  markConsignmentInvoicesPaidBulk: Array<BulkConsignmentPayResult>;
  marketplaceCampaignAddItem: MarketplaceCampaign;
  marketplaceCampaignCreate: MarketplaceCampaign;
  marketplaceCampaignDelete: Scalars['Boolean']['output'];
  marketplaceCampaignDuplicate: MarketplaceCampaign;
  marketplaceCampaignExtend: MarketplaceCampaign;
  marketplaceCampaignImportProducts: MarketplaceCampaignImportResult;
  marketplaceCampaignPublishFromPromo: MarketplaceCampaign;
  marketplaceCampaignPush: MarketplaceCampaign;
  marketplaceCampaignRemoveItem: MarketplaceCampaign;
  marketplaceCampaignResume: MarketplaceCampaign;
  marketplaceCampaignStop: MarketplaceCampaign;
  marketplaceCampaignSync: MarketplaceCampaignSyncResult;
  marketplaceCampaignUpdate: MarketplaceCampaign;
  marketplaceCronRun: MarketplaceCronRunResult;
  marketplaceCronSettingUpdate: MarketplaceCronSetting;
  marketplaceMenuSync: MarketplaceMenuSyncResult;
  marketplaceOrderCancel: MarketplaceOrder;
  marketplaceOrderEdit: MarketplaceOrder;
  marketplaceOrderMarkReady: MarketplaceOrder;
  marketplaceOrderReconcilePayment: MarketplaceOrder;
  marketplaceOrderSyncPOS: MarketplaceOrderSyncPosResult;
  marketplaceStorePause: Scalars['Boolean']['output'];
  memberTypeCreate: MemberType;
  memberTypeDelete: Scalars['Boolean']['output'];
  memberTypeUpdate: MemberType;
  moveConsignmentItems: VendorConsignmentInvoice;
  outboundContainerBulkGeneration: Scalars['Boolean']['output'];
  outboundContainerCreate: OutboundContainer;
  outboundContainerDelete: Scalars['Boolean']['output'];
  outboundContainerOpenSeal: OutboundContainer;
  outboundContainerPackItem: OutboundContainer;
  outboundContainerUnpackItem: OutboundContainer;
  outboundContainerUpdatePackItem: OutboundContainer;
  packingTaskCancel: Scalars['Boolean']['output'];
  packingTaskFinish: PackingTask;
  packingTaskStart: PackingTask;
  packingTaskVerify: PackingTask;
  paymentProviderConfigUpdate: PaymentProviderConfig;
  paymentTransactionCancel: PaymentTransaction;
  paymentTransactionCheckStatus: PaymentTransactionCheckStatusResult;
  paymentTransactionCreateDynamicQris: PaymentTransaction;
  permissionCreate: Permission;
  permissionDelete: Scalars['Boolean']['output'];
  permissionUpdate: Permission;
  pettyCashAddFundTransactionCancel: PettyCashAddFundTransaction;
  pettyCashAddFundTransactionConfirm: PettyCashAddFundTransaction;
  pettyCashAddFundTransactionCreate: PettyCashAddFundTransaction;
  pettyCashAddFundTransactionDelete: Scalars['Boolean']['output'];
  pettyCashAddFundTransactionUpdate: PettyCashAddFundTransaction;
  pettyCashExpenseTransactionCancel: PettyCashExpenseTransaction;
  pettyCashExpenseTransactionConfirm: PettyCashExpenseTransaction;
  pettyCashExpenseTransactionCreate: PettyCashExpenseTransaction;
  pettyCashExpenseTransactionDelete: Scalars['Boolean']['output'];
  pettyCashExpenseTransactionUpdate: PettyCashExpenseTransaction;
  pettyCashRefundTransactionCancel: PettyCashRefundTransaction;
  pettyCashRefundTransactionConfirm: PettyCashRefundTransaction;
  pettyCashRefundTransactionCreate: PettyCashRefundTransaction;
  pettyCashRefundTransactionDelete: Scalars['Boolean']['output'];
  pettyCashRefundTransactionUpdate: PettyCashRefundTransaction;
  pickingTaskAcceptAndStart: PickingTask;
  pickingTaskAssign: PickingTask;
  pickingTaskCancel: Scalars['Boolean']['output'];
  pickingTaskExecute: PickingTask;
  pickingTaskFinish: PickingTask;
  pickingTaskGenerate: PickingTask;
  pickingTaskGenerateBulk: Array<PickingTask>;
  pickingTaskStart: PickingTask;
  pickingTaskUpdateUnfulfilledReasons: PickingTask;
  placeholder?: Maybe<Scalars['Boolean']['output']>;
  posBookmarkCreate: PosBookmark;
  posBookmarkDelete: Scalars['Boolean']['output'];
  posBookmarkProductCreate: PosBookmarkProduct;
  posBookmarkProductDelete: Scalars['Boolean']['output'];
  posBookmarkProductUpdate: PosBookmarkProduct;
  posBookmarkUpdate: PosBookmark;
  posSalesOrderCreate: PosSalesOrder;
  posSalesOrderUpdate: PosSalesOrder;
  posterCreate: Poster;
  posterDelete: Scalars['Boolean']['output'];
  posterUpdate: Poster;
  pricelistCreate: Pricelist;
  pricelistDelete: Pricelist;
  pricelistPeriodCreate: PricelistPeriod;
  pricelistPeriodDelete: Scalars['Boolean']['output'];
  pricelistPeriodUpdate: PricelistPeriod;
  pricelistProductBulkCreate: Array<PricelistProduct>;
  pricelistProductCreate: PricelistProduct;
  pricelistProductDelete: PricelistProduct;
  pricelistProductImport: PricelistProductImportResult;
  pricelistProductImportValidate: PricelistProductImportValidateResult;
  pricelistProductSalesChannelCreate: PricelistProductSalesChannel;
  pricelistProductSalesChannelDelete: Scalars['Boolean']['output'];
  pricelistProductSalesChannelUpdate: PricelistProductSalesChannel;
  pricelistProductSalesChannelUpsert: PricelistProductSalesChannel;
  pricelistProductUpdate: PricelistProduct;
  pricelistSalesChannelDelete: Scalars['Boolean']['output'];
  pricelistSalesChannelUpsert: PricelistSalesChannel;
  pricelistUpdate: Pricelist;
  productAIImageCreate: ProductAiImage;
  productAIImageDelete: Scalars['Boolean']['output'];
  productAIImageUpdate: ProductAiImage;
  productAccountingCategoryCreate: ProductAccountingCategory;
  productAccountingCategoryDelete: Scalars['Boolean']['output'];
  productAccountingCategoryUpdate: ProductAccountingCategory;
  productAddonComponentCreate: ProductAddonComponent;
  productAddonComponentDelete: ProductAddonComponent;
  productAddonComponentUpdate: ProductAddonComponent;
  productAddonCreate: ProductAddon;
  productAddonDelete: Scalars['Boolean']['output'];
  productAddonGroupCreate: ProductAddonGroup;
  productAddonGroupDelete: Scalars['Boolean']['output'];
  productAddonGroupItemCreate: ProductAddonGroupItem;
  productAddonGroupItemDelete: Scalars['Boolean']['output'];
  productAddonGroupItemUpdate: ProductAddonGroupItem;
  productAddonGroupUpdate: ProductAddonGroup;
  productAddonUpdate: ProductAddon;
  productAvailabilityTemplateCreate: ProductAvailabilityTemplate;
  productAvailabilityTemplateDelete: Scalars['Boolean']['output'];
  productAvailabilityTemplateItemCreate: ProductAvailabilityTemplateItem;
  productAvailabilityTemplateItemDelete: Scalars['Boolean']['output'];
  productAvailabilityTemplateItemExport: ProductAvailabilityTemplateItemExportResult;
  productAvailabilityTemplateItemImport: ProductAvailabilityTemplateItemImportResult;
  productAvailabilityTemplateItemImportValidate: ProductAvailabilityTemplateItemImportValidateResult;
  productAvailabilityTemplateItemSetChannels: ProductAvailabilityTemplateItem;
  productAvailabilityTemplateItemUpdate: ProductAvailabilityTemplateItem;
  productAvailabilityTemplateUpdate: ProductAvailabilityTemplate;
  productBarcodeMapCreate: ProductBarcodeMap;
  productBarcodeMapDelete: Scalars['Boolean']['output'];
  productBarcodeMapUpdate: ProductBarcodeMap;
  productBookmarkCreate: ProductBookmark;
  productBookmarkDelete: Scalars['Boolean']['output'];
  productBookmarkProductCreate: ProductBookmarkProduct;
  productBookmarkProductDelete: Scalars['Boolean']['output'];
  productBookmarkProductUpdate: ProductBookmarkProduct;
  productBookmarkUpdate: ProductBookmark;
  productBrandCreate: ProductBrand;
  productBrandDelete: Scalars['Boolean']['output'];
  productBrandUpdate: ProductBrand;
  productBundleComponentCreate: ProductBundleComponent;
  productBundleComponentDelete: ProductBundleComponent;
  productBundleComponentUpdate: ProductBundleComponent;
  productCategoryCreate: ProductCategory;
  productCategoryDelete: Scalars['Boolean']['output'];
  productCategorySalesChannelMapCreate: ProductCategorySalesChannelMap;
  productCategorySalesChannelMapDelete: Scalars['Boolean']['output'];
  productCategorySalesChannelMapExport: ProductCategorySalesChannelMapExportResult;
  productCategorySalesChannelMapImport: ProductCategorySalesChannelMapImportResult;
  productCategorySalesChannelMapImportValidate: ProductCategorySalesChannelMapImportValidateResult;
  productCategorySalesChannelMapUpdate: ProductCategorySalesChannelMap;
  productCategoryUpdate: ProductCategory;
  productConsignmentImport: ProductImportResult;
  productConsignmentImportValidate: ProductImportValidateResult;
  productCreate: Product;
  productDelete: Scalars['Boolean']['output'];
  productDepartmentCreate: ProductDepartment;
  productDepartmentDelete: Scalars['Boolean']['output'];
  productDepartmentUpdate: ProductDepartment;
  productDivisionCreate: ProductDivision;
  productDivisionDelete: Scalars['Boolean']['output'];
  productDivisionUpdate: ProductDivision;
  productFileCreate: ProductFile;
  productFileDelete: Scalars['Boolean']['output'];
  productFileUpdate: ProductFile;
  productNonConsignmentImport: ProductImportResult;
  productNonConsignmentImportValidate: ProductImportValidateResult;
  productSalesChannelItemMapCreate: ProductSalesChannelItemMap;
  productSalesChannelItemMapDelete: Scalars['Boolean']['output'];
  productSalesChannelItemMapUpdate: ProductSalesChannelItemMap;
  productSourceCreate: ProductSource;
  productSourceDelete: Scalars['Boolean']['output'];
  productSourceUpdate: ProductSource;
  productSubCategoryCreate: ProductSubCategory;
  productSubCategoryDelete: Scalars['Boolean']['output'];
  productSubCategoryUpdate: ProductSubCategory;
  productSubDepartmentCreate: ProductSubDepartment;
  productSubDepartmentDelete: Scalars['Boolean']['output'];
  productSubDepartmentUpdate: ProductSubDepartment;
  productTagCreate: ProductTag;
  productTagDelete: Scalars['Boolean']['output'];
  productTagProductCreate: ProductTagProduct;
  productTagProductDelete: Scalars['Boolean']['output'];
  productTagProductUpdate: ProductTagProduct;
  productTagUpdate: ProductTag;
  productUpdate: Product;
  productVendorCreate: ProductVendor;
  productVendorDelete: Scalars['Boolean']['output'];
  productVendorUpdate: ProductVendor;
  productionOrderCancel: ProductionOrder;
  productionOrderConfirm: ProductionOrder;
  productionOrderCreate: ProductionOrder;
  productionOrderUpdate: ProductionOrder;
  promoComponentImportValidate: PromoComponentImportValidateResult;
  promoCreate: Array<Promo>;
  promoDelete: Scalars['Boolean']['output'];
  /** Create a new promo quota config */
  promoQuotaCreate: PromoQuota;
  /** Delete promo quota config */
  promoQuotaDelete: Scalars['Boolean']['output'];
  /** Increment usage counter for a branch (creates usage record if not exists) */
  promoQuotaIncrementUsage: PromoQuotaBranchUsage;
  /** Reset usage counter for a branch */
  promoQuotaResetUsage: PromoQuotaBranchUsage;
  /** Update existing promo quota config */
  promoQuotaUpdate: PromoQuota;
  promoTypeCreate: PromoType;
  promoTypeDelete: Scalars['Boolean']['output'];
  promoTypeUpdate: PromoType;
  promoUpdate: Array<Promo>;
  provinceCreate: Province;
  provinceDelete: Scalars['Boolean']['output'];
  provinceUpdate: Province;
  purchaseAreaCreate: PurchaseArea;
  purchaseAreaDelete: Scalars['Boolean']['output'];
  purchaseAreaUpdate: PurchaseArea;
  purchaseOrderBackfillTotals: PurchaseOrderBackfillTotalsResult;
  purchaseOrderCancel: Scalars['Boolean']['output'];
  purchaseOrderClose: Scalars['Boolean']['output'];
  purchaseOrderConfirm: Scalars['Boolean']['output'];
  purchaseOrderCreate: PurchaseOrder;
  purchaseOrderForceClose: Scalars['Boolean']['output'];
  purchaseOrderImport: Scalars['UUID']['output'];
  purchaseOrderImportValidateCodes: PurchaseOrderImportValidateCodesResult;
  purchaseOrderReceivingCancel: Scalars['Boolean']['output'];
  purchaseOrderReceivingConfirm: PurchaseOrderReceiving;
  purchaseOrderReceivingCreate: PurchaseOrderReceiving;
  purchaseOrderReceivingUpdate: PurchaseOrderReceiving;
  purchaseOrderRevise: Scalars['Boolean']['output'];
  purchaseOrderSendEmail: Scalars['Boolean']['output'];
  purchaseOrderUpdate: PurchaseOrder;
  putawayTaskAcceptAndStart: MobilePutawayTask;
  putawayTaskAssign: PutawayTask;
  putawayTaskBatchExecutions: BatchExecutionResult;
  putawayTaskCancel: Scalars['Boolean']['output'];
  putawayTaskFinish: MobilePutawayTask;
  putawayTaskGenerateMultiple: Array<PutawayTask>;
  putawayTaskGenerateSingle: PutawayTask;
  putawayTaskRecordExecution: ExecutionResult;
  putawayTaskScanLocation: LocationValidationResult;
  putawayTaskScanProduct: ProductValidationResult;
  putawayTaskStart: MobilePutawayTask;
  putawayTaskUpdate: PutawayTask;
  reasonCreate: Reason;
  reasonDelete: Scalars['Boolean']['output'];
  reasonInventoryAdjustmentCreate: ReasonInventoryAdjustment;
  reasonInventoryAdjustmentDelete: Scalars['Boolean']['output'];
  reasonInventoryAdjustmentUpdate: ReasonInventoryAdjustment;
  reasonUpdate: Reason;
  recalculateAllConsignmentProformas: Scalars['Int']['output'];
  recalculateConsignmentProforma: VendorConsignmentInvoice;
  recomputeConsignmentDrafts: Scalars['Boolean']['output'];
  replenishmentCreate: Replenishment;
  replenishmentTemplateCategoryCreate: ReplenishmentTemplateCategory;
  replenishmentTemplateCategoryDelete: Scalars['Boolean']['output'];
  replenishmentTemplateCategoryUpdate: ReplenishmentTemplateCategory;
  replenishmentTemplateCreate: ReplenishmentTemplate;
  replenishmentTemplateDelete: Scalars['Boolean']['output'];
  replenishmentTemplateItemCreate: ReplenishmentTemplateItem;
  replenishmentTemplateItemDelete: Scalars['Boolean']['output'];
  replenishmentTemplateItemImport: ReplenishmentTemplateItemImportResult;
  replenishmentTemplateItemImportValidate: ReplenishmentTemplateItemImportValidateResult;
  replenishmentTemplateItemUpdate: ReplenishmentTemplateItem;
  replenishmentTemplateUpdate: ReplenishmentTemplate;
  resetPassword: Scalars['Boolean']['output'];
  resourceCreate: Resource;
  resourceDelete: Scalars['Boolean']['output'];
  resourceUpdate: Resource;
  revenueReportAccessLogExport: RevenueReportAccessLogExport;
  revenueReportApiKeyIssue: RevenueReportApiKeyIssued;
  revenueReportApiKeyRevoke: RevenueReportApiKey;
  revenueReportDetailCorrect: RevenueReportDetail;
  revenueReportDetailExport: RevenueReportDetailExport;
  revenueReportDetailVoid: RevenueReportDetail;
  revenueReportExport: RevenueReportExport;
  revenueReportGenerate: Array<RevenueReport>;
  revenueReportPartnerActivate: RevenueReportPartner;
  revenueReportPartnerBranchActivate: RevenueReportPartnerBranch;
  revenueReportPartnerBranchCreate: RevenueReportPartnerBranch;
  revenueReportPartnerBranchCredentialClear: RevenueReportPartnerBranch;
  revenueReportPartnerBranchCredentialSet: RevenueReportPartnerBranch;
  revenueReportPartnerBranchDeactivate: RevenueReportPartnerBranch;
  revenueReportPartnerBranchUpdate: RevenueReportPartnerBranch;
  revenueReportPartnerCreate: RevenueReportPartner;
  revenueReportPartnerCredentialSet: RevenueReportPartner;
  revenueReportPartnerDeactivate: RevenueReportPartner;
  revenueReportPartnerEndpointUpdate: RevenueReportPartner;
  revenueReportPartnerUpdate: RevenueReportPartner;
  revenueReportResend: RevenueReport;
  revenueReportResync: RevenueReport;
  revenueReportTemplateActivate: RevenueReportTemplate;
  revenueReportTemplateCreate: RevenueReportTemplate;
  revenueReportTemplateDeactivate: RevenueReportTemplate;
  revenueReportTemplateDelete: Scalars['Boolean']['output'];
  revenueReportTemplateDuplicate: RevenueReportTemplate;
  revenueReportTemplateFieldMapUpdate: RevenueReportTemplate;
  revenueReportTemplateUpdate: RevenueReportTemplate;
  revenueReportUserActivate: RevenueReportUser;
  revenueReportUserCreate: RevenueReportUser;
  revenueReportUserDeactivate: RevenueReportUser;
  revenueReportUserUpdate: RevenueReportUser;
  revenueSharingBranchCreate: RevenueSharingBranch;
  revenueSharingBranchDelete: Scalars['Boolean']['output'];
  revenueSharingBranchUpdate: RevenueSharingBranch;
  revenueSharingCorrectItem: Scalars['Boolean']['output'];
  revenueSharingExport: RevenueSharingExport;
  revenueSharingGenerate: Scalars['Boolean']['output'];
  revenueSharingReuploadDates: RevenueSharingReuploadResult;
  revenueSharingUpload: Scalars['Boolean']['output'];
  revenueSharingUploadAll: Scalars['Boolean']['output'];
  revenueSharingVoidItem: Scalars['Boolean']['output'];
  roleCreate: Roles;
  roleDelete: Scalars['Boolean']['output'];
  roleUpdate: Roles;
  salesChannelCampaignCancel: SalesChannelCampaign;
  salesChannelCampaignCreate: SalesChannelCampaign;
  salesChannelCampaignDelete: Scalars['Boolean']['output'];
  salesChannelCampaignPublish: SalesChannelCampaign;
  salesChannelCampaignPublishToStores: Array<SalesChannelCampaignPublishStoreResult>;
  salesChannelCampaignSetCategories: Array<SalesChannelCampaignCategory>;
  salesChannelCampaignSetChannels: Array<SalesChannelCampaignChannel>;
  salesChannelCampaignSetProducts: Array<SalesChannelCampaignProduct>;
  salesChannelCampaignStop: SalesChannelCampaign;
  salesChannelCampaignUpdate: SalesChannelCampaign;
  salesChannelCategoryCreate: SalesChannelCategory;
  salesChannelCategoryDelete: Scalars['Boolean']['output'];
  salesChannelCategoryGroupCreate: SalesChannelCategoryGroup;
  salesChannelCategoryGroupDelete: Scalars['Boolean']['output'];
  salesChannelCategoryGroupItemCreate: SalesChannelCategoryGroupItem;
  salesChannelCategoryGroupItemDelete: Scalars['Boolean']['output'];
  salesChannelCategoryGroupItemUpdate: SalesChannelCategoryGroupItem;
  salesChannelCategoryGroupProductCreate: SalesChannelCategoryGroupProduct;
  salesChannelCategoryGroupProductDelete: Scalars['Boolean']['output'];
  salesChannelCategoryGroupProductReorder: Scalars['Boolean']['output'];
  salesChannelCategoryGroupProductUpdate: SalesChannelCategoryGroupProduct;
  salesChannelCategoryGroupUpdate: SalesChannelCategoryGroup;
  salesChannelCategoryUpdate: SalesChannelCategory;
  salesChannelStockThresholdCreate: SalesChannelStockThreshold;
  salesChannelStockThresholdDelete: Scalars['Boolean']['output'];
  salesChannelStockThresholdUpdate: SalesChannelStockThreshold;
  salesInvoiceInventoryBackfill: SalesInvoiceInventoryBackfillResult;
  salesInvoiceReviewRefresh: SalesInvoiceReview;
  salesInvoiceReviewResolveBulk: Array<SalesInvoiceReviewResolveResult>;
  salesPaymentMethodCreate: SalesPaymentMethod;
  salesPaymentMethodDelete: Scalars['Boolean']['output'];
  salesPaymentMethodTypeCreate: SalesPaymentMethodType;
  salesPaymentMethodTypeDelete: Scalars['Boolean']['output'];
  salesPaymentMethodTypeUpdate: SalesPaymentMethodType;
  salesPaymentMethodUpdate: SalesPaymentMethod;
  sendConsignmentInvoiceEmail: VendorConsignmentInvoice;
  sendConsignmentInvoiceEmailsBulk: Array<BulkConsignmentEmailResult>;
  shiftSessionClose: ShiftSessionCloseResult;
  shiftSessionCreate: ShiftSession;
  shiftSessionDelete: Scalars['Boolean']['output'];
  shiftSessionRecompute: ShiftSession;
  shiftSessionResolveCashDiff: ShiftSession;
  simpleTransferOrderCancel: SimpleTransferOrder;
  simpleTransferOrderConfirm: SimpleTransferOrder;
  simpleTransferOrderCreate: SimpleTransferOrder;
  simpleTransferOrderDelete: Scalars['Boolean']['output'];
  simpleTransferOrderReceivingCancel: Scalars['Boolean']['output'];
  simpleTransferOrderReceivingConfirm: SimpleTransferOrderReceiving;
  simpleTransferOrderReceivingCreate: SimpleTransferOrderReceiving;
  simpleTransferOrderReceivingCreateAndConfirm: SimpleTransferOrderReceiving;
  simpleTransferOrderReceivingUpdate: SimpleTransferOrderReceiving;
  simpleTransferOrderReceivingUpdateAndConfirm: SimpleTransferOrderReceiving;
  simpleTransferOrderUpdate: SimpleTransferOrder;
  subdistrictCreate: Subdistrict;
  subdistrictDelete: Scalars['Boolean']['output'];
  subdistrictUpdate: Subdistrict;
  syncErpPurchaseOrderReceive: Scalars['Boolean']['output'];
  syncErpVendor: Scalars['Boolean']['output'];
  taxCreate: Tax;
  taxDelete: Scalars['Boolean']['output'];
  taxUpdate: Tax;
  transferOrderCancel: TransferOrder;
  transferOrderConfirm: TransferOrder;
  transferOrderCreate: TransferOrder;
  transferOrderDelete: Scalars['Boolean']['output'];
  transferOrderImport: Scalars['UUID']['output'];
  transferOrderImportValidateCodes: TransferOrderImportValidateCodesResult;
  transferOrderMarkAsDone: TransferOrder;
  transferOrderReceivingCancel: Scalars['Boolean']['output'];
  transferOrderReceivingConfirm: TransferOrderReceiving;
  transferOrderReceivingCreate: TransferOrderReceiving;
  transferOrderReceivingUpdate: TransferOrderReceiving;
  transferOrderUpdate: TransferOrder;
  transferRequestApprove: TransferRequest;
  transferRequestCancel: TransferRequest;
  transferRequestCreate: TransferRequest;
  transferRequestImport: Scalars['UUID']['output'];
  transferRequestImportValidateCodes: TransferRequestImportValidateCodesResult;
  transferRequestReject: TransferRequest;
  transferRequestSubmit: TransferRequest;
  transferRequestUpdate: TransferRequest;
  triggerProductImageEmbeddingRun: IngestionRunInfo;
  uomCategoryCreate: UomCategory;
  uomCategoryDelete: Scalars['Boolean']['output'];
  uomCategoryUpdate: UomCategory;
  uomCreate: Uom;
  uomDelete: Scalars['Boolean']['output'];
  uomUpdate: Uom;
  updateErpProduct: Scalars['Boolean']['output'];
  uploadTemplateCreate: UploadTemplate;
  uploadTemplateDelete: Scalars['Boolean']['output'];
  uploadTemplateUpdate: UploadTemplate;
  userCreate: User;
  userDelete: Scalars['Boolean']['output'];
  userRegeneratePIN: Scalars['String']['output'];
  userRegeneratePINSelf: Scalars['String']['output'];
  userUpdate: User;
  validateBeforeICFinish: Array<ValidateBeforeIcFinishRow>;
  validateBeforeICFinishConfirm: Scalars['Boolean']['output'];
  validateSupervisorPin: SupervisorPinValidationResult;
  vendorCategoryCreate: VendorCategory;
  vendorCategoryDelete: Scalars['Boolean']['output'];
  vendorCategoryUpdate: VendorCategory;
  vendorConsignmentBranchBulkDelete: VendorConsignmentBranchBulkDeleteResult;
  vendorConsignmentBranchCreate: VendorConsignmentBranch;
  vendorConsignmentBranchDelete: Scalars['Boolean']['output'];
  vendorConsignmentBranchPeriodGrant: VendorConsignmentBranchPeriod;
  vendorConsignmentBranchPeriodResume: VendorConsignmentBranchPeriod;
  vendorConsignmentBranchPeriodRevoke: VendorConsignmentBranchPeriod;
  vendorConsignmentBranchPeriodSuspend: VendorConsignmentBranchPeriod;
  vendorConsignmentBranchUpdate: VendorConsignmentBranch;
  vendorConsignmentInvoiceConfigCreate: VendorConsignmentInvoiceConfig;
  vendorConsignmentInvoiceConfigImport: VendorConsignmentInvoiceConfigImportResult;
  vendorConsignmentInvoiceConfigImportValidate: VendorConsignmentInvoiceConfigImportValidateResult;
  vendorConsignmentInvoiceConfigUpdate: VendorConsignmentInvoiceConfig;
  vendorConsignmentProductCreate: VendorConsignmentProduct;
  vendorConsignmentProductDelete: Scalars['Boolean']['output'];
  vendorConsignmentProductPriceBulkUpdate: VendorConsignmentProductBulkUpdateResult;
  vendorConsignmentProductUpdate: VendorConsignmentProduct;
  vendorConsignmentRentalPaymentApprove: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentCancel: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentCreate: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentReject: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentSubmit: VendorConsignmentRentalPayment;
  vendorConsignmentRentalPaymentUpdate: VendorConsignmentRentalPayment;
  vendorCreate: Vendor;
  vendorCreateAccess: Vendor;
  vendorDelete: Scalars['Boolean']['output'];
  vendorPicContactCreate: VendorPicContact;
  vendorPicContactDelete: Scalars['Boolean']['output'];
  vendorPicContactUpdate: VendorPicContact;
  vendorSetPortalAccessActive: Vendor;
  vendorUpdate: Vendor;
  vendorUpdateAccess: Vendor;
  villageCreate: Village;
  villageDelete: Scalars['Boolean']['output'];
  villageUpdate: Village;
  voucherCategoryCreate: VoucherCategory;
  voucherCategoryDelete: Scalars['Boolean']['output'];
  voucherCategoryUpdate: VoucherCategory;
  voucherCreate: Voucher;
  voucherDelete: Scalars['Boolean']['output'];
  voucherItemGenerate: Array<VoucherItem>;
  voucherItemImport: Array<VoucherItem>;
  voucherItemVoid: VoucherItem;
  voucherRecountItems: Voucher;
  voucherUpdate: Voucher;
  warehouseCreate: Warehouse;
  warehouseDelete: Scalars['Boolean']['output'];
  warehouseLocationCreate: WarehouseLocation;
  warehouseLocationCreateBulk: Array<WarehouseLocation>;
  warehouseLocationDelete: Scalars['Boolean']['output'];
  warehouseLocationGroupCreate: WarehouseLocationGroup;
  warehouseLocationGroupDelete: Scalars['Boolean']['output'];
  warehouseLocationGroupUpdate: WarehouseLocationGroup;
  warehouseLocationRelationMapCreate: WarehouseLocationRelationMap;
  warehouseLocationRelationMapDelete: Scalars['Boolean']['output'];
  warehouseLocationRelationMapUpdate: WarehouseLocationRelationMap;
  warehouseLocationUpdate: WarehouseLocation;
  warehouseProductLocationMapCreate: WarehouseProductLocationMap;
  warehouseProductLocationMapDelete: Scalars['Boolean']['output'];
  warehouseProductLocationMapUpdate: WarehouseProductLocationMap;
  warehouseReplenishmentTemplateCreate: WarehouseReplenishmentTemplate;
  warehouseReplenishmentTemplateCreateBulk: Array<WarehouseReplenishmentTemplate>;
  warehouseReplenishmentTemplateDelete: Scalars['Boolean']['output'];
  warehouseUpdate: Warehouse;
};


export type MutationSalesChannelCreateArgs = {
  input: SalesChannelCreateInput;
};


export type MutationSalesChannelDeleteArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type MutationSalesChannelUpdateArgs = {
  input: SalesChannelUpdateInput;
};


export type MutationAdminResetPasswordArgs = {
  input: AdminResetPasswordInput;
};


export type MutationAiChatCreateSessionArgs = {
  input?: InputMaybe<AiChatCreateSessionInput>;
};


export type MutationAiChatDeleteSessionArgs = {
  sessionID: Scalars['String']['input'];
};


export type MutationAiChatRenameSessionArgs = {
  input: AiChatRenameSessionInput;
};


export type MutationAiChatSendMessageArgs = {
  input: AiChatSendMessageInput;
};


export type MutationAiDeleteAppClientArgs = {
  appId: Scalars['String']['input'];
};


export type MutationAiRegenerateAppClientKeyArgs = {
  appId: Scalars['String']['input'];
};


export type MutationAiUpdateGuardrailsConfigArgs = {
  input: AiUpdateGuardrailsInput;
};


export type MutationAiUpdateScopeTableArgs = {
  input: AiUpdateScopeTableInput;
};


export type MutationAiUpdateScopeToolArgs = {
  input: AiUpdateScopeToolInput;
};


export type MutationAiUpsertAppClientArgs = {
  input: AiUpsertAppClientInput;
};


export type MutationAppCreateArgs = {
  input: AppCreateInput;
};


export type MutationAppDeleteArgs = {
  appID: Scalars['String']['input'];
};


export type MutationAppUpdateArgs = {
  input: AppUpdateInput;
};


export type MutationAuthLoginArgs = {
  input: LoginInput;
};


export type MutationAuthLoginVendorArgs = {
  input: LoginInput;
};


export type MutationAuthRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationAuthSetDefaultBranchArgs = {
  input: SetDefaultBranchInput;
};


export type MutationBackgroundJobCreateArgs = {
  input: BackgroundJobCreateInput;
};


export type MutationBackgroundJobDeleteArgs = {
  backgroundJobID: Scalars['UUID']['input'];
};


export type MutationBackgroundJobUpdateArgs = {
  input: BackgroundJobUpdateInput;
};


export type MutationBankAccountCreateArgs = {
  input: BankAccountCreateInput;
};


export type MutationBankAccountDeleteArgs = {
  bankAccountID: Scalars['UUID']['input'];
};


export type MutationBankAccountUpdateArgs = {
  input: BankAccountUpdateInput;
};


export type MutationBankCreateArgs = {
  input: BankCreateInput;
};


export type MutationBankDeleteArgs = {
  bankID: Scalars['UUID']['input'];
};


export type MutationBankReconciliationCancelArgs = {
  input: BankReconciliationCancelInput;
};


export type MutationBankReconciliationCreateArgs = {
  input: BankReconciliationCreateInput;
};


export type MutationBankReconciliationExportArgs = {
  input: BankReconciliationExportInput;
};


export type MutationBankReconciliationFinalizeArgs = {
  input: BankReconciliationFinalizeInput;
};


export type MutationBankReconciliationImportValidateArgs = {
  input: BankReconciliationImportValidateInput;
};


export type MutationBankReconciliationItemManualMatchArgs = {
  input: BankReconciliationItemManualMatchInput;
};


export type MutationBankReconciliationItemMergeArgs = {
  input: BankReconciliationItemMergeInput;
};


export type MutationBankReconciliationItemResolveArgs = {
  input: BankReconciliationItemResolveInput;
};


export type MutationBankReconciliationItemsBulkResolveArgs = {
  input: BankReconciliationItemsBulkResolveInput;
};


export type MutationBankReconciliationItemsBulkResolveByFilterArgs = {
  input: BankReconciliationItemsBulkResolveByFilterInput;
};


export type MutationBankReconciliationProcessArgs = {
  input: BankReconciliationProcessInput;
};


export type MutationBankReconciliationRemoveFileArgs = {
  input: BankReconciliationRemoveFileInput;
};


export type MutationBankReconciliationRetryPoolFileArgs = {
  bankReconciliationFileID: Scalars['UUID']['input'];
};


export type MutationBankReconciliationUploadFileArgs = {
  input: BankReconciliationUploadFileInput;
};


export type MutationBankReconciliationUploadPoolFileArgs = {
  input: BankReconciliationUploadPoolFileInput;
};


export type MutationBankUpdateArgs = {
  input: BankUpdateInput;
};


export type MutationBiKnowledgeCreateArgs = {
  input: BiKnowledgeCreateInput;
};


export type MutationBiKnowledgeDeleteArgs = {
  biKnowledgeID: Scalars['UUID']['input'];
};


export type MutationBiKnowledgeUpdateArgs = {
  input: BiKnowledgeUpdateInput;
};


export type MutationBiRoleCreateArgs = {
  input: BiRoleCreateInput;
};


export type MutationBiRoleDeleteArgs = {
  role: Scalars['String']['input'];
};


export type MutationBiRoleUpdateArgs = {
  input: BiRoleUpdateInput;
};


export type MutationBiScopeTableBulkUpdateArgs = {
  input: BiScopeTableBulkUpdateInput;
};


export type MutationBiScopeTableCreateArgs = {
  input: BiScopeTableCreateInput;
};


export type MutationBiScopeTableDeleteArgs = {
  tableName: Scalars['String']['input'];
};


export type MutationBiScopeTableUpdateArgs = {
  input: BiScopeTableUpdateInput;
};


export type MutationBiUserCreateArgs = {
  input: BiUserCreateInput;
};


export type MutationBiUserDeleteArgs = {
  biUserID: Scalars['UUID']['input'];
};


export type MutationBiUserUpdateArgs = {
  input: BiUserUpdateInput;
};


export type MutationBillOfMaterialComponentCreateArgs = {
  input: BillOfMaterialComponentCreateInput;
};


export type MutationBillOfMaterialComponentDeleteArgs = {
  billOfMaterialComponentID: Scalars['UUID']['input'];
};


export type MutationBillOfMaterialComponentUpdateArgs = {
  input: BillOfMaterialComponentUpdateInput;
};


export type MutationBillOfMaterialCreateArgs = {
  input: BillOfMaterialCreateInput;
};


export type MutationBillOfMaterialDeleteArgs = {
  billOfMaterialID: Scalars['UUID']['input'];
};


export type MutationBillOfMaterialUpdateArgs = {
  input: BillOfMaterialUpdateInput;
};


export type MutationBranchBankAccountCreateArgs = {
  input: BranchBankAccountCreateInput;
};


export type MutationBranchBankAccountDeleteArgs = {
  branchBankAccountID: Scalars['UUID']['input'];
};


export type MutationBranchBankAccountUpdateArgs = {
  input: BranchBankAccountUpdateInput;
};


export type MutationBranchCategoryCreateArgs = {
  input: BranchCategoryCreateInput;
};


export type MutationBranchCategoryDeleteArgs = {
  branchCategoryID: Scalars['UUID']['input'];
};


export type MutationBranchCategoryUpdateArgs = {
  input: BranchCategoryUpdateInput;
};


export type MutationBranchCreateArgs = {
  input: BranchCreateInput;
};


export type MutationBranchDeleteArgs = {
  branchID: Scalars['UUID']['input'];
};


export type MutationBranchPosBookmarkCreateArgs = {
  input: BranchPosBookmarkCreateInput;
};


export type MutationBranchPosBookmarkDeleteArgs = {
  branchPosBookmarkID: Scalars['UUID']['input'];
};


export type MutationBranchPosBookmarkUpdateArgs = {
  input: BranchPosBookmarkUpdateInput;
};


export type MutationBranchProductSalesChannelItemDisableArgs = {
  input: BranchProductSalesChannelItemDisableInput;
};


export type MutationBranchProductSalesChannelItemRestoreArgs = {
  input: BranchProductSalesChannelItemRestoreInput;
};


export type MutationBranchQrisMerchantCreateArgs = {
  input: BranchQrisMerchantCreateInput;
};


export type MutationBranchQrisMerchantDeleteArgs = {
  branchQrisMerchantID: Scalars['UUID']['input'];
};


export type MutationBranchQrisMerchantUpdateArgs = {
  input: BranchQrisMerchantUpdateInput;
};


export type MutationBranchSalesChannelCategoryGroupCreateArgs = {
  input: BranchSalesChannelCategoryGroupCreateInput;
};


export type MutationBranchSalesChannelCategoryGroupDeleteArgs = {
  branchSalesChannelCategoryGroupID: Scalars['UUID']['input'];
};


export type MutationBranchSalesChannelCategoryGroupUpdateArgs = {
  input: BranchSalesChannelCategoryGroupUpdateInput;
};


export type MutationBranchSalesChannelMerchantMapCreateArgs = {
  input: BranchSalesChannelMerchantMapCreateInput;
};


export type MutationBranchSalesChannelMerchantMapDeleteArgs = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
};


export type MutationBranchSalesChannelMerchantMapUpdateArgs = {
  input: BranchSalesChannelMerchantMapUpdateInput;
};


export type MutationBranchSalesChannelOperatingHoursUpdateArgs = {
  input: BranchSalesChannelOperatingHoursUpdateInput;
};


export type MutationBranchSalesChannelPackagingUpdateArgs = {
  input: BranchSalesChannelPackagingUpdateInput;
};


export type MutationBranchSalesChannelPauseUpdateArgs = {
  input: BranchSalesChannelPauseUpdateInput;
};


export type MutationBranchSalesPaymentMethodCreateArgs = {
  input: BranchSalesPaymentMethodCreateInput;
};


export type MutationBranchSalesPaymentMethodDeleteArgs = {
  branchSalesPaymentMethodID: Scalars['UUID']['input'];
};


export type MutationBranchSalesPaymentMethodUpdateArgs = {
  input: BranchSalesPaymentMethodUpdateInput;
};


export type MutationBranchStoreSupervisorCreateArgs = {
  input: BranchStoreSupervisorCreateInput;
};


export type MutationBranchStoreSupervisorDeleteArgs = {
  branchStoreSupervisorID: Scalars['UUID']['input'];
};


export type MutationBranchStoreSupervisorSyncArgs = {
  branchID: Scalars['UUID']['input'];
  supervisors: Array<BranchStoreSupervisorInput>;
};


export type MutationBranchStoreSupervisorUpdateArgs = {
  input: BranchStoreSupervisorUpdateInput;
};


export type MutationBranchUpdateArgs = {
  input: BranchUpdateInput;
};


export type MutationCancelConsignmentInvoiceArgs = {
  input: VendorConsignmentInvoiceCancelInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCityCreateArgs = {
  input: CityCreateInput;
};


export type MutationCityDeleteArgs = {
  cityID: Scalars['String']['input'];
};


export type MutationCityUpdateArgs = {
  input: CityUpdateInput;
};


export type MutationConsignmentStockInCancelArgs = {
  consignmentStockInID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockInConfirmArgs = {
  consignmentStockInID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockInCreateArgs = {
  input: ConsignmentStockInCreateInput;
};


export type MutationConsignmentStockInRequestApproveArgs = {
  input: ConsignmentStockInRequestApproveInput;
};


export type MutationConsignmentStockInRequestCancelArgs = {
  input: ConsignmentStockInRequestCancelInput;
};


export type MutationConsignmentStockInRequestCreateArgs = {
  input: ConsignmentStockInRequestCreateInput;
};


export type MutationConsignmentStockInRequestRejectArgs = {
  input: ConsignmentStockInRequestRejectInput;
};


export type MutationConsignmentStockInRequestSubmitArgs = {
  input: ConsignmentStockInRequestSubmitInput;
};


export type MutationConsignmentStockInRequestUpdateArgs = {
  input: ConsignmentStockInRequestUpdateInput;
};


export type MutationConsignmentStockInUpdateArgs = {
  input: ConsignmentStockInUpdateInput;
};


export type MutationConsignmentStockOutCancelArgs = {
  consignmentStockOutID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockOutConfirmArgs = {
  consignmentStockOutID: Scalars['UUID']['input'];
};


export type MutationConsignmentStockOutCreateArgs = {
  input: ConsignmentStockOutCreateInput;
};


export type MutationConsignmentStockOutUpdateArgs = {
  input: ConsignmentStockOutUpdateInput;
};


export type MutationCostAdjustmentImportArgs = {
  input: CostAdjustmentImportInput;
};


export type MutationCostAdjustmentImportValidateCodesArgs = {
  input: CostAdjustmentImportValidateCodesInput;
};


export type MutationCountryCreateArgs = {
  input: CountryCreateInput;
};


export type MutationCountryDeleteArgs = {
  countryID: Scalars['String']['input'];
};


export type MutationCountryUpdateArgs = {
  input: CountryUpdateInput;
};


export type MutationCreateErpProductArgs = {
  input: CreateErpProductInput;
};


export type MutationCreateManualConsignmentProformaArgs = {
  input: CreateManualConsignmentProformaInput;
};


export type MutationCustomerAddressCreateArgs = {
  input: CustomerAddressCreateInput;
};


export type MutationCustomerAddressDeleteArgs = {
  input: CustomerAddressDeleteInput;
};


export type MutationCustomerAddressUpdateArgs = {
  input: CustomerAddressUpdateInput;
};


export type MutationCustomerCreateArgs = {
  input: CustomerCreateInput;
};


export type MutationCustomerCreateFromPosArgs = {
  input: CustomerCreateFromPosInput;
};


export type MutationCustomerDeleteArgs = {
  customerID: Scalars['UUID']['input'];
};


export type MutationCustomerImportArgs = {
  input: Array<CustomerImportInput>;
};


export type MutationCustomerSetDefaultArgs = {
  input: CustomerSetDefaultInput;
};


export type MutationCustomerUpdateArgs = {
  input: CustomerUpdateInput;
};


export type MutationCustomerVoucherTransactionBackfillArgs = {
  input: CustomerVoucherTransactionBackfillInput;
};


export type MutationDeliveryOrderBatchAddLeftoverContainersArgs = {
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type MutationDeliveryOrderBatchCancelArgs = {
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type MutationDeliveryOrderBatchCreateArgs = {
  input: DeliveryOrderBatchCreateInput;
};


export type MutationDeliveryOrderBatchDetachSourceDocumentArgs = {
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
};


export type MutationDeliveryOrderBatchGenerateArgs = {
  input: DeliveryOrderBatchGenerateInput;
};


export type MutationDeliveryOrderBatchGenerateAndShipArgs = {
  input: DeliveryOrderBatchGenerateInput;
};


export type MutationDeliveryOrderBatchRegenerateFailedArgs = {
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type MutationDeliveryOrderBatchRemoveContainerArgs = {
  deliveryOrderBatchContainerID: Scalars['UUID']['input'];
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type MutationDeliveryOrderBatchScanArgs = {
  input: DeliveryOrderBatchScanInput;
};


export type MutationDeliveryOrderCancelArgs = {
  input: DeliveryOrderCancelInput;
};


export type MutationDeliveryOrderCheckGenerateBulkArgs = {
  input: DeliveryOrderGenerateBulkInput;
};


export type MutationDeliveryOrderContainerRemoveArgs = {
  input: DeliveryOrderContainerRemoveInput;
};


export type MutationDeliveryOrderCreateArgs = {
  input: DeliveryOrderCreateInput;
};


export type MutationDeliveryOrderGenerateBulkArgs = {
  input: DeliveryOrderGenerateBulkInput;
};


export type MutationDeliveryOrderShippedArgs = {
  input: DeliveryOrderShippedInput;
};


export type MutationDeliveryOrderUpdateArgs = {
  input: DeliveryOrderUpdateInput;
};


export type MutationEdcTerminalCreateArgs = {
  input: EdcTerminalCreateInput;
};


export type MutationEdcTerminalDeleteArgs = {
  edcTerminalID: Scalars['UUID']['input'];
};


export type MutationEdcTerminalUpdateArgs = {
  input: EdcTerminalUpdateInput;
};


export type MutationEditConsignmentSettlementArgs = {
  input: EditConsignmentSettlementInput;
};


export type MutationEmployeeCreateArgs = {
  input: EmployeeCreateInput;
};


export type MutationEmployeeDeleteArgs = {
  employeeID: Scalars['UUID']['input'];
};


export type MutationEmployeeUpdateArgs = {
  input: EmployeeUpdateInput;
};


export type MutationErpSyncMasterdataByIdsArgs = {
  entityType: MasterdataSyncEntityType;
  ids: Array<Scalars['String']['input']>;
};


export type MutationErpSyncTransactionByIdsArgs = {
  entityType: TransactionSyncEntityType;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  salesInvoices?: InputMaybe<Array<SalesInvoiceBranchDateInput>>;
};


export type MutationExpenseItemCreateArgs = {
  input: ExpenseItemCreateInput;
};


export type MutationExpenseItemDeleteArgs = {
  expenseItemID: Scalars['UUID']['input'];
};


export type MutationExpenseItemUpdateArgs = {
  input: ExpenseItemUpdateInput;
};


export type MutationFileCreateFromStorageObjectArgs = {
  input: FileCreateFromStorageObjectInput;
};


export type MutationGenerateConsignmentInvoiceArgs = {
  input: GenerateConsignmentInvoiceInput;
};


export type MutationGenerateConsignmentInvoicesBulkArgs = {
  payoutBanks?: InputMaybe<Array<ConsignmentPayoutBankInput>>;
  vendorConsignmentInvoiceIDs: Array<Scalars['UUID']['input']>;
};


export type MutationGenerateLinkResetPasswordArgs = {
  input: GenerateLinkResetPasswordInput;
};


export type MutationGenerateOtpCodeArgs = {
  input: GenerateOtpCodeInput;
};


export type MutationGenerateTransferRequestFromReplenishmentArgs = {
  input: GenerateTransferRequestFromReplenishmentInput;
};


export type MutationInternalTransferCancelArgs = {
  input: InternalTransferCancelInput;
};


export type MutationInternalTransferConfirmArgs = {
  input: InternalTransferConfirmInput;
};


export type MutationInternalTransferCreateArgs = {
  input: InternalTransferCreateInput;
};


export type MutationInternalTransferUpdateArgs = {
  input: InternalTransferUpdateInput;
};


export type MutationInventoryAdjustmentCancelArgs = {
  input: InventoryAdjustmentCancelInput;
};


export type MutationInventoryAdjustmentConfirmArgs = {
  input: InventoryAdjustmentConfirmInput;
};


export type MutationInventoryAdjustmentCreateArgs = {
  input: InventoryAdjustmentCreateInput;
};


export type MutationInventoryAdjustmentCreateOpeningBalanceArgs = {
  input: InventoryAdjustmentCreateOpeningBalanceInput;
};


export type MutationInventoryAdjustmentCreateSystemArgs = {
  input: InventoryAdjustmentCreateSystemInput;
};


export type MutationInventoryAdjustmentDeleteArgs = {
  inventoryAdjustmentID: Scalars['UUID']['input'];
};


export type MutationInventoryAdjustmentOpeningBalanceImportArgs = {
  input: InventoryAdjustmentOpeningBalanceImportInput;
};


export type MutationInventoryAdjustmentOpeningBalanceImportValidateCodesArgs = {
  input: InventoryAdjustmentOpeningBalanceImportValidateCodesInput;
};


export type MutationInventoryAdjustmentRetryFromBackgroundJobArgs = {
  backgroundJobID: Scalars['UUID']['input'];
};


export type MutationInventoryAdjustmentUpdateArgs = {
  input: InventoryAdjustmentUpdateInput;
};


export type MutationInventoryCountItemTemplateCreateArgs = {
  input: InventoryCountItemTemplateCreateInput;
};


export type MutationInventoryCountItemTemplateDeleteArgs = {
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
};


export type MutationInventoryCountItemTemplateItemCreateArgs = {
  input: InventoryCountItemTemplateItemCreateInput;
};


export type MutationInventoryCountItemTemplateItemDeleteArgs = {
  inventoryCountItemTemplateItemID: Scalars['UUID']['input'];
};


export type MutationInventoryCountItemTemplateItemImportArgs = {
  input: InventoryCountItemTemplateItemImportInput;
};


export type MutationInventoryCountItemTemplateItemImportValidateArgs = {
  input: InventoryCountItemTemplateItemImportValidateInput;
};


export type MutationInventoryCountItemTemplateUpdateArgs = {
  input: InventoryCountItemTemplateUpdateInput;
};


export type MutationInventoryCountTaskAssignedFinishArgs = {
  input: InventoryCountTaskAssignedFinishInput;
};


export type MutationInventoryCountTaskAssigneeAddArgs = {
  input: InventoryCountTaskAssigneeAddInput;
};


export type MutationInventoryCountTaskAssigneeDeleteArgs = {
  input: InventoryCountTaskAssigneeDeleteInput;
};


export type MutationInventoryCountTaskCancelArgs = {
  input: InventoryCountTaskCancelInput;
};


export type MutationInventoryCountTaskExecuteImportArgs = {
  input: InventoryCountTaskExecuteImportInput;
};


export type MutationInventoryCountTaskExecutionDetailDeleteArgs = {
  input: InventoryCountTaskExecutionDetailDeleteInput;
};


export type MutationInventoryCountTaskExportImportTemplateArgs = {
  input: InventoryCountTaskExportInput;
};


export type MutationInventoryCountTaskExportRecountItemsArgs = {
  input: InventoryCountTaskExportInput;
};


export type MutationInventoryCountTaskFinishArgs = {
  input: InventoryCountTaskFinishInput;
};


export type MutationInventoryCountTaskItemExecuteArgs = {
  input: InventoryCountTaskItemExecuteInput;
};


export type MutationInventoryCountTaskItemResetExecutedArgs = {
  input: InventoryCountTaskItemResetExecutedInput;
};


export type MutationInventoryCountTaskRecountCreateArgs = {
  input: InventoryCountTaskRecountCreateInput;
};


export type MutationInventoryCountTaskStartArgs = {
  input: InventoryCountTaskStartInput;
};


export type MutationInventoryCountTaskUpdateArgs = {
  input: InventoryCountTaskUpdateInput;
};


export type MutationInventoryCountTransactionCancelArgs = {
  input: InventoryCountTransactionCancelInput;
};


export type MutationInventoryCountTransactionCreateArgs = {
  input: InventoryCountTransactionCreateInput;
};


export type MutationInventoryCountTransactionExportResultsArgs = {
  input: InventoryCountTransactionExportInput;
};


export type MutationInventoryCountTransactionExportResultsByLocationArgs = {
  input: InventoryCountTransactionExportInput;
};


export type MutationInventoryCountTransactionFinishArgs = {
  input: InventoryCountTransactionFinishInput;
};


export type MutationInventoryCountTransactionUpdateArgs = {
  input: InventoryCountTransactionUpdateInput;
};


export type MutationLockConsignmentDraftToProformaArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type MutationMarkConsignmentInvoicePaidArgs = {
  input: VendorConsignmentInvoicePayInput;
};


export type MutationMarkConsignmentInvoicesPaidBulkArgs = {
  input: MarkConsignmentInvoicesPaidBulkInput;
};


export type MutationMarketplaceCampaignAddItemArgs = {
  externalItemID: Scalars['String']['input'];
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignCreateArgs = {
  input: MarketplaceCampaignCreateInput;
};


export type MutationMarketplaceCampaignDeleteArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignDuplicateArgs = {
  endAtUtc?: InputMaybe<Scalars['Time']['input']>;
  marketplaceCampaignID: Scalars['UUID']['input'];
  startAtUtc?: InputMaybe<Scalars['Time']['input']>;
};


export type MutationMarketplaceCampaignExtendArgs = {
  input: MarketplaceCampaignExtendInput;
};


export type MutationMarketplaceCampaignImportProductsArgs = {
  input: MarketplaceCampaignImportProductsInput;
};


export type MutationMarketplaceCampaignPublishFromPromoArgs = {
  input: MarketplaceCampaignPublishFromPromoInput;
};


export type MutationMarketplaceCampaignPushArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignRemoveItemArgs = {
  externalItemID: Scalars['String']['input'];
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignResumeArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignStopArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type MutationMarketplaceCampaignSyncArgs = {
  input?: InputMaybe<MarketplaceCampaignSyncInput>;
};


export type MutationMarketplaceCampaignUpdateArgs = {
  input: MarketplaceCampaignUpdateInput;
};


export type MutationMarketplaceCronRunArgs = {
  jobKey: Scalars['String']['input'];
};


export type MutationMarketplaceCronSettingUpdateArgs = {
  input: MarketplaceCronSettingUpdateInput;
};


export type MutationMarketplaceMenuSyncArgs = {
  input: MarketplaceMenuSyncInput;
};


export type MutationMarketplaceOrderCancelArgs = {
  input: MarketplaceOrderCancelInput;
};


export type MutationMarketplaceOrderEditArgs = {
  input: MarketplaceOrderEditInput;
};


export type MutationMarketplaceOrderMarkReadyArgs = {
  input: MarketplaceOrderMarkReadyInput;
};


export type MutationMarketplaceOrderReconcilePaymentArgs = {
  input: MarketplaceOrderReconcilePaymentInput;
};


export type MutationMarketplaceOrderSyncPosArgs = {
  input: MarketplaceOrderSyncPosInput;
};


export type MutationMarketplaceStorePauseArgs = {
  input: MarketplaceStorePauseInput;
};


export type MutationMemberTypeCreateArgs = {
  input: MemberTypeCreateInput;
};


export type MutationMemberTypeDeleteArgs = {
  memberTypeID: Scalars['UUID']['input'];
};


export type MutationMemberTypeUpdateArgs = {
  input: MemberTypeUpdateInput;
};


export type MutationMoveConsignmentItemsArgs = {
  input: MoveConsignmentItemsInput;
};


export type MutationOutboundContainerBulkGenerationArgs = {
  input: BulkContainerGenerationInput;
};


export type MutationOutboundContainerCreateArgs = {
  input: OutboundContainerCreateInput;
};


export type MutationOutboundContainerDeleteArgs = {
  input: RemoveContainerInput;
};


export type MutationOutboundContainerOpenSealArgs = {
  input: OpenSealContainerInput;
};


export type MutationOutboundContainerPackItemArgs = {
  input: OutboundContainerPackItemInput;
};


export type MutationOutboundContainerUnpackItemArgs = {
  input: OutboundContainerUnpackItemInput;
};


export type MutationOutboundContainerUpdatePackItemArgs = {
  input: OutboundContainerUpdatePackItemInput;
};


export type MutationPackingTaskCancelArgs = {
  input: PackingTaskCancelInput;
};


export type MutationPackingTaskFinishArgs = {
  input: PackingTaskFinishInput;
};


export type MutationPackingTaskStartArgs = {
  input: PackingTaskStartInput;
};


export type MutationPackingTaskVerifyArgs = {
  input: PackingTaskVerifyInput;
};


export type MutationPaymentProviderConfigUpdateArgs = {
  input: PaymentProviderConfigUpdateInput;
};


export type MutationPaymentTransactionCancelArgs = {
  input: PaymentTransactionCancelInput;
};


export type MutationPaymentTransactionCheckStatusArgs = {
  paymentTransactionID: Scalars['UUID']['input'];
};


export type MutationPaymentTransactionCreateDynamicQrisArgs = {
  input: PaymentTransactionCreateDynamicQrisInput;
};


export type MutationPermissionCreateArgs = {
  input: PermissionCreateInput;
};


export type MutationPermissionDeleteArgs = {
  permissionID: Scalars['String']['input'];
};


export type MutationPermissionUpdateArgs = {
  input: PermissionUpdateInput;
};


export type MutationPettyCashAddFundTransactionCancelArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashAddFundTransactionConfirmArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashAddFundTransactionCreateArgs = {
  input: PettyCashAddFundTransactionCreateInput;
};


export type MutationPettyCashAddFundTransactionDeleteArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashAddFundTransactionUpdateArgs = {
  input: PettyCashAddFundTransactionUpdateInput;
};


export type MutationPettyCashExpenseTransactionCancelArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashExpenseTransactionConfirmArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashExpenseTransactionCreateArgs = {
  input: PettyCashExpenseTransactionCreateInput;
};


export type MutationPettyCashExpenseTransactionDeleteArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashExpenseTransactionUpdateArgs = {
  input: PettyCashExpenseTransactionUpdateInput;
};


export type MutationPettyCashRefundTransactionCancelArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashRefundTransactionConfirmArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashRefundTransactionCreateArgs = {
  input: PettyCashRefundTransactionCreateInput;
};


export type MutationPettyCashRefundTransactionDeleteArgs = {
  input: PettyCashTransactionActionInput;
};


export type MutationPettyCashRefundTransactionUpdateArgs = {
  input: PettyCashRefundTransactionUpdateInput;
};


export type MutationPickingTaskAcceptAndStartArgs = {
  input: PickingTaskStartInput;
};


export type MutationPickingTaskAssignArgs = {
  input: PickingTaskAssignInput;
};


export type MutationPickingTaskCancelArgs = {
  input: PickingTaskCancelInput;
};


export type MutationPickingTaskExecuteArgs = {
  input: PickingTaskExecuteInput;
};


export type MutationPickingTaskFinishArgs = {
  input: PickingTaskFinishInput;
};


export type MutationPickingTaskGenerateArgs = {
  input: PickingTaskGenerateInput;
};


export type MutationPickingTaskGenerateBulkArgs = {
  input: PickingTaskGenerateBulkInput;
};


export type MutationPickingTaskStartArgs = {
  input: PickingTaskStartInput;
};


export type MutationPickingTaskUpdateUnfulfilledReasonsArgs = {
  input: PickingTaskUpdateUnfulfilledReasonsInput;
};


export type MutationPosBookmarkCreateArgs = {
  input: PosBookmarkCreateInput;
};


export type MutationPosBookmarkDeleteArgs = {
  posBookmarkID: Scalars['UUID']['input'];
};


export type MutationPosBookmarkProductCreateArgs = {
  input: PosBookmarkProductCreateInput;
};


export type MutationPosBookmarkProductDeleteArgs = {
  posBookmarkProductID: Scalars['UUID']['input'];
};


export type MutationPosBookmarkProductUpdateArgs = {
  input: PosBookmarkProductUpdateInput;
};


export type MutationPosBookmarkUpdateArgs = {
  input: PosBookmarkUpdateInput;
};


export type MutationPosSalesOrderCreateArgs = {
  input: PosSalesOrderCreateInput;
};


export type MutationPosSalesOrderUpdateArgs = {
  input: PosSalesOrderUpdateInput;
};


export type MutationPosterCreateArgs = {
  input: PosterCreateInput;
};


export type MutationPosterDeleteArgs = {
  posterID: Scalars['UUID']['input'];
};


export type MutationPosterUpdateArgs = {
  input: PosterUpdateInput;
};


export type MutationPricelistCreateArgs = {
  input: PricelistCreateInput;
};


export type MutationPricelistDeleteArgs = {
  input: PricelistDeleteInput;
};


export type MutationPricelistPeriodCreateArgs = {
  input: PricelistPeriodCreateInput;
};


export type MutationPricelistPeriodDeleteArgs = {
  pricelistPeriodID: Scalars['UUID']['input'];
};


export type MutationPricelistPeriodUpdateArgs = {
  input: PricelistPeriodUpdateInput;
};


export type MutationPricelistProductBulkCreateArgs = {
  input: PricelistProductBulkCreateInput;
};


export type MutationPricelistProductCreateArgs = {
  input: PricelistProductCreateInput;
};


export type MutationPricelistProductDeleteArgs = {
  input: PricelistProductDeleteInput;
};


export type MutationPricelistProductImportArgs = {
  input: PricelistProductImportInput;
};


export type MutationPricelistProductImportValidateArgs = {
  input: PricelistProductImportValidateInput;
};


export type MutationPricelistProductSalesChannelCreateArgs = {
  input: PricelistProductSalesChannelCreateInput;
};


export type MutationPricelistProductSalesChannelDeleteArgs = {
  pricelistProductSalesChannelID: Scalars['UUID']['input'];
};


export type MutationPricelistProductSalesChannelUpdateArgs = {
  input: PricelistProductSalesChannelUpdateInput;
};


export type MutationPricelistProductSalesChannelUpsertArgs = {
  input: PricelistProductSalesChannelUpsertInput;
};


export type MutationPricelistProductUpdateArgs = {
  input: PricelistProductUpdateInput;
};


export type MutationPricelistSalesChannelDeleteArgs = {
  pricelistSalesChannelID: Scalars['UUID']['input'];
};


export type MutationPricelistSalesChannelUpsertArgs = {
  input: PricelistSalesChannelUpsertInput;
};


export type MutationPricelistUpdateArgs = {
  input: PricelistUpdateInput;
};


export type MutationProductAiImageCreateArgs = {
  input: ProductAiImageCreateInput;
};


export type MutationProductAiImageDeleteArgs = {
  productAIImageID: Scalars['UUID']['input'];
};


export type MutationProductAiImageUpdateArgs = {
  input: ProductAiImageUpdateInput;
};


export type MutationProductAccountingCategoryCreateArgs = {
  input: ProductAccountingCategoryCreateInput;
};


export type MutationProductAccountingCategoryDeleteArgs = {
  productAccountingCategoryID: Scalars['UUID']['input'];
};


export type MutationProductAccountingCategoryUpdateArgs = {
  input: ProductAccountingCategoryUpdateInput;
};


export type MutationProductAddonComponentCreateArgs = {
  input: ProductAddonComponentCreateInput;
};


export type MutationProductAddonComponentDeleteArgs = {
  productAddonComponentID: Scalars['UUID']['input'];
};


export type MutationProductAddonComponentUpdateArgs = {
  input: ProductAddonComponentUpdateInput;
};


export type MutationProductAddonCreateArgs = {
  input: ProductAddonCreateInput;
};


export type MutationProductAddonDeleteArgs = {
  productAddonID: Scalars['UUID']['input'];
};


export type MutationProductAddonGroupCreateArgs = {
  input: ProductAddonGroupCreateInput;
};


export type MutationProductAddonGroupDeleteArgs = {
  productAddonGroupID: Scalars['UUID']['input'];
};


export type MutationProductAddonGroupItemCreateArgs = {
  input: ProductAddonGroupItemCreateInput;
};


export type MutationProductAddonGroupItemDeleteArgs = {
  productAddonGroupItemID: Scalars['UUID']['input'];
};


export type MutationProductAddonGroupItemUpdateArgs = {
  input: ProductAddonGroupItemUpdateInput;
};


export type MutationProductAddonGroupUpdateArgs = {
  input: ProductAddonGroupUpdateInput;
};


export type MutationProductAddonUpdateArgs = {
  input: ProductAddonUpdateInput;
};


export type MutationProductAvailabilityTemplateCreateArgs = {
  input: ProductAvailabilityTemplateCreateInput;
};


export type MutationProductAvailabilityTemplateDeleteArgs = {
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};


export type MutationProductAvailabilityTemplateItemCreateArgs = {
  input: ProductAvailabilityTemplateItemCreateInput;
};


export type MutationProductAvailabilityTemplateItemDeleteArgs = {
  productAvailabilityTemplateItemID: Scalars['UUID']['input'];
};


export type MutationProductAvailabilityTemplateItemExportArgs = {
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};


export type MutationProductAvailabilityTemplateItemImportArgs = {
  input: ProductAvailabilityTemplateItemImportInput;
};


export type MutationProductAvailabilityTemplateItemImportValidateArgs = {
  input: ProductAvailabilityTemplateItemImportValidateInput;
};


export type MutationProductAvailabilityTemplateItemSetChannelsArgs = {
  input: ProductAvailabilityTemplateItemSetChannelsInput;
};


export type MutationProductAvailabilityTemplateItemUpdateArgs = {
  input: ProductAvailabilityTemplateItemUpdateInput;
};


export type MutationProductAvailabilityTemplateUpdateArgs = {
  input: ProductAvailabilityTemplateUpdateInput;
};


export type MutationProductBarcodeMapCreateArgs = {
  input: ProductBarcodeMapCreateInput;
};


export type MutationProductBarcodeMapDeleteArgs = {
  productBarcodeMapID: Scalars['UUID']['input'];
};


export type MutationProductBarcodeMapUpdateArgs = {
  input: ProductBarcodeMapUpdateInput;
};


export type MutationProductBookmarkCreateArgs = {
  input: ProductBookmarkCreateInput;
};


export type MutationProductBookmarkDeleteArgs = {
  productBookmarkID: Scalars['UUID']['input'];
};


export type MutationProductBookmarkProductCreateArgs = {
  input: ProductBookmarkProductCreateInput;
};


export type MutationProductBookmarkProductDeleteArgs = {
  productBookmarkProductID: Scalars['UUID']['input'];
};


export type MutationProductBookmarkProductUpdateArgs = {
  input: ProductBookmarkProductUpdateInput;
};


export type MutationProductBookmarkUpdateArgs = {
  input: ProductBookmarkUpdateInput;
};


export type MutationProductBrandCreateArgs = {
  input: ProductBrandCreateInput;
};


export type MutationProductBrandDeleteArgs = {
  productBrandID: Scalars['UUID']['input'];
};


export type MutationProductBrandUpdateArgs = {
  input: ProductBrandUpdateInput;
};


export type MutationProductBundleComponentCreateArgs = {
  input: ProductBundleComponentCreateInput;
};


export type MutationProductBundleComponentDeleteArgs = {
  productBundleComponentID: Scalars['UUID']['input'];
};


export type MutationProductBundleComponentUpdateArgs = {
  input: ProductBundleComponentUpdateInput;
};


export type MutationProductCategoryCreateArgs = {
  input: ProductCategoryCreateInput;
};


export type MutationProductCategoryDeleteArgs = {
  productCategoryID: Scalars['UUID']['input'];
};


export type MutationProductCategorySalesChannelMapCreateArgs = {
  input: ProductCategorySalesChannelMapCreateInput;
};


export type MutationProductCategorySalesChannelMapDeleteArgs = {
  productCategorySalesChannelMapID: Scalars['UUID']['input'];
};


export type MutationProductCategorySalesChannelMapExportArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type MutationProductCategorySalesChannelMapImportArgs = {
  input: ProductCategorySalesChannelMapImportInput;
};


export type MutationProductCategorySalesChannelMapImportValidateArgs = {
  input: ProductCategorySalesChannelMapImportValidateInput;
};


export type MutationProductCategorySalesChannelMapUpdateArgs = {
  input: ProductCategorySalesChannelMapUpdateInput;
};


export type MutationProductCategoryUpdateArgs = {
  input: ProductCategoryUpdateInput;
};


export type MutationProductConsignmentImportArgs = {
  input: ProductImportInput;
};


export type MutationProductConsignmentImportValidateArgs = {
  input: ProductImportInput;
};


export type MutationProductCreateArgs = {
  input: ProductCreateInput;
};


export type MutationProductDeleteArgs = {
  productID: Scalars['UUID']['input'];
};


export type MutationProductDepartmentCreateArgs = {
  input: ProductDepartmentCreateInput;
};


export type MutationProductDepartmentDeleteArgs = {
  productDepartmentID: Scalars['UUID']['input'];
};


export type MutationProductDepartmentUpdateArgs = {
  input: ProductDepartmentUpdateInput;
};


export type MutationProductDivisionCreateArgs = {
  input: ProductDivisionCreateInput;
};


export type MutationProductDivisionDeleteArgs = {
  productDivisionID: Scalars['UUID']['input'];
};


export type MutationProductDivisionUpdateArgs = {
  input: ProductDivisionUpdateInput;
};


export type MutationProductFileCreateArgs = {
  input: ProductFileCreateInput;
};


export type MutationProductFileDeleteArgs = {
  productFileID: Scalars['UUID']['input'];
};


export type MutationProductFileUpdateArgs = {
  input: ProductFileUpdateInput;
};


export type MutationProductNonConsignmentImportArgs = {
  input: ProductImportInput;
};


export type MutationProductNonConsignmentImportValidateArgs = {
  input: ProductImportInput;
};


export type MutationProductSalesChannelItemMapCreateArgs = {
  input: ProductSalesChannelItemMapCreateInput;
};


export type MutationProductSalesChannelItemMapDeleteArgs = {
  productSalesChannelItemMapID: Scalars['UUID']['input'];
};


export type MutationProductSalesChannelItemMapUpdateArgs = {
  input: ProductSalesChannelItemMapUpdateInput;
};


export type MutationProductSourceCreateArgs = {
  input: ProductSourceCreateInput;
};


export type MutationProductSourceDeleteArgs = {
  productSourceID: Scalars['UUID']['input'];
};


export type MutationProductSourceUpdateArgs = {
  input: ProductSourceUpdateInput;
};


export type MutationProductSubCategoryCreateArgs = {
  input: ProductSubCategoryCreateInput;
};


export type MutationProductSubCategoryDeleteArgs = {
  productSubCategoryID: Scalars['UUID']['input'];
};


export type MutationProductSubCategoryUpdateArgs = {
  input: ProductSubCategoryUpdateInput;
};


export type MutationProductSubDepartmentCreateArgs = {
  input: ProductSubDepartmentCreateInput;
};


export type MutationProductSubDepartmentDeleteArgs = {
  productSubDepartmentID: Scalars['UUID']['input'];
};


export type MutationProductSubDepartmentUpdateArgs = {
  input: ProductSubDepartmentUpdateInput;
};


export type MutationProductTagCreateArgs = {
  input: ProductTagCreateInput;
};


export type MutationProductTagDeleteArgs = {
  productTagID: Scalars['UUID']['input'];
};


export type MutationProductTagProductCreateArgs = {
  input: ProductTagProductCreateInput;
};


export type MutationProductTagProductDeleteArgs = {
  productTagProductID: Scalars['UUID']['input'];
};


export type MutationProductTagProductUpdateArgs = {
  input: ProductTagProductUpdateInput;
};


export type MutationProductTagUpdateArgs = {
  input: ProductTagUpdateInput;
};


export type MutationProductUpdateArgs = {
  input: ProductUpdateInput;
};


export type MutationProductVendorCreateArgs = {
  input: ProductVendorCreateInput;
};


export type MutationProductVendorDeleteArgs = {
  productVendorID: Scalars['UUID']['input'];
};


export type MutationProductVendorUpdateArgs = {
  input: ProductVendorUpdateInput;
};


export type MutationProductionOrderCancelArgs = {
  productionOrderID: Scalars['UUID']['input'];
};


export type MutationProductionOrderConfirmArgs = {
  productionOrderID: Scalars['UUID']['input'];
};


export type MutationProductionOrderCreateArgs = {
  input: ProductionOrderCreateInput;
};


export type MutationProductionOrderUpdateArgs = {
  input: ProductionOrderUpdateInput;
};


export type MutationPromoComponentImportValidateArgs = {
  input: PromoComponentImportValidateInput;
};


export type MutationPromoCreateArgs = {
  input: PromoBulkCreateInput;
};


export type MutationPromoDeleteArgs = {
  promoID: Scalars['UUID']['input'];
};


export type MutationPromoQuotaCreateArgs = {
  input: PromoQuotaCreateInput;
};


export type MutationPromoQuotaDeleteArgs = {
  promoQuotaID: Scalars['UUID']['input'];
};


export type MutationPromoQuotaIncrementUsageArgs = {
  input: PromoQuotaIncrementUsageInput;
};


export type MutationPromoQuotaResetUsageArgs = {
  input: PromoQuotaResetUsageInput;
};


export type MutationPromoQuotaUpdateArgs = {
  input: PromoQuotaUpdateInput;
};


export type MutationPromoTypeCreateArgs = {
  input: PromoTypeCreateInput;
};


export type MutationPromoTypeDeleteArgs = {
  promoTypeID: Scalars['UUID']['input'];
};


export type MutationPromoTypeUpdateArgs = {
  input: PromoTypeUpdateInput;
};


export type MutationPromoUpdateArgs = {
  input: PromoBulkUpdateInput;
};


export type MutationProvinceCreateArgs = {
  input: ProvinceCreateInput;
};


export type MutationProvinceDeleteArgs = {
  provinceID: Scalars['String']['input'];
};


export type MutationProvinceUpdateArgs = {
  input: ProvinceUpdateInput;
};


export type MutationPurchaseAreaCreateArgs = {
  input: PurchaseAreaCreateInput;
};


export type MutationPurchaseAreaDeleteArgs = {
  purchaseAreaID: Scalars['UUID']['input'];
};


export type MutationPurchaseAreaUpdateArgs = {
  input: PurchaseAreaUpdateInput;
};


export type MutationPurchaseOrderBackfillTotalsArgs = {
  input: PurchaseOrderBackfillTotalsInput;
};


export type MutationPurchaseOrderCancelArgs = {
  purchaseOrderID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderCloseArgs = {
  input: PurchaseOrderCloseInput;
};


export type MutationPurchaseOrderConfirmArgs = {
  purchaseOrderID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderCreateArgs = {
  input: PurchaseOrderCreateInput;
};


export type MutationPurchaseOrderForceCloseArgs = {
  input: PurchaseOrderForceCloseInput;
};


export type MutationPurchaseOrderImportArgs = {
  input: PurchaseOrderImportInput;
};


export type MutationPurchaseOrderImportValidateCodesArgs = {
  input: PurchaseOrderImportValidateCodesInput;
};


export type MutationPurchaseOrderReceivingCancelArgs = {
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderReceivingConfirmArgs = {
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderReceivingCreateArgs = {
  input: PurchaseOrderReceivingCreateInput;
};


export type MutationPurchaseOrderReceivingUpdateArgs = {
  input: PurchaseOrderReceivingUpdateInput;
};


export type MutationPurchaseOrderReviseArgs = {
  input: PurchaseOrderReviseInput;
};


export type MutationPurchaseOrderSendEmailArgs = {
  purchaseOrderID: Scalars['UUID']['input'];
};


export type MutationPurchaseOrderUpdateArgs = {
  input: PurchaseOrderUpdateInput;
};


export type MutationPutawayTaskAcceptAndStartArgs = {
  input: AcceptAndStartTaskInput;
};


export type MutationPutawayTaskAssignArgs = {
  input: AssignTaskInput;
};


export type MutationPutawayTaskBatchExecutionsArgs = {
  input: BatchExecutionInput;
};


export type MutationPutawayTaskCancelArgs = {
  input: CancelTaskInput;
};


export type MutationPutawayTaskFinishArgs = {
  input: FinishTaskInput;
};


export type MutationPutawayTaskGenerateMultipleArgs = {
  input: GenerateMultipleTasksInput;
};


export type MutationPutawayTaskGenerateSingleArgs = {
  input: GenerateSingleTaskInput;
};


export type MutationPutawayTaskRecordExecutionArgs = {
  input: RecordExecutionInput;
};


export type MutationPutawayTaskScanLocationArgs = {
  input: ScanLocationInput;
};


export type MutationPutawayTaskScanProductArgs = {
  input: ScanProductInput;
};


export type MutationPutawayTaskStartArgs = {
  input: StartTaskInput;
};


export type MutationPutawayTaskUpdateArgs = {
  input: PutawayTaskUpdateInput;
};


export type MutationReasonCreateArgs = {
  input: ReasonCreateInput;
};


export type MutationReasonDeleteArgs = {
  reasonID: Scalars['UUID']['input'];
};


export type MutationReasonInventoryAdjustmentCreateArgs = {
  input: ReasonInventoryAdjustmentCreateInput;
};


export type MutationReasonInventoryAdjustmentDeleteArgs = {
  reasonInventoryAdjustmentID: Scalars['UUID']['input'];
};


export type MutationReasonInventoryAdjustmentUpdateArgs = {
  input: ReasonInventoryAdjustmentUpdateInput;
};


export type MutationReasonUpdateArgs = {
  input: ReasonUpdateInput;
};


export type MutationRecalculateConsignmentProformaArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type MutationReplenishmentCreateArgs = {
  input: ReplenishmentCreateInput;
};


export type MutationReplenishmentTemplateCategoryCreateArgs = {
  input: ReplenishmentTemplateCategoryCreateInput;
};


export type MutationReplenishmentTemplateCategoryDeleteArgs = {
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
};


export type MutationReplenishmentTemplateCategoryUpdateArgs = {
  input: ReplenishmentTemplateCategoryUpdateInput;
};


export type MutationReplenishmentTemplateCreateArgs = {
  input: ReplenishmentTemplateCreateInput;
};


export type MutationReplenishmentTemplateDeleteArgs = {
  replenishmentTemplateID: Scalars['UUID']['input'];
};


export type MutationReplenishmentTemplateItemCreateArgs = {
  input: ReplenishmentTemplateItemCreateInput;
  replenishmentTemplateID: Scalars['UUID']['input'];
};


export type MutationReplenishmentTemplateItemDeleteArgs = {
  replenishmentTemplateItemID: Scalars['UUID']['input'];
};


export type MutationReplenishmentTemplateItemImportArgs = {
  input: ReplenishmentTemplateItemImportInput;
};


export type MutationReplenishmentTemplateItemImportValidateArgs = {
  input: ReplenishmentTemplateItemImportValidateInput;
};


export type MutationReplenishmentTemplateItemUpdateArgs = {
  input: ReplenishmentTemplateItemUpdateInput;
};


export type MutationReplenishmentTemplateUpdateArgs = {
  input: ReplenishmentTemplateUpdateInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResourceCreateArgs = {
  input: ResourceCreateInput;
};


export type MutationResourceDeleteArgs = {
  resourceID: Scalars['String']['input'];
};


export type MutationResourceUpdateArgs = {
  input: ResourceUpdateInput;
};


export type MutationRevenueReportAccessLogExportArgs = {
  input: RevenueReportAccessLogExportInput;
};


export type MutationRevenueReportApiKeyIssueArgs = {
  input: RevenueReportApiKeyIssueInput;
};


export type MutationRevenueReportApiKeyRevokeArgs = {
  revenueReportApiKeyID: Scalars['UUID']['input'];
};


export type MutationRevenueReportDetailCorrectArgs = {
  input: RevenueReportDetailCorrectInput;
};


export type MutationRevenueReportDetailExportArgs = {
  input: RevenueReportDetailExportInput;
};


export type MutationRevenueReportDetailVoidArgs = {
  input: RevenueReportDetailVoidInput;
};


export type MutationRevenueReportExportArgs = {
  input: RevenueReportExportInput;
};


export type MutationRevenueReportGenerateArgs = {
  input: RevenueReportGenerateInput;
};


export type MutationRevenueReportPartnerActivateArgs = {
  revenueReportPartnerID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerBranchActivateArgs = {
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerBranchCreateArgs = {
  input: RevenueReportPartnerBranchCreateInput;
};


export type MutationRevenueReportPartnerBranchCredentialClearArgs = {
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerBranchCredentialSetArgs = {
  input: RevenueReportPartnerBranchCredentialSetInput;
};


export type MutationRevenueReportPartnerBranchDeactivateArgs = {
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerBranchUpdateArgs = {
  input: RevenueReportPartnerBranchUpdateInput;
};


export type MutationRevenueReportPartnerCreateArgs = {
  input: RevenueReportPartnerCreateInput;
};


export type MutationRevenueReportPartnerCredentialSetArgs = {
  input: RevenueReportPartnerCredentialSetInput;
};


export type MutationRevenueReportPartnerDeactivateArgs = {
  revenueReportPartnerID: Scalars['UUID']['input'];
};


export type MutationRevenueReportPartnerEndpointUpdateArgs = {
  input: RevenueReportPartnerEndpointUpdateInput;
};


export type MutationRevenueReportPartnerUpdateArgs = {
  input: RevenueReportPartnerUpdateInput;
};


export type MutationRevenueReportResendArgs = {
  revenueReportID: Scalars['UUID']['input'];
};


export type MutationRevenueReportResyncArgs = {
  input: RevenueReportResyncInput;
};


export type MutationRevenueReportTemplateActivateArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type MutationRevenueReportTemplateCreateArgs = {
  input: RevenueReportTemplateCreateInput;
};


export type MutationRevenueReportTemplateDeactivateArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type MutationRevenueReportTemplateDeleteArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type MutationRevenueReportTemplateDuplicateArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type MutationRevenueReportTemplateFieldMapUpdateArgs = {
  input: RevenueReportTemplateFieldMapUpdateInput;
};


export type MutationRevenueReportTemplateUpdateArgs = {
  input: RevenueReportTemplateUpdateInput;
};


export type MutationRevenueReportUserActivateArgs = {
  revenueReportUserID: Scalars['UUID']['input'];
};


export type MutationRevenueReportUserCreateArgs = {
  input: RevenueReportUserCreateInput;
};


export type MutationRevenueReportUserDeactivateArgs = {
  revenueReportUserID: Scalars['UUID']['input'];
};


export type MutationRevenueReportUserUpdateArgs = {
  input: RevenueReportUserUpdateInput;
};


export type MutationRevenueSharingBranchCreateArgs = {
  input: RevenueSharingBranchCreateInput;
};


export type MutationRevenueSharingBranchDeleteArgs = {
  revenueSharingBranchID: Scalars['UUID']['input'];
};


export type MutationRevenueSharingBranchUpdateArgs = {
  input: RevenueSharingBranchUpdateInput;
};


export type MutationRevenueSharingCorrectItemArgs = {
  input: RevenueSharingCorrectItemInput;
};


export type MutationRevenueSharingExportArgs = {
  input: RevenueSharingExportInput;
};


export type MutationRevenueSharingGenerateArgs = {
  input: RevenueSharingGenerateInput;
};


export type MutationRevenueSharingReuploadDatesArgs = {
  revenueSharingID: Scalars['UUID']['input'];
};


export type MutationRevenueSharingUploadArgs = {
  revenueSharingID: Scalars['UUID']['input'];
};


export type MutationRevenueSharingVoidItemArgs = {
  revenueSharingDetailID: Scalars['UUID']['input'];
};


export type MutationRoleCreateArgs = {
  input: RoleCreateInput;
};


export type MutationRoleDeleteArgs = {
  roleID: Scalars['UUID']['input'];
};


export type MutationRoleUpdateArgs = {
  input: RoleUpdateInput;
};


export type MutationSalesChannelCampaignCancelArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCampaignCreateArgs = {
  input: SalesChannelCampaignCreateInput;
};


export type MutationSalesChannelCampaignDeleteArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCampaignPublishArgs = {
  input: SalesChannelCampaignPublishInput;
};


export type MutationSalesChannelCampaignPublishToStoresArgs = {
  input: SalesChannelCampaignPublishToStoresInput;
};


export type MutationSalesChannelCampaignSetCategoriesArgs = {
  input: SalesChannelCampaignSetCategoriesInput;
};


export type MutationSalesChannelCampaignSetChannelsArgs = {
  input: SalesChannelCampaignSetChannelsInput;
};


export type MutationSalesChannelCampaignSetProductsArgs = {
  input: SalesChannelCampaignSetProductsInput;
};


export type MutationSalesChannelCampaignStopArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCampaignUpdateArgs = {
  input: SalesChannelCampaignUpdateInput;
};


export type MutationSalesChannelCategoryCreateArgs = {
  input: SalesChannelCategoryCreateInput;
};


export type MutationSalesChannelCategoryDeleteArgs = {
  salesChannelCategoryID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCategoryGroupCreateArgs = {
  input: SalesChannelCategoryGroupCreateInput;
};


export type MutationSalesChannelCategoryGroupDeleteArgs = {
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCategoryGroupItemCreateArgs = {
  input: SalesChannelCategoryGroupItemCreateInput;
};


export type MutationSalesChannelCategoryGroupItemDeleteArgs = {
  salesChannelCategoryGroupItemID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCategoryGroupItemUpdateArgs = {
  input: SalesChannelCategoryGroupItemUpdateInput;
};


export type MutationSalesChannelCategoryGroupProductCreateArgs = {
  input: SalesChannelCategoryGroupProductCreateInput;
};


export type MutationSalesChannelCategoryGroupProductDeleteArgs = {
  salesChannelCategoryGroupProductID: Scalars['UUID']['input'];
};


export type MutationSalesChannelCategoryGroupProductReorderArgs = {
  input: Array<ReorderSalesChannelCategoryGroupProductInput>;
};


export type MutationSalesChannelCategoryGroupProductUpdateArgs = {
  input: SalesChannelCategoryGroupProductUpdateInput;
};


export type MutationSalesChannelCategoryGroupUpdateArgs = {
  input: SalesChannelCategoryGroupUpdateInput;
};


export type MutationSalesChannelCategoryUpdateArgs = {
  input: SalesChannelCategoryUpdateInput;
};


export type MutationSalesChannelStockThresholdCreateArgs = {
  input: SalesChannelStockThresholdCreateInput;
};


export type MutationSalesChannelStockThresholdDeleteArgs = {
  salesChannelStockThresholdID: Scalars['UUID']['input'];
};


export type MutationSalesChannelStockThresholdUpdateArgs = {
  input: SalesChannelStockThresholdUpdateInput;
};


export type MutationSalesInvoiceInventoryBackfillArgs = {
  input: SalesInvoiceInventoryBackfillInput;
};


export type MutationSalesInvoiceReviewRefreshArgs = {
  salesInvoiceReviewID: Scalars['UUID']['input'];
};


export type MutationSalesInvoiceReviewResolveBulkArgs = {
  input: SalesInvoiceReviewResolveBulkInput;
};


export type MutationSalesPaymentMethodCreateArgs = {
  input: SalesPaymentMethodCreateInput;
};


export type MutationSalesPaymentMethodDeleteArgs = {
  salesPaymentMethodID: Scalars['UUID']['input'];
};


export type MutationSalesPaymentMethodTypeCreateArgs = {
  input: SalesPaymentMethodTypeCreateInput;
};


export type MutationSalesPaymentMethodTypeDeleteArgs = {
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
};


export type MutationSalesPaymentMethodTypeUpdateArgs = {
  input: SalesPaymentMethodTypeUpdateInput;
};


export type MutationSalesPaymentMethodUpdateArgs = {
  input: SalesPaymentMethodUpdateInput;
};


export type MutationSendConsignmentInvoiceEmailArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type MutationSendConsignmentInvoiceEmailsBulkArgs = {
  vendorConsignmentInvoiceIDs: Array<Scalars['UUID']['input']>;
};


export type MutationShiftSessionCloseArgs = {
  input: ShiftSessionCloseInput;
};


export type MutationShiftSessionCreateArgs = {
  input: ShiftSessionCreateInput;
};


export type MutationShiftSessionDeleteArgs = {
  shiftSessionID: Scalars['UUID']['input'];
};


export type MutationShiftSessionRecomputeArgs = {
  shiftSessionID: Scalars['UUID']['input'];
};


export type MutationShiftSessionResolveCashDiffArgs = {
  input: ShiftSessionResolveCashDiffInput;
};


export type MutationSimpleTransferOrderCancelArgs = {
  input: SimpleTransferOrderCancelInput;
};


export type MutationSimpleTransferOrderConfirmArgs = {
  input: SimpleTransferOrderConfirmInput;
};


export type MutationSimpleTransferOrderCreateArgs = {
  input: SimpleTransferOrderCreateInput;
};


export type MutationSimpleTransferOrderDeleteArgs = {
  transferOrderSimpleID: Scalars['UUID']['input'];
};


export type MutationSimpleTransferOrderReceivingCancelArgs = {
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationSimpleTransferOrderReceivingConfirmArgs = {
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationSimpleTransferOrderReceivingCreateArgs = {
  input: SimpleTransferOrderReceivingCreateInput;
};


export type MutationSimpleTransferOrderReceivingCreateAndConfirmArgs = {
  input: SimpleTransferOrderReceivingCreateAndConfirmInput;
};


export type MutationSimpleTransferOrderReceivingUpdateArgs = {
  input: SimpleTransferOrderReceivingUpdateInput;
};


export type MutationSimpleTransferOrderReceivingUpdateAndConfirmArgs = {
  input: SimpleTransferOrderReceivingUpdateAndConfirmInput;
};


export type MutationSimpleTransferOrderUpdateArgs = {
  input: SimpleTransferOrderUpdateInput;
};


export type MutationSubdistrictCreateArgs = {
  input: SubdistrictCreateInput;
};


export type MutationSubdistrictDeleteArgs = {
  subdistrictID: Scalars['String']['input'];
};


export type MutationSubdistrictUpdateArgs = {
  input: SubdistrictUpdateInput;
};


export type MutationSyncErpPurchaseOrderReceiveArgs = {
  input: SyncErpPurchaseOrderReceiveInput;
};


export type MutationSyncErpVendorArgs = {
  input: SyncErpVendorInput;
};


export type MutationTaxCreateArgs = {
  input: TaxCreateInput;
};


export type MutationTaxDeleteArgs = {
  taxID: Scalars['UUID']['input'];
};


export type MutationTaxUpdateArgs = {
  input: TaxUpdateInput;
};


export type MutationTransferOrderCancelArgs = {
  input: TransferOrderCancelInput;
};


export type MutationTransferOrderConfirmArgs = {
  input: TransferOrderConfirmInput;
};


export type MutationTransferOrderCreateArgs = {
  input: TransferOrderCreateInput;
};


export type MutationTransferOrderDeleteArgs = {
  transferOrderID: Scalars['UUID']['input'];
};


export type MutationTransferOrderImportArgs = {
  input: TransferOrderImportInput;
};


export type MutationTransferOrderImportValidateCodesArgs = {
  input: TransferOrderImportValidateCodesInput;
};


export type MutationTransferOrderMarkAsDoneArgs = {
  input: TransferOrderMarkAsDoneInput;
};


export type MutationTransferOrderReceivingCancelArgs = {
  transferOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationTransferOrderReceivingConfirmArgs = {
  transferOrderReceivingID: Scalars['UUID']['input'];
};


export type MutationTransferOrderReceivingCreateArgs = {
  input: TransferOrderReceivingCreateInput;
};


export type MutationTransferOrderReceivingUpdateArgs = {
  input: TransferOrderReceivingUpdateInput;
};


export type MutationTransferOrderUpdateArgs = {
  input: TransferOrderUpdateInput;
};


export type MutationTransferRequestApproveArgs = {
  input: TransferRequestApproveInput;
};


export type MutationTransferRequestCancelArgs = {
  input: TransferRequestCancelInput;
};


export type MutationTransferRequestCreateArgs = {
  input: TransferRequestCreateInput;
};


export type MutationTransferRequestImportArgs = {
  input: TransferRequestImportInput;
};


export type MutationTransferRequestImportValidateCodesArgs = {
  input: TransferRequestImportValidateCodesInput;
};


export type MutationTransferRequestRejectArgs = {
  input: TransferRequestRejectInput;
};


export type MutationTransferRequestSubmitArgs = {
  input: TransferRequestSubmitInput;
};


export type MutationTransferRequestUpdateArgs = {
  input: TransferRequestUpdateInput;
};


export type MutationTriggerProductImageEmbeddingRunArgs = {
  input?: InputMaybe<TriggerIngestionInput>;
};


export type MutationUomCategoryCreateArgs = {
  input: UomCategoryCreateInput;
};


export type MutationUomCategoryDeleteArgs = {
  input: UomCategoryDeleteInput;
};


export type MutationUomCategoryUpdateArgs = {
  input: UomCategoryUpdateInput;
};


export type MutationUomCreateArgs = {
  input: UomCreateInput;
};


export type MutationUomDeleteArgs = {
  uomID: Scalars['UUID']['input'];
};


export type MutationUomUpdateArgs = {
  input: UomUpdateInput;
  uomID: Scalars['UUID']['input'];
};


export type MutationUpdateErpProductArgs = {
  input: UpdateErpProductInput;
  productID: Scalars['Int']['input'];
};


export type MutationUploadTemplateCreateArgs = {
  input: UploadTemplateCreateInput;
};


export type MutationUploadTemplateDeleteArgs = {
  uploadTemplateID: Scalars['UUID']['input'];
};


export type MutationUploadTemplateUpdateArgs = {
  input: UploadTemplateUpdateInput;
};


export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


export type MutationUserDeleteArgs = {
  userID: Scalars['UUID']['input'];
};


export type MutationUserRegeneratePinArgs = {
  userID: Scalars['UUID']['input'];
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationValidateBeforeIcFinishArgs = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
};


export type MutationValidateBeforeIcFinishConfirmArgs = {
  input: ValidateBeforeIcFinishConfirmInput;
};


export type MutationValidateSupervisorPinArgs = {
  input: ValidateSupervisorPinInput;
};


export type MutationVendorCategoryCreateArgs = {
  input: VendorCategoryCreateInput;
};


export type MutationVendorCategoryDeleteArgs = {
  vendorCategoryID: Scalars['UUID']['input'];
};


export type MutationVendorCategoryUpdateArgs = {
  input: VendorCategoryUpdateInput;
};


export type MutationVendorConsignmentBranchBulkDeleteArgs = {
  vendorConsignmentBranchIDs: Array<Scalars['UUID']['input']>;
};


export type MutationVendorConsignmentBranchCreateArgs = {
  input: VendorConsignmentBranchCreateInput;
};


export type MutationVendorConsignmentBranchDeleteArgs = {
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};


export type MutationVendorConsignmentBranchPeriodGrantArgs = {
  input: VendorConsignmentBranchPeriodGrantInput;
};


export type MutationVendorConsignmentBranchPeriodResumeArgs = {
  input: VendorConsignmentBranchPeriodResumeInput;
};


export type MutationVendorConsignmentBranchPeriodRevokeArgs = {
  input: VendorConsignmentBranchPeriodRevokeInput;
};


export type MutationVendorConsignmentBranchPeriodSuspendArgs = {
  input: VendorConsignmentBranchPeriodSuspendInput;
};


export type MutationVendorConsignmentBranchUpdateArgs = {
  input: VendorConsignmentBranchUpdateInput;
};


export type MutationVendorConsignmentInvoiceConfigCreateArgs = {
  input: VendorConsignmentInvoiceConfigCreateInput;
};


export type MutationVendorConsignmentInvoiceConfigImportArgs = {
  input: VendorConsignmentInvoiceConfigImportInput;
};


export type MutationVendorConsignmentInvoiceConfigImportValidateArgs = {
  input: VendorConsignmentInvoiceConfigImportInput;
};


export type MutationVendorConsignmentInvoiceConfigUpdateArgs = {
  input: VendorConsignmentInvoiceConfigUpdateInput;
};


export type MutationVendorConsignmentProductCreateArgs = {
  input: VendorConsignmentProductCreateInput;
};


export type MutationVendorConsignmentProductDeleteArgs = {
  vendorConsignmentProductID: Scalars['UUID']['input'];
};


export type MutationVendorConsignmentProductPriceBulkUpdateArgs = {
  input: VendorConsignmentProductPriceBulkUpdateInput;
};


export type MutationVendorConsignmentProductUpdateArgs = {
  input: VendorConsignmentProductUpdateInput;
};


export type MutationVendorConsignmentRentalPaymentApproveArgs = {
  input: VendorConsignmentRentalPaymentApproveInput;
};


export type MutationVendorConsignmentRentalPaymentCancelArgs = {
  input: VendorConsignmentRentalPaymentCancelInput;
};


export type MutationVendorConsignmentRentalPaymentCreateArgs = {
  input: VendorConsignmentRentalPaymentCreateInput;
};


export type MutationVendorConsignmentRentalPaymentRejectArgs = {
  input: VendorConsignmentRentalPaymentRejectInput;
};


export type MutationVendorConsignmentRentalPaymentSubmitArgs = {
  input: VendorConsignmentRentalPaymentSubmitInput;
};


export type MutationVendorConsignmentRentalPaymentUpdateArgs = {
  input: VendorConsignmentRentalPaymentUpdateInput;
};


export type MutationVendorCreateArgs = {
  input: VendorCreateInput;
};


export type MutationVendorCreateAccessArgs = {
  input: VendorCreateAccessInput;
};


export type MutationVendorDeleteArgs = {
  input: VendorDeleteInput;
};


export type MutationVendorPicContactCreateArgs = {
  input: VendorPicContactCreateInput;
};


export type MutationVendorPicContactDeleteArgs = {
  vendorPicContactID: Scalars['UUID']['input'];
};


export type MutationVendorPicContactUpdateArgs = {
  input: VendorPicContactUpdateInput;
};


export type MutationVendorSetPortalAccessActiveArgs = {
  input: VendorSetPortalAccessActiveInput;
};


export type MutationVendorUpdateArgs = {
  input: VendorUpdateInput;
};


export type MutationVendorUpdateAccessArgs = {
  input: VendorUpdateAccessInput;
};


export type MutationVillageCreateArgs = {
  input: VillageCreateInput;
};


export type MutationVillageDeleteArgs = {
  villageID: Scalars['String']['input'];
};


export type MutationVillageUpdateArgs = {
  input: VillageUpdateInput;
};


export type MutationVoucherCategoryCreateArgs = {
  input: VoucherCategoryCreateInput;
};


export type MutationVoucherCategoryDeleteArgs = {
  voucherCategoryID: Scalars['UUID']['input'];
};


export type MutationVoucherCategoryUpdateArgs = {
  input: VoucherCategoryUpdateInput;
};


export type MutationVoucherCreateArgs = {
  input: VoucherCreateInput;
};


export type MutationVoucherDeleteArgs = {
  voucherID: Scalars['UUID']['input'];
};


export type MutationVoucherItemGenerateArgs = {
  input: VoucherItemGenerateInput;
};


export type MutationVoucherItemImportArgs = {
  input: Array<VoucherItemImportInput>;
};


export type MutationVoucherItemVoidArgs = {
  voucherItemID: Scalars['UUID']['input'];
};


export type MutationVoucherRecountItemsArgs = {
  voucherID: Scalars['UUID']['input'];
};


export type MutationVoucherUpdateArgs = {
  input: VoucherUpdateInput;
};


export type MutationWarehouseCreateArgs = {
  input: WarehouseCreateInput;
};


export type MutationWarehouseDeleteArgs = {
  warehouseID: Scalars['UUID']['input'];
};


export type MutationWarehouseLocationCreateArgs = {
  input: WarehouseLocationCreateInput;
};


export type MutationWarehouseLocationCreateBulkArgs = {
  input: WarehouseLocationBulkCreateInput;
};


export type MutationWarehouseLocationDeleteArgs = {
  warehouseLocationID: Scalars['UUID']['input'];
};


export type MutationWarehouseLocationGroupCreateArgs = {
  input: WarehouseLocationGroupCreateInput;
};


export type MutationWarehouseLocationGroupDeleteArgs = {
  warehouseLocationGroupID: Scalars['UUID']['input'];
};


export type MutationWarehouseLocationGroupUpdateArgs = {
  input: WarehouseLocationGroupUpdateInput;
};


export type MutationWarehouseLocationRelationMapCreateArgs = {
  input: WarehouseLocationRelationMapCreateInput;
};


export type MutationWarehouseLocationRelationMapDeleteArgs = {
  input: WarehouseLocationRelationMapDeleteInput;
};


export type MutationWarehouseLocationRelationMapUpdateArgs = {
  input: WarehouseLocationRelationMapUpdateInput;
};


export type MutationWarehouseLocationUpdateArgs = {
  input: WarehouseLocationUpdateInput;
};


export type MutationWarehouseProductLocationMapCreateArgs = {
  input: WarehouseProductLocationMapCreateInput;
};


export type MutationWarehouseProductLocationMapDeleteArgs = {
  warehouseProductLocationMapID: Scalars['UUID']['input'];
};


export type MutationWarehouseProductLocationMapUpdateArgs = {
  input: WarehouseProductLocationMapUpdateInput;
};


export type MutationWarehouseReplenishmentTemplateCreateArgs = {
  input: WarehouseReplenishmentTemplateCreateInput;
};


export type MutationWarehouseReplenishmentTemplateCreateBulkArgs = {
  input: WarehouseReplenishmentTemplateCreateBulkInput;
};


export type MutationWarehouseReplenishmentTemplateDeleteArgs = {
  warehouseReplenishmentTemplateID: Scalars['UUID']['input'];
};


export type MutationWarehouseUpdateArgs = {
  input: WarehouseUpdateInput;
};

export enum OtpChannel {
  Email = 'EMAIL'
}

export enum OtpType {
  ResetPassword = 'RESET_PASSWORD'
}

export type OpenSealContainerInput = {
  outboundContainerID: Scalars['UUID']['input'];
};

export type OperatingHours = {
  __typename?: 'OperatingHours';
  fri: OperatingHoursDay;
  mon: OperatingHoursDay;
  sat: OperatingHoursDay;
  sun: OperatingHoursDay;
  thu: OperatingHoursDay;
  tue: OperatingHoursDay;
  wed: OperatingHoursDay;
};

export type OperatingHoursDay = {
  __typename?: 'OperatingHoursDay';
  isOpen: Scalars['Boolean']['output'];
  periods: Array<OperatingHoursPeriod>;
};

export type OperatingHoursDayInput = {
  isOpen: Scalars['Boolean']['input'];
  periods: Array<OperatingHoursPeriodInput>;
};

export type OperatingHoursInput = {
  fri: OperatingHoursDayInput;
  mon: OperatingHoursDayInput;
  sat: OperatingHoursDayInput;
  sun: OperatingHoursDayInput;
  thu: OperatingHoursDayInput;
  tue: OperatingHoursDayInput;
  wed: OperatingHoursDayInput;
};

export type OperatingHoursPeriod = {
  __typename?: 'OperatingHoursPeriod';
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type OperatingHoursPeriodInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

/**
 * Outbound container for shipping products.
 *
 * Status flags (isEmpty, isDo) are automatically set based on container data:
 * - isEmpty: Indicates if container has items (based on TotalItems count)
 * - isDo: Indicates if container is attached to a delivery order (based on DeliveryOrderID)
 */
export type OutboundContainer = {
  __typename?: 'OutboundContainer';
  containerNumber: Scalars['String']['output'];
  deliveryOrder?: Maybe<DeliveryOrder>;
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  draftDeliveryOrderBatchID?: Maybe<Scalars['UUID']['output']>;
  draftDeliveryOrderBatchNumber?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  fromBranchID: Scalars['UUID']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  gmt: Scalars['Int']['output'];
  /**
   * Indicates if the container is attached to a delivery order.
   *
   *   Automatically set based on DeliveryOrderID:
   *   - true: Container is attached to a delivery order (DeliveryOrderID is not null)
   *   - false: Container is not attached to a delivery order (DeliveryOrderID is null)
   *
   *   This flag is read-only and computed from the container's delivery order association.
   */
  isDo: Scalars['Boolean']['output'];
  /**
   * Indicates if the container is empty (has no items).
   *
   *   Automatically set based on TotalItems:
   *   - true: Container has no items (TotalItems = 0)
   *   - false: Container has items (TotalItems > 0)
   *
   *   This flag is read-only and computed from the container's item count.
   */
  isEmpty: Scalars['Boolean']['output'];
  isReceived: Scalars['Boolean']['output'];
  isSealed: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  outboundContainerID: Scalars['UUID']['output'];
  packingTask?: Maybe<OutboundContainerPackingTaskInfo>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  toBranchID?: Maybe<Scalars['UUID']['output']>;
  toWarehouse?: Maybe<Warehouse>;
  toWarehouseID?: Maybe<Scalars['UUID']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQty: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
};

export type OutboundContainerCreateInput = {
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  fromBranchID: Scalars['UUID']['input'];
  fromWarehouseID: Scalars['UUID']['input'];
  gmt: Scalars['Int']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentNumber: Scalars['String']['input'];
  sourceDocumentType: Scalars['String']['input'];
  toBranchID?: InputMaybe<Scalars['UUID']['input']>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Item within an outbound container.
 *
 * Represents a product packed into a container with quantity and UOM information.
 */
export type OutboundContainerItem = {
  __typename?: 'OutboundContainerItem';
  baseUomQty: Scalars['Float']['output'];
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  outboundContainerID: Scalars['UUID']['output'];
  outboundContainerItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

/**
 * Outbound container items grouped by product.
 *
 * Represents aggregated quantities across multiple outbound containers for the same product.
 */
export type OutboundContainerItemGrouped = {
  __typename?: 'OutboundContainerItemGrouped';
  baseUomQty: Scalars['Float']['output'];
  deliveryOrderID?: Maybe<Scalars['UUID']['output']>;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type OutboundContainerItemGroupedPaged = {
  __typename?: 'OutboundContainerItemGroupedPaged';
  items?: Maybe<Array<OutboundContainerItemGrouped>>;
  pagination: PaginationResult;
};

export type OutboundContainerItemGroupedQopFilterInput = {
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
};

export type OutboundContainerItemGroupedQopInput = {
  filters?: InputMaybe<OutboundContainerItemGroupedQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
};

/**
 * Summary of item packing status within a container.
 *
 * Tracks existing quantities, newly packed quantities, and total quantities
 * for a product in a container during packing operations.
 */
export type OutboundContainerItemPackingSummary = {
  __typename?: 'OutboundContainerItemPackingSummary';
  baseUomQty: Scalars['Float']['output'];
  baseUomQtyExisting: Scalars['Float']['output'];
  baseUomQtyPacked: Scalars['Float']['output'];
  outboundContainerID: Scalars['UUID']['output'];
  outboundContainerItemID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  qtyExisting: Scalars['Float']['output'];
  qtyPacked: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type OutboundContainerItemPaged = {
  __typename?: 'OutboundContainerItemPaged';
  items?: Maybe<Array<OutboundContainerItem>>;
  pagination: PaginationResult;
};

export type OutboundContainerItemQopFilterInput = {
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  outboundContainerID?: InputMaybe<Scalars['UUID']['input']>;
  outboundContainerItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type OutboundContainerItemQopInput = {
  filters?: InputMaybe<OutboundContainerItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type OutboundContainerPackItemInput = {
  outboundContainerID: Scalars['UUID']['input'];
  packingTaskID: Scalars['UUID']['input'];
  packingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
  version: Scalars['UUID']['input'];
};

/** Packing task snapshot for an outbound container, resolved through packing_task_container. */
export type OutboundContainerPackingTaskInfo = {
  __typename?: 'OutboundContainerPackingTaskInfo';
  packingTaskID: Scalars['UUID']['output'];
  packingTaskNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type OutboundContainerPaged = {
  __typename?: 'OutboundContainerPaged';
  items?: Maybe<Array<OutboundContainer>>;
  pagination: PaginationResult;
};

export type OutboundContainerQopFilterInput = {
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  excludeContainerNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromBranchID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  isDo?: InputMaybe<Scalars['Boolean']['input']>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSealed?: InputMaybe<Scalars['Boolean']['input']>;
  outboundContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  toBranchID?: InputMaybe<Scalars['UUID']['input']>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type OutboundContainerQopInput = {
  filters?: InputMaybe<OutboundContainerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type OutboundContainerUnpackItemInput = {
  outboundContainerID: Scalars['UUID']['input'];
  packingTaskID: Scalars['UUID']['input'];
  packingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
};

export type OutboundContainerUpdatePackItemInput = {
  outboundContainerID: Scalars['UUID']['input'];
  packingTaskID: Scalars['UUID']['input'];
  packingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
};

export type PackingTask = {
  __typename?: 'PackingTask';
  branch?: Maybe<Branch>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  cancelledAtUtc?: Maybe<Scalars['Time']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouse?: Maybe<Warehouse>;
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  packedUserID?: Maybe<Scalars['UUID']['output']>;
  packedUserName?: Maybe<Scalars['String']['output']>;
  packingTaskDatetime: Scalars['Time']['output'];
  packingTaskDatetimeUtc: Scalars['Time']['output'];
  packingTaskID: Scalars['UUID']['output'];
  packingTaskNumber: Scalars['String']['output'];
  pickedUserID: Scalars['UUID']['output'];
  pickedUserName: Scalars['String']['output'];
  pickingTask?: Maybe<PickingTask>;
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskNumber: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskDoneAt?: Maybe<Scalars['Time']['output']>;
  taskDoneAtUtc?: Maybe<Scalars['Time']['output']>;
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  taskStartAtUtc?: Maybe<Scalars['Time']['output']>;
  taskVerifiedAt?: Maybe<Scalars['Time']['output']>;
  taskVerifiedAtUtc?: Maybe<Scalars['Time']['output']>;
  toWarehouse?: Maybe<Warehouse>;
  toWarehouseCode?: Maybe<Scalars['String']['output']>;
  toWarehouseID?: Maybe<Scalars['UUID']['output']>;
  toWarehouseName?: Maybe<Scalars['String']['output']>;
  totalBaseUomQtyPacked: Scalars['Decimal']['output'];
  totalBaseUomQtyPicked: Scalars['Decimal']['output'];
  totalBaseUomQtyVerified: Scalars['Decimal']['output'];
  totalItems: Scalars['Int']['output'];
  totalItemsPacked: Scalars['Int']['output'];
  totalItemsVerified: Scalars['Int']['output'];
  totalPackings: Scalars['Int']['output'];
  totalQtyPacked: Scalars['Decimal']['output'];
  totalQtyPicked: Scalars['Decimal']['output'];
  totalQtyVerified: Scalars['Decimal']['output'];
  verifiedUserID?: Maybe<Scalars['UUID']['output']>;
  verifiedUserName?: Maybe<Scalars['String']['output']>;
};

export type PackingTaskCancelInput = {
  cancellationReason: Scalars['String']['input'];
  packingTaskID: Scalars['UUID']['input'];
};

export type PackingTaskContainer = {
  __typename?: 'PackingTaskContainer';
  entityAuditMetadata: EntityAuditMetadata;
  outboundContainer: OutboundContainer;
  outboundContainerID: Scalars['UUID']['output'];
  packingTaskContainerID: Scalars['UUID']['output'];
  packingTaskID: Scalars['UUID']['output'];
};

export type PackingTaskContainerItem = {
  __typename?: 'PackingTaskContainerItem';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  outboundContainer: OutboundContainer;
  outboundContainerID: Scalars['UUID']['output'];
  outboundContainerItemID: Scalars['UUID']['output'];
  packingTask: PackingTask;
  packingTaskContainer: PackingTaskContainer;
  packingTaskContainerID: Scalars['UUID']['output'];
  packingTaskContainerItemID: Scalars['UUID']['output'];
  packingTaskID: Scalars['UUID']['output'];
  packingTaskItem: PackingTaskItem;
  packingTaskItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
};

export type PackingTaskContainerItemPaged = {
  __typename?: 'PackingTaskContainerItemPaged';
  items: Array<PackingTaskContainerItem>;
  pagination: PaginationResult;
};

export type PackingTaskContainerItemQopFilterInput = {
  outboundContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PackingTaskContainerItemQopInput = {
  filters?: InputMaybe<PackingTaskContainerItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskContainerPaged = {
  __typename?: 'PackingTaskContainerPaged';
  items: Array<PackingTaskContainer>;
  pagination: PaginationResult;
};

export type PackingTaskContainerQopFilterInput = {
  containerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  isDo?: InputMaybe<Scalars['Boolean']['input']>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  isSealed?: InputMaybe<Scalars['Boolean']['input']>;
  outboundContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskContainerID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
};

export type PackingTaskContainerQopInput = {
  filters?: InputMaybe<PackingTaskContainerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskExecution = {
  __typename?: 'PackingTaskExecution';
  baseUomQty: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  executedAtUtc: Scalars['Time']['output'];
  outboundContainerID?: Maybe<Scalars['UUID']['output']>;
  packingContainerID: Scalars['UUID']['output'];
  packingTaskExecutionID: Scalars['UUID']['output'];
  packingTaskID: Scalars['UUID']['output'];
  packingTaskItemID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Decimal']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type PackingTaskExecutionPaged = {
  __typename?: 'PackingTaskExecutionPaged';
  items: Array<PackingTaskExecution>;
  pagination: PaginationResult;
};

export type PackingTaskExecutionQopFilterInput = {
  executedAtEnd?: InputMaybe<Scalars['Time']['input']>;
  executedAtStart?: InputMaybe<Scalars['Time']['input']>;
  packingTaskExecutionID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PackingTaskExecutionQopInput = {
  filters?: InputMaybe<PackingTaskExecutionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskFinishInput = {
  finishAt?: InputMaybe<Scalars['Time']['input']>;
  packingTaskID: Scalars['UUID']['input'];
};

export type PackingTaskItem = {
  __typename?: 'PackingTaskItem';
  baseUomQtyDiff: Scalars['Decimal']['output'];
  baseUomQtyOutstanding: Scalars['Decimal']['output'];
  baseUomQtyPacked: Scalars['Decimal']['output'];
  baseUomQtyPicked: Scalars['Decimal']['output'];
  baseUomQtyVerified: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  packingTask?: Maybe<PackingTask>;
  packingTaskID: Scalars['UUID']['output'];
  packingTaskItemID: Scalars['UUID']['output'];
  pickingTaskExecution?: Maybe<PickingTaskExecution>;
  pickingTaskItem?: Maybe<PickingTaskItem>;
  pickingTaskItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyDiff: Scalars['Decimal']['output'];
  qtyDiffNote?: Maybe<Scalars['String']['output']>;
  qtyDiffReason?: Maybe<Scalars['String']['output']>;
  qtyOutstanding: Scalars['Decimal']['output'];
  qtyPacked: Scalars['Decimal']['output'];
  qtyPicked: Scalars['Decimal']['output'];
  qtyVerified: Scalars['Decimal']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  uom?: Maybe<Uom>;
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Decimal']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['Time']['output']>;
  verifiedAtUtc?: Maybe<Scalars['Time']['output']>;
  verifiedByUserID?: Maybe<Scalars['UUID']['output']>;
  verifiedByUserName?: Maybe<Scalars['String']['output']>;
};

export type PackingTaskItemPaged = {
  __typename?: 'PackingTaskItemPaged';
  items: Array<PackingTaskItem>;
  pagination: PaginationResult;
};

export type PackingTaskItemQopFilterInput = {
  packingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PackingTaskItemQopInput = {
  filters?: InputMaybe<PackingTaskItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskPaged = {
  __typename?: 'PackingTaskPaged';
  items: Array<PackingTask>;
  pagination: PaginationResult;
};

export type PackingTaskQopFilterInput = {
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  packingTaskDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  packingTaskDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  packingTaskNumber?: InputMaybe<Scalars['String']['input']>;
  pickingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PackingTaskQopInput = {
  filters?: InputMaybe<PackingTaskQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PackingTaskStartInput = {
  packingTaskID: Scalars['UUID']['input'];
  startAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PackingTaskVerifyInput = {
  items: Array<PackingTaskVerifyItemInput>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  packingTaskID: Scalars['UUID']['input'];
};

export type PackingTaskVerifyItemInput = {
  packingTaskItemID: Scalars['UUID']['input'];
  qtyVerified: Scalars['Decimal']['input'];
  reasonID?: InputMaybe<Scalars['UUID']['input']>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
};

export type Pagination = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  withCount?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaginationResult = {
  __typename?: 'PaginationResult';
  hasNext?: Maybe<Scalars['Boolean']['output']>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

export enum PauseDuration {
  Hours_24 = 'HOURS_24',
  Hour_1 = 'HOUR_1',
  Minutes_30 = 'MINUTES_30'
}

export type PauseDurationOption = {
  __typename?: 'PauseDurationOption';
  label: Scalars['String']['output'];
  value: PauseDuration;
};

export type PaymentInboundRequestLog = {
  __typename?: 'PaymentInboundRequestLog';
  clientKey: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorReason: Scalars['String']['output'];
  externalID: Scalars['String']['output'];
  headers: Scalars['String']['output'];
  httpMethod: Scalars['String']['output'];
  isSuccess: Scalars['Boolean']['output'];
  partnerReferenceNo: Scalars['String']['output'];
  paymentInboundRequestLogID: Scalars['UUID']['output'];
  providerCode: Scalars['String']['output'];
  providerConfigID?: Maybe<Scalars['UUID']['output']>;
  receivedAt: Scalars['Time']['output'];
  requestBody: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  responseBody: Scalars['String']['output'];
  responseCode: Scalars['String']['output'];
  responseMessage: Scalars['String']['output'];
  responseStatus: Scalars['Int']['output'];
  signature: Scalars['String']['output'];
  timestampHeader: Scalars['String']['output'];
};

export type PaymentInboundRequestLogPaged = {
  __typename?: 'PaymentInboundRequestLogPaged';
  items?: Maybe<Array<PaymentInboundRequestLog>>;
  pagination: PaginationResult;
};

export type PaymentInboundRequestLogQopFilterInput = {
  clientKey?: InputMaybe<Scalars['String']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  partnerReferenceNo?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  receivedFrom?: InputMaybe<Scalars['Time']['input']>;
  receivedTo?: InputMaybe<Scalars['Time']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  responseStatus?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentInboundRequestLogQopInput = {
  filters?: InputMaybe<PaymentInboundRequestLogQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PaymentInquiryLog = {
  __typename?: 'PaymentInquiryLog';
  entityAuditMetadata: EntityAuditMetadata;
  httpStatus: Scalars['Int']['output'];
  inquiredAt: Scalars['Time']['output'];
  isSuccess: Scalars['Boolean']['output'];
  latestTransactionStatusCode: Scalars['String']['output'];
  partnerReferenceNo: Scalars['String']['output'];
  paymentInquiryLogID: Scalars['UUID']['output'];
  paymentTransactionID: Scalars['UUID']['output'];
  providerCode: Scalars['String']['output'];
  referenceNo: Scalars['String']['output'];
  requestPayload: Scalars['String']['output'];
  responseCode: Scalars['String']['output'];
  responseMessage: Scalars['String']['output'];
  responsePayload: Scalars['String']['output'];
  serviceCode: Scalars['String']['output'];
  triggeredBy: Scalars['String']['output'];
};

export type PaymentInquiryLogPaged = {
  __typename?: 'PaymentInquiryLogPaged';
  items?: Maybe<Array<PaymentInquiryLog>>;
  pagination: PaginationResult;
};

export type PaymentInquiryLogQopFilterInput = {
  inquiredFrom?: InputMaybe<Scalars['Time']['input']>;
  inquiredTo?: InputMaybe<Scalars['Time']['input']>;
  isSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  latestTransactionStatusCode?: InputMaybe<Scalars['String']['input']>;
  partnerReferenceNo?: InputMaybe<Scalars['String']['input']>;
  paymentTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['String']['input']>;
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentInquiryLogQopInput = {
  filters?: InputMaybe<PaymentInquiryLogQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PaymentProviderConfig = {
  __typename?: 'PaymentProviderConfig';
  baseURL: Scalars['String']['output'];
  channelID: Scalars['String']['output'];
  clientID: Scalars['String']['output'];
  defaultValiditySeconds: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  environment: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  partnerID: Scalars['String']['output'];
  paymentProviderConfigID: Scalars['UUID']['output'];
  providerCode: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  webhookTimestampToleranceSeconds: Scalars['Int']['output'];
};

export type PaymentProviderConfigPaged = {
  __typename?: 'PaymentProviderConfigPaged';
  items?: Maybe<Array<PaymentProviderConfig>>;
  pagination: PaginationResult;
};

export type PaymentProviderConfigQopFilterInput = {
  environment?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentProviderConfigQopInput = {
  filters?: InputMaybe<PaymentProviderConfigQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PaymentProviderConfigUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  partnerID: Scalars['String']['input'];
  paymentProviderConfigID: Scalars['UUID']['input'];
};

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount: Scalars['Float']['output'];
  approvalCode: Scalars['String']['output'];
  branch?: Maybe<Branch>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancelReason: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  currency: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiredAt?: Maybe<Scalars['Time']['output']>;
  externalID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  issuerName: Scalars['String']['output'];
  latestTransactionStatusCode: Scalars['String']['output'];
  merchantID: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['Time']['output']>;
  partnerReferenceNo: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  paymentTransactionID: Scalars['UUID']['output'];
  paymentTransactionNumber: Scalars['String']['output'];
  paymentTransactionType: Scalars['String']['output'];
  providerCode: Scalars['String']['output'];
  qrContent: Scalars['String']['output'];
  qrImage: Scalars['String']['output'];
  referenceNo: Scalars['String']['output'];
  rrn: Scalars['String']['output'];
  sourceDocumentID?: Maybe<Scalars['UUID']['output']>;
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  terminalID: Scalars['String']['output'];
  transactionDatetime: Scalars['Time']['output'];
};

export type PaymentTransactionCancelInput = {
  paymentTransactionID: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentTransactionCheckStatusResult = {
  __typename?: 'PaymentTransactionCheckStatusResult';
  isPaid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  paymentTransaction?: Maybe<PaymentTransaction>;
  paymentTransactionID: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PaymentTransactionCreateDynamicQrisInput = {
  amount: Scalars['Float']['input'];
  branchID: Scalars['UUID']['input'];
  providerCode?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  validitySeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentTransactionPaged = {
  __typename?: 'PaymentTransactionPaged';
  items?: Maybe<Array<PaymentTransaction>>;
  pagination: PaginationResult;
};

export type PaymentTransactionQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdFrom?: InputMaybe<Scalars['Time']['input']>;
  createdTo?: InputMaybe<Scalars['Time']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  partnerReferenceNo?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentTransactionQopInput = {
  filters?: InputMaybe<PaymentTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PaymentWebhookEvent = {
  __typename?: 'PaymentWebhookEvent';
  channelID: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  eventType: Scalars['String']['output'];
  externalID: Scalars['String']['output'];
  headers: Scalars['String']['output'];
  httpMethod: Scalars['String']['output'];
  isDuplicate: Scalars['Boolean']['output'];
  isProcessed: Scalars['Boolean']['output'];
  isValidSignature: Scalars['Boolean']['output'];
  latestTransactionStatusCode: Scalars['String']['output'];
  partnerReferenceNo: Scalars['String']['output'];
  payload: Scalars['String']['output'];
  paymentTransactionID?: Maybe<Scalars['UUID']['output']>;
  paymentWebhookEventID: Scalars['UUID']['output'];
  providerCode: Scalars['String']['output'];
  receivedAt: Scalars['Time']['output'];
  referenceNo: Scalars['String']['output'];
  responseCode: Scalars['String']['output'];
  responseMessage: Scalars['String']['output'];
};

export type PaymentWebhookEventPaged = {
  __typename?: 'PaymentWebhookEventPaged';
  items?: Maybe<Array<PaymentWebhookEvent>>;
  pagination: PaginationResult;
};

export type PaymentWebhookEventQopFilterInput = {
  eventType?: InputMaybe<Scalars['String']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  isValidSignature?: InputMaybe<Scalars['Boolean']['input']>;
  partnerReferenceNo?: InputMaybe<Scalars['String']['input']>;
  paymentTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  receivedFrom?: InputMaybe<Scalars['Time']['input']>;
  receivedTo?: InputMaybe<Scalars['Time']['input']>;
  referenceNo?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentWebhookEventQopInput = {
  filters?: InputMaybe<PaymentWebhookEventQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type Permission = {
  __typename?: 'Permission';
  apps?: Maybe<Array<App>>;
  entityAuditMetadata: EntityAuditMetadata;
  parentResourceID?: Maybe<Scalars['String']['output']>;
  parentResourceName?: Maybe<Scalars['String']['output']>;
  permissionID: Scalars['String']['output'];
  permissionName: Scalars['String']['output'];
  resourceID: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
};

export type PermissionCreateInput = {
  appIDs: Array<InputMaybe<Scalars['String']['input']>>;
  permissionID: Scalars['String']['input'];
  permissionName: Scalars['String']['input'];
  resourceID: Scalars['String']['input'];
};

export type PermissionPaged = {
  __typename?: 'PermissionPaged';
  items?: Maybe<Array<Permission>>;
  pagination: PaginationResult;
};

export type PermissionProfile = {
  __typename?: 'PermissionProfile';
  permissionID: Scalars['String']['output'];
  permissionName: Scalars['String']['output'];
};

export type PermissionQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  resourceID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PermissionQopInput = {
  filters?: InputMaybe<PermissionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PermissionUpdateInput = {
  appIDs: Array<InputMaybe<Scalars['String']['input']>>;
  permissionID: Scalars['String']['input'];
  permissionName: Scalars['String']['input'];
  resourceID: Scalars['String']['input'];
};

export type PettyCashAddFundTransaction = {
  __typename?: 'PettyCashAddFundTransaction';
  amount: Scalars['Float']['output'];
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankJournalAccountCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<PettyCashTransactionFile>>;
  gmt: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  pettyCashAddFundTransactionID: Scalars['UUID']['output'];
  pettyCashAddFundTransactionNumber: Scalars['String']['output'];
  pettyCashTransactionDatetime: Scalars['Time']['output'];
  pettyCashTransactionDatetimeUtc: Scalars['Time']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashAddFundTransactionCreateInput = {
  amount: Scalars['Float']['input'];
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashAddFundTransactionPaged = {
  __typename?: 'PettyCashAddFundTransactionPaged';
  items: Array<PettyCashAddFundTransaction>;
  pagination: PaginationResult;
};

export type PettyCashAddFundTransactionQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashAddFundTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PettyCashAddFundTransactionQopInput = {
  filters?: InputMaybe<PettyCashAddFundTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashAddFundTransactionUpdateInput = {
  amount: Scalars['Float']['input'];
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  pettyCashTransactionID: Scalars['UUID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['UUID']['input'];
};

export type PettyCashBalance = {
  __typename?: 'PettyCashBalance';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  currentBalance: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  lastPettyCashTransactionID: Scalars['UUID']['output'];
  lastPettyCashTransactionLedgerID?: Maybe<Scalars['UUID']['output']>;
  lastPettyCashTransactionNumber: Scalars['String']['output'];
  lastSourceDocumentID: Scalars['UUID']['output'];
  lastSourceDocumentNumber: Scalars['String']['output'];
  lastSourceDocumentType: Scalars['String']['output'];
  pettyCashBalanceID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashBalancePaged = {
  __typename?: 'PettyCashBalancePaged';
  items: Array<PettyCashBalance>;
  pagination: PaginationResult;
};

export type PettyCashBalanceQopFilterInput = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
};

export type PettyCashBalanceQopInput = {
  filters?: InputMaybe<PettyCashBalanceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashExpenseTransaction = {
  __typename?: 'PettyCashExpenseTransaction';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<PettyCashTransactionFile>>;
  gmt: Scalars['Int']['output'];
  items?: Maybe<Array<PettyCashExpenseTransactionItem>>;
  note: Scalars['String']['output'];
  pettyCashExpenseTransactionDatetime: Scalars['Time']['output'];
  pettyCashExpenseTransactionDatetimeUtc: Scalars['Time']['output'];
  pettyCashExpenseTransactionID: Scalars['UUID']['output'];
  pettyCashExpenseTransactionNumber: Scalars['String']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashExpenseTransactionCreateInput = {
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  items: Array<PettyCashExpenseTransactionItemCreateInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashExpenseTransactionItem = {
  __typename?: 'PettyCashExpenseTransactionItem';
  amount: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expenseItemID: Scalars['UUID']['output'];
  expenseItemName: Scalars['String']['output'];
  journalAccountCode: Scalars['String']['output'];
  note: Scalars['String']['output'];
  pettyCashExpenseTransactionID: Scalars['UUID']['output'];
  pettyCashExpenseTransactionItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type PettyCashExpenseTransactionItemCreateInput = {
  expenseItemID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type PettyCashExpenseTransactionItemPaged = {
  __typename?: 'PettyCashExpenseTransactionItemPaged';
  items: Array<PettyCashExpenseTransactionItem>;
  pagination: PaginationResult;
};

export type PettyCashExpenseTransactionItemQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  expenseItemName?: InputMaybe<Scalars['String']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashExpenseTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  qty?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type PettyCashExpenseTransactionItemQopInput = {
  filters?: InputMaybe<PettyCashExpenseTransactionItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashExpenseTransactionItemUpdateInput = {
  expenseItemID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashExpenseTransactionItemID?: InputMaybe<Scalars['UUID']['input']>;
  qty: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

export type PettyCashExpenseTransactionPaged = {
  __typename?: 'PettyCashExpenseTransactionPaged';
  items: Array<PettyCashExpenseTransaction>;
  pagination: PaginationResult;
};

export type PettyCashExpenseTransactionQopFilterInput = {
  pettyCashExpenseTransactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  pettyCashExpenseTransactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  pettyCashExpenseTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashExpenseTransactionQopInput = {
  filters?: InputMaybe<PettyCashExpenseTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashExpenseTransactionUpdateInput = {
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  items: Array<PettyCashExpenseTransactionItemUpdateInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  pettyCashTransactionID: Scalars['UUID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['UUID']['input'];
};

export type PettyCashLedger = {
  __typename?: 'PettyCashLedger';
  amount: Scalars['Float']['output'];
  balanceAfter: Scalars['Float']['output'];
  balanceBefore: Scalars['Float']['output'];
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankJournalAccountCode?: Maybe<Scalars['String']['output']>;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  note: Scalars['String']['output'];
  pettyCashJournalAccountCode?: Maybe<Scalars['String']['output']>;
  pettyCashTransactionID: Scalars['UUID']['output'];
  pettyCashTransactionLedgerID: Scalars['UUID']['output'];
  pettyCashTransactionNumber: Scalars['String']['output'];
  signedAmount: Scalars['Float']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashLedgerPaged = {
  __typename?: 'PettyCashLedgerPaged';
  items: Array<PettyCashLedger>;
  pagination: PaginationResult;
};

export type PettyCashLedgerQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  balanceAfter?: InputMaybe<Scalars['Float']['input']>;
  balanceBefore?: InputMaybe<Scalars['Float']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  signedAmount?: InputMaybe<Scalars['Float']['input']>;
  sourceDocumentID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashLedgerQopInput = {
  filters?: InputMaybe<PettyCashLedgerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashRefundTransaction = {
  __typename?: 'PettyCashRefundTransaction';
  amount: Scalars['Float']['output'];
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankJournalAccountCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<PettyCashTransactionFile>>;
  gmt: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  pettyCashRefundTransactionID: Scalars['UUID']['output'];
  pettyCashRefundTransactionNumber: Scalars['String']['output'];
  pettyCashTransactionDatetime: Scalars['Time']['output'];
  pettyCashTransactionDatetimeUtc: Scalars['Time']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashRefundTransactionCreateInput = {
  amount: Scalars['Float']['input'];
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashRefundTransactionPaged = {
  __typename?: 'PettyCashRefundTransactionPaged';
  items: Array<PettyCashRefundTransaction>;
  pagination: PaginationResult;
};

export type PettyCashRefundTransactionQopFilterInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashRefundTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PettyCashRefundTransactionQopInput = {
  filters?: InputMaybe<PettyCashRefundTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashRefundTransactionUpdateInput = {
  amount: Scalars['Float']['input'];
  bankAccountID: Scalars['UUID']['input'];
  branchID: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<PettyCashTransactionFileInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionDatetime: Scalars['Time']['input'];
  pettyCashTransactionID: Scalars['UUID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['UUID']['input'];
};

export type PettyCashTransaction = {
  __typename?: 'PettyCashTransaction';
  addFundTransaction?: Maybe<PettyCashAddFundTransaction>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expenseTransaction?: Maybe<PettyCashExpenseTransaction>;
  files?: Maybe<Array<PettyCashTransactionFile>>;
  gmt: Scalars['Int']['output'];
  pettyCashJournalAccountCode?: Maybe<Scalars['String']['output']>;
  pettyCashTransactionDatetime: Scalars['Time']['output'];
  pettyCashTransactionDatetimeUtc: Scalars['Time']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  pettyCashTransactionNumber: Scalars['String']['output'];
  refundTransaction?: Maybe<PettyCashRefundTransaction>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashTransactionActionInput = {
  pettyCashTransactionID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type PettyCashTransactionFile = {
  __typename?: 'PettyCashTransactionFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  pettyCashTransactionFileID: Scalars['UUID']['output'];
  pettyCashTransactionFileType: Scalars['String']['output'];
  pettyCashTransactionID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PettyCashTransactionFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType: Scalars['String']['input'];
};

export type PettyCashTransactionFilePaged = {
  __typename?: 'PettyCashTransactionFilePaged';
  items: Array<PettyCashTransactionFile>;
  pagination: PaginationResult;
};

export type PettyCashTransactionFileQopFilterInput = {
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashTransactionFileType?: InputMaybe<Scalars['String']['input']>;
  pettyCashTransactionID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PettyCashTransactionFileQopInput = {
  filters?: InputMaybe<PettyCashTransactionFileQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PettyCashTransactionPaged = {
  __typename?: 'PettyCashTransactionPaged';
  items: Array<PettyCashTransaction>;
  pagination: PaginationResult;
};

export type PettyCashTransactionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  pettyCashTransactionDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  pettyCashTransactionDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  pettyCashTransactionNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PettyCashTransactionQopInput = {
  filters?: InputMaybe<PettyCashTransactionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PickingTask = {
  __typename?: 'PickingTask';
  assignedToUser?: Maybe<User>;
  assignedToUserID?: Maybe<Scalars['UUID']['output']>;
  assignedToUserName?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  completionPercentage: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  pickingTaskDatetime: Scalars['Time']['output'];
  pickingTaskDatetimeUtc: Scalars['Time']['output'];
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskNumber: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskDoneAt?: Maybe<Scalars['Time']['output']>;
  taskDoneAtUtc?: Maybe<Scalars['Time']['output']>;
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  taskStartAtUtc?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyAssigned: Scalars['Decimal']['output'];
  totalQtyExecuted: Scalars['Decimal']['output'];
  tranferOrder?: Maybe<TransferOrder>;
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type PickingTaskAssignInput = {
  assignedToUserID: Scalars['UUID']['input'];
  pickingTaskID: Scalars['UUID']['input'];
};

export type PickingTaskCancelInput = {
  pickingTaskID: Scalars['UUID']['input'];
};

export type PickingTaskExecuteInput = {
  pickingTaskID: Scalars['UUID']['input'];
  pickingTaskItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Decimal']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type PickingTaskExecution = {
  __typename?: 'PickingTaskExecution';
  baseUomQty: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  executedAtUtc: Scalars['Time']['output'];
  pickingTaskExecutionID: Scalars['UUID']['output'];
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskItemID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Decimal']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type PickingTaskExecutionPaged = {
  __typename?: 'PickingTaskExecutionPaged';
  items: Array<PickingTaskExecution>;
  pagination: PaginationResult;
};

export type PickingTaskExecutionQopFilterInput = {
  executedAtEnd?: InputMaybe<Scalars['Time']['input']>;
  executedAtStart?: InputMaybe<Scalars['Time']['input']>;
  pickingTaskExecutionID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskExecutionQopInput = {
  filters?: InputMaybe<PickingTaskExecutionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PickingTaskFinishInput = {
  forceFinish?: InputMaybe<Scalars['Boolean']['input']>;
  pickingTaskID: Scalars['UUID']['input'];
};

export type PickingTaskGenerateBulkInput = {
  tasks: Array<PickingTaskGenerateTaskInput>;
};

export type PickingTaskGenerateByZonePreviewGroup = {
  __typename?: 'PickingTaskGenerateByZonePreviewGroup';
  items: Array<PickingTaskGenerateByZonePreviewItem>;
  totalItems: Scalars['Int']['output'];
  totalQty: Scalars['Decimal']['output'];
  warehouseLocationGroupName?: Maybe<Scalars['String']['output']>;
  warehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
};

export type PickingTaskGenerateByZonePreviewInput = {
  sourceDocumentID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type PickingTaskGenerateByZonePreviewItem = {
  __typename?: 'PickingTaskGenerateByZonePreviewItem';
  baseUomQtyOutstanding: Scalars['Decimal']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyOutstanding: Scalars['Decimal']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
};

export type PickingTaskGenerateByZonePreviewResponse = {
  __typename?: 'PickingTaskGenerateByZonePreviewResponse';
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  groups: Array<PickingTaskGenerateByZonePreviewGroup>;
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
};

export type PickingTaskGenerateInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskDatetime: Scalars['Time']['input'];
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskGenerateItemInput = {
  baseUomQtyAssigned: Scalars['Decimal']['input'];
  productID: Scalars['UUID']['input'];
  qtyAssigned: Scalars['Decimal']['input'];
  sourceDocumentDetailID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskGenerateTaskInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  items: Array<PickingTaskGenerateItemInput>;
  pickingTaskDatetime: Scalars['Time']['input'];
  sourceDocumentID: Scalars['UUID']['input'];
  sourceDocumentType: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskItem = {
  __typename?: 'PickingTaskItem';
  baseUomQtyAssigned: Scalars['Decimal']['output'];
  baseUomQtyExecuted: Scalars['Decimal']['output'];
  baseUomQtyOutstanding: Scalars['Decimal']['output'];
  baseUomQtyUnfulfilled: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executions: Array<PickingTaskExecution>;
  pickingTaskID: Scalars['UUID']['output'];
  pickingTaskItemID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyAssigned: Scalars['Decimal']['output'];
  qtyExecuted: Scalars['Decimal']['output'];
  qtyOutstanding: Scalars['Decimal']['output'];
  qtyUnfulfilled: Scalars['Decimal']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  unfulfilledReason?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Uom>;
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Decimal']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PickingTaskItemPaged = {
  __typename?: 'PickingTaskItemPaged';
  items: Array<PickingTaskItem>;
  pagination: PaginationResult;
};

export type PickingTaskItemQopFilterInput = {
  pickingTaskID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentDetailID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskItemQopInput = {
  filters?: InputMaybe<PickingTaskItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PickingTaskItemUnfulfilledReasonInput = {
  pickingTaskItemID: Scalars['UUID']['input'];
  unfulfilledReason: Scalars['String']['input'];
};

export type PickingTaskPaged = {
  __typename?: 'PickingTaskPaged';
  items: Array<PickingTask>;
  pagination: PaginationResult;
};

export type PickingTaskQopFilterInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  pickingTaskDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  pickingTaskDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  pickingTaskNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PickingTaskQopInput = {
  filters?: InputMaybe<PickingTaskQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PickingTaskStartInput = {
  pickingTaskID: Scalars['UUID']['input'];
};

export type PickingTaskUpdateUnfulfilledReasonsInput = {
  items: Array<PickingTaskItemUnfulfilledReasonInput>;
  pickingTaskID: Scalars['UUID']['input'];
};

export type PosBookmark = {
  __typename?: 'PosBookmark';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  posBookmarkID: Scalars['UUID']['output'];
  posBookmarkName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PosBookmarkCreateInput = {
  isActive?: Scalars['Boolean']['input'];
  posBookmarkName: Scalars['String']['input'];
};

export type PosBookmarkPaged = {
  __typename?: 'PosBookmarkPaged';
  items?: Maybe<Array<PosBookmark>>;
  pagination: PaginationResult;
};

export type PosBookmarkProduct = {
  __typename?: 'PosBookmarkProduct';
  entityAuditMetadata: EntityAuditMetadata;
  posBookmark?: Maybe<PosBookmark>;
  posBookmarkID: Scalars['UUID']['output'];
  posBookmarkName: Scalars['String']['output'];
  posBookmarkProductID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productID?: Maybe<Scalars['UUID']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type PosBookmarkProductCreateInput = {
  posBookmarkID: Scalars['UUID']['input'];
  posBookmarkName: Scalars['String']['input'];
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PosBookmarkProductPaged = {
  __typename?: 'PosBookmarkProductPaged';
  items?: Maybe<Array<PosBookmarkProduct>>;
  pagination: PaginationResult;
};

export type PosBookmarkProductQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  posBookmarkID?: InputMaybe<Scalars['UUID']['input']>;
  posBookmarkName?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PosBookmarkProductQopInput = {
  filters?: InputMaybe<PosBookmarkProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosBookmarkProductUpdateInput = {
  posBookmarkID: Scalars['UUID']['input'];
  posBookmarkName: Scalars['String']['input'];
  posBookmarkProductID: Scalars['UUID']['input'];
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PosBookmarkQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  posBookmarkName?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PosBookmarkQopInput = {
  filters?: InputMaybe<PosBookmarkQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosBookmarkUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  posBookmarkID: Scalars['UUID']['input'];
  posBookmarkName: Scalars['String']['input'];
};

/** PosBranch is retained as a deprecated alias of BranchLite for backwards compatibility. */
export type PosBranch = {
  __typename?: 'PosBranch';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  warehouseID?: Maybe<Scalars['UUID']['output']>;
};

export type PosSalesOrder = {
  __typename?: 'PosSalesOrder';
  adjustmentAmount: Scalars['Float']['output'];
  branchId: Scalars['UUID']['output'];
  cashPaymentAmount: Scalars['Float']['output'];
  createdTime: Scalars['Time']['output'];
  createdTimeUtc: Scalars['Time']['output'];
  createdUserId: Scalars['UUID']['output'];
  createdUserName: Scalars['String']['output'];
  customerId: Scalars['UUID']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastProcessAttemptTimeUtc?: Maybe<Scalars['Time']['output']>;
  memberTypeId: Scalars['UUID']['output'];
  nonCashPaymentAmount: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentChangeAmount: Scalars['Float']['output'];
  paymentReceivedAmount: Scalars['Float']['output'];
  posSalesOrderDatetime: Scalars['Time']['output'];
  posSalesOrderId: Scalars['UUID']['output'];
  posSalesOrderNumber: Scalars['String']['output'];
  processRemark?: Maybe<Scalars['String']['output']>;
  processStatus?: Maybe<Scalars['String']['output']>;
  processedTimeUtc?: Maybe<Scalars['Time']['output']>;
  retryCount: Scalars['Int']['output'];
  salesChannelId: Scalars['String']['output'];
  shiftSessionId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  syncError?: Maybe<Scalars['String']['output']>;
  taxAmount: Scalars['Float']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  updatedTime: Scalars['Time']['output'];
  updatedUserId: Scalars['UUID']['output'];
  updatedUserName: Scalars['String']['output'];
};

export type PosSalesOrderCreateInput = {
  adjustmentAmount: Scalars['Float']['input'];
  branchId: Scalars['UUID']['input'];
  cashPaymentAmount: Scalars['Float']['input'];
  createdTime: Scalars['Time']['input'];
  createdUserId: Scalars['UUID']['input'];
  createdUserName: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  items: Array<PosSalesOrderItemInput>;
  marketplace?: InputMaybe<PosSalesOrderMarketplaceInput>;
  memberTypeId?: InputMaybe<Scalars['UUID']['input']>;
  nonCashPaymentAmount: Scalars['Float']['input'];
  noteInternal: Scalars['String']['input'];
  paymentAmount: Scalars['Float']['input'];
  paymentChangeAmount: Scalars['Float']['input'];
  paymentReceivedAmount: Scalars['Float']['input'];
  payments: Array<PosSalesOrderPaymentInput>;
  posSalesOrderDatetime: Scalars['Time']['input'];
  posSalesOrderId: Scalars['UUID']['input'];
  posSalesOrderNumber: Scalars['String']['input'];
  salesChannelId?: InputMaybe<Scalars['String']['input']>;
  shiftSessionId: Scalars['String']['input'];
  status: Scalars['String']['input'];
  subtotal: Scalars['Float']['input'];
  subtotalAfterDiscount: Scalars['Float']['input'];
  taxAmount: Scalars['Float']['input'];
  taxIncluded: Scalars['Boolean']['input'];
  taxItems: Scalars['String']['input'];
  taxableAmount: Scalars['Float']['input'];
  total: Scalars['Float']['input'];
  totalItemQty: Scalars['Float']['input'];
  updatedTime: Scalars['Time']['input'];
  updatedUserId: Scalars['UUID']['input'];
  updatedUserName: Scalars['String']['input'];
  voucherAmount: Scalars['Float']['input'];
  vouchers?: InputMaybe<Array<PosSalesOrderVoucherInput>>;
};

export type PosSalesOrderItemInput = {
  additionalDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  additionalDiscountPerc?: InputMaybe<Scalars['Float']['input']>;
  addonComponents?: InputMaybe<Scalars['String']['input']>;
  baseUomQty?: InputMaybe<Scalars['Float']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  commissionAmount?: InputMaybe<Scalars['Float']['input']>;
  consignmentCommissionFeePerc?: InputMaybe<Scalars['Float']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  createdTime: Scalars['Time']['input'];
  createdUserId: Scalars['UUID']['input'];
  createdUserName: Scalars['String']['input'];
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountPerc?: InputMaybe<Scalars['Float']['input']>;
  discountPercPlus?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  effectiveTaxRate?: InputMaybe<Scalars['Float']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  isPromoItem?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  posSalesOrderID: Scalars['UUID']['input'];
  posSalesOrderItemID: Scalars['UUID']['input'];
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoParentItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoParentProductID?: InputMaybe<Scalars['UUID']['input']>;
  promoRowType?: InputMaybe<Scalars['String']['input']>;
  promoType?: InputMaybe<Scalars['String']['input']>;
  qty?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtotalBeforeDiscount?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  taxItems?: InputMaybe<Scalars['String']['input']>;
  taxableAmount?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  totalCalculatedDiscount?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomConvertionDecimal?: InputMaybe<Scalars['Int']['input']>;
  uomConvertionRate?: InputMaybe<Scalars['Float']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  updatedTime: Scalars['Time']['input'];
  updatedUserId: Scalars['UUID']['input'];
  updatedUserName: Scalars['String']['input'];
  vendorShareAmount?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Jejak order marketplace di balik sebuah sales order POS. Null untuk order
 * reguler. Isinya adalah POTRET saat POS menandai order siap, bukan sumber
 * kebenaran: sumber kebenarannya tetap tabel marketplace_order, yang dijangkau
 * lewat marketplaceOrderId.
 */
export type PosSalesOrderMarketplaceInput = {
  acceptedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  deliveryFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  externalOrderId: Scalars['String']['input'];
  isEdited?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceOrderId?: InputMaybe<Scalars['UUID']['input']>;
  /** JSON: rincian yang tidak pernah jadi predikat query. */
  metadata?: InputMaybe<Scalars['String']['input']>;
  orderDatetimeUtc?: InputMaybe<Scalars['Time']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  readyMarkedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  receivedAtUtc?: InputMaybe<Scalars['Time']['input']>;
  shortOrderNumber?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type PosSalesOrderPaged = {
  __typename?: 'PosSalesOrderPaged';
  items?: Maybe<Array<PosSalesOrder>>;
  pagination: PaginationResult;
};

export type PosSalesOrderPaymentInput = {
  authCode?: InputMaybe<Scalars['String']['input']>;
  bankReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  branchQrisMerchantID?: InputMaybe<Scalars['UUID']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  createdTime: Scalars['Time']['input'];
  createdUserId: Scalars['UUID']['input'];
  createdUserName: Scalars['String']['input'];
  edcTerminalID?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentMethodID?: InputMaybe<Scalars['UUID']['input']>;
  paymentMethodTypeID?: InputMaybe<Scalars['UUID']['input']>;
  paymentTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  posSalesOrderID: Scalars['UUID']['input'];
  posSalesOrderPaymentID: Scalars['UUID']['input'];
  updatedTime: Scalars['Time']['input'];
  updatedUserId: Scalars['UUID']['input'];
  updatedUserName: Scalars['String']['input'];
};

export type PosSalesOrderQopFilterInput = {
  branchId?: InputMaybe<Scalars['UUID']['input']>;
  createdTimeUtc?: InputMaybe<Scalars['Time']['input']>;
  customerId?: InputMaybe<Scalars['UUID']['input']>;
  posSalesOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  posSalesOrderNumber?: InputMaybe<Scalars['String']['input']>;
  processStatus?: InputMaybe<Scalars['String']['input']>;
  salesChannelId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PosSalesOrderQopInput = {
  filters?: InputMaybe<PosSalesOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosSalesOrderUpdateInput = {
  id: Scalars['UUID']['input'];
};

export type PosSalesOrderVoucherInput = {
  createdTime: Scalars['Time']['input'];
  createdUserId: Scalars['UUID']['input'];
  createdUserName: Scalars['String']['input'];
  isDeleted: Scalars['Boolean']['input'];
  posSalesOrderID: Scalars['UUID']['input'];
  posSalesOrderVoucherID: Scalars['UUID']['input'];
  status: Scalars['String']['input'];
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedTime: Scalars['Time']['input'];
  updatedUserId: Scalars['UUID']['input'];
  updatedUserName: Scalars['String']['input'];
  validationReason?: InputMaybe<Scalars['String']['input']>;
  validationStatus: Scalars['String']['input'];
  voucherAmount: Scalars['Float']['input'];
  voucherCode: Scalars['String']['input'];
  voucherID?: InputMaybe<Scalars['UUID']['input']>;
  voucherItemCode: Scalars['String']['input'];
  voucherItemID?: InputMaybe<Scalars['UUID']['input']>;
  voucherName?: InputMaybe<Scalars['String']['input']>;
  voucherValue: Scalars['Float']['input'];
};

/** A poster program: a named, scheduled, branch-targeted set of images. */
export type Poster = {
  __typename?: 'Poster';
  /** Ignored while isDefault, but kept. See the isAllBranches description. */
  branches?: Maybe<Array<PosterBranchRef>>;
  /** Paired with startAt. See the startAt description. */
  endAt?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  /** The images in this program, already in read order. A program always has at least one. */
  images: Array<PosterImage>;
  /** The only run/stop signal. A cron switches this off once endAt passes, so an expired program is an inactive one; a program whose startAt is still ahead stays active and simply is not eligible yet. */
  isActive: Scalars['Boolean']['output'];
  /** Ignored while isDefault, but kept: it applies again if the main-poster flag moves elsewhere. */
  isAllBranches: Scalars['Boolean']['output'];
  /** The main poster: always shown, in every branch, at any time. Ignores branches and the schedule while set. */
  isDefault: Scalars['Boolean']['output'];
  posterID: Scalars['UUID']['output'];
  posterName: Scalars['String']['output'];
  /** Orders programs for POS, 1-5; lower runs first. Unique among active programs whose branches and schedule overlap; the main poster counts as all-branches with no schedule. */
  priority: Scalars['Int']['output'];
  /** Paired with endAt: both empty means the program is always shown. */
  startAt?: Maybe<Scalars['Time']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type PosterBranchRef = {
  __typename?: 'PosterBranchRef';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  branchName?: Maybe<Scalars['String']['output']>;
};

export type PosterBranchRefInput = {
  branchID: Scalars['UUID']['input'];
};

export type PosterCreateInput = {
  branches?: InputMaybe<Array<PosterBranchRefInput>>;
  endAt?: InputMaybe<Scalars['Time']['input']>;
  /** At least one image is required: a program can never be empty. */
  images: Array<PosterImageInput>;
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  posterName: Scalars['String']['input'];
  /** 1-5, lower runs first. Must be free among active programs whose branches and schedule overlap. */
  priority: Scalars['Int']['input'];
  /** Leave startAt and endAt both empty for a program that is always shown; filling one requires the other. */
  startAt?: InputMaybe<Scalars['Time']['input']>;
};

/** One image inside a poster program. Synced to POS as its own stream and joined locally on posterID. */
export type PosterImage = {
  __typename?: 'PosterImage';
  displayDurationSeconds: Scalars['Int']['output'];
  /** Sort hint within the program; deliberately not unique. Ties break on createdAt then posterImageID. */
  displayOrder: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  file?: Maybe<File>;
  fileID: Scalars['UUID']['output'];
  /** Optional admin label. The uploaded filename lives on the file and is resolved on read. */
  imageLabel?: Maybe<Scalars['String']['output']>;
  /** Signed imgproxy URL rendered at poster size (1920x2160). Built on read. */
  imageURL: Scalars['String']['output'];
  posterID: Scalars['UUID']['output'];
  posterImageID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PosterImageInput = {
  /** 3-60 seconds. Defaults to 10 when omitted. */
  displayDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  displayOrder: Scalars['Int']['input'];
  fileID: Scalars['UUID']['input'];
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Omit to add a new image. Supply an existing id to keep that row's identity across the edit. */
  posterImageID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PosterImagePaged = {
  __typename?: 'PosterImagePaged';
  items: Array<PosterImage>;
  pagination: PaginationResult;
};

export type PosterImageQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  posterID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PosterImageQopInput = {
  filters?: InputMaybe<PosterImageQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosterPaged = {
  __typename?: 'PosterPaged';
  items: Array<Poster>;
  pagination: PaginationResult;
};

export type PosterQopFilterInput = {
  /** Matches posters targeting this branch, all-branch posters included. Resolved in the repository via jsonb containment. */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  posterName?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PosterQopInput = {
  filters?: InputMaybe<PosterQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PosterUpdateInput = {
  branches?: InputMaybe<Array<PosterBranchRefInput>>;
  endAt?: InputMaybe<Scalars['Time']['input']>;
  /** Omit to leave the images untouched. When supplied it replaces the set and must not be empty. */
  images?: InputMaybe<Array<PosterImageInput>>;
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  posterID: Scalars['UUID']['input'];
  posterName: Scalars['String']['input'];
  /** 1-5, lower runs first. Must be free among active programs whose branches and schedule overlap. */
  priority: Scalars['Int']['input'];
  /** Leave startAt and endAt both empty for a program that is always shown; filling one requires the other. */
  startAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PriceTagItem = {
  __typename?: 'PriceTagItem';
  barcode: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPercent: Scalars['Float']['output'];
  finalPrice: Scalars['Float']['output'];
  found: Scalars['Boolean']['output'];
  isConsignment: Scalars['Boolean']['output'];
  nominalPrice: Scalars['Float']['output'];
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  promoName: Scalars['String']['output'];
  promoTypeName: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
};

export type Pricelist = {
  __typename?: 'Pricelist';
  channelMarkups: Array<PricelistChannelMarkup>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  pricelistCode: Scalars['String']['output'];
  pricelistId: Scalars['UUID']['output'];
  pricelistName: Scalars['String']['output'];
  pricelistPeriods: Array<PricelistPeriod>;
  uniqueKey: Scalars['String']['output'];
};

export type PricelistChannelMarkup = {
  __typename?: 'PricelistChannelMarkup';
  markupPerc: Scalars['Float']['output'];
  markupSource: Scalars['String']['output'];
  pricelistSalesChannel?: Maybe<PricelistSalesChannel>;
  salesChannel: SalesChannel;
  salesChannelID: Scalars['String']['output'];
};

export type PricelistCreateInput = {
  isActive: Scalars['Boolean']['input'];
  pricelistCode: Scalars['String']['input'];
  pricelistName: Scalars['String']['input'];
  pricelistPeriods: Array<PricelistPeriodCreateFromPricelistInput>;
};

export type PricelistDeleteInput = {
  pricelistId: Scalars['UUID']['input'];
};

export type PricelistPaged = {
  __typename?: 'PricelistPaged';
  items: Array<Pricelist>;
  pagination: PaginationResult;
};

export type PricelistPeriod = {
  __typename?: 'PricelistPeriod';
  effectiveEndDate: Scalars['Time']['output'];
  effectiveEndHour?: Maybe<Scalars['Int']['output']>;
  effectiveEndMinute?: Maybe<Scalars['Int']['output']>;
  effectiveStartDate: Scalars['Time']['output'];
  effectiveStartHour?: Maybe<Scalars['Int']['output']>;
  effectiveStartMinute?: Maybe<Scalars['Int']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  pricelist: Pricelist;
  pricelistID: Scalars['UUID']['output'];
  pricelistPeriodID: Scalars['UUID']['output'];
  pricelistPeriodName: Scalars['String']['output'];
  pricelistProducts: Array<PricelistProduct>;
  priority: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
  useTime: Scalars['Boolean']['output'];
};

export type PricelistPeriodCreateFromPricelistInput = {
  effectiveEndDate: Scalars['Time']['input'];
  effectiveEndHour?: InputMaybe<Scalars['Int']['input']>;
  effectiveEndMinute?: InputMaybe<Scalars['Int']['input']>;
  effectiveStartDate: Scalars['Time']['input'];
  effectiveStartHour?: InputMaybe<Scalars['Int']['input']>;
  effectiveStartMinute?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistPeriodName: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  useTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricelistPeriodCreateInput = {
  effectiveEndDate: Scalars['Time']['input'];
  effectiveEndHour: Scalars['Int']['input'];
  effectiveEndMinute: Scalars['Int']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  effectiveStartHour: Scalars['Int']['input'];
  effectiveStartMinute: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodName: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  useTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricelistPeriodPaged = {
  __typename?: 'PricelistPeriodPaged';
  items?: Maybe<Array<PricelistPeriod>>;
  pagination: PaginationResult;
};

export type PricelistPeriodQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistPeriodName?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  useTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricelistPeriodQopInput = {
  filters?: InputMaybe<PricelistPeriodQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistPeriodUpdateInput = {
  effectiveEndDate: Scalars['Time']['input'];
  effectiveEndHour: Scalars['Int']['input'];
  effectiveEndMinute: Scalars['Int']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  effectiveStartHour: Scalars['Int']['input'];
  effectiveStartMinute: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  pricelistPeriodName: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  useTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PricelistProduct = {
  __typename?: 'PricelistProduct';
  entityAuditMetadata: EntityAuditMetadata;
  pricelist: Pricelist;
  pricelistID: Scalars['UUID']['output'];
  pricelistPeriod: PricelistPeriod;
  pricelistPeriodID: Scalars['UUID']['output'];
  pricelistProductID: Scalars['UUID']['output'];
  pricelistProductSalesChannels: Array<PricelistProductSalesChannel>;
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  salesChannelPrice?: Maybe<Scalars['String']['output']>;
  salesChannelPrices: Array<PricelistProductChannelPrice>;
  sellingPrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PricelistProductBulkCreateInput = {
  items: Array<PricelistProductCreateInput>;
};

export type PricelistProductChannelPrice = {
  __typename?: 'PricelistProductChannelPrice';
  autoSellingPrice: Scalars['Float']['output'];
  effectiveSellingPrice: Scalars['Float']['output'];
  priceSource: Scalars['String']['output'];
  pricelistProductSalesChannel?: Maybe<PricelistProductSalesChannel>;
  salesChannel: SalesChannel;
  salesChannelID: Scalars['String']['output'];
};

export type PricelistProductCreateInput = {
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  productID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelPrice?: InputMaybe<Scalars['String']['input']>;
  sellingPrice: Scalars['Float']['input'];
};

export type PricelistProductDeleteInput = {
  pricelistProductID: Scalars['UUID']['input'];
};

export type PricelistProductImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PricelistProductImportFileMappingInput = {
  columns: Array<PricelistProductImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type PricelistProductImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: PricelistProductImportFileMappingInput;
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
};

export type PricelistProductImportResult = {
  __typename?: 'PricelistProductImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type PricelistProductImportRowReport = {
  __typename?: 'PricelistProductImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<PricelistProductImportRowViolation>;
};

export type PricelistProductImportRowViolation = {
  __typename?: 'PricelistProductImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PricelistProductImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: PricelistProductImportFileMappingInput;
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
};

export type PricelistProductImportValidateResult = {
  __typename?: 'PricelistProductImportValidateResult';
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: PricelistProductImportRowReport;
};

export type PricelistProductPaged = {
  __typename?: 'PricelistProductPaged';
  items: Array<PricelistProduct>;
  pagination: PaginationResult;
};

export type PricelistProductQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtBefore?: InputMaybe<Scalars['Time']['input']>;
  createdByUserID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistPeriodID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistProductID?: InputMaybe<Scalars['UUID']['input']>;
  productBrandID?: InputMaybe<Scalars['UUID']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productSourceID?: InputMaybe<Scalars['UUID']['input']>;
  productSubCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productSubDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  searchKeyFull?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtBefore?: InputMaybe<Scalars['Time']['input']>;
  updatedByUserID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PricelistProductQopInput = {
  filters?: InputMaybe<PricelistProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistProductSalesChannel = {
  __typename?: 'PricelistProductSalesChannel';
  customSellingPrice: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  pricelist?: Maybe<Pricelist>;
  pricelistID: Scalars['UUID']['output'];
  pricelistPeriodID: Scalars['UUID']['output'];
  pricelistProduct?: Maybe<PricelistProduct>;
  pricelistProductID: Scalars['UUID']['output'];
  pricelistProductSalesChannelID: Scalars['UUID']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  salesChannel?: Maybe<SalesChannel>;
  salesChannelID: Scalars['String']['output'];
  sellingPrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PricelistProductSalesChannelCreateInput = {
  customSellingPrice: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  pricelistProductID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type PricelistProductSalesChannelPaged = {
  __typename?: 'PricelistProductSalesChannelPaged';
  items?: Maybe<Array<PricelistProductSalesChannel>>;
  pagination: PaginationResult;
};

export type PricelistProductSalesChannelQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customSellingPrice?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistPeriodID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistProductID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCode?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PricelistProductSalesChannelQopInput = {
  filters?: InputMaybe<PricelistProductSalesChannelQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistProductSalesChannelUpdateInput = {
  customSellingPrice: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  pricelistProductID: Scalars['UUID']['input'];
  pricelistProductSalesChannelID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type PricelistProductSalesChannelUpsertInput = {
  customSellingPrice: Scalars['Float']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistProductID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type PricelistProductUpdateInput = {
  pricelistID: Scalars['UUID']['input'];
  pricelistPeriodID: Scalars['UUID']['input'];
  pricelistProductID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  salesChannelPrice?: InputMaybe<Scalars['String']['input']>;
  sellingPrice: Scalars['Float']['input'];
};

export type PricelistQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pricelistCode?: InputMaybe<Scalars['String']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistName?: InputMaybe<Scalars['String']['input']>;
  pricelistPeriodID?: InputMaybe<Scalars['UUID']['input']>;
  productBrandID?: InputMaybe<Scalars['UUID']['input']>;
  productCategory?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productSourceID?: InputMaybe<Scalars['UUID']['input']>;
  productSubCategory?: InputMaybe<Scalars['String']['input']>;
  productSubDepartment?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PricelistQopInput = {
  filters?: InputMaybe<PricelistQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistSalesChannel = {
  __typename?: 'PricelistSalesChannel';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  priceMarkupPerc: Scalars['Float']['output'];
  pricelistID: Scalars['UUID']['output'];
  pricelistSalesChannelID: Scalars['UUID']['output'];
  salesChannel?: Maybe<SalesChannel>;
  salesChannelID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PricelistSalesChannelPaged = {
  __typename?: 'PricelistSalesChannelPaged';
  items?: Maybe<Array<PricelistSalesChannel>>;
  pagination: PaginationResult;
};

export type PricelistSalesChannelQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  priceMarkupPerc?: InputMaybe<Scalars['Float']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PricelistSalesChannelQopInput = {
  filters?: InputMaybe<PricelistSalesChannelQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PricelistSalesChannelUpsertInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  priceMarkupPerc: Scalars['Float']['input'];
  pricelistID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type PricelistTagPricesInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistID?: InputMaybe<Scalars['UUID']['input']>;
  pricelistPeriodID?: InputMaybe<Scalars['UUID']['input']>;
  skus: Array<Scalars['String']['input']>;
};

export type PricelistUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  pricelistCode: Scalars['String']['input'];
  pricelistId: Scalars['UUID']['input'];
  pricelistName: Scalars['String']['input'];
  pricelistPeriods?: InputMaybe<Array<PricelistPeriodCreateFromPricelistInput>>;
};

export type Product = {
  __typename?: 'Product';
  addonGroup?: Maybe<ProductAddonGroup>;
  addonGroupID?: Maybe<Scalars['UUID']['output']>;
  altBarcode1?: Maybe<Scalars['String']['output']>;
  altBarcode2?: Maybe<Scalars['String']['output']>;
  barcode: Scalars['String']['output'];
  baseUom?: Maybe<Uom>;
  baseUomID: Scalars['UUID']['output'];
  baseUomPurchaseCost?: Maybe<Scalars['Float']['output']>;
  canBePurchased: Scalars['Boolean']['output'];
  canBeSold: Scalars['Boolean']['output'];
  consignmentVendor?: Maybe<Vendor>;
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  country?: Maybe<Country>;
  countryID?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  hasAddon: Scalars['Boolean']['output'];
  inventoryTrackingType: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isConsignment: Scalars['Boolean']['output'];
  isProduced: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  mainImageFile: File;
  mainImageFileID?: Maybe<Scalars['UUID']['output']>;
  mainImageFileLargePathURL?: Maybe<Scalars['String']['output']>;
  mainImageFileMediumPathURL?: Maybe<Scalars['String']['output']>;
  mainImageFileSmallPathURL?: Maybe<Scalars['String']['output']>;
  minimumOrder: Scalars['Float']['output'];
  pricelistProducts: Array<PricelistProduct>;
  productAIImages: Array<ProductAiImage>;
  productAccountingCategory?: Maybe<ProductAccountingCategory>;
  productAccountingCategoryErpRefID?: Maybe<Scalars['String']['output']>;
  productAccountingCategoryErpRefName?: Maybe<Scalars['String']['output']>;
  productAccountingCategoryID?: Maybe<Scalars['UUID']['output']>;
  productAvailabilityTemplateItems: Array<ProductAvailabilityTemplateItem>;
  productBarcodeMaps: Array<ProductBarcodeMap>;
  productBrand?: Maybe<ProductBrand>;
  productBrandID: Scalars['UUID']['output'];
  productBundleComponents: Array<ProductBundleComponent>;
  productCategory?: Maybe<ProductCategory>;
  productCategoryID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productFiles: Array<ProductFile>;
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productNameAlias: Scalars['String']['output'];
  productSource?: Maybe<ProductSource>;
  productSourceID: Scalars['UUID']['output'];
  productSubCategory?: Maybe<ProductSubCategory>;
  productSubCategoryID: Scalars['UUID']['output'];
  productTagProducts: Array<ProductTagProduct>;
  productType: Scalars['String']['output'];
  productVendors: Array<ProductVendor>;
  purchaseCost?: Maybe<Scalars['Float']['output']>;
  purchaseTax?: Maybe<Tax>;
  purchaseTaxID?: Maybe<Scalars['UUID']['output']>;
  purchaseUom?: Maybe<Uom>;
  purchaseUomID?: Maybe<Scalars['UUID']['output']>;
  salesScanType?: Maybe<Scalars['String']['output']>;
  salesTax?: Maybe<Tax>;
  salesTaxID?: Maybe<Scalars['UUID']['output']>;
  salesUom?: Maybe<Uom>;
  salesUomID?: Maybe<Scalars['UUID']['output']>;
  sellingPrice?: Maybe<Scalars['Float']['output']>;
  trackExpiredDate: Scalars['Boolean']['output'];
  trackStock: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  volumeHeight: Scalars['Float']['output'];
  volumeLength: Scalars['Float']['output'];
  volumeWidth: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type ProductAiImage = {
  __typename?: 'ProductAIImage';
  aiImageType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  productAIImageID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAiImageCreateInput = {
  aiImageType: Scalars['String']['input'];
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL: Scalars['String']['input'];
  imageFileMediumPathURL: Scalars['String']['input'];
  imageFileSmallPathURL: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductAiImageInput = {
  aiImageType: Scalars['String']['input'];
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL?: InputMaybe<Scalars['String']['input']>;
  imageFileMediumPathURL?: InputMaybe<Scalars['String']['input']>;
  imageFileSmallPathURL?: InputMaybe<Scalars['String']['input']>;
  productAIImageID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductAiImagePaged = {
  __typename?: 'ProductAIImagePaged';
  items?: Maybe<Array<ProductAiImage>>;
  pagination: PaginationResult;
};

export type ProductAiImageQopFilterInput = {
  aiImageType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAiImageQopInput = {
  filters?: InputMaybe<ProductAiImageQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAiImageUpdateInput = {
  aiImageType: Scalars['String']['input'];
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL: Scalars['String']['input'];
  imageFileMediumPathURL: Scalars['String']['input'];
  imageFileSmallPathURL: Scalars['String']['input'];
  productAIImageID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductAccountingCategory = {
  __typename?: 'ProductAccountingCategory';
  entityAuditMetadata: EntityAuditMetadata;
  erpRefID?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  productAccountingCategoryID: Scalars['UUID']['output'];
  productAccountingCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAccountingCategoryCreateInput = {
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  productAccountingCategoryName: Scalars['String']['input'];
};

export type ProductAccountingCategoryPaged = {
  __typename?: 'ProductAccountingCategoryPaged';
  items?: Maybe<Array<ProductAccountingCategory>>;
  pagination: PaginationResult;
};

export type ProductAccountingCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productAccountingCategoryName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAccountingCategoryQopInput = {
  filters?: InputMaybe<ProductAccountingCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAccountingCategoryUpdateInput = {
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  productAccountingCategoryID: Scalars['UUID']['input'];
  productAccountingCategoryName: Scalars['String']['input'];
};

export type ProductAddon = {
  __typename?: 'ProductAddon';
  components?: Maybe<Array<ProductAddonComponent>>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isMultiple: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  maxQty?: Maybe<Scalars['Int']['output']>;
  minQty?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  productAddonID: Scalars['UUID']['output'];
  showQty: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAddonComponent = {
  __typename?: 'ProductAddonComponent';
  baseUomQty: Scalars['Float']['output'];
  customSellingPrice: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  priceType: Scalars['String']['output'];
  product?: Maybe<Product>;
  productAddonComponentID: Scalars['UUID']['output'];
  productAddonID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ProductAddonComponentCreateInput = {
  baseUomQty: Scalars['Float']['input'];
  customSellingPrice: Scalars['Float']['input'];
  priceType: Scalars['String']['input'];
  productAddonID: Scalars['UUID']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomConversionDecimal: Scalars['Int']['input'];
  uomConvertionRate: Scalars['Float']['input'];
  uomDecimal: Scalars['Int']['input'];
  uomID: Scalars['UUID']['input'];
  uomName: Scalars['String']['input'];
};

export type ProductAddonComponentInAddonInput = {
  customSellingPrice: Scalars['Float']['input'];
  priceType: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomConversionDecimal: Scalars['Int']['input'];
  uomConvertionRate: Scalars['Float']['input'];
  uomDecimal: Scalars['Int']['input'];
  uomID: Scalars['UUID']['input'];
  uomName: Scalars['String']['input'];
};

export type ProductAddonComponentPaged = {
  __typename?: 'ProductAddonComponentPaged';
  items: Array<ProductAddonComponent>;
  pagination: PaginationResult;
};

export type ProductAddonComponentQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  priceType?: InputMaybe<Scalars['String']['input']>;
  productAddonID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAddonComponentQopInput = {
  filters?: InputMaybe<ProductAddonComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAddonComponentUpdateInput = {
  baseUomQty: Scalars['Float']['input'];
  customSellingPrice: Scalars['Float']['input'];
  priceType: Scalars['String']['input'];
  productAddonComponentID: Scalars['UUID']['input'];
  productAddonID: Scalars['UUID']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  sequence: Scalars['Int']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomConversionDecimal: Scalars['Int']['input'];
  uomConvertionRate: Scalars['Float']['input'];
  uomDecimal: Scalars['Int']['input'];
  uomID: Scalars['UUID']['input'];
  uomName: Scalars['String']['input'];
};

export type ProductAddonCreateInput = {
  components?: InputMaybe<Array<ProductAddonComponentInAddonInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMultiple: Scalars['Boolean']['input'];
  isRequired: Scalars['Boolean']['input'];
  maxQty?: InputMaybe<Scalars['Int']['input']>;
  minQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  showQty: Scalars['Boolean']['input'];
};

export type ProductAddonGroup = {
  __typename?: 'ProductAddonGroup';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productAddonGroupID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAddonGroupCreateInput = {
  addons?: InputMaybe<Array<ProductAddonGroupItemCreateInGroupInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ProductAddonGroupItem = {
  __typename?: 'ProductAddonGroupItem';
  entityAuditMetadata: EntityAuditMetadata;
  productAddon: ProductAddon;
  productAddonGroupID: Scalars['UUID']['output'];
  productAddonGroupItemID: Scalars['UUID']['output'];
  productAddonID: Scalars['UUID']['output'];
  sequence: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAddonGroupItemCreateInGroupInput = {
  productAddonID: Scalars['UUID']['input'];
};

export type ProductAddonGroupItemCreateInput = {
  productAddonGroupID: Scalars['UUID']['input'];
  productAddonID: Scalars['UUID']['input'];
  sequence: Scalars['Int']['input'];
};

export type ProductAddonGroupItemPaged = {
  __typename?: 'ProductAddonGroupItemPaged';
  items?: Maybe<Array<ProductAddonGroupItem>>;
  pagination: PaginationResult;
};

export type ProductAddonGroupItemQopFilterInput = {
  productAddonGroupID?: InputMaybe<Scalars['UUID']['input']>;
  productAddonID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductAddonGroupItemQopInput = {
  filters?: InputMaybe<ProductAddonGroupItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAddonGroupItemUpdateInput = {
  productAddonGroupID: Scalars['UUID']['input'];
  productAddonGroupItemID: Scalars['UUID']['input'];
  productAddonID: Scalars['UUID']['input'];
  sequence: Scalars['Int']['input'];
};

export type ProductAddonGroupPaged = {
  __typename?: 'ProductAddonGroupPaged';
  items?: Maybe<Array<ProductAddonGroup>>;
  pagination: PaginationResult;
};

export type ProductAddonGroupQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAddonGroupQopInput = {
  filters?: InputMaybe<ProductAddonGroupQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAddonGroupUpdateInput = {
  addons?: InputMaybe<Array<ProductAddonGroupItemCreateInGroupInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  productAddonGroupID: Scalars['UUID']['input'];
};

export type ProductAddonPaged = {
  __typename?: 'ProductAddonPaged';
  items?: Maybe<Array<ProductAddon>>;
  pagination: PaginationResult;
};

export type ProductAddonQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAddonQopInput = {
  filters?: InputMaybe<ProductAddonQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAddonUpdateInput = {
  components?: InputMaybe<Array<ProductAddonComponentInAddonInput>>;
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isMultiple: Scalars['Boolean']['input'];
  isRequired: Scalars['Boolean']['input'];
  maxQty?: InputMaybe<Scalars['Int']['input']>;
  minQty?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  productAddonID: Scalars['UUID']['input'];
  showQty: Scalars['Boolean']['input'];
};

export type ProductAvailabilityTemplate = {
  __typename?: 'ProductAvailabilityTemplate';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productAvailabilityTemplateID: Scalars['UUID']['output'];
  productAvailabilityTemplateName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductAvailabilityTemplateCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productAvailabilityTemplateName: Scalars['String']['input'];
};

export type ProductAvailabilityTemplateItem = {
  __typename?: 'ProductAvailabilityTemplateItem';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product: Product;
  productAvailabilityTemplate?: Maybe<ProductAvailabilityTemplate>;
  productAvailabilityTemplateID: Scalars['UUID']['output'];
  productAvailabilityTemplateItemID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  salesChannelIDs: Array<Scalars['String']['output']>;
  uniqueKey: Scalars['String']['output'];
};

export type ProductAvailabilityTemplateItemCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productAvailabilityTemplateID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplateItemExportResult = {
  __typename?: 'ProductAvailabilityTemplateItemExportResult';
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type ProductAvailabilityTemplateItemImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProductAvailabilityTemplateItemImportFileMappingInput = {
  columns: Array<ProductAvailabilityTemplateItemImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductAvailabilityTemplateItemImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductAvailabilityTemplateItemImportFileMappingInput;
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplateItemImportResult = {
  __typename?: 'ProductAvailabilityTemplateItemImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type ProductAvailabilityTemplateItemImportRowReport = {
  __typename?: 'ProductAvailabilityTemplateItemImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<ProductAvailabilityTemplateItemImportRowViolation>;
};

export type ProductAvailabilityTemplateItemImportRowViolation = {
  __typename?: 'ProductAvailabilityTemplateItemImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductAvailabilityTemplateItemImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductAvailabilityTemplateItemImportFileMappingInput;
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplateItemImportValidateResult = {
  __typename?: 'ProductAvailabilityTemplateItemImportValidateResult';
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: ProductAvailabilityTemplateItemImportRowReport;
};

export type ProductAvailabilityTemplateItemInput = {
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplateItemPaged = {
  __typename?: 'ProductAvailabilityTemplateItemPaged';
  items?: Maybe<Array<ProductAvailabilityTemplateItem>>;
  pagination: PaginationResult;
};

export type ProductAvailabilityTemplateItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productAvailabilityTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAvailabilityTemplateItemQopInput = {
  filters?: InputMaybe<ProductAvailabilityTemplateItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAvailabilityTemplateItemSetChannelsInput = {
  productAvailabilityTemplateItemID: Scalars['UUID']['input'];
  salesChannelIDs: Array<Scalars['String']['input']>;
};

export type ProductAvailabilityTemplateItemUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productAvailabilityTemplateID: Scalars['UUID']['input'];
  productAvailabilityTemplateItemID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductAvailabilityTemplatePaged = {
  __typename?: 'ProductAvailabilityTemplatePaged';
  items?: Maybe<Array<ProductAvailabilityTemplate>>;
  pagination: PaginationResult;
};

export type ProductAvailabilityTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productAvailabilityTemplateName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductAvailabilityTemplateQopInput = {
  filters?: InputMaybe<ProductAvailabilityTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductAvailabilityTemplateUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productAvailabilityTemplateID: Scalars['UUID']['input'];
  productAvailabilityTemplateName: Scalars['String']['input'];
};

export type ProductBarcodeMap = {
  __typename?: 'ProductBarcodeMap';
  barcode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product: Product;
  productBarcodeMapID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductBarcodeMapCreateInput = {
  barcode: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductBarcodeMapPaged = {
  __typename?: 'ProductBarcodeMapPaged';
  items?: Maybe<Array<ProductBarcodeMap>>;
  pagination: PaginationResult;
};

export type ProductBarcodeMapQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBarcodeMapQopInput = {
  filters?: InputMaybe<ProductBarcodeMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBarcodeMapUpdateInput = {
  barcode: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productBarcodeMapID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductBookmark = {
  __typename?: 'ProductBookmark';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productBookmarkID: Scalars['UUID']['output'];
  productBookmarkName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductBookmarkCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productBookmarkName: Scalars['String']['input'];
};

export type ProductBookmarkPaged = {
  __typename?: 'ProductBookmarkPaged';
  items?: Maybe<Array<ProductBookmark>>;
  pagination: PaginationResult;
};

export type ProductBookmarkProduct = {
  __typename?: 'ProductBookmarkProduct';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productBookmark?: Maybe<ProductBookmark>;
  productBookmarkID: Scalars['UUID']['output'];
  productBookmarkName: Scalars['String']['output'];
  productBookmarkProductID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductBookmarkProductCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productBookmarkID: Scalars['UUID']['input'];
  productBookmarkName: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
};

export type ProductBookmarkProductPaged = {
  __typename?: 'ProductBookmarkProductPaged';
  items?: Maybe<Array<ProductBookmarkProduct>>;
  pagination: PaginationResult;
};

export type ProductBookmarkProductQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productBookmarkID?: InputMaybe<Scalars['UUID']['input']>;
  productBookmarkName?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBookmarkProductQopInput = {
  filters?: InputMaybe<ProductBookmarkProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBookmarkProductUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productBookmarkID: Scalars['UUID']['input'];
  productBookmarkName: Scalars['String']['input'];
  productBookmarkProductID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
};

export type ProductBookmarkQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productBookmarkName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBookmarkQopInput = {
  filters?: InputMaybe<ProductBookmarkQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBookmarkUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productBookmarkID: Scalars['UUID']['input'];
  productBookmarkName: Scalars['String']['input'];
};

export type ProductBrand = {
  __typename?: 'ProductBrand';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productBrandID: Scalars['UUID']['output'];
  productBrandName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductBrandCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productBrandName: Scalars['String']['input'];
};

export type ProductBrandPaged = {
  __typename?: 'ProductBrandPaged';
  items?: Maybe<Array<ProductBrand>>;
  pagination: PaginationResult;
};

export type ProductBrandQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productBrandName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBrandQopInput = {
  filters?: InputMaybe<ProductBrandQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBrandUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productBrandID: Scalars['UUID']['input'];
  productBrandName: Scalars['String']['input'];
};

export type ProductBundleComponent = {
  __typename?: 'ProductBundleComponent';
  componentProduct?: Maybe<Product>;
  componentProductID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productBundleComponentID: Scalars['UUID']['output'];
  productID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  uom: Uom;
  uomCategory: UomCategory;
  uomCategoryID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
};

export type ProductBundleComponentCreateInput = {
  componentProductID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductBundleComponentInput = {
  componentProductID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productBundleComponentID?: InputMaybe<Scalars['UUID']['input']>;
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductBundleComponentPaged = {
  __typename?: 'ProductBundleComponentPaged';
  items?: Maybe<Array<ProductBundleComponent>>;
  pagination: PaginationResult;
};

export type ProductBundleComponentQopFilterInput = {
  componentProductID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductBundleComponentQopInput = {
  filters?: InputMaybe<ProductBundleComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductBundleComponentUpdateInput = {
  componentProductID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productBundleComponentID: Scalars['UUID']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productCategoryFullName: Scalars['String']['output'];
  productCategoryID: Scalars['UUID']['output'];
  productCategoryName: Scalars['String']['output'];
  productDepartment?: Maybe<ProductDepartment>;
  productDepartmentID: Scalars['UUID']['output'];
  productDepartmentName: Scalars['String']['output'];
  productDivision?: Maybe<ProductDivision>;
  productDivisionID: Scalars['UUID']['output'];
  productDivisionName: Scalars['String']['output'];
  productSubDepartment?: Maybe<ProductSubDepartment>;
  productSubDepartmentID: Scalars['UUID']['output'];
  productSubDepartmentName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductCategoryCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productCategoryName: Scalars['String']['input'];
  productSubDepartmentID: Scalars['UUID']['input'];
};

export type ProductCategoryPaged = {
  __typename?: 'ProductCategoryPaged';
  items?: Maybe<Array<ProductCategory>>;
  pagination: PaginationResult;
};

export type ProductCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryName?: InputMaybe<Scalars['String']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productDivisionID?: InputMaybe<Scalars['UUID']['input']>;
  productSubDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductCategoryQopInput = {
  filters?: InputMaybe<ProductCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductCategorySalesChannelMap = {
  __typename?: 'ProductCategorySalesChannelMap';
  entityAuditMetadata: EntityAuditMetadata;
  externalCategoryID: Scalars['String']['output'];
  externalCategoryName: Scalars['String']['output'];
  externalParentCategoryID: Scalars['String']['output'];
  externalParentCategoryName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  productCategory?: Maybe<ProductCategory>;
  productCategoryID: Scalars['UUID']['output'];
  productCategorySalesChannelMapID: Scalars['UUID']['output'];
  salesChannel?: Maybe<SalesChannel>;
  salesChannelID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductCategorySalesChannelMapCreateInput = {
  externalCategoryID: Scalars['String']['input'];
  externalCategoryName: Scalars['String']['input'];
  externalParentCategoryID: Scalars['String']['input'];
  externalParentCategoryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type ProductCategorySalesChannelMapExportResult = {
  __typename?: 'ProductCategorySalesChannelMapExportResult';
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type ProductCategorySalesChannelMapImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategorySalesChannelMapImportFileMappingInput = {
  columns: Array<ProductCategorySalesChannelMapImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategorySalesChannelMapImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductCategorySalesChannelMapImportFileMappingInput;
  salesChannelID: Scalars['String']['input'];
};

export type ProductCategorySalesChannelMapImportResult = {
  __typename?: 'ProductCategorySalesChannelMapImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type ProductCategorySalesChannelMapImportRowReport = {
  __typename?: 'ProductCategorySalesChannelMapImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<ProductCategorySalesChannelMapImportRowViolation>;
};

export type ProductCategorySalesChannelMapImportRowViolation = {
  __typename?: 'ProductCategorySalesChannelMapImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductCategorySalesChannelMapImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductCategorySalesChannelMapImportFileMappingInput;
  salesChannelID: Scalars['String']['input'];
};

export type ProductCategorySalesChannelMapImportValidateResult = {
  __typename?: 'ProductCategorySalesChannelMapImportValidateResult';
  missingProductCategoryCodes: Array<Scalars['String']['output']>;
  rowReport: ProductCategorySalesChannelMapImportRowReport;
};

export type ProductCategorySalesChannelMapPaged = {
  __typename?: 'ProductCategorySalesChannelMapPaged';
  items: Array<ProductCategorySalesChannelMap>;
  pagination: PaginationResult;
};

export type ProductCategorySalesChannelMapQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalCategoryID?: InputMaybe<Scalars['String']['input']>;
  externalParentCategoryID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductCategorySalesChannelMapQopInput = {
  filters?: InputMaybe<ProductCategorySalesChannelMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductCategorySalesChannelMapUpdateInput = {
  externalCategoryID: Scalars['String']['input'];
  externalCategoryName: Scalars['String']['input'];
  externalParentCategoryID: Scalars['String']['input'];
  externalParentCategoryName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  productCategorySalesChannelMapID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};

export type ProductCategoryUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  productCategoryName: Scalars['String']['input'];
  productSubDepartmentID: Scalars['UUID']['input'];
};

export type ProductCreateInput = {
  addonGroupID?: InputMaybe<Scalars['UUID']['input']>;
  altBarcode1?: InputMaybe<Scalars['String']['input']>;
  altBarcode2?: InputMaybe<Scalars['String']['input']>;
  barcode: Scalars['String']['input'];
  baseUomID: Scalars['UUID']['input'];
  canBePurchased: Scalars['Boolean']['input'];
  canBeSold: Scalars['Boolean']['input'];
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasAddon: Scalars['Boolean']['input'];
  inventoryTrackingType?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isConsignment: Scalars['Boolean']['input'];
  isProduced: Scalars['Boolean']['input'];
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  pricelistProducts?: InputMaybe<Array<PricelistProductCreateInput>>;
  productAIImages?: InputMaybe<Array<ProductAiImageInput>>;
  productAccountingCategoryErpRefID?: InputMaybe<Scalars['String']['input']>;
  productAccountingCategoryErpRefName?: InputMaybe<Scalars['String']['input']>;
  productAccountingCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateItems?: InputMaybe<Array<ProductAvailabilityTemplateItemInput>>;
  productBrandID: Scalars['UUID']['input'];
  productBundleComponents?: InputMaybe<Array<ProductBundleComponentInput>>;
  productCategoryID: Scalars['UUID']['input'];
  productCode: Scalars['String']['input'];
  productFiles: Array<ProductFileInput>;
  productName: Scalars['String']['input'];
  productNameAlias?: InputMaybe<Scalars['String']['input']>;
  productSourceID: Scalars['UUID']['input'];
  productSubCategoryID: Scalars['UUID']['input'];
  productTags?: InputMaybe<Array<ProductTagInput>>;
  productType: Scalars['String']['input'];
  productVendors?: InputMaybe<Array<ProductVendorInput>>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseUomID?: InputMaybe<Scalars['UUID']['input']>;
  salesScanType?: InputMaybe<Scalars['String']['input']>;
  salesTaxID?: InputMaybe<Scalars['UUID']['input']>;
  salesUomID?: InputMaybe<Scalars['UUID']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate: Scalars['Boolean']['input'];
  trackStock?: InputMaybe<Scalars['Boolean']['input']>;
  uomCategoryID: Scalars['UUID']['input'];
  vendorConsignmentProductPrices?: InputMaybe<Array<VendorConsignmentProductPriceInput>>;
  volumeHeight?: InputMaybe<Scalars['Float']['input']>;
  volumeLength?: InputMaybe<Scalars['Float']['input']>;
  volumeWidth?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductDepartment = {
  __typename?: 'ProductDepartment';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productDepartmentID: Scalars['UUID']['output'];
  productDepartmentName: Scalars['String']['output'];
  productDivision: ProductDivision;
  productDivisionID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductDepartmentCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productDepartmentName: Scalars['String']['input'];
  productDivisionID: Scalars['UUID']['input'];
};

export type ProductDepartmentPaged = {
  __typename?: 'ProductDepartmentPaged';
  items?: Maybe<Array<ProductDepartment>>;
  pagination: PaginationResult;
};

export type ProductDepartmentQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productDepartmentName?: InputMaybe<Scalars['String']['input']>;
  productDivisionID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductDepartmentQopInput = {
  filters?: InputMaybe<ProductDepartmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductDepartmentUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productDepartmentID: Scalars['UUID']['input'];
  productDepartmentName: Scalars['String']['input'];
  productDivisionID: Scalars['UUID']['input'];
};

export type ProductDivision = {
  __typename?: 'ProductDivision';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productDepartments: Array<ProductDepartment>;
  productDivisionID: Scalars['UUID']['output'];
  productDivisionName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductDivisionCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productDivisionName: Scalars['String']['input'];
};

export type ProductDivisionPaged = {
  __typename?: 'ProductDivisionPaged';
  items?: Maybe<Array<ProductDivision>>;
  pagination: PaginationResult;
};

export type ProductDivisionQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productDivisionName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductDivisionQopInput = {
  filters?: InputMaybe<ProductDivisionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductDivisionUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productDivisionID: Scalars['UUID']['input'];
  productDivisionName: Scalars['String']['input'];
};

export type ProductFile = {
  __typename?: 'ProductFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  productFileID: Scalars['UUID']['output'];
  productFileType: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductFileCreateInput = {
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL: Scalars['String']['input'];
  imageFileMediumPathURL: Scalars['String']['input'];
  imageFileSmallPathURL: Scalars['String']['input'];
  productFileType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
};

export type ProductFileInput = {
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL?: InputMaybe<Scalars['String']['input']>;
  imageFileMediumPathURL?: InputMaybe<Scalars['String']['input']>;
  imageFileSmallPathURL?: InputMaybe<Scalars['String']['input']>;
  productFileID?: InputMaybe<Scalars['UUID']['input']>;
  productFileType: Scalars['String']['input'];
};

export type ProductFilePaged = {
  __typename?: 'ProductFilePaged';
  items?: Maybe<Array<ProductFile>>;
  pagination: PaginationResult;
};

export type ProductFileQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  productFileType?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductFileQopInput = {
  filters?: InputMaybe<ProductFileQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductFileUpdateInput = {
  fileID: Scalars['UUID']['input'];
  imageFileLargePathURL: Scalars['String']['input'];
  imageFileMediumPathURL: Scalars['String']['input'];
  imageFileSmallPathURL: Scalars['String']['input'];
  productFileID: Scalars['UUID']['input'];
  productFileType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
};

export enum ProductImageEmbeddingChangeOp {
  Delete = 'DELETE',
  Upsert = 'UPSERT'
}

export type ProductImageEmbeddingSyncHead = {
  __typename?: 'ProductImageEmbeddingSyncHead';
  lancedbCount: Scalars['Int']['output'];
  latestSeq: Scalars['Int']['output'];
};

export type ProductImportColumnInput = {
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
};

export type ProductImportFileMappingInput = {
  columns: Array<ProductImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ProductImportFileMappingInput;
};

export type ProductImportMissing = {
  __typename?: 'ProductImportMissing';
  accountingCategories: Array<Scalars['String']['output']>;
  brands: Array<Scalars['String']['output']>;
  categories: Array<Scalars['String']['output']>;
  countries: Array<Scalars['String']['output']>;
  sources: Array<Scalars['String']['output']>;
  subCategories: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  taxes: Array<Scalars['String']['output']>;
  uomCategories: Array<Scalars['String']['output']>;
  uoms: Array<Scalars['String']['output']>;
  vendors: Array<Scalars['String']['output']>;
};

export type ProductImportPreviewRow = {
  __typename?: 'ProductImportPreviewRow';
  action: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type ProductImportResult = {
  __typename?: 'ProductImportResult';
  backgroundJobID: Scalars['UUID']['output'];
};

export type ProductImportRowIssue = {
  __typename?: 'ProductImportRowIssue';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductImportRowReport = {
  __typename?: 'ProductImportRowReport';
  createRowCount: Scalars['Int']['output'];
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  updateRowCount: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<ProductImportRowIssue>;
  warningRowCount: Scalars['Int']['output'];
  warningSample: Array<ProductImportRowIssue>;
};

export type ProductImportValidateResult = {
  __typename?: 'ProductImportValidateResult';
  missing: ProductImportMissing;
  rowReport: ProductImportRowReport;
  status: Scalars['String']['output'];
  updatedRows: Array<ProductImportPreviewRow>;
};

export type ProductPaged = {
  __typename?: 'ProductPaged';
  items?: Maybe<Array<Product>>;
  pagination: PaginationResult;
};

export type ProductQopFilterInput = {
  altBarcode1?: InputMaybe<Scalars['String']['input']>;
  altBarcode2?: InputMaybe<Scalars['String']['input']>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  baseUomID?: InputMaybe<Scalars['UUID']['input']>;
  baseUomPurchaseCost?: InputMaybe<Scalars['Float']['input']>;
  canBePurchased?: InputMaybe<Scalars['Boolean']['input']>;
  canBeSold?: InputMaybe<Scalars['Boolean']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  excludeProductIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  inventoryTrackingType?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isProduced?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  mainImageFileID?: InputMaybe<Scalars['UUID']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  productAccountingCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productBrandID?: InputMaybe<Scalars['UUID']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productDivisionID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productNameAlias?: InputMaybe<Scalars['String']['input']>;
  productSourceID?: InputMaybe<Scalars['UUID']['input']>;
  productSubCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productSubDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  productTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseUomID?: InputMaybe<Scalars['UUID']['input']>;
  purchasingVendorID?: InputMaybe<Scalars['UUID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  salesScanType?: InputMaybe<Scalars['String']['input']>;
  salesTaxID?: InputMaybe<Scalars['UUID']['input']>;
  salesUomID?: InputMaybe<Scalars['UUID']['input']>;
  searchKeyFull?: InputMaybe<Scalars['String']['input']>;
  searchKeyScan?: InputMaybe<Scalars['String']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate?: InputMaybe<Scalars['Boolean']['input']>;
  trackStock?: InputMaybe<Scalars['Boolean']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductQopInput = {
  filters?: InputMaybe<ProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSalesChannelItemMap = {
  __typename?: 'ProductSalesChannelItemMap';
  barcode: Scalars['String']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalItemID: Scalars['String']['output'];
  externalItemName: Scalars['String']['output'];
  externalVariantID: Scalars['String']['output'];
  externalVariantName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productSalesChannelItemMapID: Scalars['UUID']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductSalesChannelItemMapCreateInput = {
  barcode: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  externalItemID: Scalars['String']['input'];
  externalItemName: Scalars['String']['input'];
  externalVariantID: Scalars['String']['input'];
  externalVariantName: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName: Scalars['String']['input'];
};

export type ProductSalesChannelItemMapPaged = {
  __typename?: 'ProductSalesChannelItemMapPaged';
  items: Array<ProductSalesChannelItemMap>;
  pagination: PaginationResult;
};

export type ProductSalesChannelItemMapQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalItemID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductSalesChannelItemMapQopInput = {
  filters?: InputMaybe<ProductSalesChannelItemMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSalesChannelItemMapUpdateInput = {
  barcode: Scalars['String']['input'];
  branchCode: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  externalItemID: Scalars['String']['input'];
  externalItemName: Scalars['String']['input'];
  externalVariantID: Scalars['String']['input'];
  externalVariantName: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  productSalesChannelItemMapID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName: Scalars['String']['input'];
};

export type ProductSource = {
  __typename?: 'ProductSource';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productSourceCode: Scalars['String']['output'];
  productSourceID: Scalars['UUID']['output'];
  productSourceName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductSourceCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productSourceCode: Scalars['String']['input'];
  productSourceName: Scalars['String']['input'];
};

export type ProductSourcePaged = {
  __typename?: 'ProductSourcePaged';
  items?: Maybe<Array<ProductSource>>;
  pagination: PaginationResult;
};

export type ProductSourceQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productSourceCode?: InputMaybe<Scalars['String']['input']>;
  productSourceName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductSourceQopInput = {
  filters?: InputMaybe<ProductSourceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSourceUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productSourceCode: Scalars['String']['input'];
  productSourceID: Scalars['UUID']['input'];
  productSourceName: Scalars['String']['input'];
};

export type ProductSubCategory = {
  __typename?: 'ProductSubCategory';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productCategory?: Maybe<ProductCategory>;
  productCategoryID: Scalars['UUID']['output'];
  productSubCategoryID: Scalars['UUID']['output'];
  productSubCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductSubCategoryCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  productSubCategoryName: Scalars['String']['input'];
};

export type ProductSubCategoryPaged = {
  __typename?: 'ProductSubCategoryPaged';
  items?: Maybe<Array<ProductSubCategory>>;
  pagination: PaginationResult;
};

export type ProductSubCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productSubCategoryName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductSubCategoryQopInput = {
  filters?: InputMaybe<ProductSubCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSubCategoryUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productCategoryID: Scalars['UUID']['input'];
  productSubCategoryID: Scalars['UUID']['input'];
  productSubCategoryName: Scalars['String']['input'];
};

export type ProductSubDepartment = {
  __typename?: 'ProductSubDepartment';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productDepartment: ProductDepartment;
  productDepartmentID: Scalars['UUID']['output'];
  productSubDepartmentID: Scalars['UUID']['output'];
  productSubDepartmentName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductSubDepartmentCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productDepartmentID: Scalars['UUID']['input'];
  productSubDepartmentName: Scalars['String']['input'];
};

export type ProductSubDepartmentPaged = {
  __typename?: 'ProductSubDepartmentPaged';
  items?: Maybe<Array<ProductSubDepartment>>;
  pagination: PaginationResult;
};

export type ProductSubDepartmentQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productSubDepartmentName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductSubDepartmentQopInput = {
  filters?: InputMaybe<ProductSubDepartmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductSubDepartmentUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productDepartmentID: Scalars['UUID']['input'];
  productSubDepartmentID: Scalars['UUID']['input'];
  productSubDepartmentName: Scalars['String']['input'];
};

export type ProductTag = {
  __typename?: 'ProductTag';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  productTagID: Scalars['UUID']['output'];
  productTagName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductTagCreateInput = {
  isActive: Scalars['Boolean']['input'];
  productTagName: Scalars['String']['input'];
};

export type ProductTagInput = {
  productTagID: Scalars['UUID']['input'];
};

export type ProductTagPaged = {
  __typename?: 'ProductTagPaged';
  items?: Maybe<Array<ProductTag>>;
  pagination: PaginationResult;
};

export type ProductTagProduct = {
  __typename?: 'ProductTagProduct';
  entityAuditMetadata: EntityAuditMetadata;
  productID: Scalars['UUID']['output'];
  productTag: ProductTag;
  productTagID: Scalars['UUID']['output'];
  productTagProductID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProductTagProductCreateInput = {
  productID: Scalars['UUID']['input'];
  productTagID: Scalars['UUID']['input'];
};

export type ProductTagProductPaged = {
  __typename?: 'ProductTagProductPaged';
  items?: Maybe<Array<ProductTagProduct>>;
  pagination: PaginationResult;
};

export type ProductTagProductQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productTagID?: InputMaybe<Scalars['UUID']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductTagProductQopInput = {
  filters?: InputMaybe<ProductTagProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductTagProductUpdateInput = {
  productID: Scalars['UUID']['input'];
  productTagID: Scalars['UUID']['input'];
  productTagProductID: Scalars['UUID']['input'];
};

export type ProductTagQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productTagName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ProductTagQopInput = {
  filters?: InputMaybe<ProductTagQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductTagUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productTagID: Scalars['UUID']['input'];
  productTagName: Scalars['String']['input'];
};

export type ProductUpdateInput = {
  addonGroupID?: InputMaybe<Scalars['UUID']['input']>;
  altBarcode1?: InputMaybe<Scalars['String']['input']>;
  altBarcode2?: InputMaybe<Scalars['String']['input']>;
  barcode: Scalars['String']['input'];
  baseUomID: Scalars['UUID']['input'];
  canBePurchased: Scalars['Boolean']['input'];
  canBeSold: Scalars['Boolean']['input'];
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  hasAddon: Scalars['Boolean']['input'];
  inventoryTrackingType?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isConsignment: Scalars['Boolean']['input'];
  isProduced: Scalars['Boolean']['input'];
  isSystem: Scalars['Boolean']['input'];
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  productAIImages?: InputMaybe<Array<ProductAiImageInput>>;
  productAccountingCategoryErpRefID?: InputMaybe<Scalars['String']['input']>;
  productAccountingCategoryErpRefName?: InputMaybe<Scalars['String']['input']>;
  productAccountingCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productAvailabilityTemplateItems?: InputMaybe<Array<ProductAvailabilityTemplateItemInput>>;
  productBrandID: Scalars['UUID']['input'];
  productBundleComponents?: InputMaybe<Array<ProductBundleComponentInput>>;
  productCategoryID: Scalars['UUID']['input'];
  productCode: Scalars['String']['input'];
  productFiles: Array<ProductFileInput>;
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  productNameAlias?: InputMaybe<Scalars['String']['input']>;
  productSourceID: Scalars['UUID']['input'];
  productSubCategoryID: Scalars['UUID']['input'];
  productTags?: InputMaybe<Array<ProductTagInput>>;
  productType: Scalars['String']['input'];
  productVendors?: InputMaybe<Array<ProductVendorInput>>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseUomID?: InputMaybe<Scalars['UUID']['input']>;
  salesScanType?: InputMaybe<Scalars['String']['input']>;
  salesTaxID?: InputMaybe<Scalars['UUID']['input']>;
  salesUomID?: InputMaybe<Scalars['UUID']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate: Scalars['Boolean']['input'];
  trackStock: Scalars['Boolean']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  vendorConsignmentProductPrices?: InputMaybe<Array<VendorConsignmentProductPriceInput>>;
  volumeHeight?: InputMaybe<Scalars['Float']['input']>;
  volumeLength?: InputMaybe<Scalars['Float']['input']>;
  volumeWidth?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductValidationResult = {
  __typename?: 'ProductValidationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productID?: Maybe<Scalars['UUID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  putawayTaskItemID?: Maybe<Scalars['UUID']['output']>;
  qtyOutstanding?: Maybe<Scalars['Float']['output']>;
  uomConversionDecimal?: Maybe<Scalars['Int']['output']>;
  uomConvertionRate?: Maybe<Scalars['Float']['output']>;
  uomDecimal?: Maybe<Scalars['Int']['output']>;
  uomID?: Maybe<Scalars['UUID']['output']>;
  uomName?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type ProductVendor = {
  __typename?: 'ProductVendor';
  canBeReturned: Scalars['Boolean']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  minimumOrder: Scalars['Float']['output'];
  product: Product;
  productId: Scalars['UUID']['output'];
  productVendorID: Scalars['UUID']['output'];
  purchasePrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  vendor: Vendor;
  vendorId: Scalars['UUID']['output'];
};

export type ProductVendorCreateInput = {
  canBeReturned: Scalars['Boolean']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrder: Scalars['Float']['input'];
  productID: Scalars['UUID']['input'];
  purchasePrice: Scalars['Float']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type ProductVendorInput = {
  canBeReturned: Scalars['Boolean']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  productVendorID?: InputMaybe<Scalars['UUID']['input']>;
  purchasePrice: Scalars['Float']['input'];
  vendorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductVendorPaged = {
  __typename?: 'ProductVendorPaged';
  items?: Maybe<Array<ProductVendor>>;
  pagination: PaginationResult;
};

export type ProductVendorQopFilterInput = {
  canBeReturned?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['UUID']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductVendorQopInput = {
  filters?: InputMaybe<ProductVendorQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductVendorUpdateInput = {
  canBeReturned: Scalars['Boolean']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrder: Scalars['Float']['input'];
  productID: Scalars['UUID']['input'];
  productVendorID: Scalars['UUID']['input'];
  purchasePrice: Scalars['Float']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type ProductionOrder = {
  __typename?: 'ProductionOrder';
  baseUomQty: Scalars['Float']['output'];
  billOfMaterial: BillOfMaterial;
  billOfMaterialID: Scalars['UUID']['output'];
  bomBaseUomQty: Scalars['Float']['output'];
  bomQty: Scalars['Float']['output'];
  bomUomConversionDecimal: Scalars['Int']['output'];
  bomUomConvertionRate: Scalars['Float']['output'];
  bomUomID: Scalars['UUID']['output'];
  branchID: Scalars['UUID']['output'];
  components: Array<ProductionOrderComponent>;
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  gmt: Scalars['Int']['output'];
  lotNo: Scalars['String']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productionOrderDatetime: Scalars['Time']['output'];
  productionOrderDatetimeUTC?: Maybe<Scalars['Time']['output']>;
  productionOrderID: Scalars['UUID']['output'];
  productionOrderNumber: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
  waste?: Maybe<Scalars['Float']['output']>;
  wastePerc?: Maybe<Scalars['Float']['output']>;
};

export type ProductionOrderComponent = {
  __typename?: 'ProductionOrderComponent';
  baseUomQty: Scalars['Float']['output'];
  bomBaseQtyDiff?: Maybe<Scalars['Float']['output']>;
  bomBaseUomQty?: Maybe<Scalars['Float']['output']>;
  bomQty?: Maybe<Scalars['Float']['output']>;
  bomUomConversionDecimal?: Maybe<Scalars['Int']['output']>;
  bomUomConvertionRate?: Maybe<Scalars['Float']['output']>;
  bomUomID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isManual: Scalars['Boolean']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productionOrderComponentID: Scalars['UUID']['output'];
  productionOrderID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type ProductionOrderComponentCreateInput = {
  bomBaseQtyDiff: Scalars['Float']['input'];
  bomQty?: InputMaybe<Scalars['Float']['input']>;
  bomUomID?: InputMaybe<Scalars['UUID']['input']>;
  isManual: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductionOrderComponentPaged = {
  __typename?: 'ProductionOrderComponentPaged';
  items: Array<ProductionOrderComponent>;
  pagination: PaginationResult;
};

export type ProductionOrderComponentQopFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productionOrderID?: InputMaybe<Scalars['UUID']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
};

export type ProductionOrderComponentQopInput = {
  filters?: InputMaybe<ProductionOrderComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductionOrderComponentUpdateInput = {
  bomBaseQtyDiff: Scalars['Float']['input'];
  bomQty?: InputMaybe<Scalars['Float']['input']>;
  bomUomID?: InputMaybe<Scalars['UUID']['input']>;
  isManual: Scalars['Boolean']['input'];
  productID: Scalars['UUID']['input'];
  productionOrderComponentID?: InputMaybe<Scalars['UUID']['input']>;
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type ProductionOrderCreateInput = {
  billOfMaterialID: Scalars['UUID']['input'];
  bomQty?: InputMaybe<Scalars['Float']['input']>;
  bomUomID?: InputMaybe<Scalars['UUID']['input']>;
  branchID: Scalars['UUID']['input'];
  components: Array<ProductionOrderComponentCreateInput>;
  expiryDate: Scalars['Time']['input'];
  gmt: Scalars['Int']['input'];
  lotNo?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  productionOrderDatetime: Scalars['Time']['input'];
  productionOrderNumber?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
  status: Scalars['String']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
  waste?: InputMaybe<Scalars['Float']['input']>;
  wastePerc?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductionOrderPaged = {
  __typename?: 'ProductionOrderPaged';
  items: Array<ProductionOrder>;
  pagination: PaginationResult;
};

export type ProductionOrderQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productionOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  productionOrderDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  productionOrderDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  productionOrderNumber?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ProductionOrderQopInput = {
  filters?: InputMaybe<ProductionOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ProductionOrderUpdateInput = {
  billOfMaterialID: Scalars['UUID']['input'];
  bomQty?: InputMaybe<Scalars['Float']['input']>;
  bomUomID?: InputMaybe<Scalars['UUID']['input']>;
  branchID: Scalars['UUID']['input'];
  components: Array<ProductionOrderComponentUpdateInput>;
  expiryDate: Scalars['Time']['input'];
  gmt: Scalars['Int']['input'];
  lotNo?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  productionOrderDatetime: Scalars['Time']['input'];
  productionOrderID: Scalars['UUID']['input'];
  productionOrderNumber?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
  status: Scalars['String']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
  waste?: InputMaybe<Scalars['Float']['input']>;
  wastePerc?: InputMaybe<Scalars['Float']['input']>;
};

export type Promo = {
  __typename?: 'Promo';
  branches?: Maybe<Array<PromoBranchRef>>;
  description: Scalars['String']['output'];
  effectiveEndDate: Scalars['Time']['output'];
  effectiveStartDate: Scalars['Time']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expenseAccountCode?: Maybe<Scalars['String']['output']>;
  expenseAccountErpRefID?: Maybe<Scalars['String']['output']>;
  expenseAccountErpRefName?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAllBranches: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  promoID: Scalars['UUID']['output'];
  promoName: Scalars['String']['output'];
  /** Extensible promo rules object (availability, min_basket, max_usage, payment_method, etc.) */
  promoRules?: Maybe<PromoRules>;
};

export type PromoAvailabilityRule = {
  __typename?: 'PromoAvailabilityRule';
  allDay: Scalars['Boolean']['output'];
  days: Array<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  useTime: Scalars['Boolean']['output'];
};

export type PromoAvailabilityRuleInput = {
  allDay: Scalars['Boolean']['input'];
  days: Array<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  useTime: Scalars['Boolean']['input'];
};

export type PromoBranchRef = {
  __typename?: 'PromoBranchRef';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  branchName?: Maybe<Scalars['String']['output']>;
};

export type PromoBranchRefInput = {
  branchID: Scalars['UUID']['input'];
};

/**
 * Promo Cat1: Buy Product X Get Discount % per Product.
 * Example: selected SKUs get 10% discount.
 *
 * Each element in PromoBulkCat1RuleInput represents a single promo row (CAT1)
 * that will share the same branches and availabilityRules (TnC) defined in the
 * PromoBulkCreateInput header.
 *
 * Quota: Per-product quota - each product has its own usage limit per branch.
 */
export type PromoBulkCat1RuleInput = {
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  productQuotas?: InputMaybe<Array<PromoProductQuotaInput>>;
  products: Array<PromoProductInput>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat1UpdateRuleInput = {
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  productQuotas?: InputMaybe<Array<PromoProductQuotaInput>>;
  products: Array<PromoProductInput>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/**
 * Promo Cat2: Buy Product X Get Product Y (free product pool).
 * Example: buy 2 of product A, get 1 free from a pool of products B/C.
 *
 * Each element in PromoBulkCat2RuleInput represents a single promo row (CAT2)
 * that will share the same branches and availabilityRules (TnC) defined in the
 * PromoBulkCreateInput header.
 *
 * Quota: Per-promo quota - single quota applies to entire promo (all products share).
 */
export type PromoBulkCat2RuleInput = {
  buyProducts: Array<PromoProductInput>;
  description: Scalars['String']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  freeQty: Scalars['Int']['input'];
  getFreeProducts: Array<PromoProductInput>;
  isMultiple: Scalars['Boolean']['input'];
  minQty: Scalars['Int']['input'];
  promoTypeID: Scalars['UUID']['input'];
  quota?: InputMaybe<PromoQuotaInput>;
};

export type PromoBulkCat2UpdateRuleInput = {
  buyProducts: Array<PromoProductInput>;
  description: Scalars['String']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  freeQty: Scalars['Int']['input'];
  getFreeProducts: Array<PromoProductInput>;
  isMultiple: Scalars['Boolean']['input'];
  minQty: Scalars['Int']['input'];
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
  quota?: InputMaybe<PromoQuotaInput>;
};

/**
 * Promo Cat3: Buy Product x Get Discount (amount).
 * Example: buy selected SKUs, get RpX off.
 *
 * Quota: Per-product quota - each product has its own usage limit per branch.
 */
export type PromoBulkCat3RuleInput = {
  description: Scalars['String']['input'];
  discountAmount: Scalars['Float']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  productQuotas?: InputMaybe<Array<PromoProductQuotaInput>>;
  products: Array<PromoProductInput>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat3UpdateRuleInput = {
  description: Scalars['String']['input'];
  discountAmount: Scalars['Float']['input'];
  enableQuota?: Scalars['Boolean']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  productQuotas?: InputMaybe<Array<PromoProductQuotaInput>>;
  products: Array<PromoProductInput>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/** Promo Cat4: Discount All Products by Percentage (basket-level). */
export type PromoBulkCat4RuleInput = {
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat4UpdateRuleInput = {
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/** Promo Cat5: Discount All Products by Nominal amount (basket-level). */
export type PromoBulkCat5RuleInput = {
  description: Scalars['String']['input'];
  discountAmount: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat5UpdateRuleInput = {
  description: Scalars['String']['input'];
  discountAmount: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/**
 * Promo Cat6: Discount Product Category by Percentage.
 * Example: discount 10% for all products in selected categories.
 */
export type PromoBulkCat6RuleInput = {
  categories: Array<PromoCategoryInput>;
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoBulkCat6UpdateRuleInput = {
  categories: Array<PromoCategoryInput>;
  description: Scalars['String']['input'];
  discountPercent: Scalars['Float']['input'];
  expenseItemID?: InputMaybe<Scalars['UUID']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

/**
 * Bulk create promo API.
 *
 * Branches and availabilityRules (TnC) are defined once at the header level and
 * will be applied to every generated promo row from cat1Rules..cat6Rules.
 * Each rule element corresponds to a single promo row in the promo table.
 */
export type PromoBulkCreateInput = {
  branches?: InputMaybe<Array<PromoBranchRefInput>>;
  cat1Rules?: InputMaybe<Array<PromoBulkCat1RuleInput>>;
  cat2Rules?: InputMaybe<Array<PromoBulkCat2RuleInput>>;
  cat3Rules?: InputMaybe<Array<PromoBulkCat3RuleInput>>;
  cat4Rules?: InputMaybe<Array<PromoBulkCat4RuleInput>>;
  cat5Rules?: InputMaybe<Array<PromoBulkCat5RuleInput>>;
  cat6Rules?: InputMaybe<Array<PromoBulkCat6RuleInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate: Scalars['Time']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  expenseAccountCode?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  promoName: Scalars['String']['input'];
  /** Extensible promo rules object (availability, min_basket, max_usage, payment_method, etc.) */
  promoRules?: InputMaybe<PromoRulesInput>;
};

export type PromoBulkUpdateInput = {
  branches?: InputMaybe<Array<PromoBranchRefInput>>;
  cat1Rules?: InputMaybe<Array<PromoBulkCat1UpdateRuleInput>>;
  cat2Rules?: InputMaybe<Array<PromoBulkCat2UpdateRuleInput>>;
  cat3Rules?: InputMaybe<Array<PromoBulkCat3UpdateRuleInput>>;
  cat4Rules?: InputMaybe<Array<PromoBulkCat4UpdateRuleInput>>;
  cat5Rules?: InputMaybe<Array<PromoBulkCat5UpdateRuleInput>>;
  cat6Rules?: InputMaybe<Array<PromoBulkCat6UpdateRuleInput>>;
  componentSyncMode?: InputMaybe<PromoComponentSyncMode>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveEndDate: Scalars['Time']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  expenseAccountCode?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  priority: Scalars['Int']['input'];
  promoID: Scalars['UUID']['input'];
  promoName: Scalars['String']['input'];
  /** Extensible promo rules object (availability, min_basket, max_usage, payment_method, etc.) */
  promoRules?: InputMaybe<PromoRulesInput>;
};

export type PromoCat1Detail = {
  __typename?: 'PromoCAT1Detail';
  configCat1: PromoConfigCat1;
  promo: Promo;
};

export type PromoCat2Detail = {
  __typename?: 'PromoCAT2Detail';
  configCat2: PromoConfigCat2;
  promo: Promo;
};

export type PromoCat3Detail = {
  __typename?: 'PromoCAT3Detail';
  configCat3: PromoConfigCat3;
  promo: Promo;
};

export type PromoCat4Detail = {
  __typename?: 'PromoCAT4Detail';
  configCat4: PromoConfigCat4;
  promo: Promo;
};

export type PromoCat5Detail = {
  __typename?: 'PromoCAT5Detail';
  configCat5: PromoConfigCat5;
  promo: Promo;
};

export type PromoCat6Detail = {
  __typename?: 'PromoCAT6Detail';
  configCat6: PromoConfigCat6;
  promo: Promo;
};

export type PromoCategory = {
  __typename?: 'PromoCategory';
  productCategory: ProductCategory;
  productCategoryID: Scalars['UUID']['output'];
  productCategoryName?: Maybe<Scalars['String']['output']>;
};

/** Reference to a product category (used by CAT6). */
export type PromoCategoryInput = {
  productCategoryID: Scalars['UUID']['input'];
};

export type PromoComponent = {
  __typename?: 'PromoComponent';
  config: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  promo: Promo;
  promoComponentID: Scalars['UUID']['output'];
  promoID: Scalars['UUID']['output'];
  promoType: PromoType;
  promoTypeID: Scalars['UUID']['output'];
};

export type PromoComponentCat1Detail = {
  __typename?: 'PromoComponentCAT1Detail';
  config: PromoConfigCat1;
  promoComponent: PromoComponent;
};

export type PromoComponentCat2Detail = {
  __typename?: 'PromoComponentCAT2Detail';
  config: PromoConfigCat2;
  promoComponent: PromoComponent;
};

export type PromoComponentCat3Detail = {
  __typename?: 'PromoComponentCAT3Detail';
  config: PromoConfigCat3;
  promoComponent: PromoComponent;
};

export type PromoComponentCat4Detail = {
  __typename?: 'PromoComponentCAT4Detail';
  config: PromoConfigCat4;
  promoComponent: PromoComponent;
};

export type PromoComponentCat5Detail = {
  __typename?: 'PromoComponentCAT5Detail';
  config: PromoConfigCat5;
  promoComponent: PromoComponent;
};

export type PromoComponentCat6Detail = {
  __typename?: 'PromoComponentCAT6Detail';
  config: PromoConfigCat6;
  promoComponent: PromoComponent;
};

export type PromoComponentImportColumnInput = {
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
};

export type PromoComponentImportComponent = {
  __typename?: 'PromoComponentImportComponent';
  description: Scalars['String']['output'];
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  enableQuota: Scalars['Boolean']['output'];
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  freeQty?: Maybe<Scalars['Int']['output']>;
  getFreeProducts: Array<PromoImportedItem>;
  isMultiple?: Maybe<Scalars['Boolean']['output']>;
  minQty?: Maybe<Scalars['Int']['output']>;
  products: Array<PromoImportedItem>;
  promoComponentID?: Maybe<Scalars['UUID']['output']>;
  promoTypeID: Scalars['UUID']['output'];
  quotaMaxQty?: Maybe<Scalars['Int']['output']>;
};

export type PromoComponentImportFileMappingInput = {
  columns: Array<PromoComponentImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoComponentImportRowReport = {
  __typename?: 'PromoComponentImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<PromoComponentImportRowViolation>;
};

export type PromoComponentImportRowViolation = {
  __typename?: 'PromoComponentImportRowViolation';
  componentName: Scalars['String']['output'];
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PromoComponentImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: PromoComponentImportFileMappingInput;
  promoID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID: Scalars['UUID']['input'];
};

export type PromoComponentImportValidateResult = {
  __typename?: 'PromoComponentImportValidateResult';
  components: Array<PromoComponentImportComponent>;
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: PromoComponentImportRowReport;
};

export type PromoComponentPaged = {
  __typename?: 'PromoComponentPaged';
  items?: Maybe<Array<PromoComponent>>;
  pagination: PaginationResult;
};

export type PromoComponentQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  promoID?: InputMaybe<Scalars['UUID']['input']>;
  promoTypeID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PromoComponentQopInput = {
  filters?: InputMaybe<PromoComponentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PromoComponentQuota = {
  __typename?: 'PromoComponentQuota';
  maxQty: Scalars['Int']['output'];
};

/**
 * How the components in this payload relate to the ones the promo already has.
 * SNAPSHOT, the default, is the historical behaviour: the payload is the complete
 * list and any component missing from it is deleted. MERGE adds and updates only
 * what is sent and leaves the rest alone, which is what an import of a promo with
 * more components than the form can load needs.
 */
export enum PromoComponentSyncMode {
  Merge = 'MERGE',
  Snapshot = 'SNAPSHOT'
}

export type PromoConfigCat1 = {
  __typename?: 'PromoConfigCAT1';
  branches: Array<PromoBranchRef>;
  discountPercent: Scalars['Float']['output'];
  enableQuota: Scalars['Boolean']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  productQuotas?: Maybe<Array<PromoProductQuota>>;
  products: Array<PromoProduct>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoConfigCat2 = {
  __typename?: 'PromoConfigCAT2';
  branches: Array<PromoBranchRef>;
  buyProducts: Array<PromoProduct>;
  enableQuota: Scalars['Boolean']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  freeQty: Scalars['Int']['output'];
  getFreeProducts: Array<PromoProduct>;
  isMultiple: Scalars['Boolean']['output'];
  minQty: Scalars['Int']['output'];
  promoRules?: Maybe<PromoRules>;
  quota?: Maybe<PromoComponentQuota>;
};

export type PromoConfigCat3 = {
  __typename?: 'PromoConfigCAT3';
  branches: Array<PromoBranchRef>;
  discountAmount: Scalars['Float']['output'];
  enableQuota: Scalars['Boolean']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  productQuotas?: Maybe<Array<PromoProductQuota>>;
  products: Array<PromoProduct>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoConfigCat4 = {
  __typename?: 'PromoConfigCAT4';
  branches: Array<PromoBranchRef>;
  discountPercent: Scalars['Float']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoConfigCat5 = {
  __typename?: 'PromoConfigCAT5';
  branches: Array<PromoBranchRef>;
  discountAmount: Scalars['Float']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoConfigCat6 = {
  __typename?: 'PromoConfigCAT6';
  branches: Array<PromoBranchRef>;
  categories: Array<PromoCategory>;
  discountPercent: Scalars['Float']['output'];
  expenseItem?: Maybe<ExpenseItem>;
  expenseItemID?: Maybe<Scalars['UUID']['output']>;
  promoRules?: Maybe<PromoRules>;
};

export type PromoImportedItem = {
  __typename?: 'PromoImportedItem';
  barcode: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  quotaMaxQty?: Maybe<Scalars['Int']['output']>;
};

export type PromoPaged = {
  __typename?: 'PromoPaged';
  items?: Maybe<Array<Promo>>;
  pagination: PaginationResult;
};

export type PromoProduct = {
  __typename?: 'PromoProduct';
  product: Product;
  productCode?: Maybe<Scalars['String']['output']>;
  productID: Scalars['UUID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
};

export type PromoProductInput = {
  productID: Scalars['UUID']['input'];
};

export type PromoProductQuota = {
  __typename?: 'PromoProductQuota';
  maxQty: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
};

/**
 * Quota configuration for per-product promos (CAT1, CAT3).
 * Each product can have its own quota limit per branch.
 */
export type PromoProductQuotaInput = {
  maxQty: Scalars['Int']['input'];
  productID: Scalars['UUID']['input'];
};

export type PromoQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveStartDate?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  promoName?: InputMaybe<Scalars['String']['input']>;
  promoTypeID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PromoQopInput = {
  filters?: InputMaybe<PromoQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PromoQuota = {
  __typename?: 'PromoQuota';
  category?: Maybe<ProductCategory>;
  data?: Maybe<PromoQuotaData>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  maxQty: Scalars['Int']['output'];
  product?: Maybe<Product>;
  promo?: Maybe<Promo>;
  promoComponent?: Maybe<PromoComponent>;
  promoComponentID: Scalars['UUID']['output'];
  promoID: Scalars['UUID']['output'];
  promoQuotaID: Scalars['UUID']['output'];
  quotaType: Scalars['String']['output'];
  remainingQty: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
  usedQty: Scalars['Int']['output'];
};

export type PromoQuotaBranchUsage = {
  __typename?: 'PromoQuotaBranchUsage';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  maxQty: Scalars['Int']['output'];
  promoQuota: PromoQuota;
  promoQuotaBranchUsageID: Scalars['UUID']['output'];
  promoQuotaID: Scalars['UUID']['output'];
  remainingQty: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
  usedQty: Scalars['Int']['output'];
};

export type PromoQuotaBranchUsageFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  promoQuotaID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PromoQuotaBranchUsagePagedResult = {
  __typename?: 'PromoQuotaBranchUsagePagedResult';
  items: Array<PromoQuotaBranchUsage>;
  pagination: PaginationResult;
};

export type PromoQuotaBranchUsageQopInput = {
  filters?: InputMaybe<PromoQuotaBranchUsageFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type PromoQuotaCheckInput = {
  branchID: Scalars['UUID']['input'];
  data?: InputMaybe<PromoQuotaDataInput>;
  promoComponentID: Scalars['UUID']['input'];
};

export type PromoQuotaCreateInput = {
  data?: InputMaybe<PromoQuotaDataInput>;
  isActive?: Scalars['Boolean']['input'];
  maxQty: Scalars['Int']['input'];
  promoComponentID: Scalars['UUID']['input'];
  promoID: Scalars['UUID']['input'];
  quotaType?: Scalars['String']['input'];
};

export type PromoQuotaData = {
  __typename?: 'PromoQuotaData';
  categoryID?: Maybe<Scalars['UUID']['output']>;
  departmentID?: Maybe<Scalars['UUID']['output']>;
  productID?: Maybe<Scalars['UUID']['output']>;
};

export type PromoQuotaDataInput = {
  categoryID?: InputMaybe<Scalars['UUID']['input']>;
  departmentID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PromoQuotaFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  promoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  promoID?: InputMaybe<Scalars['UUID']['input']>;
  quotaType?: InputMaybe<Scalars['String']['input']>;
};

export type PromoQuotaIncrementUsageInput = {
  branchID: Scalars['UUID']['input'];
  incrementQty?: Scalars['Int']['input'];
  promoQuotaID: Scalars['UUID']['input'];
};

/**
 * Quota configuration for per-promo promos (CAT2).
 * Single quota applies to entire promo (all products share).
 */
export type PromoQuotaInput = {
  maxQty: Scalars['Int']['input'];
};

export type PromoQuotaPagedResult = {
  __typename?: 'PromoQuotaPagedResult';
  items: Array<PromoQuota>;
  pagination: PaginationResult;
};

export type PromoQuotaQopInput = {
  filters?: InputMaybe<PromoQuotaFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type PromoQuotaResetUsageInput = {
  branchID: Scalars['UUID']['input'];
  promoQuotaID: Scalars['UUID']['input'];
};

export type PromoQuotaUpdateInput = {
  data?: InputMaybe<PromoQuotaDataInput>;
  isActive: Scalars['Boolean']['input'];
  maxQty: Scalars['Int']['input'];
  promoComponentID: Scalars['UUID']['input'];
  promoID: Scalars['UUID']['input'];
  promoQuotaID: Scalars['UUID']['input'];
  quotaType?: Scalars['String']['input'];
};

export type PromoQuotaUsageCheck = {
  __typename?: 'PromoQuotaUsageCheck';
  canUse: Scalars['Boolean']['output'];
  isGlobalFallback: Scalars['Boolean']['output'];
  maxQty: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  promoQuotaID?: Maybe<Scalars['UUID']['output']>;
  quotaType?: Maybe<Scalars['String']['output']>;
  remaining: Scalars['Int']['output'];
  usedQty: Scalars['Int']['output'];
};

export type PromoRules = {
  __typename?: 'PromoRules';
  availability?: Maybe<Array<PromoAvailabilityRule>>;
  /** Indicates if this promo has quota enabled (auto-computed from promo components) */
  enableQuota?: Maybe<Scalars['Boolean']['output']>;
};

export type PromoRulesInput = {
  availability?: InputMaybe<Array<PromoAvailabilityRuleInput>>;
};

export type PromoType = {
  __typename?: 'PromoType';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  promoTypeID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PromoTypeCreateInput = {
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type PromoTypePaged = {
  __typename?: 'PromoTypePaged';
  items?: Maybe<Array<PromoType>>;
  pagination: PaginationResult;
};

export type PromoTypeQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PromoTypeQopInput = {
  filters?: InputMaybe<PromoTypeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PromoTypeUpdateInput = {
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  promoTypeID: Scalars['UUID']['input'];
};

export type Province = {
  __typename?: 'Province';
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ProvinceCreateInput = {
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
};

export type ProvincePaged = {
  __typename?: 'ProvincePaged';
  items: Array<Province>;
  pagination: PaginationResult;
};

export type ProvinceQop = {
  filters?: InputMaybe<ProvinceQopFilter>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type ProvinceQopFilter = {
  countryID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  provinceName?: InputMaybe<Scalars['String']['input']>;
};

export type ProvinceUpdateInput = {
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
};

export type PurchaseArea = {
  __typename?: 'PurchaseArea';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  purchaseAreaID: Scalars['UUID']['output'];
  purchaseAreaName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type PurchaseAreaCreateInput = {
  isActive: Scalars['Boolean']['input'];
  purchaseAreaName: Scalars['String']['input'];
};

export type PurchaseAreaPaged = {
  __typename?: 'PurchaseAreaPaged';
  items?: Maybe<Array<PurchaseArea>>;
  pagination: PaginationResult;
};

export type PurchaseAreaQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseAreaName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type PurchaseAreaQopInput = {
  filters?: InputMaybe<PurchaseAreaQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseAreaUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  purchaseAreaID: Scalars['UUID']['input'];
  purchaseAreaName: Scalars['String']['input'];
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  adjustmentAmount: Scalars['Float']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  cancelledType?: Maybe<Scalars['String']['output']>;
  deadlineDate: Scalars['Time']['output'];
  deliveryDate: Scalars['Time']['output'];
  destinationWarehouseAddress?: Maybe<BaseModelAddress>;
  destinationWarehouseCode: Scalars['String']['output'];
  destinationWarehouseID: Scalars['UUID']['output'];
  destinationWarehouseName: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  isAlreadyForceClosePO?: Maybe<Scalars['Boolean']['output']>;
  isCannotRevise?: Maybe<Scalars['Boolean']['output']>;
  itemUomSummaries: Array<PurchaseOrderItemUomSummary>;
  landedCost: Scalars['Float']['output'];
  landedCostPerUnit: Scalars['Float']['output'];
  noteForVendor: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  purchaseAreaID: Scalars['UUID']['output'];
  purchaseAreaName: Scalars['String']['output'];
  purchaseOrderDatetime: Scalars['Time']['output'];
  purchaseOrderDatetimeUtc: Scalars['Time']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  receivingStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<PurchaseOrderTax>;
  total: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItems: Scalars['Int']['output'];
  vendorAddress?: Maybe<BaseModelAddress>;
  vendorCode: Scalars['String']['output'];
  vendorEmail: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
  vendorNpwp: Scalars['String']['output'];
  vendorNpwpCompanyName: Scalars['String']['output'];
  vendorPhoneNumber: Scalars['String']['output'];
  vendorRefNo: Scalars['String']['output'];
};

export type PurchaseOrderBackfillTotalsInput = {
  purchaseOrderIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type PurchaseOrderBackfillTotalsResult = {
  __typename?: 'PurchaseOrderBackfillTotalsResult';
  totalPurchaseOrderUpdated: Scalars['Int']['output'];
};

export type PurchaseOrderCloseInput = {
  purchaseOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type PurchaseOrderCreateInput = {
  adjustmentAmount: Scalars['Float']['input'];
  branchID: Scalars['UUID']['input'];
  deadlineDate: Scalars['Time']['input'];
  deliveryDate: Scalars['Time']['input'];
  destinationWarehouseID: Scalars['UUID']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  items: Array<PurchaseOrderItemCreateInput>;
  landedCost: Scalars['Float']['input'];
  noteForVendor: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseAreaID: Scalars['UUID']['input'];
  purchaseOrderDatetime: Scalars['Time']['input'];
  purchaseOrderDatetimeUtc: Scalars['Time']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
  taxIncluded: Scalars['Boolean']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorRefNo: Scalars['String']['input'];
};

export type PurchaseOrderForceCloseInput = {
  purchaseOrderID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type PurchaseOrderImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderImportFileMappingInput = {
  columns: Array<PurchaseOrderImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  rowFilters?: InputMaybe<Array<PurchaseOrderImportRowFilterInput>>;
};

export type PurchaseOrderImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: PurchaseOrderImportFileMappingInput;
};

export type PurchaseOrderImportMissingProductUom = {
  __typename?: 'PurchaseOrderImportMissingProductUom';
  productCode: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderImportRowFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
};

export type PurchaseOrderImportRowReport = {
  __typename?: 'PurchaseOrderImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<PurchaseOrderImportRowViolation>;
};

export type PurchaseOrderImportRowViolation = {
  __typename?: 'PurchaseOrderImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PurchaseOrderImportValidateCodesInput = {
  branchCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  fileMapping?: InputMaybe<PurchaseOrderImportFileMappingInput>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseAreaNames?: InputMaybe<Array<Scalars['String']['input']>>;
  taxCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PurchaseOrderImportValidateCodesResult = {
  __typename?: 'PurchaseOrderImportValidateCodesResult';
  consignmentProductCodes: Array<Scalars['String']['output']>;
  consignmentVendorCodes: Array<Scalars['String']['output']>;
  duplicateProductCodes: Array<Scalars['String']['output']>;
  missingBranchCodes: Array<Scalars['String']['output']>;
  missingProductCodes: Array<Scalars['String']['output']>;
  missingProductUoms: Array<PurchaseOrderImportMissingProductUom>;
  missingPurchaseAreaNames: Array<Scalars['String']['output']>;
  missingTaxCodes: Array<Scalars['String']['output']>;
  missingVendorCodes: Array<Scalars['String']['output']>;
  missingWarehouseCodes: Array<Scalars['String']['output']>;
  rowReport?: Maybe<PurchaseOrderImportRowReport>;
};

export type PurchaseOrderItem = {
  __typename?: 'PurchaseOrderItem';
  additionalDiscountAmount: Scalars['Float']['output'];
  additionalDiscountPerc: Scalars['Float']['output'];
  additionalLandedCost: Scalars['Float']['output'];
  baseUomQty: Scalars['Float']['output'];
  baseUomUnitCost: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  sequenceNo: Scalars['Int']['output'];
  taxAmount: Scalars['Float']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<PurchaseOrderItemTax>;
  total: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderItemCreateInput = {
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  taxes: Array<PurchaseOrderItemTaxCreateInput>;
  unitPrice: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderItemPaged = {
  __typename?: 'PurchaseOrderItemPaged';
  items: Array<PurchaseOrderItem>;
  pagination: PaginationResult;
};

export type PurchaseOrderItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PurchaseOrderItemQopInput = {
  filters?: InputMaybe<PurchaseOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseOrderItemReviseInput = {
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  taxes: Array<PurchaseOrderItemTaxCreateInput>;
  unitPrice: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderItemTax = {
  __typename?: 'PurchaseOrderItemTax';
  entityAuditMetadata: EntityAuditMetadata;
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderItemID: Scalars['UUID']['output'];
  purchaseOrderItemTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type PurchaseOrderItemTaxCreateInput = {
  taxCode: Scalars['String']['input'];
  taxID: Scalars['UUID']['input'];
  taxRate: Scalars['Float']['input'];
};

export type PurchaseOrderItemTaxUpdateInput = {
  purchaseOrderItemTaxID?: InputMaybe<Scalars['UUID']['input']>;
  taxCode: Scalars['String']['input'];
  taxID: Scalars['UUID']['input'];
  taxRate: Scalars['Float']['input'];
};

export type PurchaseOrderItemUomSummary = {
  __typename?: 'PurchaseOrderItemUomSummary';
  qty: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderItemUpdateInput = {
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  purchaseOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  qty: Scalars['Float']['input'];
  taxes: Array<PurchaseOrderItemTaxUpdateInput>;
  unitPrice: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderPaged = {
  __typename?: 'PurchaseOrderPaged';
  items: Array<PurchaseOrder>;
  pagination: PaginationResult;
};

export type PurchaseOrderQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  destinationWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseOrderDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  purchaseOrderDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNo?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderQopInput = {
  filters?: InputMaybe<PurchaseOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseOrderReceiving = {
  __typename?: 'PurchaseOrderReceiving';
  adjustmentAmount: Scalars['Float']['output'];
  branchID: Scalars['UUID']['output'];
  closePO?: Maybe<Scalars['Boolean']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountType: Scalars['String']['output'];
  driverName: Scalars['String']['output'];
  driverPhoneNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files: Array<PurchaseOrderReceivingFile>;
  gmt: Scalars['Int']['output'];
  landedCost: Scalars['Float']['output'];
  landedCostPerUnit: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderNumber: Scalars['String']['output'];
  purchaseOrderReceivingDatetime: Scalars['Time']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxIncluded?: Maybe<Scalars['Boolean']['output']>;
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<PurchaseOrderReceivingTax>;
  total: Scalars['Float']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  vehiclePlateNumber: Scalars['String']['output'];
  vendor: Vendor;
  vendorID: Scalars['UUID']['output'];
  vendorRefNo: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type PurchaseOrderReceivingCreateInput = {
  closePO: Scalars['Boolean']['input'];
  driverName: Scalars['String']['input'];
  driverPhoneNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<PurchaseOrderReceivingFileInput>>;
  items: Array<PurchaseOrderReceivingItemCreateInput>;
  landedCost: Scalars['Float']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseOrderID: Scalars['UUID']['input'];
  purchaseOrderReceivingDatetime: Scalars['Time']['input'];
  vehiclePlateNumber: Scalars['String']['input'];
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorRefNo: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type PurchaseOrderReceivingFile = {
  __typename?: 'PurchaseOrderReceivingFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  purchaseOrderReceivingFileID: Scalars['UUID']['output'];
  purchaseOrderReceivingFileType: Scalars['String']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
};

export type PurchaseOrderReceivingFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseOrderReceivingItem = {
  __typename?: 'PurchaseOrderReceivingItem';
  additionalDiscountAmount: Scalars['Float']['output'];
  additionalDiscountPerc: Scalars['Float']['output'];
  additionalLandedCost: Scalars['Float']['output'];
  baseUomQty: Scalars['Float']['output'];
  baseUomUnitCost: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  itemDetails: Array<PurchaseOrderReceivingItemDetail>;
  poQty: Scalars['Float']['output'];
  poQtyOutstanding: Scalars['Float']['output'];
  poQtyReceived: Scalars['Float']['output'];
  poUomConversionRate: Scalars['Float']['output'];
  poUomID: Scalars['UUID']['output'];
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderItemID: Scalars['UUID']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemID: Scalars['UUID']['output'];
  qtyReceived: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<PurchaseOrderReceivingItemTax>;
  total: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderReceivingItemCreateInput = {
  itemDetails?: InputMaybe<Array<PurchaseOrderReceivingItemDetailCreateInput>>;
  purchaseOrderItemID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderReceivingItemDetail = {
  __typename?: 'PurchaseOrderReceivingItemDetail';
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  lotNo: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemDetailID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PurchaseOrderReceivingItemDetailCreateInput = {
  expiryDate: Scalars['Time']['input'];
  lotNo?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
};

export type PurchaseOrderReceivingItemDetailUpdateInput = {
  expiryDate: Scalars['Time']['input'];
  lotNo?: InputMaybe<Scalars['String']['input']>;
  qty: Scalars['Float']['input'];
};

export type PurchaseOrderReceivingItemPaged = {
  __typename?: 'PurchaseOrderReceivingItemPaged';
  items: Array<PurchaseOrderReceivingItem>;
  pagination: PaginationResult;
};

export type PurchaseOrderReceivingItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseOrderReceivingID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PurchaseOrderReceivingItemQopInput = {
  filters?: InputMaybe<PurchaseOrderReceivingItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseOrderReceivingItemTax = {
  __typename?: 'PurchaseOrderReceivingItemTax';
  entityAuditMetadata: EntityAuditMetadata;
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemID: Scalars['UUID']['output'];
  purchaseOrderReceivingItemTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type PurchaseOrderReceivingItemUpdateInput = {
  itemDetails?: InputMaybe<Array<PurchaseOrderReceivingItemDetailUpdateInput>>;
  purchaseOrderItemID: Scalars['UUID']['input'];
  purchaseOrderReceivingItemID?: InputMaybe<Scalars['UUID']['input']>;
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type PurchaseOrderReceivingPaged = {
  __typename?: 'PurchaseOrderReceivingPaged';
  items: Array<PurchaseOrderReceiving>;
  pagination: PaginationResult;
};

export type PurchaseOrderReceivingQopFilterInput = {
  purchaseOrderID?: InputMaybe<Scalars['UUID']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderReceivingDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  purchaseOrderReceivingDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  purchaseOrderReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PurchaseOrderReceivingQopInput = {
  filters?: InputMaybe<PurchaseOrderReceivingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PurchaseOrderReceivingTax = {
  __typename?: 'PurchaseOrderReceivingTax';
  entityAuditMetadata: EntityAuditMetadata;
  purchaseOrderReceivingID: Scalars['UUID']['output'];
  purchaseOrderReceivingTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type PurchaseOrderReceivingUpdateInput = {
  closePO: Scalars['Boolean']['input'];
  driverName: Scalars['String']['input'];
  driverPhoneNumber: Scalars['String']['input'];
  files?: InputMaybe<Array<PurchaseOrderReceivingFileInput>>;
  items: Array<PurchaseOrderReceivingItemUpdateInput>;
  landedCost: Scalars['Float']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseOrderReceivingDatetime: Scalars['Time']['input'];
  purchaseOrderReceivingID: Scalars['UUID']['input'];
  vehiclePlateNumber: Scalars['String']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type PurchaseOrderReviseInput = {
  deadlineDate: Scalars['Time']['input'];
  deliveryDate: Scalars['Time']['input'];
  destinationWarehouseID: Scalars['UUID']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  items: Array<PurchaseOrderItemReviseInput>;
  noteForVendor: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseAreaID: Scalars['UUID']['input'];
  purchaseOrderDatetime: Scalars['Time']['input'];
  purchaseOrderDatetimeUtc: Scalars['Time']['input'];
  purchaseOrderID: Scalars['UUID']['input'];
  taxIncluded: Scalars['Boolean']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorRefNo: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
};

export type PurchaseOrderTax = {
  __typename?: 'PurchaseOrderTax';
  entityAuditMetadata: EntityAuditMetadata;
  purchaseOrderID: Scalars['UUID']['output'];
  purchaseOrderTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type PurchaseOrderUpdateInput = {
  adjustmentAmount: Scalars['Float']['input'];
  branchID: Scalars['UUID']['input'];
  deadlineDate: Scalars['Time']['input'];
  deliveryDate: Scalars['Time']['input'];
  destinationWarehouseID: Scalars['UUID']['input'];
  discountAmount: Scalars['Float']['input'];
  discountPerc: Scalars['Float']['input'];
  discountPercPlus: Scalars['String']['input'];
  discountType: Scalars['String']['input'];
  items: Array<PurchaseOrderItemUpdateInput>;
  landedCost: Scalars['Float']['input'];
  noteForVendor: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  purchaseAreaID: Scalars['UUID']['input'];
  purchaseOrderDatetime: Scalars['Time']['input'];
  purchaseOrderDatetimeUtc: Scalars['Time']['input'];
  purchaseOrderID: Scalars['UUID']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
  taxIncluded: Scalars['Boolean']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorRefNo: Scalars['String']['input'];
};

export type PutawayTask = {
  __typename?: 'PutawayTask';
  assignedToUser?: Maybe<User>;
  assignedToUserID?: Maybe<Scalars['UUID']['output']>;
  assignedToUserName?: Maybe<Scalars['String']['output']>;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseLocation?: Maybe<WarehouseLocation>;
  fromWarehouseLocationCode: Scalars['String']['output'];
  fromWarehouseLocationID: Scalars['UUID']['output'];
  fromWarehouseLocationName: Scalars['String']['output'];
  inboundReceiving?: Maybe<InboundReceiving>;
  items: Array<PutawayTaskItem>;
  noteInternal: Scalars['String']['output'];
  progressPercent: Scalars['Float']['output'];
  putawayTaskDatetime: Scalars['Time']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskNumber: Scalars['String']['output'];
  sourceDocumentID: Scalars['UUID']['output'];
  sourceDocumentNumber: Scalars['String']['output'];
  sourceDocumentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taskDoneAt?: Maybe<Scalars['Time']['output']>;
  taskDurationMinute?: Maybe<Scalars['Int']['output']>;
  taskStartAt?: Maybe<Scalars['Time']['output']>;
  totalItems: Scalars['Int']['output'];
  totalQtyAssigned: Scalars['Float']['output'];
  totalQtyExecuted: Scalars['Float']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
};

export type PutawayTaskExecution = {
  __typename?: 'PutawayTaskExecution';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  executedAt: Scalars['Time']['output'];
  putawayTaskExecutionID: Scalars['UUID']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskItemID: Scalars['UUID']['output'];
  qty: Scalars['Float']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation?: Maybe<WarehouseLocation>;
  warehouseLocationCode: Scalars['String']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
};

export type PutawayTaskExecutionPaged = {
  __typename?: 'PutawayTaskExecutionPaged';
  items: Array<PutawayTaskExecution>;
  pagination: PaginationResult;
};

export type PutawayTaskExecutionQopFilterInput = {
  putawayTaskExecutionID?: InputMaybe<Scalars['UUID']['input']>;
  putawayTaskID?: InputMaybe<Scalars['UUID']['input']>;
  putawayTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PutawayTaskExecutionQopInput = {
  filters?: InputMaybe<PutawayTaskExecutionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PutawayTaskItem = {
  __typename?: 'PutawayTaskItem';
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  putawayTaskID: Scalars['UUID']['output'];
  putawayTaskItemID: Scalars['UUID']['output'];
  qtyAssigned: Scalars['Float']['output'];
  qtyExecuted: Scalars['Float']['output'];
  qtyOutstanding: Scalars['Float']['output'];
  sourceDocumentDetailID: Scalars['UUID']['output'];
  suggestionWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  suggestionWarehouseLocationName?: Maybe<Scalars['String']['output']>;
  uom?: Maybe<Uom>;
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type PutawayTaskItemPaged = {
  __typename?: 'PutawayTaskItemPaged';
  items: Array<PutawayTaskItem>;
  pagination: PaginationResult;
};

export type PutawayTaskItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  putawayTaskID?: InputMaybe<Scalars['UUID']['input']>;
  putawayTaskItemID?: InputMaybe<Scalars['UUID']['input']>;
  sourceDocumentDetailID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PutawayTaskItemQopInput = {
  filters?: InputMaybe<PutawayTaskItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PutawayTaskItemUpdateInput = {
  putawayTaskItemID: Scalars['UUID']['input'];
  qtyAssigned: Scalars['Float']['input'];
};

export type PutawayTaskPaged = {
  __typename?: 'PutawayTaskPaged';
  items: Array<PutawayTask>;
  pagination: PaginationResult;
};

export type PutawayTaskQopFilterInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  putawayTaskNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskDatetimeFrom?: InputMaybe<Scalars['Time']['input']>;
  taskDatetimeTo?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PutawayTaskQopInput = {
  filters?: InputMaybe<PutawayTaskQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type PutawayTaskUpdateInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  items?: InputMaybe<Array<PutawayTaskItemUpdateInput>>;
  putawayTaskDatetime?: InputMaybe<Scalars['Time']['input']>;
  putawayTaskID: Scalars['UUID']['input'];
  putawayTaskNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  activeShiftSessionByUserID?: Maybe<ShiftSession>;
  aiAppClients: Array<AiAppClient>;
  aiChatMessages: AiChatMessagePaged;
  aiChatSession?: Maybe<AiChatSession>;
  aiChatSessions: AiChatSessionPaged;
  aiGuardrailsConfig: AiGuardrailsConfig;
  aiScopeConfig: AiScopeConfig;
  app?: Maybe<App>;
  apps: AppPaged;
  backgroundJob?: Maybe<BackgroundJob>;
  backgroundJobs: BackgroundJobPaged;
  bank: Bank;
  bankAccount: BankAccount;
  bankAccounts: BankAccountPaged;
  bankReconciliation?: Maybe<BankReconciliation>;
  bankReconciliationFiles: Array<BankReconciliationFile>;
  bankReconciliationItems: BankReconciliationItemPaged;
  bankReconciliationPoolFiles: Array<BankReconciliationFile>;
  bankReconciliationPoolRows: BankDataRowPaged;
  bankReconciliations: BankReconciliationPaged;
  banks: BankPaged;
  biKnowledge?: Maybe<BiKnowledge>;
  biKnowledgeList: BiKnowledgePaged;
  biMonitorSummary: BiMonitorSummary;
  biRole?: Maybe<BiRole>;
  biRoles: BiRolePaged;
  biScopeTable?: Maybe<BiScopeTable>;
  biScopeTableCategories: Array<Scalars['String']['output']>;
  biScopeTables: BiScopeTablePaged;
  biUser?: Maybe<BiUser>;
  biUsers: BiUserPaged;
  billOfMaterial: BillOfMaterial;
  billOfMaterialComponent: BillOfMaterialComponent;
  billOfMaterialComponents: BillOfMaterialComponentPaged;
  billOfMaterials: BillOfMaterialPaged;
  branch?: Maybe<Branch>;
  branchBankAccount: BranchBankAccount;
  branchBankAccounts: BranchBankAccountPaged;
  branchCategories: BranchCategoryPaged;
  branchCategory?: Maybe<BranchCategory>;
  branchPosBookmark: BranchPosBookmark;
  branchPosBookmarks: BranchPosBookmarkPaged;
  branchProductSalesChannelItems: BranchProductSalesChannelItemPaged;
  branchQrisMerchant: BranchQrisMerchant;
  branchQrisMerchants: BranchQrisMerchantPaged;
  branchSalesChannelCategoryGroup: BranchSalesChannelCategoryGroup;
  branchSalesChannelCategoryGroups: BranchSalesChannelCategoryGroupPaged;
  branchSalesChannelMerchantMap: BranchSalesChannelMerchantMap;
  branchSalesChannelMerchantMaps: BranchSalesChannelMerchantMapPaged;
  branchSalesChannelMerchantMapsByBranch: Array<BranchSalesChannelMerchantMap>;
  branchSalesChannelPauseDurations: Array<PauseDurationOption>;
  branchSalesPaymentMethod: BranchSalesPaymentMethod;
  branchSalesPaymentMethods: BranchSalesPaymentMethodPaged;
  branchStoreSupervisor?: Maybe<BranchStoreSupervisor>;
  branchStoreSupervisors: BranchStoreSupervisorPaged;
  branchStoreSupervisorsByBranchID: Array<BranchStoreSupervisor>;
  branches: BranchPaged;
  /**
   * Lightweight branch list for dropdown pickers and POS first-run setup.
   *   Returns active, store-type branches only.
   */
  branchesLite: Array<BranchLite>;
  checkOTP: CheckOtpResponse;
  /** Check if quota is available for usage */
  checkPromoQuota: PromoQuotaUsageCheck;
  cities?: Maybe<CityPaged>;
  city?: Maybe<City>;
  consignmentSettlementBranches: Array<ConsignmentSettlementBranchRow>;
  consignmentSettlementExport: ConsignmentSettlementExportResult;
  consignmentSettlementHistory: Array<ConsignmentSettlementHistory>;
  consignmentSettlementListExport: ConsignmentSettlementExportResult;
  consignmentSettlementPeriods: Array<ConsignmentSettlementPeriod>;
  consignmentSettlementPivot: Array<ConsignmentSettlementPivotRow>;
  consignmentStockIn?: Maybe<ConsignmentStockIn>;
  consignmentStockInItem?: Maybe<ConsignmentStockInItem>;
  consignmentStockInItems: ConsignmentStockInItemPaged;
  consignmentStockInRequest?: Maybe<ConsignmentStockInRequest>;
  consignmentStockInRequestFiles: ConsignmentStockInRequestFilePaged;
  consignmentStockInRequestItems: ConsignmentStockInRequestItemPaged;
  consignmentStockInRequestLabels: Array<ConsignmentStockInRequestLabel>;
  consignmentStockInRequestSummary: ConsignmentStockInRequestSummary;
  consignmentStockInRequests: ConsignmentStockInRequestPaged;
  consignmentStockIns: ConsignmentStockInPaged;
  consignmentStockOut?: Maybe<ConsignmentStockOut>;
  consignmentStockOutItem?: Maybe<ConsignmentStockOutItem>;
  consignmentStockOutItems: ConsignmentStockOutItemPaged;
  consignmentStockOuts: ConsignmentStockOutPaged;
  consignmentTagPrices: Array<ConsignmentTagItem>;
  conversationTurns: ConversationTurnPaged;
  countries?: Maybe<CountryPaged>;
  country?: Maybe<Country>;
  customer: Customer;
  customerAddressByID?: Maybe<CustomerAddress>;
  customerAddressList: CustomerAddressPaged;
  customerAddressesByCustomerID: Array<CustomerAddress>;
  customerByPhoneNumber?: Maybe<Customer>;
  customerPointTransaction?: Maybe<CustomerPointTransaction>;
  customerPointTransactions: CustomerPointTransactionPaged;
  customerVoucherTransaction?: Maybe<CustomerVoucherTransaction>;
  customerVoucherTransactions: CustomerVoucherTransactionPaged;
  customers: CustomerPaged;
  deliveryOrder: DeliveryOrder;
  deliveryOrderBatch?: Maybe<DeliveryOrderBatch>;
  deliveryOrderBatchDestinationSummary: DeliveryOrderBatchDestinationSummary;
  deliveryOrderBatchDraft?: Maybe<DeliveryOrderBatch>;
  deliveryOrderBatches: DeliveryOrderBatchPaged;
  deliveryOrderItemSummaries: DeliveryOrderItemSummaryPaged;
  deliveryOrderItemSummariesByDeliveryOrderID: Array<DeliveryOrderItemSummary>;
  deliveryOrderItemSummary?: Maybe<DeliveryOrderItemSummary>;
  deliveryOrderItems: DeliveryOrderItemPaged;
  deliveryOrders: DeliveryOrderPaged;
  edcTerminal: EdcTerminal;
  edcTerminals: EdcTerminalPaged;
  employee?: Maybe<Employee>;
  employees: EmployeePaged;
  erpAccountJournal: AccountJournal;
  erpAccountJournals: AccountJournalPaged;
  erpBranch: ErpBranch;
  erpBranches: ErpBranchPaged;
  erpEmployee: ErpEmployee;
  erpEmployees: ErpEmployeePaged;
  erpProduct: ErpProduct;
  erpProductCategories: ErpProductCategoryPaged;
  erpProductCategory: ErpProductCategory;
  erpProducts: ErpProductPaged;
  erpPurchaseOrderReceive?: Maybe<ErpPurchaseOrderReceive>;
  erpPurchaseOrderReceives: ErpPurchaseOrderReceivePaged;
  erpSyncFullRun?: Maybe<ErpSyncFullRun>;
  erpSyncFullRuns: ErpSyncFullRunPaged;
  erpTax: ErpTax;
  erpTaxes: ErpTaxPaged;
  erpUom: ErpUom;
  erpUomCategories: ErpUomCategoryPaged;
  erpUomCategory: ErpUomCategory;
  erpUoms: ErpUomPaged;
  erpVendor: ErpVendor;
  erpVendors: ErpVendorPaged;
  erpWarehouse: ErpWarehouse;
  erpWarehouses: ErpWarehousePaged;
  expenseItem: ExpenseItem;
  expenseItems: ExpenseItemPaged;
  file: File;
  files: FilePaged;
  health?: Maybe<Scalars['Boolean']['output']>;
  inboundReceiving?: Maybe<InboundReceiving>;
  inboundReceivings: InboundReceivingPaged;
  internalTransfer?: Maybe<InternalTransfer>;
  internalTransferExecution: InternalTransferExecution;
  internalTransferExecutions: InternalTransferExecutionPaged;
  internalTransferItem: InternalTransferItem;
  internalTransferItems: InternalTransferItemPaged;
  internalTransfers: InternalTransferPaged;
  inventoryAdjustment: InventoryAdjustment;
  inventoryAdjustmentItem?: Maybe<InventoryAdjustmentItem>;
  inventoryAdjustmentItems: InventoryAdjustmentItemPaged;
  inventoryAdjustmentTypes: Array<InventoryAdjustmentType>;
  inventoryAdjustments: InventoryAdjustmentPaged;
  inventoryCountItemTemplate: InventoryCountItemTemplate;
  inventoryCountItemTemplateItem: InventoryCountItemTemplateItem;
  inventoryCountItemTemplateItems: InventoryCountItemTemplateItemPaged;
  inventoryCountItemTemplates: InventoryCountItemTemplatePaged;
  inventoryCountTask?: Maybe<InventoryCountTask>;
  inventoryCountTaskAssignee?: Maybe<InventoryCountTaskAssignee>;
  inventoryCountTaskAssignees: InventoryCountTaskAssigneePaged;
  inventoryCountTaskExecutionItem?: Maybe<InventoryCountTaskExecutionItem>;
  inventoryCountTaskExecutionItemDetail?: Maybe<InventoryCountTaskExecutionItemDetail>;
  inventoryCountTaskExecutionItemDetails: InventoryCountTaskExecutionItemDetailPaged;
  inventoryCountTaskExecutionItemSummaries: InventoryCountTaskExecutionItemSummaryPaged;
  inventoryCountTaskExecutionItemSummary?: Maybe<InventoryCountTaskExecutionItemSummary>;
  inventoryCountTaskExecutionItems: InventoryCountTaskExecutionItemPaged;
  inventoryCountTaskExecutionItemsInLocations: InventoryCountTaskExecutionItemPaged;
  inventoryCountTaskRecountItem?: Maybe<InventoryCountTaskRecountItem>;
  inventoryCountTaskRecountItems: InventoryCountTaskRecountItemPaged;
  inventoryCountTasks: InventoryCountTaskPaged;
  inventoryCountTransaction?: Maybe<InventoryCountTransaction>;
  inventoryCountTransactionItem?: Maybe<InventoryCountTransactionItem>;
  inventoryCountTransactionItems: InventoryCountTransactionItemPaged;
  inventoryCountTransactionLocation?: Maybe<InventoryCountTransactionLocation>;
  inventoryCountTransactionLocationDetail?: Maybe<InventoryCountTransactionLocationDetail>;
  inventoryCountTransactionLocationDetails: InventoryCountTransactionLocationDetailPaged;
  inventoryCountTransactionLocations: InventoryCountTransactionLocationPaged;
  inventoryCountTransactionResultItem?: Maybe<InventoryCountTransactionResultItem>;
  inventoryCountTransactionResultItemDetail?: Maybe<InventoryCountTransactionResultItemDetail>;
  inventoryCountTransactionResultItemDetails: InventoryCountTransactionResultItemDetailPaged;
  inventoryCountTransactionResultItems: InventoryCountTransactionResultItemPaged;
  inventoryCountTransactions: InventoryCountTransactionPaged;
  inventoryDailyMovement: InventoryDailyMovement;
  inventoryDailyMovements: InventoryDailyMovementPaged;
  inventoryLocation: InventoryLocation;
  inventoryLocations: InventoryLocationPaged;
  inventoryMovementSummary: InventoryMovementSummaryPaged;
  inventoryPosition: InventoryPosition;
  inventoryPositionSnapshot?: Maybe<InventoryPositionSnapshot>;
  inventoryPositions: InventoryPositionPaged;
  inventoryPositionsByIds: Array<InventoryPosition>;
  inventorySummaries: InventorySummaryPaged;
  inventorySummary: InventorySummary;
  inventoryTransaction: InventoryTransaction;
  inventoryTransactionItem: InventoryTransactionLineItem;
  inventoryTransactionItems: InventoryTransactionLineItemPaged;
  inventoryTransactionLine: InventoryTransactionLine;
  inventoryTransactionLineUnit: InventoryTransactionLineUnit;
  inventoryTransactionLineUnits: InventoryTransactionLineUnitPaged;
  inventoryTransactionLines: InventoryTransactionLinePaged;
  inventoryTransactions: InventoryTransactionPaged;
  latestProductImageEmbeddingRun?: Maybe<IngestionRunInfo>;
  marketplaceBackgroundJob?: Maybe<MarketplaceBackgroundJob>;
  marketplaceBackgroundJobs: MarketplaceBackgroundJobPaged;
  marketplaceCampaign?: Maybe<MarketplaceCampaign>;
  marketplaceCampaignProducts: MarketplaceCampaignProductPaged;
  marketplaceCampaigns: MarketplaceCampaignPaged;
  marketplaceChannelAPILog?: Maybe<MarketplaceChannelApiLog>;
  marketplaceChannelAPILogs: MarketplaceChannelApiLogPaged;
  marketplaceChannelTaxonomy: Array<ChannelTaxonomyNode>;
  marketplaceCronSettings: MarketplaceCronSettingPaged;
  marketplaceInboundOrder?: Maybe<MarketplaceInboundOrder>;
  marketplaceInboundOrders: MarketplaceInboundOrderPaged;
  marketplaceMenuSyncStatus?: Maybe<MarketplaceMenuSyncStatus>;
  marketplaceOrder?: Maybe<MarketplaceOrder>;
  marketplaceOrderCheckCancelable: MarketplaceOrderCancelableResult;
  marketplaceOrderExport: MarketplaceOrderExportFile;
  marketplaceOrderItem?: Maybe<MarketplaceOrderItem>;
  marketplaceOrderItems: MarketplaceOrderItemPaged;
  marketplaceOrders: MarketplaceOrderPaged;
  marketplacePromoForPublish?: Maybe<MarketplacePromoForPublish>;
  marketplaceProviderCampaigns: Array<MarketplaceProviderCampaign>;
  marketplacePublishablePromos: Array<MarketplaceProvisionablePromo>;
  marketplaceStoreStatus?: Maybe<MarketplaceStoreStatus>;
  marketplaceSyncHealth: Array<MarketplaceChannelSyncHealth>;
  masterdataBackgroundJob?: Maybe<MasterdataBackgroundJob>;
  memberType: MemberType;
  memberTypes: MemberTypePaged;
  mobilePickingTask: MobilePickingTask;
  mobilePutawayTask: MobilePutawayTask;
  myInventoryCountTaskHistories: InventoryCountTaskPaged;
  myInventoryCountTasks: InventoryCountTaskPaged;
  myPickingTasks: PickingTaskPaged;
  myPutawayTasks?: Maybe<PutawayTaskPaged>;
  nonMainUoms: UomPaged;
  outboundContainer?: Maybe<OutboundContainer>;
  outboundContainerItems: OutboundContainerItemPaged;
  outboundContainerItemsSummary: OutboundContainerItemGroupedPaged;
  outboundContainers: OutboundContainerPaged;
  packingTask: PackingTask;
  packingTaskContainer?: Maybe<PackingTaskContainer>;
  packingTaskContainerItem?: Maybe<PackingTaskContainerItem>;
  packingTaskContainerItems: PackingTaskContainerItemPaged;
  packingTaskContainers: PackingTaskContainerPaged;
  packingTaskExecution: PackingTaskExecution;
  packingTaskExecutions: PackingTaskExecutionPaged;
  packingTaskItem?: Maybe<PackingTaskItem>;
  packingTaskItems: PackingTaskItemPaged;
  packingTasks: PackingTaskPaged;
  paymentInboundRequests: PaymentInboundRequestLogPaged;
  paymentInquiryLogs: PaymentInquiryLogPaged;
  paymentProviderConfig?: Maybe<PaymentProviderConfig>;
  paymentProviderConfigs: PaymentProviderConfigPaged;
  paymentTransaction: PaymentTransaction;
  paymentTransactions: PaymentTransactionPaged;
  paymentWebhookEvents: PaymentWebhookEventPaged;
  permission?: Maybe<Permission>;
  permissions: PermissionPaged;
  pettyCashAddFundTransaction?: Maybe<PettyCashAddFundTransaction>;
  pettyCashAddFundTransactions: PettyCashAddFundTransactionPaged;
  pettyCashBalance?: Maybe<PettyCashBalance>;
  pettyCashBalances: PettyCashBalancePaged;
  pettyCashExpenseTransaction?: Maybe<PettyCashExpenseTransaction>;
  pettyCashExpenseTransactionItem?: Maybe<PettyCashExpenseTransactionItem>;
  pettyCashExpenseTransactionItems: PettyCashExpenseTransactionItemPaged;
  pettyCashExpenseTransactions: PettyCashExpenseTransactionPaged;
  pettyCashLedger?: Maybe<PettyCashLedger>;
  pettyCashLedgers: PettyCashLedgerPaged;
  pettyCashRefundTransaction?: Maybe<PettyCashRefundTransaction>;
  pettyCashRefundTransactions: PettyCashRefundTransactionPaged;
  pettyCashTransaction?: Maybe<PettyCashTransaction>;
  pettyCashTransactionFiles: PettyCashTransactionFilePaged;
  pettyCashTransactions: PettyCashTransactionPaged;
  pickingTask?: Maybe<PickingTask>;
  pickingTaskExecution?: Maybe<PickingTaskExecution>;
  pickingTaskExecutions: PickingTaskExecutionPaged;
  pickingTaskGenerateByZonePreview: PickingTaskGenerateByZonePreviewResponse;
  pickingTaskItem?: Maybe<PickingTaskItem>;
  pickingTaskItems: PickingTaskItemPaged;
  pickingTasks: PickingTaskPaged;
  posBookmark: PosBookmark;
  posBookmarkProduct: PosBookmarkProduct;
  posBookmarkProducts: PosBookmarkProductPaged;
  posBookmarks: PosBookmarkPaged;
  /**
   * Deprecated alias: use branchesLite instead.
   * @deprecated Use branchesLite instead
   */
  posBranches: Array<PosBranch>;
  posSalesOrder: PosSalesOrder;
  posSalesOrders: PosSalesOrderPaged;
  poster: Poster;
  /** Full poster-image stream for POS cursor sync. Cursor mode cannot be combined with filters, so POS pulls everything and joins on posterID locally. */
  posterImages: PosterImagePaged;
  posters: PosterPaged;
  pricelist: Pricelist;
  pricelistPeriod?: Maybe<PricelistPeriod>;
  pricelistPeriods: PricelistPeriodPaged;
  pricelistProduct: PricelistProduct;
  pricelistProductSalesChannel: PricelistProductSalesChannel;
  pricelistProductSalesChannelByCompositeKey?: Maybe<PricelistProductSalesChannel>;
  pricelistProductSalesChannels: PricelistProductSalesChannelPaged;
  pricelistProducts: PricelistProductPaged;
  pricelistSalesChannel?: Maybe<PricelistSalesChannel>;
  pricelistSalesChannels: PricelistSalesChannelPaged;
  pricelistTagPrices: Array<PriceTagItem>;
  pricelists: PricelistPaged;
  product: Product;
  productAIImage: ProductAiImage;
  productAIImages: ProductAiImagePaged;
  productAccountingCategories: ProductAccountingCategoryPaged;
  productAccountingCategory?: Maybe<ProductAccountingCategory>;
  productAddon: ProductAddon;
  productAddonComponent?: Maybe<ProductAddonComponent>;
  productAddonComponents: ProductAddonComponentPaged;
  productAddonComponentsByProductAddonID: Array<ProductAddonComponent>;
  productAddonGroup: ProductAddonGroup;
  productAddonGroupItem: ProductAddonGroupItem;
  productAddonGroupItems: ProductAddonGroupItemPaged;
  productAddonGroupItemsByGroupID: Array<ProductAddonGroupItem>;
  productAddonGroups: ProductAddonGroupPaged;
  productAddons: ProductAddonPaged;
  productAvailabilityTemplate: ProductAvailabilityTemplate;
  productAvailabilityTemplateItem: ProductAvailabilityTemplateItem;
  productAvailabilityTemplateItems: ProductAvailabilityTemplateItemPaged;
  productAvailabilityTemplates: ProductAvailabilityTemplatePaged;
  productBarcodeConflicts: Array<BarcodeConflictOwner>;
  productBarcodeMap: ProductBarcodeMap;
  productBarcodeMaps: ProductBarcodeMapPaged;
  productBookmark: ProductBookmark;
  productBookmarkProduct: ProductBookmarkProduct;
  productBookmarkProducts: ProductBookmarkProductPaged;
  productBookmarks: ProductBookmarkPaged;
  productBrand?: Maybe<ProductBrand>;
  productBrands: ProductBrandPaged;
  productBundleComponent?: Maybe<ProductBundleComponent>;
  productBundleComponents: ProductBundleComponentPaged;
  productBundleComponentsByProductID: Array<ProductBundleComponent>;
  productCategories: ProductCategoryPaged;
  productCategory?: Maybe<ProductCategory>;
  productCategorySalesChannelMap: ProductCategorySalesChannelMap;
  productCategorySalesChannelMaps: ProductCategorySalesChannelMapPaged;
  productDepartment?: Maybe<ProductDepartment>;
  productDepartments: ProductDepartmentPaged;
  productDivision: ProductDivision;
  productDivisions: ProductDivisionPaged;
  productFile: ProductFile;
  productFiles: ProductFilePaged;
  productImageEmbeddingChanges: Array<DeltaItem>;
  productImageEmbeddingDelta: DeltaPage;
  productImageEmbeddingSnapshot: SnapshotPage;
  productImageEmbeddingSyncHead: ProductImageEmbeddingSyncHead;
  productSalesChannelItemMap: ProductSalesChannelItemMap;
  productSalesChannelItemMaps: ProductSalesChannelItemMapPaged;
  productSource?: Maybe<ProductSource>;
  productSources: ProductSourcePaged;
  productSubCategories: ProductSubCategoryPaged;
  productSubCategory?: Maybe<ProductSubCategory>;
  productSubDepartment?: Maybe<ProductSubDepartment>;
  productSubDepartments: ProductSubDepartmentPaged;
  productTag?: Maybe<ProductTag>;
  productTagProduct: ProductTagProduct;
  productTagProducts: ProductTagProductPaged;
  productTags: ProductTagPaged;
  productVendor: ProductVendor;
  productVendors: ProductVendorPaged;
  productionOrder?: Maybe<ProductionOrder>;
  productionOrderComponent?: Maybe<ProductionOrderComponent>;
  productionOrderComponents: ProductionOrderComponentPaged;
  productionOrders: ProductionOrderPaged;
  products: ProductPaged;
  promo: Promo;
  promoCat1: PromoCat1Detail;
  promoCat2: PromoCat2Detail;
  promoCat3: PromoCat3Detail;
  promoCat4: PromoCat4Detail;
  promoCat5: PromoCat5Detail;
  promoCat6: PromoCat6Detail;
  promoComponent: PromoComponent;
  promoComponentCat1: PromoComponentCat1Detail;
  promoComponentCat2: PromoComponentCat2Detail;
  promoComponentCat3: PromoComponentCat3Detail;
  promoComponentCat4: PromoComponentCat4Detail;
  promoComponentCat5: PromoComponentCat5Detail;
  promoComponentCat6: PromoComponentCat6Detail;
  promoComponents: PromoComponentPaged;
  /** Get promo quota config by ID */
  promoQuota?: Maybe<PromoQuota>;
  /** Get branch usage for a specific quota and branch */
  promoQuotaBranchUsage?: Maybe<PromoQuotaBranchUsage>;
  /** Get all branch usages for a quota */
  promoQuotaBranchUsages: PromoQuotaBranchUsagePagedResult;
  /** Get paginated list of promo quota configs */
  promoQuotas: PromoQuotaPagedResult;
  promoType: PromoType;
  promoTypes: PromoTypePaged;
  promos: PromoPaged;
  province?: Maybe<Province>;
  provinces?: Maybe<ProvincePaged>;
  purchaseArea?: Maybe<PurchaseArea>;
  purchaseAreas: PurchaseAreaPaged;
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderItem?: Maybe<PurchaseOrderItem>;
  purchaseOrderItems: PurchaseOrderItemPaged;
  purchaseOrderReceiving?: Maybe<PurchaseOrderReceiving>;
  purchaseOrderReceivingItem?: Maybe<PurchaseOrderReceivingItem>;
  purchaseOrderReceivingItems: PurchaseOrderReceivingItemPaged;
  purchaseOrderReceivings: PurchaseOrderReceivingPaged;
  purchaseOrders: PurchaseOrderPaged;
  putawayTask: PutawayTask;
  putawayTaskByNumber: PutawayTask;
  putawayTaskExecution: PutawayTaskExecution;
  putawayTaskExecutions: PutawayTaskExecutionPaged;
  putawayTaskItem: PutawayTaskItem;
  putawayTaskItems: PutawayTaskItemPaged;
  putawayTasks: PutawayTaskPaged;
  reason: Reason;
  reasonInventoryAdjustment: ReasonInventoryAdjustment;
  reasonInventoryAdjustments: ReasonInventoryAdjustmentPaged;
  reasons: ReasonPaged;
  replenishment: Replenishment;
  replenishmentItem: ReplenishmentItem;
  replenishmentItems: ReplenishmentItemPaged;
  replenishmentTemplate: ReplenishmentTemplate;
  replenishmentTemplateCategories: ReplenishmentTemplateCategoryPaged;
  replenishmentTemplateCategory: ReplenishmentTemplateCategory;
  replenishmentTemplateItem: ReplenishmentTemplateItem;
  replenishmentTemplateItems: ReplenishmentTemplateItemPaged;
  replenishmentTemplates: ReplenishmentTemplatePaged;
  replenishments: ReplenishmentPaged;
  resource?: Maybe<Resource>;
  resources: ResourcePaged;
  revenueReport?: Maybe<RevenueReport>;
  revenueReportAccessLogSummary: RevenueReportAccessLogSummary;
  revenueReportAccessLogs: RevenueReportAccessLogPaged;
  revenueReportApiKeys: RevenueReportApiKeyPaged;
  revenueReportDetails: RevenueReportDetailPaged;
  revenueReportPartner?: Maybe<RevenueReportPartner>;
  revenueReportPartnerBranch?: Maybe<RevenueReportPartnerBranch>;
  revenueReportPartnerBranches: RevenueReportPartnerBranchPaged;
  revenueReportPartners: RevenueReportPartnerPaged;
  revenueReportSummary: RevenueReportSummary;
  revenueReportTemplate?: Maybe<RevenueReportTemplate>;
  revenueReportTemplatePreview: Scalars['String']['output'];
  revenueReportTemplates: RevenueReportTemplatePaged;
  revenueReportUploadBatches: RevenueReportUploadBatchPaged;
  revenueReportUser?: Maybe<RevenueReportUser>;
  revenueReportUsers: RevenueReportUserPaged;
  revenueReports: RevenueReportPaged;
  revenueSharing?: Maybe<RevenueSharing>;
  revenueSharingBranch?: Maybe<RevenueSharingBranch>;
  revenueSharingBranches: RevenueSharingBranchPaged;
  revenueSharingDetail?: Maybe<RevenueSharingDetail>;
  revenueSharingDetailLippoLive: Array<RevenueSharingLippoLiveRow>;
  revenueSharingDetails: RevenueSharingDetailPaged;
  revenueSharingUploadBatches: Array<RevenueSharingUploadBatch>;
  revenueSharings: RevenueSharingPaged;
  role?: Maybe<RoleDetail>;
  roles: RolePaged;
  salesChannel?: Maybe<SalesChannel>;
  salesChannelCampaign: SalesChannelCampaign;
  salesChannelCampaignChannels: Array<SalesChannelCampaignChannel>;
  salesChannelCampaignProducts: SalesChannelCampaignProductPaged;
  salesChannelCampaignResults: SalesChannelCampaignResultPaged;
  salesChannelCampaigns: SalesChannelCampaignPaged;
  salesChannelCategories: SalesChannelCategoryPaged;
  salesChannelCategory: SalesChannelCategory;
  salesChannelCategoryGroup: SalesChannelCategoryGroup;
  salesChannelCategoryGroupItem: SalesChannelCategoryGroupItem;
  salesChannelCategoryGroupItems: SalesChannelCategoryGroupItemPaged;
  salesChannelCategoryGroupProduct: SalesChannelCategoryGroupProduct;
  salesChannelCategoryGroupProducts: SalesChannelCategoryGroupProductPaged;
  salesChannelCategoryGroups: SalesChannelCategoryGroupPaged;
  salesChannelMenuBuild: SalesChannelBuiltMenu;
  salesChannelStockThresholds: SalesChannelStockThresholdPaged;
  salesChannels: SalesChannelPaged;
  salesConsignmentInvoice?: Maybe<SalesConsignmentInvoice>;
  salesConsignmentInvoiceItem?: Maybe<SalesConsignmentInvoiceItem>;
  salesConsignmentInvoiceItems: SalesConsignmentInvoiceItemPaged;
  salesConsignmentInvoices: SalesConsignmentInvoicePaged;
  salesDashboard: SalesDashboard;
  salesInvoice?: Maybe<SalesInvoice>;
  salesInvoiceItem?: Maybe<SalesInvoiceItem>;
  salesInvoiceItems: SalesInvoiceItemPaged;
  salesInvoicePayments: SalesInvoicePaymentPaged;
  salesInvoiceReview?: Maybe<SalesInvoiceReview>;
  salesInvoiceReviews: SalesInvoiceReviewPaged;
  salesInvoices: SalesInvoicePaged;
  salesPaymentMethod: SalesPaymentMethod;
  salesPaymentMethodType: SalesPaymentMethodType;
  salesPaymentMethodTypes: SalesPaymentMethodTypePaged;
  salesPaymentMethods: SalesPaymentMethodPaged;
  shiftSession: ShiftSession;
  shiftSessions: ShiftSessionPaged;
  simpleTransferOrder?: Maybe<SimpleTransferOrder>;
  simpleTransferOrderItem?: Maybe<SimpleTransferOrderItem>;
  simpleTransferOrderItemLocations: SimpleTransferOrderItemLocationPaged;
  simpleTransferOrderItems: SimpleTransferOrderItemPaged;
  simpleTransferOrderReceiving?: Maybe<SimpleTransferOrderReceiving>;
  simpleTransferOrderReceivingItem?: Maybe<SimpleTransferOrderReceivingItem>;
  simpleTransferOrderReceivingItems: SimpleTransferOrderReceivingItemPaged;
  simpleTransferOrderReceivings: SimpleTransferOrderReceivingPaged;
  simpleTransferOrders: SimpleTransferOrderPaged;
  subdistrict?: Maybe<Subdistrict>;
  subdistricts?: Maybe<SubdistrictPaged>;
  tax: Tax;
  taxes: TaxPaged;
  transferOrder?: Maybe<TransferOrder>;
  transferOrderItem?: Maybe<TransferOrderItem>;
  transferOrderItems: TransferOrderItemPaged;
  transferOrderReceiving?: Maybe<TransferOrderReceiving>;
  transferOrderReceivingItem?: Maybe<TransferOrderReceivingItem>;
  transferOrderReceivingItems: TransferOrderReceivingItemPaged;
  transferOrderReceivings: TransferOrderReceivingPaged;
  transferOrders: TransferOrderPaged;
  transferRequest?: Maybe<TransferRequest>;
  transferRequestItem?: Maybe<TransferRequestItem>;
  transferRequestItems: TransferRequestItemPaged;
  transferRequests: TransferRequestPaged;
  unassignedPickingTasks: PickingTaskPaged;
  unassignedPutawayTasks?: Maybe<PutawayTaskPaged>;
  uom: Uom;
  uomCategories: UomCategoryPaged;
  uomCategory: UomCategory;
  uoms: UomPaged;
  uploadTemplate: UploadTemplate;
  uploadTemplates: UploadTemplatePaged;
  user?: Maybe<UserDetail>;
  userProfile: UserProfile;
  userTokenByCode?: Maybe<UserToken>;
  users: UserPaged;
  usersLite: UserLitePaged;
  vendor: Vendor;
  vendorCategories: VendorCategoryPaged;
  vendorCategory: VendorCategory;
  vendorConsignmentBranch: VendorConsignmentBranch;
  vendorConsignmentBranchPeriod?: Maybe<VendorConsignmentBranchPeriod>;
  vendorConsignmentBranchPeriodByBranch?: Maybe<VendorConsignmentBranchPeriod>;
  vendorConsignmentBranchPeriods: VendorConsignmentBranchPeriodPaged;
  vendorConsignmentBranches: VendorConsignmentBranchPaged;
  vendorConsignmentDashboard: VendorConsignmentDashboard;
  vendorConsignmentInvoice?: Maybe<VendorConsignmentInvoice>;
  vendorConsignmentInvoiceConfig?: Maybe<VendorConsignmentInvoiceConfig>;
  vendorConsignmentInvoiceConfigs: VendorConsignmentInvoiceConfigPaged;
  vendorConsignmentInvoiceEmailPreview: Scalars['String']['output'];
  vendorConsignmentInvoiceSummary: VendorConsignmentInvoiceSummary;
  vendorConsignmentInvoices: VendorConsignmentInvoicePaged;
  vendorConsignmentPaymentChargeConfigs: VendorConsignmentPaymentChargeConfigPaged;
  vendorConsignmentProduct: VendorConsignmentProduct;
  vendorConsignmentProducts: VendorConsignmentProductAggregatedPaged;
  vendorConsignmentProductsByBranch: VendorConsignmentImportItemPaged;
  vendorConsignmentRentalPayment?: Maybe<VendorConsignmentRentalPayment>;
  vendorConsignmentRentalPayments: VendorConsignmentRentalPaymentPaged;
  vendorConsignmentSalesExport: VendorConsignmentSalesExportResult;
  /**
   * A vendor's consignment stock aggregated per cabang (branch), storage warehouses
   *   only. Pagination is applied after aggregation so totals reflect cabang count.
   */
  vendorConsignmentStockByBranch: VendorConsignmentStockByBranchPaged;
  /** The same rows as the table, as .xlsx, honouring the same search and result filters. */
  vendorInventoryCountExport: VendorInventoryCountExportResult;
  /**
   * Opnames the vendor can open, newest first. Only counts whose stock adjustment has
   *   posted: an in-progress or unposted one would show numbers that still change.
   *
   *   Capped at 200 — a picker is a dropdown, and a vendor with a longer history should
   *   narrow the period rather than pull every count they ever appeared in.
   */
  vendorInventoryCountList: Array<VendorInventoryCountListItem>;
  /** Cards plus the paged item table for one opname. */
  vendorInventoryCountReport: VendorInventoryCountReport;
  vendorPicContact: VendorPicContact;
  vendorPicContacts: VendorPicContactPaged;
  vendorStockExport: VendorStockExportResult;
  /** Stock movement breakdown behind one product on the vendor stock opname detail page. */
  vendorStockReconciliation: VendorStockReconciliation;
  vendors: VendorPaged;
  village: Village;
  villages: VillagePaged;
  voucher?: Maybe<Voucher>;
  voucherCategories: VoucherCategoryPaged;
  voucherCategory?: Maybe<VoucherCategory>;
  voucherItem?: Maybe<VoucherItem>;
  voucherItemByCode?: Maybe<VoucherItem>;
  voucherItems: VoucherItemPaged;
  vouchers: VoucherPaged;
  warehouse?: Maybe<Warehouse>;
  warehouseLocation?: Maybe<WarehouseLocation>;
  warehouseLocationGroup?: Maybe<WarehouseLocationGroup>;
  warehouseLocationGroups: WarehouseLocationGroupPaged;
  warehouseLocationRelationMap: WarehouseLocationRelationMap;
  warehouseLocationRelationMaps: WarehouseLocationRelationMapPaged;
  warehouseLocationSortableFields: Array<Scalars['String']['output']>;
  warehouseLocations: WarehouseLocationPaged;
  warehouseProductLocationMap?: Maybe<WarehouseProductLocationMap>;
  warehouseProductLocationMaps: WarehouseProductLocationMapPaged;
  warehouseReplenishmentTemplate?: Maybe<WarehouseReplenishmentTemplate>;
  warehouseReplenishmentTemplates: WarehouseReplenishmentTemplatePaged;
  warehouses: WarehousePaged;
};


export type QueryActiveShiftSessionByUserIdArgs = {
  userID: Scalars['UUID']['input'];
};


export type QueryAiChatMessagesArgs = {
  input: AiChatMessageQopInput;
};


export type QueryAiChatSessionArgs = {
  sessionID: Scalars['String']['input'];
};


export type QueryAiChatSessionsArgs = {
  input?: InputMaybe<AiChatSessionQopInput>;
};


export type QueryAppArgs = {
  appID: Scalars['String']['input'];
};


export type QueryAppsArgs = {
  qop?: InputMaybe<AppQopInput>;
};


export type QueryBackgroundJobArgs = {
  backgroundJobID: Scalars['UUID']['input'];
};


export type QueryBackgroundJobsArgs = {
  qop?: InputMaybe<BackgroundJobQopInput>;
};


export type QueryBankArgs = {
  bankID: Scalars['UUID']['input'];
};


export type QueryBankAccountArgs = {
  bankAccountID: Scalars['UUID']['input'];
};


export type QueryBankAccountsArgs = {
  qop?: InputMaybe<BankAccountQopInput>;
};


export type QueryBankReconciliationArgs = {
  bankReconciliationID: Scalars['UUID']['input'];
};


export type QueryBankReconciliationFilesArgs = {
  bankReconciliationID: Scalars['UUID']['input'];
};


export type QueryBankReconciliationItemsArgs = {
  qop?: InputMaybe<BankReconciliationItemQopInput>;
};


export type QueryBankReconciliationPoolFilesArgs = {
  bankID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryBankReconciliationPoolRowsArgs = {
  qop?: InputMaybe<BankDataRowQopInput>;
};


export type QueryBankReconciliationsArgs = {
  qop?: InputMaybe<BankReconciliationQopInput>;
};


export type QueryBanksArgs = {
  qop?: InputMaybe<BankQopInput>;
};


export type QueryBiKnowledgeArgs = {
  biKnowledgeID: Scalars['UUID']['input'];
};


export type QueryBiKnowledgeListArgs = {
  qop?: InputMaybe<BiKnowledgeQopInput>;
};


export type QueryBiRoleArgs = {
  role: Scalars['String']['input'];
};


export type QueryBiRolesArgs = {
  qop?: InputMaybe<BiRoleQopInput>;
};


export type QueryBiScopeTableArgs = {
  tableName: Scalars['String']['input'];
};


export type QueryBiScopeTablesArgs = {
  qop?: InputMaybe<BiScopeTableQopInput>;
};


export type QueryBiUserArgs = {
  biUserID: Scalars['UUID']['input'];
};


export type QueryBiUsersArgs = {
  qop?: InputMaybe<BiUserQopInput>;
};


export type QueryBillOfMaterialArgs = {
  billOfMaterialID: Scalars['UUID']['input'];
};


export type QueryBillOfMaterialComponentArgs = {
  billOfMaterialComponentID: Scalars['UUID']['input'];
};


export type QueryBillOfMaterialComponentsArgs = {
  qop?: InputMaybe<BillOfMaterialComponentQopInput>;
};


export type QueryBillOfMaterialsArgs = {
  qop?: InputMaybe<BillOfMaterialQopInput>;
};


export type QueryBranchArgs = {
  branchID: Scalars['UUID']['input'];
};


export type QueryBranchBankAccountArgs = {
  branchBankAccountID: Scalars['UUID']['input'];
};


export type QueryBranchBankAccountsArgs = {
  qop?: InputMaybe<BranchBankAccountQopInput>;
};


export type QueryBranchCategoriesArgs = {
  qop?: InputMaybe<BranchCategoryQopInput>;
};


export type QueryBranchCategoryArgs = {
  branchCategoryID: Scalars['UUID']['input'];
};


export type QueryBranchPosBookmarkArgs = {
  branchPosBookmarkID: Scalars['UUID']['input'];
};


export type QueryBranchPosBookmarksArgs = {
  qop?: InputMaybe<BranchPosBookmarkQopInput>;
};


export type QueryBranchProductSalesChannelItemsArgs = {
  qop?: InputMaybe<BranchProductSalesChannelItemQopInput>;
};


export type QueryBranchQrisMerchantArgs = {
  branchQrisMerchantID: Scalars['UUID']['input'];
};


export type QueryBranchQrisMerchantsArgs = {
  qop?: InputMaybe<BranchQrisMerchantQopInput>;
};


export type QueryBranchSalesChannelCategoryGroupArgs = {
  branchSalesChannelCategoryGroupID: Scalars['UUID']['input'];
};


export type QueryBranchSalesChannelCategoryGroupsArgs = {
  qop?: InputMaybe<BranchSalesChannelCategoryGroupQopInput>;
};


export type QueryBranchSalesChannelMerchantMapArgs = {
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
};


export type QueryBranchSalesChannelMerchantMapsArgs = {
  qop?: InputMaybe<BranchSalesChannelMerchantMapQopInput>;
};


export type QueryBranchSalesChannelMerchantMapsByBranchArgs = {
  branchID: Scalars['UUID']['input'];
};


export type QueryBranchSalesChannelPauseDurationsArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type QueryBranchSalesPaymentMethodArgs = {
  branchSalesPaymentMethodID: Scalars['UUID']['input'];
};


export type QueryBranchSalesPaymentMethodsArgs = {
  qop?: InputMaybe<BranchSalesPaymentMethodQopInput>;
};


export type QueryBranchStoreSupervisorArgs = {
  branchStoreSupervisorID: Scalars['UUID']['input'];
};


export type QueryBranchStoreSupervisorsArgs = {
  qop?: InputMaybe<BranchStoreSupervisorQopInput>;
};


export type QueryBranchStoreSupervisorsByBranchIdArgs = {
  branchID: Scalars['UUID']['input'];
};


export type QueryBranchesArgs = {
  qop?: InputMaybe<BranchQopInput>;
};


export type QueryCheckOtpArgs = {
  input: CheckOtpRequest;
};


export type QueryCheckPromoQuotaArgs = {
  input: PromoQuotaCheckInput;
};


export type QueryCitiesArgs = {
  qop?: InputMaybe<CityQop>;
};


export type QueryCityArgs = {
  id: Scalars['String']['input'];
};


export type QueryConsignmentSettlementBranchesArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryConsignmentSettlementExportArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryConsignmentSettlementHistoryArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryConsignmentSettlementListExportArgs = {
  filter: ConsignmentSettlementListExportFilterInput;
};


export type QueryConsignmentSettlementPivotArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInArgs = {
  consignmentStockInID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInItemArgs = {
  consignmentStockInItemID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInItemsArgs = {
  qop?: InputMaybe<ConsignmentStockInItemQopInput>;
};


export type QueryConsignmentStockInRequestArgs = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInRequestFilesArgs = {
  qop?: InputMaybe<ConsignmentStockInRequestFileQopInput>;
};


export type QueryConsignmentStockInRequestItemsArgs = {
  qop?: InputMaybe<ConsignmentStockInRequestItemQopInput>;
};


export type QueryConsignmentStockInRequestLabelsArgs = {
  consignmentStockInRequestID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockInRequestSummaryArgs = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryConsignmentStockInRequestsArgs = {
  qop?: InputMaybe<ConsignmentStockInRequestQopInput>;
};


export type QueryConsignmentStockInsArgs = {
  qop?: InputMaybe<ConsignmentStockInQopInput>;
};


export type QueryConsignmentStockOutArgs = {
  consignmentStockOutID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockOutItemArgs = {
  consignmentStockOutItemID: Scalars['UUID']['input'];
};


export type QueryConsignmentStockOutItemsArgs = {
  qop?: InputMaybe<ConsignmentStockOutItemQopInput>;
};


export type QueryConsignmentStockOutsArgs = {
  qop?: InputMaybe<ConsignmentStockOutQopInput>;
};


export type QueryConsignmentTagPricesArgs = {
  input: ConsignmentTagPricesInput;
};


export type QueryConversationTurnsArgs = {
  qop?: InputMaybe<ConversationTurnQopInput>;
};


export type QueryCountriesArgs = {
  qop?: InputMaybe<CountryQop>;
};


export type QueryCountryArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerArgs = {
  customerID: Scalars['UUID']['input'];
};


export type QueryCustomerAddressByIdArgs = {
  customerAddressID: Scalars['UUID']['input'];
};


export type QueryCustomerAddressListArgs = {
  qop?: InputMaybe<CustomerAddressQopInput>;
};


export type QueryCustomerAddressesByCustomerIdArgs = {
  customerID: Scalars['UUID']['input'];
};


export type QueryCustomerByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryCustomerPointTransactionArgs = {
  customerPointTransactionID: Scalars['UUID']['input'];
};


export type QueryCustomerPointTransactionsArgs = {
  qop?: InputMaybe<CustomerPointTransactionQopInput>;
};


export type QueryCustomerVoucherTransactionArgs = {
  customerVoucherTransactionID: Scalars['UUID']['input'];
};


export type QueryCustomerVoucherTransactionsArgs = {
  qop?: InputMaybe<CustomerVoucherTransactionQopInput>;
};


export type QueryCustomersArgs = {
  qop?: InputMaybe<CustomerQopInput>;
};


export type QueryDeliveryOrderArgs = {
  deliveryOrderID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderBatchArgs = {
  deliveryOrderBatchID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderBatchDestinationSummaryArgs = {
  destinationWarehouseID: Scalars['UUID']['input'];
  originWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryDeliveryOrderBatchDraftArgs = {
  destinationWarehouseID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderBatchesArgs = {
  qop?: InputMaybe<DeliveryOrderBatchQopInput>;
};


export type QueryDeliveryOrderItemSummariesArgs = {
  qop?: InputMaybe<DeliveryOrderItemSummaryQopInput>;
};


export type QueryDeliveryOrderItemSummariesByDeliveryOrderIdArgs = {
  deliveryOrderID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderItemSummaryArgs = {
  deliveryOrderItemSummaryID: Scalars['UUID']['input'];
};


export type QueryDeliveryOrderItemsArgs = {
  qop?: InputMaybe<DeliveryOrderItemQopInput>;
};


export type QueryDeliveryOrdersArgs = {
  qop?: InputMaybe<DeliveryOrderQopInput>;
};


export type QueryEdcTerminalArgs = {
  edcTerminalID: Scalars['UUID']['input'];
};


export type QueryEdcTerminalsArgs = {
  qop?: InputMaybe<EdcTerminalQopInput>;
};


export type QueryEmployeeArgs = {
  employeeID: Scalars['UUID']['input'];
};


export type QueryEmployeesArgs = {
  qop?: InputMaybe<EmployeeQopInput>;
};


export type QueryErpAccountJournalArgs = {
  accountJournalID: Scalars['Int']['input'];
};


export type QueryErpAccountJournalsArgs = {
  qop?: InputMaybe<AccountJournalQopInput>;
};


export type QueryErpBranchArgs = {
  branchID: Scalars['Int']['input'];
};


export type QueryErpBranchesArgs = {
  qop?: InputMaybe<ErpBranchQopInput>;
};


export type QueryErpEmployeeArgs = {
  employeeID: Scalars['Int64']['input'];
};


export type QueryErpEmployeesArgs = {
  qop?: InputMaybe<ErpEmployeeQopInput>;
};


export type QueryErpProductArgs = {
  productID: Scalars['Int']['input'];
};


export type QueryErpProductCategoriesArgs = {
  qop?: InputMaybe<ErpProductCategoryQopInput>;
};


export type QueryErpProductCategoryArgs = {
  productCategoryID: Scalars['Int']['input'];
};


export type QueryErpProductsArgs = {
  qop?: InputMaybe<ErpProductQopInput>;
};


export type QueryErpPurchaseOrderReceiveArgs = {
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};


export type QueryErpPurchaseOrderReceivesArgs = {
  qop?: InputMaybe<ErpPurchaseOrderReceiveQopInput>;
};


export type QueryErpSyncFullRunArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryErpSyncFullRunsArgs = {
  qop?: InputMaybe<ErpSyncFullRunQopInput>;
};


export type QueryErpTaxArgs = {
  taxID: Scalars['Int']['input'];
};


export type QueryErpTaxesArgs = {
  qop?: InputMaybe<ErpTaxQopInput>;
};


export type QueryErpUomArgs = {
  uomID: Scalars['Int']['input'];
};


export type QueryErpUomCategoriesArgs = {
  qop?: InputMaybe<ErpUomCategoryQopInput>;
};


export type QueryErpUomCategoryArgs = {
  uomCategoryID: Scalars['Int']['input'];
};


export type QueryErpUomsArgs = {
  qop?: InputMaybe<ErpUomQopInput>;
};


export type QueryErpVendorArgs = {
  vendorID: Scalars['Int']['input'];
};


export type QueryErpVendorsArgs = {
  qop?: InputMaybe<ErpVendorQopInput>;
};


export type QueryErpWarehouseArgs = {
  warehouseID: Scalars['Int']['input'];
};


export type QueryErpWarehousesArgs = {
  qop?: InputMaybe<ErpWarehouseQopInput>;
};


export type QueryExpenseItemArgs = {
  expenseItemID: Scalars['UUID']['input'];
};


export type QueryExpenseItemsArgs = {
  qop?: InputMaybe<ExpenseItemQopInput>;
};


export type QueryFileArgs = {
  fileID: Scalars['UUID']['input'];
};


export type QueryFilesArgs = {
  qop?: InputMaybe<FileQopInput>;
};


export type QueryInboundReceivingArgs = {
  inboundReceivingID: Scalars['UUID']['input'];
};


export type QueryInboundReceivingsArgs = {
  qop?: InputMaybe<InboundReceivingQopInput>;
};


export type QueryInternalTransferArgs = {
  internalTransferID: Scalars['UUID']['input'];
};


export type QueryInternalTransferExecutionArgs = {
  internalTransferExecutionID: Scalars['UUID']['input'];
};


export type QueryInternalTransferExecutionsArgs = {
  qop?: InputMaybe<InternalTransferExecutionQopInput>;
};


export type QueryInternalTransferItemArgs = {
  internalTransferItemID: Scalars['UUID']['input'];
};


export type QueryInternalTransferItemsArgs = {
  qop?: InputMaybe<InternalTransferItemQopInput>;
};


export type QueryInternalTransfersArgs = {
  qop?: InputMaybe<InternalTransferQopInput>;
};


export type QueryInventoryAdjustmentArgs = {
  inventoryAdjustmentID: Scalars['UUID']['input'];
};


export type QueryInventoryAdjustmentItemArgs = {
  inventoryAdjustmentItemID: Scalars['UUID']['input'];
};


export type QueryInventoryAdjustmentItemsArgs = {
  qop?: InputMaybe<InventoryAdjustmentItemQopInput>;
};


export type QueryInventoryAdjustmentTypesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInventoryAdjustmentsArgs = {
  qop?: InputMaybe<InventoryAdjustmentQopInput>;
};


export type QueryInventoryCountItemTemplateArgs = {
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
};


export type QueryInventoryCountItemTemplateItemArgs = {
  inventoryCountItemTemplateItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountItemTemplateItemsArgs = {
  qop?: InputMaybe<InventoryCountItemTemplateItemQopInput>;
};


export type QueryInventoryCountItemTemplatesArgs = {
  qop?: InputMaybe<InventoryCountItemTemplateQopInput>;
};


export type QueryInventoryCountTaskArgs = {
  inventoryCountTaskID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskAssigneeArgs = {
  inventoryCountTaskAssigneeID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskAssigneesArgs = {
  qop?: InputMaybe<InventoryCountTaskAssigneeQopInput>;
};


export type QueryInventoryCountTaskExecutionItemArgs = {
  inventoryCountTaskExecutionItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskExecutionItemDetailArgs = {
  inventoryCountTaskExecutionItemDetailID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskExecutionItemDetailsArgs = {
  qop?: InputMaybe<InventoryCountTaskExecutionItemDetailQopInput>;
};


export type QueryInventoryCountTaskExecutionItemSummariesArgs = {
  qop?: InputMaybe<InventoryCountTaskExecutionItemSummaryQopInput>;
};


export type QueryInventoryCountTaskExecutionItemSummaryArgs = {
  inventoryCountTaskExecutionItemSummaryID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskExecutionItemsArgs = {
  qop?: InputMaybe<InventoryCountTaskExecutionItemQopInput>;
};


export type QueryInventoryCountTaskExecutionItemsInLocationsArgs = {
  qop?: InputMaybe<InventoryCountTaskExecutionItemQopInput>;
};


export type QueryInventoryCountTaskRecountItemArgs = {
  inventoryCountTaskRecountItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTaskRecountItemsArgs = {
  qop?: InputMaybe<InventoryCountTaskRecountItemQopInput>;
};


export type QueryInventoryCountTasksArgs = {
  qop?: InputMaybe<InventoryCountTaskQopInput>;
};


export type QueryInventoryCountTransactionArgs = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionItemArgs = {
  inventoryCountTransactionItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionItemsArgs = {
  qop?: InputMaybe<InventoryCountTransactionItemQopInput>;
};


export type QueryInventoryCountTransactionLocationArgs = {
  inventoryCountTransactionLocationID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionLocationDetailArgs = {
  inventoryCountTransactionLocationDetailID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionLocationDetailsArgs = {
  qop?: InputMaybe<InventoryCountTransactionLocationDetailQopInput>;
};


export type QueryInventoryCountTransactionLocationsArgs = {
  qop?: InputMaybe<InventoryCountTransactionLocationQopInput>;
};


export type QueryInventoryCountTransactionResultItemArgs = {
  inventoryCountTransactionResultItemID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionResultItemDetailArgs = {
  inventoryCountTransactionResultItemDetailID: Scalars['UUID']['input'];
};


export type QueryInventoryCountTransactionResultItemDetailsArgs = {
  qop?: InputMaybe<InventoryCountTransactionResultItemDetailQopInput>;
};


export type QueryInventoryCountTransactionResultItemsArgs = {
  qop?: InputMaybe<InventoryCountTransactionResultItemQopInput>;
};


export type QueryInventoryCountTransactionsArgs = {
  qop?: InputMaybe<InventoryCountTransactionQopInput>;
};


export type QueryInventoryDailyMovementArgs = {
  inventoryDailyMovementID: Scalars['UUID']['input'];
};


export type QueryInventoryDailyMovementsArgs = {
  qop?: InputMaybe<InventoryDailyMovementQopInput>;
};


export type QueryInventoryLocationArgs = {
  inventoryLocationID: Scalars['UUID']['input'];
};


export type QueryInventoryLocationsArgs = {
  qop?: InputMaybe<InventoryLocationQopInput>;
};


export type QueryInventoryMovementSummaryArgs = {
  qop: InventoryMovementSummaryQopInput;
};


export type QueryInventoryPositionArgs = {
  inventoryPositionID: Scalars['UUID']['input'];
};


export type QueryInventoryPositionSnapshotArgs = {
  qop?: InputMaybe<InventoryPositionSnapshotQopInput>;
};


export type QueryInventoryPositionsArgs = {
  qop?: InputMaybe<InventoryPositionQopInput>;
};


export type QueryInventoryPositionsByIdsArgs = {
  inventoryPositionIds: Array<Scalars['UUID']['input']>;
};


export type QueryInventorySummariesArgs = {
  qop?: InputMaybe<InventorySummaryQopInput>;
};


export type QueryInventorySummaryArgs = {
  inventorySummaryID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionArgs = {
  inventoryTransactionID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionItemArgs = {
  inventoryTransactionItemID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionItemsArgs = {
  qop?: InputMaybe<InventoryTransactionItemQopInput>;
};


export type QueryInventoryTransactionLineArgs = {
  inventoryTransactionLineID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionLineUnitArgs = {
  inventoryTransactionLineUnitID: Scalars['UUID']['input'];
};


export type QueryInventoryTransactionLineUnitsArgs = {
  qop?: InputMaybe<InventoryTransactionLineUnitQopInput>;
};


export type QueryInventoryTransactionLinesArgs = {
  qop?: InputMaybe<InventoryTransactionLineQopInput>;
};


export type QueryInventoryTransactionsArgs = {
  qop?: InputMaybe<InventoryTransactionQopInput>;
};


export type QueryMarketplaceBackgroundJobArgs = {
  marketplaceBackgroundJobID: Scalars['UUID']['input'];
};


export type QueryMarketplaceBackgroundJobsArgs = {
  qop?: InputMaybe<MarketplaceBackgroundJobQopInput>;
};


export type QueryMarketplaceCampaignArgs = {
  marketplaceCampaignID: Scalars['UUID']['input'];
};


export type QueryMarketplaceCampaignProductsArgs = {
  qop?: InputMaybe<MarketplaceCampaignProductQopInput>;
};


export type QueryMarketplaceCampaignsArgs = {
  qop?: InputMaybe<MarketplaceCampaignQopInput>;
};


export type QueryMarketplaceChannelApiLogArgs = {
  marketplaceChannelAPILogID: Scalars['UUID']['input'];
};


export type QueryMarketplaceChannelApiLogsArgs = {
  qop?: InputMaybe<MarketplaceChannelApiLogQopInput>;
};


export type QueryMarketplaceChannelTaxonomyArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceCronSettingsArgs = {
  qop?: InputMaybe<MarketplaceCronSettingQopInput>;
};


export type QueryMarketplaceInboundOrderArgs = {
  marketplaceInboundOrderID: Scalars['UUID']['input'];
};


export type QueryMarketplaceInboundOrdersArgs = {
  qop?: InputMaybe<MarketplaceInboundOrderQopInput>;
};


export type QueryMarketplaceMenuSyncStatusArgs = {
  externalMerchantID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceOrderArgs = {
  marketplaceOrderID: Scalars['UUID']['input'];
};


export type QueryMarketplaceOrderCheckCancelableArgs = {
  externalOrderID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceOrderExportArgs = {
  qop?: InputMaybe<MarketplaceOrderQopInput>;
};


export type QueryMarketplaceOrderItemArgs = {
  marketplaceOrderItemID: Scalars['UUID']['input'];
};


export type QueryMarketplaceOrderItemsArgs = {
  qop?: InputMaybe<MarketplaceOrderItemQopInput>;
};


export type QueryMarketplaceOrdersArgs = {
  qop?: InputMaybe<MarketplaceOrderQopInput>;
};


export type QueryMarketplacePromoForPublishArgs = {
  promoID: Scalars['UUID']['input'];
};


export type QueryMarketplaceProviderCampaignsArgs = {
  externalMerchantID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplacePublishablePromosArgs = {
  externalMerchantID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceStoreStatusArgs = {
  externalMerchantID: Scalars['String']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryMarketplaceSyncHealthArgs = {
  salesChannelIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryMasterdataBackgroundJobArgs = {
  backgroundJobID: Scalars['UUID']['input'];
};


export type QueryMemberTypeArgs = {
  memberTypeID: Scalars['UUID']['input'];
};


export type QueryMemberTypesArgs = {
  qop?: InputMaybe<MemberTypeQopInput>;
};


export type QueryMobilePickingTaskArgs = {
  pickingTaskID: Scalars['UUID']['input'];
};


export type QueryMobilePutawayTaskArgs = {
  putawayTaskID: Scalars['UUID']['input'];
};


export type QueryMyInventoryCountTaskHistoriesArgs = {
  qop?: InputMaybe<InventoryCountTaskQopInput>;
};


export type QueryMyInventoryCountTasksArgs = {
  qop?: InputMaybe<InventoryCountTaskQopInput>;
};


export type QueryMyPickingTasksArgs = {
  qop?: InputMaybe<PickingTaskQopInput>;
};


export type QueryMyPutawayTasksArgs = {
  qop?: InputMaybe<PutawayTaskQopInput>;
};


export type QueryNonMainUomsArgs = {
  qop?: InputMaybe<UomQopInput>;
};


export type QueryOutboundContainerArgs = {
  outboundContainerID: Scalars['UUID']['input'];
};


export type QueryOutboundContainerItemsArgs = {
  qop?: InputMaybe<OutboundContainerItemQopInput>;
};


export type QueryOutboundContainerItemsSummaryArgs = {
  qop?: InputMaybe<OutboundContainerItemGroupedQopInput>;
};


export type QueryOutboundContainersArgs = {
  qop?: InputMaybe<OutboundContainerQopInput>;
};


export type QueryPackingTaskArgs = {
  packingTaskID: Scalars['UUID']['input'];
};


export type QueryPackingTaskContainerArgs = {
  packingTaskContainerID: Scalars['UUID']['input'];
};


export type QueryPackingTaskContainerItemArgs = {
  packingTaskContainerItemID: Scalars['UUID']['input'];
};


export type QueryPackingTaskContainerItemsArgs = {
  qop?: InputMaybe<PackingTaskContainerItemQopInput>;
};


export type QueryPackingTaskContainersArgs = {
  qop?: InputMaybe<PackingTaskContainerQopInput>;
};


export type QueryPackingTaskExecutionArgs = {
  packingTaskExecutionID: Scalars['UUID']['input'];
};


export type QueryPackingTaskExecutionsArgs = {
  qop?: InputMaybe<PackingTaskExecutionQopInput>;
};


export type QueryPackingTaskItemArgs = {
  packingTaskItemID: Scalars['UUID']['input'];
};


export type QueryPackingTaskItemsArgs = {
  qop?: InputMaybe<PackingTaskItemQopInput>;
};


export type QueryPackingTasksArgs = {
  qop?: InputMaybe<PackingTaskQopInput>;
};


export type QueryPaymentInboundRequestsArgs = {
  qop?: InputMaybe<PaymentInboundRequestLogQopInput>;
};


export type QueryPaymentInquiryLogsArgs = {
  qop?: InputMaybe<PaymentInquiryLogQopInput>;
};


export type QueryPaymentProviderConfigArgs = {
  paymentProviderConfigID: Scalars['UUID']['input'];
};


export type QueryPaymentProviderConfigsArgs = {
  qop?: InputMaybe<PaymentProviderConfigQopInput>;
};


export type QueryPaymentTransactionArgs = {
  paymentTransactionID: Scalars['UUID']['input'];
};


export type QueryPaymentTransactionsArgs = {
  qop?: InputMaybe<PaymentTransactionQopInput>;
};


export type QueryPaymentWebhookEventsArgs = {
  qop?: InputMaybe<PaymentWebhookEventQopInput>;
};


export type QueryPermissionArgs = {
  permissionID: Scalars['String']['input'];
};


export type QueryPermissionsArgs = {
  qop?: InputMaybe<PermissionQopInput>;
};


export type QueryPettyCashAddFundTransactionArgs = {
  pettyCashTransactionID: Scalars['UUID']['input'];
};


export type QueryPettyCashAddFundTransactionsArgs = {
  qop?: InputMaybe<PettyCashAddFundTransactionQopInput>;
};


export type QueryPettyCashBalanceArgs = {
  pettyCashBalanceID: Scalars['UUID']['input'];
};


export type QueryPettyCashBalancesArgs = {
  qop?: InputMaybe<PettyCashBalanceQopInput>;
};


export type QueryPettyCashExpenseTransactionArgs = {
  pettyCashTransactionID: Scalars['UUID']['input'];
};


export type QueryPettyCashExpenseTransactionItemArgs = {
  pettyCashExpenseTransactionItemID: Scalars['UUID']['input'];
};


export type QueryPettyCashExpenseTransactionItemsArgs = {
  qop?: InputMaybe<PettyCashExpenseTransactionItemQopInput>;
};


export type QueryPettyCashExpenseTransactionsArgs = {
  qop?: InputMaybe<PettyCashExpenseTransactionQopInput>;
};


export type QueryPettyCashLedgerArgs = {
  pettyCashTransactionLedgerID: Scalars['UUID']['input'];
};


export type QueryPettyCashLedgersArgs = {
  qop?: InputMaybe<PettyCashLedgerQopInput>;
};


export type QueryPettyCashRefundTransactionArgs = {
  pettyCashTransactionID: Scalars['UUID']['input'];
};


export type QueryPettyCashRefundTransactionsArgs = {
  qop?: InputMaybe<PettyCashRefundTransactionQopInput>;
};


export type QueryPettyCashTransactionArgs = {
  pettyCashTransactionID: Scalars['UUID']['input'];
};


export type QueryPettyCashTransactionFilesArgs = {
  qop?: InputMaybe<PettyCashTransactionFileQopInput>;
};


export type QueryPettyCashTransactionsArgs = {
  qop?: InputMaybe<PettyCashTransactionQopInput>;
};


export type QueryPickingTaskArgs = {
  pickingTaskID: Scalars['UUID']['input'];
};


export type QueryPickingTaskExecutionArgs = {
  pickingTaskExecutionID: Scalars['UUID']['input'];
};


export type QueryPickingTaskExecutionsArgs = {
  qop?: InputMaybe<PickingTaskExecutionQopInput>;
};


export type QueryPickingTaskGenerateByZonePreviewArgs = {
  input: PickingTaskGenerateByZonePreviewInput;
};


export type QueryPickingTaskItemArgs = {
  pickingTaskItemID: Scalars['UUID']['input'];
};


export type QueryPickingTaskItemsArgs = {
  qop?: InputMaybe<PickingTaskItemQopInput>;
};


export type QueryPickingTasksArgs = {
  qop?: InputMaybe<PickingTaskQopInput>;
};


export type QueryPosBookmarkArgs = {
  posBookmarkID: Scalars['UUID']['input'];
};


export type QueryPosBookmarkProductArgs = {
  posBookmarkProductID: Scalars['UUID']['input'];
};


export type QueryPosBookmarkProductsArgs = {
  qop?: InputMaybe<PosBookmarkProductQopInput>;
};


export type QueryPosBookmarksArgs = {
  qop?: InputMaybe<PosBookmarkQopInput>;
};


export type QueryPosSalesOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPosSalesOrdersArgs = {
  qop?: InputMaybe<PosSalesOrderQopInput>;
};


export type QueryPosterArgs = {
  posterID: Scalars['UUID']['input'];
};


export type QueryPosterImagesArgs = {
  qop?: InputMaybe<PosterImageQopInput>;
};


export type QueryPostersArgs = {
  qop?: InputMaybe<PosterQopInput>;
};


export type QueryPricelistArgs = {
  pricelistID: Scalars['UUID']['input'];
};


export type QueryPricelistPeriodArgs = {
  pricelistPeriodID: Scalars['UUID']['input'];
};


export type QueryPricelistPeriodsArgs = {
  qop?: InputMaybe<PricelistPeriodQopInput>;
};


export type QueryPricelistProductArgs = {
  pricelistProductID: Scalars['UUID']['input'];
};


export type QueryPricelistProductSalesChannelArgs = {
  pricelistProductSalesChannelID: Scalars['UUID']['input'];
};


export type QueryPricelistProductSalesChannelByCompositeKeyArgs = {
  pricelistProductID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QueryPricelistProductSalesChannelsArgs = {
  qop?: InputMaybe<PricelistProductSalesChannelQopInput>;
};


export type QueryPricelistProductsArgs = {
  qop?: InputMaybe<PricelistProductQopInput>;
};


export type QueryPricelistSalesChannelArgs = {
  pricelistSalesChannelID: Scalars['UUID']['input'];
};


export type QueryPricelistSalesChannelsArgs = {
  qop?: InputMaybe<PricelistSalesChannelQopInput>;
};


export type QueryPricelistTagPricesArgs = {
  input: PricelistTagPricesInput;
};


export type QueryPricelistsArgs = {
  qop?: InputMaybe<PricelistQopInput>;
};


export type QueryProductArgs = {
  productID: Scalars['UUID']['input'];
};


export type QueryProductAiImageArgs = {
  productAIImageID: Scalars['UUID']['input'];
};


export type QueryProductAiImagesArgs = {
  qop?: InputMaybe<ProductAiImageQopInput>;
};


export type QueryProductAccountingCategoriesArgs = {
  qop?: InputMaybe<ProductAccountingCategoryQopInput>;
};


export type QueryProductAccountingCategoryArgs = {
  productAccountingCategoryID: Scalars['UUID']['input'];
};


export type QueryProductAddonArgs = {
  productAddonID: Scalars['UUID']['input'];
};


export type QueryProductAddonComponentArgs = {
  productAddonComponentID: Scalars['UUID']['input'];
};


export type QueryProductAddonComponentsArgs = {
  qop?: InputMaybe<ProductAddonComponentQopInput>;
};


export type QueryProductAddonComponentsByProductAddonIdArgs = {
  productAddonID: Scalars['UUID']['input'];
};


export type QueryProductAddonGroupArgs = {
  productAddonGroupID: Scalars['UUID']['input'];
};


export type QueryProductAddonGroupItemArgs = {
  productAddonGroupItemID: Scalars['UUID']['input'];
};


export type QueryProductAddonGroupItemsArgs = {
  qop?: InputMaybe<ProductAddonGroupItemQopInput>;
};


export type QueryProductAddonGroupItemsByGroupIdArgs = {
  productAddonGroupID: Scalars['UUID']['input'];
};


export type QueryProductAddonGroupsArgs = {
  qop?: InputMaybe<ProductAddonGroupQopInput>;
};


export type QueryProductAddonsArgs = {
  qop?: InputMaybe<ProductAddonQopInput>;
};


export type QueryProductAvailabilityTemplateArgs = {
  productAvailabilityTemplateID: Scalars['UUID']['input'];
};


export type QueryProductAvailabilityTemplateItemArgs = {
  productAvailabilityTemplateItemID: Scalars['UUID']['input'];
};


export type QueryProductAvailabilityTemplateItemsArgs = {
  qop?: InputMaybe<ProductAvailabilityTemplateItemQopInput>;
};


export type QueryProductAvailabilityTemplatesArgs = {
  qop?: InputMaybe<ProductAvailabilityTemplateQopInput>;
};


export type QueryProductBarcodeConflictsArgs = {
  barcodes: Array<Scalars['String']['input']>;
  excludeProductID?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryProductBarcodeMapArgs = {
  productBarcodeMapID: Scalars['UUID']['input'];
};


export type QueryProductBarcodeMapsArgs = {
  qop?: InputMaybe<ProductBarcodeMapQopInput>;
};


export type QueryProductBookmarkArgs = {
  productBookmarkID: Scalars['UUID']['input'];
};


export type QueryProductBookmarkProductArgs = {
  productBookmarkProductID: Scalars['UUID']['input'];
};


export type QueryProductBookmarkProductsArgs = {
  qop?: InputMaybe<ProductBookmarkProductQopInput>;
};


export type QueryProductBookmarksArgs = {
  qop?: InputMaybe<ProductBookmarkQopInput>;
};


export type QueryProductBrandArgs = {
  productBrandID: Scalars['UUID']['input'];
};


export type QueryProductBrandsArgs = {
  qop?: InputMaybe<ProductBrandQopInput>;
};


export type QueryProductBundleComponentArgs = {
  productBundleComponentID: Scalars['UUID']['input'];
};


export type QueryProductBundleComponentsArgs = {
  qop?: InputMaybe<ProductBundleComponentQopInput>;
};


export type QueryProductBundleComponentsByProductIdArgs = {
  productID: Scalars['UUID']['input'];
};


export type QueryProductCategoriesArgs = {
  qop?: InputMaybe<ProductCategoryQopInput>;
};


export type QueryProductCategoryArgs = {
  productCategoryID: Scalars['UUID']['input'];
};


export type QueryProductCategorySalesChannelMapArgs = {
  productCategorySalesChannelMapID: Scalars['UUID']['input'];
};


export type QueryProductCategorySalesChannelMapsArgs = {
  qop?: InputMaybe<ProductCategorySalesChannelMapQopInput>;
};


export type QueryProductDepartmentArgs = {
  productDepartmentID: Scalars['UUID']['input'];
};


export type QueryProductDepartmentsArgs = {
  qop?: InputMaybe<ProductDepartmentQopInput>;
};


export type QueryProductDivisionArgs = {
  productDivisionID: Scalars['UUID']['input'];
};


export type QueryProductDivisionsArgs = {
  qop?: InputMaybe<ProductDivisionQopInput>;
};


export type QueryProductFileArgs = {
  productFileID: Scalars['UUID']['input'];
};


export type QueryProductFilesArgs = {
  qop?: InputMaybe<ProductFileQopInput>;
};


export type QueryProductImageEmbeddingChangesArgs = {
  afterSeq?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductImageEmbeddingDeltaArgs = {
  afterSeq?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductImageEmbeddingSnapshotArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductSalesChannelItemMapArgs = {
  productSalesChannelItemMapID: Scalars['UUID']['input'];
};


export type QueryProductSalesChannelItemMapsArgs = {
  qop?: InputMaybe<ProductSalesChannelItemMapQopInput>;
};


export type QueryProductSourceArgs = {
  productSourceID: Scalars['UUID']['input'];
};


export type QueryProductSourcesArgs = {
  qop?: InputMaybe<ProductSourceQopInput>;
};


export type QueryProductSubCategoriesArgs = {
  qop?: InputMaybe<ProductSubCategoryQopInput>;
};


export type QueryProductSubCategoryArgs = {
  productSubCategoryID: Scalars['UUID']['input'];
};


export type QueryProductSubDepartmentArgs = {
  productSubDepartmentID: Scalars['UUID']['input'];
};


export type QueryProductSubDepartmentsArgs = {
  qop?: InputMaybe<ProductSubDepartmentQopInput>;
};


export type QueryProductTagArgs = {
  productTagID: Scalars['UUID']['input'];
};


export type QueryProductTagProductArgs = {
  productTagProductID: Scalars['UUID']['input'];
};


export type QueryProductTagProductsArgs = {
  qop?: InputMaybe<ProductTagProductQopInput>;
};


export type QueryProductTagsArgs = {
  qop?: InputMaybe<ProductTagQopInput>;
};


export type QueryProductVendorArgs = {
  productVendorID: Scalars['UUID']['input'];
};


export type QueryProductVendorsArgs = {
  qop?: InputMaybe<ProductVendorQopInput>;
};


export type QueryProductionOrderArgs = {
  productionOrderID: Scalars['UUID']['input'];
};


export type QueryProductionOrderComponentArgs = {
  productionOrderComponentID: Scalars['UUID']['input'];
};


export type QueryProductionOrderComponentsArgs = {
  qop?: InputMaybe<ProductionOrderComponentQopInput>;
};


export type QueryProductionOrdersArgs = {
  qop?: InputMaybe<ProductionOrderQopInput>;
};


export type QueryProductsArgs = {
  qop?: InputMaybe<ProductQopInput>;
};


export type QueryPromoArgs = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat1Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat2Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat3Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat4Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat5Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoCat6Args = {
  promoID: Scalars['UUID']['input'];
};


export type QueryPromoComponentArgs = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat1Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat2Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat3Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat4Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat5Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentCat6Args = {
  promoComponentID: Scalars['UUID']['input'];
};


export type QueryPromoComponentsArgs = {
  qop?: InputMaybe<PromoComponentQopInput>;
};


export type QueryPromoQuotaArgs = {
  promoQuotaID: Scalars['UUID']['input'];
};


export type QueryPromoQuotaBranchUsageArgs = {
  branchID: Scalars['UUID']['input'];
  promoQuotaID: Scalars['UUID']['input'];
};


export type QueryPromoQuotaBranchUsagesArgs = {
  input: PromoQuotaBranchUsageQopInput;
};


export type QueryPromoQuotasArgs = {
  input: PromoQuotaQopInput;
};


export type QueryPromoTypeArgs = {
  promoTypeID: Scalars['UUID']['input'];
};


export type QueryPromoTypesArgs = {
  qop?: InputMaybe<PromoTypeQopInput>;
};


export type QueryPromosArgs = {
  qop?: InputMaybe<PromoQopInput>;
};


export type QueryProvinceArgs = {
  id: Scalars['String']['input'];
};


export type QueryProvincesArgs = {
  qop?: InputMaybe<ProvinceQop>;
};


export type QueryPurchaseAreaArgs = {
  purchaseAreaID: Scalars['UUID']['input'];
};


export type QueryPurchaseAreasArgs = {
  qop?: InputMaybe<PurchaseAreaQopInput>;
};


export type QueryPurchaseOrderArgs = {
  purchaseOrderID: Scalars['UUID']['input'];
};


export type QueryPurchaseOrderItemArgs = {
  purchaseOrderItemID: Scalars['UUID']['input'];
};


export type QueryPurchaseOrderItemsArgs = {
  qop?: InputMaybe<PurchaseOrderItemQopInput>;
};


export type QueryPurchaseOrderReceivingArgs = {
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};


export type QueryPurchaseOrderReceivingItemArgs = {
  purchaseOrderReceivingItemID: Scalars['UUID']['input'];
};


export type QueryPurchaseOrderReceivingItemsArgs = {
  qop?: InputMaybe<PurchaseOrderReceivingItemQopInput>;
};


export type QueryPurchaseOrderReceivingsArgs = {
  qop?: InputMaybe<PurchaseOrderReceivingQopInput>;
};


export type QueryPurchaseOrdersArgs = {
  qop?: InputMaybe<PurchaseOrderQopInput>;
};


export type QueryPutawayTaskArgs = {
  putawayTaskID: Scalars['UUID']['input'];
};


export type QueryPutawayTaskByNumberArgs = {
  putawayTaskNumber: Scalars['String']['input'];
};


export type QueryPutawayTaskExecutionArgs = {
  putawayTaskExecutionID: Scalars['UUID']['input'];
};


export type QueryPutawayTaskExecutionsArgs = {
  qop?: InputMaybe<PutawayTaskExecutionQopInput>;
};


export type QueryPutawayTaskItemArgs = {
  putawayTaskItemID: Scalars['UUID']['input'];
};


export type QueryPutawayTaskItemsArgs = {
  qop?: InputMaybe<PutawayTaskItemQopInput>;
};


export type QueryPutawayTasksArgs = {
  qop?: InputMaybe<PutawayTaskQopInput>;
};


export type QueryReasonArgs = {
  reasonID: Scalars['UUID']['input'];
};


export type QueryReasonInventoryAdjustmentArgs = {
  reasonInventoryAdjustmentID: Scalars['UUID']['input'];
};


export type QueryReasonInventoryAdjustmentsArgs = {
  qop?: InputMaybe<ReasonInventoryAdjustmentQopInput>;
};


export type QueryReasonsArgs = {
  qop?: InputMaybe<ReasonQopInput>;
};


export type QueryReplenishmentArgs = {
  replenishmentID: Scalars['UUID']['input'];
};


export type QueryReplenishmentItemArgs = {
  replenishmentItemID: Scalars['UUID']['input'];
};


export type QueryReplenishmentItemsArgs = {
  qop?: InputMaybe<ReplenishmentItemQopInput>;
};


export type QueryReplenishmentTemplateArgs = {
  replenishmentTemplateID: Scalars['UUID']['input'];
};


export type QueryReplenishmentTemplateCategoriesArgs = {
  qop?: InputMaybe<ReplenishmentTemplateCategoryQopInput>;
};


export type QueryReplenishmentTemplateCategoryArgs = {
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
};


export type QueryReplenishmentTemplateItemArgs = {
  replenishmentTemplateItemID: Scalars['UUID']['input'];
};


export type QueryReplenishmentTemplateItemsArgs = {
  qop?: InputMaybe<ReplenishmentTemplateItemQopInput>;
};


export type QueryReplenishmentTemplatesArgs = {
  qop?: InputMaybe<ReplenishmentTemplateQopInput>;
};


export type QueryReplenishmentsArgs = {
  qop?: InputMaybe<ReplenishmentQopInput>;
};


export type QueryResourceArgs = {
  resourceID: Scalars['String']['input'];
};


export type QueryResourcesArgs = {
  qop?: InputMaybe<ResourceQopInput>;
};


export type QueryRevenueReportArgs = {
  revenueReportID: Scalars['UUID']['input'];
};


export type QueryRevenueReportAccessLogSummaryArgs = {
  qop?: InputMaybe<RevenueReportAccessLogQopInput>;
};


export type QueryRevenueReportAccessLogsArgs = {
  qop?: InputMaybe<RevenueReportAccessLogQopInput>;
};


export type QueryRevenueReportApiKeysArgs = {
  qop?: InputMaybe<RevenueReportApiKeyQopInput>;
};


export type QueryRevenueReportDetailsArgs = {
  qop?: InputMaybe<RevenueReportDetailQopInput>;
};


export type QueryRevenueReportPartnerArgs = {
  revenueReportPartnerID: Scalars['UUID']['input'];
};


export type QueryRevenueReportPartnerBranchArgs = {
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};


export type QueryRevenueReportPartnerBranchesArgs = {
  qop?: InputMaybe<RevenueReportPartnerBranchQopInput>;
};


export type QueryRevenueReportPartnersArgs = {
  qop?: InputMaybe<RevenueReportPartnerQopInput>;
};


export type QueryRevenueReportSummaryArgs = {
  qop?: InputMaybe<RevenueReportQopInput>;
};


export type QueryRevenueReportTemplateArgs = {
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type QueryRevenueReportTemplatePreviewArgs = {
  deliveryMode: Scalars['String']['input'];
  revenueReportTemplateID: Scalars['UUID']['input'];
};


export type QueryRevenueReportTemplatesArgs = {
  qop?: InputMaybe<RevenueReportTemplateQopInput>;
};


export type QueryRevenueReportUploadBatchesArgs = {
  qop?: InputMaybe<RevenueReportUploadBatchQopInput>;
};


export type QueryRevenueReportUserArgs = {
  revenueReportUserID: Scalars['UUID']['input'];
};


export type QueryRevenueReportUsersArgs = {
  qop?: InputMaybe<RevenueReportUserQopInput>;
};


export type QueryRevenueReportsArgs = {
  qop?: InputMaybe<RevenueReportQopInput>;
};


export type QueryRevenueSharingArgs = {
  revenueSharingID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingBranchArgs = {
  revenueSharingBranchID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingBranchesArgs = {
  qop?: InputMaybe<RevenueSharingBranchQopInput>;
};


export type QueryRevenueSharingDetailArgs = {
  revenueSharingDetailID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingDetailLippoLiveArgs = {
  revenueSharingDetailID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingDetailsArgs = {
  qop?: InputMaybe<RevenueSharingDetailQopInput>;
};


export type QueryRevenueSharingUploadBatchesArgs = {
  revenueSharingID: Scalars['UUID']['input'];
};


export type QueryRevenueSharingsArgs = {
  qop?: InputMaybe<RevenueSharingQopInput>;
};


export type QueryRoleArgs = {
  roleID: Scalars['UUID']['input'];
};


export type QueryRolesArgs = {
  qop?: InputMaybe<RoleQopInput>;
};


export type QuerySalesChannelArgs = {
  salesChannelID: Scalars['String']['input'];
};


export type QuerySalesChannelCampaignArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCampaignChannelsArgs = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCampaignProductsArgs = {
  qop?: InputMaybe<SalesChannelCampaignProductQopInput>;
};


export type QuerySalesChannelCampaignResultsArgs = {
  qop?: InputMaybe<SalesChannelCampaignResultQopInput>;
};


export type QuerySalesChannelCampaignsArgs = {
  qop?: InputMaybe<SalesChannelCampaignQopInput>;
};


export type QuerySalesChannelCategoriesArgs = {
  qop?: InputMaybe<SalesChannelCategoryQopInput>;
};


export type QuerySalesChannelCategoryArgs = {
  salesChannelCategoryID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCategoryGroupArgs = {
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCategoryGroupItemArgs = {
  salesChannelCategoryGroupItemID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCategoryGroupItemsArgs = {
  qop?: InputMaybe<SalesChannelCategoryGroupItemQopInput>;
};


export type QuerySalesChannelCategoryGroupProductArgs = {
  salesChannelCategoryGroupProductID: Scalars['UUID']['input'];
};


export type QuerySalesChannelCategoryGroupProductsArgs = {
  qop?: InputMaybe<SalesChannelCategoryGroupProductQopInput>;
};


export type QuerySalesChannelCategoryGroupsArgs = {
  qop?: InputMaybe<SalesChannelCategoryGroupQopInput>;
};


export type QuerySalesChannelMenuBuildArgs = {
  branchID: Scalars['UUID']['input'];
  salesChannelID: Scalars['String']['input'];
};


export type QuerySalesChannelStockThresholdsArgs = {
  qop?: InputMaybe<SalesChannelStockThresholdQopInput>;
};


export type QuerySalesChannelsArgs = {
  qop?: InputMaybe<SalesChannelQopInput>;
};


export type QuerySalesConsignmentInvoiceArgs = {
  salesConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QuerySalesConsignmentInvoiceItemArgs = {
  salesConsignmentInvoiceItemID: Scalars['UUID']['input'];
};


export type QuerySalesConsignmentInvoiceItemsArgs = {
  qop?: InputMaybe<SalesConsignmentInvoiceItemQopInput>;
};


export type QuerySalesConsignmentInvoicesArgs = {
  qop?: InputMaybe<SalesConsignmentInvoiceQopInput>;
};


export type QuerySalesDashboardArgs = {
  filter?: InputMaybe<SalesDashboardFilterInput>;
};


export type QuerySalesInvoiceArgs = {
  salesInvoiceID: Scalars['UUID']['input'];
};


export type QuerySalesInvoiceItemArgs = {
  salesInvoiceItemID: Scalars['UUID']['input'];
};


export type QuerySalesInvoiceItemsArgs = {
  qop?: InputMaybe<SalesInvoiceItemQopInput>;
};


export type QuerySalesInvoicePaymentsArgs = {
  qop?: InputMaybe<SalesInvoicePaymentQopInput>;
};


export type QuerySalesInvoiceReviewArgs = {
  salesInvoiceReviewID: Scalars['UUID']['input'];
};


export type QuerySalesInvoiceReviewsArgs = {
  qop?: InputMaybe<SalesInvoiceReviewQopInput>;
};


export type QuerySalesInvoicesArgs = {
  qop?: InputMaybe<SalesInvoiceQopInput>;
};


export type QuerySalesPaymentMethodArgs = {
  salesPaymentMethodID: Scalars['UUID']['input'];
};


export type QuerySalesPaymentMethodTypeArgs = {
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
};


export type QuerySalesPaymentMethodTypesArgs = {
  qop?: InputMaybe<SalesPaymentMethodTypeQopInput>;
};


export type QuerySalesPaymentMethodsArgs = {
  qop?: InputMaybe<SalesPaymentMethodQopInput>;
};


export type QueryShiftSessionArgs = {
  shiftSessionID: Scalars['UUID']['input'];
};


export type QueryShiftSessionsArgs = {
  qop?: InputMaybe<ShiftSessionQopInput>;
};


export type QuerySimpleTransferOrderArgs = {
  transferOrderSimpleID: Scalars['UUID']['input'];
};


export type QuerySimpleTransferOrderItemArgs = {
  transferOrderSimpleItemID: Scalars['UUID']['input'];
};


export type QuerySimpleTransferOrderItemLocationsArgs = {
  qop?: InputMaybe<SimpleTransferOrderItemLocationQopInput>;
};


export type QuerySimpleTransferOrderItemsArgs = {
  qop?: InputMaybe<SimpleTransferOrderItemQopInput>;
};


export type QuerySimpleTransferOrderReceivingArgs = {
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
};


export type QuerySimpleTransferOrderReceivingItemArgs = {
  simpleTransferOrderReceivingItemID: Scalars['UUID']['input'];
};


export type QuerySimpleTransferOrderReceivingItemsArgs = {
  qop?: InputMaybe<SimpleTransferOrderReceivingItemQopInput>;
};


export type QuerySimpleTransferOrderReceivingsArgs = {
  qop?: InputMaybe<SimpleTransferOrderReceivingQopInput>;
};


export type QuerySimpleTransferOrdersArgs = {
  qop?: InputMaybe<SimpleTransferOrderQopInput>;
};


export type QuerySubdistrictArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubdistrictsArgs = {
  qop?: InputMaybe<SubdistrictQop>;
};


export type QueryTaxArgs = {
  taxID: Scalars['UUID']['input'];
};


export type QueryTaxesArgs = {
  qop?: InputMaybe<TaxQopInput>;
};


export type QueryTransferOrderArgs = {
  transferOrderID: Scalars['UUID']['input'];
};


export type QueryTransferOrderItemArgs = {
  transferOrderItemID: Scalars['UUID']['input'];
};


export type QueryTransferOrderItemsArgs = {
  qop?: InputMaybe<TransferOrderItemQopInput>;
};


export type QueryTransferOrderReceivingArgs = {
  transferOrderReceivingID: Scalars['UUID']['input'];
};


export type QueryTransferOrderReceivingItemArgs = {
  transferOrderReceivingItemID: Scalars['UUID']['input'];
};


export type QueryTransferOrderReceivingItemsArgs = {
  qop?: InputMaybe<TransferOrderReceivingItemQopInput>;
};


export type QueryTransferOrderReceivingsArgs = {
  qop?: InputMaybe<TransferOrderReceivingQopInput>;
};


export type QueryTransferOrdersArgs = {
  qop?: InputMaybe<TransferOrderQopInput>;
};


export type QueryTransferRequestArgs = {
  transferRequestID: Scalars['UUID']['input'];
};


export type QueryTransferRequestItemArgs = {
  transferRequestItemID: Scalars['UUID']['input'];
};


export type QueryTransferRequestItemsArgs = {
  qop?: InputMaybe<TransferRequestItemQopInput>;
};


export type QueryTransferRequestsArgs = {
  qop?: InputMaybe<TransferRequestQopInput>;
};


export type QueryUnassignedPickingTasksArgs = {
  qop?: InputMaybe<PickingTaskQopInput>;
};


export type QueryUnassignedPutawayTasksArgs = {
  qop?: InputMaybe<PutawayTaskQopInput>;
};


export type QueryUomArgs = {
  uomID: Scalars['UUID']['input'];
};


export type QueryUomCategoriesArgs = {
  qop?: InputMaybe<UomCategoryQopInput>;
};


export type QueryUomCategoryArgs = {
  uomCategoryID: Scalars['UUID']['input'];
};


export type QueryUomsArgs = {
  qop?: InputMaybe<UomQopInput>;
};


export type QueryUploadTemplateArgs = {
  uploadTemplateID: Scalars['UUID']['input'];
};


export type QueryUploadTemplatesArgs = {
  qop?: InputMaybe<UploadTemplateQopInput>;
};


export type QueryUserArgs = {
  userID: Scalars['UUID']['input'];
};


export type QueryUserTokenByCodeArgs = {
  tokenCode: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  qop?: InputMaybe<UserQopInput>;
};


export type QueryUsersLiteArgs = {
  qop?: InputMaybe<UserLiteQopInput>;
};


export type QueryVendorArgs = {
  vendorID: Scalars['UUID']['input'];
};


export type QueryVendorCategoriesArgs = {
  qop?: InputMaybe<VendorCategoryQopInput>;
};


export type QueryVendorCategoryArgs = {
  vendorCategoryID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentBranchArgs = {
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentBranchPeriodArgs = {
  vendorConsignmentBranchPeriodID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentBranchPeriodByBranchArgs = {
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentBranchPeriodsArgs = {
  qop?: InputMaybe<VendorConsignmentBranchPeriodQopInput>;
};


export type QueryVendorConsignmentBranchesArgs = {
  qop?: InputMaybe<VendorConsignmentBranchQopInput>;
};


export type QueryVendorConsignmentDashboardArgs = {
  filter: VendorConsignmentDashboardFilterInput;
};


export type QueryVendorConsignmentInvoiceArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentInvoiceConfigArgs = {
  vendorConsignmentInvoiceConfigID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentInvoiceConfigsArgs = {
  qop?: InputMaybe<VendorConsignmentInvoiceConfigQopInput>;
};


export type QueryVendorConsignmentInvoiceEmailPreviewArgs = {
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentInvoiceSummaryArgs = {
  qop?: InputMaybe<VendorConsignmentInvoiceQopInput>;
};


export type QueryVendorConsignmentInvoicesArgs = {
  qop?: InputMaybe<VendorConsignmentInvoiceQopInput>;
};


export type QueryVendorConsignmentPaymentChargeConfigsArgs = {
  qop?: InputMaybe<VendorConsignmentPaymentChargeConfigQopInput>;
};


export type QueryVendorConsignmentProductArgs = {
  vendorConsignmentProductID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentProductsArgs = {
  qop?: InputMaybe<VendorConsignmentProductQopInput>;
};


export type QueryVendorConsignmentProductsByBranchArgs = {
  branchID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentRentalPaymentArgs = {
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};


export type QueryVendorConsignmentRentalPaymentsArgs = {
  qop?: InputMaybe<VendorConsignmentRentalPaymentQopInput>;
};


export type QueryVendorConsignmentSalesExportArgs = {
  filter: VendorConsignmentSalesExportFilterInput;
};


export type QueryVendorConsignmentStockByBranchArgs = {
  qop: VendorConsignmentStockByBranchQopInput;
};


export type QueryVendorInventoryCountExportArgs = {
  filter: VendorInventoryCountReportFilterInput;
};


export type QueryVendorInventoryCountListArgs = {
  filter: VendorInventoryCountListFilterInput;
};


export type QueryVendorInventoryCountReportArgs = {
  qop: VendorInventoryCountReportQopInput;
};


export type QueryVendorPicContactArgs = {
  vendorPicContactID: Scalars['UUID']['input'];
};


export type QueryVendorPicContactsArgs = {
  qop?: InputMaybe<VendorPicContactQopInput>;
};


export type QueryVendorStockExportArgs = {
  filter: VendorStockExportFilterInput;
};


export type QueryVendorStockReconciliationArgs = {
  filter: VendorStockReconciliationFilterInput;
};


export type QueryVendorsArgs = {
  qop?: InputMaybe<VendorQopInput>;
};


export type QueryVillageArgs = {
  villageID: Scalars['String']['input'];
};


export type QueryVillagesArgs = {
  qop?: InputMaybe<VillageQopInput>;
};


export type QueryVoucherArgs = {
  voucherID: Scalars['UUID']['input'];
};


export type QueryVoucherCategoriesArgs = {
  qop?: InputMaybe<VoucherCategoryQopInput>;
};


export type QueryVoucherCategoryArgs = {
  voucherCategoryID: Scalars['UUID']['input'];
};


export type QueryVoucherItemArgs = {
  voucherItemID: Scalars['UUID']['input'];
};


export type QueryVoucherItemByCodeArgs = {
  voucherItemCode: Scalars['String']['input'];
};


export type QueryVoucherItemsArgs = {
  qop?: InputMaybe<VoucherItemQopInput>;
};


export type QueryVouchersArgs = {
  qop?: InputMaybe<VoucherQopInput>;
};


export type QueryWarehouseArgs = {
  warehouseID: Scalars['UUID']['input'];
};


export type QueryWarehouseLocationArgs = {
  warehouseLocationID: Scalars['UUID']['input'];
};


export type QueryWarehouseLocationGroupArgs = {
  warehouseLocationGroupID: Scalars['UUID']['input'];
};


export type QueryWarehouseLocationGroupsArgs = {
  qop?: InputMaybe<WarehouseLocationGroupQopInput>;
};


export type QueryWarehouseLocationRelationMapArgs = {
  warehouseLocationChildID: Scalars['UUID']['input'];
  warehouseLocationParentID: Scalars['UUID']['input'];
};


export type QueryWarehouseLocationRelationMapsArgs = {
  qop?: InputMaybe<WarehouseLocationRelationMapQopInput>;
};


export type QueryWarehouseLocationsArgs = {
  qop?: InputMaybe<WarehouseLocationQopInput>;
};


export type QueryWarehouseProductLocationMapArgs = {
  warehouseProductLocationMapID: Scalars['UUID']['input'];
};


export type QueryWarehouseProductLocationMapsArgs = {
  qop?: InputMaybe<WarehouseProductLocationMapQopInput>;
};


export type QueryWarehouseReplenishmentTemplateArgs = {
  warehouseReplenishmentTemplateID: Scalars['UUID']['input'];
};


export type QueryWarehouseReplenishmentTemplatesArgs = {
  qop?: InputMaybe<WarehouseReplenishmentTemplateQopInput>;
};


export type QueryWarehousesArgs = {
  qop?: InputMaybe<WarehouseQopInput>;
};

export type Reason = {
  __typename?: 'Reason';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  reasonCategory: Scalars['String']['output'];
  reasonCode: Scalars['String']['output'];
  reasonID: Scalars['UUID']['output'];
  reasonName: Scalars['String']['output'];
  reasonScope: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ReasonCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  reasonCategory: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
  reasonName: Scalars['String']['input'];
  reasonScope: Scalars['String']['input'];
};

export type ReasonInventoryAdjustment = {
  __typename?: 'ReasonInventoryAdjustment';
  adjustmentTypes: Array<ReasonInventoryAdjustmentType>;
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  journalAccountCode: Scalars['String']['output'];
  journalAccountErpRefID?: Maybe<Scalars['String']['output']>;
  journalAccountErpRefName?: Maybe<Scalars['String']['output']>;
  reasonInventoryAdjustmentID: Scalars['UUID']['output'];
  reasonName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ReasonInventoryAdjustmentCreateInput = {
  adjustmentTypes: Array<ReasonInventoryAdjustmentType>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  reasonName: Scalars['String']['input'];
};

export type ReasonInventoryAdjustmentPaged = {
  __typename?: 'ReasonInventoryAdjustmentPaged';
  items?: Maybe<Array<ReasonInventoryAdjustment>>;
  pagination: PaginationResult;
};

export type ReasonInventoryAdjustmentQopFilterInput = {
  adjustmentTypes?: InputMaybe<Array<ReasonInventoryAdjustmentType>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  reasonName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReasonInventoryAdjustmentQopInput = {
  filters?: InputMaybe<ReasonInventoryAdjustmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export enum ReasonInventoryAdjustmentType {
  InventoryCount = 'inventory_count',
  Standard = 'standard',
  Waste = 'waste'
}

export type ReasonInventoryAdjustmentUpdateInput = {
  adjustmentTypes: Array<ReasonInventoryAdjustmentType>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  journalAccountCode: Scalars['String']['input'];
  journalAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  journalAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  reasonInventoryAdjustmentID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
};

export type ReasonPaged = {
  __typename?: 'ReasonPaged';
  items?: Maybe<Array<Reason>>;
  pagination: PaginationResult;
};

export type ReasonQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  reasonName?: InputMaybe<Scalars['String']['input']>;
  reasonScope?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReasonQopInput = {
  filters?: InputMaybe<ReasonQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReasonUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  reasonCategory: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
  reasonID: Scalars['UUID']['input'];
  reasonName: Scalars['String']['input'];
  reasonScope: Scalars['String']['input'];
};

export type RecordExecutionInput = {
  productID: Scalars['UUID']['input'];
  putawayTaskID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type RemoveContainerInput = {
  outboundContainerID: Scalars['UUID']['input'];
};

export type ReorderSalesChannelCategoryGroupProductInput = {
  displayOrder: Scalars['Int']['input'];
  salesChannelCategoryGroupProductID: Scalars['UUID']['input'];
};

export type Replenishment = {
  __typename?: 'Replenishment';
  avgUsageDays: Scalars['Int']['output'];
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  branchType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  reorderItemCount: Scalars['Int']['output'];
  replenishmentDate: Scalars['Time']['output'];
  replenishmentDateUTC: Scalars['Time']['output'];
  replenishmentID: Scalars['UUID']['output'];
  replenishmentNumber: Scalars['String']['output'];
  replenishmentTemplate?: Maybe<ReplenishmentTemplate>;
  replenishmentTemplateID: Scalars['UUID']['output'];
  sourceWarehouse: Warehouse;
  sourceWarehouseID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
};

export type ReplenishmentCreateInput = {
  avgUsageDays: Scalars['Int']['input'];
  branchID: Scalars['UUID']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  replenishmentTemplateID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type ReplenishmentItem = {
  __typename?: 'ReplenishmentItem';
  avgUsage: Scalars['Decimal']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  leadTime: Scalars['Int']['output'];
  minStock: Scalars['Decimal']['output'];
  mpkm: Scalars['Decimal']['output'];
  mpkmFromAvgUsage: Scalars['Decimal']['output'];
  orderMultiplier: Scalars['Decimal']['output'];
  pkm: Scalars['Decimal']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qtyAvailable: Scalars['Decimal']['output'];
  qtyCommitted: Scalars['Decimal']['output'];
  qtyIncoming: Scalars['Decimal']['output'];
  qtyOnHand: Scalars['Decimal']['output'];
  reorderQty: Scalars['Decimal']['output'];
  replenishmentID: Scalars['UUID']['output'];
  replenishmentItemID: Scalars['UUID']['output'];
  safetyDays: Scalars['Int']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type ReplenishmentItemPaged = {
  __typename?: 'ReplenishmentItemPaged';
  items?: Maybe<Array<ReplenishmentItem>>;
  pagination: PaginationResult;
};

export type ReplenishmentItemQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReplenishmentItemQopInput = {
  filters?: InputMaybe<ReplenishmentItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentPaged = {
  __typename?: 'ReplenishmentPaged';
  items?: Maybe<Array<Replenishment>>;
  pagination: PaginationResult;
};

export type ReplenishmentQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentDateGte?: InputMaybe<Scalars['Time']['input']>;
  replenishmentDateLte?: InputMaybe<Scalars['Time']['input']>;
  replenishmentID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentNumber?: InputMaybe<Scalars['String']['input']>;
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  sourceWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReplenishmentQopInput = {
  filters?: InputMaybe<ReplenishmentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentTemplate = {
  __typename?: 'ReplenishmentTemplate';
  defaultLeadtimeDays: Scalars['Int']['output'];
  defaultSafetyDays: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  items: Array<ReplenishmentTemplateItem>;
  replenishmentTemplateCategory?: Maybe<ReplenishmentTemplateCategory>;
  replenishmentTemplateCategoryID: Scalars['UUID']['output'];
  replenishmentTemplateID: Scalars['UUID']['output'];
  replenishmentTemplateName?: Maybe<Scalars['String']['output']>;
  sourceDocumentType: Scalars['String']['output'];
  sourceWarehouse?: Maybe<Warehouse>;
  sourceWarehouseCode: Scalars['String']['output'];
  sourceWarehouseID: Scalars['UUID']['output'];
  sourceWarehouseName: Scalars['String']['output'];
};

export type ReplenishmentTemplateCategory = {
  __typename?: 'ReplenishmentTemplateCategory';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  replenishmentTemplateCategoryID: Scalars['UUID']['output'];
  replenishmentTemplateCategoryName: Scalars['String']['output'];
};

export type ReplenishmentTemplateCategoryCreateInput = {
  isActive: Scalars['Boolean']['input'];
  replenishmentTemplateCategoryName: Scalars['String']['input'];
};

export type ReplenishmentTemplateCategoryPaged = {
  __typename?: 'ReplenishmentTemplateCategoryPaged';
  items?: Maybe<Array<ReplenishmentTemplateCategory>>;
  pagination: PaginationResult;
};

export type ReplenishmentTemplateCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  replenishmentTemplateCategoryName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReplenishmentTemplateCategoryQopInput = {
  filters?: InputMaybe<ReplenishmentTemplateCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentTemplateCategoryUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
  replenishmentTemplateCategoryName: Scalars['String']['input'];
};

export type ReplenishmentTemplateCreateInput = {
  defaultLeadtimeDays: Scalars['Int']['input'];
  defaultSafetyDays: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  items?: InputMaybe<Array<ReplenishmentTemplateItemCreateInput>>;
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
  replenishmentTemplateName: Scalars['String']['input'];
  sourceDocumentType: Scalars['String']['input'];
  sourceWarehouseCode: Scalars['String']['input'];
  sourceWarehouseID: Scalars['UUID']['input'];
  sourceWarehouseName: Scalars['String']['input'];
};

export type ReplenishmentTemplateItem = {
  __typename?: 'ReplenishmentTemplateItem';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  leadtimeDays: Scalars['Int']['output'];
  minStock: Scalars['Float']['output'];
  orderMultiplier: Scalars['Float']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  replenishmentTemplateID: Scalars['UUID']['output'];
  replenishmentTemplateItemID: Scalars['UUID']['output'];
  safetyDays: Scalars['Int']['output'];
};

export type ReplenishmentTemplateItemCreateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  leadtimeDays: Scalars['Int']['input'];
  minStock: Scalars['Float']['input'];
  orderMultiplier: Scalars['Float']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentTemplateItemID?: InputMaybe<Scalars['UUID']['input']>;
  safetyDays: Scalars['Int']['input'];
};

export type ReplenishmentTemplateItemImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ReplenishmentTemplateItemImportFileMappingInput = {
  columns: Array<ReplenishmentTemplateItemImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type ReplenishmentTemplateItemImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ReplenishmentTemplateItemImportFileMappingInput;
  replenishmentTemplateID: Scalars['UUID']['input'];
};

export type ReplenishmentTemplateItemImportResult = {
  __typename?: 'ReplenishmentTemplateItemImportResult';
  importedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type ReplenishmentTemplateItemImportRowReport = {
  __typename?: 'ReplenishmentTemplateItemImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  newRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  updateRowCount: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<ReplenishmentTemplateItemImportRowViolation>;
};

export type ReplenishmentTemplateItemImportRowViolation = {
  __typename?: 'ReplenishmentTemplateItemImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReplenishmentTemplateItemImportValidateInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: ReplenishmentTemplateItemImportFileMappingInput;
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReplenishmentTemplateItemImportValidateResult = {
  __typename?: 'ReplenishmentTemplateItemImportValidateResult';
  missingProductCodes: Array<Scalars['String']['output']>;
  rowReport: ReplenishmentTemplateItemImportRowReport;
};

export type ReplenishmentTemplateItemPaged = {
  __typename?: 'ReplenishmentTemplateItemPaged';
  items?: Maybe<Array<ReplenishmentTemplateItem>>;
  pagination: PaginationResult;
};

export type ReplenishmentTemplateItemQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReplenishmentTemplateItemQopInput = {
  filters?: InputMaybe<ReplenishmentTemplateItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentTemplateItemUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  leadtimeDays: Scalars['Int']['input'];
  minStock: Scalars['Float']['input'];
  orderMultiplier: Scalars['Float']['input'];
  productCode: Scalars['String']['input'];
  productID: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
  replenishmentTemplateItemID: Scalars['UUID']['input'];
  safetyDays: Scalars['Int']['input'];
};

export type ReplenishmentTemplatePaged = {
  __typename?: 'ReplenishmentTemplatePaged';
  items?: Maybe<Array<ReplenishmentTemplate>>;
  pagination: PaginationResult;
};

export type ReplenishmentTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  replenishmentTemplateCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentTemplateName?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentType?: InputMaybe<Scalars['String']['input']>;
  sourceWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ReplenishmentTemplateQopInput = {
  filters?: InputMaybe<ReplenishmentTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ReplenishmentTemplateUpdateInput = {
  defaultLeadtimeDays: Scalars['Int']['input'];
  defaultSafetyDays: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  items?: InputMaybe<Array<ReplenishmentTemplateItemCreateInput>>;
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
  replenishmentTemplateID: Scalars['UUID']['input'];
  replenishmentTemplateName: Scalars['String']['input'];
  sourceDocumentType: Scalars['String']['input'];
  sourceWarehouseCode: Scalars['String']['input'];
  sourceWarehouseID: Scalars['UUID']['input'];
  sourceWarehouseName: Scalars['String']['input'];
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  tokenCode: Scalars['String']['input'];
};

export type Resource = {
  __typename?: 'Resource';
  apps?: Maybe<Array<App>>;
  entityAuditMetadata: EntityAuditMetadata;
  parentResourceID?: Maybe<Scalars['String']['output']>;
  parentresourceName?: Maybe<Scalars['String']['output']>;
  resourceID: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
};

export type ResourceCreateInput = {
  parentResourceID?: InputMaybe<Scalars['String']['input']>;
  resourceID: Scalars['String']['input'];
  resourceName: Scalars['String']['input'];
};

export type ResourcePaged = {
  __typename?: 'ResourcePaged';
  items?: Maybe<Array<Resource>>;
  pagination: PaginationResult;
};

export type ResourceQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  parentResourceID?: InputMaybe<Scalars['String']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type ResourceQopInput = {
  filters?: InputMaybe<ResourceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ResourceUpdateInput = {
  parentResourceID?: InputMaybe<Scalars['String']['input']>;
  resourceID: Scalars['String']['input'];
  resourceName: Scalars['String']['input'];
};

export type RevenueReport = {
  __typename?: 'RevenueReport';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  deliveryMode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  itemCount: Scalars['Int']['output'];
  lastPulledAt?: Maybe<Scalars['Time']['output']>;
  lastUploadError: Scalars['String']['output'];
  partnerName: Scalars['String']['output'];
  revenueReportID: Scalars['UUID']['output'];
  revenueReportPartnerID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  transactionDate: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uploadAttemptCount: Scalars['Int']['output'];
  uploadStatus: Scalars['String']['output'];
  uploaded: Scalars['Boolean']['output'];
  uploadedDatetime?: Maybe<Scalars['Time']['output']>;
};

export type RevenueReportAccessLog = {
  __typename?: 'RevenueReportAccessLog';
  accessedDatetime: Scalars['Time']['output'];
  accessedDatetimeUtc: Scalars['Time']['output'];
  clientName: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  httpStatus: Scalars['Int']['output'];
  keyPrefix: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  partnerName: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  resultClass: Scalars['String']['output'];
  revenueReportAccessLogID: Scalars['UUID']['output'];
  revenueReportApiKeyID?: Maybe<Scalars['UUID']['output']>;
  revenueReportPartnerID?: Maybe<Scalars['UUID']['output']>;
  revenueReportTemplateID?: Maybe<Scalars['UUID']['output']>;
  revenueReportUserID?: Maybe<Scalars['UUID']['output']>;
  rowCount: Scalars['Int']['output'];
  sourceIp: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type RevenueReportAccessLogExport = {
  __typename?: 'RevenueReportAccessLogExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type RevenueReportAccessLogExportInput = {
  filters?: InputMaybe<RevenueReportAccessLogQopFilterInput>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportAccessLogPaged = {
  __typename?: 'RevenueReportAccessLogPaged';
  items?: Maybe<Array<RevenueReportAccessLog>>;
  pagination: PaginationResult;
};

export type RevenueReportAccessLogQopFilterInput = {
  accessedDatetimeUtcEnd?: InputMaybe<Scalars['Time']['input']>;
  accessedDatetimeUtcStart?: InputMaybe<Scalars['Time']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  keyPrefix?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  resultClass?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  revenueReportUserID?: InputMaybe<Scalars['UUID']['input']>;
  sourceIp?: InputMaybe<Scalars['String']['input']>;
  windowEndDateFrom?: InputMaybe<Scalars['String']['input']>;
  windowStartDateTo?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportAccessLogQopInput = {
  filters?: InputMaybe<RevenueReportAccessLogQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportAccessLogSummary = {
  __typename?: 'RevenueReportAccessLogSummary';
  distinctIpCount: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
  requestCount: Scalars['Int']['output'];
  rowsServed: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
};

export type RevenueReportApiKey = {
  __typename?: 'RevenueReportApiKey';
  entityAuditMetadata: EntityAuditMetadata;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  keyPrefix: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['Time']['output']>;
  lastUsedIp: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  revenueReportApiKeyID: Scalars['UUID']['output'];
  revenueReportUserID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
};

export type RevenueReportApiKeyIssueInput = {
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  revenueReportUserID: Scalars['UUID']['input'];
};

export type RevenueReportApiKeyIssued = {
  __typename?: 'RevenueReportApiKeyIssued';
  expiresAt?: Maybe<Scalars['Time']['output']>;
  keyPrefix: Scalars['String']['output'];
  plaintextApiKey: Scalars['String']['output'];
  revenueReportApiKeyID: Scalars['UUID']['output'];
  revenueReportUserID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
};

export type RevenueReportApiKeyPaged = {
  __typename?: 'RevenueReportApiKeyPaged';
  items?: Maybe<Array<RevenueReportApiKey>>;
  pagination: PaginationResult;
};

export type RevenueReportApiKeyQopFilterInput = {
  keyPrefix?: InputMaybe<Scalars['String']['input']>;
  revenueReportUserID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportApiKeyQopInput = {
  filters?: InputMaybe<RevenueReportApiKeyQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportDetail = {
  __typename?: 'RevenueReportDetail';
  barcode: Scalars['String']['output'];
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  correctedDatetime?: Maybe<Scalars['Time']['output']>;
  correctedUserID?: Maybe<Scalars['UUID']['output']>;
  correctedUserName: Scalars['String']['output'];
  correctionReason: Scalars['String']['output'];
  correctionType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isConsignment: Scalars['Boolean']['output'];
  originalTaxAmount?: Maybe<Scalars['Float']['output']>;
  originalTotalAmount?: Maybe<Scalars['Float']['output']>;
  productAccountingCategoryName: Scalars['String']['output'];
  productCategoryFullName: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID?: Maybe<Scalars['UUID']['output']>;
  productName: Scalars['String']['output'];
  productSalesTaxCode: Scalars['String']['output'];
  productSalesTaxID?: Maybe<Scalars['UUID']['output']>;
  productType: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  revenueReportDetailID: Scalars['UUID']['output'];
  revenueReportID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  sourceStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  transactionDatetime: Scalars['Time']['output'];
  transactionDatetimeUtc: Scalars['Time']['output'];
  uomName: Scalars['String']['output'];
  uploaded: Scalars['Boolean']['output'];
};

export type RevenueReportDetailCorrectInput = {
  correctionReason: Scalars['String']['input'];
  revenueReportDetailID: Scalars['UUID']['input'];
  totalAmount: Scalars['Float']['input'];
};

export type RevenueReportDetailExport = {
  __typename?: 'RevenueReportDetailExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type RevenueReportDetailExportInput = {
  filters?: InputMaybe<RevenueReportDetailQopFilterInput>;
  revenueReportID: Scalars['UUID']['input'];
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportDetailPaged = {
  __typename?: 'RevenueReportDetailPaged';
  items?: Maybe<Array<RevenueReportDetail>>;
  pagination: PaginationResult;
};

export type RevenueReportDetailQopFilterInput = {
  correctionType?: InputMaybe<Scalars['String']['input']>;
  revenueReportID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportDetailQopInput = {
  filters?: InputMaybe<RevenueReportDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportDetailVoidInput = {
  correctionReason: Scalars['String']['input'];
  revenueReportDetailID: Scalars['UUID']['input'];
};

export type RevenueReportExport = {
  __typename?: 'RevenueReportExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type RevenueReportExportInput = {
  filters?: InputMaybe<RevenueReportQopFilterInput>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportGenerateInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  endDate: Scalars['String']['input'];
  rebuildDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  startDate: Scalars['String']['input'];
};

export type RevenueReportPaged = {
  __typename?: 'RevenueReportPaged';
  items?: Maybe<Array<RevenueReport>>;
  pagination: PaginationResult;
};

export type RevenueReportPartner = {
  __typename?: 'RevenueReportPartner';
  apiClientCount: Scalars['Int']['output'];
  apiKeyPrefix: Scalars['String']['output'];
  authType: Scalars['String']['output'];
  branchCount: Scalars['Int']['output'];
  credentialState: Scalars['String']['output'];
  credentialUpdatedAt?: Maybe<Scalars['Time']['output']>;
  deliveryMode: Scalars['String']['output'];
  endpointURL: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  hasApiSecret: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isNpwpdRequired: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  partnerName: Scalars['String']['output'];
  revenueReportPartnerID: Scalars['UUID']['output'];
  revenueReportPartnerType: Scalars['String']['output'];
  revenueReportTemplateID: Scalars['UUID']['output'];
  templateName: Scalars['String']['output'];
};

export type RevenueReportPartnerBranch = {
  __typename?: 'RevenueReportPartnerBranch';
  apiKeyPrefix: Scalars['String']['output'];
  authType: Scalars['String']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  credentialSource: Scalars['String']['output'];
  credentialState: Scalars['String']['output'];
  credentialUpdatedAt?: Maybe<Scalars['Time']['output']>;
  deliveryMode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  npwpd: Scalars['String']['output'];
  partnerName: Scalars['String']['output'];
  revenueReportPartnerBranchID: Scalars['UUID']['output'];
  revenueReportPartnerID: Scalars['UUID']['output'];
  revenueReportTemplateID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

export type RevenueReportPartnerBranchCreateInput = {
  branchID: Scalars['UUID']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  npwpd?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerBranchCredentialSetInput = {
  apiKey: Scalars['String']['input'];
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerBranchPaged = {
  __typename?: 'RevenueReportPartnerBranchPaged';
  items?: Maybe<Array<RevenueReportPartnerBranch>>;
  pagination: PaginationResult;
};

export type RevenueReportPartnerBranchQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerBranchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportPartnerBranchQopInput = {
  filters?: InputMaybe<RevenueReportPartnerBranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportPartnerBranchUpdateInput = {
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  npwpd?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerCreateInput = {
  authType?: InputMaybe<Scalars['String']['input']>;
  deliveryMode: Scalars['String']['input'];
  endpointURL?: InputMaybe<Scalars['String']['input']>;
  isNpwpdRequired?: InputMaybe<Scalars['Boolean']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  partnerName: Scalars['String']['input'];
  revenueReportTemplateID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerCredentialSetInput = {
  apiKey: Scalars['String']['input'];
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerEndpointUpdateInput = {
  authType: Scalars['String']['input'];
  endpointURL: Scalars['String']['input'];
  revenueReportPartnerID: Scalars['UUID']['input'];
};

export type RevenueReportPartnerPaged = {
  __typename?: 'RevenueReportPartnerPaged';
  items?: Maybe<Array<RevenueReportPartner>>;
  pagination: PaginationResult;
};

export type RevenueReportPartnerQopFilterInput = {
  authType?: InputMaybe<Scalars['String']['input']>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  revenueReportPartnerType?: InputMaybe<Scalars['String']['input']>;
  revenueReportTemplateID?: InputMaybe<Scalars['UUID']['input']>;
};

export type RevenueReportPartnerQopInput = {
  filters?: InputMaybe<RevenueReportPartnerQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportPartnerUpdateInput = {
  isNpwpdRequired?: InputMaybe<Scalars['Boolean']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  partnerName: Scalars['String']['input'];
  revenueReportPartnerID: Scalars['UUID']['input'];
  revenueReportTemplateID: Scalars['UUID']['input'];
};

export type RevenueReportQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  revenueReportIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  transactionDateEnd?: InputMaybe<Scalars['Time']['input']>;
  transactionDateStart?: InputMaybe<Scalars['Time']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uploadStatus?: InputMaybe<Scalars['String']['input']>;
  uploadStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RevenueReportQopInput = {
  filters?: InputMaybe<RevenueReportQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportResyncInput = {
  revenueReportID: Scalars['UUID']['input'];
};

export type RevenueReportSummary = {
  __typename?: 'RevenueReportSummary';
  itemCount: Scalars['Int']['output'];
  revenueReportCount: Scalars['Int']['output'];
  taxAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type RevenueReportTemplate = {
  __typename?: 'RevenueReportTemplate';
  entityAuditMetadata: EntityAuditMetadata;
  envelope: Scalars['String']['output'];
  fieldMap: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  partnerCount: Scalars['Int']['output'];
  partnerNames: Array<Scalars['String']['output']>;
  resultKey: Scalars['String']['output'];
  revenueReportTemplateID: Scalars['UUID']['output'];
  revenueReportTemplateType: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  wrapperMap?: Maybe<Scalars['String']['output']>;
};

export type RevenueReportTemplateCreateInput = {
  envelope: Scalars['String']['input'];
  fieldMap: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  resultKey?: InputMaybe<Scalars['String']['input']>;
  revenueReportTemplateType: Scalars['String']['input'];
  templateName: Scalars['String']['input'];
  wrapperMap?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportTemplateFieldMapUpdateInput = {
  fieldMap: Scalars['String']['input'];
  revenueReportTemplateID: Scalars['UUID']['input'];
};

export type RevenueReportTemplatePaged = {
  __typename?: 'RevenueReportTemplatePaged';
  items?: Maybe<Array<RevenueReportTemplate>>;
  pagination: PaginationResult;
};

export type RevenueReportTemplateQopFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  revenueReportTemplateIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  revenueReportTemplateType?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportTemplateQopInput = {
  filters?: InputMaybe<RevenueReportTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportTemplateUpdateInput = {
  envelope: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  resultKey?: InputMaybe<Scalars['String']['input']>;
  revenueReportTemplateID: Scalars['UUID']['input'];
  templateName: Scalars['String']['input'];
  wrapperMap?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportUploadBatch = {
  __typename?: 'RevenueReportUploadBatch';
  entityAuditMetadata: EntityAuditMetadata;
  errorCount: Scalars['Int']['output'];
  errorSummary: Scalars['String']['output'];
  httpStatus: Scalars['Int']['output'];
  requestPayload: Scalars['String']['output'];
  responseBody: Scalars['String']['output'];
  revenueReportID: Scalars['UUID']['output'];
  revenueReportUploadBatchID: Scalars['UUID']['output'];
  sentCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  uploadedDatetime?: Maybe<Scalars['Time']['output']>;
  uploadedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
};

export type RevenueReportUploadBatchPaged = {
  __typename?: 'RevenueReportUploadBatchPaged';
  items?: Maybe<Array<RevenueReportUploadBatch>>;
  pagination: PaginationResult;
};

export type RevenueReportUploadBatchQopFilterInput = {
  httpStatus?: InputMaybe<Scalars['Int']['input']>;
  revenueReportID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueReportUploadBatchQopInput = {
  filters?: InputMaybe<RevenueReportUploadBatchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportUser = {
  __typename?: 'RevenueReportUser';
  activeApiKeyCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fullName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['Time']['output']>;
  partnerName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  revenueReportPartnerID: Scalars['UUID']['output'];
  revenueReportUserID: Scalars['UUID']['output'];
  userType: Scalars['String']['output'];
};

export type RevenueReportUserCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID: Scalars['UUID']['input'];
};

export type RevenueReportUserPaged = {
  __typename?: 'RevenueReportUserPaged';
  items?: Maybe<Array<RevenueReportUser>>;
  pagination: PaginationResult;
};

export type RevenueReportUserQopFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  revenueReportPartnerID?: InputMaybe<Scalars['UUID']['input']>;
  revenueReportUserIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type RevenueReportUserQopInput = {
  filters?: InputMaybe<RevenueReportUserQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueReportUserUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  revenueReportUserID: Scalars['UUID']['input'];
};

export type RevenueSharing = {
  __typename?: 'RevenueSharing';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  lastUploadError: Scalars['String']['output'];
  lastUploadPayload: Scalars['String']['output'];
  lastUploadResponse: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  providerCode: Scalars['String']['output'];
  revenueBatchId?: Maybe<Scalars['Int']['output']>;
  revenueSharingID: Scalars['UUID']['output'];
  totalActiveCount: Scalars['Int']['output'];
  totalAmountDpp: Scalars['Float']['output'];
  totalCancelledCount: Scalars['Int']['output'];
  totalDeductionAmount: Scalars['Float']['output'];
  totalNetAmount: Scalars['Float']['output'];
  totalVoucherAmount: Scalars['Float']['output'];
  transactionDate: Scalars['Time']['output'];
  uploadAttemptCount: Scalars['Int']['output'];
  uploaded: Scalars['Boolean']['output'];
  uploadedDatetime?: Maybe<Scalars['Time']['output']>;
  uploadedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
};

export type RevenueSharingBranch = {
  __typename?: 'RevenueSharingBranch';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  deductionType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  password: Scalars['String']['output'];
  providerCode: Scalars['String']['output'];
  revenueSharingBranchID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type RevenueSharingBranchCreateInput = {
  branchID: Scalars['UUID']['input'];
  deductionType: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  status: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type RevenueSharingBranchPaged = {
  __typename?: 'RevenueSharingBranchPaged';
  items?: Maybe<Array<RevenueSharingBranch>>;
  pagination: PaginationResult;
};

export type RevenueSharingBranchQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  revenueSharingBranchIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueSharingBranchQopInput = {
  filters?: InputMaybe<RevenueSharingBranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueSharingBranchUpdateInput = {
  branchID: Scalars['UUID']['input'];
  deductionType: Scalars['String']['input'];
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  revenueSharingBranchID: Scalars['UUID']['input'];
  status: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type RevenueSharingCorrectItemInput = {
  correctedAmountDpp: Scalars['Float']['input'];
  revenueSharingDetailID: Scalars['UUID']['input'];
};

export type RevenueSharingDetail = {
  __typename?: 'RevenueSharingDetail';
  deductionAmount: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalTransactionID?: Maybe<Scalars['Int64']['output']>;
  netAmount: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  revenueSharingDetailID: Scalars['UUID']['output'];
  revenueSharingID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  sourceStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionDatetime: Scalars['Time']['output'];
  transactionDatetimeUtc: Scalars['Time']['output'];
  uploadAmountDpp: Scalars['Float']['output'];
  uploaded: Scalars['Boolean']['output'];
  voucherAmount: Scalars['Float']['output'];
};

export type RevenueSharingDetailPaged = {
  __typename?: 'RevenueSharingDetailPaged';
  items?: Maybe<Array<RevenueSharingDetail>>;
  pagination: PaginationResult;
};

export type RevenueSharingDetailQopFilterInput = {
  revenueSharingDetailIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  revenueSharingID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueSharingDetailQopInput = {
  filters?: InputMaybe<RevenueSharingDetailQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueSharingExport = {
  __typename?: 'RevenueSharingExport';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type RevenueSharingExportInput = {
  endDate: Scalars['String']['input'];
  providerCode: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type RevenueSharingGenerateInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type RevenueSharingLippoLiveRow = {
  __typename?: 'RevenueSharingLippoLiveRow';
  amount: Scalars['Float']['output'];
  transactionDate: Scalars['String']['output'];
  transactionNumber: Scalars['String']['output'];
};

export type RevenueSharingPaged = {
  __typename?: 'RevenueSharingPaged';
  items?: Maybe<Array<RevenueSharing>>;
  pagination: PaginationResult;
};

export type RevenueSharingQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  revenueSharingIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionDateEnd?: InputMaybe<Scalars['Time']['input']>;
  transactionDateStart?: InputMaybe<Scalars['Time']['input']>;
  uploaded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RevenueSharingQopInput = {
  filters?: InputMaybe<RevenueSharingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RevenueSharingReuploadResult = {
  __typename?: 'RevenueSharingReuploadResult';
  alreadyCorrect: Scalars['Int']['output'];
  fixed: Scalars['Int']['output'];
  needManual: Scalars['Int']['output'];
};

export type RevenueSharingUploadBatch = {
  __typename?: 'RevenueSharingUploadBatch';
  chunkIndex: Scalars['Int']['output'];
  duplicateCount: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  errorSummary: Scalars['String']['output'];
  httpStatus: Scalars['Int']['output'];
  lippoCode: Scalars['Int']['output'];
  lippoMessage: Scalars['String']['output'];
  requestPayload: Scalars['String']['output'];
  responseBody: Scalars['String']['output'];
  revenueBatchID?: Maybe<Scalars['Int64']['output']>;
  revenueSharingID: Scalars['UUID']['output'];
  revenueSharingUploadBatchID: Scalars['UUID']['output'];
  sentCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  uploadedDatetime?: Maybe<Scalars['Time']['output']>;
  uploadedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
};

export enum Role {
  Authenticated = 'AUTHENTICATED',
  Cap = 'CAP',
  Spr = 'SPR',
  Spvcap = 'SPVCAP'
}

export type RoleCreateInput = {
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  permissionIDs: Array<InputMaybe<Scalars['String']['input']>>;
  roleName: Scalars['String']['input'];
};

export type RoleDetail = {
  __typename?: 'RoleDetail';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  roleID: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
  rolePermissions: Array<RolePermission>;
};

export type RolePaged = {
  __typename?: 'RolePaged';
  items?: Maybe<Array<Roles>>;
  pagination: PaginationResult;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  appID: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  parentResourceID: Scalars['String']['output'];
  parentResourceName: Scalars['String']['output'];
  permissionID: Scalars['String']['output'];
  permissionName: Scalars['String']['output'];
  resourceID: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
  roleID: Scalars['UUID']['output'];
};

export type RoleProfile = {
  __typename?: 'RoleProfile';
  permissions?: Maybe<Array<PermissionProfile>>;
  resourceID: Scalars['String']['output'];
  resourceName: Scalars['String']['output'];
};

export type RoleQopFilterInput = {
  appID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  policyType?: InputMaybe<Scalars['String']['input']>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type RoleQopInput = {
  filters?: InputMaybe<RoleQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RoleUpdateInput = {
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  permissionIDs: Array<InputMaybe<Scalars['String']['input']>>;
  roleID: Scalars['UUID']['input'];
  roleName: Scalars['String']['input'];
};

export type Roles = {
  __typename?: 'Roles';
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  roleID: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
};

export type SalesChannel = {
  __typename?: 'SalesChannel';
  additionalCharge: Scalars['Float']['output'];
  commisionPerc: Scalars['Float']['output'];
  defaultMenuImageURL?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
  salesChannelType: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  useCategoryMap: Scalars['Boolean']['output'];
};

export type SalesChannelBuiltMenu = {
  __typename?: 'SalesChannelBuiltMenu';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['String']['output'];
  branchName: Scalars['String']['output'];
  categories: Array<SalesChannelMenuCategory>;
  salesChannelID: Scalars['String']['output'];
};

export type SalesChannelCampaign = {
  __typename?: 'SalesChannelCampaign';
  branch?: Maybe<Branch>;
  branchCode: Scalars['String']['output'];
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName: Scalars['String']['output'];
  categories: Array<SalesChannelCampaignCategory>;
  customTag: Scalars['String']['output'];
  discountCap?: Maybe<Scalars['Float']['output']>;
  discountType: Scalars['String']['output'];
  discountValue?: Maybe<Scalars['Float']['output']>;
  eaterType: Scalars['String']['output'];
  endAt: Scalars['Time']['output'];
  endAtUtc: Scalars['Time']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  externalCampaignID: Scalars['String']['output'];
  externalMerchantID: Scalars['String']['output'];
  externalStoreID: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isAllBranches: Scalars['Boolean']['output'];
  minBasketAmount?: Maybe<Scalars['Float']['output']>;
  objectIDs?: Maybe<Scalars['String']['output']>;
  parentSalesChannelCampaignID?: Maybe<Scalars['UUID']['output']>;
  quotaPerUser?: Maybe<Scalars['Int64']['output']>;
  quotaTotal?: Maybe<Scalars['Int64']['output']>;
  salesChannel?: Maybe<SalesChannel>;
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelCampaignName: Scalars['String']['output'];
  salesChannelCategoryGroupID?: Maybe<Scalars['UUID']['output']>;
  salesChannelCategoryGroupName?: Maybe<Scalars['String']['output']>;
  salesChannelID?: Maybe<Scalars['String']['output']>;
  scopeType: Scalars['String']['output'];
  sourcePromoComponentID?: Maybe<Scalars['UUID']['output']>;
  sourcePromoID?: Maybe<Scalars['UUID']['output']>;
  startAt: Scalars['Time']['output'];
  startAtUtc: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  workingHours?: Maybe<Scalars['String']['output']>;
};

export type SalesChannelCampaignCategory = {
  __typename?: 'SalesChannelCampaignCategory';
  entityAuditMetadata: EntityAuditMetadata;
  salesChannelCampaignCategoryID: Scalars['UUID']['output'];
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelCategoryID: Scalars['UUID']['output'];
  salesChannelCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCampaignChannel = {
  __typename?: 'SalesChannelCampaignChannel';
  entityAuditMetadata: EntityAuditMetadata;
  salesChannelCampaignChannelID: Scalars['UUID']['output'];
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCampaignCreateInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountType: Scalars['String']['input'];
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['Time']['input'];
  isAllBranches?: InputMaybe<Scalars['Boolean']['input']>;
  isPublishNow?: InputMaybe<Scalars['Boolean']['input']>;
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  objectIDs?: InputMaybe<Scalars['String']['input']>;
  productIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  quotaPerUser?: InputMaybe<Scalars['Int64']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int64']['input']>;
  salesChannelCampaignName: Scalars['String']['input'];
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  salesChannelIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  sourcePromoComponentID?: InputMaybe<Scalars['UUID']['input']>;
  sourcePromoID?: InputMaybe<Scalars['UUID']['input']>;
  startAt: Scalars['Time']['input'];
  workingHours?: InputMaybe<Scalars['String']['input']>;
};

export type SalesChannelCampaignPaged = {
  __typename?: 'SalesChannelCampaignPaged';
  items?: Maybe<Array<SalesChannelCampaign>>;
  pagination: PaginationResult;
};

export type SalesChannelCampaignProduct = {
  __typename?: 'SalesChannelCampaignProduct';
  barcode: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelCampaignProductID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCampaignProductPaged = {
  __typename?: 'SalesChannelCampaignProductPaged';
  items?: Maybe<Array<SalesChannelCampaignProduct>>;
  pagination: PaginationResult;
};

export type SalesChannelCampaignProductQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCampaignID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesChannelCampaignProductQopInput = {
  filters?: InputMaybe<SalesChannelCampaignProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCampaignPublishInput = {
  salesChannelCampaignID: Scalars['UUID']['input'];
};

export type SalesChannelCampaignPublishStoreResult = {
  __typename?: 'SalesChannelCampaignPublishStoreResult';
  branchID: Scalars['UUID']['output'];
  child?: Maybe<SalesChannelCampaign>;
  note: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  salesChannelID: Scalars['String']['output'];
  skippedProductCodes: Array<Scalars['String']['output']>;
  skippedProductIDs: Array<Scalars['UUID']['output']>;
};

export type SalesChannelCampaignPublishToStoresInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  salesChannelCampaignID: Scalars['UUID']['input'];
};

export type SalesChannelCampaignQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  endAtFrom?: InputMaybe<Scalars['Time']['input']>;
  endAtTo?: InputMaybe<Scalars['Time']['input']>;
  parentSalesChannelCampaignID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  startAtFrom?: InputMaybe<Scalars['Time']['input']>;
  startAtTo?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCampaignQopInput = {
  filters?: InputMaybe<SalesChannelCampaignQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCampaignResult = {
  __typename?: 'SalesChannelCampaignResult';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  errorMessage: Scalars['String']['output'];
  externalCampaignID: Scalars['String']['output'];
  salesChannelCampaignID: Scalars['UUID']['output'];
  salesChannelCampaignResultID: Scalars['UUID']['output'];
  salesChannelID: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCampaignResultPaged = {
  __typename?: 'SalesChannelCampaignResultPaged';
  items?: Maybe<Array<SalesChannelCampaignResult>>;
  pagination: PaginationResult;
};

export type SalesChannelCampaignResultQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCampaignID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SalesChannelCampaignResultQopInput = {
  filters?: InputMaybe<SalesChannelCampaignResultQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCampaignSetCategoriesInput = {
  salesChannelCampaignID: Scalars['UUID']['input'];
  salesChannelCategoryIDs: Array<Scalars['UUID']['input']>;
};

export type SalesChannelCampaignSetChannelsInput = {
  salesChannelCampaignID: Scalars['UUID']['input'];
  salesChannelIDs: Array<Scalars['String']['input']>;
};

export type SalesChannelCampaignSetProductsInput = {
  productIDs: Array<Scalars['UUID']['input']>;
  salesChannelCampaignID: Scalars['UUID']['input'];
};

export type SalesChannelCampaignUpdateInput = {
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  customTag?: InputMaybe<Scalars['String']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountType: Scalars['String']['input'];
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  eaterType?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['Time']['input'];
  isAllBranches?: InputMaybe<Scalars['Boolean']['input']>;
  minBasketAmount?: InputMaybe<Scalars['Float']['input']>;
  objectIDs?: InputMaybe<Scalars['String']['input']>;
  quotaPerUser?: InputMaybe<Scalars['Int64']['input']>;
  quotaTotal?: InputMaybe<Scalars['Int64']['input']>;
  salesChannelCampaignID: Scalars['UUID']['input'];
  salesChannelCampaignName: Scalars['String']['input'];
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['Time']['input'];
  workingHours?: InputMaybe<Scalars['String']['input']>;
};

export type SalesChannelCategory = {
  __typename?: 'SalesChannelCategory';
  displayOrder: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isInMenu: Scalars['Boolean']['output'];
  parentSalesChannelCategoryID?: Maybe<Scalars['UUID']['output']>;
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryID: Scalars['UUID']['output'];
  salesChannelCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCategoryCreateInput = {
  displayOrder?: Scalars['Int']['input'];
  isActive?: Scalars['Boolean']['input'];
  isInMenu?: Scalars['Boolean']['input'];
  parentSalesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryName: Scalars['String']['input'];
};

export type SalesChannelCategoryGroup = {
  __typename?: 'SalesChannelCategoryGroup';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isUseMasterdataAvailability: Scalars['Boolean']['output'];
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryGroupName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCategoryGroupCreateInput = {
  isActive?: Scalars['Boolean']['input'];
  isUseMasterdataAvailability?: Scalars['Boolean']['input'];
  salesChannelCategoryGroupName: Scalars['String']['input'];
};

export type SalesChannelCategoryGroupItem = {
  __typename?: 'SalesChannelCategoryGroupItem';
  displayOrder: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isInMenu: Scalars['Boolean']['output'];
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryGroupItemID: Scalars['UUID']['output'];
  salesChannelCategoryID: Scalars['UUID']['output'];
  salesChannelCategoryName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCategoryGroupItemCreateInput = {
  displayOrder?: Scalars['Int']['input'];
  isInMenu?: Scalars['Boolean']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
  salesChannelCategoryName: Scalars['String']['input'];
};

export type SalesChannelCategoryGroupItemPaged = {
  __typename?: 'SalesChannelCategoryGroupItemPaged';
  items?: Maybe<Array<SalesChannelCategoryGroupItem>>;
  pagination: PaginationResult;
};

export type SalesChannelCategoryGroupItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCategoryGroupItemQopInput = {
  filters?: InputMaybe<SalesChannelCategoryGroupItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCategoryGroupItemUpdateInput = {
  displayOrder?: Scalars['Int']['input'];
  isInMenu: Scalars['Boolean']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupItemID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
  salesChannelCategoryName: Scalars['String']['input'];
};

export type SalesChannelCategoryGroupPaged = {
  __typename?: 'SalesChannelCategoryGroupPaged';
  items?: Maybe<Array<SalesChannelCategoryGroup>>;
  pagination: PaginationResult;
};

export type SalesChannelCategoryGroupProduct = {
  __typename?: 'SalesChannelCategoryGroupProduct';
  barcode: Scalars['String']['output'];
  customPrice: Scalars['Float']['output'];
  displayOrder: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  externalImageURL: Scalars['String']['output'];
  imageType: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isNoPrice: Scalars['Boolean']['output'];
  isOutOfStock: Scalars['Boolean']['output'];
  priceType: Scalars['String']['output'];
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty?: Maybe<Scalars['Float']['output']>;
  salesChannelCategory?: Maybe<SalesChannelCategory>;
  salesChannelCategoryGroup?: Maybe<SalesChannelCategoryGroup>;
  salesChannelCategoryGroupID: Scalars['UUID']['output'];
  salesChannelCategoryGroupProductID: Scalars['UUID']['output'];
  salesChannelCategoryID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelCategoryGroupProductCreateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  customPrice?: InputMaybe<Scalars['Float']['input']>;
  displayOrder?: Scalars['Int']['input'];
  externalImageURL?: InputMaybe<Scalars['String']['input']>;
  imageType?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  priceType?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
};

export type SalesChannelCategoryGroupProductPaged = {
  __typename?: 'SalesChannelCategoryGroupProductPaged';
  items?: Maybe<Array<SalesChannelCategoryGroupProduct>>;
  pagination: PaginationResult;
};

export type SalesChannelCategoryGroupProductQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCategoryGroupProductQopInput = {
  filters?: InputMaybe<SalesChannelCategoryGroupProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCategoryGroupProductUpdateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  customPrice?: InputMaybe<Scalars['Float']['input']>;
  displayOrder?: Scalars['Int']['input'];
  externalImageURL?: InputMaybe<Scalars['String']['input']>;
  imageType?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  priceType?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  productName?: InputMaybe<Scalars['String']['input']>;
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupProductID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
};

export type SalesChannelCategoryGroupQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelCategoryGroupName?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCategoryGroupQopInput = {
  filters?: InputMaybe<SalesChannelCategoryGroupQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCategoryGroupUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  isUseMasterdataAvailability: Scalars['Boolean']['input'];
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryGroupName: Scalars['String']['input'];
};

export type SalesChannelCategoryPaged = {
  __typename?: 'SalesChannelCategoryPaged';
  items?: Maybe<Array<SalesChannelCategory>>;
  pagination: PaginationResult;
};

export type SalesChannelCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  parentSalesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryGroupID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryName?: InputMaybe<Scalars['String']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelCategoryQopInput = {
  filters?: InputMaybe<SalesChannelCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelCategoryUpdateInput = {
  displayOrder?: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  isInMenu: Scalars['Boolean']['input'];
  parentSalesChannelCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelCategoryGroupID: Scalars['UUID']['input'];
  salesChannelCategoryID: Scalars['UUID']['input'];
  salesChannelCategoryName: Scalars['String']['input'];
};

export type SalesChannelCreateInput = {
  additionalCharge: Scalars['Float']['input'];
  commisionPerc: Scalars['Float']['input'];
  defaultMenuImageURL?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName: Scalars['String']['input'];
  salesChannelType: Scalars['String']['input'];
  useCategoryMap?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SalesChannelDeleteInput = {
  salesChannelID: Scalars['String']['input'];
};

export type SalesChannelMenuCategory = {
  __typename?: 'SalesChannelMenuCategory';
  categoryID: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  items: Array<SalesChannelMenuItem>;
};

export type SalesChannelMenuItem = {
  __typename?: 'SalesChannelMenuItem';
  barcode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  externalCategoryID: Scalars['String']['output'];
  externalCategoryName: Scalars['String']['output'];
  externalItemID: Scalars['String']['output'];
  externalParentCategoryID: Scalars['String']['output'];
  externalParentCategoryName: Scalars['String']['output'];
  imageURL: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  itemName: Scalars['String']['output'];
  modifierGroups: Array<SalesChannelMenuModifierGroup>;
  sellingPrice: Scalars['Float']['output'];
  sequence: Scalars['Int']['output'];
};

export type SalesChannelMenuModifier = {
  __typename?: 'SalesChannelMenuModifier';
  isAvailable: Scalars['Boolean']['output'];
  modifierID: Scalars['String']['output'];
  modifierName: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  productID: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
};

export type SalesChannelMenuModifierGroup = {
  __typename?: 'SalesChannelMenuModifierGroup';
  isAvailable: Scalars['Boolean']['output'];
  maxSelect: Scalars['Int']['output'];
  minSelect: Scalars['Int']['output'];
  modifierGroupID: Scalars['String']['output'];
  modifierGroupName: Scalars['String']['output'];
  modifiers: Array<SalesChannelMenuModifier>;
  sequence: Scalars['Int']['output'];
};

export type SalesChannelPaged = {
  __typename?: 'SalesChannelPaged';
  items: Array<SalesChannel>;
  pagination: PaginationResult;
};

export type SalesChannelQopFilterInput = {
  additionalCharge?: InputMaybe<Scalars['Float']['input']>;
  commisionPerc?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesChannelName?: InputMaybe<Scalars['String']['input']>;
  salesChannelType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelQopInput = {
  filters?: InputMaybe<SalesChannelQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelStockThreshold = {
  __typename?: 'SalesChannelStockThreshold';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelStockThresholdID: Scalars['UUID']['output'];
  thresholdType: Scalars['String']['output'];
  thresholdValue: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesChannelStockThresholdCreateInput = {
  isActive: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  salesChannelID: Scalars['String']['input'];
  thresholdType?: InputMaybe<Scalars['String']['input']>;
  thresholdValue: Scalars['Float']['input'];
};

export type SalesChannelStockThresholdPaged = {
  __typename?: 'SalesChannelStockThresholdPaged';
  items?: Maybe<Array<SalesChannelStockThreshold>>;
  pagination: PaginationResult;
};

export type SalesChannelStockThresholdQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  thresholdType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesChannelStockThresholdQopInput = {
  filters?: InputMaybe<SalesChannelStockThresholdQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesChannelStockThresholdUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  salesChannelID: Scalars['String']['input'];
  salesChannelStockThresholdID: Scalars['UUID']['input'];
  thresholdType?: InputMaybe<Scalars['String']['input']>;
  thresholdValue: Scalars['Float']['input'];
};

export type SalesChannelUpdateInput = {
  additionalCharge: Scalars['Float']['input'];
  commisionPerc: Scalars['Float']['input'];
  defaultMenuImageURL?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesChannelName: Scalars['String']['input'];
  salesChannelType: Scalars['String']['input'];
  useCategoryMap?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SalesConsignmentInvoice = {
  __typename?: 'SalesConsignmentInvoice';
  branchID: Scalars['UUID']['output'];
  commissionAmount: Scalars['Float']['output'];
  consignmentCommissionFeePerc?: Maybe<Scalars['Float']['output']>;
  consignmentPartnershipType?: Maybe<Scalars['String']['output']>;
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  consignmentVendorTotal: Scalars['Float']['output'];
  customerID?: Maybe<Scalars['UUID']['output']>;
  discountAmount: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  memberTypeID?: Maybe<Scalars['UUID']['output']>;
  memberTypeName?: Maybe<Scalars['String']['output']>;
  noteInternal: Scalars['String']['output'];
  salesChannelCommisionPerc?: Maybe<Scalars['Float']['output']>;
  salesChannelID?: Maybe<Scalars['String']['output']>;
  salesChannelName?: Maybe<Scalars['String']['output']>;
  salesChannelReferenceID?: Maybe<Scalars['String']['output']>;
  salesChannelType?: Maybe<Scalars['String']['output']>;
  salesConsignmentInvoiceDatetime: Scalars['Time']['output'];
  salesConsignmentInvoiceDatetimeUtc: Scalars['Time']['output'];
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceNumber: Scalars['String']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<SalesConsignmentInvoiceTax>;
  total: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  vendorConsignmentInvoiceID?: Maybe<Scalars['UUID']['output']>;
  warehouseID?: Maybe<Scalars['UUID']['output']>;
};

export type SalesConsignmentInvoiceItem = {
  __typename?: 'SalesConsignmentInvoiceItem';
  additionalDiscountAmount?: Maybe<Scalars['Float']['output']>;
  additionalDiscountPerc?: Maybe<Scalars['Float']['output']>;
  barcode: Scalars['String']['output'];
  baseUomQty: Scalars['Float']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  commissionAmount?: Maybe<Scalars['Float']['output']>;
  /** Gross commission shown to the vendor: net commissionAmount + taxAmount (PPN). commissionAmount and taxAmount are kept separate; this is the display/rollup value. */
  commissionInclTaxAmount?: Maybe<Scalars['Float']['output']>;
  consignmentCommissionFeePerc?: Maybe<Scalars['Float']['output']>;
  consignmentPartnershipType?: Maybe<Scalars['String']['output']>;
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  consignmentVendorPrice?: Maybe<Scalars['Float']['output']>;
  consignmentVendorTotal: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  productCategoryFullName: Scalars['String']['output'];
  productCategoryID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productNameAlias: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  salesConsignmentInvoice: SalesConsignmentInvoice;
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceItemID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceItem: SalesInvoiceItem;
  salesInvoiceItemID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  salesOrderID: Scalars['UUID']['output'];
  salesOrderItemID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  taxAmount: Scalars['Float']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<SalesConsignmentInvoiceItemTax>;
  total: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConvertionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
  vendorConsignmentInvoiceID?: Maybe<Scalars['UUID']['output']>;
};

export type SalesConsignmentInvoiceItemPaged = {
  __typename?: 'SalesConsignmentInvoiceItemPaged';
  items: Array<SalesConsignmentInvoiceItem>;
  pagination: PaginationResult;
};

export type SalesConsignmentInvoiceItemQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesConsignmentInvoiceDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  salesOrderID?: InputMaybe<Scalars['UUID']['input']>;
  vendorConsignmentInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesConsignmentInvoiceItemQopInput = {
  filters?: InputMaybe<SalesConsignmentInvoiceItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesConsignmentInvoiceItemTax = {
  __typename?: 'SalesConsignmentInvoiceItemTax';
  consignmentVendorID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceItemID: Scalars['UUID']['output'];
  salesConsignmentInvoiceItemTaxID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceItemID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type SalesConsignmentInvoicePaged = {
  __typename?: 'SalesConsignmentInvoicePaged';
  items: Array<SalesConsignmentInvoice>;
  pagination: PaginationResult;
};

export type SalesConsignmentInvoiceQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesConsignmentInvoiceDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  salesConsignmentInvoiceType?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesConsignmentInvoiceQopInput = {
  filters?: InputMaybe<SalesConsignmentInvoiceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesConsignmentInvoiceTax = {
  __typename?: 'SalesConsignmentInvoiceTax';
  consignmentVendorID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  salesConsignmentInvoiceID: Scalars['UUID']['output'];
  salesConsignmentInvoiceTaxID: Scalars['UUID']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type SalesDashboard = {
  __typename?: 'SalesDashboard';
  salesByDay: Array<SalesDashboardDayPoint>;
  salesByHour: Array<SalesDashboardHourPoint>;
  summary: SalesDashboardSummary;
  topProducts: Array<SalesDashboardProductPoint>;
  topProductsByRevenue: Array<SalesDashboardProductPoint>;
};

export type SalesDashboardDayPoint = {
  __typename?: 'SalesDashboardDayPoint';
  date: Scalars['String']['output'];
  invoiceCount: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type SalesDashboardFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SalesDashboardHourPoint = {
  __typename?: 'SalesDashboardHourPoint';
  bucket: Scalars['String']['output'];
  invoiceCount: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type SalesDashboardProductPoint = {
  __typename?: 'SalesDashboardProductPoint';
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type SalesDashboardSummary = {
  __typename?: 'SalesDashboardSummary';
  avgBasket: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  totalDiscount: Scalars['Float']['output'];
  totalItemBundle: Scalars['Float']['output'];
  totalItemConsignment: Scalars['Float']['output'];
  totalItemProduct: Scalars['Float']['output'];
  totalItems: Scalars['Float']['output'];
  totalSales: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
};

export type SalesInvoice = {
  __typename?: 'SalesInvoice';
  adjustmentAmount: Scalars['Float']['output'];
  branchID: Scalars['UUID']['output'];
  cashPaymentAmount: Scalars['Float']['output'];
  customerID?: Maybe<Scalars['UUID']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  memberTypeID?: Maybe<Scalars['UUID']['output']>;
  memberTypeName?: Maybe<Scalars['String']['output']>;
  nonCashPaymentAmount: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentChangeAmount: Scalars['Float']['output'];
  paymentReceivedAmount: Scalars['Float']['output'];
  paymentVoucherAmount: Scalars['Float']['output'];
  payments: Array<SalesInvoicePayment>;
  salesChannelAdditionalCharge?: Maybe<Scalars['Float']['output']>;
  salesChannelCommisionPerc?: Maybe<Scalars['Float']['output']>;
  salesChannelID?: Maybe<Scalars['String']['output']>;
  salesChannelName?: Maybe<Scalars['String']['output']>;
  salesChannelReferenceID?: Maybe<Scalars['String']['output']>;
  salesChannelType?: Maybe<Scalars['String']['output']>;
  salesInvoiceDatetime: Scalars['Time']['output'];
  salesInvoiceDatetimeUtc: Scalars['Time']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  salesInvoiceType: Scalars['String']['output'];
  salesOrderID: Scalars['UUID']['output'];
  salesOrderNumber: Scalars['String']['output'];
  shiftSession?: Maybe<ShiftSession>;
  shiftSessionID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  subtotalAfterDiscount: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxIncluded: Scalars['Boolean']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<SalesInvoiceTax>;
  total: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  warehouseID?: Maybe<Scalars['UUID']['output']>;
};

export type SalesInvoiceBranchDateInput = {
  branchId: Scalars['String']['input'];
  date: Scalars['String']['input'];
};

export type SalesInvoiceConsignmentVendor = {
  __typename?: 'SalesInvoiceConsignmentVendor';
  consignmentCommissionFeePerc?: Maybe<Scalars['Float']['output']>;
  isPKP?: Maybe<Scalars['Boolean']['output']>;
  vendorCode: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
};

export type SalesInvoiceInventoryBackfillInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  salesInvoiceIDs: Array<Scalars['UUID']['input']>;
};

export type SalesInvoiceInventoryBackfillItem = {
  __typename?: 'SalesInvoiceInventoryBackfillItem';
  error: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  skipReason: Scalars['String']['output'];
};

export type SalesInvoiceInventoryBackfillResult = {
  __typename?: 'SalesInvoiceInventoryBackfillResult';
  dryRun: Scalars['Boolean']['output'];
  failed: Scalars['Int']['output'];
  published: Scalars['Int']['output'];
  results: Array<SalesInvoiceInventoryBackfillItem>;
  skipped: Scalars['Int']['output'];
  totalRequested: Scalars['Int']['output'];
};

export type SalesInvoiceItem = {
  __typename?: 'SalesInvoiceItem';
  additionalDiscountAmount: Scalars['Float']['output'];
  additionalDiscountPerc: Scalars['Float']['output'];
  addonComponents: Array<SalesInvoiceItemAddonComponent>;
  barcode: Scalars['String']['output'];
  baseUomQty: Scalars['Float']['output'];
  cancellationReason: Scalars['String']['output'];
  commissionAmount: Scalars['Float']['output'];
  consignmentCommissionFeePerc?: Maybe<Scalars['Float']['output']>;
  consignmentVendor?: Maybe<SalesInvoiceConsignmentVendor>;
  consignmentVendorID?: Maybe<Scalars['UUID']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountPerc: Scalars['Float']['output'];
  discountPercPlus: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isConsignment: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  productCategoryFullName: Scalars['String']['output'];
  productCategoryID: Scalars['UUID']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productNameAlias: Scalars['String']['output'];
  promoComponentID?: Maybe<Scalars['UUID']['output']>;
  promoParentProductID?: Maybe<Scalars['UUID']['output']>;
  promoType?: Maybe<Scalars['String']['output']>;
  qty: Scalars['Float']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceItemID: Scalars['UUID']['output'];
  salesOrderItemID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  taxAmount: Scalars['Float']['output'];
  taxItems: Scalars['String']['output'];
  taxableAmount: Scalars['Float']['output'];
  taxes: Array<SalesInvoiceItemTax>;
  total: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type SalesInvoiceItemAddonComponent = {
  __typename?: 'SalesInvoiceItemAddonComponent';
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
};

export type SalesInvoiceItemPaged = {
  __typename?: 'SalesInvoiceItemPaged';
  items: Array<SalesInvoiceItem>;
  pagination: PaginationResult;
};

export type SalesInvoiceItemQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesInvoiceItemQopInput = {
  filters?: InputMaybe<SalesInvoiceItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesInvoiceItemTax = {
  __typename?: 'SalesInvoiceItemTax';
  entityAuditMetadata: EntityAuditMetadata;
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceItemID: Scalars['UUID']['output'];
  salesInvoiceItemTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type SalesInvoicePaged = {
  __typename?: 'SalesInvoicePaged';
  items: Array<SalesInvoice>;
  pagination: PaginationResult;
};

export type SalesInvoicePayment = {
  __typename?: 'SalesInvoicePayment';
  authCode?: Maybe<Scalars['String']['output']>;
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankReconciliationItemID?: Maybe<Scalars['UUID']['output']>;
  bankReferenceNumber?: Maybe<Scalars['String']['output']>;
  branchID?: Maybe<Scalars['UUID']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  branchQrisMerchantID?: Maybe<Scalars['UUID']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  edcTerminalID?: Maybe<Scalars['UUID']['output']>;
  edcTerminalName?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isReconciliation: Scalars['Boolean']['output'];
  journalAccountCode?: Maybe<Scalars['String']['output']>;
  paymentAmount: Scalars['Float']['output'];
  paymentMethodID: Scalars['UUID']['output'];
  paymentMethodName: Scalars['String']['output'];
  paymentMethodTypeCode: Scalars['String']['output'];
  paymentMethodTypeID: Scalars['UUID']['output'];
  paymentMethodTypeIsCard: Scalars['Boolean']['output'];
  paymentMethodTypeIsCash: Scalars['Boolean']['output'];
  paymentMethodTypeIsSalesChannel: Scalars['Boolean']['output'];
  paymentMethodTypeName: Scalars['String']['output'];
  paymentMethodTypeUseUdc: Scalars['Boolean']['output'];
  paymentTransactionID?: Maybe<Scalars['UUID']['output']>;
  reconciledAt?: Maybe<Scalars['Time']['output']>;
  reconciledAtUtc?: Maybe<Scalars['Time']['output']>;
  reconciliationStatus: Scalars['String']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoicePaymentID: Scalars['UUID']['output'];
  salesOrderPaymentID: Scalars['UUID']['output'];
};

export type SalesInvoicePaymentPaged = {
  __typename?: 'SalesInvoicePaymentPaged';
  items: Array<SalesInvoicePayment>;
  pagination: PaginationResult;
};

export type SalesInvoicePaymentQopFilterInput = {
  authCode?: InputMaybe<Scalars['String']['input']>;
  bankAccountID?: InputMaybe<Scalars['UUID']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  createdAtEnd?: InputMaybe<Scalars['Time']['input']>;
  createdAtStart?: InputMaybe<Scalars['Time']['input']>;
  isReconciliation?: InputMaybe<Scalars['Boolean']['input']>;
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentMethodTypeCode?: InputMaybe<Scalars['String']['input']>;
  paymentMethodTypeIsCash?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  reconciliationStatus?: InputMaybe<Scalars['String']['input']>;
};

export type SalesInvoicePaymentQopInput = {
  filters?: InputMaybe<SalesInvoicePaymentQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesInvoiceQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  memberTypeID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  salesInvoiceDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceType?: InputMaybe<Scalars['String']['input']>;
  salesOrderID?: InputMaybe<Scalars['UUID']['input']>;
  shiftSessionID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SalesInvoiceQopInput = {
  filters?: InputMaybe<SalesInvoiceQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesInvoiceReview = {
  __typename?: 'SalesInvoiceReview';
  actualSettlementAmount: Scalars['Float']['output'];
  amountDifference: Scalars['Float']['output'];
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cashierUserID: Scalars['UUID']['output'];
  cashierUserName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expectedSettlementAmount: Scalars['Float']['output'];
  gmt: Scalars['Int']['output'];
  isNoteInternal: Scalars['Boolean']['output'];
  isResolved: Scalars['Boolean']['output'];
  noteInternal: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentTransactions: Array<PaymentTransaction>;
  payments: Array<SalesInvoicePayment>;
  resolutionNote: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Time']['output']>;
  resolvedAtUtc?: Maybe<Scalars['Time']['output']>;
  resolvedByUserID?: Maybe<Scalars['UUID']['output']>;
  resolvedByUserName: Scalars['String']['output'];
  reviewType: Scalars['String']['output'];
  salesChannelID: Scalars['String']['output'];
  salesChannelName: Scalars['String']['output'];
  salesInvoiceDatetime: Scalars['Time']['output'];
  salesInvoiceDatetimeUtc: Scalars['Time']['output'];
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  salesInvoiceReviewID: Scalars['UUID']['output'];
  salesInvoiceStatus: Scalars['String']['output'];
  salesInvoiceType: Scalars['String']['output'];
  salesOrderID: Scalars['UUID']['output'];
  salesOrderNumber: Scalars['String']['output'];
  settlementItems: Array<SalesInvoiceReviewSettlement>;
  shiftSessionID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type SalesInvoiceReviewPaged = {
  __typename?: 'SalesInvoiceReviewPaged';
  items: Array<SalesInvoiceReview>;
  pagination: PaginationResult;
};

export type SalesInvoiceReviewQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  cashierUserID?: InputMaybe<Scalars['UUID']['input']>;
  isNoteInternal?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
  reviewType?: InputMaybe<Scalars['String']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  salesInvoiceDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  salesInvoiceID?: InputMaybe<Scalars['UUID']['input']>;
  salesInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  salesInvoiceStatus?: InputMaybe<Scalars['String']['input']>;
  salesOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shiftSessionID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalEnd?: InputMaybe<Scalars['Float']['input']>;
  totalStart?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesInvoiceReviewQopInput = {
  filters?: InputMaybe<SalesInvoiceReviewQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesInvoiceReviewResolveBulkInput = {
  filters?: InputMaybe<SalesInvoiceReviewQopFilterInput>;
  resolutionNote: Scalars['String']['input'];
  salesInvoiceReviewIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type SalesInvoiceReviewResolveResult = {
  __typename?: 'SalesInvoiceReviewResolveResult';
  error: Scalars['String']['output'];
  salesInvoiceNumber: Scalars['String']['output'];
  salesInvoiceReviewID: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type SalesInvoiceReviewSettlement = {
  __typename?: 'SalesInvoiceReviewSettlement';
  amount: Scalars['Float']['output'];
  reference: Scalars['String']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SalesInvoiceTax = {
  __typename?: 'SalesInvoiceTax';
  entityAuditMetadata: EntityAuditMetadata;
  salesInvoiceID: Scalars['UUID']['output'];
  salesInvoiceTaxID: Scalars['UUID']['output'];
  taxAmount: Scalars['Float']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxRate: Scalars['Float']['output'];
  taxableAmount: Scalars['Float']['output'];
};

export type SalesPaymentMethod = {
  __typename?: 'SalesPaymentMethod';
  bankAccountID?: Maybe<Scalars['UUID']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  journalAccountCode: Scalars['String']['output'];
  salesPaymentMethodID: Scalars['UUID']['output'];
  salesPaymentMethodName: Scalars['String']['output'];
  salesPaymentMethodType: SalesPaymentMethodType;
  salesPaymentMethodTypeCode: Scalars['String']['output'];
  salesPaymentMethodTypeID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SalesPaymentMethodCreateInput = {
  bankAccountID: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodName: Scalars['String']['input'];
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
};

export type SalesPaymentMethodPaged = {
  __typename?: 'SalesPaymentMethodPaged';
  items: Array<SalesPaymentMethod>;
  pagination: PaginationResult;
};

export type SalesPaymentMethodQopFilterInput = {
  bankAccountID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodName?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodTypeCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodTypeID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SalesPaymentMethodQopInput = {
  filters?: InputMaybe<SalesPaymentMethodQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesPaymentMethodType = {
  __typename?: 'SalesPaymentMethodType';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isCard: Scalars['Boolean']['output'];
  isCash: Scalars['Boolean']['output'];
  isHandledBySystem: Scalars['Boolean']['output'];
  isSalesChannel: Scalars['Boolean']['output'];
  isSystemAutoPaid: Scalars['Boolean']['output'];
  salesChannelID: Scalars['String']['output'];
  salesPaymentMethodTypeCode: Scalars['String']['output'];
  salesPaymentMethodTypeID: Scalars['UUID']['output'];
  salesPaymentMethodTypeName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  useEdc: Scalars['Boolean']['output'];
};

export type SalesPaymentMethodTypeCreateInput = {
  isActive: Scalars['Boolean']['input'];
  isCard: Scalars['Boolean']['input'];
  isCash: Scalars['Boolean']['input'];
  isHandledBySystem: Scalars['Boolean']['input'];
  isSalesChannel: Scalars['Boolean']['input'];
  isSystemAutoPaid: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeName: Scalars['String']['input'];
  useEdc: Scalars['Boolean']['input'];
};

export type SalesPaymentMethodTypePaged = {
  __typename?: 'SalesPaymentMethodTypePaged';
  items?: Maybe<Array<SalesPaymentMethodType>>;
  pagination: PaginationResult;
};

export type SalesPaymentMethodTypeQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCard?: InputMaybe<Scalars['Boolean']['input']>;
  isCash?: InputMaybe<Scalars['Boolean']['input']>;
  isHandledBySystem?: InputMaybe<Scalars['Boolean']['input']>;
  isSalesChannel?: InputMaybe<Scalars['Boolean']['input']>;
  salesChannelID?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodTypeCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodTypeName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  useEdc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SalesPaymentMethodTypeQopInput = {
  filters?: InputMaybe<SalesPaymentMethodTypeQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SalesPaymentMethodTypeUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  isCard: Scalars['Boolean']['input'];
  isCash: Scalars['Boolean']['input'];
  isHandledBySystem: Scalars['Boolean']['input'];
  isSalesChannel: Scalars['Boolean']['input'];
  isSystemAutoPaid: Scalars['Boolean']['input'];
  salesChannelID: Scalars['String']['input'];
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
  salesPaymentMethodTypeName: Scalars['String']['input'];
  useEdc: Scalars['Boolean']['input'];
};

export type SalesPaymentMethodUpdateInput = {
  bankAccountID: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journalAccountCode?: InputMaybe<Scalars['String']['input']>;
  salesPaymentMethodID: Scalars['UUID']['input'];
  salesPaymentMethodName: Scalars['String']['input'];
  salesPaymentMethodTypeCode: Scalars['String']['input'];
  salesPaymentMethodTypeID: Scalars['UUID']['input'];
};

export type ScanLocationInput = {
  locationBarcode: Scalars['String']['input'];
  putawayTaskID: Scalars['UUID']['input'];
};

export type ScanProductInput = {
  productBarcode: Scalars['String']['input'];
  putawayTaskID: Scalars['UUID']['input'];
};

export type SetDefaultBranchInput = {
  branchID: Scalars['UUID']['input'];
};

export type ShiftSession = {
  __typename?: 'ShiftSession';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cashBalanceDiff: Scalars['Float']['output'];
  cashTransactionAmount: Scalars['Float']['output'];
  employeeID: Scalars['UUID']['output'];
  employeeName: Scalars['String']['output'];
  endingCashBalance?: Maybe<Scalars['Float']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  isCashBalanceDiff: Scalars['Boolean']['output'];
  isResolved: Scalars['Boolean']['output'];
  nonCashTransactionAmount: Scalars['Float']['output'];
  openingCashBalance: Scalars['Float']['output'];
  resolutionNote: Scalars['String']['output'];
  resolutionStatus: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Time']['output']>;
  resolvedAtUtc?: Maybe<Scalars['Time']['output']>;
  resolvedByUserID?: Maybe<Scalars['UUID']['output']>;
  resolvedByUserName: Scalars['String']['output'];
  sessionCloseTime?: Maybe<Scalars['Time']['output']>;
  sessionCloseTimeUtc?: Maybe<Scalars['Time']['output']>;
  sessionDuration: Scalars['Int']['output'];
  sessionOpenTime: Scalars['Time']['output'];
  sessionOpenTimeUtc: Scalars['Time']['output'];
  shiftSessionID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  totalTransactionAmount: Scalars['Float']['output'];
  userID: Scalars['UUID']['output'];
  userName: Scalars['String']['output'];
  voucherTransactionAmount: Scalars['Float']['output'];
  voucherTransactionCount: Scalars['Int']['output'];
};

export type ShiftSessionCloseInput = {
  cashTransactionAmount: Scalars['Float']['input'];
  endingCashBalance: Scalars['Float']['input'];
  sessionCloseTime: Scalars['Time']['input'];
  sessionCloseTimeUtc: Scalars['Time']['input'];
  shiftSessionID: Scalars['UUID']['input'];
};

export type ShiftSessionCloseResult = {
  __typename?: 'ShiftSessionCloseResult';
  shiftSession: ShiftSession;
  unsyncedOrders: ShiftSessionUnsyncedOrders;
};

export type ShiftSessionCreateInput = {
  branchID: Scalars['UUID']['input'];
  openingCashBalance: Scalars['Float']['input'];
  sessionOpenTime: Scalars['Time']['input'];
  sessionOpenTimeUtc: Scalars['Time']['input'];
};

export type ShiftSessionDeadOrder = {
  __typename?: 'ShiftSessionDeadOrder';
  lastAttemptTimeUtc: Scalars['String']['output'];
  posSalesOrderID: Scalars['String']['output'];
  posSalesOrderNumber: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  syncError: Scalars['String']['output'];
};

export type ShiftSessionPaged = {
  __typename?: 'ShiftSessionPaged';
  items?: Maybe<Array<ShiftSession>>;
  pagination: PaginationResult;
};

export type ShiftSessionQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  employeeID?: InputMaybe<Scalars['UUID']['input']>;
  isCashBalanceDiff?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  sessionOpenTimeGte?: InputMaybe<Scalars['Time']['input']>;
  sessionOpenTimeLte?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['UUID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type ShiftSessionQopInput = {
  filters?: InputMaybe<ShiftSessionQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ShiftSessionResolveCashDiffInput = {
  resolutionNote: Scalars['String']['input'];
  resolutionStatus: Scalars['String']['input'];
  shiftSessionID: Scalars['UUID']['input'];
};

export type ShiftSessionUnsyncedOrders = {
  __typename?: 'ShiftSessionUnsyncedOrders';
  deadOrders: Array<ShiftSessionDeadOrder>;
  hasUnsynced: Scalars['Boolean']['output'];
  pendingCount: Scalars['Int']['output'];
};

export type SimpleTransferOrder = {
  __typename?: 'SimpleTransferOrder';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  confirmByUserID?: Maybe<Scalars['UUID']['output']>;
  confirmByUserName?: Maybe<Scalars['String']['output']>;
  confirmDatetime?: Maybe<Scalars['Time']['output']>;
  confirmDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  deliveredDatetime?: Maybe<Scalars['Time']['output']>;
  deliveredDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  deliveryOrder?: Maybe<DeliveryOrder>;
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderNumber: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouse: Warehouse;
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  noteForReceiver: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  scheduledDeliveryDate: Scalars['Time']['output'];
  simpleTransferOrderDatetime: Scalars['Time']['output'];
  simpleTransferOrderDatetimeUtc: Scalars['Time']['output'];
  simpleTransferOrderID: Scalars['UUID']['output'];
  simpleTransferOrderNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toWarehouse: Warehouse;
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItemQtyReadyToShip: Scalars['Float']['output'];
  totalItemQtyShipped: Scalars['Float']['output'];
  totalItemQtyUnfulfilled: Scalars['Float']['output'];
  totalItemWeight: Scalars['Float']['output'];
};

export type SimpleTransferOrderCancelInput = {
  cancellationReason: Scalars['String']['input'];
  transferOrderSimpleID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderConfirmInput = {
  deliveryOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  deliveryOrderNumber?: InputMaybe<Scalars['String']['input']>;
  transferOrderSimpleID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderCreateInput = {
  branchID: Scalars['UUID']['input'];
  deliveryOrderID?: InputMaybe<Scalars['UUID']['input']>;
  deliveryOrderNumber?: InputMaybe<Scalars['String']['input']>;
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<SimpleTransferOrderItemCreateInput>;
  noteForReceiver: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
  toWarehouseID: Scalars['UUID']['input'];
  transferOrderSimpleDatetime: Scalars['Time']['input'];
  transferOrderSimpleNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SimpleTransferOrderItem = {
  __typename?: 'SimpleTransferOrderItem';
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isMultiple: Scalars['Boolean']['output'];
  locations: Array<SimpleTransferOrderItemLocation>;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  qtyReadyToShip: Scalars['Float']['output'];
  qtyShipped: Scalars['Float']['output'];
  qtyUnfulfilled: Scalars['Float']['output'];
  simpleTransferOrderID: Scalars['UUID']['output'];
  simpleTransferOrderItemID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type SimpleTransferOrderItemCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<SimpleTransferOrderItemLocationCreateInput>>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderItemLocation = {
  __typename?: 'SimpleTransferOrderItemLocation';
  baseUomQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseLocation: WarehouseLocation;
  fromWarehouseLocationID: Scalars['UUID']['output'];
  fromWarehouseLocationName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  simpleTransferOrderItem: SimpleTransferOrderItem;
  simpleTransferOrderItemID: Scalars['UUID']['output'];
  simpleTransferOrderItemLocationID: Scalars['UUID']['output'];
};

export type SimpleTransferOrderItemLocationCreateInput = {
  fromWarehouseLocationID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
};

export type SimpleTransferOrderItemLocationPaged = {
  __typename?: 'SimpleTransferOrderItemLocationPaged';
  items: Array<SimpleTransferOrderItemLocation>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderItemLocationQopFilterInput = {
  fromWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseLocationName?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  simpleTransferOrderItemLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderItemLocationQopInput = {
  filters?: InputMaybe<SimpleTransferOrderItemLocationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderItemLocationUpdateInput = {
  fromWarehouseLocationID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  transferOrderSimpleItemLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderItemPaged = {
  __typename?: 'SimpleTransferOrderItemPaged';
  items: Array<SimpleTransferOrderItem>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderID?: InputMaybe<Scalars['UUID']['input']>;
  simpleTransferOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderItemQopInput = {
  filters?: InputMaybe<SimpleTransferOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderItemUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<SimpleTransferOrderItemLocationUpdateInput>>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  transferOrderSimpleItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderPaged = {
  __typename?: 'SimpleTransferOrderPaged';
  items: Array<SimpleTransferOrder>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  scheduledDeliveryDate?: InputMaybe<Scalars['Time']['input']>;
  scheduledDeliveryDateEnd?: InputMaybe<Scalars['Time']['input']>;
  scheduledDeliveryDateStart?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  simpleTransferOrderNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderQopInput = {
  filters?: InputMaybe<SimpleTransferOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderReceiving = {
  __typename?: 'SimpleTransferOrderReceiving';
  /** How the receiving reached confirmed: save_and_confirm | edit_and_confirm | submit_confirm. Null while still a draft. */
  actionType?: Maybe<Scalars['String']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  closeSto: Scalars['Boolean']['output'];
  deliveryBy: Scalars['String']['output'];
  deliveryOrder: DeliveryOrder;
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderNumber: Scalars['String']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhoneNumber?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<SimpleTransferOrderReceivingFile>>;
  gmt: Scalars['Int']['output'];
  noteInternal: Scalars['String']['output'];
  originWarehouse: Warehouse;
  originWarehouseID: Scalars['UUID']['output'];
  simpleTransferOrderID: Scalars['UUID']['output'];
  simpleTransferOrderNumber: Scalars['String']['output'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['output'];
  simpleTransferOrderReceivingID: Scalars['UUID']['output'];
  simpleTransferOrderReceivingNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItemWeightReceived: Scalars['Float']['output'];
  vehiclePlateNumber?: Maybe<Scalars['String']['output']>;
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
  vendorRefNumber?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type SimpleTransferOrderReceivingCreateAndConfirmInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  deliveryOrderID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<SimpleTransferOrderReceivingFileInput>>;
  items: Array<SimpleTransferOrderReceivingItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingCreateInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  deliveryOrderID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<SimpleTransferOrderReceivingFileInput>>;
  items: Array<SimpleTransferOrderReceivingItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderReceivingFile = {
  __typename?: 'SimpleTransferOrderReceivingFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  simpleTransferOrderReceivingFileID: Scalars['UUID']['output'];
  simpleTransferOrderReceivingFileType: Scalars['String']['output'];
  simpleTransferOrderReceivingID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type SimpleTransferOrderReceivingFileInput = {
  fileID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingItem = {
  __typename?: 'SimpleTransferOrderReceivingItem';
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  doQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  note?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  simpleTransferOrderID: Scalars['UUID']['output'];
  simpleTransferOrderItemID: Scalars['UUID']['output'];
  simpleTransferOrderReceivingID: Scalars['UUID']['output'];
  simpleTransferOrderReceivingItemID: Scalars['UUID']['output'];
  toQty: Scalars['Float']['output'];
  toQtyOutstanding: Scalars['Float']['output'];
  toQtyReceived: Scalars['Float']['output'];
  toUomConversionDecimal: Scalars['Int']['output'];
  toUomConversionRate: Scalars['Float']['output'];
  toUomID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type SimpleTransferOrderReceivingItemCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingItemPaged = {
  __typename?: 'SimpleTransferOrderReceivingItemPaged';
  items: Array<SimpleTransferOrderReceivingItem>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderReceivingItemQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  simpleTransferOrderID?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderReceivingID?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderReceivingItemID?: InputMaybe<Scalars['String']['input']>;
};

export type SimpleTransferOrderReceivingItemQopInput = {
  filters?: InputMaybe<SimpleTransferOrderReceivingItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderReceivingItemUpdateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  simpleTransferOrderReceivingItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingPaged = {
  __typename?: 'SimpleTransferOrderReceivingPaged';
  items: Array<SimpleTransferOrderReceiving>;
  pagination: PaginationResult;
};

export type SimpleTransferOrderReceivingQopFilterInput = {
  simpleTransferOrderNumber?: InputMaybe<Scalars['String']['input']>;
  simpleTransferOrderReceivingDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderReceivingDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  simpleTransferOrderReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderReceivingQopInput = {
  filters?: InputMaybe<SimpleTransferOrderReceivingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type SimpleTransferOrderReceivingUpdateAndConfirmInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  files?: InputMaybe<Array<SimpleTransferOrderReceivingFileInput>>;
  items: Array<SimpleTransferOrderReceivingItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['input'];
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type SimpleTransferOrderReceivingUpdateInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  files?: InputMaybe<Array<SimpleTransferOrderReceivingFileInput>>;
  items: Array<SimpleTransferOrderReceivingItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  simpleTransferOrderReceivingDatetime: Scalars['Time']['input'];
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type SimpleTransferOrderUpdateInput = {
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<SimpleTransferOrderItemUpdateInput>;
  noteForReceiver: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
  toWarehouseID: Scalars['UUID']['input'];
  transferOrderSimpleID: Scalars['UUID']['input'];
};

export type SnapshotItem = {
  __typename?: 'SnapshotItem';
  id: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  vector: Array<Scalars['Float']['output']>;
};

export type SnapshotPage = {
  __typename?: 'SnapshotPage';
  items: Array<SnapshotItem>;
  limit: Scalars['Int']['output'];
  nextOffset?: Maybe<Scalars['Int']['output']>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Sort = {
  direction: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

export type StartTaskInput = {
  putawayTaskID: Scalars['UUID']['input'];
};

export type Subdistrict = {
  __typename?: 'Subdistrict';
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  villages?: Maybe<Array<Maybe<Village>>>;
};

export type SubdistrictCreateInput = {
  cityID: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type SubdistrictPaged = {
  __typename?: 'SubdistrictPaged';
  items: Array<Subdistrict>;
  pagination: PaginationResult;
};

export type SubdistrictQop = {
  filters?: InputMaybe<SubdistrictQopFilter>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<Sort>>;
};

export type SubdistrictQopFilter = {
  cityID?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
  subdistrictName?: InputMaybe<Scalars['String']['input']>;
};

export type SubdistrictUpdateInput = {
  cityID: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  provinceID: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
};

export type SupervisorPinValidationResult = {
  __typename?: 'SupervisorPinValidationResult';
  branchID?: Maybe<Scalars['UUID']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  userID?: Maybe<Scalars['UUID']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type SyncAllResult = {
  __typename?: 'SyncAllResult';
  failedIDs: Array<Scalars['String']['output']>;
  successIDs: Array<Scalars['String']['output']>;
  totalFailed: Scalars['Int']['output'];
  totalSuccess: Scalars['Int']['output'];
};

export type SyncErpPurchaseOrderReceiveInput = {
  action: Scalars['String']['input'];
  purchaseOrderReceivingID: Scalars['UUID']['input'];
};

export type SyncErpVendorInput = {
  action: Scalars['String']['input'];
  vendorCode: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type TaskAllocationInput = {
  assignedToUserID?: InputMaybe<Scalars['UUID']['input']>;
  items: Array<TaskItemAllocationInput>;
  noteInternal?: InputMaybe<Scalars['String']['input']>;
};

export type TaskItemAllocationInput = {
  qtyAssigned: Scalars['Float']['input'];
  sourceDocumentDetailID: Scalars['UUID']['input'];
};

export type Tax = {
  __typename?: 'Tax';
  entityAuditMetadata: EntityAuditMetadata;
  erpRefID?: Maybe<Scalars['String']['output']>;
  erpRefName?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  taxCode: Scalars['String']['output'];
  taxID: Scalars['UUID']['output'];
  taxName: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
  taxType: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type TaxCreateInput = {
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  taxCode: Scalars['String']['input'];
  taxName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
  taxType: Scalars['String']['input'];
};

export type TaxPaged = {
  __typename?: 'TaxPaged';
  items?: Maybe<Array<Tax>>;
  pagination: PaginationResult;
};

export type TaxQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  taxName?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  taxType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type TaxQopInput = {
  filters?: InputMaybe<TaxQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TaxUpdateInput = {
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  taxCode: Scalars['String']['input'];
  taxID: Scalars['UUID']['input'];
  taxName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
  taxType: Scalars['String']['input'];
};

export enum TokenType {
  EmailVerification = 'EMAIL_VERIFICATION',
  PhoneVerification = 'PHONE_VERIFICATION',
  ResetPassword = 'RESET_PASSWORD'
}

export enum TransactionSyncEntityType {
  ConsignmentStockIn = 'CONSIGNMENT_STOCK_IN',
  ConsignmentStockOut = 'CONSIGNMENT_STOCK_OUT',
  DeliveryOrder = 'DELIVERY_ORDER',
  InventoryAdjustment = 'INVENTORY_ADJUSTMENT',
  PettyCashTransaction = 'PETTY_CASH_TRANSACTION',
  ProductionOrder = 'PRODUCTION_ORDER',
  PurchaseOrder = 'PURCHASE_ORDER',
  PurchaseOrderReceive = 'PURCHASE_ORDER_RECEIVE',
  SalesInvoice = 'SALES_INVOICE',
  SimpleTransferOrderReceive = 'SIMPLE_TRANSFER_ORDER_RECEIVE',
  TransferOrderReceive = 'TRANSFER_ORDER_RECEIVE'
}

export type TransferOrder = {
  __typename?: 'TransferOrder';
  branch: Branch;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  confirmByUserID?: Maybe<Scalars['UUID']['output']>;
  confirmByUserName?: Maybe<Scalars['String']['output']>;
  confirmDatetime?: Maybe<Scalars['Time']['output']>;
  confirmDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  doneByUserID?: Maybe<Scalars['UUID']['output']>;
  doneByUserName?: Maybe<Scalars['String']['output']>;
  doneDatetime?: Maybe<Scalars['Time']['output']>;
  doneDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  doneReason?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouse: Warehouse;
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  isPickingTaskComplated: Scalars['Boolean']['output'];
  isReadyGenerateDeliveryOrder: Scalars['Boolean']['output'];
  noteForReceiver: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  reasonNotReadyGenerateDeliveryOrder?: Maybe<Scalars['String']['output']>;
  scheduledDeliveryDate: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  toWarehouse: Warehouse;
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalItemQtyReadyToPack: Scalars['Float']['output'];
  totalItemQtyReadyToPick: Scalars['Float']['output'];
  totalItemQtyReadyToShip: Scalars['Float']['output'];
  totalItemQtyShipped: Scalars['Float']['output'];
  totalItemQtyUnfulfilled: Scalars['Float']['output'];
  totalItemWeight: Scalars['Float']['output'];
  transferOrderDatetime: Scalars['Time']['output'];
  transferOrderDatetimeUtc: Scalars['Time']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderNumber: Scalars['String']['output'];
  transferRequest?: Maybe<TransferRequest>;
};

export type TransferOrderCancelInput = {
  cancellationReason: Scalars['String']['input'];
  transferOrderID: Scalars['UUID']['input'];
};

export type TransferOrderConfirmInput = {
  transferOrderID: Scalars['UUID']['input'];
};

export type TransferOrderCreateInput = {
  branchID: Scalars['UUID']['input'];
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<TransferOrderItemCreateInput>;
  noteForReceiver: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
  toWarehouseID: Scalars['UUID']['input'];
  transferOrderDatetime: Scalars['Time']['input'];
  transferOrderNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TransferOrderImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TransferOrderImportFileMappingInput = {
  columns: Array<TransferOrderImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  rowFilters?: InputMaybe<Array<TransferOrderImportRowFilterInput>>;
};

export type TransferOrderImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: TransferOrderImportFileMappingInput;
};

export type TransferOrderImportMissingProductUom = {
  __typename?: 'TransferOrderImportMissingProductUom';
  productCode: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  uomName: Scalars['String']['output'];
};

export type TransferOrderImportRowFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
};

export type TransferOrderImportRowReport = {
  __typename?: 'TransferOrderImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<TransferOrderImportRowViolation>;
};

export type TransferOrderImportRowViolation = {
  __typename?: 'TransferOrderImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TransferOrderImportValidateCodesInput = {
  branchCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  fileMapping?: InputMaybe<TransferOrderImportFileMappingInput>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransferOrderImportValidateCodesResult = {
  __typename?: 'TransferOrderImportValidateCodesResult';
  consignmentProductCodes: Array<Scalars['String']['output']>;
  duplicateProductCodes: Array<Scalars['String']['output']>;
  missingBranchCodes: Array<Scalars['String']['output']>;
  missingProductCodes: Array<Scalars['String']['output']>;
  missingProductUoms: Array<TransferOrderImportMissingProductUom>;
  missingWarehouseCodes: Array<Scalars['String']['output']>;
  rowReport?: Maybe<TransferOrderImportRowReport>;
};

export type TransferOrderItem = {
  __typename?: 'TransferOrderItem';
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qty: Scalars['Float']['output'];
  qtyReadyToPack: Scalars['Float']['output'];
  qtyReadyToPick: Scalars['Float']['output'];
  qtyReadyToShip: Scalars['Float']['output'];
  qtyShipped: Scalars['Float']['output'];
  qtyUnfulfilled: Scalars['Float']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderItemID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type TransferOrderItemCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type TransferOrderItemPaged = {
  __typename?: 'TransferOrderItemPaged';
  items: Array<TransferOrderItem>;
  pagination: PaginationResult;
};

export type TransferOrderItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  transferOrderID?: InputMaybe<Scalars['UUID']['input']>;
  transferOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type TransferOrderItemQopInput = {
  filters?: InputMaybe<TransferOrderItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferOrderItemUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qty: Scalars['Float']['input'];
  transferOrderItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type TransferOrderMarkAsDoneInput = {
  reason: Scalars['String']['input'];
  transferOrderID: Scalars['UUID']['input'];
};

export type TransferOrderPaged = {
  __typename?: 'TransferOrderPaged';
  items: Array<TransferOrder>;
  pagination: PaginationResult;
};

export type TransferOrderQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  scheduledDeliveryDate?: InputMaybe<Scalars['Time']['input']>;
  scheduledDeliveryDateEnd?: InputMaybe<Scalars['Time']['input']>;
  scheduledDeliveryDateStart?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  transferOrderDatetime?: InputMaybe<Scalars['Time']['input']>;
  transferOrderDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transferOrderDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  transferOrderIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transferOrderNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TransferOrderQopInput = {
  filters?: InputMaybe<TransferOrderQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferOrderReceiving = {
  __typename?: 'TransferOrderReceiving';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  closeTO: Scalars['Boolean']['output'];
  deliveryBy: Scalars['String']['output'];
  deliveryOrder: DeliveryOrder;
  deliveryOrderID: Scalars['UUID']['output'];
  deliveryOrderNumber: Scalars['String']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhoneNumber?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<TransferOrderReceivingFile>>;
  gmt: Scalars['Int']['output'];
  items: Array<TransferOrderReceivingItem>;
  landedCost: Scalars['Float']['output'];
  landedCostPerUnit: Scalars['Float']['output'];
  noteInternal: Scalars['String']['output'];
  originWarehouse: Warehouse;
  originWarehouseID: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  totalItemQtyReceived: Scalars['Float']['output'];
  totalItemWeightReceived: Scalars['Float']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderNumber: Scalars['String']['output'];
  transferOrderReceivingDatetime: Scalars['Time']['output'];
  transferOrderReceivingID: Scalars['UUID']['output'];
  transferOrderReceivingNumber: Scalars['String']['output'];
  vehiclePlateNumber?: Maybe<Scalars['String']['output']>;
  vendorCode?: Maybe<Scalars['String']['output']>;
  vendorID?: Maybe<Scalars['UUID']['output']>;
  vendorName?: Maybe<Scalars['String']['output']>;
  vendorRefNumber?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocation: WarehouseLocation;
  warehouseLocationID: Scalars['UUID']['output'];
};

export type TransferOrderReceivingCreateInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  deliveryOrderID: Scalars['UUID']['input'];
  files?: InputMaybe<Array<TransferOrderReceivingFileInput>>;
  items: Array<TransferOrderReceivingItemCreateInput>;
  noteInternal: Scalars['String']['input'];
  transferOrderReceivingDatetime: Scalars['Time']['input'];
  version: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type TransferOrderReceivingFile = {
  __typename?: 'TransferOrderReceivingFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  transferOrderReceivingFileID: Scalars['UUID']['output'];
  transferOrderReceivingFileType: Scalars['String']['output'];
  transferOrderReceivingID: Scalars['UUID']['output'];
  uniqueKey: Scalars['String']['output'];
};

export type TransferOrderReceivingFileInput = {
  fileID: Scalars['UUID']['input'];
};

export type TransferOrderReceivingItem = {
  __typename?: 'TransferOrderReceivingItem';
  additionalLandedCost: Scalars['Float']['output'];
  baseUomQty: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  doQty: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  note?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyReceived: Scalars['Float']['output'];
  toQty: Scalars['Float']['output'];
  toQtyOutstanding: Scalars['Float']['output'];
  toQtyReceived: Scalars['Float']['output'];
  toUomConversionDecimal: Scalars['Int']['output'];
  toUomConversionRate: Scalars['Float']['output'];
  toUomID: Scalars['UUID']['output'];
  transferOrderID: Scalars['UUID']['output'];
  transferOrderItemID: Scalars['UUID']['output'];
  transferOrderReceivingID: Scalars['UUID']['output'];
  transferOrderReceivingItemID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConversionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type TransferOrderReceivingItemCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type TransferOrderReceivingItemPaged = {
  __typename?: 'TransferOrderReceivingItemPaged';
  items: Array<TransferOrderReceivingItem>;
  pagination: PaginationResult;
};

export type TransferOrderReceivingItemQopFilterInput = {
  productID?: InputMaybe<Scalars['UUID']['input']>;
  transferOrderID?: InputMaybe<Scalars['String']['input']>;
  transferOrderReceivingID?: InputMaybe<Scalars['String']['input']>;
  transferOrderReceivingItemID?: InputMaybe<Scalars['String']['input']>;
};

export type TransferOrderReceivingItemQopInput = {
  filters?: InputMaybe<TransferOrderReceivingItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferOrderReceivingItemUpdateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyReceived: Scalars['Float']['input'];
  transferOrderReceivingItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type TransferOrderReceivingPaged = {
  __typename?: 'TransferOrderReceivingPaged';
  items: Array<TransferOrderReceiving>;
  pagination: PaginationResult;
};

export type TransferOrderReceivingQopFilterInput = {
  status?: InputMaybe<Scalars['String']['input']>;
  transferOrderNumber?: InputMaybe<Scalars['String']['input']>;
  transferOrderReceivingDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transferOrderReceivingDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  transferOrderReceivingNumber?: InputMaybe<Scalars['String']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type TransferOrderReceivingQopInput = {
  filters?: InputMaybe<TransferOrderReceivingQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferOrderReceivingUpdateInput = {
  containerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  files?: InputMaybe<Array<TransferOrderReceivingFileInput>>;
  items: Array<TransferOrderReceivingItemUpdateInput>;
  noteInternal: Scalars['String']['input'];
  transferOrderReceivingDatetime: Scalars['Time']['input'];
  transferOrderReceivingID: Scalars['UUID']['input'];
};

export type TransferOrderUpdateInput = {
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<TransferOrderItemUpdateInput>;
  noteForReceiver: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate: Scalars['Time']['input'];
  toWarehouseID: Scalars['UUID']['input'];
  transferOrderID: Scalars['UUID']['input'];
};

export type TransferRequest = {
  __typename?: 'TransferRequest';
  approvedByUserID?: Maybe<Scalars['UUID']['output']>;
  approvedByUserName?: Maybe<Scalars['String']['output']>;
  approvedDatetime?: Maybe<Scalars['Time']['output']>;
  approvedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName?: Maybe<Scalars['String']['output']>;
  cancelledDatetime?: Maybe<Scalars['Time']['output']>;
  cancelledDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  fromWarehouseCode: Scalars['String']['output'];
  fromWarehouseID: Scalars['UUID']['output'];
  fromWarehouseName: Scalars['String']['output'];
  gmt: Scalars['Int']['output'];
  items: Array<TransferRequestItem>;
  noteApprover?: Maybe<Scalars['String']['output']>;
  noteForApprover: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  rejectedByUserID?: Maybe<Scalars['UUID']['output']>;
  rejectedByUserName?: Maybe<Scalars['String']['output']>;
  rejectedDatetime?: Maybe<Scalars['Time']['output']>;
  rejectedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  replenishmentID?: Maybe<Scalars['UUID']['output']>;
  scheduledDeliveryDate?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  submittedByUserID?: Maybe<Scalars['UUID']['output']>;
  submittedByUserName?: Maybe<Scalars['String']['output']>;
  submittedDatetime?: Maybe<Scalars['Time']['output']>;
  submittedDatetimeUtc?: Maybe<Scalars['Time']['output']>;
  toWarehouseCode: Scalars['String']['output'];
  toWarehouseID: Scalars['UUID']['output'];
  toWarehouseName: Scalars['String']['output'];
  totalItemQtyApproved: Scalars['Float']['output'];
  totalItemQtyRequested: Scalars['Float']['output'];
  transferOrderID?: Maybe<Scalars['UUID']['output']>;
  transferOrderNumber?: Maybe<Scalars['String']['output']>;
  transferRequestDatetime: Scalars['Time']['output'];
  transferRequestDatetimeUtc: Scalars['Time']['output'];
  transferRequestID: Scalars['UUID']['output'];
  transferRequestNumber: Scalars['String']['output'];
};

export type TransferRequestApproveInput = {
  items: Array<TransferRequestApproveItemInput>;
  noteApprover?: InputMaybe<Scalars['String']['input']>;
  transferRequestID: Scalars['UUID']['input'];
};

export type TransferRequestApproveItemInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  qtyApproved: Scalars['Float']['input'];
  transferRequestItemID: Scalars['UUID']['input'];
};

export type TransferRequestCancelInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  transferRequestID: Scalars['UUID']['input'];
};

export type TransferRequestCreateInput = {
  branchID: Scalars['UUID']['input'];
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<TransferRequestItemCreateInput>;
  noteForApprover: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate?: InputMaybe<Scalars['Time']['input']>;
  toWarehouseID: Scalars['UUID']['input'];
  transferRequestDatetime: Scalars['Time']['input'];
  transferRequestNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TransferRequestImportColumnInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TransferRequestImportFileMappingInput = {
  columns: Array<TransferRequestImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  rowFilters?: InputMaybe<Array<TransferRequestImportRowFilterInput>>;
};

export type TransferRequestImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: TransferRequestImportFileMappingInput;
};

export type TransferRequestImportRowFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
};

export type TransferRequestImportRowReport = {
  __typename?: 'TransferRequestImportRowReport';
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<TransferRequestImportRowViolation>;
};

export type TransferRequestImportRowViolation = {
  __typename?: 'TransferRequestImportRowViolation';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TransferRequestImportValidateCodesInput = {
  branchCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fileID?: InputMaybe<Scalars['UUID']['input']>;
  fileMapping?: InputMaybe<TransferRequestImportFileMappingInput>;
  productCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransferRequestImportValidateCodesResult = {
  __typename?: 'TransferRequestImportValidateCodesResult';
  consignmentProductCodes: Array<Scalars['String']['output']>;
  duplicateProductCodes: Array<Scalars['String']['output']>;
  missingBranchCodes: Array<Scalars['String']['output']>;
  missingProductCodes: Array<Scalars['String']['output']>;
  missingWarehouseCodes: Array<Scalars['String']['output']>;
  rowReport?: Maybe<TransferRequestImportRowReport>;
};

export type TransferRequestItem = {
  __typename?: 'TransferRequestItem';
  availability?: Maybe<TransferRequestItemAvailability>;
  baseUomQtyApproved: Scalars['Float']['output'];
  baseUomQtyRequested: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  noteApprover?: Maybe<Scalars['String']['output']>;
  noteRequester?: Maybe<Scalars['String']['output']>;
  product: Product;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  productWeight: Scalars['Float']['output'];
  qtyApproved: Scalars['Float']['output'];
  qtyRequested: Scalars['Float']['output'];
  transferRequestID: Scalars['UUID']['output'];
  transferRequestItemID: Scalars['UUID']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomConversionDecimal: Scalars['Int']['output'];
  uomConvertionRate: Scalars['Float']['output'];
  uomDecimal: Scalars['Int']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type TransferRequestItemAvailability = {
  __typename?: 'TransferRequestItemAvailability';
  qtyAvailable: Scalars['Float']['output'];
  qtyOutstandingIn: Scalars['Float']['output'];
  qtyOutstandingOut: Scalars['Float']['output'];
  qtyRealAvailable: Scalars['Float']['output'];
  warehouseID: Scalars['UUID']['output'];
};

export type TransferRequestItemCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  uomID: Scalars['UUID']['input'];
};

export type TransferRequestItemPaged = {
  __typename?: 'TransferRequestItemPaged';
  items: Array<TransferRequestItem>;
  pagination: PaginationResult;
};

export type TransferRequestItemQopFilterInput = {
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  transferRequestID?: InputMaybe<Scalars['String']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomID?: InputMaybe<Scalars['UUID']['input']>;
};

export type TransferRequestItemQopInput = {
  filters?: InputMaybe<TransferRequestItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferRequestItemUpdateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  productID: Scalars['UUID']['input'];
  qtyRequested: Scalars['Float']['input'];
  transferRequestItemID?: InputMaybe<Scalars['UUID']['input']>;
  uomID: Scalars['UUID']['input'];
};

export type TransferRequestPaged = {
  __typename?: 'TransferRequestPaged';
  items: Array<TransferRequest>;
  pagination: PaginationResult;
};

export type TransferRequestQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  fromWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentID?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
  transferOrderID?: InputMaybe<Scalars['UUID']['input']>;
  transferRequestDatetimeEnd?: InputMaybe<Scalars['Time']['input']>;
  transferRequestDatetimeStart?: InputMaybe<Scalars['Time']['input']>;
  transferRequestNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TransferRequestQopInput = {
  filters?: InputMaybe<TransferRequestQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TransferRequestRejectInput = {
  rejectionReason: Scalars['String']['input'];
  transferRequestID: Scalars['UUID']['input'];
};

export type TransferRequestSubmitInput = {
  transferRequestID: Scalars['UUID']['input'];
};

export type TransferRequestUpdateInput = {
  fromWarehouseID: Scalars['UUID']['input'];
  items: Array<TransferRequestItemUpdateInput>;
  noteForApprover: Scalars['String']['input'];
  noteInternal: Scalars['String']['input'];
  scheduledDeliveryDate?: InputMaybe<Scalars['Time']['input']>;
  toWarehouseID: Scalars['UUID']['input'];
  transferRequestID: Scalars['UUID']['input'];
};

export type TriggerIngestionInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Uom = {
  __typename?: 'Uom';
  conversionInfo: Scalars['String']['output'];
  convertionDecimal: Scalars['Int']['output'];
  convertionRate: Scalars['Float']['output'];
  convertionRateMultiplier: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  relationType: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  uniqueKey2: Scalars['String']['output'];
  uomCategory?: Maybe<UomCategory>;
  uomCategoryID: Scalars['UUID']['output'];
  uomID: Scalars['UUID']['output'];
  uomName: Scalars['String']['output'];
};

export type UomCategory = {
  __typename?: 'UomCategory';
  baseUom: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  nonMainUoms: Array<Uom>;
  uniqueKey: Scalars['String']['output'];
  uomCategoryID: Scalars['UUID']['output'];
  uomCategoryName: Scalars['String']['output'];
  uomItems: Scalars['String']['output'];
  uoms: Array<Uom>;
};

export type UomCategoryCreateInput = {
  baseUom: Scalars['String']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  uom: Array<UomCreateFromUomCategoryInput>;
  uomCategoryName: Scalars['String']['input'];
};

export type UomCategoryDeleteInput = {
  uomCategoryID: Scalars['UUID']['input'];
};

export type UomCategoryPaged = {
  __typename?: 'UomCategoryPaged';
  items: Array<UomCategory>;
  pagination: PaginationResult;
};

export type UomCategoryQopFilterInput = {
  baseUom?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomCategoryName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type UomCategoryQopInput = {
  filters?: InputMaybe<UomCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UomCategoryUpdateInput = {
  baseUom: Scalars['String']['input'];
  description: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  uom: Array<UomCreateFromUomCategoryInput>;
  uomCategoryID: Scalars['UUID']['input'];
  uomCategoryName: Scalars['String']['input'];
};

export type UomCreateFromUomCategoryInput = {
  convertionDecimal: Scalars['Int']['input'];
  convertionRate: Scalars['Float']['input'];
  convertionRateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  relationType: Scalars['String']['input'];
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  uomName: Scalars['String']['input'];
};

export type UomCreateInput = {
  convertionDecimal: Scalars['Int']['input'];
  convertionRate: Scalars['Float']['input'];
  convertionRateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  relationType: Scalars['String']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID?: InputMaybe<Scalars['UUID']['input']>;
  uomName: Scalars['String']['input'];
};

export type UomPaged = {
  __typename?: 'UomPaged';
  items: Array<Uom>;
  pagination: PaginationResult;
};

export type UomQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  relationType?: InputMaybe<Scalars['String']['input']>;
  uomCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  uomName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type UomQopInput = {
  filters?: InputMaybe<UomQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UomUpdateInput = {
  convertionDecimal: Scalars['Int']['input'];
  convertionRate: Scalars['Float']['input'];
  convertionRateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  isMain: Scalars['Boolean']['input'];
  relationType: Scalars['String']['input'];
  uomCategoryID: Scalars['UUID']['input'];
  uomID: Scalars['UUID']['input'];
  uomName: Scalars['String']['input'];
  version: Scalars['UUID']['input'];
};

export type UpdateErpProductInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  canBePurchased?: InputMaybe<Scalars['Boolean']['input']>;
  canBeSold?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  productCategoryID?: InputMaybe<Scalars['Int']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchaseTaxID?: InputMaybe<Scalars['Int']['input']>;
  purchaseUomID?: InputMaybe<Scalars['Int']['input']>;
  salesTaxID?: InputMaybe<Scalars['Int']['input']>;
  salesUomID?: InputMaybe<Scalars['Int']['input']>;
  sellingPrice?: InputMaybe<Scalars['Float']['input']>;
  trackExpiredDate?: InputMaybe<Scalars['Boolean']['input']>;
  trackStock?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UploadTemplate = {
  __typename?: 'UploadTemplate';
  columnMapping: Array<UploadTemplateColumnMapping>;
  delimiter?: Maybe<Scalars['String']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  headerRow?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  referenceIDs: Array<Scalars['UUID']['output']>;
  uniqueKey: Scalars['String']['output'];
  uploadTemplateID: Scalars['UUID']['output'];
  uploadTemplateKey: Scalars['String']['output'];
  uploadTemplateName: Scalars['String']['output'];
  uploadTemplateType: Scalars['String']['output'];
};

export type UploadTemplateColumnMapping = {
  __typename?: 'UploadTemplateColumnMapping';
  contains?: Maybe<Array<Scalars['String']['output']>>;
  format?: Maybe<Scalars['String']['output']>;
  gt?: Maybe<Scalars['Float']['output']>;
  gte?: Maybe<Scalars['Float']['output']>;
  notContains?: Maybe<Array<Scalars['String']['output']>>;
  sourceColumn: Scalars['String']['output'];
  standardKey: Scalars['String']['output'];
  transform?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UploadTemplateColumnMappingInput = {
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
  transform?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UploadTemplateCreateInput = {
  columnMapping: Array<UploadTemplateColumnMappingInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  referenceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uploadTemplateKey: Scalars['String']['input'];
  uploadTemplateName: Scalars['String']['input'];
  uploadTemplateType: Scalars['String']['input'];
};

export type UploadTemplatePaged = {
  __typename?: 'UploadTemplatePaged';
  items?: Maybe<Array<UploadTemplate>>;
  pagination: PaginationResult;
};

export type UploadTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  uploadTemplateKey?: InputMaybe<Scalars['String']['input']>;
  uploadTemplateName?: InputMaybe<Scalars['String']['input']>;
  uploadTemplateType?: InputMaybe<Scalars['String']['input']>;
};

export type UploadTemplateQopInput = {
  filters?: InputMaybe<UploadTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UploadTemplateUpdateInput = {
  columnMapping: Array<UploadTemplateColumnMappingInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  referenceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uploadTemplateID: Scalars['UUID']['input'];
  uploadTemplateKey: Scalars['String']['input'];
  uploadTemplateName: Scalars['String']['input'];
  uploadTemplateType: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  employeeID?: Maybe<Scalars['Int64']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAllBranches?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  pinPlainText?: Maybe<Scalars['String']['output']>;
  userBranches: Array<UserBranch>;
  userID: Scalars['UUID']['output'];
  userRoles: Array<UserRole>;
  userType: Scalars['String']['output'];
  vendorID?: Maybe<Scalars['String']['output']>;
};

export type UserBranch = {
  __typename?: 'UserBranch';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  userID: Scalars['UUID']['output'];
};

export type UserCreateInput = {
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  email: Scalars['String']['input'];
  employeeID?: InputMaybe<Scalars['Int64']['input']>;
  firstName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  roleIDs: Array<InputMaybe<Scalars['UUID']['input']>>;
  userType: Scalars['String']['input'];
  vendorID?: InputMaybe<Scalars['String']['input']>;
};

export type UserDetail = {
  __typename?: 'UserDetail';
  email: Scalars['String']['output'];
  employeeID?: Maybe<Scalars['Int64']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAllBranches?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  userBranches: Array<UserBranch>;
  userID: Scalars['UUID']['output'];
  userRoles: Array<UserRole>;
  userType: Scalars['String']['output'];
  vendorID?: Maybe<Scalars['String']['output']>;
};

export type UserLiteFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  roleID?: InputMaybe<Scalars['UUID']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type UserLiteItem = {
  __typename?: 'UserLiteItem';
  fullName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  userID: Scalars['UUID']['output'];
  userType: Scalars['String']['output'];
};

export type UserLitePaged = {
  __typename?: 'UserLitePaged';
  items?: Maybe<Array<UserLiteItem>>;
  pagination: PaginationResult;
};

export type UserLiteQopInput = {
  filters?: InputMaybe<UserLiteFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UserPaged = {
  __typename?: 'UserPaged';
  items?: Maybe<Array<User>>;
  pagination: PaginationResult;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  branches?: Maybe<Array<BranchProfile>>;
  defaultBranchCode?: Maybe<Scalars['String']['output']>;
  defaultBranchID?: Maybe<Scalars['UUID']['output']>;
  defaultBranchName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employeeID?: Maybe<Scalars['Int64']['output']>;
  fullName: Scalars['String']['output'];
  isAllBranches?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber: Scalars['String']['output'];
  pinPlainText?: Maybe<Scalars['String']['output']>;
  userID: Scalars['String']['output'];
  vendorID?: Maybe<Scalars['String']['output']>;
};

export type UserQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roleID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type UserQopInput = {
  filters?: InputMaybe<UserQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type UserRole = {
  __typename?: 'UserRole';
  role: Roles;
  roleID: Scalars['UUID']['output'];
  userID: Scalars['UUID']['output'];
};

export type UserToken = {
  __typename?: 'UserToken';
  email: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiredAt: Scalars['Time']['output'];
  isActive: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  tokenCode: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
  user?: Maybe<User>;
  userID: Scalars['UUID']['output'];
};

export type UserUpdateInput = {
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  employeeID?: InputMaybe<Scalars['Int64']['input']>;
  firstName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isAllBranches: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  roleIDs: Array<InputMaybe<Scalars['UUID']['input']>>;
  userID: Scalars['UUID']['input'];
  vendorID?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateBeforeIcFinishConfirmInput = {
  inventoryCountTransactionID: Scalars['UUID']['input'];
  version: Scalars['UUID']['input'];
};

export type ValidateBeforeIcFinishRow = {
  __typename?: 'ValidateBeforeICFinishRow';
  counted: Scalars['Float']['output'];
  diff: Scalars['Float']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  systemFrozen: Scalars['Float']['output'];
  systemLive: Scalars['Float']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
};

export type ValidateSupervisorPinInput = {
  branchID: Scalars['UUID']['input'];
  pin: Scalars['String']['input'];
  userID: Scalars['UUID']['input'];
};

export type Vendor = {
  __typename?: 'Vendor';
  addressLabel: Scalars['String']['output'];
  bankAccountName?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankID?: Maybe<Scalars['UUID']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  canBeReturned?: Maybe<Scalars['Boolean']['output']>;
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  consignmentCommisionFeePerc?: Maybe<Scalars['Float']['output']>;
  consignmentPeriodEndDate?: Maybe<Scalars['Time']['output']>;
  consignmentPeriodStartDate?: Maybe<Scalars['Time']['output']>;
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  fullAddress: Scalars['String']['output'];
  hasPortalAccess?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isConsignment?: Maybe<Scalars['Boolean']['output']>;
  isPKP: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['Time']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  npwp: Scalars['String']['output'];
  npwpCompanyName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  portalAccountActivated?: Maybe<Scalars['Boolean']['output']>;
  portalSuperadminEmail?: Maybe<Scalars['String']['output']>;
  portalSuperadminFirstName?: Maybe<Scalars['String']['output']>;
  portalSuperadminLastName?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  taxIncluded?: Maybe<Scalars['Boolean']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  taxpayerIDNumber: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorCategory: VendorCategory;
  vendorCategoryID: Scalars['UUID']['output'];
  vendorCode: Scalars['String']['output'];
  vendorConsignmentBranch: Array<VendorConsignmentBranch>;
  vendorConsignmentProducts: Array<VendorConsignmentProduct>;
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
  vendorPicContacts: Array<VendorPicContact>;
};

export type VendorCategory = {
  __typename?: 'VendorCategory';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorCategoryID: Scalars['UUID']['output'];
  vendorCategoryName: Scalars['String']['output'];
};

export type VendorCategoryCreateInput = {
  isActive: Scalars['Boolean']['input'];
  vendorCategoryName: Scalars['String']['input'];
};

export type VendorCategoryPaged = {
  __typename?: 'VendorCategoryPaged';
  items?: Maybe<Array<VendorCategory>>;
  pagination: PaginationResult;
};

export type VendorCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorCategoryName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorCategoryQopInput = {
  filters?: InputMaybe<VendorCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorCategoryUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  vendorCategoryID: Scalars['UUID']['input'];
  vendorCategoryName: Scalars['String']['input'];
};

export type VendorConsignmentBranch = {
  __typename?: 'VendorConsignmentBranch';
  branchCode: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  commissionFeePerc: Scalars['Float']['output'];
  currentPeriod?: Maybe<VendorConsignmentBranchPeriod>;
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isRent: Scalars['Boolean']['output'];
  rentPrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorConsignmentBranchID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
};

export type VendorConsignmentBranchBulkDeleteFailure = {
  __typename?: 'VendorConsignmentBranchBulkDeleteFailure';
  reason: Scalars['String']['output'];
  vendorConsignmentBranchID: Scalars['UUID']['output'];
};

export type VendorConsignmentBranchBulkDeleteResult = {
  __typename?: 'VendorConsignmentBranchBulkDeleteResult';
  deletedCount: Scalars['Int']['output'];
  deletedIDs: Array<Scalars['UUID']['output']>;
  failures: Array<VendorConsignmentBranchBulkDeleteFailure>;
};

export type VendorConsignmentBranchCreateInput = {
  branchID: Scalars['UUID']['input'];
  commissionFeePerc: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  isRent: Scalars['Boolean']['input'];
  rentPrice?: InputMaybe<Scalars['Float']['input']>;
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchInput = {
  branchID: Scalars['UUID']['input'];
  commissionFeePerc: Scalars['Float']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRent?: InputMaybe<Scalars['Boolean']['input']>;
  rentPrice?: InputMaybe<Scalars['Float']['input']>;
  vendorConsignmentBranchID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentBranchPaged = {
  __typename?: 'VendorConsignmentBranchPaged';
  items?: Maybe<Array<VendorConsignmentBranch>>;
  pagination: PaginationResult;
};

export type VendorConsignmentBranchPeriod = {
  __typename?: 'VendorConsignmentBranchPeriod';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  daysGrantedTotal: Scalars['Int']['output'];
  effectiveEndDate?: Maybe<Scalars['Time']['output']>;
  effectiveStartDate?: Maybe<Scalars['Time']['output']>;
  entityAuditMetadata: EntityAuditMetadata;
  lastGrantSource: Scalars['String']['output'];
  lastGrantSourcePaymentID?: Maybe<Scalars['UUID']['output']>;
  lastGrantSourcePaymentNumber: Scalars['String']['output'];
  lastGrantedAt?: Maybe<Scalars['Time']['output']>;
  lastGrantedByUserID?: Maybe<Scalars['UUID']['output']>;
  lastGrantedByUserName: Scalars['String']['output'];
  rentalStatus: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['Time']['output']>;
  revokedByUserID?: Maybe<Scalars['UUID']['output']>;
  revokedByUserName: Scalars['String']['output'];
  revokedReason: Scalars['String']['output'];
  suspendedAt?: Maybe<Scalars['Time']['output']>;
  suspendedByUserID?: Maybe<Scalars['UUID']['output']>;
  suspendedByUserName: Scalars['String']['output'];
  suspendedReason: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  vendor: Vendor;
  vendorConsignmentBranchID: Scalars['UUID']['output'];
  vendorConsignmentBranchPeriodID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
};

export type VendorConsignmentBranchPeriodGrantInput = {
  branchID: Scalars['UUID']['input'];
  daysGrantedTotal?: InputMaybe<Scalars['Int']['input']>;
  effectiveEndDate: Scalars['Time']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  sourcePaymentID?: InputMaybe<Scalars['UUID']['input']>;
  sourcePaymentNumber?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentBranchID: Scalars['UUID']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchPeriodPaged = {
  __typename?: 'VendorConsignmentBranchPeriodPaged';
  items?: Maybe<Array<VendorConsignmentBranchPeriod>>;
  pagination: PaginationResult;
};

export type VendorConsignmentBranchPeriodQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  effectiveEndDateTo?: InputMaybe<Scalars['Time']['input']>;
  effectiveStartDateFrom?: InputMaybe<Scalars['Time']['input']>;
  rentalStatus?: InputMaybe<Scalars['String']['input']>;
  vendorConsignmentBranchID?: InputMaybe<Scalars['UUID']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentBranchPeriodQopInput = {
  filters?: InputMaybe<VendorConsignmentBranchPeriodQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentBranchPeriodResumeInput = {
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchPeriodRevokeInput = {
  reason: Scalars['String']['input'];
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchPeriodSuspendInput = {
  reason: Scalars['String']['input'];
  vendorConsignmentBranchID: Scalars['UUID']['input'];
};

export type VendorConsignmentBranchQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  uniqueKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentBranchQopInput = {
  filters?: InputMaybe<VendorConsignmentBranchQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentBranchUpdateInput = {
  branchID: Scalars['UUID']['input'];
  commissionFeePerc: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  isRent: Scalars['Boolean']['input'];
  rentPrice?: InputMaybe<Scalars['Float']['input']>;
  vendorConsignmentBranchID: Scalars['UUID']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentDashboard = {
  __typename?: 'VendorConsignmentDashboard';
  salesByBranch: Array<VendorConsignmentDashboardBranchPoint>;
  summary: VendorConsignmentDashboardSummary;
  topProducts: Array<VendorConsignmentDashboardProductPoint>;
  topProductsByRevenue: Array<VendorConsignmentDashboardProductPoint>;
};

export type VendorConsignmentDashboardBranchPoint = {
  __typename?: 'VendorConsignmentDashboardBranchPoint';
  branchID: Scalars['UUID']['output'];
  grossSales: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type VendorConsignmentDashboardFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentDashboardProductPoint = {
  __typename?: 'VendorConsignmentDashboardProductPoint';
  grossSales: Scalars['Float']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qty: Scalars['Float']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type VendorConsignmentDashboardSummary = {
  __typename?: 'VendorConsignmentDashboardSummary';
  commissionAmount: Scalars['Float']['output'];
  /** Gross commission (commissionAmount + tax). commissionAmount stays net; this is the display value for the Total Komisi KPI. */
  commissionInclTaxAmount: Scalars['Float']['output'];
  grossSales: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  unitsSold: Scalars['Float']['output'];
  vendorShareAmount: Scalars['Float']['output'];
};

export type VendorConsignmentImportItem = {
  __typename?: 'VendorConsignmentImportItem';
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
};

export type VendorConsignmentImportItemPaged = {
  __typename?: 'VendorConsignmentImportItemPaged';
  items?: Maybe<Array<VendorConsignmentImportItem>>;
  pagination: PaginationResult;
};

export type VendorConsignmentInvoice = {
  __typename?: 'VendorConsignmentInvoice';
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  cancelledByUserID?: Maybe<Scalars['UUID']['output']>;
  cancelledByUserName: Scalars['String']['output'];
  cancelledReason: Scalars['String']['output'];
  chargeAmount: Scalars['Float']['output'];
  commissionAmount: Scalars['Float']['output'];
  cutoffDate: Scalars['Time']['output'];
  cutoffDay: Scalars['Int']['output'];
  discountAmount: Scalars['Float']['output'];
  emailSentAt?: Maybe<Scalars['Time']['output']>;
  emailStatus: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  gmt: Scalars['Int']['output'];
  isManual: Scalars['Boolean']['output'];
  manualAt?: Maybe<Scalars['Time']['output']>;
  manualByUserName: Scalars['String']['output'];
  manualReason: Scalars['String']['output'];
  noteInternal: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['Time']['output']>;
  paidByUserID?: Maybe<Scalars['UUID']['output']>;
  paidByUserName: Scalars['String']['output'];
  paidReference: Scalars['String']['output'];
  paymentDueDate?: Maybe<Scalars['Time']['output']>;
  payoutBankAccountNumber: Scalars['String']['output'];
  payoutBankID?: Maybe<Scalars['UUID']['output']>;
  payoutBankName: Scalars['String']['output'];
  periodEndDate: Scalars['Time']['output'];
  periodStartDate: Scalars['Time']['output'];
  returnsAdjustmentAmount: Scalars['Float']['output'];
  settlementBankAccountID?: Maybe<Scalars['UUID']['output']>;
  settlementBankAccountName: Scalars['String']['output'];
  settlementBankAccountNumber: Scalars['String']['output'];
  settlementBankName: Scalars['String']['output'];
  sourceInvoiceCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  totalItemQty: Scalars['Float']['output'];
  totalPayableAmount: Scalars['Float']['output'];
  transferFeeAmount: Scalars['Float']['output'];
  vendor?: Maybe<Vendor>;
  vendorConsignmentInvoiceDatetime: Scalars['Time']['output'];
  vendorConsignmentInvoiceDatetimeUtc: Scalars['Time']['output'];
  vendorConsignmentInvoiceID: Scalars['UUID']['output'];
  vendorConsignmentInvoiceNumber: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
  vendorPayoutBeforeTax: Scalars['Float']['output'];
  vendorPayoutTotal: Scalars['Float']['output'];
};

export type VendorConsignmentInvoiceCancelInput = {
  cancelledReason: Scalars['String']['input'];
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type VendorConsignmentInvoiceConfig = {
  __typename?: 'VendorConsignmentInvoiceConfig';
  /** Day/week/month: units per period (month x 2 = every two months). month_segment: periods per month, at least 2 (2 x cutoff 15 = 1..15, 16..end of month). */
  billCycleInterval: Scalars['Int']['output'];
  /** Anchor of the first day/week/month period when the vendor has no settlement yet; month_segment follows the calendar. */
  billCycleStartDate?: Maybe<Scalars['Time']['output']>;
  /** Cycle unit: month_segment (each month cut every cutoffDay days; the last period runs to month-end), day, week or month. */
  billCycleType: Scalars['String']['output'];
  cutoffDay: Scalars['Int']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  graceDays: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  paymentDueDays: Scalars['Int']['output'];
  vendorConsignmentInvoiceConfigID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
};

export type VendorConsignmentInvoiceConfigCreateInput = {
  billCycleInterval?: InputMaybe<Scalars['Int']['input']>;
  billCycleStartDate?: InputMaybe<Scalars['Time']['input']>;
  billCycleType?: InputMaybe<Scalars['String']['input']>;
  cutoffDay: Scalars['Int']['input'];
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDueDays?: InputMaybe<Scalars['Int']['input']>;
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentInvoiceConfigFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentInvoiceConfigImportColumnInput = {
  sourceColumn: Scalars['String']['input'];
  standardKey: Scalars['String']['input'];
};

export type VendorConsignmentInvoiceConfigImportFileMappingInput = {
  columns: Array<VendorConsignmentInvoiceConfigImportColumnInput>;
  delimiter?: InputMaybe<Scalars['String']['input']>;
  headerRow?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorConsignmentInvoiceConfigImportInput = {
  fileID: Scalars['UUID']['input'];
  fileMapping: VendorConsignmentInvoiceConfigImportFileMappingInput;
};

export type VendorConsignmentInvoiceConfigImportIssue = {
  __typename?: 'VendorConsignmentInvoiceConfigImportIssue';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VendorConsignmentInvoiceConfigImportResult = {
  __typename?: 'VendorConsignmentInvoiceConfigImportResult';
  createdCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type VendorConsignmentInvoiceConfigImportRowReport = {
  __typename?: 'VendorConsignmentInvoiceConfigImportRowReport';
  createRowCount: Scalars['Int']['output'];
  invalidRowCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  updateRowCount: Scalars['Int']['output'];
  validRowCount: Scalars['Int']['output'];
  violationSample: Array<VendorConsignmentInvoiceConfigImportIssue>;
  warningRowCount: Scalars['Int']['output'];
  warningSample: Array<VendorConsignmentInvoiceConfigImportIssue>;
};

export type VendorConsignmentInvoiceConfigImportValidateResult = {
  __typename?: 'VendorConsignmentInvoiceConfigImportValidateResult';
  missingVendorCodes: Array<Scalars['String']['output']>;
  rowReport: VendorConsignmentInvoiceConfigImportRowReport;
  status: Scalars['String']['output'];
};

export type VendorConsignmentInvoiceConfigPaged = {
  __typename?: 'VendorConsignmentInvoiceConfigPaged';
  items?: Maybe<Array<VendorConsignmentInvoiceConfig>>;
  pagination: PaginationResult;
};

export type VendorConsignmentInvoiceConfigQopInput = {
  filters?: InputMaybe<VendorConsignmentInvoiceConfigFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentInvoiceConfigUpdateInput = {
  billCycleInterval?: InputMaybe<Scalars['Int']['input']>;
  billCycleStartDate?: InputMaybe<Scalars['Time']['input']>;
  billCycleType?: InputMaybe<Scalars['String']['input']>;
  cutoffDay: Scalars['Int']['input'];
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDueDays?: InputMaybe<Scalars['Int']['input']>;
  vendorConsignmentInvoiceConfigID: Scalars['UUID']['input'];
};

export type VendorConsignmentInvoiceFilterInput = {
  cutoffDate?: InputMaybe<Scalars['Time']['input']>;
  cutoffDateFrom?: InputMaybe<Scalars['Time']['input']>;
  cutoffDateTo?: InputMaybe<Scalars['Time']['input']>;
  periodEndDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentInvoicePaged = {
  __typename?: 'VendorConsignmentInvoicePaged';
  items?: Maybe<Array<VendorConsignmentInvoice>>;
  pagination: PaginationResult;
};

export type VendorConsignmentInvoicePayInput = {
  paidReference?: InputMaybe<Scalars['String']['input']>;
  settlementBankAccountID: Scalars['UUID']['input'];
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
};

export type VendorConsignmentInvoiceQopInput = {
  filters?: InputMaybe<VendorConsignmentInvoiceFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentInvoiceSummary = {
  __typename?: 'VendorConsignmentInvoiceSummary';
  count: Scalars['Int']['output'];
  draftCount: Scalars['Int']['output'];
  emailableCount: Scalars['Int']['output'];
  proformaCount: Scalars['Int']['output'];
  totalCommissionAmount: Scalars['Float']['output'];
  totalSubtotal: Scalars['Float']['output'];
  totalTaxAmount: Scalars['Float']['output'];
  totalVendorPayoutTotal: Scalars['Float']['output'];
};

export type VendorConsignmentPaymentChargeConfig = {
  __typename?: 'VendorConsignmentPaymentChargeConfig';
  chargePerc: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  paymentMethodName: Scalars['String']['output'];
  paymentMethodTypeCode: Scalars['String']['output'];
  vendorConsignmentPaymentChargeConfigID: Scalars['UUID']['output'];
};

export type VendorConsignmentPaymentChargeConfigFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodTypeCode?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentPaymentChargeConfigPaged = {
  __typename?: 'VendorConsignmentPaymentChargeConfigPaged';
  items?: Maybe<Array<VendorConsignmentPaymentChargeConfig>>;
  pagination: PaginationResult;
};

export type VendorConsignmentPaymentChargeConfigQopInput = {
  filters?: InputMaybe<VendorConsignmentPaymentChargeConfigFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentProduct = {
  __typename?: 'VendorConsignmentProduct';
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  commissionFeePerc: Scalars['Float']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  product: Product;
  productCommissionFeePerc: Scalars['Float']['output'];
  productID: Scalars['UUID']['output'];
  sellingPrice: Scalars['Float']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorConsignmentProductID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
};

export type VendorConsignmentProductAggregated = {
  __typename?: 'VendorConsignmentProductAggregated';
  branchPrices: Array<VendorConsignmentProduct>;
  product: Product;
  productID: Scalars['UUID']['output'];
  vendorID: Scalars['UUID']['output'];
};

export type VendorConsignmentProductAggregatedPaged = {
  __typename?: 'VendorConsignmentProductAggregatedPaged';
  items?: Maybe<Array<VendorConsignmentProductAggregated>>;
  pagination: PaginationResult;
};

export type VendorConsignmentProductBranchPriceInput = {
  isActive: Scalars['Boolean']['input'];
  productCommissionFeePerc: Scalars['Float']['input'];
  sellingPrice: Scalars['Float']['input'];
  vendorConsignmentProductID: Scalars['UUID']['input'];
  vendorConsignmentProductVersion: Scalars['UUID']['input'];
};

export type VendorConsignmentProductBulkUpdateResult = {
  __typename?: 'VendorConsignmentProductBulkUpdateResult';
  product: Product;
  updatedBranchPrices: Array<VendorConsignmentProduct>;
};

export type VendorConsignmentProductCreateInput = {
  branchID: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
  productCommissionFeePerc: Scalars['Float']['input'];
  productID: Scalars['UUID']['input'];
  sellingPrice: Scalars['Float']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorConsignmentProductPaged = {
  __typename?: 'VendorConsignmentProductPaged';
  items?: Maybe<Array<VendorConsignmentProduct>>;
  pagination: PaginationResult;
};

export type VendorConsignmentProductPriceBulkUpdateInput = {
  branchPrices: Array<VendorConsignmentProductBranchPriceInput>;
  isActive: Scalars['Boolean']['input'];
  masterSellingPrice: Scalars['Float']['input'];
  productID: Scalars['UUID']['input'];
  productVersion: Scalars['UUID']['input'];
};

export type VendorConsignmentProductPriceInput = {
  branchID: Scalars['UUID']['input'];
  commissionFeePerc?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sellingPrice: Scalars['Float']['input'];
  vendorConsignmentProductVersion?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentProductQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  searchKeyFull?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorConsignmentProductQopInput = {
  filters?: InputMaybe<VendorConsignmentProductQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentProductUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  productCommissionFeePerc: Scalars['Float']['input'];
  sellingPrice: Scalars['Float']['input'];
  vendorConsignmentProductID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPayment = {
  __typename?: 'VendorConsignmentRentalPayment';
  activeFrom?: Maybe<Scalars['Time']['output']>;
  activeUntil?: Maybe<Scalars['Time']['output']>;
  approvedAt?: Maybe<Scalars['Time']['output']>;
  approvedByUserID?: Maybe<Scalars['UUID']['output']>;
  approvedByUserName: Scalars['String']['output'];
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  daysGranted: Scalars['Int']['output'];
  effectiveEndDate: Scalars['Time']['output'];
  effectiveStartDate: Scalars['Time']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  files?: Maybe<Array<VendorConsignmentRentalPaymentFile>>;
  rejectedAt?: Maybe<Scalars['Time']['output']>;
  rejectedByUserID?: Maybe<Scalars['UUID']['output']>;
  rejectedByUserName: Scalars['String']['output'];
  rejectedReason: Scalars['String']['output'];
  rentPeriodDaysSnapshot: Scalars['Int']['output'];
  rentPriceSnapshot: Scalars['Float']['output'];
  settlementBankAccountID?: Maybe<Scalars['UUID']['output']>;
  settlementBankAccountNumber: Scalars['String']['output'];
  settlementBankName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transferAmount: Scalars['Float']['output'];
  transferDate: Scalars['Time']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorConsignmentBranchID: Scalars['UUID']['output'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['output'];
  vendorConsignmentRentalPaymentNumber: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorName: Scalars['String']['output'];
  vendorNote: Scalars['String']['output'];
};

export type VendorConsignmentRentalPaymentApproveInput = {
  bankAccountID: Scalars['UUID']['input'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPaymentCancelInput = {
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPaymentCreateInput = {
  branchID: Scalars['UUID']['input'];
  branchName: Scalars['String']['input'];
  effectiveStartDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<VendorConsignmentRentalPaymentFileInput>>;
  rentPeriodDaysSnapshot?: InputMaybe<Scalars['Int']['input']>;
  rentPriceSnapshot: Scalars['Float']['input'];
  transferAmount: Scalars['Float']['input'];
  transferDate: Scalars['Time']['input'];
  vendorConsignmentBranchID: Scalars['UUID']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorName: Scalars['String']['input'];
  vendorNote?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentRentalPaymentFile = {
  __typename?: 'VendorConsignmentRentalPaymentFile';
  entityAuditMetadata: EntityAuditMetadata;
  fileID: Scalars['UUID']['output'];
  imageFileLargePathURL: Scalars['String']['output'];
  imageFileMediumPathURL: Scalars['String']['output'];
  imageFileSmallPathURL: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorConsignmentRentalPaymentFileID: Scalars['UUID']['output'];
  vendorConsignmentRentalPaymentFileType: Scalars['String']['output'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['output'];
};

export type VendorConsignmentRentalPaymentFileInput = {
  fileID: Scalars['UUID']['input'];
  fileType?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentRentalPaymentFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transferDateFrom?: InputMaybe<Scalars['Time']['input']>;
  transferDateTo?: InputMaybe<Scalars['Time']['input']>;
  vendorConsignmentBranchID?: InputMaybe<Scalars['UUID']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentRentalPaymentPaged = {
  __typename?: 'VendorConsignmentRentalPaymentPaged';
  items?: Maybe<Array<VendorConsignmentRentalPayment>>;
  pagination: PaginationResult;
};

export type VendorConsignmentRentalPaymentQopInput = {
  filters?: InputMaybe<VendorConsignmentRentalPaymentFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorConsignmentRentalPaymentRejectInput = {
  rejectedReason: Scalars['String']['input'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPaymentSubmitInput = {
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
};

export type VendorConsignmentRentalPaymentUpdateInput = {
  effectiveStartDate: Scalars['Time']['input'];
  files?: InputMaybe<Array<VendorConsignmentRentalPaymentFileInput>>;
  rentPeriodDaysSnapshot?: InputMaybe<Scalars['Int']['input']>;
  rentPriceSnapshot: Scalars['Float']['input'];
  transferAmount: Scalars['Float']['input'];
  transferDate: Scalars['Time']['input'];
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
  vendorNote?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentSalesExportFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Optional period. A branch wall clock stamped Z — see the contract in repository/consignment_period_filter.go. */
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  salesConsignmentInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type VendorConsignmentSalesExportResult = {
  __typename?: 'VendorConsignmentSalesExportResult';
  /** Short-lived signed URL to download the generated .xlsx from object storage. */
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type VendorConsignmentStockByBranchFilterInput = {
  /** Optional — omit to aggregate across all of the vendor's cabang (Semua Cabang). */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Optional warehouse type to restrict to: "storage" (sellable/main) or "transit".
   *   Omit to aggregate across both, netted per cabang/product.
   */
  warehouseType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One row of a vendor's consignment stock aggregated per cabang (branch). Only the
 * branch's sellable (storage) warehouse is counted — transit warehouses are excluded —
 * so a product's main on-hand shows once per cabang instead of as separate +/- rows.
 */
export type VendorConsignmentStockByBranchItem = {
  __typename?: 'VendorConsignmentStockByBranchItem';
  branchID: Scalars['UUID']['output'];
  branchName: Scalars['String']['output'];
  product?: Maybe<Product>;
  productID: Scalars['UUID']['output'];
  qty: Scalars['Decimal']['output'];
  qtyAvailable: Scalars['Decimal']['output'];
  qtyCommitted: Scalars['Decimal']['output'];
  qtyOnHand: Scalars['Decimal']['output'];
  qtyRejected: Scalars['Decimal']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type VendorConsignmentStockByBranchPaged = {
  __typename?: 'VendorConsignmentStockByBranchPaged';
  items?: Maybe<Array<VendorConsignmentStockByBranchItem>>;
  pagination: PaginationResult;
};

export type VendorConsignmentStockByBranchQopInput = {
  filter: VendorConsignmentStockByBranchFilterInput;
  pagination?: InputMaybe<Pagination>;
};

export type VendorCreateAccessInput = {
  portalSuperadminEmail: Scalars['String']['input'];
  portalSuperadminFirstName: Scalars['String']['input'];
  portalSuperadminLastName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorCreateInput = {
  addressLabel: Scalars['String']['input'];
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  canBeReturned?: InputMaybe<Scalars['Boolean']['input']>;
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  consignmentCommisionFeePerc?: InputMaybe<Scalars['Float']['input']>;
  consignmentPeriodEndDate?: InputMaybe<Scalars['Time']['input']>;
  consignmentPeriodStartDate?: InputMaybe<Scalars['Time']['input']>;
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullAddress: Scalars['String']['input'];
  hasPortalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isPKP?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  npwp: Scalars['String']['input'];
  npwpCompanyName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  portalAccountActivated?: InputMaybe<Scalars['Boolean']['input']>;
  portalSuperadminEmail?: InputMaybe<Scalars['String']['input']>;
  portalSuperadminFirstName?: InputMaybe<Scalars['String']['input']>;
  portalSuperadminLastName?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
  taxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  taxpayerIDNumber: Scalars['String']['input'];
  vendorCategoryID: Scalars['UUID']['input'];
  vendorCode: Scalars['String']['input'];
  vendorConsignmentBranches?: InputMaybe<Array<VendorConsignmentBranchInput>>;
  vendorName: Scalars['String']['input'];
  vendorPicContacts?: InputMaybe<Array<VendorPicContactCreateFromVendorInput>>;
};

export type VendorDeleteInput = {
  vendorID: Scalars['UUID']['input'];
};

/** Who ran the opname. There is no verifier stage in this system, so none is reported. */
export type VendorInventoryCountExecution = {
  __typename?: 'VendorInventoryCountExecution';
  /** Federated branch of the opname. The report header shows its name as Cabang. */
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  gmt: Scalars['Int']['output'];
  inventoryCountTransactionDatetimeUtc: Scalars['Time']['output'];
  inventoryCountTransactionNumber: Scalars['String']['output'];
  note: Scalars['String']['output'];
  /** Every assignee who counted, in assignment order. Recounts add more than one. */
  officers: Array<Scalars['String']['output']>;
  /** partial | full_count */
  taskType: Scalars['String']['output'];
  /** The warehouse the opname ran in. Needed by inventory's vendorStockReconciliation; a branch has both storage and transit warehouses, so it cannot be derived from branchID. */
  warehouseID: Scalars['UUID']['output'];
};

export type VendorInventoryCountExportResult = {
  __typename?: 'VendorInventoryCountExportResult';
  /** Short-lived signed URL to download the generated .xlsx from object storage. */
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type VendorInventoryCountItem = {
  __typename?: 'VendorInventoryCountItem';
  barcode: Scalars['String']['output'];
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  /** Canonical UTC instant of the opname. Render as branch local time by adding gmt. */
  countedAtUtc: Scalars['Time']['output'];
  gmt: Scalars['Int']['output'];
  /** The opname this row came from. In period mode the same SKU appears once per opname, so these identify the row. */
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionNumber: Scalars['String']['output'];
  inventoryCountTransactionResultItemID: Scalars['UUID']['output'];
  /**
   * What backoffice wrote on this product's line of the stock adjustment while
   *   reviewing it. autoConfirmFromInventoryCount is false in staging and production,
   *   so every count-generated adjustment waits as a draft until someone fills it in
   *   and confirms — that review is where the explanation comes from.
   *
   *   Empty for a matched product: a zero-diff item never gets an adjustment line, and
   *   needs no explanation. Also empty when the reviewer left it blank. Never null.
   */
  note: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  qtyCounted: Scalars['Float']['output'];
  qtyDiff: Scalars['Float']['output'];
  qtySystem: Scalars['Float']['output'];
  /**
   * The adjustment reason picked for this product's line. Starts as the system
   *   inventory-count reason and becomes meaningful only if the reviewer changed it.
   *   Empty for a matched product. Never null.
   */
  reasonName: Scalars['String']['output'];
  /** sesuai | kurang | lebih, derived from the sign of qtyDiff. */
  result: Scalars['String']['output'];
  /** Harga per base UOM at the time of the count. For consignment products this is the vendor selling price less the branch commission, so it is already vendor money. */
  unitCost: Scalars['Float']['output'];
  uomName: Scalars['String']['output'];
  /** qty_diff x unitCost, already net of branch commission for consignment products. */
  varianceValue: Scalars['Float']['output'];
  /** The warehouse the opname ran in — what inventory's vendorStockReconciliation needs for this row. */
  warehouseID: Scalars['UUID']['output'];
};

export type VendorInventoryCountItemPaged = {
  __typename?: 'VendorInventoryCountItemPaged';
  items?: Maybe<Array<VendorInventoryCountItem>>;
  pagination: PaginationResult;
};

/**
 * Picker filter: which finished stock opnames to offer the vendor. The period only
 * narrows the picker; the opname the vendor picks decides the branch of the report.
 */
export type VendorInventoryCountListFilterInput = {
  /** Optional — omit to list opnames across all of the vendor's cabang (Semua Cabang). */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Optional period. A branch wall clock stamped Z — see the contract in repository/vendor_inventory_count_period_filter.go. */
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

/** One finished opname that touched at least one of the vendor's products. */
export type VendorInventoryCountListItem = {
  __typename?: 'VendorInventoryCountListItem';
  /** Federated branch, so the picker can label the row with a cabang name instead of a UUID. */
  branch: Branch;
  branchID: Scalars['UUID']['output'];
  gmt: Scalars['Int']['output'];
  /** Canonical UTC instant. Render as branch local time by adding gmt. */
  inventoryCountTransactionDatetimeUtc: Scalars['Time']['output'];
  inventoryCountTransactionID: Scalars['UUID']['output'];
  inventoryCountTransactionNumber: Scalars['String']['output'];
  /** How many of the vendor's products this opname covered. */
  productCount: Scalars['Int']['output'];
  /** partial | full_count — the scope of the opname, shown as Cakupan. */
  taskType: Scalars['String']['output'];
};

export type VendorInventoryCountReport = {
  __typename?: 'VendorInventoryCountReport';
  /** Null in period mode: the block describes one count run, and a window spanning several has no single number, officer list or note. */
  execution?: Maybe<VendorInventoryCountExecution>;
  items: VendorInventoryCountItemPaged;
  summary: VendorInventoryCountSummary;
};

/**
 * Two modes, never both. Send inventoryCountTransactionID for one opname, or
 * dateStart+dateEnd for every posted opname in a window. Sending both is rejected,
 * and so is sending neither — an unbounded report would return the vendor's whole
 * history in one page.
 */
export type VendorInventoryCountReportFilterInput = {
  /** Mode periode only: narrow to one cabang. Omit for every cabang the vendor was counted in. */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  /** Mode periode, sent together with dateStart. */
  dateEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Mode periode, sent together with dateEnd. A branch wall clock stamped Z — same contract as the picker. */
  dateStart?: InputMaybe<Scalars['Time']['input']>;
  /** Mode satu opname. The execution block is only returned in this mode. */
  inventoryCountTransactionID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Narrows to one product. Sent with inventoryCountTransactionID, it returns exactly
   *   one row, so the detail page can re-read itself after a refresh or a shared link
   *   instead of depending on router state.
   */
  productID?: InputMaybe<Scalars['UUID']['input']>;
  /** all | sesuai | kurang | lebih. Omit or 'all' to keep every row. */
  result?: InputMaybe<Scalars['String']['input']>;
  /** Free text over product code, barcode and product name. */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it.
   */
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Sorting is not offered: the order is part of the report's meaning. A period report
 * groups by opname newest first, then by product, so a SKU counted several times reads
 * as a history; a single-opname report orders by product.
 */
export type VendorInventoryCountReportQopInput = {
  filter: VendorInventoryCountReportFilterInput;
  pagination?: InputMaybe<Pagination>;
};

/** Summary cards. Counts and values cover only the vendor's products inside this opname. */
export type VendorInventoryCountSummary = {
  __typename?: 'VendorInventoryCountSummary';
  matched: Scalars['Int']['output'];
  /** Signed sum of total_cost, already net of branch commission for consignment products. */
  netVarianceValue: Scalars['Float']['output'];
  /** How many opnames the report spans. Always 1 in single mode; in period mode it explains why productCounted can exceed the vendor's SKU count. */
  opnameCount: Scalars['Int']['output'];
  /** The positive half of netVarianceValue. */
  overageValue: Scalars['Float']['output'];
  /** Baris hasil hitung in scope. In period mode a SKU counted in three opnames contributes three. */
  productCounted: Scalars['Int']['output'];
  /** The negative half of netVarianceValue, so a card showing 0 can still explain itself. */
  shortageValue: Scalars['Float']['output'];
  variance: Scalars['Int']['output'];
};

export type VendorPaged = {
  __typename?: 'VendorPaged';
  items?: Maybe<Array<Vendor>>;
  pagination: PaginationResult;
};

export type VendorPicContact = {
  __typename?: 'VendorPicContact';
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  picDepartment: Scalars['String']['output'];
  picEmail: Scalars['String']['output'];
  picName: Scalars['String']['output'];
  picPhoneNumber: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  vendorID: Scalars['UUID']['output'];
  vendorPicContactID: Scalars['UUID']['output'];
};

export type VendorPicContactCreateFromVendorInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  picDepartment: Scalars['String']['input'];
  picEmail: Scalars['String']['input'];
  picName: Scalars['String']['input'];
  picPhoneNumber: Scalars['String']['input'];
};

export type VendorPicContactCreateInput = {
  isActive: Scalars['Boolean']['input'];
  picDepartment: Scalars['String']['input'];
  picEmail: Scalars['String']['input'];
  picName: Scalars['String']['input'];
  picPhoneNumber: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorPicContactPaged = {
  __typename?: 'VendorPicContactPaged';
  items?: Maybe<Array<VendorPicContact>>;
  pagination: PaginationResult;
};

export type VendorPicContactQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  picDepartment?: InputMaybe<Scalars['String']['input']>;
  picEmail?: InputMaybe<Scalars['String']['input']>;
  picName?: InputMaybe<Scalars['String']['input']>;
  picPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorPicContactQopInput = {
  filters?: InputMaybe<VendorPicContactQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorPicContactUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  picDepartment: Scalars['String']['input'];
  picEmail: Scalars['String']['input'];
  picName: Scalars['String']['input'];
  picPhoneNumber: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
  vendorPicContactID: Scalars['UUID']['input'];
};

export type VendorQopFilterInput = {
  bankCode?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasPortalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isPKP?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  portalUsername?: InputMaybe<Scalars['String']['input']>;
  provinceName?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  vendorCode?: InputMaybe<Scalars['String']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type VendorQopInput = {
  filters?: InputMaybe<VendorQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VendorSetPortalAccessActiveInput = {
  isActive: Scalars['Boolean']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorStockExportFilterInput = {
  /** Optional — omit to export the vendor's consignment stock across all cabang. The export is aggregated per cabang (storage warehouse only). */
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
};

export type VendorStockExportResult = {
  __typename?: 'VendorStockExportResult';
  /** Short-lived signed URL to download the generated .xlsx from object storage. */
  downloadURL: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

/**
 * Why a product's system stock reached the figure the opname counted against.
 * Quantities keep the ledger's sign convention: stock in positive, stock out negative,
 * so openingQty plus every line equals closingQty.
 */
export type VendorStockReconciliation = {
  __typename?: 'VendorStockReconciliation';
  /**
   * Penyesuaian stok: every inventory_adjustment — manual correction, waste, system
   *   fix or opening balance. Signed, because an opening balance adds stock. Kept apart
   *   from returnQty: an adjustment filed under "returns" reads as damaged goods that
   *   increased stock. The four subtypes are not separable here — the reason lives in
   *   the transaction service, not on the ledger.
   */
  adjustmentQty: Scalars['Decimal']['output'];
  /** openingQty plus every movement line. */
  closingQty: Scalars['Decimal']['output'];
  countedAt: Scalars['Time']['output'];
  /**
   * False when a ledger document in the window never reached status done, so the
   *   lines cannot be expected to balance. Covers movements that arrived but did not
   *   finish posting; it does not detect movements that never arrived at all.
   */
  ledgerComplete: Scalars['Boolean']['output'];
  /**
   * False when the period's first day has no daily-movement row — history only
   *   starts when the warehouse was configured, and the nightly carry-forward can skip
   *   days. Render "tidak tersedia", never a zero.
   */
  openingBalanceAvailable: Scalars['Boolean']['output'];
  /** Stok awal periode. Meaningless unless openingBalanceAvailable is true. */
  openingQty: Scalars['Decimal']['output'];
  /** Any movement type not covered above, so the lines always add up. */
  otherQty: Scalars['Decimal']['output'];
  periodStart: Scalars['Time']['output'];
  /** Retur / barang rusak — returns to the vendor or to a supplier. Always moves stock out, so this never reads positive. */
  returnQty: Scalars['Decimal']['output'];
  /** Terjual di kasir. */
  soldQty: Scalars['Decimal']['output'];
  /** Stok in diterima. */
  stockInQty: Scalars['Decimal']['output'];
  /** Stock out — transfers and deliveries out of this warehouse. */
  stockOutQty: Scalars['Decimal']['output'];
};

/**
 * Scopes the stock reconciliation behind one product on the vendor portal's stock
 * opname detail page. The window runs from periodStart to the instant of the count —
 * movements made after the physical count are not part of what it explains.
 */
export type VendorStockReconciliationFilterInput = {
  /**
   * Optional for vendor-portal callers: the authenticated vendor (X-Vendor-ID)
   *   always wins and the client should omit it. Backoffice callers, which have no
   *   vendor context, must still send it.
   */
  consignmentVendorID?: InputMaybe<Scalars['UUID']['input']>;
  /** The opname's own timestamp. Movements at or after this instant are excluded. */
  countedAt: Scalars['Time']['input'];
  /** Start of the period, typically the first day of the month the opname ran in. */
  periodStart: Scalars['Time']['input'];
  productID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type VendorUpdateAccessInput = {
  portalSuperadminEmail: Scalars['String']['input'];
  portalSuperadminFirstName: Scalars['String']['input'];
  portalSuperadminLastName: Scalars['String']['input'];
  vendorID: Scalars['UUID']['input'];
};

export type VendorUpdateInput = {
  addressLabel: Scalars['String']['input'];
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankID?: InputMaybe<Scalars['UUID']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  canBeReturned?: InputMaybe<Scalars['Boolean']['input']>;
  cityID: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  consignmentCommisionFeePerc?: InputMaybe<Scalars['Float']['input']>;
  consignmentPeriodEndDate?: InputMaybe<Scalars['Time']['input']>;
  consignmentPeriodStartDate?: InputMaybe<Scalars['Time']['input']>;
  countryID: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullAddress: Scalars['String']['input'];
  hasPortalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isConsignment?: InputMaybe<Scalars['Boolean']['input']>;
  isPKP?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  npwp: Scalars['String']['input'];
  npwpCompanyName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  portalAccountActivated?: InputMaybe<Scalars['Boolean']['input']>;
  portalSuperadminEmail?: InputMaybe<Scalars['String']['input']>;
  portalSuperadminFirstName?: InputMaybe<Scalars['String']['input']>;
  portalSuperadminLastName?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  provinceName: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  subdistrictName: Scalars['String']['input'];
  taxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  taxpayerIDNumber: Scalars['String']['input'];
  vendorCategoryID: Scalars['UUID']['input'];
  vendorCode: Scalars['String']['input'];
  vendorConsignmentBranches?: InputMaybe<Array<VendorConsignmentBranchInput>>;
  vendorID: Scalars['UUID']['input'];
  vendorName: Scalars['String']['input'];
  vendorPicContacts?: InputMaybe<Array<VendorPicContactCreateFromVendorInput>>;
  version: Scalars['UUID']['input'];
};

export type Village = {
  __typename?: 'Village';
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  postalCode: Scalars['String']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  subdistrict?: Maybe<Subdistrict>;
  subdistrictID: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  villageID: Scalars['String']['output'];
  villageName: Scalars['String']['output'];
};

export type VillageCreateInput = {
  cityID: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  villageID: Scalars['String']['input'];
  villageName: Scalars['String']['input'];
};

export type VillagePaged = {
  __typename?: 'VillagePaged';
  items?: Maybe<Array<Village>>;
  pagination: PaginationResult;
};

export type VillageQopFilterInput = {
  cityID?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  villageName?: InputMaybe<Scalars['String']['input']>;
};

export type VillageQopInput = {
  filters?: InputMaybe<VillageQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VillageUpdateInput = {
  cityID: Scalars['String']['input'];
  countryID: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  postalCode: Scalars['String']['input'];
  provinceID: Scalars['String']['input'];
  subdistrictID: Scalars['String']['input'];
  villageID: Scalars['String']['input'];
  villageName: Scalars['String']['input'];
};

export type Voucher = {
  __typename?: 'Voucher';
  autoGenerateAllVouchers: Scalars['Boolean']['output'];
  canBeUsedWithOthers: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['Time']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiredAfterDays: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  issuedCount: Scalars['Int']['output'];
  maxNumberOfVouchers: Scalars['Int']['output'];
  membersOnly: Scalars['Boolean']['output'];
  startDate: Scalars['Time']['output'];
  uniqueKey: Scalars['String']['output'];
  unusedCount: Scalars['Int']['output'];
  usedCount: Scalars['Int']['output'];
  voidCount: Scalars['Int']['output'];
  voucherCategory?: Maybe<VoucherCategory>;
  voucherCategoryID: Scalars['UUID']['output'];
  voucherCategoryName: Scalars['String']['output'];
  voucherCategoryPrefix: Scalars['String']['output'];
  voucherCode: Scalars['String']['output'];
  voucherExpiryType: VoucherExpiryType;
  voucherID: Scalars['UUID']['output'];
  voucherName: Scalars['String']['output'];
  voucherType?: Maybe<VoucherType>;
  voucherValue: Scalars['Float']['output'];
};

export type VoucherCategory = {
  __typename?: 'VoucherCategory';
  entityAuditMetadata: EntityAuditMetadata;
  expenseAccountCode: Scalars['String']['output'];
  expenseAccountErpRefID?: Maybe<Scalars['String']['output']>;
  expenseAccountErpRefName?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  prefix: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  uniqueKey2: Scalars['String']['output'];
  voucherCategoryID: Scalars['UUID']['output'];
  voucherCategoryName: Scalars['String']['output'];
  voucherType?: Maybe<VoucherType>;
};

export type VoucherCategoryCreateInput = {
  expenseAccountCode: Scalars['String']['input'];
  expenseAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  prefix: Scalars['String']['input'];
  voucherCategoryName: Scalars['String']['input'];
  voucherType: VoucherType;
};

export type VoucherCategoryPaged = {
  __typename?: 'VoucherCategoryPaged';
  items?: Maybe<Array<VoucherCategory>>;
  pagination: PaginationResult;
};

export type VoucherCategoryQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  voucherCategoryName?: InputMaybe<Scalars['String']['input']>;
  voucherType?: InputMaybe<VoucherType>;
};

export type VoucherCategoryQopInput = {
  filters?: InputMaybe<VoucherCategoryQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VoucherCategoryUpdateInput = {
  expenseAccountCode: Scalars['String']['input'];
  expenseAccountErpRefID?: InputMaybe<Scalars['String']['input']>;
  expenseAccountErpRefName?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  prefix: Scalars['String']['input'];
  voucherCategoryID: Scalars['UUID']['input'];
  voucherCategoryName: Scalars['String']['input'];
  voucherType: VoucherType;
};

export type VoucherCreateInput = {
  autoGenerateAllVouchers: Scalars['Boolean']['input'];
  canBeUsedWithOthers: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  endDate: Scalars['Time']['input'];
  expiredAfterDays: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  maxNumberOfVouchers: Scalars['Int']['input'];
  membersOnly: Scalars['Boolean']['input'];
  startDate: Scalars['Time']['input'];
  voucherCategoryID: Scalars['UUID']['input'];
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  voucherExpiryType: VoucherExpiryType;
  voucherName: Scalars['String']['input'];
  voucherValue: Scalars['Float']['input'];
};

export enum VoucherExpiryType {
  DaysFromIssuedDate = 'days_from_issued_date',
  EndDate = 'end_date'
}

export type VoucherItem = {
  __typename?: 'VoucherItem';
  customer?: Maybe<Customer>;
  customerCode: Scalars['String']['output'];
  customerID?: Maybe<Scalars['UUID']['output']>;
  customerName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  expiryDate: Scalars['Time']['output'];
  isVoid: Scalars['Boolean']['output'];
  issuedTimeUTC: Scalars['Time']['output'];
  status: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  usedOnTransactionID?: Maybe<Scalars['UUID']['output']>;
  usedOnTransactionNo: Scalars['String']['output'];
  usedTime?: Maybe<Scalars['Time']['output']>;
  usedTimeUTC?: Maybe<Scalars['Time']['output']>;
  voucher?: Maybe<Voucher>;
  voucherCode: Scalars['String']['output'];
  voucherID: Scalars['UUID']['output'];
  voucherItemCode: Scalars['String']['output'];
  voucherItemID: Scalars['UUID']['output'];
  voucherValue: Scalars['Float']['output'];
};

export type VoucherItemGenerateInput = {
  count: Scalars['Int']['input'];
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  voucherID: Scalars['UUID']['input'];
};

export type VoucherItemImportInput = {
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  expiryDate: Scalars['Time']['input'];
  issuedTimeUTC: Scalars['Time']['input'];
  voucherID: Scalars['UUID']['input'];
  voucherItemCode: Scalars['String']['input'];
};

export type VoucherItemPaged = {
  __typename?: 'VoucherItemPaged';
  items?: Maybe<Array<VoucherItem>>;
  pagination: PaginationResult;
};

export type VoucherItemQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  customerCode?: InputMaybe<Scalars['String']['input']>;
  customerID?: InputMaybe<Scalars['UUID']['input']>;
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  isVoid?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  voucherID?: InputMaybe<Scalars['UUID']['input']>;
  voucherItemCode?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherItemQopInput = {
  filters?: InputMaybe<VoucherItemQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type VoucherPaged = {
  __typename?: 'VoucherPaged';
  items?: Maybe<Array<Voucher>>;
  pagination: PaginationResult;
};

export type VoucherQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  membersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  voucherCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  voucherExpiryType?: InputMaybe<VoucherExpiryType>;
  voucherID?: InputMaybe<Scalars['UUID']['input']>;
  voucherName?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherQopInput = {
  filters?: InputMaybe<VoucherQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export enum VoucherType {
  External = 'external',
  Internal = 'internal'
}

export type VoucherUpdateInput = {
  autoGenerateAllVouchers: Scalars['Boolean']['input'];
  canBeUsedWithOthers: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  endDate: Scalars['Time']['input'];
  expiredAfterDays: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  maxNumberOfVouchers: Scalars['Int']['input'];
  membersOnly: Scalars['Boolean']['input'];
  startDate: Scalars['Time']['input'];
  voucherCategoryID: Scalars['UUID']['input'];
  voucherExpiryType: VoucherExpiryType;
  voucherID: Scalars['UUID']['input'];
  voucherName: Scalars['String']['input'];
  voucherValue: Scalars['Float']['input'];
};

export type Warehouse = {
  __typename?: 'Warehouse';
  addressLabel: Scalars['String']['output'];
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  city?: Maybe<City>;
  cityID: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Country>;
  countryID: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  erpRefID?: Maybe<Scalars['String']['output']>;
  erpRefName?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  postalCode: Scalars['String']['output'];
  province?: Maybe<Province>;
  provinceID: Scalars['String']['output'];
  provinceName: Scalars['String']['output'];
  subdistrict?: Maybe<Subdistrict>;
  subdistrictID: Scalars['String']['output'];
  subdistrictName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  warehouseCode: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseName: Scalars['String']['output'];
  warehouseType: Scalars['String']['output'];
};

export type WarehouseCreateInput = {
  addressLabel: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  cityID?: InputMaybe<Scalars['String']['input']>;
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID: Scalars['String']['input'];
  warehouseCode: Scalars['String']['input'];
  warehouseName: Scalars['String']['input'];
  warehouseType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocation = {
  __typename?: 'WarehouseLocation';
  branch?: Maybe<Branch>;
  branchID: Scalars['UUID']['output'];
  entityAuditMetadata: EntityAuditMetadata;
  isActive: Scalars['Boolean']['output'];
  isHoldInventory: Scalars['Boolean']['output'];
  isSystemGenerated?: Maybe<Scalars['Boolean']['output']>;
  parentWarehouseLocation?: Maybe<WarehouseLocation>;
  parentWarehouseLocationID?: Maybe<Scalars['UUID']['output']>;
  uniqueKey: Scalars['String']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationGroup?: Maybe<WarehouseLocationGroup>;
  warehouseLocationGroupID?: Maybe<Scalars['UUID']['output']>;
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
  warehouseLocationType: Scalars['String']['output'];
  warehouseStorageType?: Maybe<Scalars['String']['output']>;
};

export type WarehouseLocationBulkCreateInput = {
  digit: Scalars['Int']['input'];
  endingNumber: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  isHoldInventory: Scalars['Boolean']['input'];
  parentWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  prefix: Scalars['String']['input'];
  startingNumber: Scalars['Int']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationGroupID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationType?: InputMaybe<Scalars['String']['input']>;
  warehouseStorageType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocationCreateInput = {
  isActive: Scalars['Boolean']['input'];
  isHoldInventory: Scalars['Boolean']['input'];
  parentWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationGroupID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationName: Scalars['String']['input'];
  warehouseLocationType?: InputMaybe<Scalars['String']['input']>;
  warehouseStorageType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocationGroup = {
  __typename?: 'WarehouseLocationGroup';
  entityAuditMetadata: EntityAuditMetadata;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  uniqueKey: Scalars['String']['output'];
  warehouseLocationGroupID: Scalars['UUID']['output'];
  warehouseLocationGroupName: Scalars['String']['output'];
};

export type WarehouseLocationGroupCreateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationGroupName: Scalars['String']['input'];
};

export type WarehouseLocationGroupPaged = {
  __typename?: 'WarehouseLocationGroupPaged';
  items?: Maybe<Array<WarehouseLocationGroup>>;
  pagination: PaginationResult;
};

export type WarehouseLocationGroupQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseLocationGroupName?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocationGroupQopInput = {
  filters?: InputMaybe<WarehouseLocationGroupQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseLocationGroupUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationGroupID: Scalars['UUID']['input'];
  warehouseLocationGroupName: Scalars['String']['input'];
};

export type WarehouseLocationPaged = {
  __typename?: 'WarehouseLocationPaged';
  items?: Maybe<Array<WarehouseLocation>>;
  pagination: PaginationResult;
};

export type WarehouseLocationQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isHoldInventory?: InputMaybe<Scalars['Boolean']['input']>;
  parentWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationGroupID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationName?: InputMaybe<Scalars['String']['input']>;
  warehouseLocationType?: InputMaybe<Scalars['String']['input']>;
  warehouseLocationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseStorageType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehouseLocationQopInput = {
  filters?: InputMaybe<WarehouseLocationQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseLocationRelationMap = {
  __typename?: 'WarehouseLocationRelationMap';
  entityAuditMetadata: EntityAuditMetadata;
  uniqueKey: Scalars['String']['output'];
  warehouseLocationChildID: Scalars['UUID']['output'];
  warehouseLocationParentID: Scalars['UUID']['output'];
};

export type WarehouseLocationRelationMapCreateInput = {
  warehouseLocationChildID: Scalars['UUID']['input'];
  warehouseLocationParentID: Scalars['UUID']['input'];
};

export type WarehouseLocationRelationMapDeleteInput = {
  warehouseLocationChildID: Scalars['UUID']['input'];
  warehouseLocationParentID: Scalars['UUID']['input'];
};

export type WarehouseLocationRelationMapPaged = {
  __typename?: 'WarehouseLocationRelationMapPaged';
  items?: Maybe<Array<WarehouseLocationRelationMap>>;
  pagination: PaginationResult;
};

export type WarehouseLocationRelationMapQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseLocationChildID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationParentID?: InputMaybe<Scalars['UUID']['input']>;
};

export type WarehouseLocationRelationMapQopInput = {
  filters?: InputMaybe<WarehouseLocationRelationMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseLocationRelationMapUpdateInput = {
  warehouseLocationChildID: Scalars['UUID']['input'];
  warehouseLocationParentID: Scalars['UUID']['input'];
};

export type WarehouseLocationUpdateInput = {
  isActive: Scalars['Boolean']['input'];
  isHoldInventory: Scalars['Boolean']['input'];
  parentWarehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationGroupID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID: Scalars['UUID']['input'];
  warehouseLocationName: Scalars['String']['input'];
  warehouseLocationType?: InputMaybe<Scalars['String']['input']>;
  warehouseStorageType?: InputMaybe<Scalars['String']['input']>;
};

export type WarehousePaged = {
  __typename?: 'WarehousePaged';
  items?: Maybe<Array<Warehouse>>;
  pagination: PaginationResult;
};

export type WarehouseProductLocationMap = {
  __typename?: 'WarehouseProductLocationMap';
  entityAuditMetadata: EntityAuditMetadata;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  product: Product;
  productCategory?: Maybe<ProductCategory>;
  productCode: Scalars['String']['output'];
  productID: Scalars['UUID']['output'];
  productName: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  warehouseCode: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseLocationID: Scalars['UUID']['output'];
  warehouseLocationName: Scalars['String']['output'];
  warehouseName: Scalars['String']['output'];
  warehouseProductLocationMapID: Scalars['UUID']['output'];
};

export type WarehouseProductLocationMapCreateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseLocationID: Scalars['UUID']['input'];
};

export type WarehouseProductLocationMapPaged = {
  __typename?: 'WarehouseProductLocationMapPaged';
  items?: Maybe<Array<WarehouseProductLocationMap>>;
  pagination: PaginationResult;
};

export type WarehouseProductLocationMapQopFilterInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  productCategoryID?: InputMaybe<Scalars['UUID']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  productDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  productID?: InputMaybe<Scalars['UUID']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productSubDepartmentID?: InputMaybe<Scalars['UUID']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
  warehouseLocationID?: InputMaybe<Scalars['UUID']['input']>;
};

export type WarehouseProductLocationMapQopInput = {
  filters?: InputMaybe<WarehouseProductLocationMapQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseProductLocationMapUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationID: Scalars['UUID']['input'];
  warehouseProductLocationMapID: Scalars['UUID']['input'];
};

export type WarehouseQopFilterInput = {
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  branchType?: InputMaybe<Scalars['String']['input']>;
  cityID?: InputMaybe<Scalars['String']['input']>;
  countryID?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provinceID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseCode?: InputMaybe<Scalars['String']['input']>;
  warehouseName?: InputMaybe<Scalars['String']['input']>;
  warehouseType?: InputMaybe<Scalars['String']['input']>;
  warehouseTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WarehouseQopInput = {
  filters?: InputMaybe<WarehouseQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseReplenishmentTemplate = {
  __typename?: 'WarehouseReplenishmentTemplate';
  entityAuditMetadata: EntityAuditMetadata;
  replenishmentTemplateID: Scalars['UUID']['output'];
  replenishmentTemplateName: Scalars['String']['output'];
  warehouseCode: Scalars['String']['output'];
  warehouseID: Scalars['UUID']['output'];
  warehouseName: Scalars['String']['output'];
  warehouseReplenishmentTemplateID: Scalars['UUID']['output'];
};

export type WarehouseReplenishmentTemplateCreateBulkInput = {
  replenishmentTemplateIDs: Array<Scalars['UUID']['input']>;
  warehouseID: Scalars['UUID']['input'];
};

export type WarehouseReplenishmentTemplateCreateInput = {
  replenishmentTemplateID: Scalars['UUID']['input'];
  warehouseID: Scalars['UUID']['input'];
};

export type WarehouseReplenishmentTemplatePaged = {
  __typename?: 'WarehouseReplenishmentTemplatePaged';
  items?: Maybe<Array<WarehouseReplenishmentTemplate>>;
  pagination: PaginationResult;
};

export type WarehouseReplenishmentTemplateQopFilterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  replenishmentTemplateID?: InputMaybe<Scalars['UUID']['input']>;
  replenishmentTemplateName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['UUID']['input']>;
};

export type WarehouseReplenishmentTemplateQopInput = {
  filters?: InputMaybe<WarehouseReplenishmentTemplateQopFilterInput>;
  pagination?: InputMaybe<Pagination>;
  sorts?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type WarehouseUpdateInput = {
  addressLabel: Scalars['String']['input'];
  branchID: Scalars['UUID']['input'];
  cityID?: InputMaybe<Scalars['String']['input']>;
  erpRefID?: InputMaybe<Scalars['String']['input']>;
  erpRefName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  gmt: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  provinceID?: InputMaybe<Scalars['String']['input']>;
  subdistrictID: Scalars['String']['input'];
  warehouseCode: Scalars['String']['input'];
  warehouseID: Scalars['UUID']['input'];
  warehouseName: Scalars['String']['input'];
  warehouseType?: InputMaybe<Scalars['String']['input']>;
};

export const OperatingHoursDayFieldsFragmentDoc = gql`
    fragment OperatingHoursDayFields on OperatingHoursDay {
  isOpen
  periods {
    startTime
    endTime
  }
}
    `;
export const ProductImportValidateResultFieldsFragmentDoc = gql`
    fragment ProductImportValidateResultFields on ProductImportValidateResult {
  status
  missing {
    sources
    categories
    subCategories
    brands
    uomCategories
    uoms
    taxes
    countries
    tags
    accountingCategories
    vendors
  }
  rowReport {
    totalRows
    validRowCount
    invalidRowCount
    createRowCount
    updateRowCount
    warningRowCount
    violationSample {
      rowNumber
      standardKey
      label
      reason
      value
    }
    warningSample {
      rowNumber
      standardKey
      label
      reason
      value
    }
  }
  updatedRows {
    rowNumber
    action
    productCode
    productName
  }
}
    `;
export const AuthLoginDocument = gql`
    mutation AuthLogin($input: LoginInput!) {
  authLogin(input: $input) {
    accessToken
    refreshToken
    user {
      userID
      fullName
      email
      phoneNumber
      employeeID
      vendorID
    }
    defaultBranchID
    defaultBranchCode
    defaultBranchName
    defaultRoleName
    defaultWarehouseID
    defaultWarehouseName
    isAllBranches
    branches {
      branchID
      branchCode
      branchName
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
    }
    appRolePermissions {
      appID
      appName
      roles {
        resourceID
        resourceName
        permissions {
          permissionID
          permissionName
        }
      }
    }
  }
}
    `;

export function useAuthLoginMutation() {
  return Urql.useMutation<AuthLoginMutation, AuthLoginMutationVariables>(AuthLoginDocument);
};
export const AuthLoginVendorDocument = gql`
    mutation AuthLoginVendor($input: LoginInput!) {
  authLoginVendor(input: $input) {
    accessToken
    refreshToken
    user {
      userID
      fullName
      email
      phoneNumber
      employeeID
      vendorID
    }
    defaultBranchID
    defaultBranchCode
    defaultBranchName
    defaultRoleName
    defaultWarehouseID
    defaultWarehouseName
    isAllBranches
    branches {
      branchID
      branchCode
      branchName
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
    }
    appRolePermissions {
      appID
      appName
      roles {
        resourceID
        resourceName
        permissions {
          permissionID
          permissionName
        }
      }
    }
  }
}
    `;

export function useAuthLoginVendorMutation() {
  return Urql.useMutation<AuthLoginVendorMutation, AuthLoginVendorMutationVariables>(AuthLoginVendorDocument);
};
export const AuthRefreshTokenDocument = gql`
    mutation AuthRefreshToken($refreshToken: String!) {
  authRefreshToken(refreshToken: $refreshToken) {
    accessToken
    refreshToken
    user {
      userID
      fullName
      email
      phoneNumber
      employeeID
      vendorID
    }
    defaultBranchID
    defaultBranchCode
    defaultBranchName
    defaultRoleName
    defaultWarehouseID
    defaultWarehouseName
    isAllBranches
    branches {
      branchID
      branchCode
      branchName
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
    }
    appRolePermissions {
      appID
      appName
      roles {
        resourceID
        resourceName
        permissions {
          permissionID
          permissionName
        }
      }
    }
  }
}
    `;

export function useAuthRefreshTokenMutation() {
  return Urql.useMutation<AuthRefreshTokenMutation, AuthRefreshTokenMutationVariables>(AuthRefreshTokenDocument);
};
export const AuthSetDefaultBranchDocument = gql`
    mutation AuthSetDefaultBranch($input: SetDefaultBranchInput!) {
  authSetDefaultBranch(input: $input) {
    accessToken
    refreshToken
    isAllBranches
    defaultBranchID
    defaultBranchCode
    defaultBranchName
    defaultWarehouseID
    defaultWarehouseName
    defaultRoleID
    defaultRoleName
    defaultRoleAppID
    defaultRoleAppName
    branches {
      branchID
      branchCode
      branchName
    }
    appRoles {
      roleID
      roleName
      appID
      appName
    }
    appRolePermissions {
      appID
      appName
    }
  }
}
    `;

export function useAuthSetDefaultBranchMutation() {
  return Urql.useMutation<AuthSetDefaultBranchMutation, AuthSetDefaultBranchMutationVariables>(AuthSetDefaultBranchDocument);
};
export const AppCreateDocument = gql`
    mutation AppCreate($input: AppCreateInput!) {
  appCreate(input: $input) {
    appID
  }
}
    `;

export function useAppCreateMutation() {
  return Urql.useMutation<AppCreateMutation, AppCreateMutationVariables>(AppCreateDocument);
};
export const AppDeleteDocument = gql`
    mutation AppDelete($appID: String!) {
  appDelete(appID: $appID)
}
    `;

export function useAppDeleteMutation() {
  return Urql.useMutation<AppDeleteMutation, AppDeleteMutationVariables>(AppDeleteDocument);
};
export const AppListAutocompletePagedDocument = gql`
    query AppListAutocompletePaged($qop: AppQopInput!) {
  apps(qop: $qop) {
    items {
      appID
      appName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useAppListAutocompletePagedQuery(options: Omit<Urql.UseQueryArgs<AppListAutocompletePagedQueryVariables>, 'query'>) {
  return Urql.useQuery<AppListAutocompletePagedQuery, AppListAutocompletePagedQueryVariables>({ query: AppListAutocompletePagedDocument, ...options });
};
export const AppListPagedDocument = gql`
    query AppListPaged($qop: AppQopInput!) {
  apps(qop: $qop) {
    items {
      appID
      appName
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useAppListPagedQuery(options: Omit<Urql.UseQueryArgs<AppListPagedQueryVariables>, 'query'>) {
  return Urql.useQuery<AppListPagedQuery, AppListPagedQueryVariables>({ query: AppListPagedDocument, ...options });
};
export const AppLoadDocument = gql`
    query AppLoad($appID: String!) {
  app(appID: $appID) {
    appID
    appName
    isActive
  }
}
    `;

export function useAppLoadQuery(options: Omit<Urql.UseQueryArgs<AppLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<AppLoadQuery, AppLoadQueryVariables>({ query: AppLoadDocument, ...options });
};
export const AppUpdateDocument = gql`
    mutation AppUpdate($input: AppUpdateInput!) {
  appUpdate(input: $input) {
    appID
  }
}
    `;

export function useAppUpdateMutation() {
  return Urql.useMutation<AppUpdateMutation, AppUpdateMutationVariables>(AppUpdateDocument);
};
export const PermissionCreateDocument = gql`
    mutation PermissionCreate($input: PermissionCreateInput!) {
  permissionCreate(input: $input) {
    permissionID
  }
}
    `;

export function usePermissionCreateMutation() {
  return Urql.useMutation<PermissionCreateMutation, PermissionCreateMutationVariables>(PermissionCreateDocument);
};
export const PermissionDeleteDocument = gql`
    mutation PermissionDelete($permissionID: String!) {
  permissionDelete(permissionID: $permissionID)
}
    `;

export function usePermissionDeleteMutation() {
  return Urql.useMutation<PermissionDeleteMutation, PermissionDeleteMutationVariables>(PermissionDeleteDocument);
};
export const PermissionListAutocompletePagedDocument = gql`
    query PermissionListAutocompletePaged($qop: PermissionQopInput!) {
  permissions(qop: $qop) {
    items {
      permissionID
      permissionName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePermissionListAutocompletePagedQuery(options: Omit<Urql.UseQueryArgs<PermissionListAutocompletePagedQueryVariables>, 'query'>) {
  return Urql.useQuery<PermissionListAutocompletePagedQuery, PermissionListAutocompletePagedQueryVariables>({ query: PermissionListAutocompletePagedDocument, ...options });
};
export const PermissionListPagedDocument = gql`
    query PermissionListPaged($qop: PermissionQopInput!) {
  permissions(qop: $qop) {
    items {
      permissionID
      permissionName
      resourceName
      parentResourceName
      apps {
        appName
      }
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePermissionListPagedQuery(options: Omit<Urql.UseQueryArgs<PermissionListPagedQueryVariables>, 'query'>) {
  return Urql.useQuery<PermissionListPagedQuery, PermissionListPagedQueryVariables>({ query: PermissionListPagedDocument, ...options });
};
export const PermissionLoadDocument = gql`
    query PermissionLoad($permissionID: String!) {
  permission(permissionID: $permissionID) {
    permissionID
    permissionName
    resourceID
    resourceName
    apps {
      appID
      appName
    }
  }
}
    `;

export function usePermissionLoadQuery(options: Omit<Urql.UseQueryArgs<PermissionLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PermissionLoadQuery, PermissionLoadQueryVariables>({ query: PermissionLoadDocument, ...options });
};
export const PermissionUpdateDocument = gql`
    mutation PermissionUpdate($input: PermissionUpdateInput!) {
  permissionUpdate(input: $input) {
    permissionID
  }
}
    `;

export function usePermissionUpdateMutation() {
  return Urql.useMutation<PermissionUpdateMutation, PermissionUpdateMutationVariables>(PermissionUpdateDocument);
};
export const ResourceCreateDocument = gql`
    mutation ResourceCreate($input: ResourceCreateInput!) {
  resourceCreate(input: $input) {
    resourceID
  }
}
    `;

export function useResourceCreateMutation() {
  return Urql.useMutation<ResourceCreateMutation, ResourceCreateMutationVariables>(ResourceCreateDocument);
};
export const ResourceDeleteDocument = gql`
    mutation ResourceDelete($resourceID: String!) {
  resourceDelete(resourceID: $resourceID)
}
    `;

export function useResourceDeleteMutation() {
  return Urql.useMutation<ResourceDeleteMutation, ResourceDeleteMutationVariables>(ResourceDeleteDocument);
};
export const ResourceListAutocompletePagedDocument = gql`
    query ResourceListAutocompletePaged($qop: ResourceQopInput!) {
  resources(qop: $qop) {
    items {
      resourceID
      resourceName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useResourceListAutocompletePagedQuery(options: Omit<Urql.UseQueryArgs<ResourceListAutocompletePagedQueryVariables>, 'query'>) {
  return Urql.useQuery<ResourceListAutocompletePagedQuery, ResourceListAutocompletePagedQueryVariables>({ query: ResourceListAutocompletePagedDocument, ...options });
};
export const ResourceListPagedDocument = gql`
    query ResourceListPaged($qop: ResourceQopInput!) {
  resources(qop: $qop) {
    items {
      resourceID
      resourceName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useResourceListPagedQuery(options: Omit<Urql.UseQueryArgs<ResourceListPagedQueryVariables>, 'query'>) {
  return Urql.useQuery<ResourceListPagedQuery, ResourceListPagedQueryVariables>({ query: ResourceListPagedDocument, ...options });
};
export const ResourceLoadDocument = gql`
    query ResourceLoad($resourceID: String!) {
  resource(resourceID: $resourceID) {
    resourceID
    resourceName
    parentResourceID
  }
}
    `;

export function useResourceLoadQuery(options: Omit<Urql.UseQueryArgs<ResourceLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ResourceLoadQuery, ResourceLoadQueryVariables>({ query: ResourceLoadDocument, ...options });
};
export const ResourceUpdateDocument = gql`
    mutation ResourceUpdate($input: ResourceUpdateInput!) {
  resourceUpdate(input: $input) {
    resourceID
  }
}
    `;

export function useResourceUpdateMutation() {
  return Urql.useMutation<ResourceUpdateMutation, ResourceUpdateMutationVariables>(ResourceUpdateDocument);
};
export const RoleCreateDocument = gql`
    mutation RoleCreate($input: RoleCreateInput!) {
  roleCreate(input: $input) {
    roleID
  }
}
    `;

export function useRoleCreateMutation() {
  return Urql.useMutation<RoleCreateMutation, RoleCreateMutationVariables>(RoleCreateDocument);
};
export const RoleDeleteDocument = gql`
    mutation RoleDelete($roleID: UUID!) {
  roleDelete(roleID: $roleID)
}
    `;

export function useRoleDeleteMutation() {
  return Urql.useMutation<RoleDeleteMutation, RoleDeleteMutationVariables>(RoleDeleteDocument);
};
export const RoleListAutocompletePagedDocument = gql`
    query RoleListAutocompletePaged($qop: RoleQopInput!) {
  roles(qop: $qop) {
    items {
      roleID
      roleName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useRoleListAutocompletePagedQuery(options: Omit<Urql.UseQueryArgs<RoleListAutocompletePagedQueryVariables>, 'query'>) {
  return Urql.useQuery<RoleListAutocompletePagedQuery, RoleListAutocompletePagedQueryVariables>({ query: RoleListAutocompletePagedDocument, ...options });
};
export const RoleListPagedDocument = gql`
    query RoleListPaged($qop: RoleQopInput!) {
  roles(qop: $qop) {
    items {
      roleID
      roleName
      description
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useRoleListPagedQuery(options: Omit<Urql.UseQueryArgs<RoleListPagedQueryVariables>, 'query'>) {
  return Urql.useQuery<RoleListPagedQuery, RoleListPagedQueryVariables>({ query: RoleListPagedDocument, ...options });
};
export const RoleLoadDocument = gql`
    query RoleLoad($roleID: UUID!) {
  role(roleID: $roleID) {
    roleID
    roleName
    description
    isActive
    rolePermissions {
      permissionID
      permissionName
      resourceID
      resourceName
      parentResourceID
      parentResourceName
      appID
      appName
    }
  }
}
    `;

export function useRoleLoadQuery(options: Omit<Urql.UseQueryArgs<RoleLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<RoleLoadQuery, RoleLoadQueryVariables>({ query: RoleLoadDocument, ...options });
};
export const RoleUpdateDocument = gql`
    mutation RoleUpdate($input: RoleUpdateInput!) {
  roleUpdate(input: $input) {
    roleID
  }
}
    `;

export function useRoleUpdateMutation() {
  return Urql.useMutation<RoleUpdateMutation, RoleUpdateMutationVariables>(RoleUpdateDocument);
};
export const UserCreateDocument = gql`
    mutation UserCreate($input: UserCreateInput!) {
  userCreate(input: $input) {
    userID
  }
}
    `;

export function useUserCreateMutation() {
  return Urql.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument);
};
export const UserDeleteDocument = gql`
    mutation UserDelete($userID: UUID!) {
  userDelete(userID: $userID)
}
    `;

export function useUserDeleteMutation() {
  return Urql.useMutation<UserDeleteMutation, UserDeleteMutationVariables>(UserDeleteDocument);
};
export const UserListPagedDocument = gql`
    query UserListPaged($qop: UserQopInput) {
  users(qop: $qop) {
    items {
      userID
      userType
      fullName
      email
      phoneNumber
      userRoles {
        role {
          roleName
        }
      }
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useUserListPagedQuery(options?: Omit<Urql.UseQueryArgs<UserListPagedQueryVariables>, 'query'>) {
  return Urql.useQuery<UserListPagedQuery, UserListPagedQueryVariables>({ query: UserListPagedDocument, ...options });
};
export const UserLoadDocument = gql`
    query UserLoad($userID: UUID!) {
  user(userID: $userID) {
    userID
    userType
    firstName
    lastName
    fullName
    email
    phoneNumber
    vendorID
    employeeID
    isActive
    isAllBranches
    userRoles {
      roleID
      role {
        roleID
        roleName
      }
    }
    userBranches {
      userID
      branchID
      branchCode
      branchName
    }
  }
}
    `;

export function useUserLoadQuery(options: Omit<Urql.UseQueryArgs<UserLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<UserLoadQuery, UserLoadQueryVariables>({ query: UserLoadDocument, ...options });
};
export const UserUpdateDocument = gql`
    mutation UserUpdate($input: UserUpdateInput!) {
  userUpdate(input: $input) {
    userID
  }
}
    `;

export function useUserUpdateMutation() {
  return Urql.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument);
};
export const GenerateLinkResetPasswordDocument = gql`
    mutation GenerateLinkResetPassword($input: GenerateLinkResetPasswordInput!) {
  generateLinkResetPassword(input: $input) {
    success
    nextRetryDelay
    nextSessionDelay
    remainingAttempts
  }
}
    `;

export function useGenerateLinkResetPasswordMutation() {
  return Urql.useMutation<GenerateLinkResetPasswordMutation, GenerateLinkResetPasswordMutationVariables>(GenerateLinkResetPasswordDocument);
};
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const BackgroundJobDocument = gql`
    query BackgroundJob($backgroundJobID: UUID!) {
  backgroundJob(backgroundJobID: $backgroundJobID) {
    backgroundJobID
    jobCategory
    jobType
    status
    processedCount
    totalCount
    jobMessage
  }
}
    `;

export function useBackgroundJobQuery(options: Omit<Urql.UseQueryArgs<BackgroundJobQueryVariables>, 'query'>) {
  return Urql.useQuery<BackgroundJobQuery, BackgroundJobQueryVariables>({ query: BackgroundJobDocument, ...options });
};
export const BackgroundJobDetailDocument = gql`
    query BackgroundJobDetail($backgroundJobID: UUID!) {
  backgroundJob(backgroundJobID: $backgroundJobID) {
    backgroundJobID
    branchID
    jobCategory
    jobType
    jobKey
    jobDescription
    jobMessage
    jobData
    status
    processedCount
    totalCount
    retryCount
    startedDatetime
    finishedDatetime
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      createdAt
      updatedAt
      version
    }
  }
}
    `;

export function useBackgroundJobDetailQuery(options: Omit<Urql.UseQueryArgs<BackgroundJobDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<BackgroundJobDetailQuery, BackgroundJobDetailQueryVariables>({ query: BackgroundJobDetailDocument, ...options });
};
export const BackgroundJobListDocument = gql`
    query BackgroundJobList($qop: BackgroundJobQopInput!) {
  backgroundJobs(qop: $qop) {
    items {
      backgroundJobID
      branchID
      jobCategory
      jobType
      jobKey
      jobDescription
      jobMessage
      jobData
      status
      processedCount
      totalCount
      retryCount
      startedDatetime
      finishedDatetime
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        createdAt
        updatedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useBackgroundJobListQuery(options: Omit<Urql.UseQueryArgs<BackgroundJobListQueryVariables>, 'query'>) {
  return Urql.useQuery<BackgroundJobListQuery, BackgroundJobListQueryVariables>({ query: BackgroundJobListDocument, ...options });
};
export const BackgroundJobUpdateDocument = gql`
    mutation BackgroundJobUpdate($input: BackgroundJobUpdateInput!) {
  backgroundJobUpdate(input: $input) {
    backgroundJobID
    status
  }
}
    `;

export function useBackgroundJobUpdateMutation() {
  return Urql.useMutation<BackgroundJobUpdateMutation, BackgroundJobUpdateMutationVariables>(BackgroundJobUpdateDocument);
};
export const MasterdataBackgroundJobDocument = gql`
    query MasterdataBackgroundJob($backgroundJobID: UUID!) {
  masterdataBackgroundJob(backgroundJobID: $backgroundJobID) {
    backgroundJobID
    jobCategory
    jobType
    status
    processedCount
    totalCount
    jobMessage
  }
}
    `;

export function useMasterdataBackgroundJobQuery(options: Omit<Urql.UseQueryArgs<MasterdataBackgroundJobQueryVariables>, 'query'>) {
  return Urql.useQuery<MasterdataBackgroundJobQuery, MasterdataBackgroundJobQueryVariables>({ query: MasterdataBackgroundJobDocument, ...options });
};
export const BankAccountAutocompleteDocument = gql`
    query BankAccountAutocomplete($qop: BankAccountQopInput!) {
  bankAccounts(qop: $qop) {
    items {
      bankAccountID
      bankAccountNumber
      bankID
      bank {
        bankID
        bankName
      }
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useBankAccountAutocompleteQuery(options: Omit<Urql.UseQueryArgs<BankAccountAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<BankAccountAutocompleteQuery, BankAccountAutocompleteQueryVariables>({ query: BankAccountAutocompleteDocument, ...options });
};
export const BankAccountCreateDocument = gql`
    mutation BankAccountCreate($input: BankAccountCreateInput!) {
  bankAccountCreate(input: $input) {
    bankAccountID
  }
}
    `;

export function useBankAccountCreateMutation() {
  return Urql.useMutation<BankAccountCreateMutation, BankAccountCreateMutationVariables>(BankAccountCreateDocument);
};
export const BankAccountDeleteDocument = gql`
    mutation BankAccountDelete($bankAccountID: UUID!) {
  bankAccountDelete(bankAccountID: $bankAccountID)
}
    `;

export function useBankAccountDeleteMutation() {
  return Urql.useMutation<BankAccountDeleteMutation, BankAccountDeleteMutationVariables>(BankAccountDeleteDocument);
};
export const BankAccountListDocument = gql`
    query BankAccountList($qop: BankAccountQopInput!) {
  bankAccounts(qop: $qop) {
    items {
      bankAccountID
      bankID
      bankAccountNumber
      journalAccountCode
      isActive
      uniqueKey
      bank {
        bankID
        bankName
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useBankAccountListQuery(options: Omit<Urql.UseQueryArgs<BankAccountListQueryVariables>, 'query'>) {
  return Urql.useQuery<BankAccountListQuery, BankAccountListQueryVariables>({ query: BankAccountListDocument, ...options });
};
export const BankAccountLoadDocument = gql`
    query BankAccountLoad($bankAccountID: UUID!) {
  bankAccount(bankAccountID: $bankAccountID) {
    bankAccountID
    bankID
    bankAccountNumber
    journalAccountCode
    journalAccountErpRefID
    journalAccountErpRefName
    isActive
    uniqueKey
    bank {
      bankID
      bankName
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useBankAccountLoadQuery(options: Omit<Urql.UseQueryArgs<BankAccountLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<BankAccountLoadQuery, BankAccountLoadQueryVariables>({ query: BankAccountLoadDocument, ...options });
};
export const BankAccountUpdateDocument = gql`
    mutation BankAccountUpdate($input: BankAccountUpdateInput!) {
  bankAccountUpdate(input: $input) {
    bankAccountID
  }
}
    `;

export function useBankAccountUpdateMutation() {
  return Urql.useMutation<BankAccountUpdateMutation, BankAccountUpdateMutationVariables>(BankAccountUpdateDocument);
};
export const BankAutocompleteDocument = gql`
    query BankAutocomplete($qop: BankQopInput!) {
  banks(qop: $qop) {
    items {
      bankID
      bankName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useBankAutocompleteQuery(options: Omit<Urql.UseQueryArgs<BankAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<BankAutocompleteQuery, BankAutocompleteQueryVariables>({ query: BankAutocompleteDocument, ...options });
};
export const BankListDocument = gql`
    query BankList($qop: BankQopInput!) {
  banks(qop: $qop) {
    items {
      bankID
      bankName
      isActive
      uniqueKey
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useBankListQuery(options: Omit<Urql.UseQueryArgs<BankListQueryVariables>, 'query'>) {
  return Urql.useQuery<BankListQuery, BankListQueryVariables>({ query: BankListDocument, ...options });
};
export const BillOfMaterialComponentDeleteDocument = gql`
    mutation BillOfMaterialComponentDelete($billOfMaterialComponentID: UUID!) {
  billOfMaterialComponentDelete(
    billOfMaterialComponentID: $billOfMaterialComponentID
  )
}
    `;

export function useBillOfMaterialComponentDeleteMutation() {
  return Urql.useMutation<BillOfMaterialComponentDeleteMutation, BillOfMaterialComponentDeleteMutationVariables>(BillOfMaterialComponentDeleteDocument);
};
export const BillOfMaterialComponentListDocument = gql`
    query BillOfMaterialComponentList($qop: BillOfMaterialComponentQopInput) {
  billOfMaterialComponents(qop: $qop) {
    items {
      billOfMaterialComponentID
      billOfMaterialID
      productID
      uomCategoryID
      uomID
      qty
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useBillOfMaterialComponentListQuery(options?: Omit<Urql.UseQueryArgs<BillOfMaterialComponentListQueryVariables>, 'query'>) {
  return Urql.useQuery<BillOfMaterialComponentListQuery, BillOfMaterialComponentListQueryVariables>({ query: BillOfMaterialComponentListDocument, ...options });
};
export const BillOfMaterialAutocompleteDocument = gql`
    query BillOfMaterialAutocomplete($qop: BillOfMaterialQopInput) {
  billOfMaterials(qop: $qop) {
    items {
      billOfMaterialID
      name
      qty
      uomID
      product {
        productCode
        productName
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useBillOfMaterialAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<BillOfMaterialAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<BillOfMaterialAutocompleteQuery, BillOfMaterialAutocompleteQueryVariables>({ query: BillOfMaterialAutocompleteDocument, ...options });
};
export const BillOfMaterialCreateDocument = gql`
    mutation BillOfMaterialCreate($input: BillOfMaterialCreateInput!) {
  billOfMaterialCreate(input: $input) {
    billOfMaterialID
    name
    qty
    productID
    uomCategoryID
    uomID
    description
    isActive
  }
}
    `;

export function useBillOfMaterialCreateMutation() {
  return Urql.useMutation<BillOfMaterialCreateMutation, BillOfMaterialCreateMutationVariables>(BillOfMaterialCreateDocument);
};
export const BillOfMaterialDeleteDocument = gql`
    mutation BillOfMaterialDelete($billOfMaterialID: UUID!) {
  billOfMaterialDelete(billOfMaterialID: $billOfMaterialID)
}
    `;

export function useBillOfMaterialDeleteMutation() {
  return Urql.useMutation<BillOfMaterialDeleteMutation, BillOfMaterialDeleteMutationVariables>(BillOfMaterialDeleteDocument);
};
export const BillOfMaterialListDocument = gql`
    query BillOfMaterialList($qop: BillOfMaterialQopInput) {
  billOfMaterials(qop: $qop) {
    items {
      billOfMaterialID
      name
      productID
      product {
        productCode
        productName
      }
      uomCategoryID
      uomID
      description
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useBillOfMaterialListQuery(options?: Omit<Urql.UseQueryArgs<BillOfMaterialListQueryVariables>, 'query'>) {
  return Urql.useQuery<BillOfMaterialListQuery, BillOfMaterialListQueryVariables>({ query: BillOfMaterialListDocument, ...options });
};
export const BillOfMaterialLoadDocument = gql`
    query BillOfMaterialLoad($billOfMaterialID: UUID!) {
  billOfMaterial(billOfMaterialID: $billOfMaterialID) {
    billOfMaterialID
    name
    qty
    productID
    product {
      productCode
      productName
    }
    uomCategoryID
    uomCategory {
      uomCategoryName
    }
    uomID
    uom {
      uomName
    }
    components {
      billOfMaterialComponentID
      billOfMaterialID
      productID
      product {
        productCode
        productName
        barcode
        baseUom {
          uomID
          uomName
        }
      }
      uomCategoryID
      uomCategory {
        uomCategoryName
      }
      uomID
      uom {
        relationType
        conversionInfo
        convertionDecimal
        convertionRate
        convertionRateMultiplier
        uomName
      }
      qty
      isActive
    }
    description
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useBillOfMaterialLoadQuery(options: Omit<Urql.UseQueryArgs<BillOfMaterialLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<BillOfMaterialLoadQuery, BillOfMaterialLoadQueryVariables>({ query: BillOfMaterialLoadDocument, ...options });
};
export const BillOfMaterialUpdateDocument = gql`
    mutation BillOfMaterialUpdate($input: BillOfMaterialUpdateInput!) {
  billOfMaterialUpdate(input: $input) {
    billOfMaterialID
    name
    productID
    uomCategoryID
    uomID
    description
    isActive
    qty
  }
}
    `;

export function useBillOfMaterialUpdateMutation() {
  return Urql.useMutation<BillOfMaterialUpdateMutation, BillOfMaterialUpdateMutationVariables>(BillOfMaterialUpdateDocument);
};
export const BranchBankAccountCreateDocument = gql`
    mutation BranchBankAccountCreate($input: BranchBankAccountCreateInput!) {
  branchBankAccountCreate(input: $input) {
    branchBankAccountID
    branchID
    bankAccountID
    merchantID
    isActive
  }
}
    `;

export function useBranchBankAccountCreateMutation() {
  return Urql.useMutation<BranchBankAccountCreateMutation, BranchBankAccountCreateMutationVariables>(BranchBankAccountCreateDocument);
};
export const BranchBankAccountDeleteDocument = gql`
    mutation BranchBankAccountDelete($branchBankAccountID: UUID!) {
  branchBankAccountDelete(branchBankAccountID: $branchBankAccountID)
}
    `;

export function useBranchBankAccountDeleteMutation() {
  return Urql.useMutation<BranchBankAccountDeleteMutation, BranchBankAccountDeleteMutationVariables>(BranchBankAccountDeleteDocument);
};
export const BranchBankAccountListDocument = gql`
    query BranchBankAccountList($qop: BranchBankAccountQopInput) {
  branchBankAccounts(qop: $qop) {
    items {
      branchBankAccountID
      branchID
      bankAccountID
      merchantID
      isActive
      branch {
        branchID
        branchCode
        branchName
      }
      bankAccount {
        bankAccountID
        bankAccountNumber
        bank {
          bankID
          bankName
        }
      }
      entityAuditMetadata {
        version
        updatedAt
      }
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    `;

export function useBranchBankAccountListQuery(options?: Omit<Urql.UseQueryArgs<BranchBankAccountListQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchBankAccountListQuery, BranchBankAccountListQueryVariables>({ query: BranchBankAccountListDocument, ...options });
};
export const BranchBankAccountUpdateDocument = gql`
    mutation BranchBankAccountUpdate($input: BranchBankAccountUpdateInput!) {
  branchBankAccountUpdate(input: $input) {
    branchBankAccountID
    branchID
    bankAccountID
    merchantID
    isActive
  }
}
    `;

export function useBranchBankAccountUpdateMutation() {
  return Urql.useMutation<BranchBankAccountUpdateMutation, BranchBankAccountUpdateMutationVariables>(BranchBankAccountUpdateDocument);
};
export const BranchCategoryAutocompleteDocument = gql`
    query BranchCategoryAutocomplete($qop: BranchCategoryQopInput) {
  branchCategories(qop: $qop) {
    items {
      branchCategoryID
      branchCategoryName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useBranchCategoryAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<BranchCategoryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchCategoryAutocompleteQuery, BranchCategoryAutocompleteQueryVariables>({ query: BranchCategoryAutocompleteDocument, ...options });
};
export const BranchCategoryCreateDocument = gql`
    mutation BranchCategoryCreate($input: BranchCategoryCreateInput!) {
  branchCategoryCreate(input: $input) {
    branchCategoryID
    branchCategoryName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useBranchCategoryCreateMutation() {
  return Urql.useMutation<BranchCategoryCreateMutation, BranchCategoryCreateMutationVariables>(BranchCategoryCreateDocument);
};
export const BranchCategoryDeleteDocument = gql`
    mutation BranchCategoryDelete($branchCategoryID: UUID!) {
  branchCategoryDelete(branchCategoryID: $branchCategoryID)
}
    `;

export function useBranchCategoryDeleteMutation() {
  return Urql.useMutation<BranchCategoryDeleteMutation, BranchCategoryDeleteMutationVariables>(BranchCategoryDeleteDocument);
};
export const BranchCategoryListDocument = gql`
    query BranchCategoryList($qop: BranchCategoryQopInput) {
  branchCategories(qop: $qop) {
    items {
      branchCategoryID
      branchCategoryName
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useBranchCategoryListQuery(options?: Omit<Urql.UseQueryArgs<BranchCategoryListQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchCategoryListQuery, BranchCategoryListQueryVariables>({ query: BranchCategoryListDocument, ...options });
};
export const BranchCategoryLoadDocument = gql`
    query BranchCategoryLoad($branchCategoryID: UUID!) {
  branchCategory(branchCategoryID: $branchCategoryID) {
    branchCategoryID
    branchCategoryName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useBranchCategoryLoadQuery(options: Omit<Urql.UseQueryArgs<BranchCategoryLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchCategoryLoadQuery, BranchCategoryLoadQueryVariables>({ query: BranchCategoryLoadDocument, ...options });
};
export const BranchCategoryUpdateDocument = gql`
    mutation BranchCategoryUpdate($input: BranchCategoryUpdateInput!) {
  branchCategoryUpdate(input: $input) {
    branchCategoryID
    branchCategoryName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useBranchCategoryUpdateMutation() {
  return Urql.useMutation<BranchCategoryUpdateMutation, BranchCategoryUpdateMutationVariables>(BranchCategoryUpdateDocument);
};
export const BranchQrisMerchantCreateDocument = gql`
    mutation BranchQrisMerchantCreate($input: BranchQrisMerchantCreateInput!) {
  branchQrisMerchantCreate(input: $input) {
    branchQrisMerchantID
    branchID
    branchCode
    branchName
    bankID
    bankName
    providerCode
    nmid
    terminalID
    merchantName
    isActive
  }
}
    `;

export function useBranchQrisMerchantCreateMutation() {
  return Urql.useMutation<BranchQrisMerchantCreateMutation, BranchQrisMerchantCreateMutationVariables>(BranchQrisMerchantCreateDocument);
};
export const BranchQrisMerchantDeleteDocument = gql`
    mutation BranchQrisMerchantDelete($branchQrisMerchantID: UUID!) {
  branchQrisMerchantDelete(branchQrisMerchantID: $branchQrisMerchantID)
}
    `;

export function useBranchQrisMerchantDeleteMutation() {
  return Urql.useMutation<BranchQrisMerchantDeleteMutation, BranchQrisMerchantDeleteMutationVariables>(BranchQrisMerchantDeleteDocument);
};
export const BranchQrisMerchantListDocument = gql`
    query BranchQrisMerchantList($qop: BranchQrisMerchantQopInput) {
  branchQrisMerchants(qop: $qop) {
    items {
      branchQrisMerchantID
      branchID
      branchCode
      branchName
      bankID
      bankName
      providerCode
      nmid
      terminalID
      merchantName
      isActive
      uniqueKey
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useBranchQrisMerchantListQuery(options?: Omit<Urql.UseQueryArgs<BranchQrisMerchantListQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchQrisMerchantListQuery, BranchQrisMerchantListQueryVariables>({ query: BranchQrisMerchantListDocument, ...options });
};
export const BranchQrisMerchantLoadDocument = gql`
    query BranchQrisMerchantLoad($branchQrisMerchantID: UUID!) {
  branchQrisMerchant(branchQrisMerchantID: $branchQrisMerchantID) {
    branchQrisMerchantID
    branchID
    branchCode
    branchName
    bankID
    bankName
    providerCode
    nmid
    terminalID
    merchantName
    isActive
    uniqueKey
    entityAuditMetadata {
      createdAt
      updatedAt
      createdByUserName
      updatedByUserName
    }
  }
}
    `;

export function useBranchQrisMerchantLoadQuery(options: Omit<Urql.UseQueryArgs<BranchQrisMerchantLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchQrisMerchantLoadQuery, BranchQrisMerchantLoadQueryVariables>({ query: BranchQrisMerchantLoadDocument, ...options });
};
export const BranchQrisMerchantUpdateDocument = gql`
    mutation BranchQrisMerchantUpdate($input: BranchQrisMerchantUpdateInput!) {
  branchQrisMerchantUpdate(input: $input) {
    branchQrisMerchantID
    branchID
    branchCode
    branchName
    bankID
    bankName
    providerCode
    nmid
    terminalID
    merchantName
    isActive
  }
}
    `;

export function useBranchQrisMerchantUpdateMutation() {
  return Urql.useMutation<BranchQrisMerchantUpdateMutation, BranchQrisMerchantUpdateMutationVariables>(BranchQrisMerchantUpdateDocument);
};
export const BranchMenuGroupBindingsDocument = gql`
    query BranchMenuGroupBindings($qop: BranchSalesChannelCategoryGroupQopInput) {
  branchSalesChannelCategoryGroups(qop: $qop) {
    items {
      branchSalesChannelCategoryGroupID
      branchID
      salesChannelID
      salesChannelCategoryGroupID
      salesChannelCategoryGroupName
    }
  }
}
    `;

export function useBranchMenuGroupBindingsQuery(options?: Omit<Urql.UseQueryArgs<BranchMenuGroupBindingsQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchMenuGroupBindingsQuery, BranchMenuGroupBindingsQueryVariables>({ query: BranchMenuGroupBindingsDocument, ...options });
};
export const BranchMenuGroupCreateDocument = gql`
    mutation BranchMenuGroupCreate($input: BranchSalesChannelCategoryGroupCreateInput!) {
  branchSalesChannelCategoryGroupCreate(input: $input) {
    branchSalesChannelCategoryGroupID
  }
}
    `;

export function useBranchMenuGroupCreateMutation() {
  return Urql.useMutation<BranchMenuGroupCreateMutation, BranchMenuGroupCreateMutationVariables>(BranchMenuGroupCreateDocument);
};
export const BranchMenuGroupDeleteDocument = gql`
    mutation BranchMenuGroupDelete($id: UUID!) {
  branchSalesChannelCategoryGroupDelete(branchSalesChannelCategoryGroupID: $id)
}
    `;

export function useBranchMenuGroupDeleteMutation() {
  return Urql.useMutation<BranchMenuGroupDeleteMutation, BranchMenuGroupDeleteMutationVariables>(BranchMenuGroupDeleteDocument);
};
export const BranchMenuGroupUpdateDocument = gql`
    mutation BranchMenuGroupUpdate($input: BranchSalesChannelCategoryGroupUpdateInput!) {
  branchSalesChannelCategoryGroupUpdate(input: $input) {
    branchSalesChannelCategoryGroupID
  }
}
    `;

export function useBranchMenuGroupUpdateMutation() {
  return Urql.useMutation<BranchMenuGroupUpdateMutation, BranchMenuGroupUpdateMutationVariables>(BranchMenuGroupUpdateDocument);
};
export const BranchMerchantMapCreateDocument = gql`
    mutation BranchMerchantMapCreate($input: BranchSalesChannelMerchantMapCreateInput!) {
  branchSalesChannelMerchantMapCreate(input: $input) {
    branchSalesChannelMerchantMapID
  }
}
    `;

export function useBranchMerchantMapCreateMutation() {
  return Urql.useMutation<BranchMerchantMapCreateMutation, BranchMerchantMapCreateMutationVariables>(BranchMerchantMapCreateDocument);
};
export const BranchMerchantMapDeleteDocument = gql`
    mutation BranchMerchantMapDelete($id: UUID!) {
  branchSalesChannelMerchantMapDelete(branchSalesChannelMerchantMapID: $id)
}
    `;

export function useBranchMerchantMapDeleteMutation() {
  return Urql.useMutation<BranchMerchantMapDeleteMutation, BranchMerchantMapDeleteMutationVariables>(BranchMerchantMapDeleteDocument);
};
export const BranchMerchantMapListDocument = gql`
    query BranchMerchantMapList($qop: BranchSalesChannelMerchantMapQopInput) {
  branchSalesChannelMerchantMaps(qop: $qop) {
    items {
      branchSalesChannelMerchantMapID
      branchID
      branchCode
      branchName
      salesChannelID
      salesChannelName
      externalMerchantID
      externalStoreID
      isActive
      isPaused
      operatingHours {
        mon {
          ...OperatingHoursDayFields
        }
        tue {
          ...OperatingHoursDayFields
        }
        wed {
          ...OperatingHoursDayFields
        }
        thu {
          ...OperatingHoursDayFields
        }
        fri {
          ...OperatingHoursDayFields
        }
        sat {
          ...OperatingHoursDayFields
        }
        sun {
          ...OperatingHoursDayFields
        }
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
    }
  }
}
    ${OperatingHoursDayFieldsFragmentDoc}`;

export function useBranchMerchantMapListQuery(options?: Omit<Urql.UseQueryArgs<BranchMerchantMapListQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchMerchantMapListQuery, BranchMerchantMapListQueryVariables>({ query: BranchMerchantMapListDocument, ...options });
};
export const BranchMerchantMapOperatingHoursDocument = gql`
    query BranchMerchantMapOperatingHours($branchSalesChannelMerchantMapID: UUID!) {
  branchSalesChannelMerchantMap(
    branchSalesChannelMerchantMapID: $branchSalesChannelMerchantMapID
  ) {
    branchSalesChannelMerchantMapID
    branchID
    branchCode
    branchName
    salesChannelID
    salesChannelName
    externalMerchantID
    externalStoreID
    isPaused
    packagingProductID
    packagingQty
    packagingChargeAmount
    packagingProduct {
      productID
      barcode
      productName
    }
    operatingHours {
      mon {
        ...OperatingHoursDayFields
      }
      tue {
        ...OperatingHoursDayFields
      }
      wed {
        ...OperatingHoursDayFields
      }
      thu {
        ...OperatingHoursDayFields
      }
      fri {
        ...OperatingHoursDayFields
      }
      sat {
        ...OperatingHoursDayFields
      }
      sun {
        ...OperatingHoursDayFields
      }
    }
  }
}
    ${OperatingHoursDayFieldsFragmentDoc}`;

export function useBranchMerchantMapOperatingHoursQuery(options: Omit<Urql.UseQueryArgs<BranchMerchantMapOperatingHoursQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchMerchantMapOperatingHoursQuery, BranchMerchantMapOperatingHoursQueryVariables>({ query: BranchMerchantMapOperatingHoursDocument, ...options });
};
export const BranchMerchantMapUpdateDocument = gql`
    mutation BranchMerchantMapUpdate($input: BranchSalesChannelMerchantMapUpdateInput!) {
  branchSalesChannelMerchantMapUpdate(input: $input) {
    branchSalesChannelMerchantMapID
  }
}
    `;

export function useBranchMerchantMapUpdateMutation() {
  return Urql.useMutation<BranchMerchantMapUpdateMutation, BranchMerchantMapUpdateMutationVariables>(BranchMerchantMapUpdateDocument);
};
export const BranchMerchantMapsDocument = gql`
    query BranchMerchantMaps($branchID: UUID!) {
  branchSalesChannelMerchantMapsByBranch(branchID: $branchID) {
    branchSalesChannelMerchantMapID
    branchID
    salesChannelID
    salesChannelName
    externalMerchantID
    externalStoreID
    gmt
    isActive
    packagingProductID
    packagingQty
    packagingChargeAmount
    packagingProduct {
      productID
      barcode
      productName
    }
  }
}
    `;

export function useBranchMerchantMapsQuery(options: Omit<Urql.UseQueryArgs<BranchMerchantMapsQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchMerchantMapsQuery, BranchMerchantMapsQueryVariables>({ query: BranchMerchantMapsDocument, ...options });
};
export const BranchSalesChannelOperatingHoursUpdateDocument = gql`
    mutation BranchSalesChannelOperatingHoursUpdate($input: BranchSalesChannelOperatingHoursUpdateInput!) {
  branchSalesChannelOperatingHoursUpdate(input: $input) {
    branchSalesChannelMerchantMapID
  }
}
    `;

export function useBranchSalesChannelOperatingHoursUpdateMutation() {
  return Urql.useMutation<BranchSalesChannelOperatingHoursUpdateMutation, BranchSalesChannelOperatingHoursUpdateMutationVariables>(BranchSalesChannelOperatingHoursUpdateDocument);
};
export const BranchSalesChannelPackagingUpdateDocument = gql`
    mutation BranchSalesChannelPackagingUpdate($input: BranchSalesChannelPackagingUpdateInput!) {
  branchSalesChannelPackagingUpdate(input: $input) {
    branchSalesChannelMerchantMapID
  }
}
    `;

export function useBranchSalesChannelPackagingUpdateMutation() {
  return Urql.useMutation<BranchSalesChannelPackagingUpdateMutation, BranchSalesChannelPackagingUpdateMutationVariables>(BranchSalesChannelPackagingUpdateDocument);
};
export const BranchSalesChannelPauseDurationsDocument = gql`
    query BranchSalesChannelPauseDurations($salesChannelID: String!) {
  branchSalesChannelPauseDurations(salesChannelID: $salesChannelID) {
    value
    label
  }
}
    `;

export function useBranchSalesChannelPauseDurationsQuery(options: Omit<Urql.UseQueryArgs<BranchSalesChannelPauseDurationsQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchSalesChannelPauseDurationsQuery, BranchSalesChannelPauseDurationsQueryVariables>({ query: BranchSalesChannelPauseDurationsDocument, ...options });
};
export const BranchSalesChannelPauseUpdateDocument = gql`
    mutation BranchSalesChannelPauseUpdate($input: BranchSalesChannelPauseUpdateInput!) {
  branchSalesChannelPauseUpdate(input: $input) {
    branchSalesChannelMerchantMapID
    isPaused
  }
}
    `;

export function useBranchSalesChannelPauseUpdateMutation() {
  return Urql.useMutation<BranchSalesChannelPauseUpdateMutation, BranchSalesChannelPauseUpdateMutationVariables>(BranchSalesChannelPauseUpdateDocument);
};
export const MarketplaceMenuSyncDocument = gql`
    mutation MarketplaceMenuSync($input: MarketplaceMenuSyncInput!) {
  marketplaceMenuSync(input: $input) {
    syncedCount
    totalCount
    itemCount
    categoryCount
    menuGroupName
    message
  }
}
    `;

export function useMarketplaceMenuSyncMutation() {
  return Urql.useMutation<MarketplaceMenuSyncMutation, MarketplaceMenuSyncMutationVariables>(MarketplaceMenuSyncDocument);
};
export const MarketplaceStoreStatusDocument = gql`
    query MarketplaceStoreStatus($salesChannelID: String!, $externalMerchantID: String!) {
  marketplaceStoreStatus(
    salesChannelID: $salesChannelID
    externalMerchantID: $externalMerchantID
  ) {
    isOpen
    closeReason
    isInSpecialOpeningHourRange
  }
}
    `;

export function useMarketplaceStoreStatusQuery(options: Omit<Urql.UseQueryArgs<MarketplaceStoreStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceStoreStatusQuery, MarketplaceStoreStatusQueryVariables>({ query: MarketplaceStoreStatusDocument, ...options });
};
export const MenuGroupsForBranchDocument = gql`
    query MenuGroupsForBranch($qop: SalesChannelCategoryGroupQopInput) {
  salesChannelCategoryGroups(qop: $qop) {
    items {
      salesChannelCategoryGroupID
      salesChannelCategoryGroupName
    }
  }
}
    `;

export function useMenuGroupsForBranchQuery(options?: Omit<Urql.UseQueryArgs<MenuGroupsForBranchQueryVariables>, 'query'>) {
  return Urql.useQuery<MenuGroupsForBranchQuery, MenuGroupsForBranchQueryVariables>({ query: MenuGroupsForBranchDocument, ...options });
};
export const SalesChannelsForBranchDocument = gql`
    query SalesChannelsForBranch($qop: SalesChannelQopInput) {
  salesChannels(qop: $qop) {
    items {
      salesChannelID
      salesChannelName
      salesChannelType
      useCategoryMap
    }
  }
}
    `;

export function useSalesChannelsForBranchQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelsForBranchQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelsForBranchQuery, SalesChannelsForBranchQueryVariables>({ query: SalesChannelsForBranchDocument, ...options });
};
export const BranchAutocompleteDocument = gql`
    query BranchAutocomplete($qop: BranchQopInput) {
  branches(qop: $qop) {
    items {
      branchID
      branchName
      branchCode
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useBranchAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<BranchAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchAutocompleteQuery, BranchAutocompleteQueryVariables>({ query: BranchAutocompleteDocument, ...options });
};
export const BranchCreateDocument = gql`
    mutation BranchCreate($input: BranchCreateInput!) {
  branchCreate(input: $input) {
    branchID
    branchCode
    branchName
    branchType
    branchCategoryID
    pricelistID
    mainSupplyWarehouseID
    gmt
    canSell
    isMain
    cashJournalAccountCode
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
    country {
      countryID
      countryName
      uniqueKey
      isActive
    }
    province {
      provinceID
      provinceName
      countryID
      uniqueKey
      isActive
    }
    city {
      cityID
      cityName
      gmt
      provinceID
      countryID
      uniqueKey
      isActive
    }
    subdistrict {
      subdistrictID
      subdistrictName
      cityID
      provinceID
      countryID
      uniqueKey
      isActive
    }
  }
}
    `;

export function useBranchCreateMutation() {
  return Urql.useMutation<BranchCreateMutation, BranchCreateMutationVariables>(BranchCreateDocument);
};
export const BranchDeleteDocument = gql`
    mutation branchDelete($branchID: UUID!) {
  branchDelete(branchID: $branchID)
}
    `;

export function useBranchDeleteMutation() {
  return Urql.useMutation<BranchDeleteMutation, BranchDeleteMutationVariables>(BranchDeleteDocument);
};
export const BranchListDocument = gql`
    query branchList($qop: BranchQopInput) {
  branches(qop: $qop) {
    items {
      branchID
      branchCode
      branchName
      branchType
      branchCategoryID
      pricelistID
      productAvailabilityTemplateID
      mainSupplyWarehouseID
      gmt
      picName
      picPhoneNumber
      canSell
      isMain
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
      branchCategory {
        branchCategoryName
      }
      pricelist {
        pricelistId
        pricelistCode
        pricelistName
        isActive
        uniqueKey
      }
      productAvailabilityTemplate {
        productAvailabilityTemplateID
        productAvailabilityTemplateName
        isActive
        uniqueKey
      }
      mainSupplyWarehouse {
        warehouseID
        warehouseCode
        warehouseName
        branchID
        addressLabel
        fullAddress
        countryID
        countryName
        provinceID
        provinceName
        cityID
        cityName
        subdistrictID
        subdistrictName
        postalCode
        longitude
        latitude
        uniqueKey
        isActive
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useBranchListQuery(options?: Omit<Urql.UseQueryArgs<BranchListQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchListQuery, BranchListQueryVariables>({ query: BranchListDocument, ...options });
};
export const BranchLoadDocument = gql`
    query BranchLoad($branchID: UUID!) {
  branch(branchID: $branchID) {
    branchID
    branchCode
    branchName
    branchType
    branchCategoryID
    pricelistID
    productAvailabilityTemplateID
    mainSupplyWarehouseID
    gmt
    picName
    picPhoneNumber
    canSell
    isMain
    cashJournalAccountCode
    cashJournalAccountErpRefID
    cashJournalAccountErpRefName
    pettyCashJournalAccountCode
    pettyCashJournalAccountErpRefID
    pettyCashJournalAccountErpRefName
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
    branchStoreSupervisors {
      branchStoreSupervisorID
      user {
        fullName
      }
      userID
    }
    branchCategory {
      branchCategoryName
    }
    pricelist {
      pricelistId
      pricelistCode
      pricelistName
      isActive
      uniqueKey
    }
    productAvailabilityTemplate {
      productAvailabilityTemplateID
      productAvailabilityTemplateName
      isActive
      uniqueKey
    }
    mainSupplyWarehouse {
      warehouseID
      warehouseCode
      warehouseName
      branchID
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
    country {
      countryID
      countryName
      uniqueKey
      isActive
    }
    province {
      provinceID
      provinceName
      countryID
      uniqueKey
      isActive
    }
    city {
      cityID
      cityName
      gmt
      provinceID
      countryID
      uniqueKey
      isActive
    }
    subdistrict {
      subdistrictID
      subdistrictName
      cityID
      provinceID
      countryID
      uniqueKey
      isActive
    }
    branchSalesPaymentMethods {
      branchSalesPaymentMethodID
      branchID
      paymentMethodID
      uniqueKey
      paymentMethod {
        salesPaymentMethodID
        salesPaymentMethodName
        salesPaymentMethodTypeID
        salesPaymentMethodTypeCode
        uniqueKey
        isActive
      }
    }
    branchPosBookmarks {
      branchPosBookmarkID
      branchID
      posBookmarkID
      uniqueKey
      posBookmark {
        posBookmarkID
        posBookmarkName
        uniqueKey
      }
    }
    edcTerminals {
      edcTerminalID
      edcTerminalName
      serialNumber
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useBranchLoadQuery(options: Omit<Urql.UseQueryArgs<BranchLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchLoadQuery, BranchLoadQueryVariables>({ query: BranchLoadDocument, ...options });
};
export const BranchStoreSupervisorAutocompleteDocument = gql`
    query BranchStoreSupervisorAutocomplete($qop: BranchStoreSupervisorQopInput!) {
  branchStoreSupervisors(qop: $qop) {
    items {
      branchStoreSupervisorID
      branchID
      userID
      user {
        fullName
      }
      uniqueKey
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useBranchStoreSupervisorAutocompleteQuery(options: Omit<Urql.UseQueryArgs<BranchStoreSupervisorAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchStoreSupervisorAutocompleteQuery, BranchStoreSupervisorAutocompleteQueryVariables>({ query: BranchStoreSupervisorAutocompleteDocument, ...options });
};
export const BranchUpdateDocument = gql`
    mutation BranchUpdate($input: BranchUpdateInput!) {
  branchUpdate(input: $input) {
    branchID
    branchCode
    branchName
    branchType
    branchCategoryID
    pricelistID
    mainSupplyWarehouseID
    gmt
    canSell
    isMain
    cashJournalAccountCode
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
  }
}
    `;

export function useBranchUpdateMutation() {
  return Urql.useMutation<BranchUpdateMutation, BranchUpdateMutationVariables>(BranchUpdateDocument);
};
export const CancelConsignmentInvoiceDocument = gql`
    mutation CancelConsignmentInvoice($input: VendorConsignmentInvoiceCancelInput!) {
  cancelConsignmentInvoice(input: $input) {
    vendorConsignmentInvoiceID
    status
    cancelledReason
  }
}
    `;

export function useCancelConsignmentInvoiceMutation() {
  return Urql.useMutation<CancelConsignmentInvoiceMutation, CancelConsignmentInvoiceMutationVariables>(CancelConsignmentInvoiceDocument);
};
export const ConsignmentConfigListDocument = gql`
    query ConsignmentConfigList($qop: VendorConsignmentInvoiceConfigQopInput) {
  vendorConsignmentInvoiceConfigs(qop: $qop) {
    items {
      vendorConsignmentInvoiceConfigID
      vendorID
      vendorName
      cutoffDay
      graceDays
      paymentDueDays
      billCycleType
      billCycleInterval
      billCycleStartDate
      isDefault
      isActive
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useConsignmentConfigListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentConfigListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentConfigListQuery, ConsignmentConfigListQueryVariables>({ query: ConsignmentConfigListDocument, ...options });
};
export const ConsignmentEmailableIdsByPeriodDocument = gql`
    query ConsignmentEmailableIdsByPeriod($qop: VendorConsignmentInvoiceQopInput) {
  vendorConsignmentInvoices(qop: $qop) {
    items {
      vendorConsignmentInvoiceID
      vendorID
      status
    }
    pagination {
      hasNext
      totalRows
    }
  }
}
    `;

export function useConsignmentEmailableIdsByPeriodQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentEmailableIdsByPeriodQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentEmailableIdsByPeriodQuery, ConsignmentEmailableIdsByPeriodQueryVariables>({ query: ConsignmentEmailableIdsByPeriodDocument, ...options });
};
export const ConsignmentSettlementBranchesDocument = gql`
    query ConsignmentSettlementBranches($vendorConsignmentInvoiceID: UUID!) {
  consignmentSettlementBranches(
    vendorConsignmentInvoiceID: $vendorConsignmentInvoiceID
  ) {
    branchID
    branchName
    subtotal
    commissionAmount
    taxAmount
    payout
  }
}
    `;

export function useConsignmentSettlementBranchesQuery(options: Omit<Urql.UseQueryArgs<ConsignmentSettlementBranchesQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementBranchesQuery, ConsignmentSettlementBranchesQueryVariables>({ query: ConsignmentSettlementBranchesDocument, ...options });
};
export const ConsignmentSettlementExportDocument = gql`
    query ConsignmentSettlementExport($vendorConsignmentInvoiceID: UUID!) {
  consignmentSettlementExport(
    vendorConsignmentInvoiceID: $vendorConsignmentInvoiceID
  ) {
    fileName
    downloadURL
  }
}
    `;

export function useConsignmentSettlementExportQuery(options: Omit<Urql.UseQueryArgs<ConsignmentSettlementExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementExportQuery, ConsignmentSettlementExportQueryVariables>({ query: ConsignmentSettlementExportDocument, ...options });
};
export const ConsignmentSettlementHistoryDocument = gql`
    query ConsignmentSettlementHistory($vendorConsignmentInvoiceID: UUID!) {
  consignmentSettlementHistory(
    vendorConsignmentInvoiceID: $vendorConsignmentInvoiceID
  ) {
    vendorConsignmentInvoiceHistoryID
    editedAt
    editedByUserID
    editedByUserName
    reason
    fieldChanges {
      field
      label
      oldValue
      newValue
    }
    branchChanges {
      branchID
      branchName
      field
      label
      oldValue
      newValue
    }
  }
}
    `;

export function useConsignmentSettlementHistoryQuery(options: Omit<Urql.UseQueryArgs<ConsignmentSettlementHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementHistoryQuery, ConsignmentSettlementHistoryQueryVariables>({ query: ConsignmentSettlementHistoryDocument, ...options });
};
export const ConsignmentSettlementItemsDocument = gql`
    query ConsignmentSettlementItems($qop: SalesConsignmentInvoiceItemQopInput) {
  salesConsignmentInvoiceItems(qop: $qop) {
    items {
      salesConsignmentInvoiceItemID
      salesInvoiceNumber
      productCode
      productName
      barcode
      qty
      uomName
      unitPrice
      total
      discountType
      discountPerc
      discountPercPlus
      discountAmount
      additionalDiscountPerc
      additionalDiscountAmount
      salesInvoiceItem {
        promoType
        promoParentProductID
      }
      commissionAmount
      commissionInclTaxAmount
      consignmentVendorTotal
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useConsignmentSettlementItemsQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentSettlementItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementItemsQuery, ConsignmentSettlementItemsQueryVariables>({ query: ConsignmentSettlementItemsDocument, ...options });
};
export const ConsignmentSettlementListDocument = gql`
    query ConsignmentSettlementList($qop: VendorConsignmentInvoiceQopInput) {
  vendorConsignmentInvoices(qop: $qop) {
    items {
      vendorConsignmentInvoiceID
      vendorConsignmentInvoiceNumber
      vendorID
      vendorName
      vendor {
        vendorCode
        vendorConsignmentBranch {
          isRent
          currentPeriod {
            rentalStatus
          }
        }
      }
      cutoffDate
      periodStartDate
      periodEndDate
      paymentDueDate
      status
      isManual
      sourceInvoiceCount
      totalItemQty
      subtotal
      discountAmount
      taxAmount
      commissionAmount
      returnsAdjustmentAmount
      vendorPayoutTotal
      emailStatus
      emailSentAt
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useConsignmentSettlementListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentSettlementListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementListQuery, ConsignmentSettlementListQueryVariables>({ query: ConsignmentSettlementListDocument, ...options });
};
export const ConsignmentSettlementListExportDocument = gql`
    query ConsignmentSettlementListExport($filter: ConsignmentSettlementListExportFilterInput!) {
  consignmentSettlementListExport(filter: $filter) {
    fileName
    downloadURL
  }
}
    `;

export function useConsignmentSettlementListExportQuery(options: Omit<Urql.UseQueryArgs<ConsignmentSettlementListExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementListExportQuery, ConsignmentSettlementListExportQueryVariables>({ query: ConsignmentSettlementListExportDocument, ...options });
};
export const ConsignmentSettlementLoadDocument = gql`
    query ConsignmentSettlementLoad($vendorConsignmentInvoiceID: UUID!) {
  vendorConsignmentInvoice(
    vendorConsignmentInvoiceID: $vendorConsignmentInvoiceID
  ) {
    vendorConsignmentInvoiceID
    vendorConsignmentInvoiceNumber
    vendorConsignmentInvoiceDatetime
    vendorID
    vendorName
    vendor {
      isPKP
      vendorConsignmentBranch {
        branchID
        isRent
        currentPeriod {
          rentalStatus
          effectiveStartDate
          effectiveEndDate
        }
      }
    }
    cutoffDay
    cutoffDate
    periodStartDate
    periodEndDate
    paymentDueDate
    status
    sourceInvoiceCount
    totalItemQty
    subtotal
    discountAmount
    taxAmount
    commissionAmount
    returnsAdjustmentAmount
    vendorPayoutTotal
    chargeAmount
    transferFeeAmount
    totalPayableAmount
    payoutBankID
    payoutBankName
    payoutBankAccountNumber
    settlementBankAccountID
    settlementBankName
    settlementBankAccountName
    settlementBankAccountNumber
    paidByUserName
    paidAt
    paidReference
    cancelledReason
    cancelledByUserName
    cancelledAt
    noteInternal
    emailStatus
    emailSentAt
    isManual
    manualByUserName
    manualAt
    manualReason
  }
}
    `;

export function useConsignmentSettlementLoadQuery(options: Omit<Urql.UseQueryArgs<ConsignmentSettlementLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementLoadQuery, ConsignmentSettlementLoadQueryVariables>({ query: ConsignmentSettlementLoadDocument, ...options });
};
export const ConsignmentSettlementPeriodsDocument = gql`
    query ConsignmentSettlementPeriods {
  consignmentSettlementPeriods {
    periodStartDate
    periodEndDate
    totalCount
    emailableCount
    sentCount
    totalCommission
    totalPayout
  }
}
    `;

export function useConsignmentSettlementPeriodsQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentSettlementPeriodsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementPeriodsQuery, ConsignmentSettlementPeriodsQueryVariables>({ query: ConsignmentSettlementPeriodsDocument, ...options });
};
export const ConsignmentSettlementPivotDocument = gql`
    query ConsignmentSettlementPivot($vendorConsignmentInvoiceID: UUID!) {
  consignmentSettlementPivot(
    vendorConsignmentInvoiceID: $vendorConsignmentInvoiceID
  ) {
    productID
    productCode
    productName
    barcode
    branchID
    branch {
      branchName
    }
    qty
    total
    commissionAmount
    vendorShareAmount
  }
}
    `;

export function useConsignmentSettlementPivotQuery(options: Omit<Urql.UseQueryArgs<ConsignmentSettlementPivotQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementPivotQuery, ConsignmentSettlementPivotQueryVariables>({ query: ConsignmentSettlementPivotDocument, ...options });
};
export const ConsignmentSettlementSummaryDocument = gql`
    query ConsignmentSettlementSummary($qop: VendorConsignmentInvoiceQopInput) {
  vendorConsignmentInvoiceSummary(qop: $qop) {
    count
    draftCount
    proformaCount
    emailableCount
    totalSubtotal
    totalCommissionAmount
    totalTaxAmount
    totalVendorPayoutTotal
  }
}
    `;

export function useConsignmentSettlementSummaryQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentSettlementSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentSettlementSummaryQuery, ConsignmentSettlementSummaryQueryVariables>({ query: ConsignmentSettlementSummaryDocument, ...options });
};
export const CreateConsignmentConfigDocument = gql`
    mutation CreateConsignmentConfig($input: VendorConsignmentInvoiceConfigCreateInput!) {
  vendorConsignmentInvoiceConfigCreate(input: $input) {
    vendorConsignmentInvoiceConfigID
  }
}
    `;

export function useCreateConsignmentConfigMutation() {
  return Urql.useMutation<CreateConsignmentConfigMutation, CreateConsignmentConfigMutationVariables>(CreateConsignmentConfigDocument);
};
export const CreateManualConsignmentProformaDocument = gql`
    mutation CreateManualConsignmentProforma($input: CreateManualConsignmentProformaInput!) {
  createManualConsignmentProforma(input: $input) {
    vendorConsignmentInvoiceID
    vendorConsignmentInvoiceNumber
    status
  }
}
    `;

export function useCreateManualConsignmentProformaMutation() {
  return Urql.useMutation<CreateManualConsignmentProformaMutation, CreateManualConsignmentProformaMutationVariables>(CreateManualConsignmentProformaDocument);
};
export const EditConsignmentSettlementDocument = gql`
    mutation EditConsignmentSettlement($input: EditConsignmentSettlementInput!) {
  editConsignmentSettlement(input: $input) {
    vendorConsignmentInvoiceID
    commissionAmount
    vendorPayoutTotal
    periodStartDate
    periodEndDate
    isManual
    manualByUserName
    manualAt
    manualReason
  }
}
    `;

export function useEditConsignmentSettlementMutation() {
  return Urql.useMutation<EditConsignmentSettlementMutation, EditConsignmentSettlementMutationVariables>(EditConsignmentSettlementDocument);
};
export const GenerateConsignmentInvoiceDocument = gql`
    mutation GenerateConsignmentInvoice($input: GenerateConsignmentInvoiceInput!) {
  generateConsignmentInvoice(input: $input) {
    vendorConsignmentInvoiceID
    vendorConsignmentInvoiceNumber
    status
    payoutBankName
    payoutBankAccountNumber
  }
}
    `;

export function useGenerateConsignmentInvoiceMutation() {
  return Urql.useMutation<GenerateConsignmentInvoiceMutation, GenerateConsignmentInvoiceMutationVariables>(GenerateConsignmentInvoiceDocument);
};
export const GenerateConsignmentInvoicesBulkDocument = gql`
    mutation GenerateConsignmentInvoicesBulk($ids: [UUID!]!, $payoutBanks: [ConsignmentPayoutBankInput!]) {
  generateConsignmentInvoicesBulk(
    vendorConsignmentInvoiceIDs: $ids
    payoutBanks: $payoutBanks
  ) {
    vendorConsignmentInvoiceID
    success
    error
  }
}
    `;

export function useGenerateConsignmentInvoicesBulkMutation() {
  return Urql.useMutation<GenerateConsignmentInvoicesBulkMutation, GenerateConsignmentInvoicesBulkMutationVariables>(GenerateConsignmentInvoicesBulkDocument);
};
export const LockConsignmentDraftToProformaDocument = gql`
    mutation LockConsignmentDraftToProforma($vendorConsignmentInvoiceID: UUID!) {
  lockConsignmentDraftToProforma(
    vendorConsignmentInvoiceID: $vendorConsignmentInvoiceID
  ) {
    vendorConsignmentInvoiceID
    vendorConsignmentInvoiceNumber
    status
  }
}
    `;

export function useLockConsignmentDraftToProformaMutation() {
  return Urql.useMutation<LockConsignmentDraftToProformaMutation, LockConsignmentDraftToProformaMutationVariables>(LockConsignmentDraftToProformaDocument);
};
export const MarkConsignmentInvoicePaidDocument = gql`
    mutation MarkConsignmentInvoicePaid($input: VendorConsignmentInvoicePayInput!) {
  markConsignmentInvoicePaid(input: $input) {
    vendorConsignmentInvoiceID
    status
    paidAt
    paidReference
    settlementBankName
  }
}
    `;

export function useMarkConsignmentInvoicePaidMutation() {
  return Urql.useMutation<MarkConsignmentInvoicePaidMutation, MarkConsignmentInvoicePaidMutationVariables>(MarkConsignmentInvoicePaidDocument);
};
export const MarkConsignmentInvoicesPaidBulkDocument = gql`
    mutation MarkConsignmentInvoicesPaidBulk($input: MarkConsignmentInvoicesPaidBulkInput!) {
  markConsignmentInvoicesPaidBulk(input: $input) {
    vendorConsignmentInvoiceID
    success
    error
  }
}
    `;

export function useMarkConsignmentInvoicesPaidBulkMutation() {
  return Urql.useMutation<MarkConsignmentInvoicesPaidBulkMutation, MarkConsignmentInvoicesPaidBulkMutationVariables>(MarkConsignmentInvoicesPaidBulkDocument);
};
export const MoveConsignmentItemsDocument = gql`
    mutation MoveConsignmentItems($input: MoveConsignmentItemsInput!) {
  moveConsignmentItems(input: $input) {
    vendorConsignmentInvoiceID
    status
    subtotal
    commissionAmount
    vendorPayoutTotal
    totalPayableAmount
    totalItemQty
  }
}
    `;

export function useMoveConsignmentItemsMutation() {
  return Urql.useMutation<MoveConsignmentItemsMutation, MoveConsignmentItemsMutationVariables>(MoveConsignmentItemsDocument);
};
export const RecalculateAllConsignmentProformasDocument = gql`
    mutation RecalculateAllConsignmentProformas {
  recalculateAllConsignmentProformas
}
    `;

export function useRecalculateAllConsignmentProformasMutation() {
  return Urql.useMutation<RecalculateAllConsignmentProformasMutation, RecalculateAllConsignmentProformasMutationVariables>(RecalculateAllConsignmentProformasDocument);
};
export const RecalculateConsignmentProformaDocument = gql`
    mutation RecalculateConsignmentProforma($vendorConsignmentInvoiceID: UUID!) {
  recalculateConsignmentProforma(
    vendorConsignmentInvoiceID: $vendorConsignmentInvoiceID
  ) {
    vendorConsignmentInvoiceID
    status
    chargeAmount
    transferFeeAmount
    totalPayableAmount
  }
}
    `;

export function useRecalculateConsignmentProformaMutation() {
  return Urql.useMutation<RecalculateConsignmentProformaMutation, RecalculateConsignmentProformaMutationVariables>(RecalculateConsignmentProformaDocument);
};
export const RecomputeConsignmentDraftsDocument = gql`
    mutation RecomputeConsignmentDrafts {
  recomputeConsignmentDrafts
}
    `;

export function useRecomputeConsignmentDraftsMutation() {
  return Urql.useMutation<RecomputeConsignmentDraftsMutation, RecomputeConsignmentDraftsMutationVariables>(RecomputeConsignmentDraftsDocument);
};
export const SalesConsignmentInvoicesForMoveDocument = gql`
    query SalesConsignmentInvoicesForMove($qop: SalesConsignmentInvoiceQopInput) {
  salesConsignmentInvoices(qop: $qop) {
    items {
      salesConsignmentInvoiceID
      salesConsignmentInvoiceNumber
      salesConsignmentInvoiceDatetime
      totalItemQty
      subtotal
      commissionAmount
      consignmentVendorTotal
      status
      vendorConsignmentInvoiceID
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useSalesConsignmentInvoicesForMoveQuery(options?: Omit<Urql.UseQueryArgs<SalesConsignmentInvoicesForMoveQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesConsignmentInvoicesForMoveQuery, SalesConsignmentInvoicesForMoveQueryVariables>({ query: SalesConsignmentInvoicesForMoveDocument, ...options });
};
export const SendConsignmentInvoiceEmailDocument = gql`
    mutation SendConsignmentInvoiceEmail($vendorConsignmentInvoiceID: UUID!) {
  sendConsignmentInvoiceEmail(
    vendorConsignmentInvoiceID: $vendorConsignmentInvoiceID
  ) {
    vendorConsignmentInvoiceID
    status
    chargeAmount
    transferFeeAmount
    totalPayableAmount
  }
}
    `;

export function useSendConsignmentInvoiceEmailMutation() {
  return Urql.useMutation<SendConsignmentInvoiceEmailMutation, SendConsignmentInvoiceEmailMutationVariables>(SendConsignmentInvoiceEmailDocument);
};
export const SendConsignmentInvoiceEmailsBulkDocument = gql`
    mutation SendConsignmentInvoiceEmailsBulk($ids: [UUID!]!) {
  sendConsignmentInvoiceEmailsBulk(vendorConsignmentInvoiceIDs: $ids) {
    vendorConsignmentInvoiceID
    success
    error
  }
}
    `;

export function useSendConsignmentInvoiceEmailsBulkMutation() {
  return Urql.useMutation<SendConsignmentInvoiceEmailsBulkMutation, SendConsignmentInvoiceEmailsBulkMutationVariables>(SendConsignmentInvoiceEmailsBulkDocument);
};
export const UpdateConsignmentConfigDocument = gql`
    mutation UpdateConsignmentConfig($input: VendorConsignmentInvoiceConfigUpdateInput!) {
  vendorConsignmentInvoiceConfigUpdate(input: $input) {
    vendorConsignmentInvoiceConfigID
  }
}
    `;

export function useUpdateConsignmentConfigMutation() {
  return Urql.useMutation<UpdateConsignmentConfigMutation, UpdateConsignmentConfigMutationVariables>(UpdateConsignmentConfigDocument);
};
export const VendorConsignmentBranchAutocompleteDocument = gql`
    query VendorConsignmentBranchAutocomplete($qop: VendorConsignmentBranchQopInput) {
  vendorConsignmentBranches(qop: $qop) {
    items {
      vendorConsignmentBranchID
      vendorID
      branchID
      branchCode
      branchName
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorConsignmentBranchAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<VendorConsignmentBranchAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentBranchAutocompleteQuery, VendorConsignmentBranchAutocompleteQueryVariables>({ query: VendorConsignmentBranchAutocompleteDocument, ...options });
};
export const VendorConsignmentInvoiceEmailPreviewDocument = gql`
    query VendorConsignmentInvoiceEmailPreview($id: UUID!) {
  vendorConsignmentInvoiceEmailPreview(vendorConsignmentInvoiceID: $id)
}
    `;

export function useVendorConsignmentInvoiceEmailPreviewQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentInvoiceEmailPreviewQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentInvoiceEmailPreviewQuery, VendorConsignmentInvoiceEmailPreviewQueryVariables>({ query: VendorConsignmentInvoiceEmailPreviewDocument, ...options });
};
export const VendorPayoutBankDocument = gql`
    query VendorPayoutBank($vendorID: UUID!) {
  vendor(vendorID: $vendorID) {
    vendorID
    vendorName
    bankID
    bankName
    bankAccountName
    bankAccountNumber
  }
}
    `;

export function useVendorPayoutBankQuery(options: Omit<Urql.UseQueryArgs<VendorPayoutBankQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorPayoutBankQuery, VendorPayoutBankQueryVariables>({ query: VendorPayoutBankDocument, ...options });
};
export const ConsignmentStockInRequestApproveDocument = gql`
    mutation ConsignmentStockInRequestApprove($input: ConsignmentStockInRequestApproveInput!) {
  consignmentStockInRequestApprove(input: $input) {
    consignmentStockInRequestID
    status
    consignmentStockInID
    consignmentStockInNumber
    consignmentStockOutID
    consignmentStockOutNumber
  }
}
    `;

export function useConsignmentStockInRequestApproveMutation() {
  return Urql.useMutation<ConsignmentStockInRequestApproveMutation, ConsignmentStockInRequestApproveMutationVariables>(ConsignmentStockInRequestApproveDocument);
};
export const ConsignmentStockInRequestFilesDocument = gql`
    query ConsignmentStockInRequestFiles($qop: ConsignmentStockInRequestFileQopInput) {
  consignmentStockInRequestFiles(qop: $qop) {
    items {
      consignmentStockInRequestFileID
      consignmentStockInRequestID
      consignmentStockInRequestFileRole
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useConsignmentStockInRequestFilesQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentStockInRequestFilesQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockInRequestFilesQuery, ConsignmentStockInRequestFilesQueryVariables>({ query: ConsignmentStockInRequestFilesDocument, ...options });
};
export const ConsignmentStockInRequestItemsDocument = gql`
    query ConsignmentStockInRequestItems($qop: ConsignmentStockInRequestItemQopInput) {
  consignmentStockInRequestItems(qop: $qop) {
    items {
      consignmentStockInRequestItemID
      consignmentStockInRequestID
      productID
      productCode
      productName
      qtyRequested
      expiredDate
      qtyReceived
      qtyOutstanding
      qtyApproved
      expiredDateConfirmed
      receivingReason
      noteReason
      noteRequester
      uomID
      uomName
      uomDecimal
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useConsignmentStockInRequestItemsQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentStockInRequestItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockInRequestItemsQuery, ConsignmentStockInRequestItemsQueryVariables>({ query: ConsignmentStockInRequestItemsDocument, ...options });
};
export const ConsignmentStockInRequestListDocument = gql`
    query ConsignmentStockInRequestList($qop: ConsignmentStockInRequestQopInput) {
  consignmentStockInRequests(qop: $qop) {
    items {
      consignmentStockInRequestID
      consignmentStockInRequestNumber
      requestDatetime
      estimatedDeliveryDate
      vendorID
      vendorName
      branchID
      branchName
      totalItemQtyRequested
      totalItemQtyApproved
      status
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useConsignmentStockInRequestListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentStockInRequestListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockInRequestListQuery, ConsignmentStockInRequestListQueryVariables>({ query: ConsignmentStockInRequestListDocument, ...options });
};
export const ConsignmentStockInRequestLoadDocument = gql`
    query ConsignmentStockInRequestLoad($consignmentStockInRequestID: UUID!) {
  consignmentStockInRequest(
    consignmentStockInRequestID: $consignmentStockInRequestID
  ) {
    consignmentStockInRequestID
    consignmentStockInRequestNumber
    requestDatetime
    estimatedDeliveryDate
    vendorID
    vendorCode
    vendorName
    branchID
    branchCode
    branchName
    noteAdditional
    totalItemQtyRequested
    totalItemQtyApproved
    submittedDatetime
    submittedByUserName
    approvedDatetime
    approvedByUserName
    rejectedDatetime
    rejectedByUserName
    rejectionReason
    consignmentStockInID
    consignmentStockInNumber
    consignmentStockOutID
    consignmentStockOutNumber
    status
  }
}
    `;

export function useConsignmentStockInRequestLoadQuery(options: Omit<Urql.UseQueryArgs<ConsignmentStockInRequestLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockInRequestLoadQuery, ConsignmentStockInRequestLoadQueryVariables>({ query: ConsignmentStockInRequestLoadDocument, ...options });
};
export const ConsignmentStockInRequestReceivingInfoDocument = gql`
    query ConsignmentStockInRequestReceivingInfo($consignmentStockInID: UUID!) {
  consignmentStockIn(consignmentStockInID: $consignmentStockInID) {
    consignmentStockInID
    consignmentStockInNumber
    receivedByName
    warehouseID
    warehouseLocationID
    warehouse {
      warehouseID
      warehouseName
    }
    warehouseLocation {
      warehouseLocationID
      warehouseLocationName
    }
  }
}
    `;

export function useConsignmentStockInRequestReceivingInfoQuery(options: Omit<Urql.UseQueryArgs<ConsignmentStockInRequestReceivingInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockInRequestReceivingInfoQuery, ConsignmentStockInRequestReceivingInfoQueryVariables>({ query: ConsignmentStockInRequestReceivingInfoDocument, ...options });
};
export const ConsignmentStockInRequestRejectDocument = gql`
    mutation ConsignmentStockInRequestReject($input: ConsignmentStockInRequestRejectInput!) {
  consignmentStockInRequestReject(input: $input) {
    consignmentStockInRequestID
    status
    rejectionReason
  }
}
    `;

export function useConsignmentStockInRequestRejectMutation() {
  return Urql.useMutation<ConsignmentStockInRequestRejectMutation, ConsignmentStockInRequestRejectMutationVariables>(ConsignmentStockInRequestRejectDocument);
};
export const ConsignmentStockInRequestSummaryDocument = gql`
    query ConsignmentStockInRequestSummary($vendorID: UUID, $branchID: UUID, $branchIDs: [UUID!]) {
  consignmentStockInRequestSummary(
    vendorID: $vendorID
    branchID: $branchID
    branchIDs: $branchIDs
  ) {
    totalRequest
    pending
    approved
    rejected
  }
}
    `;

export function useConsignmentStockInRequestSummaryQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentStockInRequestSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockInRequestSummaryQuery, ConsignmentStockInRequestSummaryQueryVariables>({ query: ConsignmentStockInRequestSummaryDocument, ...options });
};
export const ConsignmentStockInCancelDocument = gql`
    mutation ConsignmentStockInCancel($consignmentStockInID: UUID!) {
  consignmentStockInCancel(consignmentStockInID: $consignmentStockInID)
}
    `;

export function useConsignmentStockInCancelMutation() {
  return Urql.useMutation<ConsignmentStockInCancelMutation, ConsignmentStockInCancelMutationVariables>(ConsignmentStockInCancelDocument);
};
export const ConsignmentStockInConfirmDocument = gql`
    mutation ConsignmentStockInConfirm($consignmentStockInID: UUID!) {
  consignmentStockInConfirm(consignmentStockInID: $consignmentStockInID) {
    consignmentStockInID
  }
}
    `;

export function useConsignmentStockInConfirmMutation() {
  return Urql.useMutation<ConsignmentStockInConfirmMutation, ConsignmentStockInConfirmMutationVariables>(ConsignmentStockInConfirmDocument);
};
export const ConsignmentStockInCreateDocument = gql`
    mutation ConsignmentStockInCreate($input: ConsignmentStockInCreateInput!) {
  consignmentStockInCreate(input: $input) {
    branchID
    consignmentStockInNumber
    consignmentStockInDatetime
    vendorID
    warehouseID
    warehouseLocationID
    receivedByName
    externalReferenceNumber
    noteInternal
  }
}
    `;

export function useConsignmentStockInCreateMutation() {
  return Urql.useMutation<ConsignmentStockInCreateMutation, ConsignmentStockInCreateMutationVariables>(ConsignmentStockInCreateDocument);
};
export const ConsignmentStockInItemsDocument = gql`
    query ConsignmentStockInItems($qop: ConsignmentStockInItemQopInput) {
  consignmentStockInItems(qop: $qop) {
    items {
      consignmentStockInItemID
      consignmentStockInID
      productID
      productCode
      productName
      product {
        barcode
      }
      description
      productWeight
      qtyReceived
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConvertionDecimal
      baseUomQty
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useConsignmentStockInItemsQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentStockInItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockInItemsQuery, ConsignmentStockInItemsQueryVariables>({ query: ConsignmentStockInItemsDocument, ...options });
};
export const ConsignmentStockInListDocument = gql`
    query ConsignmentStockInList($qop: ConsignmentStockInQopInput) {
  consignmentStockIns(qop: $qop) {
    items {
      consignmentStockInID
      consignmentStockInNumber
      consignmentStockInDatetime
      branchID
      gmt
      vendorID
      warehouseID
      warehouseLocationID
      externalReferenceNumber
      receivedByName
      totalItemQtyReceived
      totalItemWeightReceived
      noteInternal
      status
      vendor {
        vendorName
      }
      warehouse {
        warehouseName
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useConsignmentStockInListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentStockInListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockInListQuery, ConsignmentStockInListQueryVariables>({ query: ConsignmentStockInListDocument, ...options });
};
export const ConsignmentStockInLoadDocument = gql`
    query ConsignmentStockInLoad($consignmentStockInID: UUID!) {
  consignmentStockIn(consignmentStockInID: $consignmentStockInID) {
    consignmentStockInID
    consignmentStockInDatetime
    consignmentStockInNumber
    branchID
    gmt
    vendorID
    warehouseID
    warehouseLocationID
    vendor {
      vendorID
      vendorCode
      vendorName
      vendorCategoryID
      email
      phoneNumber
      npwp
      npwpCompanyName
      taxpayerIDNumber
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      isPKP
      taxable
      taxIncluded
      canBeReturned
      isConsignment
      consignmentCommisionFeePerc
      consignmentPeriodStartDate
      consignmentPeriodEndDate
      hasPortalAccess
      portalSuperadminFirstName
      portalSuperadminLastName
      portalSuperadminEmail
      portalAccountActivated
      uniqueKey
      isActive
    }
    warehouse {
      warehouseID
      warehouseCode
      warehouseName
      branchID
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
    warehouseLocation {
      warehouseLocationID
      warehouseLocationName
      warehouseLocationType
      warehouseStorageType
      warehouseID
      branchID
      parentWarehouseLocationID
      warehouseLocationGroupID
      isHoldInventory
      uniqueKey
      isActive
      isSystemGenerated
    }
    receivedByName
    externalReferenceNumber
    totalItemQtyReceived
    files {
      consignmentStockInFileID
      consignmentStockInID
      consignmentStockInFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    status
    noteInternal
    totalItemWeightReceived
  }
}
    `;

export function useConsignmentStockInLoadQuery(options: Omit<Urql.UseQueryArgs<ConsignmentStockInLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockInLoadQuery, ConsignmentStockInLoadQueryVariables>({ query: ConsignmentStockInLoadDocument, ...options });
};
export const ConsignmentStockInUpdateDocument = gql`
    mutation ConsignmentStockInUpdate($input: ConsignmentStockInUpdateInput!) {
  consignmentStockInUpdate(input: $input) {
    consignmentStockInID
  }
}
    `;

export function useConsignmentStockInUpdateMutation() {
  return Urql.useMutation<ConsignmentStockInUpdateMutation, ConsignmentStockInUpdateMutationVariables>(ConsignmentStockInUpdateDocument);
};
export const ConsignmentStockOutCancelDocument = gql`
    mutation consignmentStockOutCancel($consignmentStockOutID: UUID!) {
  consignmentStockOutCancel(consignmentStockOutID: $consignmentStockOutID)
}
    `;

export function useConsignmentStockOutCancelMutation() {
  return Urql.useMutation<ConsignmentStockOutCancelMutation, ConsignmentStockOutCancelMutationVariables>(ConsignmentStockOutCancelDocument);
};
export const ConsignmentStockOutConfirmDocument = gql`
    mutation consignmentStockOutConfirm($consignmentStockOutID: UUID!) {
  consignmentStockOutConfirm(consignmentStockOutID: $consignmentStockOutID) {
    consignmentStockOutID
  }
}
    `;

export function useConsignmentStockOutConfirmMutation() {
  return Urql.useMutation<ConsignmentStockOutConfirmMutation, ConsignmentStockOutConfirmMutationVariables>(ConsignmentStockOutConfirmDocument);
};
export const ConsignmentStockOutCreateDocument = gql`
    mutation consignmentStockOutCreate($input: ConsignmentStockOutCreateInput!) {
  consignmentStockOutCreate(input: $input) {
    branchID
    consignmentStockOutNumber
    consignmentStockOutDatetime
    vendorID
    warehouseID
    warehouseLocationID
    receivedByVendorName
    externalReferenceNumber
    noteInternal
  }
}
    `;

export function useConsignmentStockOutCreateMutation() {
  return Urql.useMutation<ConsignmentStockOutCreateMutation, ConsignmentStockOutCreateMutationVariables>(ConsignmentStockOutCreateDocument);
};
export const ConsignmentStockOutItemsDocument = gql`
    query ConsignmentStockOutItems($qop: ConsignmentStockOutItemQopInput) {
  consignmentStockOutItems(qop: $qop) {
    items {
      consignmentStockOutItemID
      consignmentStockOutID
      productID
      productCode
      productName
      product {
        barcode
      }
      description
      productWeight
      qty
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConvertionDecimal
      baseUomQty
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useConsignmentStockOutItemsQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentStockOutItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockOutItemsQuery, ConsignmentStockOutItemsQueryVariables>({ query: ConsignmentStockOutItemsDocument, ...options });
};
export const ConsignmentStockOutListDocument = gql`
    query ConsignmentStockOutList($qop: ConsignmentStockOutQopInput) {
  consignmentStockOuts(qop: $qop) {
    items {
      consignmentStockOutID
      consignmentStockOutNumber
      consignmentStockOutDatetime
      branchID
      gmt
      vendorID
      warehouseID
      warehouseLocationID
      externalReferenceNumber
      receivedByVendorName
      totalItemQty
      totalItemWeight
      noteInternal
      status
      vendor {
        vendorName
      }
      warehouse {
        warehouseName
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useConsignmentStockOutListQuery(options?: Omit<Urql.UseQueryArgs<ConsignmentStockOutListQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockOutListQuery, ConsignmentStockOutListQueryVariables>({ query: ConsignmentStockOutListDocument, ...options });
};
export const ConsignmentStockOutLoadDocument = gql`
    query ConsignmentStockOutLoad($consignmentStockOutID: UUID!) {
  consignmentStockOut(consignmentStockOutID: $consignmentStockOutID) {
    consignmentStockOutID
    consignmentStockOutDatetime
    consignmentStockOutNumber
    branchID
    gmt
    vendorID
    warehouseID
    warehouseLocationID
    vendor {
      vendorID
      vendorCode
      vendorName
      vendorCategoryID
      email
      phoneNumber
      npwp
      npwpCompanyName
      taxpayerIDNumber
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      isPKP
      taxable
      taxIncluded
      canBeReturned
      isConsignment
      consignmentCommisionFeePerc
      consignmentPeriodStartDate
      consignmentPeriodEndDate
      hasPortalAccess
      portalSuperadminFirstName
      portalSuperadminLastName
      portalSuperadminEmail
      portalAccountActivated
      uniqueKey
      isActive
    }
    warehouse {
      warehouseID
      warehouseCode
      warehouseName
      branchID
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
    warehouseLocation {
      warehouseLocationID
      warehouseLocationName
      warehouseLocationType
      warehouseStorageType
      warehouseID
      branchID
      parentWarehouseLocationID
      warehouseLocationGroupID
      isHoldInventory
      uniqueKey
      isActive
      isSystemGenerated
    }
    receivedByVendorName
    externalReferenceNumber
    totalItemQty
    files {
      consignmentStockOutFileID
      consignmentStockOutID
      consignmentStockOutFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    status
    noteInternal
    totalItemWeight
  }
}
    `;

export function useConsignmentStockOutLoadQuery(options: Omit<Urql.UseQueryArgs<ConsignmentStockOutLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentStockOutLoadQuery, ConsignmentStockOutLoadQueryVariables>({ query: ConsignmentStockOutLoadDocument, ...options });
};
export const ConsignmentStockOutUpdateDocument = gql`
    mutation ConsignmentStockOutUpdate($input: ConsignmentStockOutUpdateInput!) {
  consignmentStockOutUpdate(input: $input) {
    consignmentStockOutID
  }
}
    `;

export function useConsignmentStockOutUpdateMutation() {
  return Urql.useMutation<ConsignmentStockOutUpdateMutation, ConsignmentStockOutUpdateMutationVariables>(ConsignmentStockOutUpdateDocument);
};
export const CustomerAutocompleteDocument = gql`
    query CustomerAutocomplete($qop: CustomerQopInput!) {
  customers(qop: $qop) {
    items {
      customerID
      customerCode
      customerName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useCustomerAutocompleteQuery(options: Omit<Urql.UseQueryArgs<CustomerAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<CustomerAutocompleteQuery, CustomerAutocompleteQueryVariables>({ query: CustomerAutocompleteDocument, ...options });
};
export const CustomerCreateDocument = gql`
    mutation CustomerCreate($input: CustomerCreateInput!) {
  customerCreate(input: $input) {
    customerID
    customerCode
    customerName
  }
}
    `;

export function useCustomerCreateMutation() {
  return Urql.useMutation<CustomerCreateMutation, CustomerCreateMutationVariables>(CustomerCreateDocument);
};
export const CustomerDeleteDocument = gql`
    mutation CustomerDelete($customerID: UUID!) {
  customerDelete(customerID: $customerID)
}
    `;

export function useCustomerDeleteMutation() {
  return Urql.useMutation<CustomerDeleteMutation, CustomerDeleteMutationVariables>(CustomerDeleteDocument);
};
export const CustomerListDocument = gql`
    query CustomerList($qop: CustomerQopInput!) {
  customers(qop: $qop) {
    items {
      customerID
      customerCode
      customerName
      memberTypeID
      memberType {
        memberTypeID
        memberTypeName
        spendPerPoint
      }
      isMember
      email
      phoneNumber
      memberPoints
      gender
      joinDate
      isDefault
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useCustomerListQuery(options: Omit<Urql.UseQueryArgs<CustomerListQueryVariables>, 'query'>) {
  return Urql.useQuery<CustomerListQuery, CustomerListQueryVariables>({ query: CustomerListDocument, ...options });
};
export const CustomerLoadDocument = gql`
    query CustomerLoad($customerID: UUID!) {
  customer(customerID: $customerID) {
    customerID
    customerCode
    customerName
    memberTypeID
    isMember
    email
    phoneNumber
    memberPoints
    gender
    joinDate
    isDefault
    uniqueKey
    isActive
    memberType {
      memberTypeID
      memberTypeName
      spendPerPoint
      uniqueKey
      isActive
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
    addresses {
      customerAddressID
      customerID
      isMain
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
  }
}
    `;

export function useCustomerLoadQuery(options: Omit<Urql.UseQueryArgs<CustomerLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<CustomerLoadQuery, CustomerLoadQueryVariables>({ query: CustomerLoadDocument, ...options });
};
export const CustomerUpdateDocument = gql`
    mutation CustomerUpdate($input: CustomerUpdateInput!) {
  customerUpdate(input: $input) {
    customerID
    customerCode
    customerName
  }
}
    `;

export function useCustomerUpdateMutation() {
  return Urql.useMutation<CustomerUpdateMutation, CustomerUpdateMutationVariables>(CustomerUpdateDocument);
};
export const ContainerContentSearchContainerDocument = gql`
    query ContainerContentSearchContainer($qop: OutboundContainerQopInput!) {
  outboundContainers(qop: $qop) {
    items {
      outboundContainerID
      containerNumber
      sourceDocumentNumber
      sourceDocumentType
      totalItems
      totalQty
      isDo
      isEmpty
      fromWarehouseID
      toWarehouseID
      toWarehouse {
        warehouseName
      }
    }
  }
}
    `;

export function useContainerContentSearchContainerQuery(options: Omit<Urql.UseQueryArgs<ContainerContentSearchContainerQueryVariables>, 'query'>) {
  return Urql.useQuery<ContainerContentSearchContainerQuery, ContainerContentSearchContainerQueryVariables>({ query: ContainerContentSearchContainerDocument, ...options });
};
export const DeliveryOrderBatchAddLeftoverDocument = gql`
    mutation DeliveryOrderBatchAddLeftover($deliveryOrderBatchID: UUID!) {
  deliveryOrderBatchAddLeftoverContainers(
    deliveryOrderBatchID: $deliveryOrderBatchID
  ) {
    deliveryOrderBatchID
    status
    totalScannedContainers
  }
}
    `;

export function useDeliveryOrderBatchAddLeftoverMutation() {
  return Urql.useMutation<DeliveryOrderBatchAddLeftoverMutation, DeliveryOrderBatchAddLeftoverMutationVariables>(DeliveryOrderBatchAddLeftoverDocument);
};
export const DeliveryOrderBatchCancelDocument = gql`
    mutation DeliveryOrderBatchCancel($deliveryOrderBatchID: UUID!) {
  deliveryOrderBatchCancel(deliveryOrderBatchID: $deliveryOrderBatchID)
}
    `;

export function useDeliveryOrderBatchCancelMutation() {
  return Urql.useMutation<DeliveryOrderBatchCancelMutation, DeliveryOrderBatchCancelMutationVariables>(DeliveryOrderBatchCancelDocument);
};
export const DeliveryOrderBatchCreateDocument = gql`
    mutation DeliveryOrderBatchCreate($input: DeliveryOrderBatchCreateInput!) {
  deliveryOrderBatchCreate(input: $input) {
    deliveryOrderBatchID
    deliveryOrderBatchNumber
    branchID
    gmt
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toBranchID
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    deliveredBy
    vendorID
    vendorCode
    vendorName
    vendorRefNumber
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    deliveryOrderDate
    status
    totalScannedContainers
    totalGeneratedDeliveryOrders
    errorMessage
    noteInternal
    containers {
      deliveryOrderBatchContainerID
      deliveryOrderBatchID
      outboundContainerID
      containerNumber
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      deliveryOrderID
      itemCount
      scannedAt
      scannedByUserID
      scannedByUserName
    }
  }
}
    `;

export function useDeliveryOrderBatchCreateMutation() {
  return Urql.useMutation<DeliveryOrderBatchCreateMutation, DeliveryOrderBatchCreateMutationVariables>(DeliveryOrderBatchCreateDocument);
};
export const DeliveryOrderBatchDestinationSummaryDocument = gql`
    query DeliveryOrderBatchDestinationSummary($destinationWarehouseID: UUID!, $originWarehouseID: UUID) {
  deliveryOrderBatchDestinationSummary(
    destinationWarehouseID: $destinationWarehouseID
    originWarehouseID: $originWarehouseID
  ) {
    toEligible
    containersLeft
    itemsLeft
    transferOrders {
      transferOrderID
      transferOrderNumber
      containerCount
      itemCount
    }
  }
}
    `;

export function useDeliveryOrderBatchDestinationSummaryQuery(options: Omit<Urql.UseQueryArgs<DeliveryOrderBatchDestinationSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<DeliveryOrderBatchDestinationSummaryQuery, DeliveryOrderBatchDestinationSummaryQueryVariables>({ query: DeliveryOrderBatchDestinationSummaryDocument, ...options });
};
export const DeliveryOrderBatchGenerateDocument = gql`
    mutation DeliveryOrderBatchGenerate($input: DeliveryOrderBatchGenerateInput!) {
  deliveryOrderBatchGenerate(input: $input) {
    deliveryOrderBatchID
    deliveryOrderBatchNumber
    status
    totalGeneratedDeliveryOrders
    errorMessage
  }
}
    `;

export function useDeliveryOrderBatchGenerateMutation() {
  return Urql.useMutation<DeliveryOrderBatchGenerateMutation, DeliveryOrderBatchGenerateMutationVariables>(DeliveryOrderBatchGenerateDocument);
};
export const DeliveryOrderBatchGenerateAndShipDocument = gql`
    mutation DeliveryOrderBatchGenerateAndShip($input: DeliveryOrderBatchGenerateInput!) {
  deliveryOrderBatchGenerateAndShip(input: $input) {
    deliveryOrderBatchID
    deliveryOrderBatchNumber
    status
    totalGeneratedDeliveryOrders
    totalShippedDeliveryOrders
    isShipAfterGenerate
    errorMessage
  }
}
    `;

export function useDeliveryOrderBatchGenerateAndShipMutation() {
  return Urql.useMutation<DeliveryOrderBatchGenerateAndShipMutation, DeliveryOrderBatchGenerateAndShipMutationVariables>(DeliveryOrderBatchGenerateAndShipDocument);
};
export const DeliveryOrderBatchListDocument = gql`
    query DeliveryOrderBatchList($qop: DeliveryOrderBatchQopInput) {
  deliveryOrderBatches(qop: $qop) {
    items {
      deliveryOrderBatchID
      deliveryOrderBatchNumber
      fromWarehouseName
      toWarehouseName
      status
      totalScannedContainers
      totalGeneratedDeliveryOrders
      deliveryOrderBatchDatetime
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useDeliveryOrderBatchListQuery(options?: Omit<Urql.UseQueryArgs<DeliveryOrderBatchListQueryVariables>, 'query'>) {
  return Urql.useQuery<DeliveryOrderBatchListQuery, DeliveryOrderBatchListQueryVariables>({ query: DeliveryOrderBatchListDocument, ...options });
};
export const DeliveryOrderBatchLoadDocument = gql`
    query DeliveryOrderBatchLoad($deliveryOrderBatchID: UUID!) {
  deliveryOrderBatch(deliveryOrderBatchID: $deliveryOrderBatchID) {
    deliveryOrderBatchID
    deliveryOrderBatchNumber
    branchID
    gmt
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toBranchID
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    deliveredBy
    vendorID
    vendorCode
    vendorName
    vendorRefNumber
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    deliveryOrderDate
    shippedDatetime
    isShipAfterGenerate
    totalShippedDeliveryOrders
    status
    totalScannedContainers
    totalGeneratedDeliveryOrders
    totalFailedSourceDocuments
    generatedDatetime
    errorMessage
    noteInternal
    sourceDocuments {
      deliveryOrderBatchSourceDocumentID
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      totalContainers
      status
      deliveryOrderID
      deliveryOrderNumber
      errorMessage
    }
    containers {
      deliveryOrderBatchContainerID
      deliveryOrderBatchID
      outboundContainerID
      containerNumber
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      deliveryOrderID
      itemCount
      scannedAt
      scannedByUserID
      scannedByUserName
    }
  }
}
    `;

export function useDeliveryOrderBatchLoadQuery(options: Omit<Urql.UseQueryArgs<DeliveryOrderBatchLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<DeliveryOrderBatchLoadQuery, DeliveryOrderBatchLoadQueryVariables>({ query: DeliveryOrderBatchLoadDocument, ...options });
};
export const DeliveryOrderBatchRegenerateFailedDocument = gql`
    mutation DeliveryOrderBatchRegenerateFailed($deliveryOrderBatchID: UUID!) {
  deliveryOrderBatchRegenerateFailed(deliveryOrderBatchID: $deliveryOrderBatchID) {
    deliveryOrderBatchID
    deliveryOrderBatchNumber
    status
    totalGeneratedDeliveryOrders
    totalFailedSourceDocuments
    errorMessage
  }
}
    `;

export function useDeliveryOrderBatchRegenerateFailedMutation() {
  return Urql.useMutation<DeliveryOrderBatchRegenerateFailedMutation, DeliveryOrderBatchRegenerateFailedMutationVariables>(DeliveryOrderBatchRegenerateFailedDocument);
};
export const DeliveryOrderBatchRemoveContainerDocument = gql`
    mutation DeliveryOrderBatchRemoveContainer($deliveryOrderBatchID: UUID!, $deliveryOrderBatchContainerID: UUID!) {
  deliveryOrderBatchRemoveContainer(
    deliveryOrderBatchID: $deliveryOrderBatchID
    deliveryOrderBatchContainerID: $deliveryOrderBatchContainerID
  )
}
    `;

export function useDeliveryOrderBatchRemoveContainerMutation() {
  return Urql.useMutation<DeliveryOrderBatchRemoveContainerMutation, DeliveryOrderBatchRemoveContainerMutationVariables>(DeliveryOrderBatchRemoveContainerDocument);
};
export const DeliveryOrderBatchScanDocument = gql`
    mutation DeliveryOrderBatchScan($input: DeliveryOrderBatchScanInput!) {
  deliveryOrderBatchScan(input: $input) {
    code
    message
    pendingDeliveryOrderNumber
    container {
      deliveryOrderBatchContainerID
      deliveryOrderBatchID
      outboundContainerID
      containerNumber
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      deliveryOrderID
      itemCount
      scannedAt
      scannedByUserID
      scannedByUserName
    }
  }
}
    `;

export function useDeliveryOrderBatchScanMutation() {
  return Urql.useMutation<DeliveryOrderBatchScanMutation, DeliveryOrderBatchScanMutationVariables>(DeliveryOrderBatchScanDocument);
};
export const DeliveryOrderStatusDocument = gql`
    query DeliveryOrderStatus($deliveryOrderID: UUID!) {
  deliveryOrder(deliveryOrderID: $deliveryOrderID) {
    deliveryOrderID
    deliveryOrderNumber
    status
  }
}
    `;

export function useDeliveryOrderStatusQuery(options: Omit<Urql.UseQueryArgs<DeliveryOrderStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<DeliveryOrderStatusQuery, DeliveryOrderStatusQueryVariables>({ query: DeliveryOrderStatusDocument, ...options });
};
export const DeliveryOrderCreateDocument = gql`
    mutation DeliveryOrderCreate($input: DeliveryOrderCreateInput!) {
  deliveryOrderCreate(input: $input) {
    deliveryOrderID
    deliveryOrderDatetime
    deliveryOrderDatetimeUTC
    branchID
    gmt
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    deliveryBy
    vendorID
    vendorCode
    vendorName
    vendorRefNumber
    landedCost
    totalContainers
    totalItems
    totalItemQty
    noteInternal
    shippedDatetime
    shippedDatetimeUTC
    shippedByUserID
    shippedByUserName
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    cancelledDatetime
    cancelledDatetimeUTC
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    status
  }
}
    `;

export function useDeliveryOrderCreateMutation() {
  return Urql.useMutation<DeliveryOrderCreateMutation, DeliveryOrderCreateMutationVariables>(DeliveryOrderCreateDocument);
};
export const DeliveryOrdersDocument = gql`
    query DeliveryOrders($qop: DeliveryOrderQopInput!) {
  deliveryOrders(qop: $qop) {
    items {
      deliveryOrderID
      deliveryOrderNumber
      deliveryOrderDatetime
      deliveryOrderDatetimeUTC
      branchID
      gmt
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      fromWarehouseID
      fromWarehouseCode
      fromWarehouseName
      toWarehouseID
      toWarehouseCode
      toWarehouseName
      deliveryAddress
      deliveryBy
      vendorID
      vendorCode
      vendorName
      vendorRefNumber
      landedCost
      totalContainers
      totalItems
      totalItemQty
      noteInternal
      shippedDatetime
      shippedDatetimeUTC
      shippedByUserID
      shippedByUserName
      vehiclePlateNumber
      driverName
      driverPhoneNumber
      cancelledDatetime
      cancelledDatetimeUTC
      cancelledByUserID
      cancelledByUserName
      cancellationReason
      status
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useDeliveryOrdersQuery(options: Omit<Urql.UseQueryArgs<DeliveryOrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<DeliveryOrdersQuery, DeliveryOrdersQueryVariables>({ query: DeliveryOrdersDocument, ...options });
};
export const DeliveryOrderLoadDocument = gql`
    query DeliveryOrderLoad($deliveryOrderID: UUID!) {
  deliveryOrder(deliveryOrderID: $deliveryOrderID) {
    deliveryOrderID
    deliveryOrderNumber
    deliveryOrderDatetime
    deliveryOrderDatetimeUTC
    branchID
    gmt
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    deliveryAddress
    deliveryBy
    vendorID
    vendorCode
    vendorName
    vendorRefNumber
    landedCost
    totalContainers
    totalItems
    totalItemQty
    noteInternal
    shippedDatetime
    shippedDatetimeUTC
    shippedByUserID
    deliveredDatetime
    shippedByUserName
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    cancelledDatetime
    cancelledDatetimeUTC
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    status
    entityAuditMetadata {
      createdByUserName
      version
    }
  }
}
    `;

export function useDeliveryOrderLoadQuery(options: Omit<Urql.UseQueryArgs<DeliveryOrderLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<DeliveryOrderLoadQuery, DeliveryOrderLoadQueryVariables>({ query: DeliveryOrderLoadDocument, ...options });
};
export const DeliveryOrderUpdateDocument = gql`
    mutation DeliveryOrderUpdate($input: DeliveryOrderUpdateInput!) {
  deliveryOrderUpdate(input: $input) {
    deliveryOrderID
    deliveryOrderNumber
    deliveryOrderDatetime
    deliveryOrderDatetimeUTC
    branchID
    gmt
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    deliveryAddress
    deliveryBy
    vendorID
    vendorCode
    vendorName
    vendorRefNumber
    landedCost
    totalContainers
    totalItems
    totalItemQty
    noteInternal
    shippedDatetime
    shippedDatetimeUTC
    shippedByUserID
    shippedByUserName
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    cancelledDatetime
    cancelledDatetimeUTC
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    status
  }
}
    `;

export function useDeliveryOrderUpdateMutation() {
  return Urql.useMutation<DeliveryOrderUpdateMutation, DeliveryOrderUpdateMutationVariables>(DeliveryOrderUpdateDocument);
};
export const DeliveryOrderBatchDetachSourceDocumentDocument = gql`
    mutation DeliveryOrderBatchDetachSourceDocument($sourceDocumentType: String!, $sourceDocumentID: UUID!) {
  deliveryOrderBatchDetachSourceDocument(
    sourceDocumentType: $sourceDocumentType
    sourceDocumentID: $sourceDocumentID
  )
}
    `;

export function useDeliveryOrderBatchDetachSourceDocumentMutation() {
  return Urql.useMutation<DeliveryOrderBatchDetachSourceDocumentMutation, DeliveryOrderBatchDetachSourceDocumentMutationVariables>(DeliveryOrderBatchDetachSourceDocumentDocument);
};
export const DeliveryOrderCancelDocument = gql`
    mutation DeliveryOrderCancel($input: DeliveryOrderCancelInput!) {
  deliveryOrderCancel(input: $input) {
    deliveryOrderID
    deliveryOrderNumber
    deliveryOrderDatetime
    deliveryOrderDatetimeUTC
    branchID
    gmt
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    deliveryAddress
    deliveryBy
    vendorID
    vendorCode
    vendorName
    vendorRefNumber
    landedCost
    totalContainers
    totalItems
    totalItemQty
    noteInternal
    shippedDatetime
    shippedDatetimeUTC
    shippedByUserID
    shippedByUserName
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    cancelledDatetime
    cancelledDatetimeUTC
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    status
  }
}
    `;

export function useDeliveryOrderCancelMutation() {
  return Urql.useMutation<DeliveryOrderCancelMutation, DeliveryOrderCancelMutationVariables>(DeliveryOrderCancelDocument);
};
export const DeliveryOrderShippedDocument = gql`
    mutation DeliveryOrderShipped($input: DeliveryOrderShippedInput!) {
  deliveryOrderShipped(input: $input) {
    deliveryOrderID
    deliveryOrderNumber
    deliveryOrderDatetime
    deliveryOrderDatetimeUTC
    branchID
    gmt
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    deliveryAddress
    deliveryBy
    vendorID
    vendorCode
    vendorName
    vendorRefNumber
    landedCost
    totalContainers
    totalItems
    totalItemQty
    noteInternal
    shippedDatetime
    shippedDatetimeUTC
    shippedByUserID
    shippedByUserName
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    cancelledDatetime
    cancelledDatetimeUTC
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    status
  }
}
    `;

export function useDeliveryOrderShippedMutation() {
  return Urql.useMutation<DeliveryOrderShippedMutation, DeliveryOrderShippedMutationVariables>(DeliveryOrderShippedDocument);
};
export const OutboundContainerCreateDocument = gql`
    mutation OutboundContainerCreate($input: OutboundContainerCreateInput!) {
  outboundContainerCreate(input: $input) {
    outboundContainerID
    deliveryOrderID
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    containerNumber
    fromBranchID
    gmt
    fromWarehouseID
    toBranchID
    toWarehouseID
    isEmpty
    isDo
    totalItems
    totalQty
    totalWeight
    noteInternal
  }
}
    `;

export function useOutboundContainerCreateMutation() {
  return Urql.useMutation<OutboundContainerCreateMutation, OutboundContainerCreateMutationVariables>(OutboundContainerCreateDocument);
};
export const OutboundContainerDeleteDocument = gql`
    mutation OutboundContainerDelete($outboundContainerID: UUID!) {
  outboundContainerDelete(input: {outboundContainerID: $outboundContainerID})
}
    `;

export function useOutboundContainerDeleteMutation() {
  return Urql.useMutation<OutboundContainerDeleteMutation, OutboundContainerDeleteMutationVariables>(OutboundContainerDeleteDocument);
};
export const OutboundContainerItemsDocument = gql`
    query OutboundContainerItems($qop: OutboundContainerItemQopInput!) {
  outboundContainerItems(qop: $qop) {
    items {
      outboundContainerItemID
      outboundContainerID
      productID
      productCode
      productName
      product {
        barcode
      }
      productWeight
      qty
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useOutboundContainerItemsQuery(options: Omit<Urql.UseQueryArgs<OutboundContainerItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<OutboundContainerItemsQuery, OutboundContainerItemsQueryVariables>({ query: OutboundContainerItemsDocument, ...options });
};
export const OutboundContainerItemsSummaryDocument = gql`
    query OutboundContainerItemsSummary($qop: OutboundContainerItemGroupedQopInput!) {
  outboundContainerItemsSummary(qop: $qop) {
    items {
      deliveryOrderID
      productID
      productCode
      productName
      product {
        barcode
      }
      productWeight
      qty
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useOutboundContainerItemsSummaryQuery(options: Omit<Urql.UseQueryArgs<OutboundContainerItemsSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<OutboundContainerItemsSummaryQuery, OutboundContainerItemsSummaryQueryVariables>({ query: OutboundContainerItemsSummaryDocument, ...options });
};
export const OutboundContainersDocument = gql`
    query OutboundContainers($qop: OutboundContainerQopInput!) {
  outboundContainers(qop: $qop) {
    items {
      outboundContainerID
      deliveryOrderID
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      containerNumber
      fromBranchID
      gmt
      isEmpty
      isDo
      draftDeliveryOrderBatchNumber
      fromWarehouseID
      toBranchID
      toWarehouseID
      totalItems
      isReceived
      totalQty
      totalWeight
      noteInternal
      entityAuditMetadata {
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useOutboundContainersQuery(options: Omit<Urql.UseQueryArgs<OutboundContainersQueryVariables>, 'query'>) {
  return Urql.useQuery<OutboundContainersQuery, OutboundContainersQueryVariables>({ query: OutboundContainersDocument, ...options });
};
export const EdcTerminalAutocompleteDocument = gql`
    query EdcTerminalAutocomplete($qop: EdcTerminalQopInput) {
  edcTerminals(qop: $qop) {
    items {
      edcTerminalID
      edcTerminalName
      serialNumber
      branchID
      uniqueKey
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useEdcTerminalAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<EdcTerminalAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<EdcTerminalAutocompleteQuery, EdcTerminalAutocompleteQueryVariables>({ query: EdcTerminalAutocompleteDocument, ...options });
};
export const EdcTerminalCreateDocument = gql`
    mutation EdcTerminalCreate($input: EdcTerminalCreateInput!) {
  edcTerminalCreate(input: $input) {
    edcTerminalID
    edcTerminalName
    serialNumber
    branchID
    bankAccountID
    isActive
  }
}
    `;

export function useEdcTerminalCreateMutation() {
  return Urql.useMutation<EdcTerminalCreateMutation, EdcTerminalCreateMutationVariables>(EdcTerminalCreateDocument);
};
export const EdcTerminalDeleteDocument = gql`
    mutation EdcTerminalDelete($edcTerminalID: UUID!) {
  edcTerminalDelete(edcTerminalID: $edcTerminalID)
}
    `;

export function useEdcTerminalDeleteMutation() {
  return Urql.useMutation<EdcTerminalDeleteMutation, EdcTerminalDeleteMutationVariables>(EdcTerminalDeleteDocument);
};
export const EdcTerminalListDocument = gql`
    query EdcTerminalList($qop: EdcTerminalQopInput) {
  edcTerminals(qop: $qop) {
    items {
      edcTerminalID
      edcTerminalName
      serialNumber
      branchID
      bankAccountID
      uniqueKey
      branch {
        branchID
        branchCode
        branchName
      }
      bankAccount {
        bankAccountID
        bankAccountNumber
        bank {
          bankID
          bankName
        }
      }
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useEdcTerminalListQuery(options?: Omit<Urql.UseQueryArgs<EdcTerminalListQueryVariables>, 'query'>) {
  return Urql.useQuery<EdcTerminalListQuery, EdcTerminalListQueryVariables>({ query: EdcTerminalListDocument, ...options });
};
export const EdcTerminalLoadDocument = gql`
    query EdcTerminalLoad($EdcTerminalID: UUID!) {
  edcTerminal(edcTerminalID: $EdcTerminalID) {
    edcTerminalID
    edcTerminalName
    serialNumber
    branchID
    bankAccountID
    branch {
      branchID
      branchName
    }
    bankAccount {
      bankAccountID
      bankAccountNumber
      bank {
        bankID
        bankName
      }
    }
    isActive
    uniqueKey
  }
}
    `;

export function useEdcTerminalLoadQuery(options: Omit<Urql.UseQueryArgs<EdcTerminalLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<EdcTerminalLoadQuery, EdcTerminalLoadQueryVariables>({ query: EdcTerminalLoadDocument, ...options });
};
export const EdcTerminalUpdateDocument = gql`
    mutation EdcTerminalUpdate($input: EdcTerminalUpdateInput!) {
  edcTerminalUpdate(input: $input) {
    edcTerminalID
    edcTerminalName
    serialNumber
    branchID
    bankAccountID
    isActive
  }
}
    `;

export function useEdcTerminalUpdateMutation() {
  return Urql.useMutation<EdcTerminalUpdateMutation, EdcTerminalUpdateMutationVariables>(EdcTerminalUpdateDocument);
};
export const ErpAccountJournalAutocompleteDocument = gql`
    query ERPAccountJournalAutocomplete($qop: AccountJournalQopInput) {
  erpAccountJournals(qop: $qop) {
    items {
      accountJournalID
      code
      name
      displayName
      type
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useErpAccountJournalAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ErpAccountJournalAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ErpAccountJournalAutocompleteQuery, ErpAccountJournalAutocompleteQueryVariables>({ query: ErpAccountJournalAutocompleteDocument, ...options });
};
export const ErpProductCategoryAutocompleteDocument = gql`
    query ERPProductCategoryAutocomplete($qop: ErpProductCategoryQopInput) {
  erpProductCategories(qop: $qop) {
    items {
      productCategoryID
      productCategoryName
      parentID
      parentName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useErpProductCategoryAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ErpProductCategoryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ErpProductCategoryAutocompleteQuery, ErpProductCategoryAutocompleteQueryVariables>({ query: ErpProductCategoryAutocompleteDocument, ...options });
};
export const ExpenseItemAutocompleteDocument = gql`
    query ExpenseItemAutocomplete($qop: ExpenseItemQopInput!) {
  expenseItems(qop: $qop) {
    items {
      expenseItemID
      expenseItemName
      journalAccountCode
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useExpenseItemAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ExpenseItemAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseItemAutocompleteQuery, ExpenseItemAutocompleteQueryVariables>({ query: ExpenseItemAutocompleteDocument, ...options });
};
export const ExpenseItemCreateDocument = gql`
    mutation ExpenseItemCreate($input: ExpenseItemCreateInput!) {
  expenseItemCreate(input: $input) {
    expenseItemID
  }
}
    `;

export function useExpenseItemCreateMutation() {
  return Urql.useMutation<ExpenseItemCreateMutation, ExpenseItemCreateMutationVariables>(ExpenseItemCreateDocument);
};
export const ExpenseItemDeleteDocument = gql`
    mutation ExpenseItemDelete($expenseItemID: UUID!) {
  expenseItemDelete(expenseItemID: $expenseItemID)
}
    `;

export function useExpenseItemDeleteMutation() {
  return Urql.useMutation<ExpenseItemDeleteMutation, ExpenseItemDeleteMutationVariables>(ExpenseItemDeleteDocument);
};
export const ExpenseItemListDocument = gql`
    query ExpenseItemList($qop: ExpenseItemQopInput!) {
  expenseItems(qop: $qop) {
    items {
      expenseItemID
      expenseItemName
      journalAccountCode
      isActive
      uniqueKey
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useExpenseItemListQuery(options: Omit<Urql.UseQueryArgs<ExpenseItemListQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseItemListQuery, ExpenseItemListQueryVariables>({ query: ExpenseItemListDocument, ...options });
};
export const ExpenseItemLoadDocument = gql`
    query ExpenseItemLoad($expenseItemID: UUID!) {
  expenseItem(expenseItemID: $expenseItemID) {
    expenseItemID
    expenseItemName
    journalAccountCode
    journalAccountErpRefID
    journalAccountErpRefName
    isActive
    uniqueKey
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useExpenseItemLoadQuery(options: Omit<Urql.UseQueryArgs<ExpenseItemLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseItemLoadQuery, ExpenseItemLoadQueryVariables>({ query: ExpenseItemLoadDocument, ...options });
};
export const ExpenseItemUpdateDocument = gql`
    mutation ExpenseItemUpdate($input: ExpenseItemUpdateInput!) {
  expenseItemUpdate(input: $input) {
    expenseItemID
  }
}
    `;

export function useExpenseItemUpdateMutation() {
  return Urql.useMutation<ExpenseItemUpdateMutation, ExpenseItemUpdateMutationVariables>(ExpenseItemUpdateDocument);
};
export const CityAutocompleteDocument = gql`
    query CityAutocomplete($qop: CityQop) {
  cities(qop: $qop) {
    items {
      cityID
      cityName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useCityAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<CityAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<CityAutocompleteQuery, CityAutocompleteQueryVariables>({ query: CityAutocompleteDocument, ...options });
};
export const CityCreateDocument = gql`
    mutation CityCreate($formValue: CityCreateInput!) {
  cityCreate(input: $formValue) {
    cityID
    cityName
    gmt
    provinceID
    countryID
    isActive
  }
}
    `;

export function useCityCreateMutation() {
  return Urql.useMutation<CityCreateMutation, CityCreateMutationVariables>(CityCreateDocument);
};
export const CityDeleteDocument = gql`
    mutation CityDelete($cityID: String!) {
  cityDelete(cityID: $cityID)
}
    `;

export function useCityDeleteMutation() {
  return Urql.useMutation<CityDeleteMutation, CityDeleteMutationVariables>(CityDeleteDocument);
};
export const CityListDocument = gql`
    query CityList($qop: CityQop) {
  cities(qop: $qop) {
    items {
      cityID
      cityName
      gmt
      provinceID
      countryID
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useCityListQuery(options?: Omit<Urql.UseQueryArgs<CityListQueryVariables>, 'query'>) {
  return Urql.useQuery<CityListQuery, CityListQueryVariables>({ query: CityListDocument, ...options });
};
export const CityLoadDocument = gql`
    query CityLoad($CityID: String!) {
  city(id: $CityID) {
    cityID
    cityName
    provinceID
    province {
      provinceID
      provinceName
    }
    country {
      countryID
      countryName
    }
    gmt
    countryID
    isActive
  }
}
    `;

export function useCityLoadQuery(options: Omit<Urql.UseQueryArgs<CityLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<CityLoadQuery, CityLoadQueryVariables>({ query: CityLoadDocument, ...options });
};
export const CityUpdateDocument = gql`
    mutation CityUpdate($input: CityUpdateInput!) {
  cityUpdate(input: $input) {
    cityID
    cityName
    provinceID
    gmt
    countryID
    isActive
  }
}
    `;

export function useCityUpdateMutation() {
  return Urql.useMutation<CityUpdateMutation, CityUpdateMutationVariables>(CityUpdateDocument);
};
export const CountryAutocompleteDocument = gql`
    query CountryAutocomplete($qop: CountryQop) {
  countries(qop: $qop) {
    items {
      countryID
      countryName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useCountryAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<CountryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<CountryAutocompleteQuery, CountryAutocompleteQueryVariables>({ query: CountryAutocompleteDocument, ...options });
};
export const CountryCreateDocument = gql`
    mutation CountryCreate($formValue: CountryCreateInput!) {
  countryCreate(input: $formValue) {
    countryID
    countryName
  }
}
    `;

export function useCountryCreateMutation() {
  return Urql.useMutation<CountryCreateMutation, CountryCreateMutationVariables>(CountryCreateDocument);
};
export const CountryDeleteDocument = gql`
    mutation CountryDelete($countryID: String!) {
  countryDelete(countryID: $countryID)
}
    `;

export function useCountryDeleteMutation() {
  return Urql.useMutation<CountryDeleteMutation, CountryDeleteMutationVariables>(CountryDeleteDocument);
};
export const CountryListDocument = gql`
    query CountryList($qop: CountryQop) {
  countries(qop: $qop) {
    items {
      countryID
      countryName
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useCountryListQuery(options?: Omit<Urql.UseQueryArgs<CountryListQueryVariables>, 'query'>) {
  return Urql.useQuery<CountryListQuery, CountryListQueryVariables>({ query: CountryListDocument, ...options });
};
export const CountryLoadDocument = gql`
    query CountryLoad($countryID: String!) {
  country(id: $countryID) {
    countryID
    countryName
    uniqueKey
    isActive
  }
}
    `;

export function useCountryLoadQuery(options: Omit<Urql.UseQueryArgs<CountryLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<CountryLoadQuery, CountryLoadQueryVariables>({ query: CountryLoadDocument, ...options });
};
export const CountryUpdateDocument = gql`
    mutation CountryUpdate($input: CountryUpdateInput!) {
  countryUpdate(input: $input) {
    countryID
    countryName
    uniqueKey
    isActive
  }
}
    `;

export function useCountryUpdateMutation() {
  return Urql.useMutation<CountryUpdateMutation, CountryUpdateMutationVariables>(CountryUpdateDocument);
};
export const ProvinceAutocompleteDocument = gql`
    query ProvinceAutocomplete($qop: ProvinceQop) {
  provinces(qop: $qop) {
    items {
      provinceID
      provinceName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useProvinceAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ProvinceAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProvinceAutocompleteQuery, ProvinceAutocompleteQueryVariables>({ query: ProvinceAutocompleteDocument, ...options });
};
export const ProvinceCreateDocument = gql`
    mutation ProvinceCreate($formValue: ProvinceCreateInput!) {
  provinceCreate(input: $formValue) {
    provinceID
    provinceName
    countryID
    uniqueKey
    isActive
  }
}
    `;

export function useProvinceCreateMutation() {
  return Urql.useMutation<ProvinceCreateMutation, ProvinceCreateMutationVariables>(ProvinceCreateDocument);
};
export const ProvinceDeleteDocument = gql`
    mutation provinceDelete($provinceID: String!) {
  provinceDelete(provinceID: $provinceID)
}
    `;

export function useProvinceDeleteMutation() {
  return Urql.useMutation<ProvinceDeleteMutation, ProvinceDeleteMutationVariables>(ProvinceDeleteDocument);
};
export const ProvinceListDocument = gql`
    query ProvinceList($qop: ProvinceQop) {
  provinces(qop: $qop) {
    items {
      provinceID
      provinceName
      countryID
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProvinceListQuery(options?: Omit<Urql.UseQueryArgs<ProvinceListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProvinceListQuery, ProvinceListQueryVariables>({ query: ProvinceListDocument, ...options });
};
export const ProvinceLoadDocument = gql`
    query ProvinceLoad($ProvinceID: String!) {
  province(id: $ProvinceID) {
    provinceID
    provinceName
    country {
      countryID
      countryName
    }
    countryID
    isActive
  }
}
    `;

export function useProvinceLoadQuery(options: Omit<Urql.UseQueryArgs<ProvinceLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProvinceLoadQuery, ProvinceLoadQueryVariables>({ query: ProvinceLoadDocument, ...options });
};
export const ProvinceUpdateDocument = gql`
    mutation ProvinceUpdate($input: ProvinceUpdateInput!) {
  provinceUpdate(input: $input) {
    provinceID
    provinceName
    countryID
    isActive
  }
}
    `;

export function useProvinceUpdateMutation() {
  return Urql.useMutation<ProvinceUpdateMutation, ProvinceUpdateMutationVariables>(ProvinceUpdateDocument);
};
export const SubdistrictAutocompleteDocument = gql`
    query SubdistrictAutocomplete($qop: SubdistrictQop) {
  subdistricts(qop: $qop) {
    items {
      subdistrictID
      subdistrictName
      city {
        cityID
        cityName
      }
      province {
        provinceID
        provinceName
      }
      country {
        countryID
        countryName
      }
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useSubdistrictAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<SubdistrictAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<SubdistrictAutocompleteQuery, SubdistrictAutocompleteQueryVariables>({ query: SubdistrictAutocompleteDocument, ...options });
};
export const SubdistrictCreateDocument = gql`
    mutation SubdistrictCreate($formValue: SubdistrictCreateInput!) {
  subdistrictCreate(input: $formValue) {
    subdistrictID
    subdistrictName
    cityID
    provinceID
    countryID
    uniqueKey
    isActive
  }
}
    `;

export function useSubdistrictCreateMutation() {
  return Urql.useMutation<SubdistrictCreateMutation, SubdistrictCreateMutationVariables>(SubdistrictCreateDocument);
};
export const SubdistrictDeleteDocument = gql`
    mutation subdistrictDelete($subdistrictID: String!) {
  subdistrictDelete(subdistrictID: $subdistrictID)
}
    `;

export function useSubdistrictDeleteMutation() {
  return Urql.useMutation<SubdistrictDeleteMutation, SubdistrictDeleteMutationVariables>(SubdistrictDeleteDocument);
};
export const SubdistrictListDocument = gql`
    query SubdistrictList($qop: SubdistrictQop) {
  subdistricts(qop: $qop) {
    items {
      subdistrictID
      subdistrictName
      cityID
      provinceID
      countryID
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useSubdistrictListQuery(options?: Omit<Urql.UseQueryArgs<SubdistrictListQueryVariables>, 'query'>) {
  return Urql.useQuery<SubdistrictListQuery, SubdistrictListQueryVariables>({ query: SubdistrictListDocument, ...options });
};
export const SubdistrictLoadDocument = gql`
    query SubdistrictLoad($subdistrictID: String!) {
  subdistrict(id: $subdistrictID) {
    subdistrictID
    subdistrictName
    cityID
    province {
      provinceID
      provinceName
    }
    country {
      countryID
      countryName
    }
    city {
      cityID
      cityName
    }
    provinceID
    countryID
    isActive
  }
}
    `;

export function useSubdistrictLoadQuery(options: Omit<Urql.UseQueryArgs<SubdistrictLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<SubdistrictLoadQuery, SubdistrictLoadQueryVariables>({ query: SubdistrictLoadDocument, ...options });
};
export const SubdistrictUpdateDocument = gql`
    mutation SubdistrictUpdate($input: SubdistrictUpdateInput!) {
  subdistrictUpdate(input: $input) {
    subdistrictID
    subdistrictName
    cityID
    provinceID
    countryID
    isActive
  }
}
    `;

export function useSubdistrictUpdateMutation() {
  return Urql.useMutation<SubdistrictUpdateMutation, SubdistrictUpdateMutationVariables>(SubdistrictUpdateDocument);
};
export const VillageAutocompleteDocument = gql`
    query VillageAutocomplete($qop: VillageQopInput) {
  villages(qop: $qop) {
    items {
      villageID
      villageName
      postalCode
      uniqueKey
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useVillageAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<VillageAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<VillageAutocompleteQuery, VillageAutocompleteQueryVariables>({ query: VillageAutocompleteDocument, ...options });
};
export const VillageCreateDocument = gql`
    mutation VillageCreate($formValue: VillageCreateInput!) {
  villageCreate(input: $formValue) {
    villageID
    villageName
    postalCode
    cityID
    provinceID
    countryID
    subdistrictID
    isActive
  }
}
    `;

export function useVillageCreateMutation() {
  return Urql.useMutation<VillageCreateMutation, VillageCreateMutationVariables>(VillageCreateDocument);
};
export const VillageDeleteDocument = gql`
    mutation VillageDelete($villageID: String!) {
  villageDelete(villageID: $villageID)
}
    `;

export function useVillageDeleteMutation() {
  return Urql.useMutation<VillageDeleteMutation, VillageDeleteMutationVariables>(VillageDeleteDocument);
};
export const VillageListDocument = gql`
    query VillageList($qop: VillageQopInput) {
  villages(qop: $qop) {
    items {
      villageID
      villageName
      postalCode
      cityID
      provinceID
      countryID
      subdistrictID
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVillageListQuery(options?: Omit<Urql.UseQueryArgs<VillageListQueryVariables>, 'query'>) {
  return Urql.useQuery<VillageListQuery, VillageListQueryVariables>({ query: VillageListDocument, ...options });
};
export const VillageLoadDocument = gql`
    query VillageLoad($VillageID: String!) {
  village(villageID: $VillageID) {
    villageID
    villageName
    postalCode
    cityID
    provinceID
    province {
      provinceID
      provinceName
    }
    country {
      countryID
      countryName
    }
    city {
      cityID
      cityName
    }
    subdistrict {
      subdistrictID
      subdistrictName
    }
    countryID
    subdistrictID
    isActive
  }
}
    `;

export function useVillageLoadQuery(options: Omit<Urql.UseQueryArgs<VillageLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VillageLoadQuery, VillageLoadQueryVariables>({ query: VillageLoadDocument, ...options });
};
export const VillageUpdateDocument = gql`
    mutation VillageUpdate($input: VillageUpdateInput!) {
  villageUpdate(input: $input) {
    villageID
    villageName
    postalCode
    cityID
    provinceID
    countryID
    subdistrictID
    isActive
  }
}
    `;

export function useVillageUpdateMutation() {
  return Urql.useMutation<VillageUpdateMutation, VillageUpdateMutationVariables>(VillageUpdateDocument);
};
export const UploadTemplateCreateDocument = gql`
    mutation UploadTemplateCreate($input: UploadTemplateCreateInput!) {
  uploadTemplateCreate(input: $input) {
    uploadTemplateID
    uploadTemplateType
    uploadTemplateKey
    uploadTemplateName
    headerRow
    delimiter
    columnMapping {
      standardKey
      sourceColumn
      type
      format
      contains
      notContains
      gt
      gte
      transform
    }
    isActive
    referenceIDs
  }
}
    `;

export function useUploadTemplateCreateMutation() {
  return Urql.useMutation<UploadTemplateCreateMutation, UploadTemplateCreateMutationVariables>(UploadTemplateCreateDocument);
};
export const UploadTemplateListDocument = gql`
    query UploadTemplateList($qop: UploadTemplateQopInput!) {
  uploadTemplates(qop: $qop) {
    items {
      uploadTemplateID
      uploadTemplateType
      uploadTemplateKey
      uploadTemplateName
      headerRow
      delimiter
      columnMapping {
        standardKey
        sourceColumn
        type
        format
        contains
        notContains
        gt
        gte
        transform
      }
      uniqueKey
      isActive
      referenceIDs
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useUploadTemplateListQuery(options: Omit<Urql.UseQueryArgs<UploadTemplateListQueryVariables>, 'query'>) {
  return Urql.useQuery<UploadTemplateListQuery, UploadTemplateListQueryVariables>({ query: UploadTemplateListDocument, ...options });
};
export const UploadTemplateUpdateDocument = gql`
    mutation UploadTemplateUpdate($input: UploadTemplateUpdateInput!) {
  uploadTemplateUpdate(input: $input) {
    uploadTemplateID
    uploadTemplateType
    uploadTemplateKey
    uploadTemplateName
    headerRow
    delimiter
    columnMapping {
      standardKey
      sourceColumn
      type
      format
      contains
      notContains
      gt
      gte
      transform
    }
    isActive
    referenceIDs
  }
}
    `;

export function useUploadTemplateUpdateMutation() {
  return Urql.useMutation<UploadTemplateUpdateMutation, UploadTemplateUpdateMutationVariables>(UploadTemplateUpdateDocument);
};
export const InternalTransferCancelDocument = gql`
    mutation InternalTransferCancel($input: InternalTransferCancelInput!) {
  internalTransferCancel(input: $input) {
    internalTransferID
  }
}
    `;

export function useInternalTransferCancelMutation() {
  return Urql.useMutation<InternalTransferCancelMutation, InternalTransferCancelMutationVariables>(InternalTransferCancelDocument);
};
export const InternalTransferConfirmDocument = gql`
    mutation InternalTransferConfirm($input: InternalTransferConfirmInput!) {
  internalTransferConfirm(input: $input) {
    internalTransferID
  }
}
    `;

export function useInternalTransferConfirmMutation() {
  return Urql.useMutation<InternalTransferConfirmMutation, InternalTransferConfirmMutationVariables>(InternalTransferConfirmDocument);
};
export const InternalTransferCreateDocument = gql`
    mutation InternalTransferCreate($input: InternalTransferCreateInput!) {
  internalTransferCreate(input: $input) {
    internalTransferID
  }
}
    `;

export function useInternalTransferCreateMutation() {
  return Urql.useMutation<InternalTransferCreateMutation, InternalTransferCreateMutationVariables>(InternalTransferCreateDocument);
};
export const InternalTransferItemListDocument = gql`
    query InternalTransferItemList($qop: InternalTransferItemQopInput) {
  internalTransferItems(qop: $qop) {
    items {
      internalTransferItemID
      internalTransferID
      productID
      productCode
      productName
      product {
        barcode
      }
      productWeight
      fromWarehouseLocationID
      fromWarehouseLocationCode
      fromWarehouseLocationName
      toWarehouseLocationID
      toWarehouseLocationCode
      toWarehouseLocationName
      qtyRequested
      qtyTransferred
      qtyOutstanding
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQtyRequested
      baseUomQtyTransferred
      baseUomQtyOutstanding
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInternalTransferItemListQuery(options?: Omit<Urql.UseQueryArgs<InternalTransferItemListQueryVariables>, 'query'>) {
  return Urql.useQuery<InternalTransferItemListQuery, InternalTransferItemListQueryVariables>({ query: InternalTransferItemListDocument, ...options });
};
export const InternalTransferListDocument = gql`
    query InternalTransferList($qop: InternalTransferQopInput) {
  internalTransfers(qop: $qop) {
    items {
      internalTransferID
      internalTransferNumber
      internalTransferDatetime
      internalTransferDatetimeUtc
      branchID
      gmt
      warehouseID
      warehouse {
        warehouseCode
        warehouseName
      }
      totalItemQtyRequested
      totalItemQtyTransferred
      totalItemWeight
      confirmDatetime
      confirmDatetimeUtc
      confirmByUserID
      confirmByUserName
      cancelledDatetime
      cancelledDatetimeUtc
      cancelledByUserID
      cancelledByUserName
      cancellationReason
      noteInternal
      description
      status
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInternalTransferListQuery(options?: Omit<Urql.UseQueryArgs<InternalTransferListQueryVariables>, 'query'>) {
  return Urql.useQuery<InternalTransferListQuery, InternalTransferListQueryVariables>({ query: InternalTransferListDocument, ...options });
};
export const InternalTransferLoadDocument = gql`
    query InternalTransferLoad($internalTransferID: UUID!) {
  internalTransfer(internalTransferID: $internalTransferID) {
    internalTransferID
    internalTransferNumber
    internalTransferDatetime
    internalTransferDatetimeUtc
    branchID
    gmt
    warehouseID
    warehouse {
      warehouseCode
      warehouseName
    }
    totalItemQtyRequested
    totalItemQtyTransferred
    totalItemWeight
    confirmDatetime
    confirmDatetimeUtc
    confirmByUserID
    confirmByUserName
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    description
    status
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useInternalTransferLoadQuery(options: Omit<Urql.UseQueryArgs<InternalTransferLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<InternalTransferLoadQuery, InternalTransferLoadQueryVariables>({ query: InternalTransferLoadDocument, ...options });
};
export const InternalTransferUpdateDocument = gql`
    mutation InternalTransferUpdate($input: InternalTransferUpdateInput!) {
  internalTransferUpdate(input: $input) {
    internalTransferID
  }
}
    `;

export function useInternalTransferUpdateMutation() {
  return Urql.useMutation<InternalTransferUpdateMutation, InternalTransferUpdateMutationVariables>(InternalTransferUpdateDocument);
};
export const ReasonInventoryAdjustmentAutocompleteDocument = gql`
    query ReasonInventoryAdjustmentAutocomplete($qop: ReasonInventoryAdjustmentQopInput!) {
  reasonInventoryAdjustments(qop: $qop) {
    items {
      reasonInventoryAdjustmentID
      reasonName
      journalAccountCode
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useReasonInventoryAdjustmentAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ReasonInventoryAdjustmentAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ReasonInventoryAdjustmentAutocompleteQuery, ReasonInventoryAdjustmentAutocompleteQueryVariables>({ query: ReasonInventoryAdjustmentAutocompleteDocument, ...options });
};
export const ReasonInventoryAdjustmentCreateDocument = gql`
    mutation ReasonInventoryAdjustmentCreate($input: ReasonInventoryAdjustmentCreateInput!) {
  reasonInventoryAdjustmentCreate(input: $input) {
    reasonInventoryAdjustmentID
  }
}
    `;

export function useReasonInventoryAdjustmentCreateMutation() {
  return Urql.useMutation<ReasonInventoryAdjustmentCreateMutation, ReasonInventoryAdjustmentCreateMutationVariables>(ReasonInventoryAdjustmentCreateDocument);
};
export const ReasonInventoryAdjustmentDeleteDocument = gql`
    mutation ReasonInventoryAdjustmentDelete($reasonInventoryAdjustmentID: UUID!) {
  reasonInventoryAdjustmentDelete(
    reasonInventoryAdjustmentID: $reasonInventoryAdjustmentID
  )
}
    `;

export function useReasonInventoryAdjustmentDeleteMutation() {
  return Urql.useMutation<ReasonInventoryAdjustmentDeleteMutation, ReasonInventoryAdjustmentDeleteMutationVariables>(ReasonInventoryAdjustmentDeleteDocument);
};
export const ReasonInventoryAdjustmentListDocument = gql`
    query ReasonInventoryAdjustmentList($qop: ReasonInventoryAdjustmentQopInput!) {
  reasonInventoryAdjustments(qop: $qop) {
    items {
      reasonInventoryAdjustmentID
      reasonName
      journalAccountCode
      journalAccountErpRefID
      journalAccountErpRefName
      description
      isActive
      adjustmentTypes
      uniqueKey
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useReasonInventoryAdjustmentListQuery(options: Omit<Urql.UseQueryArgs<ReasonInventoryAdjustmentListQueryVariables>, 'query'>) {
  return Urql.useQuery<ReasonInventoryAdjustmentListQuery, ReasonInventoryAdjustmentListQueryVariables>({ query: ReasonInventoryAdjustmentListDocument, ...options });
};
export const ReasonInventoryAdjustmentDocument = gql`
    query ReasonInventoryAdjustment($reasonInventoryAdjustmentID: UUID!) {
  reasonInventoryAdjustment(
    reasonInventoryAdjustmentID: $reasonInventoryAdjustmentID
  ) {
    reasonInventoryAdjustmentID
    reasonName
    journalAccountCode
    journalAccountErpRefID
    journalAccountErpRefName
    description
    isActive
    adjustmentTypes
    uniqueKey
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useReasonInventoryAdjustmentQuery(options: Omit<Urql.UseQueryArgs<ReasonInventoryAdjustmentQueryVariables>, 'query'>) {
  return Urql.useQuery<ReasonInventoryAdjustmentQuery, ReasonInventoryAdjustmentQueryVariables>({ query: ReasonInventoryAdjustmentDocument, ...options });
};
export const ReasonInventoryAdjustmentUpdateDocument = gql`
    mutation ReasonInventoryAdjustmentUpdate($input: ReasonInventoryAdjustmentUpdateInput!) {
  reasonInventoryAdjustmentUpdate(input: $input) {
    reasonInventoryAdjustmentID
  }
}
    `;

export function useReasonInventoryAdjustmentUpdateMutation() {
  return Urql.useMutation<ReasonInventoryAdjustmentUpdateMutation, ReasonInventoryAdjustmentUpdateMutationVariables>(ReasonInventoryAdjustmentUpdateDocument);
};
export const CostAdjustmentImportDocument = gql`
    mutation CostAdjustmentImport($input: CostAdjustmentImportInput!) {
  costAdjustmentImport(input: $input)
}
    `;

export function useCostAdjustmentImportMutation() {
  return Urql.useMutation<CostAdjustmentImportMutation, CostAdjustmentImportMutationVariables>(CostAdjustmentImportDocument);
};
export const CostAdjustmentImportValidateCodesDocument = gql`
    mutation CostAdjustmentImportValidateCodes($input: CostAdjustmentImportValidateCodesInput!) {
  costAdjustmentImportValidateCodes(input: $input) {
    totalRows
    invalidRows
    missingProductCodes
  }
}
    `;

export function useCostAdjustmentImportValidateCodesMutation() {
  return Urql.useMutation<CostAdjustmentImportValidateCodesMutation, CostAdjustmentImportValidateCodesMutationVariables>(CostAdjustmentImportValidateCodesDocument);
};
export const InventoryAdjustmentCancelAdjustmentDocument = gql`
    mutation InventoryAdjustmentCancelAdjustment($input: InventoryAdjustmentCancelInput!) {
  inventoryAdjustmentCancel(input: $input) {
    inventoryAdjustmentID
  }
}
    `;

export function useInventoryAdjustmentCancelAdjustmentMutation() {
  return Urql.useMutation<InventoryAdjustmentCancelAdjustmentMutation, InventoryAdjustmentCancelAdjustmentMutationVariables>(InventoryAdjustmentCancelAdjustmentDocument);
};
export const InventoryAdjustmentConfirmDocument = gql`
    mutation InventoryAdjustmentConfirm($input: InventoryAdjustmentConfirmInput!) {
  inventoryAdjustmentConfirm(input: $input) {
    inventoryAdjustmentID
  }
}
    `;

export function useInventoryAdjustmentConfirmMutation() {
  return Urql.useMutation<InventoryAdjustmentConfirmMutation, InventoryAdjustmentConfirmMutationVariables>(InventoryAdjustmentConfirmDocument);
};
export const InventoryAdjustmentCreateDocument = gql`
    mutation InventoryAdjustmentCreate($input: InventoryAdjustmentCreateInput!) {
  inventoryAdjustmentCreate(input: $input) {
    inventoryAdjustmentID
  }
}
    `;

export function useInventoryAdjustmentCreateMutation() {
  return Urql.useMutation<InventoryAdjustmentCreateMutation, InventoryAdjustmentCreateMutationVariables>(InventoryAdjustmentCreateDocument);
};
export const InventoryAdjustmentCancelDocument = gql`
    mutation InventoryAdjustmentCancel($id: UUID!) {
  inventoryAdjustmentDelete(inventoryAdjustmentID: $id)
}
    `;

export function useInventoryAdjustmentCancelMutation() {
  return Urql.useMutation<InventoryAdjustmentCancelMutation, InventoryAdjustmentCancelMutationVariables>(InventoryAdjustmentCancelDocument);
};
export const InventoryAdjustmentItemListDocument = gql`
    query InventoryAdjustmentItemList($qop: InventoryAdjustmentItemQopInput) {
  inventoryAdjustmentItems(qop: $qop) {
    items {
      inventoryAdjustmentItemID
      inventoryAdjustmentID
      productID
      productCode
      productName
      qty
      unitCost
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
      warehouseLocationID
      warehouseLocationName
      reasonID
      reasonName
      note
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryAdjustmentItemListQuery(options?: Omit<Urql.UseQueryArgs<InventoryAdjustmentItemListQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryAdjustmentItemListQuery, InventoryAdjustmentItemListQueryVariables>({ query: InventoryAdjustmentItemListDocument, ...options });
};
export const InventoryAdjustmentListDocument = gql`
    query InventoryAdjustmentList($qop: InventoryAdjustmentQopInput) {
  inventoryAdjustments(qop: $qop) {
    items {
      inventoryAdjustmentID
      inventoryAdjustmentNumber
      inventoryAdjustmentDate
      inventoryAdjustmentType
      notes
      status
      confirmDatetime
      confirmDatetimeUtc
      confirmByUserID
      confirmByUserName
      cancelledDatetime
      cancelledDatetimeUtc
      cancelledByUserID
      cancelledByUserName
      cancellationReason
      branchID
      warehouseID
      isSystemGenerated
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryAdjustmentListQuery(options?: Omit<Urql.UseQueryArgs<InventoryAdjustmentListQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryAdjustmentListQuery, InventoryAdjustmentListQueryVariables>({ query: InventoryAdjustmentListDocument, ...options });
};
export const InventoryAdjustmentListItemDocument = gql`
    query InventoryAdjustmentListItem($qop: InventoryAdjustmentItemQopInput) {
  inventoryAdjustmentItems(qop: $qop) {
    items {
      inventoryAdjustmentItemID
      inventoryAdjustmentID
      productID
      productCode
      productName
      qty
      unitCost
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
      warehouseLocationID
      warehouseLocationName
      totalCost
      reasonID
      reasonName
      note
      product {
        productName
        sellingPrice
        barcode
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryAdjustmentListItemQuery(options?: Omit<Urql.UseQueryArgs<InventoryAdjustmentListItemQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryAdjustmentListItemQuery, InventoryAdjustmentListItemQueryVariables>({ query: InventoryAdjustmentListItemDocument, ...options });
};
export const InventoryAdjustmentLoadDocument = gql`
    query InventoryAdjustmentLoad($inventoryAdjustmentID: UUID!) {
  inventoryAdjustment(inventoryAdjustmentID: $inventoryAdjustmentID) {
    inventoryAdjustmentID
    inventoryAdjustmentNumber
    inventoryAdjustmentDate
    inventoryAdjustmentType
    usedCost
    notes
    status
    confirmDatetime
    confirmDatetimeUtc
    confirmByUserID
    confirmByUserName
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    branchID
    warehouseID
    isSystemGenerated
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    branch {
      branchID
      branchCode
      branchName
      branchType
      branchCategoryID
      pricelistID
      productAvailabilityTemplateID
      mainSupplyWarehouseID
      gmt
      picName
      picPhoneNumber
      canSell
      isMain
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
    warehouse {
      warehouseID
      warehouseCode
      warehouseName
      branchID
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
    files {
      inventoryAdjustmentFileID
      inventoryAdjustmentID
      inventoryAdjustmentFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
  }
}
    `;

export function useInventoryAdjustmentLoadQuery(options: Omit<Urql.UseQueryArgs<InventoryAdjustmentLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryAdjustmentLoadQuery, InventoryAdjustmentLoadQueryVariables>({ query: InventoryAdjustmentLoadDocument, ...options });
};
export const InventoryAdjustmentOpeningBalanceImportDocument = gql`
    mutation InventoryAdjustmentOpeningBalanceImport($input: InventoryAdjustmentOpeningBalanceImportInput!) {
  inventoryAdjustmentOpeningBalanceImport(input: $input)
}
    `;

export function useInventoryAdjustmentOpeningBalanceImportMutation() {
  return Urql.useMutation<InventoryAdjustmentOpeningBalanceImportMutation, InventoryAdjustmentOpeningBalanceImportMutationVariables>(InventoryAdjustmentOpeningBalanceImportDocument);
};
export const InventoryAdjustmentOpeningBalanceImportValidateCodesDocument = gql`
    mutation InventoryAdjustmentOpeningBalanceImportValidateCodes($input: InventoryAdjustmentOpeningBalanceImportValidateCodesInput!) {
  inventoryAdjustmentOpeningBalanceImportValidateCodes(input: $input) {
    missingProductCodes
    missingLocationNames
    missingProductUoms {
      rowNumber
      productCode
      uomName
    }
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        standardKey
        label
        reason
        value
      }
    }
  }
}
    `;

export function useInventoryAdjustmentOpeningBalanceImportValidateCodesMutation() {
  return Urql.useMutation<InventoryAdjustmentOpeningBalanceImportValidateCodesMutation, InventoryAdjustmentOpeningBalanceImportValidateCodesMutationVariables>(InventoryAdjustmentOpeningBalanceImportValidateCodesDocument);
};
export const InventoryAdjustmentTypeListDocument = gql`
    query InventoryAdjustmentTypeList {
  inventoryAdjustmentTypes {
    inventoryAdjustmentTypeID
    code
    type
    name
    isStandard
    isWaste
    isSystemGenerated
    isSyncToErp
    sortOrder
  }
}
    `;

export function useInventoryAdjustmentTypeListQuery(options?: Omit<Urql.UseQueryArgs<InventoryAdjustmentTypeListQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryAdjustmentTypeListQuery, InventoryAdjustmentTypeListQueryVariables>({ query: InventoryAdjustmentTypeListDocument, ...options });
};
export const InventoryAdjustmentUpdateDocument = gql`
    mutation InventoryAdjustmentUpdate($input: InventoryAdjustmentUpdateInput!) {
  inventoryAdjustmentUpdate(input: $input) {
    inventoryAdjustmentID
  }
}
    `;

export function useInventoryAdjustmentUpdateMutation() {
  return Urql.useMutation<InventoryAdjustmentUpdateMutation, InventoryAdjustmentUpdateMutationVariables>(InventoryAdjustmentUpdateDocument);
};
export const InventoryCountItemTemplateCreateDocument = gql`
    mutation InventoryCountItemTemplateCreate($input: InventoryCountItemTemplateCreateInput!) {
  inventoryCountItemTemplateCreate(input: $input) {
    inventoryCountItemTemplateName
    isActive
  }
}
    `;

export function useInventoryCountItemTemplateCreateMutation() {
  return Urql.useMutation<InventoryCountItemTemplateCreateMutation, InventoryCountItemTemplateCreateMutationVariables>(InventoryCountItemTemplateCreateDocument);
};
export const InventoryCountItemTemplateDeleteDocument = gql`
    mutation InventoryCountItemTemplateDelete($inventoryCountItemTemplateID: UUID!) {
  inventoryCountItemTemplateDelete(
    inventoryCountItemTemplateID: $inventoryCountItemTemplateID
  )
}
    `;

export function useInventoryCountItemTemplateDeleteMutation() {
  return Urql.useMutation<InventoryCountItemTemplateDeleteMutation, InventoryCountItemTemplateDeleteMutationVariables>(InventoryCountItemTemplateDeleteDocument);
};
export const InventoryCountItemTemplateItemImportDocument = gql`
    mutation InventoryCountItemTemplateItemImport($input: InventoryCountItemTemplateItemImportInput!) {
  inventoryCountItemTemplateItemImport(input: $input) {
    importedCount
    skippedCount
  }
}
    `;

export function useInventoryCountItemTemplateItemImportMutation() {
  return Urql.useMutation<InventoryCountItemTemplateItemImportMutation, InventoryCountItemTemplateItemImportMutationVariables>(InventoryCountItemTemplateItemImportDocument);
};
export const InventoryCountItemTemplateItemImportValidateDocument = gql`
    mutation InventoryCountItemTemplateItemImportValidate($input: InventoryCountItemTemplateItemImportValidateInput!) {
  inventoryCountItemTemplateItemImportValidate(input: $input) {
    missingProductCodes
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        standardKey
        label
        reason
        value
      }
    }
  }
}
    `;

export function useInventoryCountItemTemplateItemImportValidateMutation() {
  return Urql.useMutation<InventoryCountItemTemplateItemImportValidateMutation, InventoryCountItemTemplateItemImportValidateMutationVariables>(InventoryCountItemTemplateItemImportValidateDocument);
};
export const InventoryCountItemTemplateItemsDocument = gql`
    query InventoryCountItemTemplateItems($qop: InventoryCountItemTemplateItemQopInput!) {
  inventoryCountItemTemplateItems(qop: $qop) {
    items {
      inventoryCountItemTemplateItemID
      productID
      productCode
      productName
      product {
        barcode
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useInventoryCountItemTemplateItemsQuery(options: Omit<Urql.UseQueryArgs<InventoryCountItemTemplateItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountItemTemplateItemsQuery, InventoryCountItemTemplateItemsQueryVariables>({ query: InventoryCountItemTemplateItemsDocument, ...options });
};
export const InventoryCountItemTemplateLoadDocument = gql`
    query InventoryCountItemTemplateLoad($inventoryCountItemTemplateID: UUID!) {
  inventoryCountItemTemplate(
    inventoryCountItemTemplateID: $inventoryCountItemTemplateID
  ) {
    inventoryCountItemTemplateID
    inventoryCountItemTemplateName
    isActive
  }
}
    `;

export function useInventoryCountItemTemplateLoadQuery(options: Omit<Urql.UseQueryArgs<InventoryCountItemTemplateLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountItemTemplateLoadQuery, InventoryCountItemTemplateLoadQueryVariables>({ query: InventoryCountItemTemplateLoadDocument, ...options });
};
export const InventoryCountItemTemplateUpdateDocument = gql`
    mutation InventoryCountItemTemplateUpdate($input: InventoryCountItemTemplateUpdateInput!) {
  inventoryCountItemTemplateUpdate(input: $input) {
    inventoryCountItemTemplateID
    inventoryCountItemTemplateName
    isActive
  }
}
    `;

export function useInventoryCountItemTemplateUpdateMutation() {
  return Urql.useMutation<InventoryCountItemTemplateUpdateMutation, InventoryCountItemTemplateUpdateMutationVariables>(InventoryCountItemTemplateUpdateDocument);
};
export const InventoryCountItemTemplatesDocument = gql`
    query InventoryCountItemTemplates($qop: InventoryCountItemTemplateQopInput!) {
  inventoryCountItemTemplates(qop: $qop) {
    items {
      inventoryCountItemTemplateID
      inventoryCountItemTemplateName
      isActive
      itemCount
      entityAuditMetadata {
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useInventoryCountItemTemplatesQuery(options: Omit<Urql.UseQueryArgs<InventoryCountItemTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountItemTemplatesQuery, InventoryCountItemTemplatesQueryVariables>({ query: InventoryCountItemTemplatesDocument, ...options });
};
export const InventoryCountCreateDocument = gql`
    mutation InventoryCountCreate($input: InventoryCountTransactionCreateInput!) {
  inventoryCountTransactionCreate(input: $input) {
    inventoryCountTransactionID
    inventoryCountTransactionNumber
    inventoryCountTransactionDatetime
    inventoryCountTransactionDatetimeUtc
    branchID
    gmt
    warehouseID
    taskType
    totalItems
    totalCountTasks
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    status
  }
}
    `;

export function useInventoryCountCreateMutation() {
  return Urql.useMutation<InventoryCountCreateMutation, InventoryCountCreateMutationVariables>(InventoryCountCreateDocument);
};
export const InventoryCountListDocument = gql`
    query InventoryCountList($qop: InventoryCountTransactionQopInput) {
  inventoryCountTransactions(qop: $qop) {
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
    items {
      inventoryCountTransactionID
      inventoryCountTransactionNumber
      inventoryCountTransactionDatetime
      inventoryCountTransactionDatetimeUtc
      branchID
      gmt
      warehouseID
      taskType
      totalItems
      totalCountTasks
      cancelledDatetime
      cancelledDatetimeUtc
      cancelledByUserID
      cancelledByUserName
      cancellationReason
      noteInternal
      status
      warehouse {
        warehouseCode
        warehouseName
      }
      entityAuditMetadata {
        version
      }
    }
  }
}
    `;

export function useInventoryCountListQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountListQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountListQuery, InventoryCountListQueryVariables>({ query: InventoryCountListDocument, ...options });
};
export const InventoryCountListItemDocument = gql`
    query InventoryCountListItem($qop: InventoryCountTransactionItemQopInput) {
  inventoryCountTransactionItems(qop: $qop) {
    items {
      inventoryCountTransactionItemID
      inventoryCountTransactionID
      type
      productID
      productCode
      productName
      product {
        barcode
      }
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      note
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountListItemQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountListItemQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountListItemQuery, InventoryCountListItemQueryVariables>({ query: InventoryCountListItemDocument, ...options });
};
export const InventoryCountListItemResultDocument = gql`
    query InventoryCountListItemResult($qop: InventoryCountTransactionResultItemQopInput) {
  inventoryCountTransactionResultItems(qop: $qop) {
    items {
      inventoryCountTransactionResultItemID
      inventoryCountTransactionID
      sequence
      productID
      productCode
      productName
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      qtySystem
      qtyCounted
      qtyDiff
      baseUomQtySystem
      baseUomQtyCounted
      baseUomQtyDiff
      note
      baseUomUnitCostSystem
      baseUomUnitCostCounted
      baseUomUnitCostDiff
      totalCost
      product {
        barcode
        purchaseCost
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountListItemResultQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountListItemResultQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountListItemResultQuery, InventoryCountListItemResultQueryVariables>({ query: InventoryCountListItemResultDocument, ...options });
};
export const InventoryCountListTaskDocument = gql`
    query InventoryCountListTask($qop: InventoryCountTaskQopInput) {
  inventoryCountTasks(qop: $qop) {
    items {
      inventoryCountTaskID
      inventoryCountTaskNumber
      inventoryCountTaskDatetime
      inventoryCountTaskDatetimeUtc
      inventoryCountTransactionID
      inventoryCountTransactionNumber
      isRecount
      sequence
      branchID
      gmt
      warehouseID
      totalItems
      totalQtyCounted
      taskStartAt
      taskStartAtUtc
      taskDoneAt
      taskDoneAtUtc
      taskDurationMinute
      cancelledAt
      cancelledAtUtc
      cancelledByUserID
      cancelledByUserName
      cancellationReason
      status
      noteInternal
      entityAuditMetadata {
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountListTaskQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountListTaskQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountListTaskQuery, InventoryCountListTaskQueryVariables>({ query: InventoryCountListTaskDocument, ...options });
};
export const InventoryCountMonitoringStoreBranchesDocument = gql`
    query InventoryCountMonitoringStoreBranches($qop: BranchQopInput) {
  branches(qop: $qop) {
    items {
      branchID
      branchCode
      branchName
    }
  }
}
    `;

export function useInventoryCountMonitoringStoreBranchesQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountMonitoringStoreBranchesQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountMonitoringStoreBranchesQuery, InventoryCountMonitoringStoreBranchesQueryVariables>({ query: InventoryCountMonitoringStoreBranchesDocument, ...options });
};
export const InventoryCountMonitoringStoresDocument = gql`
    query InventoryCountMonitoringStores($qop: InventoryCountTransactionQopInput) {
  inventoryCountTransactions(qop: $qop) {
    pagination {
      totalRows
    }
    items {
      inventoryCountTransactionID
      inventoryCountTransactionNumber
      warehouseID
      taskType
      totalCountTasks
      status
      warehouse {
        warehouseName
      }
    }
  }
}
    `;

export function useInventoryCountMonitoringStoresQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountMonitoringStoresQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountMonitoringStoresQuery, InventoryCountMonitoringStoresQueryVariables>({ query: InventoryCountMonitoringStoresDocument, ...options });
};
export const InventoryCountTaskAssigneeDeleteDocument = gql`
    mutation InventoryCountTaskAssigneeDelete($input: InventoryCountTaskAssigneeDeleteInput!) {
  inventoryCountTaskAssigneeDelete(input: $input)
}
    `;

export function useInventoryCountTaskAssigneeDeleteMutation() {
  return Urql.useMutation<InventoryCountTaskAssigneeDeleteMutation, InventoryCountTaskAssigneeDeleteMutationVariables>(InventoryCountTaskAssigneeDeleteDocument);
};
export const InventoryCountTaskAssigneesDocument = gql`
    query InventoryCountTaskAssignees($qop: InventoryCountTaskAssigneeQopInput) {
  inventoryCountTaskAssignees(qop: $qop) {
    items {
      inventoryCountTaskAssigneeID
      inventoryCountTaskID
      inventoryCountTransactionID
      assignedToUserID
      assignedToUserName
      sequenceNo
      status
      startedAt
      startedAtUtc
      finishedAt
      finishedAtUtc
      taskDurationMinute
      entityAuditMetadata {
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountTaskAssigneesQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountTaskAssigneesQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountTaskAssigneesQuery, InventoryCountTaskAssigneesQueryVariables>({ query: InventoryCountTaskAssigneesDocument, ...options });
};
export const InventoryCountTaskCancelDocument = gql`
    mutation InventoryCountTaskCancel($input: InventoryCountTaskCancelInput!) {
  inventoryCountTaskCancel(input: $input)
}
    `;

export function useInventoryCountTaskCancelMutation() {
  return Urql.useMutation<InventoryCountTaskCancelMutation, InventoryCountTaskCancelMutationVariables>(InventoryCountTaskCancelDocument);
};
export const InventoryCountTaskExecutionItemDetailsDocument = gql`
    query InventoryCountTaskExecutionItemDetails($qop: InventoryCountTaskExecutionItemDetailQopInput) {
  inventoryCountTaskExecutionItemDetails(qop: $qop) {
    items {
      inventoryCountTaskExecutionItemDetailID
      inventoryCountTaskExecutionItemID
      inventoryCountTaskID
      inventoryCountTransactionID
      inventoryCountTransactionLocationDetailID
      warehouseID
      warehouseLocationID
      warehouseLocationName
      productID
      productCode
      productName
      sequenceNo
      inputMethod
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      qty
      baseUomQty
      qtySystem
      baseUomQtySystem
      qtyDiff
      baseUomQtyDiff
      note
      executedAt
      executedAtUtc
      executedByUserID
      executedByUserName
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
        branchID
        addressLabel
        fullAddress
        countryID
        countryName
        provinceID
        provinceName
        cityID
        cityName
        subdistrictID
        subdistrictName
        postalCode
        longitude
        latitude
        uniqueKey
        isActive
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountTaskExecutionItemDetailsQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountTaskExecutionItemDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountTaskExecutionItemDetailsQuery, InventoryCountTaskExecutionItemDetailsQueryVariables>({ query: InventoryCountTaskExecutionItemDetailsDocument, ...options });
};
export const InventoryCountTaskExecutionItemsDocument = gql`
    query InventoryCountTaskExecutionItems($qop: InventoryCountTaskExecutionItemQopInput) {
  inventoryCountTaskExecutionItems(qop: $qop) {
    items {
      inventoryCountTaskExecutionItemID
      inventoryCountTaskID
      inventoryCountTransactionID
      productID
      productCode
      productName
      product {
        barcode
      }
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      qtySystem
      qtyCounted
      qtyDiff
      baseUomQtySystem
      baseUomQtyCounted
      baseUomQtyDiff
      totalExecutionCount
      isRecountRequired
      unitCostSystem
      baseUomUnitCostDiff
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountTaskExecutionItemsQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountTaskExecutionItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountTaskExecutionItemsQuery, InventoryCountTaskExecutionItemsQueryVariables>({ query: InventoryCountTaskExecutionItemsDocument, ...options });
};
export const InventoryCountTaskExportImportTemplateDocument = gql`
    mutation InventoryCountTaskExportImportTemplate($input: InventoryCountTaskExportInput!) {
  inventoryCountTaskExportImportTemplate(input: $input) {
    downloadUrl
    fileName
  }
}
    `;

export function useInventoryCountTaskExportImportTemplateMutation() {
  return Urql.useMutation<InventoryCountTaskExportImportTemplateMutation, InventoryCountTaskExportImportTemplateMutationVariables>(InventoryCountTaskExportImportTemplateDocument);
};
export const InventoryCountTaskExportRecountItemsDocument = gql`
    mutation InventoryCountTaskExportRecountItems($input: InventoryCountTaskExportInput!) {
  inventoryCountTaskExportRecountItems(input: $input) {
    downloadUrl
    fileName
  }
}
    `;

export function useInventoryCountTaskExportRecountItemsMutation() {
  return Urql.useMutation<InventoryCountTaskExportRecountItemsMutation, InventoryCountTaskExportRecountItemsMutationVariables>(InventoryCountTaskExportRecountItemsDocument);
};
export const InventoryCountTaskFinishDocument = gql`
    mutation InventoryCountTaskFinish($input: InventoryCountTaskFinishInput!) {
  inventoryCountTaskFinish(input: $input)
}
    `;

export function useInventoryCountTaskFinishMutation() {
  return Urql.useMutation<InventoryCountTaskFinishMutation, InventoryCountTaskFinishMutationVariables>(InventoryCountTaskFinishDocument);
};
export const InventoryCountTaskRecountCreateDocument = gql`
    mutation InventoryCountTaskRecountCreate($input: InventoryCountTaskRecountCreateInput!) {
  inventoryCountTaskRecountCreate(input: $input) {
    inventoryCountTransactionID
  }
}
    `;

export function useInventoryCountTaskRecountCreateMutation() {
  return Urql.useMutation<InventoryCountTaskRecountCreateMutation, InventoryCountTaskRecountCreateMutationVariables>(InventoryCountTaskRecountCreateDocument);
};
export const InventoryCountTaskRecountItemsDocument = gql`
    query InventoryCountTaskRecountItems($qop: InventoryCountTaskRecountItemQopInput) {
  inventoryCountTaskRecountItems(qop: $qop) {
    items {
      inventoryCountTaskRecountItemID
      inventoryCountTaskID
      parentInventoryCountTaskID
      inventoryCountTransactionID
      type
      productID
      productCode
      productName
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      qtySystem
      qtyCounted
      qtyDiff
      baseUomUnitCostDiff
      product {
        barcode
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountTaskRecountItemsQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountTaskRecountItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountTaskRecountItemsQuery, InventoryCountTaskRecountItemsQueryVariables>({ query: InventoryCountTaskRecountItemsDocument, ...options });
};
export const InventoryCountTaskRecountUpdateDocument = gql`
    mutation InventoryCountTaskRecountUpdate($input: InventoryCountTaskUpdateInput!) {
  inventoryCountTaskUpdate(input: $input) {
    inventoryCountTransactionID
  }
}
    `;

export function useInventoryCountTaskRecountUpdateMutation() {
  return Urql.useMutation<InventoryCountTaskRecountUpdateMutation, InventoryCountTaskRecountUpdateMutationVariables>(InventoryCountTaskRecountUpdateDocument);
};
export const InventoryCountItemTemplateAutocompleteDocument = gql`
    query InventoryCountItemTemplateAutocomplete($qop: InventoryCountItemTemplateQopInput) {
  inventoryCountItemTemplates(qop: $qop) {
    items {
      inventoryCountItemTemplateID
      inventoryCountItemTemplateName
      isActive
      itemCount
      uniqueKey
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountItemTemplateAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountItemTemplateAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountItemTemplateAutocompleteQuery, InventoryCountItemTemplateAutocompleteQueryVariables>({ query: InventoryCountItemTemplateAutocompleteDocument, ...options });
};
export const InventoryCountTransactionCancelDocument = gql`
    mutation InventoryCountTransactionCancel($input: InventoryCountTransactionCancelInput!) {
  inventoryCountTransactionCancel(input: $input) {
    inventoryCountTransactionID
    cancellationReason
  }
}
    `;

export function useInventoryCountTransactionCancelMutation() {
  return Urql.useMutation<InventoryCountTransactionCancelMutation, InventoryCountTransactionCancelMutationVariables>(InventoryCountTransactionCancelDocument);
};
export const InventoryCountTransactionExportResultsDocument = gql`
    mutation InventoryCountTransactionExportResults($input: InventoryCountTransactionExportInput!) {
  inventoryCountTransactionExportResults(input: $input) {
    downloadUrl
    fileName
  }
}
    `;

export function useInventoryCountTransactionExportResultsMutation() {
  return Urql.useMutation<InventoryCountTransactionExportResultsMutation, InventoryCountTransactionExportResultsMutationVariables>(InventoryCountTransactionExportResultsDocument);
};
export const InventoryCountTransactionExportResultsByLocationDocument = gql`
    mutation InventoryCountTransactionExportResultsByLocation($input: InventoryCountTransactionExportInput!) {
  inventoryCountTransactionExportResultsByLocation(input: $input) {
    downloadUrl
    fileName
  }
}
    `;

export function useInventoryCountTransactionExportResultsByLocationMutation() {
  return Urql.useMutation<InventoryCountTransactionExportResultsByLocationMutation, InventoryCountTransactionExportResultsByLocationMutationVariables>(InventoryCountTransactionExportResultsByLocationDocument);
};
export const InventoryCountTransactionFinishDocument = gql`
    mutation InventoryCountTransactionFinish($input: InventoryCountTransactionFinishInput!) {
  inventoryCountTransactionFinish(input: $input) {
    inventoryCountTransactionID
  }
}
    `;

export function useInventoryCountTransactionFinishMutation() {
  return Urql.useMutation<InventoryCountTransactionFinishMutation, InventoryCountTransactionFinishMutationVariables>(InventoryCountTransactionFinishDocument);
};
export const InventoryCountTransactionLocationDocument = gql`
    query InventoryCountTransactionLocation($qop: InventoryCountTransactionLocationQopInput) {
  inventoryCountTransactionLocations(qop: $qop) {
    items {
      inventoryCountTransactionLocationID
      inventoryCountTransactionID
      warehouseLocationName
      warehouseLocationID
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountTransactionLocationQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountTransactionLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountTransactionLocationQuery, InventoryCountTransactionLocationQueryVariables>({ query: InventoryCountTransactionLocationDocument, ...options });
};
export const InventoryCountTransactionResultItemDetailsDocument = gql`
    query InventoryCountTransactionResultItemDetails($qop: InventoryCountTransactionResultItemDetailQopInput) {
  inventoryCountTransactionResultItemDetails(qop: $qop) {
    items {
      inventoryCountTransactionResultItemDetailID
      inventoryCountTransactionResultItemID
      inventoryCountTransactionLocationDetailID
      warehouseID
      warehouseLocationID
      warehouseLocationName
      productID
      productCode
      productName
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      qtyCounted
      qtySystem
      qtyDiff
      baseUomQtyCounted
      baseUomQtySystem
      baseUomQtyDiff
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryCountTransactionResultItemDetailsQuery(options?: Omit<Urql.UseQueryArgs<InventoryCountTransactionResultItemDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountTransactionResultItemDetailsQuery, InventoryCountTransactionResultItemDetailsQueryVariables>({ query: InventoryCountTransactionResultItemDetailsDocument, ...options });
};
export const InventoryCountLoadDocument = gql`
    query InventoryCountLoad($inventoryCountTransactionID: UUID!) {
  inventoryCountTransaction(
    inventoryCountTransactionID: $inventoryCountTransactionID
  ) {
    inventoryCountTransactionID
    inventoryCountTransactionNumber
    inventoryCountTransactionDatetime
    inventoryCountTransactionDatetimeUtc
    branchID
    gmt
    warehouseID
    taskType
    totalItems
    totalCountTasks
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    status
    warehouse {
      warehouseName
    }
    entityAuditMetadata {
      version
    }
  }
}
    `;

export function useInventoryCountLoadQuery(options: Omit<Urql.UseQueryArgs<InventoryCountLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryCountLoadQuery, InventoryCountLoadQueryVariables>({ query: InventoryCountLoadDocument, ...options });
};
export const InventoryCountTaskAssigneeAddDocument = gql`
    mutation InventoryCountTaskAssigneeAdd($input: InventoryCountTaskAssigneeAddInput!) {
  inventoryCountTaskAssigneeAdd(input: $input)
}
    `;

export function useInventoryCountTaskAssigneeAddMutation() {
  return Urql.useMutation<InventoryCountTaskAssigneeAddMutation, InventoryCountTaskAssigneeAddMutationVariables>(InventoryCountTaskAssigneeAddDocument);
};
export const InventoryCountUpdateDocument = gql`
    mutation InventoryCountUpdate($input: InventoryCountTransactionUpdateInput!) {
  inventoryCountTransactionUpdate(input: $input) {
    inventoryCountTransactionID
    inventoryCountTransactionNumber
    inventoryCountTransactionDatetime
    inventoryCountTransactionDatetimeUtc
    branchID
    gmt
    warehouseID
    taskType
    totalItems
    totalCountTasks
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    status
  }
}
    `;

export function useInventoryCountUpdateMutation() {
  return Urql.useMutation<InventoryCountUpdateMutation, InventoryCountUpdateMutationVariables>(InventoryCountUpdateDocument);
};
export const VendorConsignmentProductsByBranchDocument = gql`
    query VendorConsignmentProductsByBranch($qop: VendorConsignmentProductQopInput) {
  vendorConsignmentProducts(qop: $qop) {
    items {
      productID
      product {
        productCode
        productName
        barcode
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useVendorConsignmentProductsByBranchQuery(options?: Omit<Urql.UseQueryArgs<VendorConsignmentProductsByBranchQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentProductsByBranchQuery, VendorConsignmentProductsByBranchQueryVariables>({ query: VendorConsignmentProductsByBranchDocument, ...options });
};
export const InventoryAdjustmentStatusForIcDocument = gql`
    query InventoryAdjustmentStatusForIC($jobQop: BackgroundJobQopInput!) {
  backgroundJobs(qop: $jobQop) {
    items {
      backgroundJobID
      jobCategory
      jobType
      jobKey
      jobDescription
      jobMessage
      jobData
      status
      processedCount
      totalCount
      retryCount
      startedDatetime
      finishedDatetime
      entityAuditMetadata {
        createdAt
        updatedAt
        version
      }
    }
  }
}
    `;

export function useInventoryAdjustmentStatusForIcQuery(options: Omit<Urql.UseQueryArgs<InventoryAdjustmentStatusForIcQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryAdjustmentStatusForIcQuery, InventoryAdjustmentStatusForIcQueryVariables>({ query: InventoryAdjustmentStatusForIcDocument, ...options });
};
export const InventoryAdjustmentLookupByNumberDocument = gql`
    query InventoryAdjustmentLookupByNumber($qop: InventoryAdjustmentQopInput) {
  inventoryAdjustments(qop: $qop) {
    items {
      inventoryAdjustmentID
      inventoryAdjustmentNumber
      status
    }
  }
}
    `;

export function useInventoryAdjustmentLookupByNumberQuery(options?: Omit<Urql.UseQueryArgs<InventoryAdjustmentLookupByNumberQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryAdjustmentLookupByNumberQuery, InventoryAdjustmentLookupByNumberQueryVariables>({ query: InventoryAdjustmentLookupByNumberDocument, ...options });
};
export const InventoryAdjustmentRetryFromBackgroundJobDocument = gql`
    mutation InventoryAdjustmentRetryFromBackgroundJob($backgroundJobID: UUID!) {
  inventoryAdjustmentRetryFromBackgroundJob(backgroundJobID: $backgroundJobID)
}
    `;

export function useInventoryAdjustmentRetryFromBackgroundJobMutation() {
  return Urql.useMutation<InventoryAdjustmentRetryFromBackgroundJobMutation, InventoryAdjustmentRetryFromBackgroundJobMutationVariables>(InventoryAdjustmentRetryFromBackgroundJobDocument);
};
export const InventoryLocationListDocument = gql`
    query InventoryLocationList($qop: InventoryLocationQopInput) {
  inventoryLocations(qop: $qop) {
    items {
      inventoryLocationID
      productID
      product {
        productID
        productCode
        productName
        barcode
      }
      warehouseID
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
      warehouseLocationID
      warehouseLocation {
        warehouseLocationID
        warehouseLocationName
      }
      qty
      entityAuditMetadata {
        createdAt
        updatedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryLocationListQuery(options?: Omit<Urql.UseQueryArgs<InventoryLocationListQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryLocationListQuery, InventoryLocationListQueryVariables>({ query: InventoryLocationListDocument, ...options });
};
export const InventoryMovementSummaryListDocument = gql`
    query InventoryMovementSummaryList($qop: InventoryMovementSummaryQopInput!) {
  inventoryMovementSummary(qop: $qop) {
    items {
      productID
      product {
        productID
        productCode
        productName
        barcode
      }
      warehouseID
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
      startingDate
      endingDate
      startingQty
      qtyIn
      qtyOut
      endingQty
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryMovementSummaryListQuery(options: Omit<Urql.UseQueryArgs<InventoryMovementSummaryListQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryMovementSummaryListQuery, InventoryMovementSummaryListQueryVariables>({ query: InventoryMovementSummaryListDocument, ...options });
};
export const InventorySummaryListDocument = gql`
    query InventorySummaryList($qop: InventorySummaryQopInput) {
  inventorySummaries(qop: $qop) {
    items {
      inventorySummaryID
      productID
      product {
        productID
        productCode
        productName
        barcode
      }
      warehouseID
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
      qtyOnHand
      qtyAvailable
      qty
      qtyCommitted
      qtyRejected
      unitCost
      totalCost
      lastAvgCost
      lastUnitCost
      entityAuditMetadata {
        createdAt
        updatedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventorySummaryListQuery(options?: Omit<Urql.UseQueryArgs<InventorySummaryListQueryVariables>, 'query'>) {
  return Urql.useQuery<InventorySummaryListQuery, InventorySummaryListQueryVariables>({ query: InventorySummaryListDocument, ...options });
};
export const InventoryTransactionLineUnitListDocument = gql`
    query InventoryTransactionLineUnitList($qop: InventoryTransactionLineUnitQopInput) {
  inventoryTransactionLineUnits(qop: $qop) {
    items {
      inventoryTransactionLineUnitID
      inventoryTransactionLineItemID
      inventoryTransactionLineID
      prevQtyBalance
      prevLocationQtyBalance
      inventoryTransactionID
      inventoryTransaction {
        inventoryTransactionID
        inventoryTransactionNumber
        sourceDocumentType
        sourceDocumentNumber
        sourceDocumentID
      }
      productID
      product {
        productID
        productCode
        productName
        barcode
      }
      warehouseID
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
      warehouseLocationID
      warehouseLocation {
        warehouseLocationID
        warehouseLocationName
      }
      lotNumber
      expiryDate
      qty
      actualUnitCost
      actualTotalCost
      postedUnitCost
      postedTotalCost
      direction
      balanceUpdate
      sortIndex
      entityAuditMetadata {
        createdAt
        updatedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryTransactionLineUnitListQuery(options?: Omit<Urql.UseQueryArgs<InventoryTransactionLineUnitListQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryTransactionLineUnitListQuery, InventoryTransactionLineUnitListQueryVariables>({ query: InventoryTransactionLineUnitListDocument, ...options });
};
export const InventoryTransactionListDocument = gql`
    query InventoryTransactionList($qop: InventoryTransactionQopInput) {
  inventoryTransactions(qop: $qop) {
    items {
      inventoryTransactionID
      inventoryTransactionNumber
      inventoryTransactionTransactionDate
      inventoryTransactionTransactionDateUtc
      inventoryTransactionKey
      branchID
      gmt
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      warehouseID
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
      counterpartWarehouseID
      counterpartWarehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
      itemCount
      itemTotalCost
      status
      noteInternal
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        createdAt
        updatedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useInventoryTransactionListQuery(options?: Omit<Urql.UseQueryArgs<InventoryTransactionListQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryTransactionListQuery, InventoryTransactionListQueryVariables>({ query: InventoryTransactionListDocument, ...options });
};
export const InventoryTransactionLoadDocument = gql`
    query InventoryTransactionLoad($inventoryTransactionID: UUID!) {
  inventoryTransaction(inventoryTransactionID: $inventoryTransactionID) {
    inventoryTransactionID
    inventoryTransactionNumber
    inventoryTransactionTransactionDate
    inventoryTransactionTransactionDateUtc
    inventoryTransactionKey
    branchID
    gmt
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    warehouseID
    warehouse {
      warehouseID
      warehouseCode
      warehouseName
    }
    counterpartWarehouseID
    counterpartWarehouse {
      warehouseID
      warehouseCode
      warehouseName
    }
    itemCount
    itemTotalCost
    status
    noteInternal
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      createdAt
      updatedAt
      version
    }
  }
}
    `;

export function useInventoryTransactionLoadQuery(options: Omit<Urql.UseQueryArgs<InventoryTransactionLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<InventoryTransactionLoadQuery, InventoryTransactionLoadQueryVariables>({ query: InventoryTransactionLoadDocument, ...options });
};
export const MarketplaceChannelApiLogDocument = gql`
    query MarketplaceChannelAPILog($marketplaceChannelAPILogID: UUID!) {
  marketplaceChannelAPILog(
    marketplaceChannelAPILogID: $marketplaceChannelAPILogID
  ) {
    marketplaceChannelAPILogID
    salesChannelID
    direction
    operation
    externalMerchantID
    httpMethod
    url
    requestBody
    responseStatus
    responseBody
    errorMessage
    durationMs
    createdAt
  }
}
    `;

export function useMarketplaceChannelApiLogQuery(options: Omit<Urql.UseQueryArgs<MarketplaceChannelApiLogQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceChannelApiLogQuery, MarketplaceChannelApiLogQueryVariables>({ query: MarketplaceChannelApiLogDocument, ...options });
};
export const MarketplaceChannelApiLogsDocument = gql`
    query MarketplaceChannelAPILogs($qop: MarketplaceChannelAPILogQopInput) {
  marketplaceChannelAPILogs(qop: $qop) {
    items {
      marketplaceChannelAPILogID
      salesChannelID
      direction
      operation
      externalMerchantID
      httpMethod
      url
      responseStatus
      errorMessage
      durationMs
      createdAt
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useMarketplaceChannelApiLogsQuery(options?: Omit<Urql.UseQueryArgs<MarketplaceChannelApiLogsQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceChannelApiLogsQuery, MarketplaceChannelApiLogsQueryVariables>({ query: MarketplaceChannelApiLogsDocument, ...options });
};
export const MarketplaceCronRunDocument = gql`
    mutation MarketplaceCronRun($jobKey: String!) {
  marketplaceCronRun(jobKey: $jobKey) {
    jobKey
    status
    message
    ranAt
  }
}
    `;

export function useMarketplaceCronRunMutation() {
  return Urql.useMutation<MarketplaceCronRunMutation, MarketplaceCronRunMutationVariables>(MarketplaceCronRunDocument);
};
export const MarketplaceCronSettingListDocument = gql`
    query MarketplaceCronSettingList($qop: MarketplaceCronSettingQopInput) {
  marketplaceCronSettings(qop: $qop) {
    items {
      jobKey
      jobName
      description
      spec
      isEnabled
      lastRunAt
      lastRunStatus
      lastRunMessage
      updatedAt
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useMarketplaceCronSettingListQuery(options?: Omit<Urql.UseQueryArgs<MarketplaceCronSettingListQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceCronSettingListQuery, MarketplaceCronSettingListQueryVariables>({ query: MarketplaceCronSettingListDocument, ...options });
};
export const MarketplaceCronSettingUpdateDocument = gql`
    mutation MarketplaceCronSettingUpdate($input: MarketplaceCronSettingUpdateInput!) {
  marketplaceCronSettingUpdate(input: $input) {
    jobKey
    isEnabled
    lastRunAt
    lastRunStatus
    lastRunMessage
    updatedAt
  }
}
    `;

export function useMarketplaceCronSettingUpdateMutation() {
  return Urql.useMutation<MarketplaceCronSettingUpdateMutation, MarketplaceCronSettingUpdateMutationVariables>(MarketplaceCronSettingUpdateDocument);
};
export const MarketplaceInboundOrdersDocument = gql`
    query MarketplaceInboundOrders($qop: MarketplaceInboundOrderQopInput) {
  marketplaceInboundOrders(qop: $qop) {
    items {
      marketplaceInboundOrderID
      eventType
      source
      status
      errorMessage
      payload
      receivedAtUtc
      settledAtUtc
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useMarketplaceInboundOrdersQuery(options?: Omit<Urql.UseQueryArgs<MarketplaceInboundOrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceInboundOrdersQuery, MarketplaceInboundOrdersQueryVariables>({ query: MarketplaceInboundOrdersDocument, ...options });
};
export const MarketplaceOrderDocument = gql`
    query MarketplaceOrder($marketplaceOrderID: UUID!) {
  marketplaceOrder(marketplaceOrderID: $marketplaceOrderID) {
    marketplaceOrderID
    version
    salesChannelID
    externalOrderID
    shortOrderNumber
    externalMerchantID
    externalStoreID
    customerName
    paymentType
    noteInternal
    branchCode
    branchName
    gmt
    status
    isEdited
    subtotalAmount
    taxAmount
    deliveryFeeAmount
    discountAmount
    totalAmount
    salesChannelAdditionalCharge
    customerPaymentAmount
    pricingStatus
    pricingIssues {
      code
      message
    }
    promos {
      code
      name
      kind
      level
      merchantAmount
      fullAmount
      freeItemProductCode
      freeItemQty
    }
    orderDatetimeUtc
    receivedAtUtc
    acceptedAtUtc
    readyMarkedAtUtc
    posInvoiceNumber
    settledAtUtc
    paymentReconciledAtUtc
    updatedAtUtc
  }
  marketplaceOrderItems(
    qop: {filters: {marketplaceOrderID: $marketplaceOrderID}, sorts: [{field: "line_index", direction: "asc"}]}
  ) {
    items {
      lineIndex
      externalItemID
      externalItemName
      productCode
      productName
      barcode
      qty
      unitPrice
      totalPrice
      discountAmount
      netAmount
      freeQty
      promoNames
      note
      addonComponents {
        productName
        qty
        unitPrice
      }
    }
  }
}
    `;

export function useMarketplaceOrderQuery(options: Omit<Urql.UseQueryArgs<MarketplaceOrderQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceOrderQuery, MarketplaceOrderQueryVariables>({ query: MarketplaceOrderDocument, ...options });
};
export const MarketplaceOrderCancelDocument = gql`
    mutation MarketplaceOrderCancel($input: MarketplaceOrderCancelInput!) {
  marketplaceOrderCancel(input: $input) {
    marketplaceOrderID
    version
    externalOrderID
    salesChannelID
    status
  }
}
    `;

export function useMarketplaceOrderCancelMutation() {
  return Urql.useMutation<MarketplaceOrderCancelMutation, MarketplaceOrderCancelMutationVariables>(MarketplaceOrderCancelDocument);
};
export const MarketplaceOrderCheckCancelableDocument = gql`
    query MarketplaceOrderCheckCancelable($salesChannelID: String!, $externalOrderID: String!) {
  marketplaceOrderCheckCancelable(
    salesChannelID: $salesChannelID
    externalOrderID: $externalOrderID
  ) {
    cancelable
    nonCancellationReason
    limitType
    limitTimes
    cancelReasons {
      code
      reason
    }
  }
}
    `;

export function useMarketplaceOrderCheckCancelableQuery(options: Omit<Urql.UseQueryArgs<MarketplaceOrderCheckCancelableQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceOrderCheckCancelableQuery, MarketplaceOrderCheckCancelableQueryVariables>({ query: MarketplaceOrderCheckCancelableDocument, ...options });
};
export const MarketplaceOrderExportDocument = gql`
    query MarketplaceOrderExport($qop: MarketplaceOrderQopInput) {
  marketplaceOrderExport(qop: $qop) {
    downloadURL
    fileName
  }
}
    `;

export function useMarketplaceOrderExportQuery(options?: Omit<Urql.UseQueryArgs<MarketplaceOrderExportQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceOrderExportQuery, MarketplaceOrderExportQueryVariables>({ query: MarketplaceOrderExportDocument, ...options });
};
export const MarketplaceOrderMarkReadyDocument = gql`
    mutation MarketplaceOrderMarkReady($input: MarketplaceOrderMarkReadyInput!) {
  marketplaceOrderMarkReady(input: $input) {
    marketplaceOrderID
    version
    externalOrderID
    salesChannelID
    status
    acceptedAtUtc
    readyMarkedAtUtc
  }
}
    `;

export function useMarketplaceOrderMarkReadyMutation() {
  return Urql.useMutation<MarketplaceOrderMarkReadyMutation, MarketplaceOrderMarkReadyMutationVariables>(MarketplaceOrderMarkReadyDocument);
};
export const MarketplaceOrderReconcilePaymentDocument = gql`
    mutation MarketplaceOrderReconcilePayment($input: MarketplaceOrderReconcilePaymentInput!) {
  marketplaceOrderReconcilePayment(input: $input) {
    marketplaceOrderID
    paymentReconciledAtUtc
  }
}
    `;

export function useMarketplaceOrderReconcilePaymentMutation() {
  return Urql.useMutation<MarketplaceOrderReconcilePaymentMutation, MarketplaceOrderReconcilePaymentMutationVariables>(MarketplaceOrderReconcilePaymentDocument);
};
export const MarketplaceOrderSalesInvoiceDocument = gql`
    query MarketplaceOrderSalesInvoice($salesInvoiceNumber: String!) {
  salesInvoices(
    qop: {filters: {salesInvoiceNumber: $salesInvoiceNumber}, pagination: {page: 1, pageSize: 5}}
  ) {
    items {
      salesInvoiceID
      salesInvoiceNumber
    }
  }
}
    `;

export function useMarketplaceOrderSalesInvoiceQuery(options: Omit<Urql.UseQueryArgs<MarketplaceOrderSalesInvoiceQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceOrderSalesInvoiceQuery, MarketplaceOrderSalesInvoiceQueryVariables>({ query: MarketplaceOrderSalesInvoiceDocument, ...options });
};
export const MarketplaceOrderSyncPosDocument = gql`
    mutation MarketplaceOrderSyncPOS($input: MarketplaceOrderSyncPOSInput!) {
  marketplaceOrderSyncPOS(input: $input) {
    externalOrderID
    posOrderID
    posInvoiceNumber
    status
    success
  }
}
    `;

export function useMarketplaceOrderSyncPosMutation() {
  return Urql.useMutation<MarketplaceOrderSyncPosMutation, MarketplaceOrderSyncPosMutationVariables>(MarketplaceOrderSyncPosDocument);
};
export const MarketplaceOrdersDocument = gql`
    query MarketplaceOrders($qop: MarketplaceOrderQopInput) {
  marketplaceOrders(qop: $qop) {
    items {
      marketplaceOrderID
      salesChannelID
      externalOrderID
      shortOrderNumber
      branchCode
      branchName
      gmt
      status
      isEdited
      totalAmount
      receivedAtUtc
      posInvoiceNumber
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useMarketplaceOrdersQuery(options?: Omit<Urql.UseQueryArgs<MarketplaceOrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceOrdersQuery, MarketplaceOrdersQueryVariables>({ query: MarketplaceOrdersDocument, ...options });
};
export const MemberTypeAutocompleteDocument = gql`
    query MemberTypeAutocomplete($qop: MemberTypeQopInput) {
  memberTypes(qop: $qop) {
    items {
      memberTypeID
      memberTypeName
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useMemberTypeAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<MemberTypeAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<MemberTypeAutocompleteQuery, MemberTypeAutocompleteQueryVariables>({ query: MemberTypeAutocompleteDocument, ...options });
};
export const MemberTypesCreateDocument = gql`
    mutation MemberTypesCreate($input: MemberTypeCreateInput!) {
  memberTypeCreate(input: $input) {
    memberTypeID
  }
}
    `;

export function useMemberTypesCreateMutation() {
  return Urql.useMutation<MemberTypesCreateMutation, MemberTypesCreateMutationVariables>(MemberTypesCreateDocument);
};
export const MemberTypeDeleteDocument = gql`
    mutation MemberTypeDelete($memberTypeID: UUID!) {
  memberTypeDelete(memberTypeID: $memberTypeID)
}
    `;

export function useMemberTypeDeleteMutation() {
  return Urql.useMutation<MemberTypeDeleteMutation, MemberTypeDeleteMutationVariables>(MemberTypeDeleteDocument);
};
export const MemberTypeListDocument = gql`
    query MemberTypeList($qop: MemberTypeQopInput) {
  memberTypes(qop: $qop) {
    items {
      memberTypeID
      memberTypeName
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useMemberTypeListQuery(options?: Omit<Urql.UseQueryArgs<MemberTypeListQueryVariables>, 'query'>) {
  return Urql.useQuery<MemberTypeListQuery, MemberTypeListQueryVariables>({ query: MemberTypeListDocument, ...options });
};
export const MemberTypeLoadDocument = gql`
    query MemberTypeLoad($memberTypeID: UUID!) {
  memberType(memberTypeID: $memberTypeID) {
    memberTypeID
    memberTypeName
    spendPerPoint
    uniqueKey
    isActive
  }
}
    `;

export function useMemberTypeLoadQuery(options: Omit<Urql.UseQueryArgs<MemberTypeLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<MemberTypeLoadQuery, MemberTypeLoadQueryVariables>({ query: MemberTypeLoadDocument, ...options });
};
export const MemberTypeUpdateDocument = gql`
    mutation MemberTypeUpdate($input: MemberTypeUpdateInput!) {
  memberTypeUpdate(input: $input) {
    memberTypeID
  }
}
    `;

export function useMemberTypeUpdateMutation() {
  return Urql.useMutation<MemberTypeUpdateMutation, MemberTypeUpdateMutationVariables>(MemberTypeUpdateDocument);
};
export const OutboundContainerListDocument = gql`
    query OutboundContainerList($qop: OutboundContainerQopInput) {
  outboundContainers(qop: $qop) {
    items {
      outboundContainerID
      containerNumber
      sourceDocumentNumber
      sourceDocumentType
      toWarehouseID
      toWarehouse {
        warehouseName
      }
      totalItems
      totalQty
      deliveryOrderID
      isDo
      isEmpty
      draftDeliveryOrderBatchNumber
      draftDeliveryOrderBatchID
      packingTask {
        packingTaskNumber
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useOutboundContainerListQuery(options?: Omit<Urql.UseQueryArgs<OutboundContainerListQueryVariables>, 'query'>) {
  return Urql.useQuery<OutboundContainerListQuery, OutboundContainerListQueryVariables>({ query: OutboundContainerListDocument, ...options });
};
export const OutboundContainerLoadDocument = gql`
    query OutboundContainerLoad($outboundContainerID: UUID!) {
  outboundContainer(outboundContainerID: $outboundContainerID) {
    outboundContainerID
    containerNumber
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    deliveryOrderID
    deliveryOrder {
      deliveryOrderID
      deliveryOrderNumber
      deliveryOrderDatetime
      fromWarehouseName
      fromWarehouseCode
    }
    packingTask {
      packingTaskID
      packingTaskNumber
      status
    }
    toWarehouseID
    toWarehouse {
      warehouseName
      warehouseCode
      branch {
        branchName
        branchCode
        branchType
        fullAddress
      }
    }
    totalItems
    totalQty
    totalWeight
    isDo
    isEmpty
    isReceived
    isSealed
    draftDeliveryOrderBatchNumber
    draftDeliveryOrderBatchID
    noteInternal
  }
}
    `;

export function useOutboundContainerLoadQuery(options: Omit<Urql.UseQueryArgs<OutboundContainerLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<OutboundContainerLoadQuery, OutboundContainerLoadQueryVariables>({ query: OutboundContainerLoadDocument, ...options });
};
export const OutboundContainerPackingTaskLoadDocument = gql`
    query OutboundContainerPackingTaskLoad($packingTaskID: UUID!) {
  packingTask(packingTaskID: $packingTaskID) {
    packingTaskID
    packingTaskNumber
    packingTaskDatetime
    fromWarehouseName
    fromWarehouseCode
  }
}
    `;

export function useOutboundContainerPackingTaskLoadQuery(options: Omit<Urql.UseQueryArgs<OutboundContainerPackingTaskLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<OutboundContainerPackingTaskLoadQuery, OutboundContainerPackingTaskLoadQueryVariables>({ query: OutboundContainerPackingTaskLoadDocument, ...options });
};
export const PackingTaskBulkContainerGenerationDocument = gql`
    mutation PackingTaskBulkContainerGeneration($input: BulkContainerGenerationInput!) {
  outboundContainerBulkGeneration(input: $input)
}
    `;

export function usePackingTaskBulkContainerGenerationMutation() {
  return Urql.useMutation<PackingTaskBulkContainerGenerationMutation, PackingTaskBulkContainerGenerationMutationVariables>(PackingTaskBulkContainerGenerationDocument);
};
export const PackingTaskContainerItemsDocument = gql`
    query PackingTaskContainerItems($qop: PackingTaskContainerItemQopInput) {
  packingTaskContainerItems(qop: $qop) {
    items {
      packingTaskContainerItemID
      packingTaskContainerID
      packingTaskItemID
      packingTaskID
      outboundContainerID
      outboundContainerItemID
      qty
      baseUomQty
      packingTaskItem {
        productName
        productID
        productCode
        product {
          barcode
        }
        uomName
        qtyPacked
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePackingTaskContainerItemsQuery(options?: Omit<Urql.UseQueryArgs<PackingTaskContainerItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<PackingTaskContainerItemsQuery, PackingTaskContainerItemsQueryVariables>({ query: PackingTaskContainerItemsDocument, ...options });
};
export const PackingTaskContainerOpenSealDocument = gql`
    mutation PackingTaskContainerOpenSeal($input: OpenSealContainerInput!) {
  outboundContainerOpenSeal(input: $input) {
    outboundContainerID
  }
}
    `;

export function usePackingTaskContainerOpenSealMutation() {
  return Urql.useMutation<PackingTaskContainerOpenSealMutation, PackingTaskContainerOpenSealMutationVariables>(PackingTaskContainerOpenSealDocument);
};
export const PackingTaskCreateContainerDocument = gql`
    mutation PackingTaskCreateContainer($input: OutboundContainerCreateInput!) {
  outboundContainerCreate(input: $input) {
    outboundContainerID
    deliveryOrderID
    sourceDocumentType
    sourceDocumentNumber
    containerNumber
    fromBranchID
    gmt
    toWarehouseID
    toBranchID
    fromWarehouseID
    noteInternal
    totalWeight
    totalQty
    totalItems
    isSealed
    isDo
  }
}
    `;

export function usePackingTaskCreateContainerMutation() {
  return Urql.useMutation<PackingTaskCreateContainerMutation, PackingTaskCreateContainerMutationVariables>(PackingTaskCreateContainerDocument);
};
export const PackingTaskDeleteContainerDocument = gql`
    mutation PackingTaskDeleteContainer($input: RemoveContainerInput!) {
  outboundContainerDelete(input: $input)
}
    `;

export function usePackingTaskDeleteContainerMutation() {
  return Urql.useMutation<PackingTaskDeleteContainerMutation, PackingTaskDeleteContainerMutationVariables>(PackingTaskDeleteContainerDocument);
};
export const PackingTaskFinishDocument = gql`
    mutation PackingTaskFinish($input: PackingTaskFinishInput!) {
  packingTaskFinish(input: $input) {
    packingTaskID
  }
}
    `;

export function usePackingTaskFinishMutation() {
  return Urql.useMutation<PackingTaskFinishMutation, PackingTaskFinishMutationVariables>(PackingTaskFinishDocument);
};
export const PackingTaskItemsDocument = gql`
    query PackingTaskItems($qop: PackingTaskItemQopInput) {
  packingTaskItems(qop: $qop) {
    items {
      productID
      productCode
      productName
      product {
        barcode
      }
      uomName
      qtyPacked
      packingTaskItemID
      qtyPicked
      qtyVerified
      qtyDiff
      qtyOutstanding
      packingTaskItemID
      pickingTaskItemID
      pickingTaskExecution {
        qty
        uomName
        baseUomQty
        warehouseLocationName
        pickingTaskItemID
      }
      pickingTaskItem {
        executions {
          qty
          uomName
          baseUomQty
          warehouseLocationName
          pickingTaskItemID
        }
      }
      entityAuditMetadata {
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePackingTaskItemsQuery(options?: Omit<Urql.UseQueryArgs<PackingTaskItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<PackingTaskItemsQuery, PackingTaskItemsQueryVariables>({ query: PackingTaskItemsDocument, ...options });
};
export const PackingTaskListDocument = gql`
    query PackingTaskList($qop: PackingTaskQopInput) {
  packingTasks(qop: $qop) {
    items {
      packingTaskID
      packingTaskNumber
      packingTaskDatetime
      packingTaskDatetimeUtc
      pickingTaskNumber
      sourceDocumentType
      sourceDocumentNumber
      fromWarehouseName
      packedUserName
      taskStartAt
      taskDoneAt
      taskDurationMinute
      status
      packedUserName
      sourceDocumentID
      pickingTaskID
      pickingTask {
        status
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePackingTaskListQuery(options?: Omit<Urql.UseQueryArgs<PackingTaskListQueryVariables>, 'query'>) {
  return Urql.useQuery<PackingTaskListQuery, PackingTaskListQueryVariables>({ query: PackingTaskListDocument, ...options });
};
export const PackingTaskListContainerDocument = gql`
    query PackingTaskListContainer($qop: PackingTaskContainerQopInput) {
  packingTaskContainers(qop: $qop) {
    items {
      packingTaskContainerID
      packingTaskID
      outboundContainerID
      outboundContainer {
        outboundContainerID
        containerNumber
        totalItems
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePackingTaskListContainerQuery(options?: Omit<Urql.UseQueryArgs<PackingTaskListContainerQueryVariables>, 'query'>) {
  return Urql.useQuery<PackingTaskListContainerQuery, PackingTaskListContainerQueryVariables>({ query: PackingTaskListContainerDocument, ...options });
};
export const PackingTaskLoadDocument = gql`
    query PackingTaskLoad($packingTaskID: UUID!) {
  packingTask(packingTaskID: $packingTaskID) {
    packingTaskID
    sourceDocumentType
    sourceDocumentNumber
    pickingTaskNumber
    fromWarehouseName
    toWarehouseName
    packingTaskNumber
    packingTaskDatetime
    taskStartAt
    taskDoneAt
    taskDurationMinute
    status
    fromWarehouseID
    toWarehouseID
    fromWarehouseCode
    branchID
    sourceDocumentID
    noteInternal
    gmt
    pickedUserName
    toWarehouse {
      warehouseName
      branch {
        branchName
        branchType
        fullAddress
        branchCode
      }
    }
  }
}
    `;

export function usePackingTaskLoadQuery(options: Omit<Urql.UseQueryArgs<PackingTaskLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PackingTaskLoadQuery, PackingTaskLoadQueryVariables>({ query: PackingTaskLoadDocument, ...options });
};
export const PackingTaskPackItemDocument = gql`
    mutation PackingTaskPackItem($input: OutboundContainerPackItemInput!) {
  outboundContainerPackItem(input: $input) {
    outboundContainerID
  }
}
    `;

export function usePackingTaskPackItemMutation() {
  return Urql.useMutation<PackingTaskPackItemMutation, PackingTaskPackItemMutationVariables>(PackingTaskPackItemDocument);
};
export const PackingTaskProductBarcodeMapsDocument = gql`
    query PackingTaskProductBarcodeMaps($qop: ProductBarcodeMapQopInput) {
  productBarcodeMaps(qop: $qop) {
    items {
      productBarcodeMapID
      productID
      barcode
      uniqueKey
      product {
        productCode
        productName
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePackingTaskProductBarcodeMapsQuery(options?: Omit<Urql.UseQueryArgs<PackingTaskProductBarcodeMapsQueryVariables>, 'query'>) {
  return Urql.useQuery<PackingTaskProductBarcodeMapsQuery, PackingTaskProductBarcodeMapsQueryVariables>({ query: PackingTaskProductBarcodeMapsDocument, ...options });
};
export const PackingTaskStartDocument = gql`
    mutation PackingTaskStart($input: PackingTaskStartInput!) {
  packingTaskStart(input: $input) {
    packingTaskID
  }
}
    `;

export function usePackingTaskStartMutation() {
  return Urql.useMutation<PackingTaskStartMutation, PackingTaskStartMutationVariables>(PackingTaskStartDocument);
};
export const PackingTaskUnpackItemDocument = gql`
    mutation PackingTaskUnpackItem($input: OutboundContainerUnpackItemInput!) {
  outboundContainerUnpackItem(input: $input) {
    outboundContainerID
  }
}
    `;

export function usePackingTaskUnpackItemMutation() {
  return Urql.useMutation<PackingTaskUnpackItemMutation, PackingTaskUnpackItemMutationVariables>(PackingTaskUnpackItemDocument);
};
export const PackingTaskUpdateQtyDocument = gql`
    mutation PackingTaskUpdateQty($input: OutboundContainerUpdatePackItemInput!) {
  outboundContainerUpdatePackItem(input: $input) {
    outboundContainerID
  }
}
    `;

export function usePackingTaskUpdateQtyMutation() {
  return Urql.useMutation<PackingTaskUpdateQtyMutation, PackingTaskUpdateQtyMutationVariables>(PackingTaskUpdateQtyDocument);
};
export const PackingTaskVerifyDocument = gql`
    mutation PackingTaskVerify($input: PackingTaskVerifyInput!) {
  packingTaskVerify(input: $input) {
    packingTaskID
    noteInternal
  }
}
    `;

export function usePackingTaskVerifyMutation() {
  return Urql.useMutation<PackingTaskVerifyMutation, PackingTaskVerifyMutationVariables>(PackingTaskVerifyDocument);
};
export const PaymentInboundRequestListDocument = gql`
    query PaymentInboundRequestList($qop: PaymentInboundRequestLogQopInput) {
  paymentInboundRequests(qop: $qop) {
    items {
      paymentInboundRequestLogID
      requestType
      endpoint
      httpMethod
      providerCode
      providerConfigID
      clientKey
      externalID
      partnerReferenceNo
      timestampHeader
      signature
      headers
      requestBody
      responseStatus
      responseCode
      responseMessage
      responseBody
      isSuccess
      errorReason
      receivedAt
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePaymentInboundRequestListQuery(options?: Omit<Urql.UseQueryArgs<PaymentInboundRequestListQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentInboundRequestListQuery, PaymentInboundRequestListQueryVariables>({ query: PaymentInboundRequestListDocument, ...options });
};
export const PosPaymentMethodTypeAutocompleteDocument = gql`
    query PosPaymentMethodTypeAutocomplete($qop: SalesPaymentMethodTypeQopInput) {
  salesPaymentMethodTypes(qop: $qop) {
    items {
      salesPaymentMethodTypeID
      isActive
      salesPaymentMethodTypeCode
      salesPaymentMethodTypeName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePosPaymentMethodTypeAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<PosPaymentMethodTypeAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PosPaymentMethodTypeAutocompleteQuery, PosPaymentMethodTypeAutocompleteQueryVariables>({ query: PosPaymentMethodTypeAutocompleteDocument, ...options });
};
export const PosPaymentMethodAutocompleteDocument = gql`
    query PosPaymentMethodAutocomplete($qop: SalesPaymentMethodQopInput) {
  salesPaymentMethods(qop: $qop) {
    items {
      salesPaymentMethodID
      salesPaymentMethodName
      salesPaymentMethodTypeID
      salesPaymentMethodType {
        salesPaymentMethodTypeID
        salesPaymentMethodTypeCode
        salesPaymentMethodTypeName
        isActive
      }
      salesPaymentMethodTypeCode
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePosPaymentMethodAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<PosPaymentMethodAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PosPaymentMethodAutocompleteQuery, PosPaymentMethodAutocompleteQueryVariables>({ query: PosPaymentMethodAutocompleteDocument, ...options });
};
export const PosPaymentMethodCreateDocument = gql`
    mutation PosPaymentMethodCreate($input: SalesPaymentMethodCreateInput!) {
  salesPaymentMethodCreate(input: $input) {
    salesPaymentMethodID
    salesPaymentMethodName
    salesPaymentMethodTypeID
    salesPaymentMethodTypeCode
    salesPaymentMethodType {
      salesPaymentMethodTypeID
      salesPaymentMethodTypeCode
      salesPaymentMethodTypeName
      isActive
    }
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePosPaymentMethodCreateMutation() {
  return Urql.useMutation<PosPaymentMethodCreateMutation, PosPaymentMethodCreateMutationVariables>(PosPaymentMethodCreateDocument);
};
export const PosPaymentMethodDeleteDocument = gql`
    mutation PosPaymentMethodDelete($salesPaymentMethodID: UUID!) {
  salesPaymentMethodDelete(salesPaymentMethodID: $salesPaymentMethodID)
}
    `;

export function usePosPaymentMethodDeleteMutation() {
  return Urql.useMutation<PosPaymentMethodDeleteMutation, PosPaymentMethodDeleteMutationVariables>(PosPaymentMethodDeleteDocument);
};
export const PosPaymentMethodListDocument = gql`
    query PosPaymentMethodList($qop: SalesPaymentMethodQopInput) {
  salesPaymentMethods(qop: $qop) {
    items {
      salesPaymentMethodID
      salesPaymentMethodName
      salesPaymentMethodTypeID
      salesPaymentMethodTypeCode
      uniqueKey
      isActive
      salesPaymentMethodType {
        salesPaymentMethodTypeID
        salesPaymentMethodTypeCode
        salesPaymentMethodTypeName
        useEdc
        isCash
        isCard
        isSalesChannel
        salesChannelID
        isHandledBySystem
        uniqueKey
        isActive
        entityAuditMetadata {
          createdByUserID
          createdByUserName
          updatedByUserID
          updatedByUserName
          deletedByUserID
          deletedByUserName
          createdAt
          updatedAt
          deletedAt
          version
        }
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePosPaymentMethodListQuery(options?: Omit<Urql.UseQueryArgs<PosPaymentMethodListQueryVariables>, 'query'>) {
  return Urql.useQuery<PosPaymentMethodListQuery, PosPaymentMethodListQueryVariables>({ query: PosPaymentMethodListDocument, ...options });
};
export const PosPaymentMethodLoadDocument = gql`
    query PosPaymentMethodLoad($salesPaymentMethodID: UUID!) {
  salesPaymentMethod(salesPaymentMethodID: $salesPaymentMethodID) {
    salesPaymentMethodID
    salesPaymentMethodName
    salesPaymentMethodTypeID
    salesPaymentMethodTypeCode
    salesPaymentMethodType {
      salesPaymentMethodTypeID
      salesPaymentMethodTypeCode
      salesPaymentMethodTypeName
      isActive
    }
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePosPaymentMethodLoadQuery(options: Omit<Urql.UseQueryArgs<PosPaymentMethodLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PosPaymentMethodLoadQuery, PosPaymentMethodLoadQueryVariables>({ query: PosPaymentMethodLoadDocument, ...options });
};
export const PosPaymentMethodUpdateDocument = gql`
    mutation PosPaymentMethodUpdate($input: SalesPaymentMethodUpdateInput!) {
  salesPaymentMethodUpdate(input: $input) {
    salesPaymentMethodID
    salesPaymentMethodName
    salesPaymentMethodTypeID
    salesPaymentMethodTypeCode
    salesPaymentMethodType {
      salesPaymentMethodTypeID
      salesPaymentMethodTypeCode
      salesPaymentMethodTypeName
      isActive
    }
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePosPaymentMethodUpdateMutation() {
  return Urql.useMutation<PosPaymentMethodUpdateMutation, PosPaymentMethodUpdateMutationVariables>(PosPaymentMethodUpdateDocument);
};
export const PaymentProviderConfigListDocument = gql`
    query PaymentProviderConfigList($qop: PaymentProviderConfigQopInput) {
  paymentProviderConfigs(qop: $qop) {
    items {
      paymentProviderConfigID
      providerCode
      providerName
      environment
      baseURL
      channelID
      partnerID
      clientID
      defaultValiditySeconds
      webhookTimestampToleranceSeconds
      isActive
      uniqueKey
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePaymentProviderConfigListQuery(options?: Omit<Urql.UseQueryArgs<PaymentProviderConfigListQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentProviderConfigListQuery, PaymentProviderConfigListQueryVariables>({ query: PaymentProviderConfigListDocument, ...options });
};
export const PaymentProviderConfigLoadDocument = gql`
    query PaymentProviderConfigLoad($paymentProviderConfigID: UUID!) {
  paymentProviderConfig(paymentProviderConfigID: $paymentProviderConfigID) {
    paymentProviderConfigID
    providerCode
    providerName
    environment
    baseURL
    channelID
    partnerID
    clientID
    defaultValiditySeconds
    webhookTimestampToleranceSeconds
    isActive
    uniqueKey
    entityAuditMetadata {
      createdAt
      updatedAt
      createdByUserName
      updatedByUserName
    }
  }
}
    `;

export function usePaymentProviderConfigLoadQuery(options: Omit<Urql.UseQueryArgs<PaymentProviderConfigLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentProviderConfigLoadQuery, PaymentProviderConfigLoadQueryVariables>({ query: PaymentProviderConfigLoadDocument, ...options });
};
export const PaymentProviderConfigUpdateDocument = gql`
    mutation PaymentProviderConfigUpdate($input: PaymentProviderConfigUpdateInput!) {
  paymentProviderConfigUpdate(input: $input) {
    paymentProviderConfigID
    providerCode
    partnerID
    isActive
  }
}
    `;

export function usePaymentProviderConfigUpdateMutation() {
  return Urql.useMutation<PaymentProviderConfigUpdateMutation, PaymentProviderConfigUpdateMutationVariables>(PaymentProviderConfigUpdateDocument);
};
export const PaymentInquiryLogListDocument = gql`
    query PaymentInquiryLogList($qop: PaymentInquiryLogQopInput) {
  paymentInquiryLogs(qop: $qop) {
    items {
      paymentInquiryLogID
      serviceCode
      triggeredBy
      httpStatus
      latestTransactionStatusCode
      responseCode
      responseMessage
      isSuccess
      inquiredAt
      requestPayload
      responsePayload
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePaymentInquiryLogListQuery(options?: Omit<Urql.UseQueryArgs<PaymentInquiryLogListQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentInquiryLogListQuery, PaymentInquiryLogListQueryVariables>({ query: PaymentInquiryLogListDocument, ...options });
};
export const PaymentTransactionCancelDocument = gql`
    mutation PaymentTransactionCancel($input: PaymentTransactionCancelInput!) {
  paymentTransactionCancel(input: $input) {
    paymentTransactionID
    status
    cancelReason
  }
}
    `;

export function usePaymentTransactionCancelMutation() {
  return Urql.useMutation<PaymentTransactionCancelMutation, PaymentTransactionCancelMutationVariables>(PaymentTransactionCancelDocument);
};
export const PaymentTransactionCheckStatusDocument = gql`
    mutation PaymentTransactionCheckStatus($paymentTransactionID: UUID!) {
  paymentTransactionCheckStatus(paymentTransactionID: $paymentTransactionID) {
    paymentTransactionID
    status
    isPaid
    message
  }
}
    `;

export function usePaymentTransactionCheckStatusMutation() {
  return Urql.useMutation<PaymentTransactionCheckStatusMutation, PaymentTransactionCheckStatusMutationVariables>(PaymentTransactionCheckStatusDocument);
};
export const PaymentTransactionListDocument = gql`
    query PaymentTransactionList($qop: PaymentTransactionQopInput) {
  paymentTransactions(qop: $qop) {
    items {
      paymentTransactionID
      paymentTransactionNumber
      branchName
      providerCode
      paymentTransactionType
      transactionDatetime
      sourceDocumentType
      sourceDocumentNumber
      partnerReferenceNo
      referenceNo
      amount
      currency
      status
      paidAt
      entityAuditMetadata {
        createdAt
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePaymentTransactionListQuery(options?: Omit<Urql.UseQueryArgs<PaymentTransactionListQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentTransactionListQuery, PaymentTransactionListQueryVariables>({ query: PaymentTransactionListDocument, ...options });
};
export const PaymentTransactionLoadDocument = gql`
    query PaymentTransactionLoad($paymentTransactionID: UUID!) {
  paymentTransaction(paymentTransactionID: $paymentTransactionID) {
    paymentTransactionID
    paymentTransactionNumber
    partnerReferenceNo
    referenceNo
    externalID
    providerCode
    merchantID
    terminalID
    branchName
    branchCode
    sourceDocumentType
    sourceDocumentNumber
    paymentTransactionType
    amount
    currency
    status
    latestTransactionStatusCode
    expiredAt
    paidAt
    cancelledAt
    rrn
    approvalCode
    issuerName
    payerName
    cancelReason
    entityAuditMetadata {
      createdAt
      updatedAt
      createdByUserName
      updatedByUserName
    }
  }
}
    `;

export function usePaymentTransactionLoadQuery(options: Omit<Urql.UseQueryArgs<PaymentTransactionLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentTransactionLoadQuery, PaymentTransactionLoadQueryVariables>({ query: PaymentTransactionLoadDocument, ...options });
};
export const PaymentSalesInvoiceRefDocument = gql`
    query PaymentSalesInvoiceRef($qop: SalesInvoiceQopInput) {
  salesInvoices(qop: $qop) {
    items {
      salesInvoiceID
      salesInvoiceNumber
    }
  }
}
    `;

export function usePaymentSalesInvoiceRefQuery(options?: Omit<Urql.UseQueryArgs<PaymentSalesInvoiceRefQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentSalesInvoiceRefQuery, PaymentSalesInvoiceRefQueryVariables>({ query: PaymentSalesInvoiceRefDocument, ...options });
};
export const PaymentWebhookEventListDocument = gql`
    query PaymentWebhookEventList($qop: PaymentWebhookEventQopInput) {
  paymentWebhookEvents(qop: $qop) {
    items {
      paymentWebhookEventID
      paymentTransactionID
      providerCode
      eventType
      externalID
      partnerReferenceNo
      referenceNo
      latestTransactionStatusCode
      isValidSignature
      isDuplicate
      isProcessed
      responseCode
      responseMessage
      receivedAt
      payload
      headers
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePaymentWebhookEventListQuery(options?: Omit<Urql.UseQueryArgs<PaymentWebhookEventListQueryVariables>, 'query'>) {
  return Urql.useQuery<PaymentWebhookEventListQuery, PaymentWebhookEventListQueryVariables>({ query: PaymentWebhookEventListDocument, ...options });
};
export const PendingSyncMarketplaceOrderListDocument = gql`
    query PendingSyncMarketplaceOrderList($qop: MarketplaceInboundOrderQopInput) {
  marketplaceInboundOrders(qop: $qop) {
    items {
      marketplaceInboundOrderID
      salesChannelID
      externalOrderID
      externalMerchantID
      branchID
      branchCode
      branchName
      eventType
      status
      errorMessage
      retryCount
      lastProcessAttemptAtUtc
      payload
      receivedAtUtc
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePendingSyncMarketplaceOrderListQuery(options?: Omit<Urql.UseQueryArgs<PendingSyncMarketplaceOrderListQueryVariables>, 'query'>) {
  return Urql.useQuery<PendingSyncMarketplaceOrderListQuery, PendingSyncMarketplaceOrderListQueryVariables>({ query: PendingSyncMarketplaceOrderListDocument, ...options });
};
export const PendingSyncSalesOrderListDocument = gql`
    query PendingSyncSalesOrderList($qop: PosSalesOrderQopInput!) {
  posSalesOrders(qop: $qop) {
    items {
      id
      posSalesOrderId
      posSalesOrderNumber
      posSalesOrderDatetime
      branchId
      salesChannelId
      total
      status
      processStatus
      processRemark
      syncError
      retryCount
      lastProcessAttemptTimeUtc
      processedTimeUtc
      createdTimeUtc
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePendingSyncSalesOrderListQuery(options: Omit<Urql.UseQueryArgs<PendingSyncSalesOrderListQueryVariables>, 'query'>) {
  return Urql.useQuery<PendingSyncSalesOrderListQuery, PendingSyncSalesOrderListQueryVariables>({ query: PendingSyncSalesOrderListDocument, ...options });
};
export const PettyCashAddFundTransactionCancelDocument = gql`
    mutation PettyCashAddFundTransactionCancel($input: PettyCashTransactionActionInput!) {
  pettyCashAddFundTransactionCancel(input: $input) {
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashAddFundTransactionCancelMutation() {
  return Urql.useMutation<PettyCashAddFundTransactionCancelMutation, PettyCashAddFundTransactionCancelMutationVariables>(PettyCashAddFundTransactionCancelDocument);
};
export const PettyCashAddFundTransactionConfirmDocument = gql`
    mutation PettyCashAddFundTransactionConfirm($input: PettyCashTransactionActionInput!) {
  pettyCashAddFundTransactionConfirm(input: $input) {
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashAddFundTransactionConfirmMutation() {
  return Urql.useMutation<PettyCashAddFundTransactionConfirmMutation, PettyCashAddFundTransactionConfirmMutationVariables>(PettyCashAddFundTransactionConfirmDocument);
};
export const PettyCashAddFundTransactionCreateDocument = gql`
    mutation PettyCashAddFundTransactionCreate($input: PettyCashAddFundTransactionCreateInput!) {
  pettyCashAddFundTransactionCreate(input: $input) {
    pettyCashAddFundTransactionID
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashAddFundTransactionCreateMutation() {
  return Urql.useMutation<PettyCashAddFundTransactionCreateMutation, PettyCashAddFundTransactionCreateMutationVariables>(PettyCashAddFundTransactionCreateDocument);
};
export const PettyCashAddFundTransactionDeleteDocument = gql`
    mutation PettyCashAddFundTransactionDelete($input: PettyCashTransactionActionInput!) {
  pettyCashAddFundTransactionDelete(input: $input)
}
    `;

export function usePettyCashAddFundTransactionDeleteMutation() {
  return Urql.useMutation<PettyCashAddFundTransactionDeleteMutation, PettyCashAddFundTransactionDeleteMutationVariables>(PettyCashAddFundTransactionDeleteDocument);
};
export const PettyCashAddFundTransactionLoadDocument = gql`
    query PettyCashAddFundTransactionLoad($pettyCashTransactionID: UUID!) {
  pettyCashAddFundTransaction(pettyCashTransactionID: $pettyCashTransactionID) {
    pettyCashAddFundTransactionID
    pettyCashAddFundTransactionNumber
    pettyCashTransactionDatetime
    pettyCashTransactionDatetimeUtc
    pettyCashTransactionID
    branchID
    branchCode
    branchName
    description
    gmt
    amount
    bankAccountID
    bankID
    bankName
    bankAccountNumber
    note
    uniqueKey
    files {
      pettyCashTransactionFileID
      pettyCashTransactionID
      pettyCashTransactionFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePettyCashAddFundTransactionLoadQuery(options: Omit<Urql.UseQueryArgs<PettyCashAddFundTransactionLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PettyCashAddFundTransactionLoadQuery, PettyCashAddFundTransactionLoadQueryVariables>({ query: PettyCashAddFundTransactionLoadDocument, ...options });
};
export const PettyCashAddFundTransactionUpdateDocument = gql`
    mutation PettyCashAddFundTransactionUpdate($input: PettyCashAddFundTransactionUpdateInput!) {
  pettyCashAddFundTransactionUpdate(input: $input) {
    pettyCashAddFundTransactionID
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashAddFundTransactionUpdateMutation() {
  return Urql.useMutation<PettyCashAddFundTransactionUpdateMutation, PettyCashAddFundTransactionUpdateMutationVariables>(PettyCashAddFundTransactionUpdateDocument);
};
export const PettyCashBalanceByBranchDocument = gql`
    query PettyCashBalanceByBranch($branchID: UUID!) {
  pettyCashBalances(
    qop: {pagination: {page: 1, pageSize: 1, withCount: false}, filters: {branchID: $branchID}}
  ) {
    items {
      pettyCashBalanceID
      branchID
      currentBalance
    }
  }
}
    `;

export function usePettyCashBalanceByBranchQuery(options: Omit<Urql.UseQueryArgs<PettyCashBalanceByBranchQueryVariables>, 'query'>) {
  return Urql.useQuery<PettyCashBalanceByBranchQuery, PettyCashBalanceByBranchQueryVariables>({ query: PettyCashBalanceByBranchDocument, ...options });
};
export const PettyCashExpenseTransactionCancelDocument = gql`
    mutation PettyCashExpenseTransactionCancel($input: PettyCashTransactionActionInput!) {
  pettyCashExpenseTransactionCancel(input: $input) {
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashExpenseTransactionCancelMutation() {
  return Urql.useMutation<PettyCashExpenseTransactionCancelMutation, PettyCashExpenseTransactionCancelMutationVariables>(PettyCashExpenseTransactionCancelDocument);
};
export const PettyCashExpenseTransactionConfirmDocument = gql`
    mutation PettyCashExpenseTransactionConfirm($input: PettyCashTransactionActionInput!) {
  pettyCashExpenseTransactionConfirm(input: $input) {
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashExpenseTransactionConfirmMutation() {
  return Urql.useMutation<PettyCashExpenseTransactionConfirmMutation, PettyCashExpenseTransactionConfirmMutationVariables>(PettyCashExpenseTransactionConfirmDocument);
};
export const PettyCashExpenseTransactionCreateDocument = gql`
    mutation PettyCashExpenseTransactionCreate($input: PettyCashExpenseTransactionCreateInput!) {
  pettyCashExpenseTransactionCreate(input: $input) {
    pettyCashExpenseTransactionID
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashExpenseTransactionCreateMutation() {
  return Urql.useMutation<PettyCashExpenseTransactionCreateMutation, PettyCashExpenseTransactionCreateMutationVariables>(PettyCashExpenseTransactionCreateDocument);
};
export const PettyCashExpenseTransactionDeleteDocument = gql`
    mutation PettyCashExpenseTransactionDelete($input: PettyCashTransactionActionInput!) {
  pettyCashExpenseTransactionDelete(input: $input)
}
    `;

export function usePettyCashExpenseTransactionDeleteMutation() {
  return Urql.useMutation<PettyCashExpenseTransactionDeleteMutation, PettyCashExpenseTransactionDeleteMutationVariables>(PettyCashExpenseTransactionDeleteDocument);
};
export const PettyCashExpenseTransactionLoadDocument = gql`
    query PettyCashExpenseTransactionLoad($pettyCashTransactionID: UUID!) {
  pettyCashExpenseTransaction(pettyCashTransactionID: $pettyCashTransactionID) {
    pettyCashExpenseTransactionID
    pettyCashTransactionID
    branchID
    branchCode
    branchName
    description
    gmt
    pettyCashExpenseTransactionNumber
    pettyCashExpenseTransactionDatetime
    pettyCashExpenseTransactionDatetimeUtc
    totalAmount
    note
    status
    uniqueKey
    items {
      pettyCashExpenseTransactionItemID
      pettyCashExpenseTransactionID
      expenseItemID
      expenseItemName
      qty
      unitPrice
      amount
      note
    }
    files {
      pettyCashTransactionFileID
      pettyCashTransactionID
      pettyCashTransactionFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePettyCashExpenseTransactionLoadQuery(options: Omit<Urql.UseQueryArgs<PettyCashExpenseTransactionLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PettyCashExpenseTransactionLoadQuery, PettyCashExpenseTransactionLoadQueryVariables>({ query: PettyCashExpenseTransactionLoadDocument, ...options });
};
export const PettyCashExpenseTransactionUpdateDocument = gql`
    mutation PettyCashExpenseTransactionUpdate($input: PettyCashExpenseTransactionUpdateInput!) {
  pettyCashExpenseTransactionUpdate(input: $input) {
    pettyCashExpenseTransactionID
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashExpenseTransactionUpdateMutation() {
  return Urql.useMutation<PettyCashExpenseTransactionUpdateMutation, PettyCashExpenseTransactionUpdateMutationVariables>(PettyCashExpenseTransactionUpdateDocument);
};
export const PettyCashRefundTransactionCancelDocument = gql`
    mutation PettyCashRefundTransactionCancel($input: PettyCashTransactionActionInput!) {
  pettyCashRefundTransactionCancel(input: $input) {
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashRefundTransactionCancelMutation() {
  return Urql.useMutation<PettyCashRefundTransactionCancelMutation, PettyCashRefundTransactionCancelMutationVariables>(PettyCashRefundTransactionCancelDocument);
};
export const PettyCashRefundTransactionConfirmDocument = gql`
    mutation PettyCashRefundTransactionConfirm($input: PettyCashTransactionActionInput!) {
  pettyCashRefundTransactionConfirm(input: $input) {
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashRefundTransactionConfirmMutation() {
  return Urql.useMutation<PettyCashRefundTransactionConfirmMutation, PettyCashRefundTransactionConfirmMutationVariables>(PettyCashRefundTransactionConfirmDocument);
};
export const PettyCashRefundTransactionCreateDocument = gql`
    mutation PettyCashRefundTransactionCreate($input: PettyCashRefundTransactionCreateInput!) {
  pettyCashRefundTransactionCreate(input: $input) {
    pettyCashRefundTransactionID
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashRefundTransactionCreateMutation() {
  return Urql.useMutation<PettyCashRefundTransactionCreateMutation, PettyCashRefundTransactionCreateMutationVariables>(PettyCashRefundTransactionCreateDocument);
};
export const PettyCashRefundTransactionDeleteDocument = gql`
    mutation PettyCashRefundTransactionDelete($input: PettyCashTransactionActionInput!) {
  pettyCashRefundTransactionDelete(input: $input)
}
    `;

export function usePettyCashRefundTransactionDeleteMutation() {
  return Urql.useMutation<PettyCashRefundTransactionDeleteMutation, PettyCashRefundTransactionDeleteMutationVariables>(PettyCashRefundTransactionDeleteDocument);
};
export const PettyCashRefundTransactionLoadDocument = gql`
    query PettyCashRefundTransactionLoad($pettyCashTransactionID: UUID!) {
  pettyCashRefundTransaction(pettyCashTransactionID: $pettyCashTransactionID) {
    pettyCashRefundTransactionID
    pettyCashTransactionDatetime
    pettyCashTransactionDatetimeUtc
    pettyCashTransactionID
    branchID
    branchCode
    branchName
    description
    gmt
    pettyCashRefundTransactionNumber
    amount
    bankAccountID
    bankID
    bankName
    bankAccountNumber
    note
    uniqueKey
    files {
      pettyCashTransactionFileID
      pettyCashTransactionID
      pettyCashTransactionFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePettyCashRefundTransactionLoadQuery(options: Omit<Urql.UseQueryArgs<PettyCashRefundTransactionLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PettyCashRefundTransactionLoadQuery, PettyCashRefundTransactionLoadQueryVariables>({ query: PettyCashRefundTransactionLoadDocument, ...options });
};
export const PettyCashRefundTransactionUpdateDocument = gql`
    mutation PettyCashRefundTransactionUpdate($input: PettyCashRefundTransactionUpdateInput!) {
  pettyCashRefundTransactionUpdate(input: $input) {
    pettyCashRefundTransactionID
    pettyCashTransactionID
  }
}
    `;

export function usePettyCashRefundTransactionUpdateMutation() {
  return Urql.useMutation<PettyCashRefundTransactionUpdateMutation, PettyCashRefundTransactionUpdateMutationVariables>(PettyCashRefundTransactionUpdateDocument);
};
export const PettyCashTransactionFileListDocument = gql`
    query PettyCashTransactionFileList($qop: PettyCashTransactionFileQopInput!) {
  pettyCashTransactionFiles(qop: $qop) {
    items {
      pettyCashTransactionFileID
      pettyCashTransactionID
      pettyCashTransactionFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePettyCashTransactionFileListQuery(options: Omit<Urql.UseQueryArgs<PettyCashTransactionFileListQueryVariables>, 'query'>) {
  return Urql.useQuery<PettyCashTransactionFileListQuery, PettyCashTransactionFileListQueryVariables>({ query: PettyCashTransactionFileListDocument, ...options });
};
export const PettyCashTransactionListDocument = gql`
    query PettyCashTransactionList($qop: PettyCashTransactionQopInput!) {
  pettyCashTransactions(qop: $qop) {
    items {
      pettyCashTransactionID
      pettyCashTransactionNumber
      pettyCashTransactionDatetime
      pettyCashTransactionDatetimeUtc
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      branchID
      branchCode
      branchName
      gmt
      description
      totalAmount
      status
      uniqueKey
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePettyCashTransactionListQuery(options: Omit<Urql.UseQueryArgs<PettyCashTransactionListQueryVariables>, 'query'>) {
  return Urql.useQuery<PettyCashTransactionListQuery, PettyCashTransactionListQueryVariables>({ query: PettyCashTransactionListDocument, ...options });
};
export const PettyCashTransactionLoadDocument = gql`
    query PettyCashTransactionLoad($pettyCashTransactionID: UUID!) {
  pettyCashTransaction(pettyCashTransactionID: $pettyCashTransactionID) {
    pettyCashTransactionID
    pettyCashTransactionNumber
    pettyCashTransactionDatetime
    pettyCashTransactionDatetimeUtc
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    branchID
    branchCode
    branchName
    gmt
    description
    totalAmount
    status
    uniqueKey
    expenseTransaction {
      pettyCashExpenseTransactionID
      pettyCashTransactionID
      branchID
      branchCode
      branchName
      gmt
      pettyCashExpenseTransactionNumber
      pettyCashExpenseTransactionDatetime
      pettyCashExpenseTransactionDatetimeUtc
      totalAmount
      note
      status
      uniqueKey
      items {
        pettyCashExpenseTransactionItemID
        pettyCashExpenseTransactionID
        expenseItemID
        expenseItemName
        qty
        unitPrice
        amount
        note
      }
      files {
        pettyCashTransactionFileID
        pettyCashTransactionID
        pettyCashTransactionFileType
        fileID
        imageFileSmallPathURL
        imageFileMediumPathURL
        imageFileLargePathURL
        uniqueKey
      }
    }
    addFundTransaction {
      pettyCashAddFundTransactionID
      pettyCashTransactionID
      branchID
      branchCode
      branchName
      bankAccountID
      bankID
      bankName
      bankAccountNumber
      gmt
      pettyCashAddFundTransactionNumber
      amount
      note
      uniqueKey
      files {
        pettyCashTransactionFileID
        pettyCashTransactionID
        pettyCashTransactionFileType
        fileID
        imageFileSmallPathURL
        imageFileMediumPathURL
        imageFileLargePathURL
        uniqueKey
      }
    }
    refundTransaction {
      pettyCashRefundTransactionID
      pettyCashTransactionID
      branchID
      branchCode
      branchName
      bankAccountID
      bankID
      bankName
      bankAccountNumber
      gmt
      pettyCashRefundTransactionNumber
      amount
      note
      uniqueKey
      files {
        pettyCashTransactionFileID
        pettyCashTransactionID
        pettyCashTransactionFileType
        fileID
        imageFileSmallPathURL
        imageFileMediumPathURL
        imageFileLargePathURL
        uniqueKey
      }
    }
    files {
      pettyCashTransactionFileID
      pettyCashTransactionID
      pettyCashTransactionFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePettyCashTransactionLoadQuery(options: Omit<Urql.UseQueryArgs<PettyCashTransactionLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PettyCashTransactionLoadQuery, PettyCashTransactionLoadQueryVariables>({ query: PettyCashTransactionLoadDocument, ...options });
};
export const PickingTaskAssignDocument = gql`
    mutation PickingTaskAssign($input: PickingTaskAssignInput!) {
  pickingTaskAssign(input: $input) {
    pickingTaskID
    assignedToUserID
  }
}
    `;

export function usePickingTaskAssignMutation() {
  return Urql.useMutation<PickingTaskAssignMutation, PickingTaskAssignMutationVariables>(PickingTaskAssignDocument);
};
export const PickingTaskCancelDocument = gql`
    mutation PickingTaskCancel($input: PickingTaskCancelInput!) {
  pickingTaskCancel(input: $input)
}
    `;

export function usePickingTaskCancelMutation() {
  return Urql.useMutation<PickingTaskCancelMutation, PickingTaskCancelMutationVariables>(PickingTaskCancelDocument);
};
export const PickingTaskExecutionsDocument = gql`
    query PickingTaskExecutions($qop: PickingTaskExecutionQopInput) {
  pickingTaskExecutions(qop: $qop) {
    items {
      pickingTaskExecutionID
      warehouseLocationName
      qty
      uomName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePickingTaskExecutionsQuery(options?: Omit<Urql.UseQueryArgs<PickingTaskExecutionsQueryVariables>, 'query'>) {
  return Urql.useQuery<PickingTaskExecutionsQuery, PickingTaskExecutionsQueryVariables>({ query: PickingTaskExecutionsDocument, ...options });
};
export const PickingTaskGenerateByZonePreviewDocument = gql`
    query PickingTaskGenerateByZonePreview($input: PickingTaskGenerateByZonePreviewInput!) {
  pickingTaskGenerateByZonePreview(input: $input) {
    sourceDocumentID
    fromWarehouseID
    fromWarehouseName
    fromWarehouseCode
    sourceDocumentNumber
    groups {
      warehouseLocationID
      warehouseLocationName
      warehouseLocationGroupName
      totalItems
      totalQty
      items {
        sourceDocumentDetailID
        productID
        productCode
        productName
        uomID
        uomName
        warehouseLocationID
        warehouseLocationName
        qtyOutstanding
        baseUomQtyOutstanding
      }
    }
  }
}
    `;

export function usePickingTaskGenerateByZonePreviewQuery(options: Omit<Urql.UseQueryArgs<PickingTaskGenerateByZonePreviewQueryVariables>, 'query'>) {
  return Urql.useQuery<PickingTaskGenerateByZonePreviewQuery, PickingTaskGenerateByZonePreviewQueryVariables>({ query: PickingTaskGenerateByZonePreviewDocument, ...options });
};
export const PickingTaskItemsLoadDocument = gql`
    query PickingTaskItemsLoad($qop: PickingTaskItemQopInput) {
  pickingTaskItems(qop: $qop) {
    items {
      pickingTaskItemID
      productCode
      productName
      product {
        barcode
      }
      qtyAssigned
      qtyExecuted
      qtyUnfulfilled
      qtyOutstanding
      uomName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePickingTaskItemsLoadQuery(options?: Omit<Urql.UseQueryArgs<PickingTaskItemsLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PickingTaskItemsLoadQuery, PickingTaskItemsLoadQueryVariables>({ query: PickingTaskItemsLoadDocument, ...options });
};
export const PickingTaskListDocument = gql`
    query PickingTaskList($qop: PickingTaskQopInput) {
  pickingTasks(qop: $qop) {
    items {
      pickingTaskNumber
      pickingTaskDatetime
      sourceDocumentType
      sourceDocumentNumber
      warehouse {
        warehouseName
      }
      assignedToUserName
      taskStartAt
      taskDoneAt
      taskDurationMinute
      status
      pickingTaskID
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePickingTaskListQuery(options?: Omit<Urql.UseQueryArgs<PickingTaskListQueryVariables>, 'query'>) {
  return Urql.useQuery<PickingTaskListQuery, PickingTaskListQueryVariables>({ query: PickingTaskListDocument, ...options });
};
export const PickingTaskLoadDocument = gql`
    query PickingTaskLoad($pickingTaskID: UUID!) {
  pickingTask(pickingTaskID: $pickingTaskID) {
    sourceDocumentNumber
    sourceDocumentID
    sourceDocumentType
    warehouse {
      warehouseName
    }
    assignedToUserName
    pickingTaskDatetime
    taskStartAt
    taskDoneAt
    taskDurationMinute
    pickingTaskNumber
    status
  }
}
    `;

export function usePickingTaskLoadQuery(options: Omit<Urql.UseQueryArgs<PickingTaskLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PickingTaskLoadQuery, PickingTaskLoadQueryVariables>({ query: PickingTaskLoadDocument, ...options });
};
export const InboundReceivingLoadQueryDocument = gql`
    query InboundReceivingLoadQuery($inboundReceivingId: UUID!) {
  inboundReceiving(inboundReceivingID: $inboundReceivingId) {
    inboundReceivingID
    inboundReceivingNumber
    inboundReceivingDatetime
    inboundReceivingDatetimeUtc
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    branchID
    gmt
    warehouseID
    warehouseLocationID
    vendorID
    vendorRefNo
    originWarehouseID
    originWarehouseLocationID
    totalItems
    totalItemQtyReceived
    noteInternal
    status
    isPutawayCompleted
  }
}
    `;

export function useInboundReceivingLoadQueryQuery(options: Omit<Urql.UseQueryArgs<InboundReceivingLoadQueryQueryVariables>, 'query'>) {
  return Urql.useQuery<InboundReceivingLoadQueryQuery, InboundReceivingLoadQueryQueryVariables>({ query: InboundReceivingLoadQueryDocument, ...options });
};
export const PurchaseOrderAutocompleteDocument = gql`
    query PurchaseOrderAutocomplete($qop: PurchaseOrderQopInput) {
  purchaseOrders(qop: $qop) {
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
    items {
      purchaseOrderID
      purchaseOrderNumber
      purchaseOrderDatetime
      purchaseOrderDatetimeUtc
      deliveryDate
      deadlineDate
      branchID
      branchCode
      branchName
      gmt
      vendorID
      vendorCode
      vendorName
      vendorEmail
      vendorPhoneNumber
      vendorNpwp
      vendorNpwpCompanyName
      vendorRefNo
      destinationWarehouseID
      destinationWarehouseCode
      destinationWarehouseName
      purchaseAreaID
      purchaseAreaName
      taxIncluded
      totalItemQty
      totalItemQtyReceived
      subtotal
      discountType
      discountPerc
      discountPercPlus
      discountAmount
      subtotalAfterDiscount
      taxAmount
      taxItems
      landedCost
      landedCostPerUnit
      adjustmentAmount
      total
      taxableAmount
      noteInternal
      noteForVendor
      status
      entityAuditMetadata {
        version
      }
    }
  }
}
    `;

export function usePurchaseOrderAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<PurchaseOrderAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseOrderAutocompleteQuery, PurchaseOrderAutocompleteQueryVariables>({ query: PurchaseOrderAutocompleteDocument, ...options });
};
export const PurchaseOrderReceivingCancelDocument = gql`
    mutation PurchaseOrderReceivingCancel($purchaseOrderReceivingID: UUID!) {
  purchaseOrderReceivingCancel(
    purchaseOrderReceivingID: $purchaseOrderReceivingID
  )
}
    `;

export function usePurchaseOrderReceivingCancelMutation() {
  return Urql.useMutation<PurchaseOrderReceivingCancelMutation, PurchaseOrderReceivingCancelMutationVariables>(PurchaseOrderReceivingCancelDocument);
};
export const PurchaseOrderReceivingConfirmDocument = gql`
    mutation PurchaseOrderReceivingConfirm($purchaseOrderReceivingID: UUID!) {
  purchaseOrderReceivingConfirm(
    purchaseOrderReceivingID: $purchaseOrderReceivingID
  ) {
    purchaseOrderReceivingID
    purchaseOrderReceivingNumber
    purchaseOrderReceivingDatetime
    branchID
    gmt
    vendorID
    vendorRefNo
    purchaseOrderID
    purchaseOrderNumber
    warehouseID
    warehouseLocationID
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    closePO
    taxIncluded
    totalItemQtyReceived
    subtotal
    discountType
    discountPerc
    discountAmount
    subtotalAfterDiscount
    taxAmount
    landedCost
    landedCostPerUnit
    adjustmentAmount
    total
    taxableAmount
    noteInternal
    status
  }
}
    `;

export function usePurchaseOrderReceivingConfirmMutation() {
  return Urql.useMutation<PurchaseOrderReceivingConfirmMutation, PurchaseOrderReceivingConfirmMutationVariables>(PurchaseOrderReceivingConfirmDocument);
};
export const PurchaseOrderReceivingCreateDocument = gql`
    mutation PurchaseOrderReceivingCreate($input: PurchaseOrderReceivingCreateInput!) {
  purchaseOrderReceivingCreate(input: $input) {
    vendorID
    purchaseOrderID
    vendorRefNo
    warehouseID
    warehouseLocationID
    driverName
    driverPhoneNumber
    vehiclePlateNumber
    noteInternal
    landedCost
    closePO
    purchaseOrderReceivingDatetime
  }
}
    `;

export function usePurchaseOrderReceivingCreateMutation() {
  return Urql.useMutation<PurchaseOrderReceivingCreateMutation, PurchaseOrderReceivingCreateMutationVariables>(PurchaseOrderReceivingCreateDocument);
};
export const PurchaseOrderReceivingCreateMultiplePutawayDocument = gql`
    mutation PurchaseOrderReceivingCreateMultiplePutaway($input: GenerateMultipleTasksInput!) {
  putawayTaskGenerateMultiple(input: $input) {
    putawayTaskID
    putawayTaskNumber
    putawayTaskDatetime
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    branchID
    warehouseID
    fromWarehouseLocationID
    fromWarehouseLocationCode
    fromWarehouseLocationName
    assignedToUserID
    assignedToUserName
    totalItems
    totalQtyAssigned
    totalQtyExecuted
    progressPercent
    taskStartAt
    taskDoneAt
    taskDurationMinute
    status
    noteInternal
  }
}
    `;

export function usePurchaseOrderReceivingCreateMultiplePutawayMutation() {
  return Urql.useMutation<PurchaseOrderReceivingCreateMultiplePutawayMutation, PurchaseOrderReceivingCreateMultiplePutawayMutationVariables>(PurchaseOrderReceivingCreateMultiplePutawayDocument);
};
export const PurchaseOrderReceivingDraftCheckDocument = gql`
    query PurchaseOrderReceivingDraftCheck($qop: PurchaseOrderReceivingQopInput) {
  purchaseOrderReceivings(qop: $qop) {
    items {
      purchaseOrderReceivingID
      purchaseOrderReceivingNumber
      purchaseOrderReceivingDatetime
      purchaseOrderID
      purchaseOrderNumber
      status
      totalItemQtyReceived
      entityAuditMetadata {
        createdAt
        createdByUserName
      }
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    `;

export function usePurchaseOrderReceivingDraftCheckQuery(options?: Omit<Urql.UseQueryArgs<PurchaseOrderReceivingDraftCheckQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseOrderReceivingDraftCheckQuery, PurchaseOrderReceivingDraftCheckQueryVariables>({ query: PurchaseOrderReceivingDraftCheckDocument, ...options });
};
export const PurchaseOrderReceivingGeneratePutawayDocument = gql`
    mutation PurchaseOrderReceivingGeneratePutaway($input: GenerateSingleTaskInput!) {
  putawayTaskGenerateSingle(input: $input) {
    putawayTaskID
    putawayTaskNumber
    putawayTaskDatetime
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    branchID
    warehouseID
    fromWarehouseLocationID
    fromWarehouseLocationCode
    fromWarehouseLocationName
    assignedToUserID
    assignedToUserName
    totalItems
    totalQtyAssigned
    totalQtyExecuted
    progressPercent
    taskStartAt
    taskDoneAt
    taskDurationMinute
    status
    noteInternal
  }
}
    `;

export function usePurchaseOrderReceivingGeneratePutawayMutation() {
  return Urql.useMutation<PurchaseOrderReceivingGeneratePutawayMutation, PurchaseOrderReceivingGeneratePutawayMutationVariables>(PurchaseOrderReceivingGeneratePutawayDocument);
};
export const PurchaseOrderReceivingItemsDocument = gql`
    query PurchaseOrderReceivingItems($qop: PurchaseOrderReceivingItemQopInput) {
  purchaseOrderReceivingItems(qop: $qop) {
    items {
      purchaseOrderReceivingItemID
      purchaseOrderReceivingID
      purchaseOrderID
      purchaseOrderItemID
      productID
      productCode
      productName
      product {
        barcode
      }
      description
      poQty
      poQtyReceived
      poQtyOutstanding
      poUomID
      poUomConversionRate
      qtyReceived
      uomCategoryID
      uomID
      uomName
      uomConversionRate
      baseUomQty
      unitPrice
      discountType
      discountPerc
      discountAmount
      additionalDiscountPerc
      additionalDiscountAmount
      product {
        trackExpiredDate
      }
      additionalLandedCost
      total
      taxableAmount
      taxAmount
      baseUomUnitCost
      taxes {
        purchaseOrderReceivingItemTaxID
        purchaseOrderReceivingItemID
        purchaseOrderReceivingID
        taxID
        taxCode
        taxRate
        taxableAmount
        taxAmount
      }
      itemDetails {
        purchaseOrderReceivingItemDetailID
        purchaseOrderReceivingItemID
        purchaseOrderReceivingID
        productID
        productCode
        productName
        description
        lotNo
        expiryDate
        qty
        uomID
        uomName
        uomDecimal
        uomConversionRate
        uomConversionDecimal
        baseUomQty
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePurchaseOrderReceivingItemsQuery(options?: Omit<Urql.UseQueryArgs<PurchaseOrderReceivingItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseOrderReceivingItemsQuery, PurchaseOrderReceivingItemsQueryVariables>({ query: PurchaseOrderReceivingItemsDocument, ...options });
};
export const PurchaseOrderReceivingListDocument = gql`
    query PurchaseOrderReceivingList($qop: InboundReceivingQopInput) {
  inboundReceivings(qop: $qop) {
    items {
      inboundReceivingID
      inboundReceivingNumber
      inboundReceivingDatetime
      inboundReceivingDatetimeUtc
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      branchID
      gmt
      warehouseID
      warehouseLocationID
      vendorID
      vendorRefNo
      originWarehouseID
      originWarehouseLocationID
      totalItems
      totalItemQtyReceived
      noteInternal
      status
      isPutawayCompleted
      transferOrder {
        transferOrderID
      }
      purchaseOrder {
        purchaseOrderID
      }
      vendor {
        vendorName
      }
      warehouse {
        warehouseName
      }
      originWarehouse {
        warehouseName
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePurchaseOrderReceivingListQuery(options?: Omit<Urql.UseQueryArgs<PurchaseOrderReceivingListQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseOrderReceivingListQuery, PurchaseOrderReceivingListQueryVariables>({ query: PurchaseOrderReceivingListDocument, ...options });
};
export const PurchaseOrderReceivingLoadDocument = gql`
    query PurchaseOrderReceivingLoad($purchaseOrderReceivingID: UUID!) {
  purchaseOrderReceiving(purchaseOrderReceivingID: $purchaseOrderReceivingID) {
    purchaseOrderReceivingID
    purchaseOrderReceivingNumber
    purchaseOrderReceivingDatetime
    branchID
    gmt
    vendorID
    vendorRefNo
    purchaseOrderID
    purchaseOrderNumber
    warehouseID
    warehouseLocationID
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    closePO
    taxIncluded
    totalItemQtyReceived
    subtotal
    discountType
    discountPerc
    discountAmount
    subtotalAfterDiscount
    taxAmount
    landedCost
    landedCostPerUnit
    adjustmentAmount
    total
    taxableAmount
    noteInternal
    status
    vendor {
      vendorID
      vendorName
    }
    warehouse {
      warehouseID
      warehouseName
    }
    warehouseLocation {
      warehouseLocationID
      warehouseLocationName
    }
    files {
      purchaseOrderReceivingFileID
      purchaseOrderReceivingID
      purchaseOrderReceivingFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
    }
  }
}
    `;

export function usePurchaseOrderReceivingLoadQuery(options: Omit<Urql.UseQueryArgs<PurchaseOrderReceivingLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseOrderReceivingLoadQuery, PurchaseOrderReceivingLoadQueryVariables>({ query: PurchaseOrderReceivingLoadDocument, ...options });
};
export const PurchaseOrderReceivingDetailLoadDocument = gql`
    query PurchaseOrderReceivingDetailLoad($inboundReceivingID: UUID!) {
  inboundReceiving(inboundReceivingID: $inboundReceivingID) {
    inboundReceivingID
    inboundReceivingNumber
    inboundReceivingDatetime
    inboundReceivingDatetimeUtc
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    branchID
    gmt
    warehouseID
    warehouseLocationID
    vendorID
    vendorRefNo
    totalItems
    totalItemQtyReceived
    noteInternal
    purchaseOrder {
      purchaseOrderID
    }
    vendor {
      vendorID
      vendorName
    }
    warehouse {
      warehouseID
      warehouseName
    }
    status
    items {
      inboundReceivingItemID
      inboundReceivingID
      sourceDocumentDetailID
      productID
      productCode
      productName
      qtyReceived
      baseUomQtyReceived
      qtyPutawayAssigned
      baseUomQtyPutawayAssigned
      qtyPutawayExecuted
      baseUomQtyPutawayExecuted
      uomCategoryID
      uomID
      uomName
      uomConversionRate
      product {
        barcode
      }
    }
  }
}
    `;

export function usePurchaseOrderReceivingDetailLoadQuery(options: Omit<Urql.UseQueryArgs<PurchaseOrderReceivingDetailLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseOrderReceivingDetailLoadQuery, PurchaseOrderReceivingDetailLoadQueryVariables>({ query: PurchaseOrderReceivingDetailLoadDocument, ...options });
};
export const PurchaseOrderReceivingUpdateDocument = gql`
    mutation PurchaseOrderReceivingUpdate($input: PurchaseOrderReceivingUpdateInput!) {
  purchaseOrderReceivingUpdate(input: $input) {
    purchaseOrderReceivingID
    vendorID
    purchaseOrderID
    vendorRefNo
    warehouseID
    warehouseLocationID
    driverName
    driverPhoneNumber
    vehiclePlateNumber
    noteInternal
    landedCost
    closePO
    purchaseOrderReceivingDatetime
  }
}
    `;

export function usePurchaseOrderReceivingUpdateMutation() {
  return Urql.useMutation<PurchaseOrderReceivingUpdateMutation, PurchaseOrderReceivingUpdateMutationVariables>(PurchaseOrderReceivingUpdateDocument);
};
export const DeliveryOrderAutocompleteDocument = gql`
    query DeliveryOrderAutocomplete($qop: DeliveryOrderQopInput!) {
  deliveryOrders(qop: $qop) {
    items {
      deliveryOrderID
      deliveryOrderNumber
      toWarehouseID
      toWarehouseCode
      toWarehouseName
      fromWarehouseID
      fromWarehouseName
      fromWarehouseCode
      sourceDocumentNumber
      sourceDocumentType
      noteInternal
      sourceDocumentID
      vendorName
      vendorRefNumber
      shippedByUserName
      vehiclePlateNumber
      driverName
      landedCost
      driverPhoneNumber
      transferRequest {
        transferRequestID
        transferRequestNumber
      }
      entityAuditMetadata {
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useDeliveryOrderAutocompleteQuery(options: Omit<Urql.UseQueryArgs<DeliveryOrderAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<DeliveryOrderAutocompleteQuery, DeliveryOrderAutocompleteQueryVariables>({ query: DeliveryOrderAutocompleteDocument, ...options });
};
export const TransferOrderReceivingCancelDocument = gql`
    mutation TransferOrderReceivingCancel($transferOrderReceivingID: UUID!) {
  transferOrderReceivingCancel(
    transferOrderReceivingID: $transferOrderReceivingID
  )
}
    `;

export function useTransferOrderReceivingCancelMutation() {
  return Urql.useMutation<TransferOrderReceivingCancelMutation, TransferOrderReceivingCancelMutationVariables>(TransferOrderReceivingCancelDocument);
};
export const TransferOrderReceivingConfirmDocument = gql`
    mutation TransferOrderReceivingConfirm($transferOrderReceivingID: UUID!) {
  transferOrderReceivingConfirm(
    transferOrderReceivingID: $transferOrderReceivingID
  ) {
    transferOrderReceivingID
  }
}
    `;

export function useTransferOrderReceivingConfirmMutation() {
  return Urql.useMutation<TransferOrderReceivingConfirmMutation, TransferOrderReceivingConfirmMutationVariables>(TransferOrderReceivingConfirmDocument);
};
export const TransferOrderReceivingCreateDocument = gql`
    mutation TransferOrderReceivingCreate($input: TransferOrderReceivingCreateInput!) {
  transferOrderReceivingCreate(input: $input) {
    transferOrderReceivingID
  }
}
    `;

export function useTransferOrderReceivingCreateMutation() {
  return Urql.useMutation<TransferOrderReceivingCreateMutation, TransferOrderReceivingCreateMutationVariables>(TransferOrderReceivingCreateDocument);
};
export const TransferOrderReceivingDetailDocument = gql`
    query TransferOrderReceivingDetail($transferOrderReceivingID: UUID!) {
  transferOrderReceiving(transferOrderReceivingID: $transferOrderReceivingID) {
    transferOrderReceivingID
    deliveryOrderNumber
    deliveryOrderID
    transferOrderNumber
    transferOrderID
    transferOrderReceivingNumber
    transferOrderReceivingDatetime
    noteInternal
    vendorName
    vendorCode
    vehiclePlateNumber
    driverName
    deliveryBy
    driverPhoneNumber
    landedCost
    originWarehouse {
      warehouseName
      warehouseID
    }
    warehouse {
      warehouseName
      warehouseID
    }
    warehouseLocation {
      warehouseLocationName
      warehouseLocationID
    }
    totalItemQtyReceived
    status
    items {
      productCode
      productName
      qtyReceived
      toQtyReceived
      toQtyOutstanding
      toQty
      doQty
      uomName
      uomID
      productID
      transferOrderReceivingItemID
      note
    }
    files {
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      transferOrderReceivingFileType
      uniqueKey
    }
  }
}
    `;

export function useTransferOrderReceivingDetailQuery(options: Omit<Urql.UseQueryArgs<TransferOrderReceivingDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferOrderReceivingDetailQuery, TransferOrderReceivingDetailQueryVariables>({ query: TransferOrderReceivingDetailDocument, ...options });
};
export const TransferOrderReceivingItemsDocument = gql`
    query TransferOrderReceivingItems($qop: DeliveryOrderItemQopInput) {
  deliveryOrderItems(qop: $qop) {
    items {
      deliveryOrderItemID
      deliveryOrderID
      productID
      productCode
      productName
      product {
        barcode
      }
      productWeight
      qty
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useTransferOrderReceivingItemsQuery(options?: Omit<Urql.UseQueryArgs<TransferOrderReceivingItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferOrderReceivingItemsQuery, TransferOrderReceivingItemsQueryVariables>({ query: TransferOrderReceivingItemsDocument, ...options });
};
export const TransferOrderReceivingListItemDocument = gql`
    query TransferOrderReceivingListItem($qop: TransferOrderReceivingItemQopInput) {
  transferOrderReceivingItems(qop: $qop) {
    items {
      transferOrderReceivingItemID
      transferOrderReceivingID
      productID
      productCode
      productName
      product {
        barcode
      }
      productWeight
      uomID
      uomName
      uomDecimal
      uomConversionDecimal
      baseUomQty
      qtyReceived
      toQtyReceived
      toQtyOutstanding
      doQty
      toQty
      note
      doQty
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useTransferOrderReceivingListItemQuery(options?: Omit<Urql.UseQueryArgs<TransferOrderReceivingListItemQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferOrderReceivingListItemQuery, TransferOrderReceivingListItemQueryVariables>({ query: TransferOrderReceivingListItemDocument, ...options });
};
export const TransferOrderReceivingUpdateDocument = gql`
    mutation TransferOrderReceivingUpdate($input: TransferOrderReceivingUpdateInput!) {
  transferOrderReceivingUpdate(input: $input) {
    transferOrderReceivingID
    transferOrderReceivingDatetime
    warehouseLocationID
    closeTO
    noteInternal
    items {
      transferOrderReceivingItemID
      productID
      qtyReceived
      uomID
    }
  }
}
    `;

export function useTransferOrderReceivingUpdateMutation() {
  return Urql.useMutation<TransferOrderReceivingUpdateMutation, TransferOrderReceivingUpdateMutationVariables>(TransferOrderReceivingUpdateDocument);
};
export const UserAutocompleteDocument = gql`
    query UserAutocomplete($qop: UserLiteQopInput!) {
  usersLite(qop: $qop) {
    items {
      userID
      fullName
      userType
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useUserAutocompleteQuery(options: Omit<Urql.UseQueryArgs<UserAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<UserAutocompleteQuery, UserAutocompleteQueryVariables>({ query: UserAutocompleteDocument, ...options });
};
export const PosBookmarkProductCreateDocument = gql`
    mutation PosBookmarkProductCreate($input: PosBookmarkProductCreateInput!) {
  posBookmarkProductCreate(input: $input) {
    posBookmarkProductID
    posBookmarkID
    posBookmarkName
    productID
    uniqueKey
  }
}
    `;

export function usePosBookmarkProductCreateMutation() {
  return Urql.useMutation<PosBookmarkProductCreateMutation, PosBookmarkProductCreateMutationVariables>(PosBookmarkProductCreateDocument);
};
export const PosBookmarkProductDeleteDocument = gql`
    mutation PosBookmarkProductDelete($posBookmarkProductID: UUID!) {
  posBookmarkProductDelete(posBookmarkProductID: $posBookmarkProductID)
}
    `;

export function usePosBookmarkProductDeleteMutation() {
  return Urql.useMutation<PosBookmarkProductDeleteMutation, PosBookmarkProductDeleteMutationVariables>(PosBookmarkProductDeleteDocument);
};
export const PosBookmarkProductListDocument = gql`
    query PosBookmarkProductList($qop: PosBookmarkProductQopInput!) {
  posBookmarkProducts(qop: $qop) {
    items {
      posBookmarkProductID
      posBookmarkID
      posBookmarkName
      productID
      uniqueKey
      posBookmark {
        posBookmarkID
        posBookmarkName
        uniqueKey
      }
      product {
        productID
        productCode
        productName
        barcode
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePosBookmarkProductListQuery(options: Omit<Urql.UseQueryArgs<PosBookmarkProductListQueryVariables>, 'query'>) {
  return Urql.useQuery<PosBookmarkProductListQuery, PosBookmarkProductListQueryVariables>({ query: PosBookmarkProductListDocument, ...options });
};
export const PosBookmarkAutocompleteDocument = gql`
    query PosBookmarkAutocomplete($qop: PosBookmarkQopInput) {
  posBookmarks(qop: $qop) {
    items {
      posBookmarkID
      posBookmarkName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePosBookmarkAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<PosBookmarkAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PosBookmarkAutocompleteQuery, PosBookmarkAutocompleteQueryVariables>({ query: PosBookmarkAutocompleteDocument, ...options });
};
export const PosBookmarkCreateDocument = gql`
    mutation PosBookmarkCreate($input: PosBookmarkCreateInput!) {
  posBookmarkCreate(input: $input) {
    posBookmarkID
    posBookmarkName
    uniqueKey
  }
}
    `;

export function usePosBookmarkCreateMutation() {
  return Urql.useMutation<PosBookmarkCreateMutation, PosBookmarkCreateMutationVariables>(PosBookmarkCreateDocument);
};
export const PosBookmarkDeleteDocument = gql`
    mutation PosBookmarkDelete($posBookmarkID: UUID!) {
  posBookmarkDelete(posBookmarkID: $posBookmarkID)
}
    `;

export function usePosBookmarkDeleteMutation() {
  return Urql.useMutation<PosBookmarkDeleteMutation, PosBookmarkDeleteMutationVariables>(PosBookmarkDeleteDocument);
};
export const PosBookmarkListDocument = gql`
    query PosBookmarkList($qop: PosBookmarkQopInput) {
  posBookmarks(qop: $qop) {
    items {
      posBookmarkID
      posBookmarkName
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePosBookmarkListQuery(options?: Omit<Urql.UseQueryArgs<PosBookmarkListQueryVariables>, 'query'>) {
  return Urql.useQuery<PosBookmarkListQuery, PosBookmarkListQueryVariables>({ query: PosBookmarkListDocument, ...options });
};
export const PosBookmarkLoadDocument = gql`
    query PosBookmarkLoad($posBookmarkID: UUID!) {
  posBookmark(posBookmarkID: $posBookmarkID) {
    posBookmarkID
    posBookmarkName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePosBookmarkLoadQuery(options: Omit<Urql.UseQueryArgs<PosBookmarkLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PosBookmarkLoadQuery, PosBookmarkLoadQueryVariables>({ query: PosBookmarkLoadDocument, ...options });
};
export const PosBookmarkUpdateDocument = gql`
    mutation PosBookmarkUpdate($input: PosBookmarkUpdateInput!) {
  posBookmarkUpdate(input: $input) {
    posBookmarkID
    posBookmarkName
    uniqueKey
  }
}
    `;

export function usePosBookmarkUpdateMutation() {
  return Urql.useMutation<PosBookmarkUpdateMutation, PosBookmarkUpdateMutationVariables>(PosBookmarkUpdateDocument);
};
export const PosterCreateDocument = gql`
    mutation PosterCreate($input: PosterCreateInput!) {
  posterCreate(input: $input) {
    posterID
    posterName
    priority
    isActive
    isDefault
  }
}
    `;

export function usePosterCreateMutation() {
  return Urql.useMutation<PosterCreateMutation, PosterCreateMutationVariables>(PosterCreateDocument);
};
export const PosterDeleteDocument = gql`
    mutation PosterDelete($posterID: UUID!) {
  posterDelete(posterID: $posterID)
}
    `;

export function usePosterDeleteMutation() {
  return Urql.useMutation<PosterDeleteMutation, PosterDeleteMutationVariables>(PosterDeleteDocument);
};
export const PosterListDocument = gql`
    query PosterList($qop: PosterQopInput) {
  posters(qop: $qop) {
    items {
      posterID
      posterName
      priority
      startAt
      endAt
      isActive
      isDefault
      isAllBranches
      branches {
        branchID
        branchName
      }
      images {
        posterImageID
        displayDurationSeconds
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePosterListQuery(options?: Omit<Urql.UseQueryArgs<PosterListQueryVariables>, 'query'>) {
  return Urql.useQuery<PosterListQuery, PosterListQueryVariables>({ query: PosterListDocument, ...options });
};
export const PosterLoadDocument = gql`
    query PosterLoad($posterID: UUID!) {
  poster(posterID: $posterID) {
    posterID
    posterName
    priority
    startAt
    endAt
    isActive
    isDefault
    isAllBranches
    branches {
      branchID
      branchName
      branch {
        branchID
        branchCode
        branchName
      }
    }
    images {
      posterImageID
      fileID
      imageLabel
      displayOrder
      displayDurationSeconds
      imageURL
      file {
        fileID
        originalFileName
        fileSizeMB
      }
    }
    entityAuditMetadata {
      createdAt
      createdByUserName
      updatedAt
      updatedByUserName
    }
  }
}
    `;

export function usePosterLoadQuery(options: Omit<Urql.UseQueryArgs<PosterLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PosterLoadQuery, PosterLoadQueryVariables>({ query: PosterLoadDocument, ...options });
};
export const PosterUpdateDocument = gql`
    mutation PosterUpdate($input: PosterUpdateInput!) {
  posterUpdate(input: $input) {
    posterID
    posterName
    priority
    isActive
    isDefault
  }
}
    `;

export function usePosterUpdateMutation() {
  return Urql.useMutation<PosterUpdateMutation, PosterUpdateMutationVariables>(PosterUpdateDocument);
};
export const PricelistPeriodAutocompleteDocument = gql`
    query PricelistPeriodAutocomplete($qop: PricelistPeriodQopInput) {
  pricelistPeriods(qop: $qop) {
    items {
      pricelistPeriodID
      pricelistPeriodName
      pricelistID
      effectiveStartDate
      effectiveEndDate
      effectiveStartHour
      effectiveStartMinute
      effectiveEndHour
      effectiveEndMinute
      priority
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePricelistPeriodAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<PricelistPeriodAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistPeriodAutocompleteQuery, PricelistPeriodAutocompleteQueryVariables>({ query: PricelistPeriodAutocompleteDocument, ...options });
};
export const PricelistPeriodCreateDocument = gql`
    mutation PricelistPeriodCreate($input: PricelistPeriodCreateInput!) {
  pricelistPeriodCreate(input: $input) {
    pricelistPeriodID
    pricelistPeriodName
    pricelistID
    effectiveStartDate
    effectiveEndDate
    effectiveStartHour
    effectiveStartMinute
    effectiveEndHour
    effectiveEndMinute
    priority
    isActive
    uniqueKey
  }
}
    `;

export function usePricelistPeriodCreateMutation() {
  return Urql.useMutation<PricelistPeriodCreateMutation, PricelistPeriodCreateMutationVariables>(PricelistPeriodCreateDocument);
};
export const PricelistPeriodDeleteDocument = gql`
    mutation PricelistPeriodDelete($pricelistPeriodID: UUID!) {
  pricelistPeriodDelete(pricelistPeriodID: $pricelistPeriodID)
}
    `;

export function usePricelistPeriodDeleteMutation() {
  return Urql.useMutation<PricelistPeriodDeleteMutation, PricelistPeriodDeleteMutationVariables>(PricelistPeriodDeleteDocument);
};
export const PricelistPeriodListDocument = gql`
    query PricelistPeriodList($qop: PricelistPeriodQopInput) {
  pricelistPeriods(qop: $qop) {
    items {
      pricelistPeriodID
      pricelistPeriodName
      pricelistID
      effectiveStartDate
      effectiveEndDate
      effectiveStartHour
      effectiveStartMinute
      effectiveEndHour
      effectiveEndMinute
      useTime
      priority
      isActive
      uniqueKey
      pricelist {
        pricelistId
        pricelistCode
        pricelistName
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePricelistPeriodListQuery(options?: Omit<Urql.UseQueryArgs<PricelistPeriodListQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistPeriodListQuery, PricelistPeriodListQueryVariables>({ query: PricelistPeriodListDocument, ...options });
};
export const PricelistPeriodLoadDocument = gql`
    query PricelistPeriodLoad($pricelistPeriodID: UUID!) {
  pricelistPeriod(pricelistPeriodID: $pricelistPeriodID) {
    pricelistPeriodID
    pricelistPeriodName
    pricelistID
    effectiveStartDate
    effectiveEndDate
    effectiveStartHour
    effectiveStartMinute
    effectiveEndHour
    effectiveEndMinute
    useTime
    priority
    isActive
    uniqueKey
    pricelist {
      pricelistId
      pricelistCode
      pricelistName
      isActive
      uniqueKey
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePricelistPeriodLoadQuery(options: Omit<Urql.UseQueryArgs<PricelistPeriodLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistPeriodLoadQuery, PricelistPeriodLoadQueryVariables>({ query: PricelistPeriodLoadDocument, ...options });
};
export const PricelistPeriodUpdateDocument = gql`
    mutation PricelistPeriodUpdate($input: PricelistPeriodUpdateInput!) {
  pricelistPeriodUpdate(input: $input) {
    pricelistPeriodID
    pricelistPeriodName
    pricelistID
    effectiveStartDate
    effectiveEndDate
    effectiveStartHour
    effectiveStartMinute
    effectiveEndHour
    effectiveEndMinute
    priority
    isActive
    uniqueKey
  }
}
    `;

export function usePricelistPeriodUpdateMutation() {
  return Urql.useMutation<PricelistPeriodUpdateMutation, PricelistPeriodUpdateMutationVariables>(PricelistPeriodUpdateDocument);
};
export const PricelistProductChannelPricesDocument = gql`
    query PricelistProductChannelPrices($pricelistProductID: UUID!) {
  pricelistProduct(pricelistProductID: $pricelistProductID) {
    pricelistProductID
    sellingPrice
    salesChannelPrices {
      salesChannelID
      salesChannel {
        salesChannelID
        salesChannelName
        salesChannelType
      }
      pricelistProductSalesChannel {
        pricelistProductSalesChannelID
        customSellingPrice
        isActive
      }
      autoSellingPrice
      effectiveSellingPrice
      priceSource
    }
  }
}
    `;

export function usePricelistProductChannelPricesQuery(options: Omit<Urql.UseQueryArgs<PricelistProductChannelPricesQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistProductChannelPricesQuery, PricelistProductChannelPricesQueryVariables>({ query: PricelistProductChannelPricesDocument, ...options });
};
export const PricelistProductSalesChannelDeleteDocument = gql`
    mutation PricelistProductSalesChannelDelete($pricelistProductSalesChannelID: UUID!) {
  pricelistProductSalesChannelDelete(
    pricelistProductSalesChannelID: $pricelistProductSalesChannelID
  )
}
    `;

export function usePricelistProductSalesChannelDeleteMutation() {
  return Urql.useMutation<PricelistProductSalesChannelDeleteMutation, PricelistProductSalesChannelDeleteMutationVariables>(PricelistProductSalesChannelDeleteDocument);
};
export const PricelistProductSalesChannelUpsertDocument = gql`
    mutation PricelistProductSalesChannelUpsert($input: PricelistProductSalesChannelUpsertInput!) {
  pricelistProductSalesChannelUpsert(input: $input) {
    pricelistProductSalesChannelID
    salesChannelID
    customSellingPrice
    isActive
  }
}
    `;

export function usePricelistProductSalesChannelUpsertMutation() {
  return Urql.useMutation<PricelistProductSalesChannelUpsertMutation, PricelistProductSalesChannelUpsertMutationVariables>(PricelistProductSalesChannelUpsertDocument);
};
export const PricelistProductBulkCreateDocument = gql`
    mutation PricelistProductBulkCreate($input: PricelistProductBulkCreateInput!) {
  pricelistProductBulkCreate(input: $input) {
    pricelistProductID
    pricelistPeriodID
    pricelistID
    productID
    sellingPrice
    salesChannelPrice
    uniqueKey
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePricelistProductBulkCreateMutation() {
  return Urql.useMutation<PricelistProductBulkCreateMutation, PricelistProductBulkCreateMutationVariables>(PricelistProductBulkCreateDocument);
};
export const PricelistProductCreateDocument = gql`
    mutation PricelistProductCreate($input: PricelistProductCreateInput!) {
  pricelistProductCreate(input: $input) {
    pricelistProductID
    pricelistPeriodID
    pricelistID
    productID
    sellingPrice
    salesChannelPrice
    uniqueKey
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePricelistProductCreateMutation() {
  return Urql.useMutation<PricelistProductCreateMutation, PricelistProductCreateMutationVariables>(PricelistProductCreateDocument);
};
export const PricelistProductDeleteDocument = gql`
    mutation PricelistProductDelete($input: PricelistProductDeleteInput!) {
  pricelistProductDelete(input: $input) {
    pricelistProductID
    pricelistPeriodID
    pricelistID
    productID
    sellingPrice
    salesChannelPrice
    uniqueKey
  }
}
    `;

export function usePricelistProductDeleteMutation() {
  return Urql.useMutation<PricelistProductDeleteMutation, PricelistProductDeleteMutationVariables>(PricelistProductDeleteDocument);
};
export const PricelistProductImportDocument = gql`
    mutation PricelistProductImport($input: PricelistProductImportInput!) {
  pricelistProductImport(input: $input) {
    importedCount
    updatedCount
    skippedCount
  }
}
    `;

export function usePricelistProductImportMutation() {
  return Urql.useMutation<PricelistProductImportMutation, PricelistProductImportMutationVariables>(PricelistProductImportDocument);
};
export const PricelistProductImportValidateDocument = gql`
    mutation PricelistProductImportValidate($input: PricelistProductImportValidateInput!) {
  pricelistProductImportValidate(input: $input) {
    missingProductCodes
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        standardKey
        label
        reason
        value
      }
    }
  }
}
    `;

export function usePricelistProductImportValidateMutation() {
  return Urql.useMutation<PricelistProductImportValidateMutation, PricelistProductImportValidateMutationVariables>(PricelistProductImportValidateDocument);
};
export const PricelistProductListDocument = gql`
    query PricelistProductList($qop: PricelistProductQopInput) {
  pricelistProducts(qop: $qop) {
    items {
      pricelistProductID
      pricelistPeriodID
      pricelistID
      productID
      sellingPrice
      salesChannelPrice
      uniqueKey
      product {
        productID
        productCode
        productName
        productNameAlias
        productType
        barcode
        altBarcode1
        altBarcode2
        uomCategoryID
        baseUomID
        description
        productBrandID
        productSourceID
        productCategoryID
        productSubCategoryID
        mainImageFileID
        mainImageFileSmallPathURL
        mainImageFileMediumPathURL
        mainImageFileLargePathURL
        isConsignment
        consignmentVendorID
        trackExpiredDate
        isProduced
        weight
        volumeLength
        volumeHeight
        volumeWidth
        canBePurchased
        purchaseCost
        minimumOrder
        purchaseUomID
        purchaseTaxID
        canBeSold
        salesUomID
        salesTaxID
        salesScanType
        uniqueKey
        isActive
        productBrand {
          productBrandID
          productBrandName
          uniqueKey
          isActive
        }
        productSource {
          productSourceID
          productSourceCode
          productSourceName
          uniqueKey
          isActive
        }
        productCategory {
          productCategoryID
          productCategoryName
          productCategoryFullName
          productSubDepartmentID
          productSubDepartmentName
          productDepartmentID
          productDepartmentName
          productDivisionID
          productDivisionName
          uniqueKey
          isActive
        }
        productSubCategory {
          productSubCategoryID
          productSubCategoryName
          productCategoryID
          uniqueKey
          isActive
        }
        baseUom {
          uomID
          uomCategoryID
          uomName
          relationType
          convertionRate
          convertionRateMultiplier
          convertionDecimal
          isMain
          uniqueKey
          uniqueKey2
          isActive
        }
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePricelistProductListQuery(options?: Omit<Urql.UseQueryArgs<PricelistProductListQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistProductListQuery, PricelistProductListQueryVariables>({ query: PricelistProductListDocument, ...options });
};
export const PricelistProductLoadDocument = gql`
    query PricelistProductLoad($pricelistProductID: UUID!) {
  pricelistProduct(pricelistProductID: $pricelistProductID) {
    pricelistProductID
    pricelistPeriodID
    pricelistID
    productID
    sellingPrice
    salesChannelPrice
    uniqueKey
  }
}
    `;

export function usePricelistProductLoadQuery(options: Omit<Urql.UseQueryArgs<PricelistProductLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistProductLoadQuery, PricelistProductLoadQueryVariables>({ query: PricelistProductLoadDocument, ...options });
};
export const PricelistProductUpdateDocument = gql`
    mutation PricelistProductUpdate($input: PricelistProductUpdateInput!) {
  pricelistProductUpdate(input: $input) {
    pricelistProductID
    pricelistPeriodID
    pricelistID
    productID
    sellingPrice
    salesChannelPrice
    uniqueKey
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePricelistProductUpdateMutation() {
  return Urql.useMutation<PricelistProductUpdateMutation, PricelistProductUpdateMutationVariables>(PricelistProductUpdateDocument);
};
export const PricelistChannelMarkupsDocument = gql`
    query PricelistChannelMarkups($pricelistID: UUID!) {
  pricelist(pricelistID: $pricelistID) {
    pricelistId
    channelMarkups {
      salesChannelID
      markupPerc
      markupSource
      salesChannel {
        salesChannelID
        salesChannelName
        salesChannelType
        commisionPerc
      }
      pricelistSalesChannel {
        pricelistSalesChannelID
        priceMarkupPerc
        isActive
      }
    }
  }
}
    `;

export function usePricelistChannelMarkupsQuery(options: Omit<Urql.UseQueryArgs<PricelistChannelMarkupsQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistChannelMarkupsQuery, PricelistChannelMarkupsQueryVariables>({ query: PricelistChannelMarkupsDocument, ...options });
};
export const PricelistSalesChannelDeleteDocument = gql`
    mutation PricelistSalesChannelDelete($pricelistSalesChannelID: UUID!) {
  pricelistSalesChannelDelete(pricelistSalesChannelID: $pricelistSalesChannelID)
}
    `;

export function usePricelistSalesChannelDeleteMutation() {
  return Urql.useMutation<PricelistSalesChannelDeleteMutation, PricelistSalesChannelDeleteMutationVariables>(PricelistSalesChannelDeleteDocument);
};
export const PricelistSalesChannelUpsertDocument = gql`
    mutation PricelistSalesChannelUpsert($input: PricelistSalesChannelUpsertInput!) {
  pricelistSalesChannelUpsert(input: $input) {
    pricelistSalesChannelID
    salesChannelID
    priceMarkupPerc
    isActive
  }
}
    `;

export function usePricelistSalesChannelUpsertMutation() {
  return Urql.useMutation<PricelistSalesChannelUpsertMutation, PricelistSalesChannelUpsertMutationVariables>(PricelistSalesChannelUpsertDocument);
};
export const PricelistAutocompleteDocument = gql`
    query PricelistAutocomplete($qop: PricelistQopInput) {
  pricelists(qop: $qop) {
    items {
      pricelistId
      pricelistName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePricelistAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<PricelistAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistAutocompleteQuery, PricelistAutocompleteQueryVariables>({ query: PricelistAutocompleteDocument, ...options });
};
export const PricelistCreateDocument = gql`
    mutation PricelistCreate($input: PricelistCreateInput!) {
  pricelistCreate(input: $input) {
    pricelistId
    pricelistCode
    pricelistName
    isActive
    uniqueKey
  }
}
    `;

export function usePricelistCreateMutation() {
  return Urql.useMutation<PricelistCreateMutation, PricelistCreateMutationVariables>(PricelistCreateDocument);
};
export const PricelistDeleteDocument = gql`
    mutation PricelistDelete($input: PricelistDeleteInput!) {
  pricelistDelete(input: $input) {
    pricelistId
    pricelistCode
    pricelistName
    isActive
    uniqueKey
  }
}
    `;

export function usePricelistDeleteMutation() {
  return Urql.useMutation<PricelistDeleteMutation, PricelistDeleteMutationVariables>(PricelistDeleteDocument);
};
export const PricelistListDocument = gql`
    query PricelistList($qop: PricelistQopInput) {
  pricelists(qop: $qop) {
    items {
      pricelistId
      pricelistCode
      pricelistName
      isActive
      uniqueKey
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePricelistListQuery(options?: Omit<Urql.UseQueryArgs<PricelistListQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistListQuery, PricelistListQueryVariables>({ query: PricelistListDocument, ...options });
};
export const PricelistLoadDocument = gql`
    query PricelistLoad($pricelistID: UUID!) {
  pricelist(pricelistID: $pricelistID) {
    pricelistId
    pricelistCode
    pricelistName
    isActive
    uniqueKey
    pricelistPeriods {
      pricelistPeriodID
      pricelistPeriodName
      pricelistID
      effectiveStartDate
      effectiveEndDate
      effectiveStartHour
      effectiveStartMinute
      effectiveEndHour
      effectiveEndMinute
      useTime
      priority
      isActive
      uniqueKey
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePricelistLoadQuery(options: Omit<Urql.UseQueryArgs<PricelistLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistLoadQuery, PricelistLoadQueryVariables>({ query: PricelistLoadDocument, ...options });
};
export const PricelistUpdateDocument = gql`
    mutation PricelistUpdate($input: PricelistUpdateInput!) {
  pricelistUpdate(input: $input) {
    pricelistId
    pricelistCode
    pricelistName
    isActive
    uniqueKey
  }
}
    `;

export function usePricelistUpdateMutation() {
  return Urql.useMutation<PricelistUpdateMutation, PricelistUpdateMutationVariables>(PricelistUpdateDocument);
};
export const ConsignmentTagPricesDocument = gql`
    query ConsignmentTagPrices($input: ConsignmentTagPricesInput!) {
  consignmentTagPrices(input: $input) {
    productCode
    productName
    brandName
    barcode
    vendorCode
    stickerCode
    sellingPrice
    found
  }
}
    `;

export function useConsignmentTagPricesQuery(options: Omit<Urql.UseQueryArgs<ConsignmentTagPricesQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentTagPricesQuery, ConsignmentTagPricesQueryVariables>({ query: ConsignmentTagPricesDocument, ...options });
};
export const BranchWithPricelistAutocompleteDocument = gql`
    query BranchWithPricelistAutocomplete($qop: BranchQopInput) {
  branches(qop: $qop) {
    items {
      branchID
      branchName
      branchCode
      pricelistID
      pricelist {
        pricelistName
      }
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useBranchWithPricelistAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<BranchWithPricelistAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchWithPricelistAutocompleteQuery, BranchWithPricelistAutocompleteQueryVariables>({ query: BranchWithPricelistAutocompleteDocument, ...options });
};
export const PricelistProductAutocompleteDocument = gql`
    query PricelistProductAutocomplete($qop: PricelistProductQopInput) {
  pricelistProducts(qop: $qop) {
    items {
      productID
      product {
        productCode
        productName
      }
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePricelistProductAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<PricelistProductAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistProductAutocompleteQuery, PricelistProductAutocompleteQueryVariables>({ query: PricelistProductAutocompleteDocument, ...options });
};
export const PricelistTagPricesDocument = gql`
    query PricelistTagPrices($input: PricelistTagPricesInput!) {
  pricelistTagPrices(input: $input) {
    productCode
    productName
    brandName
    barcode
    sellingPrice
    nominalPrice
    finalPrice
    discountAmount
    discountPercent
    promoName
    promoTypeName
    found
  }
}
    `;

export function usePricelistTagPricesQuery(options: Omit<Urql.UseQueryArgs<PricelistTagPricesQueryVariables>, 'query'>) {
  return Urql.useQuery<PricelistTagPricesQuery, PricelistTagPricesQueryVariables>({ query: PricelistTagPricesDocument, ...options });
};
export const ProductAccountingCategoryAutocompleteDocument = gql`
    query ProductAccountingCategoryAutocomplete($qop: ProductAccountingCategoryQopInput!) {
  productAccountingCategories(qop: $qop) {
    items {
      productAccountingCategoryID
      productAccountingCategoryName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductAccountingCategoryAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ProductAccountingCategoryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAccountingCategoryAutocompleteQuery, ProductAccountingCategoryAutocompleteQueryVariables>({ query: ProductAccountingCategoryAutocompleteDocument, ...options });
};
export const ProductAccountingCategoryDeleteDocument = gql`
    mutation ProductAccountingCategoryDelete($productAccountingCategoryID: UUID!) {
  productAccountingCategoryDelete(
    productAccountingCategoryID: $productAccountingCategoryID
  )
}
    `;

export function useProductAccountingCategoryDeleteMutation() {
  return Urql.useMutation<ProductAccountingCategoryDeleteMutation, ProductAccountingCategoryDeleteMutationVariables>(ProductAccountingCategoryDeleteDocument);
};
export const ProductAccountingCategoryListDocument = gql`
    query ProductAccountingCategoryList($qop: ProductAccountingCategoryQopInput!) {
  productAccountingCategories(qop: $qop) {
    items {
      productAccountingCategoryID
      productAccountingCategoryName
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useProductAccountingCategoryListQuery(options: Omit<Urql.UseQueryArgs<ProductAccountingCategoryListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAccountingCategoryListQuery, ProductAccountingCategoryListQueryVariables>({ query: ProductAccountingCategoryListDocument, ...options });
};
export const ProductAccountingCategoryLoadDocument = gql`
    query ProductAccountingCategoryLoad($productAccountingCategoryID: UUID!) {
  productAccountingCategory(
    productAccountingCategoryID: $productAccountingCategoryID
  ) {
    productAccountingCategoryID
    productAccountingCategoryName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductAccountingCategoryLoadQuery(options: Omit<Urql.UseQueryArgs<ProductAccountingCategoryLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAccountingCategoryLoadQuery, ProductAccountingCategoryLoadQueryVariables>({ query: ProductAccountingCategoryLoadDocument, ...options });
};
export const ProductAccountingCategoryUpdateDocument = gql`
    mutation ProductAccountingCategoryUpdate($input: ProductAccountingCategoryUpdateInput!) {
  productAccountingCategoryUpdate(input: $input) {
    productAccountingCategoryID
  }
}
    `;

export function useProductAccountingCategoryUpdateMutation() {
  return Urql.useMutation<ProductAccountingCategoryUpdateMutation, ProductAccountingCategoryUpdateMutationVariables>(ProductAccountingCategoryUpdateDocument);
};
export const ProductAccountingCategoryCreateDocument = gql`
    mutation ProductAccountingCategoryCreate($input: ProductAccountingCategoryCreateInput!) {
  productAccountingCategoryCreate(input: $input) {
    productAccountingCategoryID
  }
}
    `;

export function useProductAccountingCategoryCreateMutation() {
  return Urql.useMutation<ProductAccountingCategoryCreateMutation, ProductAccountingCategoryCreateMutationVariables>(ProductAccountingCategoryCreateDocument);
};
export const ProductAddonComponentListByProductAddonIdDocument = gql`
    query ProductAddonComponentListByProductAddonID($productAddonID: UUID!) {
  productAddonComponentsByProductAddonID(productAddonID: $productAddonID) {
    productAddonComponentID
    productAddonID
    productID
    productCode
    productName
    product {
      barcode
    }
    uomCategoryID
    uomID
    uomName
    uomDecimal
    uomConvertionRate
    uomConversionDecimal
    baseUomQty
    priceType
    customSellingPrice
    sequence
    uniqueKey
  }
}
    `;

export function useProductAddonComponentListByProductAddonIdQuery(options: Omit<Urql.UseQueryArgs<ProductAddonComponentListByProductAddonIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAddonComponentListByProductAddonIdQuery, ProductAddonComponentListByProductAddonIdQueryVariables>({ query: ProductAddonComponentListByProductAddonIdDocument, ...options });
};
export const ProductAddonGroupItemsByGroupIdDocument = gql`
    query ProductAddonGroupItemsByGroupID($productAddonGroupID: UUID!) {
  productAddonGroupItemsByGroupID(productAddonGroupID: $productAddonGroupID) {
    productAddonGroupItemID
    productAddonGroupID
    productAddonID
    productAddon {
      name
      description
    }
    sequence
    uniqueKey
  }
}
    `;

export function useProductAddonGroupItemsByGroupIdQuery(options: Omit<Urql.UseQueryArgs<ProductAddonGroupItemsByGroupIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAddonGroupItemsByGroupIdQuery, ProductAddonGroupItemsByGroupIdQueryVariables>({ query: ProductAddonGroupItemsByGroupIdDocument, ...options });
};
export const ProductAddonGroupAutocompleteDocument = gql`
    query ProductAddonGroupAutocomplete($qop: ProductAddonGroupQopInput) {
  productAddonGroups(qop: $qop) {
    items {
      productAddonGroupID
      name
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useProductAddonGroupAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ProductAddonGroupAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAddonGroupAutocompleteQuery, ProductAddonGroupAutocompleteQueryVariables>({ query: ProductAddonGroupAutocompleteDocument, ...options });
};
export const ProductAddonGroupCreateDocument = gql`
    mutation ProductAddonGroupCreate($input: ProductAddonGroupCreateInput!) {
  productAddonGroupCreate(input: $input) {
    productAddonGroupID
  }
}
    `;

export function useProductAddonGroupCreateMutation() {
  return Urql.useMutation<ProductAddonGroupCreateMutation, ProductAddonGroupCreateMutationVariables>(ProductAddonGroupCreateDocument);
};
export const ProductAddonGroupDeleteDocument = gql`
    mutation ProductAddonGroupDelete($productAddonGroupID: UUID!) {
  productAddonGroupDelete(productAddonGroupID: $productAddonGroupID)
}
    `;

export function useProductAddonGroupDeleteMutation() {
  return Urql.useMutation<ProductAddonGroupDeleteMutation, ProductAddonGroupDeleteMutationVariables>(ProductAddonGroupDeleteDocument);
};
export const ProductAddonGroupListDocument = gql`
    query ProductAddonGroupList($qop: ProductAddonGroupQopInput) {
  productAddonGroups(qop: $qop) {
    items {
      productAddonGroupID
      name
      description
      isActive
      uniqueKey
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useProductAddonGroupListQuery(options?: Omit<Urql.UseQueryArgs<ProductAddonGroupListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAddonGroupListQuery, ProductAddonGroupListQueryVariables>({ query: ProductAddonGroupListDocument, ...options });
};
export const ProductAddonGroupLoadDocument = gql`
    query ProductAddonGroupLoad($productAddonGroupID: UUID!) {
  productAddonGroup(productAddonGroupID: $productAddonGroupID) {
    productAddonGroupID
    name
    description
    isActive
    uniqueKey
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductAddonGroupLoadQuery(options: Omit<Urql.UseQueryArgs<ProductAddonGroupLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAddonGroupLoadQuery, ProductAddonGroupLoadQueryVariables>({ query: ProductAddonGroupLoadDocument, ...options });
};
export const ProductAddonGroupUpdateDocument = gql`
    mutation ProductAddonGroupUpdate($input: ProductAddonGroupUpdateInput!) {
  productAddonGroupUpdate(input: $input) {
    productAddonGroupID
  }
}
    `;

export function useProductAddonGroupUpdateMutation() {
  return Urql.useMutation<ProductAddonGroupUpdateMutation, ProductAddonGroupUpdateMutationVariables>(ProductAddonGroupUpdateDocument);
};
export const ProductAddonAutocompleteDocument = gql`
    query ProductAddonAutocomplete($qop: ProductAddonQopInput) {
  productAddons(qop: $qop) {
    items {
      productAddonID
      name
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useProductAddonAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ProductAddonAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAddonAutocompleteQuery, ProductAddonAutocompleteQueryVariables>({ query: ProductAddonAutocompleteDocument, ...options });
};
export const ProductAddonCreateDocument = gql`
    mutation ProductAddonCreate($input: ProductAddonCreateInput!) {
  productAddonCreate(input: $input) {
    productAddonID
  }
}
    `;

export function useProductAddonCreateMutation() {
  return Urql.useMutation<ProductAddonCreateMutation, ProductAddonCreateMutationVariables>(ProductAddonCreateDocument);
};
export const ProductAddonDeleteDocument = gql`
    mutation ProductAddonDelete($productAddonID: UUID!) {
  productAddonDelete(productAddonID: $productAddonID)
}
    `;

export function useProductAddonDeleteMutation() {
  return Urql.useMutation<ProductAddonDeleteMutation, ProductAddonDeleteMutationVariables>(ProductAddonDeleteDocument);
};
export const ProductAddonListDocument = gql`
    query ProductAddonList($qop: ProductAddonQopInput) {
  productAddons(qop: $qop) {
    items {
      productAddonID
      name
      description
      isRequired
      isMultiple
      minQty
      maxQty
      showQty
      isActive
      uniqueKey
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useProductAddonListQuery(options?: Omit<Urql.UseQueryArgs<ProductAddonListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAddonListQuery, ProductAddonListQueryVariables>({ query: ProductAddonListDocument, ...options });
};
export const ProductAddonLoadDocument = gql`
    query ProductAddonLoad($productAddonID: UUID!) {
  productAddon(productAddonID: $productAddonID) {
    productAddonID
    name
    description
    isRequired
    isMultiple
    minQty
    maxQty
    showQty
    isActive
    uniqueKey
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductAddonLoadQuery(options: Omit<Urql.UseQueryArgs<ProductAddonLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAddonLoadQuery, ProductAddonLoadQueryVariables>({ query: ProductAddonLoadDocument, ...options });
};
export const ProductAddonUpdateDocument = gql`
    mutation ProductAddonUpdate($input: ProductAddonUpdateInput!) {
  productAddonUpdate(input: $input) {
    productAddonID
  }
}
    `;

export function useProductAddonUpdateMutation() {
  return Urql.useMutation<ProductAddonUpdateMutation, ProductAddonUpdateMutationVariables>(ProductAddonUpdateDocument);
};
export const ProductAvailabilityTemplateItemCreateDocument = gql`
    mutation ProductAvailabilityTemplateItemCreate($input: ProductAvailabilityTemplateItemCreateInput!) {
  productAvailabilityTemplateItemCreate(input: $input) {
    productAvailabilityTemplateItemID
    productAvailabilityTemplateID
    productID
    uniqueKey
    isActive
  }
}
    `;

export function useProductAvailabilityTemplateItemCreateMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateItemCreateMutation, ProductAvailabilityTemplateItemCreateMutationVariables>(ProductAvailabilityTemplateItemCreateDocument);
};
export const ProductAvailabilityTemplateItemDeleteDocument = gql`
    mutation ProductAvailabilityTemplateItemDelete($productAvailabilityTemplateItemID: UUID!) {
  productAvailabilityTemplateItemDelete(
    productAvailabilityTemplateItemID: $productAvailabilityTemplateItemID
  )
}
    `;

export function useProductAvailabilityTemplateItemDeleteMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateItemDeleteMutation, ProductAvailabilityTemplateItemDeleteMutationVariables>(ProductAvailabilityTemplateItemDeleteDocument);
};
export const ProductAvailabilityTemplateItemExportDocument = gql`
    mutation ProductAvailabilityTemplateItemExport($productAvailabilityTemplateID: UUID!) {
  productAvailabilityTemplateItemExport(
    productAvailabilityTemplateID: $productAvailabilityTemplateID
  ) {
    fileName
    downloadURL
  }
}
    `;

export function useProductAvailabilityTemplateItemExportMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateItemExportMutation, ProductAvailabilityTemplateItemExportMutationVariables>(ProductAvailabilityTemplateItemExportDocument);
};
export const ProductAvailabilityTemplateItemImportDocument = gql`
    mutation ProductAvailabilityTemplateItemImport($input: ProductAvailabilityTemplateItemImportInput!) {
  productAvailabilityTemplateItemImport(input: $input) {
    importedCount
    skippedCount
  }
}
    `;

export function useProductAvailabilityTemplateItemImportMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateItemImportMutation, ProductAvailabilityTemplateItemImportMutationVariables>(ProductAvailabilityTemplateItemImportDocument);
};
export const ProductAvailabilityTemplateItemImportValidateDocument = gql`
    mutation ProductAvailabilityTemplateItemImportValidate($input: ProductAvailabilityTemplateItemImportValidateInput!) {
  productAvailabilityTemplateItemImportValidate(input: $input) {
    missingProductCodes
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        standardKey
        label
        reason
        value
      }
    }
  }
}
    `;

export function useProductAvailabilityTemplateItemImportValidateMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateItemImportValidateMutation, ProductAvailabilityTemplateItemImportValidateMutationVariables>(ProductAvailabilityTemplateItemImportValidateDocument);
};
export const ProductAvailabilityTemplateItemListDocument = gql`
    query ProductAvailabilityTemplateItemList($qop: ProductAvailabilityTemplateItemQopInput) {
  productAvailabilityTemplateItems(qop: $qop) {
    items {
      productAvailabilityTemplateItemID
      productAvailabilityTemplateID
      productID
      uniqueKey
      isActive
      salesChannelIDs
      product {
        productCode
        productName
        barcode
        isConsignment
        productCategoryID
        productCategory {
          productCategoryID
          productCategoryName
        }
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductAvailabilityTemplateItemListQuery(options?: Omit<Urql.UseQueryArgs<ProductAvailabilityTemplateItemListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAvailabilityTemplateItemListQuery, ProductAvailabilityTemplateItemListQueryVariables>({ query: ProductAvailabilityTemplateItemListDocument, ...options });
};
export const ProductAvailabilityTemplateItemSetChannelsDocument = gql`
    mutation ProductAvailabilityTemplateItemSetChannels($input: ProductAvailabilityTemplateItemSetChannelsInput!) {
  productAvailabilityTemplateItemSetChannels(input: $input) {
    productAvailabilityTemplateItemID
    salesChannelIDs
    isActive
  }
}
    `;

export function useProductAvailabilityTemplateItemSetChannelsMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateItemSetChannelsMutation, ProductAvailabilityTemplateItemSetChannelsMutationVariables>(ProductAvailabilityTemplateItemSetChannelsDocument);
};
export const ProductAvailabilityTemplateItemUpdateDocument = gql`
    mutation ProductAvailabilityTemplateItemUpdate($input: ProductAvailabilityTemplateItemUpdateInput!) {
  productAvailabilityTemplateItemUpdate(input: $input) {
    productAvailabilityTemplateItemID
    productAvailabilityTemplateID
    productID
    uniqueKey
    isActive
  }
}
    `;

export function useProductAvailabilityTemplateItemUpdateMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateItemUpdateMutation, ProductAvailabilityTemplateItemUpdateMutationVariables>(ProductAvailabilityTemplateItemUpdateDocument);
};
export const ProductAvailabilityTemplateAutocompleteDocument = gql`
    query ProductAvailabilityTemplateAutocomplete($qop: ProductAvailabilityTemplateQopInput) {
  productAvailabilityTemplates(qop: $qop) {
    items {
      productAvailabilityTemplateID
      productAvailabilityTemplateName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductAvailabilityTemplateAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ProductAvailabilityTemplateAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAvailabilityTemplateAutocompleteQuery, ProductAvailabilityTemplateAutocompleteQueryVariables>({ query: ProductAvailabilityTemplateAutocompleteDocument, ...options });
};
export const ProductAvailabilityTemplateCreateDocument = gql`
    mutation ProductAvailabilityTemplateCreate($input: ProductAvailabilityTemplateCreateInput!) {
  productAvailabilityTemplateCreate(input: $input) {
    productAvailabilityTemplateID
    productAvailabilityTemplateName
    isActive
    uniqueKey
  }
}
    `;

export function useProductAvailabilityTemplateCreateMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateCreateMutation, ProductAvailabilityTemplateCreateMutationVariables>(ProductAvailabilityTemplateCreateDocument);
};
export const ProductAvailabilityTemplateDeleteDocument = gql`
    mutation ProductAvailabilityTemplateDelete($productAvailabilityTemplateID: UUID!) {
  productAvailabilityTemplateDelete(
    productAvailabilityTemplateID: $productAvailabilityTemplateID
  )
}
    `;

export function useProductAvailabilityTemplateDeleteMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateDeleteMutation, ProductAvailabilityTemplateDeleteMutationVariables>(ProductAvailabilityTemplateDeleteDocument);
};
export const ProductAvailabilityTemplateListDocument = gql`
    query ProductAvailabilityTemplateList($qop: ProductAvailabilityTemplateQopInput) {
  productAvailabilityTemplates(qop: $qop) {
    items {
      productAvailabilityTemplateID
      productAvailabilityTemplateName
      isActive
      uniqueKey
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductAvailabilityTemplateListQuery(options?: Omit<Urql.UseQueryArgs<ProductAvailabilityTemplateListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAvailabilityTemplateListQuery, ProductAvailabilityTemplateListQueryVariables>({ query: ProductAvailabilityTemplateListDocument, ...options });
};
export const ProductAvailabilityTemplateLoadDocument = gql`
    query ProductAvailabilityTemplateLoad($productAvailabilityTemplateID: UUID!) {
  productAvailabilityTemplate(
    productAvailabilityTemplateID: $productAvailabilityTemplateID
  ) {
    productAvailabilityTemplateID
    productAvailabilityTemplateName
    isActive
    uniqueKey
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductAvailabilityTemplateLoadQuery(options: Omit<Urql.UseQueryArgs<ProductAvailabilityTemplateLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAvailabilityTemplateLoadQuery, ProductAvailabilityTemplateLoadQueryVariables>({ query: ProductAvailabilityTemplateLoadDocument, ...options });
};
export const ProductAvailabilityTemplateUpdateDocument = gql`
    mutation ProductAvailabilityTemplateUpdate($input: ProductAvailabilityTemplateUpdateInput!) {
  productAvailabilityTemplateUpdate(input: $input) {
    productAvailabilityTemplateID
    productAvailabilityTemplateName
    isActive
    uniqueKey
  }
}
    `;

export function useProductAvailabilityTemplateUpdateMutation() {
  return Urql.useMutation<ProductAvailabilityTemplateUpdateMutation, ProductAvailabilityTemplateUpdateMutationVariables>(ProductAvailabilityTemplateUpdateDocument);
};
export const ProductBrandAutocompleteDocument = gql`
    query ProductBrandAutocomplete($qop: ProductBrandQopInput!) {
  productBrands(qop: $qop) {
    items {
      productBrandID
      productBrandName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductBrandAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ProductBrandAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductBrandAutocompleteQuery, ProductBrandAutocompleteQueryVariables>({ query: ProductBrandAutocompleteDocument, ...options });
};
export const ProductBrandCreateDocument = gql`
    mutation ProductBrandCreate($input: ProductBrandCreateInput!) {
  productBrandCreate(input: $input) {
    productBrandID
    productBrandName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductBrandCreateMutation() {
  return Urql.useMutation<ProductBrandCreateMutation, ProductBrandCreateMutationVariables>(ProductBrandCreateDocument);
};
export const ProductBrandDeleteDocument = gql`
    mutation ProductBrandDelete($productBrandID: UUID!) {
  productBrandDelete(productBrandID: $productBrandID)
}
    `;

export function useProductBrandDeleteMutation() {
  return Urql.useMutation<ProductBrandDeleteMutation, ProductBrandDeleteMutationVariables>(ProductBrandDeleteDocument);
};
export const ProductBrandListDocument = gql`
    query ProductBrandList($qop: ProductBrandQopInput!) {
  productBrands(qop: $qop) {
    items {
      productBrandID
      productBrandName
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductBrandListQuery(options: Omit<Urql.UseQueryArgs<ProductBrandListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductBrandListQuery, ProductBrandListQueryVariables>({ query: ProductBrandListDocument, ...options });
};
export const ProductBrandLoadDocument = gql`
    query ProductBrandLoad($productBrandID: UUID!) {
  productBrand(productBrandID: $productBrandID) {
    productBrandID
    productBrandName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductBrandLoadQuery(options: Omit<Urql.UseQueryArgs<ProductBrandLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductBrandLoadQuery, ProductBrandLoadQueryVariables>({ query: ProductBrandLoadDocument, ...options });
};
export const ProductBrandUpdateDocument = gql`
    mutation ProductBrandUpdate($input: ProductBrandUpdateInput!) {
  productBrandUpdate(input: $input) {
    productBrandID
    productBrandName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductBrandUpdateMutation() {
  return Urql.useMutation<ProductBrandUpdateMutation, ProductBrandUpdateMutationVariables>(ProductBrandUpdateDocument);
};
export const ProductCategoryAutocompleteDocument = gql`
    query ProductCategoryAutocomplete($qop: ProductCategoryQopInput!) {
  productCategories(qop: $qop) {
    items {
      productCategoryID
      productCategoryName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductCategoryAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ProductCategoryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductCategoryAutocompleteQuery, ProductCategoryAutocompleteQueryVariables>({ query: ProductCategoryAutocompleteDocument, ...options });
};
export const ProductCategoryCreateDocument = gql`
    mutation ProductCategoryCreate($input: ProductCategoryCreateInput!) {
  productCategoryCreate(input: $input) {
    productCategoryID
    productCategoryName
    productSubDepartmentID
    productSubDepartmentName
    productDepartmentID
    productDepartmentName
    productDivisionID
    productDivisionName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductCategoryCreateMutation() {
  return Urql.useMutation<ProductCategoryCreateMutation, ProductCategoryCreateMutationVariables>(ProductCategoryCreateDocument);
};
export const ProductCategoryDeleteDocument = gql`
    mutation ProductCategoryDelete($productCategoryID: UUID!) {
  productCategoryDelete(productCategoryID: $productCategoryID)
}
    `;

export function useProductCategoryDeleteMutation() {
  return Urql.useMutation<ProductCategoryDeleteMutation, ProductCategoryDeleteMutationVariables>(ProductCategoryDeleteDocument);
};
export const ProductCategoryListDocument = gql`
    query ProductCategoryList($qop: ProductCategoryQopInput!) {
  productCategories(qop: $qop) {
    items {
      productCategoryID
      productCategoryName
      productCategoryFullName
      productSubDepartmentID
      productSubDepartmentName
      productDepartmentID
      productDepartmentName
      productDivisionID
      productDivisionName
      uniqueKey
      isActive
      productSubDepartment {
        productSubDepartmentID
        productDepartmentID
        productSubDepartmentName
        uniqueKey
        isActive
      }
      productDepartment {
        productDepartmentID
        productDepartmentName
        productDivisionID
        uniqueKey
        isActive
      }
      productDivision {
        productDivisionID
        productDivisionName
        uniqueKey
        isActive
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductCategoryListQuery(options: Omit<Urql.UseQueryArgs<ProductCategoryListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductCategoryListQuery, ProductCategoryListQueryVariables>({ query: ProductCategoryListDocument, ...options });
};
export const ProductCategoryLoadDocument = gql`
    query ProductCategoryLoad($productCategoryID: UUID!) {
  productCategory(productCategoryID: $productCategoryID) {
    productCategoryID
    productCategoryName
    productSubDepartmentID
    productSubDepartmentName
    productDepartmentID
    productDepartmentName
    productDivisionID
    productDivisionName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductCategoryLoadQuery(options: Omit<Urql.UseQueryArgs<ProductCategoryLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductCategoryLoadQuery, ProductCategoryLoadQueryVariables>({ query: ProductCategoryLoadDocument, ...options });
};
export const ProductCategoryUpdateDocument = gql`
    mutation ProductCategoryUpdate($input: ProductCategoryUpdateInput!) {
  productCategoryUpdate(input: $input) {
    productCategoryID
    productCategoryName
    productSubDepartmentID
    productSubDepartmentName
    productDepartmentID
    productDepartmentName
    productDivisionID
    productDivisionName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductCategoryUpdateMutation() {
  return Urql.useMutation<ProductCategoryUpdateMutation, ProductCategoryUpdateMutationVariables>(ProductCategoryUpdateDocument);
};
export const ProductDepartmentAutocompleteDocument = gql`
    query ProductDepartmentAutocomplete($qop: ProductDepartmentQopInput!) {
  productDepartments(qop: $qop) {
    items {
      productDepartmentID
      productDepartmentName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductDepartmentAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ProductDepartmentAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductDepartmentAutocompleteQuery, ProductDepartmentAutocompleteQueryVariables>({ query: ProductDepartmentAutocompleteDocument, ...options });
};
export const ProductDepartmentCreateDocument = gql`
    mutation ProductDepartmentCreate($input: ProductDepartmentCreateInput!) {
  productDepartmentCreate(input: $input) {
    productDepartmentID
    productDepartmentName
    uniqueKey
    isActive
  }
}
    `;

export function useProductDepartmentCreateMutation() {
  return Urql.useMutation<ProductDepartmentCreateMutation, ProductDepartmentCreateMutationVariables>(ProductDepartmentCreateDocument);
};
export const ProductDepartmentDeleteDocument = gql`
    mutation ProductDepartmentDelete($productDepartmentID: UUID!) {
  productDepartmentDelete(productDepartmentID: $productDepartmentID)
}
    `;

export function useProductDepartmentDeleteMutation() {
  return Urql.useMutation<ProductDepartmentDeleteMutation, ProductDepartmentDeleteMutationVariables>(ProductDepartmentDeleteDocument);
};
export const ProductDepartmentListDocument = gql`
    query ProductDepartmentList($qop: ProductDepartmentQopInput!) {
  productDepartments(qop: $qop) {
    items {
      productDepartmentID
      productDepartmentName
      productDivision {
        productDivisionID
        productDivisionName
        uniqueKey
        isActive
      }
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductDepartmentListQuery(options: Omit<Urql.UseQueryArgs<ProductDepartmentListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductDepartmentListQuery, ProductDepartmentListQueryVariables>({ query: ProductDepartmentListDocument, ...options });
};
export const ProductDepartmentLoadDocument = gql`
    query ProductDepartmentLoad($productDepartmentID: UUID!) {
  productDepartment(productDepartmentID: $productDepartmentID) {
    productDepartmentID
    productDepartmentName
    productDivisionID
    productDivision {
      productDivisionName
      productDivisionID
      uniqueKey
      isActive
    }
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductDepartmentLoadQuery(options: Omit<Urql.UseQueryArgs<ProductDepartmentLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductDepartmentLoadQuery, ProductDepartmentLoadQueryVariables>({ query: ProductDepartmentLoadDocument, ...options });
};
export const ProductDepartmentUpdateDocument = gql`
    mutation ProductDepartmentUpdate($input: ProductDepartmentUpdateInput!) {
  productDepartmentUpdate(input: $input) {
    productDepartmentID
    productDepartmentName
    uniqueKey
    isActive
  }
}
    `;

export function useProductDepartmentUpdateMutation() {
  return Urql.useMutation<ProductDepartmentUpdateMutation, ProductDepartmentUpdateMutationVariables>(ProductDepartmentUpdateDocument);
};
export const ProductDivisionAutocompleteDocument = gql`
    query ProductDivisionAutocomplete($qop: ProductDivisionQopInput!) {
  productDivisions(qop: $qop) {
    items {
      productDivisionID
      productDivisionName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductDivisionAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ProductDivisionAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductDivisionAutocompleteQuery, ProductDivisionAutocompleteQueryVariables>({ query: ProductDivisionAutocompleteDocument, ...options });
};
export const ProductDivisionCreateDocument = gql`
    mutation ProductDivisionCreate($input: ProductDivisionCreateInput!) {
  productDivisionCreate(input: $input) {
    productDivisionID
    productDivisionName
    uniqueKey
    isActive
  }
}
    `;

export function useProductDivisionCreateMutation() {
  return Urql.useMutation<ProductDivisionCreateMutation, ProductDivisionCreateMutationVariables>(ProductDivisionCreateDocument);
};
export const ProductDivisionDeleteDocument = gql`
    mutation ProductDivisionDelete($productDivisionID: UUID!) {
  productDivisionDelete(productDivisionID: $productDivisionID)
}
    `;

export function useProductDivisionDeleteMutation() {
  return Urql.useMutation<ProductDivisionDeleteMutation, ProductDivisionDeleteMutationVariables>(ProductDivisionDeleteDocument);
};
export const ProductDivisionListDocument = gql`
    query ProductDivisionList($qop: ProductDivisionQopInput!) {
  productDivisions(qop: $qop) {
    items {
      productDivisionID
      productDivisionName
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductDivisionListQuery(options: Omit<Urql.UseQueryArgs<ProductDivisionListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductDivisionListQuery, ProductDivisionListQueryVariables>({ query: ProductDivisionListDocument, ...options });
};
export const ProductDivisionLoadDocument = gql`
    query ProductDivisionLoad($productDivisionID: UUID!) {
  productDivision(productDivisionID: $productDivisionID) {
    productDivisionID
    productDivisionName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductDivisionLoadQuery(options: Omit<Urql.UseQueryArgs<ProductDivisionLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductDivisionLoadQuery, ProductDivisionLoadQueryVariables>({ query: ProductDivisionLoadDocument, ...options });
};
export const ProductDivisionUpdateDocument = gql`
    mutation ProductDivisionUpdate($input: ProductDivisionUpdateInput!) {
  productDivisionUpdate(input: $input) {
    productDivisionID
    productDivisionName
    uniqueKey
    isActive
  }
}
    `;

export function useProductDivisionUpdateMutation() {
  return Urql.useMutation<ProductDivisionUpdateMutation, ProductDivisionUpdateMutationVariables>(ProductDivisionUpdateDocument);
};
export const ProductFileLoadDocument = gql`
    query ProductFileLoad($productFileID: UUID!) {
  productFile(productFileID: productFileID) {
    productFileID
    productID
    productFileType
    fileID
    imageFileSmallPathURL
    imageFileMediumPathURL
    imageFileLargePathURL
    uniqueKey
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductFileLoadQuery(options: Omit<Urql.UseQueryArgs<ProductFileLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductFileLoadQuery, ProductFileLoadQueryVariables>({ query: ProductFileLoadDocument, ...options });
};
export const ProductSourceAutocompleteDocument = gql`
    query ProductSourceAutocomplete($qop: ProductSourceQopInput) {
  productSources(qop: $qop) {
    items {
      productSourceID
      productSourceCode
      productSourceName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductSourceAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ProductSourceAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSourceAutocompleteQuery, ProductSourceAutocompleteQueryVariables>({ query: ProductSourceAutocompleteDocument, ...options });
};
export const ProductSourceLoadDocument = gql`
    query ProductSourceLoad($productSourceID: UUID!) {
  productSource(productSourceID: $productSourceID) {
    productSourceID
    productSourceCode
    productSourceName
  }
}
    `;

export function useProductSourceLoadQuery(options: Omit<Urql.UseQueryArgs<ProductSourceLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSourceLoadQuery, ProductSourceLoadQueryVariables>({ query: ProductSourceLoadDocument, ...options });
};
export const ProductSubCategoryAutocompleteDocument = gql`
    query ProductSubCategoryAutocomplete($qop: ProductSubCategoryQopInput!) {
  productSubCategories(qop: $qop) {
    items {
      productSubCategoryID
      productSubCategoryName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductSubCategoryAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ProductSubCategoryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSubCategoryAutocompleteQuery, ProductSubCategoryAutocompleteQueryVariables>({ query: ProductSubCategoryAutocompleteDocument, ...options });
};
export const ProductSubCategoryCreateDocument = gql`
    mutation ProductSubCategoryCreate($input: ProductSubCategoryCreateInput!) {
  productSubCategoryCreate(input: $input) {
    productSubCategoryID
    productSubCategoryName
    productCategoryID
    uniqueKey
    isActive
  }
}
    `;

export function useProductSubCategoryCreateMutation() {
  return Urql.useMutation<ProductSubCategoryCreateMutation, ProductSubCategoryCreateMutationVariables>(ProductSubCategoryCreateDocument);
};
export const ProductSubCategoryDeleteDocument = gql`
    mutation ProductSubCategoryDelete($productSubCategoryID: UUID!) {
  productSubCategoryDelete(productSubCategoryID: $productSubCategoryID)
}
    `;

export function useProductSubCategoryDeleteMutation() {
  return Urql.useMutation<ProductSubCategoryDeleteMutation, ProductSubCategoryDeleteMutationVariables>(ProductSubCategoryDeleteDocument);
};
export const ProductSubCategoryListDocument = gql`
    query ProductSubCategoryList($qop: ProductSubCategoryQopInput!) {
  productSubCategories(qop: $qop) {
    items {
      productSubCategoryID
      productSubCategoryName
      productCategoryID
      uniqueKey
      isActive
      productCategory {
        productCategoryID
        productCategoryName
        productCategoryFullName
        productSubDepartmentID
        productSubDepartmentName
        productDepartmentID
        productDepartmentName
        productDivisionID
        productDivisionName
        uniqueKey
        isActive
        entityAuditMetadata {
          createdByUserID
          createdByUserName
          updatedByUserID
          updatedByUserName
          deletedByUserID
          deletedByUserName
          createdAt
          updatedAt
          deletedAt
          version
        }
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductSubCategoryListQuery(options: Omit<Urql.UseQueryArgs<ProductSubCategoryListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSubCategoryListQuery, ProductSubCategoryListQueryVariables>({ query: ProductSubCategoryListDocument, ...options });
};
export const ProductSubCategoryLoadDocument = gql`
    query ProductSubCategoryLoad($productSubCategoryID: UUID!) {
  productSubCategory(productSubCategoryID: $productSubCategoryID) {
    productSubCategoryID
    productSubCategoryName
    productCategoryID
    productCategory {
      productCategoryID
      productCategoryName
      productCategoryFullName
    }
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductSubCategoryLoadQuery(options: Omit<Urql.UseQueryArgs<ProductSubCategoryLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSubCategoryLoadQuery, ProductSubCategoryLoadQueryVariables>({ query: ProductSubCategoryLoadDocument, ...options });
};
export const ProductSubCategoryUpdateDocument = gql`
    mutation ProductSubCategoryUpdate($input: ProductSubCategoryUpdateInput!) {
  productSubCategoryUpdate(input: $input) {
    productSubCategoryID
    productSubCategoryName
    productCategoryID
    uniqueKey
    isActive
  }
}
    `;

export function useProductSubCategoryUpdateMutation() {
  return Urql.useMutation<ProductSubCategoryUpdateMutation, ProductSubCategoryUpdateMutationVariables>(ProductSubCategoryUpdateDocument);
};
export const ProductSubDepartmentAutocompleteDocument = gql`
    query ProductSubDepartmentAutocomplete($qop: ProductSubDepartmentQopInput!) {
  productSubDepartments(qop: $qop) {
    items {
      productSubDepartmentID
      productSubDepartmentName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductSubDepartmentAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ProductSubDepartmentAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSubDepartmentAutocompleteQuery, ProductSubDepartmentAutocompleteQueryVariables>({ query: ProductSubDepartmentAutocompleteDocument, ...options });
};
export const ProductSubDepartmentCreateDocument = gql`
    mutation ProductSubDepartmentCreate($input: ProductSubDepartmentCreateInput!) {
  productSubDepartmentCreate(input: $input) {
    productSubDepartmentID
    productSubDepartmentName
    uniqueKey
    isActive
  }
}
    `;

export function useProductSubDepartmentCreateMutation() {
  return Urql.useMutation<ProductSubDepartmentCreateMutation, ProductSubDepartmentCreateMutationVariables>(ProductSubDepartmentCreateDocument);
};
export const ProductSubDepartmentDeleteDocument = gql`
    mutation ProductSubDepartmentDelete($productSubDepartmentID: UUID!) {
  productSubDepartmentDelete(productSubDepartmentID: $productSubDepartmentID)
}
    `;

export function useProductSubDepartmentDeleteMutation() {
  return Urql.useMutation<ProductSubDepartmentDeleteMutation, ProductSubDepartmentDeleteMutationVariables>(ProductSubDepartmentDeleteDocument);
};
export const ProductSubDepartmentListDocument = gql`
    query ProductSubDepartmentList($qop: ProductSubDepartmentQopInput!) {
  productSubDepartments(qop: $qop) {
    items {
      productSubDepartmentID
      productDepartmentID
      productSubDepartmentName
      uniqueKey
      isActive
      productDepartment {
        productDepartmentID
        productDepartmentName
        productDivisionID
        uniqueKey
        isActive
        entityAuditMetadata {
          createdByUserID
          createdByUserName
          updatedByUserID
          updatedByUserName
          deletedByUserID
          deletedByUserName
          createdAt
          updatedAt
          deletedAt
          version
        }
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductSubDepartmentListQuery(options: Omit<Urql.UseQueryArgs<ProductSubDepartmentListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSubDepartmentListQuery, ProductSubDepartmentListQueryVariables>({ query: ProductSubDepartmentListDocument, ...options });
};
export const ProductSubDepartmentLoadDocument = gql`
    query ProductSubDepartmentLoad($productSubDepartmentID: UUID!) {
  productSubDepartment(productSubDepartmentID: $productSubDepartmentID) {
    productSubDepartmentID
    productSubDepartmentName
    productDepartmentID
    productDepartment {
      productDepartmentName
    }
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductSubDepartmentLoadQuery(options: Omit<Urql.UseQueryArgs<ProductSubDepartmentLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSubDepartmentLoadQuery, ProductSubDepartmentLoadQueryVariables>({ query: ProductSubDepartmentLoadDocument, ...options });
};
export const ProductSubDepartmentUpdateDocument = gql`
    mutation ProductSubDepartmentUpdate($input: ProductSubDepartmentUpdateInput!) {
  productSubDepartmentUpdate(input: $input) {
    productSubDepartmentID
    productSubDepartmentName
    uniqueKey
    isActive
  }
}
    `;

export function useProductSubDepartmentUpdateMutation() {
  return Urql.useMutation<ProductSubDepartmentUpdateMutation, ProductSubDepartmentUpdateMutationVariables>(ProductSubDepartmentUpdateDocument);
};
export const ProductTagAutocompleteDocument = gql`
    query ProductTagAutocomplete($qop: ProductTagQopInput!) {
  productTags(qop: $qop) {
    items {
      productTagID
      productTagName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductTagAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ProductTagAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductTagAutocompleteQuery, ProductTagAutocompleteQueryVariables>({ query: ProductTagAutocompleteDocument, ...options });
};
export const ProductTagCreateDocument = gql`
    mutation ProductTagCreate($input: ProductTagCreateInput!) {
  productTagCreate(input: $input) {
    productTagID
    productTagName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductTagCreateMutation() {
  return Urql.useMutation<ProductTagCreateMutation, ProductTagCreateMutationVariables>(ProductTagCreateDocument);
};
export const ProductTagDeleteDocument = gql`
    mutation ProductTagDelete($productTagID: UUID!) {
  productTagDelete(productTagID: $productTagID)
}
    `;

export function useProductTagDeleteMutation() {
  return Urql.useMutation<ProductTagDeleteMutation, ProductTagDeleteMutationVariables>(ProductTagDeleteDocument);
};
export const ProductTagListDocument = gql`
    query ProductTagList($qop: ProductTagQopInput!) {
  productTags(qop: $qop) {
    items {
      productTagID
      productTagName
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductTagListQuery(options: Omit<Urql.UseQueryArgs<ProductTagListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductTagListQuery, ProductTagListQueryVariables>({ query: ProductTagListDocument, ...options });
};
export const ProductTagLoadDocument = gql`
    query ProductTagLoad($productTagID: UUID!) {
  productTag(productTagID: $productTagID) {
    productTagID
    productTagName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductTagLoadQuery(options: Omit<Urql.UseQueryArgs<ProductTagLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductTagLoadQuery, ProductTagLoadQueryVariables>({ query: ProductTagLoadDocument, ...options });
};
export const ProductTagUpdateDocument = gql`
    mutation ProductTagUpdate($input: ProductTagUpdateInput!) {
  productTagUpdate(input: $input) {
    productTagID
    productTagName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductTagUpdateMutation() {
  return Urql.useMutation<ProductTagUpdateMutation, ProductTagUpdateMutationVariables>(ProductTagUpdateDocument);
};
export const ConsignmentApproveProductLoadDocument = gql`
    query ConsignmentApproveProductLoad($productID: UUID!) {
  product(productID: $productID) {
    productID
    productCode
    productName
    productNameAlias
    productType
    barcode
    altBarcode1
    altBarcode2
    uomCategoryID
    baseUomID
    description
    mainImageFileMediumPathURL
    productCategory {
      productCategoryName
    }
    productBrandID
    productSourceID
    productCategoryID
    productSubCategoryID
    productAccountingCategoryID
    countryID
    addonGroupID
    hasAddon
    mainImageFileID
    isConsignment
    consignmentVendorID
    isSystem
    trackStock
    trackExpiredDate
    inventoryTrackingType
    isProduced
    weight
    volumeLength
    volumeHeight
    volumeWidth
    canBePurchased
    purchaseCost
    minimumOrder
    purchaseUomID
    purchaseTaxID
    canBeSold
    sellingPrice
    salesUomID
    salesTaxID
    salesScanType
    isActive
    consignmentVendor {
      vendorConsignmentProducts {
        branchID
        commissionFeePerc
        isActive
        entityAuditMetadata {
          version
        }
      }
    }
  }
}
    `;

export function useConsignmentApproveProductLoadQuery(options: Omit<Urql.UseQueryArgs<ConsignmentApproveProductLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ConsignmentApproveProductLoadQuery, ConsignmentApproveProductLoadQueryVariables>({ query: ConsignmentApproveProductLoadDocument, ...options });
};
export const ProductAutocompleteDocument = gql`
    query ProductAutocomplete($qop: ProductQopInput) {
  products(qop: $qop) {
    items {
      productID
      productCode
      productName
      barcode
      uomCategoryID
      sellingPrice
      purchaseCost
      productVendors {
        productVendorID
        productId
        vendorId
        purchasePrice
        minimumOrder
        canBeReturned
        uniqueKey
        isActive
        discountType
        discountPerc
        discountPercPlus
        discountAmount
        vendor {
          vendorID
          vendorCode
          vendorName
          vendorCategoryID
          email
          phoneNumber
          npwp
          npwpCompanyName
          taxpayerIDNumber
          addressLabel
          fullAddress
          countryID
          countryName
          provinceID
          provinceName
          cityID
          cityName
          subdistrictID
          subdistrictName
          postalCode
          longitude
          latitude
          taxable
          taxIncluded
          canBeReturned
          isConsignment
          consignmentCommisionFeePerc
          consignmentPeriodStartDate
          consignmentPeriodEndDate
          hasPortalAccess
          portalSuperadminFirstName
          portalSuperadminLastName
          portalSuperadminEmail
          portalAccountActivated
          uniqueKey
          isActive
        }
      }
      baseUom {
        uomID
        uomName
      }
      purchaseUom {
        uomID
        uomName
      }
      purchaseTax {
        taxID
        taxCode
        taxName
        taxType
        taxRate
        uniqueKey
        isActive
      }
      canBePurchased
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ProductAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductAutocompleteQuery, ProductAutocompleteQueryVariables>({ query: ProductAutocompleteDocument, ...options });
};
export const ProductBarcodeConflictsDocument = gql`
    query ProductBarcodeConflicts($barcodes: [String!]!, $excludeProductID: UUID) {
  productBarcodeConflicts(
    barcodes: $barcodes
    excludeProductID: $excludeProductID
  ) {
    barcode
    productID
    productCode
    productName
    isActive
    isConsignment
  }
}
    `;

export function useProductBarcodeConflictsQuery(options: Omit<Urql.UseQueryArgs<ProductBarcodeConflictsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductBarcodeConflictsQuery, ProductBarcodeConflictsQueryVariables>({ query: ProductBarcodeConflictsDocument, ...options });
};
export const ProductConsignmentImportDocument = gql`
    mutation ProductConsignmentImport($input: ProductImportInput!) {
  productConsignmentImport(input: $input) {
    backgroundJobID
  }
}
    `;

export function useProductConsignmentImportMutation() {
  return Urql.useMutation<ProductConsignmentImportMutation, ProductConsignmentImportMutationVariables>(ProductConsignmentImportDocument);
};
export const ProductConsignmentImportValidateDocument = gql`
    mutation ProductConsignmentImportValidate($input: ProductImportInput!) {
  productConsignmentImportValidate(input: $input) {
    ...ProductImportValidateResultFields
  }
}
    ${ProductImportValidateResultFieldsFragmentDoc}`;

export function useProductConsignmentImportValidateMutation() {
  return Urql.useMutation<ProductConsignmentImportValidateMutation, ProductConsignmentImportValidateMutationVariables>(ProductConsignmentImportValidateDocument);
};
export const ProductCreateDocument = gql`
    mutation ProductCreate($input: ProductCreateInput!) {
  productCreate(input: $input) {
    productID
    productCode
    productName
    productNameAlias
    productType
    barcode
    altBarcode1
    altBarcode2
    uomCategoryID
    baseUomID
    description
    productBrandID
    productSourceID
    productCategoryID
    productSubCategoryID
    pricelistProducts {
      pricelistProductID
      pricelistPeriodID
      pricelistID
      productID
      sellingPrice
      salesChannelPrice
      uniqueKey
      pricelistPeriod {
        pricelistPeriodID
        pricelistPeriodName
        pricelistID
        effectiveStartDate
        effectiveEndDate
        effectiveStartHour
        effectiveEndHour
        effectiveStartMinute
        effectiveEndMinute
        useTime
        priority
        isActive
        uniqueKey
      }
    }
    mainImageFileID
    mainImageFileSmallPathURL
    mainImageFileMediumPathURL
    mainImageFileLargePathURL
    isConsignment
    consignmentVendorID
    trackExpiredDate
    isProduced
    weight
    volumeLength
    volumeHeight
    volumeWidth
    canBePurchased
    purchaseCost
    minimumOrder
    purchaseUomID
    purchaseTaxID
    canBeSold
    salesUomID
    salesTaxID
    salesScanType
    uniqueKey
    isActive
  }
}
    `;

export function useProductCreateMutation() {
  return Urql.useMutation<ProductCreateMutation, ProductCreateMutationVariables>(ProductCreateDocument);
};
export const ProductDeleteDocument = gql`
    mutation ProductDelete($productID: UUID!) {
  productDelete(productID: $productID)
}
    `;

export function useProductDeleteMutation() {
  return Urql.useMutation<ProductDeleteMutation, ProductDeleteMutationVariables>(ProductDeleteDocument);
};
export const ProductListDocument = gql`
    query ProductList($qop: ProductQopInput) {
  products(qop: $qop) {
    items {
      productID
      productCode
      productName
      productNameAlias
      productType
      barcode
      altBarcode1
      altBarcode2
      uomCategoryID
      baseUomID
      description
      productBrandID
      productSourceID
      productCategoryID
      productSubCategoryID
      mainImageFileID
      mainImageFileSmallPathURL
      mainImageFileMediumPathURL
      mainImageFileLargePathURL
      isConsignment
      consignmentVendorID
      uniqueKey
      trackExpiredDate
      isProduced
      weight
      volumeLength
      volumeHeight
      volumeWidth
      canBePurchased
      purchaseCost
      productBarcodeMaps {
        productBarcodeMapID
      }
      minimumOrder
      purchaseUomID
      purchaseUom {
        uomID
        uomName
      }
      purchaseTaxID
      canBeSold
      salesUomID
      salesTaxID
      salesScanType
      uniqueKey
      isActive
      consignmentVendor {
        vendorName
      }
      baseUom {
        uomID
        uomCategoryID
        uomName
        relationType
        convertionRate
        convertionDecimal
        isMain
        uniqueKey
        uniqueKey2
        isActive
      }
      productBrand {
        productBrandID
        productBrandName
        uniqueKey
        isActive
      }
      productSource {
        productSourceID
        productSourceCode
        productSourceName
        uniqueKey
        isActive
      }
      pricelistProducts {
        pricelistProductID
        sellingPrice
        pricelistPeriod {
          pricelistPeriodName
          pricelist {
            pricelistName
          }
        }
      }
      productCategory {
        productCategoryID
        productCategoryName
        productCategoryFullName
        productSubDepartmentID
        productSubDepartmentName
        productDepartmentID
        productDepartmentName
        productDivisionID
        productDivisionName
        uniqueKey
        isActive
      }
      productSubCategory {
        productSubCategoryID
        productSubCategoryName
        productCategoryID
        uniqueKey
        isActive
      }
      purchaseTax {
        taxID
        taxCode
        taxName
        taxRate
        uniqueKey
        isActive
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductListQuery(options?: Omit<Urql.UseQueryArgs<ProductListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductListQuery, ProductListQueryVariables>({ query: ProductListDocument, ...options });
};
export const ProductLoadDocument = gql`
    query ProductLoad($productID: UUID!) {
  product(productID: $productID) {
    productID
    productCode
    productName
    productNameAlias
    productType
    barcode
    altBarcode1
    altBarcode2
    uomCategoryID
    baseUomID
    description
    productBrandID
    productSourceID
    productCategoryID
    productSubCategoryID
    mainImageFileID
    mainImageFileSmallPathURL
    mainImageFileMediumPathURL
    mainImageFileLargePathURL
    isConsignment
    consignmentVendorID
    trackExpiredDate
    isProduced
    weight
    volumeLength
    volumeHeight
    volumeWidth
    canBePurchased
    purchaseCost
    minimumOrder
    purchaseUomID
    purchaseTaxID
    canBeSold
    sellingPrice
    salesUomID
    salesTaxID
    salesScanType
    countryID
    country {
      countryName
    }
    productAccountingCategoryID
    productAccountingCategory {
      productAccountingCategoryID
      productAccountingCategoryName
    }
    productAccountingCategoryErpRefID
    productAccountingCategoryErpRefName
    hasAddon
    addonGroupID
    addonGroup {
      productAddonGroupID
      name
    }
    consignmentVendor {
      vendorName
      vendorConsignmentBranch {
        branchID
        branchCode
        branchName
      }
      vendorConsignmentProducts {
        vendorConsignmentProductID
        sellingPrice
        commissionFeePerc
        productCommissionFeePerc
        branchID
        productID
        isActive
        entityAuditMetadata {
          version
        }
      }
    }
    pricelistProducts {
      pricelistProductID
      sellingPrice
      pricelistPeriod {
        pricelistPeriodID
        pricelistPeriodName
        pricelist {
          pricelistId
          pricelistName
        }
      }
    }
    uniqueKey
    isActive
    uomCategory {
      uomCategoryName
    }
    baseUom {
      uomID
      uomCategoryID
      uomCategory {
        uomCategoryID
        uomCategoryName
      }
      uomName
      relationType
      convertionRate
      convertionRateMultiplier
      convertionDecimal
      isMain
      uniqueKey
      uniqueKey2
      isActive
    }
    productBrand {
      productBrandID
      productBrandName
      uniqueKey
      isActive
    }
    productSource {
      productSourceID
      productSourceCode
      productSourceName
      uniqueKey
      isActive
    }
    productVendors {
      productVendorID
      productId
      vendorId
      purchasePrice
      minimumOrder
      canBeReturned
      uniqueKey
      isActive
      discountType
      discountPerc
      discountPercPlus
      discountAmount
    }
    productCategory {
      productCategoryID
      productCategoryName
      productCategoryFullName
      productSubDepartmentID
      productSubDepartmentName
      productDepartmentID
      productDepartmentName
      productDivisionID
      productDivisionName
      uniqueKey
      isActive
    }
    productSubCategory {
      productSubCategoryID
      productSubCategoryName
      productCategoryID
      uniqueKey
      isActive
    }
    productFiles {
      productFileID
      productID
      productFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    productAIImages {
      productAIImageID
      productID
      aiImageType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
    purchaseUom {
      uomID
      uomCategoryID
      uomName
      relationType
      convertionRate
      convertionRateMultiplier
      convertionDecimal
      isMain
      uniqueKey
      uniqueKey2
      isActive
    }
    purchaseTax {
      taxID
      taxCode
      taxName
      taxRate
      uniqueKey
      isActive
    }
    salesUom {
      uomID
      uomCategoryID
      uomName
      relationType
      convertionRate
      convertionRateMultiplier
      convertionDecimal
      isMain
      uniqueKey
      uniqueKey2
      isActive
    }
    salesTax {
      taxID
      taxCode
      taxName
      taxRate
      uniqueKey
      isActive
    }
    productBarcodeMaps {
      productBarcodeMapID
      productID
      barcode
      uniqueKey
      isActive
    }
    productAvailabilityTemplateItems {
      productAvailabilityTemplateItemID
      productAvailabilityTemplateID
      productID
      uniqueKey
      isActive
      salesChannelIDs
      productAvailabilityTemplate {
        productAvailabilityTemplateID
        productAvailabilityTemplateName
        isActive
        uniqueKey
      }
    }
    productBundleComponents {
      productBundleComponentID
      productID
      componentProductID
      qty
      uomCategoryID
      uomID
      uniqueKey
      isActive
      componentProduct {
        productID
        productCode
        productName
        productNameAlias
        productType
        barcode
        altBarcode1
        altBarcode2
        uomCategoryID
        baseUomID
        description
        productBrandID
        productSourceID
        productCategoryID
        productSubCategoryID
        mainImageFileID
        mainImageFileSmallPathURL
        mainImageFileMediumPathURL
        mainImageFileLargePathURL
        isConsignment
        consignmentVendorID
        trackExpiredDate
        isProduced
        weight
        volumeLength
        volumeHeight
        volumeWidth
        canBePurchased
        purchaseCost
        minimumOrder
        purchaseUomID
        purchaseTaxID
        canBeSold
        salesUomID
        salesTaxID
        salesScanType
        uniqueKey
        isActive
      }
      uom {
        uomID
        uomCategoryID
        uomName
        relationType
        convertionRate
        convertionRateMultiplier
        convertionDecimal
        isMain
        uniqueKey
        uniqueKey2
        isActive
      }
    }
    productTagProducts {
      productTagProductID
      productTagID
      productID
      productTag {
        productTagName
      }
      uniqueKey
    }
    productVendors {
      productVendorID
      productId
      vendorId
      purchasePrice
      minimumOrder
      canBeReturned
      uniqueKey
      isActive
      vendor {
        vendorID
        vendorCode
        vendorName
        vendorCategoryID
        email
        phoneNumber
        npwp
        npwpCompanyName
        taxpayerIDNumber
        addressLabel
        fullAddress
        countryID
        countryName
        provinceID
        provinceName
        cityID
        cityName
        subdistrictID
        subdistrictName
        postalCode
        longitude
        latitude
        taxable
        taxIncluded
        canBeReturned
        isConsignment
        consignmentCommisionFeePerc
        consignmentPeriodStartDate
        consignmentPeriodEndDate
        hasPortalAccess
        portalSuperadminFirstName
        portalSuperadminLastName
        portalSuperadminEmail
        portalAccountActivated
        uniqueKey
        isActive
      }
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductLoadQuery(options: Omit<Urql.UseQueryArgs<ProductLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductLoadQuery, ProductLoadQueryVariables>({ query: ProductLoadDocument, ...options });
};
export const ProductNonConsignmentImportDocument = gql`
    mutation ProductNonConsignmentImport($input: ProductImportInput!) {
  productNonConsignmentImport(input: $input) {
    backgroundJobID
  }
}
    `;

export function useProductNonConsignmentImportMutation() {
  return Urql.useMutation<ProductNonConsignmentImportMutation, ProductNonConsignmentImportMutationVariables>(ProductNonConsignmentImportDocument);
};
export const ProductNonConsignmentImportValidateDocument = gql`
    mutation ProductNonConsignmentImportValidate($input: ProductImportInput!) {
  productNonConsignmentImportValidate(input: $input) {
    ...ProductImportValidateResultFields
  }
}
    ${ProductImportValidateResultFieldsFragmentDoc}`;

export function useProductNonConsignmentImportValidateMutation() {
  return Urql.useMutation<ProductNonConsignmentImportValidateMutation, ProductNonConsignmentImportValidateMutationVariables>(ProductNonConsignmentImportValidateDocument);
};
export const ProductSalesChannelPlacementsDocument = gql`
    query ProductSalesChannelPlacements($qop: SalesChannelCategoryGroupProductQopInput) {
  salesChannelCategoryGroupProducts(qop: $qop) {
    items {
      salesChannelCategoryGroupProductID
      salesChannelCategoryGroupID
      salesChannelCategoryID
      productID
      isActive
      priceType
      customPrice
      imageType
      externalImageURL
      salesChannelCategoryGroup {
        salesChannelCategoryGroupID
        salesChannelCategoryGroupName
      }
      salesChannelCategory {
        salesChannelCategoryID
        salesChannelCategoryName
      }
    }
  }
}
    `;

export function useProductSalesChannelPlacementsQuery(options?: Omit<Urql.UseQueryArgs<ProductSalesChannelPlacementsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductSalesChannelPlacementsQuery, ProductSalesChannelPlacementsQueryVariables>({ query: ProductSalesChannelPlacementsDocument, ...options });
};
export const ProductUpdateDocument = gql`
    mutation ProductUpdate($input: ProductUpdateInput!) {
  productUpdate(input: $input) {
    productID
    productCode
    productName
    productNameAlias
    productType
    barcode
    altBarcode1
    altBarcode2
    uomCategoryID
    baseUomID
    description
    productBrandID
    productSourceID
    productCategoryID
    productSubCategoryID
    mainImageFileID
    mainImageFileSmallPathURL
    mainImageFileMediumPathURL
    mainImageFileLargePathURL
    isConsignment
    consignmentVendorID
    trackExpiredDate
    isProduced
    weight
    volumeLength
    volumeHeight
    volumeWidth
    canBePurchased
    purchaseCost
    minimumOrder
    purchaseUomID
    purchaseTaxID
    canBeSold
    salesUomID
    salesTaxID
    salesScanType
    uniqueKey
    isActive
  }
}
    `;

export function useProductUpdateMutation() {
  return Urql.useMutation<ProductUpdateMutation, ProductUpdateMutationVariables>(ProductUpdateDocument);
};
export const ProductVendorCreateDocument = gql`
    mutation ProductVendorCreate($input: ProductVendorCreateInput!) {
  productVendorCreate(input: $input) {
    productVendorID
    productId
    vendorId
    purchasePrice
    minimumOrder
    canBeReturned
    uniqueKey
    isActive
  }
}
    `;

export function useProductVendorCreateMutation() {
  return Urql.useMutation<ProductVendorCreateMutation, ProductVendorCreateMutationVariables>(ProductVendorCreateDocument);
};
export const ProductVendorDeleteDocument = gql`
    mutation ProductVendorDelete($productVendorID: UUID!) {
  productVendorDelete(productVendorID: $productVendorID)
}
    `;

export function useProductVendorDeleteMutation() {
  return Urql.useMutation<ProductVendorDeleteMutation, ProductVendorDeleteMutationVariables>(ProductVendorDeleteDocument);
};
export const ProductVendorListDocument = gql`
    query ProductVendorList($qop: ProductVendorQopInput) {
  productVendors(qop: $qop) {
    items {
      productVendorID
      productId
      vendorId
      purchasePrice
      minimumOrder
      canBeReturned
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useProductVendorListQuery(options?: Omit<Urql.UseQueryArgs<ProductVendorListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductVendorListQuery, ProductVendorListQueryVariables>({ query: ProductVendorListDocument, ...options });
};
export const ProductVendorLoadDocument = gql`
    query ProductVendorLoad($productVendorID: UUID!) {
  productVendor(productVendorID: $productVendorID) {
    productVendorID
    productId
    vendorId
    purchasePrice
    minimumOrder
    canBeReturned
    uniqueKey
    isActive
    discountType
    discountPerc
    discountPercPlus
    discountAmount
    vendor {
      vendorID
      vendorCode
      vendorName
      vendorCategoryID
      email
      phoneNumber
      npwp
      npwpCompanyName
      taxpayerIDNumber
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      taxable
      taxIncluded
      canBeReturned
      isConsignment
      consignmentCommisionFeePerc
      consignmentPeriodStartDate
      consignmentPeriodEndDate
      hasPortalAccess
      portalSuperadminFirstName
      portalSuperadminLastName
      portalSuperadminEmail
      portalAccountActivated
      uniqueKey
      isActive
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductVendorLoadQuery(options: Omit<Urql.UseQueryArgs<ProductVendorLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductVendorLoadQuery, ProductVendorLoadQueryVariables>({ query: ProductVendorLoadDocument, ...options });
};
export const ProductVendorUpdateDocument = gql`
    mutation ProductVendorUpdate($input: ProductVendorUpdateInput!) {
  productVendorUpdate(input: $input) {
    productVendorID
    productId
    vendorId
    purchasePrice
    minimumOrder
    canBeReturned
    uniqueKey
    isActive
  }
}
    `;

export function useProductVendorUpdateMutation() {
  return Urql.useMutation<ProductVendorUpdateMutation, ProductVendorUpdateMutationVariables>(ProductVendorUpdateDocument);
};
export const ProductionOrderAutocompleteDocument = gql`
    query ProductionOrderAutocomplete($qop: ProductionOrderQopInput) {
  productionOrders(qop: $qop) {
    items {
      productionOrderID
      productionOrderNumber
      productionOrderDatetime
      branchID
      gmt
      warehouseID
      warehouseLocationID
      productID
      productCode
      productName
      qty
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
      billOfMaterialID
      bomQty
      bomUomID
      bomUomConvertionRate
      bomUomConversionDecimal
      bomBaseUomQty
      status
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useProductionOrderAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ProductionOrderAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductionOrderAutocompleteQuery, ProductionOrderAutocompleteQueryVariables>({ query: ProductionOrderAutocompleteDocument, ...options });
};
export const ProductionOrderCancelDocument = gql`
    mutation ProductionOrderCancel($productionOrderID: UUID!) {
  productionOrderCancel(productionOrderID: $productionOrderID) {
    productionOrderID
  }
}
    `;

export function useProductionOrderCancelMutation() {
  return Urql.useMutation<ProductionOrderCancelMutation, ProductionOrderCancelMutationVariables>(ProductionOrderCancelDocument);
};
export const ProductionOrderConfirmDocument = gql`
    mutation ProductionOrderConfirm($productionOrderID: UUID!) {
  productionOrderConfirm(productionOrderID: $productionOrderID) {
    productionOrderID
  }
}
    `;

export function useProductionOrderConfirmMutation() {
  return Urql.useMutation<ProductionOrderConfirmMutation, ProductionOrderConfirmMutationVariables>(ProductionOrderConfirmDocument);
};
export const ProductionOrderCreateDocument = gql`
    mutation ProductionOrderCreate($input: ProductionOrderCreateInput!) {
  productionOrderCreate(input: $input) {
    productionOrderID
    productionOrderNumber
    productionOrderDatetime
    branchID
    gmt
    warehouseID
    warehouseLocationID
    productID
    productCode
    productName
    qty
    uomCategoryID
    uomID
    uomName
    uomDecimal
    uomConvertionRate
    uomConversionDecimal
    baseUomQty
    billOfMaterialID
    bomQty
    bomUomID
    bomUomConvertionRate
    bomUomConversionDecimal
    bomBaseUomQty
    status
  }
}
    `;

export function useProductionOrderCreateMutation() {
  return Urql.useMutation<ProductionOrderCreateMutation, ProductionOrderCreateMutationVariables>(ProductionOrderCreateDocument);
};
export const ProductionOrderListDocument = gql`
    query ProductionOrderList($qop: ProductionOrderQopInput) {
  productionOrders(qop: $qop) {
    items {
      productionOrderID
      productionOrderNumber
      productionOrderDatetime
      branchID
      gmt
      warehouse {
        warehouseCode
        warehouseName
      }
      product {
        productCode
        productName
      }
      warehouseID
      warehouseLocationID
      productID
      productCode
      productName
      qty
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
      billOfMaterialID
      bomQty
      bomUomID
      bomUomConvertionRate
      bomUomConversionDecimal
      bomBaseUomQty
      waste
      wastePerc
      status
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useProductionOrderListQuery(options?: Omit<Urql.UseQueryArgs<ProductionOrderListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductionOrderListQuery, ProductionOrderListQueryVariables>({ query: ProductionOrderListDocument, ...options });
};
export const ProductionOrderLoadDocument = gql`
    query ProductionOrderLoad($productionOrderID: UUID!) {
  productionOrder(productionOrderID: $productionOrderID) {
    productionOrderID
    productionOrderNumber
    productionOrderDatetime
    branchID
    gmt
    warehouseID
    warehouseLocationID
    productID
    productCode
    productName
    qty
    uomCategoryID
    uomID
    uomName
    uomDecimal
    uomConvertionRate
    uomConversionDecimal
    baseUomQty
    billOfMaterialID
    bomQty
    bomUomID
    bomUomConvertionRate
    bomUomConversionDecimal
    bomBaseUomQty
    waste
    wastePerc
    status
    expiryDate
    lotNo
    warehouse {
      warehouseID
      warehouseCode
      warehouseName
      branchID
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
    warehouseLocation {
      warehouseLocationID
      warehouseLocationName
      warehouseLocationType
      warehouseID
      branchID
      parentWarehouseLocationID
      uniqueKey
      isActive
    }
    product {
      productID
      productCode
      productName
      productNameAlias
      productType
      barcode
      altBarcode1
      altBarcode2
      uomCategoryID
      baseUomID
      description
      productBrandID
      productSourceID
      productCategoryID
      productSubCategoryID
      mainImageFileID
      mainImageFileSmallPathURL
      mainImageFileMediumPathURL
      mainImageFileLargePathURL
      isConsignment
      consignmentVendorID
      trackExpiredDate
      isProduced
      weight
      volumeLength
      volumeHeight
      volumeWidth
      canBePurchased
      purchaseCost
      minimumOrder
      purchaseUomID
      purchaseTaxID
      canBeSold
      sellingPrice
      salesUomID
      salesTaxID
      salesScanType
      uniqueKey
      isActive
    }
    billOfMaterial {
      billOfMaterialID
      name
      productID
      uomCategoryID
      uomID
      qty
      description
      isActive
    }
    components {
      productionOrderComponentID
      productionOrderID
      productID
      productCode
      productName
      qty
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
      bomQty
      bomUomID
      bomUomConvertionRate
      bomUomConversionDecimal
      bomBaseUomQty
      bomBaseQtyDiff
      isManual
      product {
        productID
        productCode
        productName
        productNameAlias
        productType
        barcode
        altBarcode1
        altBarcode2
        uomCategoryID
        baseUomID
        description
        productBrandID
        productSourceID
        productCategoryID
        productSubCategoryID
        mainImageFileID
        mainImageFileSmallPathURL
        mainImageFileMediumPathURL
        mainImageFileLargePathURL
        isConsignment
        consignmentVendorID
        trackExpiredDate
        isProduced
        weight
        volumeLength
        volumeHeight
        volumeWidth
        canBePurchased
        purchaseCost
        minimumOrder
        purchaseUomID
        purchaseTaxID
        canBeSold
        sellingPrice
        salesUomID
        salesTaxID
        salesScanType
        uniqueKey
        isActive
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useProductionOrderLoadQuery(options: Omit<Urql.UseQueryArgs<ProductionOrderLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductionOrderLoadQuery, ProductionOrderLoadQueryVariables>({ query: ProductionOrderLoadDocument, ...options });
};
export const ProductionOrderUpdateDocument = gql`
    mutation ProductionOrderUpdate($input: ProductionOrderUpdateInput!) {
  productionOrderUpdate(input: $input) {
    productionOrderID
    productionOrderNumber
    productionOrderDatetime
    branchID
    gmt
    warehouseID
    warehouseLocationID
    productID
    productCode
    productName
    qty
    uomCategoryID
    uomID
    uomName
    uomDecimal
    uomConvertionRate
    uomConversionDecimal
    baseUomQty
    billOfMaterialID
    bomQty
    bomUomID
    bomUomConvertionRate
    bomUomConversionDecimal
    bomBaseUomQty
    status
  }
}
    `;

export function useProductionOrderUpdateMutation() {
  return Urql.useMutation<ProductionOrderUpdateMutation, ProductionOrderUpdateMutationVariables>(ProductionOrderUpdateDocument);
};
export const ProfileChangePasswordDocument = gql`
    mutation ProfileChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input)
}
    `;

export function useProfileChangePasswordMutation() {
  return Urql.useMutation<ProfileChangePasswordMutation, ProfileChangePasswordMutationVariables>(ProfileChangePasswordDocument);
};
export const ProfileMyPinDocument = gql`
    query ProfileMyPin {
  userProfile {
    userID
    pinPlainText
  }
}
    `;

export function useProfileMyPinQuery(options?: Omit<Urql.UseQueryArgs<ProfileMyPinQueryVariables>, 'query'>) {
  return Urql.useQuery<ProfileMyPinQuery, ProfileMyPinQueryVariables>({ query: ProfileMyPinDocument, ...options });
};
export const ProfileRegeneratePinSelfDocument = gql`
    mutation ProfileRegeneratePinSelf {
  userRegeneratePINSelf
}
    `;

export function useProfileRegeneratePinSelfMutation() {
  return Urql.useMutation<ProfileRegeneratePinSelfMutation, ProfileRegeneratePinSelfMutationVariables>(ProfileRegeneratePinSelfDocument);
};
export const PromoCat1Document = gql`
    query PromoCat1($promoComponentID: UUID!) {
  promoComponentCat1(promoComponentID: $promoComponentID) {
    promoComponent {
      promoComponentID
      promoID
      description
      promoTypeID
      config
    }
    config {
      discountPercent
      products {
        productID
        productCode
        productName
      }
      enableQuota
      productQuotas {
        productID
        maxQty
      }
    }
  }
}
    `;

export function usePromoCat1Query(options: Omit<Urql.UseQueryArgs<PromoCat1QueryVariables>, 'query'>) {
  return Urql.useQuery<PromoCat1Query, PromoCat1QueryVariables>({ query: PromoCat1Document, ...options });
};
export const PromoCat2Document = gql`
    query PromoCat2($promoComponentID: UUID!) {
  promoComponentCat2(promoComponentID: $promoComponentID) {
    promoComponent {
      promoComponentID
      promoID
      description
      promoTypeID
      config
    }
    config {
      minQty
      buyProducts {
        productID
        productCode
        productName
      }
      getFreeProducts {
        productID
        productCode
        productName
      }
      freeQty
      isMultiple
      enableQuota
      quota {
        maxQty
      }
    }
  }
}
    `;

export function usePromoCat2Query(options: Omit<Urql.UseQueryArgs<PromoCat2QueryVariables>, 'query'>) {
  return Urql.useQuery<PromoCat2Query, PromoCat2QueryVariables>({ query: PromoCat2Document, ...options });
};
export const PromoCat3Document = gql`
    query PromoCat3($promoComponentID: UUID!) {
  promoComponentCat3(promoComponentID: $promoComponentID) {
    promoComponent {
      promoComponentID
      promoID
      description
      promoTypeID
      config
    }
    config {
      discountAmount
      products {
        productID
        productCode
        productName
      }
      enableQuota
      productQuotas {
        productID
        maxQty
      }
    }
  }
}
    `;

export function usePromoCat3Query(options: Omit<Urql.UseQueryArgs<PromoCat3QueryVariables>, 'query'>) {
  return Urql.useQuery<PromoCat3Query, PromoCat3QueryVariables>({ query: PromoCat3Document, ...options });
};
export const PromoCat4Document = gql`
    query PromoCat4($promoComponentID: UUID!) {
  promoComponentCat4(promoComponentID: $promoComponentID) {
    promoComponent {
      promoComponentID
      promoID
      description
      promoTypeID
      config
    }
    config {
      discountPercent
    }
  }
}
    `;

export function usePromoCat4Query(options: Omit<Urql.UseQueryArgs<PromoCat4QueryVariables>, 'query'>) {
  return Urql.useQuery<PromoCat4Query, PromoCat4QueryVariables>({ query: PromoCat4Document, ...options });
};
export const PromoCat5Document = gql`
    query PromoCat5($promoComponentID: UUID!) {
  promoComponentCat5(promoComponentID: $promoComponentID) {
    promoComponent {
      promoComponentID
      promoID
      description
      promoTypeID
      config
    }
    config {
      discountAmount
    }
  }
}
    `;

export function usePromoCat5Query(options: Omit<Urql.UseQueryArgs<PromoCat5QueryVariables>, 'query'>) {
  return Urql.useQuery<PromoCat5Query, PromoCat5QueryVariables>({ query: PromoCat5Document, ...options });
};
export const PromoCat6Document = gql`
    query PromoCat6($promoComponentID: UUID!) {
  promoComponentCat6(promoComponentID: $promoComponentID) {
    promoComponent {
      promoComponentID
      promoID
      description
      promoTypeID
      config
    }
    config {
      discountPercent
      categories {
        productCategoryID
        productCategoryName
      }
    }
  }
}
    `;

export function usePromoCat6Query(options: Omit<Urql.UseQueryArgs<PromoCat6QueryVariables>, 'query'>) {
  return Urql.useQuery<PromoCat6Query, PromoCat6QueryVariables>({ query: PromoCat6Document, ...options });
};
export const PromoComponentListDocument = gql`
    query PromoComponentList($qop: PromoComponentQopInput!) {
  promoComponents(qop: $qop) {
    items {
      promoComponentID
      promoID
      description
      promoTypeID
      promoType {
        name
        description
        promoTypeID
      }
      expenseItemID
      expenseItem {
        expenseItemID
        expenseItemName
        journalAccountCode
      }
      config
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePromoComponentListQuery(options: Omit<Urql.UseQueryArgs<PromoComponentListQueryVariables>, 'query'>) {
  return Urql.useQuery<PromoComponentListQuery, PromoComponentListQueryVariables>({ query: PromoComponentListDocument, ...options });
};
export const PromoQuotaListDocument = gql`
    query PromoQuotaList($qop: PromoQuotaQOPInput!) {
  promoQuotas(input: $qop) {
    items {
      promoQuotaID
      promoID
      promoComponentID
      quotaType
      maxQty
      usedQty
      remainingQty
      isActive
      uniqueKey
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePromoQuotaListQuery(options: Omit<Urql.UseQueryArgs<PromoQuotaListQueryVariables>, 'query'>) {
  return Urql.useQuery<PromoQuotaListQuery, PromoQuotaListQueryVariables>({ query: PromoQuotaListDocument, ...options });
};
export const PromoTypeAutocompleteDocument = gql`
    query PromoTypeAutocomplete($qop: PromoTypeQopInput!) {
  promoTypes(qop: $qop) {
    items {
      promoTypeID
      name
      description
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePromoTypeAutocompleteQuery(options: Omit<Urql.UseQueryArgs<PromoTypeAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PromoTypeAutocompleteQuery, PromoTypeAutocompleteQueryVariables>({ query: PromoTypeAutocompleteDocument, ...options });
};
export const PromoTypeListDocument = gql`
    query PromoTypeList($qop: PromoTypeQopInput!) {
  promoTypes(qop: $qop) {
    items {
      promoTypeID
      name
      description
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePromoTypeListQuery(options: Omit<Urql.UseQueryArgs<PromoTypeListQueryVariables>, 'query'>) {
  return Urql.useQuery<PromoTypeListQuery, PromoTypeListQueryVariables>({ query: PromoTypeListDocument, ...options });
};
export const PromoTypeLoadDocument = gql`
    query PromoTypeLoad($promoTypeID: UUID!) {
  promoType(promoTypeID: $promoTypeID) {
    promoTypeID
    name
    description
    uniqueKey
    isActive
  }
}
    `;

export function usePromoTypeLoadQuery(options: Omit<Urql.UseQueryArgs<PromoTypeLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PromoTypeLoadQuery, PromoTypeLoadQueryVariables>({ query: PromoTypeLoadDocument, ...options });
};
export const PromoAutocompleteDocument = gql`
    query PromoAutocomplete($qop: PromoQopInput) {
  promos(qop: $qop) {
    items {
      promoID
      promoName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function usePromoAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<PromoAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PromoAutocompleteQuery, PromoAutocompleteQueryVariables>({ query: PromoAutocompleteDocument, ...options });
};
export const PromoComponentImportValidateDocument = gql`
    mutation PromoComponentImportValidate($input: PromoComponentImportValidateInput!) {
  promoComponentImportValidate(input: $input) {
    missingProductCodes
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        componentName
        standardKey
        label
        reason
        value
      }
    }
    components {
      promoComponentID
      expenseItemID
      description
      promoTypeID
      discountPercent
      discountAmount
      minQty
      freeQty
      isMultiple
      enableQuota
      quotaMaxQty
      products {
        productID
        productCode
        productName
        barcode
        quotaMaxQty
      }
      getFreeProducts {
        productID
        productCode
        productName
        barcode
        quotaMaxQty
      }
    }
  }
}
    `;

export function usePromoComponentImportValidateMutation() {
  return Urql.useMutation<PromoComponentImportValidateMutation, PromoComponentImportValidateMutationVariables>(PromoComponentImportValidateDocument);
};
export const PromoCreateDocument = gql`
    mutation PromoCreate($input: PromoBulkCreateInput!) {
  promoCreate(input: $input) {
    promoID
    promoName
    description
    effectiveStartDate
    effectiveEndDate
    priority
    isActive
  }
}
    `;

export function usePromoCreateMutation() {
  return Urql.useMutation<PromoCreateMutation, PromoCreateMutationVariables>(PromoCreateDocument);
};
export const PromoDeleteDocument = gql`
    mutation PromoDelete($promoID: UUID!) {
  promoDelete(promoID: $promoID)
}
    `;

export function usePromoDeleteMutation() {
  return Urql.useMutation<PromoDeleteMutation, PromoDeleteMutationVariables>(PromoDeleteDocument);
};
export const PromoListDocument = gql`
    query PromoList($qop: PromoQopInput) {
  promos(qop: $qop) {
    items {
      promoID
      promoName
      description
      effectiveStartDate
      effectiveEndDate
      priority
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePromoListQuery(options?: Omit<Urql.UseQueryArgs<PromoListQueryVariables>, 'query'>) {
  return Urql.useQuery<PromoListQuery, PromoListQueryVariables>({ query: PromoListDocument, ...options });
};
export const PromoLoadDocument = gql`
    query PromoLoad($promoID: UUID!) {
  promo(promoID: $promoID) {
    promoID
    promoName
    description
    effectiveStartDate
    effectiveEndDate
    priority
    isActive
    expenseAccountCode
    expenseAccountErpRefID
    expenseAccountErpRefName
    isAllBranches
    branches {
      branchID
      branchName
      branch {
        branchID
        branchCode
        branchName
      }
    }
    promoRules {
      availability {
        days
        allDay
        useTime
        startTime
        endTime
      }
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePromoLoadQuery(options: Omit<Urql.UseQueryArgs<PromoLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PromoLoadQuery, PromoLoadQueryVariables>({ query: PromoLoadDocument, ...options });
};
export const PromoUpdateDocument = gql`
    mutation PromoUpdate($input: PromoBulkUpdateInput!) {
  promoUpdate(input: $input) {
    promoID
    promoName
    description
    effectiveStartDate
    effectiveEndDate
    priority
    isActive
  }
}
    `;

export function usePromoUpdateMutation() {
  return Urql.useMutation<PromoUpdateMutation, PromoUpdateMutationVariables>(PromoUpdateDocument);
};
export const PurchaseAreaAutocompleteDocument = gql`
    query PurchaseAreaAutocomplete($qop: PurchaseAreaQopInput!) {
  purchaseAreas(qop: $qop) {
    items {
      purchaseAreaID
      purchaseAreaName
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePurchaseAreaAutocompleteQuery(options: Omit<Urql.UseQueryArgs<PurchaseAreaAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseAreaAutocompleteQuery, PurchaseAreaAutocompleteQueryVariables>({ query: PurchaseAreaAutocompleteDocument, ...options });
};
export const PurchaseAreaCreateDocument = gql`
    mutation PurchaseAreaCreate($input: PurchaseAreaCreateInput!) {
  purchaseAreaCreate(input: $input) {
    purchaseAreaName
    purchaseAreaID
    isActive
  }
}
    `;

export function usePurchaseAreaCreateMutation() {
  return Urql.useMutation<PurchaseAreaCreateMutation, PurchaseAreaCreateMutationVariables>(PurchaseAreaCreateDocument);
};
export const PurchaseAreaDeleteDocument = gql`
    mutation PurchaseAreaDelete($purchaseAreaID: UUID!) {
  purchaseAreaDelete(purchaseAreaID: $purchaseAreaID)
}
    `;

export function usePurchaseAreaDeleteMutation() {
  return Urql.useMutation<PurchaseAreaDeleteMutation, PurchaseAreaDeleteMutationVariables>(PurchaseAreaDeleteDocument);
};
export const PurchaseAreaListDocument = gql`
    query PurchaseAreaList($qop: PurchaseAreaQopInput!) {
  purchaseAreas(qop: $qop) {
    items {
      purchaseAreaID
      purchaseAreaName
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePurchaseAreaListQuery(options: Omit<Urql.UseQueryArgs<PurchaseAreaListQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseAreaListQuery, PurchaseAreaListQueryVariables>({ query: PurchaseAreaListDocument, ...options });
};
export const PurchaseAreaLoadDocument = gql`
    query PurchaseAreaLoad($purchaseAreaID: UUID!) {
  purchaseArea(purchaseAreaID: $purchaseAreaID) {
    purchaseAreaID
    purchaseAreaName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePurchaseAreaLoadQuery(options: Omit<Urql.UseQueryArgs<PurchaseAreaLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseAreaLoadQuery, PurchaseAreaLoadQueryVariables>({ query: PurchaseAreaLoadDocument, ...options });
};
export const PurchaseAreaUpdateDocument = gql`
    mutation PurchaseAreaUpdate($input: PurchaseAreaUpdateInput!) {
  purchaseAreaUpdate(input: $input) {
    purchaseAreaID
    purchaseAreaName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePurchaseAreaUpdateMutation() {
  return Urql.useMutation<PurchaseAreaUpdateMutation, PurchaseAreaUpdateMutationVariables>(PurchaseAreaUpdateDocument);
};
export const PurchaseOrderCancelDocument = gql`
    mutation PurchaseOrderCancel($purchaseOrderID: UUID!) {
  purchaseOrderCancel(purchaseOrderID: $purchaseOrderID)
}
    `;

export function usePurchaseOrderCancelMutation() {
  return Urql.useMutation<PurchaseOrderCancelMutation, PurchaseOrderCancelMutationVariables>(PurchaseOrderCancelDocument);
};
export const PurchaseOrderConfirmDocument = gql`
    mutation PurchaseOrderConfirm($purchaseOrderID: UUID!) {
  purchaseOrderConfirm(purchaseOrderID: $purchaseOrderID)
}
    `;

export function usePurchaseOrderConfirmMutation() {
  return Urql.useMutation<PurchaseOrderConfirmMutation, PurchaseOrderConfirmMutationVariables>(PurchaseOrderConfirmDocument);
};
export const PurchaseOrderCreateDocument = gql`
    mutation PurchaseOrderCreate($input: PurchaseOrderCreateInput!) {
  purchaseOrderCreate(input: $input) {
    purchaseOrderID
    purchaseOrderNumber
    purchaseOrderDatetime
    purchaseOrderDatetimeUtc
    deliveryDate
    deadlineDate
    branchID
    gmt
    vendorID
    vendorRefNo
    destinationWarehouseID
    purchaseAreaID
    taxIncluded
    totalItemQty
    totalItemQtyReceived
    subtotal
    discountType
    discountPerc
    discountPercPlus
    discountAmount
    subtotalAfterDiscount
    taxAmount
    taxItems
    landedCost
    landedCostPerUnit
    adjustmentAmount
    total
    taxableAmount
    noteInternal
    noteForVendor
    status
  }
}
    `;

export function usePurchaseOrderCreateMutation() {
  return Urql.useMutation<PurchaseOrderCreateMutation, PurchaseOrderCreateMutationVariables>(PurchaseOrderCreateDocument);
};
export const PurchaseOrderSendEmailDocument = gql`
    mutation PurchaseOrderSendEmail($purchaseOrderID: UUID!) {
  purchaseOrderSendEmail(purchaseOrderID: $purchaseOrderID)
}
    `;

export function usePurchaseOrderSendEmailMutation() {
  return Urql.useMutation<PurchaseOrderSendEmailMutation, PurchaseOrderSendEmailMutationVariables>(PurchaseOrderSendEmailDocument);
};
export const PurchaseOrderForceCloseDocument = gql`
    mutation PurchaseOrderForceClose($input: PurchaseOrderForceCloseInput!) {
  purchaseOrderForceClose(input: $input)
}
    `;

export function usePurchaseOrderForceCloseMutation() {
  return Urql.useMutation<PurchaseOrderForceCloseMutation, PurchaseOrderForceCloseMutationVariables>(PurchaseOrderForceCloseDocument);
};
export const PurchaseOrderImportDocument = gql`
    mutation PurchaseOrderImport($input: PurchaseOrderImportInput!) {
  purchaseOrderImport(input: $input)
}
    `;

export function usePurchaseOrderImportMutation() {
  return Urql.useMutation<PurchaseOrderImportMutation, PurchaseOrderImportMutationVariables>(PurchaseOrderImportDocument);
};
export const PurchaseOrderImportValidateCodesDocument = gql`
    mutation PurchaseOrderImportValidateCodes($input: PurchaseOrderImportValidateCodesInput!) {
  purchaseOrderImportValidateCodes(input: $input) {
    missingVendorCodes
    missingBranchCodes
    missingWarehouseCodes
    missingProductCodes
    missingTaxCodes
    missingPurchaseAreaNames
    consignmentVendorCodes
    consignmentProductCodes
    duplicateProductCodes
    missingProductUoms {
      rowNumber
      productCode
      uomName
    }
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        standardKey
        label
        reason
        value
      }
    }
  }
}
    `;

export function usePurchaseOrderImportValidateCodesMutation() {
  return Urql.useMutation<PurchaseOrderImportValidateCodesMutation, PurchaseOrderImportValidateCodesMutationVariables>(PurchaseOrderImportValidateCodesDocument);
};
export const PurchaseOrderItemsDocument = gql`
    query PurchaseOrderItems($qop: PurchaseOrderItemQopInput) {
  purchaseOrderItems(qop: $qop) {
    items {
      purchaseOrderItemID
      purchaseOrderID
      sequenceNo
      productID
      productCode
      productName
      description
      qty
      qtyReceived
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
      unitPrice
      discountType
      discountPerc
      discountPercPlus
      discountAmount
      additionalDiscountPerc
      additionalDiscountAmount
      additionalLandedCost
      total
      taxableAmount
      taxAmount
      taxItems
      baseUomUnitCost
      taxes {
        purchaseOrderItemTaxID
        purchaseOrderItemID
        purchaseOrderID
        taxID
        taxCode
        taxRate
        taxableAmount
        taxAmount
      }
      product {
        productID
        productName
        productNameAlias
        productType
        altBarcode1
        altBarcode2
        uomCategoryID
        baseUomID
        barcode
        description
        productBrandID
        productSourceID
        productCategoryID
        productSubCategoryID
        addonGroupID
        hasAddon
        mainImageFileID
        mainImageFileSmallPathURL
        mainImageFileMediumPathURL
        mainImageFileLargePathURL
        productAccountingCategoryID
        isConsignment
        consignmentVendorID
        isSystem
        trackStock
        trackExpiredDate
        inventoryTrackingType
        isProduced
        weight
        volumeLength
        volumeHeight
        volumeWidth
        canBePurchased
        purchaseCost
        minimumOrder
        purchaseUomID
        purchaseTaxID
        canBeSold
        sellingPrice
        salesUomID
        salesTaxID
        salesScanType
        uniqueKey
        isActive
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function usePurchaseOrderItemsQuery(options?: Omit<Urql.UseQueryArgs<PurchaseOrderItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseOrderItemsQuery, PurchaseOrderItemsQueryVariables>({ query: PurchaseOrderItemsDocument, ...options });
};
export const PurchaseOrderListDocument = gql`
    query PurchaseOrderList($qop: PurchaseOrderQopInput) {
  purchaseOrders(qop: $qop) {
    items {
      purchaseOrderID
      purchaseOrderNumber
      purchaseOrderDatetime
      purchaseOrderDatetimeUtc
      deliveryDate
      deadlineDate
      branchID
      gmt
      vendorID
      vendorCode
      vendorName
      vendorEmail
      vendorPhoneNumber
      vendorNpwp
      vendorNpwpCompanyName
      vendorRefNo
      destinationWarehouseID
      destinationWarehouseCode
      destinationWarehouseName
      purchaseAreaID
      purchaseAreaName
      taxIncluded
      totalItemQty
      totalItemQtyReceived
      subtotal
      discountType
      discountPerc
      discountPercPlus
      discountAmount
      subtotalAfterDiscount
      taxAmount
      taxItems
      landedCost
      landedCostPerUnit
      adjustmentAmount
      total
      taxableAmount
      noteInternal
      noteForVendor
      status
      isCannotRevise
      isAlreadyForceClosePO
      taxes {
        purchaseOrderTaxID
        purchaseOrderID
        taxID
        taxCode
        taxRate
        taxableAmount
        taxAmount
      }
      entityAuditMetadata {
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePurchaseOrderListQuery(options?: Omit<Urql.UseQueryArgs<PurchaseOrderListQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseOrderListQuery, PurchaseOrderListQueryVariables>({ query: PurchaseOrderListDocument, ...options });
};
export const PurchaseOrderLoadDocument = gql`
    query PurchaseOrderLoad($purchaseOrderID: UUID!) {
  purchaseOrder(purchaseOrderID: $purchaseOrderID) {
    purchaseOrderID
    purchaseOrderNumber
    purchaseOrderDatetime
    purchaseOrderDatetimeUtc
    deliveryDate
    deadlineDate
    branchID
    gmt
    vendorID
    vendorCode
    vendorName
    vendorEmail
    vendorPhoneNumber
    vendorNpwp
    vendorCode
    vendorNpwpCompanyName
    vendorRefNo
    destinationWarehouseID
    destinationWarehouseCode
    destinationWarehouseName
    vendorAddress {
      fullAddress
    }
    destinationWarehouseAddress {
      fullAddress
    }
    purchaseAreaID
    purchaseAreaName
    taxIncluded
    totalItemQty
    totalItemQtyReceived
    itemUomSummaries {
      uomID
      uomName
      qty
      uomDecimal
    }
    subtotal
    discountType
    discountPerc
    discountPercPlus
    discountAmount
    subtotalAfterDiscount
    taxAmount
    taxItems
    landedCost
    landedCostPerUnit
    adjustmentAmount
    total
    taxableAmount
    noteInternal
    noteForVendor
    status
    isCannotRevise
    isAlreadyForceClosePO
    receivingStatus
    cancelledType
    cancelledDatetime
    cancelledByUserName
    taxes {
      purchaseOrderTaxID
      purchaseOrderID
      taxID
      taxCode
      taxRate
      taxableAmount
      taxAmount
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function usePurchaseOrderLoadQuery(options: Omit<Urql.UseQueryArgs<PurchaseOrderLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PurchaseOrderLoadQuery, PurchaseOrderLoadQueryVariables>({ query: PurchaseOrderLoadDocument, ...options });
};
export const PurchaseOrderReviseDocument = gql`
    mutation PurchaseOrderRevise($input: PurchaseOrderReviseInput!) {
  purchaseOrderRevise(input: $input)
}
    `;

export function usePurchaseOrderReviseMutation() {
  return Urql.useMutation<PurchaseOrderReviseMutation, PurchaseOrderReviseMutationVariables>(PurchaseOrderReviseDocument);
};
export const PurchaseOrderUpdateDocument = gql`
    mutation PurchaseOrderUpdate($input: PurchaseOrderUpdateInput!) {
  purchaseOrderUpdate(input: $input) {
    purchaseOrderID
    purchaseOrderNumber
    purchaseOrderDatetime
    purchaseOrderDatetimeUtc
    deliveryDate
    deadlineDate
    branchID
    gmt
    vendorID
    vendorRefNo
    destinationWarehouseID
    purchaseAreaID
    taxIncluded
    totalItemQty
    totalItemQtyReceived
    subtotal
    discountType
    discountPerc
    discountPercPlus
    discountAmount
    subtotalAfterDiscount
    taxAmount
    taxItems
    landedCost
    landedCostPerUnit
    adjustmentAmount
    total
    taxableAmount
    noteInternal
    noteForVendor
    status
    taxes {
      purchaseOrderTaxID
      purchaseOrderID
      taxID
      taxCode
      taxRate
      taxableAmount
      taxAmount
    }
  }
}
    `;

export function usePurchaseOrderUpdateMutation() {
  return Urql.useMutation<PurchaseOrderUpdateMutation, PurchaseOrderUpdateMutationVariables>(PurchaseOrderUpdateDocument);
};
export const PutawayTaskAssignDocument = gql`
    mutation PutawayTaskAssign($input: AssignTaskInput!) {
  putawayTaskAssign(input: $input) {
    putawayTaskID
    assignedToUserID
  }
}
    `;

export function usePutawayTaskAssignMutation() {
  return Urql.useMutation<PutawayTaskAssignMutation, PutawayTaskAssignMutationVariables>(PutawayTaskAssignDocument);
};
export const PutawayTaskCancelDocument = gql`
    mutation PutawayTaskCancel($input: CancelTaskInput!) {
  putawayTaskCancel(input: $input)
}
    `;

export function usePutawayTaskCancelMutation() {
  return Urql.useMutation<PutawayTaskCancelMutation, PutawayTaskCancelMutationVariables>(PutawayTaskCancelDocument);
};
export const PutawayTaskExecutionsDocument = gql`
    query PutawayTaskExecutions($qop: PutawayTaskExecutionQopInput) {
  putawayTaskExecutions(qop: $qop) {
    items {
      putawayTaskExecutionID
      warehouseLocation {
        warehouseLocationName
      }
      qty
      uomName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePutawayTaskExecutionsQuery(options?: Omit<Urql.UseQueryArgs<PutawayTaskExecutionsQueryVariables>, 'query'>) {
  return Urql.useQuery<PutawayTaskExecutionsQuery, PutawayTaskExecutionsQueryVariables>({ query: PutawayTaskExecutionsDocument, ...options });
};
export const PutawayTaskItemsLoadDocument = gql`
    query PutawayTaskItemsLoad($qop: PutawayTaskItemQopInput) {
  putawayTaskItems(qop: $qop) {
    items {
      putawayTaskItemID
      productCode
      productName
      product {
        barcode
      }
      qtyAssigned
      qtyExecuted
      qtyOutstanding
      uomName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePutawayTaskItemsLoadQuery(options?: Omit<Urql.UseQueryArgs<PutawayTaskItemsLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PutawayTaskItemsLoadQuery, PutawayTaskItemsLoadQueryVariables>({ query: PutawayTaskItemsLoadDocument, ...options });
};
export const PutawayTaskListDocument = gql`
    query PutawayTaskList($qop: PutawayTaskQopInput) {
  putawayTasks(qop: $qop) {
    items {
      putawayTaskID
      putawayTaskNumber
      putawayTaskDatetime
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      branchID
      warehouseID
      fromWarehouseLocationID
      fromWarehouseLocationCode
      fromWarehouseLocationName
      assignedToUserID
      assignedToUserName
      totalItems
      totalQtyAssigned
      totalQtyExecuted
      progressPercent
      taskStartAt
      taskDoneAt
      taskDurationMinute
      status
      noteInternal
      warehouse {
        warehouseName
      }
      assignedToUserName
      taskStartAt
      taskDoneAt
      taskDurationMinute
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function usePutawayTaskListQuery(options?: Omit<Urql.UseQueryArgs<PutawayTaskListQueryVariables>, 'query'>) {
  return Urql.useQuery<PutawayTaskListQuery, PutawayTaskListQueryVariables>({ query: PutawayTaskListDocument, ...options });
};
export const PutawayTaskLoadDocument = gql`
    query PutawayTaskLoad($putawayTaskID: UUID!) {
  putawayTask(putawayTaskID: $putawayTaskID) {
    putawayTaskID
    putawayTaskNumber
    putawayTaskDatetime
    sourceDocumentType
    sourceDocumentID
    sourceDocumentNumber
    branchID
    warehouseID
    fromWarehouseLocationID
    fromWarehouseLocationCode
    fromWarehouseLocationName
    assignedToUserID
    assignedToUserName
    totalItems
    totalQtyAssigned
    totalQtyExecuted
    progressPercent
    taskStartAt
    taskDoneAt
    taskDurationMinute
    status
    noteInternal
    warehouse {
      warehouseCode
      warehouseName
    }
    assignedToUserName
    taskStartAt
    taskDoneAt
    taskDurationMinute
    items {
      putawayTaskItemID
      putawayTaskID
      sourceDocumentDetailID
      productID
      productCode
      productName
      uomID
      uomName
      qtyAssigned
      qtyExecuted
      qtyOutstanding
    }
  }
}
    `;

export function usePutawayTaskLoadQuery(options: Omit<Urql.UseQueryArgs<PutawayTaskLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<PutawayTaskLoadQuery, PutawayTaskLoadQueryVariables>({ query: PutawayTaskLoadDocument, ...options });
};
export const ReasonAutocompleteDocument = gql`
    query ReasonAutocomplete($qop: ReasonQopInput!) {
  reasons(qop: $qop) {
    items {
      reasonID
      reasonCode
      reasonName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useReasonAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ReasonAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ReasonAutocompleteQuery, ReasonAutocompleteQueryVariables>({ query: ReasonAutocompleteDocument, ...options });
};
export const BankReconciliationCancelDocument = gql`
    mutation BankReconciliationCancel($input: BankReconciliationCancelInput!) {
  bankReconciliationCancel(input: $input) {
    bankReconciliationID
    status
  }
}
    `;

export function useBankReconciliationCancelMutation() {
  return Urql.useMutation<BankReconciliationCancelMutation, BankReconciliationCancelMutationVariables>(BankReconciliationCancelDocument);
};
export const BankReconciliationCreateDocument = gql`
    mutation BankReconciliationCreate($input: BankReconciliationCreateInput!) {
  bankReconciliationCreate(input: $input) {
    bankReconciliationID
    bankReconciliationNumber
    status
  }
}
    `;

export function useBankReconciliationCreateMutation() {
  return Urql.useMutation<BankReconciliationCreateMutation, BankReconciliationCreateMutationVariables>(BankReconciliationCreateDocument);
};
export const BankReconciliationExportDocument = gql`
    mutation BankReconciliationExport($input: BankReconciliationExportInput!) {
  bankReconciliationExport(input: $input) {
    downloadUrl
    fileName
  }
}
    `;

export function useBankReconciliationExportMutation() {
  return Urql.useMutation<BankReconciliationExportMutation, BankReconciliationExportMutationVariables>(BankReconciliationExportDocument);
};
export const BankReconciliationFilesDocument = gql`
    query BankReconciliationFiles($bankReconciliationID: UUID!) {
  bankReconciliationFiles(bankReconciliationID: $bankReconciliationID) {
    bankReconciliationFileID
    bankReconciliationID
    bankID
    statementFileID
    statementFileName
    fileType
    settlementDateFrom
    settlementDateTo
    rowCount
    midFailureCount
    status
    errorMessage
    entityAuditMetadata {
      createdAt
      version
    }
  }
}
    `;

export function useBankReconciliationFilesQuery(options: Omit<Urql.UseQueryArgs<BankReconciliationFilesQueryVariables>, 'query'>) {
  return Urql.useQuery<BankReconciliationFilesQuery, BankReconciliationFilesQueryVariables>({ query: BankReconciliationFilesDocument, ...options });
};
export const BankReconciliationFinalizeDocument = gql`
    mutation BankReconciliationFinalize($input: BankReconciliationFinalizeInput!) {
  bankReconciliationFinalize(input: $input) {
    bankReconciliationID
    bankReconciliationNumber
    status
  }
}
    `;

export function useBankReconciliationFinalizeMutation() {
  return Urql.useMutation<BankReconciliationFinalizeMutation, BankReconciliationFinalizeMutationVariables>(BankReconciliationFinalizeDocument);
};
export const BankReconciliationItemListDocument = gql`
    query BankReconciliationItemList($qop: BankReconciliationItemQopInput!) {
  bankReconciliationItems(qop: $qop) {
    items {
      bankReconciliationItemID
      bankReconciliationID
      bankAccountID
      externalTransactionID
      transactionDate
      settlementDate
      transactionTime
      amount
      netAmount
      mdrAmount
      referenceNumber
      approvalCode
      merchantID
      merchantName
      bankBranchID
      bankBranchName
      terminalID
      cardNumber
      issuer
      rawDescription
      salesInvoicePaymentID
      salesInvoiceID
      salesInvoiceNumber
      paymentDate
      paymentDatetime
      paymentAmount
      paymentBranchID
      paymentBranchName
      paymentCashierUserName
      paymentMethodID
      paymentMethodName
      paymentBankReferenceNumber
      paymentCardNumber
      paymentApprovalCode
      bankExist
      salesPaymentExist
      isReconciliation
      reconciliationStatus
      matchedSalesInvoicePaymentID
      matchedAt
      note
      resolution
      resolutionReason
      resolvedAt
      resolvedByUserName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useBankReconciliationItemListQuery(options: Omit<Urql.UseQueryArgs<BankReconciliationItemListQueryVariables>, 'query'>) {
  return Urql.useQuery<BankReconciliationItemListQuery, BankReconciliationItemListQueryVariables>({ query: BankReconciliationItemListDocument, ...options });
};
export const BankReconciliationItemManualMatchDocument = gql`
    mutation BankReconciliationItemManualMatch($input: BankReconciliationItemManualMatchInput!) {
  bankReconciliationItemManualMatch(input: $input) {
    bankReconciliationID
    totalMatched
    totalPartialMatched
    totalUnmatched
  }
}
    `;

export function useBankReconciliationItemManualMatchMutation() {
  return Urql.useMutation<BankReconciliationItemManualMatchMutation, BankReconciliationItemManualMatchMutationVariables>(BankReconciliationItemManualMatchDocument);
};
export const BankReconciliationItemMergeDocument = gql`
    mutation BankReconciliationItemMerge($input: BankReconciliationItemMergeInput!) {
  bankReconciliationItemMerge(input: $input) {
    bankReconciliationID
    status
    totalMatched
    totalPartialMatched
    totalUnmatched
  }
}
    `;

export function useBankReconciliationItemMergeMutation() {
  return Urql.useMutation<BankReconciliationItemMergeMutation, BankReconciliationItemMergeMutationVariables>(BankReconciliationItemMergeDocument);
};
export const BankReconciliationItemResolveDocument = gql`
    mutation BankReconciliationItemResolve($input: BankReconciliationItemResolveInput!) {
  bankReconciliationItemResolve(input: $input) {
    bankReconciliationID
    status
    totalMatched
    totalPartialMatched
    totalUnmatched
  }
}
    `;

export function useBankReconciliationItemResolveMutation() {
  return Urql.useMutation<BankReconciliationItemResolveMutation, BankReconciliationItemResolveMutationVariables>(BankReconciliationItemResolveDocument);
};
export const BankReconciliationListDocument = gql`
    query BankReconciliationList($qop: BankReconciliationQopInput) {
  bankReconciliations(qop: $qop) {
    items {
      bankReconciliationID
      bankReconciliationNumber
      bankID
      bankName
      reconDate
      reconDatetime
      settlementDateFrom
      settlementDateTo
      totalItems
      totalMatched
      totalPartialMatched
      totalUnmatched
      totalAmount
      status
      statementFileID
      statementFileName
      entityAuditMetadata {
        createdAt
        createdByUserName
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useBankReconciliationListQuery(options?: Omit<Urql.UseQueryArgs<BankReconciliationListQueryVariables>, 'query'>) {
  return Urql.useQuery<BankReconciliationListQuery, BankReconciliationListQueryVariables>({ query: BankReconciliationListDocument, ...options });
};
export const BankReconciliationLoadDocument = gql`
    query BankReconciliationLoad($bankReconciliationID: UUID!) {
  bankReconciliation(bankReconciliationID: $bankReconciliationID) {
    bankReconciliationID
    bankReconciliationNumber
    bankID
    bankName
    reconDate
    reconDatetime
    reconDatetimeUtc
    gmt
    settlementDateFrom
    settlementDateTo
    branches {
      branchID
      branch {
        branchName
        branchCode
      }
    }
    totalItems
    totalMatched
    totalPartialMatched
    totalUnmatched
    totalAmount
    status
    doneDatetime
    doneByUserName
    cancelledDatetime
    cancelledByUserName
    cancellationReason
    noteInternal
    entityAuditMetadata {
      createdAt
      createdByUserName
      updatedAt
      version
    }
  }
}
    `;

export function useBankReconciliationLoadQuery(options: Omit<Urql.UseQueryArgs<BankReconciliationLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<BankReconciliationLoadQuery, BankReconciliationLoadQueryVariables>({ query: BankReconciliationLoadDocument, ...options });
};
export const BankReconciliationPoolFilesDocument = gql`
    query BankReconciliationPoolFiles($bankID: UUID) {
  bankReconciliationPoolFiles(bankID: $bankID) {
    bankReconciliationFileID
    bankReconciliationID
    bankID
    statementFileID
    statementFileName
    fileType
    settlementDateFrom
    settlementDateTo
    rowCount
    midFailureCount
    status
    errorMessage
    entityAuditMetadata {
      createdAt
      version
    }
  }
}
    `;

export function useBankReconciliationPoolFilesQuery(options?: Omit<Urql.UseQueryArgs<BankReconciliationPoolFilesQueryVariables>, 'query'>) {
  return Urql.useQuery<BankReconciliationPoolFilesQuery, BankReconciliationPoolFilesQueryVariables>({ query: BankReconciliationPoolFilesDocument, ...options });
};
export const BankReconciliationPoolRowsDocument = gql`
    query BankReconciliationPoolRows($qop: BankDataRowQopInput) {
  bankReconciliationPoolRows(qop: $qop) {
    items {
      bankDataRowID
      uploadFilename
      transactionDate
      transactionTime
      amount
      merchantID
      approvalCode
      referenceNumber
      terminalID
      cardNumber
      branchID
      branchName
      bankID
      bankName
      isMatched
      bankReconciliationID
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useBankReconciliationPoolRowsQuery(options?: Omit<Urql.UseQueryArgs<BankReconciliationPoolRowsQueryVariables>, 'query'>) {
  return Urql.useQuery<BankReconciliationPoolRowsQuery, BankReconciliationPoolRowsQueryVariables>({ query: BankReconciliationPoolRowsDocument, ...options });
};
export const BankReconciliationProcessDocument = gql`
    mutation BankReconciliationProcess($input: BankReconciliationProcessInput!) {
  bankReconciliationProcess(input: $input) {
    bankReconciliationID
    status
  }
}
    `;

export function useBankReconciliationProcessMutation() {
  return Urql.useMutation<BankReconciliationProcessMutation, BankReconciliationProcessMutationVariables>(BankReconciliationProcessDocument);
};
export const BankReconciliationRemoveFileDocument = gql`
    mutation BankReconciliationRemoveFile($input: BankReconciliationRemoveFileInput!) {
  bankReconciliationRemoveFile(input: $input) {
    bankReconciliationID
    status
  }
}
    `;

export function useBankReconciliationRemoveFileMutation() {
  return Urql.useMutation<BankReconciliationRemoveFileMutation, BankReconciliationRemoveFileMutationVariables>(BankReconciliationRemoveFileDocument);
};
export const BankReconciliationRetryPoolFileDocument = gql`
    mutation BankReconciliationRetryPoolFile($bankReconciliationFileID: UUID!) {
  bankReconciliationRetryPoolFile(
    bankReconciliationFileID: $bankReconciliationFileID
  ) {
    bankReconciliationFileID
    status
    errorMessage
  }
}
    `;

export function useBankReconciliationRetryPoolFileMutation() {
  return Urql.useMutation<BankReconciliationRetryPoolFileMutation, BankReconciliationRetryPoolFileMutationVariables>(BankReconciliationRetryPoolFileDocument);
};
export const BankReconciliationUploadFileDocument = gql`
    mutation BankReconciliationUploadFile($input: BankReconciliationUploadFileInput!) {
  bankReconciliationUploadFile(input: $input) {
    bankReconciliationID
    bankReconciliationNumber
    status
  }
}
    `;

export function useBankReconciliationUploadFileMutation() {
  return Urql.useMutation<BankReconciliationUploadFileMutation, BankReconciliationUploadFileMutationVariables>(BankReconciliationUploadFileDocument);
};
export const BankReconciliationUploadPoolFileDocument = gql`
    mutation BankReconciliationUploadPoolFile($input: BankReconciliationUploadPoolFileInput!) {
  bankReconciliationUploadPoolFile(input: $input) {
    bankReconciliationFileID
    bankID
    statementFileName
    fileType
    status
  }
}
    `;

export function useBankReconciliationUploadPoolFileMutation() {
  return Urql.useMutation<BankReconciliationUploadPoolFileMutation, BankReconciliationUploadPoolFileMutationVariables>(BankReconciliationUploadPoolFileDocument);
};
export const SalesInvoicePaymentListDocument = gql`
    query SalesInvoicePaymentList($qop: SalesInvoicePaymentQopInput) {
  salesInvoicePayments(qop: $qop) {
    items {
      salesInvoicePaymentID
      salesInvoiceID
      paymentMethodTypeCode
      paymentMethodTypeName
      bankAccountID
      bankAccountNumber
      bankID
      bankName
      bankReferenceNumber
      authCode
      cardNumber
      paymentAmount
      branchName
      isReconciliation
      reconciliationStatus
      bankReconciliationItemID
      reconciledAt
      entityAuditMetadata {
        createdAt
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useSalesInvoicePaymentListQuery(options?: Omit<Urql.UseQueryArgs<SalesInvoicePaymentListQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesInvoicePaymentListQuery, SalesInvoicePaymentListQueryVariables>({ query: SalesInvoicePaymentListDocument, ...options });
};
export const ReplenishmentTemplateCategoryAutocompleteDocument = gql`
    query ReplenishmentTemplateCategoryAutocomplete($qop: ReplenishmentTemplateCategoryQopInput!) {
  replenishmentTemplateCategories(qop: $qop) {
    items {
      replenishmentTemplateCategoryID
      replenishmentTemplateCategoryName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useReplenishmentTemplateCategoryAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ReplenishmentTemplateCategoryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentTemplateCategoryAutocompleteQuery, ReplenishmentTemplateCategoryAutocompleteQueryVariables>({ query: ReplenishmentTemplateCategoryAutocompleteDocument, ...options });
};
export const ReplenishmentTemplateCategoryCreateDocument = gql`
    mutation ReplenishmentTemplateCategoryCreate($input: ReplenishmentTemplateCategoryCreateInput!) {
  replenishmentTemplateCategoryCreate(input: $input) {
    replenishmentTemplateCategoryID
  }
}
    `;

export function useReplenishmentTemplateCategoryCreateMutation() {
  return Urql.useMutation<ReplenishmentTemplateCategoryCreateMutation, ReplenishmentTemplateCategoryCreateMutationVariables>(ReplenishmentTemplateCategoryCreateDocument);
};
export const ReplenishmentTemplateCategoryDeleteDocument = gql`
    mutation ReplenishmentTemplateCategoryDelete($replenishmentTemplateCategoryID: UUID!) {
  replenishmentTemplateCategoryDelete(
    replenishmentTemplateCategoryID: $replenishmentTemplateCategoryID
  )
}
    `;

export function useReplenishmentTemplateCategoryDeleteMutation() {
  return Urql.useMutation<ReplenishmentTemplateCategoryDeleteMutation, ReplenishmentTemplateCategoryDeleteMutationVariables>(ReplenishmentTemplateCategoryDeleteDocument);
};
export const ReplenishmentTemplateCategoryListDocument = gql`
    query ReplenishmentTemplateCategoryList($qop: ReplenishmentTemplateCategoryQopInput!) {
  replenishmentTemplateCategories(qop: $qop) {
    items {
      replenishmentTemplateCategoryID
      replenishmentTemplateCategoryName
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useReplenishmentTemplateCategoryListQuery(options: Omit<Urql.UseQueryArgs<ReplenishmentTemplateCategoryListQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentTemplateCategoryListQuery, ReplenishmentTemplateCategoryListQueryVariables>({ query: ReplenishmentTemplateCategoryListDocument, ...options });
};
export const ReplenishmentTemplateCategoryLoadDocument = gql`
    query ReplenishmentTemplateCategoryLoad($replenishmentTemplateCategoryID: UUID!) {
  replenishmentTemplateCategory(
    replenishmentTemplateCategoryID: $replenishmentTemplateCategoryID
  ) {
    replenishmentTemplateCategoryID
    replenishmentTemplateCategoryName
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useReplenishmentTemplateCategoryLoadQuery(options: Omit<Urql.UseQueryArgs<ReplenishmentTemplateCategoryLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentTemplateCategoryLoadQuery, ReplenishmentTemplateCategoryLoadQueryVariables>({ query: ReplenishmentTemplateCategoryLoadDocument, ...options });
};
export const ReplenishmentTemplateCategoryUpdateDocument = gql`
    mutation ReplenishmentTemplateCategoryUpdate($input: ReplenishmentTemplateCategoryUpdateInput!) {
  replenishmentTemplateCategoryUpdate(input: $input) {
    replenishmentTemplateCategoryID
  }
}
    `;

export function useReplenishmentTemplateCategoryUpdateMutation() {
  return Urql.useMutation<ReplenishmentTemplateCategoryUpdateMutation, ReplenishmentTemplateCategoryUpdateMutationVariables>(ReplenishmentTemplateCategoryUpdateDocument);
};
export const ReplenishmentTemplateItemCreateDocument = gql`
    mutation ReplenishmentTemplateItemCreate($replenishmentTemplateID: UUID!, $input: ReplenishmentTemplateItemCreateInput!) {
  replenishmentTemplateItemCreate(
    replenishmentTemplateID: $replenishmentTemplateID
    input: $input
  ) {
    replenishmentTemplateItemID
  }
}
    `;

export function useReplenishmentTemplateItemCreateMutation() {
  return Urql.useMutation<ReplenishmentTemplateItemCreateMutation, ReplenishmentTemplateItemCreateMutationVariables>(ReplenishmentTemplateItemCreateDocument);
};
export const ReplenishmentTemplateItemDeleteDocument = gql`
    mutation ReplenishmentTemplateItemDelete($replenishmentTemplateItemID: UUID!) {
  replenishmentTemplateItemDelete(
    replenishmentTemplateItemID: $replenishmentTemplateItemID
  )
}
    `;

export function useReplenishmentTemplateItemDeleteMutation() {
  return Urql.useMutation<ReplenishmentTemplateItemDeleteMutation, ReplenishmentTemplateItemDeleteMutationVariables>(ReplenishmentTemplateItemDeleteDocument);
};
export const ReplenishmentTemplateItemImportDocument = gql`
    mutation ReplenishmentTemplateItemImport($input: ReplenishmentTemplateItemImportInput!) {
  replenishmentTemplateItemImport(input: $input) {
    importedCount
    skippedCount
  }
}
    `;

export function useReplenishmentTemplateItemImportMutation() {
  return Urql.useMutation<ReplenishmentTemplateItemImportMutation, ReplenishmentTemplateItemImportMutationVariables>(ReplenishmentTemplateItemImportDocument);
};
export const ReplenishmentTemplateItemImportValidateDocument = gql`
    mutation ReplenishmentTemplateItemImportValidate($input: ReplenishmentTemplateItemImportValidateInput!) {
  replenishmentTemplateItemImportValidate(input: $input) {
    missingProductCodes
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        standardKey
        label
        reason
        value
      }
    }
  }
}
    `;

export function useReplenishmentTemplateItemImportValidateMutation() {
  return Urql.useMutation<ReplenishmentTemplateItemImportValidateMutation, ReplenishmentTemplateItemImportValidateMutationVariables>(ReplenishmentTemplateItemImportValidateDocument);
};
export const ReplenishmentTemplateItemListDocument = gql`
    query ReplenishmentTemplateItemList($qop: ReplenishmentTemplateItemQopInput) {
  replenishmentTemplateItems(qop: $qop) {
    items {
      replenishmentTemplateItemID
      replenishmentTemplateID
      productID
      productCode
      productName
      isActive
      product {
        productID
        productCode
        productName
        barcode
        productCategory {
          productCategoryID
          productCategoryName
        }
      }
      minStock
      orderMultiplier
      leadtimeDays
      safetyDays
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useReplenishmentTemplateItemListQuery(options?: Omit<Urql.UseQueryArgs<ReplenishmentTemplateItemListQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentTemplateItemListQuery, ReplenishmentTemplateItemListQueryVariables>({ query: ReplenishmentTemplateItemListDocument, ...options });
};
export const ReplenishmentTemplateItemLoadDocument = gql`
    query ReplenishmentTemplateItemLoad($replenishmentTemplateItemID: UUID!) {
  replenishmentTemplateItem(
    replenishmentTemplateItemID: $replenishmentTemplateItemID
  ) {
    replenishmentTemplateItemID
    replenishmentTemplateID
    productID
    productCode
    productName
    minStock
    orderMultiplier
    leadtimeDays
    safetyDays
  }
}
    `;

export function useReplenishmentTemplateItemLoadQuery(options: Omit<Urql.UseQueryArgs<ReplenishmentTemplateItemLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentTemplateItemLoadQuery, ReplenishmentTemplateItemLoadQueryVariables>({ query: ReplenishmentTemplateItemLoadDocument, ...options });
};
export const ReplenishmentTemplateItemUpdateDocument = gql`
    mutation ReplenishmentTemplateItemUpdate($input: ReplenishmentTemplateItemUpdateInput!) {
  replenishmentTemplateItemUpdate(input: $input) {
    replenishmentTemplateItemID
  }
}
    `;

export function useReplenishmentTemplateItemUpdateMutation() {
  return Urql.useMutation<ReplenishmentTemplateItemUpdateMutation, ReplenishmentTemplateItemUpdateMutationVariables>(ReplenishmentTemplateItemUpdateDocument);
};
export const ReplenishmentTemplateAutocompleteDocument = gql`
    query ReplenishmentTemplateAutocomplete($qop: ReplenishmentTemplateQopInput!) {
  replenishmentTemplates(qop: $qop) {
    items {
      replenishmentTemplateID
      replenishmentTemplateName
      sourceDocumentType
      sourceWarehouseID
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useReplenishmentTemplateAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ReplenishmentTemplateAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentTemplateAutocompleteQuery, ReplenishmentTemplateAutocompleteQueryVariables>({ query: ReplenishmentTemplateAutocompleteDocument, ...options });
};
export const ReplenishmentTemplateCreateDocument = gql`
    mutation ReplenishmentTemplateCreate($input: ReplenishmentTemplateCreateInput!) {
  replenishmentTemplateCreate(input: $input) {
    replenishmentTemplateID
  }
}
    `;

export function useReplenishmentTemplateCreateMutation() {
  return Urql.useMutation<ReplenishmentTemplateCreateMutation, ReplenishmentTemplateCreateMutationVariables>(ReplenishmentTemplateCreateDocument);
};
export const ReplenishmentTemplateDeleteDocument = gql`
    mutation ReplenishmentTemplateDelete($replenishmentTemplateID: UUID!) {
  replenishmentTemplateDelete(replenishmentTemplateID: $replenishmentTemplateID)
}
    `;

export function useReplenishmentTemplateDeleteMutation() {
  return Urql.useMutation<ReplenishmentTemplateDeleteMutation, ReplenishmentTemplateDeleteMutationVariables>(ReplenishmentTemplateDeleteDocument);
};
export const ReplenishmentTemplateListDocument = gql`
    query ReplenishmentTemplateList($qop: ReplenishmentTemplateQopInput) {
  replenishmentTemplates(qop: $qop) {
    items {
      replenishmentTemplateID
      replenishmentTemplateName
      description
      replenishmentTemplateCategoryID
      replenishmentTemplateCategory {
        replenishmentTemplateCategoryID
        replenishmentTemplateCategoryName
      }
      sourceDocumentType
      sourceWarehouseID
      sourceWarehouseCode
      sourceWarehouseName
      defaultLeadtimeDays
      defaultSafetyDays
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useReplenishmentTemplateListQuery(options?: Omit<Urql.UseQueryArgs<ReplenishmentTemplateListQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentTemplateListQuery, ReplenishmentTemplateListQueryVariables>({ query: ReplenishmentTemplateListDocument, ...options });
};
export const ReplenishmentTemplateLoadDocument = gql`
    query ReplenishmentTemplateLoad($replenishmentTemplateID: UUID!) {
  replenishmentTemplate(replenishmentTemplateID: $replenishmentTemplateID) {
    replenishmentTemplateID
    replenishmentTemplateName
    description
    replenishmentTemplateCategoryID
    replenishmentTemplateCategory {
      replenishmentTemplateCategoryID
      replenishmentTemplateCategoryName
    }
    sourceDocumentType
    sourceWarehouseID
    sourceWarehouseCode
    sourceWarehouseName
    defaultLeadtimeDays
    defaultSafetyDays
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useReplenishmentTemplateLoadQuery(options: Omit<Urql.UseQueryArgs<ReplenishmentTemplateLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentTemplateLoadQuery, ReplenishmentTemplateLoadQueryVariables>({ query: ReplenishmentTemplateLoadDocument, ...options });
};
export const ReplenishmentTemplateUpdateDocument = gql`
    mutation ReplenishmentTemplateUpdate($input: ReplenishmentTemplateUpdateInput!) {
  replenishmentTemplateUpdate(input: $input) {
    replenishmentTemplateID
  }
}
    `;

export function useReplenishmentTemplateUpdateMutation() {
  return Urql.useMutation<ReplenishmentTemplateUpdateMutation, ReplenishmentTemplateUpdateMutationVariables>(ReplenishmentTemplateUpdateDocument);
};
export const ReplenishmentAutocompleteDocument = gql`
    query ReplenishmentAutocomplete($qop: ReplenishmentQopInput) {
  replenishments(qop: $qop) {
    items {
      replenishmentID
      replenishmentNumber
      replenishmentDate
      status
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useReplenishmentAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<ReplenishmentAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentAutocompleteQuery, ReplenishmentAutocompleteQueryVariables>({ query: ReplenishmentAutocompleteDocument, ...options });
};
export const ReplenishmentCreateDocument = gql`
    mutation ReplenishmentCreate($input: ReplenishmentCreateInput!) {
  replenishmentCreate(input: $input) {
    replenishmentID
    replenishmentNumber
    status
    replenishmentDate
    warehouseID
    replenishmentTemplateID
    avgUsageDays
  }
}
    `;

export function useReplenishmentCreateMutation() {
  return Urql.useMutation<ReplenishmentCreateMutation, ReplenishmentCreateMutationVariables>(ReplenishmentCreateDocument);
};
export const ReplenishmentItemListDocument = gql`
    query ReplenishmentItemList($qop: ReplenishmentItemQopInput) {
  replenishmentItems(qop: $qop) {
    items {
      replenishmentItemID
      replenishmentID
      productID
      product {
        productID
        productCode
        productName
        barcode
        altBarcode1
        altBarcode2
        productCategory {
          productCategoryID
          productCategoryName
          productDepartmentID
          productDepartmentName
          productSubDepartmentName
          productSubDepartmentID
        }
      }
      minStock
      avgUsage
      leadTime
      safetyDays
      mpkmFromAvgUsage
      mpkm
      pkm
      orderMultiplier
      qtyOnHand
      qtyIncoming
      qtyCommitted
      qtyAvailable
      reorderQty
      uniqueKey
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useReplenishmentItemListQuery(options?: Omit<Urql.UseQueryArgs<ReplenishmentItemListQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentItemListQuery, ReplenishmentItemListQueryVariables>({ query: ReplenishmentItemListDocument, ...options });
};
export const ReplenishmentListDocument = gql`
    query ReplenishmentList($qop: ReplenishmentQopInput) {
  replenishments(qop: $qop) {
    items {
      replenishmentID
      replenishmentNumber
      replenishmentDate
      branchID
      branch {
        branchID
        branchCode
        branchName
      }
      warehouseID
      warehouse {
        warehouseID
        warehouseCode
        warehouseName
      }
      sourceWarehouseID
      replenishmentTemplateID
      replenishmentTemplate {
        replenishmentTemplateID
        replenishmentTemplateName
      }
      sourceWarehouse {
        warehouseName
      }
      avgUsageDays
      reorderItemCount
      status
      noteInternal
      uniqueKey
      entityAuditMetadata {
        createdByUserName
        createdAt
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useReplenishmentListQuery(options?: Omit<Urql.UseQueryArgs<ReplenishmentListQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentListQuery, ReplenishmentListQueryVariables>({ query: ReplenishmentListDocument, ...options });
};
export const ReplenishmentLoadDocument = gql`
    query ReplenishmentLoad($replenishmentID: UUID!) {
  replenishment(replenishmentID: $replenishmentID) {
    replenishmentID
    replenishmentNumber
    replenishmentDate
    branchID
    branch {
      branchID
      branchCode
      branchName
    }
    warehouseID
    warehouse {
      warehouseID
      warehouseCode
      warehouseName
    }
    replenishmentTemplateID
    replenishmentTemplate {
      replenishmentTemplateID
      replenishmentTemplateName
      description
      sourceDocumentType
      sourceWarehouseID
      sourceWarehouseCode
      sourceWarehouseName
    }
    avgUsageDays
    status
    noteInternal
    uniqueKey
    entityAuditMetadata {
      createdByUserName
      createdAt
    }
  }
}
    `;

export function useReplenishmentLoadQuery(options: Omit<Urql.UseQueryArgs<ReplenishmentLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ReplenishmentLoadQuery, ReplenishmentLoadQueryVariables>({ query: ReplenishmentLoadDocument, ...options });
};
export const RevenueReportAccessLogExportDocument = gql`
    mutation RevenueReportAccessLogExport($input: RevenueReportAccessLogExportInput!) {
  revenueReportAccessLogExport(input: $input) {
    downloadUrl
    fileName
  }
}
    `;

export function useRevenueReportAccessLogExportMutation() {
  return Urql.useMutation<RevenueReportAccessLogExportMutation, RevenueReportAccessLogExportMutationVariables>(RevenueReportAccessLogExportDocument);
};
export const RevenueReportAccessLogSummaryDocument = gql`
    query RevenueReportAccessLogSummary($qop: RevenueReportAccessLogQopInput) {
  revenueReportAccessLogSummary(qop: $qop) {
    requestCount
    successCount
    rejectedCount
    rowsServed
    distinctIpCount
  }
}
    `;

export function useRevenueReportAccessLogSummaryQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportAccessLogSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportAccessLogSummaryQuery, RevenueReportAccessLogSummaryQueryVariables>({ query: RevenueReportAccessLogSummaryDocument, ...options });
};
export const RevenueReportAccessLogsDocument = gql`
    query RevenueReportAccessLogs($qop: RevenueReportAccessLogQopInput) {
  revenueReportAccessLogs(qop: $qop) {
    items {
      revenueReportAccessLogID
      revenueReportUserID
      partnerName
      clientName
      keyPrefix
      accessedDatetime
      startDate
      endDate
      page
      pageSize
      rowCount
      httpStatus
      resultClass
      reason
      sourceIp
      durationMs
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useRevenueReportAccessLogsQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportAccessLogsQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportAccessLogsQuery, RevenueReportAccessLogsQueryVariables>({ query: RevenueReportAccessLogsDocument, ...options });
};
export const RevenueReportPartnerBranchDocument = gql`
    query RevenueReportPartnerBranch($revenueReportPartnerBranchID: UUID!) {
  revenueReportPartnerBranch(
    revenueReportPartnerBranchID: $revenueReportPartnerBranchID
  ) {
    revenueReportPartnerBranchID
    revenueReportPartnerID
    partnerName
    deliveryMode
    authType
    revenueReportTemplateID
    templateName
    branchID
    branchCode
    branchName
    npwpd
    status
    credentialState
    credentialSource
    apiKeyPrefix
    credentialUpdatedAt
    noteInternal
    entityAuditMetadata {
      createdAt
      createdByUserName
      updatedAt
      updatedByUserName
    }
  }
}
    `;

export function useRevenueReportPartnerBranchQuery(options: Omit<Urql.UseQueryArgs<RevenueReportPartnerBranchQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportPartnerBranchQuery, RevenueReportPartnerBranchQueryVariables>({ query: RevenueReportPartnerBranchDocument, ...options });
};
export const RevenueReportPartnerBranchActivateDocument = gql`
    mutation RevenueReportPartnerBranchActivate($revenueReportPartnerBranchID: UUID!) {
  revenueReportPartnerBranchActivate(
    revenueReportPartnerBranchID: $revenueReportPartnerBranchID
  ) {
    revenueReportPartnerBranchID
    status
  }
}
    `;

export function useRevenueReportPartnerBranchActivateMutation() {
  return Urql.useMutation<RevenueReportPartnerBranchActivateMutation, RevenueReportPartnerBranchActivateMutationVariables>(RevenueReportPartnerBranchActivateDocument);
};
export const RevenueReportPartnerBranchCreateDocument = gql`
    mutation RevenueReportPartnerBranchCreate($input: RevenueReportPartnerBranchCreateInput!) {
  revenueReportPartnerBranchCreate(input: $input) {
    revenueReportPartnerBranchID
  }
}
    `;

export function useRevenueReportPartnerBranchCreateMutation() {
  return Urql.useMutation<RevenueReportPartnerBranchCreateMutation, RevenueReportPartnerBranchCreateMutationVariables>(RevenueReportPartnerBranchCreateDocument);
};
export const RevenueReportPartnerBranchCredentialClearDocument = gql`
    mutation RevenueReportPartnerBranchCredentialClear($revenueReportPartnerBranchID: UUID!) {
  revenueReportPartnerBranchCredentialClear(
    revenueReportPartnerBranchID: $revenueReportPartnerBranchID
  ) {
    revenueReportPartnerBranchID
  }
}
    `;

export function useRevenueReportPartnerBranchCredentialClearMutation() {
  return Urql.useMutation<RevenueReportPartnerBranchCredentialClearMutation, RevenueReportPartnerBranchCredentialClearMutationVariables>(RevenueReportPartnerBranchCredentialClearDocument);
};
export const RevenueReportPartnerBranchCredentialSetDocument = gql`
    mutation RevenueReportPartnerBranchCredentialSet($input: RevenueReportPartnerBranchCredentialSetInput!) {
  revenueReportPartnerBranchCredentialSet(input: $input) {
    revenueReportPartnerBranchID
  }
}
    `;

export function useRevenueReportPartnerBranchCredentialSetMutation() {
  return Urql.useMutation<RevenueReportPartnerBranchCredentialSetMutation, RevenueReportPartnerBranchCredentialSetMutationVariables>(RevenueReportPartnerBranchCredentialSetDocument);
};
export const RevenueReportPartnerBranchDeactivateDocument = gql`
    mutation RevenueReportPartnerBranchDeactivate($revenueReportPartnerBranchID: UUID!) {
  revenueReportPartnerBranchDeactivate(
    revenueReportPartnerBranchID: $revenueReportPartnerBranchID
  ) {
    revenueReportPartnerBranchID
    status
  }
}
    `;

export function useRevenueReportPartnerBranchDeactivateMutation() {
  return Urql.useMutation<RevenueReportPartnerBranchDeactivateMutation, RevenueReportPartnerBranchDeactivateMutationVariables>(RevenueReportPartnerBranchDeactivateDocument);
};
export const RevenueReportPartnerBranchUpdateDocument = gql`
    mutation RevenueReportPartnerBranchUpdate($input: RevenueReportPartnerBranchUpdateInput!) {
  revenueReportPartnerBranchUpdate(input: $input) {
    revenueReportPartnerBranchID
  }
}
    `;

export function useRevenueReportPartnerBranchUpdateMutation() {
  return Urql.useMutation<RevenueReportPartnerBranchUpdateMutation, RevenueReportPartnerBranchUpdateMutationVariables>(RevenueReportPartnerBranchUpdateDocument);
};
export const RevenueReportPartnerBranchesDocument = gql`
    query RevenueReportPartnerBranches($qop: RevenueReportPartnerBranchQopInput) {
  revenueReportPartnerBranches(qop: $qop) {
    items {
      revenueReportPartnerBranchID
      revenueReportPartnerID
      partnerName
      deliveryMode
      branchID
      branchCode
      branchName
      npwpd
      status
      credentialState
      noteInternal
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useRevenueReportPartnerBranchesQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportPartnerBranchesQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportPartnerBranchesQuery, RevenueReportPartnerBranchesQueryVariables>({ query: RevenueReportPartnerBranchesDocument, ...options });
};
export const RevenueReportPartnerDocument = gql`
    query RevenueReportPartner($revenueReportPartnerID: UUID!) {
  revenueReportPartner(revenueReportPartnerID: $revenueReportPartnerID) {
    revenueReportPartnerID
    revenueReportPartnerType
    partnerName
    deliveryMode
    endpointURL
    authType
    apiKeyPrefix
    hasApiSecret
    credentialUpdatedAt
    credentialState
    revenueReportTemplateID
    templateName
    isNpwpdRequired
    isActive
    noteInternal
    branchCount
    apiClientCount
    entityAuditMetadata {
      createdAt
      createdByUserName
      updatedAt
      updatedByUserName
    }
  }
}
    `;

export function useRevenueReportPartnerQuery(options: Omit<Urql.UseQueryArgs<RevenueReportPartnerQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportPartnerQuery, RevenueReportPartnerQueryVariables>({ query: RevenueReportPartnerDocument, ...options });
};
export const RevenueReportPartnerActivateDocument = gql`
    mutation RevenueReportPartnerActivate($revenueReportPartnerID: UUID!) {
  revenueReportPartnerActivate(revenueReportPartnerID: $revenueReportPartnerID) {
    revenueReportPartnerID
    isActive
  }
}
    `;

export function useRevenueReportPartnerActivateMutation() {
  return Urql.useMutation<RevenueReportPartnerActivateMutation, RevenueReportPartnerActivateMutationVariables>(RevenueReportPartnerActivateDocument);
};
export const RevenueReportPartnerAutocompleteDocument = gql`
    query RevenueReportPartnerAutocomplete($qop: RevenueReportPartnerQopInput) {
  revenueReportPartners(qop: $qop) {
    items {
      revenueReportPartnerID
      partnerName
      isNpwpdRequired
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useRevenueReportPartnerAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportPartnerAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportPartnerAutocompleteQuery, RevenueReportPartnerAutocompleteQueryVariables>({ query: RevenueReportPartnerAutocompleteDocument, ...options });
};
export const RevenueReportPartnerCreateDocument = gql`
    mutation RevenueReportPartnerCreate($input: RevenueReportPartnerCreateInput!) {
  revenueReportPartnerCreate(input: $input) {
    revenueReportPartnerID
  }
}
    `;

export function useRevenueReportPartnerCreateMutation() {
  return Urql.useMutation<RevenueReportPartnerCreateMutation, RevenueReportPartnerCreateMutationVariables>(RevenueReportPartnerCreateDocument);
};
export const RevenueReportPartnerCredentialSetDocument = gql`
    mutation RevenueReportPartnerCredentialSet($input: RevenueReportPartnerCredentialSetInput!) {
  revenueReportPartnerCredentialSet(input: $input) {
    revenueReportPartnerID
  }
}
    `;

export function useRevenueReportPartnerCredentialSetMutation() {
  return Urql.useMutation<RevenueReportPartnerCredentialSetMutation, RevenueReportPartnerCredentialSetMutationVariables>(RevenueReportPartnerCredentialSetDocument);
};
export const RevenueReportPartnerDeactivateDocument = gql`
    mutation RevenueReportPartnerDeactivate($revenueReportPartnerID: UUID!) {
  revenueReportPartnerDeactivate(revenueReportPartnerID: $revenueReportPartnerID) {
    revenueReportPartnerID
    isActive
  }
}
    `;

export function useRevenueReportPartnerDeactivateMutation() {
  return Urql.useMutation<RevenueReportPartnerDeactivateMutation, RevenueReportPartnerDeactivateMutationVariables>(RevenueReportPartnerDeactivateDocument);
};
export const RevenueReportPartnerEndpointUpdateDocument = gql`
    mutation RevenueReportPartnerEndpointUpdate($input: RevenueReportPartnerEndpointUpdateInput!) {
  revenueReportPartnerEndpointUpdate(input: $input) {
    revenueReportPartnerID
  }
}
    `;

export function useRevenueReportPartnerEndpointUpdateMutation() {
  return Urql.useMutation<RevenueReportPartnerEndpointUpdateMutation, RevenueReportPartnerEndpointUpdateMutationVariables>(RevenueReportPartnerEndpointUpdateDocument);
};
export const RevenueReportPartnerUpdateDocument = gql`
    mutation RevenueReportPartnerUpdate($input: RevenueReportPartnerUpdateInput!) {
  revenueReportPartnerUpdate(input: $input) {
    revenueReportPartnerID
  }
}
    `;

export function useRevenueReportPartnerUpdateMutation() {
  return Urql.useMutation<RevenueReportPartnerUpdateMutation, RevenueReportPartnerUpdateMutationVariables>(RevenueReportPartnerUpdateDocument);
};
export const RevenueReportPartnersDocument = gql`
    query RevenueReportPartners($qop: RevenueReportPartnerQopInput) {
  revenueReportPartners(qop: $qop) {
    items {
      revenueReportPartnerID
      partnerName
      deliveryMode
      endpointURL
      authType
      revenueReportTemplateID
      templateName
      credentialState
      isNpwpdRequired
      isActive
      noteInternal
      branchCount
      apiClientCount
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useRevenueReportPartnersQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportPartnersQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportPartnersQuery, RevenueReportPartnersQueryVariables>({ query: RevenueReportPartnersDocument, ...options });
};
export const RevenueReportTemplateDocument = gql`
    query RevenueReportTemplate($revenueReportTemplateID: UUID!) {
  revenueReportTemplate(revenueReportTemplateID: $revenueReportTemplateID) {
    revenueReportTemplateID
    revenueReportTemplateType
    templateName
    fieldMap
    envelope
    resultKey
    wrapperMap
    isActive
    noteInternal
    partnerNames
    entityAuditMetadata {
      createdAt
      createdByUserName
      updatedAt
      updatedByUserName
    }
  }
}
    `;

export function useRevenueReportTemplateQuery(options: Omit<Urql.UseQueryArgs<RevenueReportTemplateQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportTemplateQuery, RevenueReportTemplateQueryVariables>({ query: RevenueReportTemplateDocument, ...options });
};
export const RevenueReportTemplateActivateDocument = gql`
    mutation RevenueReportTemplateActivate($revenueReportTemplateID: UUID!) {
  revenueReportTemplateActivate(revenueReportTemplateID: $revenueReportTemplateID) {
    revenueReportTemplateID
    isActive
  }
}
    `;

export function useRevenueReportTemplateActivateMutation() {
  return Urql.useMutation<RevenueReportTemplateActivateMutation, RevenueReportTemplateActivateMutationVariables>(RevenueReportTemplateActivateDocument);
};
export const RevenueReportTemplateAutocompleteDocument = gql`
    query RevenueReportTemplateAutocomplete($qop: RevenueReportTemplateQopInput) {
  revenueReportTemplates(qop: $qop) {
    items {
      revenueReportTemplateID
      templateName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useRevenueReportTemplateAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportTemplateAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportTemplateAutocompleteQuery, RevenueReportTemplateAutocompleteQueryVariables>({ query: RevenueReportTemplateAutocompleteDocument, ...options });
};
export const RevenueReportTemplateCreateDocument = gql`
    mutation RevenueReportTemplateCreate($input: RevenueReportTemplateCreateInput!) {
  revenueReportTemplateCreate(input: $input) {
    revenueReportTemplateID
  }
}
    `;

export function useRevenueReportTemplateCreateMutation() {
  return Urql.useMutation<RevenueReportTemplateCreateMutation, RevenueReportTemplateCreateMutationVariables>(RevenueReportTemplateCreateDocument);
};
export const RevenueReportTemplateDeactivateDocument = gql`
    mutation RevenueReportTemplateDeactivate($revenueReportTemplateID: UUID!) {
  revenueReportTemplateDeactivate(
    revenueReportTemplateID: $revenueReportTemplateID
  ) {
    revenueReportTemplateID
    isActive
  }
}
    `;

export function useRevenueReportTemplateDeactivateMutation() {
  return Urql.useMutation<RevenueReportTemplateDeactivateMutation, RevenueReportTemplateDeactivateMutationVariables>(RevenueReportTemplateDeactivateDocument);
};
export const RevenueReportTemplateDuplicateDocument = gql`
    mutation RevenueReportTemplateDuplicate($revenueReportTemplateID: UUID!) {
  revenueReportTemplateDuplicate(
    revenueReportTemplateID: $revenueReportTemplateID
  ) {
    revenueReportTemplateID
    isActive
  }
}
    `;

export function useRevenueReportTemplateDuplicateMutation() {
  return Urql.useMutation<RevenueReportTemplateDuplicateMutation, RevenueReportTemplateDuplicateMutationVariables>(RevenueReportTemplateDuplicateDocument);
};
export const RevenueReportTemplateFieldMapUpdateDocument = gql`
    mutation RevenueReportTemplateFieldMapUpdate($input: RevenueReportTemplateFieldMapUpdateInput!) {
  revenueReportTemplateFieldMapUpdate(input: $input) {
    revenueReportTemplateID
  }
}
    `;

export function useRevenueReportTemplateFieldMapUpdateMutation() {
  return Urql.useMutation<RevenueReportTemplateFieldMapUpdateMutation, RevenueReportTemplateFieldMapUpdateMutationVariables>(RevenueReportTemplateFieldMapUpdateDocument);
};
export const RevenueReportTemplatePreviewDocument = gql`
    query RevenueReportTemplatePreview($revenueReportTemplateID: UUID!, $deliveryMode: String!) {
  revenueReportTemplatePreview(
    revenueReportTemplateID: $revenueReportTemplateID
    deliveryMode: $deliveryMode
  )
}
    `;

export function useRevenueReportTemplatePreviewQuery(options: Omit<Urql.UseQueryArgs<RevenueReportTemplatePreviewQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportTemplatePreviewQuery, RevenueReportTemplatePreviewQueryVariables>({ query: RevenueReportTemplatePreviewDocument, ...options });
};
export const RevenueReportTemplateUpdateDocument = gql`
    mutation RevenueReportTemplateUpdate($input: RevenueReportTemplateUpdateInput!) {
  revenueReportTemplateUpdate(input: $input) {
    revenueReportTemplateID
  }
}
    `;

export function useRevenueReportTemplateUpdateMutation() {
  return Urql.useMutation<RevenueReportTemplateUpdateMutation, RevenueReportTemplateUpdateMutationVariables>(RevenueReportTemplateUpdateDocument);
};
export const RevenueReportTemplatesDocument = gql`
    query RevenueReportTemplates($qop: RevenueReportTemplateQopInput) {
  revenueReportTemplates(qop: $qop) {
    items {
      revenueReportTemplateID
      revenueReportTemplateType
      templateName
      fieldMap
      envelope
      resultKey
      wrapperMap
      isActive
      noteInternal
      partnerNames
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useRevenueReportTemplatesQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportTemplatesQuery, RevenueReportTemplatesQueryVariables>({ query: RevenueReportTemplatesDocument, ...options });
};
export const RevenueReportApiKeyIssueDocument = gql`
    mutation RevenueReportApiKeyIssue($input: RevenueReportApiKeyIssueInput!) {
  revenueReportApiKeyIssue(input: $input) {
    revenueReportApiKeyID
    keyPrefix
    plaintextApiKey
    expiresAt
  }
}
    `;

export function useRevenueReportApiKeyIssueMutation() {
  return Urql.useMutation<RevenueReportApiKeyIssueMutation, RevenueReportApiKeyIssueMutationVariables>(RevenueReportApiKeyIssueDocument);
};
export const RevenueReportApiKeyRevokeDocument = gql`
    mutation RevenueReportApiKeyRevoke($revenueReportApiKeyID: UUID!) {
  revenueReportApiKeyRevoke(revenueReportApiKeyID: $revenueReportApiKeyID) {
    revenueReportApiKeyID
    status
  }
}
    `;

export function useRevenueReportApiKeyRevokeMutation() {
  return Urql.useMutation<RevenueReportApiKeyRevokeMutation, RevenueReportApiKeyRevokeMutationVariables>(RevenueReportApiKeyRevokeDocument);
};
export const RevenueReportApiKeysDocument = gql`
    query RevenueReportApiKeys($qop: RevenueReportApiKeyQopInput) {
  revenueReportApiKeys(qop: $qop) {
    items {
      revenueReportApiKeyID
      keyPrefix
      status
      expiresAt
      lastUsedAt
      lastUsedIp
      entityAuditMetadata {
        createdAt
      }
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useRevenueReportApiKeysQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportApiKeysQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportApiKeysQuery, RevenueReportApiKeysQueryVariables>({ query: RevenueReportApiKeysDocument, ...options });
};
export const RevenueReportUserAutocompleteDocument = gql`
    query RevenueReportUserAutocomplete($qop: RevenueReportUserQopInput) {
  revenueReportUsers(qop: $qop) {
    items {
      revenueReportUserID
      fullName
      partnerName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useRevenueReportUserAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportUserAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportUserAutocompleteQuery, RevenueReportUserAutocompleteQueryVariables>({ query: RevenueReportUserAutocompleteDocument, ...options });
};
export const RevenueReportUserCreateDocument = gql`
    mutation RevenueReportUserCreate($input: RevenueReportUserCreateInput!) {
  revenueReportUserCreate(input: $input) {
    revenueReportUserID
  }
}
    `;

export function useRevenueReportUserCreateMutation() {
  return Urql.useMutation<RevenueReportUserCreateMutation, RevenueReportUserCreateMutationVariables>(RevenueReportUserCreateDocument);
};
export const RevenueReportUsersDocument = gql`
    query RevenueReportUsers($qop: RevenueReportUserQopInput) {
  revenueReportUsers(qop: $qop) {
    items {
      revenueReportUserID
      fullName
      email
      isActive
      activeApiKeyCount
      lastUsedAt
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useRevenueReportUsersQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportUsersQuery, RevenueReportUsersQueryVariables>({ query: RevenueReportUsersDocument, ...options });
};
export const RevenueReportDocument = gql`
    query RevenueReport($revenueReportID: UUID!) {
  revenueReport(revenueReportID: $revenueReportID) {
    revenueReportID
    type
    transactionDate
    revenueReportPartnerID
    partnerName
    branchID
    branchCode
    branchName
    deliveryMode
    itemCount
    totalAmount
    taxAmount
    uploadedDatetime
    uploadAttemptCount
    lastUploadError
    uploadStatus
    lastPulledAt
    entityAuditMetadata {
      createdAt
      updatedAt
    }
  }
}
    `;

export function useRevenueReportQuery(options: Omit<Urql.UseQueryArgs<RevenueReportQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportQuery, RevenueReportQueryVariables>({ query: RevenueReportDocument, ...options });
};
export const RevenueReportDetailCorrectDocument = gql`
    mutation RevenueReportDetailCorrect($input: RevenueReportDetailCorrectInput!) {
  revenueReportDetailCorrect(input: $input) {
    revenueReportDetailID
    status
  }
}
    `;

export function useRevenueReportDetailCorrectMutation() {
  return Urql.useMutation<RevenueReportDetailCorrectMutation, RevenueReportDetailCorrectMutationVariables>(RevenueReportDetailCorrectDocument);
};
export const RevenueReportDetailExportDocument = gql`
    mutation RevenueReportDetailExport($input: RevenueReportDetailExportInput!) {
  revenueReportDetailExport(input: $input) {
    downloadUrl
    fileName
  }
}
    `;

export function useRevenueReportDetailExportMutation() {
  return Urql.useMutation<RevenueReportDetailExportMutation, RevenueReportDetailExportMutationVariables>(RevenueReportDetailExportDocument);
};
export const RevenueReportDetailVoidDocument = gql`
    mutation RevenueReportDetailVoid($input: RevenueReportDetailVoidInput!) {
  revenueReportDetailVoid(input: $input) {
    revenueReportDetailID
    status
  }
}
    `;

export function useRevenueReportDetailVoidMutation() {
  return Urql.useMutation<RevenueReportDetailVoidMutation, RevenueReportDetailVoidMutationVariables>(RevenueReportDetailVoidDocument);
};
export const RevenueReportDetailsDocument = gql`
    query RevenueReportDetails($qop: RevenueReportDetailQopInput) {
  revenueReportDetails(qop: $qop) {
    items {
      revenueReportDetailID
      salesInvoiceID
      salesInvoiceNumber
      barcode
      productCode
      productName
      isConsignment
      transactionDatetimeUtc
      totalAmount
      taxAmount
      status
      correctionType
      originalTotalAmount
      originalTaxAmount
      correctionReason
      correctedUserName
      correctedDatetime
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useRevenueReportDetailsQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportDetailsQuery, RevenueReportDetailsQueryVariables>({ query: RevenueReportDetailsDocument, ...options });
};
export const RevenueReportExportDocument = gql`
    mutation RevenueReportExport($input: RevenueReportExportInput!) {
  revenueReportExport(input: $input) {
    downloadUrl
    fileName
  }
}
    `;

export function useRevenueReportExportMutation() {
  return Urql.useMutation<RevenueReportExportMutation, RevenueReportExportMutationVariables>(RevenueReportExportDocument);
};
export const RevenueReportGenerateDocument = gql`
    mutation RevenueReportGenerate($input: RevenueReportGenerateInput!) {
  revenueReportGenerate(input: $input) {
    revenueReportID
  }
}
    `;

export function useRevenueReportGenerateMutation() {
  return Urql.useMutation<RevenueReportGenerateMutation, RevenueReportGenerateMutationVariables>(RevenueReportGenerateDocument);
};
export const RevenueReportResendDocument = gql`
    mutation RevenueReportResend($revenueReportID: UUID!) {
  revenueReportResend(revenueReportID: $revenueReportID) {
    revenueReportID
    uploadStatus
    lastUploadError
  }
}
    `;

export function useRevenueReportResendMutation() {
  return Urql.useMutation<RevenueReportResendMutation, RevenueReportResendMutationVariables>(RevenueReportResendDocument);
};
export const RevenueReportResyncDocument = gql`
    mutation RevenueReportResync($input: RevenueReportResyncInput!) {
  revenueReportResync(input: $input) {
    revenueReportID
    uploadStatus
  }
}
    `;

export function useRevenueReportResyncMutation() {
  return Urql.useMutation<RevenueReportResyncMutation, RevenueReportResyncMutationVariables>(RevenueReportResyncDocument);
};
export const RevenueReportUploadBatchesDocument = gql`
    query RevenueReportUploadBatches($qop: RevenueReportUploadBatchQopInput) {
  revenueReportUploadBatches(qop: $qop) {
    items {
      revenueReportUploadBatchID
      status
      httpStatus
      sentCount
      successCount
      errorCount
      errorSummary
      responseBody
      requestPayload
      entityAuditMetadata {
        createdAt
        createdByUserName
      }
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useRevenueReportUploadBatchesQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportUploadBatchesQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportUploadBatchesQuery, RevenueReportUploadBatchesQueryVariables>({ query: RevenueReportUploadBatchesDocument, ...options });
};
export const RevenueReportsDocument = gql`
    query RevenueReports($qop: RevenueReportQopInput) {
  revenueReports(qop: $qop) {
    items {
      revenueReportID
      type
      transactionDate
      partnerName
      branchCode
      branchName
      deliveryMode
      itemCount
      totalAmount
      taxAmount
      uploadStatus
    }
    pagination {
      totalRows
    }
  }
  revenueReportSummary(qop: $qop) {
    revenueReportCount
    itemCount
    totalAmount
    taxAmount
  }
}
    `;

export function useRevenueReportsQuery(options?: Omit<Urql.UseQueryArgs<RevenueReportsQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueReportsQuery, RevenueReportsQueryVariables>({ query: RevenueReportsDocument, ...options });
};
export const RevenueSharingCorrectItemDocument = gql`
    mutation RevenueSharingCorrectItem($input: RevenueSharingCorrectItemInput!) {
  revenueSharingCorrectItem(input: $input)
}
    `;

export function useRevenueSharingCorrectItemMutation() {
  return Urql.useMutation<RevenueSharingCorrectItemMutation, RevenueSharingCorrectItemMutationVariables>(RevenueSharingCorrectItemDocument);
};
export const RevenueSharingDetailLippoLiveDocument = gql`
    query RevenueSharingDetailLippoLive($revenueSharingDetailID: UUID!) {
  revenueSharingDetailLippoLive(revenueSharingDetailID: $revenueSharingDetailID) {
    transactionNumber
    transactionDate
    amount
  }
}
    `;

export function useRevenueSharingDetailLippoLiveQuery(options: Omit<Urql.UseQueryArgs<RevenueSharingDetailLippoLiveQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueSharingDetailLippoLiveQuery, RevenueSharingDetailLippoLiveQueryVariables>({ query: RevenueSharingDetailLippoLiveDocument, ...options });
};
export const RevenueSharingDetailLoadDocument = gql`
    query RevenueSharingDetailLoad($revenueSharingDetailID: UUID!) {
  revenueSharingDetail(revenueSharingDetailID: $revenueSharingDetailID) {
    revenueSharingDetailID
    revenueSharingID
    salesInvoiceID
    salesInvoiceNumber
    transactionDatetime
    transactionDatetimeUtc
    netAmount
    voucherAmount
    deductionAmount
    uploadAmountDpp
    status
    sourceStatus
    uploaded
    externalTransactionID
    noteInternal
  }
}
    `;

export function useRevenueSharingDetailLoadQuery(options: Omit<Urql.UseQueryArgs<RevenueSharingDetailLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueSharingDetailLoadQuery, RevenueSharingDetailLoadQueryVariables>({ query: RevenueSharingDetailLoadDocument, ...options });
};
export const RevenueSharingExportDocument = gql`
    mutation RevenueSharingExport($input: RevenueSharingExportInput!) {
  revenueSharingExport(input: $input) {
    downloadUrl
    fileName
  }
}
    `;

export function useRevenueSharingExportMutation() {
  return Urql.useMutation<RevenueSharingExportMutation, RevenueSharingExportMutationVariables>(RevenueSharingExportDocument);
};
export const RevenueSharingGenerateDocument = gql`
    mutation RevenueSharingGenerate($input: RevenueSharingGenerateInput!) {
  revenueSharingGenerate(input: $input)
}
    `;

export function useRevenueSharingGenerateMutation() {
  return Urql.useMutation<RevenueSharingGenerateMutation, RevenueSharingGenerateMutationVariables>(RevenueSharingGenerateDocument);
};
export const RevenueSharingItemsDocument = gql`
    query RevenueSharingItems($qop: RevenueSharingDetailQopInput) {
  revenueSharingDetails(qop: $qop) {
    items {
      revenueSharingDetailID
      revenueSharingID
      salesInvoiceID
      salesInvoiceNumber
      transactionDatetime
      netAmount
      voucherAmount
      deductionAmount
      uploadAmountDpp
      status
      sourceStatus
      uploaded
      externalTransactionID
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useRevenueSharingItemsQuery(options?: Omit<Urql.UseQueryArgs<RevenueSharingItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueSharingItemsQuery, RevenueSharingItemsQueryVariables>({ query: RevenueSharingItemsDocument, ...options });
};
export const RevenueSharingListDocument = gql`
    query RevenueSharingList($qop: RevenueSharingQopInput) {
  revenueSharings(qop: $qop) {
    items {
      revenueSharingID
      transactionDate
      branchID
      branchCode
      branchName
      gmt
      providerCode
      totalActiveCount
      totalCancelledCount
      totalNetAmount
      totalVoucherAmount
      totalDeductionAmount
      totalAmountDpp
      uploaded
      uploadedDatetime
      uploadAttemptCount
      lastUploadError
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useRevenueSharingListQuery(options?: Omit<Urql.UseQueryArgs<RevenueSharingListQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueSharingListQuery, RevenueSharingListQueryVariables>({ query: RevenueSharingListDocument, ...options });
};
export const RevenueSharingLoadDocument = gql`
    query RevenueSharingLoad($revenueSharingID: UUID!) {
  revenueSharing(revenueSharingID: $revenueSharingID) {
    revenueSharingID
    transactionDate
    branchID
    branchCode
    branchName
    gmt
    providerCode
    uploaded
    uploadedDatetime
    uploadedDatetimeUtc
    uploadAttemptCount
    lastUploadError
    lastUploadResponse
    lastUploadPayload
    revenueBatchId
    noteInternal
    entityAuditMetadata {
      createdAt
      createdByUserName
      updatedAt
      updatedByUserName
    }
  }
}
    `;

export function useRevenueSharingLoadQuery(options: Omit<Urql.UseQueryArgs<RevenueSharingLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueSharingLoadQuery, RevenueSharingLoadQueryVariables>({ query: RevenueSharingLoadDocument, ...options });
};
export const RevenueSharingReuploadDatesDocument = gql`
    mutation RevenueSharingReuploadDates($revenueSharingID: UUID!) {
  revenueSharingReuploadDates(revenueSharingID: $revenueSharingID) {
    fixed
    alreadyCorrect
    needManual
  }
}
    `;

export function useRevenueSharingReuploadDatesMutation() {
  return Urql.useMutation<RevenueSharingReuploadDatesMutation, RevenueSharingReuploadDatesMutationVariables>(RevenueSharingReuploadDatesDocument);
};
export const RevenueSharingUploadDocument = gql`
    mutation RevenueSharingUpload($revenueSharingID: UUID!) {
  revenueSharingUpload(revenueSharingID: $revenueSharingID)
}
    `;

export function useRevenueSharingUploadMutation() {
  return Urql.useMutation<RevenueSharingUploadMutation, RevenueSharingUploadMutationVariables>(RevenueSharingUploadDocument);
};
export const RevenueSharingUploadAllDocument = gql`
    mutation RevenueSharingUploadAll {
  revenueSharingUploadAll
}
    `;

export function useRevenueSharingUploadAllMutation() {
  return Urql.useMutation<RevenueSharingUploadAllMutation, RevenueSharingUploadAllMutationVariables>(RevenueSharingUploadAllDocument);
};
export const RevenueSharingUploadBatchesDocument = gql`
    query RevenueSharingUploadBatches($revenueSharingID: UUID!) {
  revenueSharingUploadBatches(revenueSharingID: $revenueSharingID) {
    revenueSharingUploadBatchID
    chunkIndex
    sentCount
    successCount
    duplicateCount
    errorCount
    status
    httpStatus
    lippoCode
    lippoMessage
    revenueBatchID
    requestPayload
    responseBody
    errorSummary
    uploadedDatetime
  }
}
    `;

export function useRevenueSharingUploadBatchesQuery(options: Omit<Urql.UseQueryArgs<RevenueSharingUploadBatchesQueryVariables>, 'query'>) {
  return Urql.useQuery<RevenueSharingUploadBatchesQuery, RevenueSharingUploadBatchesQueryVariables>({ query: RevenueSharingUploadBatchesDocument, ...options });
};
export const RevenueSharingVoidItemDocument = gql`
    mutation RevenueSharingVoidItem($revenueSharingDetailID: UUID!) {
  revenueSharingVoidItem(revenueSharingDetailID: $revenueSharingDetailID)
}
    `;

export function useRevenueSharingVoidItemMutation() {
  return Urql.useMutation<RevenueSharingVoidItemMutation, RevenueSharingVoidItemMutationVariables>(RevenueSharingVoidItemDocument);
};
export const SalesChannelCampaignDocument = gql`
    query SalesChannelCampaign($salesChannelCampaignID: UUID!) {
  salesChannelCampaign(salesChannelCampaignID: $salesChannelCampaignID) {
    salesChannelCampaignID
    parentSalesChannelCampaignID
    salesChannelCategoryGroupID
    salesChannelCategoryGroupName
    salesChannelCampaignName
    customTag
    status
    isAllBranches
    eaterType
    scopeType
    discountType
    discountValue
    discountCap
    minBasketAmount
    quotaTotal
    quotaPerUser
    objectIDs
    workingHours
    startAt
    endAt
    errorMessage
    categories {
      salesChannelCategoryID
      salesChannelCategoryName
    }
  }
}
    `;

export function useSalesChannelCampaignQuery(options: Omit<Urql.UseQueryArgs<SalesChannelCampaignQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCampaignQuery, SalesChannelCampaignQueryVariables>({ query: SalesChannelCampaignDocument, ...options });
};
export const SalesChannelCampaignCancelDocument = gql`
    mutation SalesChannelCampaignCancel($salesChannelCampaignID: UUID!) {
  salesChannelCampaignCancel(salesChannelCampaignID: $salesChannelCampaignID) {
    salesChannelCampaignID
    status
  }
}
    `;

export function useSalesChannelCampaignCancelMutation() {
  return Urql.useMutation<SalesChannelCampaignCancelMutation, SalesChannelCampaignCancelMutationVariables>(SalesChannelCampaignCancelDocument);
};
export const SalesChannelCampaignChildrenDocument = gql`
    query SalesChannelCampaignChildren($qop: SalesChannelCampaignQopInput) {
  salesChannelCampaigns(qop: $qop) {
    items {
      salesChannelCampaignID
      parentSalesChannelCampaignID
      salesChannelID
      status
      branchID
      branchCode
      branchName
      externalCampaignID
      errorMessage
      entityAuditMetadata {
        updatedAt
      }
    }
  }
}
    `;

export function useSalesChannelCampaignChildrenQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelCampaignChildrenQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCampaignChildrenQuery, SalesChannelCampaignChildrenQueryVariables>({ query: SalesChannelCampaignChildrenDocument, ...options });
};
export const SalesChannelCampaignCreateDocument = gql`
    mutation SalesChannelCampaignCreate($input: SalesChannelCampaignCreateInput!) {
  salesChannelCampaignCreate(input: $input) {
    salesChannelCampaignID
  }
}
    `;

export function useSalesChannelCampaignCreateMutation() {
  return Urql.useMutation<SalesChannelCampaignCreateMutation, SalesChannelCampaignCreateMutationVariables>(SalesChannelCampaignCreateDocument);
};
export const SalesChannelCampaignDeleteDocument = gql`
    mutation SalesChannelCampaignDelete($salesChannelCampaignID: UUID!) {
  salesChannelCampaignDelete(salesChannelCampaignID: $salesChannelCampaignID)
}
    `;

export function useSalesChannelCampaignDeleteMutation() {
  return Urql.useMutation<SalesChannelCampaignDeleteMutation, SalesChannelCampaignDeleteMutationVariables>(SalesChannelCampaignDeleteDocument);
};
export const SalesChannelCampaignProductsDocument = gql`
    query SalesChannelCampaignProducts($qop: SalesChannelCampaignProductQopInput) {
  salesChannelCampaignProducts(qop: $qop) {
    items {
      salesChannelCampaignProductID
      salesChannelCampaignID
      productID
      productCode
      productName
      barcode
      product {
        productID
        productCode
        productName
        barcode
        isConsignment
      }
    }
  }
}
    `;

export function useSalesChannelCampaignProductsQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelCampaignProductsQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCampaignProductsQuery, SalesChannelCampaignProductsQueryVariables>({ query: SalesChannelCampaignProductsDocument, ...options });
};
export const SalesChannelCampaignPublishToStoresDocument = gql`
    mutation SalesChannelCampaignPublishToStores($input: SalesChannelCampaignPublishToStoresInput!) {
  salesChannelCampaignPublishToStores(input: $input) {
    branchID
    salesChannelID
    published
    note
    skippedProductIDs
    skippedProductCodes
    child {
      salesChannelCampaignID
      status
      branchName
    }
  }
}
    `;

export function useSalesChannelCampaignPublishToStoresMutation() {
  return Urql.useMutation<SalesChannelCampaignPublishToStoresMutation, SalesChannelCampaignPublishToStoresMutationVariables>(SalesChannelCampaignPublishToStoresDocument);
};
export const SalesChannelCampaignResultsDocument = gql`
    query SalesChannelCampaignResults($qop: SalesChannelCampaignResultQopInput) {
  salesChannelCampaignResults(qop: $qop) {
    items {
      salesChannelCampaignResultID
      salesChannelCampaignID
      branchID
      salesChannelID
      externalCampaignID
      status
      errorMessage
      branch {
        branchID
        branchCode
        branchName
      }
      entityAuditMetadata {
        updatedAt
      }
    }
  }
}
    `;

export function useSalesChannelCampaignResultsQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelCampaignResultsQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCampaignResultsQuery, SalesChannelCampaignResultsQueryVariables>({ query: SalesChannelCampaignResultsDocument, ...options });
};
export const SalesChannelCampaignSetCategoriesDocument = gql`
    mutation SalesChannelCampaignSetCategories($input: SalesChannelCampaignSetCategoriesInput!) {
  salesChannelCampaignSetCategories(input: $input) {
    salesChannelCampaignCategoryID
    salesChannelCampaignID
    salesChannelCategoryID
    salesChannelCategoryName
  }
}
    `;

export function useSalesChannelCampaignSetCategoriesMutation() {
  return Urql.useMutation<SalesChannelCampaignSetCategoriesMutation, SalesChannelCampaignSetCategoriesMutationVariables>(SalesChannelCampaignSetCategoriesDocument);
};
export const SalesChannelCampaignSetProductsDocument = gql`
    mutation SalesChannelCampaignSetProducts($input: SalesChannelCampaignSetProductsInput!) {
  salesChannelCampaignSetProducts(input: $input) {
    salesChannelCampaignProductID
    salesChannelCampaignID
    productID
    productCode
    productName
  }
}
    `;

export function useSalesChannelCampaignSetProductsMutation() {
  return Urql.useMutation<SalesChannelCampaignSetProductsMutation, SalesChannelCampaignSetProductsMutationVariables>(SalesChannelCampaignSetProductsDocument);
};
export const SalesChannelCampaignStopDocument = gql`
    mutation SalesChannelCampaignStop($salesChannelCampaignID: UUID!) {
  salesChannelCampaignStop(salesChannelCampaignID: $salesChannelCampaignID) {
    salesChannelCampaignID
    status
  }
}
    `;

export function useSalesChannelCampaignStopMutation() {
  return Urql.useMutation<SalesChannelCampaignStopMutation, SalesChannelCampaignStopMutationVariables>(SalesChannelCampaignStopDocument);
};
export const SalesChannelCampaignUpdateDocument = gql`
    mutation SalesChannelCampaignUpdate($input: SalesChannelCampaignUpdateInput!) {
  salesChannelCampaignUpdate(input: $input) {
    salesChannelCampaignID
  }
}
    `;

export function useSalesChannelCampaignUpdateMutation() {
  return Urql.useMutation<SalesChannelCampaignUpdateMutation, SalesChannelCampaignUpdateMutationVariables>(SalesChannelCampaignUpdateDocument);
};
export const SalesChannelCampaignsDocument = gql`
    query SalesChannelCampaigns($qop: SalesChannelCampaignQopInput) {
  salesChannelCampaigns(qop: $qop) {
    items {
      salesChannelCampaignID
      salesChannelCategoryGroupID
      salesChannelCategoryGroupName
      salesChannelCampaignName
      customTag
      status
      scopeType
      discountType
      discountValue
      discountCap
      startAt
      endAt
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useSalesChannelCampaignsQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelCampaignsQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCampaignsQuery, SalesChannelCampaignsQueryVariables>({ query: SalesChannelCampaignsDocument, ...options });
};
export const BranchProductSalesChannelItemDisableDocument = gql`
    mutation BranchProductSalesChannelItemDisable($input: BranchProductSalesChannelItemDisableInput!) {
  branchProductSalesChannelItemDisable(input: $input) {
    branchProductSalesChannelItemID
  }
}
    `;

export function useBranchProductSalesChannelItemDisableMutation() {
  return Urql.useMutation<BranchProductSalesChannelItemDisableMutation, BranchProductSalesChannelItemDisableMutationVariables>(BranchProductSalesChannelItemDisableDocument);
};
export const BranchProductSalesChannelItemRestoreDocument = gql`
    mutation BranchProductSalesChannelItemRestore($input: BranchProductSalesChannelItemRestoreInput!) {
  branchProductSalesChannelItemRestore(input: $input)
}
    `;

export function useBranchProductSalesChannelItemRestoreMutation() {
  return Urql.useMutation<BranchProductSalesChannelItemRestoreMutation, BranchProductSalesChannelItemRestoreMutationVariables>(BranchProductSalesChannelItemRestoreDocument);
};
export const BranchProductSalesChannelItemsDocument = gql`
    query BranchProductSalesChannelItems($qop: BranchProductSalesChannelItemQopInput) {
  branchProductSalesChannelItems(qop: $qop) {
    items {
      branchProductSalesChannelItemID
      branchID
      branchCode
      productID
      productCode
      productName
      product {
        barcode
      }
      salesChannelID
      salesChannelCategoryGroupID
      type
      note
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useBranchProductSalesChannelItemsQuery(options?: Omit<Urql.UseQueryArgs<BranchProductSalesChannelItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchProductSalesChannelItemsQuery, BranchProductSalesChannelItemsQueryVariables>({ query: BranchProductSalesChannelItemsDocument, ...options });
};
export const BranchSalesChannelCategoryGroupsDocument = gql`
    query BranchSalesChannelCategoryGroups($qop: BranchSalesChannelCategoryGroupQopInput) {
  branchSalesChannelCategoryGroups(qop: $qop) {
    items {
      branchSalesChannelCategoryGroupID
      branchID
      branchCode
      branchName
      salesChannelID
      salesChannelCategoryGroupID
      salesChannelCategoryGroupName
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useBranchSalesChannelCategoryGroupsQuery(options?: Omit<Urql.UseQueryArgs<BranchSalesChannelCategoryGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<BranchSalesChannelCategoryGroupsQuery, BranchSalesChannelCategoryGroupsQueryVariables>({ query: BranchSalesChannelCategoryGroupsDocument, ...options });
};
export const MenuGroupProductAddonsDocument = gql`
    query MenuGroupProductAddons($productAddonGroupID: UUID!) {
  productAddonGroupItemsByGroupID(productAddonGroupID: $productAddonGroupID) {
    productAddonGroupItemID
    sequence
    productAddon {
      productAddonID
      name
      isRequired
      isMultiple
      minQty
      maxQty
      showQty
      components {
        productAddonComponentID
        productName
        customSellingPrice
        priceType
        sequence
      }
    }
  }
}
    `;

export function useMenuGroupProductAddonsQuery(options: Omit<Urql.UseQueryArgs<MenuGroupProductAddonsQueryVariables>, 'query'>) {
  return Urql.useQuery<MenuGroupProductAddonsQuery, MenuGroupProductAddonsQueryVariables>({ query: MenuGroupProductAddonsDocument, ...options });
};
export const SalesChannelCategoriesDocument = gql`
    query SalesChannelCategories($qop: SalesChannelCategoryQopInput) {
  salesChannelCategories(qop: $qop) {
    items {
      salesChannelCategoryID
      salesChannelCategoryGroupID
      salesChannelCategoryName
      displayOrder
      isActive
      isInMenu
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useSalesChannelCategoriesQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelCategoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCategoriesQuery, SalesChannelCategoriesQueryVariables>({ query: SalesChannelCategoriesDocument, ...options });
};
export const SalesChannelCategoryCreateDocument = gql`
    mutation SalesChannelCategoryCreate($input: SalesChannelCategoryCreateInput!) {
  salesChannelCategoryCreate(input: $input) {
    salesChannelCategoryID
  }
}
    `;

export function useSalesChannelCategoryCreateMutation() {
  return Urql.useMutation<SalesChannelCategoryCreateMutation, SalesChannelCategoryCreateMutationVariables>(SalesChannelCategoryCreateDocument);
};
export const SalesChannelCategoryDeleteDocument = gql`
    mutation SalesChannelCategoryDelete($id: UUID!) {
  salesChannelCategoryDelete(salesChannelCategoryID: $id)
}
    `;

export function useSalesChannelCategoryDeleteMutation() {
  return Urql.useMutation<SalesChannelCategoryDeleteMutation, SalesChannelCategoryDeleteMutationVariables>(SalesChannelCategoryDeleteDocument);
};
export const SalesChannelCategoryGroupDocument = gql`
    query SalesChannelCategoryGroup($id: UUID!) {
  salesChannelCategoryGroup(salesChannelCategoryGroupID: $id) {
    salesChannelCategoryGroupID
    salesChannelCategoryGroupName
    isActive
    isUseMasterdataAvailability
  }
}
    `;

export function useSalesChannelCategoryGroupQuery(options: Omit<Urql.UseQueryArgs<SalesChannelCategoryGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCategoryGroupQuery, SalesChannelCategoryGroupQueryVariables>({ query: SalesChannelCategoryGroupDocument, ...options });
};
export const SalesChannelCategoryGroupCreateDocument = gql`
    mutation SalesChannelCategoryGroupCreate($input: SalesChannelCategoryGroupCreateInput!) {
  salesChannelCategoryGroupCreate(input: $input) {
    salesChannelCategoryGroupID
  }
}
    `;

export function useSalesChannelCategoryGroupCreateMutation() {
  return Urql.useMutation<SalesChannelCategoryGroupCreateMutation, SalesChannelCategoryGroupCreateMutationVariables>(SalesChannelCategoryGroupCreateDocument);
};
export const SalesChannelCategoryGroupDeleteDocument = gql`
    mutation SalesChannelCategoryGroupDelete($id: UUID!) {
  salesChannelCategoryGroupDelete(salesChannelCategoryGroupID: $id)
}
    `;

export function useSalesChannelCategoryGroupDeleteMutation() {
  return Urql.useMutation<SalesChannelCategoryGroupDeleteMutation, SalesChannelCategoryGroupDeleteMutationVariables>(SalesChannelCategoryGroupDeleteDocument);
};
export const SalesChannelCategoryGroupDeleteFromDetailDocument = gql`
    mutation SalesChannelCategoryGroupDeleteFromDetail($id: UUID!) {
  salesChannelCategoryGroupDelete(salesChannelCategoryGroupID: $id)
}
    `;

export function useSalesChannelCategoryGroupDeleteFromDetailMutation() {
  return Urql.useMutation<SalesChannelCategoryGroupDeleteFromDetailMutation, SalesChannelCategoryGroupDeleteFromDetailMutationVariables>(SalesChannelCategoryGroupDeleteFromDetailDocument);
};
export const SalesChannelCategoryGroupProductCreateDocument = gql`
    mutation SalesChannelCategoryGroupProductCreate($input: SalesChannelCategoryGroupProductCreateInput!) {
  salesChannelCategoryGroupProductCreate(input: $input) {
    salesChannelCategoryGroupProductID
  }
}
    `;

export function useSalesChannelCategoryGroupProductCreateMutation() {
  return Urql.useMutation<SalesChannelCategoryGroupProductCreateMutation, SalesChannelCategoryGroupProductCreateMutationVariables>(SalesChannelCategoryGroupProductCreateDocument);
};
export const SalesChannelCategoryGroupProductDeleteDocument = gql`
    mutation SalesChannelCategoryGroupProductDelete($id: UUID!) {
  salesChannelCategoryGroupProductDelete(salesChannelCategoryGroupProductID: $id)
}
    `;

export function useSalesChannelCategoryGroupProductDeleteMutation() {
  return Urql.useMutation<SalesChannelCategoryGroupProductDeleteMutation, SalesChannelCategoryGroupProductDeleteMutationVariables>(SalesChannelCategoryGroupProductDeleteDocument);
};
export const SalesChannelCategoryGroupProductReorderDocument = gql`
    mutation SalesChannelCategoryGroupProductReorder($input: [ReorderSalesChannelCategoryGroupProductInput!]!) {
  salesChannelCategoryGroupProductReorder(input: $input)
}
    `;

export function useSalesChannelCategoryGroupProductReorderMutation() {
  return Urql.useMutation<SalesChannelCategoryGroupProductReorderMutation, SalesChannelCategoryGroupProductReorderMutationVariables>(SalesChannelCategoryGroupProductReorderDocument);
};
export const SalesChannelCategoryGroupProductUpdateDocument = gql`
    mutation SalesChannelCategoryGroupProductUpdate($input: SalesChannelCategoryGroupProductUpdateInput!) {
  salesChannelCategoryGroupProductUpdate(input: $input) {
    salesChannelCategoryGroupProductID
  }
}
    `;

export function useSalesChannelCategoryGroupProductUpdateMutation() {
  return Urql.useMutation<SalesChannelCategoryGroupProductUpdateMutation, SalesChannelCategoryGroupProductUpdateMutationVariables>(SalesChannelCategoryGroupProductUpdateDocument);
};
export const SalesChannelCategoryGroupProductsDocument = gql`
    query SalesChannelCategoryGroupProducts($qop: SalesChannelCategoryGroupProductQopInput) {
  salesChannelCategoryGroupProducts(qop: $qop) {
    items {
      salesChannelCategoryGroupProductID
      salesChannelCategoryGroupID
      salesChannelCategoryID
      productID
      productCode
      productName
      barcode
      displayOrder
      isActive
      priceType
      customPrice
      imageType
      externalImageURL
      qty
      isOutOfStock
      isNoPrice
      product {
        productID
        productCode
        productName
        barcode
        isActive
        canBeSold
        mainImageFileMediumPathURL
        hasAddon
        addonGroupID
        addonGroup {
          productAddonGroupID
          name
        }
        baseUom {
          uomID
          uomName
        }
      }
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useSalesChannelCategoryGroupProductsQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelCategoryGroupProductsQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCategoryGroupProductsQuery, SalesChannelCategoryGroupProductsQueryVariables>({ query: SalesChannelCategoryGroupProductsDocument, ...options });
};
export const SalesChannelCategoryGroupUpdateDocument = gql`
    mutation SalesChannelCategoryGroupUpdate($input: SalesChannelCategoryGroupUpdateInput!) {
  salesChannelCategoryGroupUpdate(input: $input) {
    salesChannelCategoryGroupID
  }
}
    `;

export function useSalesChannelCategoryGroupUpdateMutation() {
  return Urql.useMutation<SalesChannelCategoryGroupUpdateMutation, SalesChannelCategoryGroupUpdateMutationVariables>(SalesChannelCategoryGroupUpdateDocument);
};
export const SalesChannelCategoryGroupsDocument = gql`
    query SalesChannelCategoryGroups($qop: SalesChannelCategoryGroupQopInput) {
  salesChannelCategoryGroups(qop: $qop) {
    items {
      salesChannelCategoryGroupID
      salesChannelCategoryGroupName
      isActive
      isUseMasterdataAvailability
    }
    pagination {
      totalRows
    }
  }
}
    `;

export function useSalesChannelCategoryGroupsQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelCategoryGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCategoryGroupsQuery, SalesChannelCategoryGroupsQueryVariables>({ query: SalesChannelCategoryGroupsDocument, ...options });
};
export const SalesChannelCategoryUpdateDocument = gql`
    mutation SalesChannelCategoryUpdate($input: SalesChannelCategoryUpdateInput!) {
  salesChannelCategoryUpdate(input: $input) {
    salesChannelCategoryID
  }
}
    `;

export function useSalesChannelCategoryUpdateMutation() {
  return Urql.useMutation<SalesChannelCategoryUpdateMutation, SalesChannelCategoryUpdateMutationVariables>(SalesChannelCategoryUpdateDocument);
};
export const MarketplaceChannelTaxonomyDocument = gql`
    query MarketplaceChannelTaxonomy($salesChannelID: String!) {
  marketplaceChannelTaxonomy(salesChannelID: $salesChannelID) {
    externalParentCategoryID
    externalParentCategoryName
    externalCategoryID
    externalCategoryName
  }
}
    `;

export function useMarketplaceChannelTaxonomyQuery(options: Omit<Urql.UseQueryArgs<MarketplaceChannelTaxonomyQueryVariables>, 'query'>) {
  return Urql.useQuery<MarketplaceChannelTaxonomyQuery, MarketplaceChannelTaxonomyQueryVariables>({ query: MarketplaceChannelTaxonomyDocument, ...options });
};
export const SalesChannelCategoryMapCreateDocument = gql`
    mutation SalesChannelCategoryMapCreate($input: ProductCategorySalesChannelMapCreateInput!) {
  productCategorySalesChannelMapCreate(input: $input) {
    productCategorySalesChannelMapID
    productCategoryID
    salesChannelID
    externalParentCategoryID
    externalParentCategoryName
    externalCategoryID
    externalCategoryName
    isActive
  }
}
    `;

export function useSalesChannelCategoryMapCreateMutation() {
  return Urql.useMutation<SalesChannelCategoryMapCreateMutation, SalesChannelCategoryMapCreateMutationVariables>(SalesChannelCategoryMapCreateDocument);
};
export const SalesChannelCategoryMapDeleteDocument = gql`
    mutation SalesChannelCategoryMapDelete($productCategorySalesChannelMapID: UUID!) {
  productCategorySalesChannelMapDelete(
    productCategorySalesChannelMapID: $productCategorySalesChannelMapID
  )
}
    `;

export function useSalesChannelCategoryMapDeleteMutation() {
  return Urql.useMutation<SalesChannelCategoryMapDeleteMutation, SalesChannelCategoryMapDeleteMutationVariables>(SalesChannelCategoryMapDeleteDocument);
};
export const SalesChannelCategoryMapExportDocument = gql`
    mutation SalesChannelCategoryMapExport($salesChannelID: String!) {
  productCategorySalesChannelMapExport(salesChannelID: $salesChannelID) {
    fileName
    downloadURL
  }
}
    `;

export function useSalesChannelCategoryMapExportMutation() {
  return Urql.useMutation<SalesChannelCategoryMapExportMutation, SalesChannelCategoryMapExportMutationVariables>(SalesChannelCategoryMapExportDocument);
};
export const SalesChannelCategoryMapImportDocument = gql`
    mutation SalesChannelCategoryMapImport($input: ProductCategorySalesChannelMapImportInput!) {
  productCategorySalesChannelMapImport(input: $input) {
    importedCount
    skippedCount
  }
}
    `;

export function useSalesChannelCategoryMapImportMutation() {
  return Urql.useMutation<SalesChannelCategoryMapImportMutation, SalesChannelCategoryMapImportMutationVariables>(SalesChannelCategoryMapImportDocument);
};
export const SalesChannelCategoryMapImportValidateDocument = gql`
    mutation SalesChannelCategoryMapImportValidate($input: ProductCategorySalesChannelMapImportValidateInput!) {
  productCategorySalesChannelMapImportValidate(input: $input) {
    missingProductCategoryCodes
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        standardKey
        label
        reason
        value
      }
    }
  }
}
    `;

export function useSalesChannelCategoryMapImportValidateMutation() {
  return Urql.useMutation<SalesChannelCategoryMapImportValidateMutation, SalesChannelCategoryMapImportValidateMutationVariables>(SalesChannelCategoryMapImportValidateDocument);
};
export const SalesChannelCategoryMapListDocument = gql`
    query SalesChannelCategoryMapList($qop: ProductCategorySalesChannelMapQopInput!) {
  productCategorySalesChannelMaps(qop: $qop) {
    items {
      productCategorySalesChannelMapID
      productCategoryID
      salesChannelID
      externalParentCategoryID
      externalParentCategoryName
      externalCategoryID
      externalCategoryName
      isActive
      productCategory {
        productCategoryID
        productCategoryName
      }
      salesChannel {
        salesChannelID
        salesChannelName
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useSalesChannelCategoryMapListQuery(options: Omit<Urql.UseQueryArgs<SalesChannelCategoryMapListQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCategoryMapListQuery, SalesChannelCategoryMapListQueryVariables>({ query: SalesChannelCategoryMapListDocument, ...options });
};
export const SalesChannelCategoryMapLoadDocument = gql`
    query SalesChannelCategoryMapLoad($productCategorySalesChannelMapID: UUID!) {
  productCategorySalesChannelMap(
    productCategorySalesChannelMapID: $productCategorySalesChannelMapID
  ) {
    productCategorySalesChannelMapID
    productCategoryID
    salesChannelID
    externalParentCategoryID
    externalParentCategoryName
    externalCategoryID
    externalCategoryName
    isActive
    productCategory {
      productCategoryID
      productCategoryName
    }
    salesChannel {
      salesChannelID
      salesChannelName
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useSalesChannelCategoryMapLoadQuery(options: Omit<Urql.UseQueryArgs<SalesChannelCategoryMapLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelCategoryMapLoadQuery, SalesChannelCategoryMapLoadQueryVariables>({ query: SalesChannelCategoryMapLoadDocument, ...options });
};
export const SalesChannelCategoryMapUpdateDocument = gql`
    mutation SalesChannelCategoryMapUpdate($input: ProductCategorySalesChannelMapUpdateInput!) {
  productCategorySalesChannelMapUpdate(input: $input) {
    productCategorySalesChannelMapID
    productCategoryID
    salesChannelID
    externalParentCategoryID
    externalParentCategoryName
    externalCategoryID
    externalCategoryName
    isActive
  }
}
    `;

export function useSalesChannelCategoryMapUpdateMutation() {
  return Urql.useMutation<SalesChannelCategoryMapUpdateMutation, SalesChannelCategoryMapUpdateMutationVariables>(SalesChannelCategoryMapUpdateDocument);
};
export const SalesChannelStockThresholdCreateDocument = gql`
    mutation SalesChannelStockThresholdCreate($input: SalesChannelStockThresholdCreateInput!) {
  salesChannelStockThresholdCreate(input: $input) {
    salesChannelStockThresholdID
  }
}
    `;

export function useSalesChannelStockThresholdCreateMutation() {
  return Urql.useMutation<SalesChannelStockThresholdCreateMutation, SalesChannelStockThresholdCreateMutationVariables>(SalesChannelStockThresholdCreateDocument);
};
export const SalesChannelStockThresholdDeleteDocument = gql`
    mutation SalesChannelStockThresholdDelete($salesChannelStockThresholdID: UUID!) {
  salesChannelStockThresholdDelete(
    salesChannelStockThresholdID: $salesChannelStockThresholdID
  )
}
    `;

export function useSalesChannelStockThresholdDeleteMutation() {
  return Urql.useMutation<SalesChannelStockThresholdDeleteMutation, SalesChannelStockThresholdDeleteMutationVariables>(SalesChannelStockThresholdDeleteDocument);
};
export const SalesChannelStockThresholdListDocument = gql`
    query SalesChannelStockThresholdList($qop: SalesChannelStockThresholdQopInput) {
  salesChannelStockThresholds(qop: $qop) {
    items {
      salesChannelStockThresholdID
      salesChannelID
      thresholdType
      thresholdValue
      isActive
      note
      entityAuditMetadata {
        version
        updatedAt
      }
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    `;

export function useSalesChannelStockThresholdListQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelStockThresholdListQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelStockThresholdListQuery, SalesChannelStockThresholdListQueryVariables>({ query: SalesChannelStockThresholdListDocument, ...options });
};
export const SalesChannelStockThresholdUpdateDocument = gql`
    mutation SalesChannelStockThresholdUpdate($input: SalesChannelStockThresholdUpdateInput!) {
  salesChannelStockThresholdUpdate(input: $input) {
    salesChannelStockThresholdID
  }
}
    `;

export function useSalesChannelStockThresholdUpdateMutation() {
  return Urql.useMutation<SalesChannelStockThresholdUpdateMutation, SalesChannelStockThresholdUpdateMutationVariables>(SalesChannelStockThresholdUpdateDocument);
};
export const SalesChannelCreateDocument = gql`
    mutation SalesChannelCreate($input: SalesChannelCreateInput!) {
  SalesChannelCreate(input: $input) {
    salesChannelID
    salesChannelName
    salesChannelType
    commisionPerc
    additionalCharge
    isMain
    isActive
    defaultMenuImageURL
  }
}
    `;

export function useSalesChannelCreateMutation() {
  return Urql.useMutation<SalesChannelCreateMutation, SalesChannelCreateMutationVariables>(SalesChannelCreateDocument);
};
export const SalesChannelDeleteDocument = gql`
    mutation SalesChannelDelete($salesChannelID: String!) {
  SalesChannelDelete(salesChannelID: $salesChannelID)
}
    `;

export function useSalesChannelDeleteMutation() {
  return Urql.useMutation<SalesChannelDeleteMutation, SalesChannelDeleteMutationVariables>(SalesChannelDeleteDocument);
};
export const SalesChannelLoadDocument = gql`
    query SalesChannelLoad($salesChannelID: String!) {
  salesChannel(salesChannelID: $salesChannelID) {
    salesChannelID
    salesChannelName
    salesChannelType
    commisionPerc
    additionalCharge
    isMain
    isActive
    defaultMenuImageURL
  }
}
    `;

export function useSalesChannelLoadQuery(options: Omit<Urql.UseQueryArgs<SalesChannelLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelLoadQuery, SalesChannelLoadQueryVariables>({ query: SalesChannelLoadDocument, ...options });
};
export const SalesChannelUpdateDocument = gql`
    mutation SalesChannelUpdate($input: SalesChannelUpdateInput!) {
  SalesChannelUpdate(input: $input) {
    salesChannelID
    salesChannelName
    salesChannelType
    commisionPerc
    additionalCharge
    isMain
    isActive
    defaultMenuImageURL
  }
}
    `;

export function useSalesChannelUpdateMutation() {
  return Urql.useMutation<SalesChannelUpdateMutation, SalesChannelUpdateMutationVariables>(SalesChannelUpdateDocument);
};
export const SalesChannelsDocument = gql`
    query SalesChannels($qop: SalesChannelQopInput) {
  salesChannels(qop: $qop) {
    items {
      salesChannelID
      salesChannelName
      salesChannelType
      commisionPerc
      additionalCharge
      isMain
      isActive
      defaultMenuImageURL
    }
    pagination {
      totalRows
      page
      pageSize
    }
  }
}
    `;

export function useSalesChannelsQuery(options?: Omit<Urql.UseQueryArgs<SalesChannelsQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesChannelsQuery, SalesChannelsQueryVariables>({ query: SalesChannelsDocument, ...options });
};
export const SalesDashboardDocument = gql`
    query SalesDashboard($filter: SalesDashboardFilterInput) {
  salesDashboard(filter: $filter) {
    summary {
      totalSales
      invoiceCount
      totalItems
      totalItemProduct
      totalItemBundle
      totalItemConsignment
      avgBasket
      totalTax
      totalDiscount
    }
    salesByDay {
      date
      total
      invoiceCount
    }
    salesByHour {
      bucket
      total
      invoiceCount
    }
    topProducts {
      productID
      productName
      qty
      total
    }
    topProductsByRevenue {
      productID
      productName
      qty
      total
    }
  }
}
    `;

export function useSalesDashboardQuery(options?: Omit<Urql.UseQueryArgs<SalesDashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesDashboardQuery, SalesDashboardQueryVariables>({ query: SalesDashboardDocument, ...options });
};
export const SalesInvoiceReviewListDocument = gql`
    query SalesInvoiceReviewList($qop: SalesInvoiceReviewQopInput) {
  salesInvoiceReviews(qop: $qop) {
    items {
      salesInvoiceReviewID
      salesInvoiceID
      salesInvoiceNumber
      salesInvoiceDatetime
      salesInvoiceDatetimeUtc
      salesOrderNumber
      branchID
      branchCode
      branchName
      salesChannelName
      cashierUserName
      reviewType
      isNoteInternal
      amountDifference
      noteInternal
      total
      paymentAmount
      status
      isResolved
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useSalesInvoiceReviewListQuery(options?: Omit<Urql.UseQueryArgs<SalesInvoiceReviewListQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesInvoiceReviewListQuery, SalesInvoiceReviewListQueryVariables>({ query: SalesInvoiceReviewListDocument, ...options });
};
export const SalesInvoiceReviewLoadDocument = gql`
    query SalesInvoiceReviewLoad($salesInvoiceReviewID: UUID!) {
  salesInvoiceReview(salesInvoiceReviewID: $salesInvoiceReviewID) {
    salesInvoiceReviewID
    salesInvoiceID
    salesInvoiceNumber
    salesInvoiceType
    salesInvoiceStatus
    salesInvoiceDatetime
    salesInvoiceDatetimeUtc
    gmt
    salesOrderID
    salesOrderNumber
    branchID
    branchCode
    branchName
    salesChannelID
    salesChannelName
    shiftSessionID
    cashierUserID
    cashierUserName
    reviewType
    isNoteInternal
    amountDifference
    noteInternal
    total
    isResolved
    resolutionNote
    resolvedAt
    resolvedAtUtc
    resolvedByUserID
    resolvedByUserName
    status
    payments {
      salesInvoicePaymentID
      paymentMethodName
      paymentMethodTypeCode
      paymentAmount
      edcTerminalName
      bankReferenceNumber
      paymentTransactionID
      reconciliationStatus
    }
    paymentTransactions {
      paymentTransactionID
      paymentTransactionType
      providerCode
      amount
      status
      latestTransactionStatusCode
      transactionDatetime
      paidAt
      rrn
      approvalCode
      issuerName
      payerName
      cancelReason
    }
  }
}
    `;

export function useSalesInvoiceReviewLoadQuery(options: Omit<Urql.UseQueryArgs<SalesInvoiceReviewLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesInvoiceReviewLoadQuery, SalesInvoiceReviewLoadQueryVariables>({ query: SalesInvoiceReviewLoadDocument, ...options });
};
export const SalesInvoiceReviewRefreshDocument = gql`
    mutation SalesInvoiceReviewRefresh($salesInvoiceReviewID: UUID!) {
  salesInvoiceReviewRefresh(salesInvoiceReviewID: $salesInvoiceReviewID) {
    salesInvoiceReviewID
    salesInvoiceNumber
    reviewType
    amountDifference
    status
  }
}
    `;

export function useSalesInvoiceReviewRefreshMutation() {
  return Urql.useMutation<SalesInvoiceReviewRefreshMutation, SalesInvoiceReviewRefreshMutationVariables>(SalesInvoiceReviewRefreshDocument);
};
export const SalesInvoiceReviewResolveBulkDocument = gql`
    mutation SalesInvoiceReviewResolveBulk($input: SalesInvoiceReviewResolveBulkInput!) {
  salesInvoiceReviewResolveBulk(input: $input) {
    salesInvoiceReviewID
    salesInvoiceNumber
    success
    error
  }
}
    `;

export function useSalesInvoiceReviewResolveBulkMutation() {
  return Urql.useMutation<SalesInvoiceReviewResolveBulkMutation, SalesInvoiceReviewResolveBulkMutationVariables>(SalesInvoiceReviewResolveBulkDocument);
};
export const SalesInvoiceItemsDocument = gql`
    query SalesInvoiceItems($qop: SalesInvoiceItemQopInput) {
  salesInvoiceItems(qop: $qop) {
    items {
      salesInvoiceItemID
      salesInvoiceID
      productCode
      productName
      productNameAlias
      barcode
      status
      qty
      uomName
      unitPrice
      discountAmount
      total
      taxableAmount
      taxAmount
      promoType
      commissionAmount
      isConsignment
      consignmentVendorID
      consignmentCommissionFeePerc
      taxes {
        salesInvoiceItemTaxID
        taxCode
        taxRate
        taxableAmount
        taxAmount
      }
      product {
        productID
        productType
        productBundleComponents {
          qty
          uom {
            uomName
          }
          componentProduct {
            productCode
            productName
          }
        }
      }
      addonComponents {
        productID
        productCode
        productName
        qty
      }
      consignmentVendor {
        vendorID
        vendorCode
        vendorName
        isPKP
        consignmentCommissionFeePerc
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useSalesInvoiceItemsQuery(options?: Omit<Urql.UseQueryArgs<SalesInvoiceItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesInvoiceItemsQuery, SalesInvoiceItemsQueryVariables>({ query: SalesInvoiceItemsDocument, ...options });
};
export const SalesInvoiceListDocument = gql`
    query SalesInvoiceList($qop: SalesInvoiceQopInput) {
  salesInvoices(qop: $qop) {
    items {
      salesInvoiceID
      salesInvoiceNumber
      salesInvoiceDatetime
      salesInvoiceDatetimeUtc
      salesInvoiceType
      salesOrderNumber
      branchID
      customerID
      memberTypeName
      salesChannelName
      salesChannelType
      totalItemQty
      subtotal
      discountAmount
      taxAmount
      total
      status
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useSalesInvoiceListQuery(options?: Omit<Urql.UseQueryArgs<SalesInvoiceListQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesInvoiceListQuery, SalesInvoiceListQueryVariables>({ query: SalesInvoiceListDocument, ...options });
};
export const SalesInvoiceLoadDocument = gql`
    query SalesInvoiceLoad($salesInvoiceID: UUID!) {
  salesInvoice(salesInvoiceID: $salesInvoiceID) {
    salesInvoiceID
    salesInvoiceNumber
    salesInvoiceDatetime
    salesInvoiceDatetimeUtc
    salesInvoiceType
    salesOrderID
    salesOrderNumber
    shiftSessionID
    branchID
    gmt
    customerID
    memberTypeID
    memberTypeName
    salesChannelID
    salesChannelName
    salesChannelType
    warehouseID
    taxIncluded
    totalItemQty
    subtotal
    discountType
    discountPerc
    discountAmount
    subtotalAfterDiscount
    taxAmount
    adjustmentAmount
    total
    taxableAmount
    cashPaymentAmount
    nonCashPaymentAmount
    paymentReceivedAmount
    paymentChangeAmount
    paymentAmount
    paymentVoucherAmount
    noteInternal
    status
    payments {
      salesInvoicePaymentID
      paymentMethodName
      paymentMethodTypeName
      paymentMethodTypeCode
      paymentMethodTypeIsCash
      paymentMethodTypeIsCard
      edcTerminalName
      bankName
      bankAccountNumber
      cardNumber
      authCode
      paymentAmount
      isReconciliation
      reconciliationStatus
    }
    taxes {
      salesInvoiceTaxID
      taxCode
      taxRate
      taxableAmount
      taxAmount
    }
    shiftSession {
      shiftSessionID
      userName
      employeeName
      status
      sessionOpenTime
    }
    entityAuditMetadata {
      createdByUserName
      updatedByUserName
      createdAt
      updatedAt
    }
  }
}
    `;

export function useSalesInvoiceLoadQuery(options: Omit<Urql.UseQueryArgs<SalesInvoiceLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesInvoiceLoadQuery, SalesInvoiceLoadQueryVariables>({ query: SalesInvoiceLoadDocument, ...options });
};
export const SalesInvoicePointsDocument = gql`
    query SalesInvoicePoints($qop: CustomerPointTransactionQopInput) {
  customerPointTransactions(qop: $qop) {
    items {
      customerPointTransactionID
      customerPointTransactionNumber
      transactionDatetime
      earnedPoint
      pointBefore
      pointAfter
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    `;

export function useSalesInvoicePointsQuery(options?: Omit<Urql.UseQueryArgs<SalesInvoicePointsQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesInvoicePointsQuery, SalesInvoicePointsQueryVariables>({ query: SalesInvoicePointsDocument, ...options });
};
export const SalesInvoiceVouchersDocument = gql`
    query SalesInvoiceVouchers($qop: CustomerVoucherTransactionQopInput) {
  customerVoucherTransactions(qop: $qop) {
    items {
      customerVoucherTransactionID
      customerVoucherTransactionNumber
      transactionDatetime
      voucherCode
      voucherName
      voucherItemCode
      voucherValue
      paymentAmount
      status
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    `;

export function useSalesInvoiceVouchersQuery(options?: Omit<Urql.UseQueryArgs<SalesInvoiceVouchersQueryVariables>, 'query'>) {
  return Urql.useQuery<SalesInvoiceVouchersQuery, SalesInvoiceVouchersQueryVariables>({ query: SalesInvoiceVouchersDocument, ...options });
};
export const DeliveryOrderItemsDocument = gql`
    query DeliveryOrderItems($qop: DeliveryOrderItemQopInput) {
  deliveryOrderItems(qop: $qop) {
    items {
      baseUomQty
      uomConvertionRate
      uomDecimal
      uomConversionDecimal
      uomID
      qty
      uomName
      productWeight
      productName
      productCode
      product {
        barcode
      }
      productID
      deliveryOrderID
      deliveryOrderItemID
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useDeliveryOrderItemsQuery(options?: Omit<Urql.UseQueryArgs<DeliveryOrderItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<DeliveryOrderItemsQuery, DeliveryOrderItemsQueryVariables>({ query: DeliveryOrderItemsDocument, ...options });
};
export const SimpleTransferOrderReceivingCancelDocument = gql`
    mutation SimpleTransferOrderReceivingCancel($simpleTransferOrderReceivingID: UUID!) {
  simpleTransferOrderReceivingCancel(
    simpleTransferOrderReceivingID: $simpleTransferOrderReceivingID
  )
}
    `;

export function useSimpleTransferOrderReceivingCancelMutation() {
  return Urql.useMutation<SimpleTransferOrderReceivingCancelMutation, SimpleTransferOrderReceivingCancelMutationVariables>(SimpleTransferOrderReceivingCancelDocument);
};
export const SimpleTransferOrderReceivingConfirmDocument = gql`
    mutation SimpleTransferOrderReceivingConfirm($simpleTransferOrderReceivingID: UUID!) {
  simpleTransferOrderReceivingConfirm(
    simpleTransferOrderReceivingID: $simpleTransferOrderReceivingID
  ) {
    simpleTransferOrderReceivingID
  }
}
    `;

export function useSimpleTransferOrderReceivingConfirmMutation() {
  return Urql.useMutation<SimpleTransferOrderReceivingConfirmMutation, SimpleTransferOrderReceivingConfirmMutationVariables>(SimpleTransferOrderReceivingConfirmDocument);
};
export const SimpleTransferOrderReceivingCreateDocument = gql`
    mutation SimpleTransferOrderReceivingCreate($input: SimpleTransferOrderReceivingCreateInput!) {
  simpleTransferOrderReceivingCreate(input: $input) {
    simpleTransferOrderReceivingID
  }
}
    `;

export function useSimpleTransferOrderReceivingCreateMutation() {
  return Urql.useMutation<SimpleTransferOrderReceivingCreateMutation, SimpleTransferOrderReceivingCreateMutationVariables>(SimpleTransferOrderReceivingCreateDocument);
};
export const SimpleTransferOrderReceivingCreateAndConfirmDocument = gql`
    mutation SimpleTransferOrderReceivingCreateAndConfirm($input: SimpleTransferOrderReceivingCreateAndConfirmInput!) {
  simpleTransferOrderReceivingCreateAndConfirm(input: $input) {
    simpleTransferOrderReceivingID
    simpleTransferOrderReceivingNumber
    status
    actionType
  }
}
    `;

export function useSimpleTransferOrderReceivingCreateAndConfirmMutation() {
  return Urql.useMutation<SimpleTransferOrderReceivingCreateAndConfirmMutation, SimpleTransferOrderReceivingCreateAndConfirmMutationVariables>(SimpleTransferOrderReceivingCreateAndConfirmDocument);
};
export const SimpleTransferOrderReceivingListItemsDocument = gql`
    query SimpleTransferOrderReceivingListItems($qop: SimpleTransferOrderReceivingItemQopInput) {
  simpleTransferOrderReceivingItems(qop: $qop) {
    items {
      note
      baseUomQty
      uomConversionDecimal
      uomConversionRate
      uomDecimal
      uomID
      uomCategoryID
      uomName
      qtyReceived
      doQty
      toUomConversionDecimal
      toUomConversionRate
      toUomID
      toQtyOutstanding
      toQtyReceived
      toQty
      description
      productName
      productCode
      product {
        barcode
      }
      productWeight
      simpleTransferOrderReceivingItemID
      simpleTransferOrderReceivingID
      simpleTransferOrderID
      simpleTransferOrderItemID
      productID
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useSimpleTransferOrderReceivingListItemsQuery(options?: Omit<Urql.UseQueryArgs<SimpleTransferOrderReceivingListItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<SimpleTransferOrderReceivingListItemsQuery, SimpleTransferOrderReceivingListItemsQueryVariables>({ query: SimpleTransferOrderReceivingListItemsDocument, ...options });
};
export const SimpleTransferOrderReceivingLoadDocument = gql`
    query SimpleTransferOrderReceivingLoad($simpleTransferOrderReceivingID: UUID!) {
  simpleTransferOrderReceiving(
    simpleTransferOrderReceivingID: $simpleTransferOrderReceivingID
  ) {
    simpleTransferOrderReceivingID
    simpleTransferOrderReceivingNumber
    simpleTransferOrderReceivingDatetime
    branchID
    branchCode
    branchName
    gmt
    deliveryOrderID
    deliveryOrderNumber
    deliveryBy
    simpleTransferOrderID
    simpleTransferOrderNumber
    originWarehouseID
    warehouseID
    warehouseLocationID
    vendorID
    vendorCode
    vendorName
    vendorRefNumber
    vehiclePlateNumber
    driverName
    driverPhoneNumber
    closeSto
    totalItemQtyReceived
    totalItemWeightReceived
    noteInternal
    status
    warehouseLocation {
      warehouseLocationID
      warehouseLocationName
    }
    originWarehouse {
      warehouseID
      warehouseName
    }
    warehouse {
      warehouseID
      warehouseName
    }
    files {
      simpleTransferOrderReceivingFileID
      simpleTransferOrderReceivingID
      simpleTransferOrderReceivingFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
      uniqueKey
    }
  }
}
    `;

export function useSimpleTransferOrderReceivingLoadQuery(options: Omit<Urql.UseQueryArgs<SimpleTransferOrderReceivingLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<SimpleTransferOrderReceivingLoadQuery, SimpleTransferOrderReceivingLoadQueryVariables>({ query: SimpleTransferOrderReceivingLoadDocument, ...options });
};
export const SimpleTransferOrderReceivingUpdateDocument = gql`
    mutation SimpleTransferOrderReceivingUpdate($input: SimpleTransferOrderReceivingUpdateInput!) {
  simpleTransferOrderReceivingUpdate(input: $input) {
    simpleTransferOrderReceivingID
  }
}
    `;

export function useSimpleTransferOrderReceivingUpdateMutation() {
  return Urql.useMutation<SimpleTransferOrderReceivingUpdateMutation, SimpleTransferOrderReceivingUpdateMutationVariables>(SimpleTransferOrderReceivingUpdateDocument);
};
export const SimpleTransferOrderReceivingUpdateAndConfirmDocument = gql`
    mutation SimpleTransferOrderReceivingUpdateAndConfirm($input: SimpleTransferOrderReceivingUpdateAndConfirmInput!) {
  simpleTransferOrderReceivingUpdateAndConfirm(input: $input) {
    simpleTransferOrderReceivingID
    simpleTransferOrderReceivingNumber
    status
    actionType
  }
}
    `;

export function useSimpleTransferOrderReceivingUpdateAndConfirmMutation() {
  return Urql.useMutation<SimpleTransferOrderReceivingUpdateAndConfirmMutation, SimpleTransferOrderReceivingUpdateAndConfirmMutationVariables>(SimpleTransferOrderReceivingUpdateAndConfirmDocument);
};
export const SimpleTransferOrderCancelDocument = gql`
    mutation SimpleTransferOrderCancel($input: SimpleTransferOrderCancelInput!) {
  simpleTransferOrderCancel(input: $input) {
    simpleTransferOrderID
    simpleTransferOrderNumber
    simpleTransferOrderDatetime
    simpleTransferOrderDatetimeUtc
    scheduledDeliveryDate
    branchID
    gmt
    fromWarehouseID
    fromWarehouseName
    toWarehouseID
    toWarehouseName
    totalItemQty
    totalItemWeight
    totalItemQtyReadyToShip
    totalItemQtyShipped
    totalItemQtyUnfulfilled
    confirmDatetime
    confirmDatetimeUtc
    confirmByUserID
    confirmByUserName
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteForReceiver
    status
    deliveryOrderID
    deliveryOrderNumber
  }
}
    `;

export function useSimpleTransferOrderCancelMutation() {
  return Urql.useMutation<SimpleTransferOrderCancelMutation, SimpleTransferOrderCancelMutationVariables>(SimpleTransferOrderCancelDocument);
};
export const SimpleTransferOrderConfirmDocument = gql`
    mutation SimpleTransferOrderConfirm($input: SimpleTransferOrderConfirmInput!) {
  simpleTransferOrderConfirm(input: $input) {
    simpleTransferOrderID
    simpleTransferOrderNumber
    simpleTransferOrderDatetime
    simpleTransferOrderDatetimeUtc
    scheduledDeliveryDate
    branchID
    gmt
    fromWarehouseID
    fromWarehouseName
    toWarehouseID
    toWarehouseName
    totalItemQty
    totalItemWeight
    totalItemQtyReadyToShip
    totalItemQtyShipped
    totalItemQtyUnfulfilled
    confirmDatetime
    confirmDatetimeUtc
    confirmByUserID
    confirmByUserName
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteForReceiver
    status
    deliveryOrderID
    deliveryOrderNumber
  }
}
    `;

export function useSimpleTransferOrderConfirmMutation() {
  return Urql.useMutation<SimpleTransferOrderConfirmMutation, SimpleTransferOrderConfirmMutationVariables>(SimpleTransferOrderConfirmDocument);
};
export const SimpleTransferOrderCreateDocument = gql`
    mutation SimpleTransferOrderCreate($input: SimpleTransferOrderCreateInput!) {
  simpleTransferOrderCreate(input: $input) {
    simpleTransferOrderID
    simpleTransferOrderNumber
    simpleTransferOrderDatetime
    simpleTransferOrderDatetimeUtc
    scheduledDeliveryDate
    branchID
    gmt
    fromWarehouseID
    fromWarehouseName
    toWarehouseID
    toWarehouseName
    totalItemQty
    totalItemWeight
    totalItemQtyReadyToShip
    totalItemQtyShipped
    totalItemQtyUnfulfilled
    confirmDatetime
    confirmDatetimeUtc
    confirmByUserID
    confirmByUserName
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteForReceiver
    status
    deliveryOrderID
    deliveryOrderNumber
  }
}
    `;

export function useSimpleTransferOrderCreateMutation() {
  return Urql.useMutation<SimpleTransferOrderCreateMutation, SimpleTransferOrderCreateMutationVariables>(SimpleTransferOrderCreateDocument);
};
export const SimpleTransferOrderDeleteDocument = gql`
    mutation SimpleTransferOrderDelete($transferOrderSimpleID: UUID!) {
  simpleTransferOrderDelete(transferOrderSimpleID: $transferOrderSimpleID)
}
    `;

export function useSimpleTransferOrderDeleteMutation() {
  return Urql.useMutation<SimpleTransferOrderDeleteMutation, SimpleTransferOrderDeleteMutationVariables>(SimpleTransferOrderDeleteDocument);
};
export const SimpleTransferOrderItemLoadDocument = gql`
    query SimpleTransferOrderItemLoad($transferOrderSimpleItemID: UUID!) {
  simpleTransferOrderItem(transferOrderSimpleItemID: $transferOrderSimpleItemID) {
    simpleTransferOrderItemID
    simpleTransferOrderID
    productID
    productCode
    productName
    description
    productWeight
    qty
    qtyReadyToShip
    qtyShipped
    qtyUnfulfilled
    uomCategoryID
    uomID
    uomName
    uomDecimal
    uomConvertionRate
    uomConversionDecimal
    baseUomQty
    isMultiple
  }
}
    `;

export function useSimpleTransferOrderItemLoadQuery(options: Omit<Urql.UseQueryArgs<SimpleTransferOrderItemLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<SimpleTransferOrderItemLoadQuery, SimpleTransferOrderItemLoadQueryVariables>({ query: SimpleTransferOrderItemLoadDocument, ...options });
};
export const SimpleTransferOrderItemLocationsAutocompleteDocument = gql`
    query SimpleTransferOrderItemLocationsAutocomplete($qop: SimpleTransferOrderItemLocationQopInput!) {
  simpleTransferOrderItemLocations(qop: $qop) {
    items {
      simpleTransferOrderItemLocationID
      simpleTransferOrderItemID
      fromWarehouseLocationID
      fromWarehouseLocationName
      qty
      baseUomQty
      simpleTransferOrderItem {
        simpleTransferOrderItemID
        simpleTransferOrderID
        productID
        productCode
        productName
        description
        productWeight
        qty
        qtyReadyToShip
        qtyShipped
        qtyUnfulfilled
        uomCategoryID
        uomID
        uomName
        uomDecimal
        uomConvertionRate
        uomConversionDecimal
        baseUomQty
        isMultiple
        product {
          productID
          productCode
          productName
          productNameAlias
          productType
          barcode
          altBarcode1
          altBarcode2
          uomCategoryID
          baseUomID
          description
          productBrandID
          productSourceID
          productCategoryID
          productSubCategoryID
          addonGroupID
          hasAddon
          mainImageFileID
          mainImageFileSmallPathURL
          mainImageFileMediumPathURL
          mainImageFileLargePathURL
          isConsignment
          consignmentVendorID
          isSystem
          trackStock
          trackExpiredDate
          isProduced
          weight
          volumeLength
          volumeHeight
          volumeWidth
          canBePurchased
          purchaseCost
          minimumOrder
          purchaseUomID
          purchaseTaxID
          canBeSold
          sellingPrice
          salesUomID
          salesTaxID
          salesScanType
          uniqueKey
          isActive
        }
      }
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useSimpleTransferOrderItemLocationsAutocompleteQuery(options: Omit<Urql.UseQueryArgs<SimpleTransferOrderItemLocationsAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<SimpleTransferOrderItemLocationsAutocompleteQuery, SimpleTransferOrderItemLocationsAutocompleteQueryVariables>({ query: SimpleTransferOrderItemLocationsAutocompleteDocument, ...options });
};
export const SimpleTransferOrderItemListDocument = gql`
    query SimpleTransferOrderItemList($qop: SimpleTransferOrderItemQopInput) {
  simpleTransferOrderItems(qop: $qop) {
    items {
      simpleTransferOrderItemID
      simpleTransferOrderID
      productID
      productCode
      productName
      product {
        barcode
      }
      description
      productWeight
      qty
      qtyReadyToShip
      qtyShipped
      qtyUnfulfilled
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQty
      isMultiple
      locations {
        simpleTransferOrderItemLocationID
        simpleTransferOrderItemID
        fromWarehouseLocationID
        fromWarehouseLocationName
        qty
        baseUomQty
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useSimpleTransferOrderItemListQuery(options?: Omit<Urql.UseQueryArgs<SimpleTransferOrderItemListQueryVariables>, 'query'>) {
  return Urql.useQuery<SimpleTransferOrderItemListQuery, SimpleTransferOrderItemListQueryVariables>({ query: SimpleTransferOrderItemListDocument, ...options });
};
export const SimpleTransferOrderItemLocationsDocument = gql`
    query SimpleTransferOrderItemLocations($qop: SimpleTransferOrderItemLocationQopInput) {
  simpleTransferOrderItemLocations(qop: $qop) {
    items {
      simpleTransferOrderItemLocationID
      simpleTransferOrderItemID
      fromWarehouseLocationID
      fromWarehouseLocationName
      qty
      baseUomQty
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useSimpleTransferOrderItemLocationsQuery(options?: Omit<Urql.UseQueryArgs<SimpleTransferOrderItemLocationsQueryVariables>, 'query'>) {
  return Urql.useQuery<SimpleTransferOrderItemLocationsQuery, SimpleTransferOrderItemLocationsQueryVariables>({ query: SimpleTransferOrderItemLocationsDocument, ...options });
};
export const SimpleTransferOrderListDocument = gql`
    query SimpleTransferOrderList($qop: SimpleTransferOrderQopInput) {
  simpleTransferOrders(qop: $qop) {
    items {
      simpleTransferOrderID
      simpleTransferOrderNumber
      simpleTransferOrderDatetime
      simpleTransferOrderDatetimeUtc
      scheduledDeliveryDate
      branchID
      gmt
      fromWarehouseID
      fromWarehouseName
      toWarehouseID
      toWarehouseName
      totalItemQty
      totalItemWeight
      totalItemQtyReadyToShip
      totalItemQtyShipped
      totalItemQtyUnfulfilled
      confirmDatetime
      confirmDatetimeUtc
      confirmByUserID
      confirmByUserName
      cancelledDatetime
      cancelledDatetimeUtc
      cancelledByUserID
      cancelledByUserName
      cancellationReason
      noteInternal
      noteForReceiver
      status
      deliveryOrderID
      deliveryOrderNumber
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useSimpleTransferOrderListQuery(options?: Omit<Urql.UseQueryArgs<SimpleTransferOrderListQueryVariables>, 'query'>) {
  return Urql.useQuery<SimpleTransferOrderListQuery, SimpleTransferOrderListQueryVariables>({ query: SimpleTransferOrderListDocument, ...options });
};
export const SimpleTransferOrderLoadDocument = gql`
    query SimpleTransferOrderLoad($transferOrderSimpleID: UUID!) {
  simpleTransferOrder(transferOrderSimpleID: $transferOrderSimpleID) {
    simpleTransferOrderID
    simpleTransferOrderNumber
    simpleTransferOrderDatetime
    simpleTransferOrderDatetimeUtc
    scheduledDeliveryDate
    branchID
    gmt
    fromWarehouseID
    fromWarehouseName
    toWarehouseID
    toWarehouseName
    totalItemQty
    totalItemWeight
    totalItemQtyReadyToShip
    totalItemQtyShipped
    totalItemQtyUnfulfilled
    confirmDatetime
    confirmDatetimeUtc
    confirmByUserID
    confirmByUserName
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteForReceiver
    status
    deliveryOrderID
    deliveryOrderNumber
    deliveredDatetime
    deliveredDatetimeUtc
    deliveryOrder {
      deliveryOrderID
      deliveryOrderNumber
      deliveryOrderDatetime
      deliveryOrderDatetimeUTC
      branchID
      gmt
      sourceDocumentType
      sourceDocumentID
      sourceDocumentNumber
      fromWarehouseID
      fromWarehouseCode
      fromWarehouseName
      toWarehouseID
      toWarehouseCode
      toWarehouseName
      deliveryAddress
      deliveryBy
      vendorID
      vendorCode
      vendorName
      vendorRefNumber
      landedCost
      totalContainers
      totalItems
      totalItemQty
      noteInternal
      shippedDatetime
      shippedDatetimeUTC
      shippedByUserID
      shippedByUserName
      vehiclePlateNumber
      driverName
      driverPhoneNumber
      cancelledDatetime
      cancelledDatetimeUTC
      cancelledByUserID
      cancelledByUserName
      cancellationReason
      status
    }
  }
}
    `;

export function useSimpleTransferOrderLoadQuery(options: Omit<Urql.UseQueryArgs<SimpleTransferOrderLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<SimpleTransferOrderLoadQuery, SimpleTransferOrderLoadQueryVariables>({ query: SimpleTransferOrderLoadDocument, ...options });
};
export const SimpleTransferOrderUpdateDocument = gql`
    mutation SimpleTransferOrderUpdate($input: SimpleTransferOrderUpdateInput!) {
  simpleTransferOrderUpdate(input: $input) {
    simpleTransferOrderID
    simpleTransferOrderNumber
    simpleTransferOrderDatetime
    simpleTransferOrderDatetimeUtc
    scheduledDeliveryDate
    branchID
    gmt
    fromWarehouseID
    fromWarehouseName
    toWarehouseID
    toWarehouseName
    totalItemQty
    totalItemWeight
    totalItemQtyReadyToShip
    totalItemQtyShipped
    totalItemQtyUnfulfilled
    confirmDatetime
    confirmDatetimeUtc
    confirmByUserID
    confirmByUserName
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteForReceiver
    status
    deliveryOrderID
    deliveryOrderNumber
  }
}
    `;

export function useSimpleTransferOrderUpdateMutation() {
  return Urql.useMutation<SimpleTransferOrderUpdateMutation, SimpleTransferOrderUpdateMutationVariables>(SimpleTransferOrderUpdateDocument);
};
export const TaxAutocompleteDocument = gql`
    query TaxAutocomplete($qop: TaxQopInput!) {
  taxes(qop: $qop) {
    items {
      taxID
      taxCode
      taxName
      taxType
      taxRate
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useTaxAutocompleteQuery(options: Omit<Urql.UseQueryArgs<TaxAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<TaxAutocompleteQuery, TaxAutocompleteQueryVariables>({ query: TaxAutocompleteDocument, ...options });
};
export const TaxCreateDocument = gql`
    mutation TaxCreate($input: TaxCreateInput!) {
  taxCreate(input: $input) {
    taxID
    taxCode
    taxName
    taxRate
    taxType
    uniqueKey
    isActive
  }
}
    `;

export function useTaxCreateMutation() {
  return Urql.useMutation<TaxCreateMutation, TaxCreateMutationVariables>(TaxCreateDocument);
};
export const TaxDeleteDocument = gql`
    mutation TaxDelete($taxID: UUID!) {
  taxDelete(taxID: $taxID)
}
    `;

export function useTaxDeleteMutation() {
  return Urql.useMutation<TaxDeleteMutation, TaxDeleteMutationVariables>(TaxDeleteDocument);
};
export const TaxListDocument = gql`
    query TaxList($qop: TaxQopInput!) {
  taxes(qop: $qop) {
    items {
      taxID
      taxCode
      taxName
      taxRate
      taxType
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useTaxListQuery(options: Omit<Urql.UseQueryArgs<TaxListQueryVariables>, 'query'>) {
  return Urql.useQuery<TaxListQuery, TaxListQueryVariables>({ query: TaxListDocument, ...options });
};
export const TaxDocument = gql`
    query Tax($taxID: UUID!) {
  tax(taxID: $taxID) {
    taxID
    taxCode
    taxName
    taxRate
    taxType
    uniqueKey
    isActive
  }
}
    `;

export function useTaxQuery(options: Omit<Urql.UseQueryArgs<TaxQueryVariables>, 'query'>) {
  return Urql.useQuery<TaxQuery, TaxQueryVariables>({ query: TaxDocument, ...options });
};
export const TaxUpdateDocument = gql`
    mutation TaxUpdate($input: TaxUpdateInput!) {
  taxUpdate(input: $input) {
    taxID
    taxCode
    taxName
    taxRate
    taxType
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useTaxUpdateMutation() {
  return Urql.useMutation<TaxUpdateMutation, TaxUpdateMutationVariables>(TaxUpdateDocument);
};
export const TransferOrderCancelDocument = gql`
    mutation TransferOrderCancel($input: TransferOrderCancelInput!) {
  transferOrderCancel(input: $input) {
    transferOrderID
    cancellationReason
  }
}
    `;

export function useTransferOrderCancelMutation() {
  return Urql.useMutation<TransferOrderCancelMutation, TransferOrderCancelMutationVariables>(TransferOrderCancelDocument);
};
export const TransferOrderCheckGenerateBulkDocument = gql`
    mutation TransferOrderCheckGenerateBulk($input: DeliveryOrderGenerateBulkInput!) {
  deliveryOrderCheckGenerateBulk(input: $input) {
    fromWarehouseName
    totalContainerReady
    sourceDocumentNumber
    sourceDocumentID
  }
}
    `;

export function useTransferOrderCheckGenerateBulkMutation() {
  return Urql.useMutation<TransferOrderCheckGenerateBulkMutation, TransferOrderCheckGenerateBulkMutationVariables>(TransferOrderCheckGenerateBulkDocument);
};
export const TransferOrderConfirmDocument = gql`
    mutation TransferOrderConfirm($input: TransferOrderConfirmInput!) {
  transferOrderConfirm(input: $input) {
    transferOrderID
  }
}
    `;

export function useTransferOrderConfirmMutation() {
  return Urql.useMutation<TransferOrderConfirmMutation, TransferOrderConfirmMutationVariables>(TransferOrderConfirmDocument);
};
export const TransferOrderCreateDocument = gql`
    mutation TransferOrderCreate($input: TransferOrderCreateInput!) {
  transferOrderCreate(input: $input) {
    transferOrderNumber
    transferOrderDatetime
    branchID
    scheduledDeliveryDate
    fromWarehouseID
    toWarehouseID
    noteInternal
    noteForReceiver
  }
}
    `;

export function useTransferOrderCreateMutation() {
  return Urql.useMutation<TransferOrderCreateMutation, TransferOrderCreateMutationVariables>(TransferOrderCreateDocument);
};
export const TransferOrderGenerateBulkDocument = gql`
    mutation TransferOrderGenerateBulk($input: DeliveryOrderGenerateBulkInput!) {
  deliveryOrderGenerateBulk(input: $input)
}
    `;

export function useTransferOrderGenerateBulkMutation() {
  return Urql.useMutation<TransferOrderGenerateBulkMutation, TransferOrderGenerateBulkMutationVariables>(TransferOrderGenerateBulkDocument);
};
export const TransferOrderGeneratePickingMultipleDocument = gql`
    mutation TransferOrderGeneratePickingMultiple($input: PickingTaskGenerateBulkInput!) {
  pickingTaskGenerateBulk(input: $input) {
    sourceDocumentType
    sourceDocumentID
    warehouseID
    assignedToUserID
  }
}
    `;

export function useTransferOrderGeneratePickingMultipleMutation() {
  return Urql.useMutation<TransferOrderGeneratePickingMultipleMutation, TransferOrderGeneratePickingMultipleMutationVariables>(TransferOrderGeneratePickingMultipleDocument);
};
export const TransferOrderGeneratePickingSingleDocument = gql`
    mutation TransferOrderGeneratePickingSingle($input: PickingTaskGenerateInput!) {
  pickingTaskGenerate(input: $input) {
    sourceDocumentType
    sourceDocumentID
    warehouseID
    assignedToUserID
  }
}
    `;

export function useTransferOrderGeneratePickingSingleMutation() {
  return Urql.useMutation<TransferOrderGeneratePickingSingleMutation, TransferOrderGeneratePickingSingleMutationVariables>(TransferOrderGeneratePickingSingleDocument);
};
export const TransferOrderImportDocument = gql`
    mutation TransferOrderImport($input: TransferOrderImportInput!) {
  transferOrderImport(input: $input)
}
    `;

export function useTransferOrderImportMutation() {
  return Urql.useMutation<TransferOrderImportMutation, TransferOrderImportMutationVariables>(TransferOrderImportDocument);
};
export const TransferOrderImportValidateCodesDocument = gql`
    mutation TransferOrderImportValidateCodes($input: TransferOrderImportValidateCodesInput!) {
  transferOrderImportValidateCodes(input: $input) {
    missingBranchCodes
    missingWarehouseCodes
    missingProductCodes
    consignmentProductCodes
    duplicateProductCodes
    missingProductUoms {
      rowNumber
      productCode
      uomName
    }
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        standardKey
        label
        reason
        value
      }
    }
  }
}
    `;

export function useTransferOrderImportValidateCodesMutation() {
  return Urql.useMutation<TransferOrderImportValidateCodesMutation, TransferOrderImportValidateCodesMutationVariables>(TransferOrderImportValidateCodesDocument);
};
export const TransferOrderListDocument = gql`
    query TransferOrderList($qop: TransferOrderQopInput) {
  transferOrders(qop: $qop) {
    items {
      transferOrderNumber
      transferOrderDatetime
      status
      toWarehouseName
      fromWarehouseName
      transferOrderID
      fromWarehouseID
      isPickingTaskComplated
      isReadyGenerateDeliveryOrder
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useTransferOrderListQuery(options?: Omit<Urql.UseQueryArgs<TransferOrderListQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferOrderListQuery, TransferOrderListQueryVariables>({ query: TransferOrderListDocument, ...options });
};
export const TransferOrderLoadDocument = gql`
    query TransferOrderLoad($transferOrderID: UUID!) {
  transferOrder(transferOrderID: $transferOrderID) {
    transferOrderID
    transferOrderNumber
    transferOrderDatetime
    transferOrderDatetimeUtc
    scheduledDeliveryDate
    branchID
    branchCode
    branchName
    gmt
    fromWarehouseID
    fromWarehouseCode
    isPickingTaskComplated
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    totalItemQty
    totalItemWeight
    totalItemQtyReadyToPick
    totalItemQtyReadyToPack
    totalItemQtyReadyToShip
    totalItemQtyShipped
    totalItemQtyUnfulfilled
    confirmDatetime
    confirmDatetimeUtc
    confirmByUserID
    confirmByUserName
    cancelledDatetime
    transferRequest {
      transferRequestNumber
      scheduledDeliveryDate
      transferRequestDatetime
    }
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteForReceiver
    status
    isReadyGenerateDeliveryOrder
    isPickingTaskComplated
    doneByUserName
    doneDatetime
    doneReason
  }
}
    `;

export function useTransferOrderLoadQuery(options: Omit<Urql.UseQueryArgs<TransferOrderLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferOrderLoadQuery, TransferOrderLoadQueryVariables>({ query: TransferOrderLoadDocument, ...options });
};
export const TransferOrderMarkAsDoneDocument = gql`
    mutation TransferOrderMarkAsDone($input: TransferOrderMarkAsDoneInput!) {
  transferOrderMarkAsDone(input: $input) {
    transferOrderID
  }
}
    `;

export function useTransferOrderMarkAsDoneMutation() {
  return Urql.useMutation<TransferOrderMarkAsDoneMutation, TransferOrderMarkAsDoneMutationVariables>(TransferOrderMarkAsDoneDocument);
};
export const TransferOrderProductsLoadDocument = gql`
    query TransferOrderProductsLoad($qop: TransferOrderItemQopInput) {
  transferOrderItems(qop: $qop) {
    items {
      productID
      productName
      productCode
      product {
        barcode
      }
      productWeight
      qty
      qtyReadyToPick
      qtyReadyToPack
      qtyReadyToShip
      qtyShipped
      qtyUnfulfilled
      uomName
      uomID
      transferOrderItemID
      baseUomQty
      uomCategoryID
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useTransferOrderProductsLoadQuery(options?: Omit<Urql.UseQueryArgs<TransferOrderProductsLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferOrderProductsLoadQuery, TransferOrderProductsLoadQueryVariables>({ query: TransferOrderProductsLoadDocument, ...options });
};
export const TransferOrderUpdateDocument = gql`
    mutation TransferOrderUpdate($input: TransferOrderUpdateInput!) {
  transferOrderUpdate(input: $input) {
    transferOrderID
    scheduledDeliveryDate
    fromWarehouseID
    toWarehouseID
    noteInternal
    noteForReceiver
    transferOrderDatetime
  }
}
    `;

export function useTransferOrderUpdateMutation() {
  return Urql.useMutation<TransferOrderUpdateMutation, TransferOrderUpdateMutationVariables>(TransferOrderUpdateDocument);
};
export const TransferOrderWarehouseLocationLoadDocument = gql`
    query TransferOrderWarehouseLocationLoad($qop: WarehouseLocationQopInput!) {
  warehouseLocations(qop: $qop) {
    items {
      warehouseLocationID
      warehouseLocationName
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useTransferOrderWarehouseLocationLoadQuery(options: Omit<Urql.UseQueryArgs<TransferOrderWarehouseLocationLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferOrderWarehouseLocationLoadQuery, TransferOrderWarehouseLocationLoadQueryVariables>({ query: TransferOrderWarehouseLocationLoadDocument, ...options });
};
export const WarehouseLocationGroupsDocument = gql`
    query warehouseLocationGroups($qop: WarehouseLocationGroupQopInput!) {
  warehouseLocationGroups(qop: $qop) {
    items {
      warehouseLocationGroupID
      warehouseLocationGroupName
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useWarehouseLocationGroupsQuery(options: Omit<Urql.UseQueryArgs<WarehouseLocationGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseLocationGroupsQuery, WarehouseLocationGroupsQueryVariables>({ query: WarehouseLocationGroupsDocument, ...options });
};
export const GenerateTransferRequestFromReplenishmentDocument = gql`
    mutation GenerateTransferRequestFromReplenishment($input: GenerateTransferRequestFromReplenishmentInput!) {
  generateTransferRequestFromReplenishment(input: $input) {
    transferRequestID
    transferRequestNumber
    replenishmentID
    status
  }
}
    `;

export function useGenerateTransferRequestFromReplenishmentMutation() {
  return Urql.useMutation<GenerateTransferRequestFromReplenishmentMutation, GenerateTransferRequestFromReplenishmentMutationVariables>(GenerateTransferRequestFromReplenishmentDocument);
};
export const TransferRequestApproveDocument = gql`
    mutation TransferRequestApprove($input: TransferRequestApproveInput!) {
  transferRequestApprove(input: $input) {
    transferRequestID
    transferRequestNumber
    transferRequestDatetime
    transferRequestDatetimeUtc
    scheduledDeliveryDate
    branchID
    branchCode
    branchName
    gmt
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    totalItemQtyRequested
    totalItemQtyApproved
    submittedDatetime
    submittedDatetimeUtc
    submittedByUserID
    submittedByUserName
    approvedDatetime
    approvedDatetimeUtc
    approvedByUserID
    approvedByUserName
    rejectedDatetime
    rejectedDatetimeUtc
    rejectedByUserID
    rejectedByUserName
    rejectionReason
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteApprover
    status
  }
}
    `;

export function useTransferRequestApproveMutation() {
  return Urql.useMutation<TransferRequestApproveMutation, TransferRequestApproveMutationVariables>(TransferRequestApproveDocument);
};
export const TransferRequestCancelDocument = gql`
    mutation TransferRequestCancel($input: TransferRequestCancelInput!) {
  transferRequestCancel(input: $input) {
    transferRequestID
    transferRequestNumber
    transferRequestDatetime
    transferRequestDatetimeUtc
    scheduledDeliveryDate
    branchID
    branchCode
    branchName
    gmt
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    totalItemQtyRequested
    totalItemQtyApproved
    submittedDatetime
    submittedDatetimeUtc
    submittedByUserID
    submittedByUserName
    approvedDatetime
    approvedDatetimeUtc
    approvedByUserID
    approvedByUserName
    rejectedDatetime
    rejectedDatetimeUtc
    rejectedByUserID
    rejectedByUserName
    rejectionReason
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteApprover
    status
  }
}
    `;

export function useTransferRequestCancelMutation() {
  return Urql.useMutation<TransferRequestCancelMutation, TransferRequestCancelMutationVariables>(TransferRequestCancelDocument);
};
export const TransferRequestCreateDocument = gql`
    mutation TransferRequestCreate($input: TransferRequestCreateInput!) {
  transferRequestCreate(input: $input) {
    transferRequestID
    transferRequestNumber
    transferRequestDatetime
    transferRequestDatetimeUtc
    scheduledDeliveryDate
    transferOrderID
    transferOrderNumber
    branchID
    branchCode
    branchName
    gmt
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    totalItemQtyRequested
    totalItemQtyApproved
    submittedDatetime
    submittedDatetimeUtc
    submittedByUserID
    submittedByUserName
    approvedDatetime
    approvedDatetimeUtc
    approvedByUserID
    approvedByUserName
    rejectedDatetime
    rejectedDatetimeUtc
    rejectedByUserID
    rejectedByUserName
    rejectionReason
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteForApprover
    status
    items {
      transferRequestItemID
      transferRequestID
      productID
      productCode
      productName
      description
      productWeight
      qtyRequested
      qtyApproved
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQtyRequested
      baseUomQtyApproved
      noteApprover
      noteRequester
    }
  }
}
    `;

export function useTransferRequestCreateMutation() {
  return Urql.useMutation<TransferRequestCreateMutation, TransferRequestCreateMutationVariables>(TransferRequestCreateDocument);
};
export const TransferRequestImportDocument = gql`
    mutation TransferRequestImport($input: TransferRequestImportInput!) {
  transferRequestImport(input: $input)
}
    `;

export function useTransferRequestImportMutation() {
  return Urql.useMutation<TransferRequestImportMutation, TransferRequestImportMutationVariables>(TransferRequestImportDocument);
};
export const TransferRequestImportValidateCodesDocument = gql`
    mutation TransferRequestImportValidateCodes($input: TransferRequestImportValidateCodesInput!) {
  transferRequestImportValidateCodes(input: $input) {
    missingBranchCodes
    missingWarehouseCodes
    missingProductCodes
    consignmentProductCodes
    duplicateProductCodes
    rowReport {
      totalRows
      validRowCount
      invalidRowCount
      violationSample {
        rowNumber
        standardKey
        label
        reason
        value
      }
    }
  }
}
    `;

export function useTransferRequestImportValidateCodesMutation() {
  return Urql.useMutation<TransferRequestImportValidateCodesMutation, TransferRequestImportValidateCodesMutationVariables>(TransferRequestImportValidateCodesDocument);
};
export const TransferRequestItemsDocument = gql`
    query TransferRequestItems($qop: TransferRequestItemQopInput!) {
  transferRequestItems(qop: $qop) {
    items {
      transferRequestItemID
      transferRequestID
      productID
      productCode
      productName
      product {
        barcode
      }
      description
      productWeight
      qtyRequested
      qtyApproved
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQtyRequested
      baseUomQtyApproved
      noteApprover
      noteRequester
      availability {
        warehouseID
        qtyAvailable
        qtyOutstandingIn
        qtyOutstandingOut
        qtyRealAvailable
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useTransferRequestItemsQuery(options: Omit<Urql.UseQueryArgs<TransferRequestItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferRequestItemsQuery, TransferRequestItemsQueryVariables>({ query: TransferRequestItemsDocument, ...options });
};
export const TransferRequestListDocument = gql`
    query TransferRequestList($qop: TransferRequestQopInput) {
  transferRequests(qop: $qop) {
    items {
      transferRequestID
      transferRequestNumber
      transferRequestDatetime
      transferRequestDatetimeUtc
      scheduledDeliveryDate
      transferOrderID
      transferOrderNumber
      branchID
      branchCode
      branchName
      gmt
      fromWarehouseID
      fromWarehouseCode
      fromWarehouseName
      toWarehouseID
      toWarehouseCode
      toWarehouseName
      totalItemQtyRequested
      totalItemQtyApproved
      submittedDatetime
      submittedDatetimeUtc
      submittedByUserID
      submittedByUserName
      approvedDatetime
      approvedDatetimeUtc
      approvedByUserID
      approvedByUserName
      rejectedDatetime
      rejectedDatetimeUtc
      rejectedByUserID
      rejectedByUserName
      rejectionReason
      cancelledDatetime
      cancelledDatetimeUtc
      cancelledByUserID
      cancelledByUserName
      cancellationReason
      noteInternal
      noteApprover
      status
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useTransferRequestListQuery(options?: Omit<Urql.UseQueryArgs<TransferRequestListQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferRequestListQuery, TransferRequestListQueryVariables>({ query: TransferRequestListDocument, ...options });
};
export const TransferRequestLoadDocument = gql`
    query TransferRequestLoad($transferRequestID: UUID!) {
  transferRequest(transferRequestID: $transferRequestID) {
    transferRequestID
    transferRequestNumber
    transferRequestDatetime
    transferRequestDatetimeUtc
    scheduledDeliveryDate
    transferOrderID
    transferOrderNumber
    branchID
    branchCode
    branchName
    gmt
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    totalItemQtyRequested
    totalItemQtyApproved
    submittedDatetime
    submittedDatetimeUtc
    submittedByUserID
    submittedByUserName
    approvedDatetime
    approvedDatetimeUtc
    approvedByUserID
    approvedByUserName
    rejectedDatetime
    rejectedDatetimeUtc
    rejectedByUserID
    rejectedByUserName
    rejectionReason
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteForApprover
    noteApprover
    status
    items {
      transferRequestItemID
      transferRequestID
      productID
      productCode
      productName
      description
      productWeight
      qtyRequested
      qtyApproved
      uomCategoryID
      uomID
      uomName
      uomDecimal
      uomConvertionRate
      uomConversionDecimal
      baseUomQtyRequested
      baseUomQtyApproved
      noteApprover
      noteRequester
      product {
        productID
        productCode
        productName
        productNameAlias
        productType
        barcode
        altBarcode1
        altBarcode2
        uomCategoryID
        baseUomID
        description
        productBrandID
        productSourceID
        productCategoryID
        productSubCategoryID
        addonGroupID
        hasAddon
        mainImageFileID
        mainImageFileSmallPathURL
        mainImageFileMediumPathURL
        mainImageFileLargePathURL
        isConsignment
        consignmentVendorID
        trackExpiredDate
        isProduced
        weight
        volumeLength
        volumeHeight
        volumeWidth
        canBePurchased
        purchaseCost
        minimumOrder
        purchaseUomID
        purchaseTaxID
        canBeSold
        sellingPrice
        salesUomID
        salesTaxID
        salesScanType
        uniqueKey
        isActive
      }
    }
  }
}
    `;

export function useTransferRequestLoadQuery(options: Omit<Urql.UseQueryArgs<TransferRequestLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<TransferRequestLoadQuery, TransferRequestLoadQueryVariables>({ query: TransferRequestLoadDocument, ...options });
};
export const TransferRequestRejectDocument = gql`
    mutation TransferRequestReject($input: TransferRequestRejectInput!) {
  transferRequestReject(input: $input) {
    transferRequestID
    transferRequestNumber
    transferRequestDatetime
    transferRequestDatetimeUtc
    scheduledDeliveryDate
    branchID
    branchCode
    branchName
    gmt
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    totalItemQtyRequested
    totalItemQtyApproved
    submittedDatetime
    submittedDatetimeUtc
    submittedByUserID
    submittedByUserName
    approvedDatetime
    approvedDatetimeUtc
    approvedByUserID
    approvedByUserName
    rejectedDatetime
    rejectedDatetimeUtc
    rejectedByUserID
    rejectedByUserName
    rejectionReason
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteApprover
    status
  }
}
    `;

export function useTransferRequestRejectMutation() {
  return Urql.useMutation<TransferRequestRejectMutation, TransferRequestRejectMutationVariables>(TransferRequestRejectDocument);
};
export const TransferRequestSubmitDocument = gql`
    mutation TransferRequestSubmit($input: TransferRequestSubmitInput!) {
  transferRequestSubmit(input: $input) {
    transferRequestID
    transferRequestNumber
    transferRequestDatetime
    transferRequestDatetimeUtc
    scheduledDeliveryDate
    branchID
    branchCode
    branchName
    gmt
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    totalItemQtyRequested
    totalItemQtyApproved
    submittedDatetime
    submittedDatetimeUtc
    submittedByUserID
    submittedByUserName
    approvedDatetime
    approvedDatetimeUtc
    approvedByUserID
    approvedByUserName
    rejectedDatetime
    rejectedDatetimeUtc
    rejectedByUserID
    rejectedByUserName
    rejectionReason
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteApprover
    status
  }
}
    `;

export function useTransferRequestSubmitMutation() {
  return Urql.useMutation<TransferRequestSubmitMutation, TransferRequestSubmitMutationVariables>(TransferRequestSubmitDocument);
};
export const TransferRequestUpdateDocument = gql`
    mutation TransferRequestUpdate($input: TransferRequestUpdateInput!) {
  transferRequestUpdate(input: $input) {
    transferRequestID
    transferRequestNumber
    transferRequestDatetime
    transferRequestDatetimeUtc
    scheduledDeliveryDate
    branchID
    branchCode
    branchName
    gmt
    fromWarehouseID
    fromWarehouseCode
    fromWarehouseName
    toWarehouseID
    toWarehouseCode
    toWarehouseName
    totalItemQtyRequested
    totalItemQtyApproved
    submittedDatetime
    submittedDatetimeUtc
    submittedByUserID
    submittedByUserName
    approvedDatetime
    approvedDatetimeUtc
    approvedByUserID
    approvedByUserName
    rejectedDatetime
    rejectedDatetimeUtc
    rejectedByUserID
    rejectedByUserName
    rejectionReason
    cancelledDatetime
    cancelledDatetimeUtc
    cancelledByUserID
    cancelledByUserName
    cancellationReason
    noteInternal
    noteForApprover
    status
  }
}
    `;

export function useTransferRequestUpdateMutation() {
  return Urql.useMutation<TransferRequestUpdateMutation, TransferRequestUpdateMutationVariables>(TransferRequestUpdateDocument);
};
export const UomCategoryAutocompleteDocument = gql`
    query UomCategoryAutocomplete($qop: UomCategoryQopInput) {
  uomCategories(qop: $qop) {
    items {
      uomCategoryID
      uomCategoryName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useUomCategoryAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<UomCategoryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<UomCategoryAutocompleteQuery, UomCategoryAutocompleteQueryVariables>({ query: UomCategoryAutocompleteDocument, ...options });
};
export const UomCategoryCreateDocument = gql`
    mutation UomCategoryCreate($input: UomCategoryCreateInput!) {
  uomCategoryCreate(input: $input) {
    uomCategoryID
    uomCategoryName
    description
    baseUom
    uomItems
    uniqueKey
    isActive
  }
}
    `;

export function useUomCategoryCreateMutation() {
  return Urql.useMutation<UomCategoryCreateMutation, UomCategoryCreateMutationVariables>(UomCategoryCreateDocument);
};
export const UomCategoryDeleteDocument = gql`
    mutation UomCategoryDelete($input: UomCategoryDeleteInput!) {
  uomCategoryDelete(input: $input)
}
    `;

export function useUomCategoryDeleteMutation() {
  return Urql.useMutation<UomCategoryDeleteMutation, UomCategoryDeleteMutationVariables>(UomCategoryDeleteDocument);
};
export const UomCategoryListDocument = gql`
    query UomCategoryList($qop: UomCategoryQopInput) {
  uomCategories(qop: $qop) {
    items {
      uomCategoryID
      uomCategoryName
      description
      baseUom
      uomItems
      uniqueKey
      isActive
      uoms {
        uomID
        uomCategoryID
        uomName
        relationType
        convertionRate
        convertionDecimal
        isMain
        uniqueKey
        uniqueKey2
        isActive
        entityAuditMetadata {
          createdByUserID
          createdByUserName
          updatedByUserID
          updatedByUserName
          deletedByUserID
          deletedByUserName
          createdAt
          updatedAt
          deletedAt
          version
        }
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useUomCategoryListQuery(options?: Omit<Urql.UseQueryArgs<UomCategoryListQueryVariables>, 'query'>) {
  return Urql.useQuery<UomCategoryListQuery, UomCategoryListQueryVariables>({ query: UomCategoryListDocument, ...options });
};
export const UomCategoryLoadDocument = gql`
    query UomCategoryLoad($uomCategoryID: UUID!) {
  uomCategory(uomCategoryID: $uomCategoryID) {
    uomCategoryID
    uomCategoryName
    description
    baseUom
    uomItems
    uniqueKey
    isActive
    nonMainUoms {
      uomID
      uomCategoryID
      uomName
      relationType
      convertionRate
      convertionDecimal
      isMain
      uniqueKey
      uniqueKey2
      isActive
    }
    uoms {
      uomID
      uomCategoryID
      uomName
      relationType
      convertionRate
      convertionDecimal
      isMain
      uniqueKey
      uniqueKey2
      isActive
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useUomCategoryLoadQuery(options: Omit<Urql.UseQueryArgs<UomCategoryLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<UomCategoryLoadQuery, UomCategoryLoadQueryVariables>({ query: UomCategoryLoadDocument, ...options });
};
export const UomCategoryUpdateDocument = gql`
    mutation UomCategoryUpdate($input: UomCategoryUpdateInput!) {
  uomCategoryUpdate(input: $input) {
    uomCategoryID
    uomCategoryName
    description
    baseUom
    uomItems
    uniqueKey
    isActive
  }
}
    `;

export function useUomCategoryUpdateMutation() {
  return Urql.useMutation<UomCategoryUpdateMutation, UomCategoryUpdateMutationVariables>(UomCategoryUpdateDocument);
};
export const UomsDocument = gql`
    query Uoms($qop: UomQopInput) {
  uoms(qop: $qop) {
    items {
      uomID
      uomCategoryID
      uomName
      relationType
      convertionRate
      convertionRateMultiplier
      convertionDecimal
      conversionInfo
      isMain
      uniqueKey
      uniqueKey2
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useUomsQuery(options?: Omit<Urql.UseQueryArgs<UomsQueryVariables>, 'query'>) {
  return Urql.useQuery<UomsQuery, UomsQueryVariables>({ query: UomsDocument, ...options });
};
export const UomAutocompleteDocument = gql`
    query UomAutocomplete($qop: UomQopInput) {
  uoms(qop: $qop) {
    items {
      uomID
      uomName
      uomCategoryID
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useUomAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<UomAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<UomAutocompleteQuery, UomAutocompleteQueryVariables>({ query: UomAutocompleteDocument, ...options });
};
export const UomLoadMiniDocument = gql`
    query UomLoadMini($uomID: UUID!) {
  uom(uomID: $uomID) {
    uomID
    uomName
  }
}
    `;

export function useUomLoadMiniQuery(options: Omit<Urql.UseQueryArgs<UomLoadMiniQueryVariables>, 'query'>) {
  return Urql.useQuery<UomLoadMiniQuery, UomLoadMiniQueryVariables>({ query: UomLoadMiniDocument, ...options });
};
export const ShiftSessionCloseDocument = gql`
    mutation ShiftSessionClose($input: ShiftSessionCloseInput!) {
  shiftSessionClose(input: $input) {
    shiftSession {
      shiftSessionID
      status
      endingCashBalance
      cashBalanceDiff
      isCashBalanceDiff
      sessionCloseTime
    }
  }
}
    `;

export function useShiftSessionCloseMutation() {
  return Urql.useMutation<ShiftSessionCloseMutation, ShiftSessionCloseMutationVariables>(ShiftSessionCloseDocument);
};
export const ShiftSessionListDocument = gql`
    query ShiftSessionList($qop: ShiftSessionQopInput) {
  shiftSessions(qop: $qop) {
    items {
      shiftSessionID
      userID
      userName
      employeeID
      employeeName
      branchID
      gmt
      sessionOpenTime
      sessionCloseTime
      sessionDuration
      openingCashBalance
      endingCashBalance
      totalTransactionAmount
      cashTransactionAmount
      nonCashTransactionAmount
      cashBalanceDiff
      isCashBalanceDiff
      voucherTransactionCount
      voucherTransactionAmount
      isResolved
      resolutionStatus
      status
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useShiftSessionListQuery(options?: Omit<Urql.UseQueryArgs<ShiftSessionListQueryVariables>, 'query'>) {
  return Urql.useQuery<ShiftSessionListQuery, ShiftSessionListQueryVariables>({ query: ShiftSessionListDocument, ...options });
};
export const ShiftSessionLoadDocument = gql`
    query ShiftSessionLoad($shiftSessionID: UUID!) {
  shiftSession(shiftSessionID: $shiftSessionID) {
    shiftSessionID
    userID
    userName
    employeeID
    employeeName
    branchID
    branch {
      branchID
      branchName
    }
    gmt
    sessionOpenTime
    sessionOpenTimeUtc
    sessionCloseTime
    sessionCloseTimeUtc
    sessionDuration
    openingCashBalance
    endingCashBalance
    totalTransactionAmount
    cashTransactionAmount
    nonCashTransactionAmount
    cashBalanceDiff
    isCashBalanceDiff
    voucherTransactionCount
    voucherTransactionAmount
    isResolved
    resolutionStatus
    resolutionNote
    resolvedAt
    resolvedAtUtc
    resolvedByUserID
    resolvedByUserName
    status
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      createdAt
      updatedAt
    }
  }
}
    `;

export function useShiftSessionLoadQuery(options: Omit<Urql.UseQueryArgs<ShiftSessionLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<ShiftSessionLoadQuery, ShiftSessionLoadQueryVariables>({ query: ShiftSessionLoadDocument, ...options });
};
export const ShiftSessionRecomputeDocument = gql`
    mutation ShiftSessionRecompute($shiftSessionID: UUID!) {
  shiftSessionRecompute(shiftSessionID: $shiftSessionID) {
    shiftSessionID
    status
    totalTransactionAmount
    cashTransactionAmount
    nonCashTransactionAmount
    voucherTransactionCount
    voucherTransactionAmount
    cashBalanceDiff
    isCashBalanceDiff
    isResolved
  }
}
    `;

export function useShiftSessionRecomputeMutation() {
  return Urql.useMutation<ShiftSessionRecomputeMutation, ShiftSessionRecomputeMutationVariables>(ShiftSessionRecomputeDocument);
};
export const ShiftSessionResolveCashDiffDocument = gql`
    mutation ShiftSessionResolveCashDiff($input: ShiftSessionResolveCashDiffInput!) {
  shiftSessionResolveCashDiff(input: $input) {
    shiftSessionID
    status
    isResolved
    resolutionStatus
    resolutionNote
    resolvedAt
    resolvedByUserName
  }
}
    `;

export function useShiftSessionResolveCashDiffMutation() {
  return Urql.useMutation<ShiftSessionResolveCashDiffMutation, ShiftSessionResolveCashDiffMutationVariables>(ShiftSessionResolveCashDiffDocument);
};
export const VendorAppBranchStockDocument = gql`
    query VendorAppBranchStock($qop: VendorConsignmentStockByBranchQopInput!) {
  vendorConsignmentStockByBranch(qop: $qop) {
    items {
      branchID
      branchName
      productID
      product {
        productID
        productCode
        productName
        barcode
        productType
        isActive
        baseUom {
          uomName
        }
      }
      qty
      qtyCommitted
      qtyRejected
      qtyOnHand
      qtyAvailable
      updatedAt
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppBranchStockQuery(options: Omit<Urql.UseQueryArgs<VendorAppBranchStockQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppBranchStockQuery, VendorAppBranchStockQueryVariables>({ query: VendorAppBranchStockDocument, ...options });
};
export const VendorAppProductListDocument = gql`
    query VendorAppProductList($qop: ProductQopInput) {
  products(qop: $qop) {
    items {
      productID
      productCode
      productName
      barcode
      productType
      consignmentVendorID
      isActive
      mainImageFileSmallPathURL
      baseUom {
        uomName
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppProductListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppProductListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppProductListQuery, VendorAppProductListQueryVariables>({ query: VendorAppProductListDocument, ...options });
};
export const VendorAppProductLoadDocument = gql`
    query VendorAppProductLoad($productID: UUID!) {
  product(productID: $productID) {
    productID
    productCode
    productName
    productNameAlias
    barcode
    altBarcode1
    altBarcode2
    productType
    description
    weight
    volumeLength
    volumeHeight
    volumeWidth
    isConsignment
    consignmentVendorID
    isActive
    mainImageFileSmallPathURL
    mainImageFileMediumPathURL
    mainImageFileLargePathURL
    baseUom {
      uomName
    }
    productBrand {
      productBrandName
    }
    productCategory {
      productCategoryName
    }
    productSubCategory {
      productSubCategoryName
    }
    productFiles {
      productFileID
      imageFileMediumPathURL
    }
  }
}
    `;

export function useVendorAppProductLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppProductLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppProductLoadQuery, VendorAppProductLoadQueryVariables>({ query: VendorAppProductLoadDocument, ...options });
};
export const VendorAppRentalBranchListDocument = gql`
    query VendorAppRentalBranchList($vendorID: UUID!) {
  vendor(vendorID: $vendorID) {
    vendorID
    vendorName
    vendorConsignmentBranch {
      vendorConsignmentBranchID
      branchID
      branchCode
      branchName
      isRent
      rentPrice
      isActive
      currentPeriod {
        vendorConsignmentBranchPeriodID
        effectiveStartDate
        effectiveEndDate
        rentalStatus
      }
    }
  }
}
    `;

export function useVendorAppRentalBranchListQuery(options: Omit<Urql.UseQueryArgs<VendorAppRentalBranchListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppRentalBranchListQuery, VendorAppRentalBranchListQueryVariables>({ query: VendorAppRentalBranchListDocument, ...options });
};
export const VendorAppRentalPaymentCancelDocument = gql`
    mutation VendorAppRentalPaymentCancel($input: VendorConsignmentRentalPaymentCancelInput!) {
  vendorConsignmentRentalPaymentCancel(input: $input) {
    vendorConsignmentRentalPaymentID
    status
  }
}
    `;

export function useVendorAppRentalPaymentCancelMutation() {
  return Urql.useMutation<VendorAppRentalPaymentCancelMutation, VendorAppRentalPaymentCancelMutationVariables>(VendorAppRentalPaymentCancelDocument);
};
export const VendorAppRentalPaymentCreateDocument = gql`
    mutation VendorAppRentalPaymentCreate($input: VendorConsignmentRentalPaymentCreateInput!) {
  vendorConsignmentRentalPaymentCreate(input: $input) {
    vendorConsignmentRentalPaymentID
    status
    rentPriceSnapshot
    rentPeriodDaysSnapshot
    transferAmount
    transferDate
  }
}
    `;

export function useVendorAppRentalPaymentCreateMutation() {
  return Urql.useMutation<VendorAppRentalPaymentCreateMutation, VendorAppRentalPaymentCreateMutationVariables>(VendorAppRentalPaymentCreateDocument);
};
export const VendorAppRentalPaymentListDocument = gql`
    query VendorAppRentalPaymentList($qop: VendorConsignmentRentalPaymentQopInput) {
  vendorConsignmentRentalPayments(qop: $qop) {
    items {
      vendorConsignmentRentalPaymentID
      vendorConsignmentRentalPaymentNumber
      vendorConsignmentBranchID
      vendorID
      vendorName
      branchID
      branchName
      transferAmount
      transferDate
      vendorNote
      rentPriceSnapshot
      rentPeriodDaysSnapshot
      status
      approvedAt
      rejectedReason
      rejectedAt
      files {
        vendorConsignmentRentalPaymentFileID
        vendorConsignmentRentalPaymentFileType
        fileID
        imageFileSmallPathURL
        imageFileMediumPathURL
        imageFileLargePathURL
      }
      entityAuditMetadata {
        createdAt
        updatedAt
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorAppRentalPaymentListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppRentalPaymentListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppRentalPaymentListQuery, VendorAppRentalPaymentListQueryVariables>({ query: VendorAppRentalPaymentListDocument, ...options });
};
export const VendorAppRentalPaymentLoadDocument = gql`
    query VendorAppRentalPaymentLoad($vendorConsignmentRentalPaymentID: UUID!) {
  vendorConsignmentRentalPayment(
    vendorConsignmentRentalPaymentID: $vendorConsignmentRentalPaymentID
  ) {
    vendorConsignmentRentalPaymentID
    vendorConsignmentRentalPaymentNumber
    vendorConsignmentBranchID
    vendorID
    vendorName
    branchID
    branchName
    transferAmount
    transferDate
    vendorNote
    rentPriceSnapshot
    rentPeriodDaysSnapshot
    effectiveStartDate
    effectiveEndDate
    status
    settlementBankName
    settlementBankAccountNumber
    approvedByUserName
    approvedAt
    rejectedReason
    rejectedByUserName
    rejectedAt
    files {
      vendorConsignmentRentalPaymentFileID
      vendorConsignmentRentalPaymentFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
    }
    entityAuditMetadata {
      createdAt
      updatedAt
    }
  }
}
    `;

export function useVendorAppRentalPaymentLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppRentalPaymentLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppRentalPaymentLoadQuery, VendorAppRentalPaymentLoadQueryVariables>({ query: VendorAppRentalPaymentLoadDocument, ...options });
};
export const VendorAppRentalPaymentSubmitDocument = gql`
    mutation VendorAppRentalPaymentSubmit($input: VendorConsignmentRentalPaymentSubmitInput!) {
  vendorConsignmentRentalPaymentSubmit(input: $input) {
    vendorConsignmentRentalPaymentID
    status
  }
}
    `;

export function useVendorAppRentalPaymentSubmitMutation() {
  return Urql.useMutation<VendorAppRentalPaymentSubmitMutation, VendorAppRentalPaymentSubmitMutationVariables>(VendorAppRentalPaymentSubmitDocument);
};
export const VendorAppRentalPaymentUpdateDocument = gql`
    mutation VendorAppRentalPaymentUpdate($input: VendorConsignmentRentalPaymentUpdateInput!) {
  vendorConsignmentRentalPaymentUpdate(input: $input) {
    vendorConsignmentRentalPaymentID
    status
    transferAmount
    transferDate
  }
}
    `;

export function useVendorAppRentalPaymentUpdateMutation() {
  return Urql.useMutation<VendorAppRentalPaymentUpdateMutation, VendorAppRentalPaymentUpdateMutationVariables>(VendorAppRentalPaymentUpdateDocument);
};
export const VendorAppSalesItemsListDocument = gql`
    query VendorAppSalesItemsList($qop: SalesConsignmentInvoiceItemQopInput) {
  salesConsignmentInvoiceItems(qop: $qop) {
    items {
      salesConsignmentInvoiceItemID
      productID
      productCode
      productName
      barcode
      qty
      uomName
      unitPrice
      discountType
      discountPerc
      discountPercPlus
      discountAmount
      additionalDiscountPerc
      additionalDiscountAmount
      commissionAmount
      taxAmount
      consignmentVendorTotal
      salesConsignmentInvoice {
        salesConsignmentInvoiceID
        salesConsignmentInvoiceNumber
        salesConsignmentInvoiceDatetime
        salesConsignmentInvoiceDatetimeUtc
        salesInvoiceID
        salesInvoiceNumber
        consignmentVendorID
        consignmentCommissionFeePerc
        totalItemQty
        subtotal
        discountAmount
        taxAmount
        commissionAmount
        total
        consignmentVendorTotal
        status
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppSalesItemsListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppSalesItemsListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppSalesItemsListQuery, VendorAppSalesItemsListQueryVariables>({ query: VendorAppSalesItemsListDocument, ...options });
};
export const VendorAppSalesListDocument = gql`
    query VendorAppSalesList($qop: SalesConsignmentInvoiceQopInput) {
  salesConsignmentInvoices(qop: $qop) {
    items {
      salesConsignmentInvoiceID
      salesConsignmentInvoiceNumber
      salesConsignmentInvoiceDatetime
      salesConsignmentInvoiceDatetimeUtc
      salesInvoiceID
      salesInvoiceNumber
      consignmentVendorID
      consignmentCommissionFeePerc
      totalItemQty
      subtotal
      discountAmount
      taxAmount
      commissionAmount
      total
      consignmentVendorTotal
      status
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppSalesListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppSalesListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppSalesListQuery, VendorAppSalesListQueryVariables>({ query: VendorAppSalesListDocument, ...options });
};
export const VendorAppSalesLoadDocument = gql`
    query VendorAppSalesLoad($salesConsignmentInvoiceID: UUID!) {
  salesConsignmentInvoice(salesConsignmentInvoiceID: $salesConsignmentInvoiceID) {
    salesConsignmentInvoiceID
    salesConsignmentInvoiceNumber
    salesConsignmentInvoiceDatetime
    salesInvoiceID
    salesInvoiceNumber
    consignmentVendorID
    totalItemQty
    status
  }
}
    `;

export function useVendorAppSalesLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppSalesLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppSalesLoadQuery, VendorAppSalesLoadQueryVariables>({ query: VendorAppSalesLoadDocument, ...options });
};
export const VendorAppStockInItemsListDocument = gql`
    query VendorAppStockInItemsList($qop: ConsignmentStockInItemQopInput) {
  consignmentStockInItems(qop: $qop) {
    items {
      consignmentStockInItemID
      consignmentStockInID
      productID
      productCode
      productName
      qtyReceived
      uomName
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockInItemsListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockInItemsListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInItemsListQuery, VendorAppStockInItemsListQueryVariables>({ query: VendorAppStockInItemsListDocument, ...options });
};
export const VendorAppStockInListDocument = gql`
    query VendorAppStockInList($qop: ConsignmentStockInQopInput) {
  consignmentStockIns(qop: $qop) {
    items {
      consignmentStockInID
      consignmentStockInNumber
      consignmentStockInDatetime
      vendorID
      warehouseID
      externalReferenceNumber
      receivedByName
      totalItemQtyReceived
      status
      warehouse {
        warehouseName
        branch {
          branchID
          branchCode
          branchName
        }
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockInListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockInListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInListQuery, VendorAppStockInListQueryVariables>({ query: VendorAppStockInListDocument, ...options });
};
export const VendorAppStockInLoadDocument = gql`
    query VendorAppStockInLoad($consignmentStockInID: UUID!) {
  consignmentStockIn(consignmentStockInID: $consignmentStockInID) {
    consignmentStockInID
    consignmentStockInNumber
    consignmentStockInDatetime
    status
    externalReferenceNumber
    receivedByName
    totalItemQtyReceived
    warehouse {
      warehouseName
      branch {
        branchName
      }
    }
  }
}
    `;

export function useVendorAppStockInLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppStockInLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockInLoadQuery, VendorAppStockInLoadQueryVariables>({ query: VendorAppStockInLoadDocument, ...options });
};
export const VendorAppStockOutItemsListDocument = gql`
    query VendorAppStockOutItemsList($qop: ConsignmentStockOutItemQopInput) {
  consignmentStockOutItems(qop: $qop) {
    items {
      consignmentStockOutItemID
      consignmentStockOutID
      productID
      productCode
      productName
      qty
      uomName
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockOutItemsListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockOutItemsListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockOutItemsListQuery, VendorAppStockOutItemsListQueryVariables>({ query: VendorAppStockOutItemsListDocument, ...options });
};
export const VendorAppStockOutListDocument = gql`
    query VendorAppStockOutList($qop: ConsignmentStockOutQopInput) {
  consignmentStockOuts(qop: $qop) {
    items {
      consignmentStockOutID
      consignmentStockOutNumber
      consignmentStockOutDatetime
      vendorID
      warehouseID
      externalReferenceNumber
      receivedByVendorName
      totalItemQty
      status
      warehouse {
        warehouseName
        branch {
          branchID
          branchCode
          branchName
        }
      }
    }
    pagination {
      page
      pageSize
      totalRows
      totalPages
      hasNext
    }
  }
}
    `;

export function useVendorAppStockOutListQuery(options?: Omit<Urql.UseQueryArgs<VendorAppStockOutListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockOutListQuery, VendorAppStockOutListQueryVariables>({ query: VendorAppStockOutListDocument, ...options });
};
export const VendorAppStockOutLoadDocument = gql`
    query VendorAppStockOutLoad($consignmentStockOutID: UUID!) {
  consignmentStockOut(consignmentStockOutID: $consignmentStockOutID) {
    consignmentStockOutID
    consignmentStockOutNumber
    consignmentStockOutDatetime
    status
    externalReferenceNumber
    receivedByVendorName
    totalItemQty
    warehouse {
      warehouseName
      branch {
        branchName
      }
    }
  }
}
    `;

export function useVendorAppStockOutLoadQuery(options: Omit<Urql.UseQueryArgs<VendorAppStockOutLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAppStockOutLoadQuery, VendorAppStockOutLoadQueryVariables>({ query: VendorAppStockOutLoadDocument, ...options });
};
export const VendorConsignmentDashboardDocument = gql`
    query VendorConsignmentDashboard($filter: VendorConsignmentDashboardFilterInput!) {
  vendorConsignmentDashboard(filter: $filter) {
    summary {
      grossSales
      commissionAmount
      vendorShareAmount
      unitsSold
      invoiceCount
    }
    salesByBranch {
      branchID
      grossSales
      vendorShareAmount
      invoiceCount
    }
    topProducts {
      productID
      productName
      qty
      grossSales
      vendorShareAmount
    }
    topProductsByRevenue {
      productID
      productName
      qty
      grossSales
      vendorShareAmount
    }
  }
}
    `;

export function useVendorConsignmentDashboardQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentDashboardQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentDashboardQuery, VendorConsignmentDashboardQueryVariables>({ query: VendorConsignmentDashboardDocument, ...options });
};
export const VendorConsignmentSalesExportDocument = gql`
    query VendorConsignmentSalesExport($filter: VendorConsignmentSalesExportFilterInput!) {
  vendorConsignmentSalesExport(filter: $filter) {
    fileName
    downloadURL
  }
}
    `;

export function useVendorConsignmentSalesExportQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentSalesExportQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentSalesExportQuery, VendorConsignmentSalesExportQueryVariables>({ query: VendorConsignmentSalesExportDocument, ...options });
};
export const VendorStockExportDocument = gql`
    query VendorStockExport($filter: VendorStockExportFilterInput!) {
  vendorStockExport(filter: $filter) {
    fileName
    downloadURL
  }
}
    `;

export function useVendorStockExportQuery(options: Omit<Urql.UseQueryArgs<VendorStockExportQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorStockExportQuery, VendorStockExportQueryVariables>({ query: VendorStockExportDocument, ...options });
};
export const VendorCategoryAutocompleteDocument = gql`
    query VendorCategoryAutocomplete($qop: VendorCategoryQopInput) {
  vendorCategories(qop: $qop) {
    items {
      vendorCategoryID
      vendorCategoryName
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorCategoryAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<VendorCategoryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorCategoryAutocompleteQuery, VendorCategoryAutocompleteQueryVariables>({ query: VendorCategoryAutocompleteDocument, ...options });
};
export const VendorCategoryCreateDocument = gql`
    mutation VendorCategoryCreate($input: VendorCategoryCreateInput!) {
  vendorCategoryCreate(input: $input) {
    vendorCategoryID
    vendorCategoryName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useVendorCategoryCreateMutation() {
  return Urql.useMutation<VendorCategoryCreateMutation, VendorCategoryCreateMutationVariables>(VendorCategoryCreateDocument);
};
export const VendorCategoryDeleteDocument = gql`
    mutation VendorCategoryDelete($vendorCategoryID: UUID!) {
  vendorCategoryDelete(vendorCategoryID: $vendorCategoryID)
}
    `;

export function useVendorCategoryDeleteMutation() {
  return Urql.useMutation<VendorCategoryDeleteMutation, VendorCategoryDeleteMutationVariables>(VendorCategoryDeleteDocument);
};
export const VendorCategoryListDocument = gql`
    query VendorCategoryList($qop: VendorCategoryQopInput) {
  vendorCategories(qop: $qop) {
    items {
      vendorCategoryID
      vendorCategoryName
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorCategoryListQuery(options?: Omit<Urql.UseQueryArgs<VendorCategoryListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorCategoryListQuery, VendorCategoryListQueryVariables>({ query: VendorCategoryListDocument, ...options });
};
export const VendorCategoryLoadDocument = gql`
    query VendorCategoryLoad($vendorCategoryID: UUID!) {
  vendorCategory(vendorCategoryID: $vendorCategoryID) {
    vendorCategoryID
    vendorCategoryName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useVendorCategoryLoadQuery(options: Omit<Urql.UseQueryArgs<VendorCategoryLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorCategoryLoadQuery, VendorCategoryLoadQueryVariables>({ query: VendorCategoryLoadDocument, ...options });
};
export const VendorCategoryUpdateDocument = gql`
    mutation VendorCategoryUpdate($input: VendorCategoryUpdateInput!) {
  vendorCategoryUpdate(input: $input) {
    vendorCategoryID
    vendorCategoryName
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useVendorCategoryUpdateMutation() {
  return Urql.useMutation<VendorCategoryUpdateMutation, VendorCategoryUpdateMutationVariables>(VendorCategoryUpdateDocument);
};
export const VendorConsignmentRentalPaymentApproveDocument = gql`
    mutation VendorConsignmentRentalPaymentApprove($input: VendorConsignmentRentalPaymentApproveInput!) {
  vendorConsignmentRentalPaymentApprove(input: $input) {
    vendorConsignmentRentalPaymentID
    status
    approvedByUserName
    approvedAt
  }
}
    `;

export function useVendorConsignmentRentalPaymentApproveMutation() {
  return Urql.useMutation<VendorConsignmentRentalPaymentApproveMutation, VendorConsignmentRentalPaymentApproveMutationVariables>(VendorConsignmentRentalPaymentApproveDocument);
};
export const VendorConsignmentRentalPaymentListDocument = gql`
    query VendorConsignmentRentalPaymentList($qop: VendorConsignmentRentalPaymentQopInput) {
  vendorConsignmentRentalPayments(qop: $qop) {
    items {
      vendorConsignmentRentalPaymentID
      vendorConsignmentRentalPaymentNumber
      vendorConsignmentBranchID
      vendorID
      vendorName
      branchID
      branchName
      transferAmount
      transferDate
      vendorNote
      rentPriceSnapshot
      rentPeriodDaysSnapshot
      effectiveStartDate
      effectiveEndDate
      status
      approvedByUserName
      approvedAt
      rejectedReason
      rejectedByUserName
      rejectedAt
      files {
        vendorConsignmentRentalPaymentFileID
        vendorConsignmentRentalPaymentFileType
        fileID
        imageFileSmallPathURL
        imageFileMediumPathURL
        imageFileLargePathURL
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorConsignmentRentalPaymentListQuery(options?: Omit<Urql.UseQueryArgs<VendorConsignmentRentalPaymentListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentRentalPaymentListQuery, VendorConsignmentRentalPaymentListQueryVariables>({ query: VendorConsignmentRentalPaymentListDocument, ...options });
};
export const VendorConsignmentRentalPaymentLoadDocument = gql`
    query VendorConsignmentRentalPaymentLoad($vendorConsignmentRentalPaymentID: UUID!) {
  vendorConsignmentRentalPayment(
    vendorConsignmentRentalPaymentID: $vendorConsignmentRentalPaymentID
  ) {
    vendorConsignmentRentalPaymentID
    vendorConsignmentRentalPaymentNumber
    vendorConsignmentBranchID
    vendorID
    vendorName
    branchID
    branchName
    transferAmount
    transferDate
    vendorNote
    rentPriceSnapshot
    rentPeriodDaysSnapshot
    effectiveStartDate
    effectiveEndDate
    status
    settlementBankAccountID
    settlementBankName
    settlementBankAccountNumber
    approvedByUserName
    approvedAt
    rejectedReason
    rejectedByUserName
    rejectedAt
    files {
      vendorConsignmentRentalPaymentFileID
      vendorConsignmentRentalPaymentFileType
      fileID
      imageFileSmallPathURL
      imageFileMediumPathURL
      imageFileLargePathURL
    }
    entityAuditMetadata {
      createdAt
      updatedAt
    }
  }
}
    `;

export function useVendorConsignmentRentalPaymentLoadQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentRentalPaymentLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentRentalPaymentLoadQuery, VendorConsignmentRentalPaymentLoadQueryVariables>({ query: VendorConsignmentRentalPaymentLoadDocument, ...options });
};
export const VendorConsignmentRentalPaymentRejectDocument = gql`
    mutation VendorConsignmentRentalPaymentReject($input: VendorConsignmentRentalPaymentRejectInput!) {
  vendorConsignmentRentalPaymentReject(input: $input) {
    vendorConsignmentRentalPaymentID
    status
    rejectedReason
    rejectedByUserName
    rejectedAt
  }
}
    `;

export function useVendorConsignmentRentalPaymentRejectMutation() {
  return Urql.useMutation<VendorConsignmentRentalPaymentRejectMutation, VendorConsignmentRentalPaymentRejectMutationVariables>(VendorConsignmentRentalPaymentRejectDocument);
};
export const VendorConsignmentBranchPeriodGrantDocument = gql`
    mutation VendorConsignmentBranchPeriodGrant($input: VendorConsignmentBranchPeriodGrantInput!) {
  vendorConsignmentBranchPeriodGrant(input: $input) {
    vendorConsignmentBranchPeriodID
    rentalStatus
    effectiveStartDate
    effectiveEndDate
  }
}
    `;

export function useVendorConsignmentBranchPeriodGrantMutation() {
  return Urql.useMutation<VendorConsignmentBranchPeriodGrantMutation, VendorConsignmentBranchPeriodGrantMutationVariables>(VendorConsignmentBranchPeriodGrantDocument);
};
export const VendorConsignmentBranchPeriodListDocument = gql`
    query VendorConsignmentBranchPeriodList($qop: VendorConsignmentBranchPeriodQopInput) {
  vendorConsignmentBranchPeriods(qop: $qop) {
    items {
      vendorConsignmentBranchPeriodID
      vendorConsignmentBranchID
      vendorID
      vendor {
        vendorID
        vendorCode
        vendorName
      }
      branchID
      branch {
        branchID
        branchCode
        branchName
      }
      effectiveStartDate
      effectiveEndDate
      daysGrantedTotal
      rentalStatus
      suspendedReason
      suspendedByUserName
      suspendedAt
      revokedReason
      revokedByUserName
      revokedAt
      lastGrantSource
      lastGrantSourcePaymentID
      lastGrantSourcePaymentNumber
      lastGrantedByUserName
      lastGrantedAt
      entityAuditMetadata {
        createdByUserName
        updatedByUserName
        createdAt
        updatedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorConsignmentBranchPeriodListQuery(options?: Omit<Urql.UseQueryArgs<VendorConsignmentBranchPeriodListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentBranchPeriodListQuery, VendorConsignmentBranchPeriodListQueryVariables>({ query: VendorConsignmentBranchPeriodListDocument, ...options });
};
export const VendorConsignmentBranchPeriodResumeDocument = gql`
    mutation VendorConsignmentBranchPeriodResume($input: VendorConsignmentBranchPeriodResumeInput!) {
  vendorConsignmentBranchPeriodResume(input: $input) {
    vendorConsignmentBranchPeriodID
    rentalStatus
  }
}
    `;

export function useVendorConsignmentBranchPeriodResumeMutation() {
  return Urql.useMutation<VendorConsignmentBranchPeriodResumeMutation, VendorConsignmentBranchPeriodResumeMutationVariables>(VendorConsignmentBranchPeriodResumeDocument);
};
export const VendorConsignmentBranchPeriodSuspendDocument = gql`
    mutation VendorConsignmentBranchPeriodSuspend($input: VendorConsignmentBranchPeriodSuspendInput!) {
  vendorConsignmentBranchPeriodSuspend(input: $input) {
    vendorConsignmentBranchPeriodID
    rentalStatus
    suspendedReason
    suspendedAt
  }
}
    `;

export function useVendorConsignmentBranchPeriodSuspendMutation() {
  return Urql.useMutation<VendorConsignmentBranchPeriodSuspendMutation, VendorConsignmentBranchPeriodSuspendMutationVariables>(VendorConsignmentBranchPeriodSuspendDocument);
};
export const VendorCreateAccessDocument = gql`
    mutation VendorCreateAccess($input: VendorCreateAccessInput!) {
  vendorCreateAccess(input: $input) {
    vendorID
  }
}
    `;

export function useVendorCreateAccessMutation() {
  return Urql.useMutation<VendorCreateAccessMutation, VendorCreateAccessMutationVariables>(VendorCreateAccessDocument);
};
export const VendorUpdateAccessDocument = gql`
    mutation VendorUpdateAccess($input: VendorUpdateAccessInput!) {
  vendorUpdateAccess(input: $input) {
    vendorID
  }
}
    `;

export function useVendorUpdateAccessMutation() {
  return Urql.useMutation<VendorUpdateAccessMutation, VendorUpdateAccessMutationVariables>(VendorUpdateAccessDocument);
};
export const VendorAutocompleteDocument = gql`
    query VendorAutocomplete($qop: VendorQopInput) {
  vendors(qop: $qop) {
    items {
      vendorID
      vendorName
      taxIncluded
      vendorCode
      cityID
      cityName
      taxable
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<VendorAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorAutocompleteQuery, VendorAutocompleteQueryVariables>({ query: VendorAutocompleteDocument, ...options });
};
export const VendorConsignmentBranchDeleteDocument = gql`
    mutation VendorConsignmentBranchDelete($vendorConsignmentBranchID: UUID!) {
  vendorConsignmentBranchDelete(
    vendorConsignmentBranchID: $vendorConsignmentBranchID
  )
}
    `;

export function useVendorConsignmentBranchDeleteMutation() {
  return Urql.useMutation<VendorConsignmentBranchDeleteMutation, VendorConsignmentBranchDeleteMutationVariables>(VendorConsignmentBranchDeleteDocument);
};
export const VendorCreateDocument = gql`
    mutation VendorCreate($input: VendorCreateInput!) {
  vendorCreate(input: $input) {
    vendorID
    vendorCode
    vendorName
    isConsignment
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
  }
}
    `;

export function useVendorCreateMutation() {
  return Urql.useMutation<VendorCreateMutation, VendorCreateMutationVariables>(VendorCreateDocument);
};
export const VendorDeleteDocument = gql`
    mutation VendorDelete($input: VendorDeleteInput!) {
  vendorDelete(input: $input)
}
    `;

export function useVendorDeleteMutation() {
  return Urql.useMutation<VendorDeleteMutation, VendorDeleteMutationVariables>(VendorDeleteDocument);
};
export const VendorListDocument = gql`
    query VendorList($qop: VendorQopInput) {
  vendors(qop: $qop) {
    items {
      vendorID
      vendorCode
      vendorName
      vendorCategoryID
      email
      phoneNumber
      npwp
      npwpCompanyName
      isPKP
      taxpayerIDNumber
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      taxIncluded
      canBeReturned
      isConsignment
      consignmentCommisionFeePerc
      consignmentPeriodStartDate
      consignmentPeriodEndDate
      hasPortalAccess
      portalSuperadminFirstName
      portalSuperadminLastName
      portalSuperadminEmail
      portalAccountActivated
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVendorListQuery(options?: Omit<Urql.UseQueryArgs<VendorListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorListQuery, VendorListQueryVariables>({ query: VendorListDocument, ...options });
};
export const VendorLoadDocument = gql`
    query VendorLoad($vendorID: UUID!) {
  vendor(vendorID: $vendorID) {
    vendorID
    vendorCode
    vendorName
    vendorCategoryID
    vendorCategory {
      vendorCategoryName
    }
    bankID
    bankName
    bankAccountName
    bankAccountNumber
    email
    phoneNumber
    npwp
    npwpCompanyName
    isPKP
    taxable
    taxpayerIDNumber
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    taxIncluded
    canBeReturned
    isConsignment
    consignmentPeriodStartDate
    consignmentPeriodEndDate
    hasPortalAccess
    portalSuperadminFirstName
    portalSuperadminLastName
    portalSuperadminEmail
    portalAccountActivated
    uniqueKey
    isActive
    vendorPicContacts {
      vendorPicContactID
      vendorID
      picName
      picDepartment
      picEmail
      picPhoneNumber
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    vendorConsignmentProducts {
      productID
      product {
        productCode
        productName
        barcode
        baseUom {
          uomName
        }
      }
      sellingPrice
    }
    vendorConsignmentBranch {
      vendorConsignmentBranchID
      vendorID
      branchID
      branchCode
      branchName
      commissionFeePerc
      isRent
      rentPrice
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useVendorLoadQuery(options: Omit<Urql.UseQueryArgs<VendorLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorLoadQuery, VendorLoadQueryVariables>({ query: VendorLoadDocument, ...options });
};
export const VendorConsignmentProductCreateDocument = gql`
    mutation VendorConsignmentProductCreate($input: VendorConsignmentProductCreateInput!) {
  vendorConsignmentProductCreate(input: $input) {
    vendorConsignmentProductID
  }
}
    `;

export function useVendorConsignmentProductCreateMutation() {
  return Urql.useMutation<VendorConsignmentProductCreateMutation, VendorConsignmentProductCreateMutationVariables>(VendorConsignmentProductCreateDocument);
};
export const VendorConsignmentProductDeleteDocument = gql`
    mutation VendorConsignmentProductDelete($vendorConsignmentProductID: UUID!) {
  vendorConsignmentProductDelete(
    vendorConsignmentProductID: $vendorConsignmentProductID
  )
}
    `;

export function useVendorConsignmentProductDeleteMutation() {
  return Urql.useMutation<VendorConsignmentProductDeleteMutation, VendorConsignmentProductDeleteMutationVariables>(VendorConsignmentProductDeleteDocument);
};
export const VendorConsignmentProductListDocument = gql`
    query VendorConsignmentProductList($qop: VendorConsignmentProductQopInput!) {
  vendorConsignmentProducts(qop: $qop) {
    items {
      productID
      product {
        productCode
        productName
        barcode
        sellingPrice
        baseUom {
          uomName
        }
        isActive
        entityAuditMetadata {
          version
        }
      }
      branchPrices {
        vendorConsignmentProductID
        branch {
          branchCode
          branchName
        }
        sellingPrice
        productCommissionFeePerc
        isActive
        entityAuditMetadata {
          version
        }
      }
      branchPrices {
        vendorConsignmentProductID
        branchID
        sellingPrice
        productCommissionFeePerc
        isActive
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useVendorConsignmentProductListQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentProductListQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentProductListQuery, VendorConsignmentProductListQueryVariables>({ query: VendorConsignmentProductListDocument, ...options });
};
export const VendorConsignmentProductLoadDocument = gql`
    query VendorConsignmentProductLoad($vendorConsignmentProductID: UUID!) {
  vendorConsignmentProduct(
    vendorConsignmentProductID: $vendorConsignmentProductID
  ) {
    vendorConsignmentProductID
    vendorID
    productID
    branchID
    sellingPrice
    isActive
    uniqueKey
  }
}
    `;

export function useVendorConsignmentProductLoadQuery(options: Omit<Urql.UseQueryArgs<VendorConsignmentProductLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VendorConsignmentProductLoadQuery, VendorConsignmentProductLoadQueryVariables>({ query: VendorConsignmentProductLoadDocument, ...options });
};
export const VendorConsignmentProductPricesUpdateDocument = gql`
    mutation VendorConsignmentProductPricesUpdate($input: VendorConsignmentProductPriceBulkUpdateInput!) {
  vendorConsignmentProductPriceBulkUpdate(input: $input) {
    product {
      productID
    }
    updatedBranchPrices {
      vendorConsignmentProductID
    }
  }
}
    `;

export function useVendorConsignmentProductPricesUpdateMutation() {
  return Urql.useMutation<VendorConsignmentProductPricesUpdateMutation, VendorConsignmentProductPricesUpdateMutationVariables>(VendorConsignmentProductPricesUpdateDocument);
};
export const VendorConsignmentProductUpdateDocument = gql`
    mutation VendorConsignmentProductUpdate($input: VendorConsignmentProductUpdateInput!) {
  vendorConsignmentProductUpdate(input: $input) {
    vendorConsignmentProductID
  }
}
    `;

export function useVendorConsignmentProductUpdateMutation() {
  return Urql.useMutation<VendorConsignmentProductUpdateMutation, VendorConsignmentProductUpdateMutationVariables>(VendorConsignmentProductUpdateDocument);
};
export const VendorSetPortalAccessActiveDocument = gql`
    mutation VendorSetPortalAccessActive($input: VendorSetPortalAccessActiveInput!) {
  vendorSetPortalAccessActive(input: $input) {
    vendorID
    hasPortalAccess
  }
}
    `;

export function useVendorSetPortalAccessActiveMutation() {
  return Urql.useMutation<VendorSetPortalAccessActiveMutation, VendorSetPortalAccessActiveMutationVariables>(VendorSetPortalAccessActiveDocument);
};
export const VendorUpdateDocument = gql`
    mutation VendorUpdate($input: VendorUpdateInput!) {
  vendorUpdate(input: $input) {
    vendorID
    vendorCode
    vendorName
    isConsignment
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
  }
}
    `;

export function useVendorUpdateMutation() {
  return Urql.useMutation<VendorUpdateMutation, VendorUpdateMutationVariables>(VendorUpdateDocument);
};
export const VoucherCategoryAutocompleteDocument = gql`
    query VoucherCategoryAutocomplete($qop: VoucherCategoryQopInput) {
  voucherCategories(qop: $qop) {
    items {
      voucherCategoryID
      voucherCategoryName
      voucherType
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useVoucherCategoryAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<VoucherCategoryAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<VoucherCategoryAutocompleteQuery, VoucherCategoryAutocompleteQueryVariables>({ query: VoucherCategoryAutocompleteDocument, ...options });
};
export const VoucherCategoryCreateDocument = gql`
    mutation VoucherCategoryCreate($input: VoucherCategoryCreateInput!) {
  voucherCategoryCreate(input: $input) {
    voucherCategoryID
  }
}
    `;

export function useVoucherCategoryCreateMutation() {
  return Urql.useMutation<VoucherCategoryCreateMutation, VoucherCategoryCreateMutationVariables>(VoucherCategoryCreateDocument);
};
export const VoucherCategoryDeleteDocument = gql`
    mutation VoucherCategoryDelete($voucherCategoryID: UUID!) {
  voucherCategoryDelete(voucherCategoryID: $voucherCategoryID)
}
    `;

export function useVoucherCategoryDeleteMutation() {
  return Urql.useMutation<VoucherCategoryDeleteMutation, VoucherCategoryDeleteMutationVariables>(VoucherCategoryDeleteDocument);
};
export const VoucherCategoryListDocument = gql`
    query VoucherCategoryList($qop: VoucherCategoryQopInput) {
  voucherCategories(qop: $qop) {
    items {
      voucherCategoryID
      voucherCategoryName
      expenseAccountCode
      voucherType
      prefix
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useVoucherCategoryListQuery(options?: Omit<Urql.UseQueryArgs<VoucherCategoryListQueryVariables>, 'query'>) {
  return Urql.useQuery<VoucherCategoryListQuery, VoucherCategoryListQueryVariables>({ query: VoucherCategoryListDocument, ...options });
};
export const VoucherCategoryLoadDocument = gql`
    query VoucherCategoryLoad($voucherCategoryID: UUID!) {
  voucherCategory(voucherCategoryID: $voucherCategoryID) {
    voucherCategoryID
    voucherCategoryName
    expenseAccountCode
    expenseAccountErpRefID
    expenseAccountErpRefName
    voucherType
    prefix
    uniqueKey
    isActive
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useVoucherCategoryLoadQuery(options: Omit<Urql.UseQueryArgs<VoucherCategoryLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VoucherCategoryLoadQuery, VoucherCategoryLoadQueryVariables>({ query: VoucherCategoryLoadDocument, ...options });
};
export const VoucherCategoryUpdateDocument = gql`
    mutation VoucherCategoryUpdate($input: VoucherCategoryUpdateInput!) {
  voucherCategoryUpdate(input: $input) {
    voucherCategoryID
  }
}
    `;

export function useVoucherCategoryUpdateMutation() {
  return Urql.useMutation<VoucherCategoryUpdateMutation, VoucherCategoryUpdateMutationVariables>(VoucherCategoryUpdateDocument);
};
export const VoucherCreateDocument = gql`
    mutation VoucherCreate($input: VoucherCreateInput!) {
  voucherCreate(input: $input) {
    voucherID
  }
}
    `;

export function useVoucherCreateMutation() {
  return Urql.useMutation<VoucherCreateMutation, VoucherCreateMutationVariables>(VoucherCreateDocument);
};
export const VoucherDeleteDocument = gql`
    mutation VoucherDelete($voucherID: UUID!) {
  voucherDelete(voucherID: $voucherID)
}
    `;

export function useVoucherDeleteMutation() {
  return Urql.useMutation<VoucherDeleteMutation, VoucherDeleteMutationVariables>(VoucherDeleteDocument);
};
export const VoucherItemGenerateDocument = gql`
    mutation VoucherItemGenerate($input: VoucherItemGenerateInput!) {
  voucherItemGenerate(input: $input) {
    voucherItemID
    voucherID
  }
}
    `;

export function useVoucherItemGenerateMutation() {
  return Urql.useMutation<VoucherItemGenerateMutation, VoucherItemGenerateMutationVariables>(VoucherItemGenerateDocument);
};
export const VoucherItemListDocument = gql`
    query VoucherItemList($qop: VoucherItemQopInput) {
  voucherItems(qop: $qop) {
    items {
      voucherItemID
      voucherID
      voucherCode
      voucherItemCode
      voucherValue
      customerID
      customerCode
      customerName
      issuedTimeUTC
      expiryDate
      usedOnTransactionID
      usedOnTransactionNo
      usedTimeUTC
      usedTime
      isVoid
      status
      uniqueKey
      voucher {
        voucherID
        voucherCode
        voucherName
        voucherCategoryID
        voucherCategoryName
        voucherCategoryPrefix
        membersOnly
        startDate
        endDate
        voucherExpiryType
        expiredAfterDays
        voucherValue
        maxNumberOfVouchers
        issuedCount
        usedCount
        voidCount
        unusedCount
        canBeUsedWithOthers
        autoGenerateAllVouchers
        description
        uniqueKey
        isActive
      }
      customer {
        customerID
        customerCode
        customerName
        memberTypeID
        isMember
        email
        phoneNumber
        memberPoints
        gender
        joinDate
        isDefault
        uniqueKey
        isActive
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useVoucherItemListQuery(options?: Omit<Urql.UseQueryArgs<VoucherItemListQueryVariables>, 'query'>) {
  return Urql.useQuery<VoucherItemListQuery, VoucherItemListQueryVariables>({ query: VoucherItemListDocument, ...options });
};
export const VoucherItemVoidDocument = gql`
    mutation VoucherItemVoid($voucherItemID: UUID!) {
  voucherItemVoid(voucherItemID: $voucherItemID) {
    voucherItemID
  }
}
    `;

export function useVoucherItemVoidMutation() {
  return Urql.useMutation<VoucherItemVoidMutation, VoucherItemVoidMutationVariables>(VoucherItemVoidDocument);
};
export const VoucherListDocument = gql`
    query VoucherList($qop: VoucherQopInput!) {
  vouchers(qop: $qop) {
    items {
      voucherID
      voucherCode
      voucherName
      voucherCategoryID
      voucherCategoryName
      voucherCategoryPrefix
      membersOnly
      startDate
      endDate
      voucherExpiryType
      expiredAfterDays
      voucherValue
      maxNumberOfVouchers
      issuedCount
      usedCount
      voidCount
      unusedCount
      canBeUsedWithOthers
      autoGenerateAllVouchers
      description
      uniqueKey
      isActive
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useVoucherListQuery(options: Omit<Urql.UseQueryArgs<VoucherListQueryVariables>, 'query'>) {
  return Urql.useQuery<VoucherListQuery, VoucherListQueryVariables>({ query: VoucherListDocument, ...options });
};
export const VoucherLoadDocument = gql`
    query VoucherLoad($voucherID: UUID!) {
  voucher(voucherID: $voucherID) {
    voucherID
    voucherCode
    voucherName
    voucherCategoryID
    voucherCategoryName
    voucherCategoryPrefix
    membersOnly
    startDate
    endDate
    voucherExpiryType
    expiredAfterDays
    voucherValue
    maxNumberOfVouchers
    issuedCount
    usedCount
    voidCount
    unusedCount
    canBeUsedWithOthers
    autoGenerateAllVouchers
    description
    uniqueKey
    isActive
    voucherCategory {
      voucherCategoryID
      voucherCategoryName
      prefix
      expenseAccountCode
      voucherType
      uniqueKey
      uniqueKey2
      isActive
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useVoucherLoadQuery(options: Omit<Urql.UseQueryArgs<VoucherLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<VoucherLoadQuery, VoucherLoadQueryVariables>({ query: VoucherLoadDocument, ...options });
};
export const VoucherLoadFromListDocument = gql`
    query VoucherLoadFromList($voucherID: UUID!) {
  vouchers(
    qop: {filters: {voucherID: $voucherID}, pagination: {pageSize: 1, page: 1, withDeleted: true}}
  ) {
    items {
      voucherID
      voucherCode
      voucherName
      voucherCategoryID
      voucherCategoryName
      voucherCategoryPrefix
      voucherType
      membersOnly
      startDate
      endDate
      voucherExpiryType
      expiredAfterDays
      voucherValue
      maxNumberOfVouchers
      issuedCount
      usedCount
      voidCount
      unusedCount
      canBeUsedWithOthers
      autoGenerateAllVouchers
      description
      uniqueKey
      isActive
      voucherCategory {
        voucherCategoryID
        voucherCategoryName
        prefix
        expenseAccountCode
        uniqueKey
        uniqueKey2
        isActive
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
  }
}
    `;

export function useVoucherLoadFromListQuery(options: Omit<Urql.UseQueryArgs<VoucherLoadFromListQueryVariables>, 'query'>) {
  return Urql.useQuery<VoucherLoadFromListQuery, VoucherLoadFromListQueryVariables>({ query: VoucherLoadFromListDocument, ...options });
};
export const VoucherUpdateDocument = gql`
    mutation VoucherUpdate($input: VoucherUpdateInput!) {
  voucherUpdate(input: $input) {
    voucherID
  }
}
    `;

export function useVoucherUpdateMutation() {
  return Urql.useMutation<VoucherUpdateMutation, VoucherUpdateMutationVariables>(VoucherUpdateDocument);
};
export const WarehouseLocationGroupAutocompleteDocument = gql`
    query WarehouseLocationGroupAutocomplete($qop: WarehouseLocationGroupQopInput) {
  warehouseLocationGroups(qop: $qop) {
    items {
      warehouseLocationGroupID
      warehouseLocationGroupName
      uniqueKey
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useWarehouseLocationGroupAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<WarehouseLocationGroupAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseLocationGroupAutocompleteQuery, WarehouseLocationGroupAutocompleteQueryVariables>({ query: WarehouseLocationGroupAutocompleteDocument, ...options });
};
export const WarehouseLocationGroupCreateDocument = gql`
    mutation WarehouseLocationGroupCreate($input: WarehouseLocationGroupCreateInput!) {
  warehouseLocationGroupCreate(input: $input) {
    warehouseLocationGroupID
    warehouseLocationGroupName
    uniqueKey
    isActive
  }
}
    `;

export function useWarehouseLocationGroupCreateMutation() {
  return Urql.useMutation<WarehouseLocationGroupCreateMutation, WarehouseLocationGroupCreateMutationVariables>(WarehouseLocationGroupCreateDocument);
};
export const WarehouseLocationGroupDeleteDocument = gql`
    mutation WarehouseLocationGroupDelete($warehouseLocationGroupID: UUID!) {
  warehouseLocationGroupDelete(
    warehouseLocationGroupID: $warehouseLocationGroupID
  )
}
    `;

export function useWarehouseLocationGroupDeleteMutation() {
  return Urql.useMutation<WarehouseLocationGroupDeleteMutation, WarehouseLocationGroupDeleteMutationVariables>(WarehouseLocationGroupDeleteDocument);
};
export const WarehouseLocationGroupListDocument = gql`
    query WarehouseLocationGroupList($qop: WarehouseLocationGroupQopInput) {
  warehouseLocationGroups(qop: $qop) {
    items {
      warehouseLocationGroupID
      warehouseLocationGroupName
      uniqueKey
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useWarehouseLocationGroupListQuery(options?: Omit<Urql.UseQueryArgs<WarehouseLocationGroupListQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseLocationGroupListQuery, WarehouseLocationGroupListQueryVariables>({ query: WarehouseLocationGroupListDocument, ...options });
};
export const WarehouseLocationGroupLoadDocument = gql`
    query WarehouseLocationGroupLoad($warehouseLocationGroupID: UUID!) {
  warehouseLocationGroup(warehouseLocationGroupID: $warehouseLocationGroupID) {
    warehouseLocationGroupID
    warehouseLocationGroupName
    uniqueKey
    isActive
  }
}
    `;

export function useWarehouseLocationGroupLoadQuery(options: Omit<Urql.UseQueryArgs<WarehouseLocationGroupLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseLocationGroupLoadQuery, WarehouseLocationGroupLoadQueryVariables>({ query: WarehouseLocationGroupLoadDocument, ...options });
};
export const WarehouseLocationGroupUpdateDocument = gql`
    mutation WarehouseLocationGroupUpdate($input: WarehouseLocationGroupUpdateInput!) {
  warehouseLocationGroupUpdate(input: $input) {
    warehouseLocationGroupID
    warehouseLocationGroupName
    uniqueKey
    isActive
  }
}
    `;

export function useWarehouseLocationGroupUpdateMutation() {
  return Urql.useMutation<WarehouseLocationGroupUpdateMutation, WarehouseLocationGroupUpdateMutationVariables>(WarehouseLocationGroupUpdateDocument);
};
export const WarehouseLocationAutocompleteDocument = gql`
    query WarehouseLocationAutocomplete($qop: WarehouseLocationQopInput) {
  warehouseLocations(qop: $qop) {
    items {
      warehouseLocationID
      warehouseLocationName
      warehouseLocationType
      warehouseID
      branchID
      parentWarehouseLocationID
      parentWarehouseLocation {
        warehouseLocationID
        warehouseLocationName
        parentWarehouseLocation {
          warehouseLocationID
          warehouseLocationName
        }
      }
      uniqueKey
      isActive
    }
    pagination {
      totalRows
      hasNext
    }
  }
}
    `;

export function useWarehouseLocationAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<WarehouseLocationAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseLocationAutocompleteQuery, WarehouseLocationAutocompleteQueryVariables>({ query: WarehouseLocationAutocompleteDocument, ...options });
};
export const WarehouseLocationCreateBulkDocument = gql`
    mutation WarehouseLocationCreateBulk($input: WarehouseLocationBulkCreateInput!) {
  warehouseLocationCreateBulk(input: $input) {
    warehouseLocationID
    warehouseLocationName
    warehouseLocationType
    warehouseStorageType
    warehouseID
    branchID
    parentWarehouseLocationID
    warehouseLocationGroupID
    isHoldInventory
    uniqueKey
    isActive
    isSystemGenerated
  }
}
    `;

export function useWarehouseLocationCreateBulkMutation() {
  return Urql.useMutation<WarehouseLocationCreateBulkMutation, WarehouseLocationCreateBulkMutationVariables>(WarehouseLocationCreateBulkDocument);
};
export const WarehouseLocationCreateDocument = gql`
    mutation WarehouseLocationCreate($input: WarehouseLocationCreateInput!) {
  warehouseLocationCreate(input: $input) {
    warehouseLocationID
    warehouseLocationName
    warehouseLocationType
    warehouseID
    branchID
    parentWarehouseLocationID
    uniqueKey
    isActive
  }
}
    `;

export function useWarehouseLocationCreateMutation() {
  return Urql.useMutation<WarehouseLocationCreateMutation, WarehouseLocationCreateMutationVariables>(WarehouseLocationCreateDocument);
};
export const WarehouseLocationDeleteDocument = gql`
    mutation WarehouseLocationDelete($warehouseLocationID: UUID!) {
  warehouseLocationDelete(warehouseLocationID: $warehouseLocationID)
}
    `;

export function useWarehouseLocationDeleteMutation() {
  return Urql.useMutation<WarehouseLocationDeleteMutation, WarehouseLocationDeleteMutationVariables>(WarehouseLocationDeleteDocument);
};
export const WarehouseLocationListDocument = gql`
    query WarehouseLocationList($qop: WarehouseLocationQopInput) {
  warehouseLocations(qop: $qop) {
    items {
      warehouseLocationID
      warehouseLocationName
      warehouseLocationType
      warehouseStorageType
      warehouseID
      branchID
      parentWarehouseLocationID
      parentWarehouseLocation {
        warehouseLocationID
        warehouseLocationName
        warehouseStorageType
      }
      warehouseLocationGroupID
      warehouseLocationGroup {
        warehouseLocationGroupID
        warehouseLocationGroupName
      }
      isHoldInventory
      uniqueKey
      isActive
      isSystemGenerated
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useWarehouseLocationListQuery(options?: Omit<Urql.UseQueryArgs<WarehouseLocationListQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseLocationListQuery, WarehouseLocationListQueryVariables>({ query: WarehouseLocationListDocument, ...options });
};
export const WarehouseLocationLoadDocument = gql`
    query WarehouseLocationLoad($warehouseLocationID: UUID!) {
  warehouseLocation(warehouseLocationID: $warehouseLocationID) {
    warehouseLocationID
    warehouseLocationName
    warehouseLocationType
    warehouseStorageType
    warehouseID
    branchID
    parentWarehouseLocationID
    warehouseLocationGroupID
    isHoldInventory
    uniqueKey
    isActive
    isSystemGenerated
  }
}
    `;

export function useWarehouseLocationLoadQuery(options: Omit<Urql.UseQueryArgs<WarehouseLocationLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseLocationLoadQuery, WarehouseLocationLoadQueryVariables>({ query: WarehouseLocationLoadDocument, ...options });
};
export const WarehouseLocationTreeDocument = gql`
    query WarehouseLocationTree($qop: WarehouseLocationQopInput) {
  warehouseLocations(qop: $qop) {
    items {
      warehouseLocationID
      warehouseLocationName
      warehouseLocationType
      warehouseStorageType
      parentWarehouseLocationID
      isActive
      warehouseLocationGroup {
        warehouseLocationGroupName
      }
    }
    pagination {
      page
      pageSize
      totalRows
      hasNext
    }
  }
}
    `;

export function useWarehouseLocationTreeQuery(options?: Omit<Urql.UseQueryArgs<WarehouseLocationTreeQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseLocationTreeQuery, WarehouseLocationTreeQueryVariables>({ query: WarehouseLocationTreeDocument, ...options });
};
export const WarehouseLocationUpdateDocument = gql`
    mutation WarehouseLocationUpdate($input: WarehouseLocationUpdateInput!) {
  warehouseLocationUpdate(input: $input) {
    warehouseLocationID
    warehouseLocationName
    warehouseLocationType
    warehouseID
    branchID
    parentWarehouseLocationID
    uniqueKey
    isActive
  }
}
    `;

export function useWarehouseLocationUpdateMutation() {
  return Urql.useMutation<WarehouseLocationUpdateMutation, WarehouseLocationUpdateMutationVariables>(WarehouseLocationUpdateDocument);
};
export const WarehouseProductLocationMapCreateDocument = gql`
    mutation WarehouseProductLocationMapCreate($input: WarehouseProductLocationMapCreateInput!) {
  warehouseProductLocationMapCreate(input: $input) {
    warehouseProductLocationMapID
  }
}
    `;

export function useWarehouseProductLocationMapCreateMutation() {
  return Urql.useMutation<WarehouseProductLocationMapCreateMutation, WarehouseProductLocationMapCreateMutationVariables>(WarehouseProductLocationMapCreateDocument);
};
export const WarehouseProductLocationMapDeleteDocument = gql`
    mutation WarehouseProductLocationMapDelete($warehouseProductLocationMapID: UUID!) {
  warehouseProductLocationMapDelete(
    warehouseProductLocationMapID: $warehouseProductLocationMapID
  )
}
    `;

export function useWarehouseProductLocationMapDeleteMutation() {
  return Urql.useMutation<WarehouseProductLocationMapDeleteMutation, WarehouseProductLocationMapDeleteMutationVariables>(WarehouseProductLocationMapDeleteDocument);
};
export const WarehouseProductLocationMapListDocument = gql`
    query WarehouseProductLocationMapList($qop: WarehouseProductLocationMapQopInput) {
  warehouseProductLocationMaps(qop: $qop) {
    items {
      warehouseProductLocationMapID
      warehouseID
      warehouseCode
      warehouseName
      productID
      productCode
      productName
      warehouseLocationID
      warehouseLocationName
      uniqueKey
      isActive
      product {
        productID
        productCode
        productName
        barcode
        productCategory {
          productCategoryID
          productCategoryName
          productCategoryFullName
          productSubDepartmentID
          productSubDepartmentName
          productDepartmentID
          productDepartmentName
          productDivisionID
          productDivisionName
          uniqueKey
          isActive
        }
      }
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useWarehouseProductLocationMapListQuery(options?: Omit<Urql.UseQueryArgs<WarehouseProductLocationMapListQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseProductLocationMapListQuery, WarehouseProductLocationMapListQueryVariables>({ query: WarehouseProductLocationMapListDocument, ...options });
};
export const WarehouseProductLocationMapLoadDocument = gql`
    query WarehouseProductLocationMapLoad($warehouseProductLocationMapID: UUID!) {
  warehouseProductLocationMap(
    warehouseProductLocationMapID: $warehouseProductLocationMapID
  ) {
    warehouseProductLocationMapID
    warehouseID
    warehouseCode
    warehouseName
    productID
    productCode
    productName
    warehouseLocationID
    warehouseLocationName
    uniqueKey
    isActive
    product {
      productID
      productCode
      productName
      productCategory {
        productCategoryID
        productCategoryName
        productCategoryFullName
        productSubDepartmentID
        productSubDepartmentName
        productDepartmentID
        productDepartmentName
        productDivisionID
        productDivisionName
        uniqueKey
        isActive
      }
    }
    entityAuditMetadata {
      createdByUserID
      createdByUserName
      updatedByUserID
      updatedByUserName
      deletedByUserID
      deletedByUserName
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
}
    `;

export function useWarehouseProductLocationMapLoadQuery(options: Omit<Urql.UseQueryArgs<WarehouseProductLocationMapLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseProductLocationMapLoadQuery, WarehouseProductLocationMapLoadQueryVariables>({ query: WarehouseProductLocationMapLoadDocument, ...options });
};
export const WarehouseProductLocationMapUpdateDocument = gql`
    mutation WarehouseProductLocationMapUpdate($input: WarehouseProductLocationMapUpdateInput!) {
  warehouseProductLocationMapUpdate(input: $input) {
    warehouseProductLocationMapID
  }
}
    `;

export function useWarehouseProductLocationMapUpdateMutation() {
  return Urql.useMutation<WarehouseProductLocationMapUpdateMutation, WarehouseProductLocationMapUpdateMutationVariables>(WarehouseProductLocationMapUpdateDocument);
};
export const WarehouseReplenishmentTemplateCreateDocument = gql`
    mutation WarehouseReplenishmentTemplateCreate($input: WarehouseReplenishmentTemplateCreateInput!) {
  warehouseReplenishmentTemplateCreate(input: $input) {
    warehouseReplenishmentTemplateID
  }
}
    `;

export function useWarehouseReplenishmentTemplateCreateMutation() {
  return Urql.useMutation<WarehouseReplenishmentTemplateCreateMutation, WarehouseReplenishmentTemplateCreateMutationVariables>(WarehouseReplenishmentTemplateCreateDocument);
};
export const WarehouseReplenishmentTemplateCreateBulkDocument = gql`
    mutation WarehouseReplenishmentTemplateCreateBulk($input: WarehouseReplenishmentTemplateCreateBulkInput!) {
  warehouseReplenishmentTemplateCreateBulk(input: $input) {
    warehouseReplenishmentTemplateID
    replenishmentTemplateID
    replenishmentTemplateName
  }
}
    `;

export function useWarehouseReplenishmentTemplateCreateBulkMutation() {
  return Urql.useMutation<WarehouseReplenishmentTemplateCreateBulkMutation, WarehouseReplenishmentTemplateCreateBulkMutationVariables>(WarehouseReplenishmentTemplateCreateBulkDocument);
};
export const WarehouseReplenishmentTemplateDeleteDocument = gql`
    mutation WarehouseReplenishmentTemplateDelete($warehouseReplenishmentTemplateID: UUID!) {
  warehouseReplenishmentTemplateDelete(
    warehouseReplenishmentTemplateID: $warehouseReplenishmentTemplateID
  )
}
    `;

export function useWarehouseReplenishmentTemplateDeleteMutation() {
  return Urql.useMutation<WarehouseReplenishmentTemplateDeleteMutation, WarehouseReplenishmentTemplateDeleteMutationVariables>(WarehouseReplenishmentTemplateDeleteDocument);
};
export const WarehouseReplenishmentTemplateListDocument = gql`
    query WarehouseReplenishmentTemplateList($qop: WarehouseReplenishmentTemplateQopInput) {
  warehouseReplenishmentTemplates(qop: $qop) {
    items {
      warehouseReplenishmentTemplateID
      warehouseID
      warehouseCode
      warehouseName
      replenishmentTemplateID
      replenishmentTemplateName
      entityAuditMetadata {
        createdByUserID
        createdByUserName
        updatedByUserID
        updatedByUserName
        deletedByUserID
        deletedByUserName
        createdAt
        updatedAt
        deletedAt
        version
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
      nextCursor
    }
  }
}
    `;

export function useWarehouseReplenishmentTemplateListQuery(options?: Omit<Urql.UseQueryArgs<WarehouseReplenishmentTemplateListQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseReplenishmentTemplateListQuery, WarehouseReplenishmentTemplateListQueryVariables>({ query: WarehouseReplenishmentTemplateListDocument, ...options });
};
export const WarehouseLoadDocument = gql`
    query WarehouseLoad($warehouseID: UUID!) {
  warehouse(warehouseID: $warehouseID) {
    warehouseID
    warehouseCode
    warehouseName
    branchID
    branch {
      branchID
      branchCode
      branchName
      branchType
      branchCategoryID
      pricelistID
      productAvailabilityTemplateID
      mainSupplyWarehouseID
      gmt
      picName
      picPhoneNumber
      canSell
      isMain
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
  }
}
    `;

export function useWarehouseLoadQuery(options: Omit<Urql.UseQueryArgs<WarehouseLoadQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseLoadQuery, WarehouseLoadQueryVariables>({ query: WarehouseLoadDocument, ...options });
};
export const WarehouseAutocompleteDocument = gql`
    query warehouseAutocomplete($qop: WarehouseQopInput) {
  warehouses(qop: $qop) {
    items {
      warehouseID
      warehouseCode
      warehouseName
      branch {
        branchID
        gmt
        branchType
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useWarehouseAutocompleteQuery(options?: Omit<Urql.UseQueryArgs<WarehouseAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseAutocompleteQuery, WarehouseAutocompleteQueryVariables>({ query: WarehouseAutocompleteDocument, ...options });
};
export const WarehouseCreateDocument = gql`
    mutation WarehouseCreate($input: WarehouseCreateInput!) {
  warehouseCreate(input: $input) {
    warehouseID
    warehouseCode
    warehouseName
    branchID
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
  }
}
    `;

export function useWarehouseCreateMutation() {
  return Urql.useMutation<WarehouseCreateMutation, WarehouseCreateMutationVariables>(WarehouseCreateDocument);
};
export const WarehouseDeleteDocument = gql`
    mutation WarehouseDelete($warehouseID: UUID!) {
  warehouseDelete(warehouseID: $warehouseID)
}
    `;

export function useWarehouseDeleteMutation() {
  return Urql.useMutation<WarehouseDeleteMutation, WarehouseDeleteMutationVariables>(WarehouseDeleteDocument);
};
export const WarehouseListDocument = gql`
    query WarehouseList($qop: WarehouseQopInput) {
  warehouses(qop: $qop) {
    items {
      warehouseID
      warehouseCode
      warehouseName
      branchID
      branch {
        branchID
        branchCode
        branchName
        branchType
        branchCategoryID
        pricelistID
        productAvailabilityTemplateID
        mainSupplyWarehouseID
        gmt
        picName
        picPhoneNumber
        canSell
        isMain
        addressLabel
        fullAddress
        countryID
        countryName
        provinceID
        provinceName
        cityID
        cityName
        subdistrictID
        subdistrictName
        postalCode
        longitude
        latitude
        uniqueKey
        isActive
      }
      addressLabel
      fullAddress
      countryID
      countryName
      provinceID
      provinceName
      cityID
      cityName
      subdistrictID
      subdistrictName
      postalCode
      longitude
      latitude
      uniqueKey
      isActive
    }
    pagination {
      page
      pageSize
      totalPages
      totalRows
      hasNext
    }
  }
}
    `;

export function useWarehouseListQuery(options?: Omit<Urql.UseQueryArgs<WarehouseListQueryVariables>, 'query'>) {
  return Urql.useQuery<WarehouseListQuery, WarehouseListQueryVariables>({ query: WarehouseListDocument, ...options });
};
export const WarehouseUpdateDocument = gql`
    mutation WarehouseUpdate($input: WarehouseUpdateInput!) {
  warehouseUpdate(input: $input) {
    warehouseID
    warehouseCode
    warehouseName
    branchID
    addressLabel
    fullAddress
    countryID
    countryName
    provinceID
    provinceName
    cityID
    cityName
    subdistrictID
    subdistrictName
    postalCode
    longitude
    latitude
    uniqueKey
    isActive
  }
}
    `;

export function useWarehouseUpdateMutation() {
  return Urql.useMutation<WarehouseUpdateMutation, WarehouseUpdateMutationVariables>(WarehouseUpdateDocument);
};
export type AuthLoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type AuthLoginMutation = { __typename?: 'Mutation', authLogin: { __typename?: 'AuthResponse', accessToken: string, refreshToken: string, defaultBranchID?: any | null, defaultBranchCode?: string | null, defaultBranchName?: string | null, defaultRoleName?: string | null, defaultWarehouseID?: any | null, defaultWarehouseName?: string | null, isAllBranches?: boolean | null, user: { __typename?: 'UserProfile', userID: string, fullName: string, email: string, phoneNumber: string, employeeID?: any | null, vendorID?: string | null }, branches?: Array<{ __typename?: 'BranchProfile', branchID: any, branchCode: string, branchName: string, warehouse?: { __typename?: 'BranchWarehouseProfile', warehouseID: any, warehouseCode: string, warehouseName: string } | null }> | null, appRolePermissions?: Array<{ __typename?: 'AppRolePermission', appID: string, appName: string, roles?: Array<{ __typename?: 'RoleProfile', resourceID: string, resourceName: string, permissions?: Array<{ __typename?: 'PermissionProfile', permissionID: string, permissionName: string }> | null }> | null }> | null } };

export type AuthLoginVendorMutationVariables = Exact<{
  input: LoginInput;
}>;


export type AuthLoginVendorMutation = { __typename?: 'Mutation', authLoginVendor: { __typename?: 'AuthResponse', accessToken: string, refreshToken: string, defaultBranchID?: any | null, defaultBranchCode?: string | null, defaultBranchName?: string | null, defaultRoleName?: string | null, defaultWarehouseID?: any | null, defaultWarehouseName?: string | null, isAllBranches?: boolean | null, user: { __typename?: 'UserProfile', userID: string, fullName: string, email: string, phoneNumber: string, employeeID?: any | null, vendorID?: string | null }, branches?: Array<{ __typename?: 'BranchProfile', branchID: any, branchCode: string, branchName: string, warehouse?: { __typename?: 'BranchWarehouseProfile', warehouseID: any, warehouseCode: string, warehouseName: string } | null }> | null, appRolePermissions?: Array<{ __typename?: 'AppRolePermission', appID: string, appName: string, roles?: Array<{ __typename?: 'RoleProfile', resourceID: string, resourceName: string, permissions?: Array<{ __typename?: 'PermissionProfile', permissionID: string, permissionName: string }> | null }> | null }> | null } };

export type AuthRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type AuthRefreshTokenMutation = { __typename?: 'Mutation', authRefreshToken: { __typename?: 'AuthResponse', accessToken: string, refreshToken: string, defaultBranchID?: any | null, defaultBranchCode?: string | null, defaultBranchName?: string | null, defaultRoleName?: string | null, defaultWarehouseID?: any | null, defaultWarehouseName?: string | null, isAllBranches?: boolean | null, user: { __typename?: 'UserProfile', userID: string, fullName: string, email: string, phoneNumber: string, employeeID?: any | null, vendorID?: string | null }, branches?: Array<{ __typename?: 'BranchProfile', branchID: any, branchCode: string, branchName: string, warehouse?: { __typename?: 'BranchWarehouseProfile', warehouseID: any, warehouseCode: string, warehouseName: string } | null }> | null, appRolePermissions?: Array<{ __typename?: 'AppRolePermission', appID: string, appName: string, roles?: Array<{ __typename?: 'RoleProfile', resourceID: string, resourceName: string, permissions?: Array<{ __typename?: 'PermissionProfile', permissionID: string, permissionName: string }> | null }> | null }> | null } };

export type AuthSetDefaultBranchMutationVariables = Exact<{
  input: SetDefaultBranchInput;
}>;


export type AuthSetDefaultBranchMutation = { __typename?: 'Mutation', authSetDefaultBranch: { __typename?: 'AuthResponse', accessToken: string, refreshToken: string, isAllBranches?: boolean | null, defaultBranchID?: any | null, defaultBranchCode?: string | null, defaultBranchName?: string | null, defaultWarehouseID?: any | null, defaultWarehouseName?: string | null, defaultRoleID?: any | null, defaultRoleName?: string | null, defaultRoleAppID?: string | null, defaultRoleAppName?: string | null, branches?: Array<{ __typename?: 'BranchProfile', branchID: any, branchCode: string, branchName: string }> | null, appRoles?: Array<{ __typename?: 'AppRole', roleID: any, roleName: string, appID: string, appName: string }> | null, appRolePermissions?: Array<{ __typename?: 'AppRolePermission', appID: string, appName: string }> | null } };

export type AppCreateMutationVariables = Exact<{
  input: AppCreateInput;
}>;


export type AppCreateMutation = { __typename?: 'Mutation', appCreate: { __typename?: 'App', appID: string } };

export type AppDeleteMutationVariables = Exact<{
  appID: Scalars['String']['input'];
}>;


export type AppDeleteMutation = { __typename?: 'Mutation', appDelete: boolean };

export type AppListAutocompletePagedQueryVariables = Exact<{
  qop: AppQopInput;
}>;


export type AppListAutocompletePagedQuery = { __typename?: 'Query', apps: { __typename?: 'AppPaged', items?: Array<{ __typename?: 'App', appID: string, appName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type AppListPagedQueryVariables = Exact<{
  qop: AppQopInput;
}>;


export type AppListPagedQuery = { __typename?: 'Query', apps: { __typename?: 'AppPaged', items?: Array<{ __typename?: 'App', appID: string, appName: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type AppLoadQueryVariables = Exact<{
  appID: Scalars['String']['input'];
}>;


export type AppLoadQuery = { __typename?: 'Query', app?: { __typename?: 'App', appID: string, appName: string, isActive: boolean } | null };

export type AppUpdateMutationVariables = Exact<{
  input: AppUpdateInput;
}>;


export type AppUpdateMutation = { __typename?: 'Mutation', appUpdate: { __typename?: 'App', appID: string } };

export type PermissionCreateMutationVariables = Exact<{
  input: PermissionCreateInput;
}>;


export type PermissionCreateMutation = { __typename?: 'Mutation', permissionCreate: { __typename?: 'Permission', permissionID: string } };

export type PermissionDeleteMutationVariables = Exact<{
  permissionID: Scalars['String']['input'];
}>;


export type PermissionDeleteMutation = { __typename?: 'Mutation', permissionDelete: boolean };

export type PermissionListAutocompletePagedQueryVariables = Exact<{
  qop: PermissionQopInput;
}>;


export type PermissionListAutocompletePagedQuery = { __typename?: 'Query', permissions: { __typename?: 'PermissionPaged', items?: Array<{ __typename?: 'Permission', permissionID: string, permissionName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PermissionListPagedQueryVariables = Exact<{
  qop: PermissionQopInput;
}>;


export type PermissionListPagedQuery = { __typename?: 'Query', permissions: { __typename?: 'PermissionPaged', items?: Array<{ __typename?: 'Permission', permissionID: string, permissionName: string, resourceName: string, parentResourceName?: string | null, apps?: Array<{ __typename?: 'App', appName: string }> | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PermissionLoadQueryVariables = Exact<{
  permissionID: Scalars['String']['input'];
}>;


export type PermissionLoadQuery = { __typename?: 'Query', permission?: { __typename?: 'Permission', permissionID: string, permissionName: string, resourceID: string, resourceName: string, apps?: Array<{ __typename?: 'App', appID: string, appName: string }> | null } | null };

export type PermissionUpdateMutationVariables = Exact<{
  input: PermissionUpdateInput;
}>;


export type PermissionUpdateMutation = { __typename?: 'Mutation', permissionUpdate: { __typename?: 'Permission', permissionID: string } };

export type ResourceCreateMutationVariables = Exact<{
  input: ResourceCreateInput;
}>;


export type ResourceCreateMutation = { __typename?: 'Mutation', resourceCreate: { __typename?: 'Resource', resourceID: string } };

export type ResourceDeleteMutationVariables = Exact<{
  resourceID: Scalars['String']['input'];
}>;


export type ResourceDeleteMutation = { __typename?: 'Mutation', resourceDelete: boolean };

export type ResourceListAutocompletePagedQueryVariables = Exact<{
  qop: ResourceQopInput;
}>;


export type ResourceListAutocompletePagedQuery = { __typename?: 'Query', resources: { __typename?: 'ResourcePaged', items?: Array<{ __typename?: 'Resource', resourceID: string, resourceName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ResourceListPagedQueryVariables = Exact<{
  qop: ResourceQopInput;
}>;


export type ResourceListPagedQuery = { __typename?: 'Query', resources: { __typename?: 'ResourcePaged', items?: Array<{ __typename?: 'Resource', resourceID: string, resourceName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ResourceLoadQueryVariables = Exact<{
  resourceID: Scalars['String']['input'];
}>;


export type ResourceLoadQuery = { __typename?: 'Query', resource?: { __typename?: 'Resource', resourceID: string, resourceName: string, parentResourceID?: string | null } | null };

export type ResourceUpdateMutationVariables = Exact<{
  input: ResourceUpdateInput;
}>;


export type ResourceUpdateMutation = { __typename?: 'Mutation', resourceUpdate: { __typename?: 'Resource', resourceID: string } };

export type RoleCreateMutationVariables = Exact<{
  input: RoleCreateInput;
}>;


export type RoleCreateMutation = { __typename?: 'Mutation', roleCreate: { __typename?: 'Roles', roleID: any } };

export type RoleDeleteMutationVariables = Exact<{
  roleID: Scalars['UUID']['input'];
}>;


export type RoleDeleteMutation = { __typename?: 'Mutation', roleDelete: boolean };

export type RoleListAutocompletePagedQueryVariables = Exact<{
  qop: RoleQopInput;
}>;


export type RoleListAutocompletePagedQuery = { __typename?: 'Query', roles: { __typename?: 'RolePaged', items?: Array<{ __typename?: 'Roles', roleID: any, roleName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type RoleListPagedQueryVariables = Exact<{
  qop: RoleQopInput;
}>;


export type RoleListPagedQuery = { __typename?: 'Query', roles: { __typename?: 'RolePaged', items?: Array<{ __typename?: 'Roles', roleID: any, roleName: string, description: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type RoleLoadQueryVariables = Exact<{
  roleID: Scalars['UUID']['input'];
}>;


export type RoleLoadQuery = { __typename?: 'Query', role?: { __typename?: 'RoleDetail', roleID: any, roleName: string, description: string, isActive: boolean, rolePermissions: Array<{ __typename?: 'RolePermission', permissionID: string, permissionName: string, resourceID: string, resourceName: string, parentResourceID: string, parentResourceName: string, appID: string, appName: string }> } | null };

export type RoleUpdateMutationVariables = Exact<{
  input: RoleUpdateInput;
}>;


export type RoleUpdateMutation = { __typename?: 'Mutation', roleUpdate: { __typename?: 'Roles', roleID: any } };

export type UserCreateMutationVariables = Exact<{
  input: UserCreateInput;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate: { __typename?: 'User', userID: any } };

export type UserDeleteMutationVariables = Exact<{
  userID: Scalars['UUID']['input'];
}>;


export type UserDeleteMutation = { __typename?: 'Mutation', userDelete: boolean };

export type UserListPagedQueryVariables = Exact<{
  qop?: InputMaybe<UserQopInput>;
}>;


export type UserListPagedQuery = { __typename?: 'Query', users: { __typename?: 'UserPaged', items?: Array<{ __typename?: 'User', userID: any, userType: string, fullName: string, email: string, phoneNumber: string, isActive: boolean, userRoles: Array<{ __typename?: 'UserRole', role: { __typename?: 'Roles', roleName: string } }> }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type UserLoadQueryVariables = Exact<{
  userID: Scalars['UUID']['input'];
}>;


export type UserLoadQuery = { __typename?: 'Query', user?: { __typename?: 'UserDetail', userID: any, userType: string, firstName: string, lastName: string, fullName: string, email: string, phoneNumber: string, vendorID?: string | null, employeeID?: any | null, isActive: boolean, isAllBranches?: boolean | null, userRoles: Array<{ __typename?: 'UserRole', roleID: any, role: { __typename?: 'Roles', roleID: any, roleName: string } }>, userBranches: Array<{ __typename?: 'UserBranch', userID: any, branchID: any, branchCode: string, branchName: string }> } | null };

export type UserUpdateMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'User', userID: any } };

export type GenerateLinkResetPasswordMutationVariables = Exact<{
  input: GenerateLinkResetPasswordInput;
}>;


export type GenerateLinkResetPasswordMutation = { __typename?: 'Mutation', generateLinkResetPassword: { __typename?: 'GenerateLinkResetPasswordResponse', success: boolean, nextRetryDelay: number, nextSessionDelay: number, remainingAttempts: number } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type BackgroundJobQueryVariables = Exact<{
  backgroundJobID: Scalars['UUID']['input'];
}>;


export type BackgroundJobQuery = { __typename?: 'Query', backgroundJob?: { __typename?: 'BackgroundJob', backgroundJobID: any, jobCategory: string, jobType: string, status: string, processedCount: number, totalCount: number, jobMessage: string } | null };

export type BackgroundJobDetailQueryVariables = Exact<{
  backgroundJobID: Scalars['UUID']['input'];
}>;


export type BackgroundJobDetailQuery = { __typename?: 'Query', backgroundJob?: { __typename?: 'BackgroundJob', backgroundJobID: any, branchID?: any | null, jobCategory: string, jobType: string, jobKey: string, jobDescription: string, jobMessage: string, jobData: string, status: string, processedCount: number, totalCount: number, retryCount: number, startedDatetime?: any | null, finishedDatetime?: any | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, createdAt: any, updatedAt: any, version: any } } | null };

export type BackgroundJobListQueryVariables = Exact<{
  qop: BackgroundJobQopInput;
}>;


export type BackgroundJobListQuery = { __typename?: 'Query', backgroundJobs: { __typename?: 'BackgroundJobPaged', items?: Array<{ __typename?: 'BackgroundJob', backgroundJobID: any, branchID?: any | null, jobCategory: string, jobType: string, jobKey: string, jobDescription: string, jobMessage: string, jobData: string, status: string, processedCount: number, totalCount: number, retryCount: number, startedDatetime?: any | null, finishedDatetime?: any | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, createdAt: any, updatedAt: any, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type BackgroundJobUpdateMutationVariables = Exact<{
  input: BackgroundJobUpdateInput;
}>;


export type BackgroundJobUpdateMutation = { __typename?: 'Mutation', backgroundJobUpdate: { __typename?: 'BackgroundJob', backgroundJobID: any, status: string } };

export type MasterdataBackgroundJobQueryVariables = Exact<{
  backgroundJobID: Scalars['UUID']['input'];
}>;


export type MasterdataBackgroundJobQuery = { __typename?: 'Query', masterdataBackgroundJob?: { __typename?: 'MasterdataBackgroundJob', backgroundJobID: any, jobCategory: string, jobType: string, status: string, processedCount: number, totalCount: number, jobMessage: string } | null };

export type BankAccountAutocompleteQueryVariables = Exact<{
  qop: BankAccountQopInput;
}>;


export type BankAccountAutocompleteQuery = { __typename?: 'Query', bankAccounts: { __typename?: 'BankAccountPaged', items?: Array<{ __typename?: 'BankAccount', bankAccountID: any, bankAccountNumber: string, bankID: any, bank: { __typename?: 'Bank', bankID: any, bankName: string } }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type BankAccountCreateMutationVariables = Exact<{
  input: BankAccountCreateInput;
}>;


export type BankAccountCreateMutation = { __typename?: 'Mutation', bankAccountCreate: { __typename?: 'BankAccount', bankAccountID: any } };

export type BankAccountDeleteMutationVariables = Exact<{
  bankAccountID: Scalars['UUID']['input'];
}>;


export type BankAccountDeleteMutation = { __typename?: 'Mutation', bankAccountDelete: boolean };

export type BankAccountListQueryVariables = Exact<{
  qop: BankAccountQopInput;
}>;


export type BankAccountListQuery = { __typename?: 'Query', bankAccounts: { __typename?: 'BankAccountPaged', items?: Array<{ __typename?: 'BankAccount', bankAccountID: any, bankID: any, bankAccountNumber: string, journalAccountCode: string, isActive: boolean, uniqueKey: string, bank: { __typename?: 'Bank', bankID: any, bankName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type BankAccountLoadQueryVariables = Exact<{
  bankAccountID: Scalars['UUID']['input'];
}>;


export type BankAccountLoadQuery = { __typename?: 'Query', bankAccount: { __typename?: 'BankAccount', bankAccountID: any, bankID: any, bankAccountNumber: string, journalAccountCode: string, journalAccountErpRefID?: string | null, journalAccountErpRefName?: string | null, isActive: boolean, uniqueKey: string, bank: { __typename?: 'Bank', bankID: any, bankName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type BankAccountUpdateMutationVariables = Exact<{
  input: BankAccountUpdateInput;
}>;


export type BankAccountUpdateMutation = { __typename?: 'Mutation', bankAccountUpdate: { __typename?: 'BankAccount', bankAccountID: any } };

export type BankAutocompleteQueryVariables = Exact<{
  qop: BankQopInput;
}>;


export type BankAutocompleteQuery = { __typename?: 'Query', banks: { __typename?: 'BankPaged', items?: Array<{ __typename?: 'Bank', bankID: any, bankName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type BankListQueryVariables = Exact<{
  qop: BankQopInput;
}>;


export type BankListQuery = { __typename?: 'Query', banks: { __typename?: 'BankPaged', items?: Array<{ __typename?: 'Bank', bankID: any, bankName: string, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type BillOfMaterialComponentDeleteMutationVariables = Exact<{
  billOfMaterialComponentID: Scalars['UUID']['input'];
}>;


export type BillOfMaterialComponentDeleteMutation = { __typename?: 'Mutation', billOfMaterialComponentDelete: boolean };

export type BillOfMaterialComponentListQueryVariables = Exact<{
  qop?: InputMaybe<BillOfMaterialComponentQopInput>;
}>;


export type BillOfMaterialComponentListQuery = { __typename?: 'Query', billOfMaterialComponents: { __typename?: 'BillOfMaterialComponentPaged', items?: Array<{ __typename?: 'BillOfMaterialComponent', billOfMaterialComponentID: any, billOfMaterialID: any, productID: any, uomCategoryID: any, uomID: any, qty: number, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type BillOfMaterialAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<BillOfMaterialQopInput>;
}>;


export type BillOfMaterialAutocompleteQuery = { __typename?: 'Query', billOfMaterials: { __typename?: 'BillOfMaterialPaged', items?: Array<{ __typename?: 'BillOfMaterial', billOfMaterialID: any, name: string, qty: number, uomID: any, product?: { __typename?: 'Product', productCode: string, productName: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type BillOfMaterialCreateMutationVariables = Exact<{
  input: BillOfMaterialCreateInput;
}>;


export type BillOfMaterialCreateMutation = { __typename?: 'Mutation', billOfMaterialCreate: { __typename?: 'BillOfMaterial', billOfMaterialID: any, name: string, qty: number, productID: any, uomCategoryID: any, uomID: any, description: string, isActive: boolean } };

export type BillOfMaterialDeleteMutationVariables = Exact<{
  billOfMaterialID: Scalars['UUID']['input'];
}>;


export type BillOfMaterialDeleteMutation = { __typename?: 'Mutation', billOfMaterialDelete: boolean };

export type BillOfMaterialListQueryVariables = Exact<{
  qop?: InputMaybe<BillOfMaterialQopInput>;
}>;


export type BillOfMaterialListQuery = { __typename?: 'Query', billOfMaterials: { __typename?: 'BillOfMaterialPaged', items?: Array<{ __typename?: 'BillOfMaterial', billOfMaterialID: any, name: string, productID: any, uomCategoryID: any, uomID: any, description: string, isActive: boolean, product?: { __typename?: 'Product', productCode: string, productName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type BillOfMaterialLoadQueryVariables = Exact<{
  billOfMaterialID: Scalars['UUID']['input'];
}>;


export type BillOfMaterialLoadQuery = { __typename?: 'Query', billOfMaterial: { __typename?: 'BillOfMaterial', billOfMaterialID: any, name: string, qty: number, productID: any, uomCategoryID: any, uomID: any, description: string, isActive: boolean, product?: { __typename?: 'Product', productCode: string, productName: string } | null, uomCategory?: { __typename?: 'UomCategory', uomCategoryName: string } | null, uom?: { __typename?: 'Uom', uomName: string } | null, components: Array<{ __typename?: 'BillOfMaterialComponent', billOfMaterialComponentID: any, billOfMaterialID: any, productID: any, uomCategoryID: any, uomID: any, qty: number, isActive: boolean, product?: { __typename?: 'Product', productCode: string, productName: string, barcode: string, baseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null } | null, uomCategory?: { __typename?: 'UomCategory', uomCategoryName: string } | null, uom?: { __typename?: 'Uom', relationType: string, conversionInfo: string, convertionDecimal: number, convertionRate: number, convertionRateMultiplier: number, uomName: string } | null }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type BillOfMaterialUpdateMutationVariables = Exact<{
  input: BillOfMaterialUpdateInput;
}>;


export type BillOfMaterialUpdateMutation = { __typename?: 'Mutation', billOfMaterialUpdate: { __typename?: 'BillOfMaterial', billOfMaterialID: any, name: string, productID: any, uomCategoryID: any, uomID: any, description: string, isActive: boolean, qty: number } };

export type BranchBankAccountCreateMutationVariables = Exact<{
  input: BranchBankAccountCreateInput;
}>;


export type BranchBankAccountCreateMutation = { __typename?: 'Mutation', branchBankAccountCreate: { __typename?: 'BranchBankAccount', branchBankAccountID: any, branchID: any, bankAccountID: any, merchantID: string, isActive: boolean } };

export type BranchBankAccountDeleteMutationVariables = Exact<{
  branchBankAccountID: Scalars['UUID']['input'];
}>;


export type BranchBankAccountDeleteMutation = { __typename?: 'Mutation', branchBankAccountDelete: boolean };

export type BranchBankAccountListQueryVariables = Exact<{
  qop?: InputMaybe<BranchBankAccountQopInput>;
}>;


export type BranchBankAccountListQuery = { __typename?: 'Query', branchBankAccounts: { __typename?: 'BranchBankAccountPaged', items: Array<{ __typename?: 'BranchBankAccount', branchBankAccountID: any, branchID: any, bankAccountID: any, merchantID: string, isActive: boolean, branch: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string }, bankAccount?: { __typename?: 'BankAccount', bankAccountID: any, bankAccountNumber: string, bank: { __typename?: 'Bank', bankID: any, bankName: string } } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any, updatedAt: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type BranchBankAccountUpdateMutationVariables = Exact<{
  input: BranchBankAccountUpdateInput;
}>;


export type BranchBankAccountUpdateMutation = { __typename?: 'Mutation', branchBankAccountUpdate: { __typename?: 'BranchBankAccount', branchBankAccountID: any, branchID: any, bankAccountID: any, merchantID: string, isActive: boolean } };

export type BranchCategoryAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<BranchCategoryQopInput>;
}>;


export type BranchCategoryAutocompleteQuery = { __typename?: 'Query', branchCategories: { __typename?: 'BranchCategoryPaged', items?: Array<{ __typename?: 'BranchCategory', branchCategoryID: any, branchCategoryName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type BranchCategoryCreateMutationVariables = Exact<{
  input: BranchCategoryCreateInput;
}>;


export type BranchCategoryCreateMutation = { __typename?: 'Mutation', branchCategoryCreate: { __typename?: 'BranchCategory', branchCategoryID: any, branchCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type BranchCategoryDeleteMutationVariables = Exact<{
  branchCategoryID: Scalars['UUID']['input'];
}>;


export type BranchCategoryDeleteMutation = { __typename?: 'Mutation', branchCategoryDelete: boolean };

export type BranchCategoryListQueryVariables = Exact<{
  qop?: InputMaybe<BranchCategoryQopInput>;
}>;


export type BranchCategoryListQuery = { __typename?: 'Query', branchCategories: { __typename?: 'BranchCategoryPaged', items?: Array<{ __typename?: 'BranchCategory', branchCategoryID: any, branchCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type BranchCategoryLoadQueryVariables = Exact<{
  branchCategoryID: Scalars['UUID']['input'];
}>;


export type BranchCategoryLoadQuery = { __typename?: 'Query', branchCategory?: { __typename?: 'BranchCategory', branchCategoryID: any, branchCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type BranchCategoryUpdateMutationVariables = Exact<{
  input: BranchCategoryUpdateInput;
}>;


export type BranchCategoryUpdateMutation = { __typename?: 'Mutation', branchCategoryUpdate: { __typename?: 'BranchCategory', branchCategoryID: any, branchCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type BranchQrisMerchantCreateMutationVariables = Exact<{
  input: BranchQrisMerchantCreateInput;
}>;


export type BranchQrisMerchantCreateMutation = { __typename?: 'Mutation', branchQrisMerchantCreate: { __typename?: 'BranchQrisMerchant', branchQrisMerchantID: any, branchID: any, branchCode: string, branchName: string, bankID: any, bankName: string, providerCode: string, nmid: string, terminalID: string, merchantName: string, isActive: boolean } };

export type BranchQrisMerchantDeleteMutationVariables = Exact<{
  branchQrisMerchantID: Scalars['UUID']['input'];
}>;


export type BranchQrisMerchantDeleteMutation = { __typename?: 'Mutation', branchQrisMerchantDelete: boolean };

export type BranchQrisMerchantListQueryVariables = Exact<{
  qop?: InputMaybe<BranchQrisMerchantQopInput>;
}>;


export type BranchQrisMerchantListQuery = { __typename?: 'Query', branchQrisMerchants: { __typename?: 'BranchQrisMerchantPaged', items: Array<{ __typename?: 'BranchQrisMerchant', branchQrisMerchantID: any, branchID: any, branchCode: string, branchName: string, bankID: any, bankName: string, providerCode: string, nmid: string, terminalID: string, merchantName: string, isActive: boolean, uniqueKey: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type BranchQrisMerchantLoadQueryVariables = Exact<{
  branchQrisMerchantID: Scalars['UUID']['input'];
}>;


export type BranchQrisMerchantLoadQuery = { __typename?: 'Query', branchQrisMerchant: { __typename?: 'BranchQrisMerchant', branchQrisMerchantID: any, branchID: any, branchCode: string, branchName: string, bankID: any, bankName: string, providerCode: string, nmid: string, terminalID: string, merchantName: string, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any, createdByUserName?: string | null, updatedByUserName?: string | null } } };

export type BranchQrisMerchantUpdateMutationVariables = Exact<{
  input: BranchQrisMerchantUpdateInput;
}>;


export type BranchQrisMerchantUpdateMutation = { __typename?: 'Mutation', branchQrisMerchantUpdate: { __typename?: 'BranchQrisMerchant', branchQrisMerchantID: any, branchID: any, branchCode: string, branchName: string, bankID: any, bankName: string, providerCode: string, nmid: string, terminalID: string, merchantName: string, isActive: boolean } };

export type BranchMenuGroupBindingsQueryVariables = Exact<{
  qop?: InputMaybe<BranchSalesChannelCategoryGroupQopInput>;
}>;


export type BranchMenuGroupBindingsQuery = { __typename?: 'Query', branchSalesChannelCategoryGroups: { __typename?: 'BranchSalesChannelCategoryGroupPaged', items?: Array<{ __typename?: 'BranchSalesChannelCategoryGroup', branchSalesChannelCategoryGroupID: any, branchID: any, salesChannelID: string, salesChannelCategoryGroupID: any, salesChannelCategoryGroupName: string }> | null } };

export type BranchMenuGroupCreateMutationVariables = Exact<{
  input: BranchSalesChannelCategoryGroupCreateInput;
}>;


export type BranchMenuGroupCreateMutation = { __typename?: 'Mutation', branchSalesChannelCategoryGroupCreate: { __typename?: 'BranchSalesChannelCategoryGroup', branchSalesChannelCategoryGroupID: any } };

export type BranchMenuGroupDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BranchMenuGroupDeleteMutation = { __typename?: 'Mutation', branchSalesChannelCategoryGroupDelete: boolean };

export type BranchMenuGroupUpdateMutationVariables = Exact<{
  input: BranchSalesChannelCategoryGroupUpdateInput;
}>;


export type BranchMenuGroupUpdateMutation = { __typename?: 'Mutation', branchSalesChannelCategoryGroupUpdate: { __typename?: 'BranchSalesChannelCategoryGroup', branchSalesChannelCategoryGroupID: any } };

export type BranchMerchantMapCreateMutationVariables = Exact<{
  input: BranchSalesChannelMerchantMapCreateInput;
}>;


export type BranchMerchantMapCreateMutation = { __typename?: 'Mutation', branchSalesChannelMerchantMapCreate: { __typename?: 'BranchSalesChannelMerchantMap', branchSalesChannelMerchantMapID: any } };

export type BranchMerchantMapDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BranchMerchantMapDeleteMutation = { __typename?: 'Mutation', branchSalesChannelMerchantMapDelete: boolean };

export type BranchMerchantMapListQueryVariables = Exact<{
  qop?: InputMaybe<BranchSalesChannelMerchantMapQopInput>;
}>;


export type BranchMerchantMapListQuery = { __typename?: 'Query', branchSalesChannelMerchantMaps: { __typename?: 'BranchSalesChannelMerchantMapPaged', items?: Array<{ __typename?: 'BranchSalesChannelMerchantMap', branchSalesChannelMerchantMapID: any, branchID: any, branchCode: string, branchName: string, salesChannelID: string, salesChannelName: string, externalMerchantID: string, externalStoreID: string, isActive: boolean, isPaused: boolean, operatingHours?: { __typename?: 'OperatingHours', mon: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, tue: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, wed: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, thu: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, fri: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, sat: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, sun: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> } } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null } } };

export type BranchMerchantMapOperatingHoursQueryVariables = Exact<{
  branchSalesChannelMerchantMapID: Scalars['UUID']['input'];
}>;


export type BranchMerchantMapOperatingHoursQuery = { __typename?: 'Query', branchSalesChannelMerchantMap: { __typename?: 'BranchSalesChannelMerchantMap', branchSalesChannelMerchantMapID: any, branchID: any, branchCode: string, branchName: string, salesChannelID: string, salesChannelName: string, externalMerchantID: string, externalStoreID: string, isPaused: boolean, packagingProductID?: any | null, packagingQty: number, packagingChargeAmount: number, packagingProduct?: { __typename?: 'Product', productID: any, barcode: string, productName: string } | null, operatingHours?: { __typename?: 'OperatingHours', mon: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, tue: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, wed: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, thu: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, fri: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, sat: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> }, sun: { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> } } | null } };

export type BranchMerchantMapUpdateMutationVariables = Exact<{
  input: BranchSalesChannelMerchantMapUpdateInput;
}>;


export type BranchMerchantMapUpdateMutation = { __typename?: 'Mutation', branchSalesChannelMerchantMapUpdate: { __typename?: 'BranchSalesChannelMerchantMap', branchSalesChannelMerchantMapID: any } };

export type BranchMerchantMapsQueryVariables = Exact<{
  branchID: Scalars['UUID']['input'];
}>;


export type BranchMerchantMapsQuery = { __typename?: 'Query', branchSalesChannelMerchantMapsByBranch: Array<{ __typename?: 'BranchSalesChannelMerchantMap', branchSalesChannelMerchantMapID: any, branchID: any, salesChannelID: string, salesChannelName: string, externalMerchantID: string, externalStoreID: string, gmt: number, isActive: boolean, packagingProductID?: any | null, packagingQty: number, packagingChargeAmount: number, packagingProduct?: { __typename?: 'Product', productID: any, barcode: string, productName: string } | null }> };

export type BranchSalesChannelOperatingHoursUpdateMutationVariables = Exact<{
  input: BranchSalesChannelOperatingHoursUpdateInput;
}>;


export type BranchSalesChannelOperatingHoursUpdateMutation = { __typename?: 'Mutation', branchSalesChannelOperatingHoursUpdate: { __typename?: 'BranchSalesChannelMerchantMap', branchSalesChannelMerchantMapID: any } };

export type BranchSalesChannelPackagingUpdateMutationVariables = Exact<{
  input: BranchSalesChannelPackagingUpdateInput;
}>;


export type BranchSalesChannelPackagingUpdateMutation = { __typename?: 'Mutation', branchSalesChannelPackagingUpdate: { __typename?: 'BranchSalesChannelMerchantMap', branchSalesChannelMerchantMapID: any } };

export type BranchSalesChannelPauseDurationsQueryVariables = Exact<{
  salesChannelID: Scalars['String']['input'];
}>;


export type BranchSalesChannelPauseDurationsQuery = { __typename?: 'Query', branchSalesChannelPauseDurations: Array<{ __typename?: 'PauseDurationOption', value: PauseDuration, label: string }> };

export type BranchSalesChannelPauseUpdateMutationVariables = Exact<{
  input: BranchSalesChannelPauseUpdateInput;
}>;


export type BranchSalesChannelPauseUpdateMutation = { __typename?: 'Mutation', branchSalesChannelPauseUpdate: { __typename?: 'BranchSalesChannelMerchantMap', branchSalesChannelMerchantMapID: any, isPaused: boolean } };

export type MarketplaceMenuSyncMutationVariables = Exact<{
  input: MarketplaceMenuSyncInput;
}>;


export type MarketplaceMenuSyncMutation = { __typename?: 'Mutation', marketplaceMenuSync: { __typename?: 'MarketplaceMenuSyncResult', syncedCount: number, totalCount: number, itemCount?: number | null, categoryCount?: number | null, menuGroupName?: string | null, message?: string | null } };

export type MarketplaceStoreStatusQueryVariables = Exact<{
  salesChannelID: Scalars['String']['input'];
  externalMerchantID: Scalars['String']['input'];
}>;


export type MarketplaceStoreStatusQuery = { __typename?: 'Query', marketplaceStoreStatus?: { __typename?: 'MarketplaceStoreStatus', isOpen: boolean, closeReason: string, isInSpecialOpeningHourRange: boolean } | null };

export type MenuGroupsForBranchQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelCategoryGroupQopInput>;
}>;


export type MenuGroupsForBranchQuery = { __typename?: 'Query', salesChannelCategoryGroups: { __typename?: 'SalesChannelCategoryGroupPaged', items?: Array<{ __typename?: 'SalesChannelCategoryGroup', salesChannelCategoryGroupID: any, salesChannelCategoryGroupName: string }> | null } };

export type OperatingHoursDayFieldsFragment = { __typename?: 'OperatingHoursDay', isOpen: boolean, periods: Array<{ __typename?: 'OperatingHoursPeriod', startTime: string, endTime: string }> };

export type SalesChannelsForBranchQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelQopInput>;
}>;


export type SalesChannelsForBranchQuery = { __typename?: 'Query', salesChannels: { __typename?: 'SalesChannelPaged', items: Array<{ __typename?: 'SalesChannel', salesChannelID: string, salesChannelName: string, salesChannelType: string, useCategoryMap: boolean }> } };

export type BranchAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<BranchQopInput>;
}>;


export type BranchAutocompleteQuery = { __typename?: 'Query', branches: { __typename?: 'BranchPaged', items?: Array<{ __typename?: 'Branch', branchID: any, branchName: string, branchCode: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type BranchCreateMutationVariables = Exact<{
  input: BranchCreateInput;
}>;


export type BranchCreateMutation = { __typename?: 'Mutation', branchCreate: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, canSell?: boolean | null, isMain?: boolean | null, cashJournalAccountCode?: string | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null, country?: { __typename?: 'Country', countryID: string, countryName: string, uniqueKey: string, isActive: boolean } | null, province?: { __typename?: 'Province', provinceID: string, provinceName: string, countryID: string, uniqueKey: string, isActive: boolean } | null, city?: { __typename?: 'City', cityID: string, cityName: string, gmt: number, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean } | null, subdistrict?: { __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string, cityID: string, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean } | null } };

export type BranchDeleteMutationVariables = Exact<{
  branchID: Scalars['UUID']['input'];
}>;


export type BranchDeleteMutation = { __typename?: 'Mutation', branchDelete: boolean };

export type BranchListQueryVariables = Exact<{
  qop?: InputMaybe<BranchQopInput>;
}>;


export type BranchListQuery = { __typename?: 'Query', branches: { __typename?: 'BranchPaged', items?: Array<{ __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, productAvailabilityTemplateID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, picName?: string | null, picPhoneNumber?: string | null, canSell?: boolean | null, isMain?: boolean | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null, branchCategory?: { __typename?: 'BranchCategory', branchCategoryName: string } | null, pricelist?: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string } | null, productAvailabilityTemplate?: { __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string } | null, mainSupplyWarehouse?: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type BranchLoadQueryVariables = Exact<{
  branchID: Scalars['UUID']['input'];
}>;


export type BranchLoadQuery = { __typename?: 'Query', branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, productAvailabilityTemplateID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, picName?: string | null, picPhoneNumber?: string | null, canSell?: boolean | null, isMain?: boolean | null, cashJournalAccountCode?: string | null, cashJournalAccountErpRefID?: string | null, cashJournalAccountErpRefName?: string | null, pettyCashJournalAccountCode?: string | null, pettyCashJournalAccountErpRefID?: string | null, pettyCashJournalAccountErpRefName?: string | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null, branchStoreSupervisors: Array<{ __typename?: 'BranchStoreSupervisor', branchStoreSupervisorID: any, userID: any, user?: { __typename?: 'User', fullName: string } | null }>, branchCategory?: { __typename?: 'BranchCategory', branchCategoryName: string } | null, pricelist?: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string } | null, productAvailabilityTemplate?: { __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string } | null, mainSupplyWarehouse?: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } | null, country?: { __typename?: 'Country', countryID: string, countryName: string, uniqueKey: string, isActive: boolean } | null, province?: { __typename?: 'Province', provinceID: string, provinceName: string, countryID: string, uniqueKey: string, isActive: boolean } | null, city?: { __typename?: 'City', cityID: string, cityName: string, gmt: number, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean } | null, subdistrict?: { __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string, cityID: string, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean } | null, branchSalesPaymentMethods: Array<{ __typename?: 'BranchSalesPaymentMethod', branchSalesPaymentMethodID: any, branchID: any, paymentMethodID: any, uniqueKey: string, paymentMethod?: { __typename?: 'SalesPaymentMethod', salesPaymentMethodID: any, salesPaymentMethodName: string, salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, uniqueKey: string, isActive?: boolean | null } | null }>, branchPosBookmarks: Array<{ __typename?: 'BranchPosBookmark', branchPosBookmarkID: any, branchID: any, posBookmarkID: any, uniqueKey: string, posBookmark?: { __typename?: 'PosBookmark', posBookmarkID: any, posBookmarkName: string, uniqueKey: string } | null }>, edcTerminals: Array<{ __typename?: 'EdcTerminal', edcTerminalID: any, edcTerminalName: string, serialNumber: string }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type BranchStoreSupervisorAutocompleteQueryVariables = Exact<{
  qop: BranchStoreSupervisorQopInput;
}>;


export type BranchStoreSupervisorAutocompleteQuery = { __typename?: 'Query', branchStoreSupervisors: { __typename?: 'BranchStoreSupervisorPaged', items?: Array<{ __typename?: 'BranchStoreSupervisor', branchStoreSupervisorID: any, branchID: any, userID: any, uniqueKey: string, isActive: boolean, user?: { __typename?: 'User', fullName: string } | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type BranchUpdateMutationVariables = Exact<{
  input: BranchUpdateInput;
}>;


export type BranchUpdateMutation = { __typename?: 'Mutation', branchUpdate: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, canSell?: boolean | null, isMain?: boolean | null, cashJournalAccountCode?: string | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } };

export type CancelConsignmentInvoiceMutationVariables = Exact<{
  input: VendorConsignmentInvoiceCancelInput;
}>;


export type CancelConsignmentInvoiceMutation = { __typename?: 'Mutation', cancelConsignmentInvoice: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, status: string, cancelledReason: string } };

export type ConsignmentConfigListQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentInvoiceConfigQopInput>;
}>;


export type ConsignmentConfigListQuery = { __typename?: 'Query', vendorConsignmentInvoiceConfigs: { __typename?: 'VendorConsignmentInvoiceConfigPaged', items?: Array<{ __typename?: 'VendorConsignmentInvoiceConfig', vendorConsignmentInvoiceConfigID: any, vendorID: any, vendorName: string, cutoffDay: number, graceDays: number, paymentDueDays: number, billCycleType: string, billCycleInterval: number, billCycleStartDate?: any | null, isDefault: boolean, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type ConsignmentEmailableIdsByPeriodQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentInvoiceQopInput>;
}>;


export type ConsignmentEmailableIdsByPeriodQuery = { __typename?: 'Query', vendorConsignmentInvoices: { __typename?: 'VendorConsignmentInvoicePaged', items?: Array<{ __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, vendorID: any, status: string }> | null, pagination: { __typename?: 'PaginationResult', hasNext?: boolean | null, totalRows?: number | null } } };

export type ConsignmentSettlementBranchesQueryVariables = Exact<{
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type ConsignmentSettlementBranchesQuery = { __typename?: 'Query', consignmentSettlementBranches: Array<{ __typename?: 'ConsignmentSettlementBranchRow', branchID: any, branchName: string, subtotal: number, commissionAmount: number, taxAmount: number, payout: number }> };

export type ConsignmentSettlementExportQueryVariables = Exact<{
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type ConsignmentSettlementExportQuery = { __typename?: 'Query', consignmentSettlementExport: { __typename?: 'ConsignmentSettlementExportResult', fileName: string, downloadURL: string } };

export type ConsignmentSettlementHistoryQueryVariables = Exact<{
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type ConsignmentSettlementHistoryQuery = { __typename?: 'Query', consignmentSettlementHistory: Array<{ __typename?: 'ConsignmentSettlementHistory', vendorConsignmentInvoiceHistoryID: any, editedAt: any, editedByUserID?: any | null, editedByUserName: string, reason: string, fieldChanges: Array<{ __typename?: 'ConsignmentSettlementFieldChange', field: string, label: string, oldValue: string, newValue: string }>, branchChanges: Array<{ __typename?: 'ConsignmentSettlementBranchChange', branchID: string, branchName: string, field: string, label: string, oldValue: string, newValue: string }> }> };

export type ConsignmentSettlementItemsQueryVariables = Exact<{
  qop?: InputMaybe<SalesConsignmentInvoiceItemQopInput>;
}>;


export type ConsignmentSettlementItemsQuery = { __typename?: 'Query', salesConsignmentInvoiceItems: { __typename?: 'SalesConsignmentInvoiceItemPaged', items: Array<{ __typename?: 'SalesConsignmentInvoiceItem', salesConsignmentInvoiceItemID: any, salesInvoiceNumber: string, productCode: string, productName: string, barcode: string, qty: number, uomName: string, unitPrice: number, total: number, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, additionalDiscountPerc?: number | null, additionalDiscountAmount?: number | null, commissionAmount?: number | null, commissionInclTaxAmount?: number | null, consignmentVendorTotal: number, salesInvoiceItem: { __typename?: 'SalesInvoiceItem', promoType?: string | null, promoParentProductID?: any | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type ConsignmentSettlementListQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentInvoiceQopInput>;
}>;


export type ConsignmentSettlementListQuery = { __typename?: 'Query', vendorConsignmentInvoices: { __typename?: 'VendorConsignmentInvoicePaged', items?: Array<{ __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, vendorConsignmentInvoiceNumber: string, vendorID: any, vendorName: string, cutoffDate: any, periodStartDate: any, periodEndDate: any, paymentDueDate?: any | null, status: string, isManual: boolean, sourceInvoiceCount: number, totalItemQty: number, subtotal: number, discountAmount: number, taxAmount: number, commissionAmount: number, returnsAdjustmentAmount: number, vendorPayoutTotal: number, emailStatus: string, emailSentAt?: any | null, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorConsignmentBranch: Array<{ __typename?: 'VendorConsignmentBranch', isRent: boolean, currentPeriod?: { __typename?: 'VendorConsignmentBranchPeriod', rentalStatus: string } | null }> } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type ConsignmentSettlementListExportQueryVariables = Exact<{
  filter: ConsignmentSettlementListExportFilterInput;
}>;


export type ConsignmentSettlementListExportQuery = { __typename?: 'Query', consignmentSettlementListExport: { __typename?: 'ConsignmentSettlementExportResult', fileName: string, downloadURL: string } };

export type ConsignmentSettlementLoadQueryVariables = Exact<{
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type ConsignmentSettlementLoadQuery = { __typename?: 'Query', vendorConsignmentInvoice?: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, vendorConsignmentInvoiceNumber: string, vendorConsignmentInvoiceDatetime: any, vendorID: any, vendorName: string, cutoffDay: number, cutoffDate: any, periodStartDate: any, periodEndDate: any, paymentDueDate?: any | null, status: string, sourceInvoiceCount: number, totalItemQty: number, subtotal: number, discountAmount: number, taxAmount: number, commissionAmount: number, returnsAdjustmentAmount: number, vendorPayoutTotal: number, chargeAmount: number, transferFeeAmount: number, totalPayableAmount: number, payoutBankID?: any | null, payoutBankName: string, payoutBankAccountNumber: string, settlementBankAccountID?: any | null, settlementBankName: string, settlementBankAccountName: string, settlementBankAccountNumber: string, paidByUserName: string, paidAt?: any | null, paidReference: string, cancelledReason: string, cancelledByUserName: string, cancelledAt?: any | null, noteInternal: string, emailStatus: string, emailSentAt?: any | null, isManual: boolean, manualByUserName: string, manualAt?: any | null, manualReason: string, vendor?: { __typename?: 'Vendor', isPKP: boolean, vendorConsignmentBranch: Array<{ __typename?: 'VendorConsignmentBranch', branchID: any, isRent: boolean, currentPeriod?: { __typename?: 'VendorConsignmentBranchPeriod', rentalStatus: string, effectiveStartDate?: any | null, effectiveEndDate?: any | null } | null }> } | null } | null };

export type ConsignmentSettlementPeriodsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsignmentSettlementPeriodsQuery = { __typename?: 'Query', consignmentSettlementPeriods: Array<{ __typename?: 'ConsignmentSettlementPeriod', periodStartDate: any, periodEndDate: any, totalCount: number, emailableCount: number, sentCount: number, totalCommission: number, totalPayout: number }> };

export type ConsignmentSettlementPivotQueryVariables = Exact<{
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type ConsignmentSettlementPivotQuery = { __typename?: 'Query', consignmentSettlementPivot: Array<{ __typename?: 'ConsignmentSettlementPivotRow', productID: any, productCode: string, productName: string, barcode: string, branchID: any, qty: number, total: number, commissionAmount: number, vendorShareAmount: number, branch: { __typename?: 'Branch', branchName: string } }> };

export type ConsignmentSettlementSummaryQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentInvoiceQopInput>;
}>;


export type ConsignmentSettlementSummaryQuery = { __typename?: 'Query', vendorConsignmentInvoiceSummary: { __typename?: 'VendorConsignmentInvoiceSummary', count: number, draftCount: number, proformaCount: number, emailableCount: number, totalSubtotal: number, totalCommissionAmount: number, totalTaxAmount: number, totalVendorPayoutTotal: number } };

export type CreateConsignmentConfigMutationVariables = Exact<{
  input: VendorConsignmentInvoiceConfigCreateInput;
}>;


export type CreateConsignmentConfigMutation = { __typename?: 'Mutation', vendorConsignmentInvoiceConfigCreate: { __typename?: 'VendorConsignmentInvoiceConfig', vendorConsignmentInvoiceConfigID: any } };

export type CreateManualConsignmentProformaMutationVariables = Exact<{
  input: CreateManualConsignmentProformaInput;
}>;


export type CreateManualConsignmentProformaMutation = { __typename?: 'Mutation', createManualConsignmentProforma: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, vendorConsignmentInvoiceNumber: string, status: string } };

export type EditConsignmentSettlementMutationVariables = Exact<{
  input: EditConsignmentSettlementInput;
}>;


export type EditConsignmentSettlementMutation = { __typename?: 'Mutation', editConsignmentSettlement: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, commissionAmount: number, vendorPayoutTotal: number, periodStartDate: any, periodEndDate: any, isManual: boolean, manualByUserName: string, manualAt?: any | null, manualReason: string } };

export type GenerateConsignmentInvoiceMutationVariables = Exact<{
  input: GenerateConsignmentInvoiceInput;
}>;


export type GenerateConsignmentInvoiceMutation = { __typename?: 'Mutation', generateConsignmentInvoice: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, vendorConsignmentInvoiceNumber: string, status: string, payoutBankName: string, payoutBankAccountNumber: string } };

export type GenerateConsignmentInvoicesBulkMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  payoutBanks?: InputMaybe<Array<ConsignmentPayoutBankInput> | ConsignmentPayoutBankInput>;
}>;


export type GenerateConsignmentInvoicesBulkMutation = { __typename?: 'Mutation', generateConsignmentInvoicesBulk: Array<{ __typename?: 'BulkConsignmentGenerateResult', vendorConsignmentInvoiceID: any, success: boolean, error: string }> };

export type LockConsignmentDraftToProformaMutationVariables = Exact<{
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type LockConsignmentDraftToProformaMutation = { __typename?: 'Mutation', lockConsignmentDraftToProforma: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, vendorConsignmentInvoiceNumber: string, status: string } };

export type MarkConsignmentInvoicePaidMutationVariables = Exact<{
  input: VendorConsignmentInvoicePayInput;
}>;


export type MarkConsignmentInvoicePaidMutation = { __typename?: 'Mutation', markConsignmentInvoicePaid: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, status: string, paidAt?: any | null, paidReference: string, settlementBankName: string } };

export type MarkConsignmentInvoicesPaidBulkMutationVariables = Exact<{
  input: MarkConsignmentInvoicesPaidBulkInput;
}>;


export type MarkConsignmentInvoicesPaidBulkMutation = { __typename?: 'Mutation', markConsignmentInvoicesPaidBulk: Array<{ __typename?: 'BulkConsignmentPayResult', vendorConsignmentInvoiceID: any, success: boolean, error: string }> };

export type MoveConsignmentItemsMutationVariables = Exact<{
  input: MoveConsignmentItemsInput;
}>;


export type MoveConsignmentItemsMutation = { __typename?: 'Mutation', moveConsignmentItems: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, status: string, subtotal: number, commissionAmount: number, vendorPayoutTotal: number, totalPayableAmount: number, totalItemQty: number } };

export type RecalculateAllConsignmentProformasMutationVariables = Exact<{ [key: string]: never; }>;


export type RecalculateAllConsignmentProformasMutation = { __typename?: 'Mutation', recalculateAllConsignmentProformas: number };

export type RecalculateConsignmentProformaMutationVariables = Exact<{
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type RecalculateConsignmentProformaMutation = { __typename?: 'Mutation', recalculateConsignmentProforma: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, status: string, chargeAmount: number, transferFeeAmount: number, totalPayableAmount: number } };

export type RecomputeConsignmentDraftsMutationVariables = Exact<{ [key: string]: never; }>;


export type RecomputeConsignmentDraftsMutation = { __typename?: 'Mutation', recomputeConsignmentDrafts: boolean };

export type SalesConsignmentInvoicesForMoveQueryVariables = Exact<{
  qop?: InputMaybe<SalesConsignmentInvoiceQopInput>;
}>;


export type SalesConsignmentInvoicesForMoveQuery = { __typename?: 'Query', salesConsignmentInvoices: { __typename?: 'SalesConsignmentInvoicePaged', items: Array<{ __typename?: 'SalesConsignmentInvoice', salesConsignmentInvoiceID: any, salesConsignmentInvoiceNumber: string, salesConsignmentInvoiceDatetime: any, totalItemQty: number, subtotal: number, commissionAmount: number, consignmentVendorTotal: number, status: string, vendorConsignmentInvoiceID?: any | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type SendConsignmentInvoiceEmailMutationVariables = Exact<{
  vendorConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type SendConsignmentInvoiceEmailMutation = { __typename?: 'Mutation', sendConsignmentInvoiceEmail: { __typename?: 'VendorConsignmentInvoice', vendorConsignmentInvoiceID: any, status: string, chargeAmount: number, transferFeeAmount: number, totalPayableAmount: number } };

export type SendConsignmentInvoiceEmailsBulkMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type SendConsignmentInvoiceEmailsBulkMutation = { __typename?: 'Mutation', sendConsignmentInvoiceEmailsBulk: Array<{ __typename?: 'BulkConsignmentEmailResult', vendorConsignmentInvoiceID: any, success: boolean, error: string }> };

export type UpdateConsignmentConfigMutationVariables = Exact<{
  input: VendorConsignmentInvoiceConfigUpdateInput;
}>;


export type UpdateConsignmentConfigMutation = { __typename?: 'Mutation', vendorConsignmentInvoiceConfigUpdate: { __typename?: 'VendorConsignmentInvoiceConfig', vendorConsignmentInvoiceConfigID: any } };

export type VendorConsignmentBranchAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentBranchQopInput>;
}>;


export type VendorConsignmentBranchAutocompleteQuery = { __typename?: 'Query', vendorConsignmentBranches: { __typename?: 'VendorConsignmentBranchPaged', items?: Array<{ __typename?: 'VendorConsignmentBranch', vendorConsignmentBranchID: any, vendorID: any, branchID: any, branchCode: string, branchName: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorConsignmentInvoiceEmailPreviewQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type VendorConsignmentInvoiceEmailPreviewQuery = { __typename?: 'Query', vendorConsignmentInvoiceEmailPreview: string };

export type VendorPayoutBankQueryVariables = Exact<{
  vendorID: Scalars['UUID']['input'];
}>;


export type VendorPayoutBankQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', vendorID: any, vendorName: string, bankID?: any | null, bankName?: string | null, bankAccountName?: string | null, bankAccountNumber?: string | null } };

export type ConsignmentStockInRequestApproveMutationVariables = Exact<{
  input: ConsignmentStockInRequestApproveInput;
}>;


export type ConsignmentStockInRequestApproveMutation = { __typename?: 'Mutation', consignmentStockInRequestApprove: { __typename?: 'ConsignmentStockInRequest', consignmentStockInRequestID: any, status: string, consignmentStockInID?: any | null, consignmentStockInNumber: string, consignmentStockOutID?: any | null, consignmentStockOutNumber: string } };

export type ConsignmentStockInRequestFilesQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInRequestFileQopInput>;
}>;


export type ConsignmentStockInRequestFilesQuery = { __typename?: 'Query', consignmentStockInRequestFiles: { __typename?: 'ConsignmentStockInRequestFilePaged', items: Array<{ __typename?: 'ConsignmentStockInRequestFile', consignmentStockInRequestFileID: any, consignmentStockInRequestID: any, consignmentStockInRequestFileRole: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type ConsignmentStockInRequestItemsQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInRequestItemQopInput>;
}>;


export type ConsignmentStockInRequestItemsQuery = { __typename?: 'Query', consignmentStockInRequestItems: { __typename?: 'ConsignmentStockInRequestItemPaged', items: Array<{ __typename?: 'ConsignmentStockInRequestItem', consignmentStockInRequestItemID: any, consignmentStockInRequestID: any, productID: any, productCode: string, productName: string, qtyRequested: number, expiredDate?: any | null, qtyReceived: number, qtyOutstanding: number, qtyApproved: number, expiredDateConfirmed?: any | null, receivingReason: string, noteReason: string, noteRequester: string, uomID: any, uomName: string, uomDecimal: number }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type ConsignmentStockInRequestListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInRequestQopInput>;
}>;


export type ConsignmentStockInRequestListQuery = { __typename?: 'Query', consignmentStockInRequests: { __typename?: 'ConsignmentStockInRequestPaged', items: Array<{ __typename?: 'ConsignmentStockInRequest', consignmentStockInRequestID: any, consignmentStockInRequestNumber: string, requestDatetime: any, estimatedDeliveryDate: any, vendorID: any, vendorName: string, branchID: any, branchName: string, totalItemQtyRequested: number, totalItemQtyApproved: number, status: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type ConsignmentStockInRequestLoadQueryVariables = Exact<{
  consignmentStockInRequestID: Scalars['UUID']['input'];
}>;


export type ConsignmentStockInRequestLoadQuery = { __typename?: 'Query', consignmentStockInRequest?: { __typename?: 'ConsignmentStockInRequest', consignmentStockInRequestID: any, consignmentStockInRequestNumber: string, requestDatetime: any, estimatedDeliveryDate: any, vendorID: any, vendorCode: string, vendorName: string, branchID: any, branchCode: string, branchName: string, noteAdditional: string, totalItemQtyRequested: number, totalItemQtyApproved: number, submittedDatetime?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, consignmentStockInID?: any | null, consignmentStockInNumber: string, consignmentStockOutID?: any | null, consignmentStockOutNumber: string, status: string } | null };

export type ConsignmentStockInRequestReceivingInfoQueryVariables = Exact<{
  consignmentStockInID: Scalars['UUID']['input'];
}>;


export type ConsignmentStockInRequestReceivingInfoQuery = { __typename?: 'Query', consignmentStockIn?: { __typename?: 'ConsignmentStockIn', consignmentStockInID: any, consignmentStockInNumber: string, receivedByName?: string | null, warehouseID: any, warehouseLocationID: any, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseName: string }, warehouseLocation: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string } } | null };

export type ConsignmentStockInRequestRejectMutationVariables = Exact<{
  input: ConsignmentStockInRequestRejectInput;
}>;


export type ConsignmentStockInRequestRejectMutation = { __typename?: 'Mutation', consignmentStockInRequestReject: { __typename?: 'ConsignmentStockInRequest', consignmentStockInRequestID: any, status: string, rejectionReason?: string | null } };

export type ConsignmentStockInRequestSummaryQueryVariables = Exact<{
  vendorID?: InputMaybe<Scalars['UUID']['input']>;
  branchID?: InputMaybe<Scalars['UUID']['input']>;
  branchIDs?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type ConsignmentStockInRequestSummaryQuery = { __typename?: 'Query', consignmentStockInRequestSummary: { __typename?: 'ConsignmentStockInRequestSummary', totalRequest: number, pending: number, approved: number, rejected: number } };

export type ConsignmentStockInCancelMutationVariables = Exact<{
  consignmentStockInID: Scalars['UUID']['input'];
}>;


export type ConsignmentStockInCancelMutation = { __typename?: 'Mutation', consignmentStockInCancel: boolean };

export type ConsignmentStockInConfirmMutationVariables = Exact<{
  consignmentStockInID: Scalars['UUID']['input'];
}>;


export type ConsignmentStockInConfirmMutation = { __typename?: 'Mutation', consignmentStockInConfirm: { __typename?: 'ConsignmentStockIn', consignmentStockInID: any } };

export type ConsignmentStockInCreateMutationVariables = Exact<{
  input: ConsignmentStockInCreateInput;
}>;


export type ConsignmentStockInCreateMutation = { __typename?: 'Mutation', consignmentStockInCreate: { __typename?: 'ConsignmentStockIn', branchID: any, consignmentStockInNumber: string, consignmentStockInDatetime: any, vendorID: any, warehouseID: any, warehouseLocationID: any, receivedByName?: string | null, externalReferenceNumber?: string | null, noteInternal: string } };

export type ConsignmentStockInItemsQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInItemQopInput>;
}>;


export type ConsignmentStockInItemsQuery = { __typename?: 'Query', consignmentStockInItems: { __typename?: 'ConsignmentStockInItemPaged', items: Array<{ __typename?: 'ConsignmentStockInItem', consignmentStockInItemID: any, consignmentStockInID: any, productID: any, productCode: string, productName: string, description: string, productWeight: number, qtyReceived: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConvertionDecimal: number, baseUomQty: number, product?: { __typename?: 'Product', barcode: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ConsignmentStockInListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInQopInput>;
}>;


export type ConsignmentStockInListQuery = { __typename?: 'Query', consignmentStockIns: { __typename?: 'ConsignmentStockInPaged', items: Array<{ __typename?: 'ConsignmentStockIn', consignmentStockInID: any, consignmentStockInNumber: string, consignmentStockInDatetime: any, branchID: any, gmt: number, vendorID: any, warehouseID: any, warehouseLocationID: any, externalReferenceNumber?: string | null, receivedByName?: string | null, totalItemQtyReceived: number, totalItemWeightReceived: number, noteInternal: string, status: string, vendor: { __typename?: 'Vendor', vendorName: string }, warehouse: { __typename?: 'Warehouse', warehouseName: string } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type ConsignmentStockInLoadQueryVariables = Exact<{
  consignmentStockInID: Scalars['UUID']['input'];
}>;


export type ConsignmentStockInLoadQuery = { __typename?: 'Query', consignmentStockIn?: { __typename?: 'ConsignmentStockIn', consignmentStockInID: any, consignmentStockInDatetime: any, consignmentStockInNumber: string, branchID: any, gmt: number, vendorID: any, warehouseID: any, warehouseLocationID: any, receivedByName?: string | null, externalReferenceNumber?: string | null, totalItemQtyReceived: number, status: string, noteInternal: string, totalItemWeightReceived: number, vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, isPKP: boolean, taxable?: boolean | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentCommisionFeePerc?: number | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null }, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null }, warehouseLocation: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseStorageType?: string | null, warehouseID: any, branchID: any, parentWarehouseLocationID?: any | null, warehouseLocationGroupID?: any | null, isHoldInventory: boolean, uniqueKey: string, isActive: boolean, isSystemGenerated?: boolean | null }, files?: Array<{ __typename?: 'ConsignmentStockInFile', consignmentStockInFileID: any, consignmentStockInID: any, consignmentStockInFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null } | null };

export type ConsignmentStockInUpdateMutationVariables = Exact<{
  input: ConsignmentStockInUpdateInput;
}>;


export type ConsignmentStockInUpdateMutation = { __typename?: 'Mutation', consignmentStockInUpdate: { __typename?: 'ConsignmentStockIn', consignmentStockInID: any } };

export type ConsignmentStockOutCancelMutationVariables = Exact<{
  consignmentStockOutID: Scalars['UUID']['input'];
}>;


export type ConsignmentStockOutCancelMutation = { __typename?: 'Mutation', consignmentStockOutCancel: boolean };

export type ConsignmentStockOutConfirmMutationVariables = Exact<{
  consignmentStockOutID: Scalars['UUID']['input'];
}>;


export type ConsignmentStockOutConfirmMutation = { __typename?: 'Mutation', consignmentStockOutConfirm: { __typename?: 'ConsignmentStockOut', consignmentStockOutID: any } };

export type ConsignmentStockOutCreateMutationVariables = Exact<{
  input: ConsignmentStockOutCreateInput;
}>;


export type ConsignmentStockOutCreateMutation = { __typename?: 'Mutation', consignmentStockOutCreate: { __typename?: 'ConsignmentStockOut', branchID: any, consignmentStockOutNumber: string, consignmentStockOutDatetime: any, vendorID: any, warehouseID: any, warehouseLocationID: any, receivedByVendorName?: string | null, externalReferenceNumber?: string | null, noteInternal: string } };

export type ConsignmentStockOutItemsQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockOutItemQopInput>;
}>;


export type ConsignmentStockOutItemsQuery = { __typename?: 'Query', consignmentStockOutItems: { __typename?: 'ConsignmentStockOutItemPaged', items: Array<{ __typename?: 'ConsignmentStockOutItem', consignmentStockOutItemID: any, consignmentStockOutID: any, productID: any, productCode: string, productName: string, description: string, productWeight: number, qty: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConvertionDecimal: number, baseUomQty: number, product?: { __typename?: 'Product', barcode: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ConsignmentStockOutListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockOutQopInput>;
}>;


export type ConsignmentStockOutListQuery = { __typename?: 'Query', consignmentStockOuts: { __typename?: 'ConsignmentStockOutPaged', items: Array<{ __typename?: 'ConsignmentStockOut', consignmentStockOutID: any, consignmentStockOutNumber: string, consignmentStockOutDatetime: any, branchID: any, gmt: number, vendorID: any, warehouseID: any, warehouseLocationID: any, externalReferenceNumber?: string | null, receivedByVendorName?: string | null, totalItemQty: number, totalItemWeight: number, noteInternal: string, status: string, vendor: { __typename?: 'Vendor', vendorName: string }, warehouse: { __typename?: 'Warehouse', warehouseName: string } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type ConsignmentStockOutLoadQueryVariables = Exact<{
  consignmentStockOutID: Scalars['UUID']['input'];
}>;


export type ConsignmentStockOutLoadQuery = { __typename?: 'Query', consignmentStockOut?: { __typename?: 'ConsignmentStockOut', consignmentStockOutID: any, consignmentStockOutDatetime: any, consignmentStockOutNumber: string, branchID: any, gmt: number, vendorID: any, warehouseID: any, warehouseLocationID: any, receivedByVendorName?: string | null, externalReferenceNumber?: string | null, totalItemQty: number, status: string, noteInternal: string, totalItemWeight: number, vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, isPKP: boolean, taxable?: boolean | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentCommisionFeePerc?: number | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null }, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null }, warehouseLocation: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseStorageType?: string | null, warehouseID: any, branchID: any, parentWarehouseLocationID?: any | null, warehouseLocationGroupID?: any | null, isHoldInventory: boolean, uniqueKey: string, isActive: boolean, isSystemGenerated?: boolean | null }, files?: Array<{ __typename?: 'ConsignmentStockOutFile', consignmentStockOutFileID: any, consignmentStockOutID: any, consignmentStockOutFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null } | null };

export type ConsignmentStockOutUpdateMutationVariables = Exact<{
  input: ConsignmentStockOutUpdateInput;
}>;


export type ConsignmentStockOutUpdateMutation = { __typename?: 'Mutation', consignmentStockOutUpdate: { __typename?: 'ConsignmentStockOut', consignmentStockOutID: any } };

export type CustomerAutocompleteQueryVariables = Exact<{
  qop: CustomerQopInput;
}>;


export type CustomerAutocompleteQuery = { __typename?: 'Query', customers: { __typename?: 'CustomerPaged', items?: Array<{ __typename?: 'Customer', customerID: any, customerCode: string, customerName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type CustomerCreateMutationVariables = Exact<{
  input: CustomerCreateInput;
}>;


export type CustomerCreateMutation = { __typename?: 'Mutation', customerCreate: { __typename?: 'Customer', customerID: any, customerCode: string, customerName: string } };

export type CustomerDeleteMutationVariables = Exact<{
  customerID: Scalars['UUID']['input'];
}>;


export type CustomerDeleteMutation = { __typename?: 'Mutation', customerDelete: boolean };

export type CustomerListQueryVariables = Exact<{
  qop: CustomerQopInput;
}>;


export type CustomerListQuery = { __typename?: 'Query', customers: { __typename?: 'CustomerPaged', items?: Array<{ __typename?: 'Customer', customerID: any, customerCode: string, customerName: string, memberTypeID?: any | null, isMember: boolean, email?: string | null, phoneNumber: string, memberPoints: number, gender?: string | null, joinDate: any, isDefault: boolean, uniqueKey: string, isActive: boolean, memberType?: { __typename?: 'MemberType', memberTypeID: any, memberTypeName: string, spendPerPoint: number } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type CustomerLoadQueryVariables = Exact<{
  customerID: Scalars['UUID']['input'];
}>;


export type CustomerLoadQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', customerID: any, customerCode: string, customerName: string, memberTypeID?: any | null, isMember: boolean, email?: string | null, phoneNumber: string, memberPoints: number, gender?: string | null, joinDate: any, isDefault: boolean, uniqueKey: string, isActive: boolean, memberType?: { __typename?: 'MemberType', memberTypeID: any, memberTypeName: string, spendPerPoint: number, uniqueKey: string, isActive: boolean } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any }, addresses: Array<{ __typename?: 'CustomerAddress', customerAddressID: any, customerID: any, isMain: boolean, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive: boolean }> } };

export type CustomerUpdateMutationVariables = Exact<{
  input: CustomerUpdateInput;
}>;


export type CustomerUpdateMutation = { __typename?: 'Mutation', customerUpdate: { __typename?: 'Customer', customerID: any, customerCode: string, customerName: string } };

export type ContainerContentSearchContainerQueryVariables = Exact<{
  qop: OutboundContainerQopInput;
}>;


export type ContainerContentSearchContainerQuery = { __typename?: 'Query', outboundContainers: { __typename?: 'OutboundContainerPaged', items?: Array<{ __typename?: 'OutboundContainer', outboundContainerID: any, containerNumber: string, sourceDocumentNumber: string, sourceDocumentType: string, totalItems: number, totalQty: number, isDo: boolean, isEmpty: boolean, fromWarehouseID: any, toWarehouseID?: any | null, toWarehouse?: { __typename?: 'Warehouse', warehouseName: string } | null }> | null } };

export type DeliveryOrderBatchAddLeftoverMutationVariables = Exact<{
  deliveryOrderBatchID: Scalars['UUID']['input'];
}>;


export type DeliveryOrderBatchAddLeftoverMutation = { __typename?: 'Mutation', deliveryOrderBatchAddLeftoverContainers: { __typename?: 'DeliveryOrderBatch', deliveryOrderBatchID: any, status: string, totalScannedContainers: number } };

export type DeliveryOrderBatchCancelMutationVariables = Exact<{
  deliveryOrderBatchID: Scalars['UUID']['input'];
}>;


export type DeliveryOrderBatchCancelMutation = { __typename?: 'Mutation', deliveryOrderBatchCancel: boolean };

export type DeliveryOrderBatchCreateMutationVariables = Exact<{
  input: DeliveryOrderBatchCreateInput;
}>;


export type DeliveryOrderBatchCreateMutation = { __typename?: 'Mutation', deliveryOrderBatchCreate: { __typename?: 'DeliveryOrderBatch', deliveryOrderBatchID: any, deliveryOrderBatchNumber: string, branchID: any, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toBranchID: any, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, deliveredBy: string, vendorID?: any | null, vendorCode: string, vendorName: string, vendorRefNumber: string, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, deliveryOrderDate?: any | null, status: string, totalScannedContainers: number, totalGeneratedDeliveryOrders: number, errorMessage: string, noteInternal: string, containers?: Array<{ __typename?: 'DeliveryOrderBatchContainer', deliveryOrderBatchContainerID: any, deliveryOrderBatchID: any, outboundContainerID: any, containerNumber: string, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, deliveryOrderID?: any | null, itemCount: number, scannedAt: any, scannedByUserID: any, scannedByUserName: string }> | null } };

export type DeliveryOrderBatchDestinationSummaryQueryVariables = Exact<{
  destinationWarehouseID: Scalars['UUID']['input'];
  originWarehouseID?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type DeliveryOrderBatchDestinationSummaryQuery = { __typename?: 'Query', deliveryOrderBatchDestinationSummary: { __typename?: 'DeliveryOrderBatchDestinationSummary', toEligible: number, containersLeft: number, itemsLeft: number, transferOrders?: Array<{ __typename?: 'DeliveryOrderBatchEligibleTransferOrder', transferOrderID: any, transferOrderNumber: string, containerCount: number, itemCount: number }> | null } };

export type DeliveryOrderBatchGenerateMutationVariables = Exact<{
  input: DeliveryOrderBatchGenerateInput;
}>;


export type DeliveryOrderBatchGenerateMutation = { __typename?: 'Mutation', deliveryOrderBatchGenerate: { __typename?: 'DeliveryOrderBatch', deliveryOrderBatchID: any, deliveryOrderBatchNumber: string, status: string, totalGeneratedDeliveryOrders: number, errorMessage: string } };

export type DeliveryOrderBatchGenerateAndShipMutationVariables = Exact<{
  input: DeliveryOrderBatchGenerateInput;
}>;


export type DeliveryOrderBatchGenerateAndShipMutation = { __typename?: 'Mutation', deliveryOrderBatchGenerateAndShip: { __typename?: 'DeliveryOrderBatch', deliveryOrderBatchID: any, deliveryOrderBatchNumber: string, status: string, totalGeneratedDeliveryOrders: number, totalShippedDeliveryOrders: number, isShipAfterGenerate: boolean, errorMessage: string } };

export type DeliveryOrderBatchListQueryVariables = Exact<{
  qop?: InputMaybe<DeliveryOrderBatchQopInput>;
}>;


export type DeliveryOrderBatchListQuery = { __typename?: 'Query', deliveryOrderBatches: { __typename?: 'DeliveryOrderBatchPaged', items?: Array<{ __typename?: 'DeliveryOrderBatch', deliveryOrderBatchID: any, deliveryOrderBatchNumber: string, fromWarehouseName: string, toWarehouseName: string, status: string, totalScannedContainers: number, totalGeneratedDeliveryOrders: number, deliveryOrderBatchDatetime: any }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type DeliveryOrderBatchLoadQueryVariables = Exact<{
  deliveryOrderBatchID: Scalars['UUID']['input'];
}>;


export type DeliveryOrderBatchLoadQuery = { __typename?: 'Query', deliveryOrderBatch?: { __typename?: 'DeliveryOrderBatch', deliveryOrderBatchID: any, deliveryOrderBatchNumber: string, branchID: any, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toBranchID: any, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, deliveredBy: string, vendorID?: any | null, vendorCode: string, vendorName: string, vendorRefNumber: string, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, deliveryOrderDate?: any | null, shippedDatetime?: any | null, isShipAfterGenerate: boolean, totalShippedDeliveryOrders: number, status: string, totalScannedContainers: number, totalGeneratedDeliveryOrders: number, totalFailedSourceDocuments: number, generatedDatetime?: any | null, errorMessage: string, noteInternal: string, sourceDocuments?: Array<{ __typename?: 'DeliveryOrderBatchSourceDocument', deliveryOrderBatchSourceDocumentID: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, totalContainers: number, status: string, deliveryOrderID?: any | null, deliveryOrderNumber: string, errorMessage: string }> | null, containers?: Array<{ __typename?: 'DeliveryOrderBatchContainer', deliveryOrderBatchContainerID: any, deliveryOrderBatchID: any, outboundContainerID: any, containerNumber: string, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, deliveryOrderID?: any | null, itemCount: number, scannedAt: any, scannedByUserID: any, scannedByUserName: string }> | null } | null };

export type DeliveryOrderBatchRegenerateFailedMutationVariables = Exact<{
  deliveryOrderBatchID: Scalars['UUID']['input'];
}>;


export type DeliveryOrderBatchRegenerateFailedMutation = { __typename?: 'Mutation', deliveryOrderBatchRegenerateFailed: { __typename?: 'DeliveryOrderBatch', deliveryOrderBatchID: any, deliveryOrderBatchNumber: string, status: string, totalGeneratedDeliveryOrders: number, totalFailedSourceDocuments: number, errorMessage: string } };

export type DeliveryOrderBatchRemoveContainerMutationVariables = Exact<{
  deliveryOrderBatchID: Scalars['UUID']['input'];
  deliveryOrderBatchContainerID: Scalars['UUID']['input'];
}>;


export type DeliveryOrderBatchRemoveContainerMutation = { __typename?: 'Mutation', deliveryOrderBatchRemoveContainer: boolean };

export type DeliveryOrderBatchScanMutationVariables = Exact<{
  input: DeliveryOrderBatchScanInput;
}>;


export type DeliveryOrderBatchScanMutation = { __typename?: 'Mutation', deliveryOrderBatchScan: { __typename?: 'DeliveryOrderBatchScanResult', code: string, message: string, pendingDeliveryOrderNumber?: string | null, container?: { __typename?: 'DeliveryOrderBatchContainer', deliveryOrderBatchContainerID: any, deliveryOrderBatchID: any, outboundContainerID: any, containerNumber: string, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, deliveryOrderID?: any | null, itemCount: number, scannedAt: any, scannedByUserID: any, scannedByUserName: string } | null } };

export type DeliveryOrderStatusQueryVariables = Exact<{
  deliveryOrderID: Scalars['UUID']['input'];
}>;


export type DeliveryOrderStatusQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderNumber: string, status: string } };

export type DeliveryOrderCreateMutationVariables = Exact<{
  input: DeliveryOrderCreateInput;
}>;


export type DeliveryOrderCreateMutation = { __typename?: 'Mutation', deliveryOrderCreate: { __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderDatetime: any, deliveryOrderDatetimeUTC: any, branchID: any, gmt: number, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, deliveryBy: string, vendorID?: any | null, vendorCode?: string | null, vendorName?: string | null, vendorRefNumber?: string | null, landedCost: number, totalContainers: number, totalItems: number, totalItemQty: number, noteInternal: string, shippedDatetime?: any | null, shippedDatetimeUTC?: any | null, shippedByUserID?: any | null, shippedByUserName?: string | null, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, cancelledDatetime?: any | null, cancelledDatetimeUTC?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, status: string } };

export type DeliveryOrdersQueryVariables = Exact<{
  qop: DeliveryOrderQopInput;
}>;


export type DeliveryOrdersQuery = { __typename?: 'Query', deliveryOrders: { __typename?: 'DeliveryOrderPaged', items?: Array<{ __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderNumber: string, deliveryOrderDatetime: any, deliveryOrderDatetimeUTC: any, branchID: any, gmt: number, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, deliveryAddress: string, deliveryBy: string, vendorID?: any | null, vendorCode?: string | null, vendorName?: string | null, vendorRefNumber?: string | null, landedCost: number, totalContainers: number, totalItems: number, totalItemQty: number, noteInternal: string, shippedDatetime?: any | null, shippedDatetimeUTC?: any | null, shippedByUserID?: any | null, shippedByUserName?: string | null, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, cancelledDatetime?: any | null, cancelledDatetimeUTC?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, status: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type DeliveryOrderLoadQueryVariables = Exact<{
  deliveryOrderID: Scalars['UUID']['input'];
}>;


export type DeliveryOrderLoadQuery = { __typename?: 'Query', deliveryOrder: { __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderNumber: string, deliveryOrderDatetime: any, deliveryOrderDatetimeUTC: any, branchID: any, gmt: number, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, deliveryAddress: string, deliveryBy: string, vendorID?: any | null, vendorCode?: string | null, vendorName?: string | null, vendorRefNumber?: string | null, landedCost: number, totalContainers: number, totalItems: number, totalItemQty: number, noteInternal: string, shippedDatetime?: any | null, shippedDatetimeUTC?: any | null, shippedByUserID?: any | null, deliveredDatetime?: any | null, shippedByUserName?: string | null, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, cancelledDatetime?: any | null, cancelledDatetimeUTC?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, status: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, version: any } } };

export type DeliveryOrderUpdateMutationVariables = Exact<{
  input: DeliveryOrderUpdateInput;
}>;


export type DeliveryOrderUpdateMutation = { __typename?: 'Mutation', deliveryOrderUpdate: { __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderNumber: string, deliveryOrderDatetime: any, deliveryOrderDatetimeUTC: any, branchID: any, gmt: number, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, deliveryAddress: string, deliveryBy: string, vendorID?: any | null, vendorCode?: string | null, vendorName?: string | null, vendorRefNumber?: string | null, landedCost: number, totalContainers: number, totalItems: number, totalItemQty: number, noteInternal: string, shippedDatetime?: any | null, shippedDatetimeUTC?: any | null, shippedByUserID?: any | null, shippedByUserName?: string | null, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, cancelledDatetime?: any | null, cancelledDatetimeUTC?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, status: string } };

export type DeliveryOrderBatchDetachSourceDocumentMutationVariables = Exact<{
  sourceDocumentType: Scalars['String']['input'];
  sourceDocumentID: Scalars['UUID']['input'];
}>;


export type DeliveryOrderBatchDetachSourceDocumentMutation = { __typename?: 'Mutation', deliveryOrderBatchDetachSourceDocument: number };

export type DeliveryOrderCancelMutationVariables = Exact<{
  input: DeliveryOrderCancelInput;
}>;


export type DeliveryOrderCancelMutation = { __typename?: 'Mutation', deliveryOrderCancel: { __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderNumber: string, deliveryOrderDatetime: any, deliveryOrderDatetimeUTC: any, branchID: any, gmt: number, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, deliveryAddress: string, deliveryBy: string, vendorID?: any | null, vendorCode?: string | null, vendorName?: string | null, vendorRefNumber?: string | null, landedCost: number, totalContainers: number, totalItems: number, totalItemQty: number, noteInternal: string, shippedDatetime?: any | null, shippedDatetimeUTC?: any | null, shippedByUserID?: any | null, shippedByUserName?: string | null, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, cancelledDatetime?: any | null, cancelledDatetimeUTC?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, status: string } };

export type DeliveryOrderShippedMutationVariables = Exact<{
  input: DeliveryOrderShippedInput;
}>;


export type DeliveryOrderShippedMutation = { __typename?: 'Mutation', deliveryOrderShipped: { __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderNumber: string, deliveryOrderDatetime: any, deliveryOrderDatetimeUTC: any, branchID: any, gmt: number, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, deliveryAddress: string, deliveryBy: string, vendorID?: any | null, vendorCode?: string | null, vendorName?: string | null, vendorRefNumber?: string | null, landedCost: number, totalContainers: number, totalItems: number, totalItemQty: number, noteInternal: string, shippedDatetime?: any | null, shippedDatetimeUTC?: any | null, shippedByUserID?: any | null, shippedByUserName?: string | null, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, cancelledDatetime?: any | null, cancelledDatetimeUTC?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, status: string } };

export type OutboundContainerCreateMutationVariables = Exact<{
  input: OutboundContainerCreateInput;
}>;


export type OutboundContainerCreateMutation = { __typename?: 'Mutation', outboundContainerCreate: { __typename?: 'OutboundContainer', outboundContainerID: any, deliveryOrderID?: any | null, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, containerNumber: string, fromBranchID: any, gmt: number, fromWarehouseID: any, toBranchID?: any | null, toWarehouseID?: any | null, isEmpty: boolean, isDo: boolean, totalItems: number, totalQty: number, totalWeight: number, noteInternal: string } };

export type OutboundContainerDeleteMutationVariables = Exact<{
  outboundContainerID: Scalars['UUID']['input'];
}>;


export type OutboundContainerDeleteMutation = { __typename?: 'Mutation', outboundContainerDelete: boolean };

export type OutboundContainerItemsQueryVariables = Exact<{
  qop: OutboundContainerItemQopInput;
}>;


export type OutboundContainerItemsQuery = { __typename?: 'Query', outboundContainerItems: { __typename?: 'OutboundContainerItemPaged', items?: Array<{ __typename?: 'OutboundContainerItem', outboundContainerItemID: any, outboundContainerID: any, productID: any, productCode: string, productName: string, productWeight: number, qty: number, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, product?: { __typename?: 'Product', barcode: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type OutboundContainerItemsSummaryQueryVariables = Exact<{
  qop: OutboundContainerItemGroupedQopInput;
}>;


export type OutboundContainerItemsSummaryQuery = { __typename?: 'Query', outboundContainerItemsSummary: { __typename?: 'OutboundContainerItemGroupedPaged', items?: Array<{ __typename?: 'OutboundContainerItemGrouped', deliveryOrderID?: any | null, productID: any, productCode: string, productName: string, productWeight: number, qty: number, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, product?: { __typename?: 'Product', barcode: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type OutboundContainersQueryVariables = Exact<{
  qop: OutboundContainerQopInput;
}>;


export type OutboundContainersQuery = { __typename?: 'Query', outboundContainers: { __typename?: 'OutboundContainerPaged', items?: Array<{ __typename?: 'OutboundContainer', outboundContainerID: any, deliveryOrderID?: any | null, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, containerNumber: string, fromBranchID: any, gmt: number, isEmpty: boolean, isDo: boolean, draftDeliveryOrderBatchNumber?: string | null, fromWarehouseID: any, toBranchID?: any | null, toWarehouseID?: any | null, totalItems: number, isReceived: boolean, totalQty: number, totalWeight: number, noteInternal: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type EdcTerminalAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<EdcTerminalQopInput>;
}>;


export type EdcTerminalAutocompleteQuery = { __typename?: 'Query', edcTerminals: { __typename?: 'EdcTerminalPaged', items: Array<{ __typename?: 'EdcTerminal', edcTerminalID: any, edcTerminalName: string, serialNumber: string, branchID: any, uniqueKey: string }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type EdcTerminalCreateMutationVariables = Exact<{
  input: EdcTerminalCreateInput;
}>;


export type EdcTerminalCreateMutation = { __typename?: 'Mutation', edcTerminalCreate: { __typename?: 'EdcTerminal', edcTerminalID: any, edcTerminalName: string, serialNumber: string, branchID: any, bankAccountID?: any | null, isActive: boolean } };

export type EdcTerminalDeleteMutationVariables = Exact<{
  edcTerminalID: Scalars['UUID']['input'];
}>;


export type EdcTerminalDeleteMutation = { __typename?: 'Mutation', edcTerminalDelete: boolean };

export type EdcTerminalListQueryVariables = Exact<{
  qop?: InputMaybe<EdcTerminalQopInput>;
}>;


export type EdcTerminalListQuery = { __typename?: 'Query', edcTerminals: { __typename?: 'EdcTerminalPaged', items: Array<{ __typename?: 'EdcTerminal', edcTerminalID: any, edcTerminalName: string, serialNumber: string, branchID: any, bankAccountID?: any | null, uniqueKey: string, isActive: boolean, branch: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string }, bankAccount?: { __typename?: 'BankAccount', bankAccountID: any, bankAccountNumber: string, bank: { __typename?: 'Bank', bankID: any, bankName: string } } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type EdcTerminalLoadQueryVariables = Exact<{
  EdcTerminalID: Scalars['UUID']['input'];
}>;


export type EdcTerminalLoadQuery = { __typename?: 'Query', edcTerminal: { __typename?: 'EdcTerminal', edcTerminalID: any, edcTerminalName: string, serialNumber: string, branchID: any, bankAccountID?: any | null, isActive: boolean, uniqueKey: string, branch: { __typename?: 'Branch', branchID: any, branchName: string }, bankAccount?: { __typename?: 'BankAccount', bankAccountID: any, bankAccountNumber: string, bank: { __typename?: 'Bank', bankID: any, bankName: string } } | null } };

export type EdcTerminalUpdateMutationVariables = Exact<{
  input: EdcTerminalUpdateInput;
}>;


export type EdcTerminalUpdateMutation = { __typename?: 'Mutation', edcTerminalUpdate: { __typename?: 'EdcTerminal', edcTerminalID: any, edcTerminalName: string, serialNumber: string, branchID: any, bankAccountID?: any | null, isActive: boolean } };

export type ErpAccountJournalAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<AccountJournalQopInput>;
}>;


export type ErpAccountJournalAutocompleteQuery = { __typename?: 'Query', erpAccountJournals: { __typename?: 'AccountJournalPaged', items?: Array<{ __typename?: 'AccountJournal', accountJournalID: number, code: string, name: string, displayName: string, type: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ErpProductCategoryAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ErpProductCategoryQopInput>;
}>;


export type ErpProductCategoryAutocompleteQuery = { __typename?: 'Query', erpProductCategories: { __typename?: 'ErpProductCategoryPaged', items?: Array<{ __typename?: 'ErpProductCategory', productCategoryID: number, productCategoryName: string, parentID: number, parentName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ExpenseItemAutocompleteQueryVariables = Exact<{
  qop: ExpenseItemQopInput;
}>;


export type ExpenseItemAutocompleteQuery = { __typename?: 'Query', expenseItems: { __typename?: 'ExpenseItemPaged', items?: Array<{ __typename?: 'ExpenseItem', expenseItemID: any, expenseItemName: string, journalAccountCode: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ExpenseItemCreateMutationVariables = Exact<{
  input: ExpenseItemCreateInput;
}>;


export type ExpenseItemCreateMutation = { __typename?: 'Mutation', expenseItemCreate: { __typename?: 'ExpenseItem', expenseItemID: any } };

export type ExpenseItemDeleteMutationVariables = Exact<{
  expenseItemID: Scalars['UUID']['input'];
}>;


export type ExpenseItemDeleteMutation = { __typename?: 'Mutation', expenseItemDelete: boolean };

export type ExpenseItemListQueryVariables = Exact<{
  qop: ExpenseItemQopInput;
}>;


export type ExpenseItemListQuery = { __typename?: 'Query', expenseItems: { __typename?: 'ExpenseItemPaged', items?: Array<{ __typename?: 'ExpenseItem', expenseItemID: any, expenseItemName: string, journalAccountCode: string, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ExpenseItemLoadQueryVariables = Exact<{
  expenseItemID: Scalars['UUID']['input'];
}>;


export type ExpenseItemLoadQuery = { __typename?: 'Query', expenseItem: { __typename?: 'ExpenseItem', expenseItemID: any, expenseItemName: string, journalAccountCode: string, journalAccountErpRefID?: string | null, journalAccountErpRefName?: string | null, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ExpenseItemUpdateMutationVariables = Exact<{
  input: ExpenseItemUpdateInput;
}>;


export type ExpenseItemUpdateMutation = { __typename?: 'Mutation', expenseItemUpdate: { __typename?: 'ExpenseItem', expenseItemID: any } };

export type CityAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<CityQop>;
}>;


export type CityAutocompleteQuery = { __typename?: 'Query', cities?: { __typename?: 'CityPaged', items: Array<{ __typename?: 'City', cityID: string, cityName: string }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } | null };

export type CityCreateMutationVariables = Exact<{
  formValue: CityCreateInput;
}>;


export type CityCreateMutation = { __typename?: 'Mutation', cityCreate: { __typename?: 'City', cityID: string, cityName: string, gmt: number, provinceID: string, countryID: string, isActive: boolean } };

export type CityDeleteMutationVariables = Exact<{
  cityID: Scalars['String']['input'];
}>;


export type CityDeleteMutation = { __typename?: 'Mutation', cityDelete: boolean };

export type CityListQueryVariables = Exact<{
  qop?: InputMaybe<CityQop>;
}>;


export type CityListQuery = { __typename?: 'Query', cities?: { __typename?: 'CityPaged', items: Array<{ __typename?: 'City', cityID: string, cityName: string, gmt: number, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } | null };

export type CityLoadQueryVariables = Exact<{
  CityID: Scalars['String']['input'];
}>;


export type CityLoadQuery = { __typename?: 'Query', city?: { __typename?: 'City', cityID: string, cityName: string, provinceID: string, gmt: number, countryID: string, isActive: boolean, province?: { __typename?: 'Province', provinceID: string, provinceName: string } | null, country?: { __typename?: 'Country', countryID: string, countryName: string } | null } | null };

export type CityUpdateMutationVariables = Exact<{
  input: CityUpdateInput;
}>;


export type CityUpdateMutation = { __typename?: 'Mutation', cityUpdate: { __typename?: 'City', cityID: string, cityName: string, provinceID: string, gmt: number, countryID: string, isActive: boolean } };

export type CountryAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<CountryQop>;
}>;


export type CountryAutocompleteQuery = { __typename?: 'Query', countries?: { __typename?: 'CountryPaged', items: Array<{ __typename?: 'Country', countryID: string, countryName: string }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } | null };

export type CountryCreateMutationVariables = Exact<{
  formValue: CountryCreateInput;
}>;


export type CountryCreateMutation = { __typename?: 'Mutation', countryCreate: { __typename?: 'Country', countryID: string, countryName: string } };

export type CountryDeleteMutationVariables = Exact<{
  countryID: Scalars['String']['input'];
}>;


export type CountryDeleteMutation = { __typename?: 'Mutation', countryDelete: boolean };

export type CountryListQueryVariables = Exact<{
  qop?: InputMaybe<CountryQop>;
}>;


export type CountryListQuery = { __typename?: 'Query', countries?: { __typename?: 'CountryPaged', items: Array<{ __typename?: 'Country', countryID: string, countryName: string, uniqueKey: string, isActive: boolean }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } | null };

export type CountryLoadQueryVariables = Exact<{
  countryID: Scalars['String']['input'];
}>;


export type CountryLoadQuery = { __typename?: 'Query', country?: { __typename?: 'Country', countryID: string, countryName: string, uniqueKey: string, isActive: boolean } | null };

export type CountryUpdateMutationVariables = Exact<{
  input: CountryUpdateInput;
}>;


export type CountryUpdateMutation = { __typename?: 'Mutation', countryUpdate: { __typename?: 'Country', countryID: string, countryName: string, uniqueKey: string, isActive: boolean } };

export type ProvinceAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ProvinceQop>;
}>;


export type ProvinceAutocompleteQuery = { __typename?: 'Query', provinces?: { __typename?: 'ProvincePaged', items: Array<{ __typename?: 'Province', provinceID: string, provinceName: string }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } | null };

export type ProvinceCreateMutationVariables = Exact<{
  formValue: ProvinceCreateInput;
}>;


export type ProvinceCreateMutation = { __typename?: 'Mutation', provinceCreate: { __typename?: 'Province', provinceID: string, provinceName: string, countryID: string, uniqueKey: string, isActive: boolean } };

export type ProvinceDeleteMutationVariables = Exact<{
  provinceID: Scalars['String']['input'];
}>;


export type ProvinceDeleteMutation = { __typename?: 'Mutation', provinceDelete: boolean };

export type ProvinceListQueryVariables = Exact<{
  qop?: InputMaybe<ProvinceQop>;
}>;


export type ProvinceListQuery = { __typename?: 'Query', provinces?: { __typename?: 'ProvincePaged', items: Array<{ __typename?: 'Province', provinceID: string, provinceName: string, countryID: string, uniqueKey: string, isActive: boolean }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } | null };

export type ProvinceLoadQueryVariables = Exact<{
  ProvinceID: Scalars['String']['input'];
}>;


export type ProvinceLoadQuery = { __typename?: 'Query', province?: { __typename?: 'Province', provinceID: string, provinceName: string, countryID: string, isActive: boolean, country?: { __typename?: 'Country', countryID: string, countryName: string } | null } | null };

export type ProvinceUpdateMutationVariables = Exact<{
  input: ProvinceUpdateInput;
}>;


export type ProvinceUpdateMutation = { __typename?: 'Mutation', provinceUpdate: { __typename?: 'Province', provinceID: string, provinceName: string, countryID: string, isActive: boolean } };

export type SubdistrictAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<SubdistrictQop>;
}>;


export type SubdistrictAutocompleteQuery = { __typename?: 'Query', subdistricts?: { __typename?: 'SubdistrictPaged', items: Array<{ __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string, city?: { __typename?: 'City', cityID: string, cityName: string } | null, province?: { __typename?: 'Province', provinceID: string, provinceName: string } | null, country?: { __typename?: 'Country', countryID: string, countryName: string } | null }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } | null };

export type SubdistrictCreateMutationVariables = Exact<{
  formValue: SubdistrictCreateInput;
}>;


export type SubdistrictCreateMutation = { __typename?: 'Mutation', subdistrictCreate: { __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string, cityID: string, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean } };

export type SubdistrictDeleteMutationVariables = Exact<{
  subdistrictID: Scalars['String']['input'];
}>;


export type SubdistrictDeleteMutation = { __typename?: 'Mutation', subdistrictDelete: boolean };

export type SubdistrictListQueryVariables = Exact<{
  qop?: InputMaybe<SubdistrictQop>;
}>;


export type SubdistrictListQuery = { __typename?: 'Query', subdistricts?: { __typename?: 'SubdistrictPaged', items: Array<{ __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string, cityID: string, provinceID: string, countryID: string, uniqueKey: string, isActive: boolean }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } | null };

export type SubdistrictLoadQueryVariables = Exact<{
  subdistrictID: Scalars['String']['input'];
}>;


export type SubdistrictLoadQuery = { __typename?: 'Query', subdistrict?: { __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string, cityID: string, provinceID: string, countryID: string, isActive: boolean, province?: { __typename?: 'Province', provinceID: string, provinceName: string } | null, country?: { __typename?: 'Country', countryID: string, countryName: string } | null, city?: { __typename?: 'City', cityID: string, cityName: string } | null } | null };

export type SubdistrictUpdateMutationVariables = Exact<{
  input: SubdistrictUpdateInput;
}>;


export type SubdistrictUpdateMutation = { __typename?: 'Mutation', subdistrictUpdate: { __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string, cityID: string, provinceID: string, countryID: string, isActive: boolean } };

export type VillageAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<VillageQopInput>;
}>;


export type VillageAutocompleteQuery = { __typename?: 'Query', villages: { __typename?: 'VillagePaged', items?: Array<{ __typename?: 'Village', villageID: string, villageName: string, postalCode: string, uniqueKey: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type VillageCreateMutationVariables = Exact<{
  formValue: VillageCreateInput;
}>;


export type VillageCreateMutation = { __typename?: 'Mutation', villageCreate: { __typename?: 'Village', villageID: string, villageName: string, postalCode: string, cityID: string, provinceID: string, countryID: string, subdistrictID: string, isActive: boolean } };

export type VillageDeleteMutationVariables = Exact<{
  villageID: Scalars['String']['input'];
}>;


export type VillageDeleteMutation = { __typename?: 'Mutation', villageDelete: boolean };

export type VillageListQueryVariables = Exact<{
  qop?: InputMaybe<VillageQopInput>;
}>;


export type VillageListQuery = { __typename?: 'Query', villages: { __typename?: 'VillagePaged', items?: Array<{ __typename?: 'Village', villageID: string, villageName: string, postalCode: string, cityID: string, provinceID: string, countryID: string, subdistrictID: string, uniqueKey: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VillageLoadQueryVariables = Exact<{
  VillageID: Scalars['String']['input'];
}>;


export type VillageLoadQuery = { __typename?: 'Query', village: { __typename?: 'Village', villageID: string, villageName: string, postalCode: string, cityID: string, provinceID: string, countryID: string, subdistrictID: string, isActive: boolean, province?: { __typename?: 'Province', provinceID: string, provinceName: string } | null, country?: { __typename?: 'Country', countryID: string, countryName: string } | null, city?: { __typename?: 'City', cityID: string, cityName: string } | null, subdistrict?: { __typename?: 'Subdistrict', subdistrictID: string, subdistrictName: string } | null } };

export type VillageUpdateMutationVariables = Exact<{
  input: VillageUpdateInput;
}>;


export type VillageUpdateMutation = { __typename?: 'Mutation', villageUpdate: { __typename?: 'Village', villageID: string, villageName: string, postalCode: string, cityID: string, provinceID: string, countryID: string, subdistrictID: string, isActive: boolean } };

export type UploadTemplateCreateMutationVariables = Exact<{
  input: UploadTemplateCreateInput;
}>;


export type UploadTemplateCreateMutation = { __typename?: 'Mutation', uploadTemplateCreate: { __typename?: 'UploadTemplate', uploadTemplateID: any, uploadTemplateType: string, uploadTemplateKey: string, uploadTemplateName: string, headerRow?: number | null, delimiter?: string | null, isActive: boolean, referenceIDs: Array<any>, columnMapping: Array<{ __typename?: 'UploadTemplateColumnMapping', standardKey: string, sourceColumn: string, type?: string | null, format?: string | null, contains?: Array<string> | null, notContains?: Array<string> | null, gt?: number | null, gte?: number | null, transform?: string | null }> } };

export type UploadTemplateListQueryVariables = Exact<{
  qop: UploadTemplateQopInput;
}>;


export type UploadTemplateListQuery = { __typename?: 'Query', uploadTemplates: { __typename?: 'UploadTemplatePaged', items?: Array<{ __typename?: 'UploadTemplate', uploadTemplateID: any, uploadTemplateType: string, uploadTemplateKey: string, uploadTemplateName: string, headerRow?: number | null, delimiter?: string | null, uniqueKey: string, isActive: boolean, referenceIDs: Array<any>, columnMapping: Array<{ __typename?: 'UploadTemplateColumnMapping', standardKey: string, sourceColumn: string, type?: string | null, format?: string | null, contains?: Array<string> | null, notContains?: Array<string> | null, gt?: number | null, gte?: number | null, transform?: string | null }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type UploadTemplateUpdateMutationVariables = Exact<{
  input: UploadTemplateUpdateInput;
}>;


export type UploadTemplateUpdateMutation = { __typename?: 'Mutation', uploadTemplateUpdate: { __typename?: 'UploadTemplate', uploadTemplateID: any, uploadTemplateType: string, uploadTemplateKey: string, uploadTemplateName: string, headerRow?: number | null, delimiter?: string | null, isActive: boolean, referenceIDs: Array<any>, columnMapping: Array<{ __typename?: 'UploadTemplateColumnMapping', standardKey: string, sourceColumn: string, type?: string | null, format?: string | null, contains?: Array<string> | null, notContains?: Array<string> | null, gt?: number | null, gte?: number | null, transform?: string | null }> } };

export type InternalTransferCancelMutationVariables = Exact<{
  input: InternalTransferCancelInput;
}>;


export type InternalTransferCancelMutation = { __typename?: 'Mutation', internalTransferCancel: { __typename?: 'InternalTransfer', internalTransferID: any } };

export type InternalTransferConfirmMutationVariables = Exact<{
  input: InternalTransferConfirmInput;
}>;


export type InternalTransferConfirmMutation = { __typename?: 'Mutation', internalTransferConfirm: { __typename?: 'InternalTransfer', internalTransferID: any } };

export type InternalTransferCreateMutationVariables = Exact<{
  input: InternalTransferCreateInput;
}>;


export type InternalTransferCreateMutation = { __typename?: 'Mutation', internalTransferCreate: { __typename?: 'InternalTransfer', internalTransferID: any } };

export type InternalTransferItemListQueryVariables = Exact<{
  qop?: InputMaybe<InternalTransferItemQopInput>;
}>;


export type InternalTransferItemListQuery = { __typename?: 'Query', internalTransferItems: { __typename?: 'InternalTransferItemPaged', items: Array<{ __typename?: 'InternalTransferItem', internalTransferItemID: any, internalTransferID: any, productID: any, productCode: string, productName: string, productWeight: number, fromWarehouseLocationID: any, fromWarehouseLocationCode: string, fromWarehouseLocationName: string, toWarehouseLocationID: any, toWarehouseLocationCode: string, toWarehouseLocationName: string, qtyRequested: number, qtyTransferred: number, qtyOutstanding: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQtyRequested: number, baseUomQtyTransferred: number, baseUomQtyOutstanding: number, product?: { __typename?: 'Product', barcode: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InternalTransferListQueryVariables = Exact<{
  qop?: InputMaybe<InternalTransferQopInput>;
}>;


export type InternalTransferListQuery = { __typename?: 'Query', internalTransfers: { __typename?: 'InternalTransferPaged', items: Array<{ __typename?: 'InternalTransfer', internalTransferID: any, internalTransferNumber: string, internalTransferDatetime: any, internalTransferDatetimeUtc: any, branchID: any, gmt: number, warehouseID: any, totalItemQtyRequested: number, totalItemQtyTransferred: number, totalItemWeight: number, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, description: string, status: string, warehouse: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InternalTransferLoadQueryVariables = Exact<{
  internalTransferID: Scalars['UUID']['input'];
}>;


export type InternalTransferLoadQuery = { __typename?: 'Query', internalTransfer?: { __typename?: 'InternalTransfer', internalTransferID: any, internalTransferNumber: string, internalTransferDatetime: any, internalTransferDatetimeUtc: any, branchID: any, gmt: number, warehouseID: any, totalItemQtyRequested: number, totalItemQtyTransferred: number, totalItemWeight: number, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, description: string, status: string, warehouse: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type InternalTransferUpdateMutationVariables = Exact<{
  input: InternalTransferUpdateInput;
}>;


export type InternalTransferUpdateMutation = { __typename?: 'Mutation', internalTransferUpdate: { __typename?: 'InternalTransfer', internalTransferID: any } };

export type ReasonInventoryAdjustmentAutocompleteQueryVariables = Exact<{
  qop: ReasonInventoryAdjustmentQopInput;
}>;


export type ReasonInventoryAdjustmentAutocompleteQuery = { __typename?: 'Query', reasonInventoryAdjustments: { __typename?: 'ReasonInventoryAdjustmentPaged', items?: Array<{ __typename?: 'ReasonInventoryAdjustment', reasonInventoryAdjustmentID: any, reasonName: string, journalAccountCode: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ReasonInventoryAdjustmentCreateMutationVariables = Exact<{
  input: ReasonInventoryAdjustmentCreateInput;
}>;


export type ReasonInventoryAdjustmentCreateMutation = { __typename?: 'Mutation', reasonInventoryAdjustmentCreate: { __typename?: 'ReasonInventoryAdjustment', reasonInventoryAdjustmentID: any } };

export type ReasonInventoryAdjustmentDeleteMutationVariables = Exact<{
  reasonInventoryAdjustmentID: Scalars['UUID']['input'];
}>;


export type ReasonInventoryAdjustmentDeleteMutation = { __typename?: 'Mutation', reasonInventoryAdjustmentDelete: boolean };

export type ReasonInventoryAdjustmentListQueryVariables = Exact<{
  qop: ReasonInventoryAdjustmentQopInput;
}>;


export type ReasonInventoryAdjustmentListQuery = { __typename?: 'Query', reasonInventoryAdjustments: { __typename?: 'ReasonInventoryAdjustmentPaged', items?: Array<{ __typename?: 'ReasonInventoryAdjustment', reasonInventoryAdjustmentID: any, reasonName: string, journalAccountCode: string, journalAccountErpRefID?: string | null, journalAccountErpRefName?: string | null, description: string, isActive: boolean, adjustmentTypes: Array<ReasonInventoryAdjustmentType>, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ReasonInventoryAdjustmentQueryVariables = Exact<{
  reasonInventoryAdjustmentID: Scalars['UUID']['input'];
}>;


export type ReasonInventoryAdjustmentQuery = { __typename?: 'Query', reasonInventoryAdjustment: { __typename?: 'ReasonInventoryAdjustment', reasonInventoryAdjustmentID: any, reasonName: string, journalAccountCode: string, journalAccountErpRefID?: string | null, journalAccountErpRefName?: string | null, description: string, isActive: boolean, adjustmentTypes: Array<ReasonInventoryAdjustmentType>, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ReasonInventoryAdjustmentUpdateMutationVariables = Exact<{
  input: ReasonInventoryAdjustmentUpdateInput;
}>;


export type ReasonInventoryAdjustmentUpdateMutation = { __typename?: 'Mutation', reasonInventoryAdjustmentUpdate: { __typename?: 'ReasonInventoryAdjustment', reasonInventoryAdjustmentID: any } };

export type CostAdjustmentImportMutationVariables = Exact<{
  input: CostAdjustmentImportInput;
}>;


export type CostAdjustmentImportMutation = { __typename?: 'Mutation', costAdjustmentImport: any };

export type CostAdjustmentImportValidateCodesMutationVariables = Exact<{
  input: CostAdjustmentImportValidateCodesInput;
}>;


export type CostAdjustmentImportValidateCodesMutation = { __typename?: 'Mutation', costAdjustmentImportValidateCodes: { __typename?: 'CostAdjustmentImportValidateCodesResult', totalRows: number, invalidRows: number, missingProductCodes: Array<string> } };

export type InventoryAdjustmentCancelAdjustmentMutationVariables = Exact<{
  input: InventoryAdjustmentCancelInput;
}>;


export type InventoryAdjustmentCancelAdjustmentMutation = { __typename?: 'Mutation', inventoryAdjustmentCancel: { __typename?: 'InventoryAdjustment', inventoryAdjustmentID: any } };

export type InventoryAdjustmentConfirmMutationVariables = Exact<{
  input: InventoryAdjustmentConfirmInput;
}>;


export type InventoryAdjustmentConfirmMutation = { __typename?: 'Mutation', inventoryAdjustmentConfirm: { __typename?: 'InventoryAdjustment', inventoryAdjustmentID: any } };

export type InventoryAdjustmentCreateMutationVariables = Exact<{
  input: InventoryAdjustmentCreateInput;
}>;


export type InventoryAdjustmentCreateMutation = { __typename?: 'Mutation', inventoryAdjustmentCreate: { __typename?: 'InventoryAdjustment', inventoryAdjustmentID: any } };

export type InventoryAdjustmentCancelMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type InventoryAdjustmentCancelMutation = { __typename?: 'Mutation', inventoryAdjustmentDelete: boolean };

export type InventoryAdjustmentItemListQueryVariables = Exact<{
  qop?: InputMaybe<InventoryAdjustmentItemQopInput>;
}>;


export type InventoryAdjustmentItemListQuery = { __typename?: 'Query', inventoryAdjustmentItems: { __typename?: 'InventoryAdjustmentItemPaged', items: Array<{ __typename?: 'InventoryAdjustmentItem', inventoryAdjustmentItemID: any, inventoryAdjustmentID: any, productID: any, productCode: string, productName: string, qty: number, unitCost: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, warehouseLocationID: any, warehouseLocationName: string, reasonID: any, reasonName: string, note: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryAdjustmentListQueryVariables = Exact<{
  qop?: InputMaybe<InventoryAdjustmentQopInput>;
}>;


export type InventoryAdjustmentListQuery = { __typename?: 'Query', inventoryAdjustments: { __typename?: 'InventoryAdjustmentPaged', items?: Array<{ __typename?: 'InventoryAdjustment', inventoryAdjustmentID: any, inventoryAdjustmentNumber: string, inventoryAdjustmentDate: any, inventoryAdjustmentType: string, notes?: string | null, status: string, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, branchID: any, warehouseID: any, isSystemGenerated: boolean, sourceDocumentType?: string | null, sourceDocumentID?: any | null, sourceDocumentNumber?: string | null, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryAdjustmentListItemQueryVariables = Exact<{
  qop?: InputMaybe<InventoryAdjustmentItemQopInput>;
}>;


export type InventoryAdjustmentListItemQuery = { __typename?: 'Query', inventoryAdjustmentItems: { __typename?: 'InventoryAdjustmentItemPaged', items: Array<{ __typename?: 'InventoryAdjustmentItem', inventoryAdjustmentItemID: any, inventoryAdjustmentID: any, productID: any, productCode: string, productName: string, qty: number, unitCost: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, warehouseLocationID: any, warehouseLocationName: string, totalCost?: number | null, reasonID: any, reasonName: string, note: string, product: { __typename?: 'Product', productName: string, sellingPrice?: number | null, barcode: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryAdjustmentLoadQueryVariables = Exact<{
  inventoryAdjustmentID: Scalars['UUID']['input'];
}>;


export type InventoryAdjustmentLoadQuery = { __typename?: 'Query', inventoryAdjustment: { __typename?: 'InventoryAdjustment', inventoryAdjustmentID: any, inventoryAdjustmentNumber: string, inventoryAdjustmentDate: any, inventoryAdjustmentType: string, usedCost: boolean, notes?: string | null, status: string, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, branchID: any, warehouseID: any, isSystemGenerated: boolean, sourceDocumentType?: string | null, sourceDocumentID?: any | null, sourceDocumentNumber?: string | null, branch: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, productAvailabilityTemplateID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, picName?: string | null, picPhoneNumber?: string | null, canSell?: boolean | null, isMain?: boolean | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null }, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any }, files?: Array<{ __typename?: 'InventoryAdjustmentFile', inventoryAdjustmentFileID: any, inventoryAdjustmentID: any, inventoryAdjustmentFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null } };

export type InventoryAdjustmentOpeningBalanceImportMutationVariables = Exact<{
  input: InventoryAdjustmentOpeningBalanceImportInput;
}>;


export type InventoryAdjustmentOpeningBalanceImportMutation = { __typename?: 'Mutation', inventoryAdjustmentOpeningBalanceImport: any };

export type InventoryAdjustmentOpeningBalanceImportValidateCodesMutationVariables = Exact<{
  input: InventoryAdjustmentOpeningBalanceImportValidateCodesInput;
}>;


export type InventoryAdjustmentOpeningBalanceImportValidateCodesMutation = { __typename?: 'Mutation', inventoryAdjustmentOpeningBalanceImportValidateCodes: { __typename?: 'InventoryAdjustmentOpeningBalanceImportValidateCodesResult', missingProductCodes: Array<string>, missingLocationNames: Array<string>, missingProductUoms: Array<{ __typename?: 'InventoryAdjustmentOpeningBalanceImportMissingProductUom', rowNumber: number, productCode: string, uomName: string }>, rowReport?: { __typename?: 'InventoryAdjustmentOpeningBalanceImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'InventoryAdjustmentOpeningBalanceImportRowViolation', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> } | null } };

export type InventoryAdjustmentTypeListQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryAdjustmentTypeListQuery = { __typename?: 'Query', inventoryAdjustmentTypes: Array<{ __typename?: 'InventoryAdjustmentType', inventoryAdjustmentTypeID: any, code: string, type: string, name: string, isStandard: boolean, isWaste: boolean, isSystemGenerated: boolean, isSyncToErp: boolean, sortOrder: number }> };

export type InventoryAdjustmentUpdateMutationVariables = Exact<{
  input: InventoryAdjustmentUpdateInput;
}>;


export type InventoryAdjustmentUpdateMutation = { __typename?: 'Mutation', inventoryAdjustmentUpdate: { __typename?: 'InventoryAdjustment', inventoryAdjustmentID: any } };

export type InventoryCountItemTemplateCreateMutationVariables = Exact<{
  input: InventoryCountItemTemplateCreateInput;
}>;


export type InventoryCountItemTemplateCreateMutation = { __typename?: 'Mutation', inventoryCountItemTemplateCreate: { __typename?: 'InventoryCountItemTemplate', inventoryCountItemTemplateName: string, isActive: boolean } };

export type InventoryCountItemTemplateDeleteMutationVariables = Exact<{
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
}>;


export type InventoryCountItemTemplateDeleteMutation = { __typename?: 'Mutation', inventoryCountItemTemplateDelete: boolean };

export type InventoryCountItemTemplateItemImportMutationVariables = Exact<{
  input: InventoryCountItemTemplateItemImportInput;
}>;


export type InventoryCountItemTemplateItemImportMutation = { __typename?: 'Mutation', inventoryCountItemTemplateItemImport: { __typename?: 'InventoryCountItemTemplateItemImportResult', importedCount: number, skippedCount: number } };

export type InventoryCountItemTemplateItemImportValidateMutationVariables = Exact<{
  input: InventoryCountItemTemplateItemImportValidateInput;
}>;


export type InventoryCountItemTemplateItemImportValidateMutation = { __typename?: 'Mutation', inventoryCountItemTemplateItemImportValidate: { __typename?: 'InventoryCountItemTemplateItemImportValidateResult', missingProductCodes: Array<string>, rowReport: { __typename?: 'InventoryCountItemTemplateItemImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'InventoryCountItemTemplateItemImportRowViolation', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> } } };

export type InventoryCountItemTemplateItemsQueryVariables = Exact<{
  qop: InventoryCountItemTemplateItemQopInput;
}>;


export type InventoryCountItemTemplateItemsQuery = { __typename?: 'Query', inventoryCountItemTemplateItems: { __typename?: 'InventoryCountItemTemplateItemPaged', items?: Array<{ __typename?: 'InventoryCountItemTemplateItem', inventoryCountItemTemplateItemID: any, productID: any, productCode: string, productName: string, product?: { __typename?: 'Product', barcode: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type InventoryCountItemTemplateLoadQueryVariables = Exact<{
  inventoryCountItemTemplateID: Scalars['UUID']['input'];
}>;


export type InventoryCountItemTemplateLoadQuery = { __typename?: 'Query', inventoryCountItemTemplate: { __typename?: 'InventoryCountItemTemplate', inventoryCountItemTemplateID: any, inventoryCountItemTemplateName: string, isActive: boolean } };

export type InventoryCountItemTemplateUpdateMutationVariables = Exact<{
  input: InventoryCountItemTemplateUpdateInput;
}>;


export type InventoryCountItemTemplateUpdateMutation = { __typename?: 'Mutation', inventoryCountItemTemplateUpdate: { __typename?: 'InventoryCountItemTemplate', inventoryCountItemTemplateID: any, inventoryCountItemTemplateName: string, isActive: boolean } };

export type InventoryCountItemTemplatesQueryVariables = Exact<{
  qop: InventoryCountItemTemplateQopInput;
}>;


export type InventoryCountItemTemplatesQuery = { __typename?: 'Query', inventoryCountItemTemplates: { __typename?: 'InventoryCountItemTemplatePaged', items?: Array<{ __typename?: 'InventoryCountItemTemplate', inventoryCountItemTemplateID: any, inventoryCountItemTemplateName: string, isActive: boolean, itemCount: number, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type InventoryCountCreateMutationVariables = Exact<{
  input: InventoryCountTransactionCreateInput;
}>;


export type InventoryCountCreateMutation = { __typename?: 'Mutation', inventoryCountTransactionCreate: { __typename?: 'InventoryCountTransaction', inventoryCountTransactionID: any, inventoryCountTransactionNumber: string, inventoryCountTransactionDatetime: any, inventoryCountTransactionDatetimeUtc: any, branchID: any, gmt: number, warehouseID: any, taskType: string, totalItems: number, totalCountTasks: number, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, status: string } };

export type InventoryCountListQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTransactionQopInput>;
}>;


export type InventoryCountListQuery = { __typename?: 'Query', inventoryCountTransactions: { __typename?: 'InventoryCountTransactionPaged', pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null }, items: Array<{ __typename?: 'InventoryCountTransaction', inventoryCountTransactionID: any, inventoryCountTransactionNumber: string, inventoryCountTransactionDatetime: any, inventoryCountTransactionDatetimeUtc: any, branchID: any, gmt: number, warehouseID: any, taskType: string, totalItems: number, totalCountTasks: number, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, status: string, warehouse: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> } };

export type InventoryCountListItemQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTransactionItemQopInput>;
}>;


export type InventoryCountListItemQuery = { __typename?: 'Query', inventoryCountTransactionItems: { __typename?: 'InventoryCountTransactionItemPaged', items: Array<{ __typename?: 'InventoryCountTransactionItem', inventoryCountTransactionItemID: any, inventoryCountTransactionID: any, type: string, productID: any, productCode: string, productName: string, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, note: string, product: { __typename?: 'Product', barcode: string } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountListItemResultQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTransactionResultItemQopInput>;
}>;


export type InventoryCountListItemResultQuery = { __typename?: 'Query', inventoryCountTransactionResultItems: { __typename?: 'InventoryCountTransactionResultItemPaged', items: Array<{ __typename?: 'InventoryCountTransactionResultItem', inventoryCountTransactionResultItemID: any, inventoryCountTransactionID: any, sequence: number, productID: any, productCode: string, productName: string, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, qtySystem: number, qtyCounted: number, qtyDiff: number, baseUomQtySystem: number, baseUomQtyCounted: number, baseUomQtyDiff: number, note: string, baseUomUnitCostSystem: number, baseUomUnitCostCounted: number, baseUomUnitCostDiff: number, totalCost: number, product: { __typename?: 'Product', barcode: string, purchaseCost?: number | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountListTaskQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTaskQopInput>;
}>;


export type InventoryCountListTaskQuery = { __typename?: 'Query', inventoryCountTasks: { __typename?: 'InventoryCountTaskPaged', items: Array<{ __typename?: 'InventoryCountTask', inventoryCountTaskID: any, inventoryCountTaskNumber: string, inventoryCountTaskDatetime: any, inventoryCountTaskDatetimeUtc: any, inventoryCountTransactionID: any, inventoryCountTransactionNumber: string, isRecount: boolean, sequence: number, branchID: any, gmt: number, warehouseID: any, totalItems: number, totalQtyCounted: number, taskStartAt?: any | null, taskStartAtUtc?: any | null, taskDoneAt?: any | null, taskDoneAtUtc?: any | null, taskDurationMinute?: number | null, cancelledAt?: any | null, cancelledAtUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, status: string, noteInternal: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountMonitoringStoreBranchesQueryVariables = Exact<{
  qop?: InputMaybe<BranchQopInput>;
}>;


export type InventoryCountMonitoringStoreBranchesQuery = { __typename?: 'Query', branches: { __typename?: 'BranchPaged', items?: Array<{ __typename?: 'Branch', branchID: any, branchCode: string, branchName: string }> | null } };

export type InventoryCountMonitoringStoresQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTransactionQopInput>;
}>;


export type InventoryCountMonitoringStoresQuery = { __typename?: 'Query', inventoryCountTransactions: { __typename?: 'InventoryCountTransactionPaged', pagination: { __typename?: 'PaginationResult', totalRows?: number | null }, items: Array<{ __typename?: 'InventoryCountTransaction', inventoryCountTransactionID: any, inventoryCountTransactionNumber: string, warehouseID: any, taskType: string, totalCountTasks: number, status: string, warehouse: { __typename?: 'Warehouse', warehouseName: string } }> } };

export type InventoryCountTaskAssigneeDeleteMutationVariables = Exact<{
  input: InventoryCountTaskAssigneeDeleteInput;
}>;


export type InventoryCountTaskAssigneeDeleteMutation = { __typename?: 'Mutation', inventoryCountTaskAssigneeDelete: boolean };

export type InventoryCountTaskAssigneesQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTaskAssigneeQopInput>;
}>;


export type InventoryCountTaskAssigneesQuery = { __typename?: 'Query', inventoryCountTaskAssignees: { __typename?: 'InventoryCountTaskAssigneePaged', items: Array<{ __typename?: 'InventoryCountTaskAssignee', inventoryCountTaskAssigneeID: any, inventoryCountTaskID: any, inventoryCountTransactionID: any, assignedToUserID: any, assignedToUserName: string, sequenceNo: number, status: string, startedAt?: any | null, startedAtUtc?: any | null, finishedAt?: any | null, finishedAtUtc?: any | null, taskDurationMinute?: number | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountTaskCancelMutationVariables = Exact<{
  input: InventoryCountTaskCancelInput;
}>;


export type InventoryCountTaskCancelMutation = { __typename?: 'Mutation', inventoryCountTaskCancel: boolean };

export type InventoryCountTaskExecutionItemDetailsQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTaskExecutionItemDetailQopInput>;
}>;


export type InventoryCountTaskExecutionItemDetailsQuery = { __typename?: 'Query', inventoryCountTaskExecutionItemDetails: { __typename?: 'InventoryCountTaskExecutionItemDetailPaged', items: Array<{ __typename?: 'InventoryCountTaskExecutionItemDetail', inventoryCountTaskExecutionItemDetailID: any, inventoryCountTaskExecutionItemID: any, inventoryCountTaskID: any, inventoryCountTransactionID: any, inventoryCountTransactionLocationDetailID: any, warehouseID: any, warehouseLocationID: any, warehouseLocationName: string, productID: any, productCode: string, productName: string, sequenceNo: number, inputMethod: string, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, qty: number, baseUomQty: number, qtySystem: number, baseUomQtySystem: number, qtyDiff: number, baseUomQtyDiff: number, note: string, executedAt: any, executedAtUtc: any, executedByUserID: any, executedByUserName: string, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountTaskExecutionItemsQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTaskExecutionItemQopInput>;
}>;


export type InventoryCountTaskExecutionItemsQuery = { __typename?: 'Query', inventoryCountTaskExecutionItems: { __typename?: 'InventoryCountTaskExecutionItemPaged', items: Array<{ __typename?: 'InventoryCountTaskExecutionItem', inventoryCountTaskExecutionItemID: any, inventoryCountTaskID: any, inventoryCountTransactionID: any, productID: any, productCode: string, productName: string, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, qtySystem: number, qtyCounted: number, qtyDiff: number, baseUomQtySystem: number, baseUomQtyCounted: number, baseUomQtyDiff: number, totalExecutionCount: number, isRecountRequired: boolean, unitCostSystem: number, baseUomUnitCostDiff: number, product: { __typename?: 'Product', barcode: string } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountTaskExportImportTemplateMutationVariables = Exact<{
  input: InventoryCountTaskExportInput;
}>;


export type InventoryCountTaskExportImportTemplateMutation = { __typename?: 'Mutation', inventoryCountTaskExportImportTemplate: { __typename?: 'InventoryCountTransactionExport', downloadUrl: string, fileName: string } };

export type InventoryCountTaskExportRecountItemsMutationVariables = Exact<{
  input: InventoryCountTaskExportInput;
}>;


export type InventoryCountTaskExportRecountItemsMutation = { __typename?: 'Mutation', inventoryCountTaskExportRecountItems: { __typename?: 'InventoryCountTransactionExport', downloadUrl: string, fileName: string } };

export type InventoryCountTaskFinishMutationVariables = Exact<{
  input: InventoryCountTaskFinishInput;
}>;


export type InventoryCountTaskFinishMutation = { __typename?: 'Mutation', inventoryCountTaskFinish: boolean };

export type InventoryCountTaskRecountCreateMutationVariables = Exact<{
  input: InventoryCountTaskRecountCreateInput;
}>;


export type InventoryCountTaskRecountCreateMutation = { __typename?: 'Mutation', inventoryCountTaskRecountCreate: { __typename?: 'InventoryCountTask', inventoryCountTransactionID: any } };

export type InventoryCountTaskRecountItemsQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTaskRecountItemQopInput>;
}>;


export type InventoryCountTaskRecountItemsQuery = { __typename?: 'Query', inventoryCountTaskRecountItems: { __typename?: 'InventoryCountTaskRecountItemPaged', items: Array<{ __typename?: 'InventoryCountTaskRecountItem', inventoryCountTaskRecountItemID: any, inventoryCountTaskID: any, parentInventoryCountTaskID: any, inventoryCountTransactionID: any, type: string, productID: any, productCode: string, productName: string, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, qtySystem: number, qtyCounted: number, qtyDiff: number, baseUomUnitCostDiff: number, product: { __typename?: 'Product', barcode: string } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountTaskRecountUpdateMutationVariables = Exact<{
  input: InventoryCountTaskUpdateInput;
}>;


export type InventoryCountTaskRecountUpdateMutation = { __typename?: 'Mutation', inventoryCountTaskUpdate: { __typename?: 'InventoryCountTask', inventoryCountTransactionID: any } };

export type InventoryCountItemTemplateAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountItemTemplateQopInput>;
}>;


export type InventoryCountItemTemplateAutocompleteQuery = { __typename?: 'Query', inventoryCountItemTemplates: { __typename?: 'InventoryCountItemTemplatePaged', items?: Array<{ __typename?: 'InventoryCountItemTemplate', inventoryCountItemTemplateID: any, inventoryCountItemTemplateName: string, isActive: boolean, itemCount: number, uniqueKey: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountTransactionCancelMutationVariables = Exact<{
  input: InventoryCountTransactionCancelInput;
}>;


export type InventoryCountTransactionCancelMutation = { __typename?: 'Mutation', inventoryCountTransactionCancel: { __typename?: 'InventoryCountTransaction', inventoryCountTransactionID: any, cancellationReason?: string | null } };

export type InventoryCountTransactionExportResultsMutationVariables = Exact<{
  input: InventoryCountTransactionExportInput;
}>;


export type InventoryCountTransactionExportResultsMutation = { __typename?: 'Mutation', inventoryCountTransactionExportResults: { __typename?: 'InventoryCountTransactionExport', downloadUrl: string, fileName: string } };

export type InventoryCountTransactionExportResultsByLocationMutationVariables = Exact<{
  input: InventoryCountTransactionExportInput;
}>;


export type InventoryCountTransactionExportResultsByLocationMutation = { __typename?: 'Mutation', inventoryCountTransactionExportResultsByLocation: { __typename?: 'InventoryCountTransactionExport', downloadUrl: string, fileName: string } };

export type InventoryCountTransactionFinishMutationVariables = Exact<{
  input: InventoryCountTransactionFinishInput;
}>;


export type InventoryCountTransactionFinishMutation = { __typename?: 'Mutation', inventoryCountTransactionFinish: { __typename?: 'InventoryCountTransaction', inventoryCountTransactionID: any } };

export type InventoryCountTransactionLocationQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTransactionLocationQopInput>;
}>;


export type InventoryCountTransactionLocationQuery = { __typename?: 'Query', inventoryCountTransactionLocations: { __typename?: 'InventoryCountTransactionLocationPaged', items: Array<{ __typename?: 'InventoryCountTransactionLocation', inventoryCountTransactionLocationID: any, inventoryCountTransactionID: any, warehouseLocationName: string, warehouseLocationID: any }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountTransactionResultItemDetailsQueryVariables = Exact<{
  qop?: InputMaybe<InventoryCountTransactionResultItemDetailQopInput>;
}>;


export type InventoryCountTransactionResultItemDetailsQuery = { __typename?: 'Query', inventoryCountTransactionResultItemDetails: { __typename?: 'InventoryCountTransactionResultItemDetailPaged', items: Array<{ __typename?: 'InventoryCountTransactionResultItemDetail', inventoryCountTransactionResultItemDetailID: any, inventoryCountTransactionResultItemID: any, inventoryCountTransactionLocationDetailID: any, warehouseID: any, warehouseLocationID: any, warehouseLocationName: string, productID: any, productCode: string, productName: string, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, qtyCounted: number, qtySystem: number, qtyDiff: number, baseUomQtyCounted: number, baseUomQtySystem: number, baseUomQtyDiff: number }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryCountLoadQueryVariables = Exact<{
  inventoryCountTransactionID: Scalars['UUID']['input'];
}>;


export type InventoryCountLoadQuery = { __typename?: 'Query', inventoryCountTransaction?: { __typename?: 'InventoryCountTransaction', inventoryCountTransactionID: any, inventoryCountTransactionNumber: string, inventoryCountTransactionDatetime: any, inventoryCountTransactionDatetimeUtc: any, branchID: any, gmt: number, warehouseID: any, taskType: string, totalItems: number, totalCountTasks: number, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, status: string, warehouse: { __typename?: 'Warehouse', warehouseName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } } | null };

export type InventoryCountTaskAssigneeAddMutationVariables = Exact<{
  input: InventoryCountTaskAssigneeAddInput;
}>;


export type InventoryCountTaskAssigneeAddMutation = { __typename?: 'Mutation', inventoryCountTaskAssigneeAdd: boolean };

export type InventoryCountUpdateMutationVariables = Exact<{
  input: InventoryCountTransactionUpdateInput;
}>;


export type InventoryCountUpdateMutation = { __typename?: 'Mutation', inventoryCountTransactionUpdate: { __typename?: 'InventoryCountTransaction', inventoryCountTransactionID: any, inventoryCountTransactionNumber: string, inventoryCountTransactionDatetime: any, inventoryCountTransactionDatetimeUtc: any, branchID: any, gmt: number, warehouseID: any, taskType: string, totalItems: number, totalCountTasks: number, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, status: string } };

export type VendorConsignmentProductsByBranchQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentProductQopInput>;
}>;


export type VendorConsignmentProductsByBranchQuery = { __typename?: 'Query', vendorConsignmentProducts: { __typename?: 'VendorConsignmentProductAggregatedPaged', items?: Array<{ __typename?: 'VendorConsignmentProductAggregated', productID: any, product: { __typename?: 'Product', productCode: string, productName: string, barcode: string } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryAdjustmentStatusForIcQueryVariables = Exact<{
  jobQop: BackgroundJobQopInput;
}>;


export type InventoryAdjustmentStatusForIcQuery = { __typename?: 'Query', backgroundJobs: { __typename?: 'BackgroundJobPaged', items?: Array<{ __typename?: 'BackgroundJob', backgroundJobID: any, jobCategory: string, jobType: string, jobKey: string, jobDescription: string, jobMessage: string, jobData: string, status: string, processedCount: number, totalCount: number, retryCount: number, startedDatetime?: any | null, finishedDatetime?: any | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any, version: any } }> | null } };

export type InventoryAdjustmentLookupByNumberQueryVariables = Exact<{
  qop?: InputMaybe<InventoryAdjustmentQopInput>;
}>;


export type InventoryAdjustmentLookupByNumberQuery = { __typename?: 'Query', inventoryAdjustments: { __typename?: 'InventoryAdjustmentPaged', items?: Array<{ __typename?: 'InventoryAdjustment', inventoryAdjustmentID: any, inventoryAdjustmentNumber: string, status: string }> | null } };

export type InventoryAdjustmentRetryFromBackgroundJobMutationVariables = Exact<{
  backgroundJobID: Scalars['UUID']['input'];
}>;


export type InventoryAdjustmentRetryFromBackgroundJobMutation = { __typename?: 'Mutation', inventoryAdjustmentRetryFromBackgroundJob: boolean };

export type InventoryLocationListQueryVariables = Exact<{
  qop?: InputMaybe<InventoryLocationQopInput>;
}>;


export type InventoryLocationListQuery = { __typename?: 'Query', inventoryLocations: { __typename?: 'InventoryLocationPaged', items?: Array<{ __typename?: 'InventoryLocation', inventoryLocationID: any, productID: any, warehouseID: any, warehouseLocationID: any, qty: any, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string } | null, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string }, warehouseLocation?: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryMovementSummaryListQueryVariables = Exact<{
  qop: InventoryMovementSummaryQopInput;
}>;


export type InventoryMovementSummaryListQuery = { __typename?: 'Query', inventoryMovementSummary: { __typename?: 'InventoryMovementSummaryPaged', items?: Array<{ __typename?: 'InventoryMovementSummary', productID: any, warehouseID: any, startingDate: any, endingDate: any, startingQty: any, qtyIn: any, qtyOut: any, endingQty: any, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string } | null, warehouse?: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventorySummaryListQueryVariables = Exact<{
  qop?: InputMaybe<InventorySummaryQopInput>;
}>;


export type InventorySummaryListQuery = { __typename?: 'Query', inventorySummaries: { __typename?: 'InventorySummaryPaged', items?: Array<{ __typename?: 'InventorySummary', inventorySummaryID: any, productID: any, warehouseID: any, qtyOnHand: any, qtyAvailable: any, qty: any, qtyCommitted: any, qtyRejected: any, unitCost: any, totalCost: any, lastAvgCost: any, lastUnitCost: any, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string } | null, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryTransactionLineUnitListQueryVariables = Exact<{
  qop?: InputMaybe<InventoryTransactionLineUnitQopInput>;
}>;


export type InventoryTransactionLineUnitListQuery = { __typename?: 'Query', inventoryTransactionLineUnits: { __typename?: 'InventoryTransactionLineUnitPaged', items?: Array<{ __typename?: 'InventoryTransactionLineUnit', inventoryTransactionLineUnitID: any, inventoryTransactionLineItemID: any, inventoryTransactionLineID: any, prevQtyBalance: any, prevLocationQtyBalance: any, inventoryTransactionID: any, productID: any, warehouseID: any, warehouseLocationID: any, lotNumber: string, expiryDate?: any | null, qty: any, actualUnitCost: any, actualTotalCost: any, postedUnitCost: any, postedTotalCost: any, direction: string, balanceUpdate: boolean, sortIndex: number, inventoryTransaction: { __typename?: 'InventoryTransaction', inventoryTransactionID: any, inventoryTransactionNumber: string, sourceDocumentType: string, sourceDocumentNumber: string, sourceDocumentID: any }, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string } | null, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string }, warehouseLocation: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryTransactionListQueryVariables = Exact<{
  qop?: InputMaybe<InventoryTransactionQopInput>;
}>;


export type InventoryTransactionListQuery = { __typename?: 'Query', inventoryTransactions: { __typename?: 'InventoryTransactionPaged', items?: Array<{ __typename?: 'InventoryTransaction', inventoryTransactionID: any, inventoryTransactionNumber: string, inventoryTransactionTransactionDate: any, inventoryTransactionTransactionDateUtc: any, inventoryTransactionKey: string, branchID: any, gmt: number, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, warehouseID: any, counterpartWarehouseID?: any | null, itemCount: number, itemTotalCost: number, status: string, noteInternal: string, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string }, counterpartWarehouse?: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, createdAt: any, updatedAt: any, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type InventoryTransactionLoadQueryVariables = Exact<{
  inventoryTransactionID: Scalars['UUID']['input'];
}>;


export type InventoryTransactionLoadQuery = { __typename?: 'Query', inventoryTransaction: { __typename?: 'InventoryTransaction', inventoryTransactionID: any, inventoryTransactionNumber: string, inventoryTransactionTransactionDate: any, inventoryTransactionTransactionDateUtc: any, inventoryTransactionKey: string, branchID: any, gmt: number, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, warehouseID: any, counterpartWarehouseID?: any | null, itemCount: number, itemTotalCost: number, status: string, noteInternal: string, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string }, counterpartWarehouse?: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, createdAt: any, updatedAt: any, version: any } } };

export type MarketplaceChannelApiLogQueryVariables = Exact<{
  marketplaceChannelAPILogID: Scalars['UUID']['input'];
}>;


export type MarketplaceChannelApiLogQuery = { __typename?: 'Query', marketplaceChannelAPILog?: { __typename?: 'MarketplaceChannelAPILog', marketplaceChannelAPILogID: any, salesChannelID: string, direction: string, operation: string, externalMerchantID: string, httpMethod: string, url: string, requestBody: string, responseStatus: number, responseBody: string, errorMessage: string, durationMs: number, createdAt: any } | null };

export type MarketplaceChannelApiLogsQueryVariables = Exact<{
  qop?: InputMaybe<MarketplaceChannelApiLogQopInput>;
}>;


export type MarketplaceChannelApiLogsQuery = { __typename?: 'Query', marketplaceChannelAPILogs: { __typename?: 'MarketplaceChannelAPILogPaged', items?: Array<{ __typename?: 'MarketplaceChannelAPILog', marketplaceChannelAPILogID: any, salesChannelID: string, direction: string, operation: string, externalMerchantID: string, httpMethod: string, url: string, responseStatus: number, errorMessage: string, durationMs: number, createdAt: any }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type MarketplaceCronRunMutationVariables = Exact<{
  jobKey: Scalars['String']['input'];
}>;


export type MarketplaceCronRunMutation = { __typename?: 'Mutation', marketplaceCronRun: { __typename?: 'MarketplaceCronRunResult', jobKey: string, status: string, message: string, ranAt: any } };

export type MarketplaceCronSettingListQueryVariables = Exact<{
  qop?: InputMaybe<MarketplaceCronSettingQopInput>;
}>;


export type MarketplaceCronSettingListQuery = { __typename?: 'Query', marketplaceCronSettings: { __typename?: 'MarketplaceCronSettingPaged', items?: Array<{ __typename?: 'MarketplaceCronSetting', jobKey: string, jobName: string, description: string, spec: string, isEnabled: boolean, lastRunAt?: any | null, lastRunStatus?: string | null, lastRunMessage: string, updatedAt: any }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type MarketplaceCronSettingUpdateMutationVariables = Exact<{
  input: MarketplaceCronSettingUpdateInput;
}>;


export type MarketplaceCronSettingUpdateMutation = { __typename?: 'Mutation', marketplaceCronSettingUpdate: { __typename?: 'MarketplaceCronSetting', jobKey: string, isEnabled: boolean, lastRunAt?: any | null, lastRunStatus?: string | null, lastRunMessage: string, updatedAt: any } };

export type MarketplaceInboundOrdersQueryVariables = Exact<{
  qop?: InputMaybe<MarketplaceInboundOrderQopInput>;
}>;


export type MarketplaceInboundOrdersQuery = { __typename?: 'Query', marketplaceInboundOrders: { __typename?: 'MarketplaceInboundOrderPaged', items?: Array<{ __typename?: 'MarketplaceInboundOrder', marketplaceInboundOrderID: any, eventType: string, source: string, status: string, errorMessage: string, payload: string, receivedAtUtc: any, settledAtUtc?: any | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type MarketplaceOrderQueryVariables = Exact<{
  marketplaceOrderID: Scalars['UUID']['input'];
}>;


export type MarketplaceOrderQuery = { __typename?: 'Query', marketplaceOrder?: { __typename?: 'MarketplaceOrder', marketplaceOrderID: any, version: any, salesChannelID: string, externalOrderID: string, shortOrderNumber: string, externalMerchantID: string, externalStoreID: string, customerName: string, paymentType: string, noteInternal: string, branchCode: string, branchName: string, gmt: number, status: string, isEdited: boolean, subtotalAmount: number, taxAmount: number, deliveryFeeAmount: number, discountAmount: number, totalAmount: number, salesChannelAdditionalCharge: number, customerPaymentAmount: number, pricingStatus: string, orderDatetimeUtc: any, receivedAtUtc: any, acceptedAtUtc?: any | null, readyMarkedAtUtc?: any | null, posInvoiceNumber: string, settledAtUtc?: any | null, paymentReconciledAtUtc?: any | null, updatedAtUtc: any, pricingIssues: Array<{ __typename?: 'MarketplaceOrderPricingIssue', code: string, message: string }>, promos: Array<{ __typename?: 'MarketplaceOrderPromo', code: string, name: string, kind: string, level: string, merchantAmount: number, fullAmount: number, freeItemProductCode: string, freeItemQty: number }> } | null, marketplaceOrderItems: { __typename?: 'MarketplaceOrderItemPaged', items?: Array<{ __typename?: 'MarketplaceOrderItem', lineIndex: number, externalItemID: string, externalItemName: string, productCode: string, productName: string, barcode: string, qty: number, unitPrice: number, totalPrice: number, discountAmount: number, netAmount: number, freeQty: number, promoNames: Array<string>, note: string, addonComponents: Array<{ __typename?: 'MarketplaceOrderItemAddon', productName: string, qty: number, unitPrice: number }> }> | null } };

export type MarketplaceOrderCancelMutationVariables = Exact<{
  input: MarketplaceOrderCancelInput;
}>;


export type MarketplaceOrderCancelMutation = { __typename?: 'Mutation', marketplaceOrderCancel: { __typename?: 'MarketplaceOrder', marketplaceOrderID: any, version: any, externalOrderID: string, salesChannelID: string, status: string } };

export type MarketplaceOrderCheckCancelableQueryVariables = Exact<{
  salesChannelID: Scalars['String']['input'];
  externalOrderID: Scalars['String']['input'];
}>;


export type MarketplaceOrderCheckCancelableQuery = { __typename?: 'Query', marketplaceOrderCheckCancelable: { __typename?: 'MarketplaceOrderCancelableResult', cancelable: boolean, nonCancellationReason?: string | null, limitType?: string | null, limitTimes?: number | null, cancelReasons: Array<{ __typename?: 'MarketplaceOrderCancelReason', code: number, reason: string }> } };

export type MarketplaceOrderExportQueryVariables = Exact<{
  qop?: InputMaybe<MarketplaceOrderQopInput>;
}>;


export type MarketplaceOrderExportQuery = { __typename?: 'Query', marketplaceOrderExport: { __typename?: 'MarketplaceOrderExportFile', downloadURL: string, fileName: string } };

export type MarketplaceOrderMarkReadyMutationVariables = Exact<{
  input: MarketplaceOrderMarkReadyInput;
}>;


export type MarketplaceOrderMarkReadyMutation = { __typename?: 'Mutation', marketplaceOrderMarkReady: { __typename?: 'MarketplaceOrder', marketplaceOrderID: any, version: any, externalOrderID: string, salesChannelID: string, status: string, acceptedAtUtc?: any | null, readyMarkedAtUtc?: any | null } };

export type MarketplaceOrderReconcilePaymentMutationVariables = Exact<{
  input: MarketplaceOrderReconcilePaymentInput;
}>;


export type MarketplaceOrderReconcilePaymentMutation = { __typename?: 'Mutation', marketplaceOrderReconcilePayment: { __typename?: 'MarketplaceOrder', marketplaceOrderID: any, paymentReconciledAtUtc?: any | null } };

export type MarketplaceOrderSalesInvoiceQueryVariables = Exact<{
  salesInvoiceNumber: Scalars['String']['input'];
}>;


export type MarketplaceOrderSalesInvoiceQuery = { __typename?: 'Query', salesInvoices: { __typename?: 'SalesInvoicePaged', items: Array<{ __typename?: 'SalesInvoice', salesInvoiceID: any, salesInvoiceNumber: string }> } };

export type MarketplaceOrderSyncPosMutationVariables = Exact<{
  input: MarketplaceOrderSyncPosInput;
}>;


export type MarketplaceOrderSyncPosMutation = { __typename?: 'Mutation', marketplaceOrderSyncPOS: { __typename?: 'MarketplaceOrderSyncPOSResult', externalOrderID: string, posOrderID?: string | null, posInvoiceNumber?: string | null, status?: string | null, success: boolean } };

export type MarketplaceOrdersQueryVariables = Exact<{
  qop?: InputMaybe<MarketplaceOrderQopInput>;
}>;


export type MarketplaceOrdersQuery = { __typename?: 'Query', marketplaceOrders: { __typename?: 'MarketplaceOrderPaged', items?: Array<{ __typename?: 'MarketplaceOrder', marketplaceOrderID: any, salesChannelID: string, externalOrderID: string, shortOrderNumber: string, branchCode: string, branchName: string, gmt: number, status: string, isEdited: boolean, totalAmount: number, receivedAtUtc: any, posInvoiceNumber: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type MemberTypeAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<MemberTypeQopInput>;
}>;


export type MemberTypeAutocompleteQuery = { __typename?: 'Query', memberTypes: { __typename?: 'MemberTypePaged', items?: Array<{ __typename?: 'MemberType', memberTypeID: any, memberTypeName: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type MemberTypesCreateMutationVariables = Exact<{
  input: MemberTypeCreateInput;
}>;


export type MemberTypesCreateMutation = { __typename?: 'Mutation', memberTypeCreate: { __typename?: 'MemberType', memberTypeID: any } };

export type MemberTypeDeleteMutationVariables = Exact<{
  memberTypeID: Scalars['UUID']['input'];
}>;


export type MemberTypeDeleteMutation = { __typename?: 'Mutation', memberTypeDelete: boolean };

export type MemberTypeListQueryVariables = Exact<{
  qop?: InputMaybe<MemberTypeQopInput>;
}>;


export type MemberTypeListQuery = { __typename?: 'Query', memberTypes: { __typename?: 'MemberTypePaged', items?: Array<{ __typename?: 'MemberType', memberTypeID: any, memberTypeName: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type MemberTypeLoadQueryVariables = Exact<{
  memberTypeID: Scalars['UUID']['input'];
}>;


export type MemberTypeLoadQuery = { __typename?: 'Query', memberType: { __typename?: 'MemberType', memberTypeID: any, memberTypeName: string, spendPerPoint: number, uniqueKey: string, isActive: boolean } };

export type MemberTypeUpdateMutationVariables = Exact<{
  input: MemberTypeUpdateInput;
}>;


export type MemberTypeUpdateMutation = { __typename?: 'Mutation', memberTypeUpdate: { __typename?: 'MemberType', memberTypeID: any } };

export type OutboundContainerListQueryVariables = Exact<{
  qop?: InputMaybe<OutboundContainerQopInput>;
}>;


export type OutboundContainerListQuery = { __typename?: 'Query', outboundContainers: { __typename?: 'OutboundContainerPaged', items?: Array<{ __typename?: 'OutboundContainer', outboundContainerID: any, containerNumber: string, sourceDocumentNumber: string, sourceDocumentType: string, toWarehouseID?: any | null, totalItems: number, totalQty: number, deliveryOrderID?: any | null, isDo: boolean, isEmpty: boolean, draftDeliveryOrderBatchNumber?: string | null, draftDeliveryOrderBatchID?: any | null, toWarehouse?: { __typename?: 'Warehouse', warehouseName: string } | null, packingTask?: { __typename?: 'OutboundContainerPackingTaskInfo', packingTaskNumber: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type OutboundContainerLoadQueryVariables = Exact<{
  outboundContainerID: Scalars['UUID']['input'];
}>;


export type OutboundContainerLoadQuery = { __typename?: 'Query', outboundContainer?: { __typename?: 'OutboundContainer', outboundContainerID: any, containerNumber: string, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, deliveryOrderID?: any | null, toWarehouseID?: any | null, totalItems: number, totalQty: number, totalWeight: number, isDo: boolean, isEmpty: boolean, isReceived: boolean, isSealed: boolean, draftDeliveryOrderBatchNumber?: string | null, draftDeliveryOrderBatchID?: any | null, noteInternal: string, deliveryOrder?: { __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderNumber: string, deliveryOrderDatetime: any, fromWarehouseName: string, fromWarehouseCode: string } | null, packingTask?: { __typename?: 'OutboundContainerPackingTaskInfo', packingTaskID: any, packingTaskNumber: string, status: string } | null, toWarehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseCode: string, branch?: { __typename?: 'Branch', branchName: string, branchCode: string, branchType: string, fullAddress: string } | null } | null } | null };

export type OutboundContainerPackingTaskLoadQueryVariables = Exact<{
  packingTaskID: Scalars['UUID']['input'];
}>;


export type OutboundContainerPackingTaskLoadQuery = { __typename?: 'Query', packingTask: { __typename?: 'PackingTask', packingTaskID: any, packingTaskNumber: string, packingTaskDatetime: any, fromWarehouseName: string, fromWarehouseCode: string } };

export type PackingTaskBulkContainerGenerationMutationVariables = Exact<{
  input: BulkContainerGenerationInput;
}>;


export type PackingTaskBulkContainerGenerationMutation = { __typename?: 'Mutation', outboundContainerBulkGeneration: boolean };

export type PackingTaskContainerItemsQueryVariables = Exact<{
  qop?: InputMaybe<PackingTaskContainerItemQopInput>;
}>;


export type PackingTaskContainerItemsQuery = { __typename?: 'Query', packingTaskContainerItems: { __typename?: 'PackingTaskContainerItemPaged', items: Array<{ __typename?: 'PackingTaskContainerItem', packingTaskContainerItemID: any, packingTaskContainerID: any, packingTaskItemID: any, packingTaskID: any, outboundContainerID: any, outboundContainerItemID: any, qty: number, baseUomQty: number, packingTaskItem: { __typename?: 'PackingTaskItem', productName: string, productID: any, productCode: string, uomName: string, qtyPacked: any, product?: { __typename?: 'Product', barcode: string } | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PackingTaskContainerOpenSealMutationVariables = Exact<{
  input: OpenSealContainerInput;
}>;


export type PackingTaskContainerOpenSealMutation = { __typename?: 'Mutation', outboundContainerOpenSeal: { __typename?: 'OutboundContainer', outboundContainerID: any } };

export type PackingTaskCreateContainerMutationVariables = Exact<{
  input: OutboundContainerCreateInput;
}>;


export type PackingTaskCreateContainerMutation = { __typename?: 'Mutation', outboundContainerCreate: { __typename?: 'OutboundContainer', outboundContainerID: any, deliveryOrderID?: any | null, sourceDocumentType: string, sourceDocumentNumber: string, containerNumber: string, fromBranchID: any, gmt: number, toWarehouseID?: any | null, toBranchID?: any | null, fromWarehouseID: any, noteInternal: string, totalWeight: number, totalQty: number, totalItems: number, isSealed: boolean, isDo: boolean } };

export type PackingTaskDeleteContainerMutationVariables = Exact<{
  input: RemoveContainerInput;
}>;


export type PackingTaskDeleteContainerMutation = { __typename?: 'Mutation', outboundContainerDelete: boolean };

export type PackingTaskFinishMutationVariables = Exact<{
  input: PackingTaskFinishInput;
}>;


export type PackingTaskFinishMutation = { __typename?: 'Mutation', packingTaskFinish: { __typename?: 'PackingTask', packingTaskID: any } };

export type PackingTaskItemsQueryVariables = Exact<{
  qop?: InputMaybe<PackingTaskItemQopInput>;
}>;


export type PackingTaskItemsQuery = { __typename?: 'Query', packingTaskItems: { __typename?: 'PackingTaskItemPaged', items: Array<{ __typename?: 'PackingTaskItem', productID: any, productCode: string, productName: string, uomName: string, qtyPacked: any, packingTaskItemID: any, qtyPicked: any, qtyVerified: any, qtyDiff: any, qtyOutstanding: any, pickingTaskItemID: any, product?: { __typename?: 'Product', barcode: string } | null, pickingTaskExecution?: { __typename?: 'PickingTaskExecution', qty: any, uomName: string, baseUomQty: any, warehouseLocationName: string, pickingTaskItemID: any } | null, pickingTaskItem?: { __typename?: 'PickingTaskItem', executions: Array<{ __typename?: 'PickingTaskExecution', qty: any, uomName: string, baseUomQty: any, warehouseLocationName: string, pickingTaskItemID: any }> } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PackingTaskListQueryVariables = Exact<{
  qop?: InputMaybe<PackingTaskQopInput>;
}>;


export type PackingTaskListQuery = { __typename?: 'Query', packingTasks: { __typename?: 'PackingTaskPaged', items: Array<{ __typename?: 'PackingTask', packingTaskID: any, packingTaskNumber: string, packingTaskDatetime: any, packingTaskDatetimeUtc: any, pickingTaskNumber: string, sourceDocumentType: string, sourceDocumentNumber: string, fromWarehouseName: string, packedUserName?: string | null, taskStartAt?: any | null, taskDoneAt?: any | null, taskDurationMinute?: number | null, status: string, sourceDocumentID: any, pickingTaskID: any, pickingTask?: { __typename?: 'PickingTask', status: string } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PackingTaskListContainerQueryVariables = Exact<{
  qop?: InputMaybe<PackingTaskContainerQopInput>;
}>;


export type PackingTaskListContainerQuery = { __typename?: 'Query', packingTaskContainers: { __typename?: 'PackingTaskContainerPaged', items: Array<{ __typename?: 'PackingTaskContainer', packingTaskContainerID: any, packingTaskID: any, outboundContainerID: any, outboundContainer: { __typename?: 'OutboundContainer', outboundContainerID: any, containerNumber: string, totalItems: number } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PackingTaskLoadQueryVariables = Exact<{
  packingTaskID: Scalars['UUID']['input'];
}>;


export type PackingTaskLoadQuery = { __typename?: 'Query', packingTask: { __typename?: 'PackingTask', packingTaskID: any, sourceDocumentType: string, sourceDocumentNumber: string, pickingTaskNumber: string, fromWarehouseName: string, toWarehouseName?: string | null, packingTaskNumber: string, packingTaskDatetime: any, taskStartAt?: any | null, taskDoneAt?: any | null, taskDurationMinute?: number | null, status: string, fromWarehouseID: any, toWarehouseID?: any | null, fromWarehouseCode: string, branchID: any, sourceDocumentID: any, noteInternal: string, gmt: number, pickedUserName: string, toWarehouse?: { __typename?: 'Warehouse', warehouseName: string, branch?: { __typename?: 'Branch', branchName: string, branchType: string, fullAddress: string, branchCode: string } | null } | null } };

export type PackingTaskPackItemMutationVariables = Exact<{
  input: OutboundContainerPackItemInput;
}>;


export type PackingTaskPackItemMutation = { __typename?: 'Mutation', outboundContainerPackItem: { __typename?: 'OutboundContainer', outboundContainerID: any } };

export type PackingTaskProductBarcodeMapsQueryVariables = Exact<{
  qop?: InputMaybe<ProductBarcodeMapQopInput>;
}>;


export type PackingTaskProductBarcodeMapsQuery = { __typename?: 'Query', productBarcodeMaps: { __typename?: 'ProductBarcodeMapPaged', items?: Array<{ __typename?: 'ProductBarcodeMap', productBarcodeMapID: any, productID: any, barcode: string, uniqueKey: string, product: { __typename?: 'Product', productCode: string, productName: string } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PackingTaskStartMutationVariables = Exact<{
  input: PackingTaskStartInput;
}>;


export type PackingTaskStartMutation = { __typename?: 'Mutation', packingTaskStart: { __typename?: 'PackingTask', packingTaskID: any } };

export type PackingTaskUnpackItemMutationVariables = Exact<{
  input: OutboundContainerUnpackItemInput;
}>;


export type PackingTaskUnpackItemMutation = { __typename?: 'Mutation', outboundContainerUnpackItem: { __typename?: 'OutboundContainer', outboundContainerID: any } };

export type PackingTaskUpdateQtyMutationVariables = Exact<{
  input: OutboundContainerUpdatePackItemInput;
}>;


export type PackingTaskUpdateQtyMutation = { __typename?: 'Mutation', outboundContainerUpdatePackItem: { __typename?: 'OutboundContainer', outboundContainerID: any } };

export type PackingTaskVerifyMutationVariables = Exact<{
  input: PackingTaskVerifyInput;
}>;


export type PackingTaskVerifyMutation = { __typename?: 'Mutation', packingTaskVerify: { __typename?: 'PackingTask', packingTaskID: any, noteInternal: string } };

export type PaymentInboundRequestListQueryVariables = Exact<{
  qop?: InputMaybe<PaymentInboundRequestLogQopInput>;
}>;


export type PaymentInboundRequestListQuery = { __typename?: 'Query', paymentInboundRequests: { __typename?: 'PaymentInboundRequestLogPaged', items?: Array<{ __typename?: 'PaymentInboundRequestLog', paymentInboundRequestLogID: any, requestType: string, endpoint: string, httpMethod: string, providerCode: string, providerConfigID?: any | null, clientKey: string, externalID: string, partnerReferenceNo: string, timestampHeader: string, signature: string, headers: string, requestBody: string, responseStatus: number, responseCode: string, responseMessage: string, responseBody: string, isSuccess: boolean, errorReason: string, receivedAt: any }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PosPaymentMethodTypeAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<SalesPaymentMethodTypeQopInput>;
}>;


export type PosPaymentMethodTypeAutocompleteQuery = { __typename?: 'Query', salesPaymentMethodTypes: { __typename?: 'SalesPaymentMethodTypePaged', items?: Array<{ __typename?: 'SalesPaymentMethodType', salesPaymentMethodTypeID: any, isActive: boolean, salesPaymentMethodTypeCode: string, salesPaymentMethodTypeName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PosPaymentMethodAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<SalesPaymentMethodQopInput>;
}>;


export type PosPaymentMethodAutocompleteQuery = { __typename?: 'Query', salesPaymentMethods: { __typename?: 'SalesPaymentMethodPaged', items: Array<{ __typename?: 'SalesPaymentMethod', salesPaymentMethodID: any, salesPaymentMethodName: string, salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, salesPaymentMethodType: { __typename?: 'SalesPaymentMethodType', salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, salesPaymentMethodTypeName: string, isActive: boolean } }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PosPaymentMethodCreateMutationVariables = Exact<{
  input: SalesPaymentMethodCreateInput;
}>;


export type PosPaymentMethodCreateMutation = { __typename?: 'Mutation', salesPaymentMethodCreate: { __typename?: 'SalesPaymentMethod', salesPaymentMethodID: any, salesPaymentMethodName: string, salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, uniqueKey: string, isActive?: boolean | null, salesPaymentMethodType: { __typename?: 'SalesPaymentMethodType', salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, salesPaymentMethodTypeName: string, isActive: boolean }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type PosPaymentMethodDeleteMutationVariables = Exact<{
  salesPaymentMethodID: Scalars['UUID']['input'];
}>;


export type PosPaymentMethodDeleteMutation = { __typename?: 'Mutation', salesPaymentMethodDelete: boolean };

export type PosPaymentMethodListQueryVariables = Exact<{
  qop?: InputMaybe<SalesPaymentMethodQopInput>;
}>;


export type PosPaymentMethodListQuery = { __typename?: 'Query', salesPaymentMethods: { __typename?: 'SalesPaymentMethodPaged', items: Array<{ __typename?: 'SalesPaymentMethod', salesPaymentMethodID: any, salesPaymentMethodName: string, salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, uniqueKey: string, isActive?: boolean | null, salesPaymentMethodType: { __typename?: 'SalesPaymentMethodType', salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, salesPaymentMethodTypeName: string, useEdc: boolean, isCash: boolean, isCard: boolean, isSalesChannel: boolean, salesChannelID: string, isHandledBySystem: boolean, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PosPaymentMethodLoadQueryVariables = Exact<{
  salesPaymentMethodID: Scalars['UUID']['input'];
}>;


export type PosPaymentMethodLoadQuery = { __typename?: 'Query', salesPaymentMethod: { __typename?: 'SalesPaymentMethod', salesPaymentMethodID: any, salesPaymentMethodName: string, salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, uniqueKey: string, isActive?: boolean | null, salesPaymentMethodType: { __typename?: 'SalesPaymentMethodType', salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, salesPaymentMethodTypeName: string, isActive: boolean }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type PosPaymentMethodUpdateMutationVariables = Exact<{
  input: SalesPaymentMethodUpdateInput;
}>;


export type PosPaymentMethodUpdateMutation = { __typename?: 'Mutation', salesPaymentMethodUpdate: { __typename?: 'SalesPaymentMethod', salesPaymentMethodID: any, salesPaymentMethodName: string, salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, uniqueKey: string, isActive?: boolean | null, salesPaymentMethodType: { __typename?: 'SalesPaymentMethodType', salesPaymentMethodTypeID: any, salesPaymentMethodTypeCode: string, salesPaymentMethodTypeName: string, isActive: boolean }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type PaymentProviderConfigListQueryVariables = Exact<{
  qop?: InputMaybe<PaymentProviderConfigQopInput>;
}>;


export type PaymentProviderConfigListQuery = { __typename?: 'Query', paymentProviderConfigs: { __typename?: 'PaymentProviderConfigPaged', items?: Array<{ __typename?: 'PaymentProviderConfig', paymentProviderConfigID: any, providerCode: string, providerName: string, environment: string, baseURL: string, channelID: string, partnerID: string, clientID: string, defaultValiditySeconds: number, webhookTimestampToleranceSeconds: number, isActive: boolean, uniqueKey: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PaymentProviderConfigLoadQueryVariables = Exact<{
  paymentProviderConfigID: Scalars['UUID']['input'];
}>;


export type PaymentProviderConfigLoadQuery = { __typename?: 'Query', paymentProviderConfig?: { __typename?: 'PaymentProviderConfig', paymentProviderConfigID: any, providerCode: string, providerName: string, environment: string, baseURL: string, channelID: string, partnerID: string, clientID: string, defaultValiditySeconds: number, webhookTimestampToleranceSeconds: number, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any, createdByUserName?: string | null, updatedByUserName?: string | null } } | null };

export type PaymentProviderConfigUpdateMutationVariables = Exact<{
  input: PaymentProviderConfigUpdateInput;
}>;


export type PaymentProviderConfigUpdateMutation = { __typename?: 'Mutation', paymentProviderConfigUpdate: { __typename?: 'PaymentProviderConfig', paymentProviderConfigID: any, providerCode: string, partnerID: string, isActive: boolean } };

export type PaymentInquiryLogListQueryVariables = Exact<{
  qop?: InputMaybe<PaymentInquiryLogQopInput>;
}>;


export type PaymentInquiryLogListQuery = { __typename?: 'Query', paymentInquiryLogs: { __typename?: 'PaymentInquiryLogPaged', items?: Array<{ __typename?: 'PaymentInquiryLog', paymentInquiryLogID: any, serviceCode: string, triggeredBy: string, httpStatus: number, latestTransactionStatusCode: string, responseCode: string, responseMessage: string, isSuccess: boolean, inquiredAt: any, requestPayload: string, responsePayload: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PaymentTransactionCancelMutationVariables = Exact<{
  input: PaymentTransactionCancelInput;
}>;


export type PaymentTransactionCancelMutation = { __typename?: 'Mutation', paymentTransactionCancel: { __typename?: 'PaymentTransaction', paymentTransactionID: any, status: string, cancelReason: string } };

export type PaymentTransactionCheckStatusMutationVariables = Exact<{
  paymentTransactionID: Scalars['UUID']['input'];
}>;


export type PaymentTransactionCheckStatusMutation = { __typename?: 'Mutation', paymentTransactionCheckStatus: { __typename?: 'PaymentTransactionCheckStatusResult', paymentTransactionID: string, status: string, isPaid: boolean, message: string } };

export type PaymentTransactionListQueryVariables = Exact<{
  qop?: InputMaybe<PaymentTransactionQopInput>;
}>;


export type PaymentTransactionListQuery = { __typename?: 'Query', paymentTransactions: { __typename?: 'PaymentTransactionPaged', items?: Array<{ __typename?: 'PaymentTransaction', paymentTransactionID: any, paymentTransactionNumber: string, branchName: string, providerCode: string, paymentTransactionType: string, transactionDatetime: any, sourceDocumentType: string, sourceDocumentNumber: string, partnerReferenceNo: string, referenceNo: string, amount: number, currency: string, status: string, paidAt?: any | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PaymentTransactionLoadQueryVariables = Exact<{
  paymentTransactionID: Scalars['UUID']['input'];
}>;


export type PaymentTransactionLoadQuery = { __typename?: 'Query', paymentTransaction: { __typename?: 'PaymentTransaction', paymentTransactionID: any, paymentTransactionNumber: string, partnerReferenceNo: string, referenceNo: string, externalID: string, providerCode: string, merchantID: string, terminalID: string, branchName: string, branchCode: string, sourceDocumentType: string, sourceDocumentNumber: string, paymentTransactionType: string, amount: number, currency: string, status: string, latestTransactionStatusCode: string, expiredAt?: any | null, paidAt?: any | null, cancelledAt?: any | null, rrn: string, approvalCode: string, issuerName: string, payerName: string, cancelReason: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any, createdByUserName?: string | null, updatedByUserName?: string | null } } };

export type PaymentSalesInvoiceRefQueryVariables = Exact<{
  qop?: InputMaybe<SalesInvoiceQopInput>;
}>;


export type PaymentSalesInvoiceRefQuery = { __typename?: 'Query', salesInvoices: { __typename?: 'SalesInvoicePaged', items: Array<{ __typename?: 'SalesInvoice', salesInvoiceID: any, salesInvoiceNumber: string }> } };

export type PaymentWebhookEventListQueryVariables = Exact<{
  qop?: InputMaybe<PaymentWebhookEventQopInput>;
}>;


export type PaymentWebhookEventListQuery = { __typename?: 'Query', paymentWebhookEvents: { __typename?: 'PaymentWebhookEventPaged', items?: Array<{ __typename?: 'PaymentWebhookEvent', paymentWebhookEventID: any, paymentTransactionID?: any | null, providerCode: string, eventType: string, externalID: string, partnerReferenceNo: string, referenceNo: string, latestTransactionStatusCode: string, isValidSignature: boolean, isDuplicate: boolean, isProcessed: boolean, responseCode: string, responseMessage: string, receivedAt: any, payload: string, headers: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PendingSyncMarketplaceOrderListQueryVariables = Exact<{
  qop?: InputMaybe<MarketplaceInboundOrderQopInput>;
}>;


export type PendingSyncMarketplaceOrderListQuery = { __typename?: 'Query', marketplaceInboundOrders: { __typename?: 'MarketplaceInboundOrderPaged', items?: Array<{ __typename?: 'MarketplaceInboundOrder', marketplaceInboundOrderID: any, salesChannelID: string, externalOrderID: string, externalMerchantID: string, branchID: string, branchCode: string, branchName: string, eventType: string, status: string, errorMessage: string, retryCount: number, lastProcessAttemptAtUtc?: any | null, payload: string, receivedAtUtc: any }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PendingSyncSalesOrderListQueryVariables = Exact<{
  qop: PosSalesOrderQopInput;
}>;


export type PendingSyncSalesOrderListQuery = { __typename?: 'Query', posSalesOrders: { __typename?: 'PosSalesOrderPaged', items?: Array<{ __typename?: 'PosSalesOrder', id: any, posSalesOrderId: any, posSalesOrderNumber: string, posSalesOrderDatetime: any, branchId: any, salesChannelId: string, total: number, status: string, processStatus?: string | null, processRemark?: string | null, syncError?: string | null, retryCount: number, lastProcessAttemptTimeUtc?: any | null, processedTimeUtc?: any | null, createdTimeUtc: any }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PettyCashAddFundTransactionCancelMutationVariables = Exact<{
  input: PettyCashTransactionActionInput;
}>;


export type PettyCashAddFundTransactionCancelMutation = { __typename?: 'Mutation', pettyCashAddFundTransactionCancel: { __typename?: 'PettyCashAddFundTransaction', pettyCashTransactionID: any } };

export type PettyCashAddFundTransactionConfirmMutationVariables = Exact<{
  input: PettyCashTransactionActionInput;
}>;


export type PettyCashAddFundTransactionConfirmMutation = { __typename?: 'Mutation', pettyCashAddFundTransactionConfirm: { __typename?: 'PettyCashAddFundTransaction', pettyCashTransactionID: any } };

export type PettyCashAddFundTransactionCreateMutationVariables = Exact<{
  input: PettyCashAddFundTransactionCreateInput;
}>;


export type PettyCashAddFundTransactionCreateMutation = { __typename?: 'Mutation', pettyCashAddFundTransactionCreate: { __typename?: 'PettyCashAddFundTransaction', pettyCashAddFundTransactionID: any, pettyCashTransactionID: any } };

export type PettyCashAddFundTransactionDeleteMutationVariables = Exact<{
  input: PettyCashTransactionActionInput;
}>;


export type PettyCashAddFundTransactionDeleteMutation = { __typename?: 'Mutation', pettyCashAddFundTransactionDelete: boolean };

export type PettyCashAddFundTransactionLoadQueryVariables = Exact<{
  pettyCashTransactionID: Scalars['UUID']['input'];
}>;


export type PettyCashAddFundTransactionLoadQuery = { __typename?: 'Query', pettyCashAddFundTransaction?: { __typename?: 'PettyCashAddFundTransaction', pettyCashAddFundTransactionID: any, pettyCashAddFundTransactionNumber: string, pettyCashTransactionDatetime: any, pettyCashTransactionDatetimeUtc: any, pettyCashTransactionID: any, branchID: any, branchCode: string, branchName: string, description: string, gmt: number, amount: number, bankAccountID?: any | null, bankID?: any | null, bankName?: string | null, bankAccountNumber?: string | null, note: string, uniqueKey: string, files?: Array<{ __typename?: 'PettyCashTransactionFile', pettyCashTransactionFileID: any, pettyCashTransactionID: any, pettyCashTransactionFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type PettyCashAddFundTransactionUpdateMutationVariables = Exact<{
  input: PettyCashAddFundTransactionUpdateInput;
}>;


export type PettyCashAddFundTransactionUpdateMutation = { __typename?: 'Mutation', pettyCashAddFundTransactionUpdate: { __typename?: 'PettyCashAddFundTransaction', pettyCashAddFundTransactionID: any, pettyCashTransactionID: any } };

export type PettyCashBalanceByBranchQueryVariables = Exact<{
  branchID: Scalars['UUID']['input'];
}>;


export type PettyCashBalanceByBranchQuery = { __typename?: 'Query', pettyCashBalances: { __typename?: 'PettyCashBalancePaged', items: Array<{ __typename?: 'PettyCashBalance', pettyCashBalanceID: any, branchID: any, currentBalance: number }> } };

export type PettyCashExpenseTransactionCancelMutationVariables = Exact<{
  input: PettyCashTransactionActionInput;
}>;


export type PettyCashExpenseTransactionCancelMutation = { __typename?: 'Mutation', pettyCashExpenseTransactionCancel: { __typename?: 'PettyCashExpenseTransaction', pettyCashTransactionID: any } };

export type PettyCashExpenseTransactionConfirmMutationVariables = Exact<{
  input: PettyCashTransactionActionInput;
}>;


export type PettyCashExpenseTransactionConfirmMutation = { __typename?: 'Mutation', pettyCashExpenseTransactionConfirm: { __typename?: 'PettyCashExpenseTransaction', pettyCashTransactionID: any } };

export type PettyCashExpenseTransactionCreateMutationVariables = Exact<{
  input: PettyCashExpenseTransactionCreateInput;
}>;


export type PettyCashExpenseTransactionCreateMutation = { __typename?: 'Mutation', pettyCashExpenseTransactionCreate: { __typename?: 'PettyCashExpenseTransaction', pettyCashExpenseTransactionID: any, pettyCashTransactionID: any } };

export type PettyCashExpenseTransactionDeleteMutationVariables = Exact<{
  input: PettyCashTransactionActionInput;
}>;


export type PettyCashExpenseTransactionDeleteMutation = { __typename?: 'Mutation', pettyCashExpenseTransactionDelete: boolean };

export type PettyCashExpenseTransactionLoadQueryVariables = Exact<{
  pettyCashTransactionID: Scalars['UUID']['input'];
}>;


export type PettyCashExpenseTransactionLoadQuery = { __typename?: 'Query', pettyCashExpenseTransaction?: { __typename?: 'PettyCashExpenseTransaction', pettyCashExpenseTransactionID: any, pettyCashTransactionID: any, branchID: any, branchCode: string, branchName: string, description: string, gmt: number, pettyCashExpenseTransactionNumber: string, pettyCashExpenseTransactionDatetime: any, pettyCashExpenseTransactionDatetimeUtc: any, totalAmount: number, note: string, status: string, uniqueKey: string, items?: Array<{ __typename?: 'PettyCashExpenseTransactionItem', pettyCashExpenseTransactionItemID: any, pettyCashExpenseTransactionID: any, expenseItemID: any, expenseItemName: string, qty: number, unitPrice: number, amount: number, note: string }> | null, files?: Array<{ __typename?: 'PettyCashTransactionFile', pettyCashTransactionFileID: any, pettyCashTransactionID: any, pettyCashTransactionFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type PettyCashExpenseTransactionUpdateMutationVariables = Exact<{
  input: PettyCashExpenseTransactionUpdateInput;
}>;


export type PettyCashExpenseTransactionUpdateMutation = { __typename?: 'Mutation', pettyCashExpenseTransactionUpdate: { __typename?: 'PettyCashExpenseTransaction', pettyCashExpenseTransactionID: any, pettyCashTransactionID: any } };

export type PettyCashRefundTransactionCancelMutationVariables = Exact<{
  input: PettyCashTransactionActionInput;
}>;


export type PettyCashRefundTransactionCancelMutation = { __typename?: 'Mutation', pettyCashRefundTransactionCancel: { __typename?: 'PettyCashRefundTransaction', pettyCashTransactionID: any } };

export type PettyCashRefundTransactionConfirmMutationVariables = Exact<{
  input: PettyCashTransactionActionInput;
}>;


export type PettyCashRefundTransactionConfirmMutation = { __typename?: 'Mutation', pettyCashRefundTransactionConfirm: { __typename?: 'PettyCashRefundTransaction', pettyCashTransactionID: any } };

export type PettyCashRefundTransactionCreateMutationVariables = Exact<{
  input: PettyCashRefundTransactionCreateInput;
}>;


export type PettyCashRefundTransactionCreateMutation = { __typename?: 'Mutation', pettyCashRefundTransactionCreate: { __typename?: 'PettyCashRefundTransaction', pettyCashRefundTransactionID: any, pettyCashTransactionID: any } };

export type PettyCashRefundTransactionDeleteMutationVariables = Exact<{
  input: PettyCashTransactionActionInput;
}>;


export type PettyCashRefundTransactionDeleteMutation = { __typename?: 'Mutation', pettyCashRefundTransactionDelete: boolean };

export type PettyCashRefundTransactionLoadQueryVariables = Exact<{
  pettyCashTransactionID: Scalars['UUID']['input'];
}>;


export type PettyCashRefundTransactionLoadQuery = { __typename?: 'Query', pettyCashRefundTransaction?: { __typename?: 'PettyCashRefundTransaction', pettyCashRefundTransactionID: any, pettyCashTransactionDatetime: any, pettyCashTransactionDatetimeUtc: any, pettyCashTransactionID: any, branchID: any, branchCode: string, branchName: string, description: string, gmt: number, pettyCashRefundTransactionNumber: string, amount: number, bankAccountID?: any | null, bankID?: any | null, bankName?: string | null, bankAccountNumber?: string | null, note: string, uniqueKey: string, files?: Array<{ __typename?: 'PettyCashTransactionFile', pettyCashTransactionFileID: any, pettyCashTransactionID: any, pettyCashTransactionFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type PettyCashRefundTransactionUpdateMutationVariables = Exact<{
  input: PettyCashRefundTransactionUpdateInput;
}>;


export type PettyCashRefundTransactionUpdateMutation = { __typename?: 'Mutation', pettyCashRefundTransactionUpdate: { __typename?: 'PettyCashRefundTransaction', pettyCashRefundTransactionID: any, pettyCashTransactionID: any } };

export type PettyCashTransactionFileListQueryVariables = Exact<{
  qop: PettyCashTransactionFileQopInput;
}>;


export type PettyCashTransactionFileListQuery = { __typename?: 'Query', pettyCashTransactionFiles: { __typename?: 'PettyCashTransactionFilePaged', items: Array<{ __typename?: 'PettyCashTransactionFile', pettyCashTransactionFileID: any, pettyCashTransactionID: any, pettyCashTransactionFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PettyCashTransactionListQueryVariables = Exact<{
  qop: PettyCashTransactionQopInput;
}>;


export type PettyCashTransactionListQuery = { __typename?: 'Query', pettyCashTransactions: { __typename?: 'PettyCashTransactionPaged', items: Array<{ __typename?: 'PettyCashTransaction', pettyCashTransactionID: any, pettyCashTransactionNumber: string, pettyCashTransactionDatetime: any, pettyCashTransactionDatetimeUtc: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, branchID: any, branchCode: string, branchName: string, gmt: number, description: string, totalAmount: number, status: string, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PettyCashTransactionLoadQueryVariables = Exact<{
  pettyCashTransactionID: Scalars['UUID']['input'];
}>;


export type PettyCashTransactionLoadQuery = { __typename?: 'Query', pettyCashTransaction?: { __typename?: 'PettyCashTransaction', pettyCashTransactionID: any, pettyCashTransactionNumber: string, pettyCashTransactionDatetime: any, pettyCashTransactionDatetimeUtc: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, branchID: any, branchCode: string, branchName: string, gmt: number, description: string, totalAmount: number, status: string, uniqueKey: string, expenseTransaction?: { __typename?: 'PettyCashExpenseTransaction', pettyCashExpenseTransactionID: any, pettyCashTransactionID: any, branchID: any, branchCode: string, branchName: string, gmt: number, pettyCashExpenseTransactionNumber: string, pettyCashExpenseTransactionDatetime: any, pettyCashExpenseTransactionDatetimeUtc: any, totalAmount: number, note: string, status: string, uniqueKey: string, items?: Array<{ __typename?: 'PettyCashExpenseTransactionItem', pettyCashExpenseTransactionItemID: any, pettyCashExpenseTransactionID: any, expenseItemID: any, expenseItemName: string, qty: number, unitPrice: number, amount: number, note: string }> | null, files?: Array<{ __typename?: 'PettyCashTransactionFile', pettyCashTransactionFileID: any, pettyCashTransactionID: any, pettyCashTransactionFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null } | null, addFundTransaction?: { __typename?: 'PettyCashAddFundTransaction', pettyCashAddFundTransactionID: any, pettyCashTransactionID: any, branchID: any, branchCode: string, branchName: string, bankAccountID?: any | null, bankID?: any | null, bankName?: string | null, bankAccountNumber?: string | null, gmt: number, pettyCashAddFundTransactionNumber: string, amount: number, note: string, uniqueKey: string, files?: Array<{ __typename?: 'PettyCashTransactionFile', pettyCashTransactionFileID: any, pettyCashTransactionID: any, pettyCashTransactionFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null } | null, refundTransaction?: { __typename?: 'PettyCashRefundTransaction', pettyCashRefundTransactionID: any, pettyCashTransactionID: any, branchID: any, branchCode: string, branchName: string, bankAccountID?: any | null, bankID?: any | null, bankName?: string | null, bankAccountNumber?: string | null, gmt: number, pettyCashRefundTransactionNumber: string, amount: number, note: string, uniqueKey: string, files?: Array<{ __typename?: 'PettyCashTransactionFile', pettyCashTransactionFileID: any, pettyCashTransactionID: any, pettyCashTransactionFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null } | null, files?: Array<{ __typename?: 'PettyCashTransactionFile', pettyCashTransactionFileID: any, pettyCashTransactionID: any, pettyCashTransactionFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type PickingTaskAssignMutationVariables = Exact<{
  input: PickingTaskAssignInput;
}>;


export type PickingTaskAssignMutation = { __typename?: 'Mutation', pickingTaskAssign: { __typename?: 'PickingTask', pickingTaskID: any, assignedToUserID?: any | null } };

export type PickingTaskCancelMutationVariables = Exact<{
  input: PickingTaskCancelInput;
}>;


export type PickingTaskCancelMutation = { __typename?: 'Mutation', pickingTaskCancel: boolean };

export type PickingTaskExecutionsQueryVariables = Exact<{
  qop?: InputMaybe<PickingTaskExecutionQopInput>;
}>;


export type PickingTaskExecutionsQuery = { __typename?: 'Query', pickingTaskExecutions: { __typename?: 'PickingTaskExecutionPaged', items: Array<{ __typename?: 'PickingTaskExecution', pickingTaskExecutionID: any, warehouseLocationName: string, qty: any, uomName: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PickingTaskGenerateByZonePreviewQueryVariables = Exact<{
  input: PickingTaskGenerateByZonePreviewInput;
}>;


export type PickingTaskGenerateByZonePreviewQuery = { __typename?: 'Query', pickingTaskGenerateByZonePreview: { __typename?: 'PickingTaskGenerateByZonePreviewResponse', sourceDocumentID: any, fromWarehouseID: any, fromWarehouseName: string, fromWarehouseCode: string, sourceDocumentNumber: string, groups: Array<{ __typename?: 'PickingTaskGenerateByZonePreviewGroup', warehouseLocationID?: any | null, warehouseLocationName?: string | null, warehouseLocationGroupName?: string | null, totalItems: number, totalQty: any, items: Array<{ __typename?: 'PickingTaskGenerateByZonePreviewItem', sourceDocumentDetailID: any, productID: any, productCode: string, productName: string, uomID: any, uomName: string, warehouseLocationID?: any | null, warehouseLocationName?: string | null, qtyOutstanding: any, baseUomQtyOutstanding: any }> }> } };

export type PickingTaskItemsLoadQueryVariables = Exact<{
  qop?: InputMaybe<PickingTaskItemQopInput>;
}>;


export type PickingTaskItemsLoadQuery = { __typename?: 'Query', pickingTaskItems: { __typename?: 'PickingTaskItemPaged', items: Array<{ __typename?: 'PickingTaskItem', pickingTaskItemID: any, productCode: string, productName: string, qtyAssigned: any, qtyExecuted: any, qtyUnfulfilled: any, qtyOutstanding: any, uomName: string, product?: { __typename?: 'Product', barcode: string } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PickingTaskListQueryVariables = Exact<{
  qop?: InputMaybe<PickingTaskQopInput>;
}>;


export type PickingTaskListQuery = { __typename?: 'Query', pickingTasks: { __typename?: 'PickingTaskPaged', items: Array<{ __typename?: 'PickingTask', pickingTaskNumber: string, pickingTaskDatetime: any, sourceDocumentType: string, sourceDocumentNumber: string, assignedToUserName?: string | null, taskStartAt?: any | null, taskDoneAt?: any | null, taskDurationMinute?: number | null, status: string, pickingTaskID: any, warehouse?: { __typename?: 'Warehouse', warehouseName: string } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PickingTaskLoadQueryVariables = Exact<{
  pickingTaskID: Scalars['UUID']['input'];
}>;


export type PickingTaskLoadQuery = { __typename?: 'Query', pickingTask?: { __typename?: 'PickingTask', sourceDocumentNumber: string, sourceDocumentID: any, sourceDocumentType: string, assignedToUserName?: string | null, pickingTaskDatetime: any, taskStartAt?: any | null, taskDoneAt?: any | null, taskDurationMinute?: number | null, pickingTaskNumber: string, status: string, warehouse?: { __typename?: 'Warehouse', warehouseName: string } | null } | null };

export type InboundReceivingLoadQueryQueryVariables = Exact<{
  inboundReceivingId: Scalars['UUID']['input'];
}>;


export type InboundReceivingLoadQueryQuery = { __typename?: 'Query', inboundReceiving?: { __typename?: 'InboundReceiving', inboundReceivingID: any, inboundReceivingNumber: string, inboundReceivingDatetime: any, inboundReceivingDatetimeUtc: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, branchID: any, gmt: number, warehouseID: any, warehouseLocationID: any, vendorID?: any | null, vendorRefNo?: string | null, originWarehouseID?: any | null, originWarehouseLocationID?: any | null, totalItems: number, totalItemQtyReceived: number, noteInternal: string, status: string, isPutawayCompleted: boolean } | null };

export type PurchaseOrderAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<PurchaseOrderQopInput>;
}>;


export type PurchaseOrderAutocompleteQuery = { __typename?: 'Query', purchaseOrders: { __typename?: 'PurchaseOrderPaged', pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null }, items: Array<{ __typename?: 'PurchaseOrder', purchaseOrderID: any, purchaseOrderNumber: string, purchaseOrderDatetime: any, purchaseOrderDatetimeUtc: any, deliveryDate: any, deadlineDate: any, branchID: any, branchCode: string, branchName: string, gmt: number, vendorID: any, vendorCode: string, vendorName: string, vendorEmail: string, vendorPhoneNumber: string, vendorNpwp: string, vendorNpwpCompanyName: string, vendorRefNo: string, destinationWarehouseID: any, destinationWarehouseCode: string, destinationWarehouseName: string, purchaseAreaID: any, purchaseAreaName: string, taxIncluded: boolean, totalItemQty: number, totalItemQtyReceived: number, subtotal: number, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, subtotalAfterDiscount: number, taxAmount: number, taxItems: string, landedCost: number, landedCostPerUnit: number, adjustmentAmount: number, total: number, taxableAmount: number, noteInternal: string, noteForVendor: string, status: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> } };

export type PurchaseOrderReceivingCancelMutationVariables = Exact<{
  purchaseOrderReceivingID: Scalars['UUID']['input'];
}>;


export type PurchaseOrderReceivingCancelMutation = { __typename?: 'Mutation', purchaseOrderReceivingCancel: boolean };

export type PurchaseOrderReceivingConfirmMutationVariables = Exact<{
  purchaseOrderReceivingID: Scalars['UUID']['input'];
}>;


export type PurchaseOrderReceivingConfirmMutation = { __typename?: 'Mutation', purchaseOrderReceivingConfirm: { __typename?: 'PurchaseOrderReceiving', purchaseOrderReceivingID: any, purchaseOrderReceivingNumber: string, purchaseOrderReceivingDatetime: any, branchID: any, gmt: number, vendorID: any, vendorRefNo: string, purchaseOrderID: any, purchaseOrderNumber: string, warehouseID: any, warehouseLocationID: any, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, closePO?: boolean | null, taxIncluded?: boolean | null, totalItemQtyReceived: number, subtotal: number, discountType: string, discountPerc: number, discountAmount: number, subtotalAfterDiscount: number, taxAmount: number, landedCost: number, landedCostPerUnit: number, adjustmentAmount: number, total: number, taxableAmount: number, noteInternal: string, status: string } };

export type PurchaseOrderReceivingCreateMutationVariables = Exact<{
  input: PurchaseOrderReceivingCreateInput;
}>;


export type PurchaseOrderReceivingCreateMutation = { __typename?: 'Mutation', purchaseOrderReceivingCreate: { __typename?: 'PurchaseOrderReceiving', vendorID: any, purchaseOrderID: any, vendorRefNo: string, warehouseID: any, warehouseLocationID: any, driverName: string, driverPhoneNumber: string, vehiclePlateNumber: string, noteInternal: string, landedCost: number, closePO?: boolean | null, purchaseOrderReceivingDatetime: any } };

export type PurchaseOrderReceivingCreateMultiplePutawayMutationVariables = Exact<{
  input: GenerateMultipleTasksInput;
}>;


export type PurchaseOrderReceivingCreateMultiplePutawayMutation = { __typename?: 'Mutation', putawayTaskGenerateMultiple: Array<{ __typename?: 'PutawayTask', putawayTaskID: any, putawayTaskNumber: string, putawayTaskDatetime: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, branchID: any, warehouseID: any, fromWarehouseLocationID: any, fromWarehouseLocationCode: string, fromWarehouseLocationName: string, assignedToUserID?: any | null, assignedToUserName?: string | null, totalItems: number, totalQtyAssigned: number, totalQtyExecuted: number, progressPercent: number, taskStartAt?: any | null, taskDoneAt?: any | null, taskDurationMinute?: number | null, status: string, noteInternal: string }> };

export type PurchaseOrderReceivingDraftCheckQueryVariables = Exact<{
  qop?: InputMaybe<PurchaseOrderReceivingQopInput>;
}>;


export type PurchaseOrderReceivingDraftCheckQuery = { __typename?: 'Query', purchaseOrderReceivings: { __typename?: 'PurchaseOrderReceivingPaged', items: Array<{ __typename?: 'PurchaseOrderReceiving', purchaseOrderReceivingID: any, purchaseOrderReceivingNumber: string, purchaseOrderReceivingDatetime: any, purchaseOrderID: any, purchaseOrderNumber: string, status: string, totalItemQtyReceived: number, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PurchaseOrderReceivingGeneratePutawayMutationVariables = Exact<{
  input: GenerateSingleTaskInput;
}>;


export type PurchaseOrderReceivingGeneratePutawayMutation = { __typename?: 'Mutation', putawayTaskGenerateSingle: { __typename?: 'PutawayTask', putawayTaskID: any, putawayTaskNumber: string, putawayTaskDatetime: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, branchID: any, warehouseID: any, fromWarehouseLocationID: any, fromWarehouseLocationCode: string, fromWarehouseLocationName: string, assignedToUserID?: any | null, assignedToUserName?: string | null, totalItems: number, totalQtyAssigned: number, totalQtyExecuted: number, progressPercent: number, taskStartAt?: any | null, taskDoneAt?: any | null, taskDurationMinute?: number | null, status: string, noteInternal: string } };

export type PurchaseOrderReceivingItemsQueryVariables = Exact<{
  qop?: InputMaybe<PurchaseOrderReceivingItemQopInput>;
}>;


export type PurchaseOrderReceivingItemsQuery = { __typename?: 'Query', purchaseOrderReceivingItems: { __typename?: 'PurchaseOrderReceivingItemPaged', items: Array<{ __typename?: 'PurchaseOrderReceivingItem', purchaseOrderReceivingItemID: any, purchaseOrderReceivingID: any, purchaseOrderID: any, purchaseOrderItemID: any, productID: any, productCode: string, productName: string, description: string, poQty: number, poQtyReceived: number, poQtyOutstanding: number, poUomID: any, poUomConversionRate: number, qtyReceived: number, uomCategoryID: any, uomID: any, uomName: string, uomConversionRate: number, baseUomQty: number, unitPrice: number, discountType: string, discountPerc: number, discountAmount: number, additionalDiscountPerc: number, additionalDiscountAmount: number, additionalLandedCost: number, total: number, taxableAmount: number, taxAmount: number, baseUomUnitCost: number, product: { __typename?: 'Product', barcode: string, trackExpiredDate: boolean }, taxes: Array<{ __typename?: 'PurchaseOrderReceivingItemTax', purchaseOrderReceivingItemTaxID: any, purchaseOrderReceivingItemID: any, purchaseOrderReceivingID: any, taxID: any, taxCode: string, taxRate: number, taxableAmount: number, taxAmount: number }>, itemDetails: Array<{ __typename?: 'PurchaseOrderReceivingItemDetail', purchaseOrderReceivingItemDetailID: any, purchaseOrderReceivingItemID: any, purchaseOrderReceivingID: any, productID: any, productCode: string, productName: string, description: string, lotNo: string, expiryDate: any, qty: number, uomID: any, uomName: string, uomDecimal: number, uomConversionRate: number, uomConversionDecimal: number, baseUomQty: number }> }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PurchaseOrderReceivingListQueryVariables = Exact<{
  qop?: InputMaybe<InboundReceivingQopInput>;
}>;


export type PurchaseOrderReceivingListQuery = { __typename?: 'Query', inboundReceivings: { __typename?: 'InboundReceivingPaged', items: Array<{ __typename?: 'InboundReceiving', inboundReceivingID: any, inboundReceivingNumber: string, inboundReceivingDatetime: any, inboundReceivingDatetimeUtc: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, branchID: any, gmt: number, warehouseID: any, warehouseLocationID: any, vendorID?: any | null, vendorRefNo?: string | null, originWarehouseID?: any | null, originWarehouseLocationID?: any | null, totalItems: number, totalItemQtyReceived: number, noteInternal: string, status: string, isPutawayCompleted: boolean, transferOrder?: { __typename?: 'TransferOrder', transferOrderID: any } | null, purchaseOrder?: { __typename?: 'PurchaseOrder', purchaseOrderID: any } | null, vendor?: { __typename?: 'Vendor', vendorName: string } | null, warehouse: { __typename?: 'Warehouse', warehouseName: string }, originWarehouse?: { __typename?: 'Warehouse', warehouseName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PurchaseOrderReceivingLoadQueryVariables = Exact<{
  purchaseOrderReceivingID: Scalars['UUID']['input'];
}>;


export type PurchaseOrderReceivingLoadQuery = { __typename?: 'Query', purchaseOrderReceiving?: { __typename?: 'PurchaseOrderReceiving', purchaseOrderReceivingID: any, purchaseOrderReceivingNumber: string, purchaseOrderReceivingDatetime: any, branchID: any, gmt: number, vendorID: any, vendorRefNo: string, purchaseOrderID: any, purchaseOrderNumber: string, warehouseID: any, warehouseLocationID: any, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, closePO?: boolean | null, taxIncluded?: boolean | null, totalItemQtyReceived: number, subtotal: number, discountType: string, discountPerc: number, discountAmount: number, subtotalAfterDiscount: number, taxAmount: number, landedCost: number, landedCostPerUnit: number, adjustmentAmount: number, total: number, taxableAmount: number, noteInternal: string, status: string, vendor: { __typename?: 'Vendor', vendorID: any, vendorName: string }, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseName: string }, warehouseLocation: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string }, files: Array<{ __typename?: 'PurchaseOrderReceivingFile', purchaseOrderReceivingFileID: any, purchaseOrderReceivingID: any, purchaseOrderReceivingFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> } | null };

export type PurchaseOrderReceivingDetailLoadQueryVariables = Exact<{
  inboundReceivingID: Scalars['UUID']['input'];
}>;


export type PurchaseOrderReceivingDetailLoadQuery = { __typename?: 'Query', inboundReceiving?: { __typename?: 'InboundReceiving', inboundReceivingID: any, inboundReceivingNumber: string, inboundReceivingDatetime: any, inboundReceivingDatetimeUtc: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, branchID: any, gmt: number, warehouseID: any, warehouseLocationID: any, vendorID?: any | null, vendorRefNo?: string | null, totalItems: number, totalItemQtyReceived: number, noteInternal: string, status: string, purchaseOrder?: { __typename?: 'PurchaseOrder', purchaseOrderID: any } | null, vendor?: { __typename?: 'Vendor', vendorID: any, vendorName: string } | null, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseName: string }, items: Array<{ __typename?: 'InboundReceivingItem', inboundReceivingItemID: any, inboundReceivingID: any, sourceDocumentDetailID: any, productID: any, productCode: string, productName: string, qtyReceived: number, baseUomQtyReceived: number, qtyPutawayAssigned: number, baseUomQtyPutawayAssigned: number, qtyPutawayExecuted: number, baseUomQtyPutawayExecuted: number, uomCategoryID: any, uomID: any, uomName: string, uomConversionRate: number, product: { __typename?: 'Product', barcode: string } }> } | null };

export type PurchaseOrderReceivingUpdateMutationVariables = Exact<{
  input: PurchaseOrderReceivingUpdateInput;
}>;


export type PurchaseOrderReceivingUpdateMutation = { __typename?: 'Mutation', purchaseOrderReceivingUpdate: { __typename?: 'PurchaseOrderReceiving', purchaseOrderReceivingID: any, vendorID: any, purchaseOrderID: any, vendorRefNo: string, warehouseID: any, warehouseLocationID: any, driverName: string, driverPhoneNumber: string, vehiclePlateNumber: string, noteInternal: string, landedCost: number, closePO?: boolean | null, purchaseOrderReceivingDatetime: any } };

export type DeliveryOrderAutocompleteQueryVariables = Exact<{
  qop: DeliveryOrderQopInput;
}>;


export type DeliveryOrderAutocompleteQuery = { __typename?: 'Query', deliveryOrders: { __typename?: 'DeliveryOrderPaged', items?: Array<{ __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderNumber: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, fromWarehouseID: any, fromWarehouseName: string, fromWarehouseCode: string, sourceDocumentNumber: string, sourceDocumentType: string, noteInternal: string, sourceDocumentID: any, vendorName?: string | null, vendorRefNumber?: string | null, shippedByUserName?: string | null, vehiclePlateNumber: string, driverName: string, landedCost: number, driverPhoneNumber: string, transferRequest?: { __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type TransferOrderReceivingCancelMutationVariables = Exact<{
  transferOrderReceivingID: Scalars['UUID']['input'];
}>;


export type TransferOrderReceivingCancelMutation = { __typename?: 'Mutation', transferOrderReceivingCancel: boolean };

export type TransferOrderReceivingConfirmMutationVariables = Exact<{
  transferOrderReceivingID: Scalars['UUID']['input'];
}>;


export type TransferOrderReceivingConfirmMutation = { __typename?: 'Mutation', transferOrderReceivingConfirm: { __typename?: 'TransferOrderReceiving', transferOrderReceivingID: any } };

export type TransferOrderReceivingCreateMutationVariables = Exact<{
  input: TransferOrderReceivingCreateInput;
}>;


export type TransferOrderReceivingCreateMutation = { __typename?: 'Mutation', transferOrderReceivingCreate: { __typename?: 'TransferOrderReceiving', transferOrderReceivingID: any } };

export type TransferOrderReceivingDetailQueryVariables = Exact<{
  transferOrderReceivingID: Scalars['UUID']['input'];
}>;


export type TransferOrderReceivingDetailQuery = { __typename?: 'Query', transferOrderReceiving?: { __typename?: 'TransferOrderReceiving', transferOrderReceivingID: any, deliveryOrderNumber: string, deliveryOrderID: any, transferOrderNumber: string, transferOrderID: any, transferOrderReceivingNumber: string, transferOrderReceivingDatetime: any, noteInternal: string, vendorName?: string | null, vendorCode?: string | null, vehiclePlateNumber?: string | null, driverName?: string | null, deliveryBy: string, driverPhoneNumber?: string | null, landedCost: number, totalItemQtyReceived: number, status: string, originWarehouse: { __typename?: 'Warehouse', warehouseName: string, warehouseID: any }, warehouse: { __typename?: 'Warehouse', warehouseName: string, warehouseID: any }, warehouseLocation: { __typename?: 'WarehouseLocation', warehouseLocationName: string, warehouseLocationID: any }, items: Array<{ __typename?: 'TransferOrderReceivingItem', productCode: string, productName: string, qtyReceived: number, toQtyReceived: number, toQtyOutstanding: number, toQty: number, doQty: number, uomName: string, uomID: any, productID: any, transferOrderReceivingItemID: any, note?: string | null }>, files?: Array<{ __typename?: 'TransferOrderReceivingFile', fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, transferOrderReceivingFileType: string, uniqueKey: string }> | null } | null };

export type TransferOrderReceivingItemsQueryVariables = Exact<{
  qop?: InputMaybe<DeliveryOrderItemQopInput>;
}>;


export type TransferOrderReceivingItemsQuery = { __typename?: 'Query', deliveryOrderItems: { __typename?: 'DeliveryOrderItemPaged', items?: Array<{ __typename?: 'DeliveryOrderItem', deliveryOrderItemID: any, deliveryOrderID: any, productID: any, productCode: string, productName: string, productWeight: number, qty: number, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, product?: { __typename?: 'Product', barcode: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type TransferOrderReceivingListItemQueryVariables = Exact<{
  qop?: InputMaybe<TransferOrderReceivingItemQopInput>;
}>;


export type TransferOrderReceivingListItemQuery = { __typename?: 'Query', transferOrderReceivingItems: { __typename?: 'TransferOrderReceivingItemPaged', items: Array<{ __typename?: 'TransferOrderReceivingItem', transferOrderReceivingItemID: any, transferOrderReceivingID: any, productID: any, productCode: string, productName: string, productWeight: number, uomID: any, uomName: string, uomDecimal: number, uomConversionDecimal: number, baseUomQty: number, qtyReceived: number, toQtyReceived: number, toQtyOutstanding: number, doQty: number, toQty: number, note?: string | null, product?: { __typename?: 'Product', barcode: string } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type TransferOrderReceivingUpdateMutationVariables = Exact<{
  input: TransferOrderReceivingUpdateInput;
}>;


export type TransferOrderReceivingUpdateMutation = { __typename?: 'Mutation', transferOrderReceivingUpdate: { __typename?: 'TransferOrderReceiving', transferOrderReceivingID: any, transferOrderReceivingDatetime: any, warehouseLocationID: any, closeTO: boolean, noteInternal: string, items: Array<{ __typename?: 'TransferOrderReceivingItem', transferOrderReceivingItemID: any, productID: any, qtyReceived: number, uomID: any }> } };

export type UserAutocompleteQueryVariables = Exact<{
  qop: UserLiteQopInput;
}>;


export type UserAutocompleteQuery = { __typename?: 'Query', usersLite: { __typename?: 'UserLitePaged', items?: Array<{ __typename?: 'UserLiteItem', userID: any, fullName: string, userType: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PosBookmarkProductCreateMutationVariables = Exact<{
  input: PosBookmarkProductCreateInput;
}>;


export type PosBookmarkProductCreateMutation = { __typename?: 'Mutation', posBookmarkProductCreate: { __typename?: 'PosBookmarkProduct', posBookmarkProductID: any, posBookmarkID: any, posBookmarkName: string, productID?: any | null, uniqueKey: string } };

export type PosBookmarkProductDeleteMutationVariables = Exact<{
  posBookmarkProductID: Scalars['UUID']['input'];
}>;


export type PosBookmarkProductDeleteMutation = { __typename?: 'Mutation', posBookmarkProductDelete: boolean };

export type PosBookmarkProductListQueryVariables = Exact<{
  qop: PosBookmarkProductQopInput;
}>;


export type PosBookmarkProductListQuery = { __typename?: 'Query', posBookmarkProducts: { __typename?: 'PosBookmarkProductPaged', items?: Array<{ __typename?: 'PosBookmarkProduct', posBookmarkProductID: any, posBookmarkID: any, posBookmarkName: string, productID?: any | null, uniqueKey: string, posBookmark?: { __typename?: 'PosBookmark', posBookmarkID: any, posBookmarkName: string, uniqueKey: string } | null, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PosBookmarkAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<PosBookmarkQopInput>;
}>;


export type PosBookmarkAutocompleteQuery = { __typename?: 'Query', posBookmarks: { __typename?: 'PosBookmarkPaged', items?: Array<{ __typename?: 'PosBookmark', posBookmarkID: any, posBookmarkName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PosBookmarkCreateMutationVariables = Exact<{
  input: PosBookmarkCreateInput;
}>;


export type PosBookmarkCreateMutation = { __typename?: 'Mutation', posBookmarkCreate: { __typename?: 'PosBookmark', posBookmarkID: any, posBookmarkName: string, uniqueKey: string } };

export type PosBookmarkDeleteMutationVariables = Exact<{
  posBookmarkID: Scalars['UUID']['input'];
}>;


export type PosBookmarkDeleteMutation = { __typename?: 'Mutation', posBookmarkDelete: boolean };

export type PosBookmarkListQueryVariables = Exact<{
  qop?: InputMaybe<PosBookmarkQopInput>;
}>;


export type PosBookmarkListQuery = { __typename?: 'Query', posBookmarks: { __typename?: 'PosBookmarkPaged', items?: Array<{ __typename?: 'PosBookmark', posBookmarkID: any, posBookmarkName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PosBookmarkLoadQueryVariables = Exact<{
  posBookmarkID: Scalars['UUID']['input'];
}>;


export type PosBookmarkLoadQuery = { __typename?: 'Query', posBookmark: { __typename?: 'PosBookmark', posBookmarkID: any, posBookmarkName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type PosBookmarkUpdateMutationVariables = Exact<{
  input: PosBookmarkUpdateInput;
}>;


export type PosBookmarkUpdateMutation = { __typename?: 'Mutation', posBookmarkUpdate: { __typename?: 'PosBookmark', posBookmarkID: any, posBookmarkName: string, uniqueKey: string } };

export type PosterCreateMutationVariables = Exact<{
  input: PosterCreateInput;
}>;


export type PosterCreateMutation = { __typename?: 'Mutation', posterCreate: { __typename?: 'Poster', posterID: any, posterName: string, priority: number, isActive: boolean, isDefault: boolean } };

export type PosterDeleteMutationVariables = Exact<{
  posterID: Scalars['UUID']['input'];
}>;


export type PosterDeleteMutation = { __typename?: 'Mutation', posterDelete: boolean };

export type PosterListQueryVariables = Exact<{
  qop?: InputMaybe<PosterQopInput>;
}>;


export type PosterListQuery = { __typename?: 'Query', posters: { __typename?: 'PosterPaged', items: Array<{ __typename?: 'Poster', posterID: any, posterName: string, priority: number, startAt?: any | null, endAt?: any | null, isActive: boolean, isDefault: boolean, isAllBranches: boolean, branches?: Array<{ __typename?: 'PosterBranchRef', branchID: any, branchName?: string | null }> | null, images: Array<{ __typename?: 'PosterImage', posterImageID: any, displayDurationSeconds: number }> }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PosterLoadQueryVariables = Exact<{
  posterID: Scalars['UUID']['input'];
}>;


export type PosterLoadQuery = { __typename?: 'Query', poster: { __typename?: 'Poster', posterID: any, posterName: string, priority: number, startAt?: any | null, endAt?: any | null, isActive: boolean, isDefault: boolean, isAllBranches: boolean, branches?: Array<{ __typename?: 'PosterBranchRef', branchID: any, branchName?: string | null, branch: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string } }> | null, images: Array<{ __typename?: 'PosterImage', posterImageID: any, fileID: any, imageLabel?: string | null, displayOrder: number, displayDurationSeconds: number, imageURL: string, file?: { __typename?: 'File', fileID: any, originalFileName: string, fileSizeMB: number } | null }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null, updatedAt: any, updatedByUserName?: string | null } } };

export type PosterUpdateMutationVariables = Exact<{
  input: PosterUpdateInput;
}>;


export type PosterUpdateMutation = { __typename?: 'Mutation', posterUpdate: { __typename?: 'Poster', posterID: any, posterName: string, priority: number, isActive: boolean, isDefault: boolean } };

export type PricelistPeriodAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<PricelistPeriodQopInput>;
}>;


export type PricelistPeriodAutocompleteQuery = { __typename?: 'Query', pricelistPeriods: { __typename?: 'PricelistPeriodPaged', items?: Array<{ __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelistID: any, effectiveStartDate: any, effectiveEndDate: any, effectiveStartHour?: number | null, effectiveStartMinute?: number | null, effectiveEndHour?: number | null, effectiveEndMinute?: number | null, priority: number }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PricelistPeriodCreateMutationVariables = Exact<{
  input: PricelistPeriodCreateInput;
}>;


export type PricelistPeriodCreateMutation = { __typename?: 'Mutation', pricelistPeriodCreate: { __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelistID: any, effectiveStartDate: any, effectiveEndDate: any, effectiveStartHour?: number | null, effectiveStartMinute?: number | null, effectiveEndHour?: number | null, effectiveEndMinute?: number | null, priority: number, isActive: boolean, uniqueKey: string } };

export type PricelistPeriodDeleteMutationVariables = Exact<{
  pricelistPeriodID: Scalars['UUID']['input'];
}>;


export type PricelistPeriodDeleteMutation = { __typename?: 'Mutation', pricelistPeriodDelete: boolean };

export type PricelistPeriodListQueryVariables = Exact<{
  qop?: InputMaybe<PricelistPeriodQopInput>;
}>;


export type PricelistPeriodListQuery = { __typename?: 'Query', pricelistPeriods: { __typename?: 'PricelistPeriodPaged', items?: Array<{ __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelistID: any, effectiveStartDate: any, effectiveEndDate: any, effectiveStartHour?: number | null, effectiveStartMinute?: number | null, effectiveEndHour?: number | null, effectiveEndMinute?: number | null, useTime: boolean, priority: number, isActive: boolean, uniqueKey: string, pricelist: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PricelistPeriodLoadQueryVariables = Exact<{
  pricelistPeriodID: Scalars['UUID']['input'];
}>;


export type PricelistPeriodLoadQuery = { __typename?: 'Query', pricelistPeriod?: { __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelistID: any, effectiveStartDate: any, effectiveEndDate: any, effectiveStartHour?: number | null, effectiveStartMinute?: number | null, effectiveEndHour?: number | null, effectiveEndMinute?: number | null, useTime: boolean, priority: number, isActive: boolean, uniqueKey: string, pricelist: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type PricelistPeriodUpdateMutationVariables = Exact<{
  input: PricelistPeriodUpdateInput;
}>;


export type PricelistPeriodUpdateMutation = { __typename?: 'Mutation', pricelistPeriodUpdate: { __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelistID: any, effectiveStartDate: any, effectiveEndDate: any, effectiveStartHour?: number | null, effectiveStartMinute?: number | null, effectiveEndHour?: number | null, effectiveEndMinute?: number | null, priority: number, isActive: boolean, uniqueKey: string } };

export type PricelistProductChannelPricesQueryVariables = Exact<{
  pricelistProductID: Scalars['UUID']['input'];
}>;


export type PricelistProductChannelPricesQuery = { __typename?: 'Query', pricelistProduct: { __typename?: 'PricelistProduct', pricelistProductID: any, sellingPrice: number, salesChannelPrices: Array<{ __typename?: 'PricelistProductChannelPrice', salesChannelID: string, autoSellingPrice: number, effectiveSellingPrice: number, priceSource: string, salesChannel: { __typename?: 'SalesChannel', salesChannelID: string, salesChannelName: string, salesChannelType: string }, pricelistProductSalesChannel?: { __typename?: 'PricelistProductSalesChannel', pricelistProductSalesChannelID: any, customSellingPrice: number, isActive: boolean } | null }> } };

export type PricelistProductSalesChannelDeleteMutationVariables = Exact<{
  pricelistProductSalesChannelID: Scalars['UUID']['input'];
}>;


export type PricelistProductSalesChannelDeleteMutation = { __typename?: 'Mutation', pricelistProductSalesChannelDelete: boolean };

export type PricelistProductSalesChannelUpsertMutationVariables = Exact<{
  input: PricelistProductSalesChannelUpsertInput;
}>;


export type PricelistProductSalesChannelUpsertMutation = { __typename?: 'Mutation', pricelistProductSalesChannelUpsert: { __typename?: 'PricelistProductSalesChannel', pricelistProductSalesChannelID: any, salesChannelID: string, customSellingPrice: number, isActive: boolean } };

export type PricelistProductBulkCreateMutationVariables = Exact<{
  input: PricelistProductBulkCreateInput;
}>;


export type PricelistProductBulkCreateMutation = { __typename?: 'Mutation', pricelistProductBulkCreate: Array<{ __typename?: 'PricelistProduct', pricelistProductID: any, pricelistPeriodID: any, pricelistID: any, productID: any, sellingPrice: number, salesChannelPrice?: string | null, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> };

export type PricelistProductCreateMutationVariables = Exact<{
  input: PricelistProductCreateInput;
}>;


export type PricelistProductCreateMutation = { __typename?: 'Mutation', pricelistProductCreate: { __typename?: 'PricelistProduct', pricelistProductID: any, pricelistPeriodID: any, pricelistID: any, productID: any, sellingPrice: number, salesChannelPrice?: string | null, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type PricelistProductDeleteMutationVariables = Exact<{
  input: PricelistProductDeleteInput;
}>;


export type PricelistProductDeleteMutation = { __typename?: 'Mutation', pricelistProductDelete: { __typename?: 'PricelistProduct', pricelistProductID: any, pricelistPeriodID: any, pricelistID: any, productID: any, sellingPrice: number, salesChannelPrice?: string | null, uniqueKey: string } };

export type PricelistProductImportMutationVariables = Exact<{
  input: PricelistProductImportInput;
}>;


export type PricelistProductImportMutation = { __typename?: 'Mutation', pricelistProductImport: { __typename?: 'PricelistProductImportResult', importedCount: number, updatedCount: number, skippedCount: number } };

export type PricelistProductImportValidateMutationVariables = Exact<{
  input: PricelistProductImportValidateInput;
}>;


export type PricelistProductImportValidateMutation = { __typename?: 'Mutation', pricelistProductImportValidate: { __typename?: 'PricelistProductImportValidateResult', missingProductCodes: Array<string>, rowReport: { __typename?: 'PricelistProductImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'PricelistProductImportRowViolation', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> } } };

export type PricelistProductListQueryVariables = Exact<{
  qop?: InputMaybe<PricelistProductQopInput>;
}>;


export type PricelistProductListQuery = { __typename?: 'Query', pricelistProducts: { __typename?: 'PricelistProductPaged', items: Array<{ __typename?: 'PricelistProduct', pricelistProductID: any, pricelistPeriodID: any, pricelistID: any, productID: any, sellingPrice: number, salesChannelPrice?: string | null, uniqueKey: string, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean, productBrand?: { __typename?: 'ProductBrand', productBrandID: any, productBrandName: string, uniqueKey: string, isActive: boolean } | null, productSource?: { __typename?: 'ProductSource', productSourceID: any, productSourceCode: string, productSourceName: string, uniqueKey: string, isActive: boolean } | null, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } | null, productSubCategory?: { __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string, productCategoryID: any, uniqueKey: string, isActive: boolean } | null, baseUom?: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean } | null } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PricelistProductLoadQueryVariables = Exact<{
  pricelistProductID: Scalars['UUID']['input'];
}>;


export type PricelistProductLoadQuery = { __typename?: 'Query', pricelistProduct: { __typename?: 'PricelistProduct', pricelistProductID: any, pricelistPeriodID: any, pricelistID: any, productID: any, sellingPrice: number, salesChannelPrice?: string | null, uniqueKey: string } };

export type PricelistProductUpdateMutationVariables = Exact<{
  input: PricelistProductUpdateInput;
}>;


export type PricelistProductUpdateMutation = { __typename?: 'Mutation', pricelistProductUpdate: { __typename?: 'PricelistProduct', pricelistProductID: any, pricelistPeriodID: any, pricelistID: any, productID: any, sellingPrice: number, salesChannelPrice?: string | null, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type PricelistChannelMarkupsQueryVariables = Exact<{
  pricelistID: Scalars['UUID']['input'];
}>;


export type PricelistChannelMarkupsQuery = { __typename?: 'Query', pricelist: { __typename?: 'Pricelist', pricelistId: any, channelMarkups: Array<{ __typename?: 'PricelistChannelMarkup', salesChannelID: string, markupPerc: number, markupSource: string, salesChannel: { __typename?: 'SalesChannel', salesChannelID: string, salesChannelName: string, salesChannelType: string, commisionPerc: number }, pricelistSalesChannel?: { __typename?: 'PricelistSalesChannel', pricelistSalesChannelID: any, priceMarkupPerc: number, isActive: boolean } | null }> } };

export type PricelistSalesChannelDeleteMutationVariables = Exact<{
  pricelistSalesChannelID: Scalars['UUID']['input'];
}>;


export type PricelistSalesChannelDeleteMutation = { __typename?: 'Mutation', pricelistSalesChannelDelete: boolean };

export type PricelistSalesChannelUpsertMutationVariables = Exact<{
  input: PricelistSalesChannelUpsertInput;
}>;


export type PricelistSalesChannelUpsertMutation = { __typename?: 'Mutation', pricelistSalesChannelUpsert: { __typename?: 'PricelistSalesChannel', pricelistSalesChannelID: any, salesChannelID: string, priceMarkupPerc: number, isActive: boolean } };

export type PricelistAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<PricelistQopInput>;
}>;


export type PricelistAutocompleteQuery = { __typename?: 'Query', pricelists: { __typename?: 'PricelistPaged', items: Array<{ __typename?: 'Pricelist', pricelistId: any, pricelistName: string }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PricelistCreateMutationVariables = Exact<{
  input: PricelistCreateInput;
}>;


export type PricelistCreateMutation = { __typename?: 'Mutation', pricelistCreate: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string } };

export type PricelistDeleteMutationVariables = Exact<{
  input: PricelistDeleteInput;
}>;


export type PricelistDeleteMutation = { __typename?: 'Mutation', pricelistDelete: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string } };

export type PricelistListQueryVariables = Exact<{
  qop?: InputMaybe<PricelistQopInput>;
}>;


export type PricelistListQuery = { __typename?: 'Query', pricelists: { __typename?: 'PricelistPaged', items: Array<{ __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PricelistLoadQueryVariables = Exact<{
  pricelistID: Scalars['UUID']['input'];
}>;


export type PricelistLoadQuery = { __typename?: 'Query', pricelist: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string, pricelistPeriods: Array<{ __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelistID: any, effectiveStartDate: any, effectiveEndDate: any, effectiveStartHour?: number | null, effectiveStartMinute?: number | null, effectiveEndHour?: number | null, effectiveEndMinute?: number | null, useTime: boolean, priority: number, isActive: boolean, uniqueKey: string }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type PricelistUpdateMutationVariables = Exact<{
  input: PricelistUpdateInput;
}>;


export type PricelistUpdateMutation = { __typename?: 'Mutation', pricelistUpdate: { __typename?: 'Pricelist', pricelistId: any, pricelistCode: string, pricelistName: string, isActive: boolean, uniqueKey: string } };

export type ConsignmentTagPricesQueryVariables = Exact<{
  input: ConsignmentTagPricesInput;
}>;


export type ConsignmentTagPricesQuery = { __typename?: 'Query', consignmentTagPrices: Array<{ __typename?: 'ConsignmentTagItem', productCode: string, productName: string, brandName: string, barcode: string, vendorCode: string, stickerCode: string, sellingPrice: number, found: boolean }> };

export type BranchWithPricelistAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<BranchQopInput>;
}>;


export type BranchWithPricelistAutocompleteQuery = { __typename?: 'Query', branches: { __typename?: 'BranchPaged', items?: Array<{ __typename?: 'Branch', branchID: any, branchName: string, branchCode: string, pricelistID?: any | null, pricelist?: { __typename?: 'Pricelist', pricelistName: string } | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PricelistProductAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<PricelistProductQopInput>;
}>;


export type PricelistProductAutocompleteQuery = { __typename?: 'Query', pricelistProducts: { __typename?: 'PricelistProductPaged', items: Array<{ __typename?: 'PricelistProduct', productID: any, product?: { __typename?: 'Product', productCode: string, productName: string } | null }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PricelistTagPricesQueryVariables = Exact<{
  input: PricelistTagPricesInput;
}>;


export type PricelistTagPricesQuery = { __typename?: 'Query', pricelistTagPrices: Array<{ __typename?: 'PriceTagItem', productCode: string, productName: string, brandName: string, barcode: string, sellingPrice: number, nominalPrice: number, finalPrice: number, discountAmount: number, discountPercent: number, promoName: string, promoTypeName: string, found: boolean }> };

export type ProductAccountingCategoryAutocompleteQueryVariables = Exact<{
  qop: ProductAccountingCategoryQopInput;
}>;


export type ProductAccountingCategoryAutocompleteQuery = { __typename?: 'Query', productAccountingCategories: { __typename?: 'ProductAccountingCategoryPaged', items?: Array<{ __typename?: 'ProductAccountingCategory', productAccountingCategoryID: any, productAccountingCategoryName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductAccountingCategoryDeleteMutationVariables = Exact<{
  productAccountingCategoryID: Scalars['UUID']['input'];
}>;


export type ProductAccountingCategoryDeleteMutation = { __typename?: 'Mutation', productAccountingCategoryDelete: boolean };

export type ProductAccountingCategoryListQueryVariables = Exact<{
  qop: ProductAccountingCategoryQopInput;
}>;


export type ProductAccountingCategoryListQuery = { __typename?: 'Query', productAccountingCategories: { __typename?: 'ProductAccountingCategoryPaged', items?: Array<{ __typename?: 'ProductAccountingCategory', productAccountingCategoryID: any, productAccountingCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ProductAccountingCategoryLoadQueryVariables = Exact<{
  productAccountingCategoryID: Scalars['UUID']['input'];
}>;


export type ProductAccountingCategoryLoadQuery = { __typename?: 'Query', productAccountingCategory?: { __typename?: 'ProductAccountingCategory', productAccountingCategoryID: any, productAccountingCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type ProductAccountingCategoryUpdateMutationVariables = Exact<{
  input: ProductAccountingCategoryUpdateInput;
}>;


export type ProductAccountingCategoryUpdateMutation = { __typename?: 'Mutation', productAccountingCategoryUpdate: { __typename?: 'ProductAccountingCategory', productAccountingCategoryID: any } };

export type ProductAccountingCategoryCreateMutationVariables = Exact<{
  input: ProductAccountingCategoryCreateInput;
}>;


export type ProductAccountingCategoryCreateMutation = { __typename?: 'Mutation', productAccountingCategoryCreate: { __typename?: 'ProductAccountingCategory', productAccountingCategoryID: any } };

export type ProductAddonComponentListByProductAddonIdQueryVariables = Exact<{
  productAddonID: Scalars['UUID']['input'];
}>;


export type ProductAddonComponentListByProductAddonIdQuery = { __typename?: 'Query', productAddonComponentsByProductAddonID: Array<{ __typename?: 'ProductAddonComponent', productAddonComponentID: any, productAddonID: any, productID: any, productCode: string, productName: string, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, priceType: string, customSellingPrice: number, sequence: number, uniqueKey: string, product?: { __typename?: 'Product', barcode: string } | null }> };

export type ProductAddonGroupItemsByGroupIdQueryVariables = Exact<{
  productAddonGroupID: Scalars['UUID']['input'];
}>;


export type ProductAddonGroupItemsByGroupIdQuery = { __typename?: 'Query', productAddonGroupItemsByGroupID: Array<{ __typename?: 'ProductAddonGroupItem', productAddonGroupItemID: any, productAddonGroupID: any, productAddonID: any, sequence: number, uniqueKey: string, productAddon: { __typename?: 'ProductAddon', name: string, description: string } }> };

export type ProductAddonGroupAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ProductAddonGroupQopInput>;
}>;


export type ProductAddonGroupAutocompleteQuery = { __typename?: 'Query', productAddonGroups: { __typename?: 'ProductAddonGroupPaged', items?: Array<{ __typename?: 'ProductAddonGroup', productAddonGroupID: any, name: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ProductAddonGroupCreateMutationVariables = Exact<{
  input: ProductAddonGroupCreateInput;
}>;


export type ProductAddonGroupCreateMutation = { __typename?: 'Mutation', productAddonGroupCreate: { __typename?: 'ProductAddonGroup', productAddonGroupID: any } };

export type ProductAddonGroupDeleteMutationVariables = Exact<{
  productAddonGroupID: Scalars['UUID']['input'];
}>;


export type ProductAddonGroupDeleteMutation = { __typename?: 'Mutation', productAddonGroupDelete: boolean };

export type ProductAddonGroupListQueryVariables = Exact<{
  qop?: InputMaybe<ProductAddonGroupQopInput>;
}>;


export type ProductAddonGroupListQuery = { __typename?: 'Query', productAddonGroups: { __typename?: 'ProductAddonGroupPaged', items?: Array<{ __typename?: 'ProductAddonGroup', productAddonGroupID: any, name: string, description: string, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ProductAddonGroupLoadQueryVariables = Exact<{
  productAddonGroupID: Scalars['UUID']['input'];
}>;


export type ProductAddonGroupLoadQuery = { __typename?: 'Query', productAddonGroup: { __typename?: 'ProductAddonGroup', productAddonGroupID: any, name: string, description: string, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductAddonGroupUpdateMutationVariables = Exact<{
  input: ProductAddonGroupUpdateInput;
}>;


export type ProductAddonGroupUpdateMutation = { __typename?: 'Mutation', productAddonGroupUpdate: { __typename?: 'ProductAddonGroup', productAddonGroupID: any } };

export type ProductAddonAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ProductAddonQopInput>;
}>;


export type ProductAddonAutocompleteQuery = { __typename?: 'Query', productAddons: { __typename?: 'ProductAddonPaged', items?: Array<{ __typename?: 'ProductAddon', productAddonID: any, name: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ProductAddonCreateMutationVariables = Exact<{
  input: ProductAddonCreateInput;
}>;


export type ProductAddonCreateMutation = { __typename?: 'Mutation', productAddonCreate: { __typename?: 'ProductAddon', productAddonID: any } };

export type ProductAddonDeleteMutationVariables = Exact<{
  productAddonID: Scalars['UUID']['input'];
}>;


export type ProductAddonDeleteMutation = { __typename?: 'Mutation', productAddonDelete: boolean };

export type ProductAddonListQueryVariables = Exact<{
  qop?: InputMaybe<ProductAddonQopInput>;
}>;


export type ProductAddonListQuery = { __typename?: 'Query', productAddons: { __typename?: 'ProductAddonPaged', items?: Array<{ __typename?: 'ProductAddon', productAddonID: any, name: string, description: string, isRequired: boolean, isMultiple: boolean, minQty?: number | null, maxQty?: number | null, showQty: boolean, isActive: boolean, uniqueKey: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ProductAddonLoadQueryVariables = Exact<{
  productAddonID: Scalars['UUID']['input'];
}>;


export type ProductAddonLoadQuery = { __typename?: 'Query', productAddon: { __typename?: 'ProductAddon', productAddonID: any, name: string, description: string, isRequired: boolean, isMultiple: boolean, minQty?: number | null, maxQty?: number | null, showQty: boolean, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductAddonUpdateMutationVariables = Exact<{
  input: ProductAddonUpdateInput;
}>;


export type ProductAddonUpdateMutation = { __typename?: 'Mutation', productAddonUpdate: { __typename?: 'ProductAddon', productAddonID: any } };

export type ProductAvailabilityTemplateItemCreateMutationVariables = Exact<{
  input: ProductAvailabilityTemplateItemCreateInput;
}>;


export type ProductAvailabilityTemplateItemCreateMutation = { __typename?: 'Mutation', productAvailabilityTemplateItemCreate: { __typename?: 'ProductAvailabilityTemplateItem', productAvailabilityTemplateItemID: any, productAvailabilityTemplateID: any, productID: any, uniqueKey: string, isActive: boolean } };

export type ProductAvailabilityTemplateItemDeleteMutationVariables = Exact<{
  productAvailabilityTemplateItemID: Scalars['UUID']['input'];
}>;


export type ProductAvailabilityTemplateItemDeleteMutation = { __typename?: 'Mutation', productAvailabilityTemplateItemDelete: boolean };

export type ProductAvailabilityTemplateItemExportMutationVariables = Exact<{
  productAvailabilityTemplateID: Scalars['UUID']['input'];
}>;


export type ProductAvailabilityTemplateItemExportMutation = { __typename?: 'Mutation', productAvailabilityTemplateItemExport: { __typename?: 'ProductAvailabilityTemplateItemExportResult', fileName: string, downloadURL: string } };

export type ProductAvailabilityTemplateItemImportMutationVariables = Exact<{
  input: ProductAvailabilityTemplateItemImportInput;
}>;


export type ProductAvailabilityTemplateItemImportMutation = { __typename?: 'Mutation', productAvailabilityTemplateItemImport: { __typename?: 'ProductAvailabilityTemplateItemImportResult', importedCount: number, skippedCount: number } };

export type ProductAvailabilityTemplateItemImportValidateMutationVariables = Exact<{
  input: ProductAvailabilityTemplateItemImportValidateInput;
}>;


export type ProductAvailabilityTemplateItemImportValidateMutation = { __typename?: 'Mutation', productAvailabilityTemplateItemImportValidate: { __typename?: 'ProductAvailabilityTemplateItemImportValidateResult', missingProductCodes: Array<string>, rowReport: { __typename?: 'ProductAvailabilityTemplateItemImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'ProductAvailabilityTemplateItemImportRowViolation', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> } } };

export type ProductAvailabilityTemplateItemListQueryVariables = Exact<{
  qop?: InputMaybe<ProductAvailabilityTemplateItemQopInput>;
}>;


export type ProductAvailabilityTemplateItemListQuery = { __typename?: 'Query', productAvailabilityTemplateItems: { __typename?: 'ProductAvailabilityTemplateItemPaged', items?: Array<{ __typename?: 'ProductAvailabilityTemplateItem', productAvailabilityTemplateItemID: any, productAvailabilityTemplateID: any, productID: any, uniqueKey: string, isActive: boolean, salesChannelIDs: Array<string>, product: { __typename?: 'Product', productCode: string, productName: string, barcode: string, isConsignment: boolean, productCategoryID: any, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string } | null }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductAvailabilityTemplateItemSetChannelsMutationVariables = Exact<{
  input: ProductAvailabilityTemplateItemSetChannelsInput;
}>;


export type ProductAvailabilityTemplateItemSetChannelsMutation = { __typename?: 'Mutation', productAvailabilityTemplateItemSetChannels: { __typename?: 'ProductAvailabilityTemplateItem', productAvailabilityTemplateItemID: any, salesChannelIDs: Array<string>, isActive: boolean } };

export type ProductAvailabilityTemplateItemUpdateMutationVariables = Exact<{
  input: ProductAvailabilityTemplateItemUpdateInput;
}>;


export type ProductAvailabilityTemplateItemUpdateMutation = { __typename?: 'Mutation', productAvailabilityTemplateItemUpdate: { __typename?: 'ProductAvailabilityTemplateItem', productAvailabilityTemplateItemID: any, productAvailabilityTemplateID: any, productID: any, uniqueKey: string, isActive: boolean } };

export type ProductAvailabilityTemplateAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ProductAvailabilityTemplateQopInput>;
}>;


export type ProductAvailabilityTemplateAutocompleteQuery = { __typename?: 'Query', productAvailabilityTemplates: { __typename?: 'ProductAvailabilityTemplatePaged', items?: Array<{ __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductAvailabilityTemplateCreateMutationVariables = Exact<{
  input: ProductAvailabilityTemplateCreateInput;
}>;


export type ProductAvailabilityTemplateCreateMutation = { __typename?: 'Mutation', productAvailabilityTemplateCreate: { __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string } };

export type ProductAvailabilityTemplateDeleteMutationVariables = Exact<{
  productAvailabilityTemplateID: Scalars['UUID']['input'];
}>;


export type ProductAvailabilityTemplateDeleteMutation = { __typename?: 'Mutation', productAvailabilityTemplateDelete: boolean };

export type ProductAvailabilityTemplateListQueryVariables = Exact<{
  qop?: InputMaybe<ProductAvailabilityTemplateQopInput>;
}>;


export type ProductAvailabilityTemplateListQuery = { __typename?: 'Query', productAvailabilityTemplates: { __typename?: 'ProductAvailabilityTemplatePaged', items?: Array<{ __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductAvailabilityTemplateLoadQueryVariables = Exact<{
  productAvailabilityTemplateID: Scalars['UUID']['input'];
}>;


export type ProductAvailabilityTemplateLoadQuery = { __typename?: 'Query', productAvailabilityTemplate: { __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductAvailabilityTemplateUpdateMutationVariables = Exact<{
  input: ProductAvailabilityTemplateUpdateInput;
}>;


export type ProductAvailabilityTemplateUpdateMutation = { __typename?: 'Mutation', productAvailabilityTemplateUpdate: { __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string } };

export type ProductBrandAutocompleteQueryVariables = Exact<{
  qop: ProductBrandQopInput;
}>;


export type ProductBrandAutocompleteQuery = { __typename?: 'Query', productBrands: { __typename?: 'ProductBrandPaged', items?: Array<{ __typename?: 'ProductBrand', productBrandID: any, productBrandName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductBrandCreateMutationVariables = Exact<{
  input: ProductBrandCreateInput;
}>;


export type ProductBrandCreateMutation = { __typename?: 'Mutation', productBrandCreate: { __typename?: 'ProductBrand', productBrandID: any, productBrandName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductBrandDeleteMutationVariables = Exact<{
  productBrandID: Scalars['UUID']['input'];
}>;


export type ProductBrandDeleteMutation = { __typename?: 'Mutation', productBrandDelete: boolean };

export type ProductBrandListQueryVariables = Exact<{
  qop: ProductBrandQopInput;
}>;


export type ProductBrandListQuery = { __typename?: 'Query', productBrands: { __typename?: 'ProductBrandPaged', items?: Array<{ __typename?: 'ProductBrand', productBrandID: any, productBrandName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductBrandLoadQueryVariables = Exact<{
  productBrandID: Scalars['UUID']['input'];
}>;


export type ProductBrandLoadQuery = { __typename?: 'Query', productBrand?: { __typename?: 'ProductBrand', productBrandID: any, productBrandName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type ProductBrandUpdateMutationVariables = Exact<{
  input: ProductBrandUpdateInput;
}>;


export type ProductBrandUpdateMutation = { __typename?: 'Mutation', productBrandUpdate: { __typename?: 'ProductBrand', productBrandID: any, productBrandName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductCategoryAutocompleteQueryVariables = Exact<{
  qop: ProductCategoryQopInput;
}>;


export type ProductCategoryAutocompleteQuery = { __typename?: 'Query', productCategories: { __typename?: 'ProductCategoryPaged', items?: Array<{ __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductCategoryCreateMutationVariables = Exact<{
  input: ProductCategoryCreateInput;
}>;


export type ProductCategoryCreateMutation = { __typename?: 'Mutation', productCategoryCreate: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductCategoryDeleteMutationVariables = Exact<{
  productCategoryID: Scalars['UUID']['input'];
}>;


export type ProductCategoryDeleteMutation = { __typename?: 'Mutation', productCategoryDelete: boolean };

export type ProductCategoryListQueryVariables = Exact<{
  qop: ProductCategoryQopInput;
}>;


export type ProductCategoryListQuery = { __typename?: 'Query', productCategories: { __typename?: 'ProductCategoryPaged', items?: Array<{ __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean, productSubDepartment?: { __typename?: 'ProductSubDepartment', productSubDepartmentID: any, productDepartmentID: any, productSubDepartmentName: string, uniqueKey: string, isActive: boolean } | null, productDepartment?: { __typename?: 'ProductDepartment', productDepartmentID: any, productDepartmentName: string, productDivisionID: any, uniqueKey: string, isActive: boolean } | null, productDivision?: { __typename?: 'ProductDivision', productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductCategoryLoadQueryVariables = Exact<{
  productCategoryID: Scalars['UUID']['input'];
}>;


export type ProductCategoryLoadQuery = { __typename?: 'Query', productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type ProductCategoryUpdateMutationVariables = Exact<{
  input: ProductCategoryUpdateInput;
}>;


export type ProductCategoryUpdateMutation = { __typename?: 'Mutation', productCategoryUpdate: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductDepartmentAutocompleteQueryVariables = Exact<{
  qop: ProductDepartmentQopInput;
}>;


export type ProductDepartmentAutocompleteQuery = { __typename?: 'Query', productDepartments: { __typename?: 'ProductDepartmentPaged', items?: Array<{ __typename?: 'ProductDepartment', productDepartmentID: any, productDepartmentName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductDepartmentCreateMutationVariables = Exact<{
  input: ProductDepartmentCreateInput;
}>;


export type ProductDepartmentCreateMutation = { __typename?: 'Mutation', productDepartmentCreate: { __typename?: 'ProductDepartment', productDepartmentID: any, productDepartmentName: string, uniqueKey: string, isActive: boolean } };

export type ProductDepartmentDeleteMutationVariables = Exact<{
  productDepartmentID: Scalars['UUID']['input'];
}>;


export type ProductDepartmentDeleteMutation = { __typename?: 'Mutation', productDepartmentDelete: boolean };

export type ProductDepartmentListQueryVariables = Exact<{
  qop: ProductDepartmentQopInput;
}>;


export type ProductDepartmentListQuery = { __typename?: 'Query', productDepartments: { __typename?: 'ProductDepartmentPaged', items?: Array<{ __typename?: 'ProductDepartment', productDepartmentID: any, productDepartmentName: string, uniqueKey: string, isActive: boolean, productDivision: { __typename?: 'ProductDivision', productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductDepartmentLoadQueryVariables = Exact<{
  productDepartmentID: Scalars['UUID']['input'];
}>;


export type ProductDepartmentLoadQuery = { __typename?: 'Query', productDepartment?: { __typename?: 'ProductDepartment', productDepartmentID: any, productDepartmentName: string, productDivisionID: any, uniqueKey: string, isActive: boolean, productDivision: { __typename?: 'ProductDivision', productDivisionName: string, productDivisionID: any, uniqueKey: string, isActive: boolean }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type ProductDepartmentUpdateMutationVariables = Exact<{
  input: ProductDepartmentUpdateInput;
}>;


export type ProductDepartmentUpdateMutation = { __typename?: 'Mutation', productDepartmentUpdate: { __typename?: 'ProductDepartment', productDepartmentID: any, productDepartmentName: string, uniqueKey: string, isActive: boolean } };

export type ProductDivisionAutocompleteQueryVariables = Exact<{
  qop: ProductDivisionQopInput;
}>;


export type ProductDivisionAutocompleteQuery = { __typename?: 'Query', productDivisions: { __typename?: 'ProductDivisionPaged', items?: Array<{ __typename?: 'ProductDivision', productDivisionID: any, productDivisionName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductDivisionCreateMutationVariables = Exact<{
  input: ProductDivisionCreateInput;
}>;


export type ProductDivisionCreateMutation = { __typename?: 'Mutation', productDivisionCreate: { __typename?: 'ProductDivision', productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } };

export type ProductDivisionDeleteMutationVariables = Exact<{
  productDivisionID: Scalars['UUID']['input'];
}>;


export type ProductDivisionDeleteMutation = { __typename?: 'Mutation', productDivisionDelete: boolean };

export type ProductDivisionListQueryVariables = Exact<{
  qop: ProductDivisionQopInput;
}>;


export type ProductDivisionListQuery = { __typename?: 'Query', productDivisions: { __typename?: 'ProductDivisionPaged', items?: Array<{ __typename?: 'ProductDivision', productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductDivisionLoadQueryVariables = Exact<{
  productDivisionID: Scalars['UUID']['input'];
}>;


export type ProductDivisionLoadQuery = { __typename?: 'Query', productDivision: { __typename?: 'ProductDivision', productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductDivisionUpdateMutationVariables = Exact<{
  input: ProductDivisionUpdateInput;
}>;


export type ProductDivisionUpdateMutation = { __typename?: 'Mutation', productDivisionUpdate: { __typename?: 'ProductDivision', productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } };

export type ProductFileLoadQueryVariables = Exact<{
  productFileID: Scalars['UUID']['input'];
}>;


export type ProductFileLoadQuery = { __typename?: 'Query', productFile: { __typename?: 'ProductFile', productFileID: any, productID: any, productFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductSourceAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ProductSourceQopInput>;
}>;


export type ProductSourceAutocompleteQuery = { __typename?: 'Query', productSources: { __typename?: 'ProductSourcePaged', items?: Array<{ __typename?: 'ProductSource', productSourceID: any, productSourceCode: string, productSourceName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductSourceLoadQueryVariables = Exact<{
  productSourceID: Scalars['UUID']['input'];
}>;


export type ProductSourceLoadQuery = { __typename?: 'Query', productSource?: { __typename?: 'ProductSource', productSourceID: any, productSourceCode: string, productSourceName: string } | null };

export type ProductSubCategoryAutocompleteQueryVariables = Exact<{
  qop: ProductSubCategoryQopInput;
}>;


export type ProductSubCategoryAutocompleteQuery = { __typename?: 'Query', productSubCategories: { __typename?: 'ProductSubCategoryPaged', items?: Array<{ __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductSubCategoryCreateMutationVariables = Exact<{
  input: ProductSubCategoryCreateInput;
}>;


export type ProductSubCategoryCreateMutation = { __typename?: 'Mutation', productSubCategoryCreate: { __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string, productCategoryID: any, uniqueKey: string, isActive: boolean } };

export type ProductSubCategoryDeleteMutationVariables = Exact<{
  productSubCategoryID: Scalars['UUID']['input'];
}>;


export type ProductSubCategoryDeleteMutation = { __typename?: 'Mutation', productSubCategoryDelete: boolean };

export type ProductSubCategoryListQueryVariables = Exact<{
  qop: ProductSubCategoryQopInput;
}>;


export type ProductSubCategoryListQuery = { __typename?: 'Query', productSubCategories: { __typename?: 'ProductSubCategoryPaged', items?: Array<{ __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string, productCategoryID: any, uniqueKey: string, isActive: boolean, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductSubCategoryLoadQueryVariables = Exact<{
  productSubCategoryID: Scalars['UUID']['input'];
}>;


export type ProductSubCategoryLoadQuery = { __typename?: 'Query', productSubCategory?: { __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string, productCategoryID: any, uniqueKey: string, isActive: boolean, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type ProductSubCategoryUpdateMutationVariables = Exact<{
  input: ProductSubCategoryUpdateInput;
}>;


export type ProductSubCategoryUpdateMutation = { __typename?: 'Mutation', productSubCategoryUpdate: { __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string, productCategoryID: any, uniqueKey: string, isActive: boolean } };

export type ProductSubDepartmentAutocompleteQueryVariables = Exact<{
  qop: ProductSubDepartmentQopInput;
}>;


export type ProductSubDepartmentAutocompleteQuery = { __typename?: 'Query', productSubDepartments: { __typename?: 'ProductSubDepartmentPaged', items?: Array<{ __typename?: 'ProductSubDepartment', productSubDepartmentID: any, productSubDepartmentName: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductSubDepartmentCreateMutationVariables = Exact<{
  input: ProductSubDepartmentCreateInput;
}>;


export type ProductSubDepartmentCreateMutation = { __typename?: 'Mutation', productSubDepartmentCreate: { __typename?: 'ProductSubDepartment', productSubDepartmentID: any, productSubDepartmentName: string, uniqueKey: string, isActive: boolean } };

export type ProductSubDepartmentDeleteMutationVariables = Exact<{
  productSubDepartmentID: Scalars['UUID']['input'];
}>;


export type ProductSubDepartmentDeleteMutation = { __typename?: 'Mutation', productSubDepartmentDelete: boolean };

export type ProductSubDepartmentListQueryVariables = Exact<{
  qop: ProductSubDepartmentQopInput;
}>;


export type ProductSubDepartmentListQuery = { __typename?: 'Query', productSubDepartments: { __typename?: 'ProductSubDepartmentPaged', items?: Array<{ __typename?: 'ProductSubDepartment', productSubDepartmentID: any, productDepartmentID: any, productSubDepartmentName: string, uniqueKey: string, isActive: boolean, productDepartment: { __typename?: 'ProductDepartment', productDepartmentID: any, productDepartmentName: string, productDivisionID: any, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductSubDepartmentLoadQueryVariables = Exact<{
  productSubDepartmentID: Scalars['UUID']['input'];
}>;


export type ProductSubDepartmentLoadQuery = { __typename?: 'Query', productSubDepartment?: { __typename?: 'ProductSubDepartment', productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, uniqueKey: string, isActive: boolean, productDepartment: { __typename?: 'ProductDepartment', productDepartmentName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type ProductSubDepartmentUpdateMutationVariables = Exact<{
  input: ProductSubDepartmentUpdateInput;
}>;


export type ProductSubDepartmentUpdateMutation = { __typename?: 'Mutation', productSubDepartmentUpdate: { __typename?: 'ProductSubDepartment', productSubDepartmentID: any, productSubDepartmentName: string, uniqueKey: string, isActive: boolean } };

export type ProductTagAutocompleteQueryVariables = Exact<{
  qop: ProductTagQopInput;
}>;


export type ProductTagAutocompleteQuery = { __typename?: 'Query', productTags: { __typename?: 'ProductTagPaged', items?: Array<{ __typename?: 'ProductTag', productTagID: any, productTagName: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductTagCreateMutationVariables = Exact<{
  input: ProductTagCreateInput;
}>;


export type ProductTagCreateMutation = { __typename?: 'Mutation', productTagCreate: { __typename?: 'ProductTag', productTagID: any, productTagName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductTagDeleteMutationVariables = Exact<{
  productTagID: Scalars['UUID']['input'];
}>;


export type ProductTagDeleteMutation = { __typename?: 'Mutation', productTagDelete: boolean };

export type ProductTagListQueryVariables = Exact<{
  qop: ProductTagQopInput;
}>;


export type ProductTagListQuery = { __typename?: 'Query', productTags: { __typename?: 'ProductTagPaged', items?: Array<{ __typename?: 'ProductTag', productTagID: any, productTagName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductTagLoadQueryVariables = Exact<{
  productTagID: Scalars['UUID']['input'];
}>;


export type ProductTagLoadQuery = { __typename?: 'Query', productTag?: { __typename?: 'ProductTag', productTagID: any, productTagName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type ProductTagUpdateMutationVariables = Exact<{
  input: ProductTagUpdateInput;
}>;


export type ProductTagUpdateMutation = { __typename?: 'Mutation', productTagUpdate: { __typename?: 'ProductTag', productTagID: any, productTagName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ConsignmentApproveProductLoadQueryVariables = Exact<{
  productID: Scalars['UUID']['input'];
}>;


export type ConsignmentApproveProductLoadQuery = { __typename?: 'Query', product: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, mainImageFileMediumPathURL?: string | null, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, productAccountingCategoryID?: any | null, countryID?: string | null, addonGroupID?: any | null, hasAddon: boolean, mainImageFileID?: any | null, isConsignment: boolean, consignmentVendorID?: any | null, isSystem: boolean, trackStock: boolean, trackExpiredDate: boolean, inventoryTrackingType: string, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, sellingPrice?: number | null, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, isActive: boolean, productCategory?: { __typename?: 'ProductCategory', productCategoryName: string } | null, consignmentVendor?: { __typename?: 'Vendor', vendorConsignmentProducts: Array<{ __typename?: 'VendorConsignmentProduct', branchID: any, commissionFeePerc: number, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> } | null } };

export type ProductAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ProductQopInput>;
}>;


export type ProductAutocompleteQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaged', items?: Array<{ __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, uomCategoryID: any, sellingPrice?: number | null, purchaseCost?: number | null, canBePurchased: boolean, productVendors: Array<{ __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, taxable?: boolean | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentCommisionFeePerc?: number | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null } }>, baseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null, purchaseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null, purchaseTax?: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxType: string, taxRate: number, uniqueKey: string, isActive: boolean } | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductBarcodeConflictsQueryVariables = Exact<{
  barcodes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  excludeProductID?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ProductBarcodeConflictsQuery = { __typename?: 'Query', productBarcodeConflicts: Array<{ __typename?: 'BarcodeConflictOwner', barcode: string, productID: any, productCode: string, productName: string, isActive: boolean, isConsignment: boolean }> };

export type ProductConsignmentImportMutationVariables = Exact<{
  input: ProductImportInput;
}>;


export type ProductConsignmentImportMutation = { __typename?: 'Mutation', productConsignmentImport: { __typename?: 'ProductImportResult', backgroundJobID: any } };

export type ProductConsignmentImportValidateMutationVariables = Exact<{
  input: ProductImportInput;
}>;


export type ProductConsignmentImportValidateMutation = { __typename?: 'Mutation', productConsignmentImportValidate: { __typename?: 'ProductImportValidateResult', status: string, missing: { __typename?: 'ProductImportMissing', sources: Array<string>, categories: Array<string>, subCategories: Array<string>, brands: Array<string>, uomCategories: Array<string>, uoms: Array<string>, taxes: Array<string>, countries: Array<string>, tags: Array<string>, accountingCategories: Array<string>, vendors: Array<string> }, rowReport: { __typename?: 'ProductImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, createRowCount: number, updateRowCount: number, warningRowCount: number, violationSample: Array<{ __typename?: 'ProductImportRowIssue', rowNumber: number, standardKey: string, label: string, reason: string, value: string }>, warningSample: Array<{ __typename?: 'ProductImportRowIssue', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> }, updatedRows: Array<{ __typename?: 'ProductImportPreviewRow', rowNumber: number, action: string, productCode: string, productName: string }> } };

export type ProductCreateMutationVariables = Exact<{
  input: ProductCreateInput;
}>;


export type ProductCreateMutation = { __typename?: 'Mutation', productCreate: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean, pricelistProducts: Array<{ __typename?: 'PricelistProduct', pricelistProductID: any, pricelistPeriodID: any, pricelistID: any, productID: any, sellingPrice: number, salesChannelPrice?: string | null, uniqueKey: string, pricelistPeriod: { __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelistID: any, effectiveStartDate: any, effectiveEndDate: any, effectiveStartHour?: number | null, effectiveEndHour?: number | null, effectiveStartMinute?: number | null, effectiveEndMinute?: number | null, useTime: boolean, priority: number, isActive: boolean, uniqueKey: string } }> } };

export type ProductDeleteMutationVariables = Exact<{
  productID: Scalars['UUID']['input'];
}>;


export type ProductDeleteMutation = { __typename?: 'Mutation', productDelete: boolean };

export type ProductImportValidateResultFieldsFragment = { __typename?: 'ProductImportValidateResult', status: string, missing: { __typename?: 'ProductImportMissing', sources: Array<string>, categories: Array<string>, subCategories: Array<string>, brands: Array<string>, uomCategories: Array<string>, uoms: Array<string>, taxes: Array<string>, countries: Array<string>, tags: Array<string>, accountingCategories: Array<string>, vendors: Array<string> }, rowReport: { __typename?: 'ProductImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, createRowCount: number, updateRowCount: number, warningRowCount: number, violationSample: Array<{ __typename?: 'ProductImportRowIssue', rowNumber: number, standardKey: string, label: string, reason: string, value: string }>, warningSample: Array<{ __typename?: 'ProductImportRowIssue', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> }, updatedRows: Array<{ __typename?: 'ProductImportPreviewRow', rowNumber: number, action: string, productCode: string, productName: string }> };

export type ProductListQueryVariables = Exact<{
  qop?: InputMaybe<ProductQopInput>;
}>;


export type ProductListQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaged', items?: Array<{ __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, uniqueKey: string, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, isActive: boolean, productBarcodeMaps: Array<{ __typename?: 'ProductBarcodeMap', productBarcodeMapID: any }>, purchaseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null, consignmentVendor?: { __typename?: 'Vendor', vendorName: string } | null, baseUom?: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean } | null, productBrand?: { __typename?: 'ProductBrand', productBrandID: any, productBrandName: string, uniqueKey: string, isActive: boolean } | null, productSource?: { __typename?: 'ProductSource', productSourceID: any, productSourceCode: string, productSourceName: string, uniqueKey: string, isActive: boolean } | null, pricelistProducts: Array<{ __typename?: 'PricelistProduct', pricelistProductID: any, sellingPrice: number, pricelistPeriod: { __typename?: 'PricelistPeriod', pricelistPeriodName: string, pricelist: { __typename?: 'Pricelist', pricelistName: string } } }>, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } | null, productSubCategory?: { __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string, productCategoryID: any, uniqueKey: string, isActive: boolean } | null, purchaseTax?: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, uniqueKey: string, isActive: boolean } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductLoadQueryVariables = Exact<{
  productID: Scalars['UUID']['input'];
}>;


export type ProductLoadQuery = { __typename?: 'Query', product: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, sellingPrice?: number | null, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, countryID?: string | null, productAccountingCategoryID?: any | null, productAccountingCategoryErpRefID?: string | null, productAccountingCategoryErpRefName?: string | null, hasAddon: boolean, addonGroupID?: any | null, uniqueKey: string, isActive: boolean, country?: { __typename?: 'Country', countryName: string } | null, productAccountingCategory?: { __typename?: 'ProductAccountingCategory', productAccountingCategoryID: any, productAccountingCategoryName: string } | null, addonGroup?: { __typename?: 'ProductAddonGroup', productAddonGroupID: any, name: string } | null, consignmentVendor?: { __typename?: 'Vendor', vendorName: string, vendorConsignmentBranch: Array<{ __typename?: 'VendorConsignmentBranch', branchID: any, branchCode: string, branchName: string }>, vendorConsignmentProducts: Array<{ __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any, sellingPrice: number, commissionFeePerc: number, productCommissionFeePerc: number, branchID: any, productID: any, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> } | null, pricelistProducts: Array<{ __typename?: 'PricelistProduct', pricelistProductID: any, sellingPrice: number, pricelistPeriod: { __typename?: 'PricelistPeriod', pricelistPeriodID: any, pricelistPeriodName: string, pricelist: { __typename?: 'Pricelist', pricelistId: any, pricelistName: string } } }>, uomCategory?: { __typename?: 'UomCategory', uomCategoryName: string } | null, baseUom?: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean, uomCategory?: { __typename?: 'UomCategory', uomCategoryID: any, uomCategoryName: string } | null } | null, productBrand?: { __typename?: 'ProductBrand', productBrandID: any, productBrandName: string, uniqueKey: string, isActive: boolean } | null, productSource?: { __typename?: 'ProductSource', productSourceID: any, productSourceCode: string, productSourceName: string, uniqueKey: string, isActive: boolean } | null, productVendors: Array<{ __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, taxable?: boolean | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentCommisionFeePerc?: number | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null } }>, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } | null, productSubCategory?: { __typename?: 'ProductSubCategory', productSubCategoryID: any, productSubCategoryName: string, productCategoryID: any, uniqueKey: string, isActive: boolean } | null, productFiles: Array<{ __typename?: 'ProductFile', productFileID: any, productID: any, productFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }>, productAIImages: Array<{ __typename?: 'ProductAIImage', productAIImageID: any, productID: any, aiImageType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }>, purchaseUom?: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean } | null, purchaseTax?: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, uniqueKey: string, isActive: boolean } | null, salesUom?: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean } | null, salesTax?: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, uniqueKey: string, isActive: boolean } | null, productBarcodeMaps: Array<{ __typename?: 'ProductBarcodeMap', productBarcodeMapID: any, productID: any, barcode: string, uniqueKey: string, isActive: boolean }>, productAvailabilityTemplateItems: Array<{ __typename?: 'ProductAvailabilityTemplateItem', productAvailabilityTemplateItemID: any, productAvailabilityTemplateID: any, productID: any, uniqueKey: string, isActive: boolean, salesChannelIDs: Array<string>, productAvailabilityTemplate?: { __typename?: 'ProductAvailabilityTemplate', productAvailabilityTemplateID: any, productAvailabilityTemplateName: string, isActive: boolean, uniqueKey: string } | null }>, productBundleComponents: Array<{ __typename?: 'ProductBundleComponent', productBundleComponentID: any, productID: any, componentProductID: any, qty: number, uomCategoryID: any, uomID: any, uniqueKey: string, isActive: boolean, componentProduct?: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean } | null, uom: { __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean } }>, productTagProducts: Array<{ __typename?: 'ProductTagProduct', productTagProductID: any, productTagID: any, productID: any, uniqueKey: string, productTag: { __typename?: 'ProductTag', productTagName: string } }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductNonConsignmentImportMutationVariables = Exact<{
  input: ProductImportInput;
}>;


export type ProductNonConsignmentImportMutation = { __typename?: 'Mutation', productNonConsignmentImport: { __typename?: 'ProductImportResult', backgroundJobID: any } };

export type ProductNonConsignmentImportValidateMutationVariables = Exact<{
  input: ProductImportInput;
}>;


export type ProductNonConsignmentImportValidateMutation = { __typename?: 'Mutation', productNonConsignmentImportValidate: { __typename?: 'ProductImportValidateResult', status: string, missing: { __typename?: 'ProductImportMissing', sources: Array<string>, categories: Array<string>, subCategories: Array<string>, brands: Array<string>, uomCategories: Array<string>, uoms: Array<string>, taxes: Array<string>, countries: Array<string>, tags: Array<string>, accountingCategories: Array<string>, vendors: Array<string> }, rowReport: { __typename?: 'ProductImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, createRowCount: number, updateRowCount: number, warningRowCount: number, violationSample: Array<{ __typename?: 'ProductImportRowIssue', rowNumber: number, standardKey: string, label: string, reason: string, value: string }>, warningSample: Array<{ __typename?: 'ProductImportRowIssue', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> }, updatedRows: Array<{ __typename?: 'ProductImportPreviewRow', rowNumber: number, action: string, productCode: string, productName: string }> } };

export type ProductSalesChannelPlacementsQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelCategoryGroupProductQopInput>;
}>;


export type ProductSalesChannelPlacementsQuery = { __typename?: 'Query', salesChannelCategoryGroupProducts: { __typename?: 'SalesChannelCategoryGroupProductPaged', items?: Array<{ __typename?: 'SalesChannelCategoryGroupProduct', salesChannelCategoryGroupProductID: any, salesChannelCategoryGroupID: any, salesChannelCategoryID: any, productID: any, isActive: boolean, priceType: string, customPrice: number, imageType: string, externalImageURL: string, salesChannelCategoryGroup?: { __typename?: 'SalesChannelCategoryGroup', salesChannelCategoryGroupID: any, salesChannelCategoryGroupName: string } | null, salesChannelCategory?: { __typename?: 'SalesChannelCategory', salesChannelCategoryID: any, salesChannelCategoryName: string } | null }> | null } };

export type ProductUpdateMutationVariables = Exact<{
  input: ProductUpdateInput;
}>;


export type ProductUpdateMutation = { __typename?: 'Mutation', productUpdate: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean } };

export type ProductVendorCreateMutationVariables = Exact<{
  input: ProductVendorCreateInput;
}>;


export type ProductVendorCreateMutation = { __typename?: 'Mutation', productVendorCreate: { __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean } };

export type ProductVendorDeleteMutationVariables = Exact<{
  productVendorID: Scalars['UUID']['input'];
}>;


export type ProductVendorDeleteMutation = { __typename?: 'Mutation', productVendorDelete: boolean };

export type ProductVendorListQueryVariables = Exact<{
  qop?: InputMaybe<ProductVendorQopInput>;
}>;


export type ProductVendorListQuery = { __typename?: 'Query', productVendors: { __typename?: 'ProductVendorPaged', items?: Array<{ __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ProductVendorLoadQueryVariables = Exact<{
  productVendorID: Scalars['UUID']['input'];
}>;


export type ProductVendorLoadQuery = { __typename?: 'Query', productVendor: { __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, taxable?: boolean | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentCommisionFeePerc?: number | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ProductVendorUpdateMutationVariables = Exact<{
  input: ProductVendorUpdateInput;
}>;


export type ProductVendorUpdateMutation = { __typename?: 'Mutation', productVendorUpdate: { __typename?: 'ProductVendor', productVendorID: any, productId: any, vendorId: any, purchasePrice: number, minimumOrder: number, canBeReturned: boolean, uniqueKey: string, isActive: boolean } };

export type ProductionOrderAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ProductionOrderQopInput>;
}>;


export type ProductionOrderAutocompleteQuery = { __typename?: 'Query', productionOrders: { __typename?: 'ProductionOrderPaged', items: Array<{ __typename?: 'ProductionOrder', productionOrderID: any, productionOrderNumber: string, productionOrderDatetime: any, branchID: any, gmt: number, warehouseID: any, warehouseLocationID: any, productID: any, productCode: string, productName: string, qty: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, billOfMaterialID: any, bomQty: number, bomUomID: any, bomUomConvertionRate: number, bomUomConversionDecimal: number, bomBaseUomQty: number, status: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ProductionOrderCancelMutationVariables = Exact<{
  productionOrderID: Scalars['UUID']['input'];
}>;


export type ProductionOrderCancelMutation = { __typename?: 'Mutation', productionOrderCancel: { __typename?: 'ProductionOrder', productionOrderID: any } };

export type ProductionOrderConfirmMutationVariables = Exact<{
  productionOrderID: Scalars['UUID']['input'];
}>;


export type ProductionOrderConfirmMutation = { __typename?: 'Mutation', productionOrderConfirm: { __typename?: 'ProductionOrder', productionOrderID: any } };

export type ProductionOrderCreateMutationVariables = Exact<{
  input: ProductionOrderCreateInput;
}>;


export type ProductionOrderCreateMutation = { __typename?: 'Mutation', productionOrderCreate: { __typename?: 'ProductionOrder', productionOrderID: any, productionOrderNumber: string, productionOrderDatetime: any, branchID: any, gmt: number, warehouseID: any, warehouseLocationID: any, productID: any, productCode: string, productName: string, qty: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, billOfMaterialID: any, bomQty: number, bomUomID: any, bomUomConvertionRate: number, bomUomConversionDecimal: number, bomBaseUomQty: number, status: string } };

export type ProductionOrderListQueryVariables = Exact<{
  qop?: InputMaybe<ProductionOrderQopInput>;
}>;


export type ProductionOrderListQuery = { __typename?: 'Query', productionOrders: { __typename?: 'ProductionOrderPaged', items: Array<{ __typename?: 'ProductionOrder', productionOrderID: any, productionOrderNumber: string, productionOrderDatetime: any, branchID: any, gmt: number, warehouseID: any, warehouseLocationID: any, productID: any, productCode: string, productName: string, qty: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, billOfMaterialID: any, bomQty: number, bomUomID: any, bomUomConvertionRate: number, bomUomConversionDecimal: number, bomBaseUomQty: number, waste?: number | null, wastePerc?: number | null, status: string, warehouse: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string }, product: { __typename?: 'Product', productCode: string, productName: string } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ProductionOrderLoadQueryVariables = Exact<{
  productionOrderID: Scalars['UUID']['input'];
}>;


export type ProductionOrderLoadQuery = { __typename?: 'Query', productionOrder?: { __typename?: 'ProductionOrder', productionOrderID: any, productionOrderNumber: string, productionOrderDatetime: any, branchID: any, gmt: number, warehouseID: any, warehouseLocationID: any, productID: any, productCode: string, productName: string, qty: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, billOfMaterialID: any, bomQty: number, bomUomID: any, bomUomConvertionRate: number, bomUomConversionDecimal: number, bomBaseUomQty: number, waste?: number | null, wastePerc?: number | null, status: string, expiryDate: any, lotNo: string, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null }, warehouseLocation: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseID: any, branchID: any, parentWarehouseLocationID?: any | null, uniqueKey: string, isActive: boolean }, product: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, sellingPrice?: number | null, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean }, billOfMaterial: { __typename?: 'BillOfMaterial', billOfMaterialID: any, name: string, productID: any, uomCategoryID: any, uomID: any, qty: number, description: string, isActive: boolean }, components: Array<{ __typename?: 'ProductionOrderComponent', productionOrderComponentID: any, productionOrderID: any, productID: any, productCode: string, productName: string, qty: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, bomQty?: number | null, bomUomID?: any | null, bomUomConvertionRate?: number | null, bomUomConversionDecimal?: number | null, bomBaseUomQty?: number | null, bomBaseQtyDiff?: number | null, isManual: boolean, product: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, sellingPrice?: number | null, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type ProductionOrderUpdateMutationVariables = Exact<{
  input: ProductionOrderUpdateInput;
}>;


export type ProductionOrderUpdateMutation = { __typename?: 'Mutation', productionOrderUpdate: { __typename?: 'ProductionOrder', productionOrderID: any, productionOrderNumber: string, productionOrderDatetime: any, branchID: any, gmt: number, warehouseID: any, warehouseLocationID: any, productID: any, productCode: string, productName: string, qty: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, billOfMaterialID: any, bomQty: number, bomUomID: any, bomUomConvertionRate: number, bomUomConversionDecimal: number, bomBaseUomQty: number, status: string } };

export type ProfileChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ProfileChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type ProfileMyPinQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileMyPinQuery = { __typename?: 'Query', userProfile: { __typename?: 'UserProfile', userID: string, pinPlainText?: string | null } };

export type ProfileRegeneratePinSelfMutationVariables = Exact<{ [key: string]: never; }>;


export type ProfileRegeneratePinSelfMutation = { __typename?: 'Mutation', userRegeneratePINSelf: string };

export type PromoCat1QueryVariables = Exact<{
  promoComponentID: Scalars['UUID']['input'];
}>;


export type PromoCat1Query = { __typename?: 'Query', promoComponentCat1: { __typename?: 'PromoComponentCAT1Detail', promoComponent: { __typename?: 'PromoComponent', promoComponentID: any, promoID: any, description: string, promoTypeID: any, config: string }, config: { __typename?: 'PromoConfigCAT1', discountPercent: number, enableQuota: boolean, products: Array<{ __typename?: 'PromoProduct', productID: any, productCode?: string | null, productName?: string | null }>, productQuotas?: Array<{ __typename?: 'PromoProductQuota', productID: any, maxQty: number }> | null } } };

export type PromoCat2QueryVariables = Exact<{
  promoComponentID: Scalars['UUID']['input'];
}>;


export type PromoCat2Query = { __typename?: 'Query', promoComponentCat2: { __typename?: 'PromoComponentCAT2Detail', promoComponent: { __typename?: 'PromoComponent', promoComponentID: any, promoID: any, description: string, promoTypeID: any, config: string }, config: { __typename?: 'PromoConfigCAT2', minQty: number, freeQty: number, isMultiple: boolean, enableQuota: boolean, buyProducts: Array<{ __typename?: 'PromoProduct', productID: any, productCode?: string | null, productName?: string | null }>, getFreeProducts: Array<{ __typename?: 'PromoProduct', productID: any, productCode?: string | null, productName?: string | null }>, quota?: { __typename?: 'PromoComponentQuota', maxQty: number } | null } } };

export type PromoCat3QueryVariables = Exact<{
  promoComponentID: Scalars['UUID']['input'];
}>;


export type PromoCat3Query = { __typename?: 'Query', promoComponentCat3: { __typename?: 'PromoComponentCAT3Detail', promoComponent: { __typename?: 'PromoComponent', promoComponentID: any, promoID: any, description: string, promoTypeID: any, config: string }, config: { __typename?: 'PromoConfigCAT3', discountAmount: number, enableQuota: boolean, products: Array<{ __typename?: 'PromoProduct', productID: any, productCode?: string | null, productName?: string | null }>, productQuotas?: Array<{ __typename?: 'PromoProductQuota', productID: any, maxQty: number }> | null } } };

export type PromoCat4QueryVariables = Exact<{
  promoComponentID: Scalars['UUID']['input'];
}>;


export type PromoCat4Query = { __typename?: 'Query', promoComponentCat4: { __typename?: 'PromoComponentCAT4Detail', promoComponent: { __typename?: 'PromoComponent', promoComponentID: any, promoID: any, description: string, promoTypeID: any, config: string }, config: { __typename?: 'PromoConfigCAT4', discountPercent: number } } };

export type PromoCat5QueryVariables = Exact<{
  promoComponentID: Scalars['UUID']['input'];
}>;


export type PromoCat5Query = { __typename?: 'Query', promoComponentCat5: { __typename?: 'PromoComponentCAT5Detail', promoComponent: { __typename?: 'PromoComponent', promoComponentID: any, promoID: any, description: string, promoTypeID: any, config: string }, config: { __typename?: 'PromoConfigCAT5', discountAmount: number } } };

export type PromoCat6QueryVariables = Exact<{
  promoComponentID: Scalars['UUID']['input'];
}>;


export type PromoCat6Query = { __typename?: 'Query', promoComponentCat6: { __typename?: 'PromoComponentCAT6Detail', promoComponent: { __typename?: 'PromoComponent', promoComponentID: any, promoID: any, description: string, promoTypeID: any, config: string }, config: { __typename?: 'PromoConfigCAT6', discountPercent: number, categories: Array<{ __typename?: 'PromoCategory', productCategoryID: any, productCategoryName?: string | null }> } } };

export type PromoComponentListQueryVariables = Exact<{
  qop: PromoComponentQopInput;
}>;


export type PromoComponentListQuery = { __typename?: 'Query', promoComponents: { __typename?: 'PromoComponentPaged', items?: Array<{ __typename?: 'PromoComponent', promoComponentID: any, promoID: any, description: string, promoTypeID: any, expenseItemID?: any | null, config: string, promoType: { __typename?: 'PromoType', name: string, description: string, promoTypeID: any }, expenseItem?: { __typename?: 'ExpenseItem', expenseItemID: any, expenseItemName: string, journalAccountCode: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PromoQuotaListQueryVariables = Exact<{
  qop: PromoQuotaQopInput;
}>;


export type PromoQuotaListQuery = { __typename?: 'Query', promoQuotas: { __typename?: 'PromoQuotaPagedResult', items: Array<{ __typename?: 'PromoQuota', promoQuotaID: any, promoID: any, promoComponentID: any, quotaType: string, maxQty: number, usedQty: number, remainingQty: number, isActive: boolean, uniqueKey: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PromoTypeAutocompleteQueryVariables = Exact<{
  qop: PromoTypeQopInput;
}>;


export type PromoTypeAutocompleteQuery = { __typename?: 'Query', promoTypes: { __typename?: 'PromoTypePaged', items?: Array<{ __typename?: 'PromoType', promoTypeID: any, name: string, description: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PromoTypeListQueryVariables = Exact<{
  qop: PromoTypeQopInput;
}>;


export type PromoTypeListQuery = { __typename?: 'Query', promoTypes: { __typename?: 'PromoTypePaged', items?: Array<{ __typename?: 'PromoType', promoTypeID: any, name: string, description: string, uniqueKey: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PromoTypeLoadQueryVariables = Exact<{
  promoTypeID: Scalars['UUID']['input'];
}>;


export type PromoTypeLoadQuery = { __typename?: 'Query', promoType: { __typename?: 'PromoType', promoTypeID: any, name: string, description: string, uniqueKey: string, isActive: boolean } };

export type PromoAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<PromoQopInput>;
}>;


export type PromoAutocompleteQuery = { __typename?: 'Query', promos: { __typename?: 'PromoPaged', items?: Array<{ __typename?: 'Promo', promoID: any, promoName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type PromoComponentImportValidateMutationVariables = Exact<{
  input: PromoComponentImportValidateInput;
}>;


export type PromoComponentImportValidateMutation = { __typename?: 'Mutation', promoComponentImportValidate: { __typename?: 'PromoComponentImportValidateResult', missingProductCodes: Array<string>, rowReport: { __typename?: 'PromoComponentImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'PromoComponentImportRowViolation', rowNumber: number, componentName: string, standardKey: string, label: string, reason: string, value: string }> }, components: Array<{ __typename?: 'PromoComponentImportComponent', promoComponentID?: any | null, expenseItemID?: any | null, description: string, promoTypeID: any, discountPercent?: number | null, discountAmount?: number | null, minQty?: number | null, freeQty?: number | null, isMultiple?: boolean | null, enableQuota: boolean, quotaMaxQty?: number | null, products: Array<{ __typename?: 'PromoImportedItem', productID: any, productCode: string, productName: string, barcode: string, quotaMaxQty?: number | null }>, getFreeProducts: Array<{ __typename?: 'PromoImportedItem', productID: any, productCode: string, productName: string, barcode: string, quotaMaxQty?: number | null }> }> } };

export type PromoCreateMutationVariables = Exact<{
  input: PromoBulkCreateInput;
}>;


export type PromoCreateMutation = { __typename?: 'Mutation', promoCreate: Array<{ __typename?: 'Promo', promoID: any, promoName: string, description: string, effectiveStartDate: any, effectiveEndDate: any, priority: number, isActive: boolean }> };

export type PromoDeleteMutationVariables = Exact<{
  promoID: Scalars['UUID']['input'];
}>;


export type PromoDeleteMutation = { __typename?: 'Mutation', promoDelete: boolean };

export type PromoListQueryVariables = Exact<{
  qop?: InputMaybe<PromoQopInput>;
}>;


export type PromoListQuery = { __typename?: 'Query', promos: { __typename?: 'PromoPaged', items?: Array<{ __typename?: 'Promo', promoID: any, promoName: string, description: string, effectiveStartDate: any, effectiveEndDate: any, priority: number, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PromoLoadQueryVariables = Exact<{
  promoID: Scalars['UUID']['input'];
}>;


export type PromoLoadQuery = { __typename?: 'Query', promo: { __typename?: 'Promo', promoID: any, promoName: string, description: string, effectiveStartDate: any, effectiveEndDate: any, priority: number, isActive: boolean, expenseAccountCode?: string | null, expenseAccountErpRefID?: string | null, expenseAccountErpRefName?: string | null, isAllBranches: boolean, branches?: Array<{ __typename?: 'PromoBranchRef', branchID: any, branchName?: string | null, branch: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string } }> | null, promoRules?: { __typename?: 'PromoRules', availability?: Array<{ __typename?: 'PromoAvailabilityRule', days: Array<string>, allDay: boolean, useTime: boolean, startTime?: string | null, endTime?: string | null }> | null } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type PromoUpdateMutationVariables = Exact<{
  input: PromoBulkUpdateInput;
}>;


export type PromoUpdateMutation = { __typename?: 'Mutation', promoUpdate: Array<{ __typename?: 'Promo', promoID: any, promoName: string, description: string, effectiveStartDate: any, effectiveEndDate: any, priority: number, isActive: boolean }> };

export type PurchaseAreaAutocompleteQueryVariables = Exact<{
  qop: PurchaseAreaQopInput;
}>;


export type PurchaseAreaAutocompleteQuery = { __typename?: 'Query', purchaseAreas: { __typename?: 'PurchaseAreaPaged', items?: Array<{ __typename?: 'PurchaseArea', purchaseAreaID: any, purchaseAreaName: string, uniqueKey: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PurchaseAreaCreateMutationVariables = Exact<{
  input: PurchaseAreaCreateInput;
}>;


export type PurchaseAreaCreateMutation = { __typename?: 'Mutation', purchaseAreaCreate: { __typename?: 'PurchaseArea', purchaseAreaName: string, purchaseAreaID: any, isActive: boolean } };

export type PurchaseAreaDeleteMutationVariables = Exact<{
  purchaseAreaID: Scalars['UUID']['input'];
}>;


export type PurchaseAreaDeleteMutation = { __typename?: 'Mutation', purchaseAreaDelete: boolean };

export type PurchaseAreaListQueryVariables = Exact<{
  qop: PurchaseAreaQopInput;
}>;


export type PurchaseAreaListQuery = { __typename?: 'Query', purchaseAreas: { __typename?: 'PurchaseAreaPaged', items?: Array<{ __typename?: 'PurchaseArea', purchaseAreaID: any, purchaseAreaName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PurchaseAreaLoadQueryVariables = Exact<{
  purchaseAreaID: Scalars['UUID']['input'];
}>;


export type PurchaseAreaLoadQuery = { __typename?: 'Query', purchaseArea?: { __typename?: 'PurchaseArea', purchaseAreaID: any, purchaseAreaName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type PurchaseAreaUpdateMutationVariables = Exact<{
  input: PurchaseAreaUpdateInput;
}>;


export type PurchaseAreaUpdateMutation = { __typename?: 'Mutation', purchaseAreaUpdate: { __typename?: 'PurchaseArea', purchaseAreaID: any, purchaseAreaName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type PurchaseOrderCancelMutationVariables = Exact<{
  purchaseOrderID: Scalars['UUID']['input'];
}>;


export type PurchaseOrderCancelMutation = { __typename?: 'Mutation', purchaseOrderCancel: boolean };

export type PurchaseOrderConfirmMutationVariables = Exact<{
  purchaseOrderID: Scalars['UUID']['input'];
}>;


export type PurchaseOrderConfirmMutation = { __typename?: 'Mutation', purchaseOrderConfirm: boolean };

export type PurchaseOrderCreateMutationVariables = Exact<{
  input: PurchaseOrderCreateInput;
}>;


export type PurchaseOrderCreateMutation = { __typename?: 'Mutation', purchaseOrderCreate: { __typename?: 'PurchaseOrder', purchaseOrderID: any, purchaseOrderNumber: string, purchaseOrderDatetime: any, purchaseOrderDatetimeUtc: any, deliveryDate: any, deadlineDate: any, branchID: any, gmt: number, vendorID: any, vendorRefNo: string, destinationWarehouseID: any, purchaseAreaID: any, taxIncluded: boolean, totalItemQty: number, totalItemQtyReceived: number, subtotal: number, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, subtotalAfterDiscount: number, taxAmount: number, taxItems: string, landedCost: number, landedCostPerUnit: number, adjustmentAmount: number, total: number, taxableAmount: number, noteInternal: string, noteForVendor: string, status: string } };

export type PurchaseOrderSendEmailMutationVariables = Exact<{
  purchaseOrderID: Scalars['UUID']['input'];
}>;


export type PurchaseOrderSendEmailMutation = { __typename?: 'Mutation', purchaseOrderSendEmail: boolean };

export type PurchaseOrderForceCloseMutationVariables = Exact<{
  input: PurchaseOrderForceCloseInput;
}>;


export type PurchaseOrderForceCloseMutation = { __typename?: 'Mutation', purchaseOrderForceClose: boolean };

export type PurchaseOrderImportMutationVariables = Exact<{
  input: PurchaseOrderImportInput;
}>;


export type PurchaseOrderImportMutation = { __typename?: 'Mutation', purchaseOrderImport: any };

export type PurchaseOrderImportValidateCodesMutationVariables = Exact<{
  input: PurchaseOrderImportValidateCodesInput;
}>;


export type PurchaseOrderImportValidateCodesMutation = { __typename?: 'Mutation', purchaseOrderImportValidateCodes: { __typename?: 'PurchaseOrderImportValidateCodesResult', missingVendorCodes: Array<string>, missingBranchCodes: Array<string>, missingWarehouseCodes: Array<string>, missingProductCodes: Array<string>, missingTaxCodes: Array<string>, missingPurchaseAreaNames: Array<string>, consignmentVendorCodes: Array<string>, consignmentProductCodes: Array<string>, duplicateProductCodes: Array<string>, missingProductUoms: Array<{ __typename?: 'PurchaseOrderImportMissingProductUom', rowNumber: number, productCode: string, uomName: string }>, rowReport?: { __typename?: 'PurchaseOrderImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'PurchaseOrderImportRowViolation', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> } | null } };

export type PurchaseOrderItemsQueryVariables = Exact<{
  qop?: InputMaybe<PurchaseOrderItemQopInput>;
}>;


export type PurchaseOrderItemsQuery = { __typename?: 'Query', purchaseOrderItems: { __typename?: 'PurchaseOrderItemPaged', items: Array<{ __typename?: 'PurchaseOrderItem', purchaseOrderItemID: any, purchaseOrderID: any, sequenceNo: number, productID: any, productCode: string, productName: string, description: string, qty: number, qtyReceived: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, unitPrice: number, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, additionalDiscountPerc: number, additionalDiscountAmount: number, additionalLandedCost: number, total: number, taxableAmount: number, taxAmount: number, taxItems: string, baseUomUnitCost: number, taxes: Array<{ __typename?: 'PurchaseOrderItemTax', purchaseOrderItemTaxID: any, purchaseOrderItemID: any, purchaseOrderID: any, taxID: any, taxCode: string, taxRate: number, taxableAmount: number, taxAmount: number }>, product?: { __typename?: 'Product', productID: any, productName: string, productNameAlias: string, productType: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, barcode: string, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, addonGroupID?: any | null, hasAddon: boolean, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, productAccountingCategoryID?: any | null, isConsignment: boolean, consignmentVendorID?: any | null, isSystem: boolean, trackStock: boolean, trackExpiredDate: boolean, inventoryTrackingType: string, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, sellingPrice?: number | null, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type PurchaseOrderListQueryVariables = Exact<{
  qop?: InputMaybe<PurchaseOrderQopInput>;
}>;


export type PurchaseOrderListQuery = { __typename?: 'Query', purchaseOrders: { __typename?: 'PurchaseOrderPaged', items: Array<{ __typename?: 'PurchaseOrder', purchaseOrderID: any, purchaseOrderNumber: string, purchaseOrderDatetime: any, purchaseOrderDatetimeUtc: any, deliveryDate: any, deadlineDate: any, branchID: any, gmt: number, vendorID: any, vendorCode: string, vendorName: string, vendorEmail: string, vendorPhoneNumber: string, vendorNpwp: string, vendorNpwpCompanyName: string, vendorRefNo: string, destinationWarehouseID: any, destinationWarehouseCode: string, destinationWarehouseName: string, purchaseAreaID: any, purchaseAreaName: string, taxIncluded: boolean, totalItemQty: number, totalItemQtyReceived: number, subtotal: number, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, subtotalAfterDiscount: number, taxAmount: number, taxItems: string, landedCost: number, landedCostPerUnit: number, adjustmentAmount: number, total: number, taxableAmount: number, noteInternal: string, noteForVendor: string, status: string, isCannotRevise?: boolean | null, isAlreadyForceClosePO?: boolean | null, taxes: Array<{ __typename?: 'PurchaseOrderTax', purchaseOrderTaxID: any, purchaseOrderID: any, taxID: any, taxCode: string, taxRate: number, taxableAmount: number, taxAmount: number }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PurchaseOrderLoadQueryVariables = Exact<{
  purchaseOrderID: Scalars['UUID']['input'];
}>;


export type PurchaseOrderLoadQuery = { __typename?: 'Query', purchaseOrder?: { __typename?: 'PurchaseOrder', purchaseOrderID: any, purchaseOrderNumber: string, purchaseOrderDatetime: any, purchaseOrderDatetimeUtc: any, deliveryDate: any, deadlineDate: any, branchID: any, gmt: number, vendorID: any, vendorCode: string, vendorName: string, vendorEmail: string, vendorPhoneNumber: string, vendorNpwp: string, vendorNpwpCompanyName: string, vendorRefNo: string, destinationWarehouseID: any, destinationWarehouseCode: string, destinationWarehouseName: string, purchaseAreaID: any, purchaseAreaName: string, taxIncluded: boolean, totalItemQty: number, totalItemQtyReceived: number, subtotal: number, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, subtotalAfterDiscount: number, taxAmount: number, taxItems: string, landedCost: number, landedCostPerUnit: number, adjustmentAmount: number, total: number, taxableAmount: number, noteInternal: string, noteForVendor: string, status: string, isCannotRevise?: boolean | null, isAlreadyForceClosePO?: boolean | null, receivingStatus: string, cancelledType?: string | null, cancelledDatetime?: any | null, cancelledByUserName?: string | null, vendorAddress?: { __typename?: 'BaseModelAddress', fullAddress?: string | null } | null, destinationWarehouseAddress?: { __typename?: 'BaseModelAddress', fullAddress?: string | null } | null, itemUomSummaries: Array<{ __typename?: 'PurchaseOrderItemUomSummary', uomID: any, uomName: string, qty: number, uomDecimal: number }>, taxes: Array<{ __typename?: 'PurchaseOrderTax', purchaseOrderTaxID: any, purchaseOrderID: any, taxID: any, taxCode: string, taxRate: number, taxableAmount: number, taxAmount: number, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type PurchaseOrderReviseMutationVariables = Exact<{
  input: PurchaseOrderReviseInput;
}>;


export type PurchaseOrderReviseMutation = { __typename?: 'Mutation', purchaseOrderRevise: boolean };

export type PurchaseOrderUpdateMutationVariables = Exact<{
  input: PurchaseOrderUpdateInput;
}>;


export type PurchaseOrderUpdateMutation = { __typename?: 'Mutation', purchaseOrderUpdate: { __typename?: 'PurchaseOrder', purchaseOrderID: any, purchaseOrderNumber: string, purchaseOrderDatetime: any, purchaseOrderDatetimeUtc: any, deliveryDate: any, deadlineDate: any, branchID: any, gmt: number, vendorID: any, vendorRefNo: string, destinationWarehouseID: any, purchaseAreaID: any, taxIncluded: boolean, totalItemQty: number, totalItemQtyReceived: number, subtotal: number, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, subtotalAfterDiscount: number, taxAmount: number, taxItems: string, landedCost: number, landedCostPerUnit: number, adjustmentAmount: number, total: number, taxableAmount: number, noteInternal: string, noteForVendor: string, status: string, taxes: Array<{ __typename?: 'PurchaseOrderTax', purchaseOrderTaxID: any, purchaseOrderID: any, taxID: any, taxCode: string, taxRate: number, taxableAmount: number, taxAmount: number }> } };

export type PutawayTaskAssignMutationVariables = Exact<{
  input: AssignTaskInput;
}>;


export type PutawayTaskAssignMutation = { __typename?: 'Mutation', putawayTaskAssign: { __typename?: 'PutawayTask', putawayTaskID: any, assignedToUserID?: any | null } };

export type PutawayTaskCancelMutationVariables = Exact<{
  input: CancelTaskInput;
}>;


export type PutawayTaskCancelMutation = { __typename?: 'Mutation', putawayTaskCancel: boolean };

export type PutawayTaskExecutionsQueryVariables = Exact<{
  qop?: InputMaybe<PutawayTaskExecutionQopInput>;
}>;


export type PutawayTaskExecutionsQuery = { __typename?: 'Query', putawayTaskExecutions: { __typename?: 'PutawayTaskExecutionPaged', items: Array<{ __typename?: 'PutawayTaskExecution', putawayTaskExecutionID: any, qty: number, uomName: string, warehouseLocation?: { __typename?: 'WarehouseLocation', warehouseLocationName: string } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PutawayTaskItemsLoadQueryVariables = Exact<{
  qop?: InputMaybe<PutawayTaskItemQopInput>;
}>;


export type PutawayTaskItemsLoadQuery = { __typename?: 'Query', putawayTaskItems: { __typename?: 'PutawayTaskItemPaged', items: Array<{ __typename?: 'PutawayTaskItem', putawayTaskItemID: any, productCode: string, productName: string, qtyAssigned: number, qtyExecuted: number, qtyOutstanding: number, uomName: string, product?: { __typename?: 'Product', barcode: string } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PutawayTaskListQueryVariables = Exact<{
  qop?: InputMaybe<PutawayTaskQopInput>;
}>;


export type PutawayTaskListQuery = { __typename?: 'Query', putawayTasks: { __typename?: 'PutawayTaskPaged', items: Array<{ __typename?: 'PutawayTask', putawayTaskID: any, putawayTaskNumber: string, putawayTaskDatetime: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, branchID: any, warehouseID: any, fromWarehouseLocationID: any, fromWarehouseLocationCode: string, fromWarehouseLocationName: string, assignedToUserID?: any | null, assignedToUserName?: string | null, totalItems: number, totalQtyAssigned: number, totalQtyExecuted: number, progressPercent: number, taskStartAt?: any | null, taskDoneAt?: any | null, taskDurationMinute?: number | null, status: string, noteInternal: string, warehouse?: { __typename?: 'Warehouse', warehouseName: string } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type PutawayTaskLoadQueryVariables = Exact<{
  putawayTaskID: Scalars['UUID']['input'];
}>;


export type PutawayTaskLoadQuery = { __typename?: 'Query', putawayTask: { __typename?: 'PutawayTask', putawayTaskID: any, putawayTaskNumber: string, putawayTaskDatetime: any, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, branchID: any, warehouseID: any, fromWarehouseLocationID: any, fromWarehouseLocationCode: string, fromWarehouseLocationName: string, assignedToUserID?: any | null, assignedToUserName?: string | null, totalItems: number, totalQtyAssigned: number, totalQtyExecuted: number, progressPercent: number, taskStartAt?: any | null, taskDoneAt?: any | null, taskDurationMinute?: number | null, status: string, noteInternal: string, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null, items: Array<{ __typename?: 'PutawayTaskItem', putawayTaskItemID: any, putawayTaskID: any, sourceDocumentDetailID: any, productID: any, productCode: string, productName: string, uomID: any, uomName: string, qtyAssigned: number, qtyExecuted: number, qtyOutstanding: number }> } };

export type ReasonAutocompleteQueryVariables = Exact<{
  qop: ReasonQopInput;
}>;


export type ReasonAutocompleteQuery = { __typename?: 'Query', reasons: { __typename?: 'ReasonPaged', items?: Array<{ __typename?: 'Reason', reasonID: any, reasonCode: string, reasonName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type BankReconciliationCancelMutationVariables = Exact<{
  input: BankReconciliationCancelInput;
}>;


export type BankReconciliationCancelMutation = { __typename?: 'Mutation', bankReconciliationCancel: { __typename?: 'BankReconciliation', bankReconciliationID: any, status: string } };

export type BankReconciliationCreateMutationVariables = Exact<{
  input: BankReconciliationCreateInput;
}>;


export type BankReconciliationCreateMutation = { __typename?: 'Mutation', bankReconciliationCreate: { __typename?: 'BankReconciliation', bankReconciliationID: any, bankReconciliationNumber: string, status: string } };

export type BankReconciliationExportMutationVariables = Exact<{
  input: BankReconciliationExportInput;
}>;


export type BankReconciliationExportMutation = { __typename?: 'Mutation', bankReconciliationExport: { __typename?: 'BankReconciliationExport', downloadUrl: string, fileName: string } };

export type BankReconciliationFilesQueryVariables = Exact<{
  bankReconciliationID: Scalars['UUID']['input'];
}>;


export type BankReconciliationFilesQuery = { __typename?: 'Query', bankReconciliationFiles: Array<{ __typename?: 'BankReconciliationFile', bankReconciliationFileID: any, bankReconciliationID?: any | null, bankID: any, statementFileID: any, statementFileName: string, fileType: string, settlementDateFrom?: any | null, settlementDateTo?: any | null, rowCount: number, midFailureCount: number, status: string, errorMessage: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, version: any } }> };

export type BankReconciliationFinalizeMutationVariables = Exact<{
  input: BankReconciliationFinalizeInput;
}>;


export type BankReconciliationFinalizeMutation = { __typename?: 'Mutation', bankReconciliationFinalize: { __typename?: 'BankReconciliation', bankReconciliationID: any, bankReconciliationNumber: string, status: string } };

export type BankReconciliationItemListQueryVariables = Exact<{
  qop: BankReconciliationItemQopInput;
}>;


export type BankReconciliationItemListQuery = { __typename?: 'Query', bankReconciliationItems: { __typename?: 'BankReconciliationItemPaged', items: Array<{ __typename?: 'BankReconciliationItem', bankReconciliationItemID: any, bankReconciliationID: any, bankAccountID: any, externalTransactionID: string, transactionDate?: any | null, settlementDate?: any | null, transactionTime: string, amount: number, netAmount: number, mdrAmount: number, referenceNumber: string, approvalCode: string, merchantID: string, merchantName: string, bankBranchID?: any | null, bankBranchName: string, terminalID: string, cardNumber: string, issuer: string, rawDescription: string, salesInvoicePaymentID?: any | null, salesInvoiceID?: any | null, salesInvoiceNumber: string, paymentDate?: any | null, paymentDatetime?: any | null, paymentAmount: number, paymentBranchID?: any | null, paymentBranchName: string, paymentCashierUserName: string, paymentMethodID?: any | null, paymentMethodName: string, paymentBankReferenceNumber: string, paymentCardNumber: string, paymentApprovalCode: string, bankExist: boolean, salesPaymentExist: boolean, isReconciliation: boolean, reconciliationStatus: string, matchedSalesInvoicePaymentID?: any | null, matchedAt?: any | null, note: string, resolution: string, resolutionReason: string, resolvedAt?: any | null, resolvedByUserName?: string | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type BankReconciliationItemManualMatchMutationVariables = Exact<{
  input: BankReconciliationItemManualMatchInput;
}>;


export type BankReconciliationItemManualMatchMutation = { __typename?: 'Mutation', bankReconciliationItemManualMatch: { __typename?: 'BankReconciliation', bankReconciliationID: any, totalMatched: number, totalPartialMatched: number, totalUnmatched: number } };

export type BankReconciliationItemMergeMutationVariables = Exact<{
  input: BankReconciliationItemMergeInput;
}>;


export type BankReconciliationItemMergeMutation = { __typename?: 'Mutation', bankReconciliationItemMerge: { __typename?: 'BankReconciliation', bankReconciliationID: any, status: string, totalMatched: number, totalPartialMatched: number, totalUnmatched: number } };

export type BankReconciliationItemResolveMutationVariables = Exact<{
  input: BankReconciliationItemResolveInput;
}>;


export type BankReconciliationItemResolveMutation = { __typename?: 'Mutation', bankReconciliationItemResolve: { __typename?: 'BankReconciliation', bankReconciliationID: any, status: string, totalMatched: number, totalPartialMatched: number, totalUnmatched: number } };

export type BankReconciliationListQueryVariables = Exact<{
  qop?: InputMaybe<BankReconciliationQopInput>;
}>;


export type BankReconciliationListQuery = { __typename?: 'Query', bankReconciliations: { __typename?: 'BankReconciliationPaged', items: Array<{ __typename?: 'BankReconciliation', bankReconciliationID: any, bankReconciliationNumber: string, bankID: any, bankName: string, reconDate: any, reconDatetime: any, settlementDateFrom?: any | null, settlementDateTo?: any | null, totalItems: number, totalMatched: number, totalPartialMatched: number, totalUnmatched: number, totalAmount: number, status: string, statementFileID?: any | null, statementFileName?: string | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type BankReconciliationLoadQueryVariables = Exact<{
  bankReconciliationID: Scalars['UUID']['input'];
}>;


export type BankReconciliationLoadQuery = { __typename?: 'Query', bankReconciliation?: { __typename?: 'BankReconciliation', bankReconciliationID: any, bankReconciliationNumber: string, bankID: any, bankName: string, reconDate: any, reconDatetime: any, reconDatetimeUtc: any, gmt: number, settlementDateFrom?: any | null, settlementDateTo?: any | null, totalItems: number, totalMatched: number, totalPartialMatched: number, totalUnmatched: number, totalAmount: number, status: string, doneDatetime?: any | null, doneByUserName?: string | null, cancelledDatetime?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, branches: Array<{ __typename?: 'BankReconciliationBranch', branchID: any, branch: { __typename?: 'Branch', branchName: string, branchCode: string } }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null, updatedAt: any, version: any } } | null };

export type BankReconciliationPoolFilesQueryVariables = Exact<{
  bankID?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type BankReconciliationPoolFilesQuery = { __typename?: 'Query', bankReconciliationPoolFiles: Array<{ __typename?: 'BankReconciliationFile', bankReconciliationFileID: any, bankReconciliationID?: any | null, bankID: any, statementFileID: any, statementFileName: string, fileType: string, settlementDateFrom?: any | null, settlementDateTo?: any | null, rowCount: number, midFailureCount: number, status: string, errorMessage: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, version: any } }> };

export type BankReconciliationPoolRowsQueryVariables = Exact<{
  qop?: InputMaybe<BankDataRowQopInput>;
}>;


export type BankReconciliationPoolRowsQuery = { __typename?: 'Query', bankReconciliationPoolRows: { __typename?: 'BankDataRowPaged', items: Array<{ __typename?: 'BankDataRow', bankDataRowID: any, uploadFilename: string, transactionDate: any, transactionTime: string, amount: number, merchantID: string, approvalCode: string, referenceNumber: string, terminalID: string, cardNumber: string, branchID?: any | null, branchName: string, bankID?: any | null, bankName: string, isMatched: boolean, bankReconciliationID?: any | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type BankReconciliationProcessMutationVariables = Exact<{
  input: BankReconciliationProcessInput;
}>;


export type BankReconciliationProcessMutation = { __typename?: 'Mutation', bankReconciliationProcess: { __typename?: 'BankReconciliation', bankReconciliationID: any, status: string } };

export type BankReconciliationRemoveFileMutationVariables = Exact<{
  input: BankReconciliationRemoveFileInput;
}>;


export type BankReconciliationRemoveFileMutation = { __typename?: 'Mutation', bankReconciliationRemoveFile?: { __typename?: 'BankReconciliation', bankReconciliationID: any, status: string } | null };

export type BankReconciliationRetryPoolFileMutationVariables = Exact<{
  bankReconciliationFileID: Scalars['UUID']['input'];
}>;


export type BankReconciliationRetryPoolFileMutation = { __typename?: 'Mutation', bankReconciliationRetryPoolFile: { __typename?: 'BankReconciliationFile', bankReconciliationFileID: any, status: string, errorMessage: string } };

export type BankReconciliationUploadFileMutationVariables = Exact<{
  input: BankReconciliationUploadFileInput;
}>;


export type BankReconciliationUploadFileMutation = { __typename?: 'Mutation', bankReconciliationUploadFile: { __typename?: 'BankReconciliation', bankReconciliationID: any, bankReconciliationNumber: string, status: string } };

export type BankReconciliationUploadPoolFileMutationVariables = Exact<{
  input: BankReconciliationUploadPoolFileInput;
}>;


export type BankReconciliationUploadPoolFileMutation = { __typename?: 'Mutation', bankReconciliationUploadPoolFile: { __typename?: 'BankReconciliationFile', bankReconciliationFileID: any, bankID: any, statementFileName: string, fileType: string, status: string } };

export type SalesInvoicePaymentListQueryVariables = Exact<{
  qop?: InputMaybe<SalesInvoicePaymentQopInput>;
}>;


export type SalesInvoicePaymentListQuery = { __typename?: 'Query', salesInvoicePayments: { __typename?: 'SalesInvoicePaymentPaged', items: Array<{ __typename?: 'SalesInvoicePayment', salesInvoicePaymentID: any, salesInvoiceID: any, paymentMethodTypeCode: string, paymentMethodTypeName: string, bankAccountID?: any | null, bankAccountNumber?: string | null, bankID?: any | null, bankName?: string | null, bankReferenceNumber?: string | null, authCode?: string | null, cardNumber?: string | null, paymentAmount: number, branchName?: string | null, isReconciliation: boolean, reconciliationStatus: string, bankReconciliationItemID?: any | null, reconciledAt?: any | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ReplenishmentTemplateCategoryAutocompleteQueryVariables = Exact<{
  qop: ReplenishmentTemplateCategoryQopInput;
}>;


export type ReplenishmentTemplateCategoryAutocompleteQuery = { __typename?: 'Query', replenishmentTemplateCategories: { __typename?: 'ReplenishmentTemplateCategoryPaged', items?: Array<{ __typename?: 'ReplenishmentTemplateCategory', replenishmentTemplateCategoryID: any, replenishmentTemplateCategoryName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type ReplenishmentTemplateCategoryCreateMutationVariables = Exact<{
  input: ReplenishmentTemplateCategoryCreateInput;
}>;


export type ReplenishmentTemplateCategoryCreateMutation = { __typename?: 'Mutation', replenishmentTemplateCategoryCreate: { __typename?: 'ReplenishmentTemplateCategory', replenishmentTemplateCategoryID: any } };

export type ReplenishmentTemplateCategoryDeleteMutationVariables = Exact<{
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
}>;


export type ReplenishmentTemplateCategoryDeleteMutation = { __typename?: 'Mutation', replenishmentTemplateCategoryDelete: boolean };

export type ReplenishmentTemplateCategoryListQueryVariables = Exact<{
  qop: ReplenishmentTemplateCategoryQopInput;
}>;


export type ReplenishmentTemplateCategoryListQuery = { __typename?: 'Query', replenishmentTemplateCategories: { __typename?: 'ReplenishmentTemplateCategoryPaged', items?: Array<{ __typename?: 'ReplenishmentTemplateCategory', replenishmentTemplateCategoryID: any, replenishmentTemplateCategoryName: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ReplenishmentTemplateCategoryLoadQueryVariables = Exact<{
  replenishmentTemplateCategoryID: Scalars['UUID']['input'];
}>;


export type ReplenishmentTemplateCategoryLoadQuery = { __typename?: 'Query', replenishmentTemplateCategory: { __typename?: 'ReplenishmentTemplateCategory', replenishmentTemplateCategoryID: any, replenishmentTemplateCategoryName: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ReplenishmentTemplateCategoryUpdateMutationVariables = Exact<{
  input: ReplenishmentTemplateCategoryUpdateInput;
}>;


export type ReplenishmentTemplateCategoryUpdateMutation = { __typename?: 'Mutation', replenishmentTemplateCategoryUpdate: { __typename?: 'ReplenishmentTemplateCategory', replenishmentTemplateCategoryID: any } };

export type ReplenishmentTemplateItemCreateMutationVariables = Exact<{
  replenishmentTemplateID: Scalars['UUID']['input'];
  input: ReplenishmentTemplateItemCreateInput;
}>;


export type ReplenishmentTemplateItemCreateMutation = { __typename?: 'Mutation', replenishmentTemplateItemCreate: { __typename?: 'ReplenishmentTemplateItem', replenishmentTemplateItemID: any } };

export type ReplenishmentTemplateItemDeleteMutationVariables = Exact<{
  replenishmentTemplateItemID: Scalars['UUID']['input'];
}>;


export type ReplenishmentTemplateItemDeleteMutation = { __typename?: 'Mutation', replenishmentTemplateItemDelete: boolean };

export type ReplenishmentTemplateItemImportMutationVariables = Exact<{
  input: ReplenishmentTemplateItemImportInput;
}>;


export type ReplenishmentTemplateItemImportMutation = { __typename?: 'Mutation', replenishmentTemplateItemImport: { __typename?: 'ReplenishmentTemplateItemImportResult', importedCount: number, skippedCount: number } };

export type ReplenishmentTemplateItemImportValidateMutationVariables = Exact<{
  input: ReplenishmentTemplateItemImportValidateInput;
}>;


export type ReplenishmentTemplateItemImportValidateMutation = { __typename?: 'Mutation', replenishmentTemplateItemImportValidate: { __typename?: 'ReplenishmentTemplateItemImportValidateResult', missingProductCodes: Array<string>, rowReport: { __typename?: 'ReplenishmentTemplateItemImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'ReplenishmentTemplateItemImportRowViolation', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> } } };

export type ReplenishmentTemplateItemListQueryVariables = Exact<{
  qop?: InputMaybe<ReplenishmentTemplateItemQopInput>;
}>;


export type ReplenishmentTemplateItemListQuery = { __typename?: 'Query', replenishmentTemplateItems: { __typename?: 'ReplenishmentTemplateItemPaged', items?: Array<{ __typename?: 'ReplenishmentTemplateItem', replenishmentTemplateItemID: any, replenishmentTemplateID: any, productID: any, productCode: string, productName: string, isActive: boolean, minStock: number, orderMultiplier: number, leadtimeDays: number, safetyDays: number, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string } | null } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ReplenishmentTemplateItemLoadQueryVariables = Exact<{
  replenishmentTemplateItemID: Scalars['UUID']['input'];
}>;


export type ReplenishmentTemplateItemLoadQuery = { __typename?: 'Query', replenishmentTemplateItem: { __typename?: 'ReplenishmentTemplateItem', replenishmentTemplateItemID: any, replenishmentTemplateID: any, productID: any, productCode: string, productName: string, minStock: number, orderMultiplier: number, leadtimeDays: number, safetyDays: number } };

export type ReplenishmentTemplateItemUpdateMutationVariables = Exact<{
  input: ReplenishmentTemplateItemUpdateInput;
}>;


export type ReplenishmentTemplateItemUpdateMutation = { __typename?: 'Mutation', replenishmentTemplateItemUpdate: { __typename?: 'ReplenishmentTemplateItem', replenishmentTemplateItemID: any } };

export type ReplenishmentTemplateAutocompleteQueryVariables = Exact<{
  qop: ReplenishmentTemplateQopInput;
}>;


export type ReplenishmentTemplateAutocompleteQuery = { __typename?: 'Query', replenishmentTemplates: { __typename?: 'ReplenishmentTemplatePaged', items?: Array<{ __typename?: 'ReplenishmentTemplate', replenishmentTemplateID: any, replenishmentTemplateName?: string | null, sourceDocumentType: string, sourceWarehouseID: any }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ReplenishmentTemplateCreateMutationVariables = Exact<{
  input: ReplenishmentTemplateCreateInput;
}>;


export type ReplenishmentTemplateCreateMutation = { __typename?: 'Mutation', replenishmentTemplateCreate: { __typename?: 'ReplenishmentTemplate', replenishmentTemplateID: any } };

export type ReplenishmentTemplateDeleteMutationVariables = Exact<{
  replenishmentTemplateID: Scalars['UUID']['input'];
}>;


export type ReplenishmentTemplateDeleteMutation = { __typename?: 'Mutation', replenishmentTemplateDelete: boolean };

export type ReplenishmentTemplateListQueryVariables = Exact<{
  qop?: InputMaybe<ReplenishmentTemplateQopInput>;
}>;


export type ReplenishmentTemplateListQuery = { __typename?: 'Query', replenishmentTemplates: { __typename?: 'ReplenishmentTemplatePaged', items?: Array<{ __typename?: 'ReplenishmentTemplate', replenishmentTemplateID: any, replenishmentTemplateName?: string | null, description: string, replenishmentTemplateCategoryID: any, sourceDocumentType: string, sourceWarehouseID: any, sourceWarehouseCode: string, sourceWarehouseName: string, defaultLeadtimeDays: number, defaultSafetyDays: number, isActive: boolean, replenishmentTemplateCategory?: { __typename?: 'ReplenishmentTemplateCategory', replenishmentTemplateCategoryID: any, replenishmentTemplateCategoryName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ReplenishmentTemplateLoadQueryVariables = Exact<{
  replenishmentTemplateID: Scalars['UUID']['input'];
}>;


export type ReplenishmentTemplateLoadQuery = { __typename?: 'Query', replenishmentTemplate: { __typename?: 'ReplenishmentTemplate', replenishmentTemplateID: any, replenishmentTemplateName?: string | null, description: string, replenishmentTemplateCategoryID: any, sourceDocumentType: string, sourceWarehouseID: any, sourceWarehouseCode: string, sourceWarehouseName: string, defaultLeadtimeDays: number, defaultSafetyDays: number, isActive: boolean, replenishmentTemplateCategory?: { __typename?: 'ReplenishmentTemplateCategory', replenishmentTemplateCategoryID: any, replenishmentTemplateCategoryName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type ReplenishmentTemplateUpdateMutationVariables = Exact<{
  input: ReplenishmentTemplateUpdateInput;
}>;


export type ReplenishmentTemplateUpdateMutation = { __typename?: 'Mutation', replenishmentTemplateUpdate: { __typename?: 'ReplenishmentTemplate', replenishmentTemplateID: any } };

export type ReplenishmentAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<ReplenishmentQopInput>;
}>;


export type ReplenishmentAutocompleteQuery = { __typename?: 'Query', replenishments: { __typename?: 'ReplenishmentPaged', items?: Array<{ __typename?: 'Replenishment', replenishmentID: any, replenishmentNumber: string, replenishmentDate: any, status: string, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ReplenishmentCreateMutationVariables = Exact<{
  input: ReplenishmentCreateInput;
}>;


export type ReplenishmentCreateMutation = { __typename?: 'Mutation', replenishmentCreate: { __typename?: 'Replenishment', replenishmentID: any, replenishmentNumber: string, status: string, replenishmentDate: any, warehouseID: any, replenishmentTemplateID: any, avgUsageDays: number } };

export type ReplenishmentItemListQueryVariables = Exact<{
  qop?: InputMaybe<ReplenishmentItemQopInput>;
}>;


export type ReplenishmentItemListQuery = { __typename?: 'Query', replenishmentItems: { __typename?: 'ReplenishmentItemPaged', items?: Array<{ __typename?: 'ReplenishmentItem', replenishmentItemID: any, replenishmentID: any, productID: any, minStock: any, avgUsage: any, leadTime: number, safetyDays: number, mpkmFromAvgUsage: any, mpkm: any, pkm: any, orderMultiplier: any, qtyOnHand: any, qtyIncoming: any, qtyCommitted: any, qtyAvailable: any, reorderQty: any, uniqueKey: string, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productDepartmentID: any, productDepartmentName: string, productSubDepartmentName: string, productSubDepartmentID: any } | null } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ReplenishmentListQueryVariables = Exact<{
  qop?: InputMaybe<ReplenishmentQopInput>;
}>;


export type ReplenishmentListQuery = { __typename?: 'Query', replenishments: { __typename?: 'ReplenishmentPaged', items?: Array<{ __typename?: 'Replenishment', replenishmentID: any, replenishmentNumber: string, replenishmentDate: any, branchID: any, warehouseID: any, sourceWarehouseID: any, replenishmentTemplateID: any, avgUsageDays: number, reorderItemCount: number, status: string, noteInternal: string, uniqueKey: string, branch: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string }, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string }, replenishmentTemplate?: { __typename?: 'ReplenishmentTemplate', replenishmentTemplateID: any, replenishmentTemplateName?: string | null } | null, sourceWarehouse: { __typename?: 'Warehouse', warehouseName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type ReplenishmentLoadQueryVariables = Exact<{
  replenishmentID: Scalars['UUID']['input'];
}>;


export type ReplenishmentLoadQuery = { __typename?: 'Query', replenishment: { __typename?: 'Replenishment', replenishmentID: any, replenishmentNumber: string, replenishmentDate: any, branchID: any, warehouseID: any, replenishmentTemplateID: any, avgUsageDays: number, status: string, noteInternal: string, uniqueKey: string, branch: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string }, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string }, replenishmentTemplate?: { __typename?: 'ReplenishmentTemplate', replenishmentTemplateID: any, replenishmentTemplateName?: string | null, description: string, sourceDocumentType: string, sourceWarehouseID: any, sourceWarehouseCode: string, sourceWarehouseName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, createdAt: any } } };

export type RevenueReportAccessLogExportMutationVariables = Exact<{
  input: RevenueReportAccessLogExportInput;
}>;


export type RevenueReportAccessLogExportMutation = { __typename?: 'Mutation', revenueReportAccessLogExport: { __typename?: 'RevenueReportAccessLogExport', downloadUrl: string, fileName: string } };

export type RevenueReportAccessLogSummaryQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportAccessLogQopInput>;
}>;


export type RevenueReportAccessLogSummaryQuery = { __typename?: 'Query', revenueReportAccessLogSummary: { __typename?: 'RevenueReportAccessLogSummary', requestCount: number, successCount: number, rejectedCount: number, rowsServed: number, distinctIpCount: number } };

export type RevenueReportAccessLogsQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportAccessLogQopInput>;
}>;


export type RevenueReportAccessLogsQuery = { __typename?: 'Query', revenueReportAccessLogs: { __typename?: 'RevenueReportAccessLogPaged', items?: Array<{ __typename?: 'RevenueReportAccessLog', revenueReportAccessLogID: any, revenueReportUserID?: any | null, partnerName: string, clientName: string, keyPrefix: string, accessedDatetime: any, startDate: string, endDate: string, page: number, pageSize: number, rowCount: number, httpStatus: number, resultClass: string, reason: string, sourceIp: string, durationMs: number }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type RevenueReportPartnerBranchQueryVariables = Exact<{
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
}>;


export type RevenueReportPartnerBranchQuery = { __typename?: 'Query', revenueReportPartnerBranch?: { __typename?: 'RevenueReportPartnerBranch', revenueReportPartnerBranchID: any, revenueReportPartnerID: any, partnerName: string, deliveryMode: string, authType: string, revenueReportTemplateID: any, templateName: string, branchID: any, branchCode: string, branchName: string, npwpd: string, status: string, credentialState: string, credentialSource: string, apiKeyPrefix: string, credentialUpdatedAt?: any | null, noteInternal: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null, updatedAt: any, updatedByUserName?: string | null } } | null };

export type RevenueReportPartnerBranchActivateMutationVariables = Exact<{
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
}>;


export type RevenueReportPartnerBranchActivateMutation = { __typename?: 'Mutation', revenueReportPartnerBranchActivate: { __typename?: 'RevenueReportPartnerBranch', revenueReportPartnerBranchID: any, status: string } };

export type RevenueReportPartnerBranchCreateMutationVariables = Exact<{
  input: RevenueReportPartnerBranchCreateInput;
}>;


export type RevenueReportPartnerBranchCreateMutation = { __typename?: 'Mutation', revenueReportPartnerBranchCreate: { __typename?: 'RevenueReportPartnerBranch', revenueReportPartnerBranchID: any } };

export type RevenueReportPartnerBranchCredentialClearMutationVariables = Exact<{
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
}>;


export type RevenueReportPartnerBranchCredentialClearMutation = { __typename?: 'Mutation', revenueReportPartnerBranchCredentialClear: { __typename?: 'RevenueReportPartnerBranch', revenueReportPartnerBranchID: any } };

export type RevenueReportPartnerBranchCredentialSetMutationVariables = Exact<{
  input: RevenueReportPartnerBranchCredentialSetInput;
}>;


export type RevenueReportPartnerBranchCredentialSetMutation = { __typename?: 'Mutation', revenueReportPartnerBranchCredentialSet: { __typename?: 'RevenueReportPartnerBranch', revenueReportPartnerBranchID: any } };

export type RevenueReportPartnerBranchDeactivateMutationVariables = Exact<{
  revenueReportPartnerBranchID: Scalars['UUID']['input'];
}>;


export type RevenueReportPartnerBranchDeactivateMutation = { __typename?: 'Mutation', revenueReportPartnerBranchDeactivate: { __typename?: 'RevenueReportPartnerBranch', revenueReportPartnerBranchID: any, status: string } };

export type RevenueReportPartnerBranchUpdateMutationVariables = Exact<{
  input: RevenueReportPartnerBranchUpdateInput;
}>;


export type RevenueReportPartnerBranchUpdateMutation = { __typename?: 'Mutation', revenueReportPartnerBranchUpdate: { __typename?: 'RevenueReportPartnerBranch', revenueReportPartnerBranchID: any } };

export type RevenueReportPartnerBranchesQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportPartnerBranchQopInput>;
}>;


export type RevenueReportPartnerBranchesQuery = { __typename?: 'Query', revenueReportPartnerBranches: { __typename?: 'RevenueReportPartnerBranchPaged', items?: Array<{ __typename?: 'RevenueReportPartnerBranch', revenueReportPartnerBranchID: any, revenueReportPartnerID: any, partnerName: string, deliveryMode: string, branchID: any, branchCode: string, branchName: string, npwpd: string, status: string, credentialState: string, noteInternal: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type RevenueReportPartnerQueryVariables = Exact<{
  revenueReportPartnerID: Scalars['UUID']['input'];
}>;


export type RevenueReportPartnerQuery = { __typename?: 'Query', revenueReportPartner?: { __typename?: 'RevenueReportPartner', revenueReportPartnerID: any, revenueReportPartnerType: string, partnerName: string, deliveryMode: string, endpointURL: string, authType: string, apiKeyPrefix: string, hasApiSecret: boolean, credentialUpdatedAt?: any | null, credentialState: string, revenueReportTemplateID: any, templateName: string, isNpwpdRequired: boolean, isActive: boolean, noteInternal: string, branchCount: number, apiClientCount: number, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null, updatedAt: any, updatedByUserName?: string | null } } | null };

export type RevenueReportPartnerActivateMutationVariables = Exact<{
  revenueReportPartnerID: Scalars['UUID']['input'];
}>;


export type RevenueReportPartnerActivateMutation = { __typename?: 'Mutation', revenueReportPartnerActivate: { __typename?: 'RevenueReportPartner', revenueReportPartnerID: any, isActive: boolean } };

export type RevenueReportPartnerAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportPartnerQopInput>;
}>;


export type RevenueReportPartnerAutocompleteQuery = { __typename?: 'Query', revenueReportPartners: { __typename?: 'RevenueReportPartnerPaged', items?: Array<{ __typename?: 'RevenueReportPartner', revenueReportPartnerID: any, partnerName: string, isNpwpdRequired: boolean }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type RevenueReportPartnerCreateMutationVariables = Exact<{
  input: RevenueReportPartnerCreateInput;
}>;


export type RevenueReportPartnerCreateMutation = { __typename?: 'Mutation', revenueReportPartnerCreate: { __typename?: 'RevenueReportPartner', revenueReportPartnerID: any } };

export type RevenueReportPartnerCredentialSetMutationVariables = Exact<{
  input: RevenueReportPartnerCredentialSetInput;
}>;


export type RevenueReportPartnerCredentialSetMutation = { __typename?: 'Mutation', revenueReportPartnerCredentialSet: { __typename?: 'RevenueReportPartner', revenueReportPartnerID: any } };

export type RevenueReportPartnerDeactivateMutationVariables = Exact<{
  revenueReportPartnerID: Scalars['UUID']['input'];
}>;


export type RevenueReportPartnerDeactivateMutation = { __typename?: 'Mutation', revenueReportPartnerDeactivate: { __typename?: 'RevenueReportPartner', revenueReportPartnerID: any, isActive: boolean } };

export type RevenueReportPartnerEndpointUpdateMutationVariables = Exact<{
  input: RevenueReportPartnerEndpointUpdateInput;
}>;


export type RevenueReportPartnerEndpointUpdateMutation = { __typename?: 'Mutation', revenueReportPartnerEndpointUpdate: { __typename?: 'RevenueReportPartner', revenueReportPartnerID: any } };

export type RevenueReportPartnerUpdateMutationVariables = Exact<{
  input: RevenueReportPartnerUpdateInput;
}>;


export type RevenueReportPartnerUpdateMutation = { __typename?: 'Mutation', revenueReportPartnerUpdate: { __typename?: 'RevenueReportPartner', revenueReportPartnerID: any } };

export type RevenueReportPartnersQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportPartnerQopInput>;
}>;


export type RevenueReportPartnersQuery = { __typename?: 'Query', revenueReportPartners: { __typename?: 'RevenueReportPartnerPaged', items?: Array<{ __typename?: 'RevenueReportPartner', revenueReportPartnerID: any, partnerName: string, deliveryMode: string, endpointURL: string, authType: string, revenueReportTemplateID: any, templateName: string, credentialState: string, isNpwpdRequired: boolean, isActive: boolean, noteInternal: string, branchCount: number, apiClientCount: number }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type RevenueReportTemplateQueryVariables = Exact<{
  revenueReportTemplateID: Scalars['UUID']['input'];
}>;


export type RevenueReportTemplateQuery = { __typename?: 'Query', revenueReportTemplate?: { __typename?: 'RevenueReportTemplate', revenueReportTemplateID: any, revenueReportTemplateType: string, templateName: string, fieldMap: string, envelope: string, resultKey: string, wrapperMap?: string | null, isActive: boolean, noteInternal: string, partnerNames: Array<string>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null, updatedAt: any, updatedByUserName?: string | null } } | null };

export type RevenueReportTemplateActivateMutationVariables = Exact<{
  revenueReportTemplateID: Scalars['UUID']['input'];
}>;


export type RevenueReportTemplateActivateMutation = { __typename?: 'Mutation', revenueReportTemplateActivate: { __typename?: 'RevenueReportTemplate', revenueReportTemplateID: any, isActive: boolean } };

export type RevenueReportTemplateAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportTemplateQopInput>;
}>;


export type RevenueReportTemplateAutocompleteQuery = { __typename?: 'Query', revenueReportTemplates: { __typename?: 'RevenueReportTemplatePaged', items?: Array<{ __typename?: 'RevenueReportTemplate', revenueReportTemplateID: any, templateName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type RevenueReportTemplateCreateMutationVariables = Exact<{
  input: RevenueReportTemplateCreateInput;
}>;


export type RevenueReportTemplateCreateMutation = { __typename?: 'Mutation', revenueReportTemplateCreate: { __typename?: 'RevenueReportTemplate', revenueReportTemplateID: any } };

export type RevenueReportTemplateDeactivateMutationVariables = Exact<{
  revenueReportTemplateID: Scalars['UUID']['input'];
}>;


export type RevenueReportTemplateDeactivateMutation = { __typename?: 'Mutation', revenueReportTemplateDeactivate: { __typename?: 'RevenueReportTemplate', revenueReportTemplateID: any, isActive: boolean } };

export type RevenueReportTemplateDuplicateMutationVariables = Exact<{
  revenueReportTemplateID: Scalars['UUID']['input'];
}>;


export type RevenueReportTemplateDuplicateMutation = { __typename?: 'Mutation', revenueReportTemplateDuplicate: { __typename?: 'RevenueReportTemplate', revenueReportTemplateID: any, isActive: boolean } };

export type RevenueReportTemplateFieldMapUpdateMutationVariables = Exact<{
  input: RevenueReportTemplateFieldMapUpdateInput;
}>;


export type RevenueReportTemplateFieldMapUpdateMutation = { __typename?: 'Mutation', revenueReportTemplateFieldMapUpdate: { __typename?: 'RevenueReportTemplate', revenueReportTemplateID: any } };

export type RevenueReportTemplatePreviewQueryVariables = Exact<{
  revenueReportTemplateID: Scalars['UUID']['input'];
  deliveryMode: Scalars['String']['input'];
}>;


export type RevenueReportTemplatePreviewQuery = { __typename?: 'Query', revenueReportTemplatePreview: string };

export type RevenueReportTemplateUpdateMutationVariables = Exact<{
  input: RevenueReportTemplateUpdateInput;
}>;


export type RevenueReportTemplateUpdateMutation = { __typename?: 'Mutation', revenueReportTemplateUpdate: { __typename?: 'RevenueReportTemplate', revenueReportTemplateID: any } };

export type RevenueReportTemplatesQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportTemplateQopInput>;
}>;


export type RevenueReportTemplatesQuery = { __typename?: 'Query', revenueReportTemplates: { __typename?: 'RevenueReportTemplatePaged', items?: Array<{ __typename?: 'RevenueReportTemplate', revenueReportTemplateID: any, revenueReportTemplateType: string, templateName: string, fieldMap: string, envelope: string, resultKey: string, wrapperMap?: string | null, isActive: boolean, noteInternal: string, partnerNames: Array<string> }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type RevenueReportApiKeyIssueMutationVariables = Exact<{
  input: RevenueReportApiKeyIssueInput;
}>;


export type RevenueReportApiKeyIssueMutation = { __typename?: 'Mutation', revenueReportApiKeyIssue: { __typename?: 'RevenueReportApiKeyIssued', revenueReportApiKeyID: any, keyPrefix: string, plaintextApiKey: string, expiresAt?: any | null } };

export type RevenueReportApiKeyRevokeMutationVariables = Exact<{
  revenueReportApiKeyID: Scalars['UUID']['input'];
}>;


export type RevenueReportApiKeyRevokeMutation = { __typename?: 'Mutation', revenueReportApiKeyRevoke: { __typename?: 'RevenueReportApiKey', revenueReportApiKeyID: any, status: string } };

export type RevenueReportApiKeysQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportApiKeyQopInput>;
}>;


export type RevenueReportApiKeysQuery = { __typename?: 'Query', revenueReportApiKeys: { __typename?: 'RevenueReportApiKeyPaged', items?: Array<{ __typename?: 'RevenueReportApiKey', revenueReportApiKeyID: any, keyPrefix: string, status: string, expiresAt?: any | null, lastUsedAt?: any | null, lastUsedIp: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any } }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type RevenueReportUserAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportUserQopInput>;
}>;


export type RevenueReportUserAutocompleteQuery = { __typename?: 'Query', revenueReportUsers: { __typename?: 'RevenueReportUserPaged', items?: Array<{ __typename?: 'RevenueReportUser', revenueReportUserID: any, fullName: string, partnerName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type RevenueReportUserCreateMutationVariables = Exact<{
  input: RevenueReportUserCreateInput;
}>;


export type RevenueReportUserCreateMutation = { __typename?: 'Mutation', revenueReportUserCreate: { __typename?: 'RevenueReportUser', revenueReportUserID: any } };

export type RevenueReportUsersQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportUserQopInput>;
}>;


export type RevenueReportUsersQuery = { __typename?: 'Query', revenueReportUsers: { __typename?: 'RevenueReportUserPaged', items?: Array<{ __typename?: 'RevenueReportUser', revenueReportUserID: any, fullName: string, email: string, isActive: boolean, activeApiKeyCount: number, lastUsedAt?: any | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type RevenueReportQueryVariables = Exact<{
  revenueReportID: Scalars['UUID']['input'];
}>;


export type RevenueReportQuery = { __typename?: 'Query', revenueReport?: { __typename?: 'RevenueReport', revenueReportID: any, type: string, transactionDate: string, revenueReportPartnerID: any, partnerName: string, branchID: any, branchCode: string, branchName: string, deliveryMode: string, itemCount: number, totalAmount: number, taxAmount: number, uploadedDatetime?: any | null, uploadAttemptCount: number, lastUploadError: string, uploadStatus: string, lastPulledAt?: any | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any } } | null };

export type RevenueReportDetailCorrectMutationVariables = Exact<{
  input: RevenueReportDetailCorrectInput;
}>;


export type RevenueReportDetailCorrectMutation = { __typename?: 'Mutation', revenueReportDetailCorrect: { __typename?: 'RevenueReportDetail', revenueReportDetailID: any, status: string } };

export type RevenueReportDetailExportMutationVariables = Exact<{
  input: RevenueReportDetailExportInput;
}>;


export type RevenueReportDetailExportMutation = { __typename?: 'Mutation', revenueReportDetailExport: { __typename?: 'RevenueReportDetailExport', downloadUrl: string, fileName: string } };

export type RevenueReportDetailVoidMutationVariables = Exact<{
  input: RevenueReportDetailVoidInput;
}>;


export type RevenueReportDetailVoidMutation = { __typename?: 'Mutation', revenueReportDetailVoid: { __typename?: 'RevenueReportDetail', revenueReportDetailID: any, status: string } };

export type RevenueReportDetailsQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportDetailQopInput>;
}>;


export type RevenueReportDetailsQuery = { __typename?: 'Query', revenueReportDetails: { __typename?: 'RevenueReportDetailPaged', items?: Array<{ __typename?: 'RevenueReportDetail', revenueReportDetailID: any, salesInvoiceID: any, salesInvoiceNumber: string, barcode: string, productCode: string, productName: string, isConsignment: boolean, transactionDatetimeUtc: any, totalAmount: number, taxAmount: number, status: string, correctionType: string, originalTotalAmount?: number | null, originalTaxAmount?: number | null, correctionReason: string, correctedUserName: string, correctedDatetime?: any | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type RevenueReportExportMutationVariables = Exact<{
  input: RevenueReportExportInput;
}>;


export type RevenueReportExportMutation = { __typename?: 'Mutation', revenueReportExport: { __typename?: 'RevenueReportExport', downloadUrl: string, fileName: string } };

export type RevenueReportGenerateMutationVariables = Exact<{
  input: RevenueReportGenerateInput;
}>;


export type RevenueReportGenerateMutation = { __typename?: 'Mutation', revenueReportGenerate: Array<{ __typename?: 'RevenueReport', revenueReportID: any }> };

export type RevenueReportResendMutationVariables = Exact<{
  revenueReportID: Scalars['UUID']['input'];
}>;


export type RevenueReportResendMutation = { __typename?: 'Mutation', revenueReportResend: { __typename?: 'RevenueReport', revenueReportID: any, uploadStatus: string, lastUploadError: string } };

export type RevenueReportResyncMutationVariables = Exact<{
  input: RevenueReportResyncInput;
}>;


export type RevenueReportResyncMutation = { __typename?: 'Mutation', revenueReportResync: { __typename?: 'RevenueReport', revenueReportID: any, uploadStatus: string } };

export type RevenueReportUploadBatchesQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportUploadBatchQopInput>;
}>;


export type RevenueReportUploadBatchesQuery = { __typename?: 'Query', revenueReportUploadBatches: { __typename?: 'RevenueReportUploadBatchPaged', items?: Array<{ __typename?: 'RevenueReportUploadBatch', revenueReportUploadBatchID: any, status: string, httpStatus: number, sentCount: number, successCount: number, errorCount: number, errorSummary: string, responseBody: string, requestPayload: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null } }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type RevenueReportsQueryVariables = Exact<{
  qop?: InputMaybe<RevenueReportQopInput>;
}>;


export type RevenueReportsQuery = { __typename?: 'Query', revenueReports: { __typename?: 'RevenueReportPaged', items?: Array<{ __typename?: 'RevenueReport', revenueReportID: any, type: string, transactionDate: string, partnerName: string, branchCode: string, branchName: string, deliveryMode: string, itemCount: number, totalAmount: number, taxAmount: number, uploadStatus: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } }, revenueReportSummary: { __typename?: 'RevenueReportSummary', revenueReportCount: number, itemCount: number, totalAmount: number, taxAmount: number } };

export type RevenueSharingCorrectItemMutationVariables = Exact<{
  input: RevenueSharingCorrectItemInput;
}>;


export type RevenueSharingCorrectItemMutation = { __typename?: 'Mutation', revenueSharingCorrectItem: boolean };

export type RevenueSharingDetailLippoLiveQueryVariables = Exact<{
  revenueSharingDetailID: Scalars['UUID']['input'];
}>;


export type RevenueSharingDetailLippoLiveQuery = { __typename?: 'Query', revenueSharingDetailLippoLive: Array<{ __typename?: 'RevenueSharingLippoLiveRow', transactionNumber: string, transactionDate: string, amount: number }> };

export type RevenueSharingDetailLoadQueryVariables = Exact<{
  revenueSharingDetailID: Scalars['UUID']['input'];
}>;


export type RevenueSharingDetailLoadQuery = { __typename?: 'Query', revenueSharingDetail?: { __typename?: 'RevenueSharingDetail', revenueSharingDetailID: any, revenueSharingID: any, salesInvoiceID: any, salesInvoiceNumber: string, transactionDatetime: any, transactionDatetimeUtc: any, netAmount: number, voucherAmount: number, deductionAmount: number, uploadAmountDpp: number, status: string, sourceStatus: string, uploaded: boolean, externalTransactionID?: any | null, noteInternal: string } | null };

export type RevenueSharingExportMutationVariables = Exact<{
  input: RevenueSharingExportInput;
}>;


export type RevenueSharingExportMutation = { __typename?: 'Mutation', revenueSharingExport: { __typename?: 'RevenueSharingExport', downloadUrl: string, fileName: string } };

export type RevenueSharingGenerateMutationVariables = Exact<{
  input: RevenueSharingGenerateInput;
}>;


export type RevenueSharingGenerateMutation = { __typename?: 'Mutation', revenueSharingGenerate: boolean };

export type RevenueSharingItemsQueryVariables = Exact<{
  qop?: InputMaybe<RevenueSharingDetailQopInput>;
}>;


export type RevenueSharingItemsQuery = { __typename?: 'Query', revenueSharingDetails: { __typename?: 'RevenueSharingDetailPaged', items?: Array<{ __typename?: 'RevenueSharingDetail', revenueSharingDetailID: any, revenueSharingID: any, salesInvoiceID: any, salesInvoiceNumber: string, transactionDatetime: any, netAmount: number, voucherAmount: number, deductionAmount: number, uploadAmountDpp: number, status: string, sourceStatus: string, uploaded: boolean, externalTransactionID?: any | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type RevenueSharingListQueryVariables = Exact<{
  qop?: InputMaybe<RevenueSharingQopInput>;
}>;


export type RevenueSharingListQuery = { __typename?: 'Query', revenueSharings: { __typename?: 'RevenueSharingPaged', items?: Array<{ __typename?: 'RevenueSharing', revenueSharingID: any, transactionDate: any, branchID: any, branchCode: string, branchName: string, gmt: number, providerCode: string, totalActiveCount: number, totalCancelledCount: number, totalNetAmount: number, totalVoucherAmount: number, totalDeductionAmount: number, totalAmountDpp: number, uploaded: boolean, uploadedDatetime?: any | null, uploadAttemptCount: number, lastUploadError: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type RevenueSharingLoadQueryVariables = Exact<{
  revenueSharingID: Scalars['UUID']['input'];
}>;


export type RevenueSharingLoadQuery = { __typename?: 'Query', revenueSharing?: { __typename?: 'RevenueSharing', revenueSharingID: any, transactionDate: any, branchID: any, branchCode: string, branchName: string, gmt: number, providerCode: string, uploaded: boolean, uploadedDatetime?: any | null, uploadedDatetimeUtc?: any | null, uploadAttemptCount: number, lastUploadError: string, lastUploadResponse: string, lastUploadPayload: string, revenueBatchId?: number | null, noteInternal: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, createdByUserName?: string | null, updatedAt: any, updatedByUserName?: string | null } } | null };

export type RevenueSharingReuploadDatesMutationVariables = Exact<{
  revenueSharingID: Scalars['UUID']['input'];
}>;


export type RevenueSharingReuploadDatesMutation = { __typename?: 'Mutation', revenueSharingReuploadDates: { __typename?: 'RevenueSharingReuploadResult', fixed: number, alreadyCorrect: number, needManual: number } };

export type RevenueSharingUploadMutationVariables = Exact<{
  revenueSharingID: Scalars['UUID']['input'];
}>;


export type RevenueSharingUploadMutation = { __typename?: 'Mutation', revenueSharingUpload: boolean };

export type RevenueSharingUploadAllMutationVariables = Exact<{ [key: string]: never; }>;


export type RevenueSharingUploadAllMutation = { __typename?: 'Mutation', revenueSharingUploadAll: boolean };

export type RevenueSharingUploadBatchesQueryVariables = Exact<{
  revenueSharingID: Scalars['UUID']['input'];
}>;


export type RevenueSharingUploadBatchesQuery = { __typename?: 'Query', revenueSharingUploadBatches: Array<{ __typename?: 'RevenueSharingUploadBatch', revenueSharingUploadBatchID: any, chunkIndex: number, sentCount: number, successCount: number, duplicateCount: number, errorCount: number, status: string, httpStatus: number, lippoCode: number, lippoMessage: string, revenueBatchID?: any | null, requestPayload: string, responseBody: string, errorSummary: string, uploadedDatetime?: any | null }> };

export type RevenueSharingVoidItemMutationVariables = Exact<{
  revenueSharingDetailID: Scalars['UUID']['input'];
}>;


export type RevenueSharingVoidItemMutation = { __typename?: 'Mutation', revenueSharingVoidItem: boolean };

export type SalesChannelCampaignQueryVariables = Exact<{
  salesChannelCampaignID: Scalars['UUID']['input'];
}>;


export type SalesChannelCampaignQuery = { __typename?: 'Query', salesChannelCampaign: { __typename?: 'SalesChannelCampaign', salesChannelCampaignID: any, parentSalesChannelCampaignID?: any | null, salesChannelCategoryGroupID?: any | null, salesChannelCategoryGroupName?: string | null, salesChannelCampaignName: string, customTag: string, status: string, isAllBranches: boolean, eaterType: string, scopeType: string, discountType: string, discountValue?: number | null, discountCap?: number | null, minBasketAmount?: number | null, quotaTotal?: any | null, quotaPerUser?: any | null, objectIDs?: string | null, workingHours?: string | null, startAt: any, endAt: any, errorMessage: string, categories: Array<{ __typename?: 'SalesChannelCampaignCategory', salesChannelCategoryID: any, salesChannelCategoryName: string }> } };

export type SalesChannelCampaignCancelMutationVariables = Exact<{
  salesChannelCampaignID: Scalars['UUID']['input'];
}>;


export type SalesChannelCampaignCancelMutation = { __typename?: 'Mutation', salesChannelCampaignCancel: { __typename?: 'SalesChannelCampaign', salesChannelCampaignID: any, status: string } };

export type SalesChannelCampaignChildrenQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelCampaignQopInput>;
}>;


export type SalesChannelCampaignChildrenQuery = { __typename?: 'Query', salesChannelCampaigns: { __typename?: 'SalesChannelCampaignPaged', items?: Array<{ __typename?: 'SalesChannelCampaign', salesChannelCampaignID: any, parentSalesChannelCampaignID?: any | null, salesChannelID?: string | null, status: string, branchID?: any | null, branchCode: string, branchName: string, externalCampaignID: string, errorMessage: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', updatedAt: any } }> | null } };

export type SalesChannelCampaignCreateMutationVariables = Exact<{
  input: SalesChannelCampaignCreateInput;
}>;


export type SalesChannelCampaignCreateMutation = { __typename?: 'Mutation', salesChannelCampaignCreate: { __typename?: 'SalesChannelCampaign', salesChannelCampaignID: any } };

export type SalesChannelCampaignDeleteMutationVariables = Exact<{
  salesChannelCampaignID: Scalars['UUID']['input'];
}>;


export type SalesChannelCampaignDeleteMutation = { __typename?: 'Mutation', salesChannelCampaignDelete: boolean };

export type SalesChannelCampaignProductsQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelCampaignProductQopInput>;
}>;


export type SalesChannelCampaignProductsQuery = { __typename?: 'Query', salesChannelCampaignProducts: { __typename?: 'SalesChannelCampaignProductPaged', items?: Array<{ __typename?: 'SalesChannelCampaignProduct', salesChannelCampaignProductID: any, salesChannelCampaignID: any, productID: any, productCode: string, productName: string, barcode: string, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, isConsignment: boolean } | null }> | null } };

export type SalesChannelCampaignPublishToStoresMutationVariables = Exact<{
  input: SalesChannelCampaignPublishToStoresInput;
}>;


export type SalesChannelCampaignPublishToStoresMutation = { __typename?: 'Mutation', salesChannelCampaignPublishToStores: Array<{ __typename?: 'SalesChannelCampaignPublishStoreResult', branchID: any, salesChannelID: string, published: boolean, note: string, skippedProductIDs: Array<any>, skippedProductCodes: Array<string>, child?: { __typename?: 'SalesChannelCampaign', salesChannelCampaignID: any, status: string, branchName: string } | null }> };

export type SalesChannelCampaignResultsQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelCampaignResultQopInput>;
}>;


export type SalesChannelCampaignResultsQuery = { __typename?: 'Query', salesChannelCampaignResults: { __typename?: 'SalesChannelCampaignResultPaged', items?: Array<{ __typename?: 'SalesChannelCampaignResult', salesChannelCampaignResultID: any, salesChannelCampaignID: any, branchID: any, salesChannelID: string, externalCampaignID: string, status: string, errorMessage: string, branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', updatedAt: any } }> | null } };

export type SalesChannelCampaignSetCategoriesMutationVariables = Exact<{
  input: SalesChannelCampaignSetCategoriesInput;
}>;


export type SalesChannelCampaignSetCategoriesMutation = { __typename?: 'Mutation', salesChannelCampaignSetCategories: Array<{ __typename?: 'SalesChannelCampaignCategory', salesChannelCampaignCategoryID: any, salesChannelCampaignID: any, salesChannelCategoryID: any, salesChannelCategoryName: string }> };

export type SalesChannelCampaignSetProductsMutationVariables = Exact<{
  input: SalesChannelCampaignSetProductsInput;
}>;


export type SalesChannelCampaignSetProductsMutation = { __typename?: 'Mutation', salesChannelCampaignSetProducts: Array<{ __typename?: 'SalesChannelCampaignProduct', salesChannelCampaignProductID: any, salesChannelCampaignID: any, productID: any, productCode: string, productName: string }> };

export type SalesChannelCampaignStopMutationVariables = Exact<{
  salesChannelCampaignID: Scalars['UUID']['input'];
}>;


export type SalesChannelCampaignStopMutation = { __typename?: 'Mutation', salesChannelCampaignStop: { __typename?: 'SalesChannelCampaign', salesChannelCampaignID: any, status: string } };

export type SalesChannelCampaignUpdateMutationVariables = Exact<{
  input: SalesChannelCampaignUpdateInput;
}>;


export type SalesChannelCampaignUpdateMutation = { __typename?: 'Mutation', salesChannelCampaignUpdate: { __typename?: 'SalesChannelCampaign', salesChannelCampaignID: any } };

export type SalesChannelCampaignsQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelCampaignQopInput>;
}>;


export type SalesChannelCampaignsQuery = { __typename?: 'Query', salesChannelCampaigns: { __typename?: 'SalesChannelCampaignPaged', items?: Array<{ __typename?: 'SalesChannelCampaign', salesChannelCampaignID: any, salesChannelCategoryGroupID?: any | null, salesChannelCategoryGroupName?: string | null, salesChannelCampaignName: string, customTag: string, status: string, scopeType: string, discountType: string, discountValue?: number | null, discountCap?: number | null, startAt: any, endAt: any }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type BranchProductSalesChannelItemDisableMutationVariables = Exact<{
  input: BranchProductSalesChannelItemDisableInput;
}>;


export type BranchProductSalesChannelItemDisableMutation = { __typename?: 'Mutation', branchProductSalesChannelItemDisable: { __typename?: 'BranchProductSalesChannelItem', branchProductSalesChannelItemID: any } };

export type BranchProductSalesChannelItemRestoreMutationVariables = Exact<{
  input: BranchProductSalesChannelItemRestoreInput;
}>;


export type BranchProductSalesChannelItemRestoreMutation = { __typename?: 'Mutation', branchProductSalesChannelItemRestore: boolean };

export type BranchProductSalesChannelItemsQueryVariables = Exact<{
  qop?: InputMaybe<BranchProductSalesChannelItemQopInput>;
}>;


export type BranchProductSalesChannelItemsQuery = { __typename?: 'Query', branchProductSalesChannelItems: { __typename?: 'BranchProductSalesChannelItemPaged', items?: Array<{ __typename?: 'BranchProductSalesChannelItem', branchProductSalesChannelItemID: any, branchID: any, branchCode: string, productID: any, productCode: string, productName: string, salesChannelID: string, salesChannelCategoryGroupID?: any | null, type: string, note: string, product?: { __typename?: 'Product', barcode: string } | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type BranchSalesChannelCategoryGroupsQueryVariables = Exact<{
  qop?: InputMaybe<BranchSalesChannelCategoryGroupQopInput>;
}>;


export type BranchSalesChannelCategoryGroupsQuery = { __typename?: 'Query', branchSalesChannelCategoryGroups: { __typename?: 'BranchSalesChannelCategoryGroupPaged', items?: Array<{ __typename?: 'BranchSalesChannelCategoryGroup', branchSalesChannelCategoryGroupID: any, branchID: any, branchCode: string, branchName: string, salesChannelID: string, salesChannelCategoryGroupID: any, salesChannelCategoryGroupName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type MenuGroupProductAddonsQueryVariables = Exact<{
  productAddonGroupID: Scalars['UUID']['input'];
}>;


export type MenuGroupProductAddonsQuery = { __typename?: 'Query', productAddonGroupItemsByGroupID: Array<{ __typename?: 'ProductAddonGroupItem', productAddonGroupItemID: any, sequence: number, productAddon: { __typename?: 'ProductAddon', productAddonID: any, name: string, isRequired: boolean, isMultiple: boolean, minQty?: number | null, maxQty?: number | null, showQty: boolean, components?: Array<{ __typename?: 'ProductAddonComponent', productAddonComponentID: any, productName: string, customSellingPrice: number, priceType: string, sequence: number }> | null } }> };

export type SalesChannelCategoriesQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelCategoryQopInput>;
}>;


export type SalesChannelCategoriesQuery = { __typename?: 'Query', salesChannelCategories: { __typename?: 'SalesChannelCategoryPaged', items?: Array<{ __typename?: 'SalesChannelCategory', salesChannelCategoryID: any, salesChannelCategoryGroupID: any, salesChannelCategoryName: string, displayOrder: number, isActive: boolean, isInMenu: boolean }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type SalesChannelCategoryCreateMutationVariables = Exact<{
  input: SalesChannelCategoryCreateInput;
}>;


export type SalesChannelCategoryCreateMutation = { __typename?: 'Mutation', salesChannelCategoryCreate: { __typename?: 'SalesChannelCategory', salesChannelCategoryID: any } };

export type SalesChannelCategoryDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SalesChannelCategoryDeleteMutation = { __typename?: 'Mutation', salesChannelCategoryDelete: boolean };

export type SalesChannelCategoryGroupQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SalesChannelCategoryGroupQuery = { __typename?: 'Query', salesChannelCategoryGroup: { __typename?: 'SalesChannelCategoryGroup', salesChannelCategoryGroupID: any, salesChannelCategoryGroupName: string, isActive: boolean, isUseMasterdataAvailability: boolean } };

export type SalesChannelCategoryGroupCreateMutationVariables = Exact<{
  input: SalesChannelCategoryGroupCreateInput;
}>;


export type SalesChannelCategoryGroupCreateMutation = { __typename?: 'Mutation', salesChannelCategoryGroupCreate: { __typename?: 'SalesChannelCategoryGroup', salesChannelCategoryGroupID: any } };

export type SalesChannelCategoryGroupDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SalesChannelCategoryGroupDeleteMutation = { __typename?: 'Mutation', salesChannelCategoryGroupDelete: boolean };

export type SalesChannelCategoryGroupDeleteFromDetailMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SalesChannelCategoryGroupDeleteFromDetailMutation = { __typename?: 'Mutation', salesChannelCategoryGroupDelete: boolean };

export type SalesChannelCategoryGroupProductCreateMutationVariables = Exact<{
  input: SalesChannelCategoryGroupProductCreateInput;
}>;


export type SalesChannelCategoryGroupProductCreateMutation = { __typename?: 'Mutation', salesChannelCategoryGroupProductCreate: { __typename?: 'SalesChannelCategoryGroupProduct', salesChannelCategoryGroupProductID: any } };

export type SalesChannelCategoryGroupProductDeleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SalesChannelCategoryGroupProductDeleteMutation = { __typename?: 'Mutation', salesChannelCategoryGroupProductDelete: boolean };

export type SalesChannelCategoryGroupProductReorderMutationVariables = Exact<{
  input: Array<ReorderSalesChannelCategoryGroupProductInput> | ReorderSalesChannelCategoryGroupProductInput;
}>;


export type SalesChannelCategoryGroupProductReorderMutation = { __typename?: 'Mutation', salesChannelCategoryGroupProductReorder: boolean };

export type SalesChannelCategoryGroupProductUpdateMutationVariables = Exact<{
  input: SalesChannelCategoryGroupProductUpdateInput;
}>;


export type SalesChannelCategoryGroupProductUpdateMutation = { __typename?: 'Mutation', salesChannelCategoryGroupProductUpdate: { __typename?: 'SalesChannelCategoryGroupProduct', salesChannelCategoryGroupProductID: any } };

export type SalesChannelCategoryGroupProductsQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelCategoryGroupProductQopInput>;
}>;


export type SalesChannelCategoryGroupProductsQuery = { __typename?: 'Query', salesChannelCategoryGroupProducts: { __typename?: 'SalesChannelCategoryGroupProductPaged', items?: Array<{ __typename?: 'SalesChannelCategoryGroupProduct', salesChannelCategoryGroupProductID: any, salesChannelCategoryGroupID: any, salesChannelCategoryID: any, productID: any, productCode: string, productName: string, barcode: string, displayOrder: number, isActive: boolean, priceType: string, customPrice: number, imageType: string, externalImageURL: string, qty?: number | null, isOutOfStock: boolean, isNoPrice: boolean, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, isActive: boolean, canBeSold: boolean, mainImageFileMediumPathURL?: string | null, hasAddon: boolean, addonGroupID?: any | null, addonGroup?: { __typename?: 'ProductAddonGroup', productAddonGroupID: any, name: string } | null, baseUom?: { __typename?: 'Uom', uomID: any, uomName: string } | null } | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type SalesChannelCategoryGroupUpdateMutationVariables = Exact<{
  input: SalesChannelCategoryGroupUpdateInput;
}>;


export type SalesChannelCategoryGroupUpdateMutation = { __typename?: 'Mutation', salesChannelCategoryGroupUpdate: { __typename?: 'SalesChannelCategoryGroup', salesChannelCategoryGroupID: any } };

export type SalesChannelCategoryGroupsQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelCategoryGroupQopInput>;
}>;


export type SalesChannelCategoryGroupsQuery = { __typename?: 'Query', salesChannelCategoryGroups: { __typename?: 'SalesChannelCategoryGroupPaged', items?: Array<{ __typename?: 'SalesChannelCategoryGroup', salesChannelCategoryGroupID: any, salesChannelCategoryGroupName: string, isActive: boolean, isUseMasterdataAvailability: boolean }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null } } };

export type SalesChannelCategoryUpdateMutationVariables = Exact<{
  input: SalesChannelCategoryUpdateInput;
}>;


export type SalesChannelCategoryUpdateMutation = { __typename?: 'Mutation', salesChannelCategoryUpdate: { __typename?: 'SalesChannelCategory', salesChannelCategoryID: any } };

export type MarketplaceChannelTaxonomyQueryVariables = Exact<{
  salesChannelID: Scalars['String']['input'];
}>;


export type MarketplaceChannelTaxonomyQuery = { __typename?: 'Query', marketplaceChannelTaxonomy: Array<{ __typename?: 'ChannelTaxonomyNode', externalParentCategoryID: string, externalParentCategoryName: string, externalCategoryID: string, externalCategoryName: string }> };

export type SalesChannelCategoryMapCreateMutationVariables = Exact<{
  input: ProductCategorySalesChannelMapCreateInput;
}>;


export type SalesChannelCategoryMapCreateMutation = { __typename?: 'Mutation', productCategorySalesChannelMapCreate: { __typename?: 'ProductCategorySalesChannelMap', productCategorySalesChannelMapID: any, productCategoryID: any, salesChannelID: string, externalParentCategoryID: string, externalParentCategoryName: string, externalCategoryID: string, externalCategoryName: string, isActive: boolean } };

export type SalesChannelCategoryMapDeleteMutationVariables = Exact<{
  productCategorySalesChannelMapID: Scalars['UUID']['input'];
}>;


export type SalesChannelCategoryMapDeleteMutation = { __typename?: 'Mutation', productCategorySalesChannelMapDelete: boolean };

export type SalesChannelCategoryMapExportMutationVariables = Exact<{
  salesChannelID: Scalars['String']['input'];
}>;


export type SalesChannelCategoryMapExportMutation = { __typename?: 'Mutation', productCategorySalesChannelMapExport: { __typename?: 'ProductCategorySalesChannelMapExportResult', fileName: string, downloadURL: string } };

export type SalesChannelCategoryMapImportMutationVariables = Exact<{
  input: ProductCategorySalesChannelMapImportInput;
}>;


export type SalesChannelCategoryMapImportMutation = { __typename?: 'Mutation', productCategorySalesChannelMapImport: { __typename?: 'ProductCategorySalesChannelMapImportResult', importedCount: number, skippedCount: number } };

export type SalesChannelCategoryMapImportValidateMutationVariables = Exact<{
  input: ProductCategorySalesChannelMapImportValidateInput;
}>;


export type SalesChannelCategoryMapImportValidateMutation = { __typename?: 'Mutation', productCategorySalesChannelMapImportValidate: { __typename?: 'ProductCategorySalesChannelMapImportValidateResult', missingProductCategoryCodes: Array<string>, rowReport: { __typename?: 'ProductCategorySalesChannelMapImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'ProductCategorySalesChannelMapImportRowViolation', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> } } };

export type SalesChannelCategoryMapListQueryVariables = Exact<{
  qop: ProductCategorySalesChannelMapQopInput;
}>;


export type SalesChannelCategoryMapListQuery = { __typename?: 'Query', productCategorySalesChannelMaps: { __typename?: 'ProductCategorySalesChannelMapPaged', items: Array<{ __typename?: 'ProductCategorySalesChannelMap', productCategorySalesChannelMapID: any, productCategoryID: any, salesChannelID: string, externalParentCategoryID: string, externalParentCategoryName: string, externalCategoryID: string, externalCategoryName: string, isActive: boolean, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string } | null, salesChannel?: { __typename?: 'SalesChannel', salesChannelID: string, salesChannelName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type SalesChannelCategoryMapLoadQueryVariables = Exact<{
  productCategorySalesChannelMapID: Scalars['UUID']['input'];
}>;


export type SalesChannelCategoryMapLoadQuery = { __typename?: 'Query', productCategorySalesChannelMap: { __typename?: 'ProductCategorySalesChannelMap', productCategorySalesChannelMapID: any, productCategoryID: any, salesChannelID: string, externalParentCategoryID: string, externalParentCategoryName: string, externalCategoryID: string, externalCategoryName: string, isActive: boolean, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string } | null, salesChannel?: { __typename?: 'SalesChannel', salesChannelID: string, salesChannelName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type SalesChannelCategoryMapUpdateMutationVariables = Exact<{
  input: ProductCategorySalesChannelMapUpdateInput;
}>;


export type SalesChannelCategoryMapUpdateMutation = { __typename?: 'Mutation', productCategorySalesChannelMapUpdate: { __typename?: 'ProductCategorySalesChannelMap', productCategorySalesChannelMapID: any, productCategoryID: any, salesChannelID: string, externalParentCategoryID: string, externalParentCategoryName: string, externalCategoryID: string, externalCategoryName: string, isActive: boolean } };

export type SalesChannelStockThresholdCreateMutationVariables = Exact<{
  input: SalesChannelStockThresholdCreateInput;
}>;


export type SalesChannelStockThresholdCreateMutation = { __typename?: 'Mutation', salesChannelStockThresholdCreate: { __typename?: 'SalesChannelStockThreshold', salesChannelStockThresholdID: any } };

export type SalesChannelStockThresholdDeleteMutationVariables = Exact<{
  salesChannelStockThresholdID: Scalars['UUID']['input'];
}>;


export type SalesChannelStockThresholdDeleteMutation = { __typename?: 'Mutation', salesChannelStockThresholdDelete: boolean };

export type SalesChannelStockThresholdListQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelStockThresholdQopInput>;
}>;


export type SalesChannelStockThresholdListQuery = { __typename?: 'Query', salesChannelStockThresholds: { __typename?: 'SalesChannelStockThresholdPaged', items?: Array<{ __typename?: 'SalesChannelStockThreshold', salesChannelStockThresholdID: any, salesChannelID: string, thresholdType: string, thresholdValue: number, isActive: boolean, note: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any, updatedAt: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type SalesChannelStockThresholdUpdateMutationVariables = Exact<{
  input: SalesChannelStockThresholdUpdateInput;
}>;


export type SalesChannelStockThresholdUpdateMutation = { __typename?: 'Mutation', salesChannelStockThresholdUpdate: { __typename?: 'SalesChannelStockThreshold', salesChannelStockThresholdID: any } };

export type SalesChannelCreateMutationVariables = Exact<{
  input: SalesChannelCreateInput;
}>;


export type SalesChannelCreateMutation = { __typename?: 'Mutation', SalesChannelCreate: { __typename?: 'SalesChannel', salesChannelID: string, salesChannelName: string, salesChannelType: string, commisionPerc: number, additionalCharge: number, isMain: boolean, isActive: boolean, defaultMenuImageURL?: string | null } };

export type SalesChannelDeleteMutationVariables = Exact<{
  salesChannelID: Scalars['String']['input'];
}>;


export type SalesChannelDeleteMutation = { __typename?: 'Mutation', SalesChannelDelete: boolean };

export type SalesChannelLoadQueryVariables = Exact<{
  salesChannelID: Scalars['String']['input'];
}>;


export type SalesChannelLoadQuery = { __typename?: 'Query', salesChannel?: { __typename?: 'SalesChannel', salesChannelID: string, salesChannelName: string, salesChannelType: string, commisionPerc: number, additionalCharge: number, isMain: boolean, isActive: boolean, defaultMenuImageURL?: string | null } | null };

export type SalesChannelUpdateMutationVariables = Exact<{
  input: SalesChannelUpdateInput;
}>;


export type SalesChannelUpdateMutation = { __typename?: 'Mutation', SalesChannelUpdate: { __typename?: 'SalesChannel', salesChannelID: string, salesChannelName: string, salesChannelType: string, commisionPerc: number, additionalCharge: number, isMain: boolean, isActive: boolean, defaultMenuImageURL?: string | null } };

export type SalesChannelsQueryVariables = Exact<{
  qop?: InputMaybe<SalesChannelQopInput>;
}>;


export type SalesChannelsQuery = { __typename?: 'Query', salesChannels: { __typename?: 'SalesChannelPaged', items: Array<{ __typename?: 'SalesChannel', salesChannelID: string, salesChannelName: string, salesChannelType: string, commisionPerc: number, additionalCharge: number, isMain: boolean, isActive: boolean, defaultMenuImageURL?: string | null }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, page?: number | null, pageSize?: number | null } } };

export type SalesDashboardQueryVariables = Exact<{
  filter?: InputMaybe<SalesDashboardFilterInput>;
}>;


export type SalesDashboardQuery = { __typename?: 'Query', salesDashboard: { __typename?: 'SalesDashboard', summary: { __typename?: 'SalesDashboardSummary', totalSales: number, invoiceCount: number, totalItems: number, totalItemProduct: number, totalItemBundle: number, totalItemConsignment: number, avgBasket: number, totalTax: number, totalDiscount: number }, salesByDay: Array<{ __typename?: 'SalesDashboardDayPoint', date: string, total: number, invoiceCount: number }>, salesByHour: Array<{ __typename?: 'SalesDashboardHourPoint', bucket: string, total: number, invoiceCount: number }>, topProducts: Array<{ __typename?: 'SalesDashboardProductPoint', productID: any, productName: string, qty: number, total: number }>, topProductsByRevenue: Array<{ __typename?: 'SalesDashboardProductPoint', productID: any, productName: string, qty: number, total: number }> } };

export type SalesInvoiceReviewListQueryVariables = Exact<{
  qop?: InputMaybe<SalesInvoiceReviewQopInput>;
}>;


export type SalesInvoiceReviewListQuery = { __typename?: 'Query', salesInvoiceReviews: { __typename?: 'SalesInvoiceReviewPaged', items: Array<{ __typename?: 'SalesInvoiceReview', salesInvoiceReviewID: any, salesInvoiceID: any, salesInvoiceNumber: string, salesInvoiceDatetime: any, salesInvoiceDatetimeUtc: any, salesOrderNumber: string, branchID: any, branchCode: string, branchName: string, salesChannelName: string, cashierUserName: string, reviewType: string, isNoteInternal: boolean, amountDifference: number, noteInternal: string, total: number, paymentAmount: number, status: string, isResolved: boolean }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type SalesInvoiceReviewLoadQueryVariables = Exact<{
  salesInvoiceReviewID: Scalars['UUID']['input'];
}>;


export type SalesInvoiceReviewLoadQuery = { __typename?: 'Query', salesInvoiceReview?: { __typename?: 'SalesInvoiceReview', salesInvoiceReviewID: any, salesInvoiceID: any, salesInvoiceNumber: string, salesInvoiceType: string, salesInvoiceStatus: string, salesInvoiceDatetime: any, salesInvoiceDatetimeUtc: any, gmt: number, salesOrderID: any, salesOrderNumber: string, branchID: any, branchCode: string, branchName: string, salesChannelID: string, salesChannelName: string, shiftSessionID: any, cashierUserID: any, cashierUserName: string, reviewType: string, isNoteInternal: boolean, amountDifference: number, noteInternal: string, total: number, isResolved: boolean, resolutionNote: string, resolvedAt?: any | null, resolvedAtUtc?: any | null, resolvedByUserID?: any | null, resolvedByUserName: string, status: string, payments: Array<{ __typename?: 'SalesInvoicePayment', salesInvoicePaymentID: any, paymentMethodName: string, paymentMethodTypeCode: string, paymentAmount: number, edcTerminalName?: string | null, bankReferenceNumber?: string | null, paymentTransactionID?: any | null, reconciliationStatus: string }>, paymentTransactions: Array<{ __typename?: 'PaymentTransaction', paymentTransactionID: any, paymentTransactionType: string, providerCode: string, amount: number, status: string, latestTransactionStatusCode: string, transactionDatetime: any, paidAt?: any | null, rrn: string, approvalCode: string, issuerName: string, payerName: string, cancelReason: string }> } | null };

export type SalesInvoiceReviewRefreshMutationVariables = Exact<{
  salesInvoiceReviewID: Scalars['UUID']['input'];
}>;


export type SalesInvoiceReviewRefreshMutation = { __typename?: 'Mutation', salesInvoiceReviewRefresh: { __typename?: 'SalesInvoiceReview', salesInvoiceReviewID: any, salesInvoiceNumber: string, reviewType: string, amountDifference: number, status: string } };

export type SalesInvoiceReviewResolveBulkMutationVariables = Exact<{
  input: SalesInvoiceReviewResolveBulkInput;
}>;


export type SalesInvoiceReviewResolveBulkMutation = { __typename?: 'Mutation', salesInvoiceReviewResolveBulk: Array<{ __typename?: 'SalesInvoiceReviewResolveResult', salesInvoiceReviewID: any, salesInvoiceNumber: string, success: boolean, error: string }> };

export type SalesInvoiceItemsQueryVariables = Exact<{
  qop?: InputMaybe<SalesInvoiceItemQopInput>;
}>;


export type SalesInvoiceItemsQuery = { __typename?: 'Query', salesInvoiceItems: { __typename?: 'SalesInvoiceItemPaged', items: Array<{ __typename?: 'SalesInvoiceItem', salesInvoiceItemID: any, salesInvoiceID: any, productCode: string, productName: string, productNameAlias: string, barcode: string, status: string, qty: number, uomName: string, unitPrice: number, discountAmount: number, total: number, taxableAmount: number, taxAmount: number, promoType?: string | null, commissionAmount: number, isConsignment: boolean, consignmentVendorID?: any | null, consignmentCommissionFeePerc?: number | null, taxes: Array<{ __typename?: 'SalesInvoiceItemTax', salesInvoiceItemTaxID: any, taxCode: string, taxRate: number, taxableAmount: number, taxAmount: number }>, product?: { __typename?: 'Product', productID: any, productType: string, productBundleComponents: Array<{ __typename?: 'ProductBundleComponent', qty: number, uom: { __typename?: 'Uom', uomName: string }, componentProduct?: { __typename?: 'Product', productCode: string, productName: string } | null }> } | null, addonComponents: Array<{ __typename?: 'SalesInvoiceItemAddonComponent', productID: any, productCode: string, productName: string, qty: number }>, consignmentVendor?: { __typename?: 'SalesInvoiceConsignmentVendor', vendorID: any, vendorCode: string, vendorName: string, isPKP?: boolean | null, consignmentCommissionFeePerc?: number | null } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type SalesInvoiceListQueryVariables = Exact<{
  qop?: InputMaybe<SalesInvoiceQopInput>;
}>;


export type SalesInvoiceListQuery = { __typename?: 'Query', salesInvoices: { __typename?: 'SalesInvoicePaged', items: Array<{ __typename?: 'SalesInvoice', salesInvoiceID: any, salesInvoiceNumber: string, salesInvoiceDatetime: any, salesInvoiceDatetimeUtc: any, salesInvoiceType: string, salesOrderNumber: string, branchID: any, customerID?: any | null, memberTypeName?: string | null, salesChannelName?: string | null, salesChannelType?: string | null, totalItemQty: number, subtotal: number, discountAmount: number, taxAmount: number, total: number, status: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type SalesInvoiceLoadQueryVariables = Exact<{
  salesInvoiceID: Scalars['UUID']['input'];
}>;


export type SalesInvoiceLoadQuery = { __typename?: 'Query', salesInvoice?: { __typename?: 'SalesInvoice', salesInvoiceID: any, salesInvoiceNumber: string, salesInvoiceDatetime: any, salesInvoiceDatetimeUtc: any, salesInvoiceType: string, salesOrderID: any, salesOrderNumber: string, shiftSessionID: any, branchID: any, gmt: number, customerID?: any | null, memberTypeID?: any | null, memberTypeName?: string | null, salesChannelID?: string | null, salesChannelName?: string | null, salesChannelType?: string | null, warehouseID?: any | null, taxIncluded: boolean, totalItemQty: number, subtotal: number, discountType: string, discountPerc: number, discountAmount: number, subtotalAfterDiscount: number, taxAmount: number, adjustmentAmount: number, total: number, taxableAmount: number, cashPaymentAmount: number, nonCashPaymentAmount: number, paymentReceivedAmount: number, paymentChangeAmount: number, paymentAmount: number, paymentVoucherAmount: number, noteInternal: string, status: string, payments: Array<{ __typename?: 'SalesInvoicePayment', salesInvoicePaymentID: any, paymentMethodName: string, paymentMethodTypeName: string, paymentMethodTypeCode: string, paymentMethodTypeIsCash: boolean, paymentMethodTypeIsCard: boolean, edcTerminalName?: string | null, bankName?: string | null, bankAccountNumber?: string | null, cardNumber?: string | null, authCode?: string | null, paymentAmount: number, isReconciliation: boolean, reconciliationStatus: string }>, taxes: Array<{ __typename?: 'SalesInvoiceTax', salesInvoiceTaxID: any, taxCode: string, taxRate: number, taxableAmount: number, taxAmount: number }>, shiftSession?: { __typename?: 'ShiftSession', shiftSessionID: any, userName: string, employeeName: string, status: string, sessionOpenTime: any } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, updatedByUserName?: string | null, createdAt: any, updatedAt: any } } | null };

export type SalesInvoicePointsQueryVariables = Exact<{
  qop?: InputMaybe<CustomerPointTransactionQopInput>;
}>;


export type SalesInvoicePointsQuery = { __typename?: 'Query', customerPointTransactions: { __typename?: 'CustomerPointTransactionPaged', items: Array<{ __typename?: 'CustomerPointTransaction', customerPointTransactionID: any, customerPointTransactionNumber: string, transactionDatetime: string, earnedPoint: number, pointBefore: number, pointAfter: number }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type SalesInvoiceVouchersQueryVariables = Exact<{
  qop?: InputMaybe<CustomerVoucherTransactionQopInput>;
}>;


export type SalesInvoiceVouchersQuery = { __typename?: 'Query', customerVoucherTransactions: { __typename?: 'CustomerVoucherTransactionPaged', items: Array<{ __typename?: 'CustomerVoucherTransaction', customerVoucherTransactionID: any, customerVoucherTransactionNumber: string, transactionDatetime: any, voucherCode: string, voucherName: string, voucherItemCode: string, voucherValue: number, paymentAmount: number, status: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type DeliveryOrderItemsQueryVariables = Exact<{
  qop?: InputMaybe<DeliveryOrderItemQopInput>;
}>;


export type DeliveryOrderItemsQuery = { __typename?: 'Query', deliveryOrderItems: { __typename?: 'DeliveryOrderItemPaged', items?: Array<{ __typename?: 'DeliveryOrderItem', baseUomQty: number, uomConvertionRate: number, uomDecimal: number, uomConversionDecimal: number, uomID: any, qty: number, uomName: string, productWeight: number, productName: string, productCode: string, productID: any, deliveryOrderID: any, deliveryOrderItemID: any, product?: { __typename?: 'Product', barcode: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type SimpleTransferOrderReceivingCancelMutationVariables = Exact<{
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
}>;


export type SimpleTransferOrderReceivingCancelMutation = { __typename?: 'Mutation', simpleTransferOrderReceivingCancel: boolean };

export type SimpleTransferOrderReceivingConfirmMutationVariables = Exact<{
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
}>;


export type SimpleTransferOrderReceivingConfirmMutation = { __typename?: 'Mutation', simpleTransferOrderReceivingConfirm: { __typename?: 'SimpleTransferOrderReceiving', simpleTransferOrderReceivingID: any } };

export type SimpleTransferOrderReceivingCreateMutationVariables = Exact<{
  input: SimpleTransferOrderReceivingCreateInput;
}>;


export type SimpleTransferOrderReceivingCreateMutation = { __typename?: 'Mutation', simpleTransferOrderReceivingCreate: { __typename?: 'SimpleTransferOrderReceiving', simpleTransferOrderReceivingID: any } };

export type SimpleTransferOrderReceivingCreateAndConfirmMutationVariables = Exact<{
  input: SimpleTransferOrderReceivingCreateAndConfirmInput;
}>;


export type SimpleTransferOrderReceivingCreateAndConfirmMutation = { __typename?: 'Mutation', simpleTransferOrderReceivingCreateAndConfirm: { __typename?: 'SimpleTransferOrderReceiving', simpleTransferOrderReceivingID: any, simpleTransferOrderReceivingNumber: string, status: string, actionType?: string | null } };

export type SimpleTransferOrderReceivingListItemsQueryVariables = Exact<{
  qop?: InputMaybe<SimpleTransferOrderReceivingItemQopInput>;
}>;


export type SimpleTransferOrderReceivingListItemsQuery = { __typename?: 'Query', simpleTransferOrderReceivingItems: { __typename?: 'SimpleTransferOrderReceivingItemPaged', items: Array<{ __typename?: 'SimpleTransferOrderReceivingItem', note?: string | null, baseUomQty: number, uomConversionDecimal: number, uomConversionRate: number, uomDecimal: number, uomID: any, uomCategoryID: any, uomName: string, qtyReceived: number, doQty: number, toUomConversionDecimal: number, toUomConversionRate: number, toUomID: any, toQtyOutstanding: number, toQtyReceived: number, toQty: number, description: string, productName: string, productCode: string, productWeight: number, simpleTransferOrderReceivingItemID: any, simpleTransferOrderReceivingID: any, simpleTransferOrderID: any, simpleTransferOrderItemID: any, productID: any, product?: { __typename?: 'Product', barcode: string } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type SimpleTransferOrderReceivingLoadQueryVariables = Exact<{
  simpleTransferOrderReceivingID: Scalars['UUID']['input'];
}>;


export type SimpleTransferOrderReceivingLoadQuery = { __typename?: 'Query', simpleTransferOrderReceiving?: { __typename?: 'SimpleTransferOrderReceiving', simpleTransferOrderReceivingID: any, simpleTransferOrderReceivingNumber: string, simpleTransferOrderReceivingDatetime: any, branchID: any, branchCode: string, branchName: string, gmt: number, deliveryOrderID: any, deliveryOrderNumber: string, deliveryBy: string, simpleTransferOrderID: any, simpleTransferOrderNumber: string, originWarehouseID: any, warehouseID: any, warehouseLocationID: any, vendorID?: any | null, vendorCode?: string | null, vendorName?: string | null, vendorRefNumber?: string | null, vehiclePlateNumber?: string | null, driverName?: string | null, driverPhoneNumber?: string | null, closeSto: boolean, totalItemQtyReceived: number, totalItemWeightReceived: number, noteInternal: string, status: string, warehouseLocation: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string }, originWarehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseName: string }, warehouse: { __typename?: 'Warehouse', warehouseID: any, warehouseName: string }, files?: Array<{ __typename?: 'SimpleTransferOrderReceivingFile', simpleTransferOrderReceivingFileID: any, simpleTransferOrderReceivingID: any, simpleTransferOrderReceivingFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string, uniqueKey: string }> | null } | null };

export type SimpleTransferOrderReceivingUpdateMutationVariables = Exact<{
  input: SimpleTransferOrderReceivingUpdateInput;
}>;


export type SimpleTransferOrderReceivingUpdateMutation = { __typename?: 'Mutation', simpleTransferOrderReceivingUpdate: { __typename?: 'SimpleTransferOrderReceiving', simpleTransferOrderReceivingID: any } };

export type SimpleTransferOrderReceivingUpdateAndConfirmMutationVariables = Exact<{
  input: SimpleTransferOrderReceivingUpdateAndConfirmInput;
}>;


export type SimpleTransferOrderReceivingUpdateAndConfirmMutation = { __typename?: 'Mutation', simpleTransferOrderReceivingUpdateAndConfirm: { __typename?: 'SimpleTransferOrderReceiving', simpleTransferOrderReceivingID: any, simpleTransferOrderReceivingNumber: string, status: string, actionType?: string | null } };

export type SimpleTransferOrderCancelMutationVariables = Exact<{
  input: SimpleTransferOrderCancelInput;
}>;


export type SimpleTransferOrderCancelMutation = { __typename?: 'Mutation', simpleTransferOrderCancel: { __typename?: 'SimpleTransferOrder', simpleTransferOrderID: any, simpleTransferOrderNumber: string, simpleTransferOrderDatetime: any, simpleTransferOrderDatetimeUtc: any, scheduledDeliveryDate: any, branchID: any, gmt: number, fromWarehouseID: any, fromWarehouseName: string, toWarehouseID: any, toWarehouseName: string, totalItemQty: number, totalItemWeight: number, totalItemQtyReadyToShip: number, totalItemQtyShipped: number, totalItemQtyUnfulfilled: number, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForReceiver: string, status: string, deliveryOrderID: any, deliveryOrderNumber: string } };

export type SimpleTransferOrderConfirmMutationVariables = Exact<{
  input: SimpleTransferOrderConfirmInput;
}>;


export type SimpleTransferOrderConfirmMutation = { __typename?: 'Mutation', simpleTransferOrderConfirm: { __typename?: 'SimpleTransferOrder', simpleTransferOrderID: any, simpleTransferOrderNumber: string, simpleTransferOrderDatetime: any, simpleTransferOrderDatetimeUtc: any, scheduledDeliveryDate: any, branchID: any, gmt: number, fromWarehouseID: any, fromWarehouseName: string, toWarehouseID: any, toWarehouseName: string, totalItemQty: number, totalItemWeight: number, totalItemQtyReadyToShip: number, totalItemQtyShipped: number, totalItemQtyUnfulfilled: number, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForReceiver: string, status: string, deliveryOrderID: any, deliveryOrderNumber: string } };

export type SimpleTransferOrderCreateMutationVariables = Exact<{
  input: SimpleTransferOrderCreateInput;
}>;


export type SimpleTransferOrderCreateMutation = { __typename?: 'Mutation', simpleTransferOrderCreate: { __typename?: 'SimpleTransferOrder', simpleTransferOrderID: any, simpleTransferOrderNumber: string, simpleTransferOrderDatetime: any, simpleTransferOrderDatetimeUtc: any, scheduledDeliveryDate: any, branchID: any, gmt: number, fromWarehouseID: any, fromWarehouseName: string, toWarehouseID: any, toWarehouseName: string, totalItemQty: number, totalItemWeight: number, totalItemQtyReadyToShip: number, totalItemQtyShipped: number, totalItemQtyUnfulfilled: number, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForReceiver: string, status: string, deliveryOrderID: any, deliveryOrderNumber: string } };

export type SimpleTransferOrderDeleteMutationVariables = Exact<{
  transferOrderSimpleID: Scalars['UUID']['input'];
}>;


export type SimpleTransferOrderDeleteMutation = { __typename?: 'Mutation', simpleTransferOrderDelete: boolean };

export type SimpleTransferOrderItemLoadQueryVariables = Exact<{
  transferOrderSimpleItemID: Scalars['UUID']['input'];
}>;


export type SimpleTransferOrderItemLoadQuery = { __typename?: 'Query', simpleTransferOrderItem?: { __typename?: 'SimpleTransferOrderItem', simpleTransferOrderItemID: any, simpleTransferOrderID: any, productID: any, productCode: string, productName: string, description: string, productWeight: number, qty: number, qtyReadyToShip: number, qtyShipped: number, qtyUnfulfilled: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, isMultiple: boolean } | null };

export type SimpleTransferOrderItemLocationsAutocompleteQueryVariables = Exact<{
  qop: SimpleTransferOrderItemLocationQopInput;
}>;


export type SimpleTransferOrderItemLocationsAutocompleteQuery = { __typename?: 'Query', simpleTransferOrderItemLocations: { __typename?: 'SimpleTransferOrderItemLocationPaged', items: Array<{ __typename?: 'SimpleTransferOrderItemLocation', simpleTransferOrderItemLocationID: any, simpleTransferOrderItemID: any, fromWarehouseLocationID: any, fromWarehouseLocationName: string, qty: number, baseUomQty: number, simpleTransferOrderItem: { __typename?: 'SimpleTransferOrderItem', simpleTransferOrderItemID: any, simpleTransferOrderID: any, productID: any, productCode: string, productName: string, description: string, productWeight: number, qty: number, qtyReadyToShip: number, qtyShipped: number, qtyUnfulfilled: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, isMultiple: boolean, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, addonGroupID?: any | null, hasAddon: boolean, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, isSystem: boolean, trackStock: boolean, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, sellingPrice?: number | null, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean } | null } }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type SimpleTransferOrderItemListQueryVariables = Exact<{
  qop?: InputMaybe<SimpleTransferOrderItemQopInput>;
}>;


export type SimpleTransferOrderItemListQuery = { __typename?: 'Query', simpleTransferOrderItems: { __typename?: 'SimpleTransferOrderItemPaged', items: Array<{ __typename?: 'SimpleTransferOrderItem', simpleTransferOrderItemID: any, simpleTransferOrderID: any, productID: any, productCode: string, productName: string, description: string, productWeight: number, qty: number, qtyReadyToShip: number, qtyShipped: number, qtyUnfulfilled: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQty: number, isMultiple: boolean, product?: { __typename?: 'Product', barcode: string } | null, locations: Array<{ __typename?: 'SimpleTransferOrderItemLocation', simpleTransferOrderItemLocationID: any, simpleTransferOrderItemID: any, fromWarehouseLocationID: any, fromWarehouseLocationName: string, qty: number, baseUomQty: number }> }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type SimpleTransferOrderItemLocationsQueryVariables = Exact<{
  qop?: InputMaybe<SimpleTransferOrderItemLocationQopInput>;
}>;


export type SimpleTransferOrderItemLocationsQuery = { __typename?: 'Query', simpleTransferOrderItemLocations: { __typename?: 'SimpleTransferOrderItemLocationPaged', items: Array<{ __typename?: 'SimpleTransferOrderItemLocation', simpleTransferOrderItemLocationID: any, simpleTransferOrderItemID: any, fromWarehouseLocationID: any, fromWarehouseLocationName: string, qty: number, baseUomQty: number }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type SimpleTransferOrderListQueryVariables = Exact<{
  qop?: InputMaybe<SimpleTransferOrderQopInput>;
}>;


export type SimpleTransferOrderListQuery = { __typename?: 'Query', simpleTransferOrders: { __typename?: 'SimpleTransferOrderPaged', items: Array<{ __typename?: 'SimpleTransferOrder', simpleTransferOrderID: any, simpleTransferOrderNumber: string, simpleTransferOrderDatetime: any, simpleTransferOrderDatetimeUtc: any, scheduledDeliveryDate: any, branchID: any, gmt: number, fromWarehouseID: any, fromWarehouseName: string, toWarehouseID: any, toWarehouseName: string, totalItemQty: number, totalItemWeight: number, totalItemQtyReadyToShip: number, totalItemQtyShipped: number, totalItemQtyUnfulfilled: number, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForReceiver: string, status: string, deliveryOrderID: any, deliveryOrderNumber: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type SimpleTransferOrderLoadQueryVariables = Exact<{
  transferOrderSimpleID: Scalars['UUID']['input'];
}>;


export type SimpleTransferOrderLoadQuery = { __typename?: 'Query', simpleTransferOrder?: { __typename?: 'SimpleTransferOrder', simpleTransferOrderID: any, simpleTransferOrderNumber: string, simpleTransferOrderDatetime: any, simpleTransferOrderDatetimeUtc: any, scheduledDeliveryDate: any, branchID: any, gmt: number, fromWarehouseID: any, fromWarehouseName: string, toWarehouseID: any, toWarehouseName: string, totalItemQty: number, totalItemWeight: number, totalItemQtyReadyToShip: number, totalItemQtyShipped: number, totalItemQtyUnfulfilled: number, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForReceiver: string, status: string, deliveryOrderID: any, deliveryOrderNumber: string, deliveredDatetime?: any | null, deliveredDatetimeUtc?: any | null, deliveryOrder?: { __typename?: 'DeliveryOrder', deliveryOrderID: any, deliveryOrderNumber: string, deliveryOrderDatetime: any, deliveryOrderDatetimeUTC: any, branchID: any, gmt: number, sourceDocumentType: string, sourceDocumentID: any, sourceDocumentNumber: string, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, deliveryAddress: string, deliveryBy: string, vendorID?: any | null, vendorCode?: string | null, vendorName?: string | null, vendorRefNumber?: string | null, landedCost: number, totalContainers: number, totalItems: number, totalItemQty: number, noteInternal: string, shippedDatetime?: any | null, shippedDatetimeUTC?: any | null, shippedByUserID?: any | null, shippedByUserName?: string | null, vehiclePlateNumber: string, driverName: string, driverPhoneNumber: string, cancelledDatetime?: any | null, cancelledDatetimeUTC?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, status: string } | null } | null };

export type SimpleTransferOrderUpdateMutationVariables = Exact<{
  input: SimpleTransferOrderUpdateInput;
}>;


export type SimpleTransferOrderUpdateMutation = { __typename?: 'Mutation', simpleTransferOrderUpdate: { __typename?: 'SimpleTransferOrder', simpleTransferOrderID: any, simpleTransferOrderNumber: string, simpleTransferOrderDatetime: any, simpleTransferOrderDatetimeUtc: any, scheduledDeliveryDate: any, branchID: any, gmt: number, fromWarehouseID: any, fromWarehouseName: string, toWarehouseID: any, toWarehouseName: string, totalItemQty: number, totalItemWeight: number, totalItemQtyReadyToShip: number, totalItemQtyShipped: number, totalItemQtyUnfulfilled: number, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForReceiver: string, status: string, deliveryOrderID: any, deliveryOrderNumber: string } };

export type TaxAutocompleteQueryVariables = Exact<{
  qop: TaxQopInput;
}>;


export type TaxAutocompleteQuery = { __typename?: 'Query', taxes: { __typename?: 'TaxPaged', items?: Array<{ __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxType: string, taxRate: number }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type TaxCreateMutationVariables = Exact<{
  input: TaxCreateInput;
}>;


export type TaxCreateMutation = { __typename?: 'Mutation', taxCreate: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, taxType: string, uniqueKey: string, isActive: boolean } };

export type TaxDeleteMutationVariables = Exact<{
  taxID: Scalars['UUID']['input'];
}>;


export type TaxDeleteMutation = { __typename?: 'Mutation', taxDelete: boolean };

export type TaxListQueryVariables = Exact<{
  qop: TaxQopInput;
}>;


export type TaxListQuery = { __typename?: 'Query', taxes: { __typename?: 'TaxPaged', items?: Array<{ __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, taxType: string, uniqueKey: string, isActive: boolean }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type TaxQueryVariables = Exact<{
  taxID: Scalars['UUID']['input'];
}>;


export type TaxQuery = { __typename?: 'Query', tax: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, taxType: string, uniqueKey: string, isActive: boolean } };

export type TaxUpdateMutationVariables = Exact<{
  input: TaxUpdateInput;
}>;


export type TaxUpdateMutation = { __typename?: 'Mutation', taxUpdate: { __typename?: 'Tax', taxID: any, taxCode: string, taxName: string, taxRate: number, taxType: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type TransferOrderCancelMutationVariables = Exact<{
  input: TransferOrderCancelInput;
}>;


export type TransferOrderCancelMutation = { __typename?: 'Mutation', transferOrderCancel: { __typename?: 'TransferOrder', transferOrderID: any, cancellationReason?: string | null } };

export type TransferOrderCheckGenerateBulkMutationVariables = Exact<{
  input: DeliveryOrderGenerateBulkInput;
}>;


export type TransferOrderCheckGenerateBulkMutation = { __typename?: 'Mutation', deliveryOrderCheckGenerateBulk?: Array<{ __typename?: 'CheckReadyGenerateDeliveryOrderBulk', fromWarehouseName: string, totalContainerReady: number, sourceDocumentNumber: string, sourceDocumentID: any }> | null };

export type TransferOrderConfirmMutationVariables = Exact<{
  input: TransferOrderConfirmInput;
}>;


export type TransferOrderConfirmMutation = { __typename?: 'Mutation', transferOrderConfirm: { __typename?: 'TransferOrder', transferOrderID: any } };

export type TransferOrderCreateMutationVariables = Exact<{
  input: TransferOrderCreateInput;
}>;


export type TransferOrderCreateMutation = { __typename?: 'Mutation', transferOrderCreate: { __typename?: 'TransferOrder', transferOrderNumber: string, transferOrderDatetime: any, branchID: any, scheduledDeliveryDate: any, fromWarehouseID: any, toWarehouseID: any, noteInternal: string, noteForReceiver: string } };

export type TransferOrderGenerateBulkMutationVariables = Exact<{
  input: DeliveryOrderGenerateBulkInput;
}>;


export type TransferOrderGenerateBulkMutation = { __typename?: 'Mutation', deliveryOrderGenerateBulk: boolean };

export type TransferOrderGeneratePickingMultipleMutationVariables = Exact<{
  input: PickingTaskGenerateBulkInput;
}>;


export type TransferOrderGeneratePickingMultipleMutation = { __typename?: 'Mutation', pickingTaskGenerateBulk: Array<{ __typename?: 'PickingTask', sourceDocumentType: string, sourceDocumentID: any, warehouseID: any, assignedToUserID?: any | null }> };

export type TransferOrderGeneratePickingSingleMutationVariables = Exact<{
  input: PickingTaskGenerateInput;
}>;


export type TransferOrderGeneratePickingSingleMutation = { __typename?: 'Mutation', pickingTaskGenerate: { __typename?: 'PickingTask', sourceDocumentType: string, sourceDocumentID: any, warehouseID: any, assignedToUserID?: any | null } };

export type TransferOrderImportMutationVariables = Exact<{
  input: TransferOrderImportInput;
}>;


export type TransferOrderImportMutation = { __typename?: 'Mutation', transferOrderImport: any };

export type TransferOrderImportValidateCodesMutationVariables = Exact<{
  input: TransferOrderImportValidateCodesInput;
}>;


export type TransferOrderImportValidateCodesMutation = { __typename?: 'Mutation', transferOrderImportValidateCodes: { __typename?: 'TransferOrderImportValidateCodesResult', missingBranchCodes: Array<string>, missingWarehouseCodes: Array<string>, missingProductCodes: Array<string>, consignmentProductCodes: Array<string>, duplicateProductCodes: Array<string>, missingProductUoms: Array<{ __typename?: 'TransferOrderImportMissingProductUom', rowNumber: number, productCode: string, uomName: string }>, rowReport?: { __typename?: 'TransferOrderImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'TransferOrderImportRowViolation', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> } | null } };

export type TransferOrderListQueryVariables = Exact<{
  qop?: InputMaybe<TransferOrderQopInput>;
}>;


export type TransferOrderListQuery = { __typename?: 'Query', transferOrders: { __typename?: 'TransferOrderPaged', items: Array<{ __typename?: 'TransferOrder', transferOrderNumber: string, transferOrderDatetime: any, status: string, toWarehouseName: string, fromWarehouseName: string, transferOrderID: any, fromWarehouseID: any, isPickingTaskComplated: boolean, isReadyGenerateDeliveryOrder: boolean }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type TransferOrderLoadQueryVariables = Exact<{
  transferOrderID: Scalars['UUID']['input'];
}>;


export type TransferOrderLoadQuery = { __typename?: 'Query', transferOrder?: { __typename?: 'TransferOrder', transferOrderID: any, transferOrderNumber: string, transferOrderDatetime: any, transferOrderDatetimeUtc: any, scheduledDeliveryDate: any, branchID: any, branchCode: string, branchName: string, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, isPickingTaskComplated: boolean, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, totalItemQty: number, totalItemWeight: number, totalItemQtyReadyToPick: number, totalItemQtyReadyToPack: number, totalItemQtyReadyToShip: number, totalItemQtyShipped: number, totalItemQtyUnfulfilled: number, confirmDatetime?: any | null, confirmDatetimeUtc?: any | null, confirmByUserID?: any | null, confirmByUserName?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForReceiver: string, status: string, isReadyGenerateDeliveryOrder: boolean, doneByUserName?: string | null, doneDatetime?: any | null, doneReason?: string | null, transferRequest?: { __typename?: 'TransferRequest', transferRequestNumber: string, scheduledDeliveryDate?: any | null, transferRequestDatetime: any } | null } | null };

export type TransferOrderMarkAsDoneMutationVariables = Exact<{
  input: TransferOrderMarkAsDoneInput;
}>;


export type TransferOrderMarkAsDoneMutation = { __typename?: 'Mutation', transferOrderMarkAsDone: { __typename?: 'TransferOrder', transferOrderID: any } };

export type TransferOrderProductsLoadQueryVariables = Exact<{
  qop?: InputMaybe<TransferOrderItemQopInput>;
}>;


export type TransferOrderProductsLoadQuery = { __typename?: 'Query', transferOrderItems: { __typename?: 'TransferOrderItemPaged', items: Array<{ __typename?: 'TransferOrderItem', productID: any, productName: string, productCode: string, productWeight: number, qty: number, qtyReadyToPick: number, qtyReadyToPack: number, qtyReadyToShip: number, qtyShipped: number, qtyUnfulfilled: number, uomName: string, uomID: any, transferOrderItemID: any, baseUomQty: number, uomCategoryID: any, product: { __typename?: 'Product', barcode: string } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type TransferOrderUpdateMutationVariables = Exact<{
  input: TransferOrderUpdateInput;
}>;


export type TransferOrderUpdateMutation = { __typename?: 'Mutation', transferOrderUpdate: { __typename?: 'TransferOrder', transferOrderID: any, scheduledDeliveryDate: any, fromWarehouseID: any, toWarehouseID: any, noteInternal: string, noteForReceiver: string, transferOrderDatetime: any } };

export type TransferOrderWarehouseLocationLoadQueryVariables = Exact<{
  qop: WarehouseLocationQopInput;
}>;


export type TransferOrderWarehouseLocationLoadQuery = { __typename?: 'Query', warehouseLocations: { __typename?: 'WarehouseLocationPaged', items?: Array<{ __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type WarehouseLocationGroupsQueryVariables = Exact<{
  qop: WarehouseLocationGroupQopInput;
}>;


export type WarehouseLocationGroupsQuery = { __typename?: 'Query', warehouseLocationGroups: { __typename?: 'WarehouseLocationGroupPaged', items?: Array<{ __typename?: 'WarehouseLocationGroup', warehouseLocationGroupID: any, warehouseLocationGroupName: string, isActive?: boolean | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type GenerateTransferRequestFromReplenishmentMutationVariables = Exact<{
  input: GenerateTransferRequestFromReplenishmentInput;
}>;


export type GenerateTransferRequestFromReplenishmentMutation = { __typename?: 'Mutation', generateTransferRequestFromReplenishment: { __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string, replenishmentID?: any | null, status: string } };

export type TransferRequestApproveMutationVariables = Exact<{
  input: TransferRequestApproveInput;
}>;


export type TransferRequestApproveMutation = { __typename?: 'Mutation', transferRequestApprove: { __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string, transferRequestDatetime: any, transferRequestDatetimeUtc: any, scheduledDeliveryDate?: any | null, branchID: any, branchCode: string, branchName: string, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, totalItemQtyRequested: number, totalItemQtyApproved: number, submittedDatetime?: any | null, submittedDatetimeUtc?: any | null, submittedByUserID?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedDatetimeUtc?: any | null, approvedByUserID?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedDatetimeUtc?: any | null, rejectedByUserID?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteApprover?: string | null, status: string } };

export type TransferRequestCancelMutationVariables = Exact<{
  input: TransferRequestCancelInput;
}>;


export type TransferRequestCancelMutation = { __typename?: 'Mutation', transferRequestCancel: { __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string, transferRequestDatetime: any, transferRequestDatetimeUtc: any, scheduledDeliveryDate?: any | null, branchID: any, branchCode: string, branchName: string, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, totalItemQtyRequested: number, totalItemQtyApproved: number, submittedDatetime?: any | null, submittedDatetimeUtc?: any | null, submittedByUserID?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedDatetimeUtc?: any | null, approvedByUserID?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedDatetimeUtc?: any | null, rejectedByUserID?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteApprover?: string | null, status: string } };

export type TransferRequestCreateMutationVariables = Exact<{
  input: TransferRequestCreateInput;
}>;


export type TransferRequestCreateMutation = { __typename?: 'Mutation', transferRequestCreate: { __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string, transferRequestDatetime: any, transferRequestDatetimeUtc: any, scheduledDeliveryDate?: any | null, transferOrderID?: any | null, transferOrderNumber?: string | null, branchID: any, branchCode: string, branchName: string, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, totalItemQtyRequested: number, totalItemQtyApproved: number, submittedDatetime?: any | null, submittedDatetimeUtc?: any | null, submittedByUserID?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedDatetimeUtc?: any | null, approvedByUserID?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedDatetimeUtc?: any | null, rejectedByUserID?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForApprover: string, status: string, items: Array<{ __typename?: 'TransferRequestItem', transferRequestItemID: any, transferRequestID: any, productID: any, productCode: string, productName: string, description: string, productWeight: number, qtyRequested: number, qtyApproved: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQtyRequested: number, baseUomQtyApproved: number, noteApprover?: string | null, noteRequester?: string | null }> } };

export type TransferRequestImportMutationVariables = Exact<{
  input: TransferRequestImportInput;
}>;


export type TransferRequestImportMutation = { __typename?: 'Mutation', transferRequestImport: any };

export type TransferRequestImportValidateCodesMutationVariables = Exact<{
  input: TransferRequestImportValidateCodesInput;
}>;


export type TransferRequestImportValidateCodesMutation = { __typename?: 'Mutation', transferRequestImportValidateCodes: { __typename?: 'TransferRequestImportValidateCodesResult', missingBranchCodes: Array<string>, missingWarehouseCodes: Array<string>, missingProductCodes: Array<string>, consignmentProductCodes: Array<string>, duplicateProductCodes: Array<string>, rowReport?: { __typename?: 'TransferRequestImportRowReport', totalRows: number, validRowCount: number, invalidRowCount: number, violationSample: Array<{ __typename?: 'TransferRequestImportRowViolation', rowNumber: number, standardKey: string, label: string, reason: string, value: string }> } | null } };

export type TransferRequestItemsQueryVariables = Exact<{
  qop: TransferRequestItemQopInput;
}>;


export type TransferRequestItemsQuery = { __typename?: 'Query', transferRequestItems: { __typename?: 'TransferRequestItemPaged', items: Array<{ __typename?: 'TransferRequestItem', transferRequestItemID: any, transferRequestID: any, productID: any, productCode: string, productName: string, description: string, productWeight: number, qtyRequested: number, qtyApproved: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQtyRequested: number, baseUomQtyApproved: number, noteApprover?: string | null, noteRequester?: string | null, product: { __typename?: 'Product', barcode: string }, availability?: { __typename?: 'TransferRequestItemAvailability', warehouseID: any, qtyAvailable: number, qtyOutstandingIn: number, qtyOutstandingOut: number, qtyRealAvailable: number } | null }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type TransferRequestListQueryVariables = Exact<{
  qop?: InputMaybe<TransferRequestQopInput>;
}>;


export type TransferRequestListQuery = { __typename?: 'Query', transferRequests: { __typename?: 'TransferRequestPaged', items: Array<{ __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string, transferRequestDatetime: any, transferRequestDatetimeUtc: any, scheduledDeliveryDate?: any | null, transferOrderID?: any | null, transferOrderNumber?: string | null, branchID: any, branchCode: string, branchName: string, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, totalItemQtyRequested: number, totalItemQtyApproved: number, submittedDatetime?: any | null, submittedDatetimeUtc?: any | null, submittedByUserID?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedDatetimeUtc?: any | null, approvedByUserID?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedDatetimeUtc?: any | null, rejectedByUserID?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteApprover?: string | null, status: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type TransferRequestLoadQueryVariables = Exact<{
  transferRequestID: Scalars['UUID']['input'];
}>;


export type TransferRequestLoadQuery = { __typename?: 'Query', transferRequest?: { __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string, transferRequestDatetime: any, transferRequestDatetimeUtc: any, scheduledDeliveryDate?: any | null, transferOrderID?: any | null, transferOrderNumber?: string | null, branchID: any, branchCode: string, branchName: string, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, totalItemQtyRequested: number, totalItemQtyApproved: number, submittedDatetime?: any | null, submittedDatetimeUtc?: any | null, submittedByUserID?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedDatetimeUtc?: any | null, approvedByUserID?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedDatetimeUtc?: any | null, rejectedByUserID?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForApprover: string, noteApprover?: string | null, status: string, items: Array<{ __typename?: 'TransferRequestItem', transferRequestItemID: any, transferRequestID: any, productID: any, productCode: string, productName: string, description: string, productWeight: number, qtyRequested: number, qtyApproved: number, uomCategoryID: any, uomID: any, uomName: string, uomDecimal: number, uomConvertionRate: number, uomConversionDecimal: number, baseUomQtyRequested: number, baseUomQtyApproved: number, noteApprover?: string | null, noteRequester?: string | null, product: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, productType: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, uomCategoryID: any, baseUomID: any, description: string, productBrandID: any, productSourceID: any, productCategoryID: any, productSubCategoryID: any, addonGroupID?: any | null, hasAddon: boolean, mainImageFileID?: any | null, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, isConsignment: boolean, consignmentVendorID?: any | null, trackExpiredDate: boolean, isProduced: boolean, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, canBePurchased: boolean, purchaseCost?: number | null, minimumOrder: number, purchaseUomID?: any | null, purchaseTaxID?: any | null, canBeSold: boolean, sellingPrice?: number | null, salesUomID?: any | null, salesTaxID?: any | null, salesScanType?: string | null, uniqueKey: string, isActive: boolean } }> } | null };

export type TransferRequestRejectMutationVariables = Exact<{
  input: TransferRequestRejectInput;
}>;


export type TransferRequestRejectMutation = { __typename?: 'Mutation', transferRequestReject: { __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string, transferRequestDatetime: any, transferRequestDatetimeUtc: any, scheduledDeliveryDate?: any | null, branchID: any, branchCode: string, branchName: string, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, totalItemQtyRequested: number, totalItemQtyApproved: number, submittedDatetime?: any | null, submittedDatetimeUtc?: any | null, submittedByUserID?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedDatetimeUtc?: any | null, approvedByUserID?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedDatetimeUtc?: any | null, rejectedByUserID?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteApprover?: string | null, status: string } };

export type TransferRequestSubmitMutationVariables = Exact<{
  input: TransferRequestSubmitInput;
}>;


export type TransferRequestSubmitMutation = { __typename?: 'Mutation', transferRequestSubmit: { __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string, transferRequestDatetime: any, transferRequestDatetimeUtc: any, scheduledDeliveryDate?: any | null, branchID: any, branchCode: string, branchName: string, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, totalItemQtyRequested: number, totalItemQtyApproved: number, submittedDatetime?: any | null, submittedDatetimeUtc?: any | null, submittedByUserID?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedDatetimeUtc?: any | null, approvedByUserID?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedDatetimeUtc?: any | null, rejectedByUserID?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteApprover?: string | null, status: string } };

export type TransferRequestUpdateMutationVariables = Exact<{
  input: TransferRequestUpdateInput;
}>;


export type TransferRequestUpdateMutation = { __typename?: 'Mutation', transferRequestUpdate: { __typename?: 'TransferRequest', transferRequestID: any, transferRequestNumber: string, transferRequestDatetime: any, transferRequestDatetimeUtc: any, scheduledDeliveryDate?: any | null, branchID: any, branchCode: string, branchName: string, gmt: number, fromWarehouseID: any, fromWarehouseCode: string, fromWarehouseName: string, toWarehouseID: any, toWarehouseCode: string, toWarehouseName: string, totalItemQtyRequested: number, totalItemQtyApproved: number, submittedDatetime?: any | null, submittedDatetimeUtc?: any | null, submittedByUserID?: any | null, submittedByUserName?: string | null, approvedDatetime?: any | null, approvedDatetimeUtc?: any | null, approvedByUserID?: any | null, approvedByUserName?: string | null, rejectedDatetime?: any | null, rejectedDatetimeUtc?: any | null, rejectedByUserID?: any | null, rejectedByUserName?: string | null, rejectionReason?: string | null, cancelledDatetime?: any | null, cancelledDatetimeUtc?: any | null, cancelledByUserID?: any | null, cancelledByUserName?: string | null, cancellationReason?: string | null, noteInternal: string, noteForApprover: string, status: string } };

export type UomCategoryAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<UomCategoryQopInput>;
}>;


export type UomCategoryAutocompleteQuery = { __typename?: 'Query', uomCategories: { __typename?: 'UomCategoryPaged', items: Array<{ __typename?: 'UomCategory', uomCategoryID: any, uomCategoryName: string }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type UomCategoryCreateMutationVariables = Exact<{
  input: UomCategoryCreateInput;
}>;


export type UomCategoryCreateMutation = { __typename?: 'Mutation', uomCategoryCreate: { __typename?: 'UomCategory', uomCategoryID: any, uomCategoryName: string, description: string, baseUom: string, uomItems: string, uniqueKey: string, isActive: boolean } };

export type UomCategoryDeleteMutationVariables = Exact<{
  input: UomCategoryDeleteInput;
}>;


export type UomCategoryDeleteMutation = { __typename?: 'Mutation', uomCategoryDelete: boolean };

export type UomCategoryListQueryVariables = Exact<{
  qop?: InputMaybe<UomCategoryQopInput>;
}>;


export type UomCategoryListQuery = { __typename?: 'Query', uomCategories: { __typename?: 'UomCategoryPaged', items: Array<{ __typename?: 'UomCategory', uomCategoryID: any, uomCategoryName: string, description: string, baseUom: string, uomItems: string, uniqueKey: string, isActive: boolean, uoms: Array<{ __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type UomCategoryLoadQueryVariables = Exact<{
  uomCategoryID: Scalars['UUID']['input'];
}>;


export type UomCategoryLoadQuery = { __typename?: 'Query', uomCategory: { __typename?: 'UomCategory', uomCategoryID: any, uomCategoryName: string, description: string, baseUom: string, uomItems: string, uniqueKey: string, isActive: boolean, nonMainUoms: Array<{ __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean }>, uoms: Array<{ __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionDecimal: number, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type UomCategoryUpdateMutationVariables = Exact<{
  input: UomCategoryUpdateInput;
}>;


export type UomCategoryUpdateMutation = { __typename?: 'Mutation', uomCategoryUpdate: { __typename?: 'UomCategory', uomCategoryID: any, uomCategoryName: string, description: string, baseUom: string, uomItems: string, uniqueKey: string, isActive: boolean } };

export type UomsQueryVariables = Exact<{
  qop?: InputMaybe<UomQopInput>;
}>;


export type UomsQuery = { __typename?: 'Query', uoms: { __typename?: 'UomPaged', items: Array<{ __typename?: 'Uom', uomID: any, uomCategoryID: any, uomName: string, relationType: string, convertionRate: number, convertionRateMultiplier: number, convertionDecimal: number, conversionInfo: string, isMain: boolean, uniqueKey: string, uniqueKey2: string, isActive: boolean }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type UomAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<UomQopInput>;
}>;


export type UomAutocompleteQuery = { __typename?: 'Query', uoms: { __typename?: 'UomPaged', items: Array<{ __typename?: 'Uom', uomID: any, uomName: string, uomCategoryID: any }>, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type UomLoadMiniQueryVariables = Exact<{
  uomID: Scalars['UUID']['input'];
}>;


export type UomLoadMiniQuery = { __typename?: 'Query', uom: { __typename?: 'Uom', uomID: any, uomName: string } };

export type ShiftSessionCloseMutationVariables = Exact<{
  input: ShiftSessionCloseInput;
}>;


export type ShiftSessionCloseMutation = { __typename?: 'Mutation', shiftSessionClose: { __typename?: 'ShiftSessionCloseResult', shiftSession: { __typename?: 'ShiftSession', shiftSessionID: any, status: string, endingCashBalance?: number | null, cashBalanceDiff: number, isCashBalanceDiff: boolean, sessionCloseTime?: any | null } } };

export type ShiftSessionListQueryVariables = Exact<{
  qop?: InputMaybe<ShiftSessionQopInput>;
}>;


export type ShiftSessionListQuery = { __typename?: 'Query', shiftSessions: { __typename?: 'ShiftSessionPaged', items?: Array<{ __typename?: 'ShiftSession', shiftSessionID: any, userID: any, userName: string, employeeID: any, employeeName: string, branchID: any, gmt: number, sessionOpenTime: any, sessionCloseTime?: any | null, sessionDuration: number, openingCashBalance: number, endingCashBalance?: number | null, totalTransactionAmount: number, cashTransactionAmount: number, nonCashTransactionAmount: number, cashBalanceDiff: number, isCashBalanceDiff: boolean, voucherTransactionCount: number, voucherTransactionAmount: number, isResolved: boolean, resolutionStatus: string, status: string }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type ShiftSessionLoadQueryVariables = Exact<{
  shiftSessionID: Scalars['UUID']['input'];
}>;


export type ShiftSessionLoadQuery = { __typename?: 'Query', shiftSession: { __typename?: 'ShiftSession', shiftSessionID: any, userID: any, userName: string, employeeID: any, employeeName: string, branchID: any, gmt: number, sessionOpenTime: any, sessionOpenTimeUtc: any, sessionCloseTime?: any | null, sessionCloseTimeUtc?: any | null, sessionDuration: number, openingCashBalance: number, endingCashBalance?: number | null, totalTransactionAmount: number, cashTransactionAmount: number, nonCashTransactionAmount: number, cashBalanceDiff: number, isCashBalanceDiff: boolean, voucherTransactionCount: number, voucherTransactionAmount: number, isResolved: boolean, resolutionStatus: string, resolutionNote: string, resolvedAt?: any | null, resolvedAtUtc?: any | null, resolvedByUserID?: any | null, resolvedByUserName: string, status: string, branch: { __typename?: 'Branch', branchID: any, branchName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, createdAt: any, updatedAt: any } } };

export type ShiftSessionRecomputeMutationVariables = Exact<{
  shiftSessionID: Scalars['UUID']['input'];
}>;


export type ShiftSessionRecomputeMutation = { __typename?: 'Mutation', shiftSessionRecompute: { __typename?: 'ShiftSession', shiftSessionID: any, status: string, totalTransactionAmount: number, cashTransactionAmount: number, nonCashTransactionAmount: number, voucherTransactionCount: number, voucherTransactionAmount: number, cashBalanceDiff: number, isCashBalanceDiff: boolean, isResolved: boolean } };

export type ShiftSessionResolveCashDiffMutationVariables = Exact<{
  input: ShiftSessionResolveCashDiffInput;
}>;


export type ShiftSessionResolveCashDiffMutation = { __typename?: 'Mutation', shiftSessionResolveCashDiff: { __typename?: 'ShiftSession', shiftSessionID: any, status: string, isResolved: boolean, resolutionStatus: string, resolutionNote: string, resolvedAt?: any | null, resolvedByUserName: string } };

export type VendorAppBranchStockQueryVariables = Exact<{
  qop: VendorConsignmentStockByBranchQopInput;
}>;


export type VendorAppBranchStockQuery = { __typename?: 'Query', vendorConsignmentStockByBranch: { __typename?: 'VendorConsignmentStockByBranchPaged', items?: Array<{ __typename?: 'VendorConsignmentStockByBranchItem', branchID: any, branchName: string, productID: any, qty: any, qtyCommitted: any, qtyRejected: any, qtyOnHand: any, qtyAvailable: any, updatedAt?: any | null, product?: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, productType: string, isActive: boolean, baseUom?: { __typename?: 'Uom', uomName: string } | null } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppProductListQueryVariables = Exact<{
  qop?: InputMaybe<ProductQopInput>;
}>;


export type VendorAppProductListQuery = { __typename?: 'Query', products: { __typename?: 'ProductPaged', items?: Array<{ __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, productType: string, consignmentVendorID?: any | null, isActive: boolean, mainImageFileSmallPathURL?: string | null, baseUom?: { __typename?: 'Uom', uomName: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppProductLoadQueryVariables = Exact<{
  productID: Scalars['UUID']['input'];
}>;


export type VendorAppProductLoadQuery = { __typename?: 'Query', product: { __typename?: 'Product', productID: any, productCode: string, productName: string, productNameAlias: string, barcode: string, altBarcode1?: string | null, altBarcode2?: string | null, productType: string, description: string, weight: number, volumeLength: number, volumeHeight: number, volumeWidth: number, isConsignment: boolean, consignmentVendorID?: any | null, isActive: boolean, mainImageFileSmallPathURL?: string | null, mainImageFileMediumPathURL?: string | null, mainImageFileLargePathURL?: string | null, baseUom?: { __typename?: 'Uom', uomName: string } | null, productBrand?: { __typename?: 'ProductBrand', productBrandName: string } | null, productCategory?: { __typename?: 'ProductCategory', productCategoryName: string } | null, productSubCategory?: { __typename?: 'ProductSubCategory', productSubCategoryName: string } | null, productFiles: Array<{ __typename?: 'ProductFile', productFileID: any, imageFileMediumPathURL: string }> } };

export type VendorAppRentalBranchListQueryVariables = Exact<{
  vendorID: Scalars['UUID']['input'];
}>;


export type VendorAppRentalBranchListQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', vendorID: any, vendorName: string, vendorConsignmentBranch: Array<{ __typename?: 'VendorConsignmentBranch', vendorConsignmentBranchID: any, branchID: any, branchCode: string, branchName: string, isRent: boolean, rentPrice: number, isActive: boolean, currentPeriod?: { __typename?: 'VendorConsignmentBranchPeriod', vendorConsignmentBranchPeriodID: any, effectiveStartDate?: any | null, effectiveEndDate?: any | null, rentalStatus: string } | null }> } };

export type VendorAppRentalPaymentCancelMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentCancelInput;
}>;


export type VendorAppRentalPaymentCancelMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentCancel: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string } };

export type VendorAppRentalPaymentCreateMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentCreateInput;
}>;


export type VendorAppRentalPaymentCreateMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentCreate: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, transferAmount: number, transferDate: any } };

export type VendorAppRentalPaymentListQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentRentalPaymentQopInput>;
}>;


export type VendorAppRentalPaymentListQuery = { __typename?: 'Query', vendorConsignmentRentalPayments: { __typename?: 'VendorConsignmentRentalPaymentPaged', items?: Array<{ __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, vendorConsignmentRentalPaymentNumber: string, vendorConsignmentBranchID: any, vendorID: any, vendorName: string, branchID: any, branchName: string, transferAmount: number, transferDate: any, vendorNote: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, status: string, approvedAt?: any | null, rejectedReason: string, rejectedAt?: any | null, files?: Array<{ __typename?: 'VendorConsignmentRentalPaymentFile', vendorConsignmentRentalPaymentFileID: any, vendorConsignmentRentalPaymentFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorAppRentalPaymentLoadQueryVariables = Exact<{
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
}>;


export type VendorAppRentalPaymentLoadQuery = { __typename?: 'Query', vendorConsignmentRentalPayment?: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, vendorConsignmentRentalPaymentNumber: string, vendorConsignmentBranchID: any, vendorID: any, vendorName: string, branchID: any, branchName: string, transferAmount: number, transferDate: any, vendorNote: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, effectiveStartDate: any, effectiveEndDate: any, status: string, settlementBankName: string, settlementBankAccountNumber: string, approvedByUserName: string, approvedAt?: any | null, rejectedReason: string, rejectedByUserName: string, rejectedAt?: any | null, files?: Array<{ __typename?: 'VendorConsignmentRentalPaymentFile', vendorConsignmentRentalPaymentFileID: any, vendorConsignmentRentalPaymentFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any } } | null };

export type VendorAppRentalPaymentSubmitMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentSubmitInput;
}>;


export type VendorAppRentalPaymentSubmitMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentSubmit: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string } };

export type VendorAppRentalPaymentUpdateMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentUpdateInput;
}>;


export type VendorAppRentalPaymentUpdateMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentUpdate: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string, transferAmount: number, transferDate: any } };

export type VendorAppSalesItemsListQueryVariables = Exact<{
  qop?: InputMaybe<SalesConsignmentInvoiceItemQopInput>;
}>;


export type VendorAppSalesItemsListQuery = { __typename?: 'Query', salesConsignmentInvoiceItems: { __typename?: 'SalesConsignmentInvoiceItemPaged', items: Array<{ __typename?: 'SalesConsignmentInvoiceItem', salesConsignmentInvoiceItemID: any, productID: any, productCode: string, productName: string, barcode: string, qty: number, uomName: string, unitPrice: number, discountType: string, discountPerc: number, discountPercPlus: string, discountAmount: number, additionalDiscountPerc?: number | null, additionalDiscountAmount?: number | null, commissionAmount?: number | null, taxAmount: number, consignmentVendorTotal: number, salesConsignmentInvoice: { __typename?: 'SalesConsignmentInvoice', salesConsignmentInvoiceID: any, salesConsignmentInvoiceNumber: string, salesConsignmentInvoiceDatetime: any, salesConsignmentInvoiceDatetimeUtc: any, salesInvoiceID: any, salesInvoiceNumber: string, consignmentVendorID?: any | null, consignmentCommissionFeePerc?: number | null, totalItemQty: number, subtotal: number, discountAmount: number, taxAmount: number, commissionAmount: number, total: number, consignmentVendorTotal: number, status: string } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppSalesListQueryVariables = Exact<{
  qop?: InputMaybe<SalesConsignmentInvoiceQopInput>;
}>;


export type VendorAppSalesListQuery = { __typename?: 'Query', salesConsignmentInvoices: { __typename?: 'SalesConsignmentInvoicePaged', items: Array<{ __typename?: 'SalesConsignmentInvoice', salesConsignmentInvoiceID: any, salesConsignmentInvoiceNumber: string, salesConsignmentInvoiceDatetime: any, salesConsignmentInvoiceDatetimeUtc: any, salesInvoiceID: any, salesInvoiceNumber: string, consignmentVendorID?: any | null, consignmentCommissionFeePerc?: number | null, totalItemQty: number, subtotal: number, discountAmount: number, taxAmount: number, commissionAmount: number, total: number, consignmentVendorTotal: number, status: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppSalesLoadQueryVariables = Exact<{
  salesConsignmentInvoiceID: Scalars['UUID']['input'];
}>;


export type VendorAppSalesLoadQuery = { __typename?: 'Query', salesConsignmentInvoice?: { __typename?: 'SalesConsignmentInvoice', salesConsignmentInvoiceID: any, salesConsignmentInvoiceNumber: string, salesConsignmentInvoiceDatetime: any, salesInvoiceID: any, salesInvoiceNumber: string, consignmentVendorID?: any | null, totalItemQty: number, status: string } | null };

export type VendorAppStockInItemsListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInItemQopInput>;
}>;


export type VendorAppStockInItemsListQuery = { __typename?: 'Query', consignmentStockInItems: { __typename?: 'ConsignmentStockInItemPaged', items: Array<{ __typename?: 'ConsignmentStockInItem', consignmentStockInItemID: any, consignmentStockInID: any, productID: any, productCode: string, productName: string, qtyReceived: number, uomName: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockInListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockInQopInput>;
}>;


export type VendorAppStockInListQuery = { __typename?: 'Query', consignmentStockIns: { __typename?: 'ConsignmentStockInPaged', items: Array<{ __typename?: 'ConsignmentStockIn', consignmentStockInID: any, consignmentStockInNumber: string, consignmentStockInDatetime: any, vendorID: any, warehouseID: any, externalReferenceNumber?: string | null, receivedByName?: string | null, totalItemQtyReceived: number, status: string, warehouse: { __typename?: 'Warehouse', warehouseName: string, branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string } | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockInLoadQueryVariables = Exact<{
  consignmentStockInID: Scalars['UUID']['input'];
}>;


export type VendorAppStockInLoadQuery = { __typename?: 'Query', consignmentStockIn?: { __typename?: 'ConsignmentStockIn', consignmentStockInID: any, consignmentStockInNumber: string, consignmentStockInDatetime: any, status: string, externalReferenceNumber?: string | null, receivedByName?: string | null, totalItemQtyReceived: number, warehouse: { __typename?: 'Warehouse', warehouseName: string, branch?: { __typename?: 'Branch', branchName: string } | null } } | null };

export type VendorAppStockOutItemsListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockOutItemQopInput>;
}>;


export type VendorAppStockOutItemsListQuery = { __typename?: 'Query', consignmentStockOutItems: { __typename?: 'ConsignmentStockOutItemPaged', items: Array<{ __typename?: 'ConsignmentStockOutItem', consignmentStockOutItemID: any, consignmentStockOutID: any, productID: any, productCode: string, productName: string, qty: number, uomName: string }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockOutListQueryVariables = Exact<{
  qop?: InputMaybe<ConsignmentStockOutQopInput>;
}>;


export type VendorAppStockOutListQuery = { __typename?: 'Query', consignmentStockOuts: { __typename?: 'ConsignmentStockOutPaged', items: Array<{ __typename?: 'ConsignmentStockOut', consignmentStockOutID: any, consignmentStockOutNumber: string, consignmentStockOutDatetime: any, vendorID: any, warehouseID: any, externalReferenceNumber?: string | null, receivedByVendorName?: string | null, totalItemQty: number, status: string, warehouse: { __typename?: 'Warehouse', warehouseName: string, branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string } | null } }>, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, totalPages?: number | null, hasNext?: boolean | null } } };

export type VendorAppStockOutLoadQueryVariables = Exact<{
  consignmentStockOutID: Scalars['UUID']['input'];
}>;


export type VendorAppStockOutLoadQuery = { __typename?: 'Query', consignmentStockOut?: { __typename?: 'ConsignmentStockOut', consignmentStockOutID: any, consignmentStockOutNumber: string, consignmentStockOutDatetime: any, status: string, externalReferenceNumber?: string | null, receivedByVendorName?: string | null, totalItemQty: number, warehouse: { __typename?: 'Warehouse', warehouseName: string, branch?: { __typename?: 'Branch', branchName: string } | null } } | null };

export type VendorConsignmentDashboardQueryVariables = Exact<{
  filter: VendorConsignmentDashboardFilterInput;
}>;


export type VendorConsignmentDashboardQuery = { __typename?: 'Query', vendorConsignmentDashboard: { __typename?: 'VendorConsignmentDashboard', summary: { __typename?: 'VendorConsignmentDashboardSummary', grossSales: number, commissionAmount: number, vendorShareAmount: number, unitsSold: number, invoiceCount: number }, salesByBranch: Array<{ __typename?: 'VendorConsignmentDashboardBranchPoint', branchID: any, grossSales: number, vendorShareAmount: number, invoiceCount: number }>, topProducts: Array<{ __typename?: 'VendorConsignmentDashboardProductPoint', productID: any, productName: string, qty: number, grossSales: number, vendorShareAmount: number }>, topProductsByRevenue: Array<{ __typename?: 'VendorConsignmentDashboardProductPoint', productID: any, productName: string, qty: number, grossSales: number, vendorShareAmount: number }> } };

export type VendorConsignmentSalesExportQueryVariables = Exact<{
  filter: VendorConsignmentSalesExportFilterInput;
}>;


export type VendorConsignmentSalesExportQuery = { __typename?: 'Query', vendorConsignmentSalesExport: { __typename?: 'VendorConsignmentSalesExportResult', fileName: string, downloadURL: string } };

export type VendorStockExportQueryVariables = Exact<{
  filter: VendorStockExportFilterInput;
}>;


export type VendorStockExportQuery = { __typename?: 'Query', vendorStockExport: { __typename?: 'VendorStockExportResult', fileName: string, downloadURL: string } };

export type VendorCategoryAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<VendorCategoryQopInput>;
}>;


export type VendorCategoryAutocompleteQuery = { __typename?: 'Query', vendorCategories: { __typename?: 'VendorCategoryPaged', items?: Array<{ __typename?: 'VendorCategory', vendorCategoryID: any, vendorCategoryName: string }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorCategoryCreateMutationVariables = Exact<{
  input: VendorCategoryCreateInput;
}>;


export type VendorCategoryCreateMutation = { __typename?: 'Mutation', vendorCategoryCreate: { __typename?: 'VendorCategory', vendorCategoryID: any, vendorCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type VendorCategoryDeleteMutationVariables = Exact<{
  vendorCategoryID: Scalars['UUID']['input'];
}>;


export type VendorCategoryDeleteMutation = { __typename?: 'Mutation', vendorCategoryDelete: boolean };

export type VendorCategoryListQueryVariables = Exact<{
  qop?: InputMaybe<VendorCategoryQopInput>;
}>;


export type VendorCategoryListQuery = { __typename?: 'Query', vendorCategories: { __typename?: 'VendorCategoryPaged', items?: Array<{ __typename?: 'VendorCategory', vendorCategoryID: any, vendorCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorCategoryLoadQueryVariables = Exact<{
  vendorCategoryID: Scalars['UUID']['input'];
}>;


export type VendorCategoryLoadQuery = { __typename?: 'Query', vendorCategory: { __typename?: 'VendorCategory', vendorCategoryID: any, vendorCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type VendorCategoryUpdateMutationVariables = Exact<{
  input: VendorCategoryUpdateInput;
}>;


export type VendorCategoryUpdateMutation = { __typename?: 'Mutation', vendorCategoryUpdate: { __typename?: 'VendorCategory', vendorCategoryID: any, vendorCategoryName: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type VendorConsignmentRentalPaymentApproveMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentApproveInput;
}>;


export type VendorConsignmentRentalPaymentApproveMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentApprove: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string, approvedByUserName: string, approvedAt?: any | null } };

export type VendorConsignmentRentalPaymentListQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentRentalPaymentQopInput>;
}>;


export type VendorConsignmentRentalPaymentListQuery = { __typename?: 'Query', vendorConsignmentRentalPayments: { __typename?: 'VendorConsignmentRentalPaymentPaged', items?: Array<{ __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, vendorConsignmentRentalPaymentNumber: string, vendorConsignmentBranchID: any, vendorID: any, vendorName: string, branchID: any, branchName: string, transferAmount: number, transferDate: any, vendorNote: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, effectiveStartDate: any, effectiveEndDate: any, status: string, approvedByUserName: string, approvedAt?: any | null, rejectedReason: string, rejectedByUserName: string, rejectedAt?: any | null, files?: Array<{ __typename?: 'VendorConsignmentRentalPaymentFile', vendorConsignmentRentalPaymentFileID: any, vendorConsignmentRentalPaymentFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorConsignmentRentalPaymentLoadQueryVariables = Exact<{
  vendorConsignmentRentalPaymentID: Scalars['UUID']['input'];
}>;


export type VendorConsignmentRentalPaymentLoadQuery = { __typename?: 'Query', vendorConsignmentRentalPayment?: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, vendorConsignmentRentalPaymentNumber: string, vendorConsignmentBranchID: any, vendorID: any, vendorName: string, branchID: any, branchName: string, transferAmount: number, transferDate: any, vendorNote: string, rentPriceSnapshot: number, rentPeriodDaysSnapshot: number, effectiveStartDate: any, effectiveEndDate: any, status: string, settlementBankAccountID?: any | null, settlementBankName: string, settlementBankAccountNumber: string, approvedByUserName: string, approvedAt?: any | null, rejectedReason: string, rejectedByUserName: string, rejectedAt?: any | null, files?: Array<{ __typename?: 'VendorConsignmentRentalPaymentFile', vendorConsignmentRentalPaymentFileID: any, vendorConsignmentRentalPaymentFileType: string, fileID: any, imageFileSmallPathURL: string, imageFileMediumPathURL: string, imageFileLargePathURL: string }> | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdAt: any, updatedAt: any } } | null };

export type VendorConsignmentRentalPaymentRejectMutationVariables = Exact<{
  input: VendorConsignmentRentalPaymentRejectInput;
}>;


export type VendorConsignmentRentalPaymentRejectMutation = { __typename?: 'Mutation', vendorConsignmentRentalPaymentReject: { __typename?: 'VendorConsignmentRentalPayment', vendorConsignmentRentalPaymentID: any, status: string, rejectedReason: string, rejectedByUserName: string, rejectedAt?: any | null } };

export type VendorConsignmentBranchPeriodGrantMutationVariables = Exact<{
  input: VendorConsignmentBranchPeriodGrantInput;
}>;


export type VendorConsignmentBranchPeriodGrantMutation = { __typename?: 'Mutation', vendorConsignmentBranchPeriodGrant: { __typename?: 'VendorConsignmentBranchPeriod', vendorConsignmentBranchPeriodID: any, rentalStatus: string, effectiveStartDate?: any | null, effectiveEndDate?: any | null } };

export type VendorConsignmentBranchPeriodListQueryVariables = Exact<{
  qop?: InputMaybe<VendorConsignmentBranchPeriodQopInput>;
}>;


export type VendorConsignmentBranchPeriodListQuery = { __typename?: 'Query', vendorConsignmentBranchPeriods: { __typename?: 'VendorConsignmentBranchPeriodPaged', items?: Array<{ __typename?: 'VendorConsignmentBranchPeriod', vendorConsignmentBranchPeriodID: any, vendorConsignmentBranchID: any, vendorID: any, branchID: any, effectiveStartDate?: any | null, effectiveEndDate?: any | null, daysGrantedTotal: number, rentalStatus: string, suspendedReason: string, suspendedByUserName: string, suspendedAt?: any | null, revokedReason: string, revokedByUserName: string, revokedAt?: any | null, lastGrantSource: string, lastGrantSourcePaymentID?: any | null, lastGrantSourcePaymentNumber: string, lastGrantedByUserName: string, lastGrantedAt?: any | null, vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string }, branch: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserName?: string | null, updatedByUserName?: string | null, createdAt: any, updatedAt: any, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorConsignmentBranchPeriodResumeMutationVariables = Exact<{
  input: VendorConsignmentBranchPeriodResumeInput;
}>;


export type VendorConsignmentBranchPeriodResumeMutation = { __typename?: 'Mutation', vendorConsignmentBranchPeriodResume: { __typename?: 'VendorConsignmentBranchPeriod', vendorConsignmentBranchPeriodID: any, rentalStatus: string } };

export type VendorConsignmentBranchPeriodSuspendMutationVariables = Exact<{
  input: VendorConsignmentBranchPeriodSuspendInput;
}>;


export type VendorConsignmentBranchPeriodSuspendMutation = { __typename?: 'Mutation', vendorConsignmentBranchPeriodSuspend: { __typename?: 'VendorConsignmentBranchPeriod', vendorConsignmentBranchPeriodID: any, rentalStatus: string, suspendedReason: string, suspendedAt?: any | null } };

export type VendorCreateAccessMutationVariables = Exact<{
  input: VendorCreateAccessInput;
}>;


export type VendorCreateAccessMutation = { __typename?: 'Mutation', vendorCreateAccess: { __typename?: 'Vendor', vendorID: any } };

export type VendorUpdateAccessMutationVariables = Exact<{
  input: VendorUpdateAccessInput;
}>;


export type VendorUpdateAccessMutation = { __typename?: 'Mutation', vendorUpdateAccess: { __typename?: 'Vendor', vendorID: any } };

export type VendorAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<VendorQopInput>;
}>;


export type VendorAutocompleteQuery = { __typename?: 'Query', vendors: { __typename?: 'VendorPaged', items?: Array<{ __typename?: 'Vendor', vendorID: any, vendorName: string, taxIncluded?: boolean | null, vendorCode: string, cityID: string, cityName: string, taxable?: boolean | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorConsignmentBranchDeleteMutationVariables = Exact<{
  vendorConsignmentBranchID: Scalars['UUID']['input'];
}>;


export type VendorConsignmentBranchDeleteMutation = { __typename?: 'Mutation', vendorConsignmentBranchDelete: boolean };

export type VendorCreateMutationVariables = Exact<{
  input: VendorCreateInput;
}>;


export type VendorCreateMutation = { __typename?: 'Mutation', vendorCreate: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, isConsignment?: boolean | null, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, uniqueKey: string, isActive?: boolean | null } };

export type VendorDeleteMutationVariables = Exact<{
  input: VendorDeleteInput;
}>;


export type VendorDeleteMutation = { __typename?: 'Mutation', vendorDelete: boolean };

export type VendorListQueryVariables = Exact<{
  qop?: InputMaybe<VendorQopInput>;
}>;


export type VendorListQuery = { __typename?: 'Query', vendors: { __typename?: 'VendorPaged', items?: Array<{ __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, isPKP: boolean, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentCommisionFeePerc?: number | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VendorLoadQueryVariables = Exact<{
  vendorID: Scalars['UUID']['input'];
}>;


export type VendorLoadQuery = { __typename?: 'Query', vendor: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, vendorCategoryID: any, bankID?: any | null, bankName?: string | null, bankAccountName?: string | null, bankAccountNumber?: string | null, email: string, phoneNumber: string, npwp: string, npwpCompanyName: string, isPKP: boolean, taxable?: boolean | null, taxpayerIDNumber: string, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, taxIncluded?: boolean | null, canBeReturned?: boolean | null, isConsignment?: boolean | null, consignmentPeriodStartDate?: any | null, consignmentPeriodEndDate?: any | null, hasPortalAccess?: boolean | null, portalSuperadminFirstName?: string | null, portalSuperadminLastName?: string | null, portalSuperadminEmail?: string | null, portalAccountActivated?: boolean | null, uniqueKey: string, isActive?: boolean | null, vendorCategory: { __typename?: 'VendorCategory', vendorCategoryName: string }, vendorPicContacts: Array<{ __typename?: 'VendorPicContact', vendorPicContactID: any, vendorID: any, picName: string, picDepartment: string, picEmail: string, picPhoneNumber: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, vendorConsignmentProducts: Array<{ __typename?: 'VendorConsignmentProduct', productID: any, sellingPrice: number, product: { __typename?: 'Product', productCode: string, productName: string, barcode: string, baseUom?: { __typename?: 'Uom', uomName: string } | null } }>, vendorConsignmentBranch: Array<{ __typename?: 'VendorConsignmentBranch', vendorConsignmentBranchID: any, vendorID: any, branchID: any, branchCode: string, branchName: string, commissionFeePerc: number, isRent: boolean, rentPrice: number, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }>, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } };

export type VendorConsignmentProductCreateMutationVariables = Exact<{
  input: VendorConsignmentProductCreateInput;
}>;


export type VendorConsignmentProductCreateMutation = { __typename?: 'Mutation', vendorConsignmentProductCreate: { __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any } };

export type VendorConsignmentProductDeleteMutationVariables = Exact<{
  vendorConsignmentProductID: Scalars['UUID']['input'];
}>;


export type VendorConsignmentProductDeleteMutation = { __typename?: 'Mutation', vendorConsignmentProductDelete: boolean };

export type VendorConsignmentProductListQueryVariables = Exact<{
  qop: VendorConsignmentProductQopInput;
}>;


export type VendorConsignmentProductListQuery = { __typename?: 'Query', vendorConsignmentProducts: { __typename?: 'VendorConsignmentProductAggregatedPaged', items?: Array<{ __typename?: 'VendorConsignmentProductAggregated', productID: any, product: { __typename?: 'Product', productCode: string, productName: string, barcode: string, sellingPrice?: number | null, isActive: boolean, baseUom?: { __typename?: 'Uom', uomName: string } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }, branchPrices: Array<{ __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any, sellingPrice: number, productCommissionFeePerc: number, isActive: boolean, branchID: any, branch: { __typename?: 'Branch', branchCode: string, branchName: string }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', version: any } }> }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type VendorConsignmentProductLoadQueryVariables = Exact<{
  vendorConsignmentProductID: Scalars['UUID']['input'];
}>;


export type VendorConsignmentProductLoadQuery = { __typename?: 'Query', vendorConsignmentProduct: { __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any, vendorID: any, productID: any, branchID: any, sellingPrice: number, isActive: boolean, uniqueKey: string } };

export type VendorConsignmentProductPricesUpdateMutationVariables = Exact<{
  input: VendorConsignmentProductPriceBulkUpdateInput;
}>;


export type VendorConsignmentProductPricesUpdateMutation = { __typename?: 'Mutation', vendorConsignmentProductPriceBulkUpdate: { __typename?: 'VendorConsignmentProductBulkUpdateResult', product: { __typename?: 'Product', productID: any }, updatedBranchPrices: Array<{ __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any }> } };

export type VendorConsignmentProductUpdateMutationVariables = Exact<{
  input: VendorConsignmentProductUpdateInput;
}>;


export type VendorConsignmentProductUpdateMutation = { __typename?: 'Mutation', vendorConsignmentProductUpdate: { __typename?: 'VendorConsignmentProduct', vendorConsignmentProductID: any } };

export type VendorSetPortalAccessActiveMutationVariables = Exact<{
  input: VendorSetPortalAccessActiveInput;
}>;


export type VendorSetPortalAccessActiveMutation = { __typename?: 'Mutation', vendorSetPortalAccessActive: { __typename?: 'Vendor', vendorID: any, hasPortalAccess?: boolean | null } };

export type VendorUpdateMutationVariables = Exact<{
  input: VendorUpdateInput;
}>;


export type VendorUpdateMutation = { __typename?: 'Mutation', vendorUpdate: { __typename?: 'Vendor', vendorID: any, vendorCode: string, vendorName: string, isConsignment?: boolean | null, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude?: number | null, latitude?: number | null, uniqueKey: string, isActive?: boolean | null } };

export type VoucherCategoryAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<VoucherCategoryQopInput>;
}>;


export type VoucherCategoryAutocompleteQuery = { __typename?: 'Query', voucherCategories: { __typename?: 'VoucherCategoryPaged', items?: Array<{ __typename?: 'VoucherCategory', voucherCategoryID: any, voucherCategoryName: string, voucherType?: VoucherType | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type VoucherCategoryCreateMutationVariables = Exact<{
  input: VoucherCategoryCreateInput;
}>;


export type VoucherCategoryCreateMutation = { __typename?: 'Mutation', voucherCategoryCreate: { __typename?: 'VoucherCategory', voucherCategoryID: any } };

export type VoucherCategoryDeleteMutationVariables = Exact<{
  voucherCategoryID: Scalars['UUID']['input'];
}>;


export type VoucherCategoryDeleteMutation = { __typename?: 'Mutation', voucherCategoryDelete: boolean };

export type VoucherCategoryListQueryVariables = Exact<{
  qop?: InputMaybe<VoucherCategoryQopInput>;
}>;


export type VoucherCategoryListQuery = { __typename?: 'Query', voucherCategories: { __typename?: 'VoucherCategoryPaged', items?: Array<{ __typename?: 'VoucherCategory', voucherCategoryID: any, voucherCategoryName: string, expenseAccountCode: string, voucherType?: VoucherType | null, prefix: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type VoucherCategoryLoadQueryVariables = Exact<{
  voucherCategoryID: Scalars['UUID']['input'];
}>;


export type VoucherCategoryLoadQuery = { __typename?: 'Query', voucherCategory?: { __typename?: 'VoucherCategory', voucherCategoryID: any, voucherCategoryName: string, expenseAccountCode: string, expenseAccountErpRefID?: string | null, expenseAccountErpRefName?: string | null, voucherType?: VoucherType | null, prefix: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type VoucherCategoryUpdateMutationVariables = Exact<{
  input: VoucherCategoryUpdateInput;
}>;


export type VoucherCategoryUpdateMutation = { __typename?: 'Mutation', voucherCategoryUpdate: { __typename?: 'VoucherCategory', voucherCategoryID: any } };

export type VoucherCreateMutationVariables = Exact<{
  input: VoucherCreateInput;
}>;


export type VoucherCreateMutation = { __typename?: 'Mutation', voucherCreate: { __typename?: 'Voucher', voucherID: any } };

export type VoucherDeleteMutationVariables = Exact<{
  voucherID: Scalars['UUID']['input'];
}>;


export type VoucherDeleteMutation = { __typename?: 'Mutation', voucherDelete: boolean };

export type VoucherItemGenerateMutationVariables = Exact<{
  input: VoucherItemGenerateInput;
}>;


export type VoucherItemGenerateMutation = { __typename?: 'Mutation', voucherItemGenerate: Array<{ __typename?: 'VoucherItem', voucherItemID: any, voucherID: any }> };

export type VoucherItemListQueryVariables = Exact<{
  qop?: InputMaybe<VoucherItemQopInput>;
}>;


export type VoucherItemListQuery = { __typename?: 'Query', voucherItems: { __typename?: 'VoucherItemPaged', items?: Array<{ __typename?: 'VoucherItem', voucherItemID: any, voucherID: any, voucherCode: string, voucherItemCode: string, voucherValue: number, customerID?: any | null, customerCode: string, customerName: string, issuedTimeUTC: any, expiryDate: any, usedOnTransactionID?: any | null, usedOnTransactionNo: string, usedTimeUTC?: any | null, usedTime?: any | null, isVoid: boolean, status: string, uniqueKey: string, voucher?: { __typename?: 'Voucher', voucherID: any, voucherCode: string, voucherName: string, voucherCategoryID: any, voucherCategoryName: string, voucherCategoryPrefix: string, membersOnly: boolean, startDate: any, endDate: any, voucherExpiryType: VoucherExpiryType, expiredAfterDays: number, voucherValue: number, maxNumberOfVouchers: number, issuedCount: number, usedCount: number, voidCount: number, unusedCount: number, canBeUsedWithOthers: boolean, autoGenerateAllVouchers: boolean, description: string, uniqueKey: string, isActive: boolean } | null, customer?: { __typename?: 'Customer', customerID: any, customerCode: string, customerName: string, memberTypeID?: any | null, isMember: boolean, email?: string | null, phoneNumber: string, memberPoints: number, gender?: string | null, joinDate: any, isDefault: boolean, uniqueKey: string, isActive: boolean } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type VoucherItemVoidMutationVariables = Exact<{
  voucherItemID: Scalars['UUID']['input'];
}>;


export type VoucherItemVoidMutation = { __typename?: 'Mutation', voucherItemVoid: { __typename?: 'VoucherItem', voucherItemID: any } };

export type VoucherListQueryVariables = Exact<{
  qop: VoucherQopInput;
}>;


export type VoucherListQuery = { __typename?: 'Query', vouchers: { __typename?: 'VoucherPaged', items?: Array<{ __typename?: 'Voucher', voucherID: any, voucherCode: string, voucherName: string, voucherCategoryID: any, voucherCategoryName: string, voucherCategoryPrefix: string, membersOnly: boolean, startDate: any, endDate: any, voucherExpiryType: VoucherExpiryType, expiredAfterDays: number, voucherValue: number, maxNumberOfVouchers: number, issuedCount: number, usedCount: number, voidCount: number, unusedCount: number, canBeUsedWithOthers: boolean, autoGenerateAllVouchers: boolean, description: string, uniqueKey: string, isActive: boolean, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type VoucherLoadQueryVariables = Exact<{
  voucherID: Scalars['UUID']['input'];
}>;


export type VoucherLoadQuery = { __typename?: 'Query', voucher?: { __typename?: 'Voucher', voucherID: any, voucherCode: string, voucherName: string, voucherCategoryID: any, voucherCategoryName: string, voucherCategoryPrefix: string, membersOnly: boolean, startDate: any, endDate: any, voucherExpiryType: VoucherExpiryType, expiredAfterDays: number, voucherValue: number, maxNumberOfVouchers: number, issuedCount: number, usedCount: number, voidCount: number, unusedCount: number, canBeUsedWithOthers: boolean, autoGenerateAllVouchers: boolean, description: string, uniqueKey: string, isActive: boolean, voucherCategory?: { __typename?: 'VoucherCategory', voucherCategoryID: any, voucherCategoryName: string, prefix: string, expenseAccountCode: string, voucherType?: VoucherType | null, uniqueKey: string, uniqueKey2: string, isActive: boolean } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type VoucherLoadFromListQueryVariables = Exact<{
  voucherID: Scalars['UUID']['input'];
}>;


export type VoucherLoadFromListQuery = { __typename?: 'Query', vouchers: { __typename?: 'VoucherPaged', items?: Array<{ __typename?: 'Voucher', voucherID: any, voucherCode: string, voucherName: string, voucherCategoryID: any, voucherCategoryName: string, voucherCategoryPrefix: string, voucherType?: VoucherType | null, membersOnly: boolean, startDate: any, endDate: any, voucherExpiryType: VoucherExpiryType, expiredAfterDays: number, voucherValue: number, maxNumberOfVouchers: number, issuedCount: number, usedCount: number, voidCount: number, unusedCount: number, canBeUsedWithOthers: boolean, autoGenerateAllVouchers: boolean, description: string, uniqueKey: string, isActive: boolean, voucherCategory?: { __typename?: 'VoucherCategory', voucherCategoryID: any, voucherCategoryName: string, prefix: string, expenseAccountCode: string, uniqueKey: string, uniqueKey2: string, isActive: boolean } | null, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null } };

export type VoucherUpdateMutationVariables = Exact<{
  input: VoucherUpdateInput;
}>;


export type VoucherUpdateMutation = { __typename?: 'Mutation', voucherUpdate: { __typename?: 'Voucher', voucherID: any } };

export type WarehouseLocationGroupAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<WarehouseLocationGroupQopInput>;
}>;


export type WarehouseLocationGroupAutocompleteQuery = { __typename?: 'Query', warehouseLocationGroups: { __typename?: 'WarehouseLocationGroupPaged', items?: Array<{ __typename?: 'WarehouseLocationGroup', warehouseLocationGroupID: any, warehouseLocationGroupName: string, uniqueKey: string, isActive?: boolean | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type WarehouseLocationGroupCreateMutationVariables = Exact<{
  input: WarehouseLocationGroupCreateInput;
}>;


export type WarehouseLocationGroupCreateMutation = { __typename?: 'Mutation', warehouseLocationGroupCreate: { __typename?: 'WarehouseLocationGroup', warehouseLocationGroupID: any, warehouseLocationGroupName: string, uniqueKey: string, isActive?: boolean | null } };

export type WarehouseLocationGroupDeleteMutationVariables = Exact<{
  warehouseLocationGroupID: Scalars['UUID']['input'];
}>;


export type WarehouseLocationGroupDeleteMutation = { __typename?: 'Mutation', warehouseLocationGroupDelete: boolean };

export type WarehouseLocationGroupListQueryVariables = Exact<{
  qop?: InputMaybe<WarehouseLocationGroupQopInput>;
}>;


export type WarehouseLocationGroupListQuery = { __typename?: 'Query', warehouseLocationGroups: { __typename?: 'WarehouseLocationGroupPaged', items?: Array<{ __typename?: 'WarehouseLocationGroup', warehouseLocationGroupID: any, warehouseLocationGroupName: string, uniqueKey: string, isActive?: boolean | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type WarehouseLocationGroupLoadQueryVariables = Exact<{
  warehouseLocationGroupID: Scalars['UUID']['input'];
}>;


export type WarehouseLocationGroupLoadQuery = { __typename?: 'Query', warehouseLocationGroup?: { __typename?: 'WarehouseLocationGroup', warehouseLocationGroupID: any, warehouseLocationGroupName: string, uniqueKey: string, isActive?: boolean | null } | null };

export type WarehouseLocationGroupUpdateMutationVariables = Exact<{
  input: WarehouseLocationGroupUpdateInput;
}>;


export type WarehouseLocationGroupUpdateMutation = { __typename?: 'Mutation', warehouseLocationGroupUpdate: { __typename?: 'WarehouseLocationGroup', warehouseLocationGroupID: any, warehouseLocationGroupName: string, uniqueKey: string, isActive?: boolean | null } };

export type WarehouseLocationAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<WarehouseLocationQopInput>;
}>;


export type WarehouseLocationAutocompleteQuery = { __typename?: 'Query', warehouseLocations: { __typename?: 'WarehouseLocationPaged', items?: Array<{ __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseID: any, branchID: any, parentWarehouseLocationID?: any | null, uniqueKey: string, isActive: boolean, parentWarehouseLocation?: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, parentWarehouseLocation?: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string } | null } | null }> | null, pagination: { __typename?: 'PaginationResult', totalRows?: number | null, hasNext?: boolean | null } } };

export type WarehouseLocationCreateBulkMutationVariables = Exact<{
  input: WarehouseLocationBulkCreateInput;
}>;


export type WarehouseLocationCreateBulkMutation = { __typename?: 'Mutation', warehouseLocationCreateBulk: Array<{ __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseStorageType?: string | null, warehouseID: any, branchID: any, parentWarehouseLocationID?: any | null, warehouseLocationGroupID?: any | null, isHoldInventory: boolean, uniqueKey: string, isActive: boolean, isSystemGenerated?: boolean | null }> };

export type WarehouseLocationCreateMutationVariables = Exact<{
  input: WarehouseLocationCreateInput;
}>;


export type WarehouseLocationCreateMutation = { __typename?: 'Mutation', warehouseLocationCreate: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseID: any, branchID: any, parentWarehouseLocationID?: any | null, uniqueKey: string, isActive: boolean } };

export type WarehouseLocationDeleteMutationVariables = Exact<{
  warehouseLocationID: Scalars['UUID']['input'];
}>;


export type WarehouseLocationDeleteMutation = { __typename?: 'Mutation', warehouseLocationDelete: boolean };

export type WarehouseLocationListQueryVariables = Exact<{
  qop?: InputMaybe<WarehouseLocationQopInput>;
}>;


export type WarehouseLocationListQuery = { __typename?: 'Query', warehouseLocations: { __typename?: 'WarehouseLocationPaged', items?: Array<{ __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseStorageType?: string | null, warehouseID: any, branchID: any, parentWarehouseLocationID?: any | null, warehouseLocationGroupID?: any | null, isHoldInventory: boolean, uniqueKey: string, isActive: boolean, isSystemGenerated?: boolean | null, parentWarehouseLocation?: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseStorageType?: string | null } | null, warehouseLocationGroup?: { __typename?: 'WarehouseLocationGroup', warehouseLocationGroupID: any, warehouseLocationGroupName: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type WarehouseLocationLoadQueryVariables = Exact<{
  warehouseLocationID: Scalars['UUID']['input'];
}>;


export type WarehouseLocationLoadQuery = { __typename?: 'Query', warehouseLocation?: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseStorageType?: string | null, warehouseID: any, branchID: any, parentWarehouseLocationID?: any | null, warehouseLocationGroupID?: any | null, isHoldInventory: boolean, uniqueKey: string, isActive: boolean, isSystemGenerated?: boolean | null } | null };

export type WarehouseLocationTreeQueryVariables = Exact<{
  qop?: InputMaybe<WarehouseLocationQopInput>;
}>;


export type WarehouseLocationTreeQuery = { __typename?: 'Query', warehouseLocations: { __typename?: 'WarehouseLocationPaged', items?: Array<{ __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseStorageType?: string | null, parentWarehouseLocationID?: any | null, isActive: boolean, warehouseLocationGroup?: { __typename?: 'WarehouseLocationGroup', warehouseLocationGroupName: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type WarehouseLocationUpdateMutationVariables = Exact<{
  input: WarehouseLocationUpdateInput;
}>;


export type WarehouseLocationUpdateMutation = { __typename?: 'Mutation', warehouseLocationUpdate: { __typename?: 'WarehouseLocation', warehouseLocationID: any, warehouseLocationName: string, warehouseLocationType: string, warehouseID: any, branchID: any, parentWarehouseLocationID?: any | null, uniqueKey: string, isActive: boolean } };

export type WarehouseProductLocationMapCreateMutationVariables = Exact<{
  input: WarehouseProductLocationMapCreateInput;
}>;


export type WarehouseProductLocationMapCreateMutation = { __typename?: 'Mutation', warehouseProductLocationMapCreate: { __typename?: 'WarehouseProductLocationMap', warehouseProductLocationMapID: any } };

export type WarehouseProductLocationMapDeleteMutationVariables = Exact<{
  warehouseProductLocationMapID: Scalars['UUID']['input'];
}>;


export type WarehouseProductLocationMapDeleteMutation = { __typename?: 'Mutation', warehouseProductLocationMapDelete: boolean };

export type WarehouseProductLocationMapListQueryVariables = Exact<{
  qop?: InputMaybe<WarehouseProductLocationMapQopInput>;
}>;


export type WarehouseProductLocationMapListQuery = { __typename?: 'Query', warehouseProductLocationMaps: { __typename?: 'WarehouseProductLocationMapPaged', items?: Array<{ __typename?: 'WarehouseProductLocationMap', warehouseProductLocationMapID: any, warehouseID: any, warehouseCode: string, warehouseName: string, productID: any, productCode: string, productName: string, warehouseLocationID: any, warehouseLocationName: string, uniqueKey: string, isActive?: boolean | null, product: { __typename?: 'Product', productID: any, productCode: string, productName: string, barcode: string, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } | null }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type WarehouseProductLocationMapLoadQueryVariables = Exact<{
  warehouseProductLocationMapID: Scalars['UUID']['input'];
}>;


export type WarehouseProductLocationMapLoadQuery = { __typename?: 'Query', warehouseProductLocationMap?: { __typename?: 'WarehouseProductLocationMap', warehouseProductLocationMapID: any, warehouseID: any, warehouseCode: string, warehouseName: string, productID: any, productCode: string, productName: string, warehouseLocationID: any, warehouseLocationName: string, uniqueKey: string, isActive?: boolean | null, product: { __typename?: 'Product', productID: any, productCode: string, productName: string, productCategory?: { __typename?: 'ProductCategory', productCategoryID: any, productCategoryName: string, productCategoryFullName: string, productSubDepartmentID: any, productSubDepartmentName: string, productDepartmentID: any, productDepartmentName: string, productDivisionID: any, productDivisionName: string, uniqueKey: string, isActive: boolean } | null }, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } } | null };

export type WarehouseProductLocationMapUpdateMutationVariables = Exact<{
  input: WarehouseProductLocationMapUpdateInput;
}>;


export type WarehouseProductLocationMapUpdateMutation = { __typename?: 'Mutation', warehouseProductLocationMapUpdate: { __typename?: 'WarehouseProductLocationMap', warehouseProductLocationMapID: any } };

export type WarehouseReplenishmentTemplateCreateMutationVariables = Exact<{
  input: WarehouseReplenishmentTemplateCreateInput;
}>;


export type WarehouseReplenishmentTemplateCreateMutation = { __typename?: 'Mutation', warehouseReplenishmentTemplateCreate: { __typename?: 'WarehouseReplenishmentTemplate', warehouseReplenishmentTemplateID: any } };

export type WarehouseReplenishmentTemplateCreateBulkMutationVariables = Exact<{
  input: WarehouseReplenishmentTemplateCreateBulkInput;
}>;


export type WarehouseReplenishmentTemplateCreateBulkMutation = { __typename?: 'Mutation', warehouseReplenishmentTemplateCreateBulk: Array<{ __typename?: 'WarehouseReplenishmentTemplate', warehouseReplenishmentTemplateID: any, replenishmentTemplateID: any, replenishmentTemplateName: string }> };

export type WarehouseReplenishmentTemplateDeleteMutationVariables = Exact<{
  warehouseReplenishmentTemplateID: Scalars['UUID']['input'];
}>;


export type WarehouseReplenishmentTemplateDeleteMutation = { __typename?: 'Mutation', warehouseReplenishmentTemplateDelete: boolean };

export type WarehouseReplenishmentTemplateListQueryVariables = Exact<{
  qop?: InputMaybe<WarehouseReplenishmentTemplateQopInput>;
}>;


export type WarehouseReplenishmentTemplateListQuery = { __typename?: 'Query', warehouseReplenishmentTemplates: { __typename?: 'WarehouseReplenishmentTemplatePaged', items?: Array<{ __typename?: 'WarehouseReplenishmentTemplate', warehouseReplenishmentTemplateID: any, warehouseID: any, warehouseCode: string, warehouseName: string, replenishmentTemplateID: any, replenishmentTemplateName: string, entityAuditMetadata: { __typename?: 'EntityAuditMetadata', createdByUserID?: any | null, createdByUserName?: string | null, updatedByUserID?: any | null, updatedByUserName?: string | null, deletedByUserID?: any | null, deletedByUserName?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, version: any } }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null, nextCursor?: string | null } } };

export type WarehouseLoadQueryVariables = Exact<{
  warehouseID: Scalars['UUID']['input'];
}>;


export type WarehouseLoadQuery = { __typename?: 'Query', warehouse?: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null, branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, productAvailabilityTemplateID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, picName?: string | null, picPhoneNumber?: string | null, canSell?: boolean | null, isMain?: boolean | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } | null } | null };

export type WarehouseAutocompleteQueryVariables = Exact<{
  qop?: InputMaybe<WarehouseQopInput>;
}>;


export type WarehouseAutocompleteQuery = { __typename?: 'Query', warehouses: { __typename?: 'WarehousePaged', items?: Array<{ __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branch?: { __typename?: 'Branch', branchID: any, gmt: number, branchType: string } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type WarehouseCreateMutationVariables = Exact<{
  input: WarehouseCreateInput;
}>;


export type WarehouseCreateMutation = { __typename?: 'Mutation', warehouseCreate: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } };

export type WarehouseDeleteMutationVariables = Exact<{
  warehouseID: Scalars['UUID']['input'];
}>;


export type WarehouseDeleteMutation = { __typename?: 'Mutation', warehouseDelete: boolean };

export type WarehouseListQueryVariables = Exact<{
  qop?: InputMaybe<WarehouseQopInput>;
}>;


export type WarehouseListQuery = { __typename?: 'Query', warehouses: { __typename?: 'WarehousePaged', items?: Array<{ __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null, branch?: { __typename?: 'Branch', branchID: any, branchCode: string, branchName: string, branchType: string, branchCategoryID: any, pricelistID?: any | null, productAvailabilityTemplateID?: any | null, mainSupplyWarehouseID?: any | null, gmt: number, picName?: string | null, picPhoneNumber?: string | null, canSell?: boolean | null, isMain?: boolean | null, addressLabel?: string | null, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } | null }> | null, pagination: { __typename?: 'PaginationResult', page?: number | null, pageSize?: number | null, totalPages?: number | null, totalRows?: number | null, hasNext?: boolean | null } } };

export type WarehouseUpdateMutationVariables = Exact<{
  input: WarehouseUpdateInput;
}>;


export type WarehouseUpdateMutation = { __typename?: 'Mutation', warehouseUpdate: { __typename?: 'Warehouse', warehouseID: any, warehouseCode: string, warehouseName: string, branchID: any, addressLabel: string, fullAddress: string, countryID: string, countryName: string, provinceID: string, provinceName: string, cityID: string, cityName: string, subdistrictID: string, subdistrictName: string, postalCode: string, longitude: number, latitude: number, uniqueKey: string, isActive?: boolean | null } };
